(function() {
    'use strict';
    angular.module('spapp.bandeja', []);
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').controller('SolicitudArchivoDialogController', SolicitudArchivoDialogController);
    /** @ngInject */
    function SolicitudArchivoDialogController(toastr, $scope, $sce, ngDialog) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataTitulo = '';
        $scope.renderHtml = function(htmlCode) {
            return $sce.trustAsHtml(htmlCode);
        };
        /*declaración de metodos enlazados a la vista*/
        vm.cancelar = cancelar;
        /*implementación de metodos*/
        function cancelar() {
            ngDialog.close();
        }
        /*fin de metodos*/
        function init() {
            if (angular.isDefined($scope.ngDialogData)) {
                vm.dataTitulo = angular.copy($scope.ngDialogData.data);
            } else {
                vm.dataTitulo = 'Documento Tipo de Solicitud';
            }
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').controller('MotivoRechazoDialogController', MotivoRechazoDialogController);
    /** @ngInject */
    function MotivoRechazoDialogController($rootScope, toastr, $scope, ngDialog) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataMotivoRechazo = '';
        /*declaración de metodos enlazados a la vista*/
        vm.guardarMotivoRechazo = guardarMotivoRechazo;
        /*implementación de metodos*/
        function guardarMotivoRechazo() {
            $rootScope.motivoRechazo = vm.dataMotivoRechazo;
        }

        function cancelar() {
            ngDialog.close();
        }
        /*fin de metodos*/
        function init() {
            // body...
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision', []);
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ResiduoListaController', ResiduoListaController);
    /* @ngInject */
    function ResiduoListaController($state, toastr, ngDialog, $scope, AdministradoFactory, ReporteFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, ResiduoFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmResiduo = ResiduoFactory.model();
        vm.lstResiduos = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        vm.exportarExcel = exportarExcel;
       
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarDeclaracionResiduo() {
            ResiduoFactory.listar(angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstResiduos = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
       
        function exportarExcel(tipo){
			 var filtro = {
			   tiporeporte : tipo,
			   idAdministrado : vm.prmResiduo.idAdministrado,
			   idInstalacion : vm.prmResiduo.idInstalacion,
			   fechadesde : vm.prmResiduo.fechadesde,
			   fechahasta : vm.prmResiduo.fechahasta
			 }
			 ReporteFactory.descargarExcel(angular.copy(filtro),'Reporte_Residuos.xls');
		}
        
        
        /* fin de implementacion de metodos */
        function init() {
        	 if (angular.isDefined(localStorage.prmResiduo)) {
                 vm.prmResiduo = angular.copy(angular.fromJson(localStorage.prmResiduo));
                 buscarDeclaracionResiduo();
             }
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('PresentacionListaController', PresentacionListaController);
    /* @ngInject */
    function PresentacionListaController($state, toastr, ngDialog, $scope, InstalacionPresentacionFactory,ReporteFactory,AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, ResiduoFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmPresentacion = InstalacionPresentacionFactory.model();
        vm.lstPresentacion = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        vm.exportarExcel = exportarExcel;
       
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarPresentacion() {
        	 InstalacionPresentacionFactory.listar(angular.copy(vm.prmPresentacion)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstPresentacion = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }

        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
       
        function exportarExcel(tipo){
			 var filtro = {
			   tiporeporte : tipo,
			   idAdministrado : vm.prmPresentacion.idAdministrado,
			   idInstalacion : vm.prmPresentacion.idInstalacion,
			   fechadesde : vm.prmPresentacion.fechadesde,
			   fechahasta : vm.prmPresentacion.fechahasta
			 }
			 ReporteFactory.descargarExcel(angular.copy(filtro),'Reporte_Presentacion.xls');
		}
        
        /* fin de implementacion de metodos */
        function init() {
        	 if (angular.isDefined(localStorage.prmPresentacion)) {
                 vm.prmPresentacion = angular.copy(angular.fromJson(localStorage.prmPresentacion));
                 buscarPresentacion();
             }
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InformeMonitoreoListaController', InformeMonitoreoListaController);
    /* @ngInject */
    function InformeMonitoreoListaController($state, toastr, ngDialog, $scope, ReporteFactory, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInformeMonitoreo = InformeMonitoreoFactory.model();
        vm.lstInformeMonitoreo = [];
        vm.lstIntrumentoGestionMod = [];
        vm.lstIntrumentoGestionModBase = [];
        vm.dataInstrumentoGestionMod = InstrumentoGestionFactory.modificacion_model();
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        vm.exportarExcel = exportarExcel;
       
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInformeMonitoreo() {
        	    InformeMonitoreoFactory.listarHistorial(angular.copy(vm.prmInformeMonitoreo)).then(function(response) {
   		        if (response != null && response.valido) {
   		        	vm.lstInformeMonitoreo = angular.copy(response.data);
   		        }
 	   		}).catch(function(error) {
 	   		         toastr.error('No se pudo obtener los datos.');
 	   		});
        }

        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
       
        
        function exportarExcel(tipo){
			 var filtro = {
			   tiporeporte : tipo,
			   idAdministrado : vm.prmInformeMonitoreo.idAdministrado,
			   idInstalacion : vm.prmInformeMonitoreo.idInstalacion,
			   fechadesde : vm.prmInformeMonitoreo.fechadesde,
			   fechahasta : vm.prmInformeMonitoreo.fechahasta
			 }
			 ReporteFactory.descargarExcel(angular.copy(filtro),'Reporte_InformeMonitoreo.xls');
		}
        
        /* fin de implementacion de metodos */
        function init() {
        	 if (angular.isDefined(localStorage.prmInformeMonitoreo)) {
                 vm.prmInformeMonitoreo = angular.copy(angular.fromJson(localStorage.prmInformeMonitoreo));
                 buscarInformeMonitoreo();
             }
        }
       
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('PresentacionEdicionController', PresentacionEdicionController);
    /* @ngInject */
    function PresentacionEdicionController(ngDialog, API_CONFIG,toastr, $scope, $rootScope,MaestroFactory,EntidadFactory, InstalacionPresentacionFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };

        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];
        vm.lstTipoPresentacion = [];

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        vm.prmPresentacion = InstalacionPresentacionFactory.model();
        /* declaración de metodos enlazados a la vista */
        vm.guardar = guardar;
        vm.validaDocumento = validaDocumento;
        vm.cancelar = cancelar;
        vm.lstPeriodos = [];

        function cancelar(){
        	 ngDialog.close();
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function guardar() {
            if (vm.prmPresentacion.idresiduo == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            getMensajeDeclaracionJurada();
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: vm.mensajeDeclaracionJurada
                },
                width: '380px'
            }).then(function(okValue) {
            	registrar();
            });
        }

        function registrar() {
        	vm.prmPresentacion.prm1= CookiesFactory.obtenerCookie();
        	vm.prmPresentacion.fechapresentacion = new Date();
        	vm.prmPresentacion.tipo = "MR";
            InstalacionPresentacionFactory.registrar(vm.listaArchivos,angular.copy(vm.prmPresentacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });

        }

        function actualizar() {
        	vm.prmPresentacion.prm1= CookiesFactory.obtenerCookie();
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	InstalacionPresentacionFactory.actualizar(angular.copy(vm.prmPresentacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function formatearfecha(fecha){
            return [
            	fecha.getDate(),
            	fecha.getMonth()+1,
            	fecha.getFullYear()].join('/');
        }


    	function listarTipoPresentacion(){

    		var dataPresentacion = {
            		codigoMaestro : 'TipoInformePresentacion',
            		idMaestro			:0,
    			  	descripcion 		:'',
            	};
                MaestroFactory.buscarXCodigoMaestro(angular.copy(dataPresentacion)).then(function(response) {
                    if (response != null && response.valido) {
                    			vm.lstTipoPresentacion = response.data[x];
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
    	}

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");

            vm.listaArchivos = [];

                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);

                // habilitamos el boton dependiendo de otras condiciones
				 if(vm.prmPresentacion.lstCaracteristicas!=0 && vm.prmPresentacion.periodo!=0){
					 document.getElementById("btnRegistrarManifiesto").disabled = false;
				 }

                vm.tieneArchivo = true;
        }

        function init() {
           if(angular.isDefined($rootScope.itemResiduo)){
        	   vm.prmPresentacion = $rootScope.itemResiduo;
        	   if(vm.prmPresentacion.idresiduo != 0){
        	   }
        	   else{
        		   vm.prmPresentacion.periodo = new Date().getFullYear() - 1;
        	   }
        	   if (angular.isDefined(localStorage.objInstalacion)) {
        		   var prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                   vm.prmPresentacion.idInstalacion = prmInstalacion.idInstalacion;
                   vm.prmPresentacion.idAdministrado = prmInstalacion.idAdministrado;
        	   }
           }
           listarTipoPresentacion();
           obtenerParametros();
        }

        function cargarPeriodos() {

        	var dataTipoPeriodo = {
        		codigoMaestro : 'TipoPeriodo'
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                    if(vm.lstPeriodos.length>0){
                    	for(var x in vm.lstPeriodos){
                    		if(vm.lstPeriodos[x].descripcion == 'MENSUAL'){
                    			vm.prmResiduo.frecuencia = vm.lstPeriodos[x].codigoRegistro;
                    			break;
                    		}
                    	}
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }

        function getMensajeDeclaracionJurada() {
            //console.log("vm.dataMaestros.codigoMaestro" + vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }

        init();
        /* fin de metodos */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.etapa', []);
})();
(function() {
    'use strict';
    angular.module('spapp.etapa').controller('PresentacionController', PresentacionController);
    /* @ngInject */
    function PresentacionController(ngDialog, API_CONFIG , toastr, $state, $scope, $rootScope, InstalacionPresentacionFactory,CookiesFactory,MaestroFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        vm.rutaBase = API_CONFIG.url;
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.lstPresentacion = [];
        vm.lstTipoPresentacion = [];
        vm.guardarPresentacion = guardarPresentacion;
        vm.prmPresentacion = InstalacionPresentacionFactory.model();
        vm.prmPresentacionFiltro = InstalacionPresentacionFactory.model();
        vm.prmInstalacion;
        vm.validaDocumento = validaDocumento;
        vm.verNuevo = false;
        vm.cancelar = cancelar;
        vm.lstPeriodos = [];
        vm.validarTipoPresentacion = validarTipoPresentacion;

        function validarTipoPresentacion(tipo){
        	if(tipo==7){// registros de incidentes
        		if(vm.lstPeriodos.length>0){
                	for(var x in vm.lstPeriodos){
                		if(vm.lstPeriodos[x].descripcion == 'MENSUAL'){
                			vm.prmPresentacion.frecuencia = vm.lstPeriodos[x].codigoRegistro;
                			break;
                		}
                	}
                }
                vm.prmPresentacion.numero_frecuencia = 0;
        	}
        	else{
        		 vm.prmPresentacion.frecuencia = 5;
                 vm.prmPresentacion.numero_frecuencia = 1;
        	}
        }

        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-instalacion');
        }

        function guardarPresentacion (){
            confirmarGuardar();
        }

        function confirmarGuardar() {
            getMensajeDeclaracionJurada();
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: vm.mensajeDeclaracionJurada
                },
                width: '380px'
            }).then(function(okValue) {
            	validar();
            });
        }

        function validar(){
        	var lstDocumentos = [];
        	var filDocumento = InstalacionPresentacionFactory.model() ;
        	filDocumento.codigoTipoInforme = vm.prmPresentacion.codigoTipoInforme;
        	filDocumento.periodo = vm.prmPresentacion.periodo;
        	filDocumento.numero_frecuencia = vm.prmPresentacion.numero_frecuencia;
        	filDocumento.idInstalacion = vm.prmPresentacion.idInstalacion;
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	InstalacionPresentacionFactory.listar(angular.copy(filDocumento)).then(function(response) {
                if (response != null && response.valido) {
                	lstDocumentos = angular.copy(response.data);
                    if(lstDocumentos.length>0){
                    	 toastr.error('Periodo ya declarado.');
                    	return false;
                    }
                    else{
                    	 registrar();
                    }
                }
                else{
                	 registrar();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });

        }

        function registrar() {
        	vm.prmPresentacion.prm1= CookiesFactory.obtenerCookie();
            InstalacionPresentacionFactory.registrarArchivo(vm.listaArchivos,angular.copy(vm.prmPresentacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    init();
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");

            vm.listaArchivos = [];

                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);

// // habilitamos el boton dependiendo de otras condiciones
				 if(vm.prmPresentacion.periodo !=0 &&vm.prmPresentacion.frecuencia!=0 &&vm.prmPresentacion.numero_frecuencia!=0 &&vm.prmPresentacion.fechapresentacion!=null ){
					 	document.getElementById("btnGrabar").disabled = false;
				 }
//
// vm.tieneArchivo = true;
        }



        function agregarItem(item) {
        	vm.verNuevo = true;
        	vm.prmPresentacion = InstalacionPresentacionFactory.model();
        	vm.prmPresentacion.idInstalacion = vm.prmPresentacionFiltro.idInstalacion;
            vm.prmPresentacion.idAdministrado = vm.prmPresentacionFiltro.idAdministrado;
        	vm.listaArchivos = [];
        	cargarPeriodos();
// if (item != null) {
//
// InstalacionPresentacionFactory.buscarPorId(angular.copy(item)).then(function(response)
// {
// console.log('response.valido ' + response.valido);
// if (response.valido) {
// $rootScope.itemResiduo = response.data;
// ngDialog.open({
// template:
// 'app/modules/supervision/online/presentacion/presentacion_edicion.html',
// controller: 'PresentacionEdicionController',
// controllerAs: 'vm',
//
// width: '70%'
// }).closePromise.then(function(dataDialog) {
// listar();
// });
// } else {
// toastr.error(response.mensaje)
// }
// }).catch(function(error) {
// toastr.error('Ocurrió un error al obtener la etapa');
// });
// }
// else{
// $rootScope.itemResiduo = InstalacionPresentacionFactory.model();
// ngDialog.open({
// template: 'app/modules/residuos/declaracion_anual_residuos_edicion.html',
// controller: 'PresentacionEdicionController',
// controllerAs: 'vm',
//
// width: '70%'
// }).closePromise.then(function(dataDialog) {
// listar();
// });
// }
        }

        function confirmarEliminacion(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(item);
            });
        }

    	function listarTipoPresentacion(){

    		var dataPresentacion = {
            		codigoMaestro : 'TipoInformePresentacion',
            		idMaestro			:0,
    			  	descripcion 		:'',
            	};
                MaestroFactory.buscarXCodigoMaestro(angular.copy(dataPresentacion)).then(function(response) {
                    if (response != null && response.valido) {
                    			vm.lstTipoPresentacion = response.data;
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
    	}

        function confirmarInactivacion(prmEtapa) {

            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(item) {
            InstalacionPresentacionFactory.eliminar(angular.copy(item)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }

        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }


        function listar() {
            InstalacionPresentacionFactory.listar(angular.copy(vm.prmPresentacionFiltro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPresentacion = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function init() {
        	vm.verNuevo = false;
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	if (angular.isDefined(localStorage.dataListaInstalacion)) {
            	vm.dataListaInstalacion = angular.copy(angular.fromJson(localStorage.dataListaInstalacion));
            }
        	  if (angular.isDefined(localStorage.objInstalacion)) {
                  vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                  vm.prmPresentacion.idInstalacion = vm.prmInstalacion.idInstalacion;
                  vm.prmPresentacion.idAdministrado = vm.prmInstalacion.idAdministrado;
                  vm.prmPresentacionFiltro.idInstalacion = vm.prmInstalacion.idInstalacion;
                  vm.prmPresentacionFiltro.idAdministrado = vm.prmInstalacion.idAdministrado;
                  vm.prmPresentacionFiltro.periodo = 0;
                  listar();
              }

        	  obtenerParametros();
        	  listarTipoPresentacion();
        }


        function cargarPeriodos() {

        	var dataTipoPeriodo = {
        		codigoMaestro : 'TipoPeriodo'
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }

        function getMensajeDeclaracionJurada() {
            //console.log("vm.dataMaestros.codigoMaestro" + vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }

        init();
        /* fin de metodos */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.etapa').controller('InstalacionPresentacionController', InstalacionPresentacionController);
    /* @ngInject */
    function InstalacionPresentacionController(ngDialog, API_CONFIG , toastr, $state, $scope, $rootScope, InstalacionPresentacionFactory,CookiesFactory,MaestroFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        vm.rutaBase = API_CONFIG.url;
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.lstPresentacion = [];
        vm.lstTipoPresentacion = [];
        vm.guardarPresentacion = guardarPresentacion;
        vm.prmPresentacion = InstalacionPresentacionFactory.model();
        vm.prmPresentacionFiltro = InstalacionPresentacionFactory.model();
        vm.prmInstalacion;
        vm.validaDocumento = validaDocumento;
        vm.verNuevo = false;
        vm.cancelar = cancelar;
        vm.lstPeriodos = [];
        vm.validarTipoPresentacion = validarTipoPresentacion;
        vm.refrescar = refrescar;

        function validarTipoPresentacion(tipo){
        	vm.prmPresentacion.tiene_incidente = null;
        	vm.listaArchivos = [];
        	vm.prmPresentacion.fechahora_incidente=null; 
        	vm.prmPresentacion.lugar_incidente=null; 
        	vm.prmPresentacion.descripcion_incidente=null; 
        	vm.prmPresentacion.observaciones_incidente=null;
        	
        	if(tipo==7){// registros de incidentes
        		if(vm.lstPeriodos.length>0){
                	for(var x in vm.lstPeriodos){
                		if(vm.lstPeriodos[x].descripcion == 'MENSUAL'){
                			vm.prmPresentacion.frecuencia = vm.lstPeriodos[x].codigoRegistro;
                			break;
                		}
                	}
                }
                vm.prmPresentacion.numero_frecuencia = 0;
        	}
        	else{
        		 vm.prmPresentacion.frecuencia = 5;
                 vm.prmPresentacion.numero_frecuencia = 1;
        	}
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
        }

        function guardarPresentacion (){
            confirmarGuardar();
        }

        function confirmarGuardar() {
            getMensajeDeclaracionJurada();
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: vm.mensajeDeclaracionJurada
                },
                width: '380px'
            }).then(function(okValue) {
            	registrar();
            });
        }

        function registrar() {
        	vm.prmPresentacion.prm1= CookiesFactory.obtenerCookie();
            InstalacionPresentacionFactory.registrarArchivo(vm.listaArchivos,angular.copy(vm.prmPresentacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    init();
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });
            vm.verNuevo = false;
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");

            vm.listaArchivos = [];

                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);

// // habilitamos el boton dependiendo de otras condiciones
// if(vm.prmResiduo.lstCaracteristicas!=0 && vm.prmResiduo.periodo!=0){
// document.getElementById("btnRegistrarDeclaracion").disabled = false;
// }
//
// vm.tieneArchivo = true;
                
                document.getElementById("btnCerrar").click();
        }



        function agregarItem(item) {
        	vm.verNuevo = true;
        	vm.prmPresentacion = InstalacionPresentacionFactory.model();
        	vm.prmPresentacion.idInstalacion = vm.prmPresentacionFiltro.idInstalacion;
            vm.prmPresentacion.idAdministrado = vm.prmPresentacionFiltro.idAdministrado;
        	vm.listaArchivos = [];
        	cargarPeriodos();
// if (item != null) {
//
// InstalacionPresentacionFactory.buscarPorId(angular.copy(item)).then(function(response)
// {
// console.log('response.valido ' + response.valido);
// if (response.valido) {
// $rootScope.itemResiduo = response.data;
// ngDialog.open({
// template:
// 'app/modules/supervision/online/presentacion/presentacion_edicion.html',
// controller: 'PresentacionEdicionController',
// controllerAs: 'vm',
//
// width: '70%'
// }).closePromise.then(function(dataDialog) {
// listar();
// });
// } else {
// toastr.error(response.mensaje)
// }
// }).catch(function(error) {
// toastr.error('Ocurrió un error al obtener la etapa');
// });
// }
// else{
// $rootScope.itemResiduo = InstalacionPresentacionFactory.model();
// ngDialog.open({
// template: 'app/modules/residuos/declaracion_anual_residuos_edicion.html',
// controller: 'PresentacionEdicionController',
// controllerAs: 'vm',
//
// width: '70%'
// }).closePromise.then(function(dataDialog) {
// listar();
// });
// }
        }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }

    	function listarTipoPresentacion(){

    		var dataPresentacion = {
            		codigoMaestro : 'TipoInformePresentacion',
            		idMaestro			:0,
    			  	descripcion 		:'',
            	};
                MaestroFactory.buscarXCodigoMaestro(angular.copy(dataPresentacion)).then(function(response) {
                    if (response != null && response.valido) {
                    			vm.lstTipoPresentacion = response.data;
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
    	}

        function confirmarInactivacion(prmEtapa) {

            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }

        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }


        function listar() {
        	//alert(vm.prmPresentacionFiltro.periodo);
            InstalacionPresentacionFactory.listar(angular.copy(vm.prmPresentacionFiltro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPresentacion = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	 if (angular.isDefined(localStorage.objInstalacion)) {
                 vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                 vm.prmPresentacion.idInstalacion = vm.prmInstalacion.idInstalacion;
                 vm.prmPresentacion.idAdministrado = vm.prmInstalacion.idAdministrado;
                 vm.prmPresentacionFiltro.idInstalacion = vm.prmInstalacion.idInstalacion;
                 vm.prmPresentacionFiltro.idAdministrado = vm.prmInstalacion.idAdministrado;
                 vm.prmPresentacionFiltro.periodo = 0;
                 listar();
             }

        	  obtenerParametros();
        	  listarTipoPresentacion();
        }


        function cargarPeriodos() {

        	var dataTipoPeriodo = {
        		codigoMaestro : 'TipoPeriodo'
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }

        function getMensajeDeclaracionJurada() {
            //console.log("vm.dataMaestros.codigoMaestro" + vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }
        
        function refrescar(){
        	
        }

        init();
        /* fin de metodos */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.etapa').controller('InstalacionManifiestoResiduosController', InstalacionManifiestoResiduosController);
    /* @ngInject */
    function InstalacionManifiestoResiduosController(ngDialog, API_CONFIG , toastr, $state, $scope, $rootScope, ResiduoFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        vm.rutaBase = API_CONFIG.url;
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.lstResiduos = [];
        vm.prmResiduo = ResiduoFactory.model();
        vm.cancelar = cancelar;
        
        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
        }

        function agregarItem(item) {
        	 if (item != null) {
                 
        		 ResiduoFactory.buscarPorId(angular.copy(item)).then(function(response) {
                 	console.log('response.valido ' + response.valido);
                 		if (response.valido) {
                         	$rootScope.itemResiduo = response.data;
                         	  ngDialog.open({
                                   template: 'app/modules/residuos/manifiesto_residuos_edicion.html',
                                   controller: 'ManifiestoResiduosEdicionController',
                                   controllerAs: 'vm',
                                   
                                   width: '90%'
                               }).closePromise.then(function(dataDialog) {
                                   listar();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la etapa');
 		                });
             } 
             else{
            	$rootScope.itemResiduo = ResiduoFactory.model();
             	ngDialog.open({
                     template: 'app/modules/residuos/manifiesto_residuos_edicion.html',
                     controller: 'ManifiestoResiduosEdicionController',
                     controllerAs: 'vm',
                     
                     width: '90%'
                 }).closePromise.then(function(dataDialog) {
                     listar();
                 });
             }
        }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }
        
        function confirmarInactivacion(prmEtapa) {
        	
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }
        
        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }

        function listar() {
        	vm.prmResiduo.tipo = 'MR';
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ResiduoFactory.listar(angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstResiduos = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	  if (angular.isDefined(localStorage.objInstalacion)) {
                  vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                  vm.prmResiduo.idInstalacion = vm.prmInstalacion.idInstalacion;
                  vm.prmResiduo.idAdministrado = vm.prmInstalacion.idAdministrado;
                  listar();
              }
            
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstalacionInstrumentoGestionController', InstalacionInstrumentoGestionController);
    /* @ngInject */
    function InstalacionInstrumentoGestionController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        vm.nuevoIGA = nuevoIGA;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.irDeclaracion = irDeclaracion;
        vm.idInstrumentoGestion;
        vm.copiarIGA = copiarIGA;
        vm.seleccionarcopiarIGA = seleccionarcopiarIGA;
        
        function irDeclaracion(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.instalacion-declaracion');
        }
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.prmInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            if (angular.isDefined(localStorage.objInstalacion)) {
            	if (angular.isDefined(localStorage.dataListaInstalacion)) {
                    vm.dataListaInstalacion = angular.copy(angular.fromJson(localStorage.dataListaInstalacion));
                }
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.idAdministrado =  angular.copy(vm.prmInstalacion.idAdministrado);
                vm.prmInstrumentoGestion.estado = "T";
                buscarInstrumentoGestion();
                console.log("data ---> : " + getFileExtension("daraassaas.docx"));
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        // Nuevo IGA
        function nuevoIGA(datoParametro) {
        	
        	if(datoParametro != null){
        		vm.idInstrumentoGestion = datoParametro.idInstrumentoGestion;
        		$rootScope.prmdatoInstrumento = angular.copy(datoParametro);
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '1100px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	else{
        		$rootScope.prmdatoInstrumento = angular.copy(InstrumentoGestionFactory.model());
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '1100px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	
        }
        
        function confirmarEliminacion(prmInstrumentoGestion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstrumentoGestion.resolucion  + ' ' + prmInstrumentoGestion.auxTipoIgaNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstrumentoGestion,true);
            });
        }
        
        function eliminar(prmInstrumentoGestion, validar){
        	    prmInstrumentoGestion.isvalidar = validar;
        	 	InstrumentoGestionFactory.eliminar(angular.copy(prmInstrumentoGestion)).then(function(response) {
                     if (response.valido) {
                         toastr.success(response.mensaje);
                         buscarInstrumentoGestion();
                     } else {
                    	 validacionModal(prmInstrumentoGestion, response.mensaje);
                     }
                 }).catch(function(error) {
                     toastr.error('Ocurrió un error al eliminar la parametro');
                 });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function validacionModal(prmInstrumentoGestion, mensaje) {
//            ngDialog.open({
//                template: '<div class="">' + '<div class="modal-header">' + 
//                '<h4 class="modal-title" style="text-align: justify;">' + mensaje.replace( new RegExp('/n','g') ,'<br/>')  + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Cerrar</button>' + '</div>' + '</div>',
//                plain: true,
//                width: 550,
//                preCloseCallback: function() {
//                }
//            });
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?',
            		Mensajeadicional: mensaje.replace( new RegExp('/n','g') ,',')
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstrumentoGestion,false);
            });
            
        }
        
        function seleccionarcopiarIGA(item){
        	$rootScope.lstIntrumentoGestionModBase = [];
        	$rootScope.selIgamultiple = false;
        	
	       		 ngDialog.open({
	                    template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-selector.html',
	                    controller: 'CargaInfoInstrumentoGestionSelectorController',
	                    controllerAs: 'vm',
	                    width: '1100px'
	                }).closePromise.then(function(dataDialog) {
	               	    var array  = $rootScope.lstIntrumentoGestionMod;
	               		copiarIGA(item,array[0]);
	                });
        }
        
        function copiarIGA(igaBase, igaDestino){
        	igaBase.idInstrumentoGestionDestino = igaDestino.id_InstrumentoGestionMod;
    	 	InstrumentoGestionFactory.copiarProgramaMonitoreo(angular.copy(igaBase)).then(function(response) {
                 if (response.valido) {
                     toastr.success(response.mensaje);
                     buscarInstrumentoGestion();
                 } 
             }).catch(function(error) {
                 toastr.error('Ocurrió un error al copiar el programa de monitoreo');
             });
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstalacionInformeMonitoreoController', InstalacionInformeMonitoreoController);
    /* @ngInject */
    function InstalacionInformeMonitoreoController($state, toastr, ngDialog, $scope, InformeMonitoreoFactory, DeclaracionEtapaFactory, DeclaracionComponenteFactory, DeclaracionPuntoFactory, DeclaracionParametroFactory, AdministradoFactory, MaestroFactory, InstalacionFactory, InstrumentoGestionFactory,  $filter, $log, $rootScope, EtapaFactory,ComponenteAmbientalFactory, ReporteFactory, API_CONFIG, $window) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 4,
            fillLastPage: true,
            current: 1
        };

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        /* fin de configuracion de tablas */
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        /* Lista de Combos */

        /* declaracion de metodos enlazados a la vista */
        /** ****** */
        vm.cancelar = cancelar;

        // Lista de Etapas para iniciar la declaración de información
        vm.lstEtapas = [];

        // Lista de Periodos para seleccionar la frecuencia por cada componente
		// ambiental
        vm.lstPeriodos = [];

        // Lista de puntos de monitoreo de un componente ambiental
        vm.lstDeclaracionPunto = [];

        // Lista de Parametros de un punto de monitoreo
        vm.lstDeclaracionParametro = [];

        // Filtro para el listado de Etapas para iniciar la declaración de
		// información
        vm.dataEtapa = EtapaFactory.model();

         // Filtro para el listado de Periodos para iniciar la declaración de
		// información
        vm.dataTipoPeriodo = MaestroFactory.model();

        // Objeto principal que contiene toda la informacion para la declaracion
        vm.objInstrumentoGestion ;

        // Objeto para mostrar los datos de la instalación
        vm.objInstalacion;

        // Metodo principal para grabar los datos de la declaración de la
		// información a remitir
        vm.guardarDeclaracion = guardarDeclaracion;

        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.agregarDeclaracionComponentes = agregarDeclaracionComponentes;

        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionComponentes = actualizarDeclaracionComponentes;

        // carga los componenetes de la declaración según la etapa seleccionada
        vm.cargarDeclaracionComponentes = cargarDeclaracionComponentes;

        // carga los puntos de monitorreo según el componente seleccionado
        vm.cargarDeclaracionPuntosMonitoreo = cargarDeclaracionPuntosMonitoreo;

        vm.agregarDeclaracionPuntosMonitoreo = agregarDeclaracionPuntosMonitoreo;

        vm.agregarDeclaracionParametros = agregarDeclaracionParametros;

        vm.verPuntosMonitoreo = false;
        vm.verComponentes = false;

        vm.verMonitoreo = false;

        // confirma eliminación de los compoenestes de un proyecto en la
		// declaración
        vm.confirmarEliminacionComponente = confirmarEliminacionComponente;

        // Componente seleccionado para agregar puntos de monitoreo
        vm.objDeclaracionComponente ;

      // Punto de Monitoreo seleccionado para agregar parametros
        vm.objDeclaracionPuntoMonitoreo ;

        vm.cargarDeclaracionParametros = cargarDeclaracionParametros;

        vm.confirmarEliminacionPunto = confirmarEliminacionPunto;

        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;

        vm.activeetapa = vm.activeetapa;

        vm.active = 0;

        vm.actualizarComentarioIMA= actualizarComentarioIMA;

        vm.guardarInforme = guardarInforme;

        vm.objInformeMonitoreo =  InformeMonitoreoFactory.model();

        vm.validaDocumentoInformeMonitoreo = validaDocumentoInformeMonitoreo;

        vm.listaArchivosInformeMonitoreo = [];
        vm.declaracion = declaracion;

        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;

        vm.objInformeSel;
        vm.abrirInformeMonitoreo = abrirInformeMonitoreo;

        vm.editarArchivoInforme = editarArchivoInforme;

        vm.cargarPeriodosHijos = cargarPeriodosHijos;

        vm.nuevoInformeMonitoreo = nuevoInformeMonitoreo;
        vm.acciones = InformeMonitoreoFactory.acciones();
        vm.obtenerInformeEnsayo = obtenerInformeEnsayo;
        vm.generarPlantillaMonitoreoMasivo = generarPlantillaMonitoreoMasivo;
        vm.cargarPlantillaMonitoreoMasivo = cargarPlantillaMonitoreoMasivo;
        vm.obtenerInformeEnsayo = obtenerInformeEnsayo;
        vm.lstComponentesBase = [];
        vm.filtrarComponentes = filtrarComponentes;
        vm.elejirComponente = elejirComponente;
        
        function filtrarComponentes(informe){
        	
        	vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = [];
        	for(var x in vm.lstComponentesBase){
        		vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(vm.lstComponentesBase[x]);
        	}
        	
        	
        	var arrayCom = informe.componente.split(",");
        	
        	if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length>0){
         		for(var x in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes){
         			var existe = false;
         			
         			if(arrayCom.length>0){
                 		for(var y in arrayCom){
                 			if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[x].idComponente == arrayCom[y]){
                 				existe = true;
                 				break;
                 			}
                 		}
                 		if(!existe){
                 			vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.splice(x,1);
                 		}
         			}
         			
         			
         		}
         	}
        	
        	 cargarDeclaracionPuntosMonitoreo(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[0]);
        }
        
        function elejirComponente(componente){
        	if(componente.blSeleccionado){
        		// agregar
        		vm.objInformeMonitoreo.componente = vm.objInformeMonitoreo.componente + componente.idComponente + ",";
        	}
        	else{
        		// quitar
        		vm.objInformeMonitoreo.componente = vm.objInformeMonitoreo.componente.replace( componente.idComponente + "," ,"");
        	}
        	
        }
        
        function generarPlantillaMonitoreoMasivo(informeMonitoreo){
        	ReporteFactory.generarPlantillaMonitoreoMasivo(informeMonitoreo).then(function(response) {
    			if (response.valido) {
    				toastr.success('Se generó la plantilla para la carga masiva');
    				cargarInformes();
                }
    			else{
    				toastr.error(response.mensaje);
    			}
    				
            }).catch(function(error) {
            	toastr.error(response.mensaje);
            });
        }
        
        function cargarPlantillaMonitoreoMasivo(item){
        
        	localStorage.setItem("objInformeMonitoreo", angular.copy(angular.toJson(item)));
             
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo-masivo.html',
                controller: 'CargaInfoInformeMonitoreoMasivoController',
                controllerAs: 'vm',
                width: '30%'
            }).closePromise.then(function(dataDialog) {
            	
            });
        }
        
        function obtenerInformeEnsayo(){
        	
        	var item ={
        		idAdministrado :vm.objInstalacion.idAdministrado,
                idInstalacion : vm.objInstrumentoGestion.idInstalacion,
         		idIga : vm.objInstrumentoGestion.idInstrumentoGestion
        	};
        	
        	$rootScope.objInformeMonitoreo = item;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informe-ensayo/cargainfo-informe-ensayo.html',
                controller: 'CargaInfoInformeEnsayoController',
                controllerAs: 'vm',
                width: '98%'
            }).closePromise.then(function(dataDialog) {
            	for(var x in vm.lstParametrosComponenteBase){
            		
            		if(vm.lstParametrosComponenteBase[x].numeroItem == item.numeroItem){
            			vm.lstParametrosComponenteBase[x].codigo_ensayo = $rootScope.informeEnsayo.codigo_ensayo;
            			break;
            		}
            	}
            });
        }
         
        
        function nuevoInformeMonitoreo(){
        	vm.acciones.nuevoInforme = true;
        	vm.objInformeMonitoreo = InformeMonitoreoFactory.model();
        } 
        
        function editarArchivoInforme(item){
        	$rootScope.objInformeMonitoreo = item;

            ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo-archivo.html',
                controller: 'CargaInfoInformeMonitoreoArchivoController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarInformes();
            });
        }


        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }


        function validarInformeMonitoreo(){

             	var selBool = 0;

             	if(vm.objInformeMonitoreo.periodo == 0 || vm.objInformeMonitoreo.periodo == ''){
             		toastr.error('Es obligatorio registrar el Año del Informe de Monitoreo');
             		return false;
             	}

             	if(vm.objInformeMonitoreo.frecuencia == 0 || vm.objInformeMonitoreo.frecuencia == ''){
             		toastr.error('Es obligatorio registrar la frecuencia del Informe de Monitoreo');
             		return false;
             	}

             	if(vm.objInformeMonitoreo.numero_frecuencia == 0 || vm.objInformeMonitoreo.numero_frecuencia == ''){
             		toastr.error('Es obligatorio registrar el número de frecuencia del Informe de Monitoreo');
             		return false;
             	}

             	if(vm.listaArchivosInformeMonitoreo.length== 0){
             		toastr.error('Es obligatorio adjuntar el archivo de Informe de Monitoreo');
             		return false;
             	}

             	// validar que el informe no exista en la lista
             	if(vm.lstInformesMonitoreo.length>0){
             		for(var x in vm.lstInformesMonitoreo){
             			if(vm.lstInformesMonitoreo[x].periodo == vm.objInformeMonitoreo.periodo &&
             					vm.lstInformesMonitoreo[x].frecuencia == vm.objInformeMonitoreo.frecuencia &&
             					vm.lstInformesMonitoreo[x].numero_frecuencia == vm.objInformeMonitoreo.numero_frecuencia){
             				toastr.error('El informe de monitoreo ya se encuentra registrado');
                     		return false;
             			}
             		}
             	}


             	return true;
             }

             function guardarInforme(){
            	 console.log("instalacion");
             	if(validarInformeMonitoreo()){


             		vm.objInformeMonitoreo.idAdministrado = vm.objInstalacion.idAdministrado;
             		vm.objInformeMonitoreo.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
             		vm.objInformeMonitoreo.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
             		vm.objInformeMonitoreo.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa;
             		vm.objInformeMonitoreo.estado = '1';
             		vm.objInformeMonitoreo.lstInformeMonitoreo = [];
             		vm.objInformeMonitoreo.numero_frecuencia = convertirRomanoALatinoNumero(vm.objInformeMonitoreo.numero_frecuencia);

        	        		InformeMonitoreoFactory.registrarConArchivo(vm.listaArchivosInformeMonitoreo,angular.copy(vm.objInformeMonitoreo)).then(function(response) {
        	                    if (response != null && response.valido) {
        	                    	toastr.success('Se registró el informe de monitoreo correctamente');
        	                    	cargarInformes();
        	                    	vm.verComponentes = false;
        	                    	vm.listaArchivosInformeMonitoreo = [];
        	                    }
        	    			});
             	}

             	// limpiamos para nuevos registros
             	vm.objInformeMonitoreo = InformeMonitoreoFactory.model();
             	vm.objInformeMonitoreo.fechaPresentacion = new Date();
             	vm.listaArchivosInformeMonitoreo = [];

             }

             function validaDocumentoInformeMonitoreo(prmFileList) {
                 var lstExtens = vm.extension.split(",");

                     if (!prmFileList) {
                         toastr.warning('Debe seleccionar un Archivo');
                         return;
                     }
                     var archivo = prmFileList[0];
                     if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                         toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                         document.getElementById("fileArchivoInformeMonitoreo").value = "";
                         return;
                     }
                     var str = archivo.name;
                     var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                     if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                         toastr.warning('El archivo seleccionado no esta permitido');
                         document.getElementById("fileArchivoInformeMonitoreo").value = "";
                         return;
                     }
                     if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                         toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                         document.getElementById("fileArchivoInformeMonitoreo").value = "";
                         return;
                     }

                     vm.listaArchivosInformeMonitoreo.push(prmFileList[0]);

                     if(vm.objInformeMonitoreo.periodo!=0 && vm.objInformeMonitoreo.frecuencia!=null && vm.objInformeMonitoreo.numero_frecuencia!=0){
                    	 document.getElementById("btnRegistrarInforme").disabled = false;
                     }


             }

             function cargarInformes(){
            	 	var tempInformeMonitoreo = {
            			idAdministrado :vm.objInstalacion.idAdministrado,
             			idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
             			idInstalacion : vm.objInstrumentoGestion.idInstalacion,
             			idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
                 		estado : '1',
        			};

            	     InformeMonitoreoFactory.listarHistorial(angular.copy(tempInformeMonitoreo)).then(function(response) {
       		        if (response != null && response.valido) {
       		        	vm.lstInformesMonitoreo = angular.copy(response.data);
       		        }
     	   		}).catch(function(error) {
     	   		         toastr.error('No se pudo obtener los datos.');
     	   		});
            }



        /* declaracion de metodos */

        function cancelar() {
            $state.go('spapp.home.supervision.instalacion-informe-instrumento');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
        	cargarEtapas();
            cargarPeriodos();
        }

        function cargarEtapas() {
        	vm.dataEtapa.estado = '1';
            EtapaFactory.listarActivosPorUnidad(angular.copy(vm.dataEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = response.data;
                    vm.activeetapa = 1;
                    vm.active = 0;
                    cargarDeclaracionComponentes(vm.lstEtapas[1]);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizarComentarioIMA(){
        	DeclaracionComponenteFactory.actualizarComentarioIMA(angular.copy(vm.objDeclaracionComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function cargarDeclaracionPuntosMonitoreo(prmComponente){


        	if(prmComponente == null){
        		vm.objDeclaracionComponente = DeclaracionComponenteFactory.model();
        		return;
        	}

        	vm.verPuntosMonitoreo = true;
        	vm.verParametros = false;
        	vm.objDeclaracionComponente = prmComponente;
        	var tempPunto = {
        			idAdministrado : prmComponente.idAdministrado,
    				idIga : prmComponente.idIga,
    				idInstalacion : prmComponente.idInstalacion,
    				idEtapa : prmComponente.idEtapa,
    				idComponente : prmComponente.idComponente,
    				origen : null,
            	};

        	 DeclaracionPuntoFactory.listar(angular.copy(tempPunto)).then(function(response) {
                 if (response != null && response.valido) {
                	 vm.lstDeclaracionPunto = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }


        function agregarDeclaracionPuntosMonitoreo(prmPuntoMonitoreo) {

        	if(prmPuntoMonitoreo == null){
        		prmPuntoMonitoreo = DeclaracionPuntoFactory.model();
        		prmPuntoMonitoreo.idAdministrado  = vm.objDeclaracionComponente.idAdministrado;
        		prmPuntoMonitoreo.idIga  = vm.objDeclaracionComponente.idIga;
        		prmPuntoMonitoreo.idInstalacion  = vm.objDeclaracionComponente.idInstalacion;
        		prmPuntoMonitoreo.idEtapa  = vm.objDeclaracionComponente.idEtapa;
        		prmPuntoMonitoreo.idComponente  = vm.objDeclaracionComponente.idComponente;
        		prmPuntoMonitoreo.origen= 'I';
        	}

        	$rootScope.objDeclaracionPunto = prmPuntoMonitoreo;

            ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/declaracion/cargainfo-punto-monitoreo.html',
                controller: 'CargaInfoPuntoMonitoreoController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
            });
        }

  function cargarDeclaracionComponentes(etapa) {

	  		vm.verMonitoreo = true;

        	var tempetapa = null;
        	if( etapa.codetapa != null){
        		tempetapa = etapa.codetapa;
        	}
        	if( etapa.idEtapa != null){
        		tempetapa = etapa.idEtapa;
        	}

        	vm.objInstrumentoGestion.declaracionEtapa.idEtapa = tempetapa;
        	vm.verPuntosMonitoreo = false;
        	vm.verParametros = false;
        	vm.verComponentes = false;

        	if(vm.objInstrumentoGestion.declaracionEtapa.idEtapa == 0){
        		vm.verComponentes = false;
        		return;
        	}

        	vm.objInformeSel = InformeMonitoreoFactory.model();
        	vm.objInformeSel.estado = '0';
        	cargarInformes();

        	var tempComponente = {
        		idAdministrado : vm.objInstalacion.idAdministrado,
        	    idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
        	    idInstalacion : vm.objInstrumentoGestion.idInstalacion,
        	    idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa
        	};

        	DeclaracionComponenteFactory.listarInforme(angular.copy(tempComponente)).then(function(response) {
             if (response != null && response.valido) {
            	 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = angular.copy(response.data);
            	 vm.lstComponentesBase = angular.copy(response.data);
            	 if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length > 0){
            		 cargarDeclaracionPuntosMonitoreo(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[0]);
            	 }
             }
         }).catch(function(error) {
             toastr.error('No se pudo obtener los datos.');
         });

        }

        function agregarDeclaracionComponentes() {
        	$rootScope.lstComponentesBase = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes;
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-selector.html',
                controller: 'ComponenteAmbientalSelectorController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	var array  = $rootScope.lstComponentesSel;
            	if (angular.isDefined(array)){
            		if(array.length > 0){
            			for (var x in array) {
            				var tempComponente = {
            						idAdministrado : vm.objInstalacion.idAdministrado,
            					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
            					idInstalacion : vm.objInstalacion.idInstalacion,
            					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
            					idComponente : array[x].codigo,
            					idFrecuencia : null,
            					estado : 'P',
            					origen : 'I'
            		        };
            				guardarDeclaracionComponentes(tempComponente);
                        }
            		}
            	}

            });
        }

        function guardarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.registrar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	vm.active = 0;
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function actualizarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.actualizar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function confirmarEliminacionComponente(prmDeclaracionComponente){
       	 ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionComponente(prmDeclaracionComponente);
            });
       }

       function eliminarDeclaracionComponente(prmDeclaracionComponente) {
       	vm.verPuntosMonitoreo = false;
       	DeclaracionComponenteFactory.eliminar(angular.copy(prmDeclaracionComponente)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar la parametro');
           });
       }

        function  cargarDeclaracionParametros(prmPuntoMonitoreo){
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	idFrecuencia : vm.objDeclaracionComponente.idFrecuencia,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};

        	$rootScope.prmPuntoMonitoreo = prmPuntoMonitoreo;
        	$rootScope.prmComponente = componente;
        	$rootScope.objInformeMonitoreo = vm.objInformeSel;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-parametro.html',
                controller: 'CargaInfoInformeParametroController',
                controllerAs: 'vm',
                width: '98%'
            });
        }


        function agregarDeclaracionParametros(){

        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};

        	$rootScope.prmComponente = componente;
        	$rootScope.lstParametrosComponenteBase  = vm.lstDeclaracionParametro;
        	ngDialog.open({
                template: 'app/modules/componente-parametro/componente-parametro-selector.html',
                controller: 'ComponenteParametroSelectorController',
                controllerAs: 'vm',

                width: '50%'
            }).closePromise.then(function(dataDialog) {
            	var array = $rootScope.lstParametrosComponenteSel;
                for (var x in array){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.objDeclaracionComponente.idAdministrado,
            				idIga : vm.objDeclaracionComponente.idIga,
            				idInstalacion : vm.objDeclaracionComponente.idInstalacion,
            				idEtapa : vm.objDeclaracionComponente.idEtapa,
            				idComponente : vm.objDeclaracionComponente.idComponente,
            				idPunto : vm.objDeclaracionPuntoMonitoreo.idPunto,
            				idParametroValor : array[x].parametro_valor,
            				idMatriz : array[x].matriz,
            				idSubMatriz: array[x].submatriz,
            				estado : 'P'
                	};
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
                        }
                    }).catch(function(error) {
                        toastr.error('No se pudo obtener los datos.');
                    });
                }
            });
        }


        function confirmarEliminacionPunto(prmDeclaracionPunto){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar el registro?'
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminarDeclaracionPunto(prmDeclaracionPunto);
             });
        }

        function eliminarDeclaracionPunto(prmDeclaracionPunto){
        	vm.verPuntosMonitoreo = false;
        	DeclaracionPuntoFactory.eliminar(angular.copy(prmDeclaracionPunto)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    cargarDeclaracionComponentes();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }

        function confirmarEliminacionParametro(prmDeclaracionParametro){
       	 ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionParametro(prmDeclaracionParametro);
            });
       }

       function eliminarDeclaracionParametro(prmDeclaracionParametro){
       	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar el parametro');
           });
       }




        function cargarPeriodos() {

        	vm.dataTipoPeriodo.codigoMaestro = 'TipoPeriodo';
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }


        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }

        function declaracion(item){
            getMensajeDeclaracionJurada();
          	 ngDialog.openConfirm({
                   template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                   controller: 'DialogConfirmController',
                   controllerAs: 'vm',
                   data: {
	                     Titulo: 'Declaración Jurada',
	                     Mensaje: vm.mensajeDeclaracionJurada
	                 },
                   width: '380px'
               }).then(function(okValue) {
                   cerrarInformeMonitoreo(item);
               });

          }

        function getMensajeDeclaracionJurada() {
            //console.log("vm.dataMaestros.codigoMaestro" + vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }

        function cerrarInformeMonitoreo(item){
        			vm.objInformeSel.estado = '2';
	        		InformeMonitoreoFactory.cerrarInforme(angular.copy(item)).then(function(response) {
	                    if (response != null && response.valido) {
	                    	toastr.success('Se cerró el informe de monitoreo correctamente');
	                    	cargarInformes();
	                    	vm.verComponentes = false;
	                    }
	    			});
        }

        function abrirInformeMonitoreo(item){
        	vm.objInformeSel.estado = '1';
    		InformeMonitoreoFactory.abrirInforme(angular.copy(item)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success('Se Abrió el informe de monitoreo correctamente');
                	cargarInformes();
                	vm.verComponentes = false;
                }
			});
        }

        function guardarDeclaracion() {

        	// Declaración Etapa
        	vm.objInstrumentoGestion.declaracionEtapa.idAdministrado = vm.objInstalacion.idAdministrado;
        	vm.objInstrumentoGestion.declaracionEtapa.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
        	vm.objInstrumentoGestion.declaracionEtapa.idInstalacion = vm.objInstrumentoGestion.idInstalacion;

        	// Declaracion Componentes
        	vm.declaracionComponente = DeclaracionComponenteFactory.model();
        	// actualizamos la relacion:
           	for (var x in vm.lstComponentes) {
                	if (vm.lstComponentes[x].blSeleccionado){

                		 vm.declaracionComponente.idAdministrado = vm.objInstalacion.idAdministrado;
                		 vm.declaracionComponente.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
                		 vm.declaracionComponente.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
                		 vm.declaracionComponente.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa ;
                		 vm.declaracionComponente.idComponente = vm.lstComponentes[x].codigo ;
                		 vm.declaracionComponente.idFrecuencia = vm.lstComponentes[x].idFrecuencia ;
                		 vm.declaracionComponente.estado = '1' ;
                		 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(angular.copy());
                	}
                }

        	InstrumentoGestionFactory.registrarDeclaracion(angular.copy(vm.objInstrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo guardar.');
            });
        }

            function init() {
                if (angular.isDefined(localStorage.objInstrumentoGestion)) {
                    vm.objInstrumentoGestion = angular.copy(angular.fromJson(localStorage.objInstrumentoGestion));
                    vm.objInstrumentoGestion.declaracionEtapa = DeclaracionEtapaFactory.model();
                }
                if (angular.isDefined(localStorage.objInstalacion)) {
                    vm.objInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                }
                vm.objInformeMonitoreo.fechaPresentacion = new Date();
                cargarCombos();
                obtenerParametros();
            }




            function cargarPeriodosHijos(itempadre) {

            	var dataTipoPeriodo = {
            		codigoMaestro : 'TipoPeriodo',
            		codigoRegistroPadre :  itempadre
            	};

                MaestroFactory.buscarRegistroHijo(angular.copy(dataTipoPeriodo)).then(function(response) {
                    if (response != null && response.valido) {
                    	vm.lstPeriodosHijos = response.data;
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });

            }


            function convertirRomanoALatinoNumero(numromano){
            		if(numromano=='ENERO'){
            			return 1;
            		}
            		if(numromano=='FEBRERO'){
            			return 2;
            		}
            		if(numromano=='MARZO'){
            			return 3;
            		}
            		if(numromano=='ABRIL'){
            			return 4;
            		}
            		if(numromano=='MAYO'){
            			return 5;
            		}
            		if(numromano=='JUNIO'){
            			return 6;
            		}
            		if(numromano=='JULIO'){
            			return 7;
            		}
            		if(numromano=='AGOSTO'){
            			return 8;
            		}
            		if(numromano=='SEPTIEMBRE'){
            			return 9;
            		}
            		if(numromano=='OCTUBRE'){
            			return 11;
            		}
            		if(numromano=='NOVIEMBRE'){
            			return 12;
            		}
            		if(numromano=='DICIEMBRE'){
            			return 13;
            		}
            		if(numromano=='I'){
            			return 1;
            		}
            		if(numromano=='II'){
            			return 2;
            		}
            		if(numromano=='III'){
            			return 3;
            		}
            		if(numromano=='IV'){
            			return 4;
            		}
            		if(numromano=='V'){
            			return 5;
            		}
            		if(numromano=='VI'){
            			return 6;
            		}

            }


        init();
        /* fin de controller */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstalacionInformeInstrumentoController', InstalacionInformeInstrumentoController);
    /* @ngInject */
    function InstalacionInformeInstrumentoController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory,  InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        vm.nuevoIGA = nuevoIGA;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.irDeclaracion = irDeclaracion;
        vm.idInstrumentoGestion;
        vm.irInformeMonitoreo = irInformeMonitoreo;
        
        function irDeclaracion(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-declaracion');
        }
        
        function irInformeMonitoreo(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.instalacion-informe');
        }
        
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarMonitoreoPorInstalacion(angular.copy(vm.prmInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
        	if (angular.isDefined(localStorage.dataListaInstalacion)) {
                vm.dataListaInstalacion = angular.copy(angular.fromJson(localStorage.dataListaInstalacion));
            }
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.idAdministrado =  angular.copy(vm.prmInstalacion.idAdministrado);
                vm.prmInstrumentoGestion.estado = "T";
                buscarInstrumentoGestion();
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        // Nuevo IGA
        function nuevoIGA(datoParametro) {
        	
        	if(datoParametro != null){
        		vm.idInstrumentoGestion = datoParametro.idInstrumentoGestion;
        		$rootScope.prmdatoInstrumento = angular.copy(datoParametro);
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '700px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	else{
        		$rootScope.prmdatoInstrumento = angular.copy(InstrumentoGestionFactory.model());
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '700px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	
        }
        
        function confirmarEliminacion(prmInstrumentoGestion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstrumentoGestion.resolucion  + ' ' + prmInstrumentoGestion.auxTipoIgaNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstrumentoGestion);
            });
        }
        
        function eliminar(prmInstrumentoGestion){
        	 	InstrumentoGestionFactory.eliminar(angular.copy(prmInstrumentoGestion)).then(function(response) {
                     if (response.valido) {
                         toastr.success(response.mensaje);
                         buscarInstrumentoGestion();
                     } else {
                         toastr.error(response.mensaje)
                     }
                 }).catch(function(error) {
                     toastr.error('Ocurrió un error al eliminar la parametro');
                 });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.etapa').controller('InstalacionDeclaracionResiduosController', InstalacionDeclaracionResiduosController);
    /* @ngInject */
    function InstalacionDeclaracionResiduosController(ngDialog, API_CONFIG , toastr, $scope, $state, $rootScope, ResiduoFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        vm.rutaBase = API_CONFIG.url;
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.lstResiduos = [];
        vm.prmResiduo = ResiduoFactory.model();
        vm.cancelar = cancelar;
        
        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
        }

        function agregarItem(item) {
        	 if (item != null) {
                 
        		 ResiduoFactory.buscarPorId(angular.copy(item)).then(function(response) {
                 	console.log('response.valido ' + response.valido);
                 		if (response.valido) {
                         	$rootScope.itemResiduo = response.data;
                         	  ngDialog.open({
                                   template: 'app/modules/residuos/declaracion_anual_residuos_edicion.html',
                                   controller: 'DeclaracionResiduosEdicionController',
                                   controllerAs: 'vm',
                                   
                                   width: '70%'
                               }).closePromise.then(function(dataDialog) {
                                   listar();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la etapa');
 		                });
             } 
             else{
            	$rootScope.itemResiduo = ResiduoFactory.model();
             	ngDialog.open({
                     template: 'app/modules/residuos/declaracion_anual_residuos_edicion.html',
                     controller: 'DeclaracionResiduosEdicionController',
                     controllerAs: 'vm',
                     
                     width: '70%'
                 }).closePromise.then(function(dataDialog) {
                     listar();
                 });
             }
        }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }
        
        function confirmarInactivacion(prmEtapa) {
        	
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }
        
        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }

        function listar() {
        	vm.prmResiduo.tipo = 'DR';
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ResiduoFactory.listar(angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstResiduos = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	  if (angular.isDefined(localStorage.objInstalacion)) {
                  vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                  vm.prmResiduo.idInstalacion = vm.prmInstalacion.idInstalacion;
                  vm.prmResiduo.idAdministrado = vm.prmInstalacion.idAdministrado;
                  listar();
              }
            
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstalacionDeclaracionController', InstalacionDeclaracionController);
    /* @ngInject */
    function InstalacionDeclaracionController($state, toastr, ngDialog, $scope, DeclaracionEtapaFactory, DeclaracionComponenteFactory, DeclaracionPuntoFactory, CookiesFactory, DeclaracionParametroFactory, AdministradoFactory, MaestroFactory, InstalacionFactory, InstrumentoGestionFactory,  $filter, $log, $rootScope, EtapaFactory,ComponenteAmbientalFactory, API_CONFIG, $window) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        /* Lista de Combos */

        /* declaracion de metodos enlazados a la vista */
        /** ****** */
        vm.cancelar = cancelar;
        
        // Lista de Etapas para iniciar la declaración de información
        vm.lstEtapas = [];
        
        // Lista de Periodos para seleccionar la frecuencia por cada componente
		// ambiental
        vm.lstPeriodos = [];
        
        // Lista de puntos de monitoreo de un componente ambiental
        vm.lstDeclaracionPunto = [];
        
        // Lista de Parametros de un punto de monitoreo
        vm.lstDeclaracionParametro = [];
        
        // Filtro para el listado de Etapas para iniciar la declaración de
		// información
        vm.dataEtapa = EtapaFactory.model();
       
         // Filtro para el listado de Periodos para iniciar la declaración de
		// información
        vm.dataTipoPeriodo = MaestroFactory.model();
        
        // Objeto principal que contiene toda la informacion para la declaracion
        vm.objInstrumentoGestion ;
        
        // Objeto para mostrar los datos de la instalación
        vm.objInstalacion;
        
        // Metodo principal para grabar los datos de la declaración de la
		// información a remitir
        vm.guardarDeclaracion = guardarDeclaracion;
        
        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.agregarDeclaracionComponentes = agregarDeclaracionComponentes;
        
        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionComponentes = actualizarDeclaracionComponentes; 
        
        // carga los componenetes de la declaración según la etapa seleccionada
        vm.cargarDeclaracionComponentes = cargarDeclaracionComponentes;
        
        // carga los puntos de monitorreo según el componente seleccionado
        vm.cargarDeclaracionPuntosMonitoreo = cargarDeclaracionPuntosMonitoreo;
        
        vm.agregarDeclaracionPuntosMonitoreo = agregarDeclaracionPuntosMonitoreo;
        
        vm.agregarDeclaracionParametros = agregarDeclaracionParametros;
        
        vm.verPuntosMonitoreo = false;
        vm.verFrecuenciaAbandono = false;
        vm.verComponentes = false;
        	
        // confirma eliminación de los compoenestes de un proyecto en la
		// declaración
        vm.confirmarEliminacionComponente = confirmarEliminacionComponente;
        
        // Componente seleccionado para agregar puntos de monitoreo
        vm.objDeclaracionComponente ;
        
      // Punto de Monitoreo seleccionado para agregar parametros
        vm.objDeclaracionPuntoMonitoreo ;
        
        vm.cargarDeclaracionParametros = cargarDeclaracionParametros;
        
        vm.confirmarEliminacionPunto = confirmarEliminacionPunto;
        
        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;
        
        vm.activeetapa = vm.activeetapa;
        
        vm.active = 0;
        
        vm.cambiarEtapa = cambiarEtapa;
        
       
        /* declaracion de metodos */
        
        function cambiarEtapa(etapa){
        	vm.objDeclaracionComponente = null;
        	cargarDeclaracionComponentes(etapa);
        }
        
        function cancelar() {
            $state.go('spapp.home.supervision.instalacion-instrumento');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
        	cargarEtapas();
            cargarPeriodos();
        }
        
        function cargarEtapas() {
        	vm.dataEtapa.estado = '1';
            EtapaFactory.listarActivosPorUnidad(angular.copy(vm.dataEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = response.data;
                    if( vm.activeetapa == null){
                    	 vm.activeetapa = 1;
                    }
                    vm.active = 0;
                    cargarDeclaracionComponentes(vm.lstEtapas[1]);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function cargarDeclaracionPuntosMonitoreo(prmComponente){
        	if(prmComponente == null){
        		vm.objDeclaracionComponente = DeclaracionComponenteFactory.model();
        		return;
        	}
        	
        	vm.verPuntosMonitoreo = true;
        	vm.verParametros = false;
        	vm.objDeclaracionComponente = prmComponente;
        	
        	var tempPunto = {
        			idAdministrado : prmComponente.idAdministrado,
    				idIga : prmComponente.idIga,
    				idInstalacion : prmComponente.idInstalacion,
    				idEtapa : prmComponente.idEtapa,
    				idComponente : prmComponente.idComponente,
    				origen : 'D'
            	};
        	
        	 DeclaracionPuntoFactory.listar(angular.copy(tempPunto)).then(function(response) {
                 if (response != null && response.valido) {
                	 vm.lstDeclaracionPunto = angular.copy(response.data);
                	 
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function agregarDeclaracionPuntosMonitoreo(prmPuntoMonitoreo) {
        	
        	if(prmPuntoMonitoreo == null){
        		prmPuntoMonitoreo = DeclaracionPuntoFactory.model();
        		prmPuntoMonitoreo.idAdministrado  = vm.objDeclaracionComponente.idAdministrado;
        		prmPuntoMonitoreo.idIga  = vm.objDeclaracionComponente.idIga;
        		prmPuntoMonitoreo.idInstalacion  = vm.objDeclaracionComponente.idInstalacion;
        		prmPuntoMonitoreo.idEtapa  = vm.objDeclaracionComponente.idEtapa;
        		prmPuntoMonitoreo.idComponente  = vm.objDeclaracionComponente.idComponente;
        		prmPuntoMonitoreo.origen= 'D';
        	}
        		
        	$rootScope.objDeclaracionPunto = prmPuntoMonitoreo;
        		
            ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/declaracion/cargainfo-punto-monitoreo.html',
                controller: 'CargaInfoPuntoMonitoreoController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
            });
        }
        
        function cargarDeclaracionComponentes(etapa,active) {
        	
        	var tempetapa = null;
        	if( etapa.codetapa != null){
        		tempetapa = etapa.codetapa;
        	}
        	if( etapa.idEtapa != null){
        		tempetapa = etapa.idEtapa;
        	}
        	if( etapa.descripcion == 'ABANDONO' || vm.activeetapa == 2){
        		vm.verFrecuenciaAbandono = false;
        	}else{
        		vm.verFrecuenciaAbandono = true;
        	}
        	
        	vm.objInstrumentoGestion.declaracionEtapa.idEtapa = tempetapa;
        	vm.verPuntosMonitoreo = false;
        	vm.verParametros = false;
        	vm.verComponentes = true;
        	
        	if(vm.objInstrumentoGestion.declaracionEtapa.idEtapa == 0){
        		vm.verComponentes = false;
        		return;
        	}
        	
        	var tempComponente = {
        		idAdministrado : vm.objInstalacion.idAdministrado,
        	    idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
        	    idInstalacion : vm.objInstrumentoGestion.idInstalacion,
        	    idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
        	    origen : 'D'
        	};
    	 
        	DeclaracionComponenteFactory.listar(angular.copy(tempComponente)).then(function(response) {
             if (response != null && response.valido) {
            	 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = angular.copy(response.data);
            	 if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length > 0){
            		 if(vm.objDeclaracionComponente == null){
            			 vm.objDeclaracionComponente = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[0];
            		 }
            		 cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);            		 
            	 }
             }
         }).catch(function(error) {
             toastr.error('No se pudo obtener los datos.');
         }).finally(function(){
         });
        	
        	
        	
    	 
        }
        
        function agregarDeclaracionComponentes() {
        	$rootScope.lstComponentesBase = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes;
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-selector.html',
                controller: 'ComponenteAmbientalSelectorController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	var array  = $rootScope.lstComponentesSel;
            	if (angular.isDefined(array)){
            		if(array.length > 0){
            			
            			//GUARDAMOS LA ETAPA
            			var tempEtapa = {
            					idAdministrado : vm.objInstalacion.idAdministrado,
            					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
            					idInstalacion : vm.objInstalacion.idInstalacion,
            					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
            					estado : 'P',
            					prm1: CookiesFactory.obtenerCookie(),
            		    };
            			DeclaracionEtapaFactory.generarEtapa(angular.copy(tempEtapa)).then(function(response) {
                            if (response != null && response.valido) {
                            	for (var x in array) {
                    				var tempComponente = {
                    					idAdministrado : vm.objInstalacion.idAdministrado,
                    					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
                    					idInstalacion : vm.objInstalacion.idInstalacion,
                    					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
                    					idComponente : array[x].codigo,
                    					idFrecuencia : null,
                    					estado : 'P',
                    					origen : 'D',
                    					prm1: CookiesFactory.obtenerCookie(),
                    		        };
                    				guardarDeclaracionComponentes(tempComponente);
                                }
                            }
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos.');
                        });
            			
            		}
            	}
             	
            });
        }
        
        function guardarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.registrar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function actualizarDeclaracionComponentes(prmComponente){
        	vm.objDeclaracionComponente = prmComponente;
        	DeclaracionComponenteFactory.actualizar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function confirmarEliminacionComponente(prmDeclaracionComponente){
        	var punto = {
        			idAdministrado : prmDeclaracionComponente.idAdministrado,
    				idIga : prmDeclaracionComponente.idIga,
    				idInstalacion : prmDeclaracionComponente.idInstalacion,
    				idEtapa : prmDeclaracionComponente.idEtapa,
    				idComponente : prmDeclaracionComponente.idComponente
        	}
        	
        	DeclaracionPuntoFactory.contar(angular.copy(punto)).then(function(response) {
                var mensaje = '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + '?';
        		if (response.valido) {
        			if(response.data>0){
        				mensaje = '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + ' y sus puntos de monitoreo asociados?'	
        			}
        			ngDialog.openConfirm({
                        template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                        controller: 'DialogConfirmController',
                        controllerAs: 'vm',
                        data: {
                            Titulo: 'Confirmar eliminación',
                            Mensaje: mensaje
                        },
                        width: '380px'
                    }).then(function(okValue) {
                        eliminarDeclaracionComponente(prmDeclaracionComponente);
                    });
                } else {
                    toastr.error(response.mensaje)
                }
                
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        	
        }
        
        function eliminarDeclaracionComponente(prmDeclaracionComponente) {
        	DeclaracionComponenteFactory.eliminar(angular.copy(prmDeclaracionComponente)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length==0){
                    	// si no hay datos ocultamos toda la información
                    	vm.verPuntosMonitoreo = false;
                    }
                    vm.objDeclaracionComponente =null;
                    cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }
        
        
        function  cargarDeclaracionParametros(prmPuntoMonitoreo){
// vm.verParametros = true;
// vm.objDeclaracionPuntoMonitoreo = prmPuntoMonitoreo;
//        	
// var tempPuntoMonitoreo = {
// ruc : vm.objInstalacion.ruc,
// idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
// idInstalacion : vm.objInstrumentoGestion.idInstalacion,
// idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
// idComponente : prmPuntoMonitoreo.idComponente,
// idPunto : prmPuntoMonitoreo.idPunto,
// };
//    	 
// DeclaracionParametroFactory.listar(angular.copy(tempPuntoMonitoreo)).then(function(response)
// {
// if (response != null && response.valido) {
// vm.lstDeclaracionParametro = angular.copy(response.data);
// }
// }).catch(function(error) {
// toastr.error('No se pudo obtener los datos.');
// });
        	
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};
        	
        	$rootScope.prmPuntoMonitoreo = prmPuntoMonitoreo;
        	$rootScope.prmComponente = componente;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/declaracion/cargainfo-declaracion-parametro.html',
                controller: 'CargaInfoDeclaracionParametroController',
                controllerAs: 'vm',
                width: '75%'
            });
        }
        
        
        function agregarDeclaracionParametros(){
        	
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};
        	
        	$rootScope.prmComponente = componente;
        	$rootScope.lstParametrosComponenteBase  = vm.lstDeclaracionParametro;
        	ngDialog.open({
                template: 'app/modules/componente-parametro/componente-parametro-selector.html',
                controller: 'ComponenteParametroSelectorController',
                controllerAs: 'vm',
                
                width: '50%'
            }).closePromise.then(function(dataDialog) {
            	var array = $rootScope.lstParametrosComponenteSel;
                for (var x in array){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.objDeclaracionComponente.idAdministrado,
            				idIga : vm.objDeclaracionComponente.idIga,
            				idInstalacion : vm.objDeclaracionComponente.idInstalacion,
            				idEtapa : vm.objDeclaracionComponente.idEtapa,
            				idComponente : vm.objDeclaracionComponente.idComponente,
            				idPunto : vm.objDeclaracionPuntoMonitoreo.idPunto,
            				idParametroValor : array[x].parametro_valor,
            				idMatriz : array[x].matriz,
            				idSubMatriz: array[x].submatriz,
            				estado : 'P'
                	};
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
                        }
                    }).catch(function(error) {
                        toastr.error('No se pudo obtener los datos.');
                    });
                }
            });
        }
        
        
        function confirmarEliminacionPunto(prmDeclaracionPunto){
        	var parametro = {
        			idAdministrado : prmDeclaracionPunto.idAdministrado,
    				idIga : prmDeclaracionPunto.idIga,
    				idInstalacion : prmDeclaracionPunto.idInstalacion,
    				idEtapa : prmDeclaracionPunto.idEtapa,
    				idComponente : prmDeclaracionPunto.idComponente,
    				idPunto : prmDeclaracionPunto.idPunto
        	}
        	
        	DeclaracionParametroFactory.contar(angular.copy(parametro)).then(function(response) {
                if (response != null && response.valido) {
                	var mensaje = '¿Está seguro de eliminar el registro ' + prmDeclaracionPunto.codigo + '?';
                	if(response.data > 0){
                		mensaje = '¿Está seguro de eliminar el registro ' + prmDeclaracionPunto.codigo + ' y todos los parámetros relacionados?';
                	}
                	ngDialog.openConfirm({
                        template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                        controller: 'DialogConfirmController',
                        controllerAs: 'vm',
                        data: {
                            Titulo: 'Confirmar eliminación',
                            Mensaje: mensaje
                        },
                        width: '380px'
                    }).then(function(okValue) {
                        eliminarDeclaracionPunto(prmDeclaracionPunto);
                    });
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function eliminarDeclaracionPunto(prmDeclaracionPunto){
        	vm.verPuntosMonitoreo = false;
        	DeclaracionPuntoFactory.eliminar(angular.copy(prmDeclaracionPunto)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }
        
        function confirmarEliminacionParametro(prmDeclaracionParametro){
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionParametro(prmDeclaracionParametro);
            });
       }
       
       function eliminarDeclaracionParametro(prmDeclaracionParametro){
       	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar el parametro');
           });
       }
        
        
        
        
        function cargarPeriodos() {
        	
        	vm.dataTipoPeriodo.codigoMaestro = 'TipoPeriodo';
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
        }
        
      
        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        function guardarDeclaracion() {
        	
        	// Declaración Etapa
        	vm.objInstrumentoGestion.declaracionEtapa.idAdministrado = vm.objInstalacion.idAdministrado;
        	vm.objInstrumentoGestion.declaracionEtapa.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
        	vm.objInstrumentoGestion.declaracionEtapa.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
        	
        	// Declaracion Componentes
        	vm.declaracionComponente = DeclaracionComponenteFactory.model();
        	// actualizamos la relacion:
           	for (var x in vm.lstComponentes) {
                	if (vm.lstComponentes[x].blSeleccionado){
                		
                		 vm.declaracionComponente.idAdministrado = vm.objInstalacion.idAdministrado;
                		 vm.declaracionComponente.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
                		 vm.declaracionComponente.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
                		 vm.declaracionComponente.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa ;
                		 vm.declaracionComponente.idComponente = vm.lstComponentes[x].codigo ;
                		 vm.declaracionComponente.idFrecuencia = vm.lstComponentes[x].idFrecuencia ;
                		 vm.declaracionComponente.estado = '1' ;
                		 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(angular.copy(vm.declaracionComponente));
                	}
                }
        	
        	InstrumentoGestionFactory.registrarDeclaracion(angular.copy(vm.objInstrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo guardar.');
            });
        }
        
   
            function init() {
                if (angular.isDefined(localStorage.objInstrumentoGestion)) {
                    vm.objInstrumentoGestion = angular.copy(angular.fromJson(localStorage.objInstrumentoGestion));
                    vm.objInstrumentoGestion.declaracionEtapa = DeclaracionEtapaFactory.model();
                }
                if (angular.isDefined(localStorage.objInstalacion)) {
                    vm.objInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                }
                cargarCombos();
            }
       
      
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AccionInstalacionController', AccionInstalacionController);
    /* @ngInject */
    function AccionInstalacionController($location, $rootScope, toastr, ngDialog, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, SolicitudFactory, $scope, $state, CuestionarioFactory, CookiesFactory,OpcionPreguntaFactory, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.validaArchivoModificacionInst = 0;
        $rootScope.active = 0;
        $scope.serial = 1;
        /* Configuracion de paginacion de tablas */
        vm.urlData = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        /** *************************************************************************** */
        /** * Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataCuestionarioAutosupervision = [];
        /** *************************************************************************** */
        /** * Fin Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataAdministradoContacto = ContactoAdministradoFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataContacto = {
            tipoContacto: '0'
        };
        
        vm.dataInstalacion = InstalacionFactory.model();
        vm.listaTipoPersona = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaTipoDocumento = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSector = [];
        vm.listaSubSector = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaActividad = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSolicitudesInstalacion = [];
        vm.listaContactoAdministrado = [];
        vm.listaArchivosSolicitud = [];
        vm.listaCboTipoContacto = [];
        vm.listaInstalacionAdm = [];
        vm.listaDepartamentoPersona = [];
        vm.listaProvinciaPersona = [];
        vm.listaDistritoPersona = [];
        vm.listaTipoEstablecimiento = [];
        vm.listarContactoPrincipal = [];
        vm.btnAgregarInstalacion = false;
        vm.btnListaInstalacion = true;
        vm.cambiarEstadoContacto = cambiarEstadoContacto;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.validaDocumento = validaDocumento;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.contactoPrincipal = contactoPrincipal;
        vm.mostrarInformacionInstalacionDialog = mostrarInformacionInstalacionDialog;
        vm.MostrarForm = MostrarForm;
        vm.OcultarForm = OcultarForm;
        vm.irCompromisos = irCompromisos;
        vm.irInformeMonitoreo = irInformeMonitoreo;
        vm.irInformesSupervision = irInformesSupervision;
        vm.irDeclaracionResiduos = irDeclaracionResiduos;
        vm.irManifiestoResiduos = irManifiestoResiduos;
        vm.irPresentacion = irPresentacion;
        vm.mostrarModificarInstalacion = mostrarModificarInstalacion;
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.mostrarCancelarInstalacion = mostrarCancelarInstalacion;
        vm.valorTelefono = valorTelefono;
        vm.modificar = 0;
        vm.limpiarContactoAdmi = limpiarContactoAdmi;
        vm.habilitarTexto = habilitarTexto;
        vm.guardar = guardar;
        vm.cambioDatos = cambioDatos;
        /** *** */
        
        vm.ruc;
        vm.agregarInstalacion = agregarInstalacion;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.buscar = buscar;
        

        function confirmarEliminacion(prmInstalacion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstalacion.numeroInstalacion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstalacion,true);
            });
        }

        function eliminar(prmInstalacion, validar) {
        	prmInstalacion.isvalidar = validar; 
        	InstalacionFactory.eliminar(angular.copy(prmInstalacion)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarInstalacionesAdministrado();
                } else {
                	validacionModal(prmInstalacion, response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la instalación');
            });
        }
        
        function agregarInstalacion(prmInstalacion){
             if (prmInstalacion != null) {
                 
            	 InstalacionFactory.buscarPorId(angular.copy(prmInstalacion)).then(function(response) {
                 		if (response.valido) {
                         	$rootScope.prmInstalacion = response.data;
                         	  ngDialog.open({
                         		  template: 'app/modules/supervision/instalacion/accion-instalacion/accion-instalacion-edicion.html',
                                   controller: 'AccionInstalacionEdicionController',
                                   controllerAs: 'vm',
                                   width: '70%'
                               }).closePromise.then(function(dataDialog) {
                            	   listarInstalacionesAdministrado();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la parametro');
 		                });
             } 
             else{
             	$rootScope.prmInstalacion =  InstalacionFactory.model();
             	ngDialog.open({
                     template: 'app/modules/supervision/instalacion/accion-instalacion/accion-instalacion-edicion.html',
                     controller: 'AccionInstalacionEdicionController',
                     controllerAs: 'vm',
                     width: '70%'
                 }).closePromise.then(function(dataDialog) {
                	 listarInstalacionesAdministrado();
                 });
             }
        }
        
        function irCompromisos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.instalacion-instrumento');
        }
        
        function irInformeMonitoreo(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.instalacion-informe-instrumento');
        }
        
        function irInformesSupervision(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.informes');
        }
        
        function irDeclaracionResiduos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.instalacion-residuos-declaracion');
        }
        
        function irManifiestoResiduos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.instalacion-residuos-manifiesto');
        }

        function irPresentacion(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.instalacion-presentacion');
        }
        
        
        
        function MostrarForm() {
            vm.btnAgregarInstalacion = true;
            vm.btnListaInstalacion = false;
        }

        function OcultarForm() {
            vm.btnAgregarInstalacion = false;
            vm.btnListaInstalacion = true;
            vm.dataInstalacion = angular.copy(InstalacionFactory.model());
            vm.validaArchivoModificacionInst = 0;
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            listarInstalacionesAdministrado();
        }
        /* implementacion de metodos */
        // usuario.actual= angular.fromJson(localStorage.objSesSisoLocStWqKP);
        /** ****************************************************************** */
        /**/
        function contactoPrincipal(prmData) {
            ContactoAdministradoFactory.modificarFlagPretedeterminadoDeContactoAdmi(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }
        /** *************************************************************** */
        /**/
        function habilitarTexto() {}

        function guardar() {
            habilitarTexto();
        }
        /**/
        /*-----LISTAR CONTACTO ADMINISTRADO------*/

        function cambiarEstadoContacto(data, estado) {
            // vm.confirmarDesactivarAdmi(item);
            var prmData = data;
            if (prmData != null) {
                prmData.estado.codigoRegistro = 2;
                // alert("DESCRRIPCION" +
				// vm.dataAdministradoContacto.estado.descripcion);
                if (prmData.estado.descripcion == 'DESACTIVADO') {
                    prmData.estado.codigoRegistro = 2;
                }
                // prmData.estado = 2;
            }
            ContactoAdministradoFactory.actualizar(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }

        function limpiarContactoAdmi() {
            vm.dataContactoAdministrado.tipoContacto.codigoRegistro = 0;
            vm.dataContactoAdministrado.valor = "";
        }


        function buscar(prm1) {
	            localStorage.removeItem("objInstalacion");
	            localStorage.removeItem("dataListaInstalacion");
            
                 if(prm1==null || prm1 == ''){
                	 prm1 = localStorage.objlocalStRefSisoplkijsq;
                 }
                 
                 var ruc = angular.copy(angular.fromJson(localStorage.wk));
                 
                 var data = {
                     prm1: prm1,
                     prm2: ruc
                 };
                 AdministradoFactory.buscarxid( /* vm.dataAdministrado */ angular.copy(data)).then(function(response) {
                     if (response.valido) {
                         vm.dataAdministrado = response.data;
                         listarInstalacionesAdministrado();
                     } else {
                         toastr.error('Usted no es un Administrado');
                     }
                 }).catch(function(error) {
                     toastr.error('Error al consultar');
                 }).finally(function() {
                 });
        	 
        	
        }

        function listarSubSector() {
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.subSector = '';
            vm.dataInstalacion.actividad = '';
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaSubSector" +
						 * angular.toJson(vm.listaSubSector));
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }

        function listarActividad() {
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.actividad.codigoRegistro = 0;
            /*
			 * vm.dataInstalacion.actividad=0; vm.listaActividad=[];
			 */
            if (vm.dataInstalacion.subSector != 0) {
                var actividades = {
                    codigoRegistroPadre: vm.dataInstalacion.subSector,
                    codigoMaestro: 'Actividad'
                }
                MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaActividad.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaActividad" +
						 * angular.toJson(vm.listaActividad));
						 * vm.dataNormas.actividad=0;
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        function listarInstalacionesAdministrado() {
        	vm.dataListaInstalacion.idAdministrado = vm.dataAdministrado.idAdministrado;
            InstalacionFactory.listar(angular.copy(vm.dataListaInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.listaInstalacionAdm = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarInformacionInstalacionDialog(itemInstalacion) {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html',
                controller: 'InformacionInstalacionDialogController',
                data: {
                    data: itemInstalacion
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }
        /** ******************************************************************************** */
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Seleccione'
            }];
            UbigeoFactory.listarDepartamento(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarProvincia();
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.provincia.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.provincia.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarProvincia(vm.provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarDistrito();
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            vm.distrito.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.distrito.codigoProvincia = vm.dataListaInstalacion.provincia.codigoProvincia;
            vm.distrito.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarDistrito(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            vm.validaArchivo = '0';
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                vm.validaArchivo = '1';
                vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
            }
            if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
                console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
            }
        }
        /** *********************************************************************************** */
        function procesoRegistroSolicitudArchivo() {
            if (vm.validaArchivo == '1') {
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
            } else {
                toastr.info('Falta cargar ficha de registro');
                return;
            }
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
            // console.log("vm.listaArchivosSolicitud" +
			// vm.listaArchivosSolicitud);
            // console.log("vm.listaArchivosSolicitud.length" +
			// vm.listaArchivosSolicitud.length);
            vm.dataSolicitud.tipoSolicitud = 3;
            console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
            console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada correctamente');
                    // localStorage.setItem("dataListaInstalacion",
					// angular.copy(angular.toJson(vm.dataListaInstalacion)));
                    // $state.go('ingreso');
                    // crear metodo para limpiar todos los campos y el campo de
					// file
                    // direccionar al listado de instalaciones
                    console.log("vm.dataSolicitud", vm.dataSolicitud);
                    visualizarModal();
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }

        function visualizarModal() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de nueva instalación ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function visualizarModalSolicitudModificacion() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de modificación de datos ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function procesoModificacionDeInstalacion() {
            if (vm.validaArchivoModificacionInst == 0 && vm.validaArchivo != '1') {
                toastr.warning('Debe subir un archivo para continuar con la modificación');
                return;
            }
            if (vm.validaArchivoModificacionInst == 1) {
                vm.validaArchivo = '0';
            }
            if (vm.validaArchivo == '1') {
                console.log("Realiza el Registro CON NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // localStorage.setItem("dataListaInstalacion",
						// angular.copy(angular.toJson(vm.dataListaInstalacion)));
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            } else {
                console.log("Realiza el Registro SIN NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                data.estado = 1;
                data.flagActivo = 1;
                vm.listaSolicitudesInstalacion.push(data);
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataAdministrado.flagActivo = 1;
                vm.dataAdministrado.estado = 1;
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                // console.log("Data a enviar
				// listaArchivosSolicitud",vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudSinArchivo(vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // localStorage.setItem("dataListaInstalacion",
						// angular.copy(angular.toJson(vm.dataListaInstalacion)));
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                        console.log("vm.dataSolicitud", vm.dataSolicitud);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            }
            /*
			 * console.log("ENTRA AL PROCESO DE MODIFICACION");
			 * console.log("vm.dataInstalacion",vm.dataInstalacion);
			 */
        }

        function registrarSolicitudArchivo() {
            if (vm.modificar != 1) {
                procesoRegistroSolicitudArchivo();
            } else {
                procesoModificacionDeInstalacion();
            }
        }
        /** ******************************************************************************** */
        /* Metodo para utilizado para cancelar instalacion */
        /** ******************************************************************************** */
        function mostrarCancelarInstalacion(itemInstalacion) {
            if (itemInstalacion.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog-cancelacion/cancelacion-instalacion-dialog.html',
                controller: 'CancelacionInstalacionDialogController',
                data: {
                    data: itemInstalacion,
                    dataAdministrado: vm.dataAdministrado
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function() {
                listarInstalacionesAdministrado();
            });
        }
        /** ********************************************************************************** */
        /* metodo para modificar instalación */
        /** ********************************************************************************** */
        function mostrarModificarInstalacion(item, modificar) {
            // modificar =1 -> Se trata de una modificacion
            debugger;
            if (item.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            vm.dataInstalacion = angular.copy(item);
            console.log(vm.dataInstalacion);
            vm.dataInstalacionTemporal = angular.copy(item);
            console.log(item);
            vm.modificar = modificar;
            vm.validaArchivoModificacionInst = 1;
            // listarSubSector();
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector != '') {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(angular.copy(subSector)).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                }).finally(function() {
                    debugger;
                    vm.dataInstalacion.subSector = angular.copy(item.subSector);
                    if (vm.dataInstalacion.subSector.codigoRegistro != 0) {
                        var actividades = {
                            codigoRegistroPadre: vm.dataInstalacion.subSector.codigoRegistro,
                            codigoMaestro: 'Actividad'
                        }
                        MaestroFactory.buscarRegistroHijo(angular.copy(actividades)).then(function(response) {
                            if (response != null && response.valido) {
                                for (var x in response.data) {
                                    vm.listaActividad.push(response.data[x]);
                                }
                                vm.dataInstalacion.actividad = angular.copy(item.actividad);
                                /*
								 * console.log("vm.listaActividad" +
								 * angular.toJson(vm.listaActividad));
								 * vm.dataNormas.actividad=0;
								 */
                            }
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos para los combos.');
                        });
                    }
                });
            }
            // listarActividad();
            for (var i = 0; i < 3; i++) {
                ejecutarfuncionesOrdenadas(i);
            }
        }

        function ejecutarfuncionesOrdenadas(item) {
            if (item == 0) {
                listarProvincia();
            }
            if (item == 1) {
                listarDistrito();
            }
            if (item == 2) {
                MostrarForm();
            }
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * 5 - 4;
        }

        function valorTelefono(valor) {
            var item = angular.element('#txtTelefono').val();
            if (item.length >= 13) {
                vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{4})[ .-]?(\d{3,5})$/;
            } else {
                var letra = angular.copy(item.substr(0, 1));
                console.log(letra);
                var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                var esNumeroInicial = false;
                console.log(esNumeroInicial);
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === letra) {
                        esNumeroInicial = true;
                        break;
                    }
                }
                console.log("esNumeroInicial");
                console.log(esNumeroInicial);
                if (esNumeroInicial) {
                    vm.validarTelefono = /^(\d{7,9})$/;
                } else {
                    vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{3,4})$/;
                }
            }
        }

        function cambioDatos() {
            // (true/false) = angular.equals($scope.user1, $scope.user2);
            return ((angular.equals(vm.dataInstalacion.sector, vm.dataInstalacionTemporal.sector)) && (angular.equals(vm.dataInstalacion.subSector, vm.dataInstalacionTemporal.subSector)) && (angular.equals(vm.dataInstalacion.actividad, vm.dataInstalacionTemporal.actividad)) && (angular.equals(vm.dataInstalacion.numeroInstalacion, vm.dataInstalacionTemporal.numeroInstalacion)) && (angular.equals(vm.dataInstalacion.tipoEstablecimiento, vm.dataInstalacionTemporal.tipoEstablecimiento)) && (angular.equals(vm.dataInstalacion.numeroRegistro, vm.dataInstalacionTemporal.numeroRegistro)) && (angular.equals(vm.dataInstalacion.departamento.codigoDepartamento, vm.dataInstalacionTemporal.departamento.codigoDepartamento)) && (angular.equals(vm.dataInstalacion.provincia.codigoProvincia, vm.dataInstalacionTemporal.provincia.codigoProvincia)) && (angular.equals(vm.dataInstalacion.distrito.codigoDistrito, vm.dataInstalacionTemporal.distrito.codigoDistrito)) && (angular.equals(vm.dataInstalacion.direccion, vm.dataInstalacionTemporal.direccion)));
        }
        function validacionModal(prmInstalacion, mensaje) {
// ngDialog.open({
// template: '<div class="">' + '<div class="modal-header">' +
// '<h4 class="modal-title" style="text-align: justify;">' + mensaje.replace(
// new RegExp('/n','g') ,'<br/>') + '</div>' + '<div style="display:
// inline-block;" class="modal-footer">' + '<button type="button" class="btn
// btn-default btn-sm" ng-click="closeThisDialog()">Cerrar</button>' + '</div>'
// + '</div>',
// plain: true,
// width: 550,
// preCloseCallback: function() {
// OcultarForm();
// }
// });
            
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstalacion.numeroInstalacion + '?',
            		Mensajeadicional: mensaje.replace( new RegExp('/n','g') ,',')
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstalacion,false);
            });
        }
        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            localStorage.removeItem("objInstalacion");
            if (angular.isDefined(localStorage.dataListaInstalacion)) {
            	vm.dataListaInstalacion = angular.copy(angular.fromJson(localStorage.dataListaInstalacion));
            }
            buscar(localStorage.objlocalStRefSisoplkijsq);
            cargarCombos();
            listarDepartamento();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AccionInstalacionEdicionController', AccionInstalacionEdicionController);
    /** @ngInject */
    function AccionInstalacionEdicionController($rootScope, toastr, $scope, ngDialog, API_CONFIG, AdministradoFactory , SectorGenericoFactory, AdministradoxInstalacionTempFactory, InstalacionFactory,MaestroFactory,UbigeoFactory,UsuarioUbigeoFactory ,EntidadFactory,CookiesFactory ) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        vm.dataInstalacion = InstalacionFactory.model();
        vm.filtroInstalacionINAPS = InstalacionFactory.model();
        vm.guardar = guardar;
        vm.listaDepartamento = [];
        vm.listaProvincia = [];
        vm.listaDistrito = [];
        vm.listaSector = [];
        vm.listaSubSector = [];
        vm.listaCompetencia = [];
        vm.listaActividad = [];
        vm.listaZonas = [];
        vm.listaTipoEstablecimiento = [];
        vm.listarActividad = listarActividad;
        vm.listarSubSector = listarSubSector;
        vm.listarDistrito = listarDistrito;
        vm.listarProvincia = listarProvincia;
        vm.listarDistritoInaps = listarDistritoInaps;
        vm.listarProvinciaInaps = listarProvinciaInaps;
        vm.validaDocumento = validaDocumento;
        
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];
        vm.RucValido = false;
        vm.validarRuc = validarRuc;
        vm.dataAdminxInstalacion = AdministradoxInstalacionTempFactory.model();
        vm.dataDocumentoInstalacion = InstalacionFactory.model_documento();
        vm.lstAdminxInstalcion = [];
        vm.lstFichaxInstalacion = [];
        vm.eliminarAdminxInstlacion = eliminarAdminxInstlacion;
        vm.agregarAdminxInstalacion = agregarAdminxInstalacion;
        vm.agregarFichaxInstalacion = agregarFichaxInstalacion;
        vm.eliminarFichaxInstalacion = eliminarFichaxInstalacion;
        vm.tieneArchivo = false;
        vm.changeSector = changeSector;
        vm.changeSubSector = changeSubSector;
        vm.changeCompetencia = changeCompetencia;
        vm.changeDepartamento = changeDepartamento;
        vm.changeProvincia = changeProvincia;
        vm.mostrarInaps = false;
        vm.mostrarNuevo = false;
        vm.listaUnidadesFiscalizablesExterno = [];
        vm.listaUnidadesFiscalizablesExternoBackup = [];
        vm.seleccionarTodos = seleccionarTodos;
        vm.desSeleccionarTodos = desSeleccionarTodos;
        vm.verSelTodos = true;
        vm.lstDocumentoInstalacion = [];
        vm.eliminarDocumentoInstalacion = eliminarDocumentoInstalacion;
        vm.lstUsuarioUbgeo = [];
        vm.validaDocumentoDetalle = validaDocumentoDetalle;
        vm.mostrarNuevoFicha = false;
        vm.guardarFichaxInstalacion = guardarFichaxInstalacion;
        vm.buscarInaps = buscarInaps;
        
        $scope.config = {
                itemsPerPage: 10,
                fillLastPage: true,
                current: 1
            };
        
        function seleccionarTodos(){
        	for(var x in vm.listaUnidadesFiscalizablesExterno){
    			vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado = true;
        	}
        	vm.verSelTodos = false;
        }
        
        function desSeleccionarTodos(){
        	for(var x in vm.listaUnidadesFiscalizablesExterno){
    			vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado = false;
        	}
        	vm.verSelTodos = true;
        }
        
        function buscarInaps(){
        	var tempUF = vm.listaUnidadesFiscalizablesExternoBackup;
        	var valida = false;
        	vm.listaUnidadesFiscalizablesExterno = []; 
        	if (tempUF.length > 0){
        		for(var x in tempUF){
        			valida = false;
        			if(tempUF[x].departamento.codigoDepartamento == vm.filtroInstalacionINAPS.departamento.codigoDepartamento || vm.filtroInstalacionINAPS.departamento.codigoDepartamento == ""){
        				valida = true;
        			}
        			
        			if(valida){
        				if(tempUF[x].provincia.codigoProvincia == vm.filtroInstalacionINAPS.provincia.codigoProvincia || vm.filtroInstalacionINAPS.provincia.codigoProvincia == ""){
            				valida = true;
            			}
            			else{
            				valida = false;
            			}
        			}
        			
        			if(valida){
        				if(tempUF[x].distrito.codigoDistrito == vm.filtroInstalacionINAPS.distrito.codigoDistrito || vm.filtroInstalacionINAPS.distrito.codigoDistrito == ""){
            				valida = true;
            			}
            			else{
            				valida = false;
            			}
        			}
        			
        			
        			if(valida){
        				 vm.listaUnidadesFiscalizablesExterno.push(tempUF[x]);
        			}
        		}
        	}
        }
        
        function listarProvinciaInaps() {
        	vm.listaProvincia = [];
        	vm.listaDistrito = [];
        	
        	if( vm.filtroInstalacionINAPS.departamento == null){
        		return;
        	}
        	
            var provincia = {
            	codigoDepartamento : vm.filtroInstalacionINAPS.departamento.codigoDepartamento,
            	 idsession : CookiesFactory.obtenerCookie(),
            };
            UbigeoFactory.listarProvincia(angular.copy(provincia)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.filtroInstalacionINAPS.provincia != null && vm.filtroInstalacionINAPS.provincia.codigoProvincia != '') {
                    listarDistrito();
                }
            });
        }

        function listarDistritoInaps() {
        	
        	vm.listaDistrito = [];
        	if( vm.filtroInstalacionINAPS.provincia == null){
        		return;
        	}
        	
            var distrito = {
               codigoDepartamento : vm.filtroInstalacionINAPS.departamento.codigoDepartamento,
               codigoProvincia : vm.filtroInstalacionINAPS.provincia.codigoProvincia,
               idsession : CookiesFactory.obtenerCookie(),
            };
            
           
            UbigeoFactory.listarDistrito(distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }
        
        
        function eliminarDocumentoInstalacion(index){
        	console.log('index ' + index);
      	  if(vm.dataInstalacion.idInstalacion==0){
      		  vm.lstFichaxInstalacion.splice(index,1);
      	  }
      	  else{
      		  InstalacionFactory.eliminarDocumento(angular.copy(vm.lstFichaxInstalacion[index])).then(function(response) {
                    if (response.valido) {
                  	  toastr.success('Se eliminó el registro correctamente.');
                  	  cargarDocumentoInstalacion();
                    } else {
                   	  toastr.error('Ocurrió un error al eliminar el registro');
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                }).finally(function() {
                });
      	  }
        }

        function eliminarAdminxInstlacion(index){
        	  if(vm.dataInstalacion.idInstalacion==0){
        		  vm.lstAdminxInstalcion.splice(index,1);
        	  }
        	  else{
        		  AdministradoxInstalacionTempFactory.eliminar(angular.copy(vm.lstAdminxInstalcion[index])).then(function(response) {
                      if (response.valido) {
                    	  toastr.success('Se eliminó el registro correctamente.');
                    	  cargarAdminxInstalacion();
                      } else {
                     	  toastr.error('Ocurrió un error al eliminar el registro');
                      }
                  }).catch(function(error) {
                      toastr.error('Error al consultar');
                  }).finally(function() {
                  });
        	  }
        }
        
        function agregarFichaxInstalacion(){
        	vm.listaArchivos = [];
        	 vm.dataDocumentoInstalacion = InstalacionFactory.model_documento();
        	vm.mostrarNuevoFicha = true;
            if(vm.dataInstalacion.idInstalacion!=0){
            	 vm.dataDocumentoInstalacion.idInstalacion = vm.dataInstalacion.idInstalacion;
            	 vm.dataDocumentoInstalacion.idAdministrado = vm.dataInstalacion.idAdministrado;
            }
        }
        
        function guardarFichaxInstalacion(){
        	 vm.dataDocumentoInstalacion.idInstalacion = vm.dataInstalacion.idInstalacion;
        	 vm.dataDocumentoInstalacion.idAdministrado = vm.dataInstalacion.idAdministrado;
            if(vm.dataInstalacion.idInstalacion!=0){
            	 InstalacionFactory.registrarDocumento(vm.listaArchivos, angular.copy(vm.dataDocumentoInstalacion)).then(function(response) {
                 }).catch(function(error) {
                     toastr.error('Error al grabar la ficha de registro');
                 }).finally(function() {
                		vm.mostrarNuevoFicha = false;
                	 cargarDocumentoInstalacion();
                 });
            	 
            }
            else{
            	vm.lstFichaxInstalacion.push(angular.copy(vm.dataDocumentoInstalacion)); 
            	vm.mostrarNuevoFicha = false;
            }

        }
        
        function eliminarFichaxInstalacion(index){
      	  if(vm.dataInstalacion.idInstalacion==0){
      		  vm.lstFichaxInstalacion.splice(index,1);
      	  }
      	  else{
      		  InstalacionFactory.eliminarDocumento(angular.copy(vm.lstFichaxInstalacion[index])).then(function(response) {
                    if (response.valido) {
                  	  toastr.success('Se eliminó el registro correctamente.');
                  	  cargarAdminxInstalacion();
                    } else {
                   	  toastr.error('Ocurrió un error al eliminar el registro');
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                }).finally(function() {
                });
      	  }
      }
        
        function agregarAdminxInstalacion(prmAdminxInstalacion){
        	console.log("prmAdminxInstalacion" + prmAdminxInstalacion);
        	delete $rootScope.dataInstalacion;
        	delete $rootScope.dataAdminxInstalacionEdit;
        	delete $rootScope.lstAdminxInstalacion;
        	$rootScope.dataInstalacion = vm.dataInstalacion;
        	$rootScope.lstAdminxInstalacion =  vm.lstAdminxInstalcion;
            if (prmAdminxInstalacion != null) {
                
                			$rootScope.dataAdminxInstalacion = prmAdminxInstalacion;
                        	
                        	  ngDialog.open({
                        		  template: 'app/modules/supervision/cargainformacion/administradoInstalacion/cargainfo-administracion-instalacion.html',
                                  controller: 'CargaInfoAdministradosInstalacionController',
                                  controllerAs: 'vm',
                                  
                                  width: '40%'
                              }).closePromise.then(function(dataDialog) {
                            	  // nuevo
                            	  if(vm.dataInstalacion.idInstalacion==0){
                            		  if(angular.isDefined($rootScope.dataAdminxInstalacionEdit)){
	                            		  for(var x in vm.lstAdminxInstalcion){
	                                		  if (vm.lstAdminxInstalcion[x].ruc == $rootScope.dataAdminxInstalacionEdit.ruc &&
	                                			  vm.lstAdminxInstalcion[x].idInstalacion == $rootScope.dataAdminxInstalacionEdit.idInstalacion){
	                                			  vm.lstAdminxInstalcion[x].auxInicio =  obtenerFechaTexto(vm.lstAdminxInstalcion[x].inicioAdministrado);
	                                			  vm.lstAdminxInstalcion[x].auxFin =  obtenerFechaTexto(vm.lstAdminxInstalcion[x].finAdministrado);
	                                			  vm.lstAdminxInstalcion[x] = $rootScope.dataAdminxInstalacionEdit;
	                                		  }
	                                	  }
                            		  }
                            	  }
                            	  else{
                            		  // cargamos de la bd por que ya esta
										// actuslizado
                            		  cargarAdminxInstalacion();
                            	  }
                            	  
                              });
                        
		              
            } 
            else{
            	$rootScope.dataAdminxInstalacion =  AdministradoxInstalacionTempFactory.model();
            	ngDialog.open({
                    template: 'app/modules/supervision/cargainformacion/administradoInstalacion/cargainfo-administracion-instalacion.html',
                    controller: 'CargaInfoAdministradosInstalacionController',
                    controllerAs: 'vm',
                    width: '40%'
                }).closePromise.then(function(dataDialog) {
                	 // nuevo
              	  if(vm.dataInstalacion.idInstalacion==0){
              		  if(angular.isDefined($rootScope.dataAdminxInstalacionEdit)){
              			  $rootScope.dataAdminxInstalacionEdit.auxInicio =  obtenerFechaTexto($rootScope.dataAdminxInstalacionEdit.inicioAdministrado);
              			  $rootScope.dataAdminxInstalacionEdit.auxFin =  obtenerFechaTexto($rootScope.dataAdminxInstalacionEdit.finAdministrado);
              			  vm.lstAdminxInstalcion.push($rootScope.dataAdminxInstalacionEdit);
              		  }
              	  }
              	  else{
              		  // cargamos de la bd por que ya esta actuslizado
              		  cargarAdminxInstalacion();
              	  }
                	
                });
            }
        }
        
        function validarRuc(){
        	 	 vm.lstAdminxInstalcion = [];
        	     var dataEntidad = EntidadFactory.model();
        	     dataEntidad.ruc = vm.dataInstalacion.ruc;
                 EntidadFactory.obtenerPorDocumento(angular.copy(dataEntidad)).then(function(response) {
                     if (response.valido) {
                    	 // si el inaps devuelve información deberiamos
							// cargarlo
                    	 dataEntidad = response.data;
                    	 if(dataEntidad.lstUnidadesFiscalizables.length>0){
                    		 vm.dataInstalacion.razonsocial = dataEntidad.razonSocial;
                    		 vm.listaUnidadesFiscalizablesExterno = dataEntidad.lstUnidadesFiscalizables;
                    		 vm.listaUnidadesFiscalizablesExternoBackup = vm.listaUnidadesFiscalizablesExterno;
                    		 vm.mostrarInaps = true;
                    		 vm.mostrarNuevo = false;
                    		 vm.RucValido = true;
                    	 }
                    	 else{
                    		 vm.dataAdminxInstalacion.ruc = dataEntidad.ruc;
                    		 vm.dataAdminxInstalacion.razonsocial = dataEntidad.razonSocial;
                    		 vm.dataAdminxInstalacion.flagActivo = 'S';
                    		 vm.dataAdminxInstalacion.inicioAdministrado = new Date();
                    		 vm.dataAdminxInstalacion.auxInicio = obtenerFechaTexto(vm.dataAdminxInstalacion.inicioAdministrado);
                    		 vm.dataAdminxInstalacion.auxflgaactivo = true;
                    		 vm.dataAdminxInstalacion.idsession = CookiesFactory.obtenerCookie();
                    		 vm.lstAdminxInstalcion.push(vm.dataAdminxInstalacion);
                    		 vm.dataInstalacion.razonsocial = dataEntidad.razonSocial;
                    		 vm.RucValido = true;
                    		 vm.mostrarNuevo = true;
                    		 vm.mostrarInaps = false;
                    	 }
                     } else {
                    	 vm.RucValido = false;
                         toastr.error('No se encontraron datos relacionados al documento ' + dataEntidad.ruc );
                     }
                 }).catch(function(error) {
                	 dialogMensaje();
                	 vm.RucValido = false;
                 }).finally(function() {
                 });
        }
        
        function cancelar() {
            ngDialog.close();
        }
        
        function dialogMensaje() {
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Mensaje del Sistema',
                     Mensaje: 'El servicio no devolvió ningún dato por favor. Comuniquese con el administrador del sistema.'
                 },
                 width: '380px'
             }).then(function(okValue) {
            	$scope.closeThisDialog();
             });
        }
        
        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.RucValido && vm.dataInstalacion.numeroInstalacion!=null && vm.dataInstalacion.tipoEstablecimiento != 0 && 
        				vm.dataInstalacion.sector.codigoRegistro != 0 && vm.dataInstalacion.subSector.codigoRegistro != 0 && vm.dataInstalacion.actividad.codigoRegistro != 0 && 
        				vm.dataInstalacion.departamento.codigoDepartamento != 0 && vm.dataInstalacion.provincia.codigoProvincia != 0 && vm.dataInstalacion.distrito.codigoDistrito != 0 &&
        				(vm.dataInstalacion.direccion != null && vm.dataInstalacion.direccion != '' )){
                	document.getElementById("btnGuardarInstalacion").disabled = false;
                }
        				
                vm.tieneArchivo = true;
        }
        
        function validaDocumentoDetalle(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                
// prmFileList[0].name = vm.dataDocumentoInstalacion.ficha_registro + "_" +
// prmFileList[0].name;
                
                vm.dataDocumentoInstalacion.nombreOriginal = prmFileList[0].name;
                
                vm.listaArchivos.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.dataDocumentoInstalacion.ficha_registro != null && vm.dataDocumentoInstalacion.ficha_registro != '' ){
                	document.getElementById("btnAgregarFicha").disabled = false;
                }
               
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        function changeSector(){
        	vm.dataInstalacion.subSector = '';
        	vm.dataInstalacion.competencia = '';
        	vm.dataInstalacion.actividad = '';
        	listarSubSector();
        }

        function changeSubSector(){
        	vm.dataInstalacion.competencia = '';
        	vm.dataInstalacion.actividad = '';
        	listarCompetencia();
        }
        
        function changeCompetencia(){
        	vm.dataInstalacion.actividad = '';
        	listarActividad(vm.dataInstalacion.competenciaArray);
        }
        
        
        function changeDepartamento(){
        	vm.dataInstalacion.provincia.codigoProvincia = 0;
        	vm.dataInstalacion.distrito.codigoDistrito = 0;
        	listarProvincia();
        }
        
        function changeProvincia(){
        	vm.dataInstalacion.distrito.codigoDistrito = 0;
        	listarProvincia();
        }
        
        function listarSector(){
        	SectorGenericoFactory.listarSector().then(function(response) {
                 if (response.valido) {
                     for (var x in response.data) {
                         vm.listaSector.push(response.data[x]);
                     }
                     /* vm.dataDenuncia.tipoPersona=0; */
                 } else {
                     toastr.error(response.mensaje);
                 }
             }).catch(function(error) {
                 toastr.error('Error al consultar');
             }).finally(function() {
            	 if (vm.dataInstalacion.sector != '') {
                 	listarSubSector();
                 }
             });
        }
        
        function cargarCombos(){
        	listarDepartamento();
        	listarSector();
            var codigosCombos = ['TipoSector', 'TipoEstablecimiento', 'ZONA'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
// case 'TipoSector':
// for (var i in datosCombo) {
// vm.listaSector.push(datosCombo[i]);
// }
// break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            case 'ZONA':
                            	for (var i in datosCombo) {
                                    vm.listaZonas = datosCombo;
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
        }
        
        function listarDepartamento() {
            UbigeoFactory.listarDepartamento(angular.copy(UbigeoFactory.departamento())).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }

        function listarProvincia() {
        	vm.listaProvincia = [];
        	
        	if( vm.dataInstalacion.departamento == null){
        		return;
        	}
        	
            var provincia = {
            	codigoDepartamento : vm.dataInstalacion.departamento.codigoDepartamento,
            	 idsession : CookiesFactory.obtenerCookie(),
            };
            UbigeoFactory.listarProvincia(angular.copy(provincia)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.dataInstalacion.provincia != null && vm.dataInstalacion.provincia.codigoProvincia != '') {
                    listarDistrito();
                }
            });
        }

        function listarDistrito() {
        	
        	if( vm.dataInstalacion.provincia == null){
        		return;
        	}
        	
        	vm.listaDistrito = [];
            var distrito = {
               codigoDepartamento : vm.dataInstalacion.departamento.codigoDepartamento,
               codigoProvincia : vm.dataInstalacion.provincia.codigoProvincia,
               idsession : CookiesFactory.obtenerCookie(),
            };
            
           
            UbigeoFactory.listarDistrito(distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }
        
        function listarSubSector() {
        	vm.listaSubSector = [];
            var subSector = {
                codigosector: vm.dataInstalacion.sector
            };
            SectorGenericoFactory.listarSubSector(angular.copy(subSector)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaSubSector.push(response.data[x]);
                    }
                    /*
					 * console.log("vm.listaSubSector" +
					 * angular.toJson(vm.listaSubSector));
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {
                if (vm.dataInstalacion.subSector != '') {
                	listarCompetencia();
                }
            });
        }
        
     
        
        function listarCompetencia() {
        	var componenteSel = null;

        	vm.listaCompetencia = [];
            var subSector = {
                codigosubsector: vm.dataInstalacion.subSector
            };
            SectorGenericoFactory.listarCompetencia(angular.copy(subSector)).then(function(response) {
                if (response != null && response.valido) {
                	// PARSEAMOS LA COMPETENCIA
                    for (var x in response.data) {
                        vm.listaCompetencia.push(response.data[x]);
                    }
                    
                    /*
					 * console.log("vm.listaSubSector" +
					 * angular.toJson(vm.listaSubSector));
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {
                if (vm.dataInstalacion.competencia != '') {
                	var arrayCompetencia = vm.dataInstalacion.competencia.split(';');
                	vm.dataInstalacion.competenciaArray = obtenerArraySinVacios(arrayCompetencia);
                	 if(vm.dataInstalacion.competenciaArray.length>0){
                		 listarActividad(vm.dataInstalacion.competenciaArray);
                	 }
                }
            });
        }
        
        function listarActividad(competencia) {
        	
        	vm.listaActividad = [];
        	if(competencia == null){
        		return;
        	}
        	
            var actividades = {
                codigocompetencia: competencia[competencia.length - 1]
            };
            
            SectorGenericoFactory.listarActividad(angular.copy(actividades)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaActividad.push(response.data[x]);
                    }
                    /*
					 * console.log("vm.listaActividad" +
					 * angular.toJson(vm.listaActividad));
					 * vm.dataNormas.actividad=0;
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function guardar() {
        	if(vm.mostrarInaps==true){
        		var exito = 0;
        		var primero = 0;
        		if(vm.listaUnidadesFiscalizablesExterno.length>0){
        			for(var x in vm.listaUnidadesFiscalizablesExterno){
            			if(vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado){
            				primero = x;
            			}
        			}
        			var adminxinstal1 = {
    						ruc : vm.dataInstalacion.ruc,
    						razonsocial : vm.dataInstalacion.razonsocial,
    						inicioAdministrado : new Date(),
    						flagActivo : '1',
    						idsession : CookiesFactory.obtenerCookie(),
    						ultima_fecha : new Date(),
    				};
        			vm.listaUnidadesFiscalizablesExterno[primero].lstAdministradoxInstalacion.push(adminxinstal1);
    				
    				// actualizamos la razÃ³n social en caso sea diferente a
					// los del inaps
    				if(vm.listaUnidadesFiscalizablesExterno[primero].razonsocial != vm.dataInstalacion.razonsocial){
    					vm.listaUnidadesFiscalizablesExterno[primero].razonsocial = vm.dataInstalacion.razonsocial;
    				}
    	        	
    	        	InstalacionFactory.registrar(vm.listaArchivos,angular.copy(vm.listaUnidadesFiscalizablesExterno[primero])).then(function(response) {
    	                if (response != null && response.valido) {
    	                	for(var x in vm.listaUnidadesFiscalizablesExterno){
    	            			if(vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado && x != primero){
    	            				// agegamos la lista de administrados por
									// instalacion
    	            				var adminxinstal = {
    	            						ruc : vm.dataInstalacion.ruc,
    	            						razonsocial : vm.dataInstalacion.razonsocial,
    	            						inicioAdministrado : new Date(),
    	            						flagActivo : '1',
    	            						idsession : CookiesFactory.obtenerCookie(),
    	            						ultima_fecha : new Date(),
    	            				};
    	            	        	
    	            				vm.listaUnidadesFiscalizablesExterno[x].lstAdministradoxInstalacion.push(adminxinstal);
    	            				
    	            				// actualizamos la razÃ³n social en caso sea
									// diferente a
    	    						// los del inaps
    	            				if(vm.listaUnidadesFiscalizablesExterno[x].razonsocial != vm.dataInstalacion.razonsocial){
    	            					vm.listaUnidadesFiscalizablesExterno[x].razonsocial = vm.dataInstalacion.razonsocial;
    	            				}
    	            	        	
    	            	        	InstalacionFactory.registrar(vm.listaArchivos,angular.copy(vm.listaUnidadesFiscalizablesExterno[x])).then(function(response) {
    	            	                if (response != null && response.valido) {
    	            	                	exito=exito+1;
    	            	                	if(vm.listaUnidadesFiscalizablesExterno.length = x+1){
    	            	                		 toastr.success('Ã‰xito en la operaciÃ³n.');
    	            	                		 ngDialog.close();
    	            	                	}
    	            	                }
    	            	            }).catch(function(error) {
    	            	                toastr.error('No se pudo grabar la informaciÃ³n.');
    	            	                return;
    	            	            });
    	            	            
    	            			}
    	            		}
    	                }
    	            }).catch(function(error) {
    	                toastr.error('No se pudo grabar la informaciÃ³n.');
    	                return;
    	            }).finally(function() {
    	            	ngDialog.close();
    	            });
        			
        		}
        		
        	}
        	if(vm.mostrarNuevo == true){
        		 // concatenamos en una cadena la competencia
        		   var competenciaConcat = "";
        		
        		 for (var x in vm.dataInstalacion.competenciaArray) {
        			 competenciaConcat = competenciaConcat +  vm.dataInstalacion.competenciaArray[x] + ";" ;
                 }
        		 
        		 vm.dataInstalacion.competencia = competenciaConcat;
        		
        		if (vm.dataInstalacion.idInstalacion == 0) {
                	confirmarGuardar();
                } else {
                    actualizar();
                }
        	}
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	
        	// agegamos la lista de administrados por instalacion
        	if( vm.lstAdminxInstalcion.length> 0){
        		vm.dataInstalacion.lstAdministradoxInstalacion = vm.lstAdminxInstalcion;
        	}
        	if( vm.lstFichaxInstalacion.length> 0){
        		vm.dataInstalacion.lstDocumentos = vm.lstFichaxInstalacion;
        	}
        	
        	InstalacionFactory.registrar(vm.listaArchivos,angular.copy(vm.dataInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });
            
        }

        function actualizar() {
        	
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	InstalacionFactory.actualizar(vm.listaArchivos,angular.copy(vm.dataInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function cargarAdminxInstalacion (){
        	vm.lstAdminxInstalcion= [];
        	var tempAdminXIns = {
        			idInstalacion : vm.dataInstalacion.idInstalacion,
        			ruc : vm.dataInstalacion.ruc,
        	};
        	
        	AdministradoxInstalacionTempFactory.listar(angular.copy(tempAdminXIns)).then(function(response) {
                 if (response != null && response.valido) {
                     for (var x in response.data) {
                         vm.lstAdminxInstalcion.push(response.data[x]);
                     }
                 }
        	 }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos para los combos.');
             });
        }
        
        function cargarDocumentoInstalacion (){
        	vm.lstFichaxInstalacion= [];
        	
        	InstalacionFactory.listarDocumento(angular.copy(vm.dataInstalacion)).then(function(response) {
                 if (response != null && response.valido) {
                     for (var x in response.data) {
                         vm.lstFichaxInstalacion.push(response.data[x]);
                     }
                 }
        	 }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos para los combos.');
             });
        }
        
        
        
        /* fin de metodos */
        function init() {
        	cargarCombos();
            if (angular.isDefined($rootScope.prmInstalacion)) {
                vm.dataInstalacion = angular.copy($rootScope.prmInstalacion);
                listarProvincia();
                listarDistrito();
            }
            
            if(vm.dataInstalacion.idInstalacion == 0){
            	vm.dataInstalacion.estado = 1;
            	// si el usuario es administrado, buscamos la información de
				// inaps
            	var data = {
                        prm1: localStorage.objlocalStRefSisoplkijsq,
                };
                AdministradoFactory.buscarxid( angular.copy(data)).then(function(response) {
                    if (response.valido) {
                        if(response.data.idAdministrado != 0){
                        	vm.dataInstalacion.ruc	= response.data.entidad.ruc;
                        	validarRuc();
                        }
                    }
                }).catch(function(error) {
                	toastr.error('No se pudo obtener los datos para los combos.');
                });
                
            	
            	
            }
            else{
            	vm.mostrarNuevo = true;
            	 vm.RucValido = true;
            	 vm.tieneArchivo = true;
            	cargarAdminxInstalacion();
            	cargarDocumentoInstalacion();
            }
            
            obtenerParametros();
           
        }
        
        
        function obtenerArraySinVacios(arrayCompetencia){
        	var retorno = [];
        	if(arrayCompetencia!=null){
        		for(var x in arrayCompetencia){
        			if(arrayCompetencia[x] != null && arrayCompetencia[x] != ''){
        				retorno.push(angular.copy(arrayCompetencia[x]));
        			}
        		}
        	}
        	
        	return retorno;
        }
        
        function obtenerFechaTexto(fecha){
        	if(fecha == undefined){
        		return "";
        	}
        	var dia = fecha.getDate();
        	var mes = fecha.getMonth()+1;
        	var anio = fecha.getFullYear();
        	
        	if (mes < 10) {
        		mes = "0" + mes;
        	}
        	if (dia < 10) {
        		dia = "0" + dia;
        	}

        	var fechaFinal = dia + "/" + (mes) + "/" + anio;
        	
        	return fechaFinal;
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AutosupervisionOnlineController', AutosupervisionOnlineController);
    /* @ngInject */
    function AutosupervisionOnlineController($scope, toastr, $state, ngDialog, CuestionarioFactory, OpcionPreguntaFactory, $rootScope, API_CONFIG) {
        var vm = this;
        vm.flagActivoCuestionario = 0;
        /* declaracion de variables globales */
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.rutaBase = API_CONFIG.url;
        vm.listaCuestionariosAutoSupervision = [];
        vm.dataCuestionarioAutosupervision = [];
        vm.visualizarPDF = visualizarPDF;
        /*  Lista de Combos */
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        vm.irCuestionario = irCuestionario;
        vm.cancelar = cancelar;
        /* implementacion de metodos */
        function cancelar() {
            vm.flagActivoCuestionario = 0;
            vm.dataCuestionarioAutosupervision = [];
            window.history.back();
            //$state.go("spapp.home.supervision.online");
            /*
            if (vm.flagActivoCuestionario == 1) {
                vm.flagActivoCuestionario = 0;
                vm.dataCuestionarioAutosupervision = [];
            }
            */
        }
        //           function visualizarPDF(data) 
        //      {           
        //              var dataTitulo="Cuestionario Autosupervisón";
        //               $rootScope.urlPDFFichaDenuncia = "<iframe src='" + angular.copy(data) + "' style='width:100%; height:600px;' frameborder='0'> </iframe>";
        //
        //          ngDialog
        //              .open({
        //                  template : 'app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html',
        //                  controller : 'SolicitudArchivoDialogController',
        //                  data : {
        //                  data : dataTitulo
        //                  },
        //                  controllerAs : 'vm',
        //                  width : '700px'
        //              });
        //      }
        function visualizarPDF(data) {
            CuestionarioFactory.buscarCuestionarioPorId(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    /*********************************************/
                    var prmData = response.data;
                    abrirPDFCuestionario(prmData.rutaArchivo);
                    /************************************************/
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function abrirPDFCuestionario(data) {
            var dataTitulo = "Cuestionario Autosupervisón";
            $rootScope.urlPDFFichaDenuncia = "<iframe src='" + angular.copy(data) + "' style='width:100%; height:600px;' frameborder='0'> </iframe>";
            ngDialog.open({
                template: 'app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html',
                controller: 'SolicitudArchivoDialogController',
                data: {
                    data: dataTitulo
                },
                controllerAs: 'vm',
                width: '700px'
            });
        }

        function listarCuestionariosInstalacion(data) {
            var dataCuestionario = CuestionarioFactory.model();
            dataCuestionario.instalacion = data;
            CuestionarioFactory.listar(angular.copy(dataCuestionario)).then(function(response) {
                if (response.valido) {
                    vm.listaCuestionariosAutoSupervision = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function irCuestionario(dataCuestionario) {
            /*var dataCuestionario = CuestionarioFactory.model();
                dataCuestionario.instalacion = data;*/
            CuestionarioFactory.buscarPorId(dataCuestionario).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.dataCuestionarioAutosupervision = response.data;
                    vm.flagActivoCuestionario = 1;
                    /*      for(var i in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle){
                                    debugger;
                                    if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.tipoPregunta.codigoRegistro==5){
                                        
                                        var listaDataOpciones = vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta;

                                    
                                            var listaDataOpcionesFila = [];

                                        if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosFila!=0 && vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosColumna!=0){
                                                
                                            for(var d = 0; d<vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosFila; d++){
                                                    var listaOpcionesColumna = [];
                                                    for(var e = 0; e<vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosColumna; e++){


                                                        var dataColumna = OpcionPreguntaFactory.model();
                                                        dataColumna.posicionFila    = d;
                                                        dataColumna.posicionColumna = e;
                                                        
                                                        listaOpcionesColumna.push(dataColumna);
                                                    

                                                    }
                                                        var dataFila = OpcionPreguntaFactory.model();
                                                            dataFila.lstOpcionPreguntaColumna = angular.copy(listaOpcionesColumna);
                                                    listaDataOpcionesFila.push(dataFila);


                                            }


                                        }




                                        for(var z in listaDataOpcionesFila){

                                                for(var v in listaDataOpcionesFila[z].lstOpcionPreguntaColumna){

                                                        for(var s in listaDataOpciones){

                                                            if(listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionFila==listaDataOpciones[s].posicionFila && listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionColumna==listaDataOpciones[s].posicionColumna){


                                                                    listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v]= angular.copy(listaDataOpciones[s]);

                                                            }


                                                        }


                                                }


                                        }

                                        vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta =   angular.copy(listaDataOpcionesFila);
                                        
                                            console.log("da9999"+vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta);
                                    
                                    }


                            }*/
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }
        /**************************************************************************/
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                //console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*************************************************************************/
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */
        function validaDocumento(prmFileList) {
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > 500120) {
                vm.validaArchivo = '0';
                toastr.warning('El tamaño del archivo no debe superar 5MB. Intente comprimir el tamaño del archivo y vuelva a intentarlo.');
                /*document.getElementById("fileArchivoMedio").value = "";*/
                return;
                /*vm.validaArchivoDoc='0';*/
            }
            vm.filePlanTrabajo = prmFileList[0];
        }
        /**************************************************************************************/
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            if (angular.isDefined(localStorage.objDataInstalacionAutosupervisionOnline)) {
                var data = angular.fromJson(localStorage.objDataInstalacionAutosupervisionOnline);
                listarCuestionariosInstalacion(data);
            }
            /*
            if(angular.isDefined(localStorage.objInstalacion)){
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion= angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                
                //console.log("Instalacion: ",vm.prmInstalacion);
                buscarInstrumentoGestion();
                listarDocumentacion(1,false,"");
                listarDocumentacion(2,false,"");
                listarDocumentacion(3,false,"");
            }*/
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstrumentoGestionSelectorController', InstrumentoGestionSelectorController);
    /* @ngInject */
    function InstrumentoGestionSelectorController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        vm.lstIntrumentoGestionMod = [];
        vm.lstIntrumentoGestionModBase = [];
        vm.dataInstrumentoGestionMod = InstrumentoGestionFactory.modificacion_model();
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        vm.guardar = guardar;
       
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.prmInstrumentoGestion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                    // filtramos para que muestre solo los datos que no han sido
					// seleccionados
                    console.log('$rootScope.lstIntrumentoGestionModBase ' + $rootScope.lstIntrumentoGestionModBase);
                    if (angular.isDefined($rootScope.lstIntrumentoGestionModBase)) {
                    	vm.lstIntrumentoGestionModBase = $rootScope.lstIntrumentoGestionModBase ;
                    	for (var y = 0; y < vm.lstInstrumentosGestion.length; y++) { 
                    		for(var x in vm.lstIntrumentoGestionModBase){
                    			console.log('id 1 ' + vm.lstIntrumentoGestionModBase[x].id_InstrumentoGestion );
                    			console.log('id 2 ' + vm.lstInstrumentosGestion[y].idInstrumentoGestion );
                        		if(vm.lstIntrumentoGestionModBase[x].id_InstrumentoGestionMod == vm.lstInstrumentosGestion[y].idInstrumentoGestion){
                        			// ya existe
                        			vm.lstInstrumentosGestion.splice(y,1);
                        			console.log('duplicado');
                        			y--;
                        			break;
                        		}
                        	}
                    	}
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        
        function guardar(){
        	vm.lstIntrumentoGestionMod = [];
        	// relacion: instrumento - modificacion
           	for (var x in vm.lstInstrumentosGestion) {
                if (vm.lstInstrumentosGestion[x].blSeleccionado){
                	vm.dataInstrumentoGestionMod.id_InstrumentoGestionMod = vm.lstInstrumentosGestion[x].idInstrumentoGestion ;
                	vm.dataInstrumentoGestionMod.resolucion = vm.lstInstrumentosGestion[x].resolucion ;
                	vm.dataInstrumentoGestionMod.fechaAprobacion = vm.lstInstrumentosGestion[x].fechaAprobacion ;
                	vm.dataInstrumentoGestionMod.fecha = vm.lstInstrumentosGestion[x].fecha ;
                	vm.dataInstrumentoGestionMod.auxTipoIgaNombre = vm.lstInstrumentosGestion[x].auxTipoIgaNombre ;
                	vm.dataInstrumentoGestionMod.archivoNombre = vm.lstInstrumentosGestion[x].archivoNombre ;
                	vm.lstIntrumentoGestionMod.push(angular.copy(vm.dataInstrumentoGestionMod));
                }
            }
           	
           	// guardamos en session para pasar a la ventana anterior
           	$rootScope.lstIntrumentoGestionMod = vm.lstIntrumentoGestionMod;
           	$scope.closeThisDialog();
           	
        }
        
        /* fin de implementacion de metodos */
        function init() {
        	$rootScope.lstIntrumentoGestionMod = [];
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.estado = "1";
                vm.dataInstrumentoGestionMod.id_InstrumentoGestion = angular.copy(vm.prmInstrumentoGestion.idInstrumentoGestion);
                vm.dataInstrumentoGestionMod.id_Instalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.dataInstrumentoGestionMod.estado =  "1";
                buscarInstrumentoGestion();
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstrumentoGestionListaController', InstrumentoGestionListaController);
    /* @ngInject */
    function InstrumentoGestionListaController($state, toastr, ngDialog, $scope, ReporteFactory , AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        vm.lstIntrumentoGestionMod = [];
        vm.lstIntrumentoGestionModBase = [];
        vm.dataInstrumentoGestionMod = InstrumentoGestionFactory.modificacion_model();
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        vm.exportarExcel = exportarExcel;
       
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	
            InstrumentoGestionFactory.listarPorFiltros(angular.copy(vm.prmInstrumentoGestion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }

        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        function exportarExcel(tipo){
			 var filtro = {
			   tiporeporte : tipo,
			   idAdministrado : vm.prmInstrumentoGestion.idAdministrado,
			   idInstalacion : vm.prmInstrumentoGestion.idInstalacion,
			   fechadesde : vm.prmInstrumentoGestion.fechadesde,
			   fechahasta : vm.prmInstrumentoGestion.fechahasta
			 }
			 ReporteFactory.descargarExcel(angular.copy(filtro),'Reporte_InstrumentosGestion.xls');
		}
       
        
        /* fin de implementacion de metodos */
        function init() {
        	 if (angular.isDefined(localStorage.prmInstrumentoGestion)) {
                 vm.prmInstrumentoGestion = angular.copy(angular.fromJson(localStorage.prmInstrumentoGestion));
                 buscarInstrumentoGestion();
             }
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstrumentoGestionAmbientalController', InstrumentoGestionAmbientalController);
    /** @ngInject */
    function InstrumentoGestionAmbientalController($rootScope, toastr, $scope, InstrumentoGestionFactory, MaestroFactory,TipoIgaFactory, ngDialog, API_CONFIG) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivosIGA = [];
        vm.urlData = API_CONFIG.url;
        vm.dataInstalacion;
        vm.prmIntrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstTipoIgas = [];
        vm.prmTipoIga = TipoIgaFactory.model();
        vm.guardar = guardar;
        vm.mostrarIGASModificacion = mostrarIGASModificacion;
        vm.eliminarIGAModificado = eliminarIGAModificado;
        vm.active = 0;
        vm.validaDocumento = validaDocumento;
        
        
        
        function eliminarIGAModificado(index){
        	vm.prmIntrumentoGestion.lstIntrumentoGestionMod.splice(index, 1);
        }
        
        function guardar() {
        	if (vm.prmIntrumentoGestion.idInstrumentoGestion == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	InstrumentoGestionFactory.registrar(vm.listaArchivosIGA,angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	InstrumentoGestionFactory.actualizar(vm.listaArchivosIGA,angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cancelar() {
            ngDialog.close();
        }
        
        function cargarCombos(){
        	listarTipoIGA();
        }
        
        function listarTipoIGA(){
        	 TipoIgaFactory.listarActivos(angular.copy(vm.prmTipoIga)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstTipoIgas = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function mostrarIGASModificacion(){
        	 $rootScope.lstIntrumentoGestionModBase = vm.prmIntrumentoGestion.lstIntrumentoGestionMod;
        	 if(vm.prmIntrumentoGestion.blModificaIga){
        		 vm.active = 1; 
        		 ngDialog.open({
                     template: 'app/modules/supervision/iga/dialog/instrumento-gestion-selector.html',
                     controller: 'InstrumentoGestionSelectorController',
                     controllerAs: 'vm',
                     width: '800px'
                 }).closePromise.then(function(dataDialog) {
                	var array  = $rootScope.lstIntrumentoGestionMod;
                		cargarModificados(array);
                 });
        	 }
        	 else{
        		 vm.prmIntrumentoGestion.lstIntrumentoGestionMod.splice(0, vm.prmIntrumentoGestion.lstIntrumentoGestionMod.length);
        	 }
       }
        
        function cargarModificados(array){
        	if(angular.isDefined(array)){
	        	if(array.length > 0){
	        		for (var x in array) {
	        			array[x].id_InstrumentoGestion = vm.prmIntrumentoGestion.idInstrumentoGestion;
	                    vm.prmIntrumentoGestion.lstIntrumentoGestionMod.push(array[x]);
	                }
	        	}
        	}
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                vm.listaArchivosIGA.push(prmFileList[0]);
        }
        
        /* fin de metodos */
        function init() {
        	vm.dataInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
        	vm.prmIntrumentoGestion = angular.copy($rootScope.prmdatoInstrumento);
        	vm.prmIntrumentoGestion.idInstalacion = vm.dataInstalacion.idInstalacion;
        	
        	if(vm.prmIntrumentoGestion.idInstrumentoGestion != 0){
        	 vm.prmIntrumentoGestion.fecha = new Date(vm.prmIntrumentoGestion.fecha);	
        	 vm.prmIntrumentoGestion.blModificaIga = vm.prmIntrumentoGestion.flag_modifica_iga == "1" ? true : false;
        	 
           	 InstrumentoGestionFactory.listarModificaciones(angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                    if (response.valido) {
                   	 cargarModificados(angular.copy(response.data));
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });	
        	}
        	
        	// activamos el primer tab
        	vm.active= 0;
        	obtenerParametros();
        	cargarCombos();
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CancelacionInstalacionDialogController', CancelacionInstalacionDialogController);
    /** @ngInject */
    function CancelacionInstalacionDialogController($rootScope, toastr, $scope, ngDialog, AdministradoFactory, SolicitudFactory, InstalacionFactory, MaestroFactory) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataInstalacion;
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.listaArchivosSolicitud = [];
        vm.listaSolicitudesInstalacion = [];
        vm.validaDocumento = validaDocumento;
        vm.dataContacto = {
            tipoContacto: '0'
        }

        function cancelar() {
            ngDialog.close();
        }

        function validaDocumento(prmFileList) {
            vm.validaArchivo = '0';
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoCancelacionInstalacion").value = "";
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('El tipo de archivo cargado no esta permitido.');
                document.getElementById("fileArchivoCancelacionInstalacion").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoCancelacionInstalacion").value = "";
                return;
            }
            if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                vm.validaArchivo = '1';
                vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
            }
            if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
                console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
            }
        }

        function registrarSolicitudArchivo() {
            if (vm.validaArchivo == '1') {
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    vm.dataInstalacion = InstalacionFactory.model();
                    document.getElementById("fileArchivoCancelacionInstalacion").value = "";
                    vm.validaArchivo = '0';
                }
            } else {
                toastr.warning('Falta Cargar ficha de Registro');
                return;
            }
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /*vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion;*/
            //console.log("vm.listaArchivosSolicitud" + vm.listaArchivosSolicitud); 
            //console.log("vm.listaArchivosSolicitud.length" + vm.listaArchivosSolicitud.length);
            vm.dataSolicitud.tipoSolicitud = 4;
            console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
            console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
            /* PROBANDO LOS DATOS QUE SE ENVIAN A LA BASE DE DATOS*/
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada Correctamente');
                    //$state.go('ingreso');
                    //crear metodo para limpiar todos los campos y el campo de file
                    //direccionar al listado de instalaciones
                    console.log("vm.dataSolicitud", vm.dataSolicitud);
                    ngDialog.close();
                    //siguiente();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            });
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /*fin de metodos*/
        function init() {
            obtenerParametros();
            if (angular.isDefined($scope.ngDialogData)) {
                vm.dataInstalacion = angular.copy($scope.ngDialogData.data);
                console.log("vm.dataInstalacion", vm.dataInstalacion);
                vm.dataAdministrado = angular.copy($scope.ngDialogData.dataAdministrado);
                //vm.dataSolicitud=SolicitudFactory.model();
                vm.dataContacto.tipoContacto = 1;
                vm.dataListaInstalacion.idAdministrado = vm.dataAdministrado.idAdministrado;
                vm.dataListaInstalacion.estado = 2;
                console.log("vm.dataAdministrado", vm.dataAdministrado);
            }
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('PuntoMonitoreoDialogController', PuntoMonitoreoDialogController);
    /** @ngInject */
    function PuntoMonitoreoDialogController($rootScope, DeclaracionComponenteFactory, DeclaracionPuntoFactory, toastr, $scope, ngDialog, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        
        // Objeto principal de los datos del punto de monitoreo
        vm.objDeclaracionPunto = DeclaracionPuntoFactory.model(); 
        
        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.registrarDeclaracionPunto = registrarDeclaracionPunto;
        
        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionPunto = actualizarDeclaracionPunto; 
        

        vm.guardarDeclaracionPunto = guardarDeclaracionPunto;
        
        function guardarDeclaracionPunto(){
        	  if (vm.objDeclaracionPunto.idPunto == 0) {
              	confirmarGuardar();
              } else {
            	  actualizarDeclaracionPunto();
              }
        }
        
        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	registrarDeclaracionPunto();
            });
        }
        
        function registrarDeclaracionPunto(){
        	DeclaracionPuntoFactory.registrar(angular.copy(vm.objDeclaracionPunto)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function actualizarDeclaracionPunto(){
        	DeclaracionPuntoFactory.actualizar(angular.copy(vm.objDeclaracionPunto)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        /* fin de metodos */
        function init() {
            cargarCombos();
            vm.objDeclaracionPunto = $rootScope.objDeclaracionPunto;
           
        }
        
        function cargarCombos(){
        	cargarZona();
        }
        
        function cargarZona(){
        	
        }
        
        
        
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InformacionInstalacionDialogController', InformacionInstalacionDialogController);
    /** @ngInject */
    function InformacionInstalacionDialogController($rootScope, toastr, $scope, ngDialog, API_CONFIG) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.urlData = API_CONFIG.url;
        vm.dataInstalacion;

        function cancelar() {
            ngDialog.close();
        }
        /*fin de metodos*/
        function init() {
            if (angular.isDefined($scope.ngDialogData)) {
                vm.dataInstalacion = angular.copy($scope.ngDialogData.data);
                console.log(vm.dataInstalacion);
            }
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ComponenteAmbientalSelectorController', ComponenteAmbientalSelectorController);
    /** @ngInject */
    function ComponenteAmbientalSelectorController($rootScope, toastr, $scope, ngDialog, API_CONFIG, ComponenteAmbientalFactory) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        vm.lstComponentes = [];
        vm.lstComponentesBase = [];
        vm.lstComponentesSel = [];
        vm.prmComponente = ComponenteAmbientalFactory.model();
        
        // metodos
        vm.listar = listar;
        vm.guardar = guardar;

        function cancelar() {
            ngDialog.close();
        }
        
        function listar() {
           ComponenteAmbientalFactory.listar(angular.copy(vm.prmComponente)).then(function(response) {
               if (response != null && response.valido) {
                   vm.lstComponentes = angular.copy(response.data);
                   if (angular.isDefined($rootScope.lstComponentesBase)) {
                   	vm.lstComponentesBase = $rootScope.lstComponentesBase ;
                   	for (var y = 0; y < vm.lstComponentes.length; y++) { 
                   		for(var x in vm.lstComponentesBase){
                       		if(vm.lstComponentesBase[x].idComponente == vm.lstComponentes[y].codigo){
                       			// ya existe
                       			vm.lstComponentes.splice(y,1);
                       			y--;
                       			break;
                       		}
                       	}
                   	}
                   }
               }
           }).catch(function(error) {
               toastr.error('No se pudo obtener los datos.');
           });
       }
        
        function guardar(){
        	// relacion: instrumento - modificacion
           	for (var x in vm.lstComponentes) {
                if (vm.lstComponentes[x].blSeleccionado){
                	vm.lstComponentesSel.push(angular.copy(vm.lstComponentes[x]));
                }
            }
           	// guardamos en session para pasar a la ventana anterior
           	$rootScope.lstComponentesSel = vm.lstComponentesSel;
           	ngDialog.close()
        }
        
        
        /* fin de metodos */
        function init() {
        	listar();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AdministradoSelectorController', AdministradoSelectorController);
    /** @ngInject */
    function AdministradoSelectorController($rootScope, toastr, $scope, ngDialog, API_CONFIG,AdministradoFactory) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        // metodos
        vm.listar = listar;
        vm.objAdministrado = AdministradoFactory.model();
        vm.listaAdministrado = [];
        vm.cargarSeleccion = cargarSeleccion;
        $scope.config = {
                itemsPerPage: 5,
                fillLastPage: true,
                current: 1
            };

        function cancelar() {
            ngDialog.close();
        }
        
        function listar() {
        	AdministradoFactory.buscarAdministradoSelector(angular.copy(vm.objAdministrado)).then(function(response) {
               if (response != null && response.valido) {
                   vm.listaAdministrado = angular.copy(response.data);
               }
           }).catch(function(error) {
               toastr.error('No se pudo obtener los datos.');
           });
       }
        
        function cargarSeleccion(item){
        	$rootScope.objAdministrado = item;
        	cancelar();
        }
        
        /* fin de metodos */
        function init() {
        	//listar();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CuestionariosInstalacionController', CuestionariosInstalacionController);
    /* @ngInject */
    function CuestionariosInstalacionController($scope, $state, toastr, ngDialog, CuestionarioFactory, OpcionPreguntaFactory, $rootScope, API_CONFIG) {
        var vm = this;
        vm.flagActivoCuestionario = 0;
        /* declaracion de variables globales */
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.listaCuestionariosAutoSupervision = [];
        vm.dataCuestionarioAutosupervision = [];
        vm.visualizarPDF = visualizarPDF;
        vm.rutaBase = API_CONFIG.url;
        /*  Lista de Combos */
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        vm.irCuestionario = irCuestionario;
        vm.cancelar = cancelar;
        /* implementacion de metodos */
        function cancelar() {
            $state.go('spapp.home.supervision.administrado');
            $rootScope.cancelarPresentacion = 1;
            vm.flagActivoCuestionario = 0;
            vm.dataCuestionarioAutosupervision = [];
        }

        function visualizarPDF(data) {
            CuestionarioFactory.buscarCuestionarioPorId(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    /*********************************************/
                    var prmData = response.data;
                    abrirPDFCuestionario(prmData.rutaArchivo);
                    /************************************************/
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function abrirPDFCuestionario(data) {
            var dataTitulo = "Cuestionario Autosupervisón";
            $rootScope.urlPDFFichaDenuncia = "<iframe src='" + angular.copy(data) + "' style='width:100%; height:600px;' frameborder='0'> </iframe>";
            ngDialog.open({
                template: 'app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html',
                controller: 'SolicitudArchivoDialogController',
                data: {
                    data: dataTitulo
                },
                controllerAs: 'vm',
                width: '700px'
            });
        }

        function listarCuestionariosInstalacion(data) {
            console.log(data);
            var dataCuestionario = CuestionarioFactory.model();
            dataCuestionario.instalacion = data;
            CuestionarioFactory.listar(angular.copy(dataCuestionario)).then(function(response) {
                console.log(".................");
                console.log(response);
                if (response.valido) {
                    vm.listaCuestionariosAutoSupervision = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function irCuestionario(dataCuestionario) {
            /*var dataCuestionario = CuestionarioFactory.model();
                dataCuestionario.instalacion = data;*/
            debugger;
            CuestionarioFactory.buscarPorId(dataCuestionario).then(function(response) {
                debugger;
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.dataCuestionarioAutosupervision = response.data;
                    vm.flagActivoCuestionario = 1;
                    /*      for(var i in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle){
                                    debugger;
                                    if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.tipoPregunta.codigoRegistro==5){
                                        
                                        var listaDataOpciones = vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta;

                                    
                                            var listaDataOpcionesFila = [];

                                        if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosFila!=0 && vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosColumna!=0){
                                                
                                            for(var d = 0; d<vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosFila; d++){
                                                    var listaOpcionesColumna = [];
                                                    for(var e = 0; e<vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosColumna; e++){


                                                        var dataColumna = OpcionPreguntaFactory.model();
                                                        dataColumna.posicionFila    = d;
                                                        dataColumna.posicionColumna = e;
                                                        
                                                        listaOpcionesColumna.push(dataColumna);
                                                    

                                                    }
                                                        var dataFila = OpcionPreguntaFactory.model();
                                                            dataFila.lstOpcionPreguntaColumna = angular.copy(listaOpcionesColumna);
                                                    listaDataOpcionesFila.push(dataFila);


                                            }


                                        }




                                        for(var z in listaDataOpcionesFila){

                                                for(var v in listaDataOpcionesFila[z].lstOpcionPreguntaColumna){

                                                        for(var s in listaDataOpciones){

                                                            if(listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionFila==listaDataOpciones[s].posicionFila && listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionColumna==listaDataOpciones[s].posicionColumna){


                                                                    listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v]= angular.copy(listaDataOpciones[s]);

                                                            }


                                                        }


                                                }


                                        }

                                        vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta =   angular.copy(listaDataOpcionesFila);
                                        
                                            console.log("da9999"+vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta);
                                    
                                    }


                            }*/
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }
        /**************************************************************************/
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                //console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*************************************************************************/
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */
        function validaDocumento(prmFileList) {
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > 500120) {
                vm.validaArchivo = '0';
                toastr.warning('El tamaño del archivo no debe superar 5MB. Intente comprimir el tamaño del archivo y vuelva a intentarlo.');
                /*document.getElementById("fileArchivoMedio").value = "";*/
                return;
                /*vm.validaArchivoDoc='0';*/
            }
            vm.filePlanTrabajo = prmFileList[0];
        }
        /**************************************************************************************/
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            if (angular.isDefined(localStorage.objDataInstalacionAutosupervision)) {
                var data = angular.fromJson(localStorage.objDataInstalacionAutosupervision);
                listarCuestionariosInstalacion(data);
            }
            /*
            if(angular.isDefined(localStorage.objInstalacion)){
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion= angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                
                //console.log("Instalacion: ",vm.prmInstalacion);
                buscarInstrumentoGestion();
                listarDocumentacion(1,false,"");
                listarDocumentacion(2,false,"");
                listarDocumentacion(3,false,"");
            }*/
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CuestionarioAdministradoController', CuestionarioAdministradoController);
    /* @ngInject */
    function CuestionarioAdministradoController(toastr, $scope, ngDialog, CuestionarioFactory, OpcionPreguntaFactory, PreguntaFactory, MaestroFactory, $rootScope, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.rutaBase = API_CONFIG.url;
        vm.flagCuestionario = 0;
        vm.dataCuestionarioAutosupervision = [];
        vm.dataValidacion = [];
        vm.dataOpcionPreguntaObj = OpcionPreguntaFactory.model();
        vm.dataArchivo = PreguntaFactory.modelArchivo();
        vm.archivoAdjunto = [];
        /*  Lista de Combos */
        vm.listaArchivosRespuesta = [];
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        vm.validaDocumento = validaDocumento;
        vm.obtenerDatos = obtenerDatos;
        vm.siguiente = siguiente;
        vm.atras = atras;
        vm.terminarCuestionario = terminarCuestionario;
        vm.agregarDatosPreguntaSeleccionMultiple = agregarDatosPreguntaSeleccionMultiple;
        vm.eliminarRespuestaSeleccionMultiple = eliminarRespuestaSeleccionMultiple;
        vm.validaArchivos = validaArchivos;
        vm.eliminarArchivo = eliminarArchivo;
        vm.agregarArchivoInforme = agregarArchivoInforme;
        vm.verCuestionario = verCuestionario;
        vm.validaDatosPreguntaTabla = validaDatosPreguntaTabla;
        vm.registrarArchivoCuestionarioDetalle = registrarArchivoCuestionarioDetalle;
        vm.listarDocumentosCuestionarioDetalle = listarDocumentosCuestionarioDetalle;
        vm.confirmarEliminarArchivo = confirmarEliminarArchivo;
        /* implementacion de metodos */
        /******* Archivos   ********/
        function confirmarEliminarArchivo(item, detalleCuestionario) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el archivo ' + item.nombreArchivo + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarArchivo(item, detalleCuestionario);
            });
        }

        function eliminarArchivo(item, detalleCuestionario) {
            CuestionarioFactory.eliminarArchivosCuestionario(item).then(function(response) {
                if (response.valido) {
                    listarDocumentosCuestionarioDetalle(detalleCuestionario);
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo eliminar a la norma asignada a esta entidad.');
            });
        }

        function listarDocumentosCuestionarioDetalle(detalleCuestionario) {
            /*var detalleCuestionario = vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index];*/
            vm.listaArchivosRespuesta = [];
            if (detalleCuestionario.pregunta.tipoPregunta.codigoRegistro == 3 || detalleCuestionario.pregunta.tipoPregunta.codigoRegistro == 4 || detalleCuestionario.pregunta.tipoPregunta.codigoRegistro == 6) {
                CuestionarioFactory.listarlistarDocumentosCuestionario(detalleCuestionario).then(function(response) {
                    if (response.valido) {
                        debugger;
                        //vm.dataPedido.idPedido = response.data;
                        vm.listaArchivosRespuesta = response.data;
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al Obtener Informacion.');
                });
            }
        }

        function registrarArchivoCuestionarioDetalle(itemCuestionarioDetalle) {
            debugger;
            if (vm.archivoAdjunto == null || vm.archivoAdjunto.length == 0) {
                toastr.warning('Debe Subir un Archivo');
                document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                return;
            }
            if (document.getElementById("fileArchivoPreguntaInstalacion").value == "") {
                toastr.warning('Debe seleccionar un archivo');
                return;
            }
            /*var dataArchivo = PreguntaFactory.modelArchivo();
                dataArchivo.codigoClasificacionArchivo = 8;*/
            vm.dataArchivo.idTablaArchivo = itemCuestionarioDetalle.idCuestionarioDetalle;
            vm.dataArchivo.codigoClasificacionArchivo = 8;
            CuestionarioFactory.registrarDocumentoCuestionarios(vm.archivoAdjunto, vm.dataArchivo).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    toastr.success('Se completo el registro del Archivo');
                    listarDocumentosCuestionarioDetalle(itemCuestionarioDetalle);
                    document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                    vm.dataArchivo.descripcion = '';
                    vm.archivoAdjunto = [];
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function validaDatosPreguntaTabla(data) {
            var result = 0;
            for (var x in data) {
                for (var b in data[x].lstOpcionPreguntaColumna) {
                    if (data[x].lstOpcionPreguntaColumna[b].valor.length == 0) {
                        return result = 0;
                    } else {
                        result = 1;
                    }
                }
            }
            return result;
        }

        function verCuestionario() {
            CuestionarioFactory.verCuestionario(vm.dataCuestionarioAutosupervision).then(function(response) {
                if (response.data != null && response.valido) {
                    vm.flagCuestionario = 1;
                    vm.dataCuestionarioAutosupervision.rutaArchivo = angular.copy(response.data);
                    $rootScope.urlPDFFichaDenuncia = "<iframe src='" + angular.copy(response.data) + "' style='width:100%; height:600px;' frameborder='0'> </iframe>";
                    visualizarPDF();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function visualizarPDF() {
            ngDialog.open({
                template: 'app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html',
                controller: 'SolicitudArchivoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        /*    function eliminarArchivo(index,detalleCuestionario){
                        
                        for (var x in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle){
                    if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[x].idCuestionarioDetalle == detalleCuestionario.idCuestionarioDetalle){
                                    

                            vm.archivoAdjunto.splice(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[x].lstArchivo[index].posicionArchivo, 1);
                            vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[x].lstArchivo.splice(index, 1);/*
                            vm.dataInformarAccion.lstArchivoInformeAccion.splice(index, 1);*/
        /*                          
                    }

            }

              
              

           }*/
        function agregarArchivoInforme(index) {
            if (vm.archivoAdjunto.length == 0 || (vm.archivoAdjunto.length == vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].lstArchivo.length)) {
                toastr.warning('Debe Seleccionar un Archivo');
                return;
            }
            if (document.getElementById("fileArchivoPreguntaInstalacion").value == "") {
                toastr.warning('Debe seleccionar un archivo');
                return;
            }
            console.log(vm.archivoAdjunto.length);
            vm.dataArchivo.posicionArchivo = vm.archivoAdjunto.length - 1;
            vm.dataArchivo.nombreArchivo = angular.copy(vm.archivoAdjunto[vm.dataArchivo.posicionArchivo].name);
            vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].lstArchivo.push(angular.copy(vm.dataArchivo));
            document.getElementById("fileArchivoPreguntaInstalacion").value = "";
            vm.dataArchivo.descripcion = '';
        }

        function validaArchivos(index) {
            if (vm.archivoAdjunto.length == (vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].lstArchivo.length + 1)) {
                document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                vm.archivoAdjunto.splice(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].lstArchivo.length - 1, 1);
            }
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            debugger;
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList != null && prmFileList.length == 0) {
                toastr.warning('No ha Seleccionado ningun archivo');
                document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                return;
            }
            for (var i = 0; i < prmFileList.length; i++) {
                var archivo = prmFileList[i];
                for (var x in vm.archivoAdjunto) {
                    if (vm.archivoAdjunto[x].name == archivo.name) {
                        toastr.warning('Debe Ingresar un Archivo con un nombre Diferente');
                        document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                        /*  vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoInformeAccion.length, 1);*/
                        return;
                    }
                }
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('No es el tipo de archivo seleccionado.');
                    document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoPreguntaInstalacion").value = "";
                    return;
                }
            }
            vm.archivoAdjunto.push(prmFileList[0]);
        }
        /****************************/
        function eliminarRespuestaSeleccionMultiple(index, detalleCuestionario) {
            for (var x in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle) {
                if (vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[x].idCuestionarioDetalle == detalleCuestionario.idCuestionarioDetalle) {
                    vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[x].pregunta.lstRespuestaPregunta.splice(index, 1);
                }
            }
        }

        function agregarDatosPreguntaSeleccionMultiple(listaOpciones, index) {
            console.log("paso agregar Datos");
            for (var x in listaOpciones) {
                var a = 0;
                for (var b in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].pregunta.lstRespuestaPregunta) {
                    if (vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].pregunta.lstRespuestaPregunta[b].opcionPregunta.idOpcionPregunta == listaOpciones[x].idOpcionPregunta) {
                        a = a + 1;
                    }
                }
                if (a == 0) {
                    if (listaOpciones[x].idOpcionPregunta == vm.dataOpcionPreguntaObj.opcionPregunta.idOpcionPregunta) {
                        var dataRespuesta = CuestionarioFactory.modelRespuestaCuestionario();
                        dataRespuesta.opcionPregunta = angular.copy(listaOpciones[x]);
                        vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index].pregunta.lstRespuestaPregunta.push(dataRespuesta);
                    }
                }
            }
        }

        function siguiente(index) {
            console.log(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle);
            for (var x = 0; x < vm.dataValidacion.length; x++) {
                if (x == index) {
                    vm.dataValidacion[x] = 1;
                } else {
                    vm.dataValidacion[x] = 0;
                }
            }
            var detalleCuestionario = angular.copy(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index]);
            listarDocumentosCuestionarioDetalle(detalleCuestionario);
        }

        function atras(index) {
            console.log(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle);
            for (var x = 0; x < vm.dataValidacion.length; x++) {
                if (x == index) {
                    vm.dataValidacion[x] = 1;
                } else {
                    vm.dataValidacion[x] = 0;
                }
            }
            var detalleCuestionario = angular.copy(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[index]);
            listarDocumentosCuestionarioDetalle(detalleCuestionario);
        }

        function terminarCuestionario() {
            CuestionarioFactory.resolverCuestionario( /*vm.archivoAdjunto,*/ vm.dataCuestionarioAutosupervision).then(function(response) {
                debugger;
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    toastr.success('Se completo el registro del Cuestionario');
                    ngDialog.close();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function obtenerDatos(data) {
            console.log(angular.toJson(data));
        }
        /*
                    function buscarCuestionario(data){
                    var dataCuestionario = CuestionarioFactory.model();
                        dataCuestionario.instalacion = data;
                CuestionarioFactory
                    .buscarPorIdInstalacion(dataCuestionario)
                    .then(function (response) {
                        if(response.valido){
                        
                            
                            vm.dataCuestionarioAutosupervision = response.data;

                            for(var i in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle){
                                
                                    if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.tipoPregunta.codigoRegistro==5){
                                        
                                        var listaDataOpciones = vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta;

                                
                                            var listaDataOpcionesFila = [];

                                        if(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosFila!=0 && vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosColumna!=0){
                                                
                                            for(var d = 0; d<vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosFila; d++){
                                                    var listaOpcionesColumna = [];
                                                    for(var e = 0; e<vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.numerosColumna; e++){


                                                        var dataColumna = OpcionPreguntaFactory.model();
                                                        dataColumna.posicionFila    = d;
                                                        dataColumna.posicionColumna = e;
                                                        
                                                        listaOpcionesColumna.push(dataColumna);
                                                    

                                                    }
                                                        var dataFila = OpcionPreguntaFactory.model();
                                                            dataFila.lstOpcionPreguntaColumna = angular.copy(listaOpcionesColumna);
                                                    listaDataOpcionesFila.push(dataFila);


                                            }


                                        }




                                        for(var z in listaDataOpcionesFila){

                                                for(var v in listaDataOpcionesFila[z].lstOpcionPreguntaColumna){

                                                        for(var s in listaDataOpciones){

                                                            if(listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionFila==listaDataOpciones[s].posicionFila && listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionColumna==listaDataOpciones[s].posicionColumna){


                                                                    listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v]= angular.copy(listaDataOpciones[s]);

                                                            }


                                                        }


                                                }


                                        }

                                        vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta =   angular.copy(listaDataOpcionesFila);
                                        
                                            console.log("da9999"+vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta);
                                    
                                    }


                            }
                            var numeroData =vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle.length;
                            console.log(numeroData);
                        
                            for(var x =0 ; x < numeroData; x++){
                                console.log("x: "+x );
                                    if(x==0){
                                        vm.dataValidacion[x] = 1; 
                                    }else{
                                        vm.dataValidacion[x] = 0; 
                                    }
                                    
                            }

                            console.log(vm.dataValidacion)
                        
                        }
                        else{
                            toastr.error(response.mensaje);
                        }
                    })
                    .catch(function (error) {
                        toastr.error('Ocurrió un error al Obtener Informacion.');
                    });
                }
        */
        /**************************************************************************/
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                //console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*************************************************************************/
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /**************************************************************************************/
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            if (angular.isDefined(localStorage.objInstalacionDataCuestionario)) {
                var data = angular.fromJson(localStorage.objInstalacionDataCuestionario);
                debugger;
                vm.dataCuestionarioAutosupervision = angular.copy(data);
                console.log(numeroData);
                var numeroData = vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle.length;
                for (var x = 0; x < numeroData; x++) {
                    console.log("x: " + x);
                    if (x == 0) {
                        vm.dataValidacion[x] = 1;
                    } else {
                        vm.dataValidacion[x] = 0;
                    }
                }
                listarDocumentosCuestionarioDetalle(vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle[0]);
                /*buscarCuestionario(data);*/
            }
            /*
            if(angular.isDefined(localStorage.objInstalacion)){
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion= angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                
                //console.log("Instalacion: ",vm.prmInstalacion);
                buscarInstrumentoGestion();
                listarDocumentacion(1,false,"");
                listarDocumentacion(2,false,"");
                listarDocumentacion(3,false,"");
            }*/
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AccionAdministradoController', AccionAdministradoController);
    /* @ngInject */
    function AccionAdministradoController($state, toastr, ngDialog, $scope, DeclaracionEtapaFactory, DeclaracionComponenteFactory, DeclaracionPuntoFactory, DeclaracionParametroFactory, AdministradoFactory, MaestroFactory, InstalacionFactory, InstrumentoGestionFactory,  $filter, $log, $rootScope, EtapaFactory,ComponenteAmbientalFactory, API_CONFIG, $window) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        /* Lista de Combos */

        /* declaracion de metodos enlazados a la vista */
        /** ****** */
        vm.cancelar = cancelar;
        
        // Lista de Etapas para iniciar la declaración de información
        vm.lstEtapas = [];
        
        // Lista de Periodos para seleccionar la frecuencia por cada componente
		// ambiental
        vm.lstPeriodos = [];
        
        // Lista de puntos de monitoreo de un componente ambiental
        vm.lstDeclaracionPunto = [];
        
        // Lista de Parametros de un punto de monitoreo
        vm.lstDeclaracionParametro = [];
        
        // Filtro para el listado de Etapas para iniciar la declaración de
		// información
        vm.dataEtapa = EtapaFactory.model();
       
         // Filtro para el listado de Periodos para iniciar la declaración de
		// información
        vm.dataTipoPeriodo = MaestroFactory.model();
        
        // Objeto principal que contiene toda la informacion para la declaracion
        vm.objInstrumentoGestion ;
        
        // Objeto para mostrar los datos de la instalación
        vm.objInstalacion;
        
        // Metodo principal para grabar los datos de la declaración de la
		// información a remitir
        vm.guardarDeclaracion = guardarDeclaracion;
        
        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.agregarDeclaracionComponentes = agregarDeclaracionComponentes;
        
        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionComponentes = actualizarDeclaracionComponentes; 
        
        // carga los componenetes de la declaración según la etapa seleccionada
        vm.cargarDeclaracionComponentes = cargarDeclaracionComponentes;
        
        // carga los puntos de monitorreo según el componente seleccionado
        vm.cargarDeclaracionPuntosMonitoreo = cargarDeclaracionPuntosMonitoreo;
        
        vm.agregarDeclaracionPuntosMonitoreo = agregarDeclaracionPuntosMonitoreo;
        
        vm.agregarDeclaracionParametros = agregarDeclaracionParametros;
        
        vm.verPuntosMonitoreo = false;
        vm.verComponentes = false;
        	
        // confirma eliminación de los compoenestes de un proyecto en la
		// declaración
        vm.confirmarEliminacionComponente = confirmarEliminacionComponente;
        
        // Componente seleccionado para agregar puntos de monitoreo
        vm.objDeclaracionComponente ;
        
      // Punto de Monitoreo seleccionado para agregar parametros
        vm.objDeclaracionPuntoMonitoreo ;
        
        vm.cargarDeclaracionParametros = cargarDeclaracionParametros;
        
        vm.confirmarEliminacionPunto = confirmarEliminacionPunto;
        
        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;
        
        /* declaracion de metodos */
        
        function cancelar() {
            $state.go('spapp.home.supervision.instrumento-gestion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
        	cargarEtapas();
            cargarPeriodos();
        }
        
        function cargarEtapas() {
        	vm.dataEtapa.estado = '1';
            EtapaFactory.listarActivosPorUnidad(angular.copy(vm.dataEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = response.data;
                    if( vm.activeetapa == null){
                   	 vm.activeetapa = 1;
                   }
                   vm.active = 0;
                   cargarDeclaracionComponentes(vm.lstEtapas[1]);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function cargarDeclaracionPuntosMonitoreo(prmComponente){
        	vm.verPuntosMonitoreo = true;
        	vm.verParametros = false;
        	vm.objDeclaracionComponente = prmComponente;
        	var tempPunto = {
        			idAdministrado : prmComponente.idAdministrado,
    				idIga : prmComponente.idIga,
    				idInstalacion : prmComponente.idInstalacion,
    				idEtapa : prmComponente.idEtapa,
    				idComponente : prmComponente.idComponente,
            	};
        	 
        	 DeclaracionPuntoFactory.listar(angular.copy(tempPunto)).then(function(response) {
                 if (response != null && response.valido) {
                	 vm.lstDeclaracionPunto = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        
        function agregarDeclaracionPuntosMonitoreo(prmPuntoMonitoreo) {
        	
        	if(prmPuntoMonitoreo == null){
        		prmPuntoMonitoreo = DeclaracionPuntoFactory.model();
        		prmPuntoMonitoreo.idAdministrado  = vm.objDeclaracionComponente.idAdministrado;
        		prmPuntoMonitoreo.idIga  = vm.objDeclaracionComponente.idIga;
        		prmPuntoMonitoreo.idInstalacion  = vm.objDeclaracionComponente.idInstalacion;
        		prmPuntoMonitoreo.idEtapa  = vm.objDeclaracionComponente.idEtapa;
        		prmPuntoMonitoreo.idComponente  = vm.objDeclaracionComponente.idComponente;
        	}
        		
        	$rootScope.objDeclaracionPunto = prmPuntoMonitoreo;
        		
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/punto-monitoreo-dialog.html',
                controller: 'PuntoMonitoreoDialogController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
            });
        }
        
        function cargarDeclaracionComponentes() {
        	vm.verPuntosMonitoreo = false;
        	vm.verParametros = false;
        	vm.verComponentes = true;
        	if(vm.objInstrumentoGestion.declaracionEtapa.idEtapa == 0){
        		vm.verComponentes = false;
        		return;
        	}
        	
        	var tempComponente = {
        		idAdministrado : vm.objInstalacion.idAdministrado,
        	    idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
        	    idInstalacion : vm.objInstrumentoGestion.idInstalacion,
        	    idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
        	    origen : 'D'
        	};
    	 
        	DeclaracionComponenteFactory.listar(angular.copy(tempComponente)).then(function(response) {
             if (response != null && response.valido) {
            	 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = angular.copy(response.data);
             }
         }).catch(function(error) {
             toastr.error('No se pudo obtener los datos.');
         });
    	 
        }
        
        function agregarDeclaracionComponentes() {
        	$rootScope.lstComponentesBase = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes;
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-selector.html',
                controller: 'ComponenteAmbientalSelectorController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	var array  = $rootScope.lstComponentesSel;
            	if (angular.isDefined(array)){
            		if(array.length > 0){
            			for (var x in array) {
            				var tempComponente = {
            					idAdministrado : vm.objInstalacion.idAdministrado,
            					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
            					idInstalacion : vm.objInstalacion.idInstalacion,
            					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
            					idComponente : array[x].codigo,
            					idFrecuencia : null,
            					estado : 'P',
            					origen : 'D'
            		        };
            				guardarDeclaracionComponentes(tempComponente);
                        }
            		}
            	}
             	
            });
        }
        
        function guardarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.registrar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function actualizarDeclaracionComponentes(prmComponente){
        	vm.verPuntosMonitoreo = false;
        	DeclaracionComponenteFactory.actualizar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function confirmarEliminacionComponente(prmDeclaracionComponente){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + '?'
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminarDeclaracionComponente(prmDeclaracionComponente);
             });
        }
        
        function eliminarDeclaracionComponente(prmDeclaracionComponente) {
        	vm.verPuntosMonitoreo = false;
        	DeclaracionComponenteFactory.eliminar(angular.copy(prmDeclaracionComponente)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    cargarDeclaracionComponentes();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }
        
        function  cargarDeclaracionParametros(prmPuntoMonitoreo){
        	vm.verParametros = true;
            vm.objDeclaracionPuntoMonitoreo = prmPuntoMonitoreo;
        	
        	var tempPuntoMonitoreo = {
        		idAdministrado : vm.objInstalacion.idAdministrado,
        	    idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
        	    idInstalacion : vm.objInstrumentoGestion.idInstalacion,
        	    idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
        	    idComponente : prmPuntoMonitoreo.idComponente,
        	    idPunto : prmPuntoMonitoreo.idPunto,
        	};
    	 
        	DeclaracionParametroFactory.listar(angular.copy(tempPuntoMonitoreo)).then(function(response) {
             if (response != null && response.valido) {
            	 vm.lstDeclaracionParametro = angular.copy(response.data);
             }
         }).catch(function(error) {
             toastr.error('No se pudo obtener los datos.');
         });
        }
        
        
        function agregarDeclaracionParametros(){
        	
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};
        	
        	$rootScope.prmComponente = componente;
        	$rootScope.lstParametrosComponenteBase  = vm.lstDeclaracionParametro;
        	ngDialog.open({
                template: 'app/modules/componente-parametro/componente-parametro-selector.html',
                controller: 'ComponenteParametroSelectorController',
                controllerAs: 'vm',
                
                width: '50%'
            }).closePromise.then(function(dataDialog) {
            	var array = $rootScope.lstParametrosComponenteSel;
                for (var x in array){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.objDeclaracionComponente.idAdministrado,
            				idIga : vm.objDeclaracionComponente.idIga,
            				idInstalacion : vm.objDeclaracionComponente.idInstalacion,
            				idEtapa : vm.objDeclaracionComponente.idEtapa,
            				idComponente : vm.objDeclaracionComponente.idComponente,
            				idPunto : vm.objDeclaracionPuntoMonitoreo.idPunto,
            				idParametroValor : array[x].parametro_valor,
            				idMatriz : array[x].matriz,
            				idSubMatriz: array[x].submatriz,
            				estado : 'P'
                	};
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
                        }
                    }).catch(function(error) {
                        toastr.error('No se pudo obtener los datos.');
                    });
                }
            });
        }
        
        
        function confirmarEliminacionPunto(prmDeclaracionPunto){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar el registro?'
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminarDeclaracionPunto(prmDeclaracionPunto);
             });
        }
        
        function eliminarDeclaracionPunto(prmDeclaracionPunto){
        	vm.verPuntosMonitoreo = false;
        	DeclaracionPuntoFactory.eliminar(angular.copy(prmDeclaracionPunto)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    cargarDeclaracionComponentes();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }
        
        function confirmarEliminacionParametro(prmDeclaracionParametro){
       	 ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionParametro(prmDeclaracionParametro);
            });
       }
       
       function eliminarDeclaracionParametro(prmDeclaracionParametro){
       	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar el parametro');
           });
       }
        
        
        
        
        function cargarPeriodos() {
        	
        	vm.dataTipoPeriodo.codigoMaestro = 'TipoPeriodo';
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
        }
        
      
        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Etapa
        function nuevaEtapa() {
        	console.log("abrir nuevo etapa");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/etapa-proyecto-dialog.html',
                controller: 'EtapaProyectoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Componente
        function nuevoComponenteAmbiental() {
        	console.log("abrir nuevo componente");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-dialog.html',
                controller: 'ComponenteAmbientalDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Punto Monitoreo
        function nuevoPuntoMonitoreo() {
        	console.log("abrir nuevo punto monitoreo");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/punto-monitoreo-dialog.html',
                controller: 'PuntoMonitoreoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        // Nuevo Parametro
        function nuevoParametroAmbiental() {
        	console.log("abrir nuevo punt");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/parametro-ambiental-dialog.html',
                controller: 'ParametroAmbientalDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function guardarDeclaracion() {
        	
        	// Declaración Etapa
        	vm.objInstrumentoGestion.declaracionEtapa.idAdministrado = vm.objInstalacion.idAdministrado;
        	vm.objInstrumentoGestion.declaracionEtapa.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
        	vm.objInstrumentoGestion.declaracionEtapa.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
        	
        	// Declaracion Componentes
        	vm.declaracionComponente = DeclaracionComponenteFactory.model();
        	// actualizamos la relacion:
           	for (var x in vm.lstComponentes) {
                	if (vm.lstComponentes[x].blSeleccionado){
                		
                		 vm.declaracionComponente.idAdministrado = vm.objInstalacion.idAdministrado;
                		 vm.declaracionComponente.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
                		 vm.declaracionComponente.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
                		 vm.declaracionComponente.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa ;
                		 vm.declaracionComponente.idComponente = vm.lstComponentes[x].codigo ;
                		 vm.declaracionComponente.idFrecuencia = vm.lstComponentes[x].idFrecuencia ;
                		 vm.declaracionComponente.estado = '1' ;
                		 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(angular.copy());
                	}
                }
        	
        	InstrumentoGestionFactory.registrarDeclaracion(angular.copy(vm.objInstrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo guardar.');
            });
        }
   
            function init() {
                if (angular.isDefined(localStorage.objInstrumentoGestion)) {
                    vm.objInstrumentoGestion = angular.copy(angular.fromJson(localStorage.objInstrumentoGestion));
                    vm.objInstrumentoGestion.declaracionEtapa = DeclaracionEtapaFactory.model();
                }
                if (angular.isDefined(localStorage.objInstalacion)) {
                    vm.objInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                }
                cargarCombos();
            }
       
      
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AccionAdministradoResiduoController', AccionAdministradoResiduoController);
    /* @ngInject */
    function AccionAdministradoResiduoController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InstalacionDocumentacionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.fechaActual = new Date();
        vm.file = null;
        vm.flagInformeInstalacionAnterior = 0;
        vm.showFrecuencia = true;
        vm.swBtnAgregarM = false;
        // vm.urlData= API_CONFIG.url;
        vm.rutaBase = API_CONFIG.url;
        vm.flagProcesoInformeMonitoreo = 0;
        vm.active = 0;
        /* Luis */
        vm.active2 = 0;
        /* Luis */
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.periodoInformeData = {};
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.dataInformeMonitoreo = InformeMonitoreoFactory.model();
        vm.filePlanTrabajo = null;
        vm.fileInforme = null;
        vm.fileDeclaracion = null;
        vm.fileManifestacion = null;
        vm.fileMonitoreo = null;
        vm.fileOtros = null;
        vm.fileInstrumento = null;
        vm.lstPlan = [{
            id: 0
        }];
        vm.lstInforme = [{
            id: 0
        }];
        vm.lstDeclaracion = [{
            id: 0
        }];
        vm.lstManifestacion = [{
            id: 0
        }];
        vm.lstOtros = [{
            id: 0
        }];
        vm.lstInstrumento = [{
            id: 0
        }];
        vm.lstInforme = [{
            id: 0
        }];
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.prmPlan = InstalacionDocumentacionFactory.model(1);
        vm.prmInforme = InstalacionDocumentacionFactory.model(2);
        vm.prmDeclaracion = InstalacionDocumentacionFactory.model(3);
        vm.prmManifestacion = InstalacionDocumentacionFactory.model(4);
        vm.prmOtros = InstalacionDocumentacionFactory.model(5);
        vm.prmInstrumento = InstalacionDocumentacionFactory.model(6);
        vm.dataPresentacion = {
            periodoPresentacion: 0,
            subPeriodo: 0,
            monitoreo: MaestroFactory.model(),
        };
        /* Lista de Combos */
        vm.listaPeriodoPresentacion = [];
        vm.listaSubPeriodo = [];
        vm.listaMonitoreo = [];
        vm.listaManifestacion = [];
        vm.listaInstrumento = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.dataInformePresentacionPeriodo = {};
        vm.prmDataFiltroMonitoreoPeriodos = MonitoreoPeriodosFactory.model();
        vm.dataMonitoreoPeriodoPresentacion = MonitoreoPeriodosFactory.model();
        vm.listaInformeMonitoreoAmbiental = [];
        vm.listaPresentacionInformeMonitoreoAmbiental = [];
        vm.listaArchivosInformeMonitoreo = [];
        vm.listaFileArchivosInformeMonitoreo = [];
        vm.archivoAdjunto = {};
        vm.objArchivoInformePresentacion = ArchivoFactory.model();
        vm.prmDatainformePresentacion = {};
        /** ************************************************** */
        /** Fin Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        // vm.agregarMonitoreo = agregarMonitoreo;
        /** *** */
        /* declaracion de metodos enlazados a la vista */
        vm.guardarPlan = guardarPlan;
        vm.guardarInstrumentoGestion = guardarInstrumentoGestion;
        vm.listarDocumentacion = listarDocumentacion;
        vm.validaDocumento = validaDocumento;
        vm.validaDocumentoInforme = validaDocumentoInforme;
        vm.validaDocumentoDeclaracion = validaDocumentoDeclaracion;
        vm.validaDocumentoManifestacion = validaDocumentoManifestacion;
        vm.validaDocumentoMonitoreo = validaDocumentoMonitoreo;
        vm.validaDocumentoOtros = validaDocumentoOtros;
        vm.validaDocumentoInstrumento = validaDocumentoInstrumento;
        vm.guardarInformeAmbiental = guardarInformeAmbiental;
        vm.descarga = descarga;
        vm.eliminarDocumento = eliminarDocumento;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        vm.guardarInformeMonitoreoAmbiental = guardarInformeMonitoreoAmbiental;
        vm.listarInformesMonitoreoPorInstalacion = listarInformesMonitoreoPorInstalacion;
        vm.listarPresentacionInformeMonitoreo = listarPresentacionInformeMonitoreo;
        vm.guardarPresentacionInformeMonitoreoAmbiental = guardarPresentacionInformeMonitoreoAmbiental;
        vm.validaDocumentoInformeMonitoreoAmbiental = validaDocumentoInformeMonitoreoAmbiental;
        vm.obtenerDatosDelPeriodoInforme = obtenerDatosDelPeriodoInforme;
        vm.agregarArchivosMonitoreoInformePresentacion = agregarArchivosMonitoreoInformePresentacion;
        vm.obtenerDatosInformeMonitoreo = obtenerDatosInformeMonitoreo;
        vm.atrasInformMonitoreoAmbiental = atrasInformMonitoreoAmbiental;
        vm.eliminarArchivoInformeMonitoreoAmbiental = eliminarArchivoInformeMonitoreoAmbiental;
        vm.metodoEliminarArchivoInformeMonitoreoAmbiental = metodoEliminarArchivoInformeMonitoreoAmbiental;
        vm.confirmarMetodoEliminarArchivoInformeMonitoreoAmbiental = confirmarMetodoEliminarArchivoInformeMonitoreoAmbiental;
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        // daniel
        vm.nuevoIGA = nuevoIGA;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.mostrarCampos = mostrarCampos;
        vm.mostrarPresentacion= false;
        vm.siguienteProgramMonitoreoAmbiental = siguienteProgramMonitoreoAmbiental;
        vm.atrasProgramMonitoreoAmbiental = atrasProgramMonitoreoAmbiental;
        vm.nuevaEtapa = nuevaEtapa;
        vm.nuevoComponenteAmbiental = nuevoComponenteAmbiental;
        vm.nuevoPuntoMonitoreo = nuevoPuntoMonitoreo;
        vm.nuevoParametroAmbiental = nuevoParametroAmbiental;
        vm.grabarProgramaMonitoreo = grabarProgramaMonitoreo;
        vm.mostrarProgramaMonitoreo = false;
        
        /* Luis */
        vm.mostrarInformeMonitoreo = false;
        vm.finalizar = finalizar;
        vm.siguienteInformeAmbiental = siguienteInformeAmbiental;
        vm.atrasInformeAmbiental = atrasInformeAmbiental;
        /* Luis */
        
        vm.siguienteManifiestoResiduos = siguienteManifiestoResiduos;
        vm.atrasManifiestoResiduos = atrasManifiestoResiduos;
        vm.guardarManifiestoResiduos = guardarManifiestoResiduos;
        vm.mostrarDatos1 = true;
        vm.mostrarDatos2 = false;
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.administrado');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaPeriodoPresentacion = [];
            var codigosCombos = ['TipoPeriodo', 'TipoMonitoreo'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoPeriodo':
                                for (var i in datosCombo) {
                                    vm.listaPeriodoPresentacion.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoMonitoreo':
                                vm.listaMonitoreo = [];
                                var maestro = MaestroFactory.model();
                                maestro.descripcion = "Seleccione";
                                vm.listaMonitoreo.push(maestro);
                                for (var i in datosCombo) {
                                    vm.listaMonitoreo.push(datosCombo[i]);
                                }
                                vm.dataPresentacion.monitoreo = maestro;
                                // vm.listaMonitoreo = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */
        function guardarPlan(tipo) {
            var filtro;
            var fileGeneral = null;
            switch (tipo) {
                case 1:
                    filtro = angular.copy(vm.prmPlan);
                    fileGeneral = vm.filePlanTrabajo;
                    break;
                case 2:
                    filtro = angular.copy(vm.prmInforme);
                    fileGeneral = vm.fileInforme;
                    break;
                case 3:
                    filtro = angular.copy(vm.prmDeclaracion);
                    fileGeneral = vm.fileDeclaracion;
                    break;
                case 4:
                    if (vm.prmManifestacion.mes == null && vm.prmManifestacion.mes <= 0) {
                        toastr.info("Seleccione Mes");
                        return;
                    }
                    filtro = angular.copy(vm.prmManifestacion);
                    fileGeneral = vm.fileManifestacion;
                    break;
                case 5:
                    filtro = angular.copy(vm.prmOtros);
                    fileGeneral = vm.fileOtros;
                    break;
                case 6:
                    filtro = angular.copy(vm.prmInstrumento);
                    fileGeneral = vm.fileInstrumento;
                    break;
                default:
                    break;
            }
            if (filtro.archivo == null || filtro.archivo.idArchivo == 0) {
                if (fileGeneral == null) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                InstalacionDocumentacionFactory.registrarArchivo(fileGeneral, filtro).then(function(response) {
                    if (response.valido) {
                        listarDocumentacion(tipo, true, response.mensaje);
                        // toastr.success(response.mensaje);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
            } else {
                InstalacionDocumentacionFactory.actualizar(filtro).then(function(response) {
                    if (response.valido) {
                        // listarDocumentacion(tipo,true,response.mensaje);
                        toastr.success(response.mensaje);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
            }
        }

        function eliminarDocumento(item, tipo) {
            InstalacionDocumentacionFactory.eliminar(item).then(function(response) {
                if (response.valido) {
                    listarDocumentacion(tipo, true, response.mensaje);
                    // toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function listarDocumentacion(tipo, swMsj, msj) {
            var filtro;
            switch (tipo) {
                case 1:
                    filtro = angular.copy(vm.prmPlan);
                    filtro.idDocumentacion = 0;
                    break;
                case 2:
                    filtro = angular.copy(vm.prmInforme);
                    filtro.idDocumentacion = 0;
                    break;
                case 3:
                    filtro = angular.copy(vm.prmDeclaracion);
                    filtro.idDocumentacion = 0;
                    break;
                case 4:
                    filtro = angular.copy(vm.prmManifestacion);
                    filtro.idDocumentacion = 0;
                    break;
                case 5:
                    filtro = angular.copy(vm.prmOtros);
                    filtro.idDocumentacion = 0;
                    break;
                case 6:
                    filtro = angular.copy(vm.prmInstrumento);
                    filtro.idDocumentacion = 0;
                    break;
                default:
                    break;
            }
            InstalacionDocumentacionFactory.listar(filtro).then(function(response) {
                if (response.valido) {
                    if (swMsj) {
                        toastr.success(msj);
                    }
                    if (response.data != null && response.data.length > 0) {
                        switch (tipo) {
                            case 1:
                                vm.prmPlan = angular.copy(response.data[0]);
                                vm.prmPlan.anio = angular.copy(response.data[0].anio.toString());
                                vm.lstPlan.splice(0, 1);
                                vm.lstPlan = [{
                                    id: 0
                                }];
                                vm.filePlanTrabajo = null;
                                break;
                            case 2:
                                vm.prmInforme = angular.copy(response.data[0]);
                                vm.prmInforme.anio = angular.copy(response.data[0].anio.toString());
                                vm.lstInforme.splice(0, 1);
                                vm.lstInforme = [{
                                    id: 0
                                }];
                                vm.fileInforme = null;
                                break;
                            case 3:
                                vm.prmDeclaracion = angular.copy(response.data[0]);
                                vm.prmDeclaracion.anio = angular.copy(response.data[0].anio.toString());
                                vm.lstDeclaracion.splice(0, 1);
                                vm.lstDeclaracion = [{
                                    id: 0
                                }];
                                vm.fileDeclaracion = null;
                                break;
                            case 4:
                                vm.listaManifestacion = angular.copy(response.data);
                                if (vm.listaManifestacion != null && vm.listaManifestacion.length > 0) {
                                    for (var i = 0; i < vm.listaManifestacion.length; i++) {
                                        vm.listaManifestacion[i].anio = angular.copy(vm.listaManifestacion[i].anio.toString());
                                    }
                                }
                                vm.lstManifestacion.splice(0, 1);
                                vm.lstManifestacion = [{
                                    id: 0
                                }];
                                vm.fileManifestacion = null;
                                vm.prmManifestacion = InstalacionDocumentacionFactory.model(4);
                                vm.prmManifestacion.anio = angular.copy(filtro.anio);
                                vm.prmManifestacion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 5:
                                vm.listaOtros = angular.copy(response.data);
                                vm.lstOtros.splice(0, 1);
                                vm.lstOtros = [{
                                    id: 0
                                }];
                                vm.fileOtros = null;
                                vm.prmOtros = InstalacionDocumentacionFactory.model(5);
                                vm.prmOtros.anio = angular.copy(filtro.anio);
                                vm.prmOtros.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 6:
                                vm.listaInstrumento = angular.copy(response.data);
                                vm.lstInstrumento.splice(0, 1);
                                vm.lstInstrumento = [{
                                    id: 0
                                }];
                                vm.fileInstrumento = null;
                                vm.prmInstrumento = InstalacionDocumentacionFactory.model(6);
                                vm.prmInstrumento.anio = angular.copy(filtro.anio);
                                vm.prmInstrumento.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            default:
                                break;
                        }
                    } else {
                        switch (tipo) {
                            case 1:
                                vm.prmPlan = InstalacionDocumentacionFactory.model(1);
                                vm.prmPlan.anio = angular.copy(filtro.anio);
                                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 2:
                                vm.prmInforme = InstalacionDocumentacionFactory.model(2);
                                vm.prmInforme.anio = angular.copy(filtro.anio);
                                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 3:
                                vm.prmDeclaracion = InstalacionDocumentacionFactory.model(3);
                                vm.prmDeclaracion.anio = angular.copy(filtro.anio);
                                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 4:
                                vm.prmManifestacion = InstalacionDocumentacionFactory.model(4);
                                vm.prmManifestacion.anio = angular.copy(filtro.anio);
                                vm.prmManifestacion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                vm.listaManifestacion = [];
                                break;
                            case 5:
                                vm.prmOtros = InstalacionDocumentacionFactory.model(5);
                                vm.prmOtros.anio = angular.copy(filtro.anio);
                                vm.prmOtros.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                vm.listaOtros = [];
                                break;
                            case 6:
                                vm.prmInstrumento = InstalacionDocumentacionFactory.model(6);
                                vm.prmInstrumento.anio = angular.copy(filtro.anio);
                                vm.prmInstrumento.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                vm.listaInstrumento = [];
                                break;
                            default:
                                break;
                        }
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function validaDocumento(prmFileList) {
            vm.filePlanTrabajo = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstPlan.splice(0, 1);
                vm.lstPlan = [{
                    id: 0
                }];
                vm.filePlanTrabajo = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlan").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlan").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlan").value = "";
                return;
            }
            vm.filePlanTrabajo = prmFileList[0];
        }

        function validaDocumentoInforme(prmFileList) {
            vm.fileInforme = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstInforme.splice(0, 1);
                vm.lstInforme = [{
                    id: 0
                }];
                vm.fileInforme = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanInforme").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanInforme").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanInforme").value = "";
                return;
            }
            vm.fileInforme = prmFileList[0];
        }

        function validaDocumentoDeclaracion(prmFileList) {
            vm.fileDeclaracion = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstDeclaracion.splice(0, 1);
                vm.lstDeclaracion = [{
                    id: 0
                }];
                vm.fileDeclaracion = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanDeclaracion").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanDeclaracion").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanDeclaracion").value = "";
                return;
            }
            vm.fileDeclaracion = prmFileList[0];
        }

        function validaDocumentoManifestacion(prmFileList) {
            vm.fileManifestacion = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstManifestacion.splice(0, 1);
                vm.lstManifestacion = [{
                    id: 0
                }];
                vm.fileManifestacion = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanManifestacion").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanManifestacion").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanManifestacion").value = "";
                return;
            }
            vm.fileManifestacion = prmFileList[0];
        }

        function validaDocumentoOtros(prmFileList) {
            vm.fileOtros = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstOtros.splice(0, 1);
                vm.lstOtros = [{
                    id: 0
                }];
                vm.fileOtros = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanOtros").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanOtros").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanOtros").value = "";
                return;
            }
            vm.fileOtros = prmFileList[0];
        }

        function validaDocumentoMonitoreo(prmFileList) {
            vm.fileMonitoreo = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstMonitoreo.splice(0, 1);
                vm.lstMonitoreo = [{
                    id: 0
                }];
                vm.fileMonitoreo = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                // document.getElementById("fileArchivoMedio").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                // document.getElementById("fileArchivoMedio").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                // document.getElementById("fileArchivoMedio").value = "";
                return;
            }
            vm.fileMonitoreo = prmFileList[0];
        }

        function validaDocumentoInstrumento(prmFileList) {
            vm.fileInstrumento = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstInstrumento.splice(0, 1);
                vm.lstInstrumento = [{
                    id: 0
                }];
                vm.fileInstrumento = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanInstrumento").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanInstrumento").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanInstrumento").value = "";
                return;
            }
            vm.fileInstrumento = prmFileList[0];
        }

        function buscarInstrumentoGestion() {
            InstrumentoGestionFactory.listar(vm.prmInstrumentoGestion).then(function(response) {
                if (response.valido) {
                    vm.lstAnio = angular.copy(response.data.lstAnio);
                    if (response.data.data != null && response.data.data.length > 0) {
                        vm.prmInstrumentoGestion = angular.copy(response.data.data[0]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function guardarInstrumentoGestion() {
            InstrumentoGestionFactory.registrar(vm.prmInstrumentoGestion).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function descarga(archivo) {
            document.location = archivo;
        }

        function buscarMonitoreo(lista, codigo) {
            for (var i = 0; i < lista.length; i++) {
                if (lista[i].tipoMonitoreo == codigo) {
                    return i;
                }
            }
            return -1;
        }

        function obtenerMes() {
            var prmFiltro = MaestroFactory.model();
            prmFiltro.codigoMaestro = 'PeriodoInforme';
            prmFiltro.codigoRegistroPadre = 1;
            MaestroFactory.buscarRegistroHijo(angular.copy(prmFiltro)).then(function(response) {
                if (response.valido && response.data != null && response.data.length > 0) {
                    vm.listaMes = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function nombreMes(codigo) {
            for (var i = 0; i < vm.listaMes.length; i++) {
                if (vm.listaMes[i].codigoRegistro == codigo) {
                    return vm.listaMes[i].descripcion;
                }
            }
            return "";
        }

        function convertDateToString(prmdate) {
            if (!angular.isUndefined(prmdate) && prmdate != null && prmdate != "") {
                try {
                    var strDate = $filter('date')(prmdate, "dd/MM/yyyy");
                    return strDate;
                } catch (e) {
                    return "";
                }
            }
        }

        function convertStringToDate(strDate) {
            if (!angular.isUndefined(strDate) && strDate != null && strDate != "") {
                try {
                    var dateArray = strDate.split("/");
                    var date = new Date(dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0])
                    return date;
                } catch (e) {
                    $log.log("convertStringToDate: ", e);
                    return null;
                }
            }
        }

        function buscarDataListaMaestro(lstMaestro, codigoRegistro) {
            var data = null;
            for (var x in lstMaestro) {
                if (lstMaestro[x].codigoRegistro == codigoRegistro) {
                    data = lstMaestro[x];
                }
            }
            return data;
        }
        /** ***************************************************************************************************** */
        /** Informe monitoreo ambiental * */
        /** ***************************************************************************************************** */
        function guardarInformeMonitoreoAmbiental() {
            vm.dataInformeMonitoreo.instalacion.idInstalacion = vm.prmInstalacion.idInstalacion;
            if (vm.dataInformeMonitoreo.tipoMonitoreo.codigoRegistro == 4 && (vm.dataInformeMonitoreo.descripcion == null || vm.dataInformeMonitoreo.descripcion.length == 0)) {
                toastr.warning('Debe ingresar una descripción');
                return;
            }
            if (vm.dataInformeMonitoreo.tipoMonitoreo.codigoRegistro != 4) {
                vm.dataInformeMonitoreo.descripcion = vm.dataInformeMonitoreo.tipoMonitoreo.descripcion;
            }
            InformeMonitoreoFactory.registrar(angular.copy(vm.dataInformeMonitoreo)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarInformesMonitoreoPorInstalacion();
                } else {
                    toastr.warning(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ******************************************************************************************************* */
        /** * */
        /** ******************************************************************************************************* */
        function listarInformesMonitoreoPorInstalacion() {
            var data = InformeMonitoreoFactory.model();
            data.instalacion.idInstalacion = vm.prmInstalacion.idInstalacion;
            InformeMonitoreoFactory.listar(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.listaInformeMonitoreoAmbiental = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function obtenerDatosInformeMonitoreo(prmData) {
            vm.dataInformeMonitoreo = prmData;
            vm.prmDataFiltroMonitoreoPeriodos.informeMonitoreo.idInformeMonitoreo = vm.dataInformeMonitoreo.idInformeMonitoreo;
            listarPresentacionInformeMonitoreo();
        }

        function listarPresentacionInformeMonitoreo() {
            var data = {
                idInformeMonitoreo: vm.prmDataFiltroMonitoreoPeriodos.informeMonitoreo.idInformeMonitoreo,
                nombreAnioPreInf: vm.prmDataFiltroMonitoreoPeriodos.anio,
            };
            MonitoreoPeriodosFactory.listar(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.flagProcesoInformeMonitoreo = 1;
                    vm.listaPresentacionInformeMonitoreoAmbiental = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        /*
		 * function obtenerDatosPresentacionMonitoreo(data){
		 * 
		 * vm.dataInformePresentacionPeriodo = angular.copy(data); }
		 */
        function validaDocumentoInformeMonitoreoAmbiental(prmFileList) {
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            /* $rootScope.archivoMedio=(prmFileList); */
            for (var i = 0; i < prmFileList.length; i++) {
                var archivo = prmFileList[i];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    /*
					 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
					 * 1);
					 */
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('No es el tipo de archivo seleccionado.');
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    return;
                }
            }
            vm.archivoAdjunto = prmFileList[0];
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function agregarArchivosMonitoreoInformePresentacion() {
            var r = 0;
            for (var x in vm.listaArchivosInformeMonitoreo) {
                if (vm.listaArchivosInformeMonitoreo[x].nombreArchivo == vm.archivoAdjunto.name) {
                    r = 1;
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    toastr.warning('No puede subir archivos duplicados');
                    return;
                }
            }
            if (document.getElementById("fileDocumentoPresentacion").value == "") {
                toastr.warning('Debe seleccionar un archivo');
                vm.archivoAdjunto.splice(vm.archivoAdjunto.length - 1, 1);
                return;
            }
            if (r == 0) {
                vm.objArchivoInformePresentacion.nombreArchivo = angular.copy(vm.archivoAdjunto.name);
                vm.listaArchivosInformeMonitoreo.push(angular.copy(vm.objArchivoInformePresentacion));
                vm.listaFileArchivosInformeMonitoreo.push(vm.archivoAdjunto);
                document.getElementById("fileDocumentoPresentacion").value = "";
            }
            // vm.listaArchivosInformeMonitoreo.push(vm.archivoAdjunto);
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function atrasInformMonitoreoAmbiental(numero) {
            vm.flagProcesoInformeMonitoreo = numero;
            if (vm.flagProcesoInformeMonitoreo == 0) {
                vm.dataInformeMonitoreo = InformeMonitoreoFactory.model();
                vm.prmDataFiltroMonitoreoPeriodos = MonitoreoPeriodosFactory.model();
                listarInformesMonitoreoPorInstalacion();
            }
            if (vm.flagProcesoInformeMonitoreo == 1) {
                vm.dataInformePresentacionPeriodo = {};
                vm.dataMonitoreoPeriodoPresentacion = MonitoreoPeriodosFactory.model();
                vm.listaInformeMonitoreoAmbiental = [];
                vm.listaArchivosInformeMonitoreo = [];
                vm.archivoAdjunto = {};
                vm.prmDatainformePresentacion = {};
                vm.periodoInformeData = {};
                listarPresentacionInformeMonitoreo();
            }
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function obtenerDatosDelPeriodoInforme(data) {
            vm.listaFileArchivosInformeMonitoreo = [];
            vm.periodoInformeData = angular.copy(data);
            var prmData = {
                idInformeMonitoreo: data.idInformeMonitoreo,
                nombreAnioPreInf: data.nombreAnioPreInf,
                periodoPresentacionInforme: data.periodoPresentacionInforme
            }
            MonitoreoPeriodosFactory.validarInformePresentacionPeriodo(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    debugger;
                    var dataobj = response.data;
                    if (dataobj != null && dataobj.idMonitoreoPeriodos != null && dataobj.idMonitoreoPeriodos != 0) {
                        data = angular.copy(dataobj);
                    }
                    vm.prmDatainformePresentacion = data;
                    vm.flagProcesoInformeMonitoreo = 2;
                    vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos = data.idMonitoreoPeriodos
                    vm.dataMonitoreoPeriodoPresentacion.anio = data.nombreAnioPreInf;
                    vm.dataMonitoreoPeriodoPresentacion.tipoPeriodo.codigoRegistro = data.periodoPresentacionInforme;
                    vm.dataMonitoreoPeriodoPresentacion.tipoPeriodo.descripcion = data.nombrePeriodoPreInfor;
                    vm.dataMonitoreoPeriodoPresentacion.informeMonitoreo = vm.dataInformeMonitoreo;
                    vm.dataMonitoreoPeriodoPresentacion.informeMonitoreo.instalacion.idInstalacion = vm.prmInstalacion.idInstalacion;
                    vm.dataMonitoreoPeriodoPresentacion.descripcion = data.descripcion;
                    if (vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos != null && vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos != 0) {
                        listarArchivosInformeMonitoreoAmbiental(data);
                    }
                } else {
                    toastr.info(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function guardarPresentacionInformeMonitoreoAmbiental() {
            if (vm.dataMonitoreoPeriodoPresentacion.descripcion == null || (vm.dataMonitoreoPeriodoPresentacion.descripcion.length == 0)) {
                toastr.warning('Debe ingresar una descripción');
                return;
            }
            if (vm.listaArchivosInformeMonitoreo.length == 0) {
                toastr.warning('No ha cargado archivos');
                return;
            }
            /*
			 * var prmData = MonitoreoPeriodosFactory.model();
			 * prmData.informeMonitoreo = vm.dataInformeMonitoreo;
			 * prmData.informeMonitoreo.instalacion.idInstalacion=vm.prmInstalacion.idInstalacion;
			 * prmData.anio =data.nombreAnioPreInf;
			 * prmData.tipoPeriodo.codigoRegistro =
			 * data.periodoPresentacionInforme;
			 */
            MonitoreoPeriodosFactory.registrarArchivoMonitoreo(vm.listaFileArchivosInformeMonitoreo, angular.copy(vm.dataMonitoreoPeriodoPresentacion)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos = response.data;
                    vm.periodoInformeData.idMonitoreoPeriodos = vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos;
                    vm.listaFileArchivosInformeMonitoreo = [];
                    obtenerDatosDelPeriodoInforme(vm.periodoInformeData);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function listarArchivosInformeMonitoreoAmbiental(data) {
            var prmDataArchivo = {
                codigoClasificacionArchivo: 5,
                idTablaArchivo: data.idMonitoreoPeriodos,
            };
            ArchivoFactory.listarArchivoidTabla(angular.copy(prmDataArchivo)).then(function(response) {
                if (response.valido) {
                    vm.listaArchivosInformeMonitoreo = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function confirmarMetodoEliminarArchivoInformeMonitoreoAmbiental(item, index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el archivo: ' + item.nombreArchivo + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                metodoEliminarArchivoInformeMonitoreoAmbiental(index);
            });
        }

        function metodoEliminarArchivoInformeMonitoreoAmbiental(data, index) {
            /* if(data.idArchivo==0){ */
            vm.listaFileArchivosInformeMonitoreo.splice(index, 1);
            vm.listaArchivosInformeMonitoreo.splice(index, 1);
            /*
			 * }else{ eliminarArchivoInformeMonitoreoAmbiental(data); }
			 */
        }

        function eliminarArchivoInformeMonitoreoAmbiental(data) {
            ArchivoFactory.eliminarArchivo(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmManifestacion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmOtros.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumento.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                // console.log("Instalacion: ",vm.prmInstalacion);
                obtenerMes();
                buscarInstrumentoGestion();
                listarInformesMonitoreoPorInstalacion();
                listarDocumentacion(1, false, "");
                listarDocumentacion(2, false, "");
                listarDocumentacion(3, false, "");
                listarDocumentacion(4, false, "");
                listarDocumentacion(5, false, "");
                listarDocumentacion(6, false, "");
                console.log("data ---> : " + getFileExtension("daraassaas.docx"));
            }
            cargarCombos();
        }
        
        // Nuevo IGA
        function nuevoIGA() {
        	console.log("abrir nuevo iga");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/instrumento-gestion-ambiental-dialog.html',
                controller: 'InstrumentoGestionAmbientalController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Etapa
        function nuevaEtapa() {
        	console.log("abrir nuevo etapa");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/etapa-proyecto-dialog.html',
                controller: 'EtapaProyectoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Componente
        function nuevoComponenteAmbiental() {
        	console.log("abrir nuevo componente");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-dialog.html',
                controller: 'ComponenteAmbientalDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Punto Monitoreo
        function nuevoPuntoMonitoreo() {
        	console.log("abrir nuevo punto monitoreo");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/punto-monitoreo-dialog.html',
                controller: 'PuntoMonitoreoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        // Nuevo Parametro
        function nuevoParametroAmbiental() {
        	console.log("abrir nuevo punt");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/parametro-ambiental-dialog.html',
                controller: 'ParametroAmbientalDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function grabarProgramaMonitoreo() {
        	
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Mensaje de Confirmación',
                    Mensaje: 'Se ha registrado su compromiso ambiental safactoriamente'
                },
                width: '380px'
            })
        }
        
        
        function guardarInformeAmbiental() {
        	
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: ' ¿Declara bajo juramento que la informacion anotada en la presente declaracion es verdadera, por lo que cualquier falsedad en los datos consignados dara lugar a que se le imponga las sanciones contempladas por ley?'
                },
                width: '700px'
            })
        }
        
       
        
        // funcion de pasar a un siguiente tab
        function mostrarCampos(opc){
        	console.log(opc);
        	vm.mostrarProgramaMonitoreo = false;
        	vm.mostrarInformeMonitoreo = false;
        	vm.mostrarPresentacion = false;
        	if(opc == 2){
        		vm.mostrarPresentacion = true;
        		vm.mostrarProgramaMonitoreo = true;
        		vm.mostrarInformeMonitoreo = true;
        	}
        	
        	if (opc == 0){
        		vm.mostrarProgramaMonitoreo = true;
        	}
        	if (opc == 1){
        		vm.mostrarInformeMonitoreo = true;
        	}
        	
        	
        	
        }
        
        function siguienteProgramMonitoreoAmbiental(tab){
        	
        	vm.active = tab + 1;
        	console.log(vm.active);
        }
        
        function atrasProgramMonitoreoAmbiental(tab){
        	
        	vm.active = tab - 1;
        	console.log(vm.active);
        }
        
        /* Luis */
        function siguienteInformeAmbiental(tab){
            
            vm.active2 = tab + 1;
        }
        
        function atrasInformeAmbiental(tab){
            
            vm.active2 = tab - 1;
        }
        /* Luis */
        
        function siguienteManifiestoResiduos (){
        	vm.mostrarDatos1 = false;
            vm.mostrarDatos2 = true;
        }
        
        function atrasManifiestoResiduos (){
        	vm.mostrarDatos1 = true;
            vm.mostrarDatos2 = false;
        }
        
        function guardarManifiestoResiduos (){
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: '¿Declara bajo juramento que la información anotada en la presente declaración es verdadera, por lo que cualquier falsedad en los datos consignados dará lugar a que se le imponga las sanciones contempladas por ley?'
                },
                width: '700px'
            })
        }
       
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('AccionAdministradoInformeController', AccionAdministradoInformeController);
    /* @ngInject */
    function AccionAdministradoInformeController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InstalacionDocumentacionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.fechaActual = new Date();
        vm.file = null;
        vm.flagInformeInstalacionAnterior = 0;
        vm.showFrecuencia = true;
        vm.swBtnAgregarM = false;
        // vm.urlData= API_CONFIG.url;
        vm.rutaBase = API_CONFIG.url;
        vm.flagProcesoInformeMonitoreo = 0;
        vm.active = 0;
        /* Luis */
        vm.active2 = 0;
        
        vm.siguienteManifiestoResiduos = siguienteManifiestoResiduos;
        vm.atrasManifiestoResiduos = atrasManifiestoResiduos;
        vm.guardarManifiestoResiduos = guardarManifiestoResiduos;
        vm.mostrarDatos1 = true;
        vm.mostrarDatos2 = false;
        
        /* Luis */
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.periodoInformeData = {};
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.dataInformeMonitoreo = InformeMonitoreoFactory.model();
        vm.filePlanTrabajo = null;
        vm.fileInforme = null;
        vm.fileDeclaracion = null;
        vm.fileManifestacion = null;
        vm.fileMonitoreo = null;
        vm.fileOtros = null;
        vm.fileInstrumento = null;
        vm.mostrarDeclaracionIGA = true;
        vm.lstPlan = [{
            id: 0
        }];
        vm.lstInforme = [{
            id: 0
        }];
        vm.lstDeclaracion = [{
            id: 0
        }];
        vm.lstManifestacion = [{
            id: 0
        }];
        vm.lstOtros = [{
            id: 0
        }];
        vm.lstInstrumento = [{
            id: 0
        }];
        vm.lstInforme = [{
            id: 0
        }];
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.prmPlan = InstalacionDocumentacionFactory.model(1);
        vm.prmInforme = InstalacionDocumentacionFactory.model(2);
        vm.prmDeclaracion = InstalacionDocumentacionFactory.model(3);
        vm.prmManifestacion = InstalacionDocumentacionFactory.model(4);
        vm.prmOtros = InstalacionDocumentacionFactory.model(5);
        vm.prmInstrumento = InstalacionDocumentacionFactory.model(6);
        vm.dataPresentacion = {
            periodoPresentacion: 0,
            subPeriodo: 0,
            monitoreo: MaestroFactory.model(),
        };
        /* Lista de Combos */
        vm.listaPeriodoPresentacion = [];
        vm.listaSubPeriodo = [];
        vm.listaMonitoreo = [];
        vm.listaManifestacion = [];
        vm.listaInstrumento = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.dataInformePresentacionPeriodo = {};
        vm.prmDataFiltroMonitoreoPeriodos = MonitoreoPeriodosFactory.model();
        vm.dataMonitoreoPeriodoPresentacion = MonitoreoPeriodosFactory.model();
        vm.listaInformeMonitoreoAmbiental = [];
        vm.listaPresentacionInformeMonitoreoAmbiental = [];
        vm.listaArchivosInformeMonitoreo = [];
        vm.listaFileArchivosInformeMonitoreo = [];
        vm.archivoAdjunto = {};
        vm.objArchivoInformePresentacion = ArchivoFactory.model();
        vm.prmDatainformePresentacion = {};
        /** ************************************************** */
        /** Fin Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        // vm.agregarMonitoreo = agregarMonitoreo;
        /** *** */
        /* declaracion de metodos enlazados a la vista */
        vm.guardarPlan = guardarPlan;
        vm.guardarInstrumentoGestion = guardarInstrumentoGestion;
        vm.listarDocumentacion = listarDocumentacion;
        vm.validaDocumento = validaDocumento;
        vm.validaDocumentoInforme = validaDocumentoInforme;
        vm.validaDocumentoDeclaracion = validaDocumentoDeclaracion;
        vm.validaDocumentoManifestacion = validaDocumentoManifestacion;
        vm.validaDocumentoMonitoreo = validaDocumentoMonitoreo;
        vm.validaDocumentoOtros = validaDocumentoOtros;
        vm.validaDocumentoInstrumento = validaDocumentoInstrumento;
        vm.guardarInformeAmbiental = guardarInformeAmbiental;
        vm.descarga = descarga;
        vm.eliminarDocumento = eliminarDocumento;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        vm.guardarInformeMonitoreoAmbiental = guardarInformeMonitoreoAmbiental;
        vm.listarInformesMonitoreoPorInstalacion = listarInformesMonitoreoPorInstalacion;
        vm.listarPresentacionInformeMonitoreo = listarPresentacionInformeMonitoreo;
        vm.guardarPresentacionInformeMonitoreoAmbiental = guardarPresentacionInformeMonitoreoAmbiental;
        vm.validaDocumentoInformeMonitoreoAmbiental = validaDocumentoInformeMonitoreoAmbiental;
        vm.obtenerDatosDelPeriodoInforme = obtenerDatosDelPeriodoInforme;
        vm.agregarArchivosMonitoreoInformePresentacion = agregarArchivosMonitoreoInformePresentacion;
        vm.obtenerDatosInformeMonitoreo = obtenerDatosInformeMonitoreo;
        vm.atrasInformMonitoreoAmbiental = atrasInformMonitoreoAmbiental;
        vm.eliminarArchivoInformeMonitoreoAmbiental = eliminarArchivoInformeMonitoreoAmbiental;
        vm.metodoEliminarArchivoInformeMonitoreoAmbiental = metodoEliminarArchivoInformeMonitoreoAmbiental;
        vm.confirmarMetodoEliminarArchivoInformeMonitoreoAmbiental = confirmarMetodoEliminarArchivoInformeMonitoreoAmbiental;
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        // daniel
        vm.nuevoIGA = nuevoIGA;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.mostrarCampos = mostrarCampos;
        vm.mostrarPresentacion= false;
        vm.siguienteProgramMonitoreoAmbiental = siguienteProgramMonitoreoAmbiental;
        vm.atrasProgramMonitoreoAmbiental = atrasProgramMonitoreoAmbiental;
        vm.nuevaEtapa = nuevaEtapa;
        vm.nuevoComponenteAmbiental = nuevoComponenteAmbiental;
        vm.nuevoPuntoMonitoreo = nuevoPuntoMonitoreo;
        vm.nuevoParametroAmbiental = nuevoParametroAmbiental;
        vm.grabarProgramaMonitoreo = grabarProgramaMonitoreo;
        vm.mostrarProgramaMonitoreo = false;
        
        /* Luis */
        vm.mostrarInformeMonitoreo = false;
        vm.finalizar = finalizar;
        vm.siguienteInformeAmbiental = siguienteInformeAmbiental;
        vm.atrasInformeAmbiental = atrasInformeAmbiental;
        /* Luis */
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.administrado');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaPeriodoPresentacion = [];
            var codigosCombos = ['TipoPeriodo', 'TipoMonitoreo'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoPeriodo':
                                for (var i in datosCombo) {
                                    vm.listaPeriodoPresentacion.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoMonitoreo':
                                vm.listaMonitoreo = [];
                                var maestro = MaestroFactory.model();
                                maestro.descripcion = "Seleccione";
                                vm.listaMonitoreo.push(maestro);
                                for (var i in datosCombo) {
                                    vm.listaMonitoreo.push(datosCombo[i]);
                                }
                                vm.dataPresentacion.monitoreo = maestro;
                                // vm.listaMonitoreo = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */
        function guardarPlan(tipo) {
            var filtro;
            var fileGeneral = null;
            switch (tipo) {
                case 1:
                    filtro = angular.copy(vm.prmPlan);
                    fileGeneral = vm.filePlanTrabajo;
                    break;
                case 2:
                    filtro = angular.copy(vm.prmInforme);
                    fileGeneral = vm.fileInforme;
                    break;
                case 3:
                    filtro = angular.copy(vm.prmDeclaracion);
                    fileGeneral = vm.fileDeclaracion;
                    break;
                case 4:
                    if (vm.prmManifestacion.mes == null && vm.prmManifestacion.mes <= 0) {
                        toastr.info("Seleccione Mes");
                        return;
                    }
                    filtro = angular.copy(vm.prmManifestacion);
                    fileGeneral = vm.fileManifestacion;
                    break;
                case 5:
                    filtro = angular.copy(vm.prmOtros);
                    fileGeneral = vm.fileOtros;
                    break;
                case 6:
                    filtro = angular.copy(vm.prmInstrumento);
                    fileGeneral = vm.fileInstrumento;
                    break;
                default:
                    break;
            }
            if (filtro.archivo == null || filtro.archivo.idArchivo == 0) {
                if (fileGeneral == null) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                InstalacionDocumentacionFactory.registrarArchivo(fileGeneral, filtro).then(function(response) {
                    if (response.valido) {
                        listarDocumentacion(tipo, true, response.mensaje);
                        // toastr.success(response.mensaje);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
            } else {
                InstalacionDocumentacionFactory.actualizar(filtro).then(function(response) {
                    if (response.valido) {
                        // listarDocumentacion(tipo,true,response.mensaje);
                        toastr.success(response.mensaje);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
            }
        }

        function eliminarDocumento(item, tipo) {
            InstalacionDocumentacionFactory.eliminar(item).then(function(response) {
                if (response.valido) {
                    listarDocumentacion(tipo, true, response.mensaje);
                    // toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function listarDocumentacion(tipo, swMsj, msj) {
            var filtro;
            switch (tipo) {
                case 1:
                    filtro = angular.copy(vm.prmPlan);
                    filtro.idDocumentacion = 0;
                    break;
                case 2:
                    filtro = angular.copy(vm.prmInforme);
                    filtro.idDocumentacion = 0;
                    break;
                case 3:
                    filtro = angular.copy(vm.prmDeclaracion);
                    filtro.idDocumentacion = 0;
                    break;
                case 4:
                    filtro = angular.copy(vm.prmManifestacion);
                    filtro.idDocumentacion = 0;
                    break;
                case 5:
                    filtro = angular.copy(vm.prmOtros);
                    filtro.idDocumentacion = 0;
                    break;
                case 6:
                    filtro = angular.copy(vm.prmInstrumento);
                    filtro.idDocumentacion = 0;
                    break;
                default:
                    break;
            }
            InstalacionDocumentacionFactory.listar(filtro).then(function(response) {
                if (response.valido) {
                    if (swMsj) {
                        toastr.success(msj);
                    }
                    if (response.data != null && response.data.length > 0) {
                        switch (tipo) {
                            case 1:
                                vm.prmPlan = angular.copy(response.data[0]);
                                vm.prmPlan.anio = angular.copy(response.data[0].anio.toString());
                                vm.lstPlan.splice(0, 1);
                                vm.lstPlan = [{
                                    id: 0
                                }];
                                vm.filePlanTrabajo = null;
                                break;
                            case 2:
                                vm.prmInforme = angular.copy(response.data[0]);
                                vm.prmInforme.anio = angular.copy(response.data[0].anio.toString());
                                vm.lstInforme.splice(0, 1);
                                vm.lstInforme = [{
                                    id: 0
                                }];
                                vm.fileInforme = null;
                                break;
                            case 3:
                                vm.prmDeclaracion = angular.copy(response.data[0]);
                                vm.prmDeclaracion.anio = angular.copy(response.data[0].anio.toString());
                                vm.lstDeclaracion.splice(0, 1);
                                vm.lstDeclaracion = [{
                                    id: 0
                                }];
                                vm.fileDeclaracion = null;
                                break;
                            case 4:
                                vm.listaManifestacion = angular.copy(response.data);
                                if (vm.listaManifestacion != null && vm.listaManifestacion.length > 0) {
                                    for (var i = 0; i < vm.listaManifestacion.length; i++) {
                                        vm.listaManifestacion[i].anio = angular.copy(vm.listaManifestacion[i].anio.toString());
                                    }
                                }
                                vm.lstManifestacion.splice(0, 1);
                                vm.lstManifestacion = [{
                                    id: 0
                                }];
                                vm.fileManifestacion = null;
                                vm.prmManifestacion = InstalacionDocumentacionFactory.model(4);
                                vm.prmManifestacion.anio = angular.copy(filtro.anio);
                                vm.prmManifestacion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 5:
                                vm.listaOtros = angular.copy(response.data);
                                vm.lstOtros.splice(0, 1);
                                vm.lstOtros = [{
                                    id: 0
                                }];
                                vm.fileOtros = null;
                                vm.prmOtros = InstalacionDocumentacionFactory.model(5);
                                vm.prmOtros.anio = angular.copy(filtro.anio);
                                vm.prmOtros.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 6:
                                vm.listaInstrumento = angular.copy(response.data);
                                vm.lstInstrumento.splice(0, 1);
                                vm.lstInstrumento = [{
                                    id: 0
                                }];
                                vm.fileInstrumento = null;
                                vm.prmInstrumento = InstalacionDocumentacionFactory.model(6);
                                vm.prmInstrumento.anio = angular.copy(filtro.anio);
                                vm.prmInstrumento.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            default:
                                break;
                        }
                    } else {
                        switch (tipo) {
                            case 1:
                                vm.prmPlan = InstalacionDocumentacionFactory.model(1);
                                vm.prmPlan.anio = angular.copy(filtro.anio);
                                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 2:
                                vm.prmInforme = InstalacionDocumentacionFactory.model(2);
                                vm.prmInforme.anio = angular.copy(filtro.anio);
                                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 3:
                                vm.prmDeclaracion = InstalacionDocumentacionFactory.model(3);
                                vm.prmDeclaracion.anio = angular.copy(filtro.anio);
                                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                break;
                            case 4:
                                vm.prmManifestacion = InstalacionDocumentacionFactory.model(4);
                                vm.prmManifestacion.anio = angular.copy(filtro.anio);
                                vm.prmManifestacion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                vm.listaManifestacion = [];
                                break;
                            case 5:
                                vm.prmOtros = InstalacionDocumentacionFactory.model(5);
                                vm.prmOtros.anio = angular.copy(filtro.anio);
                                vm.prmOtros.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                vm.listaOtros = [];
                                break;
                            case 6:
                                vm.prmInstrumento = InstalacionDocumentacionFactory.model(6);
                                vm.prmInstrumento.anio = angular.copy(filtro.anio);
                                vm.prmInstrumento.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                                vm.listaInstrumento = [];
                                break;
                            default:
                                break;
                        }
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function validaDocumento(prmFileList) {
            vm.filePlanTrabajo = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstPlan.splice(0, 1);
                vm.lstPlan = [{
                    id: 0
                }];
                vm.filePlanTrabajo = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlan").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlan").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlan").value = "";
                return;
            }
            vm.filePlanTrabajo = prmFileList[0];
        }

        function validaDocumentoInforme(prmFileList) {
            vm.fileInforme = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstInforme.splice(0, 1);
                vm.lstInforme = [{
                    id: 0
                }];
                vm.fileInforme = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanInforme").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanInforme").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanInforme").value = "";
                return;
            }
            vm.fileInforme = prmFileList[0];
        }

        function validaDocumentoDeclaracion(prmFileList) {
            vm.fileDeclaracion = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstDeclaracion.splice(0, 1);
                vm.lstDeclaracion = [{
                    id: 0
                }];
                vm.fileDeclaracion = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanDeclaracion").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanDeclaracion").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanDeclaracion").value = "";
                return;
            }
            vm.fileDeclaracion = prmFileList[0];
        }

        function validaDocumentoManifestacion(prmFileList) {
            vm.fileManifestacion = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstManifestacion.splice(0, 1);
                vm.lstManifestacion = [{
                    id: 0
                }];
                vm.fileManifestacion = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanManifestacion").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanManifestacion").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanManifestacion").value = "";
                return;
            }
            vm.fileManifestacion = prmFileList[0];
        }

        function validaDocumentoOtros(prmFileList) {
            vm.fileOtros = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstOtros.splice(0, 1);
                vm.lstOtros = [{
                    id: 0
                }];
                vm.fileOtros = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanOtros").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanOtros").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanOtros").value = "";
                return;
            }
            vm.fileOtros = prmFileList[0];
        }

        function validaDocumentoMonitoreo(prmFileList) {
            vm.fileMonitoreo = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstMonitoreo.splice(0, 1);
                vm.lstMonitoreo = [{
                    id: 0
                }];
                vm.fileMonitoreo = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                // document.getElementById("fileArchivoMedio").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                // document.getElementById("fileArchivoMedio").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                // document.getElementById("fileArchivoMedio").value = "";
                return;
            }
            vm.fileMonitoreo = prmFileList[0];
        }

        function validaDocumentoInstrumento(prmFileList) {
            vm.fileInstrumento = null;
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            if (prmFileList.length > 1) {
                toastr.warning('Debe seleccionar un solo archivo');
                vm.lstInstrumento.splice(0, 1);
                vm.lstInstrumento = [{
                    id: 0
                }];
                vm.fileInstrumento = null;
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoPlanInstrumento").value = "";
                /*
				 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
				 * 1);
				 */
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoPlanInstrumento").value = "";
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoPlanInstrumento").value = "";
                return;
            }
            vm.fileInstrumento = prmFileList[0];
        }

        function buscarInstrumentoGestion() {
            InstrumentoGestionFactory.listar(vm.prmInstrumentoGestion).then(function(response) {
                if (response.valido) {
                    vm.lstAnio = angular.copy(response.data.lstAnio);
                    if (response.data.data != null && response.data.data.length > 0) {
                        vm.prmInstrumentoGestion = angular.copy(response.data.data[0]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function guardarInstrumentoGestion() {
            InstrumentoGestionFactory.registrar(vm.prmInstrumentoGestion).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function descarga(archivo) {
            document.location = archivo;
        }

        function buscarMonitoreo(lista, codigo) {
            for (var i = 0; i < lista.length; i++) {
                if (lista[i].tipoMonitoreo == codigo) {
                    return i;
                }
            }
            return -1;
        }

        function obtenerMes() {
            var prmFiltro = MaestroFactory.model();
            prmFiltro.codigoMaestro = 'PeriodoInforme';
            prmFiltro.codigoRegistroPadre = 1;
            MaestroFactory.buscarRegistroHijo(angular.copy(prmFiltro)).then(function(response) {
                if (response.valido && response.data != null && response.data.length > 0) {
                    vm.listaMes = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function nombreMes(codigo) {
            for (var i = 0; i < vm.listaMes.length; i++) {
                if (vm.listaMes[i].codigoRegistro == codigo) {
                    return vm.listaMes[i].descripcion;
                }
            }
            return "";
        }

        function convertDateToString(prmdate) {
            if (!angular.isUndefined(prmdate) && prmdate != null && prmdate != "") {
                try {
                    var strDate = $filter('date')(prmdate, "dd/MM/yyyy");
                    return strDate;
                } catch (e) {
                    return "";
                }
            }
        }

        function convertStringToDate(strDate) {
            if (!angular.isUndefined(strDate) && strDate != null && strDate != "") {
                try {
                    var dateArray = strDate.split("/");
                    var date = new Date(dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0])
                    return date;
                } catch (e) {
                    $log.log("convertStringToDate: ", e);
                    return null;
                }
            }
        }

        function buscarDataListaMaestro(lstMaestro, codigoRegistro) {
            var data = null;
            for (var x in lstMaestro) {
                if (lstMaestro[x].codigoRegistro == codigoRegistro) {
                    data = lstMaestro[x];
                }
            }
            return data;
        }
        /** ***************************************************************************************************** */
        /** Informe monitoreo ambiental * */
        /** ***************************************************************************************************** */
        function guardarInformeMonitoreoAmbiental() {
            vm.dataInformeMonitoreo.instalacion.idInstalacion = vm.prmInstalacion.idInstalacion;
            if (vm.dataInformeMonitoreo.tipoMonitoreo.codigoRegistro == 4 && (vm.dataInformeMonitoreo.descripcion == null || vm.dataInformeMonitoreo.descripcion.length == 0)) {
                toastr.warning('Debe ingresar una descripción');
                return;
            }
            if (vm.dataInformeMonitoreo.tipoMonitoreo.codigoRegistro != 4) {
                vm.dataInformeMonitoreo.descripcion = vm.dataInformeMonitoreo.tipoMonitoreo.descripcion;
            }
            InformeMonitoreoFactory.registrar(angular.copy(vm.dataInformeMonitoreo)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarInformesMonitoreoPorInstalacion();
                } else {
                    toastr.warning(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ******************************************************************************************************* */
        /** * */
        /** ******************************************************************************************************* */
        function listarInformesMonitoreoPorInstalacion() {
            var data = InformeMonitoreoFactory.model();
            data.instalacion.idInstalacion = vm.prmInstalacion.idInstalacion;
            InformeMonitoreoFactory.listar(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.listaInformeMonitoreoAmbiental = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function obtenerDatosInformeMonitoreo(prmData) {
            vm.dataInformeMonitoreo = prmData;
            vm.prmDataFiltroMonitoreoPeriodos.informeMonitoreo.idInformeMonitoreo = vm.dataInformeMonitoreo.idInformeMonitoreo;
            listarPresentacionInformeMonitoreo();
        }

        function listarPresentacionInformeMonitoreo() {
            var data = {
                idInformeMonitoreo: vm.prmDataFiltroMonitoreoPeriodos.informeMonitoreo.idInformeMonitoreo,
                nombreAnioPreInf: vm.prmDataFiltroMonitoreoPeriodos.anio,
            };
            MonitoreoPeriodosFactory.listar(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.flagProcesoInformeMonitoreo = 1;
                    vm.listaPresentacionInformeMonitoreoAmbiental = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        /*
		 * function obtenerDatosPresentacionMonitoreo(data){
		 * 
		 * vm.dataInformePresentacionPeriodo = angular.copy(data); }
		 */
        function validaDocumentoInformeMonitoreoAmbiental(prmFileList) {
            var lstExtens = vm.extension.split(",");
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            /* $rootScope.archivoMedio=(prmFileList); */
            for (var i = 0; i < prmFileList.length; i++) {
                var archivo = prmFileList[i];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    /*
					 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
					 * 1);
					 */
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('No es el tipo de archivo seleccionado.');
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    return;
                }
            }
            vm.archivoAdjunto = prmFileList[0];
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function agregarArchivosMonitoreoInformePresentacion() {
            var r = 0;
            for (var x in vm.listaArchivosInformeMonitoreo) {
                if (vm.listaArchivosInformeMonitoreo[x].nombreArchivo == vm.archivoAdjunto.name) {
                    r = 1;
                    document.getElementById("fileDocumentoPresentacion").value = "";
                    toastr.warning('No puede subir archivos duplicados');
                    return;
                }
            }
            if (document.getElementById("fileDocumentoPresentacion").value == "") {
                toastr.warning('Debe seleccionar un archivo');
                vm.archivoAdjunto.splice(vm.archivoAdjunto.length - 1, 1);
                return;
            }
            if (r == 0) {
                vm.objArchivoInformePresentacion.nombreArchivo = angular.copy(vm.archivoAdjunto.name);
                vm.listaArchivosInformeMonitoreo.push(angular.copy(vm.objArchivoInformePresentacion));
                vm.listaFileArchivosInformeMonitoreo.push(vm.archivoAdjunto);
                document.getElementById("fileDocumentoPresentacion").value = "";
            }
            // vm.listaArchivosInformeMonitoreo.push(vm.archivoAdjunto);
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function atrasInformMonitoreoAmbiental(numero) {
            vm.flagProcesoInformeMonitoreo = numero;
            if (vm.flagProcesoInformeMonitoreo == 0) {
                vm.dataInformeMonitoreo = InformeMonitoreoFactory.model();
                vm.prmDataFiltroMonitoreoPeriodos = MonitoreoPeriodosFactory.model();
                listarInformesMonitoreoPorInstalacion();
            }
            if (vm.flagProcesoInformeMonitoreo == 1) {
                vm.dataInformePresentacionPeriodo = {};
                vm.dataMonitoreoPeriodoPresentacion = MonitoreoPeriodosFactory.model();
                vm.listaInformeMonitoreoAmbiental = [];
                vm.listaArchivosInformeMonitoreo = [];
                vm.archivoAdjunto = {};
                vm.prmDatainformePresentacion = {};
                vm.periodoInformeData = {};
                listarPresentacionInformeMonitoreo();
            }
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function obtenerDatosDelPeriodoInforme(data) {
            vm.listaFileArchivosInformeMonitoreo = [];
            vm.periodoInformeData = angular.copy(data);
            var prmData = {
                idInformeMonitoreo: data.idInformeMonitoreo,
                nombreAnioPreInf: data.nombreAnioPreInf,
                periodoPresentacionInforme: data.periodoPresentacionInforme
            }
            MonitoreoPeriodosFactory.validarInformePresentacionPeriodo(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    debugger;
                    var dataobj = response.data;
                    if (dataobj != null && dataobj.idMonitoreoPeriodos != null && dataobj.idMonitoreoPeriodos != 0) {
                        data = angular.copy(dataobj);
                    }
                    vm.prmDatainformePresentacion = data;
                    vm.flagProcesoInformeMonitoreo = 2;
                    vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos = data.idMonitoreoPeriodos
                    vm.dataMonitoreoPeriodoPresentacion.anio = data.nombreAnioPreInf;
                    vm.dataMonitoreoPeriodoPresentacion.tipoPeriodo.codigoRegistro = data.periodoPresentacionInforme;
                    vm.dataMonitoreoPeriodoPresentacion.tipoPeriodo.descripcion = data.nombrePeriodoPreInfor;
                    vm.dataMonitoreoPeriodoPresentacion.informeMonitoreo = vm.dataInformeMonitoreo;
                    vm.dataMonitoreoPeriodoPresentacion.informeMonitoreo.instalacion.idInstalacion = vm.prmInstalacion.idInstalacion;
                    vm.dataMonitoreoPeriodoPresentacion.descripcion = data.descripcion;
                    if (vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos != null && vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos != 0) {
                        listarArchivosInformeMonitoreoAmbiental(data);
                    }
                } else {
                    toastr.info(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function guardarPresentacionInformeMonitoreoAmbiental() {
            if (vm.dataMonitoreoPeriodoPresentacion.descripcion == null || (vm.dataMonitoreoPeriodoPresentacion.descripcion.length == 0)) {
                toastr.warning('Debe ingresar una descripción');
                return;
            }
            if (vm.listaArchivosInformeMonitoreo.length == 0) {
                toastr.warning('No ha cargado archivos');
                return;
            }
            /*
			 * var prmData = MonitoreoPeriodosFactory.model();
			 * prmData.informeMonitoreo = vm.dataInformeMonitoreo;
			 * prmData.informeMonitoreo.instalacion.idInstalacion=vm.prmInstalacion.idInstalacion;
			 * prmData.anio =data.nombreAnioPreInf;
			 * prmData.tipoPeriodo.codigoRegistro =
			 * data.periodoPresentacionInforme;
			 */
            MonitoreoPeriodosFactory.registrarArchivoMonitoreo(vm.listaFileArchivosInformeMonitoreo, angular.copy(vm.dataMonitoreoPeriodoPresentacion)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos = response.data;
                    vm.periodoInformeData.idMonitoreoPeriodos = vm.dataMonitoreoPeriodoPresentacion.idMonitoreoPeriodos;
                    vm.listaFileArchivosInformeMonitoreo = [];
                    obtenerDatosDelPeriodoInforme(vm.periodoInformeData);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function listarArchivosInformeMonitoreoAmbiental(data) {
            var prmDataArchivo = {
                codigoClasificacionArchivo: 5,
                idTablaArchivo: data.idMonitoreoPeriodos,
            };
            ArchivoFactory.listarArchivoidTabla(angular.copy(prmDataArchivo)).then(function(response) {
                if (response.valido) {
                    vm.listaArchivosInformeMonitoreo = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ****************************************************************************************************** */
        /** * */
        /** ****************************************************************************************************** */
        function confirmarMetodoEliminarArchivoInformeMonitoreoAmbiental(item, index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el archivo: ' + item.nombreArchivo + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                metodoEliminarArchivoInformeMonitoreoAmbiental(index);
            });
        }

        function metodoEliminarArchivoInformeMonitoreoAmbiental(data, index) {
            /* if(data.idArchivo==0){ */
            vm.listaFileArchivosInformeMonitoreo.splice(index, 1);
            vm.listaArchivosInformeMonitoreo.splice(index, 1);
            /*
			 * }else{ eliminarArchivoInformeMonitoreoAmbiental(data); }
			 */
        }

        function eliminarArchivoInformeMonitoreoAmbiental(data) {
            ArchivoFactory.eliminarArchivo(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmPlan.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInforme.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmDeclaracion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmManifestacion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmOtros.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumento.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                // console.log("Instalacion: ",vm.prmInstalacion);
                obtenerMes();
                buscarInstrumentoGestion();
                listarInformesMonitoreoPorInstalacion();
                listarDocumentacion(1, false, "");
                listarDocumentacion(2, false, "");
                listarDocumentacion(3, false, "");
                listarDocumentacion(4, false, "");
                listarDocumentacion(5, false, "");
                listarDocumentacion(6, false, "");
                console.log("data ---> : " + getFileExtension("daraassaas.docx"));
            }
            cargarCombos();
        }
        
        // Nuevo IGA
        function nuevoIGA() {
        	console.log("abrir nuevo iga");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/instrumento-gestion-ambiental-dialog.html',
                controller: 'InstrumentoGestionAmbientalController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Etapa
        function nuevaEtapa() {
        	console.log("abrir nuevo etapa");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/etapa-proyecto-dialog.html',
                controller: 'EtapaProyectoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Componente
        function nuevoComponenteAmbiental() {
        	console.log("abrir nuevo componente");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-dialog.html',
                controller: 'ComponenteAmbientalDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        // Nuevo Punto Monitoreo
        function nuevoPuntoMonitoreo() {
        	console.log("abrir nuevo punto monitoreo");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/punto-monitoreo-dialog.html',
                controller: 'PuntoMonitoreoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        // Nuevo Parametro
        function nuevoParametroAmbiental() {
        	console.log("abrir nuevo punt");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/parametro-ambiental-dialog.html',
                controller: 'ParametroAmbientalDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function grabarProgramaMonitoreo() {
        	
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Mensaje de Confirmación',
                    Mensaje: 'Se ha registrado su compromiso ambiental safactoriamente'
                },
                width: '380px'
            })
        }
        
        
        function guardarInformeAmbiental() {
        	
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: ' ¿Declara bajo juramento que la informacion anotada en la presente declaracion es verdadera, por lo que cualquier falsedad en los datos consignados dara lugar a que se le imponga las sanciones contempladas por ley?'
                },
                width: '700px'
            })
        }
        
       
        
        // funcion de pasar a un siguiente tab
        function mostrarCampos(opc){
        	console.log(opc);
        	vm.mostrarProgramaMonitoreo = false;
        	vm.mostrarInformeMonitoreo = false;
        	vm.mostrarPresentacion = false;
        	if(opc == 2){
        		vm.mostrarPresentacion = true;
        		vm.mostrarProgramaMonitoreo = true;
        		vm.mostrarInformeMonitoreo = true;
        	}
        	if(opc == 3){
        		vm.mostrarPresentacion = true;
        		vm.mostrarProgramaMonitoreo = true;
        		vm.mostrarInformeMonitoreo = true;
        		vm.mostrarDeclaracionIGA = false;
        	}
        	
        	if (opc == 0){
        		vm.mostrarProgramaMonitoreo = true;
        	}
        	if (opc == 1){
        		vm.mostrarInformeMonitoreo = true;
        	}
        	
        	
        	
        }
        
        function siguienteProgramMonitoreoAmbiental(tab){
        	
        	vm.active = tab + 1;
        	console.log(vm.active);
        }
        
        function atrasProgramMonitoreoAmbiental(tab){
        	
        	vm.active = tab - 1;
        	console.log(vm.active);
        }
        
        /* Luis */
        function siguienteInformeAmbiental(tab){
            
            vm.active2 = tab + 1;
        }
        
        function atrasInformeAmbiental(tab){
            
            vm.active2 = tab - 1;
        }
        /* Luis */
        
        function siguienteManifiestoResiduos (){
        	vm.mostrarDatos1 = false;
            vm.mostrarDatos2 = true;
        }
        
        function atrasManifiestoResiduos (){
        	vm.mostrarDatos1 = true;
            vm.mostrarDatos2 = false;
        }
        
        function guardarManifiestoResiduos (){
        	ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: '¿Declara bajo juramento que la información anotada en la presente declaración es verdadera, por lo que cualquier falsedad en los datos consignados dará lugar a que se le imponga las sanciones contempladas por ley?'
                },
                width: '700px'
            })
        }
       
     
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad', []);
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad').controller('UsuariosRegistroController', UsuariosRegistroController);
    /* @ngInject */
    function UsuariosRegistroController(toastr, ngDialog, UsuarioFactory, PersonaFactory, EntidadFactory, PerfilFactory) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataUsuario = UsuarioFactory.modelUsuario();
        vm.dataPersona = PersonaFactory.model();
        vm.dataEntidad = EntidadFactory.model();
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaPerfil = [];
        /*declaracion de metodos */
        vm.guardar = guardar;
        vm.buscarPersonaXNumeroDocumento = buscarPersonaXNumeroDocumento;
        vm.buscarEntidadXNumeroDocumento = buscarEntidadXNumeroDocumento;
        /*implementacion de metodos*/
        function listarPerfiles() {
            PerfilFactory.listar().then(function(response) {
                if (response.valido) {
                    vm.listaPerfil = response.data;
                    console.log("vm.listaPerfiles" + vm.listaPerfil);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al registrar Perfil.')
            });
        }

        function guardar() {
            if (vm.dataUsuario.idUsuario == 0) {
                registrar();
            } else {
                actualizar();
            }
        }

        function buscarPersonaXNumeroDocumento() {
            console.log('sdadsasad');
            PersonaFactory.buscarXNumeroDocumento(angular.copy(vm.dataPersona)).then(function(response) {
                if (response.valido) {
                    if (response.data.idPersona > 0) {
                        vm.dataPersona = response.data;
                        vm.dataUsuario.idPersona = vm.dataPersona.idPersona;
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function buscarEntidadXNumeroDocumento() {
            EntidadFactory.buscarXEntidadNumeroDocumento(vm.dataEntidad).then(function(response) {
                if (response.valido) {
                    vm.dataEntidad = response.data;
                    if (response.data.idEntidad > 0) {
                        vm.dataEntidad = response.data;
                        vm.dataUsuario.idEntidad = vm.dataEntidad.idEntidad;
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function registrar() {
            /* vm.dataUsuario.idTipoPerfil = vm.dataPerfil.idPerfil;*/
            UsuarioFactory.registrar(vm.dataUsuario).then(function(response) {
                if (response.valido) {
                    vm.dataUsuario.idUsuario = response.data;
                    toastr.success('Usuario registrado con codigo ' + vm.dataUsuario.idUsuario);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al registrar usuario.')
            });
        }

        function actualizar() {
            UsuarioFactory.actualizar(vm.dataUsuario).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al actualizar el usuario')
            });
        }
        /*fin de implementacion de metodos*/
        function init() {
            listarPerfiles();
            vm.listaTipoPersona.push({
                codigoRegistro: 1,
                descripcion: 'Natural'
            });
            vm.listaTipoPersona.push({
                codigoRegistro: 2,
                descripcion: 'Jurídica'
            });
            vm.listaTipoDocumento.push({
                codigoRegistro: 1,
                descripcion: 'RUC'
            });
            vm.listaTipoDocumento.push({
                codigoRegistro: 2,
                descripcion: 'DNI'
            });
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad').controller('UsuarioListadoController', UsuarioListadoController);
    /* @ngInject */
    function UsuarioListadoController(toastr, $scope, ngDialog, $controller, $state) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataUsuario = {
            tipoPersona: 0,
            tipoDocumento: 0
        };
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaUsuarios = [{
            idUsuario: 1,
            nombre: 'lucero',
            perfil: 'Sinada',
            situacion: 'Activo'
        }, {
            idUsuario: 1,
            nombre: 'Alcantara',
            perfil: 'EFA',
            situacion: 'Activo'
        }, {
            idUsuario: 1,
            nombre: 'Bryan',
            perfil: 'Web',
            situacion: 'Activo'
        }, ];
        /*declaracion de metodos */
        vm.irRegistroUsuario = irRegistroUsuario;
        /*implementacion de metodos*/
        /*fin de implementacion de metodos*/
        function irRegistroUsuario() {
            $state.go('spapp.home.seguridad.usuarios');
        }

        function init() {
            vm.listaTipoPersona.push({
                codigoRegistro: 1,
                descripcion: 'Natural'
            });
            vm.listaTipoPersona.push({
                codigoRegistro: 2,
                descripcion: 'Jurídica'
            });
            vm.listaTipoDocumento.push({
                codigoRegistro: 1,
                descripcion: 'RUC'
            });
            vm.listaTipoDocumento.push({
                codigoRegistro: 2,
                descripcion: 'DNI'
            });
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad').controller('CambioClaveController', CambioClaveController);
    /* @ngInject */
    function CambioClaveController(toastr, ngDialog, $controller, $state) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataUsuario = {
            tipoPersona: 0,
            tipoDocumento: 0
        };
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaUsuarios = [{
            idUsuario: 1,
            nombre: 'lucero',
            perfil: 'Sinada',
            situacion: 'Activo'
        }, {
            idUsuario: 1,
            nombre: 'Alcantara',
            perfil: 'EFA',
            situacion: 'Activo'
        }, {
            idUsuario: 1,
            nombre: 'Bryan',
            perfil: 'Web',
            situacion: 'Activo'
        }, ];
        /*declaracion de metodos */
        vm.irRegistroUsuario = irRegistroUsuario;
        /*implementacion de metodos*/
        /*fin de implementacion de metodos*/
        function irRegistroUsuario() {
            $state.go('spapp.home.seguridad.usuarios');
        }

        function init() {
            vm.listaTipoPersona.push({
                codigoRegistro: 1,
                descripcion: 'Natural'
            });
            vm.listaTipoPersona.push({
                codigoRegistro: 2,
                descripcion: 'Jurídica'
            });
            vm.listaTipoDocumento.push({
                codigoRegistro: 1,
                descripcion: 'RUC'
            });
            vm.listaTipoDocumento.push({
                codigoRegistro: 2,
                descripcion: 'DNI'
            });
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInstrumentoGestionController', CargaInfoInstrumentoGestionController);
    /* @ngInject */
    function CargaInfoInstrumentoGestionController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        vm.nuevoIGA = nuevoIGA;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.irDeclaracion = irDeclaracion;
        vm.idInstrumentoGestion;
        vm.copiarIGA = copiarIGA;
        vm.seleccionarcopiarIGA = seleccionarcopiarIGA;
        
        function irDeclaracion(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-declaracion');
        }
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.prmInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.idAdministrado =  angular.copy(vm.prmInstalacion.idAdministrado);
                vm.prmInstrumentoGestion.estado = "T";
                buscarInstrumentoGestion();
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        // Nuevo IGA
        function nuevoIGA(datoParametro) {
        	
        	if(datoParametro != null){
        		vm.idInstrumentoGestion = datoParametro.idInstrumentoGestion;
        		$rootScope.prmdatoInstrumento = angular.copy(datoParametro);
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '1100px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	else{
        		$rootScope.prmdatoInstrumento = angular.copy(InstrumentoGestionFactory.model());
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '1100px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	
        }
        
        function confirmarEliminacion(prmInstrumentoGestion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstrumentoGestion.resolucion  + ' ' + prmInstrumentoGestion.auxTipoIgaNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstrumentoGestion,true);
            });
        }
        
        function eliminar(prmInstrumentoGestion,validar){
             	prmInstrumentoGestion.isvalidar = validar;
        	 	InstrumentoGestionFactory.eliminar(angular.copy(prmInstrumentoGestion)).then(function(response) {
                     if (response.valido) {
                         toastr.success(response.mensaje);
                         buscarInstrumentoGestion();
                     } else {
                    	 validacionModal(prmInstrumentoGestion, response.mensaje);
                     }
                 }).catch(function(error) {
                     toastr.error('Ocurrió un error al eliminar la parametro');
                 });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        function validacionModal(prmInstrumentoGestion, mensaje) {

        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar el registro?',
             		Mensajeadicional: mensaje.replace( new RegExp('/n','g') ,',')
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminar(prmInstrumentoGestion,false);
             });
        }
        
        function seleccionarcopiarIGA(item){
        	$rootScope.lstIntrumentoGestionModBase = [];
        	$rootScope.selIgamultiple = false;
        	
	       		 ngDialog.open({
	                    template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-selector.html',
	                    controller: 'CargaInfoInstrumentoGestionSelectorController',
	                    controllerAs: 'vm',
	                    width: '1100px'
	                }).closePromise.then(function(dataDialog) {
	               	    var array  = $rootScope.lstIntrumentoGestionMod;
	               		copiarIGA(item,array[0]);
	                });
        }
        
        function copiarIGA(igaBase, igaDestino){
        	igaBase.idInstrumentoGestionDestino = igaDestino.id_InstrumentoGestionMod;
    	 	InstrumentoGestionFactory.copiarProgramaMonitoreo(angular.copy(igaBase)).then(function(response) {
                 if (response.valido) {
                     toastr.success(response.mensaje);
                     buscarInstrumentoGestion();
                 } 
             }).catch(function(error) {
                 toastr.error('Ocurrió un error al copiar el programa de monitoreo');
             });
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInstrumentoGestionSelectorController', CargaInfoInstrumentoGestionSelectorController);
    /* @ngInject */
    function CargaInfoInstrumentoGestionSelectorController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory,  InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        vm.lstIntrumentoGestionMod = [];
        vm.lstIntrumentoGestionModBase = [];
        vm.dataInstrumentoGestionMod = InstrumentoGestionFactory.modificacion_model();
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        vm.guardar = guardar;
        
        vm.mostrarComentarioModificacion = mostrarComentarioModificacion;
        vm.mostrarComentario = false;
        vm.selIgamultiple = false;
        vm.seleccionar = seleccionar;
        
        function mostrarComentarioModificacion(){
        	if(!mostrarComentario){
        		vm.comentarioMod = "";
        	}
        }
        
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.prmInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                    // filtramos para que muestre solo los datos que no han sido
					// seleccionados
                    console.log('$rootScope.lstIntrumentoGestionModBase ' + $rootScope.lstIntrumentoGestionModBase);
                    if (angular.isDefined($rootScope.lstIntrumentoGestionModBase)) {
                    	vm.lstIntrumentoGestionModBase = $rootScope.lstIntrumentoGestionModBase ;
                    	for (var y = 0; y < vm.lstInstrumentosGestion.length; y++) { 
                    		for(var x in vm.lstIntrumentoGestionModBase){
                        		if(vm.lstIntrumentoGestionModBase[x].id_InstrumentoGestionMod == vm.lstInstrumentosGestion[y].idInstrumentoGestion){
                        			// ya existe
                        			vm.lstInstrumentosGestion.splice(y,1);
                        			y--;
                        			break;
                        		}
                        	}
                    	}
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        
        function guardar(){
        	vm.lstIntrumentoGestionMod = [];
        	// relacion: instrumento - modificacion
           	for (var x in vm.lstInstrumentosGestion) {
                if (vm.lstInstrumentosGestion[x].blSeleccionado){
                	vm.dataInstrumentoGestionMod.idAdministrado = vm.lstInstrumentosGestion[x].idAdministrado ;
                	vm.dataInstrumentoGestionMod.id_InstrumentoGestionMod = vm.lstInstrumentosGestion[x].idInstrumentoGestion ;
                	vm.dataInstrumentoGestionMod.resolucion = vm.lstInstrumentosGestion[x].resolucion ;
                	vm.dataInstrumentoGestionMod.fechaAprobacion = vm.lstInstrumentosGestion[x].fechaAprobacion ;
                	vm.dataInstrumentoGestionMod.fecha = vm.lstInstrumentosGestion[x].fecha ;
                	vm.dataInstrumentoGestionMod.auxTipoIgaNombre = vm.lstInstrumentosGestion[x].auxTipoIgaNombre ;
                	vm.dataInstrumentoGestionMod.archivoNombre = vm.lstInstrumentosGestion[x].archivoNombre ;
                	vm.dataInstrumentoGestionMod.lstIntrumentoGestionDoc =  vm.lstInstrumentosGestion[x].lstIntrumentoGestionDoc ;
                	vm.lstIntrumentoGestionMod.push(angular.copy(vm.dataInstrumentoGestionMod));
                }
            }
           	
           	// guardamos en session para pasar a la ventana anterior
           	$rootScope.lstIntrumentoGestionMod = vm.lstIntrumentoGestionMod;
           	$rootScope.comentarioMod = vm.comentarioMod;
           	$scope.closeThisDialog();
           	
        }
        
        function seleccionar(item){
        	vm.lstIntrumentoGestionMod = [];
        	// relacion: instrumento - modificacion
           	for (var x in vm.lstInstrumentosGestion) {
                if (vm.lstInstrumentosGestion[x].idInstrumentoGestion==item.idInstrumentoGestion){
                	vm.dataInstrumentoGestionMod.idAdministrado = vm.lstInstrumentosGestion[x].idAdministrado ;
                	vm.dataInstrumentoGestionMod.id_InstrumentoGestionMod = vm.lstInstrumentosGestion[x].idInstrumentoGestion ;
                	vm.dataInstrumentoGestionMod.resolucion = vm.lstInstrumentosGestion[x].resolucion ;
                	vm.dataInstrumentoGestionMod.fechaAprobacion = vm.lstInstrumentosGestion[x].fechaAprobacion ;
                	vm.dataInstrumentoGestionMod.fecha = vm.lstInstrumentosGestion[x].fecha ;
                	vm.dataInstrumentoGestionMod.auxTipoIgaNombre = vm.lstInstrumentosGestion[x].auxTipoIgaNombre ;
                	vm.dataInstrumentoGestionMod.archivoNombre = vm.lstInstrumentosGestion[x].archivoNombre ;
                	vm.dataInstrumentoGestionMod.lstIntrumentoGestionDoc =  vm.lstInstrumentosGestion[x].lstIntrumentoGestionDoc ;
                	vm.lstIntrumentoGestionMod.push(angular.copy(vm.dataInstrumentoGestionMod));
                	break;
                }
            }
           	
           	// guardamos en session para pasar a la ventana anterior
           	$rootScope.lstIntrumentoGestionMod = vm.lstIntrumentoGestionMod;
           	$rootScope.comentarioMod = vm.comentarioMod;
           	$scope.closeThisDialog();
        }
        
        /* fin de implementacion de metodos */
        function init() {
        	$rootScope.lstIntrumentoGestionMod = [];
        	vm.selIgamultiple = $rootScope.selIgamultiple;
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.estado = "1";
                vm.dataInstrumentoGestionMod.id_InstrumentoGestion = angular.copy(vm.prmInstrumentoGestion.idInstrumentoGestion);
                vm.dataInstrumentoGestionMod.id_Instalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.dataInstrumentoGestionMod.idAdministrado = angular.copy(vm.prmInstalacion.idAdministrado);
                vm.dataInstrumentoGestionMod.estado =  "1";
                buscarInstrumentoGestion();
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInstrumentoGestionEdicionController', CargaInfoInstrumentoGestionEdicionController);
    /** @ngInject */
    function CargaInfoInstrumentoGestionEdicionController($rootScope, toastr, $scope, AccesoFactory, InstrumentoGestionFactory, MaestroFactory,TipoIgaFactory, ngDialog, API_CONFIG, CookiesFactory) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivosIGA = [];
        vm.urlData = API_CONFIG.url;
        vm.dataInstalacion;
        vm.prmIntrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstTipoIgas = [];
        vm.prmTipoIga = TipoIgaFactory.model();
        vm.guardar = guardar;
        vm.mostrarIGASModificacion = mostrarIGASModificacion;
        vm.eliminarIGAModificado = eliminarIGAModificado;
        vm.active = 0;
        vm.validaDocumento = validaDocumento;
        vm.refrescar;
        vm.eliminarDocumentoIga = eliminarDocumentoIga;
        vm.confirmareliminarDocumentoIga = confirmareliminarDocumentoIga;
        vm.blEditar = false;
        vm.blRevisar = false;
        vm.accesos = [];
        
        function refrescar(){
        }
        
        
        
        function eliminarIGAModificado(index){
        	vm.prmIntrumentoGestion.lstIntrumentoGestionMod.splice(index, 1);
        }
        
        
        function confirmareliminarDocumentoIga(index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarDocumentoIga(index);
            });
        }
        
        function eliminarDocumentoIga(index){
      	  if(vm.prmIntrumentoGestion.lstIntrumentoGestionDoc[index].secuencia==0){
      		 vm.prmIntrumentoGestion.lstIntrumentoGestionDoc.splice(index,1);
      	  }
      	  else{
      		InstrumentoGestionFactory.eliminarDocumento(angular.copy(vm.prmIntrumentoGestion.lstIntrumentoGestionDoc[index])).then(function(response) {
                    if (response.valido) {
                  	   toastr.success('Se eliminó el documento correctamente.');
                  	   cargarDocumentos();
                    } else {
                   	   toastr.error('Ocurrió un error al eliminar el documento');
                    }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
      	  }
        }
        
        function guardar() {
        	if (vm.prmIntrumentoGestion.idInstrumentoGestion == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	InstrumentoGestionFactory.registrar(vm.listaArchivosIGA,angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
                else{
                	 toastr.success('Error la operación. ' + response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	vm.prmIntrumentoGestion.idsession = CookiesFactory.obtenerCookie();
        	InstrumentoGestionFactory.actualizar(vm.listaArchivosIGA,angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cancelar() {
            ngDialog.close();
        }
        
        function cargarCombos(){
        	listarTipoIGA();
        }
        
        function listarTipoIGA(){
        	 TipoIgaFactory.listarActivos(angular.copy(vm.prmTipoIga)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstTipoIgas = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function mostrarIGASModificacion(){
        	 $rootScope.lstIntrumentoGestionModBase = vm.prmIntrumentoGestion.lstIntrumentoGestionMod;
        	 $rootScope.selIgamultiple = true;
        	 if(vm.prmIntrumentoGestion.blModificaIga){
        		 vm.active = 1; 
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-selector.html',
                     controller: 'CargaInfoInstrumentoGestionSelectorController',
                     controllerAs: 'vm',
                     width: '1100px'
                 }).closePromise.then(function(dataDialog) {
                	var array  = $rootScope.lstIntrumentoGestionMod;
                		cargarModificados(array);
                		if(angular.isDefined($rootScope.comentarioMod)){
                			vm.prmIntrumentoGestion.observacion =	$rootScope.comentarioMod;
                		}
                 });
        	 }
        	 else{
        		 vm.prmIntrumentoGestion.lstIntrumentoGestionMod.splice(0, vm.prmIntrumentoGestion.lstIntrumentoGestionMod.length);
        	 }
       }
        
        function cargarModificados(array){
        	if(angular.isDefined(array)){
	        	if(array.length > 0){
	        		for (var x in array) {
	        			array[x].id_InstrumentoGestion = vm.prmIntrumentoGestion.idInstrumentoGestion;
	                    vm.prmIntrumentoGestion.lstIntrumentoGestionMod.push(array[x]);
	                }
	        	}
        	}
        }
        
        function cargarDocumentos(){
        	 vm.prmIntrumentoGestion.lstIntrumentoGestionDoc = [];
        	InstrumentoGestionFactory.listarDocumentos(angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                if (response.valido) {
               	    var array = angular.copy(response.data);
	               	if(angular.isDefined(array)){
	    	        	if(array.length > 0){
	    	        		for (var x in array) {
	    	        			array[x].idInstrumentoGestion = vm.prmIntrumentoGestion.idInstrumentoGestion;
	    	                    vm.prmIntrumentoGestion.lstIntrumentoGestionDoc.push(array[x]);
	    	                }
	    	        	}
	            	}
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });	
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                vm.listaArchivosIGA.push(prmFileList[0]);
                
                var docIga = InstrumentoGestionFactory.documento_model();
                docIga.idAdministrado = vm.prmIntrumentoGestion.idAdministrado;
                docIga.idInstalacion = vm.prmIntrumentoGestion.idInstalacion;
                docIga.idInstrumentoGestion = vm.prmIntrumentoGestion.idInstrumentoGestion;
                docIga.secuencia = 0;
                docIga.nombreArchivo = prmFileList[0].name;
                vm.prmIntrumentoGestion.lstIntrumentoGestionDoc.push(docIga);
                
                document.getElementById("btnRefrescar").click();
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.prmIntrumentoGestion.idTipoInstrumento != 0 && vm.prmIntrumentoGestion.resolucion != '' && vm.prmIntrumentoGestion.resolucion != null && 
                		vm.prmIntrumentoGestion.fecha != null && vm.prmIntrumentoGestion.fecha != ''){
                	document.getElementById("btnGuardarIGA").disabled = false;
                }
                
        }
        
        /* fin de metodos */
        function init() {
        	validaOpcionSSOSisoWeb('EDITAR IGA','EDITAR');
        	validaOpcionSSOSisoWeb('REVISAR IGA','REVISAR');
        	 
        	vm.dataInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
        	vm.prmIntrumentoGestion = angular.copy($rootScope.prmdatoInstrumento);
        	vm.prmIntrumentoGestion.idInstalacion = vm.dataInstalacion.idInstalacion;
        	vm.prmIntrumentoGestion.idAdministrado = vm.dataInstalacion.idAdministrado;
        	
        	if(vm.prmIntrumentoGestion.idInstrumentoGestion != 0){
        		vm.prmIntrumentoGestion.fecha = new Date(vm.prmIntrumentoGestion.fecha);	
        		vm.prmIntrumentoGestion.blModificaIga = vm.prmIntrumentoGestion.flag_modifica_iga == "1" ? true : false;
        		vm.prmIntrumentoGestion.blVigente = vm.prmIntrumentoGestion.flgvigente == "1" ? true : false;
        		vm.prmIntrumentoGestion.blCompleto = vm.prmIntrumentoGestion.flgcompleto == "1" ? true : false;
        		vm.prmIntrumentoGestion.blRevisado = vm.prmIntrumentoGestion.flgrevisado == "1" ? true : false;
           	 
           	 	InstrumentoGestionFactory.listarModificaciones(angular.copy(vm.prmIntrumentoGestion)).then(function(response) {
                    if (response.valido) {
                   	 cargarModificados(angular.copy(response.data));
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar ');
                });	
           	 	
           	 
        	}
        	
        	// activamos el primer tab
        	vm.active= 0;
        	obtenerParametros();
        	cargarCombos();
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                vm.extension = vm.extension + ",.zip";
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                tipos = tipos + ",application/zip";
                vm.mimeTypes = angular.copy(tipos.split(","));
                
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        function validaOpcionSSOSisoWeb(opcion, accion) {
      	  AccesoFactory.operaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq),'Inf. Unidades Fiscalizables').then(function(response) {
         	  $rootScope.sisoOperacioneswkWeb = response;
      		  vm.accesos = response;
      		  for (var int = 0; int < vm.accesos.length; int++) {
      			    var _opcion = vm.accesos[int];
                    if (_opcion.elemento == opcion && accion == 'EDITAR') {
                  	    vm.blEditar = true;
                    }
                    if (_opcion.elemento == opcion && accion == 'REVISAR') {
                    	vm.blRevisar = true;
                    }
                }
            }).catch(function(error) {
          	   vm.blEditar = false;
          	   vm.blRevisar = false;
            });
      }
        

        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInstalacionController', CargaInfoInstalacionController);
    /* @ngInject */
    function CargaInfoInstalacionController($location, $rootScope, toastr, ngDialog, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, SolicitudFactory, $scope, $state, CuestionarioFactory, TipoIgaFactory, CookiesFactory,OpcionPreguntaFactory, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.validaArchivoModificacionInst = 0;
        $rootScope.active = 0;
        $scope.serial = 1;
        /* Configuracion de paginacion de tablas */
        vm.urlData = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        /** *************************************************************************** */
        /** * Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataCuestionarioAutosupervision = [];
        /** *************************************************************************** */
        /** * Fin Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataAdministradoContacto = ContactoAdministradoFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataContacto = {
            tipoContacto: '0'
        };
        
        vm.dataInstalacion = InstalacionFactory.model();
        vm.listaTipoPersona = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaTipoDocumento = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSector = [];
        vm.listaSubSector = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaActividad = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSolicitudesInstalacion = [];
        vm.listaContactoAdministrado = [];
        vm.listaArchivosSolicitud = [];
        vm.listaCboTipoContacto = [];
        vm.listaInstalacionAdm = [];
        vm.listaDepartamentoPersona = [];
        vm.listaProvinciaPersona = [];
        vm.listaDistritoPersona = [];
        vm.listaTipoEstablecimiento = [];
        vm.listarContactoPrincipal = [];
        vm.btnAgregarInstalacion = false;
        vm.btnListaInstalacion = true;
        vm.cambiarEstadoContacto = cambiarEstadoContacto;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.validaDocumento = validaDocumento;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.contactoPrincipal = contactoPrincipal;
        vm.mostrarInformacionInstalacionDialog = mostrarInformacionInstalacionDialog;
        vm.MostrarForm = MostrarForm;
        vm.OcultarForm = OcultarForm;
        vm.irCompromisos = irCompromisos;
        vm.irInformeMonitoreo = irInformeMonitoreo;
        vm.irDeclaracionResiduos = irDeclaracionResiduos;
        vm.irManifiestoResiduos = irManifiestoResiduos;
        vm.irPresentacion = irPresentacion;
        vm.mostrarModificarInstalacion = mostrarModificarInstalacion;
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.mostrarCancelarInstalacion = mostrarCancelarInstalacion;
        vm.valorTelefono = valorTelefono;
        vm.modificar = 0;
        vm.limpiarContactoAdmi = limpiarContactoAdmi;
        vm.habilitarTexto = habilitarTexto;
        vm.guardar = guardar;
        vm.cambioDatos = cambioDatos;
        /** *** */
        
        vm.ruc;
        vm.agregarInstalacion = agregarInstalacion;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.buscar = buscar;
        vm.lstTipoIgas = [];
        vm.prmTipoIga = TipoIgaFactory.model();

        function confirmarEliminacion(prmInstalacion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstalacion.numeroInstalacion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstalacion,true);
            });
        }

        function eliminar(prmInstalacion,validar) {
        	prmInstalacion.isvalidar = validar; 
        	InstalacionFactory.eliminar(angular.copy(prmInstalacion)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarInstalacionesAdministrado();
                } else {
                	validacionModal(prmInstalacion, response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la instalación');
            });
        }
        
        function agregarInstalacion(prmInstalacion){
             if (prmInstalacion != null) {
                 
            	 InstalacionFactory.buscarPorId(angular.copy(prmInstalacion)).then(function(response) {
                 		if (response.valido) {
                         	$rootScope.prmInstalacion = response.data;
                         	  ngDialog.open({
                                   template: 'app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion-edicion.html',
                                   controller: 'CargaInfoEdicionInstalacionController',
                                   controllerAs: 'vm',
                                   width: '70%'
                               }).closePromise.then(function(dataDialog) {
                            	   listarInstalacionesAdministrado();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la parametro');
 		                });
             } 
             else{
             	$rootScope.prmInstalacion =  InstalacionFactory.model();
             	ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion-edicion.html',
                     controller: 'CargaInfoEdicionInstalacionController',
                     controllerAs: 'vm',
                     width: '70%'
                 }).closePromise.then(function(dataDialog) {
                	 listarInstalacionesAdministrado();
                 });
             }
        }
        
        function irCompromisos(item) {
            debugger;
            $rootScope.dataListaInstalacion
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-instrumento');
        }
        
        
        function irInformeMonitoreo(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-informe-instrumento');
        }
        
        function irDeclaracionResiduos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-residuos-declaracion');
        }
        
        function irManifiestoResiduos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-residuos-manifiesto');
        }

        function irPresentacion(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            localStorage.setItem("dataListaInstalacion", angular.copy(angular.toJson(vm.dataListaInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-presentacion');
        }

        function MostrarForm() {
            vm.btnAgregarInstalacion = true;
            vm.btnListaInstalacion = false;
        }

        function OcultarForm() {
            vm.btnAgregarInstalacion = false;
            vm.btnListaInstalacion = true;
            vm.dataInstalacion = angular.copy(InstalacionFactory.model());
            vm.validaArchivoModificacionInst = 0;
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            listarInstalacionesAdministrado();
        }
        /* implementacion de metodos */
        // usuario.actual= angular.fromJson(localStorage.objSesSisoLocStWqKP);
        /** ****************************************************************** */
        /**/
        function contactoPrincipal(prmData) {
            ContactoAdministradoFactory.modificarFlagPretedeterminadoDeContactoAdmi(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }
        /** *************************************************************** */
        /**/
        function habilitarTexto() {}

        function guardar() {
            habilitarTexto();
        }
        /**/
        /*-----LISTAR CONTACTO ADMINISTRADO------*/

        function cambiarEstadoContacto(data, estado) {
            // vm.confirmarDesactivarAdmi(item);
            var prmData = data;
            if (prmData != null) {
                prmData.estado.codigoRegistro = 2;
                // alert("DESCRRIPCION" +
				// vm.dataAdministradoContacto.estado.descripcion);
                if (prmData.estado.descripcion == 'DESACTIVADO') {
                    prmData.estado.codigoRegistro = 2;
                }
                // prmData.estado = 2;
            }
            ContactoAdministradoFactory.actualizar(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }

        function limpiarContactoAdmi() {
            vm.dataContactoAdministrado.tipoContacto.codigoRegistro = 0;
            vm.dataContactoAdministrado.valor = "";
        }


        function buscar(prm1) {
        	localStorage.removeItem("objInstalacion");
            localStorage.removeItem("dataListaInstalacion");
            
        	listarInstalacionesAdministrado();
        }

        function listarSubSector() {
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.subSector = '';
            vm.dataInstalacion.actividad = '';
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaSubSector" +
						 * angular.toJson(vm.listaSubSector));
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }

        function listarActividad() {
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.actividad.codigoRegistro = 0;
            /*
			 * vm.dataInstalacion.actividad=0; vm.listaActividad=[];
			 */
            if (vm.dataInstalacion.subSector != 0) {
                var actividades = {
                    codigoRegistroPadre: vm.dataInstalacion.subSector,
                    codigoMaestro: 'Actividad'
                }
                MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaActividad.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaActividad" +
						 * angular.toJson(vm.listaActividad));
						 * vm.dataNormas.actividad=0;
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        function listarInstalacionesAdministrado() {
            InstalacionFactory.listarxUsuarioUbigeo(angular.copy(vm.dataListaInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.listaInstalacionAdm = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar ');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarInformacionInstalacionDialog(itemInstalacion) {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html',
                controller: 'InformacionInstalacionDialogController',
                data: {
                    data: itemInstalacion
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }
        /** ******************************************************************************** */
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Seleccione'
            }];
            UbigeoFactory.listarDepartamentoxUsuario(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarProvincia();
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.provincia.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.provincia.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarProvinciaxUsuario(vm.provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarDistrito();
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            vm.distrito.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.distrito.codigoProvincia = vm.dataListaInstalacion.provincia.codigoProvincia;
            vm.distrito.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarDistritoxUsuario(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            vm.validaArchivo = '0';
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                vm.validaArchivo = '1';
                vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
            }
            if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
                console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
            }
        }
        /** *********************************************************************************** */
        function procesoRegistroSolicitudArchivo() {
            if (vm.validaArchivo == '1') {
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
            } else {
                toastr.info('Falta cargar ficha de registro');
                return;
            }
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
            // console.log("vm.listaArchivosSolicitud" +
			// vm.listaArchivosSolicitud);
            // console.log("vm.listaArchivosSolicitud.length" +
			// vm.listaArchivosSolicitud.length);
            vm.dataSolicitud.tipoSolicitud = 3;
            console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
            console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada correctamente');
                    // $state.go('ingreso');
                    // crear metodo para limpiar todos los campos y el campo de
					// file
                    // direccionar al listado de instalaciones
                    console.log("vm.dataSolicitud", vm.dataSolicitud);
                    visualizarModal();
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }

        function visualizarModal() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de nueva instalación ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function visualizarModalSolicitudModificacion() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de modificación de datos ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function procesoModificacionDeInstalacion() {
            if (vm.validaArchivoModificacionInst == 0 && vm.validaArchivo != '1') {
                toastr.warning('Debe subir un archivo para continuar con la modificación');
                return;
            }
            if (vm.validaArchivoModificacionInst == 1) {
                vm.validaArchivo = '0';
            }
            if (vm.validaArchivo == '1') {
                console.log("Realiza el Registro CON NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            } else {
                console.log("Realiza el Registro SIN NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                data.estado = 1;
                data.flagActivo = 1;
                vm.listaSolicitudesInstalacion.push(data);
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataAdministrado.flagActivo = 1;
                vm.dataAdministrado.estado = 1;
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                // console.log("Data a enviar
				// listaArchivosSolicitud",vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudSinArchivo(vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                        console.log("vm.dataSolicitud", vm.dataSolicitud);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            }
            /*
			 * console.log("ENTRA AL PROCESO DE MODIFICACION");
			 * console.log("vm.dataInstalacion",vm.dataInstalacion);
			 */
        }

        function registrarSolicitudArchivo() {
            if (vm.modificar != 1) {
                procesoRegistroSolicitudArchivo();
            } else {
                procesoModificacionDeInstalacion();
            }
        }
        /** ******************************************************************************** */
        /* Metodo para utilizado para cancelar instalacion */
        /** ******************************************************************************** */
        function mostrarCancelarInstalacion(itemInstalacion) {
            if (itemInstalacion.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog-cancelacion/cancelacion-instalacion-dialog.html',
                controller: 'CancelacionInstalacionDialogController',
                data: {
                    data: itemInstalacion,
                    dataAdministrado: vm.dataAdministrado
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function() {
                listarInstalacionesAdministrado();
            });
        }
        /** ********************************************************************************** */
        /* metodo para modificar instalación */
        /** ********************************************************************************** */
        function mostrarModificarInstalacion(item, modificar) {
            // modificar =1 -> Se trata de una modificacion
            debugger;
            if (item.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            vm.dataInstalacion = angular.copy(item);
            console.log(vm.dataInstalacion);
            vm.dataInstalacionTemporal = angular.copy(item);
            console.log(item);
            vm.modificar = modificar;
            vm.validaArchivoModificacionInst = 1;
            // listarSubSector();
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector != '') {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(angular.copy(subSector)).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                }).finally(function() {
                    debugger;
                    vm.dataInstalacion.subSector = angular.copy(item.subSector);
                    if (vm.dataInstalacion.subSector.codigoRegistro != 0) {
                        var actividades = {
                            codigoRegistroPadre: vm.dataInstalacion.subSector.codigoRegistro,
                            codigoMaestro: 'Actividad'
                        }
                        MaestroFactory.buscarRegistroHijo(angular.copy(actividades)).then(function(response) {
                            if (response != null && response.valido) {
                                for (var x in response.data) {
                                    vm.listaActividad.push(response.data[x]);
                                }
                                vm.dataInstalacion.actividad = angular.copy(item.actividad);
                                /*
								 * console.log("vm.listaActividad" +
								 * angular.toJson(vm.listaActividad));
								 * vm.dataNormas.actividad=0;
								 */
                            }
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos para los combos.');
                        });
                    }
                });
            }
            // listarActividad();
            for (var i = 0; i < 3; i++) {
                ejecutarfuncionesOrdenadas(i);
            }
        }

        function ejecutarfuncionesOrdenadas(item) {
            if (item == 0) {
                listarProvincia();
            }
            if (item == 1) {
                listarDistrito();
            }
            if (item == 2) {
                MostrarForm();
            }
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * 5 - 4;
        }

        function valorTelefono(valor) {
            var item = angular.element('#txtTelefono').val();
            if (item.length >= 13) {
                vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{4})[ .-]?(\d{3,5})$/;
            } else {
                var letra = angular.copy(item.substr(0, 1));
                console.log(letra);
                var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                var esNumeroInicial = false;
                console.log(esNumeroInicial);
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === letra) {
                        esNumeroInicial = true;
                        break;
                    }
                }
                console.log("esNumeroInicial");
                console.log(esNumeroInicial);
                if (esNumeroInicial) {
                    vm.validarTelefono = /^(\d{7,9})$/;
                } else {
                    vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{3,4})$/;
                }
            }
        }

        function cambioDatos() {
            // (true/false) = angular.equals($scope.user1, $scope.user2);
            return ((angular.equals(vm.dataInstalacion.sector, vm.dataInstalacionTemporal.sector)) && (angular.equals(vm.dataInstalacion.subSector, vm.dataInstalacionTemporal.subSector)) && (angular.equals(vm.dataInstalacion.actividad, vm.dataInstalacionTemporal.actividad)) && (angular.equals(vm.dataInstalacion.numeroInstalacion, vm.dataInstalacionTemporal.numeroInstalacion)) && (angular.equals(vm.dataInstalacion.tipoEstablecimiento, vm.dataInstalacionTemporal.tipoEstablecimiento)) && (angular.equals(vm.dataInstalacion.numeroRegistro, vm.dataInstalacionTemporal.numeroRegistro)) && (angular.equals(vm.dataInstalacion.departamento.codigoDepartamento, vm.dataInstalacionTemporal.departamento.codigoDepartamento)) && (angular.equals(vm.dataInstalacion.provincia.codigoProvincia, vm.dataInstalacionTemporal.provincia.codigoProvincia)) && (angular.equals(vm.dataInstalacion.distrito.codigoDistrito, vm.dataInstalacionTemporal.distrito.codigoDistrito)) && (angular.equals(vm.dataInstalacion.direccion, vm.dataInstalacionTemporal.direccion)));
        }
        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            localStorage.removeItem("objInstalacion");
            if (angular.isDefined(localStorage.dataListaInstalacion)) {
            	vm.dataListaInstalacion = angular.copy(angular.fromJson(localStorage.dataListaInstalacion));
            	if(vm.dataListaInstalacion.fechaaprobacionIga != null){
            		vm.dataListaInstalacion.fechaaprobacionIga = new Date(vm.dataListaInstalacion.fechaaprobacionIga);
            	}
            	buscar(localStorage.objlocalStRefSisoplkijsq);
            }
           // buscar(localStorage.objlocalStRefSisoplkijsq);
            cargarCombos();
            listarDepartamento();
            listarTipoIGA();
        }
        
        function verReporte(item){
        	
        }
        
        function validacionModal(prmInstalacion, mensaje) {
//            ngDialog.open({
//                template: '<div class="">' + '<div class="modal-header">' + 
//                '<h4 class="modal-title" style="text-align: justify;">' + mensaje.replace( new RegExp('/n','g') ,'<br/>')  + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Cerrar</button>' + '</div>' + '</div>',
//                plain: true,
//                width: 550,
//                preCloseCallback: function() {
//                    OcultarForm();
//                }
//            });
            
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstalacion.numeroInstalacion + '?',
            		Mensajeadicional: mensaje.replace( new RegExp('/n','g') ,',')
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstalacion,false);
            });
            
        }
        
        function listarTipoIGA(){
       	 TipoIgaFactory.listarActivos(angular.copy(vm.prmTipoIga)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstTipoIgas = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoEdicionInstalacionController', CargaInfoEdicionInstalacionController);
    /** @ngInject */
    function CargaInfoEdicionInstalacionController($rootScope, toastr, $scope, ngDialog, API_CONFIG, AccesoFactory, SectorGenericoFactory, AdministradoxInstalacionTempFactory, InstalacionFactory,MaestroFactory,UbigeoFactory,UsuarioUbigeoFactory ,EntidadFactory,CookiesFactory ) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        vm.dataInstalacion = InstalacionFactory.model();
        vm.filtroInstalacionINAPS = InstalacionFactory.model();
        vm.guardar = guardar;
        vm.listaDepartamento = [];
        vm.listaProvincia = [];
        vm.listaDistrito = [];
        vm.listaSector = [];
        vm.listaSubSector = [];
        vm.listaCompetencia = [];
        vm.listaActividad = [];
        vm.listaZonas = [];
        vm.listaTipoEstablecimiento = [];
        vm.listarActividad = listarActividad;
        vm.listarSubSector = listarSubSector;
        vm.listarDistrito = listarDistrito;
        vm.listarProvincia = listarProvincia;
        vm.listarDistritoInaps = listarDistritoInaps;
        vm.listarProvinciaInaps = listarProvinciaInaps;
        vm.validaDocumento = validaDocumento;
        
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];
        vm.RucValido = false;
        vm.validarRuc = validarRuc;
        vm.dataAdminxInstalacion = AdministradoxInstalacionTempFactory.model();
        vm.dataDocumentoInstalacion = InstalacionFactory.model_documento();
        vm.lstAdminxInstalcion = [];
        vm.lstFichaxInstalacion = [];
        vm.eliminarAdminxInstlacion = eliminarAdminxInstlacion;
        vm.agregarAdminxInstalacion = agregarAdminxInstalacion;
        vm.agregarFichaxInstalacion = agregarFichaxInstalacion;
        vm.eliminarFichaxInstalacion = eliminarFichaxInstalacion;
        vm.tieneArchivo = false;
        vm.changeSector = changeSector;
        vm.changeSubSector = changeSubSector;
        vm.changeCompetencia = changeCompetencia;
        vm.changeDepartamento = changeDepartamento;
        vm.changeProvincia = changeProvincia;
        vm.mostrarInaps = false;
        vm.mostrarNuevo = false;
        vm.listaUnidadesFiscalizablesExterno = [];
        vm.listaUnidadesFiscalizablesExternoBackup = [];
        vm.seleccionarTodos = seleccionarTodos;
        vm.desSeleccionarTodos = desSeleccionarTodos;
        vm.verSelTodos = true;
        vm.lstDocumentoInstalacion = [];
        vm.eliminarDocumentoInstalacion = eliminarDocumentoInstalacion;
        vm.lstUsuarioUbgeo = [];
        vm.validaDocumentoDetalle = validaDocumentoDetalle;
        vm.mostrarNuevoFicha = false;
        vm.guardarFichaxInstalacion = guardarFichaxInstalacion;
        vm.buscarInaps = buscarInaps;
        vm.validaOpcionSSOSisoWeb = validaOpcionSSOSisoWeb;
        vm.accesos = [];
        vm.blAgregarAdministrado = false;
        vm.blGuardar=true;
        
        $scope.config = {
                itemsPerPage: 10,
                fillLastPage: true,
                current: 1
            };
        
        function seleccionarTodos(){
        	for(var x in vm.listaUnidadesFiscalizablesExterno){
    			vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado = true;
        	}
        	vm.verSelTodos = false;
        }
        
        function desSeleccionarTodos(){
        	for(var x in vm.listaUnidadesFiscalizablesExterno){
    			vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado = false;
        	}
        	vm.verSelTodos = true;
        }
        
        function buscarInaps(){
        	var tempUF = vm.listaUnidadesFiscalizablesExternoBackup;
        	var valida = false;
        	vm.listaUnidadesFiscalizablesExterno = []; 
        	if (tempUF.length > 0){
        		for(var x in tempUF){
        			valida = false;
        			if(tempUF[x].departamento.codigoDepartamento == vm.filtroInstalacionINAPS.departamento.codigoDepartamento || vm.filtroInstalacionINAPS.departamento.codigoDepartamento == ""){
        				valida = true;
        			}
        			
        			if(valida){
        				if(tempUF[x].provincia.codigoProvincia == vm.filtroInstalacionINAPS.provincia.codigoProvincia || vm.filtroInstalacionINAPS.provincia.codigoProvincia == ""){
            				valida = true;
            			}
            			else{
            				valida = false;
            			}
        			}
        			
        			if(valida){
        				if(tempUF[x].distrito.codigoDistrito == vm.filtroInstalacionINAPS.distrito.codigoDistrito || vm.filtroInstalacionINAPS.distrito.codigoDistrito == ""){
            				valida = true;
            			}
            			else{
            				valida = false;
            			}
        			}
        			
        			
        			if(valida){
        				 vm.listaUnidadesFiscalizablesExterno.push(tempUF[x]);
        			}
        		}
        	}
        }
        
        function listarProvinciaInaps() {
        	vm.listaProvincia = [];
        	vm.listaDistrito = [];
        	
        	if( vm.filtroInstalacionINAPS.departamento == null){
        		return;
        	}
        	
            var provincia = {
            	codigoDepartamento : vm.filtroInstalacionINAPS.departamento.codigoDepartamento,
            	 idsession : CookiesFactory.obtenerCookie(),
            };
            UbigeoFactory.listarProvinciaxUsuario(angular.copy(provincia)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.filtroInstalacionINAPS.provincia != null && vm.filtroInstalacionINAPS.provincia.codigoProvincia != '') {
                    listarDistrito();
                }
            });
        }

        function listarDistritoInaps() {
        	
        	vm.listaDistrito = [];
        	if( vm.filtroInstalacionINAPS.provincia == null){
        		return;
        	}
        	
            var distrito = {
               codigoDepartamento : vm.filtroInstalacionINAPS.departamento.codigoDepartamento,
               codigoProvincia : vm.filtroInstalacionINAPS.provincia.codigoProvincia,
               idsession : CookiesFactory.obtenerCookie(),
            };
            
           
            UbigeoFactory.listarDistritoxUsuario(distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }
        
        
        function eliminarDocumentoInstalacion(index){
        	console.log('index ' + index);
      	  if(vm.dataInstalacion.idInstalacion==0){
      		  vm.lstFichaxInstalacion.splice(index,1);
      	  }
      	  else{
      		  InstalacionFactory.eliminarDocumento(angular.copy(vm.lstFichaxInstalacion[index])).then(function(response) {
                    if (response.valido) {
                  	  toastr.success('Se eliminó el registro correctamente.');
                  	  cargarDocumentoInstalacion();
                    } else {
                   	  toastr.error('Ocurrió un error al eliminar el registro');
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                }).finally(function() {
                });
      	  }
        }

        function eliminarAdminxInstlacion(index){
        	  if(vm.dataInstalacion.idInstalacion==0){
        		  vm.lstAdminxInstalcion.splice(index,1);
        	  }
        	  else{
        		  AdministradoxInstalacionTempFactory.eliminar(angular.copy(vm.lstAdminxInstalcion[index])).then(function(response) {
                      if (response.valido) {
                    	  toastr.success('Se eliminó el registro correctamente.');
                    	  cargarAdminxInstalacion();
                      } else {
                     	  toastr.error('Ocurrió un error al eliminar el registro');
                      }
                  }).catch(function(error) {
                      toastr.error('Error al consultar');
                  }).finally(function() {
                  });
        	  }
        }
        
        function agregarFichaxInstalacion(){
        	vm.listaArchivos = [];
        	 vm.dataDocumentoInstalacion = InstalacionFactory.model_documento();
        	vm.mostrarNuevoFicha = true;
            if(vm.dataInstalacion.idInstalacion!=0){
            	 vm.dataDocumentoInstalacion.idInstalacion = vm.dataInstalacion.idInstalacion;
            	 vm.dataDocumentoInstalacion.idAdministrado = vm.dataInstalacion.idAdministrado;
            }
        }
        
        function guardarFichaxInstalacion(){
        	 vm.dataDocumentoInstalacion.idInstalacion = vm.dataInstalacion.idInstalacion;
        	 vm.dataDocumentoInstalacion.idAdministrado = vm.dataInstalacion.idAdministrado;
            if(vm.dataInstalacion.idInstalacion!=0){
            	 InstalacionFactory.registrarDocumento(vm.listaArchivos, angular.copy(vm.dataDocumentoInstalacion)).then(function(response) {
                 }).catch(function(error) {
                     toastr.error('Error al grabar la ficha de registro');
                 }).finally(function() {
                		vm.mostrarNuevoFicha = false;
                	 cargarDocumentoInstalacion();
                 });
            	 
            }
            else{
            	vm.lstFichaxInstalacion.push(angular.copy(vm.dataDocumentoInstalacion)); 
            	vm.mostrarNuevoFicha = false;
            }

        }
        
        function eliminarFichaxInstalacion(index){
      	  if(vm.dataInstalacion.idInstalacion==0){
      		  vm.lstFichaxInstalacion.splice(index,1);
      	  }
      	  else{
      		  InstalacionFactory.eliminarDocumento(angular.copy(vm.lstFichaxInstalacion[index])).then(function(response) {
                    if (response.valido) {
                  	  toastr.success('Se eliminó el registro correctamente.');
                  	  cargarAdminxInstalacion();
                    } else {
                   	  toastr.error('Ocurrió un error al eliminar el registro');
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                }).finally(function() {
                });
      	  }
      }
        
        function agregarAdminxInstalacion(prmAdminxInstalacion){
        	console.log("prmAdminxInstalacion" + prmAdminxInstalacion);
        	delete $rootScope.dataInstalacion;
        	delete $rootScope.dataAdminxInstalacionEdit;
        	delete $rootScope.lstAdminxInstalacion;
        	$rootScope.dataInstalacion = vm.dataInstalacion;
        	$rootScope.lstAdminxInstalacion =  vm.lstAdminxInstalcion;

        	if (angular.isDefined(localStorage.dataAdminxInstalacion)){
        		localStorage.removeItem("dataAdminxInstalacion");
        	}
        	
            if (prmAdminxInstalacion != null) {
                
            	              localStorage.setItem("dataAdminxInstalacion", angular.copy(angular.toJson(prmAdminxInstalacion)));
                        	
                        	  ngDialog.open({
                        		  template: 'app/modules/supervision/cargainformacion/administradoInstalacion/cargainfo-administracion-instalacion.html',
                                  controller: 'CargaInfoAdministradosInstalacionController',
                                  controllerAs: 'vm',
                                  
                                  width: '65%'
                              }).closePromise.then(function(dataDialog) {
                            	  // nuevo
                            	  if(vm.dataInstalacion.idInstalacion==0){
                            		  if(angular.isDefined($rootScope.dataAdminxInstalacionEdit)){
	                            		  for(var x in vm.lstAdminxInstalcion){
	                                		  if (vm.lstAdminxInstalcion[x].ruc == $rootScope.dataAdminxInstalacionEdit.ruc &&
	                                			  vm.lstAdminxInstalcion[x].idInstalacion == $rootScope.dataAdminxInstalacionEdit.idInstalacion){
	                                			  vm.lstAdminxInstalcion[x].auxInicio =  obtenerFechaTexto(vm.lstAdminxInstalcion[x].inicioAdministrado);
	                                			  vm.lstAdminxInstalcion[x].auxFin =  obtenerFechaTexto(vm.lstAdminxInstalcion[x].finAdministrado);
	                                			  vm.lstAdminxInstalcion[x] = $rootScope.dataAdminxInstalacionEdit;
	                                		  }
	                                	  }
                            		  }
                            	  }
                            	  else{
                            		  // cargamos de la bd por que ya esta
										// actuslizado
                            		  cargarAdminxInstalacion();
                            	  }
                            	  
                              });
                        
		              
            } 
            else{
            	localStorage.setItem("dataAdminxInstalacion", angular.copy(angular.toJson(AdministradoxInstalacionTempFactory.model())));
            	
            	ngDialog.open({
                    template: 'app/modules/supervision/cargainformacion/administradoInstalacion/cargainfo-administracion-instalacion.html',
                    controller: 'CargaInfoAdministradosInstalacionController',
                    controllerAs: 'vm',
                    width: '65%'
                }).closePromise.then(function(dataDialog) {
                	  vm.blGuardar = false;
                	 // nuevo
	              	  if(vm.dataInstalacion.idInstalacion==0){
	              		  if(angular.isDefined($rootScope.dataAdminxInstalacionEdit)){
	              			  $rootScope.dataAdminxInstalacionEdit.auxInicio =  obtenerFechaTexto($rootScope.dataAdminxInstalacionEdit.inicioAdministrado);
	              			  $rootScope.dataAdminxInstalacionEdit.auxFin =  obtenerFechaTexto($rootScope.dataAdminxInstalacionEdit.finAdministrado);
	              			  vm.lstAdminxInstalcion.push($rootScope.dataAdminxInstalacionEdit);
	              		  }
	              	  }
	              	  else{
	              		  // cargamos de la bd por que ya esta actuslizado
	              		  cargarAdminxInstalacion();
	              	  }
                });
            }
        }
        
        function validarRuc(){
        	 	 vm.lstAdminxInstalcion = [];
        	     var dataEntidad = EntidadFactory.model();
        	     dataEntidad.ruc = vm.dataInstalacion.ruc;
                 EntidadFactory.obtenerPorDocumento(angular.copy(dataEntidad)).then(function(response) {
                     if (response.valido) {
                    	 // si el inaps devuelve información deberiamos
							// cargarlo
                    	 dataEntidad = response.data;
                    	 if(dataEntidad.lstUnidadesFiscalizables.length>0){
                    		 vm.dataInstalacion.razonsocial = dataEntidad.razonSocial;
                    		 vm.listaUnidadesFiscalizablesExterno = dataEntidad.lstUnidadesFiscalizables;
                    		 vm.listaUnidadesFiscalizablesExternoBackup = vm.listaUnidadesFiscalizablesExterno;
                    		 vm.mostrarInaps = true;
                    		 vm.mostrarNuevo = false;
                    		 vm.RucValido = true;
                    	 }
                    	 else{
                    		 vm.dataAdminxInstalacion.ruc = dataEntidad.ruc;
                    		 vm.dataAdminxInstalacion.razonsocial = dataEntidad.razonSocial;
                    		 vm.dataAdminxInstalacion.flagActivo = 'S';
                    		 vm.dataAdminxInstalacion.inicioAdministrado = new Date();
                    		 vm.dataAdminxInstalacion.auxInicio = obtenerFechaTexto(vm.dataAdminxInstalacion.inicioAdministrado);
                    		 vm.dataAdminxInstalacion.auxflgaactivo = true;
                    		 vm.dataAdminxInstalacion.idsession = CookiesFactory.obtenerCookie();
                    		 vm.lstAdminxInstalcion.push(vm.dataAdminxInstalacion);
                    		 vm.dataInstalacion.razonsocial = dataEntidad.razonSocial;
                    		 vm.RucValido = true;
                    		 vm.mostrarNuevo = true;
                    		 vm.mostrarInaps = false;
                    	 }
                     } else {
                    	 vm.RucValido = false;
                         toastr.error('No se encontraron datos relacionados al documento ' + dataEntidad.ruc );
                     }
                 }).catch(function(error) {
                	 dialogMensaje();
                	 vm.RucValido = false;
                 }).finally(function() {
                 });
        }
        
        function cancelar() {
            ngDialog.close();
        }
        
        function dialogMensaje() {
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Mensaje del Sistema',
                     Mensaje: 'El servicio no devolvió ningún dato por favor. Comuniquese con el administrador del sistema.'
                 },
                 width: '380px'
             }).then(function(okValue) {
            	$scope.closeThisDialog();
             });
        }
        
        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.RucValido && vm.dataInstalacion.numeroInstalacion!=null && vm.dataInstalacion.tipoEstablecimiento != 0 && 
        				vm.dataInstalacion.sector.codigoRegistro != 0 && vm.dataInstalacion.subSector.codigoRegistro != 0 && vm.dataInstalacion.actividad.codigoRegistro != 0 && 
        				vm.dataInstalacion.departamento.codigoDepartamento != 0 && vm.dataInstalacion.provincia.codigoProvincia != 0 && vm.dataInstalacion.distrito.codigoDistrito != 0 &&
        				(vm.dataInstalacion.direccion != null && vm.dataInstalacion.direccion != '' )){
                	document.getElementById("btnGuardarInstalacion").disabled = false;
                }
        				
                vm.tieneArchivo = true;
        }
        
        function validaDocumentoDetalle(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    return;
                }
                
// prmFileList[0].name = vm.dataDocumentoInstalacion.ficha_registro + "_" +
// prmFileList[0].name;
                
                vm.dataDocumentoInstalacion.nombreOriginal = prmFileList[0].name;
                
                vm.listaArchivos.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.dataDocumentoInstalacion.ficha_registro != null && vm.dataDocumentoInstalacion.ficha_registro != '' ){
                	document.getElementById("btnAgregarFicha").disabled = false;
                }
               
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        function changeSector(){
        	vm.dataInstalacion.subSector = '';
        	vm.dataInstalacion.competencia = '';
        	vm.dataInstalacion.actividad = '';
        	listarSubSector();
        }

        function changeSubSector(){
        	vm.dataInstalacion.competencia = '';
        	vm.dataInstalacion.actividad = '';
        	listarCompetencia();
        }
        
        function changeCompetencia(){
        	vm.dataInstalacion.actividad = '';
        	listarActividad(vm.dataInstalacion.competenciaArray);
        }
        
        
        function changeDepartamento(){
        	vm.dataInstalacion.provincia.codigoProvincia = 0;
        	vm.dataInstalacion.distrito.codigoDistrito = 0;
        	listarProvincia();
        }
        
        function changeProvincia(){
        	vm.dataInstalacion.distrito.codigoDistrito = 0;
        	listarProvincia();
        }
        
        function listarSector(){
        	SectorGenericoFactory.listarSector().then(function(response) {
                 if (response.valido) {
                     for (var x in response.data) {
                         vm.listaSector.push(response.data[x]);
                     }
                     /* vm.dataDenuncia.tipoPersona=0; */
                 } else {
                     toastr.error(response.mensaje);
                 }
             }).catch(function(error) {
                 toastr.error('Error al consultar');
             }).finally(function() {
            	 if (vm.dataInstalacion.sector != '') {
                 	listarSubSector();
                 }
             });
        }
        
        function cargarCombos(){
        	listarDepartamento();
        	listarSector();
            var codigosCombos = ['TipoSector', 'TipoEstablecimiento', 'ZONA'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
// case 'TipoSector':
// for (var i in datosCombo) {
// vm.listaSector.push(datosCombo[i]);
// }
// break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            case 'ZONA':
                            	for (var i in datosCombo) {
                                    vm.listaZonas = datosCombo;
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
        }
        
        function listarDepartamento() {
            UbigeoFactory.listarDepartamentoxUsuario(angular.copy(UbigeoFactory.departamento())).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }

        function listarProvincia() {
        	vm.listaProvincia = [];
        	
        	if( vm.dataInstalacion.departamento == null){
        		return;
        	}
        	
            var provincia = {
            	codigoDepartamento : vm.dataInstalacion.departamento.codigoDepartamento,
            	 idsession : CookiesFactory.obtenerCookie(),
            };
            UbigeoFactory.listarProvinciaxUsuario(angular.copy(provincia)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.dataInstalacion.provincia != null && vm.dataInstalacion.provincia.codigoProvincia != '') {
                    listarDistrito();
                }
            });
        }

        function listarDistrito() {
        	
        	if( vm.dataInstalacion.provincia == null){
        		return;
        	}
        	
        	vm.listaDistrito = [];
            var distrito = {
               codigoDepartamento : vm.dataInstalacion.departamento.codigoDepartamento,
               codigoProvincia : vm.dataInstalacion.provincia.codigoProvincia,
               idsession : CookiesFactory.obtenerCookie(),
            };
            
           
            UbigeoFactory.listarDistritoxUsuario(distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }
        
        function listarSubSector() {
        	vm.listaSubSector = [];
            var subSector = {
                codigosector: vm.dataInstalacion.sector
            };
            SectorGenericoFactory.listarSubSector(angular.copy(subSector)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaSubSector.push(response.data[x]);
                    }
                    /*
					 * console.log("vm.listaSubSector" +
					 * angular.toJson(vm.listaSubSector));
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {
                if (vm.dataInstalacion.subSector != '') {
                	listarCompetencia();
                }
            });
        }
        
     
        
        function listarCompetencia() {
        	var componenteSel = null;

        	vm.listaCompetencia = [];
            var subSector = {
                codigosubsector: vm.dataInstalacion.subSector
            };
            SectorGenericoFactory.listarCompetencia(angular.copy(subSector)).then(function(response) {
                if (response != null && response.valido) {
                	// PARSEAMOS LA COMPETENCIA
                    for (var x in response.data) {
                        vm.listaCompetencia.push(response.data[x]);
                    }
                    
                    /*
					 * console.log("vm.listaSubSector" +
					 * angular.toJson(vm.listaSubSector));
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {
                if (vm.dataInstalacion.competencia != '') {
                	var arrayCompetencia = vm.dataInstalacion.competencia.split(';');
                	vm.dataInstalacion.competenciaArray = obtenerArraySinVacios(arrayCompetencia);
                	 if(vm.dataInstalacion.competenciaArray.length>0){
                		 listarActividad(vm.dataInstalacion.competenciaArray);
                	 }
                }
            });
        }
        
        function listarActividad(competencia) {
        	
        	vm.listaActividad = [];
        	if(competencia == null){
        		return;
        	}
        	
            var actividades = {
                codigocompetencia: competencia[competencia.length - 1]
            };
            
            SectorGenericoFactory.listarActividad(angular.copy(actividades)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaActividad.push(response.data[x]);
                    }
                    /*
					 * console.log("vm.listaActividad" +
					 * angular.toJson(vm.listaActividad));
					 * vm.dataNormas.actividad=0;
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function guardar() {
        	if(vm.mostrarInaps==true){
    		var exito = 0;
    		var primero = 0;
    		if(vm.listaUnidadesFiscalizablesExterno.length>0){
    			for(var x in vm.listaUnidadesFiscalizablesExterno){
        			if(vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado){
        				primero = x;
        			}
    			}
    			var adminxinstal1 = {
						ruc : vm.dataInstalacion.ruc,
						razonsocial : vm.dataInstalacion.razonsocial,
						inicioAdministrado : new Date(),
						flagActivo : '1',
						idsession : CookiesFactory.obtenerCookie(),
						ultima_fecha : new Date(),
				};
    			vm.listaUnidadesFiscalizablesExterno[primero].lstAdministradoxInstalacion.push(adminxinstal1);
				
				// actualizamos la razÃ³n social en caso sea diferente a
				// los del inaps
				if(vm.listaUnidadesFiscalizablesExterno[primero].razonsocial != vm.dataInstalacion.razonsocial){
					vm.listaUnidadesFiscalizablesExterno[primero].razonsocial = vm.dataInstalacion.razonsocial;
				}
	        	
	        	InstalacionFactory.registrar(vm.listaArchivos,angular.copy(vm.listaUnidadesFiscalizablesExterno[primero])).then(function(response) {
	                if (response != null && response.valido) {
	                	for(var x in vm.listaUnidadesFiscalizablesExterno){
	            			if(vm.listaUnidadesFiscalizablesExterno[x].flgSeleccionado && x != primero){
	            				// agegamos la lista de administrados por
								// instalacion
	            				var adminxinstal = {
	            						ruc : vm.dataInstalacion.ruc,
	            						razonsocial : vm.dataInstalacion.razonsocial,
	            						inicioAdministrado : new Date(),
	            						flagActivo : '1',
	            						idsession : CookiesFactory.obtenerCookie(),
	            						ultima_fecha : new Date(),
	            				};
	            	        	
	            				vm.listaUnidadesFiscalizablesExterno[x].lstAdministradoxInstalacion.push(adminxinstal);
	            				
	            				// actualizamos la razÃ³n social en caso sea
								// diferente a
	    						// los del inaps
	            				if(vm.listaUnidadesFiscalizablesExterno[x].razonsocial != vm.dataInstalacion.razonsocial){
	            					vm.listaUnidadesFiscalizablesExterno[x].razonsocial = vm.dataInstalacion.razonsocial;
	            				}
	            	        	
	            	        	InstalacionFactory.registrar(vm.listaArchivos,angular.copy(vm.listaUnidadesFiscalizablesExterno[x])).then(function(response) {
	            	                if (response != null && response.valido) {
	            	                	exito=exito+1;
	            	                	if(vm.listaUnidadesFiscalizablesExterno.length = x+1){
	            	                		 toastr.success('Ã‰xito en la operaciÃ³n.');
	            	                		 ngDialog.close();
	            	                	}
	            	                }
	            	            }).catch(function(error) {
	            	                toastr.error('No se pudo grabar la informaciÃ³n.');
	            	                return;
	            	            });
	            	            
	            			}
	            		}
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo grabar la informaciÃ³n.');
	                return;
	            }).finally(function() {
	            	ngDialog.close();
	            });
    			
    		}
    		
    	}
    	if(vm.mostrarNuevo == true){
    		 // concatenamos en una cadena la competencia
    		   var competenciaConcat = "";
    		
    		 for (var x in vm.dataInstalacion.competenciaArray) {
    			 competenciaConcat = competenciaConcat +  vm.dataInstalacion.competenciaArray[x] + ";" ;
             }
    		 
    		 vm.dataInstalacion.competencia = competenciaConcat;
    		
    		if (vm.dataInstalacion.idInstalacion == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
    	}
    	}

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	
        	// agegamos la lista de administrados por instalacion
        	if( vm.lstAdminxInstalcion.length> 0){
        		vm.dataInstalacion.lstAdministradoxInstalacion = vm.lstAdminxInstalcion;
        	}
        	if( vm.lstFichaxInstalacion.length> 0){
        		vm.dataInstalacion.lstDocumentos = vm.lstFichaxInstalacion;
        	}
        	
        	InstalacionFactory.registrar(vm.listaArchivos,angular.copy(vm.dataInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });
            
        }

        function actualizar() {
        	
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	vm.dataInstalacion.prm1 = CookiesFactory.obtenerCookie();
        	InstalacionFactory.actualizar(vm.listaArchivos,angular.copy(vm.dataInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function cargarAdminxInstalacion (){
        	vm.lstAdminxInstalcion= [];
        	var tempAdminXIns = {
        			idInstalacion : vm.dataInstalacion.idInstalacion,
        			ruc : vm.dataInstalacion.ruc,
        	};
        	
        	AdministradoxInstalacionTempFactory.listar(angular.copy(tempAdminXIns)).then(function(response) {
                 if (response != null && response.valido) {
                     for (var x in response.data) {
                         vm.lstAdminxInstalcion.push(response.data[x]);
                     }
                 }
        	 }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos para los combos.');
             });
        }
        
        function cargarDocumentoInstalacion (){
        	vm.lstFichaxInstalacion= [];
        	
        	InstalacionFactory.listarDocumento(angular.copy(vm.dataInstalacion)).then(function(response) {
                 if (response != null && response.valido) {
                     for (var x in response.data) {
                         vm.lstFichaxInstalacion.push(response.data[x]);
                     }
                 }
        	 }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos para los combos.');
             });
        }
        
        
        
        /* fin de metodos */
        function init() {
        	validaOpcionSSOSisoWeb("EDITAR UF");
        	cargarCombos();
            if (angular.isDefined($rootScope.prmInstalacion)) {
                vm.dataInstalacion = angular.copy($rootScope.prmInstalacion);
                listarProvincia();
                listarDistrito();
            }
            
            if(vm.dataInstalacion.idInstalacion == 0){
            	vm.dataInstalacion.estado = 1;
            }
            else{
            	vm.mostrarNuevo = true;
            	 vm.RucValido = true;
            	 vm.tieneArchivo = true;
            	cargarAdminxInstalacion();
            	cargarDocumentoInstalacion();
            }
            
            obtenerParametros();
           
        }
        
        
        function obtenerArraySinVacios(arrayCompetencia){
        	var retorno = [];
        	if(arrayCompetencia!=null){
        		for(var x in arrayCompetencia){
        			if(arrayCompetencia[x] != null && arrayCompetencia[x] != ''){
        				retorno.push(angular.copy(arrayCompetencia[x]));
        			}
        		}
        	}
        	
        	return retorno;
        }
        
        function obtenerFechaTexto(fecha){
        	if(fecha == undefined){
        		return "";
        	}
        	var dia = fecha.getDate();
        	var mes = fecha.getMonth()+1;
        	var anio = fecha.getFullYear();
        	
        	if (mes < 10) {
        		mes = "0" + mes;
        	}
        	if (dia < 10) {
        		dia = "0" + dia;
        	}

        	var fechaFinal = dia + "/" + (mes) + "/" + anio;
        	
        	return fechaFinal;
        }
        
        function validaOpcionSSOSisoWeb(opcion) {
      	  AccesoFactory.operaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq),'Inf. Unidades Fiscalizables').then(function(response) {
         	  $rootScope.sisoOperacioneswkWeb = response;
      		  vm.accesos = response;
      		  for (var int = 0; int < vm.accesos.length; int++) {
      			    var _opcion = vm.accesos[int];
                    if (_opcion.elemento == opcion) {
                  	  vm.blAgregarAdministrado = true;
                    }
                }
            }).catch(function(error) {
          	  vm.blEditar = false;
            });
      }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.parametro', []);
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('CargaInfoInformeParametroController', CargaInfoInformeParametroController);
    /* @ngInject */
    function CargaInfoInformeParametroController(ngDialog, toastr, $scope, $rootScope, API_CONFIG, DeclaracionPuntoFactory ,InformeEnsayoFactory , ComponenteAmbientalFactory, ComponenteAmbientalParametroFactory, DeclaracionParametroFactory ,MaestroFactory, NormaLegalFactory, NormasFactory, CookiesFactory, InformeMonitoreoFactory) {
        var vm = this;
        vm.urlData = API_CONFIG.url;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstParametrosComponente = [];
        vm.lstParametrosComponenteBase  = [];
        vm.lstMatriz = [];
        vm.lstSubMatriz = [];
        vm.lstParametrosComponenteSel = [];
        vm.matriz;
        vm.submatriz;
        
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        /* implementación de metodos */
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.lstUnidadMedida = [];
        vm.lstFrecuencia = [];
        vm.lstNormaLegal = [];
        vm.prmComponenteParametro = ComponenteAmbientalParametroFactory.model();
        vm.guardar = guardar;
        vm.confirmarGuardar = confirmarGuardar;
        vm.listarSubMatriz = listarSubMatriz;
        vm.prmPuntoMonitoreo;
        vm.agregarParametro = agregarParametro;
        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;
        vm.listaArchivosEnsayo= [];
        vm.listaArchivosInformeMonitoreo= [];
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
    	vm.objInformeEnsayo = InformeEnsayoFactory.model();
    	vm.lstEnsayos = [];
    	vm.lstInformesMonitoreo = [];
    	vm.agregarInformeEnsayo = agregarInformeEnsayo;
    	vm.guardarInformeEnsayo = guardarInformeEnsayo;
    	vm.eliminarInformeEnsayo = eliminarInformeEnsayo;
        vm.mostrarNuevoEnsayo = false;
        vm.validaDocumentoEnsayo = validaDocumentoEnsayo;
        vm.validaDocumentoInformeMonitoreo = validaDocumentoInformeMonitoreo;
        vm.actualizarComentarioIMA = actualizarComentarioIMA;
        vm.objInformeMonitoreo = InformeMonitoreoFactory.model();
        vm.lstConcetracion = [];
        vm.confirmarEliminacionResultado = confirmarEliminacionResultado;
        vm.obtenerInformeEnsayo = obtenerInformeEnsayo;
        
        function obtenerInformeEnsayo(item){
        	$rootScope.objInformeMonitoreo = item;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informe-ensayo/cargainfo-informe-ensayo.html',
                controller: 'CargaInfoInformeEnsayoController',
                controllerAs: 'vm',
                width: '98%'
            }).closePromise.then(function(dataDialog) {
            	for(var x in vm.lstParametrosComponenteBase){
            		
            		if(vm.lstParametrosComponenteBase[x].numeroItem == item.numeroItem){
            			vm.lstParametrosComponenteBase[x].codigo_ensayo = $rootScope.informeEnsayo.codigo_ensayo;
            			break;
            		}
            	}
            });
        }
         
        function confirmarEliminacionResultado(item){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar los valores reportados de esta fila?'
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminarInformeParametroResultado(item);
             });
        }

        function actualizarComentarioIMA(){
        	DeclaracionPuntoFactory.actualizarComentarioIMA(angular.copy(vm.prmPuntoMonitoreo)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });	
        }
        
        
        function confirmarEliminacionParametro(prmDeclaracionParametro){
          	 ngDialog.openConfirm({
                   template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                   controller: 'DialogConfirmController',
                   controllerAs: 'vm',
                   data: {
                       Titulo: 'Confirmar eliminación',
                       Mensaje: '¿Está seguro de eliminar el registro?'
                   },
                   width: '380px'
               }).then(function(okValue) {
                   eliminarDeclaracionParametro(prmDeclaracionParametro);
               });
          }
        
        function eliminarDeclaracionParametro(prmDeclaracionParametro){
           	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
                   if (response.valido) {
                       toastr.success(response.mensaje);
                       listarParametros();
                   } else {
                       toastr.error(response.mensaje)
                   }
               }).catch(function(error) {
                   toastr.error('Ocurrió un error al eliminar el parametro');
               });
           }
        
        function eliminarInformeParametroResultado(prmInformeDetalle){
        	
        	 var tempInformeMonitoreoDet = {
        			 	idInformeMonitoreo : prmInformeDetalle.idInformeMonitoreo,
    					secuencia : prmInformeDetalle.secuencia
        		  };
        		  
        	
        	InformeMonitoreoFactory.eliminarDetalle(angular.copy(tempInformeMonitoreoDet)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarParametros();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar el parametro');
            });
        }
        
		function listarParametros(){
			var tempParametroMonitoreo = {
		    		idAdministrado : vm.prmPuntoMonitoreo.idAdministrado,
		    	    idIga : vm.prmPuntoMonitoreo.idIga,
		    	    idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
		    	    idEtapa : vm.prmPuntoMonitoreo.idEtapa,
		    	    idComponente : vm.prmPuntoMonitoreo.idComponente,
		    	    idPunto : vm.prmPuntoMonitoreo.idPunto,
		    	    idInformeMonitoreo : vm.objInformeMonitoreo.idInformeMonitoreo
		    	};
			 
		    	DeclaracionParametroFactory.listarInforme(angular.copy(tempParametroMonitoreo)).then(function(response) {
		         if (response != null && response.valido) {
		        	 vm.lstParametrosComponenteBase = angular.copy(response.data);
		         }
		     }).catch(function(error) {
		         toastr.error('No se pudo obtener los datos.');
		     });
		}

        function listar() {
        	vm.prmComponenteParametro.componente = vm.prmComponente.codigo;
        	ComponenteAmbientalParametroFactory.listar(angular.copy(vm.prmComponenteParametro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstParametrosComponente = angular.copy(response.data);
                       	for (var y = 0; y < vm.lstParametrosComponente.length; y++) { 
                       		for(var x in vm.lstParametrosComponenteBase){
                           		if(vm.lstParametrosComponenteBase[x].idParametroValor == vm.lstParametrosComponente[y].parametro_valor){
                           			// ya existe
                           			vm.lstParametrosComponente.splice(y,1);
                           			y--;
                           			break;
                           		}
                           	}
                       	}
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarCombos() {
			listarUnidadMedida();
      	  	listarNormaLegal();
      	  	listarFrecuencia();
      	  	listarMatriz();
      	  	listarSubMatriz();
      	  	listarConcentracion();
		}
		
        function listarMatriz(){
        	var prmComponente = {
        			codigo : vm.prmComponente.codigo,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        
        function listarSubMatriz(idMatriz){
        	
        	 vm.lstSubMatriz = [];
        	 
        	if (idMatriz == 0 || idMatriz == null){
        		return;
        	}
        	
        	var prmComponente = {
        			codigo : idMatriz,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstSubMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        function listarUnidadMedida() {
        	
        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstUnidadMedida = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstUnidadMedida);
        }
        
        function listarFrecuencia() {
        	var dataFrecuencia = {
        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstFrecuencia = angular.copy(response.data);;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstFrecuencia);
        }
        
        function listarNormaLegal() {
        	 
        	var dataNormaLegal = NormasFactory.modelNormas();
        	
        	NormasFactory.listar(angular.copy(dataNormaLegal)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstNormaLegal = angular.copy(response.data);
                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function agregarParametro(parametroComponente){
                if (parametroComponente.blSeleccionado){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.prmPuntoMonitoreo.idAdministrado,
            				idIga : vm.prmPuntoMonitoreo.idIga,
            				idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
            				idEtapa : vm.prmPuntoMonitoreo.idEtapa,
            				idComponente : parametroComponente.componente,
            				idPunto : vm.prmPuntoMonitoreo.idPunto,
            				idParametroValor : parametroComponente.parametro_valor,
            				estado : 'P'
                	};
                }
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	listar();
                        	listarParametros();
                        }
                });
        }
        
        function validarInformeMonitoreo(){
        	
        	var selBool = 0;
        
        	
        	for(var x in vm.lstParametrosComponenteBase){
	        		if( vm.lstParametrosComponenteBase[x].boolInforma){
	        			selBool = selBool + 1;
	        			
	        			var nombreConMoni = obtenerNombreConcetracion(vm.lstParametrosComponenteBase[x].valor_concetracion_cod,vm.lstParametrosComponenteBase[x].lstConcetracionValores);
	        			var nombreConEnsa = obtenerNombreConcetracion(vm.lstParametrosComponenteBase[x].valor_concetracion_ensayo_cod,vm.lstParametrosComponenteBase[x].lstConcetracionValores);
	        			
	        			if(nombreConMoni == null){
	        				nombreConMoni = '';
	        			}
	        			
	        			if(nombreConEnsa == null){
	        				nombreConEnsa = '';
	        			}
	        			if((vm.lstParametrosComponenteBase[x].valor_ensayo == 0 || vm.lstParametrosComponenteBase[x].valor_ensayo==null) &&
	        					(vm.lstParametrosComponenteBase[x].valor_concetracion_ensayo_cod == 0 || nombreConEnsa == '<' || nombreConEnsa.toUpperCase() == 'RANGO') && !vm.lstParametrosComponenteBase[x].bol_nodetectable ){
	        				toastr.error('Es obligatorio registrar el valor del informe de ensayo');
	        				return false;
	        			}
//	        			if(vm.lstParametrosComponenteBase[x].codigo_ensayo == '' || vm.lstParametrosComponenteBase[x].codigo_ensayo==null){
//	        				toastr.error('Es obligatorio registrar el código de ensayo');
//	        				return false;
//	        			}
	        			if(vm.lstParametrosComponenteBase[x].flg_acreditado == '' || vm.lstParametrosComponenteBase[x].flg_acreditado==null){
	        				toastr.error('Es obligatorio seleccionar la acreditación del laboratorio por cada parámetro');
	        				return false;
	        			}
	        		}
        	}
        	
        	if(selBool==0){
        		toastr.error('Es obligatorio seleccionar la columna Informa para almenos un parámetro');
				return false;
        	}
        	
        	return true;
        }
        
        function confirmarGuardar(){
        	if(validarInformeMonitoreo()){
// ngDialog.openConfirm({
// template: 'app/base/template/dialog-confirm/dialog-confirm.html',
// controller: 'DialogConfirmController',
// controllerAs: 'vm',
// data: {
// Titulo: 'Declaración Jurada',
// Mensaje: 'Formulo la presente declaración en virtud del Principio de
// Presunción de Veracidad previsto en los artículos IV numeral 1.7 y 49º del
// Decreto Supremo Nº 006-2017-JUS'
// },
// width: '380px'
// }).then(function(okValue) {
        		
        		ngDialog.openConfirm({
                    template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                    controller: 'DialogConfirmController',
                    controllerAs: 'vm',
                    data: {
    	                     Titulo: 'Confirmar Guardar el Informe',
    	                     Mensaje: '¿Está seguro de guardar el Informe'
    	                 },
                    width: '380px'
                }).then(function(okValue) {
                	guardar();
                });	            	 
// });
        	}
        }
        
        function guardar(){
        	
        	
        	if(vm.lstParametrosComponenteBase != null){
        		
        			vm.objInformeMonitoreo.lstInformeMonitoreo = [];
        		
   		        	for(var x in vm.lstParametrosComponenteBase){
   		        		if( vm.lstParametrosComponenteBase[x].boolInforma){
   		        			
   		        		  var tempInformeMonitoreo = {
   		        				idComponente : vm.lstParametrosComponenteBase[x].idComponente,
   		             		    idPunto : vm.lstParametrosComponenteBase[x].idPunto,
   	        					idParametroValor : vm.lstParametrosComponenteBase[x].idParametroValor,
   	        					valor_monitoreo : vm.lstParametrosComponenteBase[x].valor_monitoreo == null ? 0 : vm.lstParametrosComponenteBase[x].valor_monitoreo, 
   	        					valor_concentracion_codigo : vm.lstParametrosComponenteBase[x].valor_concentracion_cod, 
   	        					valor_concentracion : obtenerNombreConcetracion(vm.lstParametrosComponenteBase[x].valor_concentracion_cod,vm.lstParametrosComponenteBase[x].lstConcetracionValores), 
   	        					id_unidad_ensayo : parseInt(vm.lstParametrosComponenteBase[x].id_unidad_ensayo),
   	        					valor_ensayo : vm.lstParametrosComponenteBase[x].valor_ensayo == null ? 0 : vm.lstParametrosComponenteBase[x].valor_ensayo,
   	        					valor_concentracion_ensayo_codigo : vm.lstParametrosComponenteBase[x].valor_concentracion_ensayo_cod,
   	        					valor_concentracion_ensayo : obtenerNombreConcetracion(vm.lstParametrosComponenteBase[x].valor_concentracion_ensayo_cod,vm.lstParametrosComponenteBase[x].lstConcetracionValores),
   	        					codigo_ensayo : vm.lstParametrosComponenteBase[x].codigo_ensayo,
   	        					comentario : vm.lstParametrosComponenteBase[x].comentario,
   	        					flg_acreditado : vm.lstParametrosComponenteBase[x].flg_acreditado,
   	        					flg_modifica : vm.lstParametrosComponenteBase[x].flgmodifica,
   	        					flg_nodetectable : vm.lstParametrosComponenteBase[x].bol_nodetectable ? 1 : 0,
   	        					secuencia : vm.lstParametrosComponenteBase[x].secuencia,
   	        					prm1 : CookiesFactory.obtenerCookie(),
   	        					estado : '1'
   		        		  };
   		        		  
   		        		vm.objInformeMonitoreo.lstInformeMonitoreo.push(angular.copy(tempInformeMonitoreo));
   		        		}
   		        	}

   	        		
   	        		InformeMonitoreoFactory.registrarDetalle(angular.copy(vm.objInformeMonitoreo)).then(function(response) {
   	                    if (response != null && response.valido) {
   	                    	$scope.closeThisDialog();
   	                    	toastr.success('Se guardo el informe de monitoreo correctamente');
   	                    }
   	    			});
        		
        	}
        	
        }
        
        function obtenerNombreConcetracion(concentracion_cod, lstConcentracion){
        	if(lstConcentracion.length > 0){
        		for(var x in lstConcentracion){
        			if(lstConcentracion[x].codigoRegistro == concentracion_cod ){
        				return lstConcentracion[x].descripcion;
        			}
        		}
        	}
        }
        
        
        
        function listarConcentracion(){
        	vm.lstConcetracion = [];
        	var dataConcentracion = {
            		codigoMaestro : 'CONCETRACION_TEXTO',
            		idMaestro			:0,
    			  	descripcion 		:'<,=',
            	};
            	
                MaestroFactory.buscarXCodigoMaestro(angular.copy(dataConcentracion)).then(function(response) {
                    if (response != null && response.valido) {
                    	vm.lstConcetracion = angular.copy(response.data);
// if( auxlstConcetracion.length > 0){
// for( var x in auxlstConcetracion){
// if(auxlstConcetracion[x].descripcion.includes("<")){
// if(vm.lstConcetracion.length>0){
// for( var y in vm.lstConcetracion){
// if(!vm.lstConcetracion[y].descripcion.includes("<")){
// vm.lstConcetracion.push(auxlstConcetracion[x]);
// }
// }
// }
// }
// }
// }
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
        }

        
        
        function agregarInformeEnsayo(){
        	vm.mostrarNuevoEnsayo = true;
        	vm.listaArchivosEnsayo = [];
        	vm.objInformeEnsayo = InformeEnsayoFactory.model();
        }
        
        function guardarInformeEnsayo(){
        	vm.objInformeEnsayo.idInstalacion = vm.prmPuntoMonitoreo.idInstalacion;
        	vm.objInformeEnsayo.idAdministrado = vm.prmPuntoMonitoreo.idAdministrado;
        	vm.objInformeEnsayo.idIga = vm.prmPuntoMonitoreo.idIga;
            	InformeEnsayoFactory.registrarArchivo(vm.listaArchivosEnsayo, angular.copy(vm.objInformeEnsayo)).then(function(response) {
                 }).catch(function(error) {
                     toastr.error('Error al grabar la ficha de registro');
                 }).finally(function() {
                     vm.mostrarNuevoEnsayo = false;
                	 cargarEnsayos();
                 });
        }
        
        function eliminarInformeEnsayo(index){
        	InformeEnsayoFactory.eliminar(angular.copy(vm.lstEnsayos[index])).then(function(response) {
                    if (response.valido) {
                  	  toastr.success('Se eliminó el registro correctamente.');
                  	  cargarEnsayos();
                    } else {
                   	  toastr.error('Ocurrió un error al eliminar el registro');
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                }).finally(function() {
                });
      }
        
        function validaDocumentoEnsayo(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                
                vm.listaArchivosEnsayo.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.objInformeEnsayo.codigo_ensayo!='' || vm.objInformeEnsayo.codigo_ensayo!=null && vm.objInformeEnsayo.ruc_consultora != null &&
                			vm.objInformeEnsayo.ruc_consultora != '' && vm.objInformeEnsayo.razon_consultora != null &&
                			vm.objInformeEnsayo.razon_consultora != '' ){
                		document.getElementById("btnAgregarEnsayo").disabled = false;
                }
               
        }
        
        function validaDocumentoInformeMonitoreo(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoInformeMonitoreo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoInformeMonitoreo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoInformeMonitoreo").value = "";
                    return;
                }
                
                vm.listaArchivosInformeMonitoreo.push(prmFileList[0]);
        }
        
        function cargarEnsayos (){
        	vm.lstEnsayos = [];
        	
        	var tempEnsayoFiltro ={
        			idAdministrado : vm.prmPuntoMonitoreo.idAdministrado,
        			idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
        			idIga : vm.prmPuntoMonitoreo.idIga
        	};
        	
        	InformeEnsayoFactory.listar(angular.copy(tempEnsayoFiltro)).then(function(response) {
                 if (response != null && response.valido) {
                     for (var x in response.data) {
                         vm.lstEnsayos.push(response.data[x]);
                     }
                 }
        	 }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos para los combos.');
             });
        }
//        
// function cargarInformes(){
// var tempInformeMonitoreo = {
// idAdministrado: vm.prmPuntoMonitoreo.idAdministrado,
// idIga: vm.prmPuntoMonitoreo.idIga,
// idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
// idEtapa : vm.prmPuntoMonitoreo.idEtapa,
// estado : '1',
// };
//        	 
// InformeMonitoreoFactory.listarHistorial(angular.copy(tempInformeMonitoreo)).then(function(response)
// {
// if (response != null && response.valido) {
// vm.lstInformesMonitoreo = angular.copy(response.data);
// }
// }).catch(function(error) {
// toastr.error('No se pudo obtener los datos.');
// });
// }
        
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        

        function init() {
        		vm.objInformeMonitoreo = $rootScope.objInformeMonitoreo;
        		vm.prmComponente = $rootScope.prmComponente;
            	vm.prmPuntoMonitoreo = $rootScope.prmPuntoMonitoreo;
            	cargarCombos();
                listarParametros();
                obtenerParametros();
                cargarEnsayos();
                listarConcentracion();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInformeMonitoreoController', CargaInfoInformeMonitoreoController);
    /* @ngInject */
    function CargaInfoInformeMonitoreoController($state, toastr, ngDialog, $scope, InformeMonitoreoFactory, DeclaracionEtapaFactory, DeclaracionComponenteFactory, DeclaracionPuntoFactory, DeclaracionParametroFactory, AdministradoFactory, MaestroFactory, InstalacionFactory, InstrumentoGestionFactory,  $filter, $log, $rootScope, EtapaFactory,ComponenteAmbientalFactory, ReporteFactory, API_CONFIG, $window) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 4,
            fillLastPage: true,
            current: 1
        };

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        /* fin de configuracion de tablas */
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        /* Lista de Combos */

        /* declaracion de metodos enlazados a la vista */
        /** ****** */
        vm.cancelar = cancelar;

        // Lista de Etapas para iniciar la declaración de información
        vm.lstEtapas = [];

        // Lista de Periodos para seleccionar la frecuencia por cada componente
		// ambiental
        vm.lstPeriodos = [];

        // Lista de puntos de monitoreo de un componente ambiental
        vm.lstDeclaracionPunto = [];

        // Lista de Parametros de un punto de monitoreo
        vm.lstDeclaracionParametro = [];

        // Filtro para el listado de Etapas para iniciar la declaración de
		// información
        vm.dataEtapa = EtapaFactory.model();

         // Filtro para el listado de Periodos para iniciar la declaración de
		// información
        vm.dataTipoPeriodo = MaestroFactory.model();

        // Objeto principal que contiene toda la informacion para la declaracion
        vm.objInstrumentoGestion ;

        // Objeto para mostrar los datos de la instalación
        vm.objInstalacion;

        // Metodo principal para grabar los datos de la declaración de la
		// información a remitir
        vm.guardarDeclaracion = guardarDeclaracion;

        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.agregarDeclaracionComponentes = agregarDeclaracionComponentes;

        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionComponentes = actualizarDeclaracionComponentes;

        // carga los componenetes de la declaración según la etapa seleccionada
        vm.cargarDeclaracionComponentes = cargarDeclaracionComponentes;

        // carga los puntos de monitorreo según el componente seleccionado
        vm.cargarDeclaracionPuntosMonitoreo = cargarDeclaracionPuntosMonitoreo;

        vm.agregarDeclaracionPuntosMonitoreo = agregarDeclaracionPuntosMonitoreo;

        vm.agregarDeclaracionParametros = agregarDeclaracionParametros;

        vm.verPuntosMonitoreo = false;
        vm.verComponentes = false;

        vm.verMonitoreo = false;

        // confirma eliminación de los compoenestes de un proyecto en la
		// declaración
        vm.confirmarEliminacionComponente = confirmarEliminacionComponente;

        // Componente seleccionado para agregar puntos de monitoreo
        vm.objDeclaracionComponente ;

      // Punto de Monitoreo seleccionado para agregar parametros
        vm.objDeclaracionPuntoMonitoreo ;

        vm.cargarDeclaracionParametros = cargarDeclaracionParametros;

        vm.confirmarEliminacionPunto = confirmarEliminacionPunto;

        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;

        vm.activeetapa = vm.activeetapa;

        vm.active = 0;

        vm.actualizarComentarioIMA= actualizarComentarioIMA;

        vm.guardarInforme = guardarInforme;

        vm.objInformeMonitoreo =  InformeMonitoreoFactory.model();

        vm.validaDocumentoInformeMonitoreo = validaDocumentoInformeMonitoreo;

        vm.listaArchivosInformeMonitoreo = [];
        vm.declaracion = declaracion;

        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;

        vm.objInformeSel;
        vm.abrirInformeMonitoreo = abrirInformeMonitoreo;

        vm.editarArchivoInforme = editarArchivoInforme;
        vm.cargarPeriodosHijos = cargarPeriodosHijos;
        vm.eliminarInforme = eliminarInforme;
        vm.confirmarEliminacionInforme = confirmarEliminacionInforme;
        vm.nuevoInformeMonitoreo = nuevoInformeMonitoreo;
        vm.acciones = InformeMonitoreoFactory.acciones();
        vm.obtenerInformeEnsayo = obtenerInformeEnsayo;
        vm.generarPlantillaMonitoreoMasivo = generarPlantillaMonitoreoMasivo;
        vm.cargarPlantillaMonitoreoMasivo = cargarPlantillaMonitoreoMasivo;
        vm.elejirComponente = elejirComponente;
        vm.filtrarComponentes = filtrarComponentes;
        vm.lstComponentesBase = [];
        
        function filtrarComponentes(informe){
        	
        	vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = [];
        	for(var x in vm.lstComponentesBase){
        		vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(vm.lstComponentesBase[x]);
        	}
        	
        	
        	var arrayCom = informe.componente.split(",");
        	
        	if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length>0){
         		for(var x in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes){
         			var existe = false;
         			
         			if(arrayCom.length>0){
                 		for(var y in arrayCom){
                 			if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[x].idComponente == arrayCom[y]){
                 				existe = true;
                 				break;
                 			}
                 		}
                 		if(!existe){
                 			vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.splice(x,1);
                 		}
         			}
         			
         			
         		}
         	}
        	
        	 cargarDeclaracionPuntosMonitoreo(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[0]);
        }
        
        function elejirComponente(componente){
        	if(componente.blSeleccionado){
        		// agregar
        		vm.objInformeMonitoreo.componente = vm.objInformeMonitoreo.componente + componente.idComponente + ",";
        	}
        	else{
        		// quitar
        		vm.objInformeMonitoreo.componente = vm.objInformeMonitoreo.componente.replace( componente.idComponente + "," ,"");
        	}
        	
        }
        
        
        function cargarPlantillaMonitoreoMasivo(item){
        
        	localStorage.setItem("objInformeMonitoreo", angular.copy(angular.toJson(item)));
             
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo-masivo.html',
                controller: 'CargaInfoInformeMonitoreoMasivoController',
                controllerAs: 'vm',
                width: '30%'
            }).closePromise.then(function(dataDialog) {
            	
            });
        }
        
        function obtenerInformeEnsayo(){
        	
        	var item ={
        		idAdministrado :vm.objInstalacion.idAdministrado,
                idInstalacion : vm.objInstrumentoGestion.idInstalacion,
         		idIga : vm.objInstrumentoGestion.idInstrumentoGestion
        	};
        	
        	$rootScope.objInformeMonitoreo = item;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informe-ensayo/cargainfo-informe-ensayo.html',
                controller: 'CargaInfoInformeEnsayoController',
                controllerAs: 'vm',
                width: '98%'
            }).closePromise.then(function(dataDialog) {
            	for(var x in vm.lstParametrosComponenteBase){
            		
            		if(vm.lstParametrosComponenteBase[x].numeroItem == item.numeroItem){
            			vm.lstParametrosComponenteBase[x].codigo_ensayo = $rootScope.informeEnsayo.codigo_ensayo;
            			break;
            		}
            	}
            });
        }
         

        function editarArchivoInforme(item){
        	$rootScope.objInformeMonitoreo = item;

            ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo-archivo.html',
                controller: 'CargaInfoInformeMonitoreoArchivoController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarInformes();
            });
        }

        function confirmarEliminacionInforme(prmInforme){
          	 ngDialog.openConfirm({
                   template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                   controller: 'DialogConfirmController',
                   controllerAs: 'vm',
                   data: {
                       Titulo: 'Confirmar eliminación',
                       Mensaje: '¿Está seguro de eliminar el informe: ' + prmInforme.numeroItem + '?'
                   },
                   width: '380px'
               }).then(function(okValue) {
            	   prmInforme.flgEliminaDet = "N";
            	   eliminarInforme(prmInforme);
               });
          }

        function confirmarEliminacionInformeDetalle(prmInforme,mensaje){
         	 ngDialog.openConfirm({
                  template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                  controller: 'DialogConfirmController',
                  controllerAs: 'vm',
                  data: {
                      Titulo: 'Confirmar eliminación',
                      Mensaje: mensaje + '¿Está seguro de eliminar el informe: ' + prmInforme.numeroItem + ' y su detalle?'
                  },
                  width: '380px'
              }).then(function(okValue) {
            	  prmInforme.flgEliminaDet = "S";
           	      eliminarInforme(prmInforme);
              });
         }


        function eliminarInforme(prmInforme){
        	 InformeMonitoreoFactory.eliminar(angular.copy(prmInforme)).then(function(response) {
        		 if(response != null ){
        			 if (response.valido) {
         		         toastr.success(response.mensaje);
         		         cargarInformes();
         		     }
         		     else{
         		    	 confirmarEliminacionInformeDetalle(prmInforme,response.mensaje)
         		     }
        		 }
  	   		}).catch(function(error) {
  	   		    toastr.error('No se pudo eliminar el informe de monitoreo.');
  	   		});
        }


        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }


        function validarInformeMonitoreo(){

             	var selBool = 0;

             	if(vm.objInformeMonitoreo.periodo == 0 || vm.objInformeMonitoreo.periodo == ''){
             		toastr.error('Es obligatorio registrar el Año del Informe de Monitoreo');
             		return false;
             	}

             	if(vm.objInformeMonitoreo.frecuencia == 0 || vm.objInformeMonitoreo.frecuencia == ''){
             		toastr.error('Es obligatorio registrar la frecuencia del Informe de Monitoreo');
             		return false;
             	}

             	if(vm.objInformeMonitoreo.numero_frecuencia == 0 || vm.objInformeMonitoreo.numero_frecuencia == ''){
             		toastr.error('Es obligatorio registrar el número de frecuencia del Informe de Monitoreo');
             		return false;
             	}
             	
             	if(vm.lstComponentesBase.length>0){
             		var sel = 0;
             		for(var x in vm.lstComponentesBase){
             			if(vm.lstComponentesBase[x].blSeleccionado){
             				sel = 1;
             				break;
             			}
             		}
             		if(sel==0){
             			toastr.error('Es obligatorio seleccionar por lo menos un componente');
                 		return false;
             		}
             	}
             	
             	if(vm.listaArchivosInformeMonitoreo.length== 0){
             		toastr.error('Es obligatorio adjuntar el archivo de Informe de Monitoreo');
             		return false;
             	}

             	// validar que el informe no exista en la lista
             	if(vm.lstInformesMonitoreo!=null){
	             	if(vm.lstInformesMonitoreo.length>0){
	             		for(var x in vm.lstInformesMonitoreo){
	             			if(vm.lstInformesMonitoreo[x].periodo == vm.objInformeMonitoreo.periodoc &&
	             					vm.lstInformesMonitoreo[x].frecuencia == vm.objInformeMonitoreo.frecuencia &&
	             					vm.lstInformesMonitoreo[x].numero_frecuencia == vm.objInformeMonitoreo.numero_frecuencia &&
	             					vm.lstInformesMonitoreo[x].componente == vm.objInformeMonitoreo.componente){
	             				toastr.error('El informe de monitoreo ya se encuentra registrado');
	                     		return false;
	             			}
	             		}
	             	}
             	}

             	return true;
             }

             function guardarInforme(){
             	if(validarInformeMonitoreo()){
             		confirmarGuardar();
             	}

             }

             function validaDocumentoInformeMonitoreo(prmFileList) {
                 var lstExtens = vm.extension.split(",");

                     if (!prmFileList) {
                         toastr.warning('Debe seleccionar un Archivo');
                         return;
                     }
                     var archivo = prmFileList[0];
                     if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                         toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                         document.getElementById("fileArchivoInformeMonitoreo").value = "";
                         return;
                     }
                     var str = archivo.name;
                     var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                     if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                         toastr.warning('El archivo seleccionado no esta permitido');
                         document.getElementById("fileArchivoInformeMonitoreo").value = "";
                         return;
                     }
                     if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                         toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                         document.getElementById("fileArchivoInformeMonitoreo").value = "";
                         return;
                     }

                     vm.listaArchivosInformeMonitoreo.push(prmFileList[0]);

                     if(vm.objInformeMonitoreo.periodo!=0 && vm.objInformeMonitoreo.frecuencia!=null && vm.objInformeMonitoreo.numero_frecuencia!=0){
                    	 document.getElementById("btnRegistrarInforme").disabled = false;
                     }


             }
             
             function confirmarGuardar() {
                 ngDialog.openConfirm({
                     template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                     controller: 'DialogConfirmController',
                     controllerAs: 'vm',
                     data: {
                    	 Titulo: 'Confirmar Guardar el Informe',
                         Mensaje: '¿Está seguro de guardar el Informe?'
                     },
                     width: '380px'
                 }).then(function(okValue) {
                 	// validar();
             		vm.objInformeMonitoreo.idAdministrado = vm.objInstalacion.idAdministrado;
             		vm.objInformeMonitoreo.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
             		vm.objInformeMonitoreo.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
             		vm.objInformeMonitoreo.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa;
             		vm.objInformeMonitoreo.estado = '1';
             		vm.objInformeMonitoreo.lstInformeMonitoreo = [];
             		vm.objInformeMonitoreo.numero_frecuencia = convertirRomanoALatinoNumero(vm.objInformeMonitoreo.numero_frecuencia);

        	        		InformeMonitoreoFactory.registrarConArchivo(vm.listaArchivosInformeMonitoreo,angular.copy(vm.objInformeMonitoreo)).then(function(response) {
        	                    if (response != null && response.valido) {
        	                    	toastr.success('Se registró el informe de monitoreo correctamente');
        	                    	cargarInformes();
        	                    	vm.verComponentes = false;
        	                    	vm.listaArchivosInformeMonitoreo = [];
        	                    	vm.objInformeMonitoreo =  InformeMonitoreoFactory.model();
        	                    }
        	    			});
                 });
            }

             function cargarInformes(){
            	 	vm.acciones.nuevoInforme = false;
            	 	var tempInformeMonitoreo = {
            			idAdministrado :vm.objInstalacion.idAdministrado,
             			idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
             			idInstalacion : vm.objInstrumentoGestion.idInstalacion,
             			idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
                 		estado : '1',
        			};

            	     InformeMonitoreoFactory.listarHistorial(angular.copy(tempInformeMonitoreo)).then(function(response) {
       		        if (response != null && response.valido) {
       		        	vm.lstInformesMonitoreo = angular.copy(response.data);
       		        }
     	   		}).catch(function(error) {
     	   		         toastr.error('No se pudo obtener los datos.');
     	   		});
            }



        /* declaracion de metodos */
             
        function nuevoInformeMonitoreo(){
        	vm.acciones.nuevoInforme = true;
        	vm.objInformeMonitoreo = InformeMonitoreoFactory.model();
        }     

        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-informe-instrumento');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
        	cargarEtapas();
            cargarPeriodos();
        }

        function cargarEtapas() {
        	vm.dataEtapa.estado = '1';
            EtapaFactory.listarActivosPorUnidad(angular.copy(vm.dataEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = response.data;
                    vm.active = 1;
                    vm.activeetapa = 1;
                    cargarDeclaracionComponentes(vm.lstEtapas[1]);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizarComentarioIMA(){
        	DeclaracionComponenteFactory.actualizarComentarioIMA(angular.copy(vm.objDeclaracionComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function cargarDeclaracionPuntosMonitoreo(prmComponente){


        	if(prmComponente == null){
        		vm.objDeclaracionComponente = DeclaracionComponenteFactory.model();
        		return;
        	}

        	vm.verPuntosMonitoreo = true;
        	vm.verParametros = false;
        	vm.objDeclaracionComponente = prmComponente;
        	var tempPunto = {
        			idAdministrado : prmComponente.idAdministrado,
    				idIga : prmComponente.idIga,
    				idInstalacion : prmComponente.idInstalacion,
    				idEtapa : prmComponente.idEtapa,
    				idComponente : prmComponente.idComponente,
    				origen : '',
            	};

        	 DeclaracionPuntoFactory.listar(angular.copy(tempPunto)).then(function(response) {
                 if (response != null && response.valido) {
                	 vm.lstDeclaracionPunto = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }


        function agregarDeclaracionPuntosMonitoreo(prmPuntoMonitoreo) {

        	if(prmPuntoMonitoreo == null){
        		prmPuntoMonitoreo = DeclaracionPuntoFactory.model();
        		prmPuntoMonitoreo.idAdministrado  = vm.objDeclaracionComponente.idAdministrado;
        		prmPuntoMonitoreo.idIga  = vm.objDeclaracionComponente.idIga;
        		prmPuntoMonitoreo.idInstalacion  = vm.objDeclaracionComponente.idInstalacion;
        		prmPuntoMonitoreo.idEtapa  = vm.objDeclaracionComponente.idEtapa;
        		prmPuntoMonitoreo.idComponente  = vm.objDeclaracionComponente.idComponente;
        		prmPuntoMonitoreo.origen= 'I';
        	}

        	$rootScope.objDeclaracionPunto = prmPuntoMonitoreo;

            ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/declaracion/cargainfo-punto-monitoreo.html',
                controller: 'CargaInfoPuntoMonitoreoController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
            });
        }

  function cargarDeclaracionComponentes(etapa) {

	  		vm.verMonitoreo = true;

        	var tempetapa = null;
        	if( etapa.codetapa != null){
        		tempetapa = etapa.codetapa;
        	}
        	if( etapa.idEtapa != null){
        		tempetapa = etapa.idEtapa;
        	}

        	vm.objInstrumentoGestion.declaracionEtapa.idEtapa = tempetapa;
        	vm.verPuntosMonitoreo = false;
        	vm.verParametros = false;
        	vm.verComponentes = false;

        	if(vm.objInstrumentoGestion.declaracionEtapa.idEtapa == 0){
        		vm.verComponentes = false;
        		return;
        	}

        	vm.objInformeSel = InformeMonitoreoFactory.model();
        	vm.objInformeSel.estado = '0';
        	cargarInformes();

        	var tempComponente = {
        		idAdministrado : vm.objInstalacion.idAdministrado,
        	    idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
        	    idInstalacion : vm.objInstrumentoGestion.idInstalacion,
        	    idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa
        	};

        	DeclaracionComponenteFactory.listarInforme(angular.copy(tempComponente)).then(function(response) {
             if (response != null && response.valido) {
            	 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = angular.copy(response.data);
            	 vm.lstComponentesBase = angular.copy(response.data);
            	 if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length > 0){
            		 cargarDeclaracionPuntosMonitoreo(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[0]);
            	 }
             }
         }).catch(function(error) {
             toastr.error('No se pudo obtener los datos.');
         });

        }

        function agregarDeclaracionComponentes() {
        	$rootScope.lstComponentesBase = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes;
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-selector.html',
                controller: 'ComponenteAmbientalSelectorController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	var array  = $rootScope.lstComponentesSel;
            	if (angular.isDefined(array)){
            		if(array.length > 0){
            			for (var x in array) {
            				var tempComponente = {
            						idAdministrado : vm.objInstalacion.idAdministrado,
            					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
            					idInstalacion : vm.objInstalacion.idInstalacion,
            					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
            					idComponente : array[x].codigo,
            					idFrecuencia : null,
            					estado : 'P',
            					origen : 'I'
            		        };
            				guardarDeclaracionComponentes(tempComponente);
                        }
            		}
            	}

            });
        }

        function guardarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.registrar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	vm.active = 0;
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function actualizarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.actualizar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function confirmarEliminacionComponente(prmDeclaracionComponente){
       	 ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionComponente(prmDeclaracionComponente);
            });
       }

       function eliminarDeclaracionComponente(prmDeclaracionComponente) {
       	vm.verPuntosMonitoreo = false;
       	DeclaracionComponenteFactory.eliminar(angular.copy(prmDeclaracionComponente)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar la parametro');
           });
       }

        function  cargarDeclaracionParametros(prmPuntoMonitoreo){
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	idFrecuencia : vm.objDeclaracionComponente.idFrecuencia,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};

        	$rootScope.prmPuntoMonitoreo = prmPuntoMonitoreo;
        	$rootScope.prmComponente = componente;
        	$rootScope.objInformeMonitoreo = vm.objInformeSel;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-parametro.html',
                controller: 'CargaInfoInformeParametroController',
                controllerAs: 'vm',
                width: '98%'
            });
        }


        function agregarDeclaracionParametros(){

        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};

        	$rootScope.prmComponente = componente;
        	$rootScope.lstParametrosComponenteBase  = vm.lstDeclaracionParametro;
        	ngDialog.open({
                template: 'app/modules/componente-parametro/componente-parametro-selector.html',
                controller: 'ComponenteParametroSelectorController',
                controllerAs: 'vm',

                width: '50%'
            }).closePromise.then(function(dataDialog) {
            	var array = $rootScope.lstParametrosComponenteSel;
                for (var x in array){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.objDeclaracionComponente.idAdministrado,
            				idIga : vm.objDeclaracionComponente.idIga,
            				idInstalacion : vm.objDeclaracionComponente.idInstalacion,
            				idEtapa : vm.objDeclaracionComponente.idEtapa,
            				idComponente : vm.objDeclaracionComponente.idComponente,
            				idPunto : vm.objDeclaracionPuntoMonitoreo.idPunto,
            				idParametroValor : array[x].parametro_valor,
            				idMatriz : array[x].matriz,
            				idSubMatriz: array[x].submatriz,
            				estado : 'P'
                	};
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
                        }
                    }).catch(function(error) {
                        toastr.error('No se pudo obtener los datos.');
                    });
                }
            });
        }


        function confirmarEliminacionPunto(prmDeclaracionPunto){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar el registro?'
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminarDeclaracionPunto(prmDeclaracionPunto);
             });
        }

        function eliminarDeclaracionPunto(prmDeclaracionPunto){
        	vm.verPuntosMonitoreo = false;
        	DeclaracionPuntoFactory.eliminar(angular.copy(prmDeclaracionPunto)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }

        function confirmarEliminacionParametro(prmDeclaracionParametro){
       	 ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionParametro(prmDeclaracionParametro);
            });
       }

       function eliminarDeclaracionParametro(prmDeclaracionParametro){
       	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar el parametro');
           });
       }




        function cargarPeriodos() {

        	vm.dataTipoPeriodo.codigoMaestro = 'TipoPeriodo';
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }


        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }

        function declaracion(item){
        	getMensajeDeclaracionJurada();
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {Titulo: 'Confirmar Cierre',
                    Mensaje: '¿Está seguro de Cerrar el Informe?'
	                 },
                width: '380px'
            }).then(function(okValue) {
                // cerrarInformeMonitoreo(item);
            	ngDialog.openConfirm({
                   template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                   controller: 'DialogConfirmController',
                   controllerAs: 'vm',
                   data: {
	                     Titulo: 'Declaración Jurada',
	                     Mensaje: vm.mensajeDeclaracionJurada
	                 },
                   width: '380px'
               }).then(function(okValue) {
                   cerrarInformeMonitoreo(item);
               });
            });
          }

        function getMensajeDeclaracionJurada() {
            // console.log("vm.dataMaestros.codigoMaestro" +
			// vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }


        function cerrarInformeMonitoreo(item){
        			vm.objInformeSel.estado = '2';
	        		InformeMonitoreoFactory.cerrarInforme(angular.copy(item)).then(function(response) {
	                    if (response != null && response.valido) {
	                    	toastr.success('Se cerró el informe de monitoreo correctamente');
	                    	cargarInformes();
	                    	vm.verComponentes = false;
	                    }
	    			});
        }

        function abrirInformeMonitoreo(item){
        	vm.objInformeSel.estado = '1';
    		InformeMonitoreoFactory.abrirInforme(angular.copy(item)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success('Se Abrió el informe de monitoreo correctamente');
                	cargarInformes();
                	vm.verComponentes = false;
                }
			});
        }

        function actualizarInformeMonitoreo(item){
			vm.objInformeSel.estado = '2';
    		InformeMonitoreoFactory.cerrarInforme(angular.copy(item)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success('Se actualizó el informe de monitoreo correctamente');
                	cargarInformes();
                	vm.verComponentes = false;
                }
			});
}

        function guardarDeclaracion() {

        	// Declaración Etapa
        	vm.objInstrumentoGestion.declaracionEtapa.idAdministrado = vm.objInstalacion.idAdministrado;
        	vm.objInstrumentoGestion.declaracionEtapa.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
        	vm.objInstrumentoGestion.declaracionEtapa.idInstalacion = vm.objInstrumentoGestion.idInstalacion;

        	// Declaracion Componentes
        	vm.declaracionComponente = DeclaracionComponenteFactory.model();
        	// actualizamos la relacion:
           	for (var x in vm.lstComponentes) {
                	if (vm.lstComponentes[x].blSeleccionado){

                		 vm.declaracionComponente.idAdministrado = vm.objInstalacion.idAdministrado;
                		 vm.declaracionComponente.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
                		 vm.declaracionComponente.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
                		 vm.declaracionComponente.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa ;
                		 vm.declaracionComponente.idComponente = vm.lstComponentes[x].codigo ;
                		 vm.declaracionComponente.idFrecuencia = vm.lstComponentes[x].idFrecuencia ;
                		 vm.declaracionComponente.estado = '1' ;
                		 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(angular.copy());
                	}
                }

        	InstrumentoGestionFactory.registrarDeclaracion(angular.copy(vm.objInstrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo guardar.');
            });
        }

            function init() {
                if (angular.isDefined(localStorage.objInstrumentoGestion)) {
                    vm.objInstrumentoGestion = angular.copy(angular.fromJson(localStorage.objInstrumentoGestion));
                    vm.objInstrumentoGestion.declaracionEtapa = DeclaracionEtapaFactory.model();
                }
                if (angular.isDefined(localStorage.objInstalacion)) {
                    vm.objInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                }
                cargarCombos();
                obtenerParametros();
            }

            function cargarPeriodosHijos(itempadre) {

            	var dataTipoPeriodo = {
            		codigoMaestro : 'TipoPeriodo',
            		codigoRegistroPadre :  itempadre
            	};

                MaestroFactory.buscarRegistroHijo(angular.copy(dataTipoPeriodo)).then(function(response) {
                    if (response != null && response.valido) {
                    	vm.lstPeriodosHijos = response.data;
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });

            }

            function convertirRomanoALatinoNumero(numromano){
        		if(numromano=='ENERO'){
        			return 1;
        		}
        		if(numromano=='FEBRERO'){
        			return 2;
        		}
        		if(numromano=='MARZO'){
        			return 3;
        		}
        		if(numromano=='ABRIL'){
        			return 4;
        		}
        		if(numromano=='MAYO'){
        			return 5;
        		}
        		if(numromano=='JUNIO'){
        			return 6;
        		}
        		if(numromano=='JULIO'){
        			return 7;
        		}
        		if(numromano=='AGOSTO'){
        			return 8;
        		}
        		if(numromano=='SEPTIEMBRE'){
        			return 9;
        		}
        		if(numromano=='OCTUBRE'){
        			return 11;
        		}
        		if(numromano=='NOVIEMBRE'){
        			return 12;
        		}
        		if(numromano=='DICIEMBRE'){
        			return 13;
        		}
        		if(numromano=='I'){
        			return 1;
        		}
        		if(numromano=='II'){
        			return 2;
        		}
        		if(numromano=='III'){
        			return 3;
        		}
        		if(numromano=='IV'){
        			return 4;
        		}
        		if(numromano=='V'){
        			return 5;
        		}
        		if(numromano=='VI'){
        			return 6;
        		}

        }
            
        function generarPlantillaMonitoreoMasivo(informeMonitoreo){
        	ReporteFactory.generarPlantillaMonitoreoMasivo(informeMonitoreo).then(function(response) {
    			if (response.valido) {
    				toastr.success('Se generó la plantilla para la carga masiva');
    				cargarInformes();
                }
    			else{
    				toastr.error(response.mensaje);
    			}
    				
            }).catch(function(error) {
            	toastr.error(response.mensaje);
            });
        }

        init();
        /* fin de controller */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInformeMonitoreoMasivoController', CargaInfoInformeMonitoreoMasivoController);
    /* @ngInject */
    function CargaInfoInformeMonitoreoMasivoController($state, toastr, ngDialog, $scope, InformeMonitoreoFactory, DeclaracionEtapaFactory, DeclaracionComponenteFactory, DeclaracionPuntoFactory, DeclaracionParametroFactory, AdministradoFactory, MaestroFactory, InstalacionFactory, InstrumentoGestionFactory,  $filter, $log, $rootScope, EtapaFactory,ComponenteAmbientalFactory, ReporteFactory, API_CONFIG, $window) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 4,
            fillLastPage: true,
            current: 1
        };

        vm.objInformeMonitoreo =  InformeMonitoreoFactory.model();

        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.acciones = InformeMonitoreoFactory.acciones();
        vm.validaDocumento = validaDocumento;
        vm.listaArchivos = [];
        vm.guardar = guardar;
        
        function guardar(){
        	
        	InformeMonitoreoFactory.registrarMasivo(vm.listaArchivos,angular.copy(vm.objInformeMonitoreo)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success(response.mensaje);
                    ngDialog.close();
                }
                else{
                	toastr.error(response.mensaje);
                	vm.listaArchivos = [];
                	document.getElementById("fileArchivoInformeMonitoreo").value = "";
                }
            }).catch(function(error) {
                toastr.error('Se produjo un error al registrar la información.');
            });
        } 
        
        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");

                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoInformeMonitoreo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoInformeMonitoreo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoInformeMonitoreo").value = "";
                    return;
                }

                vm.listaArchivos.push(prmFileList[0]);
               	
                document.getElementById("btnRegistrarInformeMasivo").disabled = false;
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumentoExcel);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumentoExcel);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function init() {
            if (angular.isDefined(localStorage.objInformeMonitoreo)) {
               vm.objInformeMonitoreo = angular.copy(angular.fromJson(localStorage.objInformeMonitoreo));
            }
            obtenerParametros();
        }

        init();
        /* fin de controller */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInformeMonitoreoArchivoController', CargaInfoInformeMonitoreoArchivoController);
    /** @ngInject */
    function CargaInfoInformeMonitoreoArchivoController($rootScope, InformeMonitoreoFactory ,MaestroFactory ,DeclaracionComponenteFactory, DeclaracionPuntoFactory, CookiesFactory , toastr, $scope, ngDialog, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        
        // Objeto principal de los datos del punto de monitoreo
        vm.objDeclaracionPunto = DeclaracionPuntoFactory.model(); 
        
        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.registrarDeclaracionPunto = registrarDeclaracionPunto;
        
        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionPunto = actualizarDeclaracionPunto; 
        

        vm.guardarDeclaracionPunto = guardarDeclaracionPunto;
        
        vm.mostrarNoEspecificaNorte = mostrarNoEspecificaNorte;
        
        vm.mostrarNoEspecificaEste = mostrarNoEspecificaEste;
        
        
        // boleanos para no especificar puntos de monitoreo
        vm.boolNorte = false;
        vm.boolEste = false;
        
        vm.objInformeMonitoreo;
        
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];
        
        vm.actualizarArchivo = actualizarArchivo;
        vm.lstPeriodos = [];
        vm.validaDocumento = validaDocumento;
        
        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                
                vm.listaArchivos = [];
                
                vm.listaArchivos.push(prmFileList[0]);
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        
        function actualizarArchivo(){
        	vm.objInformeMonitoreo.prm1 = CookiesFactory.obtenerCookie();
	        InformeMonitoreoFactory.actualizarArchivo(vm.listaArchivos,angular.copy(vm.objInformeMonitoreo)).then(function(response) {
	        	if (response != null && response.valido) {
	                    toastr.success('Se actualizó el informe de monitoreo correctamente');
	                    ngDialog.close();
	        	}
	        	else{
	        		 toastr.error(response.mensaje);
	        	}
	    	});
        }
        
        
        
        function mostrarNoEspecificaNorte(){
        	vm.objDeclaracionPunto.puntoNorte = "";
       	 	if(vm.boolNorte){
       	 		vm.objDeclaracionPunto.puntoNorte = "No Presenta";
       	 	}
        }
        
        function mostrarNoEspecificaEste(){
        	vm.objDeclaracionPunto.puntoEste = "";
        	 if(vm.boolEste){
        		 vm.objDeclaracionPunto.puntoEste = "No Presenta";
        	 }
        }
        
        function guardarDeclaracionPunto(){
        	  if (vm.objDeclaracionPunto.idPunto == 0) {
              	confirmarGuardar();
              } else {
            	  actualizarDeclaracionPunto();
              }
        }
        
        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	registrarDeclaracionPunto();
            });
        }
        
        function registrarDeclaracionPunto(){
        	vm.objDeclaracionPunto.prm1 = CookiesFactory.obtenerCookie();
        	DeclaracionPuntoFactory.registrar(angular.copy(vm.objDeclaracionPunto)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function actualizarDeclaracionPunto(){
        	vm.objDeclaracionPunto.prm1 = CookiesFactory.obtenerCookie();
        	DeclaracionPuntoFactory.actualizar(angular.copy(vm.objDeclaracionPunto)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarPeriodos() {
        	
        	var dataTipoPeriodo = MaestroFactory.model();
        	
        	dataTipoPeriodo.codigoMaestro = 'TipoPeriodo';
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
        }
   
        
        /* fin de metodos */
        function init() {
        	vm.objInformeMonitoreo = $rootScope.objInformeMonitoreo;
        	if(vm.objInformeMonitoreo.fechaPresentacion != null){
        		vm.objInformeMonitoreo.fechaPresentacion = new Date(vm.objInformeMonitoreo.fechaPresentacion);
        	}
        	
        	obtenerParametros();
        	cargarPeriodos();
        }
        
        function cargarCombos(){
        	cargarZona();
        }
        
        function cargarZona(){
        	
        }
        
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoInformeInstrumentoController', CargaInfoInformeInstrumentoController);
    /* @ngInject */
    function CargaInfoInformeInstrumentoController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory,  InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        vm.nuevoIGA = nuevoIGA;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.irDeclaracion = irDeclaracion;
        vm.idInstrumentoGestion;
        vm.irInformeMonitoreo = irInformeMonitoreo;
        
        function irDeclaracion(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-declaracion');
        }
        
        function irInformeMonitoreo(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.cargainfo-informe-monitoreo');
        }
        
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarMonitoreoPorInstalacion(angular.copy(vm.prmInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.idAdministrado =  angular.copy(vm.prmInstalacion.idAdministrado);
                vm.prmInstrumentoGestion.estado = "T";
                buscarInstrumentoGestion();
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        // Nuevo IGA
        function nuevoIGA(datoParametro) {
        	
        	if(datoParametro != null){
        		vm.idInstrumentoGestion = datoParametro.idInstrumentoGestion;
        		$rootScope.prmdatoInstrumento = angular.copy(datoParametro);
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '700px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	else{
        		$rootScope.prmdatoInstrumento = angular.copy(InstrumentoGestionFactory.model());
        		 ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html',
                     controller: 'CargaInfoInstrumentoGestionEdicionController',
                     controllerAs: 'vm',
                     width: '700px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	
        }
        
        function confirmarEliminacion(prmInstrumentoGestion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstrumentoGestion.resolucion  + ' ' + prmInstrumentoGestion.auxTipoIgaNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstrumentoGestion);
            });
        }
        
        function eliminar(prmInstrumentoGestion){
        	 	InstrumentoGestionFactory.eliminar(angular.copy(prmInstrumentoGestion)).then(function(response) {
                     if (response.valido) {
                         toastr.success(response.mensaje);
                         buscarInstrumentoGestion();
                     } else {
                         toastr.error(response.mensaje)
                     }
                 }).catch(function(error) {
                     toastr.error('Ocurrió un error al eliminar la parametro');
                 });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('CargaInfoInformeEnsayoController', CargaInfoInformeEnsayoController);
    /* @ngInject */
    function CargaInfoInformeEnsayoController(ngDialog, toastr, $scope, $rootScope, API_CONFIG, DeclaracionPuntoFactory ,InformeEnsayoFactory , ComponenteAmbientalFactory, ComponenteAmbientalParametroFactory, DeclaracionParametroFactory ,MaestroFactory, NormaLegalFactory, NormasFactory, CookiesFactory, InformeMonitoreoFactory) {
        var vm = this;
        vm.urlData = API_CONFIG.url;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstParametrosComponente = [];
        vm.lstParametrosComponenteBase  = [];
        vm.lstMatriz = [];
        vm.lstSubMatriz = [];
        vm.lstParametrosComponenteSel = [];
        vm.matriz;
        vm.submatriz;
        
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        /* implementación de metodos */
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.lstUnidadMedida = [];
        vm.lstFrecuencia = [];
        vm.lstNormaLegal = [];
        vm.prmComponenteParametro = ComponenteAmbientalParametroFactory.model();
        vm.guardar = guardar;
        vm.confirmarGuardar = confirmarGuardar;
        vm.listarSubMatriz = listarSubMatriz;
        vm.prmPuntoMonitoreo;
        vm.agregarParametro = agregarParametro;
        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;
        vm.listaArchivosEnsayo= [];
        vm.listaArchivosInformeMonitoreo= [];
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
    	vm.objInformeEnsayo = InformeEnsayoFactory.model();
    	vm.lstEnsayos = [];
    	vm.lstInformesMonitoreo = [];
    	vm.agregarInformeEnsayo = agregarInformeEnsayo;
    	vm.guardarInformeEnsayo = guardarInformeEnsayo;
    	vm.eliminarInformeEnsayo = eliminarInformeEnsayo;
        vm.mostrarNuevoEnsayo = false;
        vm.validaDocumentoEnsayo = validaDocumentoEnsayo;
        vm.actualizarComentarioIMA = actualizarComentarioIMA;
        vm.objInformeMonitoreo = InformeMonitoreoFactory.model();
        vm.lstConcetracion = [];
        vm.confirmarEliminacionResultado = confirmarEliminacionResultado;
        vm.seleccionarInformeEnsayo = seleccionarInformeEnsayo;
        vm.obtenerParametros = obtenerParametros;
        function confirmarEliminacionResultado(item){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar los valores reportados de esta fila?'
                 },
                 width: '380px'
             }).then(function(okValue) {
                 eliminarInformeParametroResultado(item);
             });
        }

        function actualizarComentarioIMA(){
        	DeclaracionPuntoFactory.actualizarComentarioIMA(angular.copy(vm.prmPuntoMonitoreo)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });	
        }
        
        
        function confirmarEliminacionParametro(prmDeclaracionParametro){
          	 ngDialog.openConfirm({
                   template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                   controller: 'DialogConfirmController',
                   controllerAs: 'vm',
                   data: {
                       Titulo: 'Confirmar eliminación',
                       Mensaje: '¿Está seguro de eliminar el registro?'
                   },
                   width: '380px'
               }).then(function(okValue) {
                   eliminarDeclaracionParametro(prmDeclaracionParametro);
               });
          }
        
        function eliminarDeclaracionParametro(prmDeclaracionParametro){
           	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
                   if (response.valido) {
                       toastr.success(response.mensaje);
                       listarParametros();
                   } else {
                       toastr.error(response.mensaje)
                   }
               }).catch(function(error) {
                   toastr.error('Ocurrió un error al eliminar el parametro');
               });
           }
        
        function eliminarInformeParametroResultado(prmInformeDetalle){
        	
        	 var tempInformeMonitoreoDet = {
        			 	idInformeMonitoreo : prmInformeDetalle.idInformeMonitoreo,
    					secuencia : prmInformeDetalle.secuencia
        		  };
        		  
        	
        	InformeMonitoreoFactory.eliminarDetalle(angular.copy(tempInformeMonitoreoDet)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarParametros();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar el parametro');
            });
        }
        
		function listarParametros(){
			var tempParametroMonitoreo = {
		    		idAdministrado : vm.prmPuntoMonitoreo.idAdministrado,
		    	    idIga : vm.prmPuntoMonitoreo.idIga,
		    	    idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
		    	    idEtapa : vm.prmPuntoMonitoreo.idEtapa,
		    	    idComponente : vm.prmPuntoMonitoreo.idComponente,
		    	    idPunto : vm.prmPuntoMonitoreo.idPunto,
		    	    idInformeMonitoreo : vm.objInformeMonitoreo.idInformeMonitoreo
		    	};
			 
		    	DeclaracionParametroFactory.listarInforme(angular.copy(tempParametroMonitoreo)).then(function(response) {
		         if (response != null && response.valido) {
		        	 vm.lstParametrosComponenteBase = angular.copy(response.data);
		         }
		     }).catch(function(error) {
		         toastr.error('No se pudo obtener los datos.');
		     });
		}

        function listar() {
        	vm.prmComponenteParametro.componente = vm.prmComponente.codigo;
        	ComponenteAmbientalParametroFactory.listar(angular.copy(vm.prmComponenteParametro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstParametrosComponente = angular.copy(response.data);
                       	for (var y = 0; y < vm.lstParametrosComponente.length; y++) { 
                       		for(var x in vm.lstParametrosComponenteBase){
                           		if(vm.lstParametrosComponenteBase[x].idParametroValor == vm.lstParametrosComponente[y].parametro_valor){
                           			// ya existe
                           			vm.lstParametrosComponente.splice(y,1);
                           			y--;
                           			break;
                           		}
                           	}
                       	}
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarCombos() {
			listarUnidadMedida();
      	  	listarNormaLegal();
      	  	listarFrecuencia();
      	  	listarMatriz();
      	  	listarSubMatriz();
      	  	listarConcentracion();
		}
		
        function listarMatriz(){
        	var prmComponente = {
        			codigo : vm.prmComponente.codigo,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        
        function listarSubMatriz(idMatriz){
        	
        	 vm.lstSubMatriz = [];
        	 
        	if (idMatriz == 0 || idMatriz == null){
        		return;
        	}
        	
        	var prmComponente = {
        			codigo : idMatriz,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstSubMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        function listarUnidadMedida() {
        	
        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstUnidadMedida = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstUnidadMedida);
        }
        
        function listarFrecuencia() {
        	var dataFrecuencia = {
        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstFrecuencia = angular.copy(response.data);;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstFrecuencia);
        }
        
        function listarNormaLegal() {
        	 
        	var dataNormaLegal = NormasFactory.modelNormas();
        	
        	NormasFactory.listar(angular.copy(dataNormaLegal)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstNormaLegal = angular.copy(response.data);
                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function agregarParametro(parametroComponente){
                if (parametroComponente.blSeleccionado){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.prmPuntoMonitoreo.idAdministrado,
            				idIga : vm.prmPuntoMonitoreo.idIga,
            				idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
            				idEtapa : vm.prmPuntoMonitoreo.idEtapa,
            				idComponente : parametroComponente.componente,
            				idPunto : vm.prmPuntoMonitoreo.idPunto,
            				idParametroValor : parametroComponente.parametro_valor,
            				estado : 'P'
                	};
                }
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	listar();
                        	listarParametros();
                        }
                });
        }
        
        function validarInformeMonitoreo(){
        	
        	var selBool = 0;
        
        	
        	for(var x in vm.lstParametrosComponenteBase){
	        		if( vm.lstParametrosComponenteBase[x].boolInforma){
	        			selBool = selBool + 1;
	        			
	        			var nombreConMoni = obtenerNombreConcetracion(vm.lstParametrosComponenteBase[x].valor_concetracion_cod,vm.lstParametrosComponenteBase[x].lstConcetracionValores);
	        			var nombreConEnsa = obtenerNombreConcetracion(vm.lstParametrosComponenteBase[x].valor_concetracion_ensayo_cod,vm.lstParametrosComponenteBase[x].lstConcetracionValores);
	        			
	        			if(nombreConMoni == null){
	        				nombreConMoni = '';
	        			}
	        			
	        			if(nombreConEnsa == null){
	        				nombreConEnsa = '';
	        			}
	        			
	        			if((vm.lstParametrosComponenteBase[x].valor_ensayo == 0 || vm.lstParametrosComponenteBase[x].valor_ensayo==null) &&
	        					(vm.lstParametrosComponenteBase[x].valor_concetracion_ensayo_cod == 0 || nombreConEnsa == '<' || nombreConEnsa.toUpperCase() == 'RANGO') && !vm.lstParametrosComponenteBase[x].bol_nodetectable ){
	        				toastr.error('Es obligatorio registrar el valor del informe de ensayo');
	        				return false;
	        			}
	        			if(vm.lstParametrosComponenteBase[x].codigo_ensayo == '' || vm.lstParametrosComponenteBase[x].codigo_ensayo==null){
	        				toastr.error('Es obligatorio registrar el código de ensayo');
	        				return false;
	        			}
	        			if(vm.lstParametrosComponenteBase[x].flg_acreditado == '' || vm.lstParametrosComponenteBase[x].flg_acreditado==null){
	        				toastr.error('Es obligatorio seleccionar la acreditación del laboratorio por cada parámetro');
	        				return false;
	        			}
	        		}
        	}
        	
        	if(selBool==0){
        		toastr.error('Es obligatorio seleccionar la columna Informa para al menos un parámetro');
				return false;
        	}
        	
        	return true;
        }
        
        function confirmarGuardar(){
        	if(validarInformeMonitoreo()){
	            	 guardar();
        	}
        }
        
        function seleccionarInformeEnsayo(informeEnsayo){
        	$rootScope.informeEnsayo = informeEnsayo;
        	$scope.closeThisDialog();
        }
      
        function agregarInformeEnsayo(){
        	vm.mostrarNuevoEnsayo = true;
        	vm.listaArchivosEnsayo = [];
        	vm.objInformeEnsayo = InformeEnsayoFactory.model();
        }
        
        function guardarInformeEnsayo(){
        	vm.objInformeEnsayo.idInstalacion = vm.objInformeMonitoreo.idInstalacion;
        	vm.objInformeEnsayo.idAdministrado = vm.objInformeMonitoreo.idAdministrado;
        	vm.objInformeEnsayo.idIga = vm.objInformeMonitoreo.idIga;
            	InformeEnsayoFactory.registrarArchivo(vm.listaArchivosEnsayo, angular.copy(vm.objInformeEnsayo)).then(function(response) {
                 }).catch(function(error) {
                     toastr.error('Error al grabar la ficha de registro');
                 }).finally(function() {
                     vm.mostrarNuevoEnsayo = false;
                	 cargarEnsayos();
                 });
        }
        
        function eliminarInformeEnsayo(index){
        	InformeEnsayoFactory.eliminar(angular.copy(vm.lstEnsayos[index])).then(function(response) {
                    if (response.valido) {
                  	  toastr.success('Se eliminó el registro correctamente.');
                  	  cargarEnsayos();
                    } else {
                   	  toastr.error('Ocurrió un error al eliminar el registro');
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                }).finally(function() {
                });
      }
        
        function validaDocumentoEnsayo(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                
                vm.listaArchivosEnsayo.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.objInformeEnsayo.codigo_ensayo!='' || vm.objInformeEnsayo.codigo_ensayo!=null && vm.objInformeEnsayo.ruc_consultora != null &&
                			vm.objInformeEnsayo.ruc_consultora != '' && vm.objInformeEnsayo.razon_consultora != null &&
                			vm.objInformeEnsayo.razon_consultora != '' ){
                		document.getElementById("btnAgregarEnsayo").disabled = false;
                }
               
        }
        
      
        
        function cargarEnsayos (){
        	vm.lstEnsayos = [];
        	
        	var tempEnsayoFiltro ={
        			idAdministrado : vm.objInformeMonitoreo.idAdministrado,
        			idInstalacion : vm.objInformeMonitoreo.idInstalacion,
        			idIga : vm.objInformeMonitoreo.idIga
        	};
        	
        	InformeEnsayoFactory.listar(angular.copy(tempEnsayoFiltro)).then(function(response) {
                 if (response != null && response.valido) {
                     for (var x in response.data) {
                         vm.lstEnsayos.push(response.data[x]);
                     }
                 }
        	 }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos para los combos.');
             });
        }
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        function guardar(){
        	
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function init() {
        		vm.objInformeMonitoreo = $rootScope.objInformeMonitoreo;
                cargarEnsayos();
                obtenerParametros();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoPuntoMonitoreoController', CargaInfoPuntoMonitoreoController);
    /** @ngInject */
    function CargaInfoPuntoMonitoreoController($rootScope, DeclaracionComponenteFactory, DeclaracionPuntoFactory, CookiesFactory , toastr, $scope, ngDialog, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        
        // Objeto principal de los datos del punto de monitoreo
        vm.objDeclaracionPunto = DeclaracionPuntoFactory.model(); 
        
        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.registrarDeclaracionPunto = registrarDeclaracionPunto;
        
        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionPunto = actualizarDeclaracionPunto; 

        vm.guardarDeclaracionPunto = guardarDeclaracionPunto;
        
        vm.mostrarNoEspecificaNorte = mostrarNoEspecificaNorte;
        
        vm.mostrarNoEspecificaEste = mostrarNoEspecificaEste;
        
        
        // boleanos para no especificar puntos de monitoreo
        vm.boolNorte = false;
        vm.boolEste = false;
        
        function mostrarNoEspecificaNorte(){
        	vm.objDeclaracionPunto.puntoNorte = "";
       	 	if(vm.boolNorte){
       	 		vm.objDeclaracionPunto.puntoNorte = "No Presenta";
       	 	}
        }
        
        function mostrarNoEspecificaEste(){
        	vm.objDeclaracionPunto.puntoEste = "";
        	 if(vm.boolEste){
        		 vm.objDeclaracionPunto.puntoEste = "No Presenta";
        	 }
        }
        
        function guardarDeclaracionPunto(){
        	  if (vm.objDeclaracionPunto.idPunto == 0) {
              	confirmarGuardar();
              } else {
            	  actualizarDeclaracionPunto();
              }
        }
        
        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	//toastr.success('Se guardo los puntos de monitoreo correctamente');
            	registrarDeclaracionPunto();
            });
        }
        
        function registrarDeclaracionPunto(){
        	vm.objDeclaracionPunto.prm1 = CookiesFactory.obtenerCookie();
        	DeclaracionPuntoFactory.registrar(angular.copy(vm.objDeclaracionPunto)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function actualizarDeclaracionPunto(){
        	vm.objDeclaracionPunto.prm1 = CookiesFactory.obtenerCookie();
        	DeclaracionPuntoFactory.actualizar(angular.copy(vm.objDeclaracionPunto)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        /* fin de metodos */
        function init() {
            cargarCombos();
            vm.objDeclaracionPunto = $rootScope.objDeclaracionPunto;
           
        }
        
        function cargarCombos(){
        	cargarZona();
        }
        
        function cargarZona(){
        	
        }
        
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('CargaInfoDeclaracionParametroController', CargaInfoDeclaracionParametroController);
    /* @ngInject */
    function CargaInfoDeclaracionParametroController(ngDialog, toastr, $scope, $rootScope, API_CONFIG, InformeEnsayoFactory , ComponenteAmbientalFactory, ComponenteAmbientalParametroFactory, DeclaracionParametroFactory ,MaestroFactory, NormaLegalFactory, NormasFactory, CookiesFactory, InformeMonitoreoFactory) {
        var vm = this;
        vm.urlData = API_CONFIG.url;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstParametrosComponente = [];
        vm.lstParametrosComponenteBase  = [];
        vm.lstMatriz = [];
        vm.lstSubMatriz = [];
        vm.lstParametrosComponenteSel = [];
        vm.matriz;
        vm.submatriz;
        
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        /* implementación de metodos */
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.lstUnidadMedida = [];
        vm.lstFrecuencia = [];
        vm.lstNormaLegal = [];
        vm.prmComponenteParametro = ComponenteAmbientalParametroFactory.model();
        vm.salir = salir;
        vm.listarSubMatriz = listarSubMatriz;
        vm.prmPuntoMonitoreo;
        vm.agregarParametro = agregarParametro;
        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;
        vm.listaArchivos= [];
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.validaDocumento = validaDocumento;
    	
        function confirmarEliminacionParametro(prmDeclaracionParametro){
          	 ngDialog.openConfirm({
                   template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                   controller: 'DialogConfirmController',
                   controllerAs: 'vm',
                   data: {
                       Titulo: 'Confirmar eliminación',
                       Mensaje: '¿Está seguro de eliminar el registro?'
                   },
                   width: '380px'
               }).then(function(okValue) {
                   eliminarDeclaracionParametro(prmDeclaracionParametro);
               });
          }
        
        function eliminarDeclaracionParametro(prmDeclaracionParametro){
           	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
                   if (response.valido) {
                       toastr.success(response.mensaje);
                       listarParametros();
                   } else {
                       toastr.error(response.mensaje)
                   }
               }).catch(function(error) {
                   toastr.error('Ocurrió un error al eliminar el parametro');
               });
           }
        
		function listarParametros(){
			var tempPuntoMonitoreo = {
		    		idAdministrado : vm.prmPuntoMonitoreo.idAdministrado,
		    	    idIga : vm.prmPuntoMonitoreo.idIga,
		    	    idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
		    	    idEtapa : vm.prmPuntoMonitoreo.idEtapa,
		    	    idComponente : vm.prmPuntoMonitoreo.idComponente,
		    	    idPunto : vm.prmPuntoMonitoreo.idPunto,
		    	};
			 
		    	DeclaracionParametroFactory.listar(angular.copy(tempPuntoMonitoreo)).then(function(response) {
		         if (response != null && response.valido) {
		        	 vm.lstParametrosComponenteBase = angular.copy(response.data);
		        	 listar();
		         }
		     }).catch(function(error) {
		         toastr.error('No se pudo obtener los datos.');
		     });
		}

        function listar() {
        	vm.prmComponenteParametro.componente = vm.prmComponente.codigo;
        	ComponenteAmbientalParametroFactory.listar(angular.copy(vm.prmComponenteParametro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstParametrosComponente = angular.copy(response.data);
                       	for (var y = 0; y < vm.lstParametrosComponente.length; y++) { 
                       		for(var x in vm.lstParametrosComponenteBase){
                           		if(vm.lstParametrosComponenteBase[x].idParametroValor == vm.lstParametrosComponente[y].parametro_valor){
                           			// ya existe
                           			vm.lstParametrosComponente.splice(y,1);
                           			y--;
                           			break;
                           		}
                           	}
                       	}
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarCombos() {
			listarUnidadMedida();
      	  	listarNormaLegal();
      	  	listarFrecuencia();
      	  	listarMatriz();
      	  	listarSubMatriz();
		}
		
        function listarMatriz(){
        	var prmComponente = {
        			codigo : vm.prmComponente.codigo,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        
        function listarSubMatriz(idMatriz){
        	
        	 vm.lstSubMatriz = [];
        	 
        	if (idMatriz == 0 || idMatriz == null){
        		return;
        	}
        	
        	var prmComponente = {
        			codigo : idMatriz,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstSubMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        function listarUnidadMedida() {
        	
        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstUnidadMedida = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstUnidadMedida);
        }
        
        function listarFrecuencia() {
        	var dataFrecuencia = {
        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstFrecuencia = angular.copy(response.data);;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstFrecuencia);
        }
        
        function listarNormaLegal() {
        	 
        	var dataNormaLegal = NormasFactory.modelNormas();
        	dataNormaLegal.componente = vm.prmComponente.codigo
        	
        	NormasFactory.listarPorComponente(angular.copy(dataNormaLegal)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstNormaLegal = angular.copy(response.data);
                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function agregarParametro(parametroComponente){
                if (parametroComponente.blSeleccionado){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.prmPuntoMonitoreo.idAdministrado,
            				idIga : vm.prmPuntoMonitoreo.idIga,
            				idInstalacion : vm.prmPuntoMonitoreo.idInstalacion,
            				idEtapa : vm.prmPuntoMonitoreo.idEtapa,
            				idComponente : parametroComponente.componente,
            				idPunto : vm.prmPuntoMonitoreo.idPunto,
            				idParametroValor : parametroComponente.parametro_valor,
            				estado : 'P',
            				prm1 : CookiesFactory.obtenerCookie() , 
                	};
                }
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	listar();
                        	listarParametros();
                        }
                });
        }
        
        
        function salir(){
            $scope.closeThisDialog();
        	
        }
        
        
        function agregarInformeEnsayo(){
        	vm.mostrarNuevoEnsayo = true;
        	vm.listaArchivos = [];
        	vm.objInformeEnsayo = InformeEnsayoFactory.model();
        }
        
        
        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoEnsayo").value = "";
                    return;
                }
                
                vm.listaArchivos.push(prmFileList[0]);
                
                // habilitamos el boton dependiendo de otras condiciones
                if(vm.objInformeEnsayo.codigo_ensayo!='' || vm.objInformeEnsayo.codigo_ensayo!=null && vm.objInformeEnsayo.ruc_consultora != null &&
                			vm.objInformeEnsayo.ruc_consultora != '' && vm.objInformeEnsayo.razon_consultora != null &&
                			vm.objInformeEnsayo.razon_consultora != '' ){
                		document.getElementById("btnAgregarEnsayo").disabled = false;
                }
               
        }
        
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        
        

        function init() {
        		vm.prmComponente = $rootScope.prmComponente;
            	vm.prmPuntoMonitoreo = $rootScope.prmPuntoMonitoreo;
            	cargarCombos();
                listarParametros();
                obtenerParametros();
        	
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoAccionAdministradoController', CargaInfoAccionAdministradoController);
    /* @ngInject */
    function CargaInfoAccionAdministradoController($state, toastr, ngDialog, $scope, DeclaracionEtapaFactory, DeclaracionComponenteFactory, DeclaracionPuntoFactory, CookiesFactory, DeclaracionParametroFactory, AdministradoFactory, MaestroFactory, InstalacionFactory, InstrumentoGestionFactory,  $filter, $log, $rootScope, EtapaFactory,ComponenteAmbientalFactory, API_CONFIG, $window) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        /* Lista de Combos */

        /* declaracion de metodos enlazados a la vista */
        /** ****** */
        vm.cancelar = cancelar;
        
        // Lista de Etapas para iniciar la declaración de información
        vm.lstEtapas = [];
        
        // Lista de Periodos para seleccionar la frecuencia por cada componente
		// ambiental
        vm.lstPeriodos = [];
        
        // Lista de puntos de monitoreo de un componente ambiental
        vm.lstDeclaracionPunto = [];
        
        // Lista de Parametros de un punto de monitoreo
        vm.lstDeclaracionParametro = [];
        
        // Filtro para el listado de Etapas para iniciar la declaración de
		// información
        vm.dataEtapa = EtapaFactory.model();
       
         // Filtro para el listado de Periodos para iniciar la declaración de
		// información
        vm.dataTipoPeriodo = MaestroFactory.model();
        
        // Objeto principal que contiene toda la informacion para la declaracion
        vm.objInstrumentoGestion ;
        
        // Objeto para mostrar los datos de la instalación
        vm.objInstalacion;
        
        // Metodo principal para grabar los datos de la declaración de la
		// información a remitir
        vm.guardarDeclaracion = guardarDeclaracion;
        
        // Metodo para llamar al selector de componentes y agregar a la
		// declaración
        vm.agregarDeclaracionComponentes = agregarDeclaracionComponentes;
        
        // actualiza la frecuencia del componete seleccionado
        vm.actualizarDeclaracionComponentes = actualizarDeclaracionComponentes; 
        
        // carga los componenetes de la declaración según la etapa seleccionada
        vm.cargarDeclaracionComponentes = cargarDeclaracionComponentes;
        
        // carga los puntos de monitorreo según el componente seleccionado
        vm.cargarDeclaracionPuntosMonitoreo = cargarDeclaracionPuntosMonitoreo;
        
        vm.agregarDeclaracionPuntosMonitoreo = agregarDeclaracionPuntosMonitoreo;
        
        vm.agregarDeclaracionParametros = agregarDeclaracionParametros;
        
        vm.verPuntosMonitoreo = false;
        vm.verFrecuenciaAbandono = false;
        vm.verComponentes = false;
        	
        // confirma eliminación de los compoenestes de un proyecto en la
		// declaración
        vm.confirmarEliminacionComponente = confirmarEliminacionComponente;
        
        // Componente seleccionado para agregar puntos de monitoreo
        vm.objDeclaracionComponente ;
        
      // Punto de Monitoreo seleccionado para agregar parametros
        vm.objDeclaracionPuntoMonitoreo ;
        
        vm.cargarDeclaracionParametros = cargarDeclaracionParametros;
        
        vm.confirmarEliminacionPunto = confirmarEliminacionPunto;
        
        vm.confirmarEliminacionParametro = confirmarEliminacionParametro;
        
        vm.activeetapa = vm.activeetapa;
        
        vm.active = 0;
        
        // Funcón es llamada cuando se cambia de etapa
        vm.cambiarEtapa = cambiarEtapa;
       
        /* declaracion de metodos */
        
        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-instrumento');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        function cargarCombos() {
        	cargarEtapas();
            cargarPeriodos();
        }
        
        function cargarEtapas() {
        	vm.dataEtapa.estado = '1';
            EtapaFactory.listarActivosPorUnidad(angular.copy(vm.dataEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = response.data;
                    if( vm.activeetapa == null){
                    	 vm.activeetapa = 1;
                    }
                    cargarDeclaracionComponentes(vm.lstEtapas[1]);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function cargarDeclaracionPuntosMonitoreo(prmComponente){
        	if(prmComponente == null){
        		vm.objDeclaracionComponente = DeclaracionComponenteFactory.model();
        		return;
        	}
        	
        	vm.verPuntosMonitoreo = true;
        	vm.verParametros = false;
        	vm.objDeclaracionComponente = prmComponente;
        	var tempPunto = {
        			idAdministrado : prmComponente.idAdministrado,
    				idIga : prmComponente.idIga,
    				idInstalacion : prmComponente.idInstalacion,
    				idEtapa : prmComponente.idEtapa,
    				idComponente : prmComponente.idComponente,
    				origen : 'D'
            	};
        	 
        	 DeclaracionPuntoFactory.listar(angular.copy(tempPunto)).then(function(response) {
                 if (response != null && response.valido) {
                	 vm.lstDeclaracionPunto = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function agregarDeclaracionPuntosMonitoreo(prmPuntoMonitoreo) {
        	
        	if(prmPuntoMonitoreo == null){
        		prmPuntoMonitoreo = DeclaracionPuntoFactory.model();
        		prmPuntoMonitoreo.idAdministrado  = vm.objDeclaracionComponente.idAdministrado;
        		prmPuntoMonitoreo.idIga  = vm.objDeclaracionComponente.idIga;
        		prmPuntoMonitoreo.idInstalacion  = vm.objDeclaracionComponente.idInstalacion;
        		prmPuntoMonitoreo.idEtapa  = vm.objDeclaracionComponente.idEtapa;
        		prmPuntoMonitoreo.idComponente  = vm.objDeclaracionComponente.idComponente;
        		prmPuntoMonitoreo.origen= 'D';
        	}
        	$rootScope.objDeclaracionPunto = prmPuntoMonitoreo;
    		
            ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/declaracion/cargainfo-punto-monitoreo.html',
                controller: 'CargaInfoPuntoMonitoreoController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
            });
        }
        
        function cambiarEtapa(etapa){
        	vm.objDeclaracionComponente = null;
        	cargarDeclaracionComponentes(etapa);
        }
        
        function cargarDeclaracionComponentes(etapa) {
        	
        	var tempetapa = null;
        	if( etapa.codetapa != null){
        		tempetapa = etapa.codetapa;
        	}
        	if( etapa.idEtapa != null){
        		tempetapa = etapa.idEtapa;
        	}
        	if( etapa.descripcion == 'ABANDONO' || vm.activeetapa==2){
        		vm.verFrecuenciaAbandono = false;
        	}else{
        		vm.verFrecuenciaAbandono = true;
        	}
        	console.log('mkmkmk '+vm.activeetapa);
        	
        	vm.objInstrumentoGestion.declaracionEtapa.idEtapa = tempetapa;
        	vm.verPuntosMonitoreo = false;
        	vm.verParametros = false;
        	vm.verComponentes = true;
        	
        	if(vm.objInstrumentoGestion.declaracionEtapa.idEtapa == 0){
        		vm.verComponentes = false;
        		return;
        	}
        	
        	var tempComponente = {
        		idAdministrado : vm.objInstalacion.idAdministrado,
        	    idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
        	    idInstalacion : vm.objInstrumentoGestion.idInstalacion,
        	    idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
        	    origen : 'D'
        	};
    	 
        	DeclaracionComponenteFactory.listar(angular.copy(tempComponente)).then(function(response) {
             if (response != null && response.valido) {
            	 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes = angular.copy(response.data);
            	 if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length > 0){
            		 if(vm.objDeclaracionComponente == null){
            			 vm.objDeclaracionComponente = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes[0];
            		 }
            		 cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);            		 
            	 }
             }
         }).catch(function(error) {
             toastr.error('No se pudo obtener los datos.');
         });
        	
        }
        
        function agregarDeclaracionComponentes() {
        	$rootScope.lstComponentesBase = vm.objInstrumentoGestion.declaracionEtapa.lstComponentes;
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/componente-ambiental-selector.html',
                controller: 'ComponenteAmbientalSelectorController',
                controllerAs: 'vm',
                width: '700px'
            }).closePromise.then(function(dataDialog) {
            	var array  = $rootScope.lstComponentesSel;
            	if (angular.isDefined(array)){
            		if(array.length > 0){
            			//GUARDAMOS LA ETAPA
            			var tempEtapa = {
            					idAdministrado : vm.objInstalacion.idAdministrado,
            					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
            					idInstalacion : vm.objInstalacion.idInstalacion,
            					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
            					estado : 'P',
            					prm1: CookiesFactory.obtenerCookie(),
            		    };
            			DeclaracionEtapaFactory.generarEtapa(angular.copy(tempEtapa)).then(function(response) {
                            if (response != null && response.valido) {
                            	for (var x in array) {
                    				var tempComponente = {
                    					idAdministrado : vm.objInstalacion.idAdministrado,
                    					idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
                    					idInstalacion : vm.objInstalacion.idInstalacion,
                    					idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
                    					idComponente : array[x].codigo,
                    					idFrecuencia : null,
                    					estado : 'P',
                    					origen : 'D',
                    					prm1: CookiesFactory.obtenerCookie(),
                    		        };
                    				guardarDeclaracionComponentes(tempComponente);
                                }
                            }
                            console.log('->'+vm.verFrecuenciaAbandono);
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos.');
                        });
            		}
            	}
             	
            });
        }
        
        function guardarDeclaracionComponentes(prmComponente){
        	DeclaracionComponenteFactory.registrar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function actualizarDeclaracionComponentes(prmComponente){
        	vm.objDeclaracionComponente = prmComponente;
        	DeclaracionComponenteFactory.actualizar(angular.copy(prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success(response.mensaje);
                	cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function confirmarEliminacionComponente(prmDeclaracionComponente){
        	
        	var punto = {
        			idAdministrado : prmDeclaracionComponente.idAdministrado,
    				idIga : prmDeclaracionComponente.idIga,
    				idInstalacion : prmDeclaracionComponente.idInstalacion,
    				idEtapa : prmDeclaracionComponente.idEtapa,
    				idComponente : prmDeclaracionComponente.idComponente
        	}
        	
        	DeclaracionPuntoFactory.contar(angular.copy(punto)).then(function(response) {
                var mensaje = '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + '?';
        		if (response.valido) {
        			if(response.data>0){
        				mensaje = '¿Está seguro de eliminar el registro: ' + prmDeclaracionComponente.auxComponenteNombre + ' y sus puntos de monitoreo asociados?'	
        			}
        			ngDialog.openConfirm({
                        template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                        controller: 'DialogConfirmController',
                        controllerAs: 'vm',
                        data: {
                            Titulo: 'Confirmar eliminación',
                            Mensaje: mensaje
                        },
                        width: '380px'
                    }).then(function(okValue) {
                        eliminarDeclaracionComponente(prmDeclaracionComponente);
                    });
                } else {
                    toastr.error(response.mensaje)
                }
                
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        	
        	 
        }
        
        function eliminarDeclaracionComponente(prmDeclaracionComponente) {
        	DeclaracionComponenteFactory.eliminar(angular.copy(prmDeclaracionComponente)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    // si existen registros seteamos el primer valor de la lista
                    if(vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length==0){
                    	// si no hay datos ocultamos toda la información
                    	vm.verPuntosMonitoreo = false;
                    }
                    vm.objDeclaracionComponente =null;
                    cargarDeclaracionComponentes(vm.objInstrumentoGestion.declaracionEtapa);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }
        
        function  cargarDeclaracionParametros(prmPuntoMonitoreo){
// vm.verParametros = true;
// vm.objDeclaracionPuntoMonitoreo = prmPuntoMonitoreo;
//        	
// var tempPuntoMonitoreo = {
// ruc : vm.objInstalacion.ruc,
// idIga : vm.objInstrumentoGestion.idInstrumentoGestion,
// idInstalacion : vm.objInstrumentoGestion.idInstalacion,
// idEtapa : vm.objInstrumentoGestion.declaracionEtapa.idEtapa,
// idComponente : prmPuntoMonitoreo.idComponente,
// idPunto : prmPuntoMonitoreo.idPunto,
// };
//    	 
// DeclaracionParametroFactory.listar(angular.copy(tempPuntoMonitoreo)).then(function(response)
// {
// if (response != null && response.valido) {
// vm.lstDeclaracionParametro = angular.copy(response.data);
// }
// }).catch(function(error) {
// toastr.error('No se pudo obtener los datos.');
// });
        	
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};
        	
        	$rootScope.prmPuntoMonitoreo = prmPuntoMonitoreo;
        	$rootScope.prmComponente = componente;
        	ngDialog.open({
                template: 'app/modules/supervision/cargainformacion/declaracion/cargainfo-declaracion-parametro.html',
                controller: 'CargaInfoDeclaracionParametroController',
                controllerAs: 'vm',
                width: '75%'
            });
        }
        
        
        function agregarDeclaracionParametros(){
        	
        	var componente = {
        		 	codigo: vm.objDeclaracionComponente.idComponente,
        		 	auxComponenteNombre: vm.objDeclaracionComponente.auxComponenteNombre,
                	estado: '1',
        	};
        	
        	$rootScope.prmComponente = componente;
        	$rootScope.lstParametrosComponenteBase  = vm.lstDeclaracionParametro;
        	ngDialog.open({
                template: 'app/modules/componente-parametro/componente-parametro-selector.html',
                controller: 'ComponenteParametroSelectorController',
                controllerAs: 'vm',
                
                width: '50%'
            }).closePromise.then(function(dataDialog) {
            	var array = $rootScope.lstParametrosComponenteSel;
                for (var x in array){
                	var tmpDeclaracionParametro = {
                			idAdministrado :vm.objDeclaracionComponente.idAdministrado,
            				idIga : vm.objDeclaracionComponente.idIga,
            				idInstalacion : vm.objDeclaracionComponente.idInstalacion,
            				idEtapa : vm.objDeclaracionComponente.idEtapa,
            				idComponente : vm.objDeclaracionComponente.idComponente,
            				idPunto : vm.objDeclaracionPuntoMonitoreo.idPunto,
            				idParametroValor : array[x].parametro_valor,
            				idMatriz : array[x].matriz,
            				idSubMatriz: array[x].submatriz,
            				estado : 'P'
                	};
                	DeclaracionParametroFactory.registrar(angular.copy(tmpDeclaracionParametro)).then(function(response) {
                        if (response != null && response.valido) {
                        	cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
                        }
                    }).catch(function(error) {
                        toastr.error('No se pudo obtener los datos.');
                    });
                }
            });
        }
        
        
        function confirmarEliminacionPunto(prmDeclaracionPunto){
        	var parametro = {
        			idAdministrado : prmDeclaracionPunto.idAdministrado,
    				idIga : prmDeclaracionPunto.idIga,
    				idInstalacion : prmDeclaracionPunto.idInstalacion,
    				idEtapa : prmDeclaracionPunto.idEtapa,
    				idComponente : prmDeclaracionPunto.idComponente,
    				idPunto : prmDeclaracionPunto.idPunto
        	}
        	
        	DeclaracionParametroFactory.contar(angular.copy(parametro)).then(function(response) {
                if (response != null && response.valido) {
                	var mensaje = '¿Está seguro de eliminar el registro ' + prmDeclaracionPunto.codigo + '?';
                	if(response.data > 0){
                		mensaje = '¿Está seguro de eliminar el registro ' + prmDeclaracionPunto.codigo + ' y todos los parámetros relacionados?';
                	}
                	ngDialog.openConfirm({
                        template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                        controller: 'DialogConfirmController',
                        controllerAs: 'vm',
                        data: {
                            Titulo: 'Confirmar eliminación',
                            Mensaje: mensaje
                        },
                        width: '380px'
                    }).then(function(okValue) {
                        eliminarDeclaracionPunto(prmDeclaracionPunto);
                    });
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        	
        	
        }
        
        function eliminarDeclaracionPunto(prmDeclaracionPunto){
        	vm.verPuntosMonitoreo = false;
        	DeclaracionPuntoFactory.eliminar(angular.copy(prmDeclaracionPunto)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    cargarDeclaracionPuntosMonitoreo(vm.objDeclaracionComponente);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }
        
        function confirmarEliminacionParametro(prmDeclaracionParametro){
       	 ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarDeclaracionParametro(prmDeclaracionParametro);
            });
       }
       
       function eliminarDeclaracionParametro(prmDeclaracionParametro){
       	DeclaracionParametroFactory.eliminar(angular.copy(prmDeclaracionParametro)).then(function(response) {
               if (response.valido) {
                   toastr.success(response.mensaje);
                   cargarDeclaracionParametros(vm.objDeclaracionPuntoMonitoreo);
               } else {
                   toastr.error(response.mensaje)
               }
           }).catch(function(error) {
               toastr.error('Ocurrió un error al eliminar el parametro');
           });
       }
        
        
        
        
        function cargarPeriodos() {
        	
        	vm.dataTipoPeriodo.codigoMaestro = 'TipoPeriodo';
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
        }
        
      
        function finalizar() {
            console.log("abrir Declaracion");
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/Declaracion-Jurada.html',
                controller: 'DeclaracionJuradaController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        function guardarDeclaracion() {
        	
        	// Declaración Etapa
        	vm.objInstrumentoGestion.declaracionEtapa.idAdministrado = vm.objInstalacion.idAdministrado;
        	vm.objInstrumentoGestion.declaracionEtapa.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
        	vm.objInstrumentoGestion.declaracionEtapa.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
        	
        	// Declaracion Componentes
        	vm.declaracionComponente = DeclaracionComponenteFactory.model();
        	// actualizamos la relacion:
           	for (var x in vm.lstComponentes) {
                	if (vm.lstComponentes[x].blSeleccionado){
                		
                		 vm.declaracionComponente.idAdministrado = vm.objInstalacion.idAdministrado;
                		 vm.declaracionComponente.idIga = vm.objInstrumentoGestion.idInstrumentoGestion;
                		 vm.declaracionComponente.idInstalacion = vm.objInstrumentoGestion.idInstalacion;
                		 vm.declaracionComponente.idEtapa = vm.objInstrumentoGestion.declaracionEtapa.idEtapa ;
                		 vm.declaracionComponente.idComponente = vm.lstComponentes[x].codigo ;
                		 vm.declaracionComponente.idFrecuencia = vm.lstComponentes[x].idFrecuencia ;
                		 vm.declaracionComponente.estado = '1' ;
                		 vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.push(angular.copy(vm.declaracionComponente));
                	}
                }
        	
        	InstrumentoGestionFactory.registrarDeclaracion(angular.copy(vm.objInstrumentoGestion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo guardar.');
            });
        }
        
   
            function init() {
                if (angular.isDefined(localStorage.objInstrumentoGestion)) {
                    vm.objInstrumentoGestion = angular.copy(angular.fromJson(localStorage.objInstrumentoGestion));
                    vm.objInstrumentoGestion.declaracionEtapa = DeclaracionEtapaFactory.model();
                }
                if (angular.isDefined(localStorage.objInstalacion)) {
                    vm.objInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                }
                cargarCombos();
            }
       
      
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('CargaInfoAdministradosInstalacionController', CargaInfoAdministradosInstalacionController);
    /** @ngInject */
    function CargaInfoAdministradosInstalacionController($rootScope, toastr, $scope, AdministradoxInstalacionTempFactory , MaestroFactory,EntidadFactory,CookiesFactory , ngDialog, API_CONFIG) {
        var vm = this;
        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.urlData = API_CONFIG.url;
        vm.dataInstalacion;
        vm.guardar = guardar;
        vm.active = 0;
        vm.validarRuc = validarRuc;
        vm.dataAdminInstalacion = AdministradoxInstalacionTempFactory.model();
        vm.dataInstalacion;
        vm.RucValido = false;
        
        vm.RucBase = "";
        vm.FecIniBase = "";
        vm.lstAdminxInstalacion = [];
        vm.validaDocumento = validaDocumento;
        vm.refrescar = refrescar;
        vm.acciones = AdministradoxInstalacionTempFactory.acciones();
        
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];
        
        vm.blCambiarArchivo = false;
        
        function validarRuc(){
   	     var dataEntidad = EntidadFactory.model();
   	     dataEntidad.ruc = vm.dataAdminInstalacion.ruc;
            EntidadFactory.obtenerPorDocumento(angular.copy(dataEntidad)).then(function(response) {
            	 vm.RucValido = false;
            	if (response.valido) {
               	 dataEntidad = response.data;
               	 if(dataEntidad.razonSocial!=null){
               		 vm.dataAdminInstalacion.ruc = dataEntidad.ruc;
               		 vm.dataAdminInstalacion.razonsocial = dataEntidad.razonSocial;
               		 vm.RucValido = true;
               	 }
               	 else{
               		toastr.error('El servicio no devolvió ningún dato.');
               	 }
                } else {
               	 toastr.error('El servicio no devolvió ningún dato.');
               	 vm.RucValido = false;
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }
        
        
        function guardar() {
        	
        	if(!validar()){
        		return;
        	}
        	
        	vm.dataAdminInstalacion.flagActivo = 'N';
        	if(vm.dataAdminInstalacion.auxflgaactivo==true){
        		vm.dataAdminInstalacion.flagActivo = 'S';
        	}
        	
        	// la instalacion tambien es nueva
        	if(vm.dataInstalacion.idInstalacion == 0){
        		$rootScope.dataAdminxInstalacionEdit = vm.dataAdminInstalacion;
        		$scope.closeThisDialog();
        	}
        	else{
        		// la instalacion ya existe
        		if (vm.dataAdminInstalacion.idInstalacion == 0) {
        			registrar();
                } else {
                    actualizar();
                }
        	}
        }
        
        function validar(){
        	if(vm.dataAdminInstalacion.ruc!=vm.RucBase ||
        			vm.dataAdminInstalacion.auxInicio != 	vm.FecIniBase ){
        		// buscamos en la lista
        		if(vm.lstAdminxInstalacion.length > 0){
        			for(var x in vm.lstAdminxInstalacion){
        				if(vm.lstAdminxInstalacion[x].ruc == vm.dataAdminInstalacion.ruc &&
        						vm.lstAdminxInstalacion[x].auxInicio == obtenerFechaTexto(vm.dataAdminInstalacion.inicioAdministrado)	){
        					 toastr.error('La entidad ya existe en la lista con el RUC y Vigencia desde indicada.');
        					 return false;
        				}
        			}
        		}
        	}
        	return true;
        }


        function registrar() {
        	vm.dataAdminInstalacion.idInstalacion = vm.dataInstalacion.idInstalacion;
        	vm.dataAdminInstalacion.inicioAdministrado = vm.dataAdminInstalacion.inicioAdministradoBase;
        	AdministradoxInstalacionTempFactory.registrar(vm.listaArchivos, angular.copy(vm.dataAdminInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    $scope.closeThisDialog();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
        	vm.dataAdminInstalacion.idInstalacion = vm.dataInstalacion.idInstalacion;
        	vm.dataAdminInstalacion.idsession = CookiesFactory.obtenerCookie();
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	AdministradoxInstalacionTempFactory.actualizar(vm.listaArchivos,angular.copy(vm.dataAdminInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                	$scope.closeThisDialog();
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo actualizar el registro');
            });
        }

        function cancelar() {
            ngDialog.close();
        }
        
        function cargarCombos(){
        }

        
        /* fin de metodos */
        function init() {
        
        	obtenerParametros();
        	if (angular.isDefined(localStorage.dataAdminxInstalacion)){
        		vm.dataAdminInstalacion = angular.copy(angular.fromJson(localStorage.dataAdminxInstalacion));
        		vm.RucBase  = vm.dataAdminInstalacion.ruc;
        		vm.FecIniBase = vm.dataAdminInstalacion.auxInicio;
        	}
        	
        	if (angular.isDefined($rootScope.dataInstalacion)){
        		vm.dataInstalacion = $rootScope.dataInstalacion;
        	}
        	
        	 vm.RucValido = false;
        	if(vm.dataAdminInstalacion.idInstalacion != 0){
        		vm.blCambiarArchivo = false;
    			vm.acciones.nuevoAdministradoxInstalacion = false;
        		vm.acciones.editarAdministradoxInstalacion = true;
        		vm.dataAdminInstalacion.inicioAdministrado = new Date(vm.dataAdminInstalacion.inicioAdministrado);
        		vm.dataAdminInstalacion.inicioAdministradoBase = new Date(vm.dataAdminInstalacion.inicioAdministrado);
        		
        		if(vm.dataAdminInstalacion.finAdministrado!=null){
        			vm.dataAdminInstalacion.finAdministrado = new Date(vm.dataAdminInstalacion.finAdministrado);
        		}
        		vm.RucValido = true;
        	}
        	else{
        		vm.acciones.nuevoAdministradoxInstalacion = true;
        		vm.acciones.editarAdministradoxInstalacion = false;
        		vm.blCambiarArchivo = true;
        		
        		if(vm.dataAdminInstalacion.razonsocial!=null && vm.dataAdminInstalacion.razonsocial!=''){
        			vm.RucValido = true;
        		}
        		vm.dataAdminInstalacion.auxflgaactivo=true;
        	}
        	
        	cargarCombos();
        	
        	if (angular.isDefined($rootScope.lstAdminxInstalacion)){
        		vm.lstAdminxInstalacion = $rootScope.lstAdminxInstalacion;
        	}
        	
        }
        
        function obtenerFechaTexto(fecha){
        	if(fecha == undefined){
        		return "";
        	}
        	var dia = fecha.getDate();
        	var mes = fecha.getMonth()+1;
        	var anio = fecha.getFullYear();
        	
        	if (mes < 10) {
        		mes = "0" + mes;
        	}
        	if (dia < 10) {
        		dia = "0" + dia;
        	}

        	var fechaFinal = dia + "/" + (mes) + "/" + anio;
        	
        	return fechaFinal;
        }
        
        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                
                vm.listaArchivos.push(prmFileList[0]);
                
                document.getElementById("btnRefrescar").click();
        }
        
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        
        function refrescar(){
        	
        }

        init();
        /* fin de controller */
    }
})();
(function() {
	'use strict';
	angular.module('spapp', [
	/* modulos de librerias externas */
	'ngAnimate', 'ngCookies', 'ngTouch', 'ngSanitize', 'ngMessages', 'ngAria',
			'ui.router', 'ui.bootstrap', 'toastr', 'ngDialog', 'ngMask',
			'angularUtils.directives.dirPagination',
			/* modulos de la aplicacion */
			/* 'spapp.cliente', */
			/* 'spapp.producto', */
			/*
			 * 'spapp.pedido', /*'spapp.reporte',
			 */
			/* 'spapp.denuncias', */
			'spapp.seguridad', 'spapp.bandeja', 'spapp.acceso',
			'spapp.supervision', 'spapp.maestro', 'spapp.preguntas',
			'spapp.etapa', 'spapp.normalegal', 'spapp.parametro',
			'spapp.tipoiga','spapp.componente', 'spapp.eor',
	/* 'spapp.usuario' */
	/* 'spapp.maestros', */
	/* 'spapp.procesos', */
	]);
})();
(function() {
    'use strict';
    angular.module('spapp').controller('AgregarNormativaDialogController', AgregarNormativaDialogController);
    /** @ngInject */
    function AgregarNormativaDialogController(toastr, $scope, ngDialog, NormasFactory, ContenidoNormaFactory, PreguntaNormativaFactory) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataPreguntaNormativa = PreguntaNormativaFactory.model();
        vm.dataPregunta = {};
        vm.prmFiltroContenidoNorma = ContenidoNormaFactory.model();
        vm.flagBusquedaContenido = 0;
        vm.dataNormas = NormasFactory.modelNormas();
        vm.listaContenidoNorma = [];
        vm.listaNormativas = [];
        vm.contenidoNorma = ContenidoNormaFactory.model();
        /*declaración de metodos enlazados a la vista*/
        vm.cancelar = cancelar;
        vm.listarNormas = listarNormas;
        vm.buscarContenido = buscarContenido;
        /* vm.registrarNormaCaso=registrarNormaCaso;*/
        vm.listarContenidoNorma = listarContenidoNorma;
        vm.registrarPreguntaNormativa = registrarPreguntaNormativa;
        /*implementación de metodos*/
        /*function registrarNormaCaso(item)
        {
        	vm.dataNormaCaso.norma.idNorma	=	item.idNorma;
        	
        	NormaCasoFactory
        	.registrar(vm.dataNormaCaso)
        	.then(function (response) 
        	{
        		if(response.valido)
        		{
        			vm.dataNormaCaso.idNormaCaso = response.data;
        			toastr.success("Se Registro La Norma al Caso");
        			listarNormas();
        		}
        		else
        		{
        			toastr.error(response.mensaje);
        		}
        	})
        	.catch(function (error) 
        	{
        		toastr.error('Ocurrió un error al registrar Problematica.');
        	});
        }*/
        function registrarPreguntaNormativa(item) {
            vm.dataPreguntaNormativa.contenidoNorma.idContenidoNorma = item.idContenidoNorma;
            vm.dataPreguntaNormativa.pregunta = vm.dataPregunta;
            PreguntaNormativaFactory.registrar(vm.dataPreguntaNormativa).then(function(response) {
                if (response.valido) {
                    vm.dataPreguntaNormativa.idPreguntaNormativa = response.data;
                    toastr.success("Se Registro el Articulo a la Pregunta");
                    ngDialog.close();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar Problematica.');
            });
        }

        function listarNormas() {
            /*vm.dataNormas.idCasoEfa = vm.dataNormaCaso.idCasoEfa;
            console.log(vm.dataNormas);*/
            console.log(vm.dataNormas);
            NormasFactory.listar(angular.copy(vm.dataNormas)).then(function(response) {
                if (response.valido) {
                    vm.listaNormativas = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            });
        }

        function buscarContenido(itemNorma) {
            console.log(itemNorma);
            vm.flagBusquedaContenido = 1;
            var contenidoNorma = {
                idNorma: itemNorma.idNorma,
                idPregunta: vm.dataPregunta.idPregunta
            };
            vm.contenidoNorma.idNorma = angular.copy(contenidoNorma.idNorma);
            vm.contenidoNorma.idPregunta = angular.copy(contenidoNorma.idPregunta);
            console.log("------------------");
            console.log(contenidoNorma);
            console.log("----------vm.contenidoNorma--------");
            console.log(vm.contenidoNorma);
            vm.prmFiltroContenidoNorma.idNorma = itemNorma.idNorma;
            ContenidoNormaFactory.listar(angular.copy(contenidoNorma)).then(function(response) {
                if (response.valido) {
                    vm.listaContenidoNorma = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            });
        }

        function listarContenidoNorma() {
            vm.flagBusquedaContenido = 1;
            /*
            ContenidoNormaFactory
            .listar(angular.copy(vm.prmFiltroContenidoNorma))
            */
            ContenidoNormaFactory.listar(angular.copy(vm.contenidoNorma)).then(function(response) {
                if (response.valido) {
                    vm.listaContenidoNorma = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            });
        }

        function cancelar() {
            ngDialog.close();
        }
        /*fin de metodos*/
        function init() {
            if (angular.isDefined($scope.ngDialogData)) {
                vm.dataPregunta = angular.copy($scope.ngDialogData.prmPregunta);
            }
            listarNormas();
            // body...
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.usuario', []);
})();
(function() {
    'use strict';
    angular.module('spapp.usuario').controller('UsuarioRegistroController', UsuarioRegistroController);
    /* @ngInject */
    function UsuarioRegistroController($state, $scope, ngDialog, toastr, ConvertFactory, UsuarioFactory, MaestroFactory) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.dataUsuario = UsuarioFactory.modelUsuario();
        //vm.prmPerfil=PermisoFactory.modelPerfil();
        //vm.perfilUsuario = UsuarioPerfilFactory.modelUsuarioPerfil();
        vm.isActivo = false;
        vm.isActivoUsuario = false;
        vm.listadoPerfil = [];
        vm.agregarUsuarioPerfil = agregarUsuarioPerfil;
        vm.eliminarUsuarioPerfil = eliminarUsuarioPerfil;
        //opciones de calendarios
        vm.dtFechaNacimientoOptions = {
            showWeeks: false,
            datepickerMode: 'year',
            minDate: new Date('January 1, 1900'),
            maxDate: new Date()
        };
        //declarar variables para guardar los combos desde la bd
        vm.listaTipoDocumento = [];
        vm.listaTipoGenero = [];
        vm.listaTipoNacionalidad = [];
        vm.listaTipoPerfil = [];
        //vm.listaTipoPersona = [];
        /*declaración de metodos enlazados a la vista*/
        vm.guardar = guardar;
        vm.limpiar = limpiar;
        vm.cancelar = cancelar;
        vm.buscarPersonaPorDocumento = buscarPersonaPorDocumento;
        vm.cambiarDocumentoPersona = cambiarDocumentoPersona;
        vm.obtenerMaxlengthNumDoc = obtenerMaxlengthNumDoc;
        /*implementación de metodos*/
        function cargarCombos() {
            var codigosCombos = ['TipoDocumento', 'TipoGenero', 'TipoNacionalidad', 'TipoPerfil'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoGenero':
                                vm.listaTipoGenero = datosCombo;
                                break;
                            case 'TipoNacionalidad':
                                vm.listaTipoNacionalidad = datosCombo;
                                break;
                                //case 'TipoPerfil' : vm.listaTipoPerfil = datosCombo; break;
                                /*case 'TipoPersona' : vm.listaTipoPersona = datosCombo; break;*/
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function buscarPersonaPorDocumento(keyCode) {
            if (keyCode == '13') {
                var prmPersona = {
                    idTipoPersona: angular.copy(vm.dataUsuario.persona.idTipoPersona),
                    idTipoDocumento: angular.copy(vm.dataUsuario.persona.idTipoDocumento),
                    numeroDocumento: angular.copy(vm.dataUsuario.persona.numeroDocumento)
                };
                if (prmPersona.idTipoDocumento == 0 || !ConvertFactory.isNotNoE(prmPersona.numeroDocumento)) {
                    toastr.warning('Indique tipo y número de documento de la persona.');
                    return;
                }
                if (prmPersona.idTipoDocumento == 1 && prmPersona.numeroDocumento.length != 8) {
                    limpiarPersona();
                    toastr.warning('Indique un número de documento de 8 dígitos.');
                    return;
                }
                UsuarioFactory.buscarPorTipoYNumeroDocumento(prmPersona).then(function(response) {
                    if (response.valido) {
                        if (response.data != null) {
                            vm.dataUsuario = angular.copy(response.data);
                            vm.personaCambiada = angular.copy(vm.dataUsuario.persona);
                            vm.isActivo = true;
                            if (vm.dataUsuario.idUsuario != null && vm.dataUsuario.idUsuario > 0) {
                                vm.isActivoUsuario = true;
                                vm.perfilUsuario.idUsuario = angular.copy(vm.dataUsuario.idUsuario);
                                listarPerfiles();
                            } else {
                                vm.isActivoUsuario = false;
                                vm.dataUsuario.nombreUsuario = angular.copy(vm.dataUsuario.persona.numeroDocumento);
                            }
                        } else {
                            limpiarPersona();
                            toastr.warning('No se han encontrado datos de la persona con documento ' + prmPersona.numeroDocumento);
                            vm.isActivo = false;
                        }
                    } else {
                        toastr.error('Error al consultar persona');
                        vm.isActivo = false;
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar persona');
                });
            }
            return;
        }

        function confirmarCambioPersona(personaInexistente) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar acción',
                    Mensaje: 'No se hallaron datos de alguna persona con documento ' + personaInexistente.numeroDocumento + '. ¿Desea registrarlo?'
                },
                width: '380px'
            }).then(function(okValue) {
                limpiarPersona();
                vm.dataUsuario.persona.idTipoDocumento = angular.copy(personaInexistente.idTipoDocumento);
                vm.dataUsuario.persona.numeroDocumento = angular.copy(personaInexistente.numeroDocumento);
                vm.dataUsuario.persona.idPersona = -1;
            }, function(cancelValue) {
                //toastr.warning('Cancelar registro de persona');
                limpiarPersona();
            });
        }

        function cambiarDocumentoPersona() {
            if (vm.dataUsuario.persona.numeroDocumento != vm.personaCambiada.numeroDocumento) {
                buscarPersonaPorDocumento('13');
            }
        }

        function obtenerMaxlengthNumDoc(idTipoDocumento) {
            /*return PersonaFactory.obtenerMaxlengthNumDoc(idTipoDocumento);*/
        }

        function limpiar() {
            vm.dataUsuario = UsuarioFactory.modelUsuario();
            vm.isActivo = false;
            vm.isActivoUsuario = false;
            vm.dataUsuario.persona.idTipoDocumento = 1;
            vm.dataUsuario.persona.idTipoPersona = '0';
            vm.personaCambiada = angular.copy(vm.dataUsuario.persona);
            vm.dataUsuario.idTipoPerfil = "";
            vm.listadoPerfil = [];
            //vm.perfilUsuario = UsuarioPerfilFactory.modelUsuarioPerfil();
        }

        function limpiarPersona() {
            vm.dataUsuario = UsuarioFactory.modelUsuario();
            vm.dataUsuario.persona.idTipoDocumento = 1;
            vm.dataUsuario.persona.idTipoPersona = '0';
            vm.personaCambiada = angular.copy(vm.dataUsuario.persona);
        }

        function cancelar() {
            $state.go('spapp.home.usuarios.listado');
        }

        function guardar() {
            if (vm.dataUsuario.persona == null) {
                toastr.warning("Datos de persona no encontrados");
            }
            if (vm.dataUsuario.persona.idPersona == null || vm.dataUsuario.persona.idPersona == 0) {
                toastr.warning("Datos de persona no encontrados");
            }
            if (vm.dataUsuario.persona.idTipoDocumento == '0') {
                vm.formUsuario.idTipoDocumento.$invalid = true;
                vm.formUsuario.idTipoDocumento.$touched = true;
                toastr.warning('Seleccione Tipo de Documento');
                return;
            }
            if (vm.dataUsuario.persona.idTipoGenero == '0') {
                vm.formUsuario.idTipoGenero.$invalid = true;
                vm.formUsuario.idTipoGenero.$touched = true;
                toastr.warning('Seleccione Tipo de Género');
                return;
            }
            if (vm.dataUsuario.idUsuario > 0) {
                actualizar();
            } else {
                registrar();
            }
        }
        vm.guardarLista = false;

        function registrar() {
            if (vm.dataUsuario.idUsuario > 0 && vm.dataUsuario.idUsuario != null) {
                vm.guardarLista = false;
            } else {
                vm.guardarLista = true;
            }
            if (vm.listadoPerfil == null || vm.listadoPerfil.length == 0) {
                toastr.warning("Debe asignar uno o mas perfiles");
                return;
            }
            UsuarioFactory.registrar(angular.copy(vm.dataUsuario)).then(function(response) {
                if (response.valido) {
                    vm.dataUsuario.idUsuario = response.data;
                    //vm.dataUsuario.persona.idPersona = response.data[1];
                    vm.perfilUsuario.idUsuario = angular.copy(vm.dataUsuario.idUsuario);
                    if (vm.guardarLista) {
                        for (var i = 0; i < vm.listadoPerfil.length; i++) {
                            vm.listadoPerfil[i].idUsuario = angular.copy(vm.dataUsuario.idUsuario);
                        }
                        guardarListaPerfiles();
                    } else {
                        toastr.success('Usuario registrado con codigo ' + vm.dataUsuario.idUsuario);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar usuario.')
            });
        }

        function actualizar() {
            if (vm.listadoPerfil == null || vm.listadoPerfil.length == 0) {
                toastr.warning("Debe asignar uno o mas perfiles");
                return;
            }
            UsuarioFactory.actualizar(angular.copy(vm.dataUsuario)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al actualizar el usuario')
            });
        }
        /*
    function listarPerfil() {
			PermisoFactory
			.listarPerfil(angular.copy(vm.prmPerfil))
			.then(function (response) {
				if (response.valido) {
					vm.listaTipoPerfil = response.data;
				}
				else {
					toastr.error(response.mensaje);
				}
			})
			.catch(function (error) {
				toastr.error('Error al consultar');
			});
		}*/
        function existe() {
            var existe = false;
            /** VERIFICAR SI LA SESION YA SE ENCUENTRA EN LA LISTA **/
            for (var i = 0; i < vm.listadoPerfil.length; i++) {
                var perfil = vm.listadoPerfil[i];
                if (perfil.idPerfil == vm.perfilUsuario.idPerfil) {
                    existe = true;
                    break;
                }
            }
            return existe;
        }

        function agregarPerfil() {
            if (!existe()) {
                for (var i = 0; i < vm.listaTipoPerfil.length; i++) {
                    var perfil = vm.listaTipoPerfil[i];
                    if (perfil.idPerfil == vm.perfilUsuario.idPerfil) {
                        vm.perfilUsuario.nombrePrefil = angular.copy(perfil.nombrePrefil);
                        break;
                    }
                }
                vm.listadoPerfil.push(angular.copy(vm.perfilUsuario));
            } else {
                toastr.info("ya existe un registro con ese perfil");
            }
            //limpiarPerfil();
        }

        function eliminarPerfil(perfil) {
            for (var i = 0; i < vm.listadoPerfil.length; i++) {
                var item = vm.listadoPerfil[i];
                if (item.idPerfil == perfil.idPerfil) {
                    vm.listadoPerfil.splice(i, 1);
                    break;
                }
            }
        }

        function init() {
            cargarCombos();
            listarPerfil();
            limpiar();
            if (angular.isDefined(localStorage.tmpIdUsuario)) {
                var tmpIdUsuario = Number(localStorage.tmpIdUsuario);
                vm.perfilUsuario.idUsuario = Number(localStorage.tmpIdUsuario);
                UsuarioFactory.obtener(tmpIdUsuario).then(function(response) {
                    if (response.valido) {
                        vm.dataUsuario = response.data;
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al obtener datos del Usuario');
                });
                listarPerfiles();
            }
        }
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.usuario').controller('UsuarioListadoController', UsuarioListadoController);
    /* @ngInject */
    function UsuarioListadoController($state, $controller, UsuarioFactory, toastr, ngDialog, MaestroFactory) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.listaUsuario = [];
        vm.prmUsuario = UsuarioFactory.modelUsuario();
        //declarar variables para guardar los combos desde la bd
        vm.listaTipoPerfil = [];
        /*variables de paginacion*/
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /*declaración de metodos enlazados a la vista*/
        vm.buscar = buscar;
        vm.nuevo = nuevo;
        vm.limpiar = limpiar;
        vm.editar = editar;
        //vm.eliminar = eliminar;
        vm.confirmarEliminacion = confirmarEliminacion;
        /*implementación de metodos*/
        /*function cargarCombos() {
        	var codigosCombos = ['TipoPerfil'];
        	MaestroFactory
        	.buscarMaestros(angular.copy(codigosCombos)) 
        	.then(function (response) {
        		if (response!=null&&response.valido)
        		{
        			for(var x in response.data)
        			{
        				var tipoCombo = response.data[x].Key;
        				var datosCombo = response.data[x].Value;
        				switch(tipoCombo)
        				{
        					case 'TipoPerfil' : vm.listaTipoPerfil = datosCombo; break;
        					default : break;
        				}
        			}
        		}
        	})
        	.catch(function (error) {
        		toastr.error('No se pudo obtener los datos para los combos.');
        	});
        }*/
        function nuevo() {
            localStorage.removeItem('tmpIdUsuario');
            $state.go('spapp.home.usuarios.registro');
        }

        function confirmarEliminacion(idUsuario) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar al usuario seleccionado?'
                },
                width: '500px'
            }).then(function(okValue) {
                eliminar(idUsuario);
            });
        }

        function editar(idUsuario) {
            localStorage.setItem('tmpIdUsuario', idUsuario);
            $state.go('spapp.home.usuarios.registro');
        }

        function buscar() {
            debugger
            UsuarioFactory.listar(angular.copy(vm.prmUsuario)).then(function(response) {
                if (response.valido) {
                    vm.listaUsuario = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function limpiar() {
            vm.prmUsuario = UsuarioFactory.modelUsuario();
        }

        function eliminar(idUsuario) {
            var tmpUsuarioEliminar = {
                idUsuario: idUsuario
            };
            UsuarioFactory.eliminar(angular.copy(tmpUsuarioEliminar)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    buscar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al eliminar al usuario');
            });
        }

        function listarPerfil() {
            /*PermisoFactory
            .listarPerfil(angular.copy(vm.prmPerfil))
            .then(function (response) {
            	if (response.valido) {
            		vm.listaTipoPerfil = response.data;
            	}
            	else {
            		toastr.error(response.mensaje);
            	}
            })
            .catch(function (error) {
            	toastr.error('Error al consultar');
            });*/
        }

        function init() {
            //cargarCombos();
            limpiar();
            listarPerfil();
            /*vm.listaRegistros.push({idUsuario : 1, nombreCompleto : 'DANIEL ENRIQUE ÁVILA MÉNDEZ', nombreUsuario : 'davila', nombrePerfil : 'ADMINISTRADOR'});	
            vm.listaRegistros.push({idUsuario : 1, nombreCompleto : 'SEBASTIÁN JOAQUÍN ÁVILA MÉNDEZ', nombreUsuario : 'savila', nombrePerfil : 'ALUMNO'});
            vm.listaRegistros.push({idUsuario : 1, nombreCompleto : 'ESTHER VILLALOBOS CARRERA', nombreUsuario : 'evillalobos', nombrePerfil : 'DOCENTE'});*/
        }
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.tipoiga', []);
})();
(function() {
    'use strict';
    angular.module('spapp.tipoiga').controller('TipoIgaListadoController', TipoIgaListadoController);
    /* @ngInject */
    function TipoIgaListadoController(ngDialog, toastr, $scope, $rootScope, TipoIgaFactory, CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstTipoIgas = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmTipoIga = TipoIgaFactory.model();

        function agregarItem(prmTipoIga) {
            console.log("prmTipoIga" + prmTipoIga);
            if (prmTipoIga != null) {
                
                TipoIgaFactory.buscarPorId(angular.copy(prmTipoIga)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemTipoIga = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/tipoiga/dialog/tipoiga-data-dialog.html',
                                  controller: 'TipoIgaDataDialogController',
                                  controllerAs: 'vm',
                                  
                                  width: '50%'
                              }).closePromise.then(function(dataDialog) {
                                  listar();
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener la tipoiga');
		                });
            } 
            else{
            	$rootScope.itemTipoIga =  TipoIgaFactory.model();
            	ngDialog.open({
                    template: 'app/modules/tipoiga/dialog/tipoiga-data-dialog.html',
                    controller: 'TipoIgaDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '50%'
                }).closePromise.then(function(dataDialog) {
                    listar();
                });
            }
          
        }

        function confirmarEliminacion(prmTipoIga) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmTipoIga.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmTipoIga.codigo);
            });
        }
        
        function confirmarInactivacion(prmTipoIga) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmTipoIga.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmTipoIga.codigo);
            });
        }

        function eliminar(codigo) {
            var temp = {
            	codigo: codigo
            };
            TipoIgaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la tipoiga');
            });
        }
        
        function inactivar(codigo) {
            var temp = {
            	codigo: codigo,
            	idsession: CookiesFactory.obtenerCookie(),
            };
            TipoIgaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la tipoiga');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmTipoIga.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            TipoIgaFactory.listar(angular.copy(vm.prmTipoIga)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstTipoIgas = angular.copy(response.data);
                    console.log("vm.lstTipoIgas" + angular.toJson(vm.lstTipoIgas));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	vm.prmTipoIga.estado = '1';
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.tipoiga').controller('TipoIgaDataDialogController', TipoIgaDataDialogController);

    function TipoIgaDataDialogController($scope, toastr, ngDialog, $log, $rootScope, TipoIgaFactory, CookiesFactory, $filter) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.prmTipoIga = TipoIgaFactory.model();
        /*declaración de metodos enlazados a la vista*/
        vm.guardar = guardar;
        vm.cancelar = cancelar;
        vm.titulo = '';
        vm.tituloAccion = '';

        function cancelar() {
            ngDialog.close();
        }

        function guardar() {
            if (vm.titulo == "Nuevo") {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	vm.prmTipoIga.idsession = CookiesFactory.obtenerCookie();
            TipoIgaFactory.registrar(angular.copy(vm.prmTipoIga)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
        	vm.prmTipoIga.idsession = CookiesFactory.obtenerCookie();
            //var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            TipoIgaFactory.actualizar(angular.copy(vm.prmTipoIga)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }


        function init() {
        	  if ($rootScope.itemTipoIga != null) {
                  vm.prmTipoIga = angular.copy($rootScope.itemTipoIga);
              }
        	  else{
        		  vm.prmTipoIga = TipoIgaFactory.model();
        	  }
        	  
        	  
        	  if(vm.prmTipoIga.codigo == ''){
        		  vm.titulo = "Nuevo";
        		  vm.tituloAccion = "Registrar";
        	  }
        	  else{
        		  vm.titulo = "Editar";
        		  vm.tituloAccion = "Actualizar";
        	  }
        	  console.log(' vm.prmTipoIga validacion ' +  vm.prmTipoIga);
        }
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('SolicitudAdministradoController', SolicitudAdministradoController);
    /* @ngInject */
    function SolicitudAdministradoController(API_CONFIG, $scope, $log, $location, toastr, ngDialog, SolicitudesFactory, SolicitudFactory, ContactoAdministradoFactory, $rootScope, MaestroFactory, InstalacionFactory) {
        var vm = this;
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        vm.flagActivoBandeja = '1';
        vm.datafiltroSolicitudes = SolicitudesFactory.model();
        vm.dataSolicitudes = SolicitudesFactory.model();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.instalacionPrincipal = InstalacionFactory.model();
        vm.instalacionAuxiliar = null;
        vm.dataInstalacion = {
            sector: 0,
            subSector: 0
        };
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaSector = [];
        vm.listaSubSector = [];
        vm.listaActividad = [];
        vm.listaSolicitudes = [];
        vm.listaDetalleSolicitud = [];
        vm.listaContactoAdministrado = [];
        vm.listaCheck = [];
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        vm.revisarSolicitud = revisarSolicitud;
        vm.descargarArchivo = descargarArchivo;
        vm.cambiarEstadoDetalleSolicitud = cambiarEstadoDetalleSolicitud;
        vm.validarDetalleSolicitudEstado = validarDetalleSolicitudEstado;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.listarSolicitudes = listarSolicitudes;
        vm.limpiar = limpiar;
        vm.descargarFicha = descargarFicha;
        vm.aprobarTodasSolicitudes = aprobarTodasSolicitudes;
        vm.aprobarSolicitudesSelecc = aprobarSolicitudesSelecc;
        /* implementacion de metodos */
        function limpiar() {
            vm.flagActivoBandeja = '1';
            vm.datafiltroSolicitudes = SolicitudesFactory.model();
            vm.dataSolicitudes = SolicitudesFactory.model();
            vm.listaDetalleSolicitud = [];
            vm.listaContactoAdministrado = [];
            vm.listaCheck = [];
            listarSolicitudes();
        }

        function cargarCombos() {
            /*vm.listaCboTipoContacto = [{codigoRegistro:0,descripcion:'--Seleccione--'}];*/
            var codigosCombos = ['TipoSector', 'TipoEstablecimiento', 'EstadoSolicitud', 'TipoSolicitud'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            case 'EstadoSolicitud':
                                vm.listaEstadoSolicitud = datosCombo;
                                break;
                            case 'TipoSolicitud':
                                vm.listaTipoSolicitud = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarSubSector() {
            vm.listaSubSector = [];
            vm.listaActividad = [];
            vm.datafiltroSolicitudes.subSector = 0;
            vm.datafiltroSolicitudes.actividad = 0;
            if (vm.datafiltroSolicitudes.sector == 0) {
                return;
            }
            //console.log("vm.datafiltroSolicitudes.sector", vm.datafiltroSolicitudes.sector);
            /*vm.dataInstalacion.subSector.codigoRegistro=0;*/
            var subSector = {
                codigoRegistroPadre: vm.datafiltroSolicitudes.sector,
                codigoMaestro: 'SubSector'
            }
            MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaSubSector.push(response.data[x]);
                    }
                    /*console.log("vm.listaSubSector" + angular.toJson(vm.listaSubSector));*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*******************************************************/
        function listarActividad() {
            vm.listaActividad = [];
            vm.datafiltroSolicitudes.actividad = 0;
            if (vm.datafiltroSolicitudes.subSector == 0) {
                return;
            }
            var actividades = {
                codigoRegistroPadre: vm.datafiltroSolicitudes.subSector,
                codigoMaestro: 'Actividad'
            }
            MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaActividad.push(response.data[x]);
                    }
                    /*  console.log("vm.listaActividad" + angular.toJson(vm.listaActividad));
                        vm.dataNormas.actividad=0;*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function validarDetalleSolicitudEstado(tipoOperacion, data, estado) {
            vm.instalacionAuxiliar = angular.copy(data.instalacion);
            //console.log("vm.instalacionAuxiliar ANTES DE SETEARLE LOS DATOS",vm.instalacionAuxiliar);
            if (vm.dataSolicitudes.tipoSolicitud == 2) {
                data.solicitud.tipoSolicitud = 2;
                data.instalacion.motivoRechazoInstalacion = '';
            }
            if (tipoOperacion == 1) {
                if (estado == 3) {
                    var numeroDetalleSolicitud = vm.listaDetalleSolicitud.length;
                    var numeroAprobados = 0;
                    var numeroRechazados = 0;
                    for (var i = 0; i < vm.listaDetalleSolicitud.length; i++) {
                        if (vm.listaDetalleSolicitud[i].estado.codigoRegistro == 3) {
                            numeroRechazados = numeroRechazados + 1;
                        }
                    }
                    //debugger;
                    mostrarMotivoRechazo(data, estado);
                    if (numeroDetalleSolicitud == (numeroRechazados + 1)) {
                        //mostrarMotivoRechazo(data,estado);
                    } else {
                        cambiarEstadoDetalleSolicitud(data, estado);
                        if (vm.dataSolicitudes.tipoSolicitud == 2) {
                            modificarInstalacionSinModificar(vm.instalacionAuxiliar);
                        }
                    }
                } else {
                    /*if(vm.dataSolicitudes.tipoSolicitud == 2){
                        data.solicitud.tipoSolicitud = 2;
                        data.instalacion.motivoRechazoInstalacion = '';
                    }*/
                    cambiarEstadoDetalleSolicitud(data, estado);
                    /*  if(vm.dataSolicitudes.tipoSolicitud == 2){
                            
                                vm.instalacionPrincipal.idInstalacion = angular.copy(data.instalacion.idInstalacionPrincipal);
                                InstalacionFactory
                                .buscarPorId(vm.instalacionPrincipal)
                                .then(function (response)
                                {
                                    if (response.valido) {
                                            vm.instalacionPrincipal = response.data;
                                            console.log("vm.instalacionPrincipal",vm.instalacionPrincipal);
                                        
                                    }else {
                                            toastr.error(response.mensaje);
                                        }
                                }).catch(function (error) 
                                {
                                    toastr.error('No se pudo procesar.');
                                }).finally(function(){                          
                                    modificarInstalaciones(vm.instalacionAuxiliar);
                                });
                            
                        }*/
                }
            }
        }

        function modificarInstalacionSinModificar(instalacion) {
            debugger;
            var idInstalacion = angular.copy(vm.instalacionAuxiliar.idInstalacion);
            //console.log("idInstalacion QUE NUMERO ES",idInstalacion);
            instalacion.idInstalacion = instalacion.idInstalacionPrincipal;
            instalacion.idInstalacionPrincipal = 0;
            instalacion.estado = 2;
            instalacion.motivoRechazoInstalacion = "";
            //console.log("instalacion QUE VA A QUEDAR EN LA TABLA PRINCIPAL",instalacion)
            InstalacionFactory.modificarEstadoInstalacion(angular.copy(instalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {});
        }

        function modificarInstalaciones(instalacion) {
            debugger;
            //instalacion - vm.instalacionPrincipal -vm.instalacionAuxiliar
            //console.log("vm.instalacionAuxiliar EN LA MODIFICACION",vm.instalacionAuxiliar);
            var idInstalacion = angular.copy(vm.instalacionAuxiliar.idInstalacion);
            //console.log("idInstalacion QUE NUMERO ES",idInstalacion);
            instalacion.idInstalacion = instalacion.idInstalacionPrincipal;
            instalacion.idInstalacionPrincipal = 0;
            instalacion.estado = 2;
            //console.log("instalacion QUE VA A QUEDAR EN LA TABLA PRINCIPAL",instalacion)
            InstalacionFactory.actualizar(angular.copy(instalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {});
            debugger;
            vm.instalacionPrincipal.idInstalacionPrincipal = vm.instalacionPrincipal.idInstalacion;
            vm.instalacionPrincipal.idInstalacion = idInstalacion;
            //console.log("vm.instalacionPrincipal QUE VA A IR A LA TABLA TEMPORAL",vm.instalacionPrincipal);
            InstalacionFactory.actualizar(angular.copy(vm.instalacionPrincipal)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cambiarEstadoDetalleSolicitud(data, estado) {
            var prmData = data;
            if (prmData != null) {
                prmData.estado.codigoRegistro = estado;
                if (vm.dataSolicitudes.nombreSolicitud == 'Solicitud De Cancelacion de Instalacion') {
                    prmData.instalacion.estado = 4;
                }
            }
            console.log("prmData QUE SE ENVIA AL ACTUALIZAR", prmData);
            SolicitudFactory.actualizarDetalleSolicitud(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                    listarDetalleSolicitudes();
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarContactosAdministrado(id) {
            var data = {
                idAdministrado: id,
            };
            ContactoAdministradoFactory.listar(data).then(function(response) {
                if (response.valido) {
                    vm.listaContactoAdministrado = response.data;
                    console.log("vm.listaContactoAdministrado" + vm.listaContactoAdministrado);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Contactos.');
            }).finally(function() {});
        }

        function descargarArchivo(data) {
            SolicitudFactory.descargarFichaRegistro(data.instalacion.idInstalacion).then(function(response) {
                $log.debug('Documento descargado');
                $log.debug('response', response);
                console.log('response', response);
            }).catch(function(error) {
                $log.error(error);
                toastr.error('Hubo un error en la descarga del documento.');
            });
        }

        function revisarSolicitud(data, tipoSolicitud) {
            if (data.estado == 1) {
                //                  cambiarEstadoSolicitudRevision(data);   
            }
            if (tipoSolicitud == '1') {
                vm.dataSolicitudes = data;
                console.log("vm.dataSolicitudes", vm.dataSolicitudes);
                listarDetalleSolicitudes();
                listarContactosAdministrado(vm.dataSolicitudes.idAdministrado);
            }
        }

        function cambiarEstadoSolicitudRevision(data) {
            var data = {
                idSolicitud: data.idSolicitud,
                estado: 4
            };
            SolicitudFactory.actualizarEstadoSolicitud(data).then(function(response) {
                /*if (response.valido) {
                    
                    
                    
                }else {
                        
                    }*/
            }).catch(function(error) {
                toastr.error('No se pudo Actualizar el estado.');
            }).finally(function() {});
        }

        function listarDetalleSolicitudes() {
            var data = {
                solicitud: {
                    idSolicitud: vm.dataSolicitudes.idSolicitud,
                    tipoSolicitud: vm.dataSolicitudes.tipoSolicitud
                }
            };
            console.log("data", data)
            SolicitudFactory.listarDetalleSolicitud(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.listaDetalleSolicitud = angular.copy(response.data);
                    vm.flagActivoBandeja = '0';
                    //debugger;
                    console.log("vm.listaDetalleSolicitud", vm.listaDetalleSolicitud);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            }).finally(function() {
                if (vm.listaDetalleSolicitud.length > 0) {
                    for (var x = 0; x < vm.listaDetalleSolicitud.length; x++) {
                        vm.check = false;
                        vm.listaCheck.push(vm.check);
                    }
                }
                if (vm.dataSolicitudes.tipoSolicitud == 2) {
                    var listaAux = angular.copy(vm.listaDetalleSolicitud);
                    console.log("vm.listaDetalleSolicitud PROCESO", vm.listaDetalleSolicitud);
                    console.log("vm.listaAux PROCESO", listaAux);
                    for (var x = 0; x < listaAux.length; x++) {
                        var codigoInstalacionPrincipal = listaAux[x].instalacion.idInstalacionPrincipal;
                        var instalacionAux = listaAux[x].instalacion;
                        instalacionAux.idInstalacionPrincipal = 0;
                        instalacionAux.idInstalacion = codigoInstalacionPrincipal;
                        instalacionAux.motivoRechazoInstalacion = '';
                        instalacionAux.estado = 5;
                        //                      console.log("instalacionAux PARA CAMBIARLE EL ESTADO", instalacionAux);                     
                        //                      InstalacionFactory
                        //                      .modificarEstadoInstalacion(angular.copy(instalacionAux))
                        //                      .then(function (response) {
                        //                          if (response!=null&&response.valido){       
                        ////                                toastr.success('Éxito en la operación.');
                        //                          }
                        //                      })
                        //                      .catch(function (error) {
                        //                          toastr.error('No se pudo obtener los datos para los combos.');
                        //                      });
                    }
                }
            });
        }

        function listarSolicitudes() {
            vm.datafiltroSolicitudes.prm1 = angular.copy(localStorage.objlocalStRefSisoplkijsq);
            console.log("vm.datafiltroSolicitudes", vm.datafiltroSolicitudes);
            SolicitudesFactory.listarSolicitudAdministrado(angular.copy(vm.datafiltroSolicitudes)).then(function(response) {
                if (response.valido) {
                    vm.listaSolicitudes = response.data;
                    console.log("vm.listaSolicitudes", vm.listaSolicitudes);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            }).finally(function() {});
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarMotivoRechazo(data, estado) {
            ngDialog.openConfirm({
                template: 'app/modules/bandeja/solicitudes/dialog/motivo-rechazo/motivo-rechazo-dialog.html',
                controller: 'MotivoRechazoDialogController',
                data: {},
                controllerAs: 'vm',
                width: '700px'
            }).then(function(okValue) {
                data.solicitud.motivoRechazo = $rootScope.motivoRechazo;
                data.instalacion.motivoRechazoInstalacion = $rootScope.motivoRechazo;
                console.log("data", data);
                if (data.solicitud.motivoRechazo != '') {
                    cambiarEstadoDetalleSolicitud(data, estado);
                }
            });
        }

        function visualizarPDF() {
            ngDialog.open({
                template: 'app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html',
                controller: 'SolicitudArchivoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }

        function descargarFicha() {
            SolicitudFactory.descargarFicha(vm.dataSolicitudes).then(function(response) {
                if (response.data != null && response.valido) {
                    $rootScope.urlPDFFichaDenuncia = "<iframe src='" + angular.copy(response.data) + "' style='width:100%; height:600px;' frameborder='0'> </iframe>";
                    visualizarPDF();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*****************************************************************************/
        /*Metodo utilizado para aprobabar todas las solicitudes de acceso*/
        /*****************************************************************************/
        function aprobarTodasSolicitudes() {
            for (var x = 0; x < vm.listaDetalleSolicitud.length; x++) {
                if (vm.listaDetalleSolicitud[x].estado.codigoRegistro == 1 || vm.listaDetalleSolicitud[x].estado.codigoRegistro == 4) {
                    vm.validarDetalleSolicitudEstado(1, vm.listaDetalleSolicitud[x], 2);
                }
            }
        }
        /*****************************************************************************/
        /*Metodo utilizado para aprobar solicitudes de acceso seleccionadas*/
        /*****************************************************************************/
        function aprobarSolicitudesSelecc() {
            for (var x = 0; x < vm.listaDetalleSolicitud.length; x++) {
                if (vm.listaDetalleSolicitud[x].estado.codigoRegistro == 1 || vm.listaDetalleSolicitud[x].estado.codigoRegistro == 4) {
                    if (vm.listaCheck[x]) {
                        vm.validarDetalleSolicitudEstado(1, vm.listaDetalleSolicitud[x], 2);
                    }
                }
            }
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            listarSolicitudes();
            cargarCombos();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ListadoSupervicionOnlineController', ListadoSupervicionOnlineController);
    /* @ngInject */
    function ListadoSupervicionOnlineController(API_CONFIG, toastr, $scope, ngDialog, MaestroFactory, AdministradoFactory, SolicitudesFactory, InstalacionFactory, $state, SolicitudFactory, $log) {
        var vm = this;
        /* declaracion de variables globales */
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.urlData = API_CONFIG.url;
        vm.datafiltroAdministrado = AdministradoFactory.modelVistaAdministrado();
        vm.datafiltroSolicitudes = SolicitudesFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataInstalacion = {
            sector: 0,
            subSector: 0,
            actividad: 0
        };
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaSector = [];
        vm.listaSubSector = [];
        vm.listaActividad = [];
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.listaAdmistradoActivo = [];
        vm.listarInstalaciones = listarInstalaciones;
        vm.listarAdministrador = listarAdministrador;
        vm.limpiar = limpiar;
        vm.confirmarVerPresentacion = confirmarVerPresentacion;
        vm.flagActivoMSO = '1';
        vm.verDatosAutoSupervisionOnline = verDatosAutoSupervisionOnline;
        vm.mostrarInformacionInstalacionDialog = mostrarInformacionInstalacionDialog;
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        /* implementacion de metodos */
        function mostrarInformacionInstalacionDialog(itemInstalacion) {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html',
                controller: 'InformacionInstalacionDialogController',
                data: {
                    data: itemInstalacion
                },
                controllerAs: 'vm',
                width: '800px',
                preCloseCallback: function() {
                    //listarProblematica();
                }
            });
        }

        function listarAdministrador() {
            console.log("vm.datafiltroAdministrado", vm.datafiltroAdministrado);
            AdministradoFactory.listaAdministrado(angular.copy(vm.datafiltroAdministrado)).then(function(response) {
                if (response.valido) {
                    vm.listaAdmistradoActivo = response.data;
                    console.log("vm.listaAdmistradoActivo", vm.listaAdmistradoActivo);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Administrados.');
            }).finally(function() {});
        }

        function listarSubSector() {
            debugger;
            vm.listaSubSector = [];
            vm.listaActividad = [];
            vm.datafiltroAdministrado.instalacion.subSector.codigoRegistro = 0;
            vm.datafiltroAdministrado.instalacion.actividad.codigoRegistro = 0;
            if (vm.datafiltroAdministrado.instalacion.sector.codigoRegistro == 0) {
                return;
            }
            var subSector = {
                codigoRegistroPadre: vm.datafiltroAdministrado.instalacion.sector.codigoRegistro,
                codigoMaestro: 'SubSector'
            }
            MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaSubSector.push(response.data[x]);
                    }
                    /*console.log("vm.listaSubSector" + angular.toJson(vm.listaSubSector));*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarActividad() {
            vm.listaActividad = [];
            vm.datafiltroAdministrado.instalacion.actividad.codigoRegistro = 0;
            if (vm.datafiltroAdministrado.instalacion.subSector.codigoRegistro == 0) {
                return;
            }
            var actividades = {
                codigoRegistroPadre: vm.datafiltroAdministrado.instalacion.subSector.codigoRegistro,
                codigoMaestro: 'Actividad'
            }
            MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaActividad.push(response.data[x]);
                    }
                    /*  console.log("vm.listaActividad" + angular.toJson(vm.listaActividad));
                        vm.dataNormas.actividad=0;*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cargarCombos() {
            var codigosCombos = ['TipoSector', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarCasosProblematicaDialog() {
            ngDialog.open({
                template: 'app/modules/denuncias/casos/dialog/casos-problematica/casos-problematica-dialog.html',
                controller: 'CasoProblematicaDialogController',
                data: {},
                controllerAs: 'vm',
                width: '700px',
                preCloseCallback: function() {
                    listarProblematica();
                }
            });
        }
        /** ******************************************************************************** */
        function agregarNormativa(item) {
            vm.verNormativas = true;
            vm.nombreEntidad = item.efa.nombre;
            vm.dataNormaCaso.idCasoEfa = item.idCasoEfa;
            console.log("vm.dataNormaCaso.idCasoEfa" + vm.dataNormaCaso.idCasoEfa);
            listarNormaCaso();
        }

        function listarInstalacionesAdministrado(item) {
            vm.listaInstalaciones = [];
            console.log("vm.datafiltroSolicitudes", vm.datafiltroSolicitudes);
            vm.dataListaInstalacion.sector.codigoRegistro = vm.datafiltroSolicitudes.sector;
            vm.dataListaInstalacion.subSector.codigoRegistro = vm.datafiltroSolicitudes.subSector;
            vm.dataListaInstalacion.actividad.codigoRegistro = vm.datafiltroSolicitudes.actividad;
            console.log("vm.dataListaInstalacion", vm.dataListaInstalacion);
            InstalacionFactory.buscarPorIdAdministrado(angular.copy(vm.dataListaInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.listaInstalaciones = angular.copy(response.data);
                    //console.log("Estado: " + vm.dataListaInstalacion.estado);
                    //console.log('sdssfdsf');
                    //console.log(vm.listaInstalacionAdm);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                console.log(vm.listaInstalaciones);
                item.listaInstalaciones = [];
                for (var x = 0; x < vm.listaInstalaciones.length; x++) {
                    if (vm.listaInstalaciones[x].estado == 2) {
                        item.listaInstalaciones.push(vm.listaInstalaciones[x]);
                    }
                }
                //item.listaInstalaciones = vm.listaInstalaciones;
            });
        }

        function listarInstalaciones(item, accion) {
            if (accion) {
                vm.dataListaInstalacion.idAdministrado = item.idAdministrado;
                vm.dataListaInstalacion.estado = 2;
                console.log(item);
                //vm.numeroOrden = vm.listaAdmistradoActivo.indexOf(item);
                //console.log("vm.numeroOrden",vm.numeroOrden);
                listarInstalacionesAdministrado(item);
            }
        }

        function verDatosAutoSupervisionOnline(item) {
            localStorage.setItem("objDataInstalacionAutosupervisionOnline", angular.toJson(item));
            $state.go("spapp.home.supervision.autosupervision-online");
        }

        function confirmarVerPresentacion(item) {
            localStorage.setItem("objInstalacion", angular.toJson(item));
            $state.go("spapp.home.supervision.instalacion-presentacion");
        }

        function limpiar() {
            vm.datafiltroAdministrado.instalacion.sector.codigoRegistro = 0;
            vm.datafiltroAdministrado.instalacion.subSector.codigoRegistro = 0;
            vm.datafiltroAdministrado.instalacion.actividad.codigoRegistro = 0;
            vm.datafiltroAdministrado.documento = "";
            vm.datafiltroAdministrado.nombreCompleto = "";
            vm.datafiltroSolicitudes = SolicitudesFactory.model();
            vm.dataListaInstalacion.numeroInstalacion = "";
            vm.listaActividad = [];
            vm.listaSubSector = [];
        }
        /* fin de implementacion de metodos */
        function init() {
            cargarCombos();
            listarAdministrador();
            localStorage.removeItem("objInstalacion");
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('InstrumentoGestionController', InstrumentoGestionController);
    /* @ngInject */
    function InstrumentoGestionController($state, toastr, ngDialog, $scope, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, InstrumentoGestionFactory, InformeMonitoreoFactory, $filter, $log, $rootScope, MonitoreoPeriodosFactory, ArchivoFactory, API_CONFIG, $window) {
        var vm = this;
        vm.file = null;
        vm.rutaBase = API_CONFIG.url;
        
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        $scope.serial1 = 1;
        $scope.serial2 = 1;
        $scope.serial3 = 1;
        $scope.serial4 = 1;
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.fileInstrumento = null;
        vm.lstAnio = [];
        vm.prmInstalacion;
        vm.prmInstrumentoGestion = InstrumentoGestionFactory.model();
        vm.lstInstrumentosGestion = [];
        /** ************************************************** */
        /** Variables de InformeMonitoreo Ambiental * */
        /** ************************************************** */
        vm.archivoAdjunto = {};
        vm.descarga = descarga;
        /* vm.eliminarMonitoreo = eliminarMonitoreo; */
        /* vm.agregarMonitoreo4 = agregarMonitoreo4; */
        /** ****** */
        /** ****** */
        vm.cancelar = cancelar;
        vm.getFileExtension = getFileExtension;
        
        vm.nuevoIGA = nuevoIGA;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.verDocumentosIGA = verDocumentosIGA;
        vm.irDeclaracion = irDeclaracion;
        
        
        function irDeclaracion(item) {
            debugger;
            localStorage.setItem("objInstrumentoGestion", angular.copy(angular.toJson(item)));
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(vm.prmInstalacion)));
            $state.go('spapp.home.supervision.accion-administrado');
        }
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function getFileExtension(filename) {
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            console.log(" ext  :" + ext);
            return ext;
        }
        $scope.descargarArchivoGenerico = function(rutaBase, rutaRest, idDescarga, filename) {
            debugger;
            var url = "";
            var ext = (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
            url = rutaBase + rutaRest + idDescarga + "." + ext;
            return url;
        }
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount1 = function(newPageNumber) {
            $scope.serial1 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount2 = function(newPageNumber) {
            $scope.serial2 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount3 = function(newPageNumber) {
            $scope.serial3 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }
        $scope.indexCount4 = function(newPageNumber) {
            $scope.serial4 = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function cancelar() {
            $state.go('spapp.home.supervision.accion-instalacion');
            $rootScope.cancelarPresentacion = 1;
        }
        /** *********************************************************************** */
        /** ********************************************************************** */
        /** ******************************PROBLEMATICA************************************** */
        /** ******************************************************************************** */


        function buscarInstrumentoGestion() {
        	console.log('id instalación ' + vm.prmInstrumentoGestion.idInstalacion);
        	console.log('estado ' + vm.prmInstrumentoGestion.estado);
        	console.log('idTipoInstrumento ' + vm.prmInstrumentoGestion.idTipoInstrumento);
        	
            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.prmInstrumentoGestion)).then(function(response) {
                if (response.valido) {
                    vm.lstInstrumentosGestion = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
            
            console.log('lstInstrumentosGestion '+ vm.lstInstrumentosGestion.length);
        }


        function descarga(archivo) {
            document.location = archivo;
        }

        /** *********************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            if (angular.isDefined(localStorage.objInstalacion)) {
                vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                vm.prmInstrumentoGestion.idInstalacion = angular.copy(vm.prmInstalacion.idInstalacion);
                vm.prmInstrumentoGestion.estado = "T";
                buscarInstrumentoGestion();
                console.log("data ---> : " + getFileExtension("daraassaas.docx"));
            }
            
            console.log('vm.prmInstalacion ' + vm.prmInstalacion);
        }
        
        // Nuevo IGA
        function nuevoIGA(datoParametro) {
        	
        	
        	if(datoParametro != null){
        		$rootScope.prmdatoInstrumento = angular.copy(datoParametro);
        		 ngDialog.open({
                     template: 'app/modules/supervision/iga/dialog/instrumento-gestion-ambiental.html',
                     controller: 'InstrumentoGestionAmbientalController',
                     controllerAs: 'vm',
                     width: '700px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	else{
        		$rootScope.prmdatoInstrumento = angular.copy(InstrumentoGestionFactory.model());
        		 ngDialog.open({
                     template: 'app/modules/supervision/iga/dialog/instrumento-gestion-ambiental.html',
                     controller: 'InstrumentoGestionAmbientalController',
                     controllerAs: 'vm',
                     width: '700px'
                 }).closePromise.then(function(dataDialog) {
                 	buscarInstrumentoGestion();
                 });
        	}
        	
        }
        
        function confirmarEliminacion(prmInstrumentoGestion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstrumentoGestion.resolucion  + ' ' + prmInstrumentoGestion.auxTipoIgaNombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstrumentoGestion);
            });
        }
        
        function eliminar(prmInstrumentoGestion){
        	 	InstrumentoGestionFactory.eliminar(angular.copy(prmInstrumentoGestion)).then(function(response) {
                     if (response.valido) {
                         toastr.success(response.mensaje);
                         buscarInstrumentoGestion();
                     } else {
                         toastr.error(response.mensaje)
                     }
                 }).catch(function(error) {
                     toastr.error('Ocurrió un error al eliminar la parametro');
                 });
        }
        
        
        function verDocumentosIGA() {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/iga-documentos-dialog.html',
                controller: 'IGADocumentosDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }
        
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.acceso', []);
})();
(function() {
	'use strict';
	angular.module('spapp.acceso').controller(
			'AdministradoSupervisionOnlineContactoController',
			AdministradoSupervisionOnlineContactoController);
	/* @ngInject */
	function AdministradoSupervisionOnlineContactoController(INTERNAL_HOME_PAGE, $scope, API_CONFIG,
			$state, $rootScope, ContactoAdministradoFactory, MaestroFactory,
			toastr, ngDialog, PersonaFactory, EntidadFactory, UbigeoFactory,
			InstalacionFactory, SolicitudFactory, AdministradoFactory,
			SolicitudesFactory) {
		var vm = this;
		vm.guardarContacto = guardarContacto;
		vm.prmContacto = ContactoAdministradoFactory.model();
		vm.dataAdministrado = AdministradoFactory.model();
		vm.urlData = API_CONFIG.url;
		
		
		function guardarContacto(){
			if (vm.prmContacto.idContactoAdministrado == 0){
					// Registramos contacto
					registrarContactoAdministrado(vm.prmContacto);
				}
				else{
					// Actualizamos conntroller
					actualizarContactoAdministrado(vm.prmContacto);
				}
			 
			 
		}
			
		   function registrarContactoAdministrado(data) {
	            data.idAdministrado = vm.dataAdministrado.idAdministrado;
	            ContactoAdministradoFactory.registrar(angular.copy(data)).then(function(response) {
	                if (response != null && response.valido) {
	                    toastr.success('Contacto Registrado Correctamente.');
	                    ngDialog.close();
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los datos para los combos.');
	            });
	        }
		   
		   function actualizarContactoAdministrado(data) {
	            ContactoAdministradoFactory.actualizar(angular.copy(data)).then(function(response) {
	                if (response != null && response.valido) {
	                    toastr.success('Contacto Actualizado Correctamente.');
	                    ngDialog.close();
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los datos para los combos.');
	            });
	        }
		   
			
		function init() {
			vm.dataAdministrado = $rootScope.dataAdministrado;
			  if ($rootScope.itemContacto.idContactoAdministrado != 0) {
                  vm.prmContacto = angular.copy($rootScope.itemContacto);
              }
        	  else{
        		  vm.prmContacto = ContactoAdministradoFactory.model();
        		  vm.prmContacto.tipoContacto.codigoRegistro = "2";
        		  vm.prmContacto.estado.codigoRegistro = "1";
        		  vm.prmContacto.flagActivo = "1";
        	  }
			  
		}
		init();
		/* fin de controller */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('administradoSupervicionOnlineController', administradoSupervicionOnlineController);
    /* @ngInject */
    function administradoSupervicionOnlineController($location, $rootScope, toastr, ngDialog, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, SolicitudFactory, $scope, $state, CuestionarioFactory, OpcionPreguntaFactory, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.validaArchivoModificacionInst = 0;
        $rootScope.active = 0;
        $scope.serial = 1;
        /* Configuracion de paginacion de tablas */
        vm.urlData = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        /** *************************************************************************** */
        /** * Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataCuestionarioAutosupervision = [];
        /** *************************************************************************** */
        /** * Fin Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataAdministradoContacto = ContactoAdministradoFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataContacto = {
            tipoContacto: '0'
        }
        vm.dataInstalacion = {
            sector: 0,
            subSector: 0
        };
        vm.listaTipoPersona = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaTipoDocumento = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSector = [];
        vm.listaSubSector = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaActividad = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSolicitudesInstalacion = [];
        vm.listaContactoAdministrado = [];
        vm.listaArchivosSolicitud = [];
        vm.listaCboTipoContacto = [];
        vm.listaInstalacionAdm = [];
        vm.listaDepartamentoPersona = [];
        vm.listaProvinciaPersona = [];
        vm.listaDistritoPersona = [];
        vm.listaTipoEstablecimiento = [];
        // vm.agregaContactoAdministrado = [];
        // vm.confirmaDesactivarAdmi = [];
        vm.listarContactoPrincipal = [];
        vm.btnAgregarInstalacion = false;
        vm.irManifiestos = irManifiestos;
        vm.btnListaInstalacion = true;
        vm.confirmarDesactivarAdmi = confirmarDesactivarAdmi;
        vm.listarContactoAdministrado = listarContactoAdministrado;
        vm.cambiarEstadoContacto = cambiarEstadoContacto;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.validaDocumento = validaDocumento;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.agregarContacto = agregarContacto;
        vm.agregarContactoAdministrado = agregarContactoAdministrado;
        vm.contactoPrincipal = contactoPrincipal;
        vm.mostrarInformacionInstalacionDialog = mostrarInformacionInstalacionDialog;
        vm.MostrarForm = MostrarForm;
        vm.OcultarForm = OcultarForm;
// vm.irPresentacion = irPresentacion;
        vm.irCompromisos = irCompromisos;
        vm.mostrarModificarInstalacion = mostrarModificarInstalacion;
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.mostrarCancelarInstalacion = mostrarCancelarInstalacion;
        vm.resolverCuestionario = resolverCuestionario;
        vm.verDatosAutoSupervision = verDatosAutoSupervision;
        vm.mostrarResolverCuestionarioDialog = mostrarResolverCuestionarioDialog;
        vm.valorTelefono = valorTelefono;
        vm.modificar = 0;
        vm.limpiarContactoAdmi = limpiarContactoAdmi;
        vm.habilitarTexto = habilitarTexto;
        vm.guardar = guardar;
        vm.procesoSolicitudNuevaInstalacion = procesoSolicitudNuevaInstalacion;
        vm.cambioDatos = cambioDatos;
        vm.eliminarContacto = eliminarContacto;
        /** *** */
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        /** ********* Cuestionario AutoSupervision ********** */
        function verDatosAutoSupervision(data) {
            localStorage.setItem("objDataInstalacionAutosupervision", angular.copy(angular.toJson(data)));
            $state.go('spapp.home.supervision.cuestionario-autosupervision');
        }

        function resolverCuestionario(data) {
            localStorage.setItem("objInstalacionDataCuestionario", angular.copy(angular.toJson(data)));
            /* $state.go('spapp.home.supervision.cuestionario'); */
        }
        /** ****************************************************************************************************************************************************************************************************************** */
        function mostrarResolverCuestionarioDialog(data) {
            var dataCuestionario = CuestionarioFactory.model();
            dataCuestionario.instalacion = data;
            CuestionarioFactory.buscarPorIdInstalacion(dataCuestionario).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    var prmDataCuestionario = response.data;
                    for (var i in prmDataCuestionario.lstCuestionarioDetalle) {
                        if (prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.tipoPregunta.codigoRegistro == 5) {
                            var listaDataOpciones = prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta;
                            /** ****************************************************** */
                            var listaDataOpcionesFila = [];
                            if (prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.numerosFila != 0 && prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.numerosColumna != 0) {
                                for (var d = 0; d < prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.numerosFila; d++) {
                                    var listaOpcionesColumna = [];
                                    for (var e = 0; e < prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.numerosColumna; e++) {
                                        var dataColumna = OpcionPreguntaFactory.model();
                                        dataColumna.posicionFila = d;
                                        dataColumna.posicionColumna = e;
                                        listaOpcionesColumna.push(dataColumna);
                                    }
                                    var dataFila = OpcionPreguntaFactory.model();
                                    dataFila.lstOpcionPreguntaColumna = angular.copy(listaOpcionesColumna);
                                    listaDataOpcionesFila.push(dataFila);
                                }
                            }
                            for (var z in listaDataOpcionesFila) {
                                for (var v in listaDataOpcionesFila[z].lstOpcionPreguntaColumna) {
                                    for (var s in listaDataOpciones) {
                                        if (listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionFila == listaDataOpciones[s].posicionFila && listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v].posicionColumna == listaDataOpciones[s].posicionColumna) {
                                            listaDataOpcionesFila[z].lstOpcionPreguntaColumna[v] = angular.copy(listaDataOpciones[s]);
                                        }
                                    }
                                }
                            }
                            prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta = angular.copy(listaDataOpcionesFila);
                            console.log("da9999" + prmDataCuestionario.lstCuestionarioDetalle[i].pregunta.lstOpcionPregunta);
                            /** ****************************************************** */
                        }
                    }
                    var numeroData = prmDataCuestionario.lstCuestionarioDetalle.length;
                    mostrarModalCuestionarioParaResolver(prmDataCuestionario);
                } else {
                    toastr.warning(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function mostrarModalCuestionarioParaResolver(data) {
            localStorage.setItem("objInstalacionDataCuestionario", angular.copy(angular.toJson(data)));
            ngDialog.open({
                template: 'app/modules/supervision/administrado/autosupervision/cuestionario-administrado.html',
                controller: 'CuestionarioAdministradoController',
                /*
				 * data : { data : itemInstalacion },
				 */
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }
        // listarInstalacionesAdministrado();
        /** *************************************************** */
        function irManifiestos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            $state.go('spapp.home.supervision.accion-administrado-residuos');
        }        

        function irCompromisos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            $state.go('spapp.home.supervision.accion-administrado');
        }

        function procesoSolicitudNuevaInstalacion() {
            vm.validaArchivoModificacionInst = 0;
            vm.modificar = 0;
            MostrarForm();
        }

        function MostrarForm() {
            vm.btnAgregarInstalacion = true;
            vm.btnListaInstalacion = false;
        }

        function OcultarForm() {
            vm.btnAgregarInstalacion = false;
            vm.btnListaInstalacion = true;
            vm.dataInstalacion = angular.copy(InstalacionFactory.model());
            vm.validaArchivoModificacionInst = 0;
            vm.listaSubSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            listarInstalacionesAdministrado();
        }
        /* implementacion de metodos */
        // usuario.actual= angular.fromJson(localStorage.objSesSisoLocStWqKP);
        /** ****************************************************************** */
// function agregarContacto() {
// vm.dataContactoAdministrado.nombreEstado = "PENDIENTE";
// var data = vm.dataContactoAdministrado;
// console.log(data);
// vm.dataAdministrado.lstContactoAdministrado.push(data);
// vm.dataContactoAdministrado = ContactoAdministradoFactory.model();
// }
        
        function eliminarContacto(index) {
            confirmarEliminarContactoAdministrado(vm.dataAdministrado.lstContactoAdministrado[index]);
        }
        
        function confirmarEliminarContactoAdministrado(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el contacto ' + item.valor + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarContactoAdministrado(item);
         		 
            });
        }
        
        function eliminarContactoAdministrado(data) {
            ContactoAdministradoFactory.eliminar(angular.copy(data)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Contacto Eliminado Correctamente.');
                    listarContactoAdministrado();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
     	function agregarContacto(prmContacto){
     		$rootScope.dataAdministrado = vm.dataAdministrado;
   			 if (prmContacto != null) {
   	                
   	                        	$rootScope.itemContacto = prmContacto;
   	                        	  ngDialog.open({
   	                                  template: 'app/modules/supervision/administrado/administrado-supervision-online-contacto.html',
   	                                  controller: 'AdministradoSupervisionOnlineContactoController',
   	                                  controllerAs: 'vm',
   	                                  width: '50%'
   	                              }).closePromise.then(function(dataDialog) {
   	                            		 listarContactoAdministrado();
   	                              });
   	            } 
   	            else{
   	            	$rootScope.itemContacto =  ContactoAdministradoFactory.model();
   	            	ngDialog.open({
   	                    template: 'app/modules/supervision/administrado/administrado-supervision-online-contacto.html',
   	                    controller: 'AdministradoSupervisionOnlineContactoController',
   	                    controllerAs: 'vm',
   	                    
   	                    width: '50%'
   	                }).closePromise.then(function(dataDialog) {
                   		 listarContactoAdministrado();
   	                });
   	            }
     	}
        /** ****************************************************************** */
        /**/
        function contactoPrincipal(prmData) {
            ContactoAdministradoFactory.modificarFlagPretedeterminadoDeContactoAdmi(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }
        /** *************************************************************** */
        /**/
        function habilitarTexto() {}

        function guardar() {
            habilitarTexto();
        }
        /**/
        /*-----LISTAR CONTACTO ADMINISTRADO------*/
        function listarContactoAdministrado() {
            vm.dataAdministradoContacto.idAdministrado = vm.dataAdministrado.idAdministrado;
           
            ContactoAdministradoFactory.listar(angular.copy(vm.dataAdministradoContacto)).then(function(response) {
                debugger;
                if (response.valido) {
                	console.log('data ' + vm.dataAdministrado.lstContactoAdministrado);
                    vm.dataAdministrado.lstContactoAdministrado = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Contactos Administrados.');
            }).finally(function() {});
        }

        function confirmarDesactivarAdmi(data, estado) {
            var prmData = data;
            ngDialog.openConfirm({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title">Desea confirmar el cambio de estado de contacto a desactivado.</h4>' + '</div>' + '<div class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Cancel</button>' + '<button type="button" id="save_modal_confirmation" ng-click="confirm()" class="btn btn-primary btn-sm">Confirmar</button>' + '</div>' + '</div>',
                plain: true,
                width: 350,
            }).then(function(value) {
                cambiarEstadoContacto(data, estado);
            });
        }

        function cambiarEstadoContacto(data, estado) {
            // vm.confirmarDesactivarAdmi(item);
            var prmData = data;
            if (prmData != null) {
                prmData.estado.codigoRegistro = 2;
                // alert("DESCRRIPCION" +
				// vm.dataAdministradoContacto.estado.descripcion);
                if (prmData.estado.descripcion == 'DESACTIVADO') {
                    prmData.estado.codigoRegistro = 2;
                }
                // prmData.estado = 2;
            }
            ContactoAdministradoFactory.actualizar(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }

        function limpiarContactoAdmi() {
            vm.dataContactoAdministrado.tipoContacto.codigoRegistro = 0;
            vm.dataContactoAdministrado.valor = "";
        }

        function agregarContactoAdministrado() {
            // Validar correo
            if (vm.dataContactoAdministrado.tipoContacto.codigoRegistro == 1) {
                if ((angular.isUndefined(vm.dataContactoAdministrado.valor))) {
                    // Mensaje debe ingresar correctamente el correo electronico
                    // toastr.warning("Debe ingresar correctamente el teléfono
					// \nEjemplo : (051)999-9999");
                    // return;
                    // Mensaje debe ingresar correctamente el correo electronico
                    var item = angular.element('#txtTelefono').val();
                    if (item.length >= 13) {
                        toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : (051)9999-99999");
                    } else {
                        var letra = angular.copy(item.substr(0, 1));
                        console.log(letra);
                        var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                        var esNumeroInicial = false;
                        console.log(esNumeroInicial);
                        for (var i = 0; i < array.length; i++) {
                            if (array[i] === letra) {
                                esNumeroInicial = true;
                                break;
                            }
                        }
                        console.log("esNumeroInicial");
                        console.log(esNumeroInicial);
                        if (esNumeroInicial) {
                            switch (item.length) {
                                case 8:
                                    toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : 99999999");
                                    break;
                                case 9:
                                    toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : 999999999");
                                    break;
                                default:
                                    toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : 9999999");
                                    break;
                            }
                        } else {
                            toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : (051)999-9999");
                        }
                    }
                    return;
                }
            }
            if (vm.dataContactoAdministrado.tipoContacto.codigoRegistro == 2) {
                if ((angular.isUndefined(vm.dataContactoAdministrado.valor))) {
                    // Mensaje debe ingresar correctamente el correo electronico
                    toastr.warning("Debe ingresar correctamente el correo \nEjemplo : ejemplo@domino.com");
                    return false;
                }
            }
            var data = vm.dataContactoAdministrado;
            data.idAdministrado = vm.dataListaInstalacion.idAdministrado;
            // vm.listaContactoAdministrado.push(data);
            ContactoAdministradoFactory.registrar(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    // vm.agregaContactoAdministrado = response.data;
                    // vm.agregarContactoAdministrado = response.data;
                    listarContactoAdministrado();
                    limpiarContactoAdmi();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }

        function buscar(prm1) {
            debugger;
            
            var ruc = angular.copy(angular.fromJson(localStorage.wk));
            
            var data = {
                prm1: prm1,
                prm2: ruc
            };
            
            AdministradoFactory.buscarxid( /* vm.dataAdministrado */ angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.dataAdministrado = response.data;
                    // console.log(vm.dataAdministrado);
                } else {
                    toastr.error('Usted no es un Administrado');
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
// listarInstalacionesAdministrado();
                listarContactoAdministrado();
            });
        }

        function listarSubSector() {
            vm.listaSubSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.subSector.codigoRegistro = 0;
            vm.dataInstalacion.actividad.codigoRegistro = 0;
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaSubSector" +
						 * angular.toJson(vm.listaSubSector));
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }

        function listarActividad() {
            vm.listaActividad = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.actividad.codigoRegistro = 0;
            /*
			 * vm.dataInstalacion.actividad=0; vm.listaActividad=[];
			 */
            if (vm.dataInstalacion.subSector.codigoRegistro != 0) {
                var actividades = {
                    codigoRegistroPadre: vm.dataInstalacion.subSector.codigoRegistro,
                    codigoMaestro: 'Actividad'
                }
                MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaActividad.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaActividad" +
						 * angular.toJson(vm.listaActividad));
						 * vm.dataNormas.actividad=0;
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        function listarInstalacionesAdministrado() {
            vm.dataListaInstalacion.idAdministrado = vm.dataAdministrado.idAdministrado;
            InstalacionFactory.buscarPorIdAdministrado(angular.copy(vm.dataListaInstalacion)).then(function(response) {
                if (response.valido) {
                    console.log("Se ejecuto -------- :");
                    vm.listaInstalacionAdm = angular.copy(response.data);
                    console.log(vm.listaInstalacionAdm);
                    // console.log("Estado: " + vm.dataListaInstalacion.estado);
                    // console.log('sdssfdsf');
                    // console.log(vm.listaInstalacionAdm);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarInformacionInstalacionDialog(itemInstalacion) {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html',
                controller: 'InformacionInstalacionDialogController',
                data: {
                    data: itemInstalacion
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }
        /** ******************************************************************************** */
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Seleccione'
            }];
            UbigeoFactory.listarDepartamento(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarProvincia();
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.provincia.codigoDepartamento = vm.dataInstalacion.departamento.codigoDepartamento;
            UbigeoFactory.listarProvincia(vm.provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarDistrito();
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            vm.distrito.codigoDepartamento = vm.dataInstalacion.departamento.codigoDepartamento;
            vm.distrito.codigoProvincia = vm.dataInstalacion.provincia.codigoProvincia;
            UbigeoFactory.listarDistrito(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            vm.validaArchivo = '0';
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                vm.validaArchivo = '1';
                vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
            }
            if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
                console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
            }
        }
        /** *********************************************************************************** */
        function procesoRegistroSolicitudArchivo() {
            if (vm.validaArchivo == '1') {
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
            } else {
                toastr.info('Falta cargar ficha de registro');
                return;
            }
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
            // console.log("vm.listaArchivosSolicitud" +
			// vm.listaArchivosSolicitud);
            // console.log("vm.listaArchivosSolicitud.length" +
			// vm.listaArchivosSolicitud.length);
            vm.dataSolicitud.tipoSolicitud = 3;
            console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
            console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada correctamente');
                    // $state.go('ingreso');
                    // crear metodo para limpiar todos los campos y el campo de
					// file
                    // direccionar al listado de instalaciones
                    console.log("vm.dataSolicitud", vm.dataSolicitud);
                    visualizarModal();
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }

        function visualizarModal() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de nueva instalación ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function visualizarModalSolicitudModificacion() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de modificación de datos ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function procesoModificacionDeInstalacion() {
            if (vm.validaArchivoModificacionInst == 0 && vm.validaArchivo != '1') {
                toastr.warning('Debe subir un archivo para continuar con la modificación');
                return;
            }
            if (vm.validaArchivoModificacionInst == 1) {
                vm.validaArchivo = '0';
            }
            if (vm.validaArchivo == '1') {
                console.log("Realiza el Registro CON NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            } else {
                console.log("Realiza el Registro SIN NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                data.estado = 1;
                data.flagActivo = 1;
                vm.listaSolicitudesInstalacion.push(data);
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataAdministrado.flagActivo = 1;
                vm.dataAdministrado.estado = 1;
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                // console.log("Data a enviar
				// listaArchivosSolicitud",vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudSinArchivo(vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                        console.log("vm.dataSolicitud", vm.dataSolicitud);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            }
            /*
			 * console.log("ENTRA AL PROCESO DE MODIFICACION");
			 * console.log("vm.dataInstalacion",vm.dataInstalacion);
			 */
        }

        function registrarSolicitudArchivo() {
            if (vm.modificar != 1) {
                procesoRegistroSolicitudArchivo();
            } else {
                procesoModificacionDeInstalacion();
            }
        }
        /** ******************************************************************************** */
        /* Metodo para utilizado para cancelar instalacion */
        /** ******************************************************************************** */
        function mostrarCancelarInstalacion(itemInstalacion) {
            if (itemInstalacion.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog-cancelacion/cancelacion-instalacion-dialog.html',
                controller: 'CancelacionInstalacionDialogController',
                data: {
                    data: itemInstalacion,
                    dataAdministrado: vm.dataAdministrado
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function() {
                listarInstalacionesAdministrado();
            });
        }
        /** ********************************************************************************** */
        /* metodo para modificar instalación */
        /** ********************************************************************************** */
        function mostrarModificarInstalacion(item, modificar) {
            // modificar =1 -> Se trata de una modificacion
            debugger;
            if (item.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            vm.dataInstalacion = angular.copy(item);
            console.log(vm.dataInstalacion);
            vm.dataInstalacionTemporal = angular.copy(item);
            console.log(item);
            vm.modificar = modificar;
            vm.validaArchivoModificacionInst = 1;
            // listarSubSector();
            vm.listaSubSector = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(angular.copy(subSector)).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                }).finally(function() {
                    debugger;
                    vm.dataInstalacion.subSector = angular.copy(item.subSector);
                    if (vm.dataInstalacion.subSector.codigoRegistro != 0) {
                        var actividades = {
                            codigoRegistroPadre: vm.dataInstalacion.subSector.codigoRegistro,
                            codigoMaestro: 'Actividad'
                        }
                        MaestroFactory.buscarRegistroHijo(angular.copy(actividades)).then(function(response) {
                            if (response != null && response.valido) {
                                for (var x in response.data) {
                                    vm.listaActividad.push(response.data[x]);
                                }
                                vm.dataInstalacion.actividad = angular.copy(item.actividad);
                                /*
								 * console.log("vm.listaActividad" +
								 * angular.toJson(vm.listaActividad));
								 * vm.dataNormas.actividad=0;
								 */
                            }
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos para los combos.');
                        });
                    }
                });
            }
            // listarActividad();
            for (var i = 0; i < 3; i++) {
                ejecutarfuncionesOrdenadas(i);
            }
        }

        function ejecutarfuncionesOrdenadas(item) {
            if (item == 0) {
                listarProvincia();
            }
            if (item == 1) {
                listarDistrito();
            }
            if (item == 2) {
                MostrarForm();
            }
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * 5 - 4;
        }

        function valorTelefono(valor) {
            var item = angular.element('#txtTelefono').val();
            if (item.length >= 13) {
                vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{4})[ .-]?(\d{3,5})$/;
            } else {
                var letra = angular.copy(item.substr(0, 1));
                console.log(letra);
                var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                var esNumeroInicial = false;
                console.log(esNumeroInicial);
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === letra) {
                        esNumeroInicial = true;
                        break;
                    }
                }
                console.log("esNumeroInicial");
                console.log(esNumeroInicial);
                if (esNumeroInicial) {
                    vm.validarTelefono = /^(\d{7,9})$/;
                } else {
                    vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{3,4})$/;
                }
            }
        }

        function cambioDatos() {
            // (true/false) = angular.equals($scope.user1, $scope.user2);
            return ((angular.equals(vm.dataInstalacion.sector, vm.dataInstalacionTemporal.sector)) && (angular.equals(vm.dataInstalacion.subSector, vm.dataInstalacionTemporal.subSector)) && (angular.equals(vm.dataInstalacion.actividad, vm.dataInstalacionTemporal.actividad)) && (angular.equals(vm.dataInstalacion.numeroInstalacion, vm.dataInstalacionTemporal.numeroInstalacion)) && (angular.equals(vm.dataInstalacion.tipoEstablecimiento, vm.dataInstalacionTemporal.tipoEstablecimiento)) && (angular.equals(vm.dataInstalacion.numeroRegistro, vm.dataInstalacionTemporal.numeroRegistro)) && (angular.equals(vm.dataInstalacion.departamento.codigoDepartamento, vm.dataInstalacionTemporal.departamento.codigoDepartamento)) && (angular.equals(vm.dataInstalacion.provincia.codigoProvincia, vm.dataInstalacionTemporal.provincia.codigoProvincia)) && (angular.equals(vm.dataInstalacion.distrito.codigoDistrito, vm.dataInstalacionTemporal.distrito.codigoDistrito)) && (angular.equals(vm.dataInstalacion.direccion, vm.dataInstalacionTemporal.direccion)));
        }
        /* fin de implementacion de metodos */
        function init() {
            vm.validarTelefono = /^\(?(\d{2})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/;
            obtenerParametros();
            if (angular.isDefined($rootScope.cancelarPresentacion) && $rootScope.cancelarPresentacion == 1) {
                $rootScope.active = 1;
            }
            localStorage.removeItem("objInstalacion");
            vm.dataContacto.tipoContacto = 1
            /* $rootScope.wqRootRefTempSiso=$location.search().ref; */
            /*
			 * vm.dataContacto.tipoContacto=1;
			 * vm.dataAdministrado.persona.idPersona = 88;
			 * vm.dataAdministrado.tipoAdministrado = 1;
			 * vm.dataListaInstalacion.idAdministrado = 73;
			 * vm.dataListaInstalacion.estado = 2;
			 */
            // vm.dataAdministrado.entidad.idEntidad = 133;
            // vm.dataAdministrado.tipoAdministrado = 2;
            listarDepartamento();
            buscar(localStorage.objlocalStRefSisoplkijsq);
            cargarCombos();
            // listar departamentos y
            // listarDepartamentoPersona();
            vm.dataContactoAdministrado = ContactoAdministradoFactory.model();
            vm.dataInstalacion = InstalacionFactory.model();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad').controller('UsuarioUbigeoController', UsuarioUbigeoController);
    /* @ngInject */
    function UsuarioUbigeoController(toastr, $scope, ngDialog, $controller, $state, UsuarioFactory , UbigeoFactory, UsuarioUbigeoFactory) {
        var vm = this;
        /* declaracion de variables globales */
        vm.cargarDepartamento  = cargarDepartamento;
        vm.cargarProvincia = cargarProvincia;
        vm.cargarDistrito = cargarDistrito;
        vm.guardarDistrito = guardarDistrito;
       
        vm.listaDepartamento = [];
        vm.listaProvincia = [];
        vm.listaDistrito = [];
        vm.listaUsuariosSSO = [];
        vm.dataUsuarioUbgeo = UsuarioUbigeoFactory.model();
        
        vm.lstUsuarioUbgeo = [];
        vm.verConfigProvincia = verConfigProvincia;
        vm.verConfigDistrito = verConfigDistrito;
        
        function cargarDepartamento(prmUsuario){
        	vm.dataUsuarioUbgeo.idUsuario = prmUsuario.idUsuario;
        	vm.dataUsuarioUbgeo.codigoUsuario = prmUsuario.codigoUsuario;
        	vm.dataUsuarioUbgeo.documento = prmUsuario.documento;
        	vm.dataUsuarioUbgeo.idPerfil = prmUsuario.idPerfil;
        	vm.dataUsuarioUbgeo.estado = "1";
        	vm.dataUsuarioUbgeo.ubigeo = "";
        	listarDepartamento();
        	listarProvincia();
        	listarDistrito();
        }
        
        function cargarConfiguracion(tipo){
        	if(vm.lstUsuarioUbgeo!=null){
        		if(vm.lstUsuarioUbgeo.length > 0){
        			for(var x in vm.lstUsuarioUbgeo){
        				if(tipo == 1){
        					for(var y in vm.listaDepartamento){
        						if(vm.listaDepartamento[y].codigoDepartamento == vm.lstUsuarioUbgeo[x].ubigeo){
        							vm.listaDepartamento[y].isSeleccionado = true;
        						}
        					}
        				}
						if(tipo == 2){
							for(var y in vm.listaProvincia){
        						if(vm.listaProvincia[y].codigoDepartamento + vm.listaProvincia[y].codigoProvincia == vm.lstUsuarioUbgeo[x].ubigeo){
        							vm.listaProvincia[y].isSeleccionado = true;
        						}
        					}
						}
						if(tipo == 3){
							for(var y in vm.listaDistrito){
        						if(vm.listaDistrito[y].codigoDepartamento + vm.listaDistrito[y].codigoProvincia + vm.listaDistrito[y].codigoDistrito == vm.lstUsuarioUbgeo[x].ubigeo){
        							vm.listaDistrito[y].isSeleccionado = true;
        						}
        					}							
						}
        			}
        		}
        	}
        }
        
        function verConfigProvincia(prmDepartamento){
        	vm.dataUsuarioUbgeo.ubigeo = prmDepartamento.codigoDepartamento;
        	listarProvincia();
        	listarDistrito();
        }
        
        function verConfigDistrito(prmProvincia){
        	vm.dataUsuarioUbgeo.ubigeo =  prmProvincia.codigoDepartamento + prmProvincia.codigoProvincia;
        	listarDistrito();
        }
 
        function cargarProvincia (prmDepartamento){
        	console.log('check' + prmDepartamento.isSeleccionado);
        	vm.dataUsuarioUbgeo.ubigeo = prmDepartamento.codigoDepartamento;
        	if(prmDepartamento.isSeleccionado){
        		grabar();
        	}
        	else{
        		eliminar();
        	}
        	
        }
        
        function cargarDistrito (prmProvincia){
        	vm.dataUsuarioUbgeo.ubigeo =  prmProvincia.codigoDepartamento + prmProvincia.codigoProvincia;
        	if(prmProvincia.isSeleccionado){
        		grabar();
        	}
        	else{
        		eliminar();
        	}
        }
        
        function guardarDistrito (prmDistrito){
        	vm.dataUsuarioUbgeo.ubigeo =  prmDistrito.codigoDepartamento + prmDistrito.codigoProvincia + prmDistrito.codigoDistrito ;
        	if(prmDistrito.isSeleccionado){
        		grabar();
        	}
        	else{
        		eliminar();
        	}
        }
        
        function listarDepartamento() {
        	vm.listaDepartamento = [];
            UbigeoFactory.listarDepartamento(angular.copy('')).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            	vm.lstUsuarioUbgeo = [];
            	UsuarioUbigeoFactory.listar(angular.copy(vm.dataUsuarioUbgeo)).then(function(response) {
                     if (response.valido) {
                         for (var x in response.data) {
                             vm.lstUsuarioUbgeo.push(response.data[x]);
                         }
                     } else {
                         toastr.error(response.mensaje);
                     }
                 }).catch(function(error) {
                     toastr.error('Error al consultar');
                 }).finally(function() {
                	 cargarConfiguracion(1);
                 });
            });
        }

        function listarProvincia() {
        	if( vm.dataUsuarioUbgeo.ubigeo == null){
        		return;
        	}
        	
        	vm.listaProvincia = [];
        	
            var provincia = {
            	codigoDepartamento : vm.dataUsuarioUbgeo.ubigeo.substring(0,2),
            };
            UbigeoFactory.listarProvincia(angular.copy(provincia)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            	cargarConfiguracion(2);
            	if (vm.dataUsuarioUbgeo.provincia != null && vm.dataUsuarioUbgeo.provincia != '') {
                    listarDistrito();
                }
            });
        }

        function listarDistrito() {
        	
        	if( vm.dataUsuarioUbgeo.ubigeo == null){
        		return;
        	}
        	
        	vm.listaDistrito = [];
            var distrito = {
               codigoDepartamento : vm.dataUsuarioUbgeo.ubigeo.substring(0,2),
               codigoProvincia  : vm.dataUsuarioUbgeo.ubigeo.substring(2,4)
            };
           
            UbigeoFactory.listarDistrito(distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {cargarConfiguracion(3);});
        }
        
        function grabar(){
        	   UsuarioUbigeoFactory.registrar(angular.copy(vm.dataUsuarioUbgeo)).then(function(response) {
                   if (response != null && response.valido) {
                   }
               }).catch(function(error) {
                   toastr.error('No se pudo grabar la información.');
               });
        }
        
        function eliminar (){
        	 UsuarioUbigeoFactory.eliminar(angular.copy(vm.dataUsuarioUbgeo)).then(function(response) {
                 if (response != null && response.valido) {
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo eliminar la información.');
             });
        }

        function cargarUsuarioSSO(){
        	
        	 var idPerfilDigitador = 0;
        	
        	 UsuarioUbigeoFactory.obtenerPerfilDigitador().then(function(response) {
                 if (response != null && response.valido) {
                	 idPerfilDigitador = angular.copy(response.data);
                	 var tempusuario = {
                			 idPerfil : idPerfilDigitador,
                	};
                	 
                	 console.log('idPerfilDigitador ' + idPerfilDigitador);
                	
                	UsuarioFactory.listarUsuariosSSO(angular.copy(tempusuario)).then(function(response) {
                             if (response.valido) {
                                 for (var x in response.data) {
                                     vm.listaUsuariosSSO.push(response.data[x]);
                                 }
                             } else {
                                 toastr.error(response.mensaje);
                             }
                         }).catch(function(error) {
                             toastr.error('Error al consultar');
                         }).finally(function() {});
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo eliminar la información.');
             });
        	 
        	
        	 
        	
        }

        function init() {
        	cargarUsuarioSSO();
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad').controller('PerfilRegistroController', PerfilRegistroController);
    /* @ngInject */
    function PerfilRegistroController(toastr, $scope, ngDialog, UsuarioFactory, PerfilFactory) {
        var vm = this;
        /*declaracion de variables globales*/
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.dataPerfil = PerfilFactory.model();
        //declarar variables para guardar los combos desde la bd
        /*vm.listaTiposDocumentoPersona = [];
        vm.listaTiposPerfil = [];
        vm.listaTiposGeneros = [];
        vm.listaTiposUsuario = [];*/
        vm.listaPerfiles = [];
        /*declaración de métodos enlazados a la vista*/
        vm.limpiar = limpiar;
        vm.editarPerfil = editarPerfil;
        vm.dataUsuario = [];
        vm.cancelar = cancelar;
        vm.guardar = guardar;
        vm.eliminar = eliminar;
        vm.confirmarEliminacion = confirmarEliminacion;
        /*	vm.cambiarTipoPersona = cambiarTipoPersona;
        	vm.cambiarTipoPerfil = cambiarTipoPerfil;*/
        /*implementación de métodos*/
        /*
        	function cargarCombos() {
        		var codigosCombos = ['TipoDocumentoPersona','TipoUsuario','TipoGenero','TipoPerfil'];
        		MaestroFactory
        		.buscarPorCodigoTabla(angular.copy(codigosCombos)) 
        		.then(function (response) {
        			if (response!=null&&response.valido)
        			{
        				for(var x in response.data)
        				{
        					var tipoCombo = response.data[x].Key;
        					var datosCombo = response.data[x].Value;
        					switch(tipoCombo)
        					{
        						case 'TipoDocumentoPersona' : vm.listaTiposDocumentoPersona = datosCombo; break;
        						case 'TipoUsuario' : vm.listaTiposUsuario = datosCombo; break;
        						case 'TipoGenero' : vm.listaTiposGeneros = datosCombo; break;
        						case 'TipoPerfil' : vm.listaTiposPerfil = datosCombo; break;
        						default : break;
        					}
        				}
        			}
        		})
        		.catch(function (error) {
        			toastr.error('No se pudo obtener los datos para los combos.');
        		});
        	}*/
        function cancelar() {
            //localStorage.removeItem('objLocalUsuario');
            $state.go('vlibrary.home.usuario.listado'); //, { dataAlumno : null }
        }

        function guardar() {
            if (vm.dataPerfil.idPerfil == 0) {
                registrar();
            } else {
                actualizar();
            }
        }
        /*
        		function cambiarTipoPersona() {
        			switch (vm.dataUsuario.persona.idTipoPersona) {
        				case '' : vm.dataUsuario.idTipoPerfil = ''; break;
        				case '1' : vm.dataUsuario.idTipoPerfil = '1'; break;
        				case '2' : vm.dataUsuario.idTipoPerfil = '2'; break;
        				case '3' : vm.dataUsuario.idTipoPerfil = '2'; break;
        				case '4' : vm.dataUsuario.idTipoPerfil = '3'; break;
        				default: vm.dataUsuario.idTipoPerfil = ''; break;
        			}
        		}

        		function cambiarTipoPerfil() {
        			switch (vm.dataUsuario.idTipoPerfil) {
        				case '' : vm.dataUsuario.persona.idTipoPersona = ''; break;
        				case '1' : vm.dataUsuario.persona.idTipoPersona = '1'; break;
        				case '2' : vm.dataUsuario.persona.idTipoPersona = '2'; break;
        				case '3' : vm.dataUsuario.persona.idTipoPersona = '4'; break;
        				default: vm.dataUsuario.persona.idTipoPersona = ''; break;
        			}
        		}
        */
        function limpiar() {
            vm.dataPerfil = PerfilFactory.model();
        }

        function registrar() {
            console.log("vm.dataPerfil" + vm.dataPerfil);
            PerfilFactory.registrar(angular.copy(vm.dataPerfil)).then(function(response) {
                if (response.valido) {
                    vm.dataPerfil.idPerfil = response.data;
                    toastr.success('Perfil registrado con codigo ' + vm.dataPerfil.idPerfil);
                    listar();
                    limpiar();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al registrar Perfil.')
            });
        }

        function actualizar() {
            PerfilFactory.actualizar(angular.copy(vm.dataPerfil)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                    limpiar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al actualizar el Perfil')
            });
        }

        function listar() {
            PerfilFactory.listar().then(function(response) {
                if (response.valido) {
                    vm.listaPerfiles = response.data;
                    console.log("vm.listaPerfiles" + vm.listaPerfiles);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al registrar Perfil.')
            });
        }

        function editarPerfil(idPerfil) {
            for (var i = 0; i < vm.listaPerfiles.length; i++) {
                if (idPerfil == vm.listaPerfiles[i].idPerfil) {
                    vm.dataPerfil.idPerfil = vm.listaPerfiles[i].idPerfil;
                    vm.dataPerfil.nombrePerfil = vm.listaPerfiles[i].nombrePerfil;
                }
            }
        }

        function confirmarEliminacion(idPerfil) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar Perfil Numero : ' + idPerfil + '?'
                },
                width: 350,
                className: 'ngdialog-theme-app'
            }).then(function(okValue) {
                eliminar(idPerfil);
            }, function(cancelValue) {});
        }

        function eliminar(idPerfil) {
            vm.dataPerfil.idPerfil = idPerfil;
            PerfilFactory.eliminar(angular.copy(vm.dataPerfil)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Hubo un error al actualizar el Perfil')
            });
        }

        function init() {
            /*	cargarCombos();*/
            listar();
            if (angular.isDefined(localStorage.objLocalUsuario)) {
                vm.dataUsuario = angular.fromJson(localStorage.objLocalUsuario);
            }
        }
        init();
        /*fin de los metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ReporteSupervisionController', ReporteSupervisionController);
    /* @ngInject */
    function ReporteSupervisionController($location, $rootScope, toastr, ngDialog, InstalacionPresentacionFactory , ResiduoFactory , ODFactory, InformeMonitoreoFactory , ReporteFactory, AdministradoFactory, GraficoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, SolicitudFactory, $scope, $state, CuestionarioFactory, CookiesFactory,OpcionPreguntaFactory, InstrumentoGestionFactory , API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        $rootScope.active = 0;
        $scope.serial = 1;
        /* Configuracion de paginacion de tablas */
        vm.urlData = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        /** *************************************************************************** */
      
        vm.od = ODFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.filtro = ReporteFactory.model();
      
        // reporte 1
        vm.listaReporteUnidadesFiscalizables = [];
        // reporte 2
        vm.listaReporteUnidadesFiscalizablesAdmin = [];
        // reporte 3
        vm.listaReporteIga = [];
        // reporte 4
        vm.listaReportePreliminarAdministrado = [];
        
        vm.listaOD = [];
        vm.listaDepartamento = [];
        vm.listaProvincia = [];
        vm.listaDistrito = [];
        vm.listarDepartamento = listarDepartamento;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        
        vm.verReporteUnidadesFiscalizables = verReporteUnidadesFiscalizables;
        vm.verReporteUnidadesFiscalizablesPorAdmin = verReporteUnidadesFiscalizablesPorAdmin;
        vm.verReporteIgas = verReporteIgas;
        vm.verReportePreliminarAdministrado = verReportePreliminarAdministrado;
        vm.buscarAdministrado = buscarAdministrado;
        
        vm.verIgas = verIgas;
        vm.verImas = verImas;
        vm.verDMR = verDMR;
        vm.verMRSP = verMRSP;
        vm.verPC = verPC;
        vm.verIAA = verIAA;
        vm.verPMR = verPMR;
        vm.verRI = verRI;
        
        vm.verGraficoUnidadesFiscalizables = false;
        vm.verGrafico = verGrafico;
        vm.exportarExcel = exportarExcel;
        vm.exportarPDF = exportarPDF;
        vm.verReporteIgaPorAdministrado = false;
        vm.verReporteIgaPorUbigeo = false;
        vm.verReporteIgaPorOd  = false;
        /** *** */
        vm.limpiarfiltros = limpiarfiltros;

        /** *********************************************************************** */
        function cargarCombos() {
        	 listarOD();
        	 listarDepartamento();
        }
        
        function listarOD() {
            vm.listaOD = [{
                idod: '',
                nombre: 'Seleccione'
            }];
            ODFactory.listar(vm.od).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaOD.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }
        
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Seleccione'
            }];
            UbigeoFactory.listarDepartamento(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarProvincia();
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.provincia.codigoDepartamento = vm.filtro.codigodepartamento;
            vm.provincia.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarProvincia(vm.provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarDistrito();
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            vm.distrito.codigoDepartamento = vm.filtro.codigodepartamento;
            vm.distrito.codigoProvincia = vm.filtro.codigoprovincia;
            vm.distrito.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarDistrito(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * 5 - 4;
        }

        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            localStorage.removeItem("objInstalacion");
            cargarCombos();
        }
        
        function verReporteUnidadesFiscalizables(){
        	
        	if(vm.filtro.codigodepartamento==null || vm.filtro.codigodepartamento==''){
        		ReporteFactory.verReporteUnidadesFiscalizablesDepartamento(angular.copy(vm.filtro)).then(function(response) {
                    if (response.valido) {
                        vm.listaReporteUnidadesFiscalizables = angular.copy(response.data);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
        	}
        	else{
        		if(vm.filtro.codigoprovincia==null || vm.filtro.codigoprovincia==''){
            		ReporteFactory.verReporteUnidadesFiscalizablesProvincia(angular.copy(vm.filtro)).then(function(response) {
                        if (response.valido) {
                            vm.listaReporteUnidadesFiscalizables = angular.copy(response.data);
                        } else {
                            toastr.error(response.mensaje);
                        }
                    }).catch(function(error) {
                        toastr.error('Error al consultar');
                    });
            	}
        		else{
        			ReporteFactory.verReporteUnidadesFiscalizablesDistrito(angular.copy(vm.filtro)).then(function(response) {
                        if (response.valido) {
                            vm.listaReporteUnidadesFiscalizables = angular.copy(response.data);
                        } else {
                            toastr.error(response.mensaje);
                        }
                    }).catch(function(error) {
                        toastr.error('Error al consultar');
                    });
        		}
        	}
            
        }
        
		function verReporteUnidadesFiscalizablesPorAdmin(){
			if(vm.filtro.codigodepartamento==null || vm.filtro.codigodepartamento==''){
        		ReporteFactory.verReporteUnidadesFiscalizablesAdminDepartamento(angular.copy(vm.filtro)).then(function(response) {
                    if (response.valido) {
                        vm.listaReporteUnidadesFiscalizablesAdmin = angular.copy(response.data);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
        	}
        	else{
        		if(vm.filtro.codigoprovincia==null || vm.filtro.codigoprovincia==''){
            		ReporteFactory.verReporteUnidadesFiscalizablesAdminProvincia(angular.copy(vm.filtro)).then(function(response) {
                        if (response.valido) {
                            vm.listaReporteUnidadesFiscalizablesAdmin = angular.copy(response.data);
                        } else {
                            toastr.error(response.mensaje);
                        }
                    }).catch(function(error) {
                        toastr.error('Error al consultar');
                    });
            	}
        		else{
        			ReporteFactory.verReporteUnidadesFiscalizablesAdminDistrito(angular.copy(vm.filtro)).then(function(response) {
                        if (response.valido) {
                            vm.listaReporteUnidadesFiscalizablesAdmin = angular.copy(response.data);
                        } else {
                            toastr.error(response.mensaje);
                        }
                    }).catch(function(error) {
                        toastr.error('Error al consultar');
                    });
        		}
        	}
	    }
		
		function verReporteIgas(){
			vm.verReporteIgaPorAdministrado = false;
			vm.verReporteIgaPorOd = false;
			vm.verReporteIgaPorUbigeo  = false;
			if(vm.filtro.idAdministrado!=null && vm.filtro.idAdministrado!=0){
				 vm.verReporteIgaPorAdministrado = true;
				 ReporteFactory.verReporteIgaPorAdministrado(angular.copy(vm.filtro)).then(function(response) {
		                if (response.valido) {
		                    vm.listaReporteIga = angular.copy(response.data);
		                } else {
		                    toastr.error(response.mensaje);
		                }
		            }).catch(function(error) {
		                toastr.error('Error al consultar');
		            });
			}
			else if(vm.filtro.codigood!=null && vm.filtro.codigood!=''){
				 vm.verReporteIgaPorOd = true;
				 vm.filtro.nombreod = obtenerNombreOd(vm.filtro.codigood);
				 ReporteFactory.verReporteIgaPorOd(angular.copy(vm.filtro)).then(function(response) {
		                if (response.valido) {
		                    vm.listaReporteIga = angular.copy(response.data);
		                } else {
		                    toastr.error(response.mensaje);
		                }
		            }).catch(function(error) {
		                toastr.error('Error al consultar');
		            });
			}
			else if(vm.filtro.codigodepartamento!=null && vm.filtro.codigodepartamento!=''){
			     vm.verReporteIgaPorUbigeo  = true;
				 ReporteFactory.verReporteIgaPorUbigeo(angular.copy(vm.filtro)).then(function(response) {
		                if (response.valido) {
		                    vm.listaReporteIga = angular.copy(response.data);
		                } else {
		                    toastr.error(response.mensaje);
		                }
		            }).catch(function(error) {
		                toastr.error('Error al consultar');
		            });
			}
		}
		
		function obtenerNombreOd(codigood){
			  for (var x in vm.listaOD) {
                 if(vm.listaOD[x].idod == codigood){
                	 return vm.listaOD[x].nombre;
                 }
              }
		}
		
		function verReportePreliminarAdministrado(){
			ReporteFactory.verReportePreliminarPorAdministrado(angular.copy(vm.filtro)).then(function(response) {
                if (response.valido) {
                    vm.listaReportePreliminarAdministrado = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
		}
		
		 function buscarAdministrado() {
        	 ngDialog.open({
                 template: 'app/modules/supervision/administrado/selector/administrado-selector.html',
                 controller: 'AdministradoSelectorController',
                 controllerAs: 'vm',
                 width: '800px'
             }).closePromise.then(function() {
            	 vm.filtro.idAdministrado = $rootScope.objAdministrado.idAdministrado;
            	 vm.filtro.razonsocial = $rootScope.objAdministrado.entidad.razonSocial;
             });
        }
		 
		 function verIgas(item){
			 var prmInstrumentoGestion = InstrumentoGestionFactory.model();
		     prmInstrumentoGestion.idAdministrado = item.idAdministrado;
		     prmInstrumentoGestion.idInstalacion = item.idInstalacion;
		     prmInstrumentoGestion.fechadesde = item.fechadesde;
		     prmInstrumentoGestion.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmInstrumentoGestion", angular.copy(angular.toJson(prmInstrumentoGestion)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/iga/dialog/instrumento-gestion-lista.html',
                 controller: 'InstrumentoGestionListaController',
                 controllerAs: 'vm',
                 width: '800px'
             }).closePromise.then(function() {
             });
		 }
		 
		 function verImas(item){
			 var prmInformeMonitoreo = InformeMonitoreoFactory.model();
			 prmInformeMonitoreo.idAdministrado = item.idAdministrado;
			 prmInformeMonitoreo.idInstalacion = item.idInstalacion;
			 prmInformeMonitoreo.fechadesde = item.fechadesde;
			 prmInformeMonitoreo.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmInformeMonitoreo", angular.copy(angular.toJson(prmInformeMonitoreo)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/ima/dialog/informe-monitoreo-lista.html',
                 controller: 'InformeMonitoreoListaController',
                 controllerAs: 'vm',
                 width: '800px'
             }).closePromise.then(function() {
             });
		 }
		 function verDMR(item){
			 var prmResiduo = ResiduoFactory.model();
			 prmResiduo.idAdministrado = item.idAdministrado;
			 prmResiduo.idInstalacion = item.idInstalacion;
			 prmResiduo.tipo = 'DR';
			 prmResiduo.fechadesde = item.fechadesde;
			 prmResiduo.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmResiduo", angular.copy(angular.toJson(prmResiduo)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/residuo/dialog/residuo-lista.html',
                 controller: 'ResiduoListaController',
                 controllerAs: 'vm',
                 width: '800px'
             }).closePromise.then(function() {
             });
		 }
		 function verMRSP(item){
			 var prmResiduo = ResiduoFactory.model();
			 prmResiduo.idAdministrado = item.idAdministrado;
			 prmResiduo.idInstalacion = item.idInstalacion;
			 prmResiduo.tipo = 'MR';
			 prmResiduo.fechadesde = item.fechadesde;
			 prmResiduo.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmResiduo", angular.copy(angular.toJson(prmResiduo)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/residuo/dialog/residuo-lista.html',
                 controller: 'ResiduoListaController',
                 controllerAs: 'vm',
                 width: '800px'
             }).closePromise.then(function() {
             }); 
		 }
		 function verPC(item){
			 var prmPresentacion = InstalacionPresentacionFactory.model();
			 prmPresentacion.idAdministrado = item.idAdministrado;
			 prmPresentacion.idInstalacion = item.idInstalacion;
			 prmPresentacion.codigoTipoInforme = 1;
			 prmPresentacion.periodo = 0;
			 prmPresentacion.fechadesde = item.fechadesde;
			 prmPresentacion.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmPresentacion", angular.copy(angular.toJson(prmPresentacion)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/presentacion/dialog/presentacion-lista.html',
                 controller: 'PresentacionListaController',
                 controllerAs: 'vm',
                 width: '1000px'
             }).closePromise.then(function() {
             }); 
		 }
		 function verIAA(item){
			 var prmPresentacion = InstalacionPresentacionFactory.model();
			 prmPresentacion.idAdministrado = item.idAdministrado;
			 prmPresentacion.idInstalacion = item.idInstalacion;
			 prmPresentacion.codigoTipoInforme = 2;
			 prmPresentacion.periodo = 0;
			 prmPresentacion.fechadesde = item.fechadesde;
			 prmPresentacion.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmPresentacion", angular.copy(angular.toJson(prmPresentacion)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/presentacion/dialog/presentacion-lista.html',
                 controller: 'PresentacionListaController',
                 controllerAs: 'vm',
                 width: '1000px'
             }).closePromise.then(function() {
             }); 
		 }
		 function verPMR(item){
			 var prmPresentacion = InstalacionPresentacionFactory.model();
			 prmPresentacion.idAdministrado = item.idAdministrado;
			 prmPresentacion.idInstalacion = item.idInstalacion;
			 prmPresentacion.codigoTipoInforme = 3;
			 prmPresentacion.periodo = 0;
			 prmPresentacion.fechadesde = item.fechadesde;
			 prmPresentacion.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmPresentacion", angular.copy(angular.toJson(prmPresentacion)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/presentacion/dialog/presentacion-lista.html',
                 controller: 'PresentacionListaController',
                 controllerAs: 'vm',
                 width: '1000px'
             }).closePromise.then(function() {
             }); 
		 }
		 function verRI(item){
			 var prmPresentacion = InstalacionPresentacionFactory.model();
			 prmPresentacion.idAdministrado = item.idAdministrado;
			 prmPresentacion.idInstalacion = item.idInstalacion;
			 prmPresentacion.codigoTipoInforme = 7;
			 prmPresentacion.periodo = 0;
			 prmPresentacion.fechadesde = item.fechadesde;
			 prmPresentacion.fechahasta = item.fechahasta;
			 
		     localStorage.setItem("prmPresentacion", angular.copy(angular.toJson(prmPresentacion)));
	         
			 ngDialog.open({
                 template: 'app/modules/supervision/presentacion/dialog/presentacion-lista.html',
                 controller: 'PresentacionListaController',
                 controllerAs: 'vm',
                 width: '1000px'
             }).closePromise.then(function() {
             }); 
		 }

		 function verGrafico(opcion){
			 if(opcion==1){
				verGraficoUnidadesFiscalizables();
			 }
			 if(opcion==2){
				 verGraficoUnidadesFiscalizablesAdmin();
			 }
			 if(opcion==3){
				 verGraficoIgas();
			 }
		 }
		 
		 function verGraficoUnidadesFiscalizables(){
			 if( vm.filtro.	codigodepartamento==null ||  vm.filtro.	codigodepartamento==''){
				 toastr.error('Debe seleccionar un departamento');
				 return;
			 }
			 var filtro = GraficoFactory.model();
			 filtro.codigodepartamento = vm.filtro.codigodepartamento;
			 filtro.codigoprovincia = vm.filtro.codigoprovincia;
			 filtro.codigodistrito = vm.filtro.codigodistrito;
			 
			 GraficoFactory.instalacionesxUbigeo(angular.copy(filtro)).then(function(response) {
	               if (response.valido) {
	                	createChartUnidadesFiscalizables(angular.copy(response.data[0]));
	               } else {
	                    toastr.error(response.mensaje);
	               }
	            }).catch(function(error) {
	                toastr.error('Error al consultar');
	            });
		 }
		 
		 function verGraficoUnidadesFiscalizablesAdmin(){
			 
			 if( vm.filtro.	codigodepartamento==null ||  vm.filtro.	codigodepartamento==''){
				 toastr.error('Debe seleccionar un departamento');
				 return;
			 }
			 
			 var filtro = GraficoFactory.model();
			 filtro.codigodepartamento = vm.filtro.codigodepartamento;
			 filtro.codigoprovincia = vm.filtro.codigoprovincia;
			 filtro.codigodistrito = vm.filtro.codigodistrito;
			 
			 GraficoFactory.instalacionesxUbigeoAdmin(angular.copy(filtro)).then(function(response) {
				   if (response.valido) {
	            	   createChartUnidadesFiscalizablesAdmin(angular.copy(response.data[0]));
	            	   createChartUnidadesFiscalizablesAdminPorcentaje(angular.copy(response.data[0]));
	               } else {
	                    toastr.error(response.mensaje);
	               }
	            }).catch(function(error) {
	                toastr.error('Error al consultar');
	            });
		 }
		 
		 function verGraficoIgas(){
				vm.verReporteIgaPorAdministrado = false;
				vm.verReporteIgaPorOd = false;
				vm.verReporteIgaPorUbigeo  = false;
				
				
				if(vm.filtro.idAdministrado!=null && vm.filtro.idAdministrado!=0){
					 vm.verReporteIgaPorAdministrado = true;
					 
					 var filtro = GraficoFactory.model();
					 filtro.idAdministrado = vm.filtro.idAdministrado;
					 filtro.codigodepartamento = vm.filtro.codigodepartamento;
					 filtro.codigoprovincia = vm.filtro.codigoprovincia;
					 filtro.codigodistrito = vm.filtro.codigodistrito;
					 filtro.fechadesde = vm.filtro.fechadesde;
					 filtro.fechahasta = vm.filtro.fechahasta;
					 
					 
					 GraficoFactory.igasPorUnidades(angular.copy(filtro)).then(function(response) {
						 if (response.valido) {
			            	   createCharIgasPorUnidades(angular.copy(response.data[0]));
			              } else {
			                    toastr.error(response.mensaje);
			              }
			            }).catch(function(error) {
			                toastr.error('Error al consultar');
			            });
				}
				else if(vm.filtro.codigood!=null && vm.filtro.codigood!=''){
					 vm.verReporteIgaPorOd = true;
					 var filtro = GraficoFactory.model();
					 filtro.idAdministrado = vm.filtro.idAdministrado;
					 filtro.codigodepartamento = vm.filtro.codigodepartamento;
					 filtro.codigoprovincia = vm.filtro.codigoprovincia;
					 filtro.codigodistrito = vm.filtro.codigodistrito;
					 filtro.codigood = vm.filtro.codigood;
					 filtro.fechadesde = vm.filtro.fechadesde;
					 filtro.fechahasta = vm.filtro.fechahasta;
					 
					 GraficoFactory.igasPorAdministrado(angular.copy(filtro)).then(function(response) {
						 if (response.valido) {
							 createCharIgasPorAdministrado(angular.copy(response.data[0]));
			              } else {
			                    toastr.error(response.mensaje);
			              }
			            }).catch(function(error) {
			                toastr.error('Error al consultar');
			            });
				}
				else if(vm.filtro.codigodepartamento!=null && vm.filtro.codigodepartamento!=''){
				     vm.verReporteIgaPorUbigeo  = true;
				     var filtro = GraficoFactory.model();
					 filtro.idAdministrado = vm.filtro.idAdministrado;
					 filtro.codigodepartamento = vm.filtro.codigodepartamento;
					 filtro.codigoprovincia = vm.filtro.codigoprovincia;
					 filtro.codigodistrito = vm.filtro.codigodistrito;
					 filtro.fechadesde = vm.filtro.fechadesde;
					 filtro.fechahasta = vm.filtro.fechahasta;
					 
				     GraficoFactory.igasPorUbigeo(angular.copy(filtro)).then(function(response) {
				    	 if (response.valido) {
				    		 createCharIgasPorUbigeo(angular.copy(response.data[0]));
			              } else {
			                    toastr.error(response.mensaje);
			              }
			            }).catch(function(error) {
			                toastr.error('Error al consultar');
			            });
				}
			}
		 
		 
		 function createChartUnidadesFiscalizables(dps) {
	        	if(dps.length==0){
	        		vm.verGraficoUnidadesFiscalizables = false;
	        		return;
	        	}
	        	vm.verGraficoUnidadesFiscalizables = true;
	            var chart2 = new CanvasJS.Chart("chartPieUnidadesFiscalizables", {
	            	colorSet: "greenShades",
	              title: {
	            	fontFamily: "Arial",
	            	fontWeight: "bold",
	            	fontSize: 13,
	                text: "Unidades fiscalizables a nivel nacional"
	              },
	              axisX:{
	              	labelFontSize:10,
	              },
	              exportEnabled: false,
	              legend: {
	          		cursor: "pointer",
	          		itemclick: toggleDataSeries,
	          		verticalAlign: "bottom",
	          		horizontalAlign: "center",
	          		fontSize: 10,
	          	  },
	              data: [{
	            	type: "doughnut",
	            	showInLegend: true,
	            	indexLabel: "{y}",
	                dataPoints: dps
	                }]
	            });
	            chart2.render();
	     }
		 
		 function createChartUnidadesFiscalizablesAdmin(dps){

	            var chart1 = new CanvasJS.Chart("chartColumnUnidadesFiscalizables", {
	              colorSet: "greenShades",
	              title: {
	            	fontFamily: "Arial",
	              	fontWeight: "bold",
	              	fontSize: 14,
	                text: "Unidades fiscalizables por Administrado"
	              },
	              axisX:{
	           	   labelFontSize:10,
	           	   interval: 1
	           	 },
	           	 axisY:{
	           		 gridColor: "transparent",
	           	 },
	              exportEnabled: false,
	              dataPointMaxWidth: 30,
	              legend: {
	          		cursor: "pointer",
	          		itemclick: toggleDataSeries,
	          		verticalAlign: "top",
	          		horizontalAlign: "center",
	          	  },
	              data: [{
	            	indexLabel: "{y}",
	            	type: "column",
	                dataPoints: dps
	              }]
	            });
	            chart1.render();
		 }
		 
		 function createCharIgasPorUnidades(dps){

	            var chart1 = new CanvasJS.Chart("chartColumnIgasUnidades", {
	              colorSet: "greenShades",
	              title: {
	            	fontFamily: "Arial",
	              	fontWeight: "bold",
	              	fontSize: 14,
	                text: "Igas por Unidades fiscalizables"
	              },
	              axisX:{
	           	   labelFontSize:10,
	           	   interval: 1
	           	 },
	           	 axisY:{
	           		 gridColor: "transparent",
	           	 },
	              exportEnabled: false,
	              dataPointMaxWidth: 30,
	              legend: {
	          		cursor: "pointer",
	          		itemclick: toggleDataSeries,
	          		verticalAlign: "top",
	          		horizontalAlign: "center",
	          	  },
	              data: [{
	            	indexLabel: "{y}",
	            	type: "column",
	                dataPoints: dps
	              }]
	            });
	            chart1.render();
		 }
		 
		 
		 function createCharIgasPorAdministrado(dps){

	            var chart1 = new CanvasJS.Chart("chartColumnIgasAdministrado", {
	              colorSet: "greenShades",
	              title: {
	            	fontFamily: "Arial",
	              	fontWeight: "bold",
	              	fontSize: 14,
	                text: "Igas por Administrado"
	              },
	              axisX:{
	           	   labelFontSize:10,
	           	   interval: 1
	           	 },
	           	 axisY:{
	           		 gridColor: "transparent",
	           	 },
	              exportEnabled: false,
	              dataPointMaxWidth: 30,
	              legend: {
	          		cursor: "pointer",
	          		itemclick: toggleDataSeries,
	          		verticalAlign: "top",
	          		horizontalAlign: "center",
	          	  },
	              data: [{
	            	indexLabel: "{y}",
	            	type: "bar",
	                dataPoints: dps
	              }]
	            });
	            chart1.render();
		 }
		 
		 
		 function createCharIgasPorUbigeo(dps){

	            var chart1 = new CanvasJS.Chart("chartColumnIgasUbigeo", {
	              colorSet: "greenShades",
	              title: {
	            	fontFamily: "Arial",
	              	fontWeight: "bold",
	              	fontSize: 14,
	                text: "Igas por Ubigeo"
	              },
	              axisX:{
	           	   labelFontSize:10,
	           	   interval: 1
	           	 },
	           	 axisY:{
	           		 gridColor: "transparent",
	           	 },
	              exportEnabled: false,
	              dataPointMaxWidth: 30,
	              legend: {
	          		cursor: "pointer",
	          		itemclick: toggleDataSeries,
	          		verticalAlign: "top",
	          		horizontalAlign: "center",
	          	  },
	              data: [{
	            	indexLabel: "{y}",
	            	type: "bar",
	                dataPoints: dps
	              }]
	            });
	            chart1.render();
		 }
		 
		 function createChartUnidadesFiscalizablesAdminPorcentaje(dps) {
	        	
	            var chart2 = new CanvasJS.Chart("chartPieUnidadesFiscalizablesAdminPorc", {
	            	colorSet: "greenShades",
	              title: {
	            	fontFamily: "Arial",
	            	fontWeight: "bold",
	            	fontSize: 13,
	                text: "Unidades fiscalizables por Administrado en %"
	              },
	              axisX:{
	              	labelFontSize:10,
	              },
	              exportEnabled: false,
	              legend: {
	          		cursor: "pointer",
	          		itemclick: toggleDataSeries,
	          		verticalAlign: "bottom",
	          		horizontalAlign: "center",
	          		fontSize: 10,
	          	  },
	              data: [{
	            	type: "doughnut",
	            	showInLegend: true,
	            	indexLabel: "{label}",
	                dataPoints: dps
	                }]
	            });
	            chart2.render();
	     }
	        
		 function toggleDataSeries(e) {
	        	if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
	        		e.dataSeries.visible = false;
	        	} else {
	        		e.dataSeries.visible = true;
	        	}
	        	e.chart.render();
	      }
		 
		 function exportarExcel(tipo){
			 vm.filtro.tiporeporte = tipo;
			 ReporteFactory.descargarExcel(angular.copy(vm.filtro),'ReporteSupervision.xls');
		 }
		 
		 function exportarPDF(tipo,item){
			 
			 var nombre = "";
			 
			 if(tipo=='REP_PRE_ADM'){
				 vm.filtro.idAdministradoAux = item.idAdministrado;
				 vm.filtro.rucAux = item.ruc;
				 vm.filtro.razonsocialAux = item.razonsocial;
				 nombre = 'Reporte_PreliminarAdministrado.pdf';
				 vm.filtro.tiporeporte = tipo;
				 ReporteFactory.descargarPDF(angular.copy(vm.filtro),nombre);
			 }
			 if(tipo=='REP_PRE_ADM_INS'){
				 nombre = 'Reporte_PreliminarAdministradoInstalacion.pdf';
				 item.tiporeporte = tipo;
				 item.fechadesde = vm.filtro.fechadesde;
			     item.fechahasta = vm.filtro.fechahasta;
				 ReporteFactory.descargarPDF(angular.copy(item),nombre);
			 }
			 if(tipo=='REP_UF_ADM'){
				 nombre = 'Reporte_UnidadesPorAdministrado.pdf';
				 item.tiporeporte = tipo;
				 ReporteFactory.descargarPDF(angular.copy(item),nombre);
			 }
			
		 }
		 
		 function limpiarfiltros(){
			 vm.filtro = ReporteFactory.model(); 
		 }
        
        init();
        /* fin de controller */
    }
})();
(function() {
	'use strict';
	angular.module('spapp.supervision').controller(
			'ReporteSupervisionDatosController',
			ReporteSupervisionDatosController);
	/** @ngInject */
	function ReporteSupervisionDatosController($rootScope, toastr, $scope,
			ngDialog, API_CONFIG, 
			InstrumentoGestionFactory, InstalacionFactory,
			MaestroFactory, UbigeoFactory, EtapaFactory,
			EntidadFactory, CookiesFactory) {
		var vm = this;
		/* declaracion de variables globales */
		vm.urlData = API_CONFIG.url;
		vm.dataInstalacion = InstalacionFactory.model();

		vm.rutaBase = API_CONFIG.url;
		/* declaracion de variables globales */
		vm.mimeTypes = [];
		vm.extension = "";
		vm.tamanioArchivo = "500";
		vm.caracteresMaximoArchivo = 50;
		vm.idEtapa;
		vm.periodo;
		vm.listaInstrumentos = [];
		vm.listaEtapas = [];

		$scope.config = {
			itemsPerPage : 10,
			fillLastPage : true,
			current : 1
		};

		function cancelar() {
			ngDialog.close();
		}

		/* fin de metodos */
		function init() {
			if (angular.isDefined($rootScope.prmInstalacion)) {
				vm.dataInstalacion = angular.copy($rootScope.prmInstalacion);
				buscarInstrumentoGestion();
				buscarEtapas();
			}
		}
		
		 function buscarInstrumentoGestion() {
	            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.dataInstalacion)).then(function(response) {
	                if (response.valido) {
	                    vm.listaInstrumentos = angular.copy(response.data);
	                } else {
	                    toastr.error(response.mensaje);
	                }
	            }).catch(function(error) {
	                toastr.error('Error al consultar');
	            });
	     }

		 function buscarEtapas() {
	        	
			 	EtapaFactory.listar(angular.copy(EtapaFactory.model())).then(function(response) {
	                if (response.valido) {
	                    vm.listaEtapas = angular.copy(response.data);
	                } else {
	                    toastr.error(response.mensaje);
	                }
	            }).catch(function(error) {
	                toastr.error('Error al consultar');
	            });
	     }

		 
		init();
		/* fin de controller */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.maestro', []);
})();
(function() {
    'use strict';
    angular.module('spapp.maestro').controller('ConfiguracionController', ConfiguracionController);
    /* @ngInject */
    function ConfiguracionController(ngDialog, toastr, $scope, $rootScope, MaestroFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
       
        vm.enviarCorreoAnticipado = enviarCorreoAnticipado;
        vm.listarfechasfrecuencia = listarfechasfrecuencia;
        vm.lstFechasFrecuencia = [];
        vm.lstFechasFrecuenciaDet = [];
        vm.listarfechasfrecuenciaDet = listarfechasfrecuenciaDet;
        vm.prmDiasCorreo = MaestroFactory.modelFrecuenciaFecha() ;
        vm.listarDiasPrevioCorreo = listarDiasPrevioCorreo;
        vm.guardarDiasPrevioCorreo = guardarDiasPrevioCorreo;
        vm.generarIGAS = generarIGAS;
 
        function init() {
        	listarfechasfrecuencia();
        	listarDiasPrevioCorreo();
        }
        init();
        
        function listarfechasfrecuencia(){
       	 	MaestroFactory.listarfechasfrecuencia(MaestroFactory.modelFrecuenciaFecha()).then(function(response) {
                if (response != null && response.valido) {
                	vm.lstFechasFrecuencia = angular.copy(response.data); 
                }
            }).catch(function(error) {
                toastr.error('Hubo un error');
            });
        }
        
        function listarDiasPrevioCorreo(){
        	MaestroFactory.listarDiasPrevioCorreo().then(function(response) {
                if (response != null && response.valido) {
                	vm.prmDiasCorreo = angular.copy(response.data[0]); 
                }
            }).catch(function(error) {
                toastr.error('Hubo un error');
            });
        }
        
        function guardarDiasPrevioCorreo(){
        	MaestroFactory.guardarDiasPrevioCorreo(vm.prmDiasCorreo).then(function(response) {
                if (response != null && response.valido) {
                	toastr.success('Se grabó la configuración de días correctamente.');
                }
            }).catch(function(error) {
                toastr.error('Hubo un error');
            });
        }
        
        function listarfechasfrecuenciaDet(item){
       	 	MaestroFactory.listarfechasfrecuenciaDet(item).then(function(response) {
                if (response != null && response.valido) {
                	vm.lstFechasFrecuenciaDet = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('Hubo un error');
            });
        }
        
        function enviarCorreoAnticipado(){
        	var prmMaestro = MaestroFactory.model();
        	 MaestroFactory.enviarCorreoAnticipado(angular.copy(prmMaestro)).then(function(response) {
                 if (response != null && response.valido) {
                	 toastr.success('Se ejecutó el proceso de envío corrrectamente');
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo ejecutar el proceso de envío de correo');
             });
        }
        
        function generarIGAS(){
	        MaestroFactory.generarIGAS().then(function(response) {
	        	 if (response != null && response.valido) {
                	 toastr.success('Se generaron los IGAS correctamente.');
                 }
	        }).catch(function(error) {
	            toastr.error('Hubo un error');
	        });
        }
        
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ReportePreliminarController', ReportePreliminarController);
    /* @ngInject */
    function ReportePreliminarController($location, $rootScope, toastr, ngDialog, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, SolicitudFactory, $scope, $state, CuestionarioFactory, CookiesFactory,OpcionPreguntaFactory, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.validaArchivoModificacionInst = 0;
        $rootScope.active = 0;
        $scope.serial = 1;
        /* Configuracion de paginacion de tablas */
        vm.urlData = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        /** *************************************************************************** */
        /** * Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataCuestionarioAutosupervision = [];
        /** *************************************************************************** */
        /** * Fin Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataAdministradoContacto = ContactoAdministradoFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataContacto = {
            tipoContacto: '0'
        };
        
        vm.dataInstalacion = InstalacionFactory.model();
        vm.listaTipoPersona = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaTipoDocumento = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSector = [];
        vm.listaSubSector = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaActividad = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSolicitudesInstalacion = [];
        vm.listaContactoAdministrado = [];
        vm.listaArchivosSolicitud = [];
        vm.listaCboTipoContacto = [];
        vm.listaInstalacionAdm = [];
        vm.listaDepartamentoPersona = [];
        vm.listaProvinciaPersona = [];
        vm.listaDistritoPersona = [];
        vm.listaTipoEstablecimiento = [];
        vm.listarContactoPrincipal = [];
        vm.btnAgregarInstalacion = false;
        vm.btnListaInstalacion = true;
        vm.cambiarEstadoContacto = cambiarEstadoContacto;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.validaDocumento = validaDocumento;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.contactoPrincipal = contactoPrincipal;
        vm.mostrarInformacionInstalacionDialog = mostrarInformacionInstalacionDialog;
        vm.MostrarForm = MostrarForm;
        vm.OcultarForm = OcultarForm;
        vm.irCompromisos = irCompromisos;
        vm.irInformeMonitoreo = irInformeMonitoreo;
        vm.mostrarModificarInstalacion = mostrarModificarInstalacion;
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.mostrarCancelarInstalacion = mostrarCancelarInstalacion;
        vm.valorTelefono = valorTelefono;
        vm.modificar = 0;
        vm.limpiarContactoAdmi = limpiarContactoAdmi;
        vm.habilitarTexto = habilitarTexto;
        vm.guardar = guardar;
        vm.cambioDatos = cambioDatos;
        vm.datosReporte = datosReporte;
        /** *** */
        
        vm.ruc;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.buscar = buscar;
        

        function confirmarEliminacion(prmInstalacion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstalacion.numeroInstalacion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstalacion);
            });
        }

        function eliminar(prmInstalacion) {
        	InstalacionFactory.eliminar(angular.copy(prmInstalacion)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarInstalacionesAdministrado();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la instalación');
            });
        }
        
        function datosReporte(prmInstalacion){
             if (prmInstalacion != null) {
                 
                         	$rootScope.prmInstalacion = prmInstalacion;
                         	  ngDialog.open({
                                   template: 'app/modules/reporte/reporte-preliminar/reporte-preliminar-datos.html',
                                   controller: 'ReportePreliminarDatosController',
                                   controllerAs: 'vm',
                                   width: '70%'
                               }).closePromise.then(function(dataDialog) {
                            	   listarInstalacionesAdministrado();
                               });
             } 
        }
        
        function irCompromisos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            $state.go('spapp.home.supervision.cargainfo-instrumento');
        }
        
        
        function irInformeMonitoreo(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            $state.go('spapp.home.supervision.cargainfo-informe-instrumento');
        }
        

        function MostrarForm() {
            vm.btnAgregarInstalacion = true;
            vm.btnListaInstalacion = false;
        }

        function OcultarForm() {
            vm.btnAgregarInstalacion = false;
            vm.btnListaInstalacion = true;
            vm.dataInstalacion = angular.copy(InstalacionFactory.model());
            vm.validaArchivoModificacionInst = 0;
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            listarInstalacionesAdministrado();
        }
        /* implementacion de metodos */
        // usuario.actual= angular.fromJson(localStorage.objSesSisoLocStWqKP);
        /** ****************************************************************** */
        /**/
        function contactoPrincipal(prmData) {
            ContactoAdministradoFactory.modificarFlagPretedeterminadoDeContactoAdmi(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }
        /** *************************************************************** */
        /**/
        function habilitarTexto() {}

        function guardar() {
            habilitarTexto();
        }
        /**/
        /*-----LISTAR CONTACTO ADMINISTRADO------*/

        function cambiarEstadoContacto(data, estado) {
            // vm.confirmarDesactivarAdmi(item);
            var prmData = data;
            if (prmData != null) {
                prmData.estado.codigoRegistro = 2;
                // alert("DESCRRIPCION" +
				// vm.dataAdministradoContacto.estado.descripcion);
                if (prmData.estado.descripcion == 'DESACTIVADO') {
                    prmData.estado.codigoRegistro = 2;
                }
                // prmData.estado = 2;
            }
            ContactoAdministradoFactory.actualizar(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }

        function limpiarContactoAdmi() {
            vm.dataContactoAdministrado.tipoContacto.codigoRegistro = 0;
            vm.dataContactoAdministrado.valor = "";
        }


        function buscar(prm1) {
        	
             if(prm1==null || prm1 == ''){
            	 prm1 = localStorage.objlocalStRefSisoplkijsq;
             }
             
             var ruc = angular.copy(localStorage.wk);
             
             if(!isNaN(ruc)){
            	 ruc=null;
             }
             
             var data = {
                 prm1: prm1,
                 prm2: ruc
             };
             
            AdministradoFactory.buscarxid( /* vm.dataAdministrado */ angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.dataAdministrado = response.data;
                    listarInstalacionesAdministrado();
                } else {
                    toastr.error('Usted no es un Administrado');
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
   	 
            
        }

        function listarSubSector() {
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.subSector = '';
            vm.dataInstalacion.actividad = '';
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaSubSector" +
						 * angular.toJson(vm.listaSubSector));
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }

        function listarActividad() {
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.actividad.codigoRegistro = 0;
            /*
			 * vm.dataInstalacion.actividad=0; vm.listaActividad=[];
			 */
            if (vm.dataInstalacion.subSector != 0) {
                var actividades = {
                    codigoRegistroPadre: vm.dataInstalacion.subSector,
                    codigoMaestro: 'Actividad'
                }
                MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaActividad.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaActividad" +
						 * angular.toJson(vm.listaActividad));
						 * vm.dataNormas.actividad=0;
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        function listarInstalacionesAdministrado() {
        	vm.dataListaInstalacion.idAdministrado = vm.dataAdministrado.idAdministrado;
            InstalacionFactory.listarxUsuarioUbigeo(angular.copy(vm.dataListaInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.listaInstalacionAdm = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarInformacionInstalacionDialog(itemInstalacion) {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html',
                controller: 'InformacionInstalacionDialogController',
                data: {
                    data: itemInstalacion
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }
        /** ******************************************************************************** */
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Seleccione'
            }];
            UbigeoFactory.listarDepartamentoxUsuario(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarProvincia();
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.provincia.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.provincia.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarProvinciaxUsuario(vm.provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarDistrito();
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            vm.distrito.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.distrito.codigoProvincia = vm.dataListaInstalacion.provincia.codigoProvincia;
            vm.distrito.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarDistritoxUsuario(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            vm.validaArchivo = '0';
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                vm.validaArchivo = '1';
                vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
            }
            if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
                console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
            }
        }
        /** *********************************************************************************** */
        function procesoRegistroSolicitudArchivo() {
            if (vm.validaArchivo == '1') {
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
            } else {
                toastr.info('Falta cargar ficha de registro');
                return;
            }
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
            // console.log("vm.listaArchivosSolicitud" +
			// vm.listaArchivosSolicitud);
            // console.log("vm.listaArchivosSolicitud.length" +
			// vm.listaArchivosSolicitud.length);
            vm.dataSolicitud.tipoSolicitud = 3;
            console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
            console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada correctamente');
                    // $state.go('ingreso');
                    // crear metodo para limpiar todos los campos y el campo de
					// file
                    // direccionar al listado de instalaciones
                    console.log("vm.dataSolicitud", vm.dataSolicitud);
                    visualizarModal();
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }

        function visualizarModal() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de nueva instalación ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function visualizarModalSolicitudModificacion() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de modificación de datos ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function procesoModificacionDeInstalacion() {
            if (vm.validaArchivoModificacionInst == 0 && vm.validaArchivo != '1') {
                toastr.warning('Debe subir un archivo para continuar con la modificación');
                return;
            }
            if (vm.validaArchivoModificacionInst == 1) {
                vm.validaArchivo = '0';
            }
            if (vm.validaArchivo == '1') {
                console.log("Realiza el Registro CON NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            } else {
                console.log("Realiza el Registro SIN NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                data.estado = 1;
                data.flagActivo = 1;
                vm.listaSolicitudesInstalacion.push(data);
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataAdministrado.flagActivo = 1;
                vm.dataAdministrado.estado = 1;
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                // console.log("Data a enviar
				// listaArchivosSolicitud",vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudSinArchivo(vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                        console.log("vm.dataSolicitud", vm.dataSolicitud);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            }
            /*
			 * console.log("ENTRA AL PROCESO DE MODIFICACION");
			 * console.log("vm.dataInstalacion",vm.dataInstalacion);
			 */
        }

        function registrarSolicitudArchivo() {
            if (vm.modificar != 1) {
                procesoRegistroSolicitudArchivo();
            } else {
                procesoModificacionDeInstalacion();
            }
        }
        /** ******************************************************************************** */
        /* Metodo para utilizado para cancelar instalacion */
        /** ******************************************************************************** */
        function mostrarCancelarInstalacion(itemInstalacion) {
            if (itemInstalacion.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog-cancelacion/cancelacion-instalacion-dialog.html',
                controller: 'CancelacionInstalacionDialogController',
                data: {
                    data: itemInstalacion,
                    dataAdministrado: vm.dataAdministrado
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function() {
                listarInstalacionesAdministrado();
            });
        }
        /** ********************************************************************************** */
        /* metodo para modificar instalación */
        /** ********************************************************************************** */
        function mostrarModificarInstalacion(item, modificar) {
            // modificar =1 -> Se trata de una modificacion
            debugger;
            if (item.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            vm.dataInstalacion = angular.copy(item);
            console.log(vm.dataInstalacion);
            vm.dataInstalacionTemporal = angular.copy(item);
            console.log(item);
            vm.modificar = modificar;
            vm.validaArchivoModificacionInst = 1;
            // listarSubSector();
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector != '') {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(angular.copy(subSector)).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                }).finally(function() {
                    debugger;
                    vm.dataInstalacion.subSector = angular.copy(item.subSector);
                    if (vm.dataInstalacion.subSector.codigoRegistro != 0) {
                        var actividades = {
                            codigoRegistroPadre: vm.dataInstalacion.subSector.codigoRegistro,
                            codigoMaestro: 'Actividad'
                        }
                        MaestroFactory.buscarRegistroHijo(angular.copy(actividades)).then(function(response) {
                            if (response != null && response.valido) {
                                for (var x in response.data) {
                                    vm.listaActividad.push(response.data[x]);
                                }
                                vm.dataInstalacion.actividad = angular.copy(item.actividad);
                                /*
								 * console.log("vm.listaActividad" +
								 * angular.toJson(vm.listaActividad));
								 * vm.dataNormas.actividad=0;
								 */
                            }
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos para los combos.');
                        });
                    }
                });
            }
            // listarActividad();
            for (var i = 0; i < 3; i++) {
                ejecutarfuncionesOrdenadas(i);
            }
        }

        function ejecutarfuncionesOrdenadas(item) {
            if (item == 0) {
                listarProvincia();
            }
            if (item == 1) {
                listarDistrito();
            }
            if (item == 2) {
                MostrarForm();
            }
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * 5 - 4;
        }

        function valorTelefono(valor) {
            var item = angular.element('#txtTelefono').val();
            if (item.length >= 13) {
                vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{4})[ .-]?(\d{3,5})$/;
            } else {
                var letra = angular.copy(item.substr(0, 1));
                console.log(letra);
                var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                var esNumeroInicial = false;
                console.log(esNumeroInicial);
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === letra) {
                        esNumeroInicial = true;
                        break;
                    }
                }
                console.log("esNumeroInicial");
                console.log(esNumeroInicial);
                if (esNumeroInicial) {
                    vm.validarTelefono = /^(\d{7,9})$/;
                } else {
                    vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{3,4})$/;
                }
            }
        }

        function cambioDatos() {
            // (true/false) = angular.equals($scope.user1, $scope.user2);
            return ((angular.equals(vm.dataInstalacion.sector, vm.dataInstalacionTemporal.sector)) && (angular.equals(vm.dataInstalacion.subSector, vm.dataInstalacionTemporal.subSector)) && (angular.equals(vm.dataInstalacion.actividad, vm.dataInstalacionTemporal.actividad)) && (angular.equals(vm.dataInstalacion.numeroInstalacion, vm.dataInstalacionTemporal.numeroInstalacion)) && (angular.equals(vm.dataInstalacion.tipoEstablecimiento, vm.dataInstalacionTemporal.tipoEstablecimiento)) && (angular.equals(vm.dataInstalacion.numeroRegistro, vm.dataInstalacionTemporal.numeroRegistro)) && (angular.equals(vm.dataInstalacion.departamento.codigoDepartamento, vm.dataInstalacionTemporal.departamento.codigoDepartamento)) && (angular.equals(vm.dataInstalacion.provincia.codigoProvincia, vm.dataInstalacionTemporal.provincia.codigoProvincia)) && (angular.equals(vm.dataInstalacion.distrito.codigoDistrito, vm.dataInstalacionTemporal.distrito.codigoDistrito)) && (angular.equals(vm.dataInstalacion.direccion, vm.dataInstalacionTemporal.direccion)));
        }
        /* fin de implementacion de metodos */
        function init() {
            obtenerParametros();
            localStorage.removeItem("objInstalacion");
            //buscar(localStorage.objlocalStRefSisoplkijsq);
            cargarCombos();
            listarDepartamento();
        }
        
        function verReporte(item){
        	
        }
        
        init();
        /* fin de controller */
    }
})();
(function() {
	'use strict';
	angular.module('spapp.supervision').controller(
			'ReportePreliminarDatosController',
			ReportePreliminarDatosController);
	/** @ngInject */
	function ReportePreliminarDatosController($rootScope, toastr, $scope,
			ngDialog, API_CONFIG, 
			InstrumentoGestionFactory, InstalacionFactory,
			MaestroFactory, UbigeoFactory, EtapaFactory,
			EntidadFactory, CookiesFactory) {
		var vm = this;
		/* declaracion de variables globales */
		vm.urlData = API_CONFIG.url;
		vm.dataInstalacion = InstalacionFactory.model();

		vm.rutaBase = API_CONFIG.url;
		/* declaracion de variables globales */
		vm.mimeTypes = [];
		vm.extension = "";
		vm.tamanioArchivo = "500";
		vm.caracteresMaximoArchivo = 50;
		vm.idEtapa;
		vm.periodo;
		vm.listaInstrumentos = [];
		vm.listaEtapas = [];

		$scope.config = {
			itemsPerPage : 10,
			fillLastPage : true,
			current : 1
		};

		function cancelar() {
			ngDialog.close();
		}

		/* fin de metodos */
		function init() {
			if (angular.isDefined($rootScope.prmInstalacion)) {
				vm.dataInstalacion = angular.copy($rootScope.prmInstalacion);
				buscarInstrumentoGestion();
				buscarEtapas();
			}
		}
		
		 function buscarInstrumentoGestion() {
	            InstrumentoGestionFactory.listarPorInstalacion(angular.copy(vm.dataInstalacion)).then(function(response) {
	                if (response.valido) {
	                    vm.listaInstrumentos = angular.copy(response.data);
	                } else {
	                    toastr.error(response.mensaje);
	                }
	            }).catch(function(error) {
	                toastr.error('Error al consultar');
	            });
	     }

		 function buscarEtapas() {
	        	
			 	EtapaFactory.listar(angular.copy(EtapaFactory.model())).then(function(response) {
	                if (response.valido) {
	                    vm.listaEtapas = angular.copy(response.data);
	                } else {
	                    toastr.error(response.mensaje);
	                }
	            }).catch(function(error) {
	                toastr.error('Error al consultar');
	            });
	     }

		 
		init();
		/* fin de controller */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ReporteControlCalidadController', ReporteControlCalidadController);
    /* @ngInject */
    function ReporteControlCalidadController($location, $rootScope, toastr, ngDialog, AdministradoFactory, ContactoAdministradoFactory, MaestroFactory, InstalacionFactory, UbigeoFactory, SolicitudFactory, $scope, $state, CuestionarioFactory, CookiesFactory,OpcionPreguntaFactory, API_CONFIG) {
        var vm = this;
        /* declaracion de variables globales */
        vm.validaArchivoModificacionInst = 0;
        $rootScope.active = 0;
        $scope.serial = 1;
        /* Configuracion de paginacion de tablas */
        vm.urlData = API_CONFIG.url;
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        /** *************************************************************************** */
        /** * Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataCuestionarioAutosupervision = [];
        /** *************************************************************************** */
        /** * Fin Obtener Pregunta ** */
        /** *************************************************************************** */
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataAdministradoContacto = ContactoAdministradoFactory.model();
        vm.dataListaInstalacion = InstalacionFactory.model();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataContacto = {
            tipoContacto: '0'
        };
        
        vm.dataInstalacion = InstalacionFactory.model();
        vm.listaTipoPersona = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaTipoDocumento = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSector = [];
        vm.listaSubSector = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaActividad = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSolicitudesInstalacion = [];
        vm.listaContactoAdministrado = [];
        vm.listaArchivosSolicitud = [];
        vm.listaCboTipoContacto = [];
        vm.listaInstalacionAdm = [];
        vm.listaDepartamentoPersona = [];
        vm.listaProvinciaPersona = [];
        vm.listaDistritoPersona = [];
        vm.listaTipoEstablecimiento = [];
        vm.listarContactoPrincipal = [];
        vm.btnAgregarInstalacion = false;
        vm.btnListaInstalacion = true;
        vm.cambiarEstadoContacto = cambiarEstadoContacto;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.validaDocumento = validaDocumento;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.contactoPrincipal = contactoPrincipal;
        vm.mostrarInformacionInstalacionDialog = mostrarInformacionInstalacionDialog;
        vm.MostrarForm = MostrarForm;
        vm.OcultarForm = OcultarForm;
        vm.irCompromisos = irCompromisos;
        vm.irInformeMonitoreo = irInformeMonitoreo;
        vm.mostrarModificarInstalacion = mostrarModificarInstalacion;
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.mostrarCancelarInstalacion = mostrarCancelarInstalacion;
        vm.valorTelefono = valorTelefono;
        vm.modificar = 0;
        vm.limpiarContactoAdmi = limpiarContactoAdmi;
        vm.habilitarTexto = habilitarTexto;
        vm.guardar = guardar;
        vm.cambioDatos = cambioDatos;
        /** *** */
        
        vm.ruc;
        vm.agregarInstalacion = agregarInstalacion;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.buscar = buscar;
        

        function confirmarEliminacion(prmInstalacion) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmInstalacion.numeroInstalacion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmInstalacion);
            });
        }

        function eliminar(prmInstalacion) {
        	InstalacionFactory.eliminar(angular.copy(prmInstalacion)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarInstalacionesAdministrado();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la instalación');
            });
        }
        
        function agregarInstalacion(prmInstalacion){
             if (prmInstalacion != null) {
                 
            	 InstalacionFactory.buscarPorId(angular.copy(prmInstalacion)).then(function(response) {
                 		if (response.valido) {
                         	$rootScope.prmInstalacion = response.data;
                         	  ngDialog.open({
                                   template: 'app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion-edicion.html',
                                   controller: 'CargaInfoEdicionInstalacionController',
                                   controllerAs: 'vm',
                                   width: '70%'
                               }).closePromise.then(function(dataDialog) {
                            	   listarInstalacionesAdministrado();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la parametro');
 		                });
             } 
             else{
             	$rootScope.prmInstalacion =  InstalacionFactory.model();
             	ngDialog.open({
                     template: 'app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion-edicion.html',
                     controller: 'CargaInfoEdicionInstalacionController',
                     controllerAs: 'vm',
                     width: '70%'
                 }).closePromise.then(function(dataDialog) {
                	 listarInstalacionesAdministrado();
                 });
             }
        }
        
        function irCompromisos(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            $state.go('spapp.home.supervision.cargainfo-instrumento');
        }
        
        
        function irInformeMonitoreo(item) {
            debugger;
            localStorage.setItem("objInstalacion", angular.copy(angular.toJson(item)));
            $state.go('spapp.home.supervision.cargainfo-informe-instrumento');
        }
        

        function MostrarForm() {
            vm.btnAgregarInstalacion = true;
            vm.btnListaInstalacion = false;
        }

        function OcultarForm() {
            vm.btnAgregarInstalacion = false;
            vm.btnListaInstalacion = true;
            vm.dataInstalacion = angular.copy(InstalacionFactory.model());
            vm.validaArchivoModificacionInst = 0;
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            listarInstalacionesAdministrado();
        }
        /* implementacion de metodos */
        // usuario.actual= angular.fromJson(localStorage.objSesSisoLocStWqKP);
        /** ****************************************************************** */
        /**/
        function contactoPrincipal(prmData) {
            ContactoAdministradoFactory.modificarFlagPretedeterminadoDeContactoAdmi(angular.copy(prmData)).then(function(response) {
                if (response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }
        /** *************************************************************** */
        /**/
        function habilitarTexto() {}

        function guardar() {
            habilitarTexto();
        }
        /**/
        /*-----LISTAR CONTACTO ADMINISTRADO------*/

        function cambiarEstadoContacto(data, estado) {
            // vm.confirmarDesactivarAdmi(item);
            var prmData = data;
            if (prmData != null) {
                prmData.estado.codigoRegistro = 2;
                // alert("DESCRRIPCION" +
				// vm.dataAdministradoContacto.estado.descripcion);
                if (prmData.estado.descripcion == 'DESACTIVADO') {
                    prmData.estado.codigoRegistro = 2;
                }
                // prmData.estado = 2;
            }
            ContactoAdministradoFactory.actualizar(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                    listarContactoAdministrado();
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo cambiar el estado.');
            });
        }

        function limpiarContactoAdmi() {
            vm.dataContactoAdministrado.tipoContacto.codigoRegistro = 0;
            vm.dataContactoAdministrado.valor = "";
        }


        function buscar(prm1) {
                 debugger;
                 if(prm1==null || prm1 == ''){
                	 prm1 = localStorage.objlocalStRefSisoplkijsq;
                 }
                 var data = {
                     prm1: prm1,
                 };
                 AdministradoFactory.buscarxid( /* vm.dataAdministrado */ angular.copy(data)).then(function(response) {
                     if (response.valido) {
                         vm.dataAdministrado = response.data;
                         listarInstalacionesAdministrado();
                     } else {
                         toastr.error('Usted no es un Administrado');
                     }
                 }).catch(function(error) {
                     toastr.error('Error al consultar');
                 }).finally(function() {
                 });
        	 
        	
        }

        function listarSubSector() {
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.subSector = '';
            vm.dataInstalacion.actividad = '';
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaSubSector" +
						 * angular.toJson(vm.listaSubSector));
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }

        function listarActividad() {
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.dataInstalacion.actividad.codigoRegistro = 0;
            /*
			 * vm.dataInstalacion.actividad=0; vm.listaActividad=[];
			 */
            if (vm.dataInstalacion.subSector != 0) {
                var actividades = {
                    codigoRegistroPadre: vm.dataInstalacion.subSector,
                    codigoMaestro: 'Actividad'
                }
                MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaActividad.push(response.data[x]);
                        }
                        /*
						 * console.log("vm.listaActividad" +
						 * angular.toJson(vm.listaActividad));
						 * vm.dataNormas.actividad=0;
						 */
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /** *********************************************************************** */
        function cargarCombos() {
            vm.listaSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaCboTipoContacto = [{
                codigoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoSector', 'TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                // console.log('response cargarCombos',response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************************************** */
        function listarInstalacionesAdministrado() {
        	vm.dataListaInstalacion.idAdministrado = vm.dataAdministrado.idAdministrado;
            InstalacionFactory.listar(angular.copy(vm.dataListaInstalacion)).then(function(response) {
                if (response.valido) {
                    vm.listaInstalacionAdm = angular.copy(response.data);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarInformacionInstalacionDialog(itemInstalacion) {
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html',
                controller: 'InformacionInstalacionDialogController',
                data: {
                    data: itemInstalacion
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }
        /** ******************************************************************************** */
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Seleccione'
            }];
            UbigeoFactory.listarDepartamento(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarProvincia();
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Seleccione'
            }];
            vm.provincia.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.provincia.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarProvincia(vm.provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                listarDistrito();
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];
            vm.distrito.codigoDepartamento = vm.dataListaInstalacion.departamento.codigoDepartamento;
            vm.distrito.codigoProvincia = vm.dataListaInstalacion.provincia.codigoProvincia;
            vm.distrito.idsession = CookiesFactory.obtenerCookie();
            
            UbigeoFactory.listarDistrito(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            vm.validaArchivo = '0';
            if (!prmFileList) {
                toastr.warning('Debe seleccionar un Archivo');
                return;
            }
            var archivo = prmFileList[0];
            if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            var str = archivo.name;
            var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
            if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                toastr.warning('No es el tipo de archivo seleccionado.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                document.getElementById("fileArchivoMedio").value = "";
                vm.validaArchivo = '0';
                return;
            }
            if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                vm.validaArchivo = '1';
                vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
            }
            if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
                console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
            }
        }
        /** *********************************************************************************** */
        function procesoRegistroSolicitudArchivo() {
            if (vm.validaArchivo == '1') {
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
            } else {
                toastr.info('Falta cargar ficha de registro');
                return;
            }
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
            // console.log("vm.listaArchivosSolicitud" +
			// vm.listaArchivosSolicitud);
            // console.log("vm.listaArchivosSolicitud.length" +
			// vm.listaArchivosSolicitud.length);
            vm.dataSolicitud.tipoSolicitud = 3;
            console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
            console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada correctamente');
                    // $state.go('ingreso');
                    // crear metodo para limpiar todos los campos y el campo de
					// file
                    // direccionar al listado de instalaciones
                    console.log("vm.dataSolicitud", vm.dataSolicitud);
                    visualizarModal();
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            }).closePromise.then(function(dialogData) {
                listarInstalacionesAdministrado();
            });
        }

        function visualizarModal() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de nueva instalación ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function visualizarModalSolicitudModificacion() {
            ngDialog.open({
                template: '<div class="">' + '<div class="modal-header">' + '<h4 class="modal-title" style="text-align: justify;">Su solicitud de registro de modificación de datos ha sido generada correctamente para revisar el estado de su solicitud puede dirigirse al módulo de <b>Solicitud administrado</b>.</h4>' + '</div>' + '<div style="display: inline-block;" class="modal-footer">' + '<button type="button" class="btn btn-default btn-sm" ng-click="closeThisDialog()">Salir</button>' + '</div>' + '</div>',
                plain: true,
                width: 550,
                preCloseCallback: function() {
                    OcultarForm();
                }
            });
        }

        function procesoModificacionDeInstalacion() {
            if (vm.validaArchivoModificacionInst == 0 && vm.validaArchivo != '1') {
                toastr.warning('Debe subir un archivo para continuar con la modificación');
                return;
            }
            if (vm.validaArchivoModificacionInst == 1) {
                vm.validaArchivo = '0';
            }
            if (vm.validaArchivo == '1') {
                console.log("Realiza el Registro CON NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                if (data != null) {
                    data.estado = 1;
                    data.flagActivo = 1;
                    vm.listaSolicitudesInstalacion.push(data);
                    /* vm.dataInstalacion = InstalacionFactory.model(); */
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaArchivo = '0';
                }
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                console.log("Data a enviar listaArchivosSolicitud", vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosSolicitud, vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            } else {
                console.log("Realiza el Registro SIN NUEVO DOCUMENTO");
                vm.dataInstalacion.idInstalacionPrincipal = vm.dataInstalacion.idInstalacion;
                vm.dataInstalacion.idInstalacion = 1;
                var data = angular.copy(vm.dataInstalacion);
                data.estado = 1;
                data.flagActivo = 1;
                vm.listaSolicitudesInstalacion.push(data);
                if (vm.dataAdministrado.persona.idPersona > 0) {
                    vm.dataAdministrado.tipoAdministrado = 1;
                }
                if (vm.dataAdministrado.entidad.idEntidad > 0) {
                    vm.dataAdministrado.tipoAdministrado = 2;
                }
                vm.dataAdministrado.flagActivo = 1;
                vm.dataAdministrado.estado = 1;
                vm.dataSolicitud.administrado = vm.dataAdministrado;
                if (vm.listaSolicitudesInstalacion != null) {
                    for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                        vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                        vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                        vm.dataDetalleSolicitud.flagActivo = 1;
                        vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                    }
                }
                /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
                // console.log("vm.listaArchivosSolicitud" +
				// vm.listaArchivosSolicitud);
                // console.log("vm.listaArchivosSolicitud.length" +
				// vm.listaArchivosSolicitud.length);
                vm.dataSolicitud.tipoSolicitud = 2;
                console.log("Data a enviar dataSolicitud", vm.dataSolicitud);
                // console.log("Data a enviar
				// listaArchivosSolicitud",vm.listaArchivosSolicitud);
                SolicitudFactory.registrarSolicitudSinArchivo(vm.dataSolicitud).then(function(response) {
                    if (response.valido) {
                        // vm.dataPedido.idPedido = response.data;
                        vm.dataSolicitud.idSolicitud = response.data;
                        // toastr.success('Solicitud generada Correctamente');
                        visualizarModalSolicitudModificacion();
                        listarInstalacionesAdministrado();
                        // $state.go('ingreso');
                        // crear metodo para limpiar todos los campos y el campo
						// de file
                        // direccionar al listado de instalaciones
                        console.log("vm.dataSolicitud", vm.dataSolicitud);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Solicitud.');
                });
            }
            /*
			 * console.log("ENTRA AL PROCESO DE MODIFICACION");
			 * console.log("vm.dataInstalacion",vm.dataInstalacion);
			 */
        }

        function registrarSolicitudArchivo() {
            if (vm.modificar != 1) {
                procesoRegistroSolicitudArchivo();
            } else {
                procesoModificacionDeInstalacion();
            }
        }
        /** ******************************************************************************** */
        /* Metodo para utilizado para cancelar instalacion */
        /** ******************************************************************************** */
        function mostrarCancelarInstalacion(itemInstalacion) {
            if (itemInstalacion.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            ngDialog.open({
                template: 'app/modules/supervision/administrado/dialog-cancelacion/cancelacion-instalacion-dialog.html',
                controller: 'CancelacionInstalacionDialogController',
                data: {
                    data: itemInstalacion,
                    dataAdministrado: vm.dataAdministrado
                },
                controllerAs: 'vm',
                width: '800px'
            }).closePromise.then(function() {
                listarInstalacionesAdministrado();
            });
        }
        /** ********************************************************************************** */
        /* metodo para modificar instalación */
        /** ********************************************************************************** */
        function mostrarModificarInstalacion(item, modificar) {
            // modificar =1 -> Se trata de una modificacion
            debugger;
            if (item.validaSolicitud != 0) {
                toastr.warning('Usted tiene una solicitud en proceso, por favor mantenerse a la espera.');
                return;
            }
            vm.dataInstalacion = angular.copy(item);
            console.log(vm.dataInstalacion);
            vm.dataInstalacionTemporal = angular.copy(item);
            console.log(item);
            vm.modificar = modificar;
            vm.validaArchivoModificacionInst = 1;
            // listarSubSector();
            vm.listaSubSector = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            vm.listaActividad = [{
                codigoRegistro: '',
                descripcion: '--Seleccione--'
            }];
            /* vm.dataInstalacion.subSector.codigoRegistro=0; */
            if (vm.dataInstalacion.sector != '') {
                var subSector = {
                    codigoRegistroPadre: vm.dataInstalacion.sector,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(angular.copy(subSector)).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                }).finally(function() {
                    debugger;
                    vm.dataInstalacion.subSector = angular.copy(item.subSector);
                    if (vm.dataInstalacion.subSector.codigoRegistro != 0) {
                        var actividades = {
                            codigoRegistroPadre: vm.dataInstalacion.subSector.codigoRegistro,
                            codigoMaestro: 'Actividad'
                        }
                        MaestroFactory.buscarRegistroHijo(angular.copy(actividades)).then(function(response) {
                            if (response != null && response.valido) {
                                for (var x in response.data) {
                                    vm.listaActividad.push(response.data[x]);
                                }
                                vm.dataInstalacion.actividad = angular.copy(item.actividad);
                                /*
								 * console.log("vm.listaActividad" +
								 * angular.toJson(vm.listaActividad));
								 * vm.dataNormas.actividad=0;
								 */
                            }
                        }).catch(function(error) {
                            toastr.error('No se pudo obtener los datos para los combos.');
                        });
                    }
                });
            }
            // listarActividad();
            for (var i = 0; i < 3; i++) {
                ejecutarfuncionesOrdenadas(i);
            }
        }

        function ejecutarfuncionesOrdenadas(item) {
            if (item == 0) {
                listarProvincia();
            }
            if (item == 1) {
                listarDistrito();
            }
            if (item == 2) {
                MostrarForm();
            }
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * 5 - 4;
        }

        function valorTelefono(valor) {
            var item = angular.element('#txtTelefono').val();
            if (item.length >= 13) {
                vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{4})[ .-]?(\d{3,5})$/;
            } else {
                var letra = angular.copy(item.substr(0, 1));
                console.log(letra);
                var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                var esNumeroInicial = false;
                console.log(esNumeroInicial);
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === letra) {
                        esNumeroInicial = true;
                        break;
                    }
                }
                console.log("esNumeroInicial");
                console.log(esNumeroInicial);
                if (esNumeroInicial) {
                    vm.validarTelefono = /^(\d{7,9})$/;
                } else {
                    vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{3,4})$/;
                }
            }
        }

        function cambioDatos() {
            // (true/false) = angular.equals($scope.user1, $scope.user2);
            return ((angular.equals(vm.dataInstalacion.sector, vm.dataInstalacionTemporal.sector)) && (angular.equals(vm.dataInstalacion.subSector, vm.dataInstalacionTemporal.subSector)) && (angular.equals(vm.dataInstalacion.actividad, vm.dataInstalacionTemporal.actividad)) && (angular.equals(vm.dataInstalacion.numeroInstalacion, vm.dataInstalacionTemporal.numeroInstalacion)) && (angular.equals(vm.dataInstalacion.tipoEstablecimiento, vm.dataInstalacionTemporal.tipoEstablecimiento)) && (angular.equals(vm.dataInstalacion.numeroRegistro, vm.dataInstalacionTemporal.numeroRegistro)) && (angular.equals(vm.dataInstalacion.departamento.codigoDepartamento, vm.dataInstalacionTemporal.departamento.codigoDepartamento)) && (angular.equals(vm.dataInstalacion.provincia.codigoProvincia, vm.dataInstalacionTemporal.provincia.codigoProvincia)) && (angular.equals(vm.dataInstalacion.distrito.codigoDistrito, vm.dataInstalacionTemporal.distrito.codigoDistrito)) && (angular.equals(vm.dataInstalacion.direccion, vm.dataInstalacionTemporal.direccion)));
        }
        /* fin de implementacion de metodos */
        function init() {
//            obtenerParametros();
//            localStorage.removeItem("objInstalacion");
//            buscar(localStorage.objlocalStRefSisoplkijsq);
            cargarCombos();
//            listarDepartamento();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
	'use strict';
	angular.module('spapp.parametro').controller(
			'ParametroSelectorController', ParametroSelectorController);

	function ParametroSelectorController($scope, toastr, ngDialog, $log,
			$rootScope, ParametroFactory,  ComponenteAmbientalFactory, ComponenteAmbientalParametroFactory , NormaLegalFactory, NormasFactory ,MaestroFactory, $filter) {
		var vm = this;
		/* declaracion de variables globales */
		vm.prmComponente = ComponenteAmbientalFactory.model();
		vm.prmParametroValor = ParametroFactory.modelValor();
		/* declaración de metodos enlazados a la vista */
		vm.guardar = guardar;
		vm.cancelar = cancelar;
		vm.lstParametros = [];
		vm.lstParametrosSel = [];
		vm.lstParametrosBase = [];
		vm.lstNormaLegal = [];
		vm.lstUnidadMedida = [];
		vm.lstFrecuencia = [];
		vm.listar = listar ;
		
		 $scope.config = {
	            itemsPerPage: 10,
	            fillLastPage: true,
	            current: 1
	        };

		
		function cancelar() {
			ngDialog.close();
		}

		function guardar() {
			var cantSel = 0;
			
			for (var x in vm.lstParametros) {
                if (vm.lstParametros[x].blSeleccionado){
                	cantSel = cantSel + 1;
                }
			}
			
			for (var x in vm.lstParametros) {
                if (vm.lstParametros[x].blSeleccionado){
                	cantSel = cantSel - 1;
                	var prmComponentePara = {
                			componente: vm.prmComponente.codigo,
                        	parametro_valor: vm.lstParametros[x].secuencia,
                        	estado: '1',
                        	idsession: '',
                            ultima_fecha: new Date(),
                	};
                	
                	ComponenteAmbientalParametroFactory.registrar(angular.copy(prmComponentePara)).then(function(response) {
                        if (response != null && response.valido) {
                        	if(cantSel==0){
                        		toastr.success('Se registró el(los) parámetro(s) correctamente.');
                        		$scope.closeThisDialog();
                        	}
                        }
                    }).catch(function(error) {
                        toastr.error('No se pudo obtener los datos.');
                    });
                	
                }
            }
			
        	
		}

		function cargarCombos() {
			listarUnidadMedida();
      	  	listarNormaLegal();
      	  	listarFrecuencia();
		}
		
		  function listarUnidadMedida() {
	        	
	        	var dataUnidadMedida = {
	        		codigoMaestro : 'UNIDAD_MEDIDA',
	        		idMaestro			:0,
				  	descripcion 		:'',
	        	};
	        	
	            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
	                if (response != null && response.valido) {
	                    vm.lstUnidadMedida = response.data;
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los datos para los combos.');
	            });
	            
	            console.log('data ' + vm.lstUnidadMedida);
	        }
	        
	        function listarFrecuencia() {
	        	var dataFrecuencia = {
	        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
	        		idMaestro			:0,
				  	descripcion 		:'',
	        	};
	        	
	            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
	                if (response != null && response.valido) {
	                    vm.lstFrecuencia = angular.copy(response.data);;
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los datos para los combos.');
	            });
	            
	            console.log('data ' + vm.lstFrecuencia);
	        }
	        
	        function listarNormaLegal() {
	        	 
	        	var dataNormaLegal =  NormasFactory.modelNormas();
	        	dataNormaLegal.componente =  vm.prmComponente.codigo;
	        	
	        	NormasFactory.listarPorComponente(angular.copy(dataNormaLegal)).then(function(response) {
	                 if (response != null && response.valido) {
	                     vm.lstNormaLegal = angular.copy(response.data);
	                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
	                 }
	             }).catch(function(error) {
	                 toastr.error('No se pudo obtener los datos.');
	             });
	        }

		function listar() {
			ParametroFactory.listarValor(angular.copy(vm.prmParametroValor)).then(function(response) {
                if (response != null && response.valido) {
                	vm.lstParametros = angular.copy(response.data);
                	vm.lstParametrosBase = $rootScope.lstParametrosBase ;
                   	for (var y = 0; y < vm.lstParametros.length; y++) { 
                   		for(var x in vm.lstParametrosBase){
                       		if(vm.lstParametrosBase[x].parametro_valor == vm.lstParametros[y].secuencia){
                       			// ya existe
                       			vm.lstParametros.splice(y,1);
                       			y--;
                       			break;
                       		}
                       	}
                   	}
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
		}

		function init() {
			
			if ($rootScope.prmComponente != null) {
				vm.prmComponente = $rootScope.prmComponente;
			}
			cargarCombos();
			listar();

		}
		init();
		/* fin de metodos */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('ParametroDataDialogController', ParametroDataDialogController);

    function ParametroDataDialogController($scope, toastr, ngDialog, $log, $rootScope, ParametroFactory, MaestroFactory, NormaLegalFactory, NormasFactory, ParametroECAFactory , ParametroLMPFactory , ComponenteAmbientalFactory,  CookiesFactory  ,$filter) {
        var vm = this;
        /* declaracion de variables globales */
        vm.prmParametro = ParametroFactory.model();
        vm.dataParametroECA = ParametroECAFactory.model();
        vm.dataParametroLMP = ParametroLMPFactory.model();
        vm.lstUnidadMedida = [];
        vm.lstFrecuencia = [];
        vm.lstNormaLegal = [];
        vm.lstActividad = [];
        /* declaración de metodos enlazados a la vista */
        vm.guardar = guardar;
        vm.cancelar = cancelar;
        vm.agregarECA = agregarECA;
        vm.agregarLMP = agregarLMP;
        vm.eliminarECA = eliminarECA;
        vm.eliminarLMP = eliminarLMP;
        vm.confirmarEliminacionLMP = confirmarEliminacionLMP;
        vm.confirmarEliminacionECA = confirmarEliminacionECA;
        
        vm.listarComponente = listarComponente;
        vm.listarMatriz = listarMatriz;
        vm.listarSubMatriz = listarSubMatriz;
        vm.lstComponente = [];
        vm.lstMatriz = [];
        vm.lstSubMatriz = [];
        vm.lstConcetracion = [];
        vm.validarConcentracion = validarConcentracion;
        vm.validarConcentracionLMP = validarConcentracionLMP;
        vm.mostrarValor2 = false;
        vm.mostrarValorLMP2 = false;
        vm.listarConcentracion = listarConcentracion ;
        
        function validarConcentracion(concentracion_cod){
        	vm.mostrarValor2 = false;
        	
        	var concentracion = obtenerNombreConcetracion(concentracion_cod);
        	vm.dataParametroECA.concentracion_texto = concentracion;
        	
        	if(concentracion.toUpperCase() == 'RANGO'){
        		vm.mostrarValor2 = true;
        	}
        	else{
        		if(concentracion.toUpperCase() != '<'){
        			vm.dataParametroECA.valor = 0;
            	}
        	}
        }
        
        function validarConcentracionLMP(concentracion_cod){
        	vm.mostrarValorLMP2 = false;
        	
        	var concentracion = obtenerNombreConcetracion(concentracion_cod);
        	vm.dataParametroLMP.concentracion_texto = concentracion;
        	
        	if(concentracion.toUpperCase() == 'RANGO'){
        		vm.mostrarValorLMP2 = true;
        	}
        	else{
        		if(concentracion.toUpperCase() != '<'){
        			vm.dataParametroLMP.valor = 0;
            	}
        	}
        }
        
        function obtenerNombreConcetracion(concentracion_cod){
        	if(vm.lstConcetracion.length > 0){
        		for(var x in vm.lstConcetracion){
        			if(vm.lstConcetracion[x].codigoRegistro == concentracion_cod ){
        				return vm.lstConcetracion[x].descripcion;
        			}
        		}
        	}
        }
        
        function listarComponente(){
        	 vm.lstMatriz = [];
             vm.lstSubMatriz = [];
        	 ComponenteAmbientalFactory.listar(ComponenteAmbientalFactory.model()).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstComponente = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        
        function listarMatriz(idComponente){
            vm.lstSubMatriz = [];
        	var prmComponente = {
        			codigo : idComponente,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        
        function listarSubMatriz(idMatriz){
        	
        	 vm.lstSubMatriz = [];
        	 
        	if (idMatriz == 0 || idMatriz == null){
        		return;
        	}
        	
        	var prmComponente = {
        			codigo : idMatriz,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstSubMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        

        function cancelar() {
            ngDialog.close();
        }

        function guardar() {
            if (vm.prmParametro.codigo == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
            	registrar();
            });
        }

        function registrar() {
        	vm.prmParametro.idsession= CookiesFactory.obtenerCookie();
            ParametroFactory.registrar(angular.copy(vm.prmParametro)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });
            
        }

        function actualizar() {
        	vm.prmParametro.idsession= CookiesFactory.obtenerCookie();
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ParametroFactory.actualizar(angular.copy(vm.prmParametro)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function listarUnidadMedida() {
        	
        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstUnidadMedida = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstUnidadMedida);
        }
        
        function listarFrecuencia() {
        	var dataFrecuencia = {
        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstFrecuencia = angular.copy(response.data);;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstFrecuencia);
        }
        
        function listarActividad(){
        	
        	var dataActividad = {
            		codigoMaestro : 'ACTIVIDAD',
            		idMaestro			:0,
    			  	descripcion 		:'',
            	};
            	
                MaestroFactory.buscarXCodigoMaestro(angular.copy(dataActividad)).then(function(response) {
                    if (response != null && response.valido) {
                        vm.lstActividad = angular.copy(response.data);;
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
                
        }
        
 		function listarConcentracion(){
        	
        	var dataConcentracion = {
            		codigoMaestro : 'CONCETRACION_TEXTO',
            		idMaestro			:0,
    			  	descripcion 		:'',
            	};
            	
                MaestroFactory.buscarXCodigoMaestro(angular.copy(dataConcentracion)).then(function(response) {
                    if (response != null && response.valido) {
                        vm.lstConcetracion = angular.copy(response.data);;
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
        }
        
        function listarNormaLegal() {
        	 
        	var dataNormaLegal = NormasFactory.modelNormas();
        	
        	 NormasFactory.listar(angular.copy(dataNormaLegal)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstNormaLegal = angular.copy(response.data);
                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }

        function cargarCombos() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	listarUnidadMedida();
        	  listarNormaLegal();
        	  listarFrecuencia();
        	  listarActividad();
        	  listarConcentracion();
        	  
        }
        
        function cargarParametroECA(){
        	 var dataParametroECA = {
             	 	cod_parametro : vm.prmParametro.codigo,
             	 };
        	 
        	 ParametroECAFactory.listar(angular.copy(dataParametroECA)).then(function(response) {
                 if (response != null && response.valido) {
                	 vm.prmParametro.lstEcas = angular.copy(response.data);
                 
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function cargarParametroLMP(){
       	 	var dataParametroLMP= {
          	 	cod_parametro : vm.prmParametro.codigo,
          	 };
       	 
       	 ParametroLMPFactory.listar(angular.copy(dataParametroLMP)).then(function(response) {
                if (response != null && response.valido) {
                	vm.prmParametro.lstLmps = angular.copy(response.data);
                    
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }
        
        function agregarECA(){
        	vm.dataParametroECA.estado='1';
        	vm.dataParametroECA.tipo='ECA';
        	if( vm.prmParametro.codigo !=0){
        		 vm.dataParametroECA.cod_parametro = vm.prmParametro.codigo;
        		 ParametroECAFactory.registrar(angular.copy(vm.dataParametroECA)).then(function(response) {
                     if (response != null && response.valido) {
                    	 cargarParametroECA();
                     }
                 }).catch(function(error) {
                     toastr.error('No se pudo grabar la información.');
                 });
        	}  
        	else{
        		 vm.dataParametroECA.auxNormaNombre = obtenerNombreNorma( vm.dataParametroECA.cod_norma);
	       		 vm.dataParametroECA.auxPeriodoNombre = obtenerNombrePeriodo( vm.dataParametroECA.cod_periodo);
	       		 vm.dataParametroECA.auxActividadNombre = obtenerNombreActividad( vm.dataParametroECA.cod_actividad);
	       		 vm.dataParametroECA.componenteNombre = obtenerNombreComponente(vm.dataParametroECA.componente);
	       		 if( vm.dataParametroECA.matriz != 0){
	       			 vm.dataParametroECA.componenteNombre = obtenerNombreMatriz(vm.dataParametroECA.matriz);
	       		 }
	       		if( vm.dataParametroECA.submatriz != 0){
	       			 vm.dataParametroECA.componenteNombre = obtenerNombreSubMatriz(vm.dataParametroECA.submatriz);
	       		 }
	       		
        		 vm.prmParametro.lstEcas.push(angular.copy(vm.dataParametroECA));
        	}
        }
        
        function agregarLMP(){
        	vm.dataParametroLMP.estado='1';
        	vm.dataParametroLMP.tipo='LMP';
        	if( vm.prmParametro.codigo !=0){
       		 vm.dataParametroLMP.cod_parametro = vm.prmParametro.codigo;
       		 ParametroLMPFactory.registrar(angular.copy(vm.dataParametroLMP)).then(function(response) {
                    if (response != null && response.valido) {
                    	cargarParametroLMP()
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo grabar la información.');
                });
	       	}  
	       	else{
	       		 vm.dataParametroLMP.auxNormaNombre = obtenerNombreNorma( vm.dataParametroLMP.cod_norma);
	       		 vm.dataParametroLMP.auxPeriodoNombre = obtenerNombrePeriodo( vm.dataParametroLMP.cod_periodo);
	       		 vm.dataParametroLMP.auxActividadNombre = obtenerNombreActividad( vm.dataParametroLMP.cod_actividad);
	       		 vm.dataParametroLMP.componenteNombre = obtenerNombreComponente(vm.dataParametroLMP.componente);
	       		 if( vm.dataParametroLMP.matriz != 0){
	       			 vm.dataParametroLMP.componenteNombre = obtenerNombreMatriz(vm.dataParametroLMP.matriz);
	       		 }
	       		if( vm.dataParametroLMP.submatriz != 0){
	       			 vm.dataParametroLMP.componenteNombre = obtenerNombreSubMatriz(vm.dataParametroLMP.submatriz);
	       		 }
	       		 vm.prmParametro.lstLmps.push(angular.copy(vm.dataParametroLMP));
	       	}
        }
        
        function obtenerNombreNorma(cod_norma){
        	for (var y in vm.lstNormaLegal) {
        		if (vm.lstNormaLegal[y].idNorma ==  cod_norma){
        			return vm.lstNormaLegal[y].numeroNorma;
        		}
        	}
        }
        
        function obtenerNombrePeriodo(cod_periodo){
        	for (var x in vm.lstFrecuencia) {
        		if (vm.lstFrecuencia[x].idMaestro ==  cod_periodo){
        			return vm.lstFrecuencia[x].descripcion;
        		}
        	}
        }
        
        function obtenerNombreActividad(cod_actividad){
        	for (var x in vm.lstActividad) {
        		if (vm.lstActividad[x].idMaestro ==  cod_actividad){
        			return vm.lstActividad[x].descripcion;
        		}
        	}
        }
        
        function obtenerNombreComponente(cod_componente){
        	for (var y in vm.lstComponente) {
        		if (vm.lstComponente[y].codigo ==  cod_componente){
        			return vm.lstComponente[y].descripcion;
        		}
        	}
        }
        
        function obtenerNombreMatriz(cod_componente){
        	for (var y in vm.lstMatriz) {
        		if (vm.lstMatriz[y].codigo ==  cod_componente){
        			return vm.lstMatriz[y].descripcion;
        		}
        	}
        }
        
        function obtenerNombreSubMatriz(cod_componente){
        	for (var y in vm.lstSubMatriz) {
        		if (vm.lstSubMatriz[y].codigo ==  cod_componente){
        			return vm.lstSubMatriz[y].descripcion;
        		}
        	}
        }
        
        function confirmarEliminacionECA(dataParametroECA,index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarECA(dataParametroECA,index);
            });
        }
        
        function confirmarEliminacionLMP(dataParametroLMP,index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarLMP(dataParametroLMP,index);
            });
        }
        
        function eliminarECA(dataParametroECA,index){
        	if( vm.prmParametro.codigo !=0){
        		 ParametroECAFactory.eliminar(angular.copy(dataParametroECA)).then(function(response) {
                     if (response != null && response.valido) {
                    	 cargarParametroECA();
                     }
                 }).catch(function(error) {
                     toastr.error('No se pudo grabar la información.');
                 });
        	}  
        	else{
        		 vm.prmParametro.lstEcas.splice(index, 1);
        	}
        }
        
        function eliminarLMP(dataParametroLMP,index){
        	if( vm.prmParametro.codigo !=0){
       		 ParametroLMPFactory.eliminar(angular.copy(dataParametroLMP)).then(function(response) {
                    if (response != null && response.valido) {
                    	cargarParametroLMP()
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo grabar la información.');
                });
	       	}  
	       	else{
	       		 vm.prmParametro.lstLmps.splice(index, 1);
	       	}
        }
        
        

        function init() {
        	  cargarCombos();
        	  if ($rootScope.itemParametro != null) {
                  vm.prmParametro = angular.copy($rootScope.itemParametro);
                  cargarParametroECA();
                  cargarParametroLMP();
              }
        	  else{
        		  vm.prmParametro = ParametroFactory.model();
        	  }
        	  listarComponente();
        	  
        	  console.log(' vm.prmParametro validacion ' +  vm.prmParametro.cod_unidad);
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('ParametroListadoController', ParametroListadoController);
    /* @ngInject */
    function ParametroListadoController(ngDialog, toastr, $scope, $rootScope, ParametroFactory, CookiesFactory ) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 8,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstParametros = [];
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmParametro = ParametroFactory.model();

        function agregarItem(prmParametro) {
            console.log("prmParametro" + prmParametro);
            if (prmParametro != null) {
                
                ParametroFactory.buscarPorId(angular.copy(prmParametro)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemParametro = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/parametro/dialog/parametro-data-dialog.html',
                                  controller: 'ParametroDataDialogController',
                                  controllerAs: 'vm',
                                  
                                  width: '50%'
                              }).closePromise.then(function(dataDialog) {
                                  listar();
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener el parámetro');
		                });
            } 
            else{
            	$rootScope.itemParametro =  ParametroFactory.model();
            	ngDialog.open({
                    template: 'app/modules/parametro/dialog/parametro-data-dialog.html',
                    controller: 'ParametroDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '50%'
                }).closePromise.then(function(dataDialog) {
                    listar();
                });
            }
          
        }

        function confirmarEliminacion(prmParametro) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmParametro.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmParametro.codigo);
            });
        }
        
        function confirmarInactivacion(prmParametro) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmParametro.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmParametro.codigo);
            });
        }

        function eliminar(codparametro) {
            var temp = {
            	codigo: codparametro
            };
            ParametroFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar el parámetro');
            });
        }
        
        function inactivar(codparametro) {
            var temp = {
            	codigo: codparametro,
            	idsession: CookiesFactory.obtenerCookie(),
            };
            ParametroFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar el parámetro');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmParametro.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ParametroFactory.listar(angular.copy(vm.prmParametro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstParametros = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	vm.prmParametro.estado = '1';
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.normalegal', []);
})();
(function() {
    'use strict';
    angular.module('spapp.normalegal').controller('NormaLegalListadoController', NormaLegalListadoController);
    /* @ngInject */
    function NormaLegalListadoController(ngDialog, toastr, $scope, $rootScope, NormaLegalFactory,NormasFactory ) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstNormaLegal = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmNormaLegal = NormasFactory.modelNormas();
        vm.urlSirin = '';

        function agregarItem(prmNormaLegal) {
            console.log("prmNormaLegal" + prmNormaLegal);
            if (prmNormaLegal != null) {
                
                NormaLegalFactory.buscarPorId(angular.copy(prmNormaLegal)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemNormaLegal = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/normalegal/dialog/normalegal-data-dialog.html',
                                  controller: 'NormaLegalDataDialogController',
                                  controllerAs: 'vm',
                                  
                                  width: '50%'
                              }).closePromise.then(function(dataDialog) {
                                  listar();
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener la NormaLegal');
		                });
            } 
            else{
            	$rootScope.itemNormaLegal =  NormaLegalFactory.model();
            	ngDialog.open({
                    template: 'app/modules/normalegal/dialog/normalegal-data-dialog.html',
                    controller: 'NormaLegalDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '50%'
                }).closePromise.then(function(dataDialog) {
                    listar();
                });
            }
          
        }

        function confirmarEliminacion(prmNormaLegal) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmNormaLegal.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmNormaLegal.codigo);
            });
        }
        
        function confirmarInactivacion(prmNormaLegal) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmNormaLegal.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmNormaLegal.codigo);
            });
        }

        function eliminar(codigo) {
            var temp = {
            	codigo: codigo
            };
            NormaLegalFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la NormaLegal');
            });
        }
        
        function inactivar(codigo) {
            var temp = {
            	codigo: codigo
            };
            NormaLegalFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la Norma Legal');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmNormaLegal.estado);
        	// vm.prmNormaLegal.sector = '23'
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	 NormasFactory.listar(angular.copy(vm.prmNormaLegal)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstNormaLegal = angular.copy(response.data);
                    console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarUrlSirin(){
        	NormasFactory.obtenerURLSirin().then(function(response) {
                 if (response.valido) {
                	 vm.urlSirin = response.data;
                 } else {
                     toastr.error(response.mensaje);
                 }
             }).catch(function(error) {
                 toastr.error('Error al consultar');
             }).finally(function() {});
        	
        	console.log('vm.urlSirin ' + vm.urlSirin);
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	vm.prmNormaLegal.estado = '1';
            listar();
            cargarUrlSirin();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.etapa').controller('NormaLegalDataDialogController', NormaLegalDataDialogController);

    function NormaLegalDataDialogController($scope, toastr, ngDialog, $log, $rootScope, NormaLegalFactory, $filter) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.prmNormaLegal = NormaLegalFactory.model();
        /*declaración de metodos enlazados a la vista*/
        vm.guardar = guardar;
        vm.cancelar = cancelar;

        function cancelar() {
            ngDialog.close();
        }

        function guardar() {
            if (vm.prmNormaLegal.codigo == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
            NormaLegalFactory.registrar(angular.copy(vm.prmNormaLegal)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
            //var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            NormaLegalFactory.actualizar(angular.copy(vm.prmNormaLegal)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }


        function init() {
        	  if ($rootScope.itemNormaLegal != null) {
                  vm.prmNormaLegal = angular.copy($rootScope.itemNormaLegal);
              }
        	  else{
        		  vm.prmNormaLegal = NormaLegalFactory.model();
        	  }
        	  
        	  console.log(' vm.prmNormaLegal validacion ' +  vm.prmNormaLegal);
        }
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').controller('RegistroPreguntaController', RegistroPreguntaController);
    /* @ngInject */
    function RegistroPreguntaController(toastr, ngDialog, $scope, PreguntaFactory, MaestroFactory, OpcionPreguntaFactory, PreguntaSectorFactory, $state, PeriodoPreguntaFactory, PreguntaNormativaFactory, AccesoFactory, $rootScope, $log, $location) {
        var vm = this;
        /* declaracion de variables globales */
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        $scope.serialPregunta = 1;
        /*fin de configuracion de tablas*/
        vm.dataPregunta = PreguntaFactory.model();
        vm.dataOpcionPregunta = OpcionPreguntaFactory.model();
        vm.dataPreguntaSector = PreguntaSectorFactory.model();
        vm.datePeriodoPregunta = PeriodoPreguntaFactory.model();
        /* Lista Combo */
        vm.listaTipoPregunta = [];
        vm.listaPreguntas = [];
        vm.listaPeriodoPreguntas = [];
        /*  *********** */
        /*** Lista Combo Sector ***/
        vm.listaSector = [];
        vm.listaSubSector = [{
            codigoRegistro: 0,
            descripcion: 'Todos'
        }];
        vm.listaActividad = [{
            codigoRegistro: 0,
            descripcion: 'Todos'
        }];
        /************************/
        /* Lista Datos Pregunta Sector*/
        vm.listaPreguntaSector = [];
        vm.listaDatosPeriodoPregunta = [];
        /* */
        vm.dataInstalacion = {
            sector: 0,
            subSector: 0
        };
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaNormativasPregunta = [];
        /******/
        /* declaracion de metodos enlazados a la vista */
        vm.registrarPregunta = registrarPregunta;
        vm.agregarOpcion = agregarOpcion;
        vm.eliminarOpcionesPregunta = eliminarOpcionesPregunta;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.registrarPreguntaSector = registrarPreguntaSector;
        vm.cancelar = cancelar;
        vm.registrarPeriodoPregunta = registrarPeriodoPregunta;
        vm.opcionesPreguntaTabla = opcionesPreguntaTabla;
        vm.mostrarAgregarNormativaDialog = mostrarAgregarNormativaDialog;
        vm.confirmareliminarPeriodoPregunta = confirmareliminarPeriodoPregunta;
        vm.confirmarEliminarPreguntaSector = confirmarEliminarPreguntaSector;
        vm.opcionesPreguntaTablaDatosCargados = opcionesPreguntaTablaDatosCargados;
        vm.confirmarEliminarPreguntaNormativa = confirmarEliminarPreguntaNormativa;
        vm.limpiar = limpiar;
        vm.limpiarPeriodo = limpiarPeriodo;
        vm.limpiarSector = limpiarSector;
        vm.validaDatosPreguntaTabla = validaDatosPreguntaTabla;
        vm.limpiarAlCambiarComboTipoPregunta = limpiarAlCambiarComboTipoPregunta;
        vm.reiniciarSelecionarOpcionSeleccion = reiniciarSelecionarOpcionSeleccion;
        /* declaracion de metodos */
        /* implementacion de metodos */
        $scope.obtenerValorIndex = function(a, b) {
            return (a + b) - 1;
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serialPregunta = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function reiniciarSelecionarOpcionSeleccion(index) {
            debugger;
            for (var x = 0; x < vm.dataPregunta.lstOpcionPregunta.length; x++) {
                if (x == index) {
                    vm.dataPregunta.lstOpcionPregunta[x].swCorrecto = 1;
                } else {
                    vm.dataPregunta.lstOpcionPregunta[x].swCorrecto = 0;
                }
            }
        }

        function limpiarAlCambiarComboTipoPregunta() {
            if (vm.dataPregunta.tipoPregunta.codigoRegistro == 6) {
                vm.dataPregunta.lstOpcionPregunta = [];
                vm.dataPregunta.numerosFila = 0;
                vm.dataPregunta.numerosColumna = 0;
                var si = OpcionPreguntaFactory.model();
                si.valor = "Si";
                var no = OpcionPreguntaFactory.model();
                no.valor = "No";
                vm.dataPregunta.lstOpcionPregunta.push(angular.copy(si));
                vm.dataPregunta.lstOpcionPregunta.push(angular.copy(no));
            } else {
                vm.dataPregunta.lstOpcionPregunta = [];
                vm.dataPregunta.numerosFila = 0;
                vm.dataPregunta.numerosColumna = 0;
            }
        }

        function confirmarEliminarPreguntaNormativa(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el artículo Nº ' + item.contenidoNorma.numeroArticulo + ' del dispositivo de ' + item.contenidoNorma.dispositivo + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarPreguntaNormativa(item);
            });
        }

        function eliminarPreguntaNormativa(item) {
            PreguntaNormativaFactory.eliminar(item).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarPreguntaNormativa();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo eliminar la normativa de la pregunta.');
            });
        }

        function confirmarEliminarPreguntaSector(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar la actividad ' + item.actividad.descripcion + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarPreguntaSector(item);
            });
        }

        function eliminarPreguntaSector(item) {
            PreguntaSectorFactory.eliminar(item).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarPreguntaSector();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo eliminar Periodo Pregunta.');
            });
        }

        function confirmareliminarPeriodoPregunta(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar periodo ' + item.periodo.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarPeriodoPregunta(item);
            });
        }

        function eliminarPeriodoPregunta(item) {
            PeriodoPreguntaFactory.eliminar(item).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarPeriodoPregunta();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo eliminar Periodo Pregunta.');
            });
        }

        function mostrarAgregarNormativaDialog() {
            ngDialog.open({
                template: 'app/modules/preguntas/registro/agregar-normativa/agregar-normativa-dialog.html',
                controller: 'AgregarNormativaDialogController',
                data: {
                    prmPregunta: vm.dataPregunta,
                },
                controllerAs: 'vm',
                width: '700px',
                preCloseCallback: function() {
                    listarPreguntaNormativa();
                }
            }).closePromise.then(function(dataDialog) {
                //console.log('productoSeleccionado',dataDialog.value);
                //              listarNormaCaso();
            });
        }

        function listarPreguntaNormativa() {
            var dataPreguntaNormativa = PreguntaNormativaFactory.model();
            dataPreguntaNormativa.pregunta.idPregunta = vm.dataPregunta.idPregunta;
            PreguntaNormativaFactory.listar(dataPreguntaNormativa).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.listaNormativasPregunta = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function opcionesPreguntaTabla() {
            if (vm.dataPregunta.numerosColumna < 0 || vm.dataPregunta.numerosColumna > 8) {
                toastr.warning('Solo puede colocar un numero de 1 a 8');
                vm.dataPregunta.numerosColumna = 0;
                vm.dataPregunta.lstOpcionPregunta = [];
                return;
            }
            if (vm.dataPregunta.numerosFila < 0 || vm.dataPregunta.numerosFila > 15) {
                toastr.warning('Solo puede colocar un numero de 1 a 15');
                vm.dataPregunta.numerosFila = 0;
                vm.dataPregunta.lstOpcionPregunta = [];
                return;
            }
            vm.dataPregunta.lstOpcionPregunta = [];
            if (vm.dataPregunta.numerosFila != 0 && vm.dataPregunta.numerosColumna != 0) {
                for (var i = 0; i < vm.dataPregunta.numerosFila; i++) {
                    var listaOpcionesColumna = [];
                    for (var e = 0; e < vm.dataPregunta.numerosColumna; e++) {
                        var dataColumna = OpcionPreguntaFactory.model();
                        dataColumna.posicionFila = i;
                        dataColumna.posicionColumna = e;
                        listaOpcionesColumna.push(dataColumna);
                    }
                    var dataFila = OpcionPreguntaFactory.model();
                    dataFila.lstOpcionPreguntaColumna = angular.copy(listaOpcionesColumna);
                    vm.dataPregunta.lstOpcionPregunta.push(dataFila);
                }
            }
        }

        function opcionesPreguntaTablaDatosCargados() {
            debugger;
            if (vm.dataPregunta.lstOpcionPregunta != null && vm.dataPregunta.lstOpcionPregunta.length != 0) {
                var listaDatosOpcionesPregunta = angular.copy(vm.dataPregunta.lstOpcionPregunta);
                vm.dataPregunta.lstOpcionPregunta = [];
                if (vm.dataPregunta.numerosFila != 0 && vm.dataPregunta.numerosColumna != 0) {
                    for (var i = 0; i < vm.dataPregunta.numerosFila; i++) {
                        var listaOpcionesColumna = [];
                        for (var e = 0; e < vm.dataPregunta.numerosColumna; e++) {
                            var dataColumna = OpcionPreguntaFactory.model();
                            dataColumna.posicionFila = i;
                            dataColumna.posicionColumna = e;
                            listaOpcionesColumna.push(angular.copy(dataColumna));
                        }
                        var dataFila = OpcionPreguntaFactory.model();
                        dataFila.lstOpcionPreguntaColumna = angular.copy(listaOpcionesColumna);
                        vm.dataPregunta.lstOpcionPregunta.push(angular.copy(dataFila));
                    }
                }
                for (var z in vm.dataPregunta.lstOpcionPregunta) {
                    for (var v in vm.dataPregunta.lstOpcionPregunta[z].lstOpcionPreguntaColumna) {
                        for (var s in listaDatosOpcionesPregunta) {
                            if (vm.dataPregunta.lstOpcionPregunta[z].lstOpcionPreguntaColumna[v].posicionFila == listaDatosOpcionesPregunta[s].posicionFila && vm.dataPregunta.lstOpcionPregunta[z].lstOpcionPreguntaColumna[v].posicionColumna == listaDatosOpcionesPregunta[s].posicionColumna) {
                                vm.dataPregunta.lstOpcionPregunta[z].lstOpcionPreguntaColumna[v] = angular.copy(listaDatosOpcionesPregunta[s]);
                            }
                        }
                    }
                }
            }
        }

        function registrarPeriodoPregunta() {
            vm.datePeriodoPregunta.pregunta.idPregunta = vm.dataPregunta.idPregunta;
            PeriodoPreguntaFactory.registrar(vm.datePeriodoPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.datePeriodoPregunta.idPeriodoPregunta = response.data;
                    toastr.success('Registrado Correctamente ');
                    vm.datePeriodoPregunta = PeriodoPreguntaFactory.model();
                    listarPeriodoPregunta();
                } else {
                    toastr.info(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Pregunta.');
            });
        }

        function listarPeriodoPregunta() {
            var dataPeriodoPregunta = PeriodoPreguntaFactory.model();
            dataPeriodoPregunta.pregunta.idPregunta = vm.dataPregunta.idPregunta;
            PeriodoPreguntaFactory.listar(dataPeriodoPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.listaDatosPeriodoPregunta = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function cancelar() {
            $state.go('spapp.home.preguntas.banco-pregunta');
        }

        function eliminarOpcionesPregunta(data) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar la opción?'
                },
                width: '380px'
            }).then(function(okValue) {
                if (data.idOpcionPregunta == 0) {
                    for (var x in vm.dataPregunta.lstOpcionPregunta) {
                        if (vm.dataPregunta.lstOpcionPregunta[x].valor.toUpperCase() == data.valor.toUpperCase()) {
                            vm.dataPregunta.lstOpcionPregunta.splice(x, 1);
                        }
                    }
                } else {
                    eliminarOpcionPregunta(data);
                }
            });
        }

        function eliminarOpcionPregunta(data) {
            OpcionPreguntaFactory.eliminar(data).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    toastr.success(response.mensaje);
                    buscarPregunta(vm.dataPregunta);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function agregarOpcion(data) {
            var b = 0;
            for (var x in vm.dataPregunta.lstOpcionPregunta) {
                if (vm.dataPregunta.lstOpcionPregunta[x].valor.toUpperCase() == vm.dataOpcionPregunta.valor.toUpperCase()) {
                    b = 1;
                }
            }
            if (b == 0) {
                vm.dataPregunta.lstOpcionPregunta.push(angular.copy(vm.dataOpcionPregunta));
                vm.dataOpcionPregunta.valor = '';
                if (vm.dataPregunta.idPregunta != 0) {
                    actualizarPregunta();
                }
            } else {
                toastr.warning('La opcion ya se encuentra agregada');
                vm.dataOpcionPregunta.valor = '';
            }
        }

        function listarPreguntaSector() {
            var dataPregunta = PreguntaSectorFactory.model();
            dataPregunta.pregunta.idPregunta = vm.dataPregunta.idPregunta;
            PreguntaSectorFactory.listar(dataPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.listaPreguntaSector = response.data;
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function registrarPreguntaSector() {
            vm.dataPreguntaSector.pregunta.idPregunta = vm.dataPregunta.idPregunta;
            PreguntaSectorFactory.registrar(vm.dataPreguntaSector).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.dataPreguntaSector.idPreguntaSector = response.data;
                    listarPreguntaSector();
                    toastr.success('Registrado Correctamente ');
                    vm.dataPreguntaSector = PreguntaSectorFactory.model();
                } else {
                    toastr.info(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Pregunta.');
            });
        }

        function registrarPregunta() {
            if (vm.dataPregunta.idPregunta == 0) {
                registroPregunta();
            } else {
                actualizarPregunta();
            }
        }

        function validaDatosPreguntaTabla(caracteresMinimos) {
            var result = 0;
            var data = vm.dataPregunta.lstOpcionPregunta;
            for (var x in data[0].lstOpcionPreguntaColumna) {
                if (data[0].lstOpcionPreguntaColumna[x].valor.length <= caracteresMinimos) {
                    result = 1;
                    return result;
                }
            }
            for (var b in data) {
                if (data[b].lstOpcionPreguntaColumna[0].valor.length <= caracteresMinimos) {
                    result = 1;
                    return result;
                }
            }
            return result;
        }

        function registroPregunta() {
            var caracterMinimoTabla = 4;
            if (vm.dataPregunta.tipoPregunta.codigoRegistro == 5 && validaDatosPreguntaTabla(caracterMinimoTabla) == 1) {
                toastr.info('Debe ingresar como mínimo ' + caracterMinimoTabla + ' caracteres en los campos permitidos de la tabla');
                return;
            }
            if (vm.dataPregunta.descripcion.length >= 12) {
                PreguntaFactory.registrar(vm.dataPregunta).then(function(response) {
                    if (response.valido) {
                        //vm.dataPedido.idPedido = response.data;
                        vm.dataPregunta.idPregunta = response.data;
                        vm.btnAccion = "Actualizar Pregunta";
                        toastr.success('Pregunta Generada');
                        buscarPregunta(vm.dataPregunta);
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Ocurrió un error al registrar la Pregunta.');
                });
            } else {
                toastr.warning('Ingresar como mínimo 12 caracteres');
            }
        }

        function actualizarPregunta() {
            debugger;
            PreguntaFactory.actualizar(vm.dataPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;       
                    toastr.success('Pregunta Actualizada Correctamente ');
                    buscarPregunta(vm.dataPregunta);
                    vm.dataOpcionPregunta.valor = '';
                } else {
                    //toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Actualizar la Pregunta.');
            });
        }
        /*function listarPregunta(){
            var dataPregunta = {


            };
    
        PreguntaFactory
            .listar(dataPregunta)
            .then(function (response) {
                if(response.valido){
                    //vm.dataPedido.idPedido = response.data;
                    vm.listaPreguntas= response.data;
                    
            
                }
                else{
                    toastr.error(response.mensaje);
                }
            })
            .catch(function (error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }*/
        function cargarCombos() {
            vm.listaTipoPregunta = [{
                codigoRegistro: 0,
                descripcion: 'Seleccione'
            }];
            vm.listaSector = [{
                codigoRegistro: 0,
                descripcion: 'Todos'
            }];
            vm.listaPeriodoPreguntas = [{
                codigoRegistro: 0,
                descripcion: 'Seleccione'
            }];
            var codigosCombos = ['TipoPregunta', 'TipoSector', 'PeriodoPregunta'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoPregunta':
                                for (var i in datosCombo) {
                                    vm.listaTipoPregunta.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'PeriodoPregunta':
                                for (var i in datosCombo) {
                                    vm.listaPeriodoPreguntas.push(datosCombo[i]);
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*************************************************/
        function listarSubSector() {
            vm.listaSubSector = [{
                codigoRegistro: 0,
                descripcion: 'Todos'
            }];
            vm.listaActividad = angular.copy([{
                codigoRegistro: 0,
                descripcion: 'Todos'
            }]);
            vm.dataPreguntaSector.subSector.codigoRegistro = 0;
            vm.dataPreguntaSector.actividad.codigoRegistro = 0;
            /*vm.dataInstalacion.subSector.codigoRegistro=0;*/
            if (vm.dataPreguntaSector.sector.codigoRegistro != 0) {
                var subSector = {
                    codigoRegistroPadre: vm.dataPreguntaSector.sector.codigoRegistro,
                    codigoMaestro: 'SubSector'
                }
                MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaSubSector.push(response.data[x]);
                        }
                        /*console.log("vm.listaSubSector" + angular.toJson(vm.listaSubSector));*/
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /*******************************************************/
        function listarActividad() {
            vm.listaActividad = [{
                codigoRegistro: 0,
                descripcion: 'Todos'
            }];
            vm.dataPreguntaSector.actividad.codigoRegistro = 0;
            /*  vm.dataInstalacion.actividad=0;
            vm.listaActividad=[];*/
            if (vm.dataPreguntaSector.subSector.codigoRegistro != 0) {
                var actividades = {
                    codigoRegistroPadre: vm.dataPreguntaSector.subSector.codigoRegistro,
                    codigoMaestro: 'Actividad'
                }
                MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                    if (response != null && response.valido) {
                        for (var x in response.data) {
                            vm.listaActividad.push(response.data[x]);
                        }
                        /*  console.log("vm.listaActividad" + angular.toJson(vm.listaActividad));
                            vm.dataNormas.actividad=0;*/
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo obtener los datos para los combos.');
                });
            }
        }
        /****************************************************/
        /** ******************************PROBLEMATICA************************************** */
        function mostrarCasosProblematicaDialog() {
            ngDialog.open({
                template: 'app/modules/denuncias/casos/dialog/casos-problematica/casos-problematica-dialog.html',
                controller: 'CasoProblematicaDialogController',
                data: {},
                controllerAs: 'vm',
                width: '700px',
                preCloseCallback: function() {
                    listarProblematica();
                }
            });
        }
        /** ******************************************************************************** */
        function agregarNormativa(item) {
            vm.verNormativas = true;
            vm.nombreEntidad = item.efa.nombre;
            vm.dataNormaCaso.idCasoEfa = item.idCasoEfa;
            console.log("vm.dataNormaCaso.idCasoEfa" + vm.dataNormaCaso.idCasoEfa);
            listarNormaCaso();
        }

        function limpiar() {
            vm.dataPregunta.descripcion = "";
            vm.dataPregunta.tipoPregunta.codigoRegistro = 0;
            vm.dataPregunta.lstOpcionPregunta = [];
            vm.dataPregunta.numerosFila = 0;
            vm.dataPregunta.numerosColumna = 0;
            vm.dataPregunta.flagArchivo = 0;
        }

        function limpiarPeriodo() {
            vm.datePeriodoPregunta.periodo.codigoRegistro = 0;
        }

        function limpiarSector() {
            vm.listaSubSector = angular.copy([{
                codigoRegistro: 0,
                descripcion: 'Todos'
            }]);
            vm.listaActividad = angular.copy([{
                codigoRegistro: 0,
                descripcion: 'Todos'
            }]);
            vm.dataPreguntaSector.sector.codigoRegistro = 0;
            vm.dataPreguntaSector.subSector.codigoRegistro = 0;
            vm.dataPreguntaSector.actividad.codigoRegistro = 0;
        }
        /* fin de implementacion de metodos */
        function leerOperaciones(ref) {
            AccesoFactory.operaciones(ref, "Preguntas").then(function(response) {
                $rootScope.sisoOperacioneswkWeb = response; //angular.toJson(response);
                //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                $rootScope.sisoValidaOperacionesWbUvk = sisoValidaOperacionesWbUvk;
            }).catch(function(error) {
                toastr.error(error);
            });
        }

        function sisoValidaOperacionesWbUvk(operacion) {
            for (var int = 0; int < $rootScope.sisoOperacioneswkWeb.length; int++) {
                var oOperacion = $rootScope.sisoOperacioneswkWeb[int];
                if (oOperacion.elemento == operacion) {
                    return true;
                }
            }
            return false;
        }

        function buscarPregunta(data) {
            var dataPregunta = data;
            PreguntaFactory.buscarPorId(dataPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.dataPregunta = response.data;
                    if (vm.dataPregunta.tipoPregunta.codigoRegistro == 5) {
                        opcionesPreguntaTablaDatosCargados();
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }

        function init() {
            if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
                leerOperaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq));
                $rootScope.kqlRefRootSiso = angular.copy(localStorage.objlocalStRefSisoplkijsq);
            } else {
                leerOperaciones($rootScope.kqlRefRootSiso);
            }
            vm.btnAccion = "Registrar Pregunta";
            if (angular.isDefined(localStorage.objPreguntaEditar)) {
                console.log("actualizar");
                vm.btnAccion = "Actualizar Pregunta";
                vm.dataPregunta = angular.copy(angular.fromJson(localStorage.objPreguntaEditar));
                localStorage.removeItem('objPreguntaEditar');
                listarPreguntaSector();
                listarPeriodoPregunta();
                listarPreguntaNormativa();
                if (vm.dataPregunta.tipoPregunta.codigoRegistro == 5) {
                    opcionesPreguntaTablaDatosCargados();
                }
            } else {
                vm.dataPregunta = PreguntaFactory.model();
                vm.dataOpcionPregunta = OpcionPreguntaFactory.model();
                vm.dataPreguntaSector = PreguntaSectorFactory.model();
            }
            cargarCombos();
            /*listarPregunta();*/
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').controller('BancoPreguntaController', BancoPreguntaController);
    /* @ngInject */
    function BancoPreguntaController(toastr, $scope, ngDialog, PreguntaFactory, $state, MaestroFactory, AccesoFactory, $rootScope, $log, $location) {
        var vm = this;
        /* declaracion de variables globales */
        vm.dataPregunta = PreguntaFactory.model();
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true
        };
        $scope.serial = 1;
        /*fin de configuracion de tablas*/
        /*   */
        vm.listaPreguntas = [];
        /* */
        vm.listaTipoPregunta = [];
        vm.listaSector = [];
        vm.listaPeriodoPreguntas = [];
        vm.listaSubSector = [];
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        vm.buscarPregunta = buscarPregunta;
        vm.nuevoRegistroPregunta = nuevoRegistroPregunta;
        vm.confirmarEliminarPregunta = confirmarEliminarPregunta;
        vm.listarSubSector = listarSubSector;
        vm.listarPregunta = listarPregunta;
        vm.limpiar = limpiar;
        /* implementacion de metodos */
        function limpiar() {
            vm.dataPregunta = PreguntaFactory.model();
        }

        function listarSubSector() {
            vm.listaSubSector = [];
            /*vm.dataInstalacion.subSector.codigoRegistro=0;*/
            var subSector = {
                codigoRegistroPadre: vm.dataPregunta.codigoSector,
                codigoMaestro: 'SubSector'
            }
            MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                if (response != null && response.valido) {
                    vm.listaSubSector = response.data;
                    /*for(var x in response.data){
                            vm.listaSubSector.push(response.data[x]);
                    }*/
                    /*console.log("vm.listaSubSector" + angular.toJson(vm.listaSubSector));*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cargarCombos() {
            vm.listaTipoPregunta = [];
            vm.listaSector = [];
            vm.listaPeriodoPreguntas = [];
            var codigosCombos = ['TipoPregunta', 'TipoSector', 'PeriodoPregunta'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoPregunta':
                                for (var i in datosCombo) {
                                    vm.listaTipoPregunta.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'PeriodoPregunta':
                                for (var i in datosCombo) {
                                    vm.listaPeriodoPreguntas.push(datosCombo[i]);
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function confirmarEliminarPregunta(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar la pregunta ' + item.descripcion + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarPregunta(item);
            });
        }

        function eliminarPregunta(item) {
            PreguntaFactory.eliminar(item).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarPregunta();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo eliminar la Pregunta.');
            });
        }

        function nuevoRegistroPregunta() {
            $state.go('spapp.home.preguntas.registro');
        }

        function buscarPregunta(data) {
            var dataPregunta = data;
            PreguntaFactory.buscarPorId(dataPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    localStorage.setItem('objPreguntaEditar', angular.toJson(response.data));
                    $state.go('spapp.home.preguntas.registro');
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }
        $scope.indexCount = function(newPageNumber) {
            $scope.serial = newPageNumber * ($scope.config.itemsPerPage) - ($scope.config.itemsPerPage - 1);
        }

        function listarPregunta() {
            var dataPregunta = {};
            PreguntaFactory.listar(vm.dataPregunta).then(function(response) {
                if (response.valido) {
                    //vm.dataPedido.idPedido = response.data;
                    vm.listaPreguntas = response.data;
                    console.log(vm.listaPreguntas);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al Obtener Informacion.');
            });
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarCasosProblematicaDialog() {
            ngDialog.open({
                template: 'app/modules/denuncias/casos/dialog/casos-problematica/casos-problematica-dialog.html',
                controller: 'CasoProblematicaDialogController',
                data: {},
                controllerAs: 'vm',
                width: '700px',
                preCloseCallback: function() {
                    listarProblematica();
                }
            });
        }
        /** ******************************************************************************** */
        function agregarNormativa(item) {
            vm.verNormativas = true;
            vm.nombreEntidad = item.efa.nombre;
            vm.dataNormaCaso.idCasoEfa = item.idCasoEfa;
            console.log("vm.dataNormaCaso.idCasoEfa" + vm.dataNormaCaso.idCasoEfa);
            listarNormaCaso();
        }
        /* fin de implementacion de metodos */
        function init() {
            listarPregunta();
            cargarCombos();
            /*vm.listaTipoPersona.push({codigoRegistro:1,descripcion:'Natural'});
            vm.listaTipoPersona.push({codigoRegistro:2,descripcion:'Jurídica'});
            vm.listaTipoDocumento.push({codigoRegistro:1,descripcion:'RUC'});
            vm.listaTipoDocumento.push({codigoRegistro:2,descripcion:'DNI'});

            vm.listaSector.push({codigoRegistro:1,descripcion:'Energia'});
            vm.listaSector.push({codigoRegistro:2,descripcion:'Mineria'});
            vm.listaSector.push({codigoRegistro:3,descripcion:'Produccion'});


            vm.listaSubSector.push({codigoRegistro:1,descripcion:'HidroCarburos'});
            vm.listaSubSector.push({codigoRegistro:2,descripcion:'Electricidad'});
            vm.listaSubSector.push({codigoRegistro:3,descripcion:'Industria'});
            vm.listaSubSector.push({codigoRegistro:4,descripcion:'Mineria'});
            vm.listaSubSector.push({codigoRegistro:5,descripcion:'Pesqueria'});*/
            /*  vm.pregunta.tipoPregunta=0;*/
        }
        /*implementación de metodos*/
        function leerOperaciones(ref) {
            AccesoFactory.operaciones(ref, "Banco de Preguntas").then(function(response) {
                $rootScope.sisoOperacioneswkWeb = response; //angular.toJson(response);
                //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                $rootScope.sisoValidaOperacionesWbUvk = sisoValidaOperacionesWbUvk;
            }).catch(function(error) {
                toastr.error(error);
            });
        }
        /*  function leerOperaciones(ref) {
                
                AccesoFactory.operaciones(ref,63).then(function (response)
                {
                    $rootScope.sisoOperacioneswkWeb=response;//angular.toJson(response);
                    //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                    $rootScope.sisoValidaOperacionesWbUvk=sisoValidaOperacionesWbUvk;
                }).catch(function (error) 
                {
                    toastr.error(error);
                });
            }
            */
        function sisoValidaOperacionesWbUvk(operacion) {
            for (var int = 0; int < $rootScope.sisoOperacioneswkWeb.length; int++) {
                var oOperacion = $rootScope.sisoOperacioneswkWeb[int];
                if (oOperacion.elemento == operacion) {
                    return true;
                }
            }
            return false;
        }
        if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
            leerOperaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq));
            $rootScope.kqlRefRootSiso = angular.copy(localStorage.objlocalStRefSisoplkijsq);
        } else {
            leerOperaciones($rootScope.kqlRefRootSiso);
        }
        /*fin de metodos*/
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.maestro').controller('MaestroListadoController', MaestroListadoController);
    /* @ngInject */
    function MaestroListadoController(ngDialog, toastr, $scope, $rootScope, MaestroFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.dataRegistrar = '';
        vm.activaRegistroHijo = '0';
        vm.lstMaestros = [];
        vm.lstMaestrosItem = [];
        vm.dataMaestros = MaestroFactory.model();
        vm.listaRegistroHijo = [];
        vm.dataRegistroHijo = MaestroFactory.model();
        vm.dataRegistroActividades = MaestroFactory.model();
        vm.activaRegistroHijoActividades = '0';
        vm.listaRegistroHijoActividades = [];
        vm.dataRegistrarActividades = '';
        /* variables de paginacion */
        // funciones//
        vm.agregarItem = agregarItem;
        vm.listarItemMaestros = listarItemMaestros;
        /* declaración de metodos enlazados a la vista */
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.agregarRegistroHijo = agregarRegistroHijo;
        vm.agregarItemHijo = agregarItemHijo;
        vm.cancelarRegistroHijo = cancelarRegistroHijo;
        vm.confirmarEliminacionRegistroHijo = confirmarEliminacionRegistroHijo;
        vm.agregarRegistroActividades = agregarRegistroActividades;
        vm.cancelarRegistroHijoActividades = cancelarRegistroHijoActividades;
        vm.agregarRegistroHijoDatos = agregarRegistroHijoDatos;
        vm.enviarCorreoAnticipado = enviarCorreoAnticipado;
        
        /* implementación de metodos */
        function agregarRegistroHijo(itemMaestroGeneral) {
            vm.dataRegistroHijo.codigoRegistroPadre = itemMaestroGeneral.codigoRegistro;
            vm.dataRegistroHijo.codigoMaestro = itemMaestroGeneral.codigoMaestro;
            vm.dataRegistroHijo.codigoNivel = 2;
            vm.activaRegistroHijo = '1';
            vm.dataRegistrar = itemMaestroGeneral.descripcion;
            listarRegistroHijo();
        }

        function agregarRegistroActividades(itemMaestroGeneral) {
            debugger;
            vm.dataRegistroActividades.codigoRegistroPadre = itemMaestroGeneral.codigoRegistro;
            vm.dataRegistroActividades.codigoMaestro = itemMaestroGeneral.valorGeneral04;
            vm.dataRegistroActividades.codigoNivel = 2;
            vm.activaRegistroHijoActividades = '1';
            vm.dataRegistrarActividades = itemMaestroGeneral.descripcion;
            listarRegistroHijoActividades();
        }

        function cancelarRegistroHijoActividades() {
            vm.activaRegistroHijoActividades = '0';
            listarRegistroHijo();
        }

        function cancelarRegistroHijo() {
            vm.activaRegistroHijo = '0';
        }

        function agregarRegistroHijoDatos() {
            if (vm.activaRegistroHijoActividades == '1') {
                agregarItemHijoActividades();
            } else {
                agregarItemHijo();
            }
        }

        function agregarItemHijo(itemRegistroHijo) {
            if (itemRegistroHijo != null) {
                /*
				 * $rootScope.itemMaestroGeneral =
				 * angular.copy(itemMaestroGeneral);
				 */
            } else {
                $rootScope.itemRegistroHijo = vm.dataRegistroHijo;
                $rootScope.activaRegistroHijo = vm.activaRegistroHijo;
            }
            ngDialog.open({
                template: 'app/modules/maestro/dialog/maestro-data-dialog.html',
                controller: 'MaestroDataDialogController',
                data: {},
                controllerAs: 'vm',
                width: '50%'
            }).closePromise.then(function(dataDialog) {
                listarRegistroHijo();
                $rootScope.itemRegistroHijo = null;
                $rootScope.activaRegistroHijo = '0';
                /*
				 * if (dataDialog.value.cliente) { vm.dataPedido.cliente =
				 * angular.copy(dataDialog.value.cliente); }
				 */
            });
        }

        function agregarItemHijoActividades(itemRegistroHijoActividades) {
            if (itemRegistroHijoActividades != null) {
                /*
				 * $rootScope.itemMaestroGeneral =
				 * angular.copy(itemMaestroGeneral);
				 */
            } else {
                $rootScope.itemRegistroHijo = vm.dataRegistroActividades;
                $rootScope.activaRegistroHijo = vm.activaRegistroHijo;
            }
            ngDialog.open({
                template: 'app/modules/maestro/dialog/maestro-data-dialog.html',
                controller: 'MaestroDataDialogController',
                data: {},
                controllerAs: 'vm',
                width: '50%'
            }).closePromise.then(function(dataDialog) {
                listarRegistroHijoActividades();
                $rootScope.itemRegistroHijo = null;
                $rootScope.activaRegistroHijo = '0';
                /*
				 * if (dataDialog.value.cliente) { vm.dataPedido.cliente =
				 * angular.copy(dataDialog.value.cliente); }
				 */
            });
        }

        function agregarItem(itemMaestroGeneral) {
            console.log("itemMaestroGeneral" + itemMaestroGeneral);
            if (itemMaestroGeneral != null) {
                $rootScope.itemMaestroGeneral = angular.copy(itemMaestroGeneral);
            } else {
                $rootScope.itemMaestroGeneral = vm.dataMaestros;
            }
            ngDialog.open({
                template: 'app/modules/maestro/dialog/maestro-data-dialog.html',
                controller: 'MaestroDataDialogController',
                data: {
                    itemMaestroGeneral: itemMaestroGeneral
                },
                controllerAs: 'vm',
                width: '50%'
            }).closePromise.then(function(dataDialog) {
                listarItemMaestros();
                if (vm.activaRegistroHijo == '1') {
                    listarRegistroHijo();
                    listarRegistroHijoActividades();
                }
                /*
				 * if (dataDialog.value.cliente) { vm.dataPedido.cliente =
				 * angular.copy(dataDialog.value.cliente); }
				 */
            });
        }

        function confirmarEliminacionRegistroHijo(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + item.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarRegistroHijo(item.idMaestro);
            });
        }

        function confirmarEliminacion(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + item.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(item.idMaestro);
            });
        }

        function eliminarRegistroHijo(idMaestro) {
            var temp = {
                idMaestro: idMaestro
            };
            MaestroFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    console.log("sdadasasd---WW");
                    toastr.success(response.mensaje);
                    listarRegistroHijo();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar el producto');
            });
        }

        function eliminar(idMaestro) {
            var temp = {
                idMaestro: idMaestro
            };
            MaestroFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listarItemMaestros();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar el producto');
            });
        }

        function listarMaestros() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.listar().then(function(response) {
                if (response != null && response.valido) {
                    vm.lstMaestros = angular.copy(response.data);
                    console.log("vm.lstMaestros" + angular.toJson(vm.lstMaestros));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarRegistroHijoActividades() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.buscarRegistroHijo(vm.dataRegistroActividades).then(function(response) {
                if (response != null && response.valido) {
                    vm.listaRegistroHijoActividades = angular.copy(response.data);
                    console.log("vm.listaRegistroHijoActividades" + angular.toJson(vm.listaRegistroHijoActividades));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarRegistroHijo() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.buscarRegistroHijo(vm.dataRegistroHijo).then(function(response) {
                if (response != null && response.valido) {
                    vm.listaRegistroHijo = angular.copy(response.data);
                    console.log("vm.listaRegistroHijo" + angular.toJson(vm.listaRegistroHijo));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarItemMaestros() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            console.log("vm.dataMaestros.codigoMaestro" + vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstMaestrosItem = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cargarCombos(codigosCombos) {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case '':
                                vm.lstMaestros = datosCombo;
                                break;
                            case 'TipoSituacionEvento':
                                vm.listaSituacionEvento = datosCombo;
                                break;
                            default:
                                lstMaestrosItem = datosCombo;
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
            listarMaestros();
        }
        init();
        
        function enviarCorreoAnticipado(){
        	var prmMaestro = MaestroFactory.model();
        	 MaestroFactory.enviarCorreoAnticipado(angular.copy(prmMaestro)).then(function(response) {
                 if (response != null && response.valido) {
                	 toastr.success('Se ejecutó el proceso de envío corrrectamente');
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo ejecutar el proceso de envío de correo');
             });
        }
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.maestro').controller('MaestroDataDialogControllerXD', MaestroDataDialogControllerXD);

    function MaestroDataDialogControllerXD() {
        var vm = this;
        /*declaracion de variables globales*/
        vm.esNuevoRegistro = true;
        /*declaración de metodos enlazados a la vista*/
        vm.cancelar = cancelar;
        /*implementación de metodos*/
        function cancelar() {
            ngDialog.close();
        }

        function init() {}
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.etapa').controller('EtapaListadoController', EtapaListadoController);
    /* @ngInject */
    function EtapaListadoController(ngDialog, toastr, $scope, $rootScope, EtapaFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstEtapas = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmEtapa = EtapaFactory.model();

        function agregarItem(prmEtapa) {
            console.log("prmEtapa" + prmEtapa);
            if (prmEtapa != null) {
                
                EtapaFactory.buscarPorId(angular.copy(prmEtapa)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemEtapa = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/etapa/dialog/etapa-data-dialog.html',
                                  controller: 'EtapaDataDialogController',
                                  controllerAs: 'vm',
                                  
                                  width: '50%'
                              }).closePromise.then(function(dataDialog) {
                                  listar();
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener la etapa');
		                });
            } 
            else{
            	$rootScope.itemEtapa =  EtapaFactory.model();
            	ngDialog.open({
                    template: 'app/modules/etapa/dialog/etapa-data-dialog.html',
                    controller: 'EtapaDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '50%'
                }).closePromise.then(function(dataDialog) {
                    listar();
                });
            }
          
        }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }
        
        function confirmarInactivacion(prmEtapa) {
        	
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }
        
        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmEtapa.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            EtapaFactory.listar(angular.copy(vm.prmEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = angular.copy(response.data);
                    console.log("vm.lstEtapas" + angular.toJson(vm.lstEtapas));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	vm.prmEtapa.estado = '1';
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.maestro').controller('MaestroDataDialogController', MaestroDataDialogController);

    function MaestroDataDialogController($scope, toastr, ngDialog, $log, $rootScope, MaestroFactory, $filter) {
        var vm = this;
        /* declaracion de variables globales */
        /** * Variables Fecha Pregunta ** */
        vm.dataFechaInicioPreguntaValida;
        vm.dataFechaFinPreguntaValida;
        vm.dataFechaNoLaborable;
        /** ***************************** */
        vm.lstMaestrosItem = [];
        vm.esNuevoRegistro = true;
        vm.prmMaestro = MaestroFactory.model();
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 5
        };
        /* declaración de metodos enlazados a la vista */
        vm.guardar = guardar;
        vm.confirmarEliminar = confirmarEliminar;
        vm.obtener = obtener;
        vm.cancelar = cancelar;
        vm.limpiar = limpiar;
        vm.fechaValidaPregunta = fechaValidaPregunta;
        vm.obtenerDatosFecha = obtenerDatosFecha;
        /* implementación de metodos */
        function obtenerDatosFecha() {
            var fecha = vm.dataFechaNoLaborable;
            var dia = fecha.getDate();
            var mes = fecha.getMonth();
            var nombreMes = "";
            switch (mes) {
                case 0:
                    nombreMes = "Enero";
                    break;
                case 1:
                    nombreMes = "Febrero";
                    break;
                case 2:
                    nombreMes = "Marzo";
                    break;
                case 3:
                    nombreMes = "Abril";
                    break;
                case 4:
                    nombreMes = "Mayo";
                    break;
                case 5:
                    nombreMes = "Junio";
                    break;
                case 6:
                    nombreMes = "Julio";
                case 7:
                    nombreMes = "Agosto";
                    break;
                case 8:
                    nombreMes = "Septiembre";
                    break;
                case 9:
                    nombreMes = "Octubre";
                    break;
                case 10:
                    nombreMes = "Noviembre";
                    break;
                case 11:
                    nombreMes = "Diciembre";
                    break;
            }
            vm.prmMaestro.valorGeneral01 = dia + "";
            vm.prmMaestro.valorGeneral02 = mes + "";
            vm.prmMaestro.descripcion = dia + " de " + nombreMes;
        }

        function convertDateToString(prmdate) {
            if (!angular.isUndefined(prmdate) && prmdate != null && prmdate != "") {
                try {
                    var strDate = $filter('date')(prmdate, "dd/MM/yyyy");
                    return strDate;
                } catch (e) {
                    return "";
                }
            }
        }

        function convertStringToDate(strDate) {
            if (!angular.isUndefined(strDate) && strDate != null && strDate != "") {
                try {
                    var dateArray = strDate.split("/");
                    var date = new Date(dateArray[2] + "/" + dateArray[1] + "/" + dateArray[0])
                    return date;
                } catch (e) {
                    $log.log("convertStringToDate: ", e);
                    return null;
                }
            }
        }

        function fechaValidaPregunta(anio) {
            if (anio.length == 4) {
                var anioFin = parseInt(anio, 10);
                var fechaFin = '31/03/' + (anioFin + 1);
                vm.dataFechaInicioPreguntaValida = convertStringToDate('01/04/' + anio);
                vm.dataFechaFinPreguntaValida = convertStringToDate(fechaFin);
                vm.prmMaestro.valorGeneral01 = convertDateToString(vm.dataFechaInicioPreguntaValida);
                vm.prmMaestro.valorGeneral02 = convertDateToString(vm.dataFechaFinPreguntaValida);
            }
        }

        function cancelar() {
            ngDialog.close();
        }

        function obtener(item) {
            vm.prmMaestro = angular.copy(item);
        }

        function limpiar() {
            vm.prmMaestro = MaestroFactory.model();
            $rootScope.itemMaestroGeneral = null;
            /*
			 * vm.prmMaestro.codigoTabla=
			 * angular.copy($rootScope.itemMaestroGeneral.codigoTabla);
			 */
        }

        function cargarCombos(codigosCombos) {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            default: vm.lstMaestrosItem = datosCombo;
                            break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function guardar() {
            if (vm.prmMaestro.idMaestro == 0) {
                registrar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function confirmarEliminar(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro que desea eliminar el registro seleccionado?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(item);
            });
        }

        function registrar() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            if (vm.prmMaestro.codigoMaestro == 'TipoSector') {
                vm.prmMaestro.valorGeneral04 = 'SubSector';
                vm.prmMaestro.codigoNivel = 1;
            }
            if (vm.prmMaestro.codigoMaestro == 'SubSector') {
                vm.prmMaestro.valorGeneral04 = 'Actividad';
                vm.prmMaestro.codigoNivel = 2;
            }
            
            if (vm.prmMaestro.codigoRegistroPadre == 0) {
                vm.prmMaestro.codigoNivel = 1;
            }
            else{
            	vm.prmMaestro.codigoNivel = 2;
            }
            
            MaestroFactory.registrar(angular.copy(vm.prmMaestro)).then(function(response) {
                if (response != null && response.valido) {
                    limpiar();
                    /* vm.lstMaestrosItem = response.data; */
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.actualizar(angular.copy(vm.prmMaestro)).then(function(response) {
                if (response != null && response.valido) {
                    limpiar();
                    vm.lstMaestrosItem = response.data;
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function eliminar(item) {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            MaestroFactory.eliminar(angular.copy(item)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstMaestrosItem = response.data;
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function init() {
            if ($rootScope.itemRegistroHijo != null && $rootScope.activaRegistroHijo == '1') {
                vm.prmMaestro = angular.copy($rootScope.itemRegistroHijo);
            } else {
                console.log("$rootScope.itemMaestroGeneral" + $rootScope.itemMaestroGeneral);
                if ($rootScope.itemMaestroGeneral != null) {
                    console.log($rootScope.itemMaestroGeneral);
                    var codigo = [$rootScope.itemMaestroGeneral.codigoTabla]
                    vm.prmMaestro = angular.copy($rootScope.itemMaestroGeneral);
                } else {
                    vm.prmMaestro.codigoTabla = angular.copy($rootScope.itemMaestroGeneral.codigoTabla);
                }
                console.log("vm.prmMaestro");
                console.log(vm.prmMaestro);
            }
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.etapa').controller('EtapaDataDialogController', EtapaDataDialogController);

    function EtapaDataDialogController($scope, toastr, ngDialog, $log, $rootScope, EtapaFactory, CookiesFactory, $filter) {
        var vm = this;
        /* declaracion de variables globales */
        vm.prmEtapa = EtapaFactory.model();
        /* declaración de metodos enlazados a la vista */
        vm.guardar = guardar;
        vm.cancelar = cancelar;
        
        $scope.config = {
                itemsPerPage: 5,
                fillLastPage: true,
                current: 1
            };

        function cancelar() {
            ngDialog.close();
        }

        function guardar() {
            if (vm.prmEtapa.codetapa == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar ' + (vm.prmEtapa.codetapa == 0 ? 'Registrar' : 'Actualizar') ,
                    Mensaje: '¿Está seguro que desea ' + (vm.prmEtapa.codetapa == 0 ? 'Registrar' : 'Actualizar')  + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
            EtapaFactory.registrar(angular.copy(vm.prmEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	vm.prmEtapa.idsession = CookiesFactory.obtenerCookie();
            EtapaFactory.actualizar(angular.copy(vm.prmEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }


        function init() {
        	  if ($rootScope.itemEtapa != null) {
                  vm.prmEtapa = angular.copy($rootScope.itemEtapa);
              }
        	  else{
        		  vm.prmEtapa = EtapaFactory.model();
        	  }
        	  
        	  console.log(' vm.prmEtapa validacion ' +  vm.prmEtapa);
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.eor', []);
})();
(function() {
    'use strict';
    angular.module('spapp.eor').controller('EorListadoController', EorListadoController);
    /* @ngInject */
    function EorListadoController(ngDialog, toastr, $scope, $rootScope, EorFactory, CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstEor = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmEor = EorFactory.model();

        function agregarItem(prmEor) {
            console.log("prmEor" + prmEor);
            if (prmEor != null) {
                
                EorFactory.buscarPorId(angular.copy(prmEor)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemEor = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/eor/dialog/eor-data-dialog.html',
                                  controller: 'EorDataDialogController',
                                  controllerAs: 'vm',
                                  width: '40%'
                              }).closePromise.then(function(dataDialog) {
                                  listar();
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener la EOR');
		                });
            } 
            else{
            	$rootScope.itemEor =  EorFactory.model();
            	ngDialog.open({
                    template: 'app/modules/eor/dialog/eor-data-dialog.html',
                    controller: 'EorDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '40%'
                }).closePromise.then(function(dataDialog) {
                    listar();
                });
            }
          
        }

        function confirmarEliminacion(prmEor) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEor.nombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEor.secuencia);
            });
        }
        
        function confirmarInactivacion(prmEor) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEor.nombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEor.secuencia);
            });
        }

        function eliminar(codigo) {
            var temp = {
            	secuencia: codigo
            };
            EorFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la tipoiga');
            });
        }
        
        function inactivar(codigo) {
            var temp = {
            	secuencia: codigo,
            	idsession: CookiesFactory.obtenerCookie(),
            };
            EorFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la tipoiga');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmEor.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            EorFactory.listar(angular.copy(vm.prmEor)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEor = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
        	vm.prmEor.estado = '1';
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.eor').controller('EorListadoSeleccionController', EorListadoSeleccionController);
    /* @ngInject */
    function EorListadoSeleccionController(ngDialog, toastr, $scope, $rootScope, EorFactory, CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstEor = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmEor = EorFactory.model();
        vm.seleccionarEor = seleccionarEor;
        
        function seleccionarEor(item){
        	$rootScope.eor = item;
        	$scope.closeThisDialog();
        }

        function agregarItem(prmEor) {
            console.log("prmEor" + prmEor);
            if (prmEor != null) {
                
                EorFactory.buscarPorId(angular.copy(prmEor)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemEor = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/eor/dialog/eor-data-dialog.html',
                                  controller: 'EorDataDialogController',
                                  controllerAs: 'vm',
                                  width: '40%'
                              }).closePromise.then(function(dataDialog) {
                                  listar();
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener la EOR');
		                });
            } 
            else{
            	$rootScope.itemEor =  EorFactory.model();
            	ngDialog.open({
                    template: 'app/modules/eor/dialog/eor-data-dialog.html',
                    controller: 'EorDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '40%'
                }).closePromise.then(function(dataDialog) {
                    listar();
                });
            }
          
        }

        function confirmarEliminacion(prmEor) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEor.nombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEor.secuencia);
            });
        }
        
        function confirmarInactivacion(prmEor) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEor.nombre + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEor.secuencia);
            });
        }

        function eliminar(codigo) {
            var temp = {
            	secuencia: codigo
            };
            EorFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la tipoiga');
            });
        }
        
        function inactivar(codigo) {
            var temp = {
            	secuencia: codigo,
            	idsession: CookiesFactory.obtenerCookie(),
            };
            EorFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la tipoiga');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmEor.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            EorFactory.listar(angular.copy(vm.prmEor)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEor = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
        	vm.prmEor.estado = '1';
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.eor').controller('EorDataDialogController', EorDataDialogController);

    function EorDataDialogController($scope, toastr, ngDialog, $log, $rootScope, EorFactory, CookiesFactory, EntidadFactory, $filter) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.prmEor = EorFactory.model();
        /*declaración de metodos enlazados a la vista*/
        vm.guardar = guardar;
        vm.cancelar = cancelar;
        vm.titulo = '';
        vm.tituloAccion = '';
        vm.validarRuc=validarRuc;
        vm.limpiarBusqueda=limpiarBusqueda;
        
        function validarRuc(){
       	    var dataEntidad = EntidadFactory.model();
    	    dataEntidad.ruc = vm.prmEor.ruc;
            EntidadFactory.validarDocumento(angular.copy(dataEntidad)).then(function(response) {
                 if (response.valido) {
                	 dataEntidad = response.data;
                	 vm.prmEor.nombre = dataEntidad.razonSocial;
                	 vm.prmEor.direccion = dataEntidad.direccion;
                 }
            });
       }

        function cancelar() {
            ngDialog.close();
        }

        function guardar() {
            if (vm.titulo == "Nuevo") {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }
        

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	vm.prmEor.idsession = CookiesFactory.obtenerCookie();
            EorFactory.registrar(angular.copy(vm.prmEor)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
                else{
                	toastr.error(response.mensaje);	
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
        	vm.prmEor.idsession = CookiesFactory.obtenerCookie();
            //var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            EorFactory.actualizar(angular.copy(vm.prmEor)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
                else{
                	toastr.error(response.mensaje);	
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function limpiarBusqueda(){
        	 vm.prmEor = EorFactory.model();	
        }

        function init() {
        	  if ($rootScope.itemEor != null) {
                  vm.prmEor = angular.copy($rootScope.itemEor);
                  if(vm.prmEor.fechavencimiento!=null){
                	  vm.prmEor.fechavencimiento = new Date(vm.prmEor.fechavencimiento);	  
                  }
              }
        	  else{
        		  vm.prmEor = EorFactory.model();
        	  }
        	  
        	  
        	  if(vm.prmEor.secuencia == 0){
        		  vm.titulo = "Nuevo";
        		  vm.tituloAccion = "Registrar";
        	  }
        	  else{
        		  vm.titulo = "Editar";
        		  vm.tituloAccion = "Actualizar";
        	  }
        }
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.componente', []);
})();
(function() {
    'use strict';
    angular.module('spapp.componente').controller('ComponenteListadoController', ComponenteListadoController);
    /* @ngInject */
    function ComponenteListadoController(ngDialog, toastr, $scope, $rootScope, ComponenteAmbientalFactory,CookiesFactory ) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstComponentes = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.regresar = regresar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.prmComponentePadre = ComponenteAmbientalFactory.model();
        vm.listarRegistroHijo = listarRegistroHijo;
        vm.codigoRegreso = 0;
        vm.cargarParametros = cargarParametros;
        vm.nivel;
        
        function regresar(){

        	if(vm.codigoRegreso == 0){
        		vm.prmComponentePadre = ComponenteAmbientalFactory.model();
        		listar();
        	}
        	else{
        		
        		
        		
        		 var temp = {
             		    codigo : vm.codigoRegreso,
             	      };
        		 
        		 
        		 ComponenteAmbientalFactory.buscarPorId(angular.copy(temp)).then(function(response) {
                 		if (response.valido) {
                 			temp = response.data;
                 			listarRegistroHijo(temp);  
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la componente');
 		                });
        	}
       
       }

        
        function listarRegistroHijo(prmComponente){
        	// guardamos el codigo padre para la funcion de regresar
        	 vm.codigoRegreso = prmComponente.codigopadre;
        	 vm.prmComponentePadre = prmComponente;
        	 
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(vm.prmComponentePadre)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstComponentes = angular.copy(response.data);
                     console.log("vm.lstComponentes" + angular.toJson(vm.lstComponentes));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }

        function agregarItem(prmComponente) {
            console.log("prmComponente" + prmComponente);
            $rootScope.itemComponentePadre = vm.prmComponentePadre;
            if (prmComponente != null) {
                
                ComponenteAmbientalFactory.buscarPorId(angular.copy(prmComponente)).then(function(response) {
                	console.log('response.valido ' + response.valido);
                		if (response.valido) {
                        	$rootScope.itemComponente = response.data;
                        	  ngDialog.open({
                                  template: 'app/modules/componente/dialog/componente-data-dialog.html',
                                  controller: 'ComponenteDataDialogController',
                                  controllerAs: 'vm',
                                  
                                  width: '50%'
                              }).closePromise.then(function(dataDialog) {
                            	  if(vm.prmComponentePadre.codigo == 0){
                            		  listar();
                            	  }
                            	  else{
                            		  listarRegistroHijo(vm.prmComponentePadre);
                            	  }
                                  
                              });
                        } else {
                            toastr.error(response.mensaje)
                        }
		                }).catch(function(error) {
		                    toastr.error('Ocurrió un error al obtener la componente');
		                });
            } 
            else{
            	$rootScope.itemComponente =  ComponenteAmbientalFactory.model();
            	ngDialog.open({
                    template: 'app/modules/componente/dialog/componente-data-dialog.html',
                    controller: 'ComponenteDataDialogController',
                    controllerAs: 'vm',
                    
                    width: '50%'
                }).closePromise.then(function(dataDialog) {
                	if(vm.prmComponentePadre.codigo == 0){
              		  listar();
              	  }
              	  else{
              		  listarRegistroHijo(vm.prmComponentePadre);
              	  }
                });
            }
          
        }

        function confirmarEliminacion(prmComponente) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmComponente.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmComponente.codigo);
            });
        }
        
        function confirmarInactivacion(prmComponente) {
        	CookiesFactory 
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmComponente.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmComponente.codigo);
            });
        }

        function eliminar(codigo) {
            var temp = {
            		codigo: codigo
            };
            ComponenteAmbientalFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    if(vm.prmComponentePadre.codigo == 0){
              		  listar();
              	  	}
              	  	else{
              		  listarRegistroHijo(vm.prmComponentePadre);
              	  	}
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la componente');
            });
        }
        
        function inactivar(codigo) {
            var temp = {
            	codigo: codigo,
            	idsession :CookiesFactory.obtenerCookie(),
            };
            ComponenteAmbientalFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    if(vm.prmComponentePadre.codigo == 0){
              		  listar();
              	  	}
                    else{
              		  listarRegistroHijo(vm.prmComponentePadre);
              	  	}
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la componente');
            });
        }
        
        function cargarParametros(prmComponente){
        	$rootScope.prmComponente = prmComponente;
        	ngDialog.open({
                template: 'app/modules/componente-parametro/componente-parametro.html',
                controller: 'ComponenteParametrosController',
                controllerAs: 'vm',
                
                width: '50%'
            }).closePromise.then(function(dataDialog) {
                
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmComponente.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ComponenteAmbientalFactory.listar(angular.copy(vm.prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstComponentes = angular.copy(response.data);
                    console.log("vm.lstComponentes" + angular.toJson(vm.lstComponentes));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	vm.prmComponente.estado = '1';
        	vm.nivel  = 1;
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.componente').controller('ComponenteDataDialogController', ComponenteDataDialogController);

    function ComponenteDataDialogController($scope, toastr, ngDialog, $log, $rootScope, ComponenteAmbientalFactory, CookiesFactory , $filter) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.prmComponentePadre = ComponenteAmbientalFactory.model();
        /*declaración de metodos enlazados a la vista*/
        vm.guardar = guardar;
        vm.cancelar = cancelar;

        function cancelar() {
            ngDialog.close();
        }

        function guardar() {
        	//si es un nuevo hijo colocamos el codigo padre
        	if(vm.prmComponentePadre.codigo != 0){
        		vm.prmComponente.codigopadre = vm.prmComponentePadre.codigo;
        	}
        	
            if (vm.prmComponente.codigo == 0) {
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar Guardar',
                    Mensaje: '¿Está seguro que desea guardar?'
                },
                width: '380px'
            }).then(function(okValue) {
                registrar();
            });
        }

        function registrar() {
        	vm.prmComponente.idsession = CookiesFactory.obtenerCookie();
        	ComponenteAmbientalFactory.registrar(angular.copy(vm.prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function actualizar() {
            //var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	vm.prmComponente.idsession = CookiesFactory.obtenerCookie();
        	ComponenteAmbientalFactory.actualizar(angular.copy(vm.prmComponente)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }


        function init() {
        	  if ($rootScope.itemComponente != null) {
                  vm.prmComponente = angular.copy($rootScope.itemComponente);
              }
        	  else{
        		  vm.prmComponente = ComponenteAmbientalFactory.model();
        	  }
        	  
        	  
        	  if ($rootScope.itemComponentePadre != null) {
                  vm.prmComponentePadre = angular.copy($rootScope.itemComponentePadre);
              }
        	  else{
        		  vm.prmComponentePadre = ComponenteAmbientalFactory.model();
        	  }
        	  
        	  
        	  
        	  
        	  console.log(' vm.prmComponente validacion ' +  vm.prmComponente);
        }
        init();
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').controller('SolicitudAccesoController', SolicitudAccesoController);
    /* @ngInject */
    function SolicitudAccesoController(API_CONFIG, $scope, $log, $location, toastr, ngDialog, SolicitudesFactory, SolicitudFactory, ContactoAdministradoFactory, $rootScope, MaestroFactory, InstalacionFactory) {
        var vm = this;
        /*Configuracion de paginacion de tablas*/
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /*fin de configuracion de tablas*/
        vm.tipoSolicitudModificacion = 0;
        /* declaracion de variables globales */
        vm.urlData = API_CONFIG.url;
        vm.flagActivoBandeja = '1';
        vm.datafiltroSolicitudes = SolicitudesFactory.model();
        vm.dataSolicitudes = SolicitudesFactory.model();
        vm.dataUsuario = {
            tipoPersona: 1
        }
        vm.dataInstacionVigente = {};
        vm.instalacionPrincipal = InstalacionFactory.model();
        vm.instalacionAuxiliar = null;
        vm.tieneParaAprobar = false;
        vm.dataInstalacion = {
            sector: 0,
            subSector: 0
        };
        vm.listaTipoPersona = [];
        vm.listaTipoDocumento = [];
        vm.listaSector = [];
        vm.listaSubSector = [];
        vm.listaActividad = [];
        vm.listaSolicitudes = [];
        vm.listaDetalleSolicitud = [];
        vm.listaContactoAdministrado = [];
        vm.listaTipoSolicitud = [];
        vm.listaEstadoSolicitud = [];
        vm.listaCheck = [];
        vm.listaCheckTemporal = [];
        /******/
        /* declaracion de metodos enlazados a la vista */
        /* declaracion de metodos */
        vm.revisarSolicitud = revisarSolicitud;
        vm.descargarArchivo = descargarArchivo;
        vm.cambiarEstadoDetalleSolicitud = cambiarEstadoDetalleSolicitud;
        vm.validarDetalleSolicitudEstado = validarDetalleSolicitudEstado;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.listarSolicitudes = listarSolicitudes;
        vm.limpiar = limpiar;
        vm.descargarFicha = descargarFicha;
        vm.aprobarTodasSolicitudes = aprobarTodasSolicitudes;
        vm.aprobarSolicitudesSelecc = aprobarSolicitudesSelecc;
        /* implementacion de metodos */
        function limpiar() {
            vm.flagActivoBandeja = '1';
            vm.datafiltroSolicitudes = SolicitudesFactory.model();
            vm.dataSolicitudes = SolicitudesFactory.model();
            vm.listaDetalleSolicitud = [];
            vm.listaContactoAdministrado = [];
            vm.listaSubSector = [];
            vm.listaActividad = [];
            vm.listaCheck = [];
            vm.listaCheckTemporal = [];
            listarSolicitudes();
        }

        function cargarCombos() {
            /*vm.listaCboTipoContacto = [{codigoRegistro:0,descripcion:'--Seleccione--'}];*/
            var codigosCombos = ['TipoSector', 'TipoEstablecimiento', 'EstadoSolicitud', 'TipoSolicitud'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {
                            case 'TipoSector':
                                for (var i in datosCombo) {
                                    vm.listaSector.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            case 'EstadoSolicitud':
                                vm.listaEstadoSolicitud = datosCombo;
                                break;
                            case 'TipoSolicitud':
                                vm.listaTipoSolicitud = datosCombo;
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarSubSector() {
            vm.listaSubSector = [];
            vm.listaActividad = [];
            vm.datafiltroSolicitudes.subSector = 0;
            vm.datafiltroSolicitudes.actividad = 0;
            if (vm.datafiltroSolicitudes.sector == 0) {
                return;
            }
            //console.log("vm.datafiltroSolicitudes.sector", vm.datafiltroSolicitudes.sector);
            /*vm.dataInstalacion.subSector.codigoRegistro=0;*/
            var subSector = {
                codigoRegistroPadre: vm.datafiltroSolicitudes.sector,
                codigoMaestro: 'SubSector'
            }
            MaestroFactory.buscarRegistroHijo(subSector).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaSubSector.push(response.data[x]);
                    }
                    /*console.log("vm.listaSubSector" + angular.toJson(vm.listaSubSector));*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*******************************************************/
        function listarActividad() {
            vm.listaActividad = [];
            vm.datafiltroSolicitudes.actividad = 0;
            if (vm.datafiltroSolicitudes.subSector == 0) {
                return;
            }
            var actividades = {
                codigoRegistroPadre: vm.datafiltroSolicitudes.subSector,
                codigoMaestro: 'Actividad'
            }
            MaestroFactory.buscarRegistroHijo(actividades).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaActividad.push(response.data[x]);
                    }
                    /*	console.log("vm.listaActividad" + angular.toJson(vm.listaActividad));
                    	vm.dataNormas.actividad=0;*/
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function validarDetalleSolicitudEstado(tipoOperacion, data, estado) {
            if (vm.dataSolicitudes.tipoSolicitud == 2) {
                data.tipoSolicitud = 2;
            }
            if (tipoOperacion == 1) {
                if (estado == 3) {
                    mostrarMotivoRechazo(data, estado);
                } else {
                    cambiarEstadoDetalleSolicitud(data, estado);
                }
            }
        }

        function modificarInstalacionSinModificar(instalacion) {
            debugger;
            var idInstalacion = angular.copy(vm.instalacionAuxiliar.idInstalacion);
            //console.log("idInstalacion QUE NUMERO ES",idInstalacion);
            instalacion.idInstalacion = instalacion.idInstalacionPrincipal;
            instalacion.idInstalacionPrincipal = 0;
            instalacion.estado = 2;
            instalacion.motivoRechazoInstalacion = "";
            //console.log("instalacion QUE VA A QUEDAR EN LA TABLA PRINCIPAL",instalacion)
            InstalacionFactory.modificarEstadoInstalacion(angular.copy(instalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {});
        }

        function modificarInstalaciones(instalacion) {
            debugger;
            //instalacion - vm.instalacionPrincipal -vm.instalacionAuxiliar
            //console.log("vm.instalacionAuxiliar EN LA MODIFICACION",vm.instalacionAuxiliar);
            var idInstalacion = angular.copy(vm.instalacionAuxiliar.idInstalacion);
            //console.log("idInstalacion QUE NUMERO ES",idInstalacion);
            instalacion.idInstalacion = instalacion.idInstalacionPrincipal;
            instalacion.idInstalacionPrincipal = 0;
            instalacion.estado = 2;
            //console.log("instalacion QUE VA A QUEDAR EN LA TABLA PRINCIPAL",instalacion)
            InstalacionFactory.actualizar(angular.copy(instalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {});
            debugger;
            vm.instalacionPrincipal.idInstalacionPrincipal = vm.instalacionPrincipal.idInstalacion;
            vm.instalacionPrincipal.idInstalacion = idInstalacion;
            //console.log("vm.instalacionPrincipal QUE VA A IR A LA TABLA TEMPORAL",vm.instalacionPrincipal);
            InstalacionFactory.actualizar(angular.copy(vm.instalacionPrincipal)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cambiarEstadoDetalleSolicitud(data, estado) {
            var prmData = data;
            if (prmData != null) {
                prmData.estado = estado;
            }
            console.log("prmData QUE SE ENVIA AL ACTUALIZAR", prmData);
            SolicitudFactory.actualizarSolicitud(angular.copy(prmData)).then(function(response) {
                if (response != null && response.valido) {
                	listarSolicitudes();
                	toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function listarContactosAdministrado(id) {
            var data = {
                idAdministrado: id,
            };
            ContactoAdministradoFactory.listar(data).then(function(response) {
                if (response.valido) {
                    vm.listaContactoAdministrado = response.data;
                    console.log("vm.listaContactoAdministrado" + vm.listaContactoAdministrado[0]);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Contactos.');
            }).finally(function() {});
        }

        function descargarArchivo(data) {
            SolicitudFactory.descargarFichaRegistro(data.instalacion.idInstalacion).then(function(response) {
                $log.debug('Documento descargado');
                $log.debug('response', response);
                console.log('response', response);
            }).catch(function(error) {
                $log.error(error);
                toastr.error('Hubo un error en la descarga del documento.');
            });
        }

        function revisarSolicitud(data, tipoSolicitud) {
            debugger;
            if (data.estado == 1) {
                cambiarEstadoSolicitudRevision(data);
            }
            if (tipoSolicitud == '1') {
                vm.dataSolicitudes = data;
                console.log("vm.dataSolicitudes", vm.dataSolicitudes);
                listarDetalleSolicitudes();
                listarContactosAdministrado(vm.dataSolicitudes.idAdministrado);
            }
            if (data.tipoSolicitud == 2) {
                vm.tipoSolicitudModificacion = 1;
            }
        }

        function cambiarEstadoSolicitudRevision(data) {
            var data = {
                idSolicitud: data.idSolicitud,
                estado: 4
            };
            SolicitudFactory.actualizarEstadoSolicitud(data).then(function(response) {
                /*if (response.valido) {
                	
                	
                	
                }else {
                		
                	}*/
            }).catch(function(error) {
                toastr.error('No se pudo Actualizar el estado.');
            }).finally(function() {});
        }

        function listarDetalleSolicitudes() {
            var data = {
                solicitud: {
                    idSolicitud: vm.dataSolicitudes.idSolicitud,
                    tipoSolicitud: vm.dataSolicitudes.tipoSolicitud
                }
            };
            console.log("data", data)
            SolicitudFactory.listarDetalleSolicitud(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.listaDetalleSolicitud = angular.copy(response.data);
                    vm.flagActivoBandeja = '0';
                    //debugger;
                    console.log("vm.listaDetalleSolicitud", vm.listaDetalleSolicitud);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            }).finally(function() {
                if (vm.listaDetalleSolicitud.length > 0) {
                    vm.tieneParaAprobar = angular.copy(false);
                    for (var x = 0; x < vm.listaDetalleSolicitud.length; x++) {
                        //Validar si todos son aprobados
                        console.log("" + x, vm.listaDetalleSolicitud[x].estado.codigoRegistro);
                        if (vm.listaDetalleSolicitud[x].estado.codigoRegistro != 2 && vm.listaDetalleSolicitud[x].estado.codigoRegistro != 3) {
                            vm.tieneParaAprobar = angular.copy(true);
                        }
                        vm.check = false;
                        vm.listaCheck.push(vm.check);
                    }
                    vm.listaCheckTemporal = angular.copy(vm.listaCheck);
                }
                if (vm.dataSolicitudes.tipoSolicitud == 2) {
                    var listaAux = angular.copy(vm.listaDetalleSolicitud);
                    console.log("vm.listaDetalleSolicitud PROCESO", vm.listaDetalleSolicitud);
                    console.log("vm.listaAux PROCESO", listaAux);
                    for (var x = 0; x < listaAux.length; x++) {
                        var codigoInstalacionPrincipal = listaAux[x].instalacion.idInstalacionPrincipal;
                        var instalacionAux = listaAux[x].instalacion;
                        instalacionAux.idInstalacionPrincipal = 0;
                        instalacionAux.idInstalacion = codigoInstalacionPrincipal;
                        instalacionAux.motivoRechazoInstalacion = '';
                        instalacionAux.estado = 5;
                        buscarInstalacionPorId();
                        //						console.log("instalacionAux PARA CAMBIARLE EL ESTADO", instalacionAux);						
                        //						InstalacionFactory
                        //						.modificarEstadoInstalacion(angular.copy(instalacionAux))
                        //						.then(function (response) {
                        //							if (response!=null&&response.valido){		
                        ////								toastr.success('Éxito en la operación.');
                        //							}
                        //						})
                        //						.catch(function (error) {
                        //							toastr.error('No se pudo obtener los datos para los combos.');
                        //						});
                    }
                }
            });
        }

        function buscarInstalacionPorId() {
            debugger;
            if (vm.dataSolicitudes.tipoSolicitud == 2) {
                var dataInstalacionP = InstalacionFactory.model();
                dataInstalacionP.idInstalacion = angular.copy(vm.listaDetalleSolicitud[0].instalacion.idInstalacionPrincipal);
                InstalacionFactory.buscarPorId(angular.copy(dataInstalacionP)).then(function(response) {
                    debugger;
                    if (response.valido) {
                        vm.dataInstacionVigente = response.data;
                        console.log("vm.instalacionPrincipal", vm.dataInstacionVigente);
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo procesar.');
                }).finally(function() {});
            }
        }

        function listarSolicitudes() {
            console.log("vm.datafiltroSolicitudes", vm.datafiltroSolicitudes);
            SolicitudesFactory.listar(angular.copy(vm.datafiltroSolicitudes)).then(function(response) {
                if (response.valido) {
                    vm.listaSolicitudes = response.data;
                    console.log("vm.listaSolicitudes", vm.listaSolicitudes);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            }).finally(function() {});
        }
        /** ******************************PROBLEMATICA************************************** */
        function mostrarMotivoRechazo(data, estado) {
            ngDialog.openConfirm({
                template: 'app/modules/bandeja/solicitudes/dialog/motivo-rechazo/motivo-rechazo-dialog.html',
                controller: 'MotivoRechazoDialogController',
                data: {},
                controllerAs: 'vm',
                width: '700px'
            }).then(function(okValue) {
                data.motivoRechazo = $rootScope.motivoRechazo;
                console.log("data", data);
                if (data.motivoRechazo != '') {
                    cambiarEstadoDetalleSolicitud(data, estado);
                }
            });
        }

        function visualizarPDF() {
            ngDialog.open({
                template: 'app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html',
                controller: 'SolicitudArchivoDialogController',
                controllerAs: 'vm',
                width: '700px'
            });
        }

        function descargarFicha() {
            SolicitudFactory.descargarFicha(vm.dataSolicitudes).then(function(response) {
                if (response.data != null && response.valido) {
                    $rootScope.urlPDFFichaDenuncia = "<iframe src='" + angular.copy(response.data) + "' style='width:100%; height:600px;' frameborder='0'> </iframe>";
                    visualizarPDF();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /*****************************************************************************/
        /*Metodo utilizado para aprobabar todas las solicitudes de acceso*/
        /*****************************************************************************/
        function aprobarTodasSolicitudes() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de aprobar todas las solicitudes?'
                },
                width: '380px'
            }).then(function(okValue) {
                for (var x = 0; x < vm.listaDetalleSolicitud.length; x++) {
                    if (vm.listaDetalleSolicitud[x].estado.codigoRegistro == 1 || vm.listaDetalleSolicitud[x].estado.codigoRegistro == 4) {
                        vm.validarDetalleSolicitudEstado(1, vm.listaDetalleSolicitud[x], 2);
                    }
                }
            });
        }
        /*****************************************************************************/
        /*Metodo utilizado para aprobar solicitudes de acceso seleccionadas*/
        /*****************************************************************************/
        function aprobarSolicitudesSelecc() {
            /*
       		console.log("vm.listaDetalleSolicitud",vm.listaDetalleSolicitud);
       		console.log("vm.listaCheck",vm.listaCheck);
       		console.log("vm.listaCheckTemporal",vm.listaCheckTemporal);
       		console.log("comparar",angular.equals(vm.listaCheck ,vm.listaCheckTemporal));
			*/
            //Verificar si la lista temporal y la lista actual son iguales [entonces no se ha modificado] en caso contrario [se modifico]
            if (!(angular.equals(vm.listaCheck, vm.listaCheckTemporal))) {
                ngDialog.openConfirm({
                    template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                    controller: 'DialogConfirmController',
                    controllerAs: 'vm',
                    data: {
                        Titulo: 'Confirmar eliminación',
                        Mensaje: '¿Está seguro de aprobar o no dicha solicitud?'
                    },
                    width: '380px'
                }).then(function(okValue) {
                    for (var x = 0; x < vm.listaDetalleSolicitud.length; x++) {
                        if (vm.listaDetalleSolicitud[x].estado.codigoRegistro == 1 || vm.listaDetalleSolicitud[x].estado.codigoRegistro == 4) {
                            if (vm.listaCheck[x]) {
                                vm.validarDetalleSolicitudEstado(1, vm.listaDetalleSolicitud[x], 2);
                            }
                        }
                    }
                });
            } else {
                toastr.warning('Debe seleccionar solicitudes');
            }
        }
        /** ******************************************************************************** */
        /* fin de implementacion de metodos */
        function init() {
            listarSolicitudes();
            cargarCombos();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('IngresoInicioController', IngresoInicioController);
    /** @ngInject */
    function IngresoInicioController($state, INTERNAL_HOME_PAGE, toastr, $rootScope, $window,  API_CONFIG, ngDialog) {
        var vm = this;
        /** Slider numero 2* */
        vm.rutaBase = API_CONFIG.url;
        vm.rutaSSO = API_CONFIG.urlSSO;
        /* declaracion de variables globales */
        /* declaración de métodos enlazados a la vista */
        vm.iraLogin = iraLogin;
        vm.iraconsultas = iraconsultas;
        vm.registrarse = registrarse;
        /* implementación de métodos */
        function iraLogin() {
            // http://200.37.65.227/OEFA.STS2
            $window.location.href = vm.rutaSSO + "/Home/Index?wa=wsignin1.0&wtrealm=" + vm.rutaBase + "seguridad/index/&wctx=rm=2&id=pluralsoft&ru=" + vm.rutaBase + "seguridad/confirmsso&wreply=" + vm.rutaBase + "seguridad/confirmsso";
        }

        function iraconsultas() {
            console.log("pasa");
            $state.go('acceso.registro');
        }

        function registrarse() {
            $state.go('invitado.nuevo-usuario');
        }

        function init() {
            // * */
            localStorage.removeItem('objSesSisoLocStWqKP');
            localStorage.removeItem('objTempPerfilSisopowqkj');
            localStorage.removeItem('objlocalStRefSisoplkijsq');
            localStorage.removeItem('ref');
            
            if (localStorage.objExitoRegistroAdministrado == "true") {
                // Modal Informativo
                ngDialog.openConfirm({
                    template: 'app/base/template/dialog-info/dialog-info.html',
                    controller: 'DialogInfoController',
                    controllerAs: 'vm',
                    data: {
                        Titulo: 'Solicitud de acceso',
                        Mensaje: 'Se ha registrado con éxito la solicitud de acceso, por favor revise su correo de contacto y manténgase a la espera para la evaluación de su solicitud.'
                    },
                    width: '380px'
                }).finally(function() {});
                localStorage.removeItem('objExitoRegistroAdministrado');
            }
        }
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('IngresoHidrocarburosController', IngresoHidrocarburosController);
    /** @ngInject */
    function IngresoHidrocarburosController($state, INTERNAL_HOME_PAGE, toastr, $rootScope, $window,  API_CONFIG, ngDialog) {
        var vm = this;
        /** Slider numero 2* */
        vm.rutaBase = API_CONFIG.url;
        vm.rutaSSO = API_CONFIG.urlSSO;
        /* declaracion de variables globales */
        /* declaración de métodos enlazados a la vista */
        vm.irmenores = irmenores;
        vm.irmayores = irmayores;
        /* implementación de métodos */
        function irmayores() {
            // http://200.37.65.227/OEFA.STS2
            
        }

        function irmenores() {
            $state.go('ingreso');
        }



        function init() {
            // * */
//            localStorage.removeItem('objSesSisoLocStWqKP');
//            localStorage.removeItem('objTempPerfilSisopowqkj');
//            localStorage.removeItem('objlocalStRefSisoplkijsq');
//            localStorage.removeItem('ref');
//            
//            if (localStorage.objExitoRegistroAdministrado == "true") {
//                // Modal Informativo
//                ngDialog.openConfirm({
//                    template: 'app/base/template/dialog-info/dialog-info.html',
//                    controller: 'DialogInfoController',
//                    controllerAs: 'vm',
//                    data: {
//                        Titulo: 'Solicitud de acceso',
//                        Mensaje: 'Se ha registrado con éxito la solicitud de acceso, por favor revise su correo de contacto y manténgase a la espera para la evaluación de su solicitud.'
//                    },
//                    width: '380px'
//                }).finally(function() {});
//                localStorage.removeItem('objExitoRegistroAdministrado');
//            }
        }
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp.acceso').controller('AccesoRegistroController', AccesoRegistroController);
    /* @ngInject */
    function AccesoRegistroController(INTERNAL_HOME_PAGE, $scope, $state, $rootScope, ContactoAdministradoFactory, InstalacionFactory , SectorGenericoFactory, MaestroFactory, toastr, ngDialog, PersonaFactory, EntidadFactory, UbigeoFactory, SolicitudFactory, AdministradoFactory, SolicitudesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.flagRegistrarPersona = 0;
        vm.flagAgregarRepresentanteLegal = 0;
        vm.flagAgregarManualmenteRepresentanteLegal = 0;
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.flagActivoEdicionDatosPersona = 0;
        vm.dataUsuario = {
            tipoPersona: 1,
            tipoDocumento: 1
        };
        vm.dataUbigeo = UbigeoFactory.distrito();
        vm.dataContactoAdministrado = ContactoAdministradoFactory.model();
        vm.validaArchivo = '0';
        vm.active = 0;
        vm.dataDetalleSolicitud = SolicitudFactory.modelDetalleSolicitud();
        vm.dataAdministrado = AdministradoFactory.model();
        vm.dataInstalacion = InstalacionFactory.model();
        vm.dataSolicitud = SolicitudFactory.model();
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.dataEntidad = EntidadFactory.model();
        vm.dataPersona = PersonaFactory.model();
        vm.listaDepartamento = [];
        vm.listaProvincia = [{
            codigoProvincia: '',
            descripcion: 'Seleccione'
        }];
        vm.listaDistrito = [{
            codigoDistrito: '',
            descripcionDistrito: 'Seleccione'
        }];
        vm.listaDepartamentoPersona = [];
        vm.listaProvinciaPersona = [];
        vm.listaDistritoPersona = [];
        vm.listaTipoEstablecimiento = [];
        vm.listaTipoPersona = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaTipoDocumento = [{
            codigoRegistro: 0,
            descripcion: '--Seleccione--'
        }];
        vm.listaSector = [];
        vm.listaSubSector = [];
        vm.listaCompetencia = [];
        vm.listaActividad = [];
        vm.listaSolicitudesInstalacion = [];
        vm.listaArchivosSolicitud = [];
        vm.listaCboTipoContacto = [];
        vm.listaSolicitudes = [];
        /** *** */
        /* declaracion de metodos enlazados a la vista */
        vm.buscarPersonaXNumeroDocumento = buscarPersonaXNumeroDocumento;
        vm.buscarEntidadXNumeroDocumento = buscarEntidadXNumeroDocumento;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.agregarInstalaciones = agregarInstalaciones;
        vm.registrarSolicitudArchivo = registrarSolicitudArchivo;
        vm.listarSubSector = listarSubSector;
        vm.listarActividad = listarActividad;
        vm.eliminarPorPosicion = eliminarPorPosicion;
        vm.validaDocumento = validaDocumento;
        vm.agregarContacto = agregarContacto;
        vm.editarContacto = editarContacto;
        vm.eliminarContacto = eliminarContacto;
        vm.limpiarPersona = limpiarPersona;
        vm.limpiarInstalacion = limpiarInstalacion;
        vm.cancelar = cancelar;
        vm.modificarInstalacion = modificarInstalacion;
        vm.listarProvinciaPersona = listarProvinciaPersona;
        vm.listarDistritoPersona = listarDistritoPersona;
        vm.actualizarDatosPersona = actualizarDatosPersona;
        vm.datafiltroSolicitudes = SolicitudesFactory.model();
        vm.validaPredeterminadoContacto = validaPredeterminadoContacto;
        vm.contactoPredeterminado = contactoPredeterminado;
        vm.validaContactoAdministrado = validaContactoAdministrado;
        vm.siguiente = siguiente;
        vm.validaContactoPredeterminado = validaContactoPredeterminado;
        vm.valorTelefono = valorTelefono;
        vm.registrarPersonaOEntidad = registrarPersonaOEntidad;
        vm.buscarRepresentanteLegal = buscarRepresentanteLegal;
        vm.limpiarRepresentanteLegal = limpiarRepresentanteLegal;
        vm.cancelarRegistro = cancelarRegistro;
        vm.changeSector = changeSector;
        vm.changeSubSector = changeSubSector;
        vm.changeCompetencia = changeCompetencia;
        vm.listaZonas = [];
        vm.isnuevaInstalacion = true;
        vm.nuevaInstalacion = nuevaInstalacion;
        vm.regresar = regresar;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.listaArchivosContacto = [];
        
        function confirmarEliminacion(index){
        	vm.listaSolicitudesInstalacion.splice(index, 1);
        }
        
        function regresar(){
        	 vm.isnuevaInstalacion = false;
        	 vm.dataInstalacion = InstalacionFactory.model();
        }
        
        function nuevaInstalacion(item){
        	 vm.isnuevaInstalacion = true;
        	 if(item!=null){
        		 vm.dataInstalacion = item;
        		 vm.dataInstalacion.flgModificado = true;
        		 listarSubSector();
        		 listarProvincia();
        	 }
        }

        function changeSector(){
        	vm.dataInstalacion.subSector = '';
        	vm.dataInstalacion.competencia = '';
        	vm.dataInstalacion.actividad = '';
        	listarSubSector();
        }

        function changeSubSector(){
        	vm.dataInstalacion.competencia = '';
        	vm.dataInstalacion.actividad = '';
        	listarCompetencia();
        }
        
        function changeCompetencia(){
        	vm.dataInstalacion.actividad = '';
        	listarActividad(vm.dataInstalacion.competenciaArray);
        }
        
        
        
        
        /* declaracion de metodos */
        /* implementacion de metodos */
        function cancelarRegistro() {
            vm.dataEntidad = EntidadFactory.model();
            vm.dataPersona = PersonaFactory.model();
            vm.dataUbigeo = UbigeoFactory.distrito();
            vm.dataAdministrado.lstContactoAdministrado = [];
            vm.dataAdministrado = AdministradoFactory.model();
            vm.flagActivoEdicionDatosPersona = 0;
            vm.listaSolicitudesInstalacion = [];
            vm.dataAdministrado.lstContactoAdministrado = [];
            vm.dataSolicitud.administrado.idAdministrado = 0;
            vm.caracteresMaximoArchivo = 50;
            vm.flagRegistrarPersona = 0;
            vm.flagAgregarRepresentanteLegal = 0;
            vm.flagAgregarManualmenteRepresentanteLegal = 0;
            limpiarRepresentanteLegal();
        }

        function validarEmail(valor) {
            var emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            var res = 0;
            if (emailRegex.test(valor)) {
                res = 1;
            }
            return res;
        }

        function siguiente() {
            if (validaContactoPredeterminado() == 0) {
                toastr.info('Debe de ingresar un contacto principal');
            } else {
                vm.active = 1;
            }
        }

        function validaContactoPredeterminado() {
            var cantContacto = 0;
            
            for (var x in vm.dataAdministrado.lstContactoAdministrado) {
                if (vm.dataAdministrado.lstContactoAdministrado[x].isPredeterminado) {
                	cantContacto = cantContacto + 1;
                }
            }
            return cantContacto;
        }

        function validaPredeterminadoContacto(index) {
            for (var x in vm.dataAdministrado.lstContactoAdministrado) {
                if (x == index) {
                    vm.dataAdministrado.lstContactoAdministrado[x].flagPredeterminado = '1';
                } else {
                    vm.dataAdministrado.lstContactoAdministrado[x].flagPredeterminado = '0';
                }
            }
        }

        function actualizarDatosPersona() {
            if (vm.dataPersona.idPersona > 0) {
                actualizarPersona();
            }
        }

        function actualizarPersona() {
            vm.dataPersona.departamento = vm.dataUbigeo.codigoDepartamento;
            vm.dataPersona.provincia = vm.dataUbigeo.codigoProvincia;
            vm.dataPersona.distrito = vm.dataUbigeo.codigoDistrito;
            PersonaFactory.actualizar(angular.copy(vm.dataPersona)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Persona Actualizada Correctamente.');
                    vm.flagActivoEdicionDatosPersona = 0;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function modificarInstalacion(data) {
            vm.dataInstalacion = angular.copy(data);
            listarSubSector();
            listarActividad();
            listarProvincia();
            listarDistrito();
        }

        function actualizarInstalacion() {
            InstalacionFactory.actualizar(vm.listaArchivosSolicitud, angular.copy(vm.dataInstalacion)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Instalacion Actualizada Correctamente.');
                    vm.listaArchivosSolicitud = [];
                    vm.dataInstalacion = InstalacionFactory.model();
                    listarDetalleSolicitudes();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function cancelar() {
            $state.go('ingreso');
        }

        function limpiarInstalacion() {
            vm.dataInstalacion = InstalacionFactory.model();
            vm.validaArchivo = '0';
            document.getElementById("fileArchivoMedio").value = "";
            vm.listaSubSector = [];
            vm.listaActividad = [];
            vm.listaProvincia = [];
            vm.listaDistrito = [];
        }

        function limpiarPersona() {
            vm.dataEntidad = EntidadFactory.model();
            vm.dataPersona = PersonaFactory.model();
            vm.dataUbigeo = UbigeoFactory.distrito();
            vm.dataAdministrado.lstContactoAdministrado = [];
            vm.dataAdministrado = AdministradoFactory.model();
            vm.flagActivoEdicionDatosPersona = 0;
            vm.listaSolicitudesInstalacion = [];
            vm.dataAdministrado.lstContactoAdministrado = [];
            vm.dataSolicitud.administrado.idAdministrado = 0;
        }

        function eliminarContacto(index) {
            console.log(vm.dataAdministrado.lstContactoAdministrado);
            if (vm.dataSolicitud.administrado != null && vm.dataSolicitud.administrado.idAdministrado != 0) {
                confirmarEliminarContactoAdministrado(vm.dataAdministrado.lstContactoAdministrado[index]);
            } else {
                confirmarEliminarContactoAdministradoTemporal(vm.dataAdministrado.lstContactoAdministrado[index], index);
            }
        }

        function editarContacto(data, index) {
            vm.dataAdministrado.lstContactoAdministrado.splice(index, 1);
            var dataContacto = data;
            vm.dataContactoAdministrado = dataContacto;
        }

// function agregarContacto() {
// console.log("vm.dataContactoAdministrado 1",
// vm.dataAdministrado.lstContactoAdministrado);
// if (vm.dataSolicitud.administrado != null &&
// vm.dataSolicitud.administrado.idAdministrado != 0) {
// registrarContactoAdministrado(vm.dataContactoAdministrado);
// console.log("vm.dataContactoAdministrado 2",
// vm.dataAdministrado.lstContactoAdministrado);
// } else {
// var data = vm.dataContactoAdministrado;
// vm.dataAdministrado.lstContactoAdministrado.push(data);
// console.log("vm.dataContactoAdministrado 3",
// vm.dataAdministrado.lstContactoAdministrado);
// vm.dataContactoAdministrado = ContactoAdministradoFactory.model();
// contactoPredeterminado(vm.dataAdministrado.lstContactoAdministrado.length -
// 1);
// }
        	
        	function agregarContacto(prmContacto){
        		
        			$rootScope.dataContactoAdministrado = null;
        		
        			$rootScope.dataSolicitud = vm.dataSolicitud;
	   			 	if (prmContacto != null) {
	   	                
	   	                        	$rootScope.itemContacto = prmContacto;
	   	                        	  ngDialog.open({
	   	                                  template: 'app/modules/acceso/registro/acceso-registro-contacto.html',
	   	                                  controller: 'AccesoRegistroContactoController',
	   	                                  controllerAs: 'vm',
	   	                                  width: '50%'
	   	                              }).closePromise.then(function(dataDialog) {
	   	                            	 if (vm.dataSolicitud.administrado == null || vm.dataSolicitud.administrado.idAdministrado == 0) {
	   	                            		 vm.dataContactoAdministrado= $rootScope.dataContactoAdministrado;
	   	                            		 vm.listaArchivosContacto.push($rootScope.dataContactoArchivo[0]);
	   	                            		 var data = vm.dataContactoAdministrado;
			   	                 			 
		   	                            	 for (var x in vm.dataAdministrado.lstContactoAdministrado) {
			   	                                 if (vm.dataAdministrado.lstContactoAdministrado[x].idContactoAdministrado == data.idContactoAdministrado) {
			   	                                	 vm.dataAdministrado.lstContactoAdministrado[x] = data;
			   	                                 }
		   	                            	 }
	   	                            	 }
	   	                            	 else{
	   	                            		 listarContactoAdministrado();
	   	                            	 }
	   	                              });
	   	            } 
	   	            else{
	   	            	$rootScope.itemContacto =  ContactoAdministradoFactory.model();
	   	            	ngDialog.open({
	   	                    template: 'app/modules/acceso/registro/acceso-registro-contacto.html',
	   	                    controller: 'AccesoRegistroContactoController',
	   	                    controllerAs: 'vm',
	   	                    
	   	                    width: '50%'
	   	                }).closePromise.then(function(dataDialog) {
	   	                 if (vm.dataSolicitud.administrado == null || vm.dataSolicitud.administrado.idAdministrado == 0) {
	   	                	 if($rootScope.dataContactoAdministrado !=null){
	   	                		 vm.dataContactoAdministrado= $rootScope.dataContactoAdministrado;
	   	                		 vm.listaArchivosContacto.push($rootScope.dataContactoArchivo[0]);
	   	                		 var data = vm.dataContactoAdministrado;
		                 			 vm.dataAdministrado.lstContactoAdministrado.push(data);
		                 			 vm.dataContactoAdministrado = ContactoAdministradoFactory.model();
		                 			 if(vm.dataContactoAdministrado.isPredeterminado){
		                 				contactoPredeterminado(vm.dataAdministrado.lstContactoAdministrado.length - 1);
		                 			 }
	   	                	 }
                       		
                       	 }
                       	 else{
                       		 listarContactoAdministrado();
                       	 }
	   	                });
	   	            }
        }

        function contactoPredeterminado(index) {
            if (vm.dataAdministrado.lstContactoAdministrado.length != 0) {
                var tipo = vm.dataAdministrado.lstContactoAdministrado[index].tipoContacto.codigoRegistro;
                for (var x in vm.dataAdministrado.lstContactoAdministrado) {
                    if (vm.dataAdministrado.lstContactoAdministrado[x].tipoContacto.codigoRegistro == tipo) {
                        if (x == index) {
                            vm.dataAdministrado.lstContactoAdministrado[x].flagPredeterminado = '1';
                        } else {
                            vm.dataAdministrado.lstContactoAdministrado[x].flagPredeterminado = '0';
                        }
                    }
                }
            }
        }

        function confirmarEliminarContactoAdministrado(item) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el contacto ' + item.valor + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminarContactoAdministrado(item);
            });
        }

        function confirmarEliminarContactoAdministradoTemporal(item, index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el contacto ' + item.valor + ' ?'
                },
                width: '380px'
            }).then(function(okValue) {
                var itemTipoContacto = 0;
                // Identificar si en predeterminado(true:si/false:no)
                if (item.flagPredeterminado == '1') {
                    // Si en la lista existen mas de uno
                    if (vm.dataAdministrado.lstContactoAdministrado.length > 1) {
                        // Identificar tipo Contacto (telefono:1/correo:2)
                        itemTipoContacto = angular.copy(item.tipoContacto.codigoRegistro);
                    }
                }
                vm.dataAdministrado.lstContactoAdministrado.splice(index, 1);
                if (itemTipoContacto != 0) {
                    for (var i = 0; i < vm.dataAdministrado.lstContactoAdministrado.length; i++) {
                        if (vm.dataAdministrado.lstContactoAdministrado[i].tipoContacto.codigoRegistro == itemTipoContacto) {
                            vm.dataAdministrado.lstContactoAdministrado[i].flagPredeterminado = angular.copy('1');
                            break;
                        }
                    }
                }
            });
        }

        function eliminarContactoAdministrado(data) {
            ContactoAdministradoFactory.eliminar(angular.copy(data)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Contacto Eliminado Correctamente.');
                    listarContactoAdministrado();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function registrarContactoAdministrado(data) {
            console.log("vm.dataContactoAdministrado 0", vm.dataAdministrado.lstContactoAdministrado);
            data.idAdministrado = vm.dataSolicitud.administrado.idAdministrado;
            ContactoAdministradoFactory.registrar(angular.copy(data)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Contacto Registrado Correctamente.');
                    listarContactoAdministrado();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function validaContactoAdministrado() {
            if (vm.dataContactoAdministrado.tipoContacto.codigoRegistro == 1) {
                if ((angular.isUndefined(vm.dataContactoAdministrado.valor))) {
                    // Mensaje debe ingresar correctamente el correo electronico
                    // toastr.warning("Debe ingresar correctamente el teléfono
					// \nEjemplo : (051)999-9999");
                    // return;
                    // Mensaje debe ingresar correctamente el correo electronico
                    var item = angular.element('#txtTelefono').val();
                    if (item.length >= 13) {
                        toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : (051)9999-99999");
                    } else {
                        var letra = angular.copy(item.substr(0, 1));
                        console.log(letra);
                        var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                        var esNumeroInicial = false;
                        console.log(esNumeroInicial);
                        for (var i = 0; i < array.length; i++) {
                            if (array[i] === letra) {
                                esNumeroInicial = true;
                                break;
                            }
                        }
                        console.log("esNumeroInicial");
                        console.log(esNumeroInicial);
                        if (esNumeroInicial) {
                            switch (item.length) {
                                case 8:
                                    toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : 99999999");
                                    break;
                                case 9:
                                    toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : 999999999");
                                    break;
                                default:
                                    toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : 9999999");
                                    break;
                            }
                        } else {
                            toastr.warning("Debe ingresar correctamente el teléfono  \nEjemplo : (051)999-9999");
                        }
                    }
                    return;
                }
            }
            if (vm.dataContactoAdministrado.tipoContacto.codigoRegistro == 2) {
                if ((angular.isUndefined(vm.dataContactoAdministrado.valor))) {
                    // Mensaje debe ingresar correctamente el correo electronico
                    toastr.warning("Debe ingresar correctamente el correo \nEjemplo : ejemplo@domino.com");
                    return;
                }
            }
            if (vm.dataAdministrado.lstContactoAdministrado.length > 0) {
                for (var i = 0; i < vm.dataAdministrado.lstContactoAdministrado.length; i++) {
                    console.log(vm.dataAdministrado.lstContactoAdministrado[i].valor);
                    if (angular.equals(vm.dataAdministrado.lstContactoAdministrado[i].valor, vm.dataContactoAdministrado.valor)) {
                        toastr.warning("El contacto ingresado ya se encuentra registrado");
                        return;
                    }
                }
            }
            if (vm.dataContactoAdministrado.tipoContacto.codigoRegistro == 2 && validarEmail(vm.dataContactoAdministrado.valor) == 0) {
                toastr.info('Debe ingresar un correo valido');
                return;
            }
            ContactoAdministradoFactory.validaContacto(angular.copy(vm.dataContactoAdministrado)).then(function(response) {
                if (response.data == 0) {
                    agregarContacto();
                } else {
                    toastr.info(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo procesar la acción.');
            });
        }

        function listarContactoAdministrado() {
            var data = {
                idAdministrado: vm.dataSolicitud.administrado.idAdministrado,
            };
            console.log("data");
            console.log(data);
            ContactoAdministradoFactory.listar(angular.copy(data)).then(function(response) {
                if (response != null && response.valido) {
                    vm.dataAdministrado.lstContactoAdministrado = angular.copy(response.data);
                    console.log("vm.dataAdministrado.lstContactoAdministrado 5");
                    console.log(vm.dataAdministrado.lstContactoAdministrado);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function eliminarPorPosicion(index) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                vm.listaSolicitudesInstalacion.splice(index, 1);
                vm.listaArchivosSolicitud.splice(index, 1);
            });
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");
            vm.validaArchivo = '0';
            if (vm.dataInstalacion.idInstalacion != 0) {
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    /*
					 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
					 * 1);
					 */
                    vm.validaEnvioCorreo = '0';
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaEnvioCorreo = '0';
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaEnvioCorreo = '0';
                    return;
                }
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.validaArchivo = '1';
            } else {
                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                
                if (vm.listaSolicitudesInstalacion.length < vm.listaArchivosSolicitud.length) {
                    vm.validaArchivo = '1';
                    vm.listaArchivosSolicitud[vm.listaArchivosSolicitud.length - 1] = prmFileList[0];
                }
                
                if (vm.listaSolicitudesInstalacion.length == vm.listaArchivosSolicitud.length) {
                    vm.listaArchivosSolicitud.push(prmFileList[0]);
                    vm.validaArchivo = '1';
                    console.log("vm.listaArchivosSolicitud", vm.listaArchivosSolicitud.length);
                }
                
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    /*
					 * vm.archivoAdjunto.splice(vm.dataInformarAccion.lstArchivoAtencion.length,
					 * 1);
					 */
                    vm.validaEnvioCorreo = '0';
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no está permitido.');
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaEnvioCorreo = '0';
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivoMedio").value = "";
                    vm.validaEnvioCorreo = '0';
                    return;
                }
                
                vm.listaArchivosSolicitud.push(prmFileList[0]);
                vm.dataInstalacion.nombreArchivoOriginal = prmFileList[0].name;
                vm.validaArchivo = '1';
            }
        }
        
        function cargarCombos() {
           
            vm.listaCboTipoContacto = [{
                codiguargoRegistro: 0,
                descripcion: '--Seleccione--'
            }];
            var codigosCombos = ['TipoPersona', 'TipoContacto', 'TipoDocumento', 'TipoEstablecimiento', 'ZONA'];
            MaestroFactory.buscarMaestros(angular.copy(codigosCombos)).then(function(response) {
                console.log('response cargarCombos', response);
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        var tipoCombo = response.data[x].Key;
                        var datosCombo = response.data[x].Value;
                        switch (tipoCombo) {

                            case 'TipoPersona':
                                vm.listaTipoPersona = datosCombo;
                                break;
                            case 'TipoContacto':
                                for (var i in datosCombo) {
                                    vm.listaCboTipoContacto.push(datosCombo[i]);
                                }
                                break;
                            case 'TipoDocumento':
                                vm.listaTipoDocumento = datosCombo;
                                break;
                            case 'TipoEstablecimiento':
                                vm.listaTipoEstablecimiento = datosCombo;
                                break;
                            case 'ZONA':
                            	for (var i in datosCombo) {
                                    vm.listaZonas = datosCombo;
                                }
                                break;
                            default:
                                break;
                        }
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        /** ********************************************** */
        function listarSector(){
        	SectorGenericoFactory.listarSector().then(function(response) {
                 if (response.valido) {
                     for (var x in response.data) {
                         vm.listaSector.push(response.data[x]);
                     }
                     /* vm.dataDenuncia.tipoPersona=0; */
                 } else {
                     toastr.error(response.mensaje);
                 }
             }).catch(function(error) {
                 toastr.error('Error al consultar');
             }).finally(function() {
            	 if (vm.dataInstalacion.sector != '') {
                 	listarSubSector();
                 }
             });
        }
        

        function listarSubSector() {
        	vm.listaSubSector = [];
            var subSector = {
                codigosector: vm.dataInstalacion.sector
            };
            SectorGenericoFactory.listarSubSector(angular.copy(subSector)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaSubSector.push(response.data[x]);
                    }
                    /*
					 * console.log("vm.listaSubSector" +
					 * angular.toJson(vm.listaSubSector));
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {
                if (vm.dataInstalacion.subSector != '') {
                	listarCompetencia();
                }
            });
        }
        
     
        
        function listarCompetencia() {
        	var componenteSel = null;

        	vm.listaCompetencia = [];
            var subSector = {
                codigosubsector: vm.dataInstalacion.subSector
            };
            SectorGenericoFactory.listarCompetencia(angular.copy(subSector)).then(function(response) {
                if (response != null && response.valido) {
                	// PARSEAMOS LA COMPETENCIA
                    for (var x in response.data) {
                        vm.listaCompetencia.push(response.data[x]);
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            }).finally(function() {
                if (vm.dataInstalacion.competencia != '') {
                	var arrayCompetencia = vm.dataInstalacion.competencia.split(';');
                	vm.dataInstalacion.competenciaArray = obtenerArraySinVacios(arrayCompetencia);
                	 if(vm.dataInstalacion.competenciaArray.length>0){
                		 listarActividad(vm.dataInstalacion.competenciaArray);
                	 }
                }
            });
        }
        
        function listarActividad(competencia) {
        	
        	vm.listaActividad = [];
        	if(competencia == null){
        		return;
        	}
        	
            var actividades = {
                codigocompetencia: competencia[competencia.length - 1]
            };
            
            SectorGenericoFactory.listarActividad(angular.copy(actividades)).then(function(response) {
                if (response != null && response.valido) {
                    for (var x in response.data) {
                        vm.listaActividad.push(response.data[x]);
                    }
                    /*
					 * console.log("vm.listaActividad" +
					 * angular.toJson(vm.listaActividad));
					 * vm.dataNormas.actividad=0;
					 */
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }
        
        function obtenerInstalaciones(){
        	// Obtener por carga
        	var prmInstalacion = {
        		ruc : vm.dataEntidad.ruc,
        	};
        	
        	 InstalacionFactory.buscarPorRuc(angular.copy(prmInstalacion)).then(function(response) {
                 if (response.valido) {
                	 var arrayTemp = angular.copy(response.data);
                	 if(arrayTemp.length > 0){
                		 vm.isnuevaInstalacion = false;
                		 for (var x in arrayTemp){
                			 var tobjIns = {
                					 idInstalacion : arrayTemp[x].idInstalacion,
                					 idAdministrado : vm.dataAdministrado.idAdministrado,
                						sector :  arrayTemp[x].sector,
                						subSector : arrayTemp[x].subSector,
                						actividad :  arrayTemp[x].actividad,
                						departamento : arrayTemp[x].departamento,
                						provincia : arrayTemp[x].provincia,
                						distrito :  arrayTemp[x].distrito,
                						estado :  arrayTemp[x].estado,
                						numeroInstalacion :  arrayTemp[x].numeroInstalacion,
                						tipoEstablecimiento : arrayTemp[x].tipoEstablecimiento,
                						numeroRegistro : arrayTemp[x].numeroRegistro,
                						rutaFichaRegistro :  arrayTemp[x].rutaFichaRegistro,
                						direccion :  arrayTemp[x].direccion,
                						puntoNorte :  arrayTemp[x].puntoNorte,
                						puntoEste :  arrayTemp[x].puntoEste,
                						referencia :  arrayTemp[x].referencia,
                						idzona : arrayTemp[x].idzona,
                						fichaRegistro :  arrayTemp[x].fichaRegistro,
                						uiid :  arrayTemp[x].uiid,
                						sectorDescripcion :  arrayTemp[x].sectorDescripcion,
                						subSectorDescripcion :  arrayTemp[x].subSectorDescripcion,
                						actividadDescripcion :  arrayTemp[x].actividadDescripcion,
                						competenciaDescripcion :  arrayTemp[x].competenciaDescripcion                				
                			 };
                			 vm.listaSolicitudesInstalacion.push(tobjIns);
                		 }
                	 }
                	 
                 } else {
                     toastr.error(response.mensaje);
                 }
             }).catch(function(error) {
                 toastr.error('Error al consultar');
             });
        	// obtener por Osinergmin
        }
        
        function agregarInstalaciones() {
            if (vm.dataInstalacion.idInstalacion != 0) {
// if (vm.validaArchivo == '1') {
            		 var data = angular.copy(vm.dataInstalacion);
            		 if (data != null) {
                         data.estado = 1;
                         data.flagActivo = 1;
                         data.ruc = vm.dataEntidad.ruc;
                         data.razonsocial = vm.dataEntidad.razonSocial;
                         data.sectorDescripcion = obtenerSectorNombre(data.sector);
                         data.subSectorDescripcion = obtenerSubsectorNombre(data.subSector);
                         data.actividadDescripcion = obtenerActividadNombre(data.actividad);
                         var competenciaConcat = "";
                		 	for (var x in data.competenciaArray) {
                				competenciaConcat = competenciaConcat +  data.competenciaArray[x] + ";" ;
                         }
                		 data.competencia = competenciaConcat;
                         data.competenciaDescripcion = obtenerCompetenciaNombre(data.competenciaArray);
                         data.departamento.descripcionDepartamento = obtenerDepartamentoNombre(data.departamento.codigoDepartamento);
                         data.provincia.descripcion = obtenerProvinciarNombre(data.provincia.codigoProvincia);
                         data.distrito.descripcionDistrito = obtenerDistritoNombre(data.distrito.codigoDistrito);
                         data.flgModificado = true;
                         
                         if(vm.listaSolicitudesInstalacion.length>0){
                        	 for(var x in vm.listaSolicitudesInstalacion){
                        		 if(vm.listaSolicitudesInstalacion[x].idInstalacion = vm.dataInstalacion.idInstalacion){
                        			 vm.listaSolicitudesInstalacion[x]=data;
                        		 }
                        	 }
                         }
                         
                         vm.dataInstalacion = InstalacionFactory.model();
                         document.getElementById("fileArchivoMedio").value = "";
                         vm.validaArchivo = '0';
                         vm.isnuevaInstalacion = false;
                     }
// }
// else{
// toastr.warning('Falta Cargar ficha de Registro');
// }
               
            } else {
                /*
				 * if(vm.listaSolicitudesInstalacion!=null){
				 * vm.dataInstalacion.idInstalacion=(vm.listaSolicitudesInstalacion.length)+1; }
				 */
// if (vm.validaArchivo == '1') {
                    var data = angular.copy(vm.dataInstalacion);
                    if (data != null) {
                    	
                    	if (data.flgModificado){
                    		 if(vm.listaSolicitudesInstalacion.length>0){
                            	 for(var x in vm.listaSolicitudesInstalacion){
                            		 if(vm.listaSolicitudesInstalacion[x].numeroItem = vm.dataInstalacion.numeroItem){
                            			 vm.listaSolicitudesInstalacion[x]=data;
                            		 }
                            	 }
                             }
                    	}else{
                    		data.estado = 1;
                            data.flagActivo = 1;
                            data.ruc = vm.dataEntidad.ruc;
                            data.razonsocial = vm.dataEntidad.razonSocial;
                            data.sectorDescripcion = obtenerSectorNombre(data.sector);
                            data.subSectorDescripcion = obtenerSubsectorNombre(data.subSector);
                            data.actividadDescripcion = obtenerActividadNombre(data.actividad);
                            var competenciaConcat = "";
                   		 	for (var x in data.competenciaArray) {
                   				competenciaConcat = competenciaConcat +  data.competenciaArray[x] + ";" ;
                            }
                   		 	data.competencia = competenciaConcat;
                            data.competenciaDescripcion = obtenerCompetenciaNombre(data.competenciaArray);
                            data.departamento.descripcionDepartamento = obtenerDepartamentoNombre(data.departamento.codigoDepartamento);
                            data.provincia.descripcion = obtenerProvinciarNombre(data.provincia.codigoProvincia);
                            data.distrito.descripcionDistrito = obtenerDistritoNombre(data.distrito.codigoDistrito);
                            data.flgModificado = false;
                            vm.listaSolicitudesInstalacion.push(data);
                    	}
                    	
                        
                        vm.dataInstalacion = InstalacionFactory.model();
                        document.getElementById("fileArchivoMedio").value = "";
                        vm.validaArchivo = '0';
                        vm.isnuevaInstalacion = false;
                    }
// } else {
// toastr.warning('Falta Cargar ficha de Registro');
// }
            }
        }
        
        
        function obtenerSectorNombre(sector){
        	if(vm.listaSector.length>0){
        		for(var x in  vm.listaSector){
        			if(vm.listaSector[x].codigosector == sector){
        				return vm.listaSector[x].sector;
        			}
        		}
        	}
        }
        
		function obtenerSubsectorNombre(subsector){
			if(vm.listaSubSector.length>0){
        		for(var x in  vm.listaSubSector){
        			if(vm.listaSubSector[x].codigosubsector == subsector){
        				return vm.listaSubSector[x].subsector;
        			}
        		}
        	}	
		}
		
		function obtenerActividadNombre(actividad){
			if(vm.listaActividad.length>0){
        		for(var x in  vm.listaActividad){
        			if(vm.listaActividad[x].codigoactividad == actividad){
        				return vm.listaActividad[x].actividad;
        			}
        		}
        	}	
		}
		
		function obtenerCompetenciaNombre(competenciaarray){
			var resultado = '';
			if(vm.listaCompetencia.length>0){
        		for(var x in  vm.listaCompetencia){
        			for(var y in  competenciaarray){
        				if(vm.listaCompetencia[x].codigocompetencia == competenciaarray[y]){
        					resultado = resultado + vm.listaCompetencia[x].competencia + ',';
            			}
        			}
        		}
        	}	
			return resultado;
		}
		
		function obtenerDepartamentoNombre(departamento){
			if(vm.listaDepartamento.length>0){
        		for(var x in  vm.listaDepartamento){
        			if(vm.listaDepartamento[x].codigoDepartamento == departamento){
        				return vm.listaDepartamento[x].descripcionDepartamento;
        			}
        		}
        	}	
		}
		
		function obtenerProvinciarNombre(provincia){
			if(vm.listaProvincia.length>0){
        		for(var x in  vm.listaProvincia){
        			if(vm.listaProvincia[x].codigoProvincia == provincia){
        				return vm.listaProvincia[x].descripcion;
        			}
        		}
        	}	
		}
		
		function obtenerDistritoNombre(distrito){
			if(vm.listaDistrito.length>0){
        		for(var x in  vm.listaDistrito){
        			if(vm.listaDistrito[x].codigoDistrito == distrito){
        				return vm.listaDistrito[x].descripcionDistrito;
        			}
        		}
        	}	
		}
        
        function eliminarSolicitudAnterior(Solicitud) {
            SolicitudFactory.eliminar(angular.copy(Solicitud)).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    // vm.dataSolicitud.idSolicitud= response.data;
                    toastr.success(response.mensaje);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            });
        }

        function registrarSolicitudArchivo() {
        	        	  
        	if (validaContactoPredeterminado() == 0) {
                toastr.info('Debe de ingresar un contacto principal');
                return false;
            } 
        	
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;

            // cambio danie 19/09/2018: los archivos ya están en la carga masiva
			// o en el servicio (primera etapa)
            SolicitudFactory.registrarSolicitudArchivo(vm.listaArchivosContacto, angular.copy(vm.dataSolicitud)).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud generada Correctamente');
                    localStorage.setItem('objExitoRegistroAdministrado', angular.toJson(true));
                    $state.go('ingreso');
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            });
        }

        function registrarSolicitud() {
            $rootScope.cargandoInformacion++;
            if (vm.dataAdministrado.persona.idPersona > 0) {
                vm.dataAdministrado.tipoAdministrado = 1;
            }
            if (vm.dataAdministrado.entidad.idEntidad > 0) {
                vm.dataAdministrado.tipoAdministrado = 2;
            }
            vm.dataAdministrado.flagActivo = 1;
            vm.dataAdministrado.estado = 1;
            vm.dataSolicitud.administrado = vm.dataAdministrado;
            if (vm.listaSolicitudesInstalacion != null) {
                for (var i = 0; i < vm.listaSolicitudesInstalacion.length; i++) {
                    vm.dataDetalleSolicitud.instalacion = vm.listaSolicitudesInstalacion[i];
                    vm.dataDetalleSolicitud.estado.codigoRegistro = 1;
                    vm.dataDetalleSolicitud.flagActivo = 1;
                    vm.dataSolicitud.lstDetalleSolicitud.push(vm.dataDetalleSolicitud);
                }
            }
            /* vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion; */
            SolicitudFactory.registrar(angular.copy(vm.dataSolicitud)).then(function(response) {
                if (response.valido) {
                    // vm.dataPedido.idPedido = response.data;
                    vm.dataSolicitud.idSolicitud = response.data;
                    toastr.success('Solicitud Generada ');
                    $rootScope.cargandoInformacion--;
                    /* siguiente(); */
                } else {
                    toastr.error(response.mensaje);
                    $rootScope.cargandoInformacion--;
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al registrar la Solicitud.');
            });
        }
        /*
		 * function registrarSolicitud(){ debugger;
		 * if(vm.listaSolicitudesInstalacion!=null){
		 * 
		 * for(var i=0;i<vm.listaSolicitudesInstalacion.length;i++){
		 * vm.listaSolicitudesInstalacion[i].idAdministrado=vm.dataAdministrado.idAdministrado; } }
		 * 
		 * vm.dataSolicitud.lstInstalacion=vm.listaSolicitudesInstalacion;
		 * SolicitudFactory .registrar(vm.dataSolicitud) .then(function
		 * (response) { if(response.valido){ //vm.dataPedido.idPedido =
		 * response.data; /*vm.dataSolicitud = response.data;
		 */
        /*
		 * toastr.success('Se Registro Instalaciones');
		 * 
		 * 
		 * /*siguiente();
		 */
        /*
		 * } else{ toastr.error(response.mensaje); } }) .catch(function (error) {
		 * toastr.error('Ocurrió un error al registrar Problematica.'); }); }
		 */
        /*
		 * function registrar(){
		 * 
		 * InstalacionFactory .registrar(vm.dataInstalacion) .then(function
		 * (response) { if(response.valido){ //vm.dataPedido.idPedido =
		 * response.data; vm.dataInstalacion = response.data;
		 * 
		 * toastr.success('Denuncia registrada con codigo ' +
		 * vm.denuncia.codigoDenuncia); } else{ toastr.error(response.mensaje); } })
		 * .catch(function (error) { toastr.error('Ocurrió un error al registrar
		 * Problematica.'); }); }
		 * 
		 */
        /** ******************************************************** */
        function listarDepartamentoPersona() {
            UbigeoFactory.listarDepartamento(angular.copy(vm.dataUbigeo)).then(function(response) {
                if (response.valido) {
                    vm.listaDepartamentoPersona = response.data;
                    console.log("vm.listaDepartamentoPersona" + vm.listaDepartamentoPersona);
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                console.log("vm.dataPersona.idPersona" + vm.dataPersona.idPersona);
                if (vm.dataPersona.idPersona > 0 && vm.dataPersona.departamento != '00' && vm.dataPersona.departamento != '' && vm.dataPersona.departamento != null || vm.dataEntidad.idEntidad != 0) {
                    listarProvinciaPersona();
                }
            });
        }

        function listarProvinciaPersona() {
            /* vm.provincia.codigoDepartamento=vm.dataPersona.departamento; */
            UbigeoFactory.listarProvincia(angular.copy(vm.dataUbigeo)).then(function(response) {
                if (response.valido) {
                    vm.listaProvinciaPersona = response.data;
                    vm.listaDistritoPersona = [];
                    /*
					 * vm.listaDistritoPersona =
					 * [];vm.dataUbigeo.codigoProvincia =
					 * "";vm.dataUbigeo.codigoDistrito = "";
					 * console.log("vm.listaProvinciaPersona" +
					 * vm.listaProvinciaPersona);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.dataPersona.idPersona > 0 && vm.dataPersona.departamento != '00' && vm.dataPersona.departamento != '' && vm.dataPersona.departamento != null && vm.dataPersona.provincia != '00' && vm.dataPersona.provincia != '' && vm.dataPersona.provincia != null || vm.dataEntidad.idEntidad != 0) {
                    listarDistritoPersona();
                }
            });
        }

        function listarDistritoPersona() {
            /*
			 * vm.distrito.codigoDepartamento=vm.dataPersona.departamento;
			 * vm.distrito.codigoProvincia=vm.dataPersona.provincia;
			 */
            UbigeoFactory.listarDistrito(angular.copy(vm.dataUbigeo)).then(function(response) {
                if (response.valido) {
                    vm.listaDistritoPersona = response.data;
                    console.log("vm.listaDistritoPersona" + vm.listaDistritoPersona);
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }
        /** ******************************************************* */
        function listarDepartamento() {
            vm.listaDepartamento = [];
            UbigeoFactory.listarDepartamento(angular.copy(vm.departamento)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function listarProvincia() {
            vm.listaProvincia = [];
            vm.provincia.codigoDepartamento = vm.dataInstalacion.departamento.codigoDepartamento;
            UbigeoFactory.listarProvincia(angular.copy(vm.provincia)).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                    /*
					 * vm.listaProvincia= response.data;
					 * console.log("vm.listaProvincia" + vm.listaProvincia);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.dataInstalacion.provincia != null && vm.dataInstalacion.provincia.codigoProvincia != '') {
                    listarDistrito();
                }
            });
        }

        function listarDistrito() {
            console.log(vm.dataInstalacion);
            vm.listaDistrito = [];
            vm.distrito.codigoDepartamento = vm.dataInstalacion.departamento.codigoDepartamento;
            vm.distrito.codigoProvincia = vm.dataInstalacion.provincia.codigoProvincia;
            UbigeoFactory.listarDistrito(vm.distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                    /*
					 * vm.listaDistrito= response.data;
					 * console.log("vm.listaDistrito" + vm.listaDistrito);
					 */
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }
        /** ******************************PROBLEMATICA************************************** */
        function buscarPersonaXNumeroDocumento() {
            PersonaFactory.buscarXNumeroDocumento(angular.copy(vm.dataPersona)).then(function(response) {
                if (response.valido) {
                    vm.dataAdministrado = AdministradoFactory.model();
                    if (response.data.idPersona > 0) {
                        console.log(response.data);
                        console.log("vm.dataSolicitud");
                        console.log(vm.dataSolicitud);
                        vm.dataPersona = response.data;
                        // debugger;
                        vm.dataAdministrado.persona = vm.dataPersona;
                        /* listarDepartamentoPersona(); */
                        vm.flagActivoEdicionDatosPersona = 0;
                        vm.dataUbigeo.codigoDepartamento = vm.dataPersona.departamento;
                        vm.dataUbigeo.codigoProvincia = vm.dataPersona.provincia;
                        vm.dataUbigeo.codigoDistrito = vm.dataPersona.distrito;
                    }
                } else {
                    // toastr.error(response.mensaje);
                    dialogMensaje();
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                /* buscarDatosDelAdministrado(); */
                if (vm.dataPersona.idPersona > 0 && vm.dataPersona.departamento != '00' && vm.dataPersona.departamento != '' && vm.dataPersona.departamento != null) {
                    listarProvinciaPersona();
                    /* listarProvinciaPersona(); */
                }
                if (vm.dataPersona.idPersona > 0) {
                    validaSolicitudAcceso();
                }
            });
        }

        function buscarEntidadXNumeroDocumento() {
            EntidadFactory.buscarXEntidadNumeroDocumento(angular.copy(vm.dataEntidad)).then(function(response) {
                if (response.valido) {
                    vm.dataEntidad = response.data;
                    if (response.data.idEntidad > 0) {
                        vm.dataEntidad = response.data;
                        vm.dataAdministrado.entidad.idEntidad = response.data.idEntidad;
                        vm.dataUbigeo.codigoDepartamento = angular.copy(vm.dataEntidad.departamento);
                        vm.dataUbigeo.codigoProvincia = angular.copy(vm.dataEntidad.provincia);
                        vm.dataUbigeo.codigoDistrito = angular.copy(vm.dataEntidad.distrito);
                        UbigeoFactory.listarProvincia(angular.copy(vm.dataUbigeo)).then(function(response) {
                            if (response.valido) {
                                vm.listaProvinciaPersona = response.data;
                                console.log("vm.listaProvinciaPersona" + vm.listaProvinciaPersona);
                                /* vm.dataDenuncia.tipoPersona=0; */
                            } else {
                                toastr.error(response.mensaje);
                            }
                        }).catch(function(error) {
                            toastr.error('Error al consultar');
                        }).finally(function() {
                            UbigeoFactory.listarDistrito(angular.copy(vm.dataUbigeo)).then(function(response) {
                                if (response.valido) {
                                    vm.listaDistritoPersona = response.data;
                                    console.log("vm.listaDistritoPersona" + vm.listaDistritoPersona);
                                    /* vm.dataDenuncia.tipoPersona=0; */
                                } else {
                                    toastr.error(response.mensaje);
                                }
                            }).catch(function(error) {
                                toastr.error('Error al consultar');
                            }).finally(function() {});
                        });
                    }
                } else {
                    dialogMensaje();
                    // toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
                if (vm.dataEntidad.idEntidad > 0) {
                    validaSolicitudAcceso();
                }
            });
        }

        function validaSolicitudAcceso() {
            vm.dataAdministrado.tipoAdministrado = vm.dataUsuario.tipoPersona;
            AdministradoFactory.validarSolicitudAccesoAdministrado(angular.copy(vm.dataAdministrado)).then(function(response) {
                if (response.valido) {
                    console.log("vm.dataSolicitud x2");
                    console.log(vm.dataSolicitud);
                    if (response.data != null) {
                        toastr.success('Usted Tiene una solicitud Pendiente');
                        vm.dataSolicitud = angular.copy(response.data);
                        vm.dataAdministrado = angular.copy(vm.dataSolicitud.administrado);
                        vm.dataAdministrado.lstContactoAdministrado = angular.copy(vm.dataSolicitud.administrado.lstContactoAdministrado);
                        console.log("vm.dataAdministrado x33");
                        console.log(vm.dataAdministrado);
                        console.log("vm.dataSolicitud x4");
                        console.log(vm.dataSolicitud);
                        for (var x in vm.dataSolicitud.lstDetalleSolicitud) {
                            vm.listaSolicitudesInstalacion.push(angular.copy(vm.dataSolicitud.lstDetalleSolicitud[x].instalacion));
                        }
                    } else {
                        toastr.warning(response.mensaje);
                        vm.dataEntidad = EntidadFactory.model();
                        vm.dataPersona = PersonaFactory.model();
                        vm.dataUbigeo = UbigeoFactory.distrito();
                        vm.flagActivoEdicionDatosPersona = 0;
                    }
                    /*
					 * if(response.data != null){
					 * 
					 * vm.dataAdministrado = response.data;
					 * 
					 * console.log("vm.dataAdministrado",vm.dataAdministrado);
					 * 
					 * if(vm.dataAdministrado.estado == 2){
					 * toastr.warning('Administrado Aprobado, Porfavor Inicie
					 * Sesión'); }else{ listarSolicitudes(); } }
					 * 
					 */
                } else {}
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** **VALIDAR SI EL ADMINISTRADO ESTA EN ESTADO APROBADO** */
        function buscarDatosDelAdministrado() {
            vm.dataAdministrado.tipoAdministrado = 1;
            AdministradoFactory.buscarxid(angular.copy(vm.dataAdministrado)).then(function(response) {
                if (response.valido) {
                    if (response.data != null) {
                        vm.dataAdministrado = response.data;
                        // console.log(vm.dataAdministrado);
                        console.log("vm.dataAdministrado", vm.dataAdministrado);
                        if (vm.dataAdministrado.estado == 2) {
                            toastr.warning('Administrado Aprobado, Porfavor Inicie Sesión');
                        } else {
                            listarSolicitudes();
                        }
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        /** **TRAER LA SOLICITUD DEL ADMINISTRADO SI AUN NO AH SIDO APROBADO*** */
        function listarSolicitudes() {
            vm.listaSolicitudes = [];
            vm.datafiltroSolicitudes.documento = vm.dataPersona.documento;
            console.log("vm.datafiltroSolicitudes", vm.datafiltroSolicitudes);
            SolicitudesFactory.listar(angular.copy(vm.datafiltroSolicitudes)).then(function(response) {
                if (response.valido) {
                    vm.listaSolicitudes = response.data;
                    console.log("vm.listaSolicitudes", vm.listaSolicitudes);
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            }).finally(function() {
                /*
				 * if(vm.listaSolicitudes.length > 0){
				 * listarDetalleSolicitudes(); }
				 */
            });
        }

        function listarDetalleSolicitudes() {
            vm.listaDetalleSolicitud = [];
            var data = {
                solicitud: {
                    idSolicitud: vm.dataSolicitud.idSolicitud,
                }
            };
            console.log("data", data)
            SolicitudFactory.listarDetalleSolicitud(angular.copy(data)).then(function(response) {
                if (response.valido) {
                    vm.dataSolicitud.lstDetalleSolicitud = response.data;
                    vm.listaSolicitudesInstalacion = [];
                    for (var x in vm.dataSolicitud.lstDetalleSolicitud) {
                        vm.listaSolicitudesInstalacion.push(angular.copy(vm.dataSolicitud.lstDetalleSolicitud[x].instalacion));
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo listar Los Titulos.');
            }).finally(function() {});
        }
        /** ******************************************************************************** */
        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function valorTelefono(valor) {
            var item = angular.element('#txtTelefono').val();
            if (item.length >= 13) {
                vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{4})[ .-]?(\d{3,5})$/;
            } else {
                var letra = angular.copy(item.substr(0, 1));
                console.log(letra);
                var array = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                var esNumeroInicial = false;
                console.log(esNumeroInicial);
                for (var i = 0; i < array.length; i++) {
                    if (array[i] === letra) {
                        esNumeroInicial = true;
                        break;
                    }
                }
                console.log("esNumeroInicial");
                console.log(esNumeroInicial);
                if (esNumeroInicial) {
                    vm.validarTelefono = /^(\d{7,9})$/;
                } else {
                    vm.validarTelefono = /^\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{3,4})$/;
                }
            }
        }

        function dialogMensaje() {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm-registro/dialog-mensaje-registro.html',
                controller: 'DialogMensajeRegistroController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Persona no encontrada',
                    Mensaje: 'El servicio no se encuentra disponible, desea registrar manualmente.',
                    tituloBtnRegistrar: "Si"
                },
                width: '380px'
            }).finally(function() {
                if ($rootScope.tipoOperacionRegistro == 2) {
                    $rootScope.tipoOperacionRegistro = 0;
                    vm.flagRegistrarPersona = 1;
                }
            });
        }

        function registrarPersonaOEntidad() {
            debugger;
            if (vm.dataUsuario.tipoDocumento == 1) {
                vm.dataPersona.departamento = vm.dataUbigeo.codigoDepartamento;
                vm.dataPersona.provincia = vm.dataUbigeo.codigoProvincia;
                vm.dataPersona.distrito = vm.dataUbigeo.codigoDistrito;
                if ((vm.dataPersona.nombres == null || vm.dataPersona.nombres.length < 1) || vm.dataPersona.apellidoPaterno.length < 1 || vm.dataPersona.apellidoMaterno.length < 1 || (vm.dataPersona.departamento == null || vm.dataPersona.departamento.length < 1) || (vm.dataPersona.provincia == null || vm.dataPersona.provincia.length < 1) || (vm.dataPersona.distrito == null || vm.dataPersona.distrito.length < 1) || vm.dataPersona.direccion.length < 1) {
                    toastr.warning('Debe completar todos los campos obligatorios');
                    return;
                }
                registrarPersonaOefa();
            } else {
                vm.dataEntidad.departamento = vm.dataUbigeo.codigoDepartamento;
                vm.dataEntidad.provincia = vm.dataUbigeo.codigoProvincia;
                vm.dataEntidad.distrito = vm.dataUbigeo.codigoDistrito;
                if ((vm.dataEntidad.razonSocial == null || vm.dataEntidad.razonSocial.length < 1) || (vm.dataEntidad.departamento == null || vm.dataEntidad.departamento.length < 1) || (vm.dataEntidad.provincia == null || vm.dataEntidad.provincia.length < 1) || (vm.dataEntidad.distrito == null || vm.dataEntidad.distrito.length < 1) || vm.dataEntidad.direccion.length < 1 || (vm.flagAgregarRepresentanteLegal == 1 && (vm.dataEntidad.representanteLegal.idPersona == null || vm.dataEntidad.representanteLegal.idPersona == 0 || vm.dataEntidad.nomCargo == null || vm.dataEntidad.nomCargo.length == 0))) {
                    toastr.warning('Debe completar todos los campos obligatorios');
                    return;
                }
                registrarEntidadOefa();
            }
        }

        function registrarEntidadOefa() {
            EntidadFactory.registrarEntidadOefa(vm.dataEntidad).then(function(response) {
                if (response.valido) {
                    toastr.success('Se registro correctamente.');
                    vm.flagRegistrarPersona = 0;
                    vm.flagAgregarRepresentanteLegal == 0;
                    buscarEntidadXNumeroDocumento();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function registrarPersonaOefa() {
            PersonaFactory.registrarPersonaOefa(angular.copy(vm.dataPersona)).then(function(response) {
                if (response.valido) {
                    toastr.success('Se registro correctamente.');
                    vm.flagRegistrarPersona = 0;
                    buscarPersonaXNumeroDocumento();
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function buscarRepresentanteLegal() {
            PersonaFactory.buscarXNumeroDocumento(angular.copy(vm.dataEntidad.representanteLegal)).then(function(response) {
                if (response.valido) {
                    if (response.data.idPersona > 0) {
                        vm.dataEntidad.representanteLegal = angular.copy(response.data);
                    }
                } else {
                    toastr.warning('No se encontro a la persona');
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {});
        }

        function limpiarRepresentanteLegal() {
            vm.dataEntidad.representanteLegal = {};
        }
        /* fin de implementacion de metodos */
        function init() {
            vm.validarTelefono = /^\(?(\d{2})\)?[ .-]?(\d{3})[ .-]?(\d{4})$/;
            obtenerParametros();
            vm.dataUsuario.tipoPersona = 2;
            vm.dataUsuario.tipoDocumento = '2';
            listarDepartamento();
            listarDepartamentoPersona();
            cargarCombos();
            listarSector();
        }
        init();
        /* fin de controller */
    }
})();
(function() {
	'use strict';
	angular.module('spapp.acceso').controller(
			'AccesoRegistroContactoController',
			AccesoRegistroContactoController);
	/* @ngInject */
	function AccesoRegistroContactoController(INTERNAL_HOME_PAGE, $scope,
			$state, $rootScope, ContactoAdministradoFactory, MaestroFactory,
			toastr, ngDialog, PersonaFactory, EntidadFactory, UbigeoFactory,
			InstalacionFactory, SolicitudFactory, AdministradoFactory,
			SolicitudesFactory, UsuarioFactory) {
		var vm = this;
		vm.guardarContacto = guardarContacto;
		vm.prmContacto = ContactoAdministradoFactory.model();
		vm.dataSolicitud = SolicitudFactory.model();
		vm.cerrar = cerrar;
		vm.mimeTypes = [];
	    vm.extension = "";
	    vm.tamanioArchivo = "500";
	    vm.caracteresMaximoArchivo = 50;
	    vm.listaArchivos = [];
	    vm.validaDocumento = validaDocumento;
		
		function cerrar(){
			ngDialog.close();
		}
		
		
		function guardarContacto(){
			 vm.dataSolicitud = $rootScope.dataSolicitud;
			 if (vm.dataSolicitud.administrado != null && vm.dataSolicitud.administrado.idAdministrado != 0) {
				if (vm.prmContacto.idContactoAdministrado == 0){
					// Registramos contacto
					registrarContactoAdministrado(vm.prmContacto);
				}
				else{
					// Actualizamos conntroller
					actualizarContactoAdministrado(vm.prmContacto);
				}
				ngDialog.close();
			 } else {
				 	UsuarioFactory.contarCorreoUsuario(angular.copy(vm.prmContacto)).then(function(response) {
			            if (response != null && response.valido) {
			            	if (response.data == 0){
			            		 $rootScope.dataContactoAdministrado =angular.copy(vm.prmContacto);
			            		 $rootScope.dataContactoArchivo = vm.listaArchivos;
			            		 ngDialog.close();
			            	}
			            	else{
			            		toastr.error('El correo ingresado ya está registrado en el sistema.');
			            	}
			            }
		            }).catch(function(error) {
		                toastr.error('No se pudo obtener la consulta de correos.');
		            });
				  
				    
			 }
			 
		}
			
		   function registrarContactoAdministrado(data) {
	            data.idAdministrado = vm.dataSolicitud.administrado.idAdministrado;
	            ContactoAdministradoFactory.registrar(angular.copy(data)).then(function(response) {
	                if (response != null && response.valido) {
	                    toastr.success('Contacto Registrado Correctamente.');
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los datos para los combos.');
	            });
	        }
		   
		   function actualizarContactoAdministrado(data) {
	            ContactoAdministradoFactory.actualizar(angular.copy(data)).then(function(response) {
	                if (response != null && response.valido) {
	                    toastr.success('Contacto Actualizado Correctamente.');
	                }
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los datos para los combos.');
	            });
	        }
		   
		   function obtenerParametros() {
	            MaestroFactory.obtenerParametros().then(function(response) {
	                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
	                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
	                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
	                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
	                vm.mimeTypes = angular.copy(tipos.split(","));
	            }).catch(function(error) {
	                toastr.error('No se pudo obtener los parametros.');
	            });
	        }
		   
		   function validaDocumento(prmFileList) {
	            var lstExtens = vm.extension.split(",");
	            
	                if (!prmFileList) {
	                    toastr.warning('Debe seleccionar un Archivo');
	                    return;
	                }
	                var archivo = prmFileList[0];
	                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
	                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
	                    document.getElementById("fileArchivo").value = "";
	                    return;
	                }
	                var str = archivo.name;
	                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
	                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
	                    toastr.warning('El archivo seleccionado no esta permitido');
	                    document.getElementById("fileArchivo").value = "";
	                    return;
	                }
	                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
	                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
	                    document.getElementById("fileArchivo").value = "";
	                    return;
	                }
	                
	                vm.prmContacto.nombreArchivo = prmFileList[0].name;
	                
	                vm.listaArchivos.push(prmFileList[0]);
	                
	                // habilitamos el boton dependiendo de otras condiciones
	             	if(vm.prmContacto.nombres != null && vm.prmContacto.nombres != '' && vm.prmContacto.cargo != null && vm.prmContacto.cargo != ''  && vm.prmContacto.valor != null && vm.prmContacto.valor != '' 
	                	&& vm.prmContacto.telefono != null && vm.prmContacto.telefono != ''){
	                	document.getElementById("btnGrabar").disabled = false;
	                }
	               
	        }
		   
			
		function init() {
			  if ($rootScope.itemContacto.flagActivo != "") {
                  vm.prmContacto = $rootScope.itemContacto;
              }
        	  else{
        		  vm.prmContacto = ContactoAdministradoFactory.model();
        		  vm.prmContacto.tipoContacto.codigoRegistro = "2";
        		  vm.prmContacto.estado.codigoRegistro = "1";
        		  vm.prmContacto.flagActivo = "1";
        	  }
			  obtenerParametros();
		}
		init();
		/* fin de controller */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.acceso').controller('AccesoInicioController', AccesoInicioController);
    /** @ngInject */
    function AccesoInicioController($state, ngDialog, API_CONFIG) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Primer Tab por defecto
        /*declaración de metodos enlazados a la vista*/
        vm.rutaBase = API_CONFIG.url;
        vm.rutaSSO = API_CONFIG.urlSSO;
        vm.mostrarModalContenido = mostrarModalContenido;
        vm.irARegistroDenuncia = irARegistroDenuncia;
        vm.iraLogin = iraLogin;
        /*implementación de metodos*/
        function iraLogin() {
            // http://200.37.65.227/OEFA.STS2
            $window.location.href = vm.rutaSSO + "/Home/Index?wa=wsignin1.0&wtrealm=" + vm.rutaBase + "seguridad/index/&wctx=rm=2&id=pluralsoft&ru=" + vm.rutaBase + "seguridad/confirmsso&wreply=" + vm.rutaBase + "seguridad/confirmsso";
        }

        function mostrarModalContenido() {
            ngDialog.open({
                template: 'app/modules/invitado/listado/dialog/validacion-invitado-denuncia-list-dialog.html',
                controller: 'ValidacionInvitadoDenunciasListDialogController',
                data: {},
                controllerAs: 'vm',
                width: '550px'
            }).closePromise.then(function(dataDialog) {
                /*if (dataDialog.value.cliente) {
                	vm.dataPedido.cliente = angular.copy(dataDialog.value.cliente);
                }*/
            });
        }

        function irARegistroDenuncia() {
            $state.go('invitado.registro.paso1');
        }
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('DialogMensajeRegistroController', DialogMensajeRegistroController);
    /** @ngInject */
    function DialogMensajeRegistroController($rootScope, ngDialog, $scope) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.titulo = null;
        vm.mensaje = null;
        vm.tituloBtnRegistrar = "";
        $rootScope.tipoOperacionRegistro = 0;
        vm.operacion = operacion;
        /*declaración de métodos enlazados a la vista*/
        function operacion(item) {
            $rootScope.tipoOperacionRegistro = item;
            ngDialog.close();
        }
        /*implementación de métodos*/
        function init() {
            if (angular.isDefined($scope.ngDialogData)) {
                vm.titulo = angular.copy($scope.ngDialogData.Titulo);
                vm.mensaje = angular.copy($scope.ngDialogData.Mensaje);
                if (angular.isDefined($scope.ngDialogData.tituloBtnRegistrar)) {
                    vm.tituloBtnRegistrar = angular.copy($scope.ngDialogData.tituloBtnRegistrar);
                }
            }
        }
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('DialogInfoController', DialogInfoController);
    /** @ngInject */
    function DialogInfoController(ngDialog, $scope) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.titulo = null;
        vm.mensaje = null;
        /*declaración de métodos enlazados a la vista*/
        /*implementación de métodos*/
        function init() {
            if (angular.isDefined($scope.ngDialogData)) {
                vm.titulo = angular.copy($scope.ngDialogData.Titulo);
                vm.mensaje = angular.copy($scope.ngDialogData.Mensaje);
            }
        }
        init();
    }
})();
(function() {
	'use strict';

	angular
	.module('spapp')
	.controller('DialogConfirmController',DialogConfirmController);


	/** @ngInject */
	function DialogConfirmController(ngDialog, $scope) {
		var vm = this;
		
		/*declaracion de variables globales*/
		vm.titulo = null;
		vm.mensaje = null;
		vm.mensajeadicional = null;
		/*declaración de métodos enlazados a la vista*/
			
		

		/*implementación de métodos*/
		
		function init() {
			
			if (angular.isDefined($scope.ngDialogData)) {
				vm.titulo = angular.copy($scope.ngDialogData.Titulo);
				vm.mensaje = angular.copy($scope.ngDialogData.Mensaje);
				vm.mensajeadicional = angular.copy($scope.ngDialogData.Mensajeadicional);
//				if(vm.mensajeadicional != null){
//					document.getElementById("msjAdicional").innerHTML = vm.mensajeadicional;
//				}
			}
		}

		init();
	}
})();
(function() {
	'use strict';

	angular
	.module('spapp')
	.config(config);

	/** @ngInject  */
	function config(toastrConfig) {
		
		/*
	    toastrConfig.allowHtml = true;
	    toastrConfig.timeOut = 3000;
	    toastrConfig.positionClass = 'toast-top-right';
	    toastrConfig.preventDuplicates = true;
	    toastrConfig.progressBar = true;
	    */
	    var options = {
			closeButton: false,
			debug: false,
			newestOnTop: false,
			progressBar: true,
			positionClass: 'toast-top-right',
			preventDuplicates: false,
			onclick: null,
			showDuration: 300,
			hideDuration: 1000,
			timeOut: 3000,
			extendedTimeOut: 1000,
			showEasing: 'swing',
			hideEasing: 'linear',
			showMethod: 'fadeIn',
			hideMethod: 'fadeOut'
		};

		angular.extend(toastrConfig, options);
		
	}

})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.config(config);

	/* @ngInject */
	function config(ngDialogProvider) {
		
		ngDialogProvider.setDefaults({
		    className: 'ngdialog-theme-app',
		    closeByDocument: false
		});
	}
})();
(function() {
    'use strict';
    angular.module('spapp.usuario').config(routeConfig);
    /* @ngInject */
    function routeConfig($stateProvider) {
        /*inicio de route*/
        $stateProvider.state('spapp.home.usuarios', {
            url: '/usuarios',
            templateUrl: 'app/modules/usuario/usuario.html',
            controller: 'UsuarioController',
            controllerAs: 'vm'
        }).state('spapp.home.usuarios.listado', {
            url: '/listado',
            templateUrl: 'app/modules/usuario/listado/usuario-listado.html',
            controller: 'UsuarioListadoController',
            controllerAs: 'vm'
        }).state('spapp.home.usuarios.registro', {
            url: '/registro',
            templateUrl: 'app/modules/usuario/registro/usuario-registro.html',
            controller: 'UsuarioRegistroController',
            controllerAs: 'vm'
        });
        /*fin de route*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.usuario').controller('UsuarioController', UsuarioController);
    /** @ngInject */
    function UsuarioController($state, INTERNAL_HOME_PAGE) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Primer Tab por defecto
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        /*fin de metodos*/
    }
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.config(appPaginationTemplateProvider);

	function appPaginationTemplateProvider(paginationTemplateProvider) {
		
		paginationTemplateProvider.setPath('app/third-party/angularUtils-pagination/dirPagination.tpl.html');
	}
})();
(function() {
	'use strict';
	angular.module('spapp.tipoiga').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider.state('spapp.home.tipoiga', {
			url : '/tipoigas',
			templateUrl : 'app/modules/tipoiga/tipoiga.html',
			controller : 'TipoIgaController',
			controllerAs : 'vm'
		}).state('spapp.home.tipoiga.listado', {
			url : '/listado',
			templateUrl : 'app/modules/tipoiga/listado/tipoiga-listado.html',
			controller : 'TipoIgaListadoController',
			controllerAs : 'vm'
		});
		/* fin de route */
	}
})();
(function() {
	'use strict';
	angular.module('spapp.tipoiga')
			.controller('TipoIgaController', TipoIgaController);
	/* @ngInject */
	function TipoIgaController($state, AccesoFactory, $rootScope, $log, toastr,
			$location) {
		var vm = this;
	}
})();
(function() {
	'use strict';
	angular.module('spapp.supervision').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider
				.state('spapp.home.supervision', {
					url : '/supervision',
					templateUrl : 'app/modules/supervision/supervision.html',
					controller : 'SupervisionController',
					controllerAs : 'vm'
				})
				.state(
						'spapp.home.supervision.online',
						{
							url : '/online',
							templateUrl : 'app/modules/supervision/online/listado-supervicion-online.html',
							controller : 'ListadoSupervicionOnlineController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-presentacion',
						{
							url : '/instalacion-presentacion',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-presentacion.html',
							controller : 'InstalacionPresentacionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-presentacion',
						{
							url : '/cargainfo-presentacion',
							templateUrl : 'app/modules/supervision/online/presentacion/presentacion.html',
							controller : 'PresentacionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.administrado',
						{
							url : '/administrado',
							templateUrl : 'app/modules/supervision/administrado/administrado-supervicion-online.html',
							controller : 'administradoSupervicionOnlineController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.resultados',
						{
							url : '/resultado',
							templateUrl : 'app/modules/supervision/resultados/resultados-reporte.html',
							controller : 'ResultadosReporteController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.accion-administrado',
						{
							url : '/accion-administrado',
							templateUrl : 'app/modules/supervision/administrado/accion-administrado/accion-administrado.html',
							controller : 'AccionAdministradoController',
							controllerAs : 'vm'

						})
				.state(
						'spapp.home.supervision.instrumento-gestion',
						{
							url : '/instrumento-gestion',
							templateUrl : 'app/modules/supervision/iga/instrumento-gestion.html',
							controller : 'InstrumentoGestionController',
							controllerAs : 'vm'

						})
				.state(
						'spapp.home.supervision.accion-administrado-informe',
						{
							url : '/accion-administrado-informe',
							templateUrl : 'app/modules/supervision/administrado/accion-administrado/accion-administrado-informe.html',
							controller : 'AccionAdministradoInformeController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.accion-instalacion',
						{
							url : '/accion-instalacion',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/accion-instalacion.html',
							controller : 'AccionInstalacionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-instrumento',
						{
							url : '/instalacion-instrumento',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-instrumento-gestion.html',
							controller : 'InstalacionInstrumentoGestionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-declaracion',
						{
							url : '/instalacion-declaracion',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-declaracion.html',
							controller : 'InstalacionDeclaracionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-informe-instrumento',
						{
							url : '/instalacion-informe-instrumento',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-informe-instrumento.html',
							controller : 'InstalacionInformeInstrumentoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-informe',
						{
							url : '/instalacion-informe',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-informe-monitoreo.html',
							controller : 'InstalacionInformeMonitoreoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.accion-administrado-residuos',
						{
							url : '/accion-administrado-residuos',
							templateUrl : 'app/modules/supervision/administrado/accion-administrado/accion-administrado-residuos.html',
							controller : 'AccionAdministradoResiduoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.autosupervision-online',
						{
							url : '/autosupervision-online',
							templateUrl : 'app/modules/supervision/online/autosupervision-online/autosupervision-online.html',
							controller : 'AutosupervisionOnlineController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.solicitudes',
						{
							url : '/solicitud-administrado',
							templateUrl : 'app/modules/supervision/solicitud-administrado/solicitud-administrado.html',
							controller : 'SolicitudAdministradoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cuestionario-autosupervision',
						{
							url : '/autosupervision',
							templateUrl : 'app/modules/supervision/administrado/cuestionarios-autosupervision/cuestionarios-instalacion.html',
							controller : 'CuestionariosInstalacionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-instalacion',
						{
							url : '/cargainfo-instalacion',
							templateUrl : 'app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion.html',
							controller : 'CargaInfoInstalacionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-instrumento',
						{
							url : '/cargainfo-instrumento',
							templateUrl : 'app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion.html',
							controller : 'CargaInfoInstrumentoGestionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-declaracion',
						{
							url : '/cargainfo-accion-administrado',
							templateUrl : 'app/modules/supervision/cargainformacion/declaracion/cargainfo-accion-administrado.html',
							controller : 'CargaInfoAccionAdministradoController',
							controllerAs : 'vm'
						})

				.state(
						'spapp.home.supervision.cargainfo-informe-monitoreo',
						{
							url : '/cargainfo-informe-monitoreo',
							templateUrl : 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo.html',
							controller : 'CargaInfoInformeMonitoreoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-informe-instrumento',
						{
							url : '/cargainfo-informe-instrumento',
							templateUrl : 'app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-instrumento.html',
							controller : 'CargaInfoInformeInstrumentoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.reporte-control-calidad',
						{
							url : '/reporte-control-calidad',
							templateUrl : 'app/modules/reporte/reporte-control-calidad/reporte-control-calidad.html',
							controller : 'ReporteControlCalidadController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.reporte-supervision',
						{
							url : '/reporte-supervision',
							templateUrl : 'app/modules/reporte/reporte-supervision/reporte-supervision.html',
							controller : 'ReporteSupervisionController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.reporte-preliminar',
						{
							url : '/reporte-preliminar',
							templateUrl : 'app/modules/reporte/reporte-preliminar/reporte-preliminar.html',
							controller : 'ReportePreliminarController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.informes',
						{
							url : '/informes',
							templateUrl : 'app/modules/informe/informe-presentacion.html',
							controller : 'InformesController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-residuos-declaracion',
						{
							url : '/cargainfo-residuos-declaracion',
							templateUrl : 'app/modules/residuos/declaracion_anual_residuos.html',
							controller : 'DeclaracionResiduosController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-residuos-declaracion',
						{
							url : '/instalacion-residuos-declaracion',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-declaracion_anual_residuos.html',
							controller : 'InstalacionDeclaracionResiduosController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.cargainfo-residuos-manifiesto',
						{
							url : '/cargainfo-residuos-manifiesto',
							templateUrl : 'app/modules/residuos/manifiesto_residuos.html',
							controller : 'ManifiestoResiduosController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.supervision.instalacion-residuos-manifiesto',
						{
							url : '/instalacion-residuos-manifiesto',
							templateUrl : 'app/modules/supervision/instalacion/accion-instalacion/instalacion-manifiesto_residuos.html',
							controller : 'InstalacionManifiestoResiduosController',
							controllerAs : 'vm'
						});

		/*
		 * .state('spapp.home.acciones',{ url : '/acciones', templateUrl :
		 * 'app/modules/acciones/acciones.html', controller :
		 * 'AccionesController', controllerAs : 'vm' })
		 * .state('spapp.home.acciones.denunciante',{ url : '/denunciante',
		 * templateUrl : 'app/modules/acciones/revisarEfa/revisarEfa.html',
		 * controller : 'RevisarEfaController', controllerAs : 'vm' });
		 */
		/* fin de route */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('SupervisionController', SupervisionController);
    /** @ngInject */
    function SupervisionController($state, INTERNAL_HOME_PAGE, AccesoFactory, $rootScope, $log, toastr, $location) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Primer Tab por defecto
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        function leerOperaciones(ref) {
            AccesoFactory.operaciones(ref, "Inf. Unidades Fiscalizables").then(function(response) {
                $rootScope.sisoOperacioneswkWeb = response; //angular.toJson(response);
                //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                $rootScope.sisoValidaOperacionesWbUvk = sisoValidaOperacionesWbUvk;
            }).catch(function(error) {
                toastr.error(error);
            });
        }

        function sisoValidaOperacionesWbUvk(operacion) {
            for (var int = 0; int < $rootScope.sisoOperacioneswkWeb.length; int++) {
                var oOperacion = $rootScope.sisoOperacioneswkWeb[int];
                if (oOperacion.elemento == operacion) {
                    return true;
                }
            }
            return false;
        }
        if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
            leerOperaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq));
            $rootScope.kqlRefRootSiso = angular.copy(localStorage.objlocalStRefSisoplkijsq);
        } else {
            leerOperaciones($rootScope.kqlRefRootSiso);
        }
        /*fin de metodos*/
    }
})();
(function() {
	'use strict';
	angular.module('spapp.seguridad').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider
				.state('spapp.home.seguridad', {
					url : '/seguridad',
					templateUrl : 'app/modules/seguridad/seguridad.html',
					controller : 'SeguridadController',
					controllerAs : 'vm'
				})
				.state(
						'spapp.home.seguridad.usuarios',
						{
							url : '/usuarios',
							templateUrl : 'app/modules/seguridad/usuarios/registro/usuarios-registro.html',
							controller : 'UsuariosRegistroController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.seguridad.configuraciones',
						{
							url : '/configuraciones',
							templateUrl : 'app/modules/seguridad/configuraciones/configuracion.html',
							controller : 'ConfiguracionController',
							controllerAs : 'vm'
						})
				/*
				 * .state('spapp.home.seguridad.denunciante',{ url :
				 * '/listado-denunciante', templateUrl :
				 * 'app/modules/seguridad/usuarios/listado/denunciante/usuariosdenunciante-listado.html',
				 * controller : 'UsuariosDenuncianteListadoController',
				 * controllerAs : 'vm' })
				 * 
				 * .state('spapp.home.seguridad.oefa',{ url : '/listado-oefa',
				 * templateUrl :
				 * 'app/modules/seguridad/usuarios/listado/oefa/usuariosoefa-listado.html',
				 * controller : 'UsuariosOefaListadoController', controllerAs :
				 * 'vm' })
				 */
				.state(
						'spapp.home.seguridad.clave',
						{
							url : '/clave',
							templateUrl : 'app/modules/seguridad/usuarios/cambioclave/cambio-clave.html',
							controller : 'UsuarioListadoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.seguridad.perfiles',
						{
							url : '/perfiles',
							templateUrl : 'app/modules/seguridad/perfiles/perfil-registro.html',
							controller : 'PerfilRegistroController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.seguridad.listado',
						{
							url : '/listado',
							templateUrl : 'app/modules/seguridad/usuarios/listado/usuario-listado.html',
							controller : 'UsuarioListadoController',
							controllerAs : 'vm'
						})
				.state(
						'spapp.home.seguridad.usuario-ubigeo',
						{
							url : '/usuario-ubigeo',
							templateUrl : 'app/modules/seguridad/usuarios-ubigeo/usuario-ubigeo-listado.html',
							controller : 'UsuarioUbigeoController',
							controllerAs : 'vm'
						});

		/*
		 * .state('spapp.home.seguridad.sinada',{ url : '/listado-sinada',
		 * templateUrl :
		 * 'app/modules/seguridad/usuarios/listado/sinada/usuariossinada-listado.html',
		 * controller : 'UsuariosSinadaListadoController', controllerAs : 'vm'
		 * });
		 */
		/* fin de route */
	}
})();
(function() {
    'use strict';
    angular.module('spapp.seguridad').controller('SeguridadController', SeguridadController);
    /** @ngInject */
    function SeguridadController($state, INTERNAL_HOME_PAGE) {
        var vm = this;
        /*declaracion de variables globales*/
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        /*fin de metodos*/
        function init() {
            // body...
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('ManifiestoResiduosEdicionController', ManifiestoResiduosEdicionController);
    /* @ngInject */
    function ManifiestoResiduosEdicionController(ngDialog, API_CONFIG,toastr, $scope, $rootScope,MaestroFactory,EorFactory , AccesoFactory,EntidadFactory, ResiduoFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };

        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];

        vm.tieneResiduosTransporte = tieneResiduosTransporte;
        vm.tieneResTransporte = false;
        vm.tieneResiduosDisposicion = tieneResiduosDisposicion;
        vm.tieneResDisposicion = false;

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        vm.prmResiduo = ResiduoFactory.model();
        vm.dataResiduoCarac = ResiduoFactory.modelCaracteristica();
        vm.dataResiduoTrans = ResiduoFactory.modelTransporte();
        vm.dataResiduoDispo = ResiduoFactory.modelDisposicion();
        vm.lstUnidadMedida = [];
        vm.lstPeligrosidad = [];
        /* declaración de metodos enlazados a la vista */
        vm.guardar = guardar;
        vm.agregarResiduoCaracteristica = agregarResiduoCaracteristica;
        vm.agregarResiduoTransporte = agregarResiduoTransporte;
        vm.agregarResiduoDisposicion = agregarResiduoDisposicion;
        vm.eliminarResiduoCaracteristica = eliminarResiduoCaracteristica;
        vm.eliminarResiduoTransporte = eliminarResiduoTransporte;
        vm.eliminarResiduoDisposicion = eliminarResiduoDisposicion;

        vm.confirmarEliminacionCarac = confirmarEliminacionCarac;
        vm.confirmarEliminacionTrans = confirmarEliminacionTrans;
        vm.confirmarEliminacionDispo = confirmarEliminacionDispo;
        vm.validaDocumento = validaDocumento;
        vm.cancelar = cancelar;
        vm.validarRuc = validarRuc;
        vm.obtenerEor = obtenerEor;
        vm.refrescar = refrescar;
        vm.cantSemisolido = 0;
        vm.cantSolido = 0;
        vm.accesos = [];
        vm.blEditar = false;

        function cancelar(){
        	 ngDialog.close();
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function guardar() {
            if (vm.prmResiduo.idresiduo == 0) {
            	confirmarGuardar();
            } else {
            	actualizar();
            }
        }

        function confirmarGuardar() {
        	getMensajeDeclaracionJurada();
        	console.log(vm.mensajeDeclaracionJurada);
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Declaración Jurada',
                    Mensaje: vm.mensajeDeclaracionJurada
                },
                width: '380px'
            }).then(function(okValue) {
            	validar();
            });
        }

        function validar(){
        	var lstResiduos = [];
        	var filResiduo = ResiduoFactory.model() ;
        	filResiduo.tipo = "MR";
        	filResiduo.periodo = vm.prmResiduo.periodo;
        	filResiduo.numero_frecuencia = vm.prmResiduo.numero_frecuencia;
        	filResiduo.idInstalacion = vm.prmResiduo.idInstalacion;
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ResiduoFactory.listar(angular.copy(filResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    lstResiduos = angular.copy(response.data);
                    if(lstResiduos.length>0){
                    	 toastr.error('Periodo ya declarado.');
                    	return false;
                    }
                    else{
                    	 registrar();
                    }
                }
                else{
                	 registrar();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });

        }


        function registrar() {
        	vm.prmResiduo.prm1= CookiesFactory.obtenerCookie();
        	//vm.prmResiduo.fechapresentacion = new Date();
        	vm.prmResiduo.tipo = "MR";
        	// por cada check seleccionado de peligrosidad guardamos los códigos
			// del maestro
        	if(vm.prmResiduo.lstCaracteristicas.length> 0){
        		for(var x in vm.prmResiduo.lstCaracteristicas){
        			if(vm.prmResiduo.lstCaracteristicas[x].isReactividad){
        				vm.prmResiduo.lstCaracteristicas[x].flgReactividad = 'S';
        			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isToxicidad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgToxicidad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isAutocombustibilidad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgAutocombustibilidad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isExplosividad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgExplosividad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isRadiactividad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgRadiactividad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isPatogenisidad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgPatogenisidad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isCorrosividad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgCorrosividad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isOtros){
	    				vm.prmResiduo.lstCaracteristicas[x].flgOtros = 'S';
	    			}
        		}
        	}

        	ResiduoFactory.registrar(vm.listaArchivos,angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
                else{
                	 toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo grabar la información.');
            });

        }

        function actualizar() {
        	vm.prmResiduo.prm1= CookiesFactory.obtenerCookie();
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	if(vm.prmResiduo.lstCaracteristicas.length> 0){
        		for(var x in vm.prmResiduo.lstCaracteristicas){
        			if(vm.prmResiduo.lstCaracteristicas[x].isReactividad){
        				vm.prmResiduo.lstCaracteristicas[x].flgReactividad = 'S';
        			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isToxicidad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgToxicidad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isAutocombustibilidad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgAutocombustibilidad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isExplosividad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgExplosividad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isRadiactividad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgRadiactividad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isPatogenisidad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgPatogenisidad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isCorrosividad){
	    				vm.prmResiduo.lstCaracteristicas[x].flgCorrosividad = 'S';
	    			}
	        		if(vm.prmResiduo.lstCaracteristicas[x].isOtros){
	    				vm.prmResiduo.lstCaracteristicas[x].flgOtros = 'S';
	    			}
        		}
        	}
        	
        	ResiduoFactory.actualizar(vm.listaArchivos,angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        // ya no se utiliza
        function agregarResiduoCaracteristica(estado){
        	
        		vm.dataResiduoCarac.secuencia = vm.prmResiduo.lstCaracteristicas[vm.prmResiduo.lstCaracteristicas.length-1].secuencia + 1;
        		vm.dataResiduoCarac.estadoResiduo = estado;
        		vm.prmResiduo.lstCaracteristicas.push(angular.copy(vm.dataResiduoCarac));
        		vm.cantSolido = vm.cantSolido + (estado==1? 1:0 );
        		vm.cantSemisolido = vm.cantSemisolido + (estado==2? 1:0);
       		    
        	vm.dataResiduoCarac = ResiduoFactory.modelCaracteristica();
        }
        
        function eliminarResiduoCaracteristica(dataCaracteristica){
//        	if( vm.prmResiduo.idresiduo !=0){
//       		    ResiduoFactory.eliminarResiduoCaracteristica(angular.copy(dataCaracteristica)).then(function(response) {
//                    if (response != null && response.valido) {
//                   	 cargarResiduoCaracteristica();
//                    }
//                }).catch(function(error) {
//                    toastr.error('No se pudo grabar la información.');
//                });
//        	}
//        	else{
        		if(vm.prmResiduo.lstCaracteristicas.length>0){
            		for(var y in vm.prmResiduo.lstCaracteristicas){
            			if( vm.prmResiduo.lstCaracteristicas[y].secuencia == dataCaracteristica.secuencia){
            				vm.prmResiduo.lstCaracteristicas.splice(y,1);
            				vm.cantSolido = vm.cantSolido - (dataCaracteristica.estadoResiduo==1? 1:0 );
                    		vm.cantSemisolido = vm.cantSemisolido - (dataCaracteristica.estadoResiduo==2? 1:0);
            				break;
            			}
                	}
            	}
//        	}
        }

        function agregarResiduoTransporte(){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 vm.dataResiduoTrans.idresiduo = vm.prmResiduo.idresiduo;
//        		 ResiduoFactory.registrarTransporte(angular.copy(vm.dataResiduoTrans)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoTransporte();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.dataResiduoTrans.fechavencimientotexto = formatearfecha(vm.dataResiduoTrans.fechavencimiento);
        		 vm.dataResiduoTrans.fechaejecuciontexto = formatearfecha(vm.dataResiduoTrans.fechaejecucion);
        		 vm.prmResiduo.lstTransporte.push(angular.copy(vm.dataResiduoTrans));
//        	}
        	vm.dataResiduoTrans = ResiduoFactory.modelTransporte();
        }

        function formatearfecha(fecha){
        	if(fecha==null){
        		return null;
        	}
            return [
            	fecha.getDate(),
            	fecha.getMonth()+1,
            	fecha.getFullYear()].join('/');
        }


        function agregarResiduoDisposicion(){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 vm.dataResiduoDispo.idresiduo = vm.prmResiduo.idresiduo;
//        		 ResiduoFactory.registrarDisposicion(angular.copy(vm.dataResiduoDispo)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoDisposicion();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.dataResiduoDispo.fechavencimientotexto = formatearfecha(vm.dataResiduoDispo.fechavencimiento);
        		 vm.dataResiduoDispo.fechaejecuciontexto = formatearfecha(vm.dataResiduoDispo.fechaejecucion);
        		 vm.prmResiduo.lstDisposicion.push(angular.copy(vm.dataResiduoDispo));
//        	}
        	vm.dataResiduoDispo = ResiduoFactory.modelDisposicion();

        }

        function cargarResiduoCaracteristica(){
       	 	var dataCaracteristica = {
            	 	idresiduo : vm.prmResiduo.idresiduo,
            	 };

       	 	ResiduoFactory.listarCaracteristica(angular.copy(dataCaracteristica)).then(function(response) {
                if (response != null && response.valido) {
               	 vm.prmResiduo.lstCaracteristicas = angular.copy(response.data);

                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }

        function cargarResiduoTransporte(){
       	 	var dataTransporte = {
            	 	idresiduo : vm.prmResiduo.idresiduo,
            	 };

       	 	ResiduoFactory.listarTransporte(angular.copy(dataTransporte)).then(function(response) {
                if (response != null && response.valido) {
               	 vm.prmResiduo.lstTransporte = angular.copy(response.data);
               	 if(vm.prmResiduo.lstTransporte.length>0){
                		vm.tieneResTransporte =  true;
                	   }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }

        function cargarResiduoDisposicion(){
       	 	var dataDisposicion = {
            	 	idresiduo : vm.prmResiduo.idresiduo,
            	 };

       	 	ResiduoFactory.listarDisposicion(angular.copy(dataDisposicion)).then(function(response) {
                if (response != null && response.valido) {
               	 vm.prmResiduo.lstDisposicion = angular.copy(response.data);
               	   if(vm.prmResiduo.lstDisposicion.length>0){
             		  vm.tieneResDisposicion =  true;
               	   }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }

// function listarPeligrosidad() {
//
// var dataPeligrosidad = {
// codigoMaestro : 'PELIGROSIDAD',
// idMaestro :0,
// descripcion :'',
// };
//
// MaestroFactory.buscarXCodigoMaestro(angular.copy(dataPeligrosidad)).then(function(response)
// {
// if (response != null && response.valido) {
// for(var x in response.data){
// // variable ficticia
// response.data[x].peligrosidad = false
// vm.lstPeligrosidad.push(response.data[x]);
// }
//
// if(vm.prmResiduo.lstCaracteristicas.length>0){
// for(var y in vm.prmResiduo.lstCaracteristicas){
// vm.prmResiduo.lstCaracteristicas.peligrosidadArray = [];
// for(var x in vm.lstPeligrosidad){
// vm.prmResiduo.lstCaracteristicas[y].peligrosidadArray.push(vm.lstPeligrosidad[x]);
// }
// }
// }
// }
// }).catch(function(error) {
// toastr.error('No se pudo obtener los datos para los combos.');
// });
//
// console.log('data ' + vm.lstUnidadMedida);
// }

        function listarUnidadMedida() {

        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                	for(var x in response.data){
                		if(response.data[x].descripcion.toUpperCase() == 'TONELADA (TN)'){
                			vm.lstUnidadMedida.push(response.data[x]);
                			if(vm.prmResiduo.lstCaracteristicas.length>0){
                				for(var y in vm.prmResiduo.lstCaracteristicas){
                					vm.prmResiduo.lstCaracteristicas[y].codUnidad = response.data[x].codigoRegistro;
                				}
                			}
                		}
                	}

                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

            console.log('data ' + vm.lstUnidadMedida);
        }

        function confirmarEliminacionCarac(index,prmResiduoCarac) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarResiduoCaracteristica(index,prmResiduoCarac);
            });
        }

        function confirmarEliminacionTrans(index,prmResiduoTrans) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarResiduoTransporte(index,prmResiduoTrans);
            });
        }

        function confirmarEliminacionDispo(index,prmResiduoTrans) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarResiduoDisposicion(index,prmResiduoTrans);
            });
        }

//        function eliminarResiduoCaracteristica(index,dataCaracteristica){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 ResiduoFactory.eliminarResiduoCaracteristica(angular.copy(dataCaracteristica)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoCaracteristica();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
//        		 vm.prmResiduo.lstCaracteristicas.splice(index, 1);
//        	}
//        }

        function eliminarResiduoTransporte(index,dataTransporte){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 ResiduoFactory.eliminarResiduoTransporte(angular.copy(dataTransporte)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoTransporte();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.prmResiduo.lstTransporte.splice(index, 1);
//        	}
        }

        function eliminarResiduoDisposicion(index,dataDisposicion){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 ResiduoFactory.eliminarResiduoDisposicion(angular.copy(dataDisposicion)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoDisposicion();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.prmResiduo.lstDisposicion.splice(index, 1);
//        	}
        }

        function limpiarEor(tipo){
        	if(tipo =='TRANSPORTE'){
        		vm.dataResiduoTrans.nombreeps = "";
                vm.dataResiduoTrans.nroregistro = "";
                vm.dataResiduoTrans.fechavencimiento = null;
                vm.dataResiduoTrans.fechaejecucion = null;
        	}
        	if(tipo =='DISPOSICION'){
        		vm.dataResiduoDispo.nombreeps = "";
                vm.dataResiduoDispo.nroregistro = "";
                vm.dataResiduoDispo.fechavencimiento = null;
                vm.dataResiduoDispo.direccion = "";
                vm.dataResiduoDispo.fechaejecucion = null;
        	}
        }
        
        function obtenerEor(tipo){
        	
        	ngDialog.open({
                template: 'app/modules/eor/dialog/eor-listado-seleccion.html',
                controller: 'EorListadoSeleccionController',
                controllerAs: 'vm',
                width: '70%'
            }).closePromise.then(function(dataDialog) {
            	mostrarEor(tipo,  $rootScope.eor);
            });
        }
        
        function mostrarEor(tipo, eor){
        	
        	limpiarEor(tipo);
        	
                	if(tipo =='TRANSPORTE'){
                		 vm.dataResiduoTrans.ruceps = eor.ruc;
                		 vm.dataResiduoTrans.nombreeps = eor.nombre;
                         vm.dataResiduoTrans.nroregistro = eor.nroregistro;
                         if(eor.fechavencimiento!=null){
                        	 vm.dataResiduoTrans.fechavencimiento = new Date(eor.fechavencimiento);
                         }
                        
                	}
                	if(tipo =='DISPOSICION'){
                		vm.dataResiduoDispo.ruceps = eor.ruc;
               		    vm.dataResiduoDispo.nombreeps = eor.nombre;
                        vm.dataResiduoDispo.nroregistro = eor.nroregistro;
                        vm.dataResiduoDispo.direccion = eor.direccion;
                        if(eor.fechavencimiento!=null){
                        	vm.dataResiduoDispo.fechavencimiento = new Date(eor.fechavencimiento);
                        }
                	}
        }


        function validarRuc(tipo){
        	
        	limpiarEor(tipo);
             
        	var dataEor = EorFactory.model();
        	dataEor.ruc = tipo =='TRANSPORTE' ? vm.dataResiduoTrans.ruceps : vm.dataResiduoDispo.ruceps;
     	    dataEor.estado = null; 
     	    EorFactory.obtenerExterno(angular.copy(dataEor)).then(function(response) {
                if (response.valido) {
                    vm.Eor = angular.copy(response.data);
                	if(tipo =='TRANSPORTE'){
                		 vm.dataResiduoTrans.nombreeps = vm.Eor.nombre;
                         vm.dataResiduoTrans.nroregistro = vm.Eor.nroregistro;
                         vm.dataResiduoTrans.fechavencimiento = new Date(vm.Eor.fechavencimiento);
                	}
                	if(tipo =='DISPOSICION'){
               		    vm.dataResiduoDispo.nombreeps = vm.Eor.nombre;
                        vm.dataResiduoDispo.nroregistro = vm.Eor.nroregistro;
                        vm.dataResiduoDispo.fechavencimiento = new Date(vm.Eor.fechavencimiento);
                        vm.dataResiduoDispo.direccion = vm.Eor.direccion;
                	}
                }
                else{
                	 toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }


        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");

            vm.listaArchivos = [];

                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);

                // habilitamos el boton dependiendo de otras condiciones
//				 if(vm.prmResiduo.lstCaracteristicas.length!=0 && (vm.prmResiduo.lstTransporte.length!=0 || vm.tieneResTransporte==true) && (vm.prmResiduo.lstDisposicion.length!=0 || vm.tieneResDisposicion==true) && vm.prmResiduo.periodo!=0 && vm.prmResiduo.frecuencia!=0 && vm.prmResiduo.numero_frecuencia!=0 ){
//					 document.getElementById("btnRegistrarManifiesto").disabled = false;
//				 }
//				 
				 document.getElementById("btnRefrescar").click();

                vm.tieneArchivo = true;
        }
        
        function refrescar(){
        	
        }

        function init() {
           validaOpcionSSOSisoWeb('EDITAR MMRS');
        	 
           if(angular.isDefined($rootScope.itemResiduo)){
        	   vm.prmResiduo = $rootScope.itemResiduo;
        	   if(vm.prmResiduo.fechapresentacion!=null){
        		   vm.prmResiduo.fechapresentacion = new Date(vm.prmResiduo.fechapresentacion);
        	   }
        	   if(vm.prmResiduo.idresiduo != 0){
        		   cargarResiduoCaracteristica();
        		   cargarResiduoTransporte();
        		   cargarResiduoDisposicion();
        	   }
        	   else{
        		   vm.prmResiduo.periodo = new Date().getFullYear() - 1;
        		   var caracPeligro = ResiduoFactory. modelCaracteristica();
        		   caracPeligro.estadoResiduo = 1;
        		   caracPeligro.secuencia = 1;
        		   var caracOtros = ResiduoFactory. modelCaracteristica();
        		   caracOtros.estadoResiduo = 2;
        		   caracOtros.secuencia = 2;

        		   vm.prmResiduo.lstCaracteristicas.push(caracPeligro);
        		   vm.prmResiduo.lstCaracteristicas.push(caracOtros);
        		   
        		   vm.cantSemisolido = 1;
        		   vm.cantSolido = 1;
        	   }
        	   if (angular.isDefined(localStorage.objInstalacion)) {
        		   var prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                   vm.prmResiduo.idInstalacion = prmInstalacion.idInstalacion;
                   vm.prmResiduo.idAdministrado = prmInstalacion.idAdministrado;
        	   }
           }
           listarUnidadMedida();
// listarPeligrosidad();
           obtenerParametros();
           cargarPeriodos();
        }

        function cargarPeriodos() {

        	var dataTipoPeriodo = {
        		codigoMaestro : 'TipoPeriodo'
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                    if(vm.lstPeriodos.length>0){
                    	for(var x in vm.lstPeriodos){
                    		if(vm.lstPeriodos[x].descripcion == 'TRIMESTRAL'){
                    			vm.prmResiduo.frecuencia = vm.lstPeriodos[x].codigoRegistro;
// cargarPeriodosHijos(vm.prmResiduo.frecuencia);
                    			break;
                    		}
                    	}

                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }


        function tieneResiduosTransporte(tiene){
        	vm.tieneResTransporte = tiene;
        	if(!tiene){
        		vm.dataResiduoTrans.ruceps = "";
        		limpiarEor('TRANSPORTE');
        	}
        }

        function tieneResiduosDisposicion(tiene){
        	vm.tieneResDisposicion = tiene;
        	if(!tiene){
        		vm.dataResiduoDispo.ruceps = "";
        		limpiarEor('DISPOSICION');
        	}
        }

        function getMensajeDeclaracionJurada() {
            // console.log("vm.dataMaestros.codigoMaestro" +
			// vm.dataMaestros.codigoMaestro);
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                	vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }
        
        function validaOpcionSSOSisoWeb(opcion) {
        	  AccesoFactory.operaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq),'Inf. Unidades Fiscalizables').then(function(response) {
           	  $rootScope.sisoOperacioneswkWeb = response;
        		  vm.accesos = response;
        		  for (var int = 0; int < vm.accesos.length; int++) {
        			    var _opcion = vm.accesos[int];
                      if (_opcion.elemento == opcion) {
                    	  vm.blEditar = true;
                      }
                  }
              }).catch(function(error) {
            	  vm.blEditar = false;
              });
        }

// function cargarPeriodosHijos(itempadre) {
//
// var dataTipoPeriodo = {
// codigoMaestro : 'TipoPeriodo',
// codigoRegistroPadre : itempadre
// };
//
// MaestroFactory.buscarRegistroHijo(angular.copy(dataTipoPeriodo)).then(function(response)
// {
// if (response != null && response.valido) {
// vm.lstPeriodosHijos = response.data;
// }
// }).catch(function(error) {
// toastr.error('No se pudo obtener los datos para los combos.');
// });
//
// }

        init();
        /* fin de metodos */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.etapa').controller('ManifiestoResiduosController', ManifiestoResiduosController);
    /* @ngInject */
    function ManifiestoResiduosController(ngDialog, API_CONFIG , toastr, $state, $scope, $rootScope, ResiduoFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        vm.rutaBase = API_CONFIG.url;
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.lstResiduos = [];
        vm.prmResiduo = ResiduoFactory.model();
        vm.cancelar = cancelar;
        
        vm.confirmarEliminacionResultado = confirmarEliminacionResultado;
        
        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-instalacion');
        }

        function agregarItem(item) {
        	 if (item != null) {
                 
        		 ResiduoFactory.buscarPorId(angular.copy(item)).then(function(response) {
                 	console.log('response.valido ' + response.valido);
                 		if (response.valido) {
                         	$rootScope.itemResiduo = response.data;
                         	  ngDialog.open({
                                   template: 'app/modules/residuos/manifiesto_residuos_edicion.html',
                                   controller: 'ManifiestoResiduosEdicionController',
                                   controllerAs: 'vm',
                                   
                                   width: '90%'
                               }).closePromise.then(function(dataDialog) {
                                   listar();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la etapa');
 		                });
             } 
             else{
            	$rootScope.itemResiduo = ResiduoFactory.model();
             	ngDialog.open({
                     template: 'app/modules/residuos/manifiesto_residuos_edicion.html',
                     controller: 'ManifiestoResiduosEdicionController',
                     controllerAs: 'vm',
                     width: '90%'
                 }).closePromise.then(function(dataDialog) {
                     listar();
                 });
             }
        }
        
        function confirmarEliminacionResultado(item){
        	 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Confirmar eliminación',
                     Mensaje: '¿Está seguro de eliminar?'
                 },
                 width: '380px'
             }).then(function(okValue) {
            	 ResiduoFactory.deshabilitar(angular.copy(item)).then(function(response) {
                     if (response.valido) {
                         toastr.success(response.mensaje);
                         listar();
                     } else {
                         toastr.error(response.mensaje)
                     }
                 }).catch(function(error) {
                     toastr.error('Ocurrió un error al eliminar la etapa');
                 });
             });
        }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }
        
        function confirmarInactivacion(prmEtapa) {
        	
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }
        
        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }

        function listar() {
        	vm.prmResiduo.tipo = 'MR';
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ResiduoFactory.listar(angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstResiduos = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	  if (angular.isDefined(localStorage.objInstalacion)) {
                  vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                  vm.prmResiduo.idInstalacion = vm.prmInstalacion.idInstalacion;
                  vm.prmResiduo.idAdministrado = vm.prmInstalacion.idAdministrado;
                  listar();
              }
            
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.supervision').controller('DeclaracionResiduosEdicionController', DeclaracionResiduosEdicionController);
    /* @ngInject */
    function DeclaracionResiduosEdicionController(ngDialog, API_CONFIG,toastr, $scope, $rootScope, AccesoFactory,MaestroFactory,EntidadFactory, ResiduoFactory,CookiesFactory, EorFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };

        vm.rutaBase = API_CONFIG.url;
        /* declaracion de variables globales */
        vm.mimeTypes = [];
        vm.extension = "";
        vm.tamanioArchivo = "500";
        vm.caracteresMaximoArchivo = 50;
        vm.listaArchivos = [];

        vm.tieneResiduosTransporte = tieneResiduosTransporte;
        vm.tieneResTransporte = false;
        vm.tieneResiduosDisposicion = tieneResiduosDisposicion;
        vm.tieneResDisposicion = false;

        vm.dataMaestros = MaestroFactory.model();
        vm.dataMaestros.codigoMaestro = "DeclaracionJurada";
        vm.mensajeDeclaracionJurada = getMensajeDeclaracionJurada();

        vm.prmResiduo = ResiduoFactory.model();
        vm.dataResiduoCarac = ResiduoFactory.modelCaracteristica();
        vm.dataResiduoTrans = ResiduoFactory.modelTransporte();
        vm.dataResiduoDispo = ResiduoFactory.modelDisposicion();
        vm.lstUnidadMedida = [];
        /* declaración de metodos enlazados a la vista */
        vm.guardar = guardar;
        vm.agregarResiduoCaracteristica = agregarResiduoCaracteristica;
        vm.agregarResiduoTransporte = agregarResiduoTransporte;
        vm.agregarResiduoDisposicion = agregarResiduoDisposicion;
        vm.eliminarResiduoCaracteristica = eliminarResiduoCaracteristica;
        vm.eliminarResiduoTransporte = eliminarResiduoTransporte;
        vm.eliminarResiduoDisposicion = eliminarResiduoDisposicion;

        vm.confirmarEliminacionCarac = confirmarEliminacionCarac;
        vm.confirmarEliminacionTrans = confirmarEliminacionTrans;
        vm.confirmarEliminacionDispo = confirmarEliminacionDispo;
        vm.validaDocumento = validaDocumento;
        vm.cancelar = cancelar;
        vm.validarRuc = validarRuc;
        vm.lstPeriodosHijos = [];
        vm.cargarPeriodosHijos  =cargarPeriodosHijos;
        vm.mostrarEor = mostrarEor;
        vm.obtenerEor = obtenerEor;
        vm.refrescar = refrescar;
        vm.blEditar = false;
        vm.accesos = [];
        vm.validaOpcionSSOSisoWeb = validaOpcionSSOSisoWeb;

        function cancelar(){
        	 ngDialog.close();
        }

        function obtenerParametros() {
            MaestroFactory.obtenerParametros().then(function(response) {
                vm.tamanioArchivo = angular.copy(response.data[0].tamanioArchivo);
                vm.caracteresMaximoArchivo = angular.copy(response.data[0].maximoCaracteresArchivo);
                vm.extension = angular.copy(response.data[0].extensionArchivoDocumento);
                var tipos = angular.copy(response.data[0].tipoArchivoDocumento);
                vm.mimeTypes = angular.copy(tipos.split(","));
            }).catch(function(error) {
                toastr.error('No se pudo obtener los parametros.');
            });
        }

        function guardar() {
            if (vm.prmResiduo.idresiduo == 0) {
            	console.log("fechavencimiento-->"+vm.dataResiduoTrans.fechavencimiento)
            	confirmarGuardar();
            } else {
                actualizar();
            }
        }

        function confirmarGuardar() {
            getMensajeDeclaracionJurada();
    		 ngDialog.openConfirm({
                 template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                 controller: 'DialogConfirmController',
                 controllerAs: 'vm',
                 data: {
                     Titulo: 'Declaración Jurada',
                     Mensaje: vm.mensajeDeclaracionJurada
                 },
                 width: '380px'
             }).then(function(okValue) {
            	 validar();
             });
        }

        function getMensajeDeclaracionJurada() {
            MaestroFactory.buscarXCodigoMaestro(angular.copy(vm.dataMaestros)).then(function(response) {
                if (response != null && response.valido) {
                    vm.mensajeDeclaracionJurada = response.data[0].descripcion;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para la Declaracion Jurada.');
            });
        }

        function registrar() {
        		vm.prmResiduo.prm1= CookiesFactory.obtenerCookie();
            	// vm.prmResiduo.fechapresentacion = new Date();
            	vm.prmResiduo.tipo = "DR";
            	vm.prmResiduo.numero_frecuencia = convertirRomanoALatinoNumero('NUMERO',vm.prmResiduo.numero_frecuencia);
                ResiduoFactory.registrar(vm.listaArchivos,angular.copy(vm.prmResiduo)).then(function(response) {
                    if (response != null && response.valido) {
                        toastr.success('Éxito en la operación.');
                        ngDialog.close();
                    }
                }).catch(function(error) {
                    toastr.error('No se pudo grabar la información.');
                });
        }

  function obtenerEor(tipo){
        	
        	ngDialog.open({
                template: 'app/modules/eor/dialog/eor-listado-seleccion.html',
                controller: 'EorListadoSeleccionController',
                controllerAs: 'vm',
                width: '70%'
            }).closePromise.then(function(dataDialog) {
            	mostrarEor(tipo,  $rootScope.eor);
            });
        }
        
        function mostrarEor(tipo, eor){
        	
        	limpiarEor(tipo);
        	
                	if(tipo =='TRANSPORTE'){
                		 vm.dataResiduoTrans.ruceps = eor.ruc;
                		 vm.dataResiduoTrans.nombreeps = eor.nombre;
                         vm.dataResiduoTrans.nroregistro = eor.nroregistro;
                         if(eor.fechavencimiento!=null){
                        	vm.dataResiduoTrans.fechavencimiento = new Date(eor.fechavencimiento);
                         }
                	}
                	if(tipo =='DISPOSICION'){
                		vm.dataResiduoDispo.ruceps = eor.ruc;
               		    vm.dataResiduoDispo.nombreeps = eor.nombre;
                        vm.dataResiduoDispo.nroregistro = eor.nroregistro;
                        vm.dataResiduoDispo.direccion = eor.direccion;
                        if(eor.fechavencimiento!=null){
                        	vm.dataResiduoDispo.fechavencimiento = new Date(eor.fechavencimiento);
                        }
                	}
        }

        
        function validar(){
        	var lstResiduos = [];
        	var filResiduo = ResiduoFactory.model() ;
        	filResiduo.tipo = "DR";
        	filResiduo.periodo = vm.prmResiduo.periodo;
        	filResiduo.idInstalacion = vm.prmResiduo.idInstalacion;
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ResiduoFactory.listar(angular.copy(filResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    lstResiduos = angular.copy(response.data);
                    if(lstResiduos.length>0){
                    	 toastr.error('Periodo ya declarado.');
                    	return false;
                    }
                    else{
                    	 registrar();
                    }
                }
                else{
                	 registrar();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });

        }

        function actualizar() {
        	vm.prmResiduo.prm1= CookiesFactory.obtenerCookie();
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
        	vm.prmResiduo.numero_frecuencia = convertirRomanoALatinoNumero('NUMERO',vm.prmResiduo.numero_frecuencia);
        	ResiduoFactory.actualizar(vm.listaArchivos,angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    toastr.success('Éxito en la operación.');
                    ngDialog.close();
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
        }

        function agregarResiduoCaracteristica(){
        	if( vm.prmResiduo.idresiduo !=0){
        		 vm.dataResiduoCarac.idresiduo = vm.prmResiduo.idresiduo;
        		 ResiduoFactory.registrarCaracteristica(angular.copy(vm.dataResiduoCarac)).then(function(response) {
                     if (response != null && response.valido) {
                    	 vm.dataResiduoCarac = ResiduoFactory.modelCaracteristica();
                    	 cargarResiduoCaracteristica();
                     }
                 }).catch(function(error) {
                     toastr.error('No se pudo grabar la información.');
                 });
        	}
        	else{
        		 vm.prmResiduo.lstCaracteristicas.push(angular.copy(vm.dataResiduoCarac));
        	}
        	vm.dataResiduoCarac = ResiduoFactory.modelCaracteristica();
        }

        function agregarResiduoTransporte(){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 vm.dataResiduoTrans.idresiduo = vm.prmResiduo.idresiduo;
//        		 console.log("fechavencimiento-->"+vm.dataResiduoTrans.fechavencimiento)
//        		 ResiduoFactory.registrarTransporte(angular.copy(vm.dataResiduoTrans)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoTransporte();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.dataResiduoTrans.fechavencimientotexto = formatearfecha(vm.dataResiduoTrans.fechavencimiento);
        		 vm.dataResiduoTrans.fechaejecuciontexto = formatearfecha(vm.dataResiduoTrans.fechaejecucion);
        		 vm.prmResiduo.lstTransporte.push(angular.copy(vm.dataResiduoTrans));
//        	}
        	vm.dataResiduoTrans = ResiduoFactory.modelTransporte();
        }

        function formatearfecha(fecha){
        	if(fecha==null){
        		return null;
        	}
            return [
            	fecha.getDate(),
            	fecha.getMonth()+1,
            	fecha.getFullYear()].join('/');
        }


        function agregarResiduoDisposicion(){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 vm.dataResiduoDispo.idresiduo = vm.prmResiduo.idresiduo;
//        		 ResiduoFactory.registrarDisposicion(angular.copy(vm.dataResiduoDispo)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoDisposicion();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.dataResiduoDispo.fechavencimientotexto = formatearfecha(vm.dataResiduoDispo.fechavencimiento);
        		 vm.dataResiduoDispo.fechaejecuciontexto = formatearfecha(vm.dataResiduoDispo.fechaejecucion);
        		 vm.prmResiduo.lstDisposicion.push(angular.copy(vm.dataResiduoDispo));
//        	}
        	vm.dataResiduoDispo = ResiduoFactory.modelDisposicion();

        }

        function cargarResiduoCaracteristica(){
       	 	var dataCaracteristica = {
            	 	idresiduo : vm.prmResiduo.idresiduo,
            	 };

       	 	ResiduoFactory.listarCaracteristica(angular.copy(dataCaracteristica)).then(function(response) {
                if (response != null && response.valido) {
               	 vm.prmResiduo.lstCaracteristicas = angular.copy(response.data);

                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }

        function cargarResiduoTransporte(){
       	 	var dataTransporte = {
            	 	idresiduo : vm.prmResiduo.idresiduo,
            	 };

       	 	ResiduoFactory.listarTransporte(angular.copy(dataTransporte)).then(function(response) {
                if (response != null && response.valido) {
               	   vm.prmResiduo.lstTransporte = angular.copy(response.data);
               	   if(vm.prmResiduo.lstTransporte.length>0){
               		vm.tieneResTransporte =  true;
               	   }
               	   
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }

        function cargarResiduoDisposicion(){
       	 	var dataDisposicion = {
            	 	idresiduo : vm.prmResiduo.idresiduo,
            	 };

       	 	ResiduoFactory.listarDisposicion(angular.copy(dataDisposicion)).then(function(response) {
                if (response != null && response.valido) {
               	 vm.prmResiduo.lstDisposicion = angular.copy(response.data);
               	    if(vm.prmResiduo.lstDisposicion.length>0){
                		vm.tieneResDisposicion =  true;
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
       }

        function listarUnidadMedida() {

        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                	for(var x in response.data){
                		if(response.data[x].descripcion.toUpperCase() == 'TONELADA (TN)'){
                			vm.lstUnidadMedida.push(response.data[x]);
                			if(vm.prmResiduo.lstCaracteristicas.length>0){
                				for(var y in vm.prmResiduo.lstCaracteristicas){
                					vm.prmResiduo.lstCaracteristicas[y].codUnidad = response.data[x].codigoRegistro;
                				}
                			}
                		}
                	}

                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

            console.log('data ' + vm.lstUnidadMedida);
        }

        function confirmarEliminacionCarac(index,prmResiduoCarac) {
// ngDialog.openConfirm({
// template: 'app/base/template/dialog-confirm/dialog-confirm.html',
// controller: 'DialogConfirmController',
// controllerAs: 'vm',
// data: {
// Titulo: 'Confirmar eliminación',
// Mensaje: '¿Está seguro de eliminar el registro?'
// },
// width: '380px'
// }).then(function(okValue) {
            	eliminarResiduoCaracteristica(index,prmResiduoCarac);
// });
        }

        function confirmarEliminacionTrans(index,prmResiduoTrans) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarResiduoTransporte(index,prmResiduoTrans);
            });
        }

        function confirmarEliminacionDispo(index,prmResiduoDisp) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
            	eliminarResiduoDisposicion(index,prmResiduoDisp);
            });
        }

        function eliminarResiduoCaracteristica(index,dataCaracteristica){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 ResiduoFactory.eliminarResiduoCaracteristica(angular.copy(dataCaracteristica)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoCaracteristica();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 for(var x in vm.prmResiduo.lstCaracteristicas){
        			 if(x==index ){
        				 vm.prmResiduo.lstCaracteristicas[x].cantEnero = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantFebrero = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantMarzo = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantAbril = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantMayo = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantJunio = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantJulio = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantAgosto = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantSeptiembre = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantOctubre = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantNoviembre = 0.0;
        				 vm.prmResiduo.lstCaracteristicas[x].cantDiciembre = 0.0;

        			 }
        		 }

//        	}
        }

        function eliminarResiduoTransporte(index,dataTransporte){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 ResiduoFactory.eliminarResiduoTransporte(angular.copy(dataTransporte)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoTransporte();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.prmResiduo.lstTransporte.splice(index, 1);
//        	}
        }

        function eliminarResiduoDisposicion(index,dataDisposicion){
//        	if( vm.prmResiduo.idresiduo !=0){
//        		 ResiduoFactory.eliminarResiduoDisposicion(angular.copy(dataDisposicion)).then(function(response) {
//                     if (response != null && response.valido) {
//                    	 cargarResiduoDisposicion();
//                     }
//                 }).catch(function(error) {
//                     toastr.error('No se pudo grabar la información.');
//                 });
//        	}
//        	else{
        		 vm.prmResiduo.lstDisposicion.splice(index, 1);
//        	}
        }
        
        function limpiarEor(tipo){
        	if(tipo =='TRANSPORTE'){
        		vm.dataResiduoTrans.nombreeps = "";
                vm.dataResiduoTrans.nroregistro = "";
                vm.dataResiduoTrans.fechavencimiento = null;
                vm.dataResiduoTrans.fechaejecucion = null;
        	}
        	if(tipo =='DISPOSICION'){
        		vm.dataResiduoDispo.nombreeps = "";
                vm.dataResiduoDispo.nroregistro = "";
                vm.dataResiduoDispo.fechavencimiento = null;
                vm.dataResiduoDispo.fechaejecucion = null;
        	}
        }

        function validarRuc(tipo){
        	
        	limpiarEor(tipo);
             
        	var dataEor = EorFactory.model();
        	dataEor.ruc = tipo =='TRANSPORTE' ? vm.dataResiduoTrans.ruceps : vm.dataResiduoDispo.ruceps;
     	    dataEor.estado = null; 
     	    EorFactory.obtenerExterno(angular.copy(dataEor)).then(function(response) {
                if (response.valido) {
                    vm.Eor = angular.copy(response.data);
                	if(tipo =='TRANSPORTE'){
                		 vm.dataResiduoTrans.nombreeps = vm.Eor.nombre;
                         vm.dataResiduoTrans.nroregistro = vm.Eor.nroregistro;
                         vm.dataResiduoTrans.fechavencimiento = new Date(vm.Eor.fechavencimiento);
                	}
                	if(tipo =='DISPOSICION'){
               		    vm.dataResiduoDispo.nombreeps = vm.Eor.nombre;
                        vm.dataResiduoDispo.nroregistro = vm.Eor.nroregistro;
                        vm.dataResiduoDispo.fechavencimiento = new Date(vm.Eor.fechavencimiento);
                	}
                }
                else{
                	 toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function validaDocumento(prmFileList) {
            var lstExtens = vm.extension.split(",");

            vm.listaArchivos = [];

                if (!prmFileList) {
                    toastr.warning('Debe seleccionar un Archivo');
                    return;
                }
                var archivo = prmFileList[0];
                if (archivo.size / 1024 > (parseInt(vm.tamanioArchivo) * 1000)) {
                    toastr.warning('El tamaño del archivo no debe superar ' + angular.copy(vm.tamanioArchivo) + 'MB. Comprima el archivo y vuelva a intentarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                var str = archivo.name;
                var extensionArchivo = str.substring(str.lastIndexOf("."), str.length);
                if (!vm.mimeTypes.includes(archivo.type) && !lstExtens.includes(extensionArchivo)) {
                    toastr.warning('El archivo seleccionado no esta permitido');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                if (archivo.name.length > parseInt(vm.caracteresMaximoArchivo)) {
                    toastr.warning('El nombre del archivo no debe superar los ' + vm.caracteresMaximoArchivo + ' caracteres. Renombre el archivo y vuelva a cargarlo.');
                    document.getElementById("fileArchivo").value = "";
                    return;
                }
                vm.listaArchivos.push(prmFileList[0]);

                // habilitamos el boton dependiendo de otras condiciones
                if(vm.prmResiduo.lstCaracteristicas.length!=0 && (vm.prmResiduo.lstTransporte.length!=0 || vm.tieneResTransporte==true) && (vm.prmResiduo.lstDisposicion.length!=0 || vm.tieneResDisposicion==true) && vm.prmResiduo.periodo!=0 && vm.prmResiduo.frecuencia!=0 && vm.prmResiduo.numero_frecuencia!=0 ){
					 document.getElementById("btnRegistrarDeclaracion").disabled = false;
				 }
                
                document.getElementById("btnRefrescar").click();

        }
        
        function refrescar(){
        	
        }

        function init() {
           validaOpcionSSOSisoWeb('EDITAR DMRS');
           
           if(angular.isDefined($rootScope.itemResiduo)){
        	   vm.prmResiduo = $rootScope.itemResiduo;
        	   if(vm.prmResiduo.fechapresentacion!=null){
        		   vm.prmResiduo.fechapresentacion = new Date(vm.prmResiduo.fechapresentacion);
        	   }
        	   vm.prmResiduo.numero_frecuencia = 1; 
        	   if(vm.prmResiduo.idresiduo != 0){
        		   cargarResiduoCaracteristica();
        		   cargarResiduoTransporte();
        		   cargarResiduoDisposicion();
        	   }
        	   else{
        		   vm.prmResiduo.periodo = new Date().getFullYear() - 1;
        		   // por defecto agregamos los peligrosos y otros
        		   var caracPeligro = ResiduoFactory. modelCaracteristica();
        		   caracPeligro.idTipo = 1;
        		   var caracOtros = ResiduoFactory. modelCaracteristica();
        		   caracOtros.idTipo = 2;

        		   vm.prmResiduo.lstCaracteristicas.push(caracPeligro);
        		   vm.prmResiduo.lstCaracteristicas.push(caracOtros);
        	   }
        	   if (angular.isDefined(localStorage.objInstalacion)) {
        		   var prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                   vm.prmResiduo.idInstalacion = prmInstalacion.idInstalacion;
                   vm.prmResiduo.idAdministrado = prmInstalacion.idAdministrado;
        	   }
           }
           listarUnidadMedida();
           obtenerParametros();
           cargarPeriodos();
        }

        function cargarPeriodos() {

        	var dataTipoPeriodo = {
        		codigoMaestro : 'TipoPeriodo'
        	};

            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstPeriodos = response.data;
                    if(vm.lstPeriodos.length>0){
                    	for(var x in vm.lstPeriodos){
                    		if(vm.lstPeriodos[x].descripcion == 'ANUAL'){
                    			vm.prmResiduo.frecuencia = vm.lstPeriodos[x].codigoRegistro;
                    			cargarPeriodosHijos(vm.prmResiduo.frecuencia);
                    			break;
                    		}
                    	}

                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }

        function cargarPeriodosHijos(itempadre) {

        	var dataTipoPeriodo = {
        		codigoMaestro : 'TipoPeriodo',
        		codigoRegistroPadre :  itempadre
        	};

            MaestroFactory.buscarRegistroHijo(angular.copy(dataTipoPeriodo)).then(function(response) {
                if (response != null && response.valido) {
                	vm.lstPeriodosHijos = response.data;
                	vm.prmResiduo.numero_frecuencia='I';
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });

        }


        function convertirRomanoALatinoNumero(tipo,numromano){
        	if(tipo=='MES'){
        		if(numromano=='ENERO'){
        			return 1;
        		}
        		if(numromano=='FEBRERO'){
        			return 2;
        		}
        		if(numromano=='MARZO'){
        			return 3;
        		}
        		if(numromano=='ABRIL'){
        			return 4;
        		}
        		if(numromano=='MAYO'){
        			return 5;
        		}
        		if(numromano=='JUNIO'){
        			return 6;
        		}
        		if(numromano=='JULIO'){
        			return 7;
        		}
        		if(numromano=='AGOSTO'){
        			return 8;
        		}
        		if(numromano=='SEPTIEMBRE'){
        			return 9;
        		}
        		if(numromano=='OCTUBRE'){
        			return 11;
        		}
        		if(numromano=='NOVIEMBRE'){
        			return 12;
        		}
        		if(numromano=='DICIEMBRE'){
        			return 13;
        		}
        	}
        	if(tipo=='NUMERO'){
        		if(numromano=='I'){
        			return 1;
        		}
        		if(numromano=='II'){
        			return 2;
        		}
        		if(numromano=='III'){
        			return 3;
        		}
        		if(numromano=='IV'){
        			return 4;
        		}
        		if(numromano=='V'){
        			return 5;
        		}
        		if(numromano=='VI'){
        			return 6;
        		}
        	}

        }

        function tieneResiduosTransporte(tiene){
        	vm.tieneResTransporte = tiene;
        	if(!tiene){
        		vm.dataResiduoTrans.ruceps = "";
        		limpiarEor('TRANSPORTE');
        	}
        }

        function tieneResiduosDisposicion(tiene){
        	vm.tieneResDisposicion = tiene;
        	if(!tiene){
        		vm.dataResiduoDispo.ruceps = "";
        		limpiarEor('DISPOSICION');
        	}
        }
        
        function validaOpcionSSOSisoWeb(opcion) {
      	  AccesoFactory.operaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq),'Inf. Unidades Fiscalizables').then(function(response) {
         	  $rootScope.sisoOperacioneswkWeb = response;
      		  vm.accesos = response;
      		  for (var int = 0; int < vm.accesos.length; int++) {
      			    var _opcion = vm.accesos[int];
                    if (_opcion.elemento == opcion) {
                  	  vm.blEditar = true;
                    }
                }
            }).catch(function(error) {
          	  vm.blEditar = false;
            });
      }

      init();
        /* fin de metodos */
    }
})();

(function() {
    'use strict';
    angular.module('spapp.etapa').controller('DeclaracionResiduosController', DeclaracionResiduosController);
    /* @ngInject */
    function DeclaracionResiduosController(ngDialog, API_CONFIG , toastr, $scope, $state, $rootScope, ResiduoFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        vm.rutaBase = API_CONFIG.url;
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.lstResiduos = [];
        vm.prmResiduo = ResiduoFactory.model();
        vm.cancelar = cancelar;
        
        vm.confirmarEliminacionResultado = confirmarEliminacionResultado;
        
        function cancelar() {
            $state.go('spapp.home.supervision.cargainfo-instalacion');
        }

        function agregarItem(item) {
        	 if (item != null) {
        		 ResiduoFactory.buscarPorId(angular.copy(item)).then(function(response) {
                 		if (response.valido) {
                         	$rootScope.itemResiduo = response.data;
                         	console.log('data ' + $rootScope.itemResiduo);
                         	  ngDialog.open({
                                   template: 'app/modules/residuos/declaracion_anual_residuos_edicion.html',
                                   controller: 'DeclaracionResiduosEdicionController',
                                   controllerAs: 'vm',
                                   width: '90%'
                               }).closePromise.then(function(dataDialog) {
                                   listar();
                               });
                         } else {
                             toastr.error(response.mensaje)
                         }
 		                }).catch(function(error) {
 		                    toastr.error('Ocurrió un error al obtener la etapa');
 		                });
             } 
             else{
            	$rootScope.itemResiduo = ResiduoFactory.model();
             	ngDialog.open({
                     template: 'app/modules/residuos/declaracion_anual_residuos_edicion.html',
                     controller: 'DeclaracionResiduosEdicionController',
                     controllerAs: 'vm',
                     width: '90%'
                 }).closePromise.then(function(dataDialog) {
                     listar();
                 });
             }
        }
        
        function confirmarEliminacionResultado(item){
         	 ngDialog.openConfirm({
                  template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                  controller: 'DialogConfirmController',
                  controllerAs: 'vm',
                  data: {
                      Titulo: 'Confirmar eliminación',
                      Mensaje: '¿Está seguro de eliminar?'
                  },
                  width: '380px'
              }).then(function(okValue) {
           	   //prmInforme.flgEliminaDet = "N";
            	  ResiduoFactory.deshabilitar(angular.copy(item)).then(function(response) {
                      if (response.valido) {
                          toastr.success(response.mensaje);
                          listar();
                      } else {
                          toastr.error(response.mensaje)
                      }
                  }).catch(function(error) {
                      toastr.error('Ocurrió un error al eliminar la etapa');
                  });
              });
         }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }
        
        function confirmarInactivacion(prmEtapa) {
        	
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }
        
        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }

        function listar() {
        	vm.prmResiduo.tipo = 'DR';
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            ResiduoFactory.listar(angular.copy(vm.prmResiduo)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstResiduos = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	  if (angular.isDefined(localStorage.objInstalacion)) {
                  vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                  vm.prmResiduo.idInstalacion = vm.prmInstalacion.idInstalacion;
                  vm.prmResiduo.idAdministrado = vm.prmInstalacion.idAdministrado;
                  listar();
              }
            
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
	'use strict';
	angular.module('spapp.parametro').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider.state('spapp.home.parametro', {
			url : '/parametros',
			templateUrl : 'app/modules/parametro/parametro.html',
			controller : 'ParametroController',
			controllerAs : 'vm'
		}).state('spapp.home.parametro.listado', {
			url : '/listado',
			templateUrl : 'app/modules/parametro/listado/parametro-listado.html',
			controller : 'ParametroListadoController',
			controllerAs : 'vm'
		});
		/* fin de route */
	}
})();
(function() {
	'use strict';
	angular.module('spapp.parametro')
			.controller('ParametroController', ParametroController);
	/* @ngInject */
	function ParametroController($state, AccesoFactory, $rootScope, $log, toastr,
			$location) {
		var vm = this;
	}
})();
(function() {
	'use strict';
	angular.module('spapp.normalegal').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider.state('spapp.home.normalegal', {
			url : '/normalegals',
			templateUrl : 'app/modules/normalegal/normalegal.html',
			controller : 'NormaLegalController',
			controllerAs : 'vm'
		}).state('spapp.home.normalegal.listado', {
			url : '/listado',
			templateUrl : 'app/modules/normalegal/listado/normalegal-listado.html',
			controller : 'NormaLegalListadoController',
			controllerAs : 'vm'
		});
		/* fin de route */
	}
})();
(function() {
	'use strict';
	angular.module('spapp.normalegal')
			.controller('NormaLegalController', NormaLegalController);
	/* @ngInject */
	function NormaLegalController($state, AccesoFactory, $rootScope, $log, toastr,
			$location) {
		var vm = this;
	}
})();
(function() {
    'use strict';
    angular.module('spapp.preguntas', []);
})();
(function() {
    'use strict';
    angular.module('spapp.preguntas').config(routeConfig);
    /* @ngInject */
    function routeConfig($stateProvider) {
        /*inicio de route*/
        $stateProvider.state('spapp.home.preguntas', {
            url: '/pregunta',
            templateUrl: 'app/modules/bandeja/bandeja.html',
            controller: 'PreguntaController',
            controllerAs: 'vm'
        }).state('spapp.home.preguntas.registro', {
            url: '/registro',
            templateUrl: 'app/modules/preguntas/registro/registro-pregunta.html',
            controller: 'RegistroPreguntaController',
            controllerAs: 'vm'
        }).state('spapp.home.preguntas.banco-pregunta', {
            url: '/banco-pregunta',
            templateUrl: 'app/modules/preguntas/banco-preguntas/banco-pregunta.html',
            controller: 'BancoPreguntaController',
            controllerAs: 'vm'
        });
        /*
        .state('spapp.home.acciones',{
        	url : '/acciones',
        	templateUrl : 'app/modules/acciones/acciones.html',
        	controller : 'AccionesController',
        	controllerAs : 'vm'
        })
        .state('spapp.home.acciones.denunciante',{
        	url : '/denunciante',
        	templateUrl : 'app/modules/acciones/revisarEfa/revisarEfa.html',
        	controller : 'RevisarEfaController',
        	controllerAs : 'vm'
        });*/
        /*fin de route*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.preguntas').controller('PreguntaController', PreguntaController);
    /** @ngInject */
    function PreguntaController($state, INTERNAL_HOME_PAGE, AccesoFactory, $rootScope, $log, toastr, $location) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Primer Tab por defecto
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        /*      function leerOperaciones(ref) {
                    
                    AccesoFactory.operaciones(ref,"Preguntas").then(function (response)
                    {
                        $rootScope.sisoOperacioneswkWeb=response;//angular.toJson(response);
                        //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                        $rootScope.sisoValidaOperacionesWbUvk=sisoValidaOperacionesWbUvk;
                    }).catch(function (error) 
                    {
                        toastr.error(error);
                    });
                }
                
                function sisoValidaOperacionesWbUvk(operacion) {
                    for (var int = 0; int < $rootScope.sisoOperacioneswkWeb.length; int++) {
                        var oOperacion=$rootScope.sisoOperacioneswkWeb[int];             
                        if (oOperacion.elemento==operacion) {
                            return true;
                        }
                    }
                    return false;
                }

                if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
                    leerOperaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq));
                    $rootScope.kqlRefRootSiso=angular.copy(localStorage.objlocalStRefSisoplkijsq);
                }else{
                    leerOperaciones($rootScope.kqlRefRootSiso);
                }*/
        /*fin de metodos*/
    }
})();
 
    
(    
function() {
    'use strict';
    angular.module('spapp').controller('InicioController', InicioController);
    function InicioController($scope, $state , $http,$rootScope, AccesoFactory, $location, ngDialog, toastr, $log, CookiesFactory,SolicitudesFactory,GraficoFactory,UbigeoFactory,AdministradoFactory ) {
       
        
        var vm = this;
        /** Slider numero 2* */
        vm.myInterval = 5000;
        vm.noWrapSlides = false;
        vm.noWrapSlides = false;
        vm.activeSliderImagenes2 = 0;
        vm.nombreUsuario = '';
        vm.vergraficoPrincipal = false;
        vm.vergraficoSecundaria = false;
        vm.vergraficoTercero = false;
        vm.listarDepartamento = listarDepartamento;
        vm.listarProvincia = listarProvincia;
        vm.listarDistrito = listarDistrito;
        vm.listaDepartamento = [];
        vm.listaProvincia = [];
        vm.listaDistrito = [];
        vm.departamento = UbigeoFactory.departamento();
        vm.provincia = UbigeoFactory.provincia();
        vm.distrito = UbigeoFactory.distrito();
        vm.filtro = GraficoFactory.model();
        vm.validaOpcionSSOSisoWeb = validaOpcionSSOSisoWeb;
        vm.cantidadUFxTipoEst = 0;
        vm.cantidadUF = 0;
        vm.cantidadUFIMA = 0;
        vm.cantidadCoorporativos = 0;
        vm.cantidadRaking = 0;
        vm.administrado = AdministradoFactory.model();
        vm.buscarAdministrado = buscarAdministrado;
        vm.limpiarAdministrado = limpiarAdministrado;
        vm.esAdministrado = false;
        vm.accesos = [];
        vm.verGrafico = false;
        vm.verCoorporativo = true;
        vm.verRanking = true;
        vm.verTipoEstablecimiento = true;
        vm.verDistribucionUbigeo = true;
        vm.verIncumplimiento = true;
        vm.verIncumplimientoParametro = true;
        vm.verDistribucionUbigeoExcedeConcetra = true;
        vm.changeDepartamento = changeDepartamento;
        vm.changeProvincia = changeProvincia;
        vm.nombreubigeo;
        
        vm.slider = [
            {
                image: 'assets/images/fondo/grifo.jpg',
                title: 'SIN FRONTERAS',
                subtitulo: '',
                id: 0
            }, {
                image: 'assets/images/fondo/grifo-02.jpg',
                title: 'CUIDEMOS NUESTRO AMBIENTE',
                subtitulo: '',
                id: 1
            }
        ]
        

        function validaOpcionSSOSisoWeb(opcion) {
        	  AccesoFactory.opciones(localStorage.objlocalStRefSisoplkijsq).then(function(response) {
        		  vm.accesos = response;
        		  for (var int = 0; int < vm.accesos.length; int++) {
                      var _opcion = vm.accesos[int];
                      if (_opcion.elemento == opcion) {
                    	  vm.verGrafico = true;
                      }
                  }
              }).catch(function(error) {
            	  vm.verGrafico = false;
              });
        }
        
        function listarDepartamento() {
            vm.listaDepartamento = [{
                codigoDepartamento: '',
                descripcionDepartamento: 'Todos'
            }];
            UbigeoFactory.listarDepartamento(vm.departamento).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDepartamento.push(response.data[x]);
                    }
                    /* vm.dataDenuncia.tipoPersona=0; */
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }

        function listarProvincia() {
            vm.listaProvincia = [{
                codigoProvincia: '',
                descripcion: 'Todos'
            }];
            var provincia = {
            	codigoDepartamento : vm.filtro.codigodepartamento
            };
            
            UbigeoFactory.listarProvincia(provincia).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaProvincia.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }

        function listarDistrito() {
            vm.listaDistrito = [{
                codigoDistrito: '',
                descripcionDistrito: 'Seleccione'
            }];

            var distrito = {
                	codigoDepartamento : vm.filtro.codigodepartamento,
                	codigoProvincia: vm.filtro.codigoprovincia
                };
            
            UbigeoFactory.listarDistrito(distrito).then(function(response) {
                if (response.valido) {
                    for (var x in response.data) {
                        vm.listaDistrito.push(response.data[x]);
                    }
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            }).finally(function() {
            });
        }
        
        function changeDepartamento(){
            	vm.filtro.codigoprovincia = null;
            	verDistribucionUbigeo();
        		verDistribucionTipoEstablecimiento();
        		verDistribucionExcedeConcentracion();
        		listarProvincia();
        		vm.verIncumplimiento = false;
        		vm.verIncumplimientoParametro = false;
        }
        
        function changeProvincia(){
        		verDistribucionUbigeo();
        		verDistribucionTipoEstablecimiento();
        		verDistribucionExcedeConcentracion();
        		listarDistrito();
        		vm.verIncumplimiento = false;
        		vm.verIncumplimientoParametro = false;
        }
        
        
        if (angular.isDefined(localStorage.wkuNomUsu)) {
            vm.nombreUsuario = localStorage.wkuNomUsu;            
        }

       
        /* declaracion de variables globales */
        /* declaración de métodos enlazados a la vista */
        /* implementación de métodos */
        
        function createChartInstalaciones(dps,dps2) {
        	
        	if(dps.length==0){
        		vm.verDistribucionUbigeo = false;
        		return;
        	}
        	
        	vm.verDistribucionUbigeo = true;
            var chart1 = new CanvasJS.Chart("chartBarInstalaciones", {
            	colorSet: "customColorSet2",
              title: {
            	fontFamily: "Arial",
              	fontWeight: "bold",
              	fontSize: 14,
                text: "Unidades fiscalizables que reportaron el informe de monitoreo (Total=" + vm.cantidadUFIMA + ")"
              },
              axisX:{
           	   labelFontSize:10,
           	   interval: 1
           	 },
           	 axisY:{
           		 gridColor: "transparent",
           	 },
              exportEnabled: true,
              dataPointMaxWidth: 30,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "top",
          		horizontalAlign: "center",
          	  },
              data: [{
            	indexLabel: "{y}",
            	name: "Registrados",
            	showInLegend: true,
            	type: "stackedColumn",
                dataPoints: dps
              },
              {
            	  click: function(e){
            			console.log("e.dataSeries.name:",e.dataSeries.name);	
            			console.log("e.dataSeries.type:",e.dataSeries.type);
            			console.log("e.dataPoint.label:",e.dataPoint.label);
            			console.log("e.dataPoint.y:",e.dataPoint.y);
            			console.log("vm.idadministrado", vm.administrado.idAdministrado);
            			
            			var nomdepartamento = "",nomprovincia = "", nomdistrito = "";
            			
            			if(vm.filtro.codigodepartamento == null || vm.filtro.codigodepartamento == ''){
            				nomdepartamento = e.dataPoint.label;
            			}
            			if(vm.filtro.codigodepartamento != null && vm.filtro.codigodepartamento != ''){
            				nomdepartamento = '';
            				nomprovincia =  e.dataPoint.label ;
            			}
            			if(vm.filtro.codigoprovincia != null && vm.filtro.codigoprovincia != ''){
            				nomdepartamento = '';
            				nomprovincia = '';
            				nomdistrito =  e.dataPoint.label ;
            			}
            			
            			vm.nombreubigeo = e.dataPoint.label;
            			
            			var tempFiltro = {
            					idAdministrado: vm.administrado.idAdministrado,
            					nombredepartamento: nomdepartamento ,
            					nombreprovincia: nomprovincia,
            					nombredistrito: nomdistrito
            			};
            			
            			GraficoFactory.incumplimientosxTipoEstablecimiento(angular.copy(tempFiltro)).then(function(response) {
                            if (response.valido) {
                            	createChartIncumplimiento1(angular.copy(response.data[0]),angular.copy(response.data[1]),angular.copy(response.data[2]),angular.copy(response.data[3]),angular.copy(response.data[4]));
                            } else {
                                toastr.error(response.mensaje);
                            }
                        }).catch(function(error) {
                            toastr.error('Error al consultar');
                        });
            	},
            	indexLabel: "{y}",
            	name: "Reportaron IMA",
            	showInLegend: true,
            	type: "stackedColumn",
                dataPoints: dps2
                }]
            });
            chart1.render();
        }
        
        
        function createChartCooporativo(dps,dps2) {
            var chart1 = new CanvasJS.Chart("chartBarCoorporativo", {
            	colorSet: "customColorSet1",
              title: {
                fontFamily: "Arial",
              	fontWeight: "bold",
              	fontSize: 14,
                text: "Unidades Fiscalizables del top 5 de Administrados (Total=" + vm.cantidadCoorporativos + ")"
              },
              axisX:{
            	   labelFontSize: 7,
            	   interval: 1,
            	   gridColor: "transparent",
            	 },
            	  axisY:{
               	   gridColor: "transparent",
               	 },
              exportEnabled: true,
              dataPointMaxWidth: 40,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "top",
          	  },
              data: [{
            	indexLabel: "{y}",
            	name: "Registrados",
            	showInLegend: true,
                dataPoints: dps
              },
              {
            	indexLabel: "{y}",
            	name: "Reportados",
            	showInLegend: true,
                dataPoints: dps2
                }]
            });
            chart1.render();
        }
        
        
        
        function createChartRanking(dps) {
        	 
            var chart1 = new CanvasJS.Chart("chartBarRanking", {
              colorSet: "greenShades",
              title: {
            	fontFamily: "Arial",
              	fontWeight: "bold",
              	fontSize: 14,
                text: "Top 5 de Administrados (Total=" + vm.cantidadRaking + ")"
              },
              axisX:{
            	  gridColor: "transparent",
           	      labelFontSize: 9,
           	      interval: 1
           	 },
           	 axisY:{
           	  gridColor: "transparent"
          	 },
              exportEnabled: true,
              dataPointMaxWidth: 30,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "center",
          		horizontalAlign: "right",
          	  },
              data: [{
            	type: "bar",
            	indexLabel: "{y}",
                dataPoints: dps
              }]
            });
            chart1.render();
        }
        
        
        
        
        function createChartTipoEstablecimiento(dps) {
        	if(dps.length==0){
        		vm.verTipoEstablecimiento = false;
        		return;
        	}
        	vm.verTipoEstablecimiento = true;
            var chart2 = new CanvasJS.Chart("chartPieTipoEstablecimiento", {
            	colorSet: "greenShades",
              title: {
            	fontFamily: "Arial",
            	fontWeight: "bold",
            	fontSize: 12,
                text: "Unidades fiscalizables por tipo de establecimiento (Total=" + vm.cantidadUFxTipoEst + ")"
              },
              axisX:{
              	labelFontSize:10,
              	
              },
              exportEnabled: true,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "center",
          		horizontalAlign: "right",
          		fontSize: 10,
          	  },
              data: [{
            	type: "doughnut",
            	showInLegend: true,
                dataPoints: dps
                }]
            });
            chart2.render();
        }
        
        
        function createChartIncumplimiento1(dps,dps2,dps3,dps4,dps5) {
        	if(dps.length==0){
        		vm.verIncumplimiento = false;
        		return;
        	}
        	
        	vm.verIncumplimiento = true;
            var chart2= new CanvasJS.Chart("chartBarCumplimiento", {
            	colorSet: "greenShades",
              title: {
                text: ""
              },
              axisX:{
              	   labelFontSize: 9,
              	 interval: 1
              	 },
              	axisY:{
              		 gridColor: "transparent",
              	 },
              exportEnabled: true,
              dataPointMaxWidth: 40,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "center",
          		horizontalAlign: "right",
          	  },
              data: [{
            	indexLabel: "{y}",
            	name: "Reportados",
            	showInLegend: true,
                dataPoints: dps
              },
              {
            	indexLabel: "{y}",
            	name: "Cumplen",
            	showInLegend: true,
                dataPoints: dps2
              },
              {
            	indexLabel: "{y}",
            	name: "Inc. Frecuencia",
            	showInLegend: true,
                dataPoints: dps3
              },
              {
              	indexLabel: "{y}",
              	name: "Inc. Puntos",
              	showInLegend: true,
                dataPoints: dps4
              },
              {
            	  click: function(e){
            		
            			var nomdepartamento = "",nomprovincia = "", nomdistrito = "";
            			
            			if(vm.filtro.codigodepartamento == null || vm.filtro.codigodepartamento == ''){
            				nomdepartamento = vm.nombreubigeo;
            			}
            			if(vm.filtro.codigodepartamento != null && vm.filtro.codigodepartamento != ''){
            				nomdepartamento = '';
            				nomprovincia =  vm.nombreubigeo;
            			}
            			if(vm.filtro.codigoprovincia != null && vm.filtro.codigoprovincia != ''){
            				nomdepartamento = '';
            				nomprovincia = '';
            				nomdistrito = vm.nombreubigeo;
            			}
            			
            			var tempFiltro = {
            					idAdministrado: vm.administrado.idAdministrado,
            					nombredepartamento: nomdepartamento ,
            					nombreprovincia: nomprovincia,
            					nombredistrito: nomdistrito,
            					nombreestablecimiento: e.dataPoint.label
            			};
            			
            			GraficoFactory.incumplimientoParametros(angular.copy(tempFiltro)).then(function(response) {
                            if (response.valido) {
                            	createChartIncParametros(angular.copy(response.data[0]));
                            } else {
                                toastr.error(response.mensaje);
                            }
                        }).catch(function(error) {
                            toastr.error('Error al consultar');
                        });
            	},
            	
              	indexLabel: "{y}",
              	name: "Inc. Parámetros",
              	showInLegend: true,
                dataPoints: dps5
              }  
              
             ]
            });
            chart2.render();
        }
        
        
        function createChartIncParametros(dps) {
        	if(dps.length==0){
        		vm.verIncumplimientoParametro = false;
        		return;
        	}
        	
        	vm.verIncumplimientoParametro = true;
        	
            var chart = new CanvasJS.Chart("chartPieIncParametros", {
            	colorSet: "greenShades",
              title: {
            	fontFamily: "Arial",
            	fontWeight: "bold",
            	fontSize: 14,
                text: "Incumplimiento de Parámetros"
              },
              axisX:{
              	labelFontSize:10,
              },
              exportEnabled: true,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "center",
          		horizontalAlign: "right",
          		fontSize: 10,
          	  },
              data: [{
            	type: "doughnut",
            	showInLegend: true,
                dataPoints: dps
                }]
            });
            chart.render();
        }
        
        
        function createChartExcedeConcetracion(dps) {
       	 
        	if(dps.length==0){
        		vm.verDistribucionUbigeoExcedeConcetra = false;
        		return;
        	}
        	
        	vm.verDistribucionUbigeoExcedeConcetra = true;
            var chart1 = new CanvasJS.Chart("chartBarExcedeConcetra", {
            	colorSet: "customColorSet2",
              title: {
            	fontFamily: "Arial",
              	fontWeight: "bold",
              	fontSize: 14,
                text: "Unidades Fiscalizables - Exceden concetración"
              },
              axisX:{
           	   labelFontSize:10,
           	   interval: 1
           	 },
           	 axisY:{
           		 gridColor: "transparent",
           	 },
              exportEnabled: true,
              dataPointMaxWidth: 30,
              legend: {
          		cursor: "pointer",
          		itemclick: toggleDataSeries,
          		verticalAlign: "top",
          		horizontalAlign: "center",
          	  },
              data: [{
            	indexLabel: "{y}",
            	name: "Exceden Concentración",
            	showInLegend: true,
            	type: "stackedColumn",
                dataPoints: dps
              },
              {
            	  click: function(e){
            			console.log("e.dataSeries.name:",e.dataSeries.name);	
            			console.log("e.dataSeries.type:",e.dataSeries.type);
            			console.log("e.dataPoint.label:",e.dataPoint.label);
            			console.log("e.dataPoint.y:",e.dataPoint.y);
            			console.log("vm.idadministrado", vm.administrado.idAdministrado);
            			
            			var nomdepartamento = "",nomprovincia = "", nomdistrito = "";
            			
            			if(vm.filtro.codigodepartamento == null || vm.filtro.codigodepartamento == ''){
            				nomdepartamento = e.dataPoint.label;
            			}
            			if(vm.filtro.codigodepartamento != null && vm.filtro.codigodepartamento != ''){
            				nomdepartamento = '';
            				nomprovincia =  e.dataPoint.label ;
            			}
            			if(vm.filtro.codigoprovincia != null && vm.filtro.codigoprovincia != ''){
            				nomdepartamento = '';
            				nomprovincia = '';
            				nomdistrito =  e.dataPoint.label ;
            			}
            			
            			vm.nombreubigeo = e.dataPoint.label;
            			
            			var tempFiltro = {
            					idAdministrado: vm.administrado.idAdministrado,
            					nombredepartamento: nomdepartamento ,
            					nombreprovincia: nomprovincia,
            					nombredistrito: nomdistrito
            			};
            			
// GraficoFactory.incumplimientosxTipoEstablecimiento(angular.copy(tempFiltro)).then(function(response)
// {
// if (response.valido) {
// createChartIncumplimiento1(angular.copy(response.data[0]),angular.copy(response.data[1]),angular.copy(response.data[2]),angular.copy(response.data[3]),angular.copy(response.data[4]));
// } else {
// toastr.error(response.mensaje);
// }
// }).catch(function(error) {
// toastr.error('Error al consultar');
// });
            	  }
                }]
            });
            chart1.render();
        }
        
        
        
        
        
      
        function init(){
        	
        	CanvasJS.addColorSet("customColorSet1",
        		     [
        		     "#6c579b",
        		     "#41ccb2",
        		     "#1BCDD1",
        		     "#8FAABB",
        		     "#B08BEB",
        		     "#3EA0DD",
        		     "#F5A52A",
        		     "#23BFAA",
        		     "#FAA586",
        		     "#EB8CC6",
        		    ]); 
        	
        	CanvasJS.addColorSet("customColorSet2",
       		     [
       		     "#41ccb2",
       		     "#ffaa5b",
       		     "#1BCDD1",
       		     "#8FAABB",
       		     "#B08BEB",
       		     "#3EA0DD",
       		     "#F5A52A",
       		     "#23BFAA",
       		     "#FAA586",
       		     "#EB8CC6",
       		    ]); 
        	
        	
// vm.filtro.codigodepartamento = '15';
// vm.filtro.codigoprovincia = '01';
             validaOpcionSSOSisoWeb('Reporte de Incumplimiento');
        	 
             var data = {
                 prm1: localStorage.objlocalStRefSisoplkijsq,
                 prm2: localStorage.wk 
             };
             AdministradoFactory.buscarxid( /* vm.dataAdministrado */ angular.copy(data)).then(function(response) {
                 if (response.valido) {
                     vm.administrado = response.data;
                     if(vm.administrado.idAdministrado != 0){
                 		vm.filtro.idAdministrado = vm.administrado.idAdministrado;
                 		 vm.esAdministrado = true;
                 	 }
                     // verificamos si es administrado o coorporativo
                     if(vm.administrado != null){
                    	 AdministradoFactory.contarAdministrado( /* vm.dataAdministrado */ angular.copy(vm.administrado)).then(function(response) {
                             if (response.valido) {
                                 if(response.data > 0){
                                	 vm.esAdministrado = true;	
                                 }
                             } 
                         }).catch(function(error) {
                             toastr.error('Error al consultar');
                         }).finally(function() {
                         });
                     }
                     
                 } 
             }).catch(function(error) {
                 toastr.error('Error al consultar');
             }).finally(function() {
            	 if( vm.esAdministrado){
            		 $state.go('spapp.home.supervision.accion-instalacion');
                	 return;
            	 }
            	 
            		 listarDepartamento();
                    	listarProvincia();
                    	verDistribucionUbigeo();
                    	verDistribucionTipoEstablecimiento();
                    	verDistribucionExcedeConcentracion();
                    	verDistribucionCoorporativo();
                    	verDistribucionRanking();
                    	
            		
             });
        	
        }
        
        function verDistribucionUbigeo(){
        		GraficoFactory.instalacionesxDepartamentos(angular.copy(vm.filtro)).then(function(response) {
                    if (response.valido) {
                    	GraficoFactory.cantidadUnidadesFiscalizablesIMA(angular.copy(vm.filtro)).then(function(response2) {
                            if (response2.valido) {
                            	vm.cantidadUFIMA = angular.copy(response2.data);
                            	createChartInstalaciones(angular.copy(response.data[0]),angular.copy(response.data[1]));
                            } else {
                                toastr.error(response2.mensaje);
                            }
                        }).catch(function(error) {
                            toastr.error('Error al consultar');
                        });
                    	
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
        }
        
        function verDistribucionTipoEstablecimiento(){
        	GraficoFactory.instalacionesxTipoEstablecimiento(angular.copy(vm.filtro)).then(function(response) {
                if (response.valido) {
                	 GraficoFactory.cantidadUnidadesFiscalizablesxTipoEstablecimiento(angular.copy(vm.filtro)).then(function(response2) {
                         if (response2.valido) {
                         	vm.cantidadUFxTipoEst = angular.copy(response2.data);
                         	createChartTipoEstablecimiento(angular.copy(response.data[0]));
                         } else {
                             toastr.error(response2.mensaje);
                         }
                     }).catch(function(error) {
                         toastr.error('Error al consultar');
                     });
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        
        function verDistribucionCoorporativo(){
        		GraficoFactory.distribucionCoorporativo(angular.copy(vm.filtro)).then(function(response) {
                    if (response.valido) {
                    	 GraficoFactory.cantidadCoorporativos(angular.copy(vm.filtro)).then(function(response2) {
                             if (response2.valido) {
                             	 vm.cantidadCoorporativos = angular.copy(response2.data);
                             	 createChartCooporativo(angular.copy(response.data[0]),angular.copy(response.data[1]));
                             } else {
                                 toastr.error(response2.mensaje);
                             }
                         }).catch(function(error) {
                             toastr.error('Error al consultar');
                         });
                    	
                    } else {
                        toastr.error(response.mensaje);
                    }
                }).catch(function(error) {
                    toastr.error('Error al consultar');
                });
        }
        
        function verDistribucionRanking(){
    		GraficoFactory.coorporativoRanking(angular.copy(vm.filtro)).then(function(response) {
                if (response.valido) {
                	GraficoFactory.cantidadUnidadesFiscalizables(angular.copy(GraficoFactory.model())).then(function(response2) {
                        if (response2.valido) {
                        	vm.cantidadRaking = angular.copy(response2.data);
                        	createChartRanking(angular.copy(response.data[0]));
                        } else {
                            toastr.error(response2.mensaje);
                        }
                    }).catch(function(error) {
                        toastr.error('Error al consultar');
                    });
                	
                } else {
                    toastr.error(response.mensaje);
                }
            }).catch(function(error) {
                toastr.error('Error al consultar');
            });
        }
        
        
        function verDistribucionExcedeConcentracion(){
    		// GraficoFactory.instalacionesExcedenConcentra(angular.copy(vm.filtro)).then(function(response)
			// {
              // if (response.valido) {
// GraficoFactory.cantidadUnidadesFiscalizables(angular.copy(GraficoFactory.model())).then(function(response2)
// {
// if (response2.valido) {
// vm.cantidadRaking = angular.copy(response2.data);
              // createChartExcedeConcetracion(angular.copy(response.data[0]));
// } else {
// toastr.error(response2.mensaje);
// }
// }).catch(function(error) {
// toastr.error('Error al consultar');
// });
                	
                // } else {
                  // toastr.error(response.mensaje);
               // }
            // }).catch(function(error) {
              // toastr.error('Error al consultar');
            // });
        }
        
        function toggleDataSeries(e) {
        	if (typeof (e.dataSeries.visible) === "undefined" || e.dataSeries.visible) {
        		e.dataSeries.visible = false;
        	} else {
        		e.dataSeries.visible = true;
        	}
        	e.chart.render();
        }
        
        function buscarAdministrado() {
        	 ngDialog.open({
                 template: 'app/modules/supervision/administrado/selector/administrado-selector.html',
                 controller: 'AdministradoSelectorController',
                 controllerAs: 'vm',
                 width: '800px'
             }).closePromise.then(function() {
            	 vm.administrado = $rootScope.objAdministrado;
            	 vm.filtro.idAdministrado = vm.administrado.idAdministrado;
            	 verDistribucionUbigeo();
             	 verDistribucionTipoEstablecimiento();
             	verDistribucionExcedeConcentracion();
             	 vm.verIncumplimiento = false;
             	 vm.verIncumplimientoParametro = false;
             });
        }
        
        function limpiarAdministrado(){
        	vm.administrado = AdministradoFactory.model();
        	vm.filtro.idAdministrado =vm.administrado.idAdministrado ;
        	 verDistribucionUbigeo();
         	 verDistribucionTipoEstablecimiento();
        }
        
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp.etapa').controller('InformesController', InformesController);
    /* @ngInject */
    function InformesController(ngDialog, toastr, $scope, $rootScope, EtapaFactory,CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 10,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstEtapas = [];
        /* variables de paginacion */
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregarItem = agregarItem;
        vm.confirmarEliminacion = confirmarEliminacion;
        vm.confirmarInactivacion = confirmarInactivacion;
        /* implementación de metodos */
        vm.prmEtapa = EtapaFactory.model();
        
        vm.listaTipoInformes = [];
        vm.prmInstalacion;
        vm.mostrarNuevo = false;

        function agregarItem() {
            	$rootScope.itemEtapa =  EtapaFactory.model();
            	vm.mostrarNuevo = true;
        }

        function confirmarEliminacion(prmEtapa) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmEtapa.codetapa);
            });
        }
        
        function confirmarInactivacion(prmEtapa) {
        	
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar inactivación',
                    Mensaje: '¿Está seguro de inactivar el registro: ' + prmEtapa.descripcion + '?'
                },
                width: '380px'
            }).then(function(okValue) {
                inactivar(prmEtapa.codetapa);
            });
        }

        function eliminar(codetapa) {
            var temp = {
            	codetapa: codetapa
            };
            EtapaFactory.eliminar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la etapa');
            });
        }
        
        function inactivar(codetapa) {
            var temp = {
            	codetapa: codetapa,
            	idsession : CookiesFactory.obtenerCookie(),
            };
            EtapaFactory.inactivar(angular.copy(temp)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al inactivar la etapa');
            });
        }

        function listar() {
        	 console.log("vm.listar " + vm.prmEtapa.estado);
            // var codigosCombos = ['TipoEvento','TipoSituacionEvento'];
            EtapaFactory.listar(angular.copy(vm.prmEtapa)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstEtapas = angular.copy(response.data);
                    console.log("vm.lstEtapas" + angular.toJson(vm.lstEtapas));
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }

        function init() {
            /*
			 * var codigos=['']; cargarCombos(codigos);
			 */
        	  if (angular.isDefined(localStorage.objInstalacion)) {
                  vm.prmInstalacion = angular.copy(angular.fromJson(localStorage.objInstalacion));
                  listar();
              }
            
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.maestro').config(routeConfig);
    /* @ngInject */
    function routeConfig($stateProvider) {
        /*inicio de route*/
        $stateProvider.state('spapp.home.maestros', {
            url: '/maestros',
            templateUrl: 'app/modules/maestro/maestro.html',
            controller: 'MaestroController',
            controllerAs: 'vm'
        }).state('spapp.home.maestros.listado', {
            url: '/listado',
            templateUrl: 'app/modules/maestro/listado/maestro-listado.html',
            controller: 'MaestroListadoController',
            controllerAs: 'vm'
        });
        /*fin de route*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.maestro').controller('MaestroController', MaestroController);
    /** @ngInject */
    function MaestroController($state, AccesoFactory, $rootScope, $log, toastr, $location) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Tab por defecto el primero
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        function leerOperaciones(ref) {
            AccesoFactory.operaciones(ref, "Mantenimiento Generico").then(function(response) {
                $rootScope.sisoOperacioneswkWeb = response; //angular.toJson(response);
                //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                $rootScope.sisoValidaOperacionesWbUvk = sisoValidaOperacionesWbUvk;
            }).catch(function(error) {
                toastr.error(error);
            });
        }
        /*
                function leerOperaciones(ref) {

                    AccesoFactory.operaciones(ref,56).then(function (response)
                    {
                        $rootScope.sisoOperacioneswkWeb=response;//angular.toJson(response);
                        //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                        $rootScope.sisoValidaOperacionesWbUvk=sisoValidaOperacionesWbUvk;
                    }).catch(function (error) 
                    {
                        toastr.error(error);
                    });
                }
                */
        function sisoValidaOperacionesWbUvk(operacion) {
        	 console.log('oOperacion.elemento ' + $rootScope.sisoOperacioneswkWeb.length);
            for (var int = 0; int < $rootScope.sisoOperacioneswkWeb.length; int++) {
                var oOperacion = $rootScope.sisoOperacioneswkWeb[int];
                console.log('oOperacion.elemento ' + oOperacion.elemento);
                if (oOperacion.elemento == operacion) {
                    return true;
                }
            }
            return false;
        }
        if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
            leerOperaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq));
            $rootScope.kqlRefRootSiso = angular.copy(localStorage.objlocalStRefSisoplkijsq);
        } else {
            leerOperaciones($rootScope.kqlRefRootSiso);
        }
        /*fin de metodos*/
    }
})();
(function() {
	'use strict';
	angular.module('spapp.etapa').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider.state('spapp.home.etapa', {
			url : '/etapas',
			templateUrl : 'app/modules/etapa/etapa.html',
			controller : 'EtapaController',
			controllerAs : 'vm'
		}).state('spapp.home.etapa.listado', {
			url : '/listado',
			templateUrl : 'app/modules/etapa/listado/etapa-listado.html',
			controller : 'EtapaListadoController',
			controllerAs : 'vm'
		});
		/* fin de route */
	}
})();
(function() {
	'use strict';
	angular.module('spapp.etapa')
			.controller('EtapaController', EtapaController);
	/* @ngInject */
	function EtapaController($state, AccesoFactory, $rootScope, $log, toastr,
			$location) {
		var vm = this;
	}
})();
(function() {
	'use strict';
	angular.module('spapp.eor').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider.state('spapp.home.eor', {
			url : '/eor',
			templateUrl : 'app/modules/eor/eor.html',
			controller : 'EorController',
			controllerAs : 'vm'
		}).state('spapp.home.eor.listado', {
			url : '/listado',
			templateUrl : 'app/modules/eor/listado/eor-listado.html',
			controller : 'EorListadoController',
			controllerAs : 'vm'
		});
		/* fin de route */
	}
})();
(function() {
	'use strict';
	angular.module('spapp.eor')
			.controller('EorController', EorController);
	/* @ngInject */
	function EorController($state, AccesoFactory, $rootScope, $log, toastr,
			$location) {
		var vm = this;
	}
})();
(function() {
	'use strict';
	angular.module('spapp.componente').config(routeConfig);
	/* @ngInject */
	function routeConfig($stateProvider) {
		/* inicio de route */
		$stateProvider.state('spapp.home.componente', {
			url : '/componentes',
			templateUrl : 'app/modules/componente/componente.html',
			controller : 'ComponenteController',
			controllerAs : 'vm'
		}).state('spapp.home.componente.listado', {
			url : '/listado',
			templateUrl : 'app/modules/componente/listado/componente-listado.html',
			controller : 'ComponenteListadoController',
			controllerAs : 'vm'
		});
		/* fin de route */
	}
})();
(function() {
	'use strict';
	angular.module('spapp.componente')
			.controller('ComponenteController', ComponenteController);
	/* @ngInject */
	function ComponenteController($state, AccesoFactory, $rootScope, $log, toastr,
			$location) {
		var vm = this;
	}
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('ComponenteParametrosController', ComponenteParametrosController);
    /* @ngInject */
    function ComponenteParametrosController(ngDialog, toastr, $scope, $rootScope, ComponenteAmbientalFactory, ComponenteAmbientalParametroFactory, MaestroFactory, NormaLegalFactory, NormasFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstParametrosComponente = [];
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        vm.agregar = agregar;
        vm.confirmarEliminacion = confirmarEliminacion;
        /* implementación de metodos */
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.lstUnidadMedida = [];
        vm.lstFrecuencia = [];
        vm.lstNormaLegal = [];
        vm.prmComponenteParametro = ComponenteAmbientalParametroFactory.model();

        function agregar() {
        	$rootScope.lstParametrosBase = vm.lstParametrosComponente;
        	$rootScope.prmComponente =  vm.prmComponente;
                        	  ngDialog.open({
                                  template: 'app/modules/parametro/dialog/parametro-selector.html',
                                  controller: 'ParametroSelectorController',
                                  controllerAs: 'vm',
                                  width: '1000px'
                              }).closePromise.then(function(dataDialog) {
                            	  vm.prmComponenteParametro.componente = ComponenteAmbientalParametroFactory.model();
                                  listar();
                              });
        }

        function confirmarEliminacion(prmComponenteParametro) {
            ngDialog.openConfirm({
                template: 'app/base/template/dialog-confirm/dialog-confirm.html',
                controller: 'DialogConfirmController',
                controllerAs: 'vm',
                data: {
                    Titulo: 'Confirmar eliminación',
                    Mensaje: '¿Está seguro de eliminar el registro?'
                },
                width: '380px'
            }).then(function(okValue) {
                eliminar(prmComponenteParametro);
            });
        }
        

        function eliminar(prmComponenteParametro) {
        	ComponenteAmbientalParametroFactory.eliminarPorLLave(angular.copy(prmComponenteParametro)).then(function(response) {
                if (response.valido) {
                    toastr.success(response.mensaje);
                    listar();
                } else {
                    toastr.error(response.mensaje)
                }
            }).catch(function(error) {
                toastr.error('Ocurrió un error al eliminar la parametro');
            });
        }

        function listar() {
        	vm.prmComponenteParametro.componente = vm.prmComponente.codigo;
        	ComponenteAmbientalParametroFactory.listar(angular.copy(vm.prmComponenteParametro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstParametrosComponente = angular.copy(response.data);
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarCombos() {
			listarUnidadMedida();
      	  	listarNormaLegal();
      	  	listarFrecuencia();
		}
		
        function listarUnidadMedida() {
        	
        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstUnidadMedida = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstUnidadMedida);
        }
        
        function listarFrecuencia() {
        	var dataFrecuencia = {
        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstFrecuencia = angular.copy(response.data);;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstFrecuencia);
        }
        
        function listarNormaLegal() {
        	 
        	var dataNormaLegal = NormasFactory.modelNormas();
        	dataNormaLegal.componente =  vm.prmComponente.codigo;
        	
        	
        	NormasFactory.listarPorComponente(angular.copy(dataNormaLegal)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstNormaLegal = angular.copy(response.data);
                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }


        function init() {
        	vm.prmComponente = $rootScope.prmComponente;
        	cargarCombos();
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.parametro').controller('ComponenteParametroSelectorController', ComponenteParametroSelectorController);
    /* @ngInject */
    function ComponenteParametroSelectorController(ngDialog, toastr, $scope, $rootScope, ComponenteAmbientalFactory, ComponenteAmbientalParametroFactory, MaestroFactory, NormaLegalFactory, NormasFactory) {
        var vm = this;
        /* declaracion de variables globales */
        /* Configuracion de paginacion de tablas */
        $scope.config = {
            itemsPerPage: 5,
            fillLastPage: true,
            current: 1
        };
        /* fin de configuracion de tablas */
        vm.lstParametrosComponente = [];
        vm.lstParametrosComponenteBase  = [];
        vm.lstMatriz = [];
        vm.lstSubMatriz = [];
        vm.lstParametrosComponenteSel = [];
        vm.matriz;
        vm.submatriz;
        
        /* variables de paginacion */
        vm.opcionesPaginacion = {
            itemsPorPag: 10,
            cantidades: [10, 25, 50, 100]
        };
        /* declaración de metodos enlazados a la vista */
        vm.listar = listar;
        /* implementación de metodos */
        vm.prmComponente = ComponenteAmbientalFactory.model();
        vm.lstUnidadMedida = [];
        vm.lstFrecuencia = [];
        vm.lstNormaLegal = [];
        vm.prmComponenteParametro = ComponenteAmbientalParametroFactory.model();
        vm.guardar = guardar;
        vm.listarSubMatriz = listarSubMatriz;


        function listar() {
        	vm.prmComponenteParametro.componente = vm.prmComponente.codigo;
        	ComponenteAmbientalParametroFactory.listar(angular.copy(vm.prmComponenteParametro)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstParametrosComponente = angular.copy(response.data);
                    if (angular.isDefined($rootScope.lstParametrosComponenteBase)) {
                       	vm.lstParametrosComponenteBase = $rootScope.lstParametrosComponenteBase ;
                       	for (var y = 0; y < vm.lstParametrosComponente.length; y++) { 
                       		for(var x in vm.lstParametrosComponenteBase){
                           		if(vm.lstParametrosComponenteBase[x].idParametroValor == vm.lstParametrosComponente[y].parametro_valor){
                           			// ya existe
                           			vm.lstParametrosComponente.splice(y,1);
                           			y--;
                           			break;
                           		}
                           	}
                       	}
                    }
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos.');
            });
        }
        
        function cargarCombos() {
			listarUnidadMedida();
      	  	listarNormaLegal();
      	  	listarFrecuencia();
      	  	listarMatriz();
      	  	listarSubMatriz();
		}
		
        function listarMatriz(){
        	var prmComponente = {
        			codigo : vm.prmComponente.codigo,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        
        function listarSubMatriz(idMatriz){
        	
        	 vm.lstSubMatriz = [];
        	 
        	if (idMatriz == 0 || idMatriz == null){
        		return;
        	}
        	
        	var prmComponente = {
        			codigo : idMatriz,
        	};
        	
        	 ComponenteAmbientalFactory.listarHijos(angular.copy(prmComponente)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstSubMatriz = angular.copy(response.data);
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener el listado de Matriz.');
             });
        }
        function listarUnidadMedida() {
        	
        	var dataUnidadMedida = {
        		codigoMaestro : 'UNIDAD_MEDIDA',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataUnidadMedida)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstUnidadMedida = response.data;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstUnidadMedida);
        }
        
        function listarFrecuencia() {
        	var dataFrecuencia = {
        		codigoMaestro : 'FRECUENCIA_PARAMETRO',
        		idMaestro			:0,
			  	descripcion 		:'',
        	};
        	
            MaestroFactory.buscarXCodigoMaestro(angular.copy(dataFrecuencia)).then(function(response) {
                if (response != null && response.valido) {
                    vm.lstFrecuencia = angular.copy(response.data);;
                }
            }).catch(function(error) {
                toastr.error('No se pudo obtener los datos para los combos.');
            });
            
            console.log('data ' + vm.lstFrecuencia);
        }
        
        function listarNormaLegal() {
        	 
        	var dataNormaLegal = NormasFactory.modelNormas();
        	
        	NormasFactory.listar(angular.copy(dataNormaLegal)).then(function(response) {
                 if (response != null && response.valido) {
                     vm.lstNormaLegal = angular.copy(response.data);
                     console.log("vm.lstNormaLegal" + angular.toJson(vm.lstNormaLegal));
                 }
             }).catch(function(error) {
                 toastr.error('No se pudo obtener los datos.');
             });
        }
        
        function guardar(){
        	vm.lstParametrosComponenteSel = [];
    			for (var x in vm.lstParametrosComponente) {
                    if (vm.lstParametrosComponente[x].blSeleccionado){
                    	vm.lstParametrosComponente[x].matriz = vm.matriz;
                    	vm.lstParametrosComponente[x].submatriz = vm.submatriz;
                    	vm.lstParametrosComponenteSel.push(vm.lstParametrosComponente[x]);
                    }
                }
    			$rootScope.lstParametrosComponenteSel = vm.lstParametrosComponenteSel;
            	$scope.closeThisDialog();
        }


        function init() {
        	vm.prmComponente = $rootScope.prmComponente;
        	cargarCombos();
        	console.log('vm.prmComponente ' + vm.prmComponente.codigo);
            listar();
        }
        init();
        /* fin de metodos */
    }
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').config(routeConfig);
    /* @ngInject */
    function routeConfig($stateProvider) {
        /*inicio de route*/
        $stateProvider.state('spapp.home.bandeja', {
            url: '/bandeja',
            templateUrl: 'app/modules/bandeja/bandeja.html',
            controller: 'BandejaController',
            controllerAs: 'vm'
        }).state('spapp.home.bandeja.solicitud', {
            url: '/solicitud',
            templateUrl: 'app/modules/bandeja/solicitudes/solicitud-acceso.html',
            controller: 'SolicitudAccesoController',
            controllerAs: 'vm'
        });
        /*
        .state('spapp.home.acciones',{
            url : '/acciones',
            templateUrl : 'app/modules/acciones/acciones.html',
            controller : 'AccionesController',
            controllerAs : 'vm'
        })
        .state('spapp.home.acciones.denunciante',{
            url : '/denunciante',
            templateUrl : 'app/modules/acciones/revisarEfa/revisarEfa.html',
            controller : 'RevisarEfaController',
            controllerAs : 'vm'
        });*/
        /*fin de route*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.bandeja').controller('BandejaController', BandejaController);
    /** @ngInject */
    function BandejaController($state, INTERNAL_HOME_PAGE, AccesoFactory, $rootScope, $log, toastr, $location) {
        var vm = this;
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Primer Tab por defecto
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        function leerOperaciones(ref) {
            AccesoFactory.operaciones(ref, "Bandeja de Solicitudes").then(function(response) {
                $rootScope.sisoOperacioneswkWeb = response; //angular.toJson(response);
                //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                $rootScope.sisoValidaOperacionesWbUvk = sisoValidaOperacionesWbUvk;
            }).catch(function(error) {
                toastr.error(error);
            });
        }
        /*      function leerOperaciones(ref) {

            AccesoFactory.operaciones(ref,58).then(function (response)
            {
                $rootScope.sisoOperacioneswkWeb=response;//angular.toJson(response);
                //$log.log('operaciones x '+$rootScope.sisoOperacioneswkWeb);                
                $rootScope.sisoValidaOperacionesWbUvk=sisoValidaOperacionesWbUvk;
            }).catch(function (error) 
            {
                toastr.error(error);
            });
        }
        */
        function sisoValidaOperacionesWbUvk(operacion) {
            for (var int = 0; int < $rootScope.sisoOperacioneswkWeb.length; int++) {
                var oOperacion = $rootScope.sisoOperacioneswkWeb[int];
                if (oOperacion.elemento == operacion) {
                    return true;
                }
            }
            return false;
        }
        if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
            $log.log('encrypt opt: ', localStorage.objlocalStRefSisoplkijsq);
            leerOperaciones(angular.copy(localStorage.objlocalStRefSisoplkijsq));
            $rootScope.kqlRefRootSiso = angular.copy(localStorage.objlocalStRefSisoplkijsq);
        } else {
            leerOperaciones($rootScope.kqlRefRootSiso);
        }
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('LoginController', LoginController);
    /** @ngInject */
    function LoginController($window, $cookies, $state, INTERNAL_HOME_PAGE, UsuarioFactory, toastr, $rootScope, AccesoFactory, $location, API_CONFIG, CookiesFactory) {
        var vm = this;
        /* declaracion de variables globales */
        vm.usuarioLogin = UsuarioFactory.modelUsuario();
        vm.rutaSSO = API_CONFIG.urlSSO;
        /* declaración de métodos enlazados a la vista */
        /* Fin declaración de métodos enlazados a la vista */
        /* Implementacion de metodos */
        function recuperarSession(sessionTemp) {
            var data = {
                prm1: sessionTemp,
            };
            AccesoFactory.obtenerSesion(data).then(function(response) {
                if (response.valido) {
                    var cookUsuSisoWkUidPkdr = response.data;
                    CookiesFactory.crearCookie(cookUsuSisoWkUidPkdr.ref);
                    var nom = $location.search().wkuNomUsu;
                    var cod = $location.search().wk;
                    localStorage.setItem("wkuNomUsu", nom);
                    localStorage.setItem("wk", cod);
                    $state.go('spapp.home.inicio');
                } else {
                    $window.location.href = vm.rutaSSO + "/Home/Index?wa=wsignout1.0";
                    $state.go('ingreso');
                }
            }).catch(function(error) {
                // toastr.error('xx');
            });
        }

        function logearUsuarioSSO(ref) {
            if (angular.isDefined(ref)) {
                recuperarSession(ref);
            } else {
                localStorage.removeItem('objSesSisoLocStWqKP');
                localStorage.removeItem('objTempPerfilSisopowqkj');
                localStorage.removeItem('objlocalStRefSisoplkijsq');
                localStorage.removeItem("dataListaInstalacion");
                localStorage.removeItem("wk");
                $cookies.remove('cookUsuSisoWkUidPkdr');
                $state.go('ingreso');
            }
        }
        /* Fin implementacion de metodos */
        /* comienzo de ejecucion de metodos iniciales */
        function init() {
            var ref = $location.search().ref;
            logearUsuarioSSO(ref);
        }
        init();
    }
})();
(function() {
    'use strict';
    angular.module('spapp.acceso').config(routeConfig);
    /* @ngInject */
    function routeConfig($stateProvider) {
        /*inicio de route*/
        $stateProvider.state('acceso.inicio', {
            url: '/inicio',
            templateUrl: 'app/modules/acceso/inicio/acceso-inicio.html',
            controller: 'AccesoInicioController',
            controllerAs: 'vm'
        }).state('acceso.registro', {
            url: '/registro',
            templateUrl: 'app/modules/acceso/registro/acceso-registro.html',
            controller: 'AccesoRegistroController',
            controllerAs: 'vm'
        });
        /*fin de route*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp.acceso').controller('AccesoController', AccesoController);
    /** @ngInject */
    function AccesoController($state) {
        var vm = this;
        vm.myInterval = 5000;
        vm.noWrapSlides = false;
        vm.noWrapSlides = false;
        vm.activeSliderImagenes2 = 0;
        vm.slider = [
            // {
            //   image: 'assets/images/fondo/ballena.jpg',
            //   title:'Nuevo Cambio',
            //   subtitulo: 'Sibtitulo Slider 1',
            //   id: 0
            // },
            {
                image: 'http://greenrescue.ancorathemes.com/wp-content/uploads/2016/08/slider1-1.jpg',
                title: 'SIN FRONTERAS',
                subtitulo: '',
                id: 0
            }, {
                image: 'http://greenrescue.ancorathemes.com/wp-content/uploads/2016/08/slider1-3.jpg',
                title: 'CUIDEMOS NUESTRO AMBIENTE',
                subtitulo: '',
                id: 1
            }
        ]
        /*declaracion de variables globales*/
        vm.itemTabActivo = 1; //Primer Tab por defecto
        /*declaración de metodos enlazados a la vista*/
        /*implementación de metodos*/
        /*fin de metodos*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('RootController', RootController);
    /** @ngInject */
    function RootController($rootScope, $state, AccesoFactory, $log, $location, $cookies, $scope, CookiesFactory, $timeout, $interval) {
        var vmRoot = this;
        /* declaracion de variables globales */
        $rootScope.menus = [{
            indice: '1',
            icono: 'glyphicon glyphicon-home',
            titulo: 'Inicio',
            desplegado: false,
            hijos: [],
            state: 'spapp.home',
            tipo: 'link',
            activo: false
        }, {
            indice: '2',
            icono: 'glyphicon glyphicon-wrench',
            titulo: 'Asistencial',
            desplegado: false,
            hijos: [{
                indice: '2.1',
                icono: '',
                titulo: 'Inicio',
                desplegado: false,
                hijos: [],
                state: 'spapp.evento.inicio',
                tipo: 'link',
                activo: false
            }, {
                indice: '2.2',
                icono: '',
                titulo: 'Emergencia',
                desplegado: false,
                hijos: [{
                    indice: '2.2.1',
                    icono: '',
                    titulo: 'Adulto',
                    desplegado: false,
                    hijos: [{
                        indice: '2.2.1.1',
                        icono: '',
                        titulo: 'Filiación',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.2',
                        icono: '',
                        titulo: 'Registro de Atención',
                        desplegado: false,
                        hijos: [{
                            indice: '2.2.1.2.1',
                            icono: '',
                            titulo: 'Antecedentes',
                            desplegado: false,
                            hijos: [],
                            state: 'spapp.evento.registro-atencion-adulto.antecedentes',
                            tipo: 'link',
                            activo: false
                        }, {
                            indice: '2.2.1.2.2',
                            icono: '',
                            titulo: 'Enfermedad Actual',
                            desplegado: false,
                            hijos: [],
                            state: '',
                            tipo: 'link',
                            activo: false
                        }],
                        state: 'spapp.evento.registro-atencion-adulto.antecedentes',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.3',
                        icono: '',
                        titulo: 'Evaluación Médica',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.4',
                        icono: '',
                        titulo: 'Procedimiento',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.5',
                        icono: '',
                        titulo: 'Dosis Unitaria',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.6',
                        icono: '',
                        titulo: 'Receta Médica Electrónica',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.7',
                        icono: '',
                        titulo: 'Registro de Cita',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.8',
                        icono: '',
                        titulo: 'Interconsulta',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }, {
                        indice: '2.2.1.9',
                        icono: '',
                        titulo: 'Referencia y Contrareferencia',
                        desplegado: false,
                        hijos: [],
                        state: '',
                        tipo: 'link',
                        activo: false
                    }],
                    state: '',
                    tipo: 'link',
                    activo: false
                }, {
                    indice: '2.2.2',
                    icono: '',
                    titulo: 'Pediátrica',
                    desplegado: false,
                    hijos: [],
                    state: '',
                    tipo: 'link',
                    activo: false
                }],
                state: 'spapp.evento.inicio',
                tipo: 'link',
                activo: false
            }],
            state: 'spapp.evento.inicio',
            tipo: 'link',
            activo: false
        }, {
            indice: '3',
            icono: 'glyphicon glyphicon-home',
            titulo: 'Administración',
            desplegado: false,
            hijos: [],
            state: 'spapp.administracion.inicio',
            tipo: 'link',
            activo: false
        }, {
            indice: '4',
            icono: 'glyphicon glyphicon-lock',
            titulo: 'Seguridad',
            desplegado: false,
            hijos: [],
            state: 'spapp.seguridad.inicio',
            tipo: 'link',
            activo: false
        }];
        vmRoot.subSistemaActual = null;
        vmRoot.moduloActual = null;
        vmRoot.procesoActual = null;
        vmRoot.subProcesoActual = null;
        vmRoot.tabActual = null;
        /* declaración de métodos enlazados a la vista */
        vmRoot.menuClick = menuClick;
        /* implementación de métodos */
        function menuClick(indiceMenuActual) {
            // debugger;
            switch (indiceMenuActual.length) {
                case 1:
                    vmRoot.subSistemaActual = indiceMenuActual;
                    localStorage.setItem('subSistemaActual', indiceMenuActual);
                    iteracionSubSistemas(vmRoot.subSistemaActual);
                    break;
                case 3:
                    vmRoot.moduloActual = indiceMenuActual;
                    localStorage.setItem('moduloActual', indiceMenuActual);
                    iteracionModulos(vmRoot.subSistemaActual, vmRoot.moduloActual);
                    break;
                case 5:
                    vmRoot.procesoActual = indiceMenuActual;
                    localStorage.setItem('procesoActual', indiceMenuActual);
                    iteracionProcesos(vmRoot.subSistemaActual, vmRoot.moduloActual, vmRoot.procesoActual);
                    break;
                case 7:
                    vmRoot.subProcesoActual = indiceMenuActual;
                    localStorage.setItem('subProcesoActual', indiceMenuActual);
                    iteracionSubProcesos(vmRoot.subSistemaActual, vmRoot.moduloActual, vmRoot.procesoActual, vmRoot.subProcesoActual);
                    break;
                case 9:
                    vmRoot.tabActual = indiceMenuActual;
                    localStorage.setItem('tabActual', indiceMenuActual);
                    iteracionTabs(vmRoot.subSistemaActual, vmRoot.moduloActual, vmRoot.procesoActual, vmRoot.subProcesoActual, vmRoot.tabActual);
                    break;
            }
        }

        function iteracionSubSistemas(indiceSubsistema) {
            for (var i = 0; i < $rootScope.menus.length; i++) {
                if ($rootScope.menus[i].indice == indiceSubsistema) {
                    if ($rootScope.menus[i].state !== '') {
                        $state.go($rootScope.menus[i].state);
                    }
                    $rootScope.menus[i].desplegado = !$rootScope.menus[i].desplegado;
                    $rootScope.menus[i].activo = true;
                } else {
                    $rootScope.menus[i].activo = false;
                }
            }
        }

        function iteracionModulos(indiceSubsistema, indiceModulo) {
            for (var i = 0; i < $rootScope.menus.length; i++) {
                if ($rootScope.menus[i].indice == indiceSubsistema && angular.isDefined($rootScope.menus[i].hijos)) {
                    for (var j = 0; j < $rootScope.menus[i].hijos.length; j++) {
                        if ($rootScope.menus[i].hijos[j].indice === indiceModulo) {
                            if ($rootScope.menus[i].hijos[j].state !== '') {
                                $state.go($rootScope.menus[i].hijos[j].state);
                            }
                            $rootScope.menus[i].hijos[j].desplegado = !$rootScope.menus[i].hijos[j].desplegado;
                            $rootScope.menus[i].hijos[j].activo = true;
                        }
                        $rootScope.menus[i].hijos[j].activo = false;
                    }
                    return;
                }
            }
        }

        function iteracionProcesos(indiceSubsistema, indiceModulo, indiceProceso) {
            for (var i = 0; i < $rootScope.menus.length; i++) {
                if ($rootScope.menus[i].indice == indiceSubsistema && angular.isDefined($rootScope.menus[i].hijos)) {
                    for (var j = 0; j < $rootScope.menus[i].hijos.length; j++) {
                        if ($rootScope.menus[i].hijos[j].indice === indiceModulo) {
                            for (var k = 0; k < $rootScope.menus[i].hijos.length; k++) {
                                if ($rootScope.menus[i].hijos[j].hijos[k].indice === indiceProceso) {
                                    if ($rootScope.menus[i].hijos[j].hijos[k].state !== '') {
                                        $state.go($rootScope.menus[i].hijos[j].hijos[k].state);
                                    }
                                    $rootScope.menus[i].hijos[j].hijos[k].desplegado = !$rootScope.menus[i].hijos[j].hijos[k].desplegado;
                                    $rootScope.menus[i].hijos[j].hijos[k].activo = true;
                                }
                                $rootScope.menus[i].hijos[j].hijos[k].activo = false;
                            }
                            return;
                        }
                    }
                }
            }
        }

        function iteracionSubProcesos(indiceSubsistema, indiceModulo, indiceProceso, indiceSubProceso) {
            for (var i = 0; i < $rootScope.menus.length; i++) {
                if ($rootScope.menus[i].indice == indiceSubsistema && angular.isDefined($rootScope.menus[i].hijos)) {
                    for (var j = 0; j < $rootScope.menus[i].hijos.length; j++) {
                        if ($rootScope.menus[i].hijos[j].indice === indiceModulo) {
                            for (var k = 0; k < $rootScope.menus[i].hijos.length; k++) {
                                if ($rootScope.menus[i].hijos[j].hijos[k].indice === indiceProceso) {
                                    for (var l = 0; l < $rootScope.menus[i].hijos.length; l++) {
                                        if ($rootScope.menus[i].hijos[j].hijos[k].hijos[l].indice === indiceSubProceso) {
                                            if ($rootScope.menus[i].hijos[j].hijos[k].hijos[l].state !== '') {
                                                $state.go($rootScope.menus[i].hijos[j].hijos[k].hijos[l].state);
                                            }
                                            $rootScope.menus[i].hijos[j].hijos[k].hijos[l].desplegado = !$rootScope.menus[i].hijos[j].hijos[k].hijos[l].desplegado;
                                            $rootScope.menus[i].hijos[j].hijos[k].hijos[l].activo = true;
                                        }
                                        $rootScope.menus[i].hijos[j].hijos[k].hijos[l].activo = false;
                                    }
                                    return;
                                }
                            }
                        }
                    }
                }
            }
        }

        function iteracionTabs(indiceSubsistema, indiceModulo, indiceProceso, indiceSubProceso, indiceTab) {
            for (var i = 0; i < $rootScope.menus.length; i++) {
                if ($rootScope.menus[i].indice == indiceSubsistema && angular.isDefined($rootScope.menus[i].hijos)) {
                    for (var j = 0; j < $rootScope.menus[i].hijos.length; j++) {
                        if ($rootScope.menus[i].hijos[j].indice === indiceModulo) {
                            for (var k = 0; k < $rootScope.menus[i].hijos.length; k++) {
                                if ($rootScope.menus[i].hijos[j].hijos[k].indice === indiceProceso) {
                                    for (var l = 0; l < $rootScope.menus[i].hijos.length; l++) {
                                        if ($rootScope.menus[i].hijos[j].hijos[k].hijos[l].indice === indiceSubProceso) {
                                            for (var m = 0; m < $rootScope.menus[i].hijos.length; m++) {
                                                if ($rootScope.menus[i].hijos[j].hijos[k].hijos[l].indice === indiceSubProceso) {
                                                    if ($rootScope.menus[i].hijos[j].hijos[k].hijos[l].hijos[m].state !== '') {
                                                        $state.go($rootScope.menus[i].hijos[j].hijos[k].hijos[l].hijos[m].state);
                                                    }
                                                    $rootScope.menus[i].hijos[j].hijos[k].hijos[l].hijos[m].desplegado = !$rootScope.menus[i].hijos[j].hijos[k].hijos[l].hijos[m].desplegado;
                                                    $rootScope.menus[i].hijos[j].hijos[k].hijos[l].hijos[m].activo = true;
                                                }
                                                $rootScope.menus[i].hijos[j].hijos[k].hijos[l].hijos[m].activo = false;
                                            }
                                            return;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        function leerOpciones(ref) {
        	console.log('ref 2 ' + ref);
            AccesoFactory.opciones(ref).then(function(response) {
                $log.log(response);
                console.log($rootScope.validaOpcionSSOSisoWeb);
                // localStorage.setItem("acceso",angular.toJson(response));
                vmRoot.accesos = response;
                $scope.accesos = vmRoot.accesos;
                $rootScope.validaOpcionSSOSisoWeb = validaOpcionSSOSisoWeb;
            }).catch(function(error) {
                // toastr.error('xx');
            });
        }

        function validaOpcionSSOSisoWeb(opcion) {
            for (var int = 0; int < vmRoot.accesos.length; int++) {
                var _opcion = vmRoot.accesos[int];
                // $log.log('_opcion.elemento '+_opcion.elemento);
                // $log.log('opcion'+opcion);
                if (_opcion.elemento == opcion) {
                    return true;
                }
            }
            return false;
        }

        function init() {
            // crearCookie('dasdasads')
        	console.log('cookie root ' + CookiesFactory.obtenerCookie());
            if (CookiesFactory.obtenerCookie() != null) {
                debugger;
                $rootScope.wqRootRefTempSiso = CookiesFactory.obtenerCookie();
                $rootScope.kqlRefRootSiso = CookiesFactory.obtenerCookie();
                localStorage.removeItem('objlocalStRefSisoplkijsq');
                // localStorage.removeItem('ref');
                localStorage.setItem("objlocalStRefSisoplkijsq", CookiesFactory.obtenerCookie());
                // localStorage.setItem("ref", CookiesFactory.obtenerCookie());
                leerOpciones($rootScope.wqRootRefTempSiso);
            } else {
                localStorage.removeItem('objSesSisoLocStWqKP');
                localStorage.removeItem('objTempPerfilSisopowqkj');
                localStorage.removeItem('objlocalStRefSisoplkijsq');
                $cookies.remove('cookUsuSisoWkUidPkdr');
                $state.go('ingreso');
            }
        }
        init();
        $interval(function() {
            CookiesFactory.validaCookie();
        }, CookiesFactory.obtenerTiempoMilisegundosTerminoSession());
        /* fin de controller */
    }
})();
(function() {
    'use strict';
    angular.module('spapp').controller('SidebarController', SidebarController);
    /** @ngInject */
    function SidebarController($log, $state) {
        var vmSidebar = this;
        /*declaracion de variables globales*/
        vmSidebar.moduloActivo = 0; //por defecto inicio - ningun modulo al crearse el controller
        vmSidebar.subModuloActivo = '';
        vmSidebar.isNavCollapsed = true;
        vmSidebar.isCollapsed = false;
        /*declaración de métodos enlazados a la vista*/
        vmSidebar.activarModulo = activarModulo;
        /*implementación de métodos*/
        function activarModulo(modulo) {
            vmSidebar.moduloActivo = (modulo == vmSidebar.moduloActivo) ? -1 : modulo;
        }

        function init() {
            vmSidebar.moduloActivo = 0; //por defecto el modulo del menu de inicio cuando carga totalmente
            if (angular.isDefined(localStorage.objSesSisoLocStWqKP)) {
                vmSidebar.usuarioActual = angular.fromJson(localStorage.objSesSisoLocStWqKP);
                $log.log("usuarioActual sideBar", vmSidebar.usuarioActual);
            }
        }
        init();
    }
})();
(function() {
	'use strict';

	angular
	.module('spapp')
	.controller('MainController',MainController);


	/** @ngInject */
	function MainController() {
		var vm = this;
		
		/*declaracion de variables globales*/


		/*declaración de métodos enlazados a la vista*/


		/*implementación de métodos*/

		
		/*fin de controller*/
		
	}
})();
(function() {
    'use strict';
    angular.module('spapp').controller('NavbarController', NavbarController);
    /* @ngInject */
    function NavbarController(toastr, $rootScope) {
        var vmNavbar = this;
        /*declaracion de variables globales*/
        vmNavbar.usuarioActual = {
            nombrePerfil: 'Administrador',
            nombreCompletoPersona: 'Daniel Ávila Méndez'
        };
        /*declaración de métodos enlazados a la vista*/
        /*implementación de métodos*/
        /*fin de controller*/
        function init() {
            /*console.log("iniciando NavbarController");
	    	if (angular.isDefined(localStorage.objSesSisoLocStWqKP)) {
	    		vmNavbar.usuarioActual = angular.fromJson(localStorage.objSesSisoLocStWqKP);

		        $rootScope.usuarioActivo = angular.copy(vmNavbar.usuarioActual);

	    	}else {
	    		$state.go('login'); 
	    		toastr.warning('Debe iniciar sesión en el sistema');
	    	}*/
        }
        init();
    }
})();
(function() {
	'use strict';

	angular
	.module('spapp')
	.controller('FooterController',FooterController);


	/** @ngInject */
	function FooterController() {
		var vmFooter = this;
		
		/*declaracion de variables globales*/
		
		vmFooter.templateBy = '123456789';

		/*vmFooter.templateBy = 'Copyright &copy;' + new Date().getFullYear() +
		' galaxybis | Website template by <a href="http://www.galaxybis.com" target="_blank">galaxybis.com</a>';*/

		/*declaración de métodos enlazados a la vista*/


		/*implementación de métodos*/

		
		/*fin de controller*/
		
	}
})();
(function() {
    'use strict';
    angular.module('spapp').controller('HeaderController', HeaderController);
    /** @ngInject */
    function HeaderController($state, $rootScope, toastr, $log, INTERNAL_HOME_PAGE, API_CONFIG, $window, $cookies) {
        var vmHeader = this;
        /*declaracion de variables globales*/
        vmHeader.cerrarSesion = cerrarSesion;
        vmHeader.nombreUsuario = '';
        vmHeader.rutaSSO = API_CONFIG.urlSSO;
        /*declaración de métodos enlazados a la vista*/
        vmHeader.obtenerAccesoMenu = obtenerAccesoMenu;
        /*implementación de métodos*/
        function cerrarSesion() {
            localStorage.removeItem('objSesSisoLocStWqKP');
            localStorage.removeItem('objTempPerfilSisopowqkj');
            localStorage.removeItem('objlocalStRefSisoplkijsq');
            localStorage.removeItem("dataListaInstalacion");
            localStorage.removeItem('ref');
            $cookies.remove('cookUsuSisoWkUidPkdr');
            $window.location.href = vmHeader.rutaSSO + "/Home/Index?wa=wsignout1.0";
            $state.go('ingreso');
        }

        function obtenerAccesoMenu() {
            /*
            $log.log("vmHeader.prmComponente filtro", vmHeader.prmComponente);
            localStorage.setItem('objTempPerfilSisopowqkj',vmHeader.prmComponente.idPerfil);
            */
        }
        /*implementación de métodos*/
        function init() {
            if (angular.isDefined(localStorage.wkuNomUsu)) {
                vmHeader.nombreUsuario = localStorage.wkuNomUsu;
            }
            /*$log.log("iniciando HeaderController");
            if (angular.isDefined(localStorage.objSesSisoLocStWqKP)) {
                vmHeader.usuarioActual = angular.fromJson(localStorage.objSesSisoLocStWqKP);
                $log.log("usuarioActual",vmHeader.usuarioActual);
                $rootScope.usuarioActivo = angular.copy(vmHeader.usuarioActual);

                if (angular.isDefined(localStorage.objTempPerfilSisopowqkj)) {
                    vmHeader.prmComponente.idPerfil = Number(localStorage.objTempPerfilSisopowqkj);
                }else{
                    vmHeader.prmComponente.idPerfil = vmHeader.usuarioActual.listaUsuarioPerfil[0].idPerfil;
                }   

            }else {
                $state.go('login'); 
                toastr.warning('Debe iniciar sesión en el sistema');
            }*/
        }
        init();
        /*fin de controller*/
    }
})();
(function() {
	'use strict';

	angular
	.module('spapp')
	.controller('ErrorPageController',ErrorPageController);


	/** @ngInject */
	function ErrorPageController() {
		var vm = this;
		
		/*declaracion de variables globales*/


		/*declaración de métodos enlazados a la vista*/


		/*implementación de métodos*/

		
		/*fin de controller*/
		
	}
})();
(function() {
  'use strict';

  angular
      .module('spapp')
      .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('spapp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
          creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creationDate" is available by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('spapp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('spapp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function(value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function() {
        angular.forEach(vm.contributors, function(contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function() {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function(data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function() {
	'use strict';

	angular
		.module('spapp')
		.filter('zeroPadding', zeroPaddingFilter);

	/* @ngInject */
	function zeroPaddingFilter($filter) {
		var filter = function (input, length) {
			//return $filter('number')(input * 100, decimals) + ' %';
			var num = parseInt(input, 10);
            length = parseInt(length, 10);
            if (isNaN(num) || isNaN(length)) {
                return input;
            }
            num = '' + num;
            while (num.length < length) {
                num = '0' + num;
            }
            return num;
		}
		return filter;
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.filter('percentage', percentageFilter);

	/* @ngInject */
	function percentageFilter($filter) {
		var filter = function (input, decimals) {
			return $filter('number')(input * 100, decimals) + ' %';
		}
		return filter;
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.filter('convert', convertFilter);

	/* @ngInject */
	function convertFilter($filter) {
		var filter = function(input, len, pad){
	    if(input === null) return input;
	    input = input.toString();
	    if(input.length >= len) return input;
	    else{
	      pad = (pad || 0).toString();
	      return new Array(1 + len - input.length).join(pad) + input;
	    }
	  };
		return filter;
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('ExportFactory', ExportFactory);

	/* @ngInject */
	function ExportFactory($window) {
		
		var uri='data:application/vnd.ms-excel;base64,';
        var template ='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
        
        return {
            tableToExcel : tableToExcel
        };

        /*implementacion de metodos*/

        function tableToExcel(idTabla, nombreHojaExcel) {
        	
        	var table = angular.element(idTabla);
            var ctx = {
            	worksheet : nombreHojaExcel,
            	table : table.html()
            };
            var href = uri+base64(format(template,ctx));
            
            return href;
        }

        function base64(s) {
        	return $window.btoa(unescape(encodeURIComponent(s)));
        }

        function format(s, c) {
        	return s.replace(/{(\w+)}/g,function(m,p){return c[p];})
        }

        /*fin de factory*/
	}

})();

(function() {
	'use strict';

		angular
		.module('spapp')
		.factory('ErrorFactory',ErrorFactory);

	/* @ngInject */
	function ErrorFactory($state, $log) {

		var factory = {
			redirect : redirect
		};

		return factory;
		
		/*implementación de métodos*/

		function redirect(error) {

			var val=error[0];

			$log.error(error);
	        if (error[1]===404) {
	          $state.go('mtp.404');
	        }
	        if (error[1]===500) {
	          $state.go('mtp.500');
	        }
	        if (error[1]===400) {
	          $state.go('mtp.400');
	        }
		}


		/*fin de factory*/
	}

})();
(function() {
    'use strict';
    angular.module('spapp').factory('CookiesFactory', CookiesFactory);
    /* @ngInject */
    function CookiesFactory($q, $http, $rootScope, $cookies, $state, API_CONFIG, $window) {
        var factory = {
            generarTiempoSession: generarTiempoSession,
            crearCookie: crearCookie,
            obtenerCookie: obtenerCookie,
            aumentarTiempoCookie: aumentarTiempoCookie,
            obtenerObjCookie: obtenerObjCookie,
            validaCookie: validaCookie,
            obtenerTiempoMilisegundosTerminoSession: obtenerTiempoMilisegundosTerminoSession
        };
        return factory;
        /*****************************************************************************************/
        function generarTiempoSession() {
            var today = new Date();
            var expiresValue = new Date(today);
            expiresValue.setMinutes(today.getMinutes() + 30);
            return expiresValue;
        }

        function crearCookie(prmRef) {
            var cookUsuSisoWkUidPkdr = {
                ref: prmRef,
                tiempoSession: generarTiempoSession()
            };
            var data = angular.toJson(cookUsuSisoWkUidPkdr);
            $cookies.put('cookUsuSisoWkUidPkdr', data, {
                'expires': generarTiempoSession()
            });
        }

        function aumentarTiempoCookie() {
            if (angular.isDefined($cookies.get('cookUsuSisoWkUidPkdr'))) {
                var obj = $cookies.get('cookUsuSisoWkUidPkdr');
                var data = angular.fromJson(obj);
                crearCookie(data.ref);
            }
//            else{
//            	 $state.go('ingreso');
//            }
        }

        function obtenerCookie() {
        	console.log('cookie ' +  $cookies.get('cookUsuSisoWkUidPkdr'));
            var dataRef = null;
            if (angular.isDefined($cookies.get('cookUsuSisoWkUidPkdr'))) {
                var obj = $cookies.get('cookUsuSisoWkUidPkdr');
                var data = angular.fromJson(obj);
                crearCookie(data.ref);
                dataRef = data.ref;
                console.log('--> dataRef :' + dataRef);
            }
            return dataRef;
        }

        function validaCookie() {
            if (!angular.isDefined($cookies.get('cookUsuSisoWkUidPkdr'))) {
                localStorage.removeItem('objSesSisoLocStWqKP');
                localStorage.removeItem('objTempPerfilSisopowqkj');
                localStorage.removeItem('objlocalStRefSisoplkijsq');
                localStorage.removeItem('ref');
                $window.location.href = API_CONFIG.urlSSO + "/Home/Index?wa=wsignout1.0";
                console.log('dataUrlSSO' + API_CONFIG.urlSSO);
                $state.go('ingreso');
            }
        }

        function obtenerObjCookie() {
            var dataRef = null;
            if (angular.isDefined($cookies.get('cookUsuSisoWkUidPkdr'))) {
                var obj = $cookies.get('cookUsuSisoWkUidPkdr');
                var data = angular.fromJson(obj);
                dataRef = data;
            }
            return dataRef;
        }

        function obtenerTiempoMilisegundosTerminoSession() {
            var milisegundos = 60000;
            if (obtenerObjCookie() != null) {
                var data = obtenerObjCookie();
                var fechaActual = new Date();
                var fechaSession = new Date(data.tiempoSession);
                var restaTiempo = ((fechaSession - fechaActual) / 900);
                var segundos = parseInt(restaTiempo);
                milisegundos = segundos * 1000;
            }
            return milisegundos;
        }
    }
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('ConvertFactory', ConvertFactory);

	/* @ngInject */
	function ConvertFactory() {
		
		var factory = {
			toDate : toDate,
			toString : toString,
			toStringDate : toStringDate,
			toTime : toTime,
			isNotNull : isNotNull,
			isNotEmpty : isNotEmpty,
			isNotNoE : isNotNoE
		};
		
		return factory;
		
		function toDate(prmStringDate) {
			if (angular.isDefined(prmStringDate) && prmStringDate!=null && prmStringDate!='') {	
				try{
					var dateArray = prmStringDate.split('/');
					var date = new Date(dateArray[2]+'/'+dateArray[1]+'/'+dateArray[0]);
					return date;
				}
				catch(e){
					return null;
				}
			}
		}

		function toTime(prmStringTime) {
			var result = false, m;
		    var regEx = /^\s*([01]?\d|2[0-3]):?([0-5]\d)\s*$/;
		    if ((m = prmStringTime.match(regEx))) {
		        result = (m[1].length === 2 ? "" : "0") + m[1] + ":" + m[2];
		    }
		    return result;
		}


		function toStringDate(prmObject) {
			
			if(isNotNoE(prmObject)){
				return moment(new Date(prmObject)).format('DD/MM/YYYY');
			}
			return null;
		}

		function toString(prmObject) {
			
			if(angular.isDate(prmObject)){
				return moment(prmObject).format('DD/MM/YYYY');
			}
			return null;
		}


		/*validaciones*/

		function isNotNull(obj) {
			return obj != null;
		}

		function isNotDefined(obj) {
			return obj != undefined;
		}

		function isNotEmpty(obj) {
			return obj.toString().length > 0;
		}

		function isNotNoE(obj) {
			return  isNotNull(obj) && isNotDefined(obj) && isNotEmpty(obj);
		}

	}	
})();
(function() {
    'use strict';
    angular.module('spapp').factory('APIFactory', APIFactory);
    /* @ngInject */
    function APIFactory($q, $http, $rootScope, CookiesFactory) {
        var factory = {
            listar: listar,
            registrar: registrar,
            obtener: obtener,
            buscarPorId: buscarPorId,
            inactivar : inactivar,
            actualizar: actualizar,
            eliminar: eliminar,
            consultaPOST: consultaPOST,
            guardarArchivo: guardarArchivo,
            download: download,
            descargarArchivo: descargarArchivo,
            descargarArchivoParam:descargarArchivoParam,
            acciones:acciones
        };
        return factory;

        function listar(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
            $rootScope.cargandoInformacion++;
            //$rootScope.$broadcast('aumentarContadorCargando', null);
            var deferred = $q.defer();
            var parametros = undefined;
            if (angular.isDefined(objeto)) {
                parametros = {
                    prmCriterio: angular.toJson(objeto)
                };
            }
            $http({
                url: url,
                method: 'GET',
                params: parametros,
//                data:objeto,
                
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            //$rootScope.$broadcast('disminuirContadorCargando', null);
            return deferred.promise;
        }

        function registrar(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
            if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
                objeto.prm1 = angular.copy(localStorage.objlocalStRefSisoplkijsq);
            }
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url,
                method: 'POST',
                data: objeto
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            //$rootScope.cargandoInformacion--;
            return deferred.promise;
        }

        
        function buscarPorId(url, id) {
        	 CookiesFactory.aumentarTiempoCookie();
             $rootScope.cargandoInformacion++;
             //$rootScope.$broadcast('aumentarContadorCargando', null);
             var deferred = $q.defer();
             var parametros = undefined;
             if (angular.isDefined(id)) {
                 parametros = {
                     prmCriterio: angular.toJson(id)
                 };
             }
             $http({
                 url: url,
                 method: 'GET',
                 params: parametros
             }).success(function(response) {
                 deferred.resolve(response);
                 $rootScope.cargandoInformacion--;
             }).error(function(error) {
                 deferred.reject(error);
                 $rootScope.cargandoInformacion--;
             });
             //$rootScope.$broadcast('disminuirContadorCargando', null);
             return deferred.promise;
        }
        
        function obtener(url, id) {
            CookiesFactory.aumentarTiempoCookie();
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url + (id ? id : ''),
                method: 'GET'
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            //$rootScope.cargandoInformacion--;
            return deferred.promise;
        }

        function actualizar(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
            if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
                objeto.prm1 = angular.copy(localStorage.objlocalStRefSisoplkijsq);
            }
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url,
                method: 'POST',
                data: objeto
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            //$rootScope.cargandoInformacion--;
            return deferred.promise;
        }

        function eliminar(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
            if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
                objeto.prm1 = angular.copy(localStorage.objlocalStRefSisoplkijsq);
            }
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url,
                method: 'POST',
                data: objeto
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            return deferred.promise;
        }
        
        function inactivar(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
//            if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
//                objeto.prm1 = angular.copy(localStorage.objlocalStRefSisoplkijsq);
//            }
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url,
                method: 'POST',
                data: objeto
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            return deferred.promise;
        }

        function consultaPOST(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url,
                method: 'POST',
                data: objeto
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            return deferred.promise;
        }

        function guardarArchivo(url, data) {
            CookiesFactory.aumentarTiempoCookie();
            if (angular.isDefined(localStorage.objlocalStRefSisoplkijsq)) {
                var dataForm = data.getAll("strContenido");
                var dataObj = angular.copy(angular.fromJson(dataForm[0]));
                dataObj.prm1 = angular.copy(localStorage.objlocalStRefSisoplkijsq);
                data.delete("strContenido");
                data.append("strContenido", angular.toJson(dataObj));
            }
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http.post(url, data, {
                headers: {
                    "Content-type": undefined
                },
                transformRequest: angular.identity
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            return deferred.promise;
        }

        function download(url, objeto) {
            CookiesFactory.aumentarTiempoCookie();
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http.post(url, objeto, {
                responseType: 'arraybuffer'
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            return deferred.promise;
        }

        function descargarArchivo(url, id) {
            CookiesFactory.aumentarTiempoCookie();
            $rootScope.cargandoInformacion++;
            var deferred = $q.defer();
            $http({
                url: url + id,
                method: 'GET'
            }).success(function(response) {
                deferred.resolve(response);
                $rootScope.cargandoInformacion--;
            }).error(function(error) {
                deferred.reject(error);
                $rootScope.cargandoInformacion--;
            });
            //$rootScope.cargandoInformacion--;
            return deferred.promise;
        }
        
        function descargarArchivoParam(url, objeto, nombrereporte, tipo) {
        	var parametros = undefined;
            if (angular.isDefined(objeto)) {
                parametros = {
                    prmCriterio: angular.toJson(objeto)
                };
            }
            
            $http({
                url : url,
                method : 'GET',
                params : parametros,
                headers : {
                    'Content-type' : tipo == 'EXCEL'? 'application/vnd.ms-excel' : 'application/pdf',
                },
                responseType : 'arraybuffer'
            }).success(function(data, status, headers, config) {
                // TODO when WS success
                var file = new Blob([ data ], {
                    type : tipo == 'EXCEL'? 'application/csv' : 'application/pdf'
                });
                //trick to download store a file having its URL
                var fileURL = URL.createObjectURL(file);
                var a         = document.createElement('a');
                a.href        = fileURL; 
                a.target      = '_blank';
                a.download    = nombrereporte;
                document.body.appendChild(a);
                a.click();
            }).error(function(data, status, headers, config) {

            });
        }
        
        
        function acciones(){
        	return {
        		nuevoInforme : false,
        		nuevoAdministradoxInstalacion : false,
        		editarAdministradoxInstalacion : false
        	}
        }
    }
})();
(function() {
  'use strict';

    angular
        .module('spapp')
        .directive('input',input);

    function input(){
      var directive = {
            restrict : 'E',
            /*require: 'ngModel',*/
            link: link
        };

        return directive;

        function link($scope, element, attrs/*, modelCtrl*/) 
        {
          var tiposSinTrim = ['texto','numero','numero-guion','alfanumerico','alfanumerico-guion',
                              'decimal','email','url','fecha','hora'];
          if (tiposSinTrim.includes(element.attr('input-restrict'))) 
          {
            attrs.$set('ngTrim', "false");
          }

        }
      };

})();
(function() {
  'use strict';

    angular
        .module('spapp')
        .directive('inputRestrict',inputRestrict);

    function inputRestrict(){
       var directive = {
            restrict : 'A',
            require: 'ngModel',
            link: link
         };

         return directive;

         function link($scope, element, attrs, modelCtrl)
         {
            modelCtrl.$parsers.push(function (inputValue)
            {
              // this next if is necessary for when using ng-required on your input.
              // In such cases, when a letter is typed first, this parser will be called
              // again, and the 2nd time, the value will be undefined

              if (angular.isUndefined(inputValue)) return '';

              //inicializar tipo de restriccion
              var tipoRestriccion = (angular.isUndefined(attrs) || angular.isUndefined(attrs.inputRestrict)) ? '' : attrs.inputRestrict;
              
              if (tipoRestriccion==='') return inputValue;
              /*
              var customRestriccion = (angular.isUndefined(attrs) || angular.isUndefined(attrs.appRegex)) ? '' : attrs.appRegex;

              // console.log('tipoRestriccion',tipoRestriccion);
              // console.log('customRestriccion',customRestriccion)
              var customRegex = null;

              if (tipoRestriccion==='custom' && customRestriccion) {
                customRegex = new RegExp(customRestriccion);
                //console.log('new RegExp', customRegex);
              }*/

              var regex = null;
              
              switch(tipoRestriccion)
              {
                case 'texto': regex = /[^A-Za-z]/g; break;
                case 'texto-espacio': regex = /[^a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g; break;
                case 'numero': regex = /[^0-9]/g; break;
                case 'numero-guion': regex = /[^0-9\-]/g; break;
                case 'numero-espacio': regex = /[^0-9\s]/g; break;
                case 'alfanumerico': regex = /[^0-9A-Za-z]/g; break;
                case 'alfanumerico-guion': regex = /[^0-9A-Za-z\-]/g; break;
                case 'alfanumerico-email': regex = /[^0-9A-Za-z_.@\-]/g; break;
                case 'alfanumerico-espacio': regex = /[^0-9a-zA-ZñÑáéíóúÁÉÍÓÚ\s]/g; break;
                case 'texto-variado': regex = /[^0-9a-zA-ZñÑáéíóúÁÉÍÓÚ\s\-.]/g; break;
                case 'decimal': regex = /[^0-9.]/g; break;
                case 'email' : regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g; break;
                case 'url': regex = /[^A-Za-z_.0-9-]/g; break;
                case 'hora': regex = /[^0-9:]/g; break;
                case 'custom' : regex = customRegex; break;
                default : break;
              }

              var transformedInput = inputValue.replace(regex, '');
              transformedInput = transformedInput.trim();
              if (transformedInput!=inputValue)
              {
                  modelCtrl.$setViewValue(transformedInput);
                  modelCtrl.$render();
              }
              return transformedInput;
            });
          }
      };

})();
(function() {
    'use strict';

    angular
        .module('spapp')
        .directive('hcChart',hcChart);

    /* @ngInject */
    function hcChart() {
        var directive = {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                options: '='
            },
            link: link
        };
        return directive;

        function link($scope, element) {
            var chart = Highcharts.chart(element[0], $scope.options);

            $scope.$watch('options',function (newOptions) {
                if (newOptions) {
                    //Highcharts.chart(element[0], $scope.options); destruye chart actual y genera uno nuevo
                    chart.update($scope.options);//actualiza el chart especificado
                }
            }, true);

        }
    }

})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.directive('fileModel', fileModelDirective);

	/* @ngInject */
	function fileModelDirective($parse) {
		var directive = {
			restrict : 'A',
			link : link
		};

		return directive;

		function link($scope, element, attrs) {
			element.on('change',function (e) {
				$parse(attrs.fileModel).assign($scope, element[0].files[0]);	
			});
		}
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.directive('fileChange', fileChange);

	/* @ngInject */
	function fileChange() {
		
		var directive = {
			restrict : 'A',
			link : link
		};

		return directive;

		function link(scope, element, attrs) {
			var onChangeHandler = scope.$eval(attrs.fileChange);
			element.bind('change', function (event) {
				var attachedFiles = event.target.files;
				
				onChangeHandler(attachedFiles);
				/*if (attachedFiles.length>1) {
					console.log('multiples archivos');
				}
				else {
					console.log('archivo único');
				}*/
			});

			element.bind('click', function () {
				//element.val('');
			});
		}
	}

})();
(function() {
  'use strict';

    angular
        .module('spapp')
        .directive('appTypeTime',input);//app-number

    function input(){
      var directive = {
            restrict : 'E',
            require: 'ngModel',
            link: link
        };

        return directive;

        function link($scope, element, attrs, modelCtrl, ConvertFactory) 
        {
          ngModel.$parsers.push(function (val) {
            return (val==null || isNaN(val)) ? null : parseInt(val);
          });
          ngModel.$formatters.push(function (val) {
            return val==null ? null : '' + val;
          });
        }
      };

})();
(function() {
  'use strict';

    angular
        .module('spapp')
        .directive('appTypeNumber',input);//app-number

    function input(){
      var directive = {
            restrict : 'E',
            require: 'ngModel',
            link: link
        };

        return directive;

        function link($scope, element, attrs, modelCtrl) 
        {
          ngModel.$parsers.push(function (val) {
            return (val==null || isNaN(val)) ? null : parseInt(val);
          });
          ngModel.$formatters.push(function (val) {
            return val==null ? null : '' + val;
          });
        }
      };

})();
(function() {
  'use strict';

  angular
    .module('spapp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1494438008479;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function() {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function(awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

(function() {
	'use strict';

	angular.module('spapp').factory('UsuarioUbigeoFactory',
			UsuarioUbigeoFactory);

	/* @ngInject */
	function UsuarioUbigeoFactory(API_CONFIG, APIFactory, PerfilFactory,
			PersonaFactory, CookiesFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			buscarPorSession : buscarPorSession,
			registrar : registrar,
			obtener : obtener,
			actualizar : actualizar,
			eliminar : eliminar,
			obtenerPerfilDigitador : obtenerPerfilDigitador,
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				idUsuario : 0,
				codigoUsuario : '',
				documento : '',
				idPerfil : '',
				ubigeo : '',
				estado : '1',
				idsession : CookiesFactory.obtenerCookie(),
				ultimafecha : new Date()
			};
		}

		function buscarPorSession(prmUsuario) {
			return APIFactory.listar(API_CONFIG.url
					+ 'usuarioubigeo/buscarPorSession', prmUsuario);
		}

		function listar(prmUsuario) {
			return APIFactory.listar(API_CONFIG.url + 'usuarioubigeo/listar',
					prmUsuario);
		}

		function registrar(prmUsuario) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'usuarioubigeo/registrar', prmUsuario);
		}

		function obtener(idUsuario) {
			return APIFactory.obtener(API_CONFIG.url
					+ 'usuarioubigeo/buscarPorID', idUsuario);
		}

		function actualizar(prmUsuario) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'usuarioubigeo/actualizar', prmUsuario);
		}

		function eliminar(prmUsuario) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'usuarioubigeo/eliminar', prmUsuario);
		}
		function obtenerPerfilDigitador() {
			return APIFactory.listar(API_CONFIG.url
					+ 'usuarioubigeo/obtenerPerfilDigitador');
		}

		/* fin de factory */

	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('UsuarioFactory', UsuarioFactory);

	/* @ngInject */
	function UsuarioFactory(API_CONFIG, APIFactory, PerfilFactory,
			PersonaFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			modelUsuario : modelUsuario,
			listar : listar,
			listarUsuariosSSO : listarUsuariosSSO,
			registrar : registrar,
			obtener : obtener,
			actualizar : actualizar,
			eliminar : eliminar,
			loginUsuario : loginUsuario,
			validarUsuario : validarUsuario,
			contarCorreoUsuario : contarCorreoUsuario
		};

		return factory;

		/* implementacion de metodos */

		function modelUsuario() {
			return {
				idUsuario : 0,
				tipoPersona : 0,
				idPersona : 0,
				persona : {},
				entidad : {},
				nombreUsuario : '',
				clave : '',
				perfil : PerfilFactory.model(),
				estado : 0,
				flagActivo : ''
			};
		}

		function listar(prmUsuario) {
			return APIFactory.listar(API_CONFIG.url + 'usuario/listar',
					prmUsuario);
		}

		function listarUsuariosSSO(prmContacto) {
			return APIFactory.listar(API_CONFIG.url
					+ 'usuario/listarUsuariosSSO', prmContacto);

		}

		function registrar(prmUsuario) {
			return APIFactory.registrar(API_CONFIG.url + 'usuario/registrar',
					prmUsuario);
		}

		function obtener(idUsuario) {
			return APIFactory.obtener(API_CONFIG.url + 'usuario/buscar-id/',
					idUsuario);
		}

		function actualizar(prmUsuario) {
			return APIFactory.actualizar(API_CONFIG.url + 'usuario/actualizar',
					prmUsuario);
		}

		function eliminar(prmUsuario) {
			return APIFactory.eliminar(API_CONFIG.url + 'usuario/eliminar',
					prmUsuario);
		}

		function loginUsuario(prmUsuario) {
			return APIFactory.consultaPOST(API_CONFIG.url + 'usuario/login',
					prmUsuario);
		}

		function validarUsuario(prmUsuario) {
			return APIFactory.consultaPOST(API_CONFIG.url
					+ 'usuario/cambiarClave', prmUsuario);
		}
		function contarCorreoUsuario(prmContacto) {
			return APIFactory.listar(API_CONFIG.url
					+ 'usuario/contarCorreoUsuario', prmContacto);
		}
		/* fin de factory */

	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('UbigeoFactory', UbigeoFactory);

	/* @ngInject */
	function UbigeoFactory(API_CONFIG, APIFactory, CookiesFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			departamento : departamento,
			provincia : provincia,
			distrito : distrito,
			listarDepartamento : listarDepartamento,
			listarProvincia : listarProvincia,
			listarDistrito  : listarDistrito,
			listarDepartamentoxUsuario : listarDepartamentoxUsuario,
			listarProvinciaxUsuario : listarProvinciaxUsuario,
			listarDistritoxUsuario  : listarDistritoxUsuario,
			registrar : registrar,
			/*obtener : obtener,*/
			actualizar : actualizar,
			eliminar : eliminar
		/*	loginUsuario : loginUsuario,
			cambiarClave : cambiarClave*/
		};

		return factory;

		/* implementacion de metodos */
			

		function departamento() {
			return {

				 	 codigoDepartamento			:'',
				 	 descripcionDepartamento	:'',
				 	 idsession : CookiesFactory.obtenerCookie(),
			};
		}


		function provincia() {
			return {

			 		 codigoDepartamento		:'',
			 		 codigoProvincia		:'',
			 		 descripcion 			:'',
			 		 idsession : CookiesFactory.obtenerCookie(),
			};
		}

		function distrito() {
			return {

			 		  codigoDepartamento	:'',
					  codigoProvincia		:'',
					  codigoDistrito 		:'',
					  descripcionDistrito 	:'',
					  idsession : CookiesFactory.obtenerCookie(),
			};
		}


		function listarDepartamento(prmUbigeo) {
			return APIFactory.listar(API_CONFIG.url+'ubigeo/listar-departamento',prmUbigeo);
		}

		function listarProvincia(prmUbigeo) {
			return APIFactory.listar(API_CONFIG.url+'ubigeo/listar-provincia',prmUbigeo);
		}

		function listarDistrito(prmUbigeo) {
			return APIFactory.listar(API_CONFIG.url+'ubigeo/listar-distrito',prmUbigeo);
		}
		
		function listarDepartamentoxUsuario(prmUbigeo) {
			return APIFactory.listar(API_CONFIG.url+'ubigeo/listar-departamento-usuario',prmUbigeo);
		}

		function listarProvinciaxUsuario(prmUbigeo) {
			return APIFactory.listar(API_CONFIG.url+'ubigeo/listar-provincia-usuario',prmUbigeo);
		}

		function listarDistritoxUsuario(prmUbigeo) {
			return APIFactory.listar(API_CONFIG.url+'ubigeo/listar-distrito-usuario',prmUbigeo);
		}
		

		function registrar(prmPerfil) {
			return APIFactory.registrar(API_CONFIG.url+'perfil/registrar', prmPerfil);
		}
/*
		function obtener(idUsuario) {
			return APIFactory.obtener(API_CONFIG.url+'perfil/obtener/', idUsuario);
		}
*/
		function actualizar(prmPerfil) {
			return APIFactory.actualizar(API_CONFIG.url+'perfil/actualizar', prmPerfil);
		}

		function eliminar(prmPerfil) {
			return APIFactory.eliminar(API_CONFIG.url+'perfil/eliminar', prmPerfil);
		}

	/*	function loginUsuario(prmPerfil){
			return APIFactory.consultaPOST(API_CONFIG.url+'perfil/login', prmUsuario);
		}

		function cambiarClave(prmPerfil){
			return APIFactory.actualizar(API_CONFIG.url+'perfil/cambiarClave',prmUsuario);
		}
*/
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('TipoIgaFactory', TipoIgaFactory);
    /* @ngInject */
    function TipoIgaFactory(API_CONFIG, APIFactory, CookiesFactory) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            listar 		: listar,
            listarActivos : listarActivos,
            listarPorModificacion : listarPorModificacion,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			inactivar   : inactivar,
			buscarPorId : buscarPorId,
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
            	codigo: '',
            	descripcion: '',
            	comentario: '',
            	flag_u_menor: '',
            	flag_u_mayor: '',
            	blUnidadMenor: true,
            	blUnidadMayor:  true,
            	estado: '1',
            	idsession: CookiesFactory.obtenerCookie(),
                ultima_fecha: new Date()
            };
        }

        function buscarPorId(prmTipoIga) {
        	console.log('buscarPorId ' + prmTipoIga.codtipoiga);
            return APIFactory.buscarPorId(API_CONFIG.url + 'tipoiga/buscarPorID', prmTipoIga);
        }

        function listar(prmTipoIga) {
        	console.log(prmTipoIga);
            return APIFactory.listar(API_CONFIG.url + 'tipoiga/listar', prmTipoIga);
        }
        
        function listarActivos(prmTipoIga) {
        	console.log(prmTipoIga);
            return APIFactory.listar(API_CONFIG.url + 'tipoiga/listarActivos', prmTipoIga);
        }
        
        
        function listarPorModificacion(prmTipoIga) {
        	console.log(prmTipoIga);
            return APIFactory.listar(API_CONFIG.url + 'tipoiga/listarPorModificacion', prmTipoIga);
        }
        
        function registrar(prmTipoIga) {
            return APIFactory.registrar(API_CONFIG.url + 'tipoiga/registrar', prmTipoIga);
        }
        
        function actualizar(prmTipoIga) {
            return APIFactory.actualizar(API_CONFIG.url + 'tipoiga/actualizar', prmTipoIga);
        }
        
        function eliminar(prmTipoIga) {
            return APIFactory.eliminar(API_CONFIG.url + 'tipoiga/eliminar', prmTipoIga);
        }
        
        function inactivar(prmTipoIga) {
            return APIFactory.inactivar(API_CONFIG.url + 'tipoiga/inactivar', prmTipoIga);
        }
        /*fin de factory*/
    }
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('SolicitudesFactory', SolicitudesFactory);

	/* @ngInject */
	function SolicitudesFactory(API_CONFIG, APIFactory,InstalacionFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
			listarSolicitudAdministrado : listarSolicitudAdministrado
		  
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		

				 	  idSolicitud 			:0,	
					  tipoSolicitud 		:0,
					  nombreSolicitud 		:'',
					  estado 				:0,
					  nombreEstado 			:'',
					  idAdministrado 		:0,
					  idPersona 			:0,
					  numeroInstalaciones 	:0,
					  nombreCompleto 		:'',
					  documento 			:'',
					  tipoPersona 			:0,
					  nombreTipoPersona 	:'',
					  motivoRechazo 		:'',
					  actividad				:0,
					  sector   				:0,
					  subSector				:0
			};
		}
		

/* ************************************Vista Solicitudes**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'solicitudes/listar', prmData);
		}
		
		function listarSolicitudAdministrado(prmData) {
			return APIFactory.listar(API_CONFIG.url+'solicitudes/listar-solicitud-administrado', prmData);
		}
		

/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('SolicitudFactory', SolicitudFactory);

	/* @ngInject */
	function SolicitudFactory(API_CONFIG, APIFactory, InstalacionFactory,
			AdministradoFactory, MaestroFactory, $q, $http) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			modelDetalleSolicitud : modelDetalleSolicitud,
			listarDetalleSolicitud : listarDetalleSolicitud,
			registrarSolicitudArchivo : registrarSolicitudArchivo,
			actualizarDetalleSolicitud : actualizarDetalleSolicitud,
			descargarFichaRegistro : descargarFichaRegistro,
			descargarFicha : descargarFicha,
			registrarSolicitudSinArchivo : registrarSolicitudSinArchivo,
			actualizarEstadoSolicitud : actualizarEstadoSolicitud,
			registrarSolicitud : registrarSolicitud,
			actualizarSolicitud : actualizarSolicitud
		};

		return factory;

		/* implementacion de metodos */

		function modelDetalleSolicitud() {

			return {

				idDetalleSolicitud : 0,
				solicitud : model(),
				instalacion : InstalacionFactory.model(),
				estado : MaestroFactory.model(),
				flagActivo : 0

			};

		}

		function model() {
			return {

				idSolicitud : 0,
				tipoSolicitud : 0,
				flagActivo : 0,
				estado : 0,
				lstDetalleSolicitud : [],
				administrado : AdministradoFactory.model(),
				motivoCancelacionInstalacion : ''
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url + 'solicitud/listar',
					prmData);
		}

		function listarDetalleSolicitud(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'solicitud/listar-detalle-solicitud', prmData);
		}

		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url + 'solicitud/registrar',
					prmData);
		}

		function registrarSolicitudArchivo(files, prmData) {

			// debugger;

			var formData = new FormData();
			/*
			 * if(files instanceof FileList) {
			 */
			for ( var x in files) {
				formData.append("file", files[x]);
			}
			/*
			 * } else { formData.append("file",files); }
			 */

			formData.append("strContenido", angular.toJson(prmData));
			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'solicitud/registrar-solicitud-archivo', formData);
		}

		function registrarSolicitud(prmData) {

			return APIFactory.registrar(API_CONFIG.url
					+ 'solicitud/registrar-solicitud', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'solicitud/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url + 'solicitud/eliminar',
					prmData);
		}

		function registrarSolicitudSinArchivo(prmData) {

			// debugger;

			var formData = new FormData();
			formData.append("strContenido", angular.toJson(prmData));
			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'solicitud/registrar-solicitud-sin-archivo', formData);
		}
		/* ******************************************************************************** */

		function actualizarDetalleSolicitud(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'solicitud/actualizar-detalle-solicitud', prmData);
		}
		
		function actualizarSolicitud(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'solicitud/actualizar-solicitud', prmData);
		}

		function descargarFichaRegistro(prmData) {
			return APIFactory.descargarArchivo(API_CONFIG.url
					+ 'solicitud/descargar-ficha-registro/', prmData);
		}

		function descargarFicha(prmData) {
			return APIFactory.eliminar(API_CONFIG.url + 'solicitud/verFicha',
					prmData);
		}

		function actualizarEstadoSolicitud(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'solicitud/actualizar-estado-solicitud', prmData);
		}
		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('SectorGenericoFactory',
			SectorGenericoFactory);
	/* @ngInject */
	function SectorGenericoFactory(API_CONFIG, APIFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			listarSector : listarSector,
			listarSubSector : listarSubSector,
			listarCompetencia : listarCompetencia,
			listarActividad : listarActividad,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			inactivar : inactivar,
			buscarPorId : buscarPorId,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				codigosector : '',
				sector : '',
				codigosubsector : '',
				subsector : '',
				codigocompetencia : '',
				competencia : '',
				codigoactividad : '',
				actividad : '',
				descripcion : '',
				estado : '1',
				idsession : '',
				ultima_fecha : new Date(),
				isSeleccionado : false,
			};
		}

		function buscarPorId(prmSectorGenerico) {
			return APIFactory.buscarPorId(API_CONFIG.url
					+ 'sectorgenerico/buscarPorID', prmSectorGenerico);
		}

		function listar(prmSectorGenerico) {
			return APIFactory.listar(API_CONFIG.url + 'sectorgenerico/listar',
					prmSectorGenerico);
		}

		function listarSector(prmSectorGenerico) {
			return APIFactory.listar(API_CONFIG.url
					+ 'sectorgenerico/listarSector', prmSectorGenerico);
		}

		function listarSubSector(prmSectorGenerico) {
			return APIFactory.listar(API_CONFIG.url
					+ 'sectorgenerico/listarSubSector', prmSectorGenerico);
		}

		function listarCompetencia(prmSectorGenerico) {
			return APIFactory.listar(API_CONFIG.url
					+ 'sectorgenerico/listarCompetencia', prmSectorGenerico);
		}

		function listarActividad(prmSectorGenerico) {
			return APIFactory.listar(API_CONFIG.url
					+ 'sectorgenerico/listarActividad', prmSectorGenerico);
		}

		function registrar(prmSectorGenerico) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'sectorgenerico/registrar', prmSectorGenerico);
		}

		function actualizar(prmSectorGenerico) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'sectorgenerico/actualizar', prmSectorGenerico);
		}

		function eliminar(prmSectorGenerico) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'sectorgenerico/eliminar', prmSectorGenerico);
		}

		function inactivar(prmSectorGenerico) {
			return APIFactory.inactivar(API_CONFIG.url
					+ 'sectorgenerico/inactivar', prmSectorGenerico);
		}
		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('ResiduoFactory', ResiduoFactory);
	/* @ngInject */
	function ResiduoFactory(API_CONFIG, APIFactory, CookiesFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			modelCaracteristica : modelCaracteristica,
			modelTransporte : modelTransporte,
			modelDisposicion : modelDisposicion,
			listar : listar,
			listarCaracteristica : listarCaracteristica,
			listarTransporte : listarTransporte,
			listarDisposicion : listarDisposicion,
			buscarPorId : buscarPorId,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			inactivar : inactivar,
			deshabilitar : deshabilitar,

		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				idresiduo : 0,
				idAdministrado : 0,
				idInstalacion : 0,
				periodo : 0,
				frecuencia : 0,
				numero_frecuencia : 0,
				comentario : '',
				fechapresentacion : new Date(),
				tipo : '',
				nombredocumento : '',
				rutadocumento : '',
				uiid : '',
				prm1 : CookiesFactory.obtenerCookie(),
				ultmafecha : new Date(),				
				lstCaracteristicas : [],
				lstTransporte : [],
				lstDisposicion : [],
				fechadesde : null,
				fechahasta : null

			};
		}

		function modelCaracteristica() {
			return {
				idresiduo : 0,
				secuencia : 0,
				idTipo : 0,
				estadoResiduo : 0,
				codUnidad : 0,
				cantEnero : 0.0,
				cantFebrero : 0.0,
				cantMarzo : 0.0,
				cantAbril : 0.0,
				cantMayo : 0.0,
				cantJunio : 0.0,
				cantJulio : 0.0,
				cantAgosto : 0.0,
				cantSeptiembre : 0.0,
				cantOctubre : 0.0,
				cantNoviembre : 0.0,
				cantDiciembre : 0.0,
				cantTotal : 0.0,
				descripcion : '',
				flgReactividad : '',
				flgToxicidad : '',
				flgAutocombustibilidad : '',
				flgExplosividad : '',
				flgRadiactividad : '',
				flgPatogenisidad : '',
				flgCorrosividad : '',
				flgOtros : '',
				isReactividad : false,
				isToxicidad : false,
				isAutocombustibilidad : false,
				isExplosividad : false,
				isRadiactividad : false,
				isPatogenisidad : false,
				isCorrosividad : false,
				isOtros : false,
				peligrosidadOtros : '',
				prm1 : CookiesFactory.obtenerCookie(),
				ultmafecha : new Date(),
			};
		}

		function modelTransporte() {
			return {
				idresiduo : 0,
				ruceps : '',
				nombreeps : '',
				nroregistro : '',
				fechavencimiento : null,
				fechavencimientotexto : '',
				fechaejecucion : null,
				fechaejecuciontexto : '',
				cantidad : 0.0,
				prm1 : CookiesFactory.obtenerCookie(),
				ultmafecha : new Date(),
			};
		}

		function modelDisposicion() {
			return {
				idresiduo : 0,
				ruceps : '',
				nombreeps : '',
				nroregistro : '',
				fechavencimiento : null,
				fechavencimientotexto : '',
				fechaejecucion : null,
				fechaejecuciontexto : '',
				cantidad : 0.0,
				direccion : '',
				prm1 : CookiesFactory.obtenerCookie(),
				ultmafecha : new Date(),
			};
		}

		function buscarPorId(prmResiduo) {
			return APIFactory.buscarPorId(API_CONFIG.url
					+ 'residuo/buscarPorID', prmResiduo);
		}

		function listar(prmResiduo) {
			return APIFactory.listar(API_CONFIG.url + 'residuo/listar',
					prmResiduo);
		}

		function listarCaracteristica(prmResiduo) {
			return APIFactory.listar(API_CONFIG.url
					+ 'residuo/listarCaracteristica', prmResiduo);
		}

		function listarTransporte(prmResiduo) {
			return APIFactory.listar(API_CONFIG.url
					+ 'residuo/listarTransporte', prmResiduo);
		}

		function listarDisposicion(prmResiduo) {
			return APIFactory.listar(API_CONFIG.url
					+ 'residuo/listarDisposicion', prmResiduo);
		}

		function registrar(archivos, prmData) {
			if (archivos.length == 0) {
				return APIFactory.registrar(API_CONFIG.url
						+ 'residuo/registrar', prmData);
			} else {
				var formData = new FormData();
				for ( var x in archivos) {
					formData.append("file", archivos[x]);
				}
				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'residuo/registrar-documento', formData);
			}
		}

		function actualizar(archivos,prmResiduo) {
			if (archivos.length == 0) {
				return APIFactory.actualizar(API_CONFIG.url + 'residuo/actualizar',
						prmResiduo);
			} else {
				var formData = new FormData();
				for ( var x in archivos) {
					formData.append("file", archivos[x]);
				}
				formData.append("strContenido", angular.toJson(prmResiduo));
				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'residuo/actualizar-documento', formData);
			}
			
			
		}

		function eliminar(prmResiduo) {
			return APIFactory.eliminar(API_CONFIG.url + 'residuo/eliminar',
					prmResiduo);
		}

		function inactivar(prmResiduo) {
			return APIFactory.inactivar(API_CONFIG.url + 'residuo/inactivar',
					prmResiduo);
		}
		
		function deshabilitar(prmResiduo) {
			console.log(prmResiduo.idresiduo);
			return APIFactory.inactivar(API_CONFIG.url + 'residuo/deshabilitar',
					prmResiduo);
		}
		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('ReporteFactory', ReporteFactory);

	/* @ngInject */
	function ReporteFactory(API_CONFIG, APIFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			generarPlantillaMonitoreoMasivo : generarPlantillaMonitoreoMasivo,
			verReporteUnidadesFiscalizablesAdminDepartamento : verReporteUnidadesFiscalizablesAdminDepartamento,
			verReporteUnidadesFiscalizablesAdminProvincia : verReporteUnidadesFiscalizablesAdminProvincia,
			verReporteUnidadesFiscalizablesAdminDistrito: verReporteUnidadesFiscalizablesAdminDistrito,
			verReporteUnidadesFiscalizablesDepartamento : verReporteUnidadesFiscalizablesDepartamento,
			verReporteUnidadesFiscalizablesProvincia : verReporteUnidadesFiscalizablesProvincia,
			verReporteUnidadesFiscalizablesDistrito : verReporteUnidadesFiscalizablesDistrito,
			verReportePreliminarPorAdministrado : verReportePreliminarPorAdministrado,
			verReporteIgaPorAdministrado : verReporteIgaPorAdministrado,
			verReporteIgaPorOd : verReporteIgaPorOd,
			verReporteIgaPorUbigeo : verReporteIgaPorUbigeo,
			descargarExcel : descargarExcel,
			descargarPDF : descargarPDF
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				idAdministrado : 0,
				idInstalacion : 0,
				ruc : '',
				razonsocial : '',
				codigodepartamento : '',
				nombredepartamento : '',
				codigoprovincia : '',
				nombreprovincia : '',
				codigodistrito : '',
				nombredistrito : '',
				fechadesde : null,
				fechahasta : null,
				tiporeporte : null,
				codigood: '',
				rucAux: '',
				razonsocialAux: ''
			};
		}

		function generarPlantillaMonitoreoMasivo(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'reporte/generar-plantilla-monitoreo-masivo/', prmData);
		}

		function verReporteUnidadesFiscalizablesDepartamento(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteUnidadesFiscalizablesDepartamento',
					prmFiltro);
		}

		function verReporteUnidadesFiscalizablesProvincia(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteUnidadesFiscalizablesProvincia',
					prmFiltro);
		}

		function verReporteUnidadesFiscalizablesDistrito(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteUnidadesFiscalizablesDistrito',
					prmFiltro);
		}

		function verReporteUnidadesFiscalizablesAdminDepartamento(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteUnidadesFiscalizablesAdminDepartamento',
					prmFiltro);
		}

		function verReporteUnidadesFiscalizablesAdminProvincia(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteUnidadesFiscalizablesAdminProvincia',
					prmFiltro);
		}

		function verReporteUnidadesFiscalizablesAdminDistrito(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteUnidadesFiscalizablesAdminDistrito',
					prmFiltro);
		}

		function verReportePreliminarPorAdministrado(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReportePreliminarPorAdministrado', prmFiltro);
		}
		
		function verReporteIgaPorAdministrado(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteIgaPorAdministrado', prmFiltro);
		}
		
		function verReporteIgaPorOd(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteIgaPorOd', prmFiltro);
		}

		function verReporteIgaPorUbigeo(prmFiltro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'reporte/verReporteIgaPorUbigeo', prmFiltro);
		}
		
		function descargarExcel(prmFiltro, nombre) {
			return APIFactory.descargarArchivoParam(API_CONFIG.url + 'reporte/descargar-excel',
					prmFiltro, nombre,'EXCEL');
		}
		
		function descargarPDF(prmFiltro, nombre) {
			return APIFactory.descargarArchivoParam(API_CONFIG.url + 'reporte/descargar-pdf',
					prmFiltro, nombre,'PDF');
		}

	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('PreguntaFactory', PreguntaFactory);

	/* @ngInject */
	function PreguntaFactory(API_CONFIG, APIFactory,MaestroFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			buscarPorId : buscarPorId,
			modelArchivo: modelArchivo
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		
				  idPregunta		:0,
				  tipoPregunta		:MaestroFactory.model(),
				  descripcion		:'', 
				  estado 			:MaestroFactory.model(),
				  numerosFila 		:0,
				  numerosColumna 	:0,
				  lstOpcionPregunta :[],
				  codigoSector 		:0,
				  codigoSubSector 	:0,
				  codigoActividad 	:0,
				  codigoPeriodo		:0,
				  flagArchivo 		:0

			};
		}
		
		function modelArchivo(){
				return {	

				  idArchivo 				    :0,
				  codigoClasificacionArchivo 	:0,
				  nombreArchivo 				:'',
				  mimeType 						:'',
				  peso 							:0,
				  ruta 							:'',
				  descripcion 					:'',
				  estado 						:0,
				  idTablaArchivo 				:0,
				  posicionArchivo 				:0
				};
				

		}
/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'pregunta/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'pregunta/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'pregunta/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'pregunta/eliminar', prmData);
		}
		
		function buscarPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'pregunta/buscarPorId', prmData);
		}
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('PreguntaSectorFactory', PreguntaSectorFactory);

	/* @ngInject */
	function PreguntaSectorFactory(API_CONFIG, APIFactory,MaestroFactory,PreguntaFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			buscarPorId : buscarPorId
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		
				  idPreguntaSector 	:0,
				  pregunta 			:PreguntaFactory.model(),
				  sector 			:MaestroFactory.model(),
				  subSector 		:MaestroFactory.model(),
				  actividad 		:MaestroFactory.model(),
				  estado 			:MaestroFactory.model()

			};
		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'pregunta-sector/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'pregunta-sector/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'pregunta-sector/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'pregunta-sector/eliminar', prmData);
		}
		
		function buscarPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'pregunta-sector/buscarPorId', prmData);
		}
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('PreguntaNormativaFactory', PreguntaNormativaFactory);

	/* @ngInject */
	function PreguntaNormativaFactory(API_CONFIG, APIFactory,PreguntaFactory,MaestroFactory,ContenidoNormaFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			buscarPorId : buscarPorId
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {	

				idPreguntaNormativa 		:0,
				pregunta 					:PreguntaFactory.model(),
				contenidoNorma 				:ContenidoNormaFactory.model(),
				estado 						:MaestroFactory.model()

			};
		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'pregunta-normativa/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'pregunta-normativa/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'pregunta-normativa/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'pregunta-normativa/eliminar', prmData);
		}
		
		function buscarPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'pregunta-normativa/buscarPorId', prmData);
		}
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('PersonaFactory', PersonaFactory);
    /* @ngInject */
    function PersonaFactory(API_CONFIG, APIFactory, $q, $http) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            buscarXId: buscarXId,
            buscarXNumeroDocumento: buscarXNumeroDocumento,
            actualizar: actualizar,
            registrarPersonaOefa: registrarPersonaOefa
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
                idPersona: 0,
                documento: '',
                primerNombre: '',
                segundoNombre: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
                ubigeo: '',
                departamento: '',
                provincia: '',
                distrito: '',
                direccion: '',
                referencia: ''
            };
        }

        function buscarXId(prmPersona) {
            return APIFactory.listar(API_CONFIG.url + 'persona/buscar', prmPersona);
        }

        function buscarXNumeroDocumento(prmPersona) {
            return APIFactory.listar(API_CONFIG.url + 'persona/buscar-documento', prmPersona);
        }

        function actualizar(prmPersona) {
            return APIFactory.actualizar(API_CONFIG.url + 'persona/actualizar', prmPersona);
        }

        function registrarPersonaOefa(prmPersona) {
            return APIFactory.registrar(API_CONFIG.url + 'persona/insertar-persona-oefa', prmPersona);
        }
        /*	function listar(prmCliente) {
        		return APIFactory.listar(API_CONFIG.url+'persona', prmCliente);
        	}
        	
        	function registrar(prmCliente) {
        		return APIFactory.registrar(API_CONFIG.url+'persona/registrar', prmCliente);
        	}

        	function obtener(idCliente) {
        		return APIFactory.obtener(API_CONFIG.url+'persona/', idCliente);
        	}

        	function actualizar(prmCliente) {
        		return APIFactory.actualizar(API_CONFIG.url+'persona/actualizar', prmCliente);
        	}

        	function eliminar(prmCliente) {
        		return APIFactory.eliminar(API_CONFIG.url+'persona/eliminar', prmCliente);
        	}

        	function buscarPorRUC(prmCliente) {
        		return APIFactory.consultaPOST(API_CONFIG.url+'persona/buscar-x-ruc',prmCliente);
        		
        	}*/
        /*fin de factory*/
    }
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('PeriodoPreguntaFactory', PeriodoPreguntaFactory);

	/* @ngInject */
	function PeriodoPreguntaFactory(API_CONFIG, APIFactory,PreguntaFactory,MaestroFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			buscarPorId : buscarPorId
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		
				  idPeriodoPregunta	:0,
				  pregunta			:PreguntaFactory.model(),
				  periodo 			:MaestroFactory.model(),
				  estado			:MaestroFactory.model()

			};
		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'periodo-pregunta/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'periodo-pregunta/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'periodo-pregunta/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'periodo-pregunta/eliminar', prmData);
		}
		
		function buscarPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'periodo-pregunta/buscarPorId', prmData);
		}
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('PerfilFactory', PerfilFactory);

	/* @ngInject */
	function PerfilFactory(API_CONFIG, APIFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			/*obtener : obtener,*/
			actualizar : actualizar,
			eliminar : eliminar
		/*	loginUsuario : loginUsuario,
			cambiarClave : cambiarClave*/
		};

		return factory;

		/* implementacion de metodos */
			

		function model() {
			return {

				idPerfil:0,
				nombrePerfil : '',
				estado :0,
				flagActivo:''
			};
		}

		function listar() {
			return APIFactory.listar(API_CONFIG.url+'perfil/listar');
		}

		function registrar(prmPerfil) {
			return APIFactory.registrar(API_CONFIG.url+'perfil/registrar', prmPerfil);
		}
/*
		function obtener(idUsuario) {
			return APIFactory.obtener(API_CONFIG.url+'perfil/obtener/', idUsuario);
		}
*/
		function actualizar(prmPerfil) {
			return APIFactory.actualizar(API_CONFIG.url+'perfil/actualizar', prmPerfil);
		}

		function eliminar(prmPerfil) {
			return APIFactory.eliminar(API_CONFIG.url+'perfil/eliminar', prmPerfil);
		}

	/*	function loginUsuario(prmPerfil){
			return APIFactory.consultaPOST(API_CONFIG.url+'perfil/login', prmUsuario);
		}

		function cambiarClave(prmPerfil){
			return APIFactory.actualizar(API_CONFIG.url+'perfil/cambiarClave',prmUsuario);
		}
*/
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('ParametroLMPFactory', ParametroLMPFactory);
	/* @ngInject */
	function ParametroLMPFactory(API_CONFIG, APIFactory, CookiesFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			inactivar : inactivar,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				secuencia : 0,
				cod_parametro : 0,
				cod_norma : 0,
				cod_periodo : 0,
				cod_actividad : 0,
				valor : 0,
				valor2 : 0,
				concentracion_texto : null,
				concentracion_codigo : null,
				tipo : 'LMP',
				auxNormaNombre : '',
				auxPeriodoNombre : '',
				auxActividadNombre : '',
				estado : '1',
				idsession : CookiesFactory.obtenerCookie(),
				componente : 0,
				matriz : 0,
				submatriz : 0,
				ultima_fecha : new Date()
			};
		}

		function listar(prmParametro) {
			console.log(prmParametro);
			return APIFactory.listar(API_CONFIG.url + 'parametrolmp/listar',
					prmParametro);
		}

		function registrar(prmParametro) {
			console.log(prmParametro);
			return APIFactory.registrar(API_CONFIG.url
					+ 'parametrolmp/registrar', prmParametro);
		}

		function actualizar(prmParametro) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'parametrolmp/actualizar', prmParametro);
		}

		function eliminar(prmParametro) {
			return APIFactory.eliminar(
					API_CONFIG.url + 'parametrolmp/eliminar', prmParametro);
		}

		function inactivar(prmParametro) {
			return APIFactory.inactivar(API_CONFIG.url
					+ 'parametrolmp/inactivar', prmParametro);
		}
		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('ParametroECAFactory', ParametroECAFactory);
	/* @ngInject */
	function ParametroECAFactory(API_CONFIG, APIFactory,CookiesFactory ) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			inactivar : inactivar,
			buscarPorId : buscarPorId,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				secuencia : 0,
				cod_parametro : 0,
				cod_norma : 0,
				cod_periodo : 0,
				cod_actividad : 0,
				valor : 0,
				valor2 : 0,
				concentracion_texto : null,
				concentracion_codigo : null,
				tipo : 'ECA',
				auxNormaNombre : '',
				auxPeriodoNombre : '',
				auxActividadNombre : '',
				estado : '1',
				idsession : CookiesFactory.obtenerCookie(),
				componente : 0,
				matriz : 0,
				submatriz : 0,
				ultima_fecha : new Date()
			};
		}

		function buscarPorId(prmParametro) {
			console.log('buscarPorId ' + prmParametro.codigo);
			return APIFactory.buscarPorId(API_CONFIG.url
					+ 'parametroeca/buscarPorID', prmParametro);
		}

		function listar(prmParametro) {
			console.log(prmParametro);
			return APIFactory.listar(API_CONFIG.url + 'parametroeca/listar',
					prmParametro);
		}

		function registrar(prmParametro) {
			console.log(prmParametro);
			return APIFactory.registrar(API_CONFIG.url
					+ 'parametroeca/registrar', prmParametro);
		}

		function actualizar(prmParametro) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'parametroeca/actualizar', prmParametro);
		}

		function eliminar(prmParametro) {
			return APIFactory.eliminar(
					API_CONFIG.url + 'parametroeca/eliminar', prmParametro);
		}

		function inactivar(prmParametro) {
			return APIFactory.inactivar(API_CONFIG.url
					+ 'parametroeca/inactivar', prmParametro);
		}
		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('ParametroFactory', ParametroFactory);
	/* @ngInject */
	function ParametroFactory(API_CONFIG, APIFactory, CookiesFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			modelValor : modelValor,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			inactivar : inactivar,
			buscarPorId : buscarPorId,
			listarValor : listarValor,
			registrarValor : registrarValor,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				codigo : 0,
				descripcion : '',
				flag_u_menor : '',
				flag_u_mayor : '',
				blUnidadMenor : true,
				blUnidadMayor : true,
				cod_unidad : 0,
				estado : '1',
				idsession : CookiesFactory.obtenerCookie(),
				ultima_fecha : new Date(),
				auxunidadnombre : '',
				lstEcas : [],
				lstLmps : []

			};
		}

		function modelValor() {
			return {
				secuencia : 0,
				cod_parametro : 0,
				cod_norma : 0,
				cod_periodo : 0,
				cod_actividad : 0,
				cod_unidad : 0,
				auxParametroNombre : '',
				tipo : '',
				estado : '1',
				idsession : '',
				ultima_fecha : new Date(),
				blSeleccionado : false,

			};
		}

		function buscarPorId(prmParametro) {
			console.log('buscarPorId ' + prmParametro.codigo);
			return APIFactory.buscarPorId(API_CONFIG.url
					+ 'parametro/buscarPorID', prmParametro);
		}

		function listar(prmParametro) {
			return APIFactory.listar(API_CONFIG.url + 'parametro/listar',
					prmParametro);
		}

		function listarValor(prmParametro) {
			return APIFactory.listar(API_CONFIG.url + 'parametro/listarValor',
					prmParametro);
		}

		function registrar(prmParametro) {
			return APIFactory.registrar(API_CONFIG.url + 'parametro/registrar',
					prmParametro);
		}

		function registrarValor(prmParametroValor) {
			return APIFactory.registrarValor(API_CONFIG.url
					+ 'parametro/registrarValor', prmParametroValor);
		}

		function actualizar(prmParametro) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'parametro/actualizar', prmParametro);
		}

		function eliminar(prmParametro) {
			return APIFactory.eliminar(API_CONFIG.url + 'parametro/eliminar',
					prmParametro);
		}

		function inactivar(prmParametro) {
			return APIFactory.inactivar(API_CONFIG.url + 'parametro/inactivar',
					prmParametro);
		}
		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('OpcionPreguntaFactory', OpcionPreguntaFactory);

	/* @ngInject */
	function OpcionPreguntaFactory(API_CONFIG, APIFactory,PreguntaFactory,MaestroFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			buscarPorId : buscarPorId
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		
				  idOpcionPregunta 	:0,
				  pregunta       	:PreguntaFactory.model(),
				  valor 			:'',
				  estado 			:MaestroFactory.model(),
				  swCorrecto 		:0,
				  posicionFila 		:0,
				  posicionColumna	:0,
				  lstOpcionPreguntaColumna : []
			};
		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'opcion-pregunta/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'opcion-pregunta/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'opcion-pregunta/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'opcion-pregunta/eliminar', prmData);
		}
		
		function buscarPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'opcion-pregunta/buscarPorId', prmData);
		}
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('ODFactory', ODFactory);
    /* @ngInject */
    function ODFactory(API_CONFIG, APIFactory, CookiesFactory) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            listar 		: listar,
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
            	idod: 0,
            	nombre: ''
            };
        }

        function listar(prmOd) {
            return APIFactory.listar(API_CONFIG.url + 'od/listar', prmOd);
        }
      
        /*fin de factory*/
    }
})();
(function() {
	'use strict';

	angular.module('spapp').factory('NormasFactory', NormasFactory);

	/* @ngInject */
	function NormasFactory(API_CONFIG, APIFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			modelNormas : modelNormas,
			listar : listar,
			buscarPorNumeroNorma : buscarPorNumeroNorma,
			buscarEntidadXNumeroDocumento : buscarEntidadXNumeroDocumento,
			buscarEntidadXId : buscarEntidadXId,
			obtenerURLSirin : obtenerURLSirin,
			listarPorComponente : listarPorComponente 
		/* modelProducto : modelProducto */

		};

		return factory;

		/* implementacion de metodos */

		function modelNormas() {
			return {

				idNorma : 0,
				numeroNorma : '',
				descripcion : '',
				tipoDispositivo : 0,
				nombreTipoDispositivo : '',
				fechaVigencia : '',
				fechaModificacion : '',
				fechaDerogacion : '',
				sector : 0,
				subSector : 0,
				actividad : 0,
				entidadEmisora : 0,
				estado : 0,
				flagActivo : '',
				ambitoDispositivo : 0,
				componente: ''

			};
		}
		/*
		 * function listar() { return APIFactory.listar(API_CONFIG.url+'efa' ); }
		 */

		function listar(prmNormas) {
			return APIFactory.listar(API_CONFIG.url + 'normas/listar',
					prmNormas);
		}

		function buscarPorNumeroNorma(numeroNorma) {
			return APIFactory.consultaPOST(API_CONFIG.url + 'normas/',
					numeroNorma);

		}

		function buscarEntidadXNumeroDocumento(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url + 'entidad/buscar-entidad',
					prmEntidad);
		}

		function buscarEntidadXId(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url
					+ 'entidad/buscar-entidad-id', prmEntidad);
		}
		function obtenerURLSirin() {
			return APIFactory.listar(API_CONFIG.url
					+ 'normas/obtenerURLSirin');
		}
		function listarPorComponente(prmNormas) {
			return APIFactory.listar(API_CONFIG.url + 'normas/listarPorComponente',
					prmNormas);
		}
		/* fin de factory */
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('NormaLegalFactory', NormaLegalFactory);
    /* @ngInject */
    function NormaLegalFactory(API_CONFIG, APIFactory) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            listar 		: listar,
            listarActivos : listarActivos,  
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			inactivar   : inactivar,
			buscarPorId : buscarPorId,
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
            	codigo: 0,
            	descripcion: '',
            	comentario: '',
            	estado: '1',
            	blSeleccionado: false,
            	idsession: '',
                ultima_fecha: new Date()
            };
        }

        function buscarPorId(prmNormaLegal) {
        	console.log('buscarPorId ' + prmNormaLegal.codetapa);
            return APIFactory.buscarPorId(API_CONFIG.url + 'normalegal/buscarPorID', prmNormaLegal);
        }

        function listar(prmNormaLegal) {
        	console.log(prmNormaLegal);
            return APIFactory.listar(API_CONFIG.url + 'normalegal/listar', prmNormaLegal);
        }
        
        function listarActivos(prmNormaLegal) {
        	console.log(prmNormaLegal);
            return APIFactory.listar(API_CONFIG.url + 'normalegal/listarActivos', prmNormaLegal);
        }
        
        function registrar(prmNormaLegal) {
            return APIFactory.registrar(API_CONFIG.url + 'normalegal/registrar', prmNormaLegal);
        }
        
        function actualizar(prmNormaLegal) {
            return APIFactory.actualizar(API_CONFIG.url + 'normalegal/actualizar', prmNormaLegal);
        }
        
        function eliminar(prmNormaLegal) {
            return APIFactory.eliminar(API_CONFIG.url + 'normalegal/eliminar', prmNormaLegal);
        }
        
        function inactivar(prmNormaLegal) {
            return APIFactory.inactivar(API_CONFIG.url + 'normalegal/inactivar', prmNormaLegal);
        }
        /*fin de factory*/
    }
})();
(function() {
	'use strict';

	angular.module('spapp').factory('MaestroFactory', MaestroFactory);

	/* @ngInject */
	function MaestroFactory(API_CONFIG, APIFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			modelFrecuenciaFecha : modelFrecuenciaFecha,
			listar : listar,
			buscarXCodigoMaestro : buscarXCodigoMaestro,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			buscarMaestros : buscarMaestros,
			buscarRegistroHijo : buscarRegistroHijo,
			obtenerParametros : obtenerParametros,
			enviarCorreoAnticipado : enviarCorreoAnticipado,
			listarfechasfrecuencia : listarfechasfrecuencia,
			listarfechasfrecuenciaDet : listarfechasfrecuenciaDet,
			listarDiasPrevioCorreo : listarDiasPrevioCorreo,
			guardarDiasPrevioCorreo : guardarDiasPrevioCorreo,
			generarIGAS : generarIGAS
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {

				idMaestro : 0,
				codigoMaestro : '',
				codigoRegistro : 0,
				descripcion : '',
				abreviatura : '',
				codigoRegistroPadre : 0,
				flagActivo : '',
				codigoNivel : 0,
				valorGeneral01 : '',
				valorGeneral02 : '',
				valorGeneral03 : '',
				valorGeneral04 : '',
				valorGeneral05 : ''

			};
		}

		function modelFrecuenciaFecha() {
			return {
				nombrepresentacion : '',
				frecuencia : '',
				periodo : 0,
				numerofrecuencia : '',
				fechalimite : '',
				tipo : '',
				diasIMA1 : 0,
				diasIMA2 : 0,
				diasDRS1 : 0,
				diasDRS2 : 0,
				diasMRS1 : 0,
				diasMRS2 : 0,
				diasRIN1 : 0,
				diasRIN2 : 0,
				diasIAA1 : 0,
				diasIAA2 : 0,
				valornumero : 0,
				codigo : ''

			};
		}

		function listar() {
			return APIFactory.listar(API_CONFIG.url
					+ 'maestro/listar-codigo-maestro');
		}

		function buscarXCodigoMaestro(prmMaestro) {
			return APIFactory.listar(API_CONFIG.url + 'maestro/buscar-maestro',
					prmMaestro);
		}

		function buscarRegistroHijo(prmMaestro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'maestro/listar-registro-hijo', prmMaestro);
		}

		function registrar(prmMaestro) {
			return APIFactory.registrar(API_CONFIG.url + 'maestro/registrar',
					prmMaestro);
		}

		function enviarCorreoAnticipado(prmMaestro) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'maestro/enviarCorreoAnticipado', prmMaestro);
		}

		function listarfechasfrecuencia(prmFechaFrecuencia) {
			return APIFactory.listar(API_CONFIG.url
					+ 'configuracion/listarfechasfrecuencia',
					prmFechaFrecuencia);
		}

		function listarfechasfrecuenciaDet(prmFechaFrecuencia) {
			return APIFactory.listar(API_CONFIG.url
					+ 'configuracion/listarfechasfrecuenciadet',
					prmFechaFrecuencia);
		}

		function listarDiasPrevioCorreo() {
			return APIFactory.listar(API_CONFIG.url
					+ 'configuracion/listarDiasPrevioCorreo');
		}

		function generarIGAS() {
			return APIFactory.listar(API_CONFIG.url
					+ 'configuracion/generarIGAS');
		}

		function guardarDiasPrevioCorreo(prmConfiguracion) {
			return APIFactory
					.actualizar(API_CONFIG.url
							+ 'configuracion/guardarDiasPrevioCorreo',
							prmConfiguracion);
		}
		/*
		 * function obtener(idMaestro) { return
		 * APIFactory.obtener(API_CONFIG.url+'maestro/obtener/', idAutor); }
		 */

		function actualizar(prmMaestro) {
			return APIFactory.actualizar(API_CONFIG.url + 'maestro/actualizar',
					prmMaestro);
		}

		function eliminar(prmMaestro) {
			return APIFactory.eliminar(API_CONFIG.url + 'maestro/eliminar',
					prmMaestro);
		}

		function buscarMaestros(prmListaMaestros) {
			return APIFactory.listar(API_CONFIG.url + 'maestro/buscarMaestros',
					prmListaMaestros);
		}
		/*
		 * function buscar(prmListaMaestros) { return
		 * APIFactory.registrar(API_CONFIG.url+'maestro/buscar',
		 * prmListaMaestros); }
		 */

		function obtenerParametros() {
			return APIFactory.listar(API_CONFIG.url
					+ 'maestro/obtenerParametros');
		}
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('InstrumentoGestionFactory',
			InstrumentoGestionFactory);

	/* @ngInject */
	function InstrumentoGestionFactory(API_CONFIG, APIFactory, MaestroFactory,
			UbigeoFactory, DeclaracionEtapaFactory, CookiesFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			modificacion_model : modificacion_model,
			documento_model : documento_model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			listarPorInstalacion : listarPorInstalacion,
			listarMonitoreoPorInstalacion : listarMonitoreoPorInstalacion,
			registrarDeclaracion : registrarDeclaracion,
			listarModificaciones : listarModificaciones,
			listarDocumentos : listarDocumentos,
			eliminarDocumento : eliminarDocumento,
			listarPorFiltros : listarPorFiltros,
			copiarProgramaMonitoreo : copiarProgramaMonitoreo
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				idAdministrado : 0,
				idInstrumentoGestion : 0,
				idInstalacion : 0,
				idTipoInstrumento : "",
				resolucion : "",
				descripcion : "",
				flag_modifica_iga : "N",
				blModificaIga : false,
				auxTipoIgaNombre : "",
				fecha : null,
				estado : "1",
				fechaAprobacion : "",
				archivoNombre : "",
				idsession : CookiesFactory.obtenerCookie(),
				blSeleccionado : false,
				declaracionEtapa : DeclaracionEtapaFactory.model(),
				lstIntrumentoGestionMod : [],
				lstIntrumentoGestionDoc : [],
				observacion : "",
				fechadesde : null,
				fechahasta : null,
				blVigente : false,
				blCompleto : false,
				blRevisado : false,
				idInstrumentoGestionDestino : 0,
			};
		}

		function modificacion_model() {
			return {
				idAdministrado : 0,
				id_InstrumentoGestion : 0,
				id_Instalacion : 0,
				id_InstrumentoGestionMod : 0,
				estado : "1",
				resolucion : "",
				fecha : null,
				auxTipoIgaNombre : "",
				fechaAprobacion : "",
				archivoNombre : "",
				lstIntrumentoGestionDoc: [],
				idsession : CookiesFactory.obtenerCookie(),
			};
		}

		function documento_model() {
			return {
				idAdministrado : 0,
				idInstalacion : 0,
				idInstrumentoGestion : 0,
				secuencia : 0,
				estado : "1",
				nombreArchivo : "",
				rutaArchivo : "",
				uuid : "",
				idsession : CookiesFactory.obtenerCookie(),
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instrumentoGestion/listar', prmData);
		}

		function listarPorInstalacion(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instrumentoGestion/listarPorInstalacion', prmData);
		}
		
		function listarPorFiltros(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instrumentoGestion/listarPorFiltros', prmData);
		}

		function listarMonitoreoPorInstalacion(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instrumentoGestion/listarMonitoreoPorInstalacion',
					prmData);
		}

		function listarModificaciones(prmData) {
			console.log('prmData ' + prmData);
			return APIFactory.listar(API_CONFIG.url
					+ 'instrumentoGestion/listarModificaciones', prmData);
		}
		
		function listarDocumentos(prmData) {
			console.log('prmData ' + prmData);
			return APIFactory.listar(API_CONFIG.url
					+ 'instrumentoGestion/listarDocumentos', prmData);
		}
		
		function registrar(files, prmData) {
			var formData = new FormData();

			for ( var x in files) {
				formData.append("file", files[x]);
			}

			formData.append("strContenido", angular.toJson(prmData));

			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'instrumentoGestion/registrar', formData);
		}

		function actualizar(files, prmData) {
			var formData = new FormData();

			if (files.length > 0) {
				for ( var x in files) {
					formData.append("file", files[x]);
				}
				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'instrumentoGestion/actualizarConArchivo', formData);
			} else {
				return APIFactory.actualizar(API_CONFIG.url
						+ 'instrumentoGestion/actualizar', prmData);
			}

		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'instrumentoGestion/eliminar', prmData);
		}
		
		function eliminarDocumento(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'instrumentoGestion/eliminarDocumento', prmData);
		}

		function registrarDeclaracion(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'instrumentoGestion/registrarDeclaracion', prmData);
		}

		function copiarProgramaMonitoreo(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'instrumentoGestion/copiarProgramaMonitoreo', prmData);
		}
		

		/* ******************************************************************************** */

		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('InstalacionFactory', InstalacionFactory);

	/* @ngInject */
	function InstalacionFactory(API_CONFIG, APIFactory, MaestroFactory,
			CookiesFactory, UbigeoFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			model_documento : model_documento,
			listar : listar,
			listarxUsuarioUbigeo : listarxUsuarioUbigeo,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			buscarPorRuc : buscarPorRuc,
			buscarPorId : buscarPorId,
			modificarEstadoInstalacion : modificarEstadoInstalacion,
			listarDocumento : listarDocumento,
			eliminarDocumento : eliminarDocumento,
			registrarDocumento : registrarDocumento,
			actualizarDocumento : actualizarDocumento,
			buscarPorIdAdministrado : buscarPorIdAdministrado,
			registrarVarios : registrarVarios,
			listarReporteDistribucion : listarReporteDistribucion,
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				idInstalacion : 0,
				idAdministrado : 0,
				ruc : '',
				razonsocial : '',
				sector : 'SEC00002',
				subSector : 'SUB00002',
				competencia : '',
				competenciaArray : [],
				actividad : '',
				departamento : UbigeoFactory.departamento(),
				provincia : UbigeoFactory.provincia(),
				distrito : UbigeoFactory.distrito(),
				estado : 1,
				flagActivo : 1,
				numeroInstalacion : '',
				tipoEstablecimiento : 0,
				numeroRegistro : '',
				rutaFichaRegistro : '',
				direccion : '',
				flgRegistroManual : "N",
				puntoNorte : '',
				puntoEste : '',
				referencia : '',
				idzona : 0,
				lstAdministradoxInstalacion : [],
				lstDocumentos : [],
				flgSeleccionado : false,
				prm1 : CookiesFactory.obtenerCookie(),
				numeroItem : 0,
				sectorDescripcion : '',
				subSectorDescripcion : '',
				competenciaDescripcion : '',
				actividadDescripcion : '',
				tipoReporte : 'UF',
				flgModificado : '',
				nombreArchivoOriginal : '',
				resolucionIga : '',
				tipoIga : '',
				fechaaprobacionIga : null
			};
		}

		function model_documento() {
			return {
				idInstalacion : 0,
				idAdministrado : '',
				ficha_registro : '',
				ruta_ficha_registro : '',
				uiid : '',
				nombreOriginal : '',
				idsession : CookiesFactory.obtenerCookie(),
				ultima_fecha : new Date(),
			};
		}

		function listarxUsuarioUbigeo(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instalacion/listarxUsuarioUbigeo', prmData);
		}

		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url + 'instalacion/listar',
					prmData);
		}

		function registrar(archivos, prmData) {
			if (archivos.length == 0) {
				return APIFactory.registrar(API_CONFIG.url
						+ 'instalacion/registrar', prmData);
			} else {
				var formData = new FormData();
				for ( var x in archivos) {
					formData.append("file", archivos[x]);
				}
				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory
						.guardarArchivo(API_CONFIG.url
								+ 'instalacion/registrar-instalacion-archivo',
								formData);
			}
		}

		function registrarVarios(archivos, prmData) {
			if (archivos.length == 0) {
				return APIFactory.registrar(API_CONFIG.url
						+ 'instalacion/registrarVarios', prmData);
			} else {
				var formData = new FormData();
				for ( var x in archivos) {
					formData.append("file", archivos[x]);
				}
				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory
						.guardarArchivo(API_CONFIG.url
								+ 'instalacion/registrar-instalacion-archivo',
								formData);
			}
		}

		function actualizar(files, prmData) {
			debugger;
			if (files.length == 0) {
				return APIFactory.actualizar(API_CONFIG.url
						+ 'instalacion/actualizar', prmData);
			} else {

				var formData = new FormData();
				for ( var x in files) {
					formData.append("file", files[x]);
				}

				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'instalacion/actualizar-instalacion-archivo',
						formData);

			}

		}

		function listarDocumento(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instalacion/listarDocumento', prmData);
		}

		function eliminarDocumento(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'instalacion/eliminarDocumento', prmData);
		}

		function registrarDocumento(files, prmData) {

			var formData = new FormData();
			for ( var x in files) {
				formData.append("file", files[x]);
			}

			formData.append("strContenido", angular.toJson(prmData));
			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'instalacion/registrar-instalacion-documento', formData);
		}

		function actualizarDocumento(files, prmData) {
			var formData = new FormData();
			for ( var x in files) {
				formData.append("file", files[x]);
			}

			formData.append("strContenido", angular.toJson(prmData));
			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'instalacion/actualizar-instalacion-archivo', formData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url + 'instalacion/eliminar',
					prmData);
		}
		function buscarPorRuc(prmData) { // debugger;
			return APIFactory.listar(API_CONFIG.url
					+ 'instalacion/buscarPorRUC', prmData);
		}

		function buscarPorId(prmData) { // debugger;
			return APIFactory.listar(
					API_CONFIG.url + 'instalacion/buscarPorID', prmData);
		}

		function modificarEstadoInstalacion(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'instalacion/modificar-estado-instalacion', prmData);
		}

		function buscarPorIdAdministrado(prmData) { // debugger;
			return APIFactory.listar(API_CONFIG.url
					+ 'instalacion/buscarPorIdAdministrado', prmData);
		}

		function listarReporteDistribucion() { // debugger;
			return APIFactory
					.listar(API_CONFIG.url + 'grafico/barras', 'chart');
		}

		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('GraficoFactory', GraficoFactory);

	/* @ngInject */
	function GraficoFactory(API_CONFIG, APIFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			instalacionesxDepartamentos : instalacionesxDepartamentos,
			instalacionesxTipoEstablecimiento : instalacionesxTipoEstablecimiento,
			incumplimientosxTipoEstablecimiento : incumplimientosxTipoEstablecimiento,
			distribucionCoorporativo : distribucionCoorporativo,
			coorporativoRanking : coorporativoRanking,
			cantidadUnidadesFiscalizablesxTipoEstablecimiento : cantidadUnidadesFiscalizablesxTipoEstablecimiento,
			cantidadUnidadesFiscalizables : cantidadUnidadesFiscalizables,
			cantidadUnidadesFiscalizablesIMA : cantidadUnidadesFiscalizablesIMA,
			cantidadCoorporativos : cantidadCoorporativos,
			incumplimientoParametros : incumplimientoParametros,
			instalacionesExcedenConcentra : instalacionesExcedenConcentra,
			
			//graficos reporte de supervision
			instalacionesxUbigeo : instalacionesxUbigeo,
			instalacionesxUbigeoAdmin : instalacionesxUbigeoAdmin,
			igasPorUnidades : igasPorUnidades,
			igasPorAdministrado: igasPorAdministrado,
			igasPorUbigeo : igasPorUbigeo
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				idAdministrado : 0,
				ruc : '',
				razonsocial : '',
				codigodepartamento : '',
				nombredepartamento : '',
				codigoprovincia : '',
				nombreprovincia : '',
				codigodistrito : '',
				nombredistrito : '',
				codigoestablecimiento : '',
				nombreestablecimiento : '',
				registrados : 0,
				reportados : 0,
				codigood: '',
				fechadesde : null,
				fechahasta : null
			};
		}

		function instalacionesxDepartamentos(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/instalacionesxDepartamentos', prmData);
		}
		function instalacionesxTipoEstablecimiento(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/instalacionesxTipoEstablecimiento', prmData);
		}
		function incumplimientosxTipoEstablecimiento(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/incumplimientosxTipoEstablecimiento', prmData);
		}

		function incumplimientoParametros(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/incumplimientoParametros', prmData);
		}

		function distribucionCoorporativo(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/distribucionCoorporativo', prmData);
		}

		function coorporativoRanking(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/coorporativoRanking', prmData);
		}

		function instalacionesExcedenConcentra(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/instalacionesExcedenConcentra', prmData);
		}

		function cantidadUnidadesFiscalizablesxTipoEstablecimiento(prmData) {
			return APIFactory
					.listar(
							API_CONFIG.url
									+ 'grafico/cantidadUnidadesFiscalizablesxTipoEstablecimiento',
							prmData);
		}

		function cantidadUnidadesFiscalizables(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/cantidadUnidadesFiscalizables', prmData);
		}

		function cantidadUnidadesFiscalizablesIMA(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/cantidadUnidadesFiscalizablesIMA', prmData);
		}

		function cantidadCoorporativos(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/cantidadCoorporativos', prmData);
		}

		function instalacionesxUbigeo(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/instalacionesxUbigeo', prmData);
		}
		
		function instalacionesxUbigeoAdmin(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/instalacionesxUbigeoAdmin', prmData);
		}
		
		function igasPorUnidades(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/igasPorUnidades', prmData);
		}
		
		function igasPorAdministrado(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/igasPorAdministrado', prmData);
		}
		
		function igasPorUbigeo(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'grafico/igasPorUbigeo', prmData);
		}
		
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('EtapaFactory', EtapaFactory);
    /* @ngInject */
    function EtapaFactory(API_CONFIG, APIFactory, CookiesFactory) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            listar 		: listar,
            listarActivosPorUnidad  : listarActivosPorUnidad ,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			inactivar   : inactivar,
			buscarPorId : buscarPorId,
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
            	codetapa: 0,
            	descripcion: '',
            	blUnidadMenor: true,
            	blUnidadMayor:  true,
            	prmTipoUnidad: 'ME',
            	estado: '1',
            	idsession: CookiesFactory.obtenerCookie(),
            };
        }

        function buscarPorId(prmEtapa) {
        	console.log('buscarPorId ' + prmEtapa.codetapa);
            return APIFactory.buscarPorId(API_CONFIG.url + 'etapa/buscarPorID', prmEtapa);
        }

        function listar(prmEtapa) {
            return APIFactory.listar(API_CONFIG.url + 'etapa/listar', prmEtapa);
        }
        
        function listarActivosPorUnidad(prmEtapa) {
            return APIFactory.listar(API_CONFIG.url + 'etapa/listarActivosPorUnidad', prmEtapa);
        }
        
        function registrar(prmEtapa) {
            return APIFactory.registrar(API_CONFIG.url + 'etapa/registrar', prmEtapa);
        }
        
        function actualizar(prmEtapa) {
            return APIFactory.actualizar(API_CONFIG.url + 'etapa/actualizar', prmEtapa);
        }
        
        function eliminar(prmEtapa) {
            return APIFactory.eliminar(API_CONFIG.url + 'etapa/eliminar', prmEtapa);
        }
        
        function inactivar(prmEtapa) {
            return APIFactory.inactivar(API_CONFIG.url + 'etapa/inactivar', prmEtapa);
        }
        /*fin de factory*/
    }
})();
(function() {
    'use strict';
    angular.module('spapp').factory('EorFactory', EorFactory);
    /* @ngInject */
    function EorFactory(API_CONFIG, APIFactory, CookiesFactory) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			inactivar   : inactivar,
			buscarPorId : buscarPorId,
			obtenerExterno	: obtenerExterno,
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
            	secuencia: 0,
            	ruc: '',
            	nombre: '',
            	direccion: '',
            	nroregistro: '',
            	fechavencimiento: null,
            	estado: '1',
            	idsession: CookiesFactory.obtenerCookie(),
                ultima_fecha: new Date()
            };
        }

        function buscarPorId(prmEor) {
            return APIFactory.buscarPorId(API_CONFIG.url + 'eor/buscarPorID', prmEor);
        }

        function listar(prmEor) {
            return APIFactory.listar(API_CONFIG.url + 'eor/listar', prmEor);
        }
        
        function obtenerExterno(prmEor) {
            return APIFactory.listar(API_CONFIG.url + 'eor/obtenerExterno', prmEor);
        }
        
        function registrar(prmEor) {
            return APIFactory.registrar(API_CONFIG.url + 'eor/registrar', prmEor);
        }
        
        function actualizar(prmEor) {
            return APIFactory.actualizar(API_CONFIG.url + 'eor/actualizar', prmEor);
        }
        
        function eliminar(prmEor) {
            return APIFactory.eliminar(API_CONFIG.url + 'eor/eliminar', prmEor);
        }
        
        function inactivar(prmEor) {
            return APIFactory.inactivar(API_CONFIG.url + 'eor/inactivar', prmEor);
        }
        /*fin de factory*/
    }
})();
(function() {
	'use strict';
	angular.module('spapp').factory('EntidadFactory', EntidadFactory);
	/* @ngInject */
	function EntidadFactory(API_CONFIG, APIFactory, CookiesFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			buscarXId : buscarXId,
			buscarXEntidadNumeroDocumento : buscarXEntidadNumeroDocumento,
			registrarEntidadOefa : registrarEntidadOefa,
			obtenerPorDocumento : obtenerPorDocumento,
			validarDocumento : validarDocumento,
			obtenerPorDocumentoAdministrado : obtenerPorDocumentoAdministrado
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				idEntidad : 0,
				razonSocial : '',
				ruc : '',
				cargo : 0,
				representanteLegal : {},
				direccion : '',
				referencia : '',
				prm1 : CookiesFactory.obtenerCookie(),
				lstUnidadesFiscalizables : [],
			};
		}

		function buscarXId(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url + 'entidad/buscar',
					prmEntidad);
		}

		function buscarXEntidadNumeroDocumento(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url
					+ 'entidad/buscar-documento', prmEntidad);
		}

		function obtenerPorDocumento(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url
					+ 'entidad/obtenerPorDocumento', prmEntidad);
		}

		function validarDocumento(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url
					+ 'entidad/validarDocumento', prmEntidad);
		}

		function obtenerPorDocumentoAdministrado(prmEntidad) {
			return APIFactory.listar(API_CONFIG.url
					+ 'entidad/obtenerPorDocumentoAdministrado', prmEntidad);
		}

		function registrarEntidadOefa(prmCliente) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'entidad/insertar-entidad-oefa', prmCliente);
		}
		/*
		 * function listar(prmCliente) { return
		 * APIFactory.listar(API_CONFIG.url+'persona', prmCliente); }
		 * 
		 * function registrar(prmCliente) { return
		 * APIFactory.registrar(API_CONFIG.url+'persona/registrar', prmCliente); }
		 * 
		 * function obtener(idCliente) { return
		 * APIFactory.obtener(API_CONFIG.url+'persona/', idCliente); }
		 * 
		 * function actualizar(prmCliente) { return
		 * APIFactory.actualizar(API_CONFIG.url+'persona/actualizar',
		 * prmCliente); }
		 * 
		 * function eliminar(prmCliente) { return
		 * APIFactory.eliminar(API_CONFIG.url+'persona/eliminar', prmCliente); }
		 * 
		 * function buscarPorRUC(prmCliente) { return
		 * APIFactory.consultaPOST(API_CONFIG.url+'persona/buscar-x-ruc',prmCliente); }
		 */
		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('DeclaracionPuntoFactory',
			DeclaracionPuntoFactory);
	/* @ngInject */
	function DeclaracionPuntoFactory(API_CONFIG, APIFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			contar : contar,
			registrar : registrar,
			actualizar : actualizar,
			actualizarComentarioIMA : actualizarComentarioIMA,
			eliminar : eliminar,
			eliminarPorComponente : eliminarPorComponente,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				idAdministrado : 0,
				idIga : 0,
				idInstalacion : 0,
				idEtapa : 0,
				idComponente : 0,
				idPunto : 0,
				idZona : 0,
				codigo : '',
				puntoNorte : '',
				puntoEste : '',
				observacion : '',
				auxNombreZona : '',
				estado : 'P',
				comentarioIMA : '',
				lstParametros : [],
				origen : 'D',
				prm1 : '',
			};
		}

		function listar(prmDeclaracionPunto) {
			return APIFactory.listar(API_CONFIG.url
					+ ' declaracionpunto/listar', prmDeclaracionPunto);
		}
		
		function contar(prmDeclaracionPunto) {
			return APIFactory.listar(API_CONFIG.url
					+ ' declaracionpunto/contar', prmDeclaracionPunto);
		}

		function registrar(prmDeclaracionPunto) {
			return APIFactory.registrar(API_CONFIG.url
					+ ' declaracionpunto/registrar', prmDeclaracionPunto);
		}

		function actualizar(prmDeclaracionPunto) {
			return APIFactory.actualizar(API_CONFIG.url
					+ ' declaracionpunto/actualizar', prmDeclaracionPunto);
		}

		function actualizar(prmDeclaracionPunto) {
			return APIFactory.actualizar(API_CONFIG.url
					+ ' declaracionpunto/actualizar', prmDeclaracionPunto);
		}

		function actualizarComentarioIMA(prmDeclaracionPunto) {
			return APIFactory.actualizar(API_CONFIG.url
					+ ' declaracionpunto/actualizarComentarioIMA',
					prmDeclaracionPunto);
		}

		function eliminar(prmDeclaracionPunto) {
			return APIFactory.eliminar(API_CONFIG.url
					+ ' declaracionpunto/eliminar', prmDeclaracionPunto);
		}

		function eliminarPorComponente(prmDeclaracionPunto) {
			return APIFactory.eliminar(API_CONFIG.url
					+ ' declaracionpunto/eliminarPorComponente',
					prmDeclaracionPunto);
		}

		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('DeclaracionParametroFactory',
			DeclaracionParametroFactory);
	/* @ngInject */
	function DeclaracionParametroFactory(API_CONFIG, APIFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			contar : contar,
			listarInforme : listarInforme,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			eliminarPorPunto : eliminarPorPunto,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				idAdministrado : '',
				idIga : 0,
				idInstalacion : 0,
				idEtapa : 0,
				idComponente : 0,
				idPunto : 0,
				idParametroValor : 0,
				periodo : '',
				frecuencia : 0,
				numero_frecuencia : 0,
				valor_monitoreo : 0.0,
				id_unidad_ensayo : 0,
				valor_ensayo : 0.0,
				codigo_ensayo : '',
				comentario : '',
				flg_acreditado : '0',
				idInformeMonitoreo: 0,
				secuencia : 0,
				idMatriz : 0,
				idSubMatriz : 0,
				auxUnidadNombre : '',
				auxParametroNombre : '',
				auxNormaNombre : '',
				auxPeriodoNombre : '',
				auxActividadNombre : '',
				auxValor : '',
				auxTipo : '',
				estado : 'P',
				boolInforma : false
			};
		}

		function listar(prmDeclaracionParametro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'declaracionparametro/listar',
					prmDeclaracionParametro);
		}
		
		function contar(prmDeclaracionParametro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'declaracionparametro/contar',
					prmDeclaracionParametro);
		}
		
		function listarInforme(prmDeclaracionParametro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'declaracionparametro/listarInforme',
					prmDeclaracionParametro);
		}

		function registrar(prmDeclaracionParametro) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'declaracionparametro/registrar',
					prmDeclaracionParametro);
		}

		function actualizar(prmDeclaracionParametro) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'declaracionparametro/actualizar',
					prmDeclaracionParametro);
		}

		function eliminar(prmDeclaracionParametro) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'declaracionparametro/eliminar',
					prmDeclaracionParametro);
		}

		function eliminarPorPunto(prmDeclaracionParametro) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'declaracionparametro/eliminarPorPunto',
					prmDeclaracionParametro);
		}

		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('DeclaracionEtapaFactory',
			DeclaracionEtapaFactory);
	/* @ngInject */
	function DeclaracionEtapaFactory(API_CONFIG, APIFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			generarEtapa : generarEtapa
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				idAdministrado : 0,
				idIga : 0,
				idInstalacion : 0,
				idEtapa : 0,
				estado : 'P',
				lstComponentes : []
			};
		}

		function listar(prmDeclaracionEtapa) {
			return APIFactory.listar(API_CONFIG.url
					+ 'declaracionetapa/listar', prmDeclaracionEtapa);
		}

		function registrar(prmDeclaracionEtapa) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'declaracionetapa/registrar', prmDeclaracionEtapa);
		}

		function actualizar(prmDeclaracionEtapa) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'declaracionetapa/actualizar', prmDeclaracionEtapa);
		}

		function eliminar(prmDeclaracionEtapa) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'declaracionetapa/eliminar', prmDeclaracionEtapa);
		}
		
		function generarEtapa(prmDeclaracionEtapa) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'declaracionetapa/generarEtapa', prmDeclaracionEtapa);
		}
		
		/* fin de factory */
	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('DeclaracionComponenteFactory',
			DeclaracionComponenteFactory);
	/* @ngInject */
	function DeclaracionComponenteFactory(API_CONFIG, APIFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			actualizarComentarioIMA : actualizarComentarioIMA,
			eliminar : eliminar,
			eliminarPorEtapa : eliminarPorEtapa,
			listarInforme : listarInforme,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				idAdministrado : 0,
				idIga : 0,
				idInstalacion : 0,
				idEtapa : 0,
				idComponente : 0,
				idFrecuencia : 0,
				estado : 'P',
				origen : 'D',
				comentarioIMA : '',
				auxComponenteNombre : '',
				lstPuntosMonitoreo : []
			};
		}

		function listar(prmDeclaracionComponente) {
			return APIFactory.listar(API_CONFIG.url
					+ 'declaracioncomponente/listar',
					prmDeclaracionComponente);
		}

		function listarInforme(prmDeclaracionComponente) {
			return APIFactory.listar(API_CONFIG.url
					+ 'declaracioncomponente/listarInforme',
					prmDeclaracionComponente);
		}

		function registrar(prmDeclaracionComponente) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'declaracioncomponente/registrar',
					prmDeclaracionComponente);
		}

		function actualizar(prmDeclaracionComponente) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'declaracioncomponente/actualizar',
					prmDeclaracionComponente);
		}

		function actualizarComentarioIMA(prmDeclaracionComponente) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'declaracioncomponente/actualizarComentarioIMA',
					prmDeclaracionComponente);
		}

		function eliminar(prmDeclaracionComponente) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'declaracioncomponente/eliminar',
					prmDeclaracionComponente);
		}

		function eliminarPorEtapa(prmDeclaracionEtapa) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'declaracioncomponente/eliminarPorEtapa',
					prmDeclaracionEtapa);
		}

		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('CuestionarioFactory', CuestionarioFactory);

	/* @ngInject */
	function CuestionarioFactory(API_CONFIG, APIFactory,MaestroFactory,InstalacionFactory,OpcionPreguntaFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			modelRespuestaCuestionario : modelRespuestaCuestionario,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			buscarPorId : buscarPorId,
			buscarPorIdInstalacion : buscarPorIdInstalacion,
			resolverCuestionario:resolverCuestionario,
			verCuestionario : verCuestionario,
			registrarDocumentoCuestionarios : registrarDocumentoCuestionarios,
			listarlistarDocumentosCuestionario : listarlistarDocumentosCuestionario,
			eliminarArchivosCuestionario: eliminarArchivosCuestionario,
			buscarCuestionarioPorId : buscarCuestionarioPorId
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		
				  idCuestionario 			:0,
				  instalacion 				:InstalacionFactory.model(),
				  fechaRegistro 			:'',
				  fechaFinal 				:'',
				  estado 					:MaestroFactory.model(),
				  lstCuestionarioDetalle 	:[]

			};
		}

		function modelRespuestaCuestionario(){
			return {
				  idRespuestaCuestionario 	:0,
				  cuestionarioDetalle 		:{},
				  descripcionRespuesta 		:'',
				  opcionPregunta 			:OpcionPreguntaFactory.model(),
				  estado 					:MaestroFactory.model(),
				  posicionFila				:0,
				  posicionColumna 			:0
			};

		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'cuestionario/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'cuestionario/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'cuestionario/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'cuestionario/eliminar', prmData);
		}
		
		function buscarPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'cuestionario/buscarPorId', prmData);
		}
		
		
		function buscarCuestionarioPorId(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'cuestionario/buscar-cuestionario-id', prmData);
		}
		
		function buscarPorIdInstalacion(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'cuestionario/buscarPorIdInstalacion', prmData);
		}

		function resolverCuestionario(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'cuestionario/resolver-cuestionario', prmData);
		}


	/*	function resolverCuestionario(files,prmData) {
			debugger;
			var formData = new FormData();

			for( var x in files)
				{
					formData.append("file",files[x]);
				}


			formData.append("strContenido",angular.toJson(prmData));


			return APIFactory.guardarArchivo(API_CONFIG.url+'cuestionario/resolver-cuestionario', formData);
		}
		*/
		function verCuestionario(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'cuestionario/verCuestionario',prmData);
		}

		function registrarDocumentoCuestionarios(files,prmData) {

				var formData = new FormData();

			for( var x in files)
				{
					formData.append("file",files[x]);
				}


				formData.append("strContenido",angular.toJson(prmData));

			return APIFactory.guardarArchivo(API_CONFIG.url+'cuestionario/registrar-documentos-cuestionario',formData);
		}


		function listarlistarDocumentosCuestionario(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url+'cuestionario/listar-documentos-cuestionario', prmData);
		}

		function eliminarArchivosCuestionario(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'cuestionario/eliminar-archivos-cuestionario', prmData);
		}

/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('ContenidoSolicitudFactory', ContenidoSolicitudFactory);

	/* @ngInject */
	function ContenidoSolicitudFactory(API_CONFIG, APIFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {		
				  idContenidoSolicitud 	:0,
				  idSolicitud 			:0,
				  campoSolicitud 		:'',
				  valorCampo 			:'',
				  tablaSolicitud 		:'',
				  estado 				:0

			};
		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'contenido-solicitud/listar', prmData);
		}
		
		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url+'contenido-solicitud/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url+'contenido-solicitud/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url+'contenido-solicitud/eliminar', prmData);
		}
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('ContenidoNormaFactory', ContenidoNormaFactory);

	/* @ngInject */
	function ContenidoNormaFactory(API_CONFIG, APIFactory,$q,$http ) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
				model:model,
				listar:listar,
				buscar : buscar
			/*modelProducto : modelProducto*/
			
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {	


		 	 		idContenidoNorma		: 0,
					idNorma 				: 0,
				    numeroNorma 			: '',
				    numeroContenidoNorma 	: '',
				    idTitulo 				: 0,
				    idCapitulo 				: 0,
				    idSubcapitulo 			: 0,
				    idSeccion 				: 0,
				    idArticulo 				: 0,
				    fechaVigencia 			: '',
				    estado 					: 0,
				    nombreEstado 			: '',
				    numeroTitulo 			: '',
				    descripcionTitulo 		: '',
				    numeroCapitulo 			: '',
				    descripcionCapitulo 	: '',
				    numeroSubCapitulo 		: '',
				    descripcionSubCapitulo	: '',
				    numeroSeccion 			: '',
				    descripcionSeccion 		: '',
				    numeroArticulo 			: '',
				    descripcionArticulo 	: ''

			};
		}

		/*function listar() {
			return APIFactory.listar(API_CONFIG.url+'efa' );
		}*/
		
		
		function listar(prmContenido) {
			return APIFactory.listar(API_CONFIG.url+'contenidonorma/listar', prmContenido);
		}

	    function buscar(idcontenido) {
			return APIFactory.consultaPOST(API_CONFIG.url+'contenidonorma/buscarPorId/',idcontenido);
			
		}
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('ContactoAdministradoFactory',
			ContactoAdministradoFactory);

	/* @ngInject */
	function ContactoAdministradoFactory(API_CONFIG, APIFactory, MaestroFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			obtener : obtener,
			actualizar : actualizar,
			eliminar : eliminar,
			listarContactosAdministrado : listarContactosAdministrado,
			modificarFlagPretedeterminadoDeContactoAdmi : modificarFlagPretedeterminadoDeContactoAdmi,
			validaContacto : validaContacto
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {

				idContactoAdministrado : 0,
				tipoContacto : MaestroFactory.model(),
				valor : '',
				idAdministrado : 0,
				estado : MaestroFactory.model(),
				flagActivo : '',
				flagPredeterminado : '',
				isPredeterminado : false,
				nombres : '',
				cargo : '',
				telefono : '',
				nombreArchivo : '',
				rutaArchivo : '',
				uuid : ''
			};
		}

		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'contacto-administrado/listar', prmData);
		}

		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'contacto-administrado/registrar', prmData);
		}

		function obtener(idContactoPersona) {
			return APIFactory.obtener(API_CONFIG.url
					+ 'contacto-administrado/buscar-id/', idContactoPersona);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'contacto-administrado/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'contacto-administrado/eliminar', prmData);
		}

		function listarContactosAdministrado(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'contacto-administrado/listarContactosAdministrado',
					prmData);
		}

		function modificarFlagPretedeterminadoDeContactoAdmi(prmData) {
			return APIFactory
					.actualizar(
							API_CONFIG.url
									+ 'contacto-administrado/modificarFlagPretedeterminadoDeContactoAdmi',
							prmData);
		}

		function validaContacto(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url
					+ 'contacto-administrado/validaContacto', prmData);
		}

		/* fin de factory */

	}
})();
(function() {
	'use strict';
	angular.module('spapp').factory('ComponenteAmbientalParametroFactory',
			ComponenteAmbientalParametroFactory);
	/* @ngInject */
	function ComponenteAmbientalParametroFactory(API_CONFIG, APIFactory) {
		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			inactivar : inactivar,
			buscarPorId : buscarPorId,
			eliminarPorLLave : eliminarPorLLave,
		};
		return factory;
		/* implementacion de metodos */
		function model() {
			return {
				componente : 0,
				matriz : 0,
				submatriz : 0,
				parametro_valor : 0,
				auxUnidadNombre : '',
				auxParametroNombre : '',
				auxNormaNombre : '',
				auxPeriodoNombre : '',
				auxActividadNombre : '',
				auxCodUnidad : 0,
				auxCodNorma : 0,
				auxCodPeriodo : 0,
				auxValor : 0,
				auxTipo : '',
				estado : '1',
				idsession : '',
				ultima_fecha : new Date()
			};
		}

		function buscarPorId(prmParametro) {
			console.log('buscarPorId ' + prmParametro.codigo);
			return APIFactory.buscarPorId(API_CONFIG.url
					+ 'componenteambientalparametro/buscarPorID', prmParametro);
		}

		function listar(prmParametro) {
			return APIFactory.listar(API_CONFIG.url
					+ 'componenteambientalparametro/listar', prmParametro);
		}

		function registrar(prmParametro) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'componenteambientalparametro/registrar', prmParametro);
		}

		function actualizar(prmParametro) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'componenteambientalparametro/actualizar', prmParametro);
		}

		function eliminar(prmParametro) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'componenteambientalparametro/eliminar', prmParametro);
		}

		function eliminarPorLLave(prmParametro) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'componenteambientalparametro/eliminarPorLLave',
					prmParametro);
		}

		function inactivar(prmParametro) {
			return APIFactory.inactivar(API_CONFIG.url
					+ 'componenteambientalparametro/inactivar', prmParametro);
		}
		/* fin de factory */
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('ComponenteAmbientalFactory', ComponenteAmbientalFactory);
    /* @ngInject */
    function ComponenteAmbientalFactory(API_CONFIG, APIFactory, CookiesFactory) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            model: model,
            listar 		: listar,
            listarActivosPorUnidad  : listarActivosPorUnidad ,
            listarHijos : listarHijos,
		    registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			inactivar   : inactivar,
			buscarPorId : buscarPorId,
        };
        return factory;
        /* implementacion de metodos */
        function model() {
            return {
            	codigo: 0,
            	codigopadre: 0,
            	nivel: 1,
            	descripcion: '',
            	flag_u_menor: '1',
            	flag_u_mayor: '1',
            	blUnidadMenor: true,
            	blUnidadMayor:  true,
            	prmTipoUnidad: 'ME',
            	estado: '1',
            	idsession: CookiesFactory.obtenerCookie(),
                ultima_fecha: new Date(),
                blSeleccionado: false
            };
        }

        function buscarPorId(prmComponenteAmbiental) {
        	console.log('buscarPorId ' + prmComponenteAmbiental.codcomponenteambiental);
            return APIFactory.buscarPorId(API_CONFIG.url + 'componenteambiental/buscarPorID', prmComponenteAmbiental);
        }

        function listar(prmComponenteAmbiental) {
        	console.log(prmComponenteAmbiental);
            return APIFactory.listar(API_CONFIG.url + 'componenteambiental/listar', prmComponenteAmbiental);
        }
        
        function registrar(prmComponenteAmbiental) {
            return APIFactory.registrar(API_CONFIG.url + 'componenteambiental/registrar', prmComponenteAmbiental);
        }
        
        function actualizar(prmComponenteAmbiental) {
            return APIFactory.actualizar(API_CONFIG.url + 'componenteambiental/actualizar', prmComponenteAmbiental);
        }
        
        function eliminar(prmComponenteAmbiental) {
            return APIFactory.eliminar(API_CONFIG.url + 'componenteambiental/eliminar', prmComponenteAmbiental);
        }
        
        function inactivar(prmComponenteAmbiental) {
            return APIFactory.inactivar(API_CONFIG.url + 'componenteambiental/inactivar', prmComponenteAmbiental);
        }
        
        function listarHijos(prmComponenteAmbiental) {
        	console.log(prmComponenteAmbiental);
            return APIFactory.listar(API_CONFIG.url + 'componenteambiental/listarHijos', prmComponenteAmbiental);
        }
        
        function listarActivosPorUnidad(prmComponenteAmbiental) {
            return APIFactory.listar(API_CONFIG.url + 'componenteambiental/listarActivosPorUnidad', prmComponenteAmbiental);
        }
        
        
        /*fin de factory*/
    }
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('ArchivoFactory', ArchivoFactory);

	/* @ngInject */
	function ArchivoFactory(API_CONFIG, APIFactory,$log) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
				listarArchivoidTabla : listarArchivoidTabla,
				model : model,
				eliminarArchivo: eliminarArchivo
		};

		return factory;


		function model() {
			return {
              
   	 	 			  idArchivo 					:0,
					  codigoClasificacionArchivo	:0,
					  nombreArchivo 				:'',
					  mimeType 						:'',
					  peso 							:0,
					  ruta 							:'',
					  descripcion 					:'',
					  estado 						:0,
					  idTablaArchivo 				:0,
					  posicionArchivo 				:0,
					  uiid 							:''
						 	 	

			};
		}



		function listarArchivoidTabla(prmData) {
			return APIFactory.listar(API_CONFIG.url+'archivo/listar-archivo-id-tabla',prmData);
		}

		function eliminarArchivo(prmData) {
			return APIFactory.listar(API_CONFIG.url+'archivo/eliminar-archivo',prmData);
		}
		
	/*	function operaciones(ref,id) {
	
			return APIFactory.listar(API_CONFIG.url+'seguridad/operaciones',{'prm1':ref,'prm2':id});
		}*/

		/*fin de factory*/
		
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('AdministradoxInstalacionTempFactory',
			AdministradoxInstalacionTempFactory);

	/* @ngInject */
	function AdministradoxInstalacionTempFactory(API_CONFIG, APIFactory,
			PersonaFactory, EntidadFactory, InstalacionFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			buscarxid : buscarxid,
			acciones : acciones
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				idInstalacion : 0,
				ruc : '',
				razonsocial : '',
				inicioAdministrado : null,
				inicioAdministradoBase : null,
				finAdministrado : null,
				flagActivo : '',
				auxflgaactivo : false,
				auxInicio : null,
				auxFin : null,
				idsession : '',
				ultima_fecha : new Date(),
				nombrearchivo : null,
				rutaalfresco : null,
				uuid : null,
				fechaInicioTexto : ''
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'administradoXinstalaciontemp/listar', prmData);
		}

		function registrar(files, prmData) {
			var formData = new FormData();
			for ( var x in files) {
				formData.append("file", files[x]);
			}

			formData.append("strContenido", angular.toJson(prmData));

			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'administradoXinstalaciontemp/registrar',
					formData);

		}

		function actualizar(files, prmData) {
			var formData = new FormData();

			if (files.length == 0) {
				return APIFactory.actualizar(API_CONFIG.url
						+ 'administradoXinstalaciontemp/actualizar', prmData);
			} else {
				for ( var x in files) {
					formData.append("file", files[x]);
				}

				formData.append("strContenido", angular.toJson(prmData));

				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'administradoXinstalaciontemp/actualizarArchivo',
						formData);
			}

		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'administradoXinstalaciontemp/eliminar', prmData);
		}

		function buscarxid(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'administradoXinstalaciontemp/buscarxid', prmData);
		}

		function acciones() {
			return APIFactory.acciones();
		}

		/* ******************************************************************************** */

		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('AdministradoFactory', AdministradoFactory);

	/* @ngInject */
	function AdministradoFactory(API_CONFIG, APIFactory, PersonaFactory,
			EntidadFactory, InstalacionFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			buscarxid : buscarxid,
			listaAdministrado : listaAdministrado,
			modelVistaAdministrado : modelVistaAdministrado,
			validarSolicitudAccesoAdministrado : validarSolicitudAccesoAdministrado,
			buscarAdministradoSelector : buscarAdministradoSelector,
			contarAdministrado : contarAdministrado 
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {

				idAdministrado : 0,
				tipoAdministrado : 0,
				persona : PersonaFactory.model(),
				entidad : EntidadFactory.model(),
				flagActivo : 0,
				lstContactoAdministrado : [],
				estado : 0

			};
		}

		function modelVistaAdministrado() {
			return {
				idAdministrado : 0,
				tipoAdministrado : 0,
				idPersona : 0,
				documento : '',
				nombreCompleto : '',
				numeroInstalaciones : 0,
				instalacion : InstalacionFactory.model()
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url + 'administrado/listar',
					prmData);
		}

		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'administrado/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'administrado/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(
					API_CONFIG.url + 'administrado/eliminar', prmData);
		}

		function buscarxid(prmData) {
			return APIFactory.listar(API_CONFIG.url + 'administrado/buscarxid',
					prmData);
		}

		function listaAdministrado(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'administrado/lista-administrado-supervicion', prmData);
		}

		function validarSolicitudAccesoAdministrado(prmData) {
			return APIFactory.consultaPOST(API_CONFIG.url
					+ 'administrado/validar-solicitud-acceso-administrado',
					prmData);
		}

		function buscarAdministradoSelector(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'administrado/buscarAdministradoSelector', prmData);
		}

		function contarAdministrado(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'administrado/contarAdministrado', prmData);
		}

		/* ******************************************************************************** */

		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
(function() {
    'use strict';
    angular.module('spapp').factory('AccesoFactory', AccesoFactory);
    /* @ngInject */
    function AccesoFactory(API_CONFIG, APIFactory, $log) {
        /*inicializacion y declaracion de metodos del factory*/
        var factory = {
            opciones: opciones,
            operaciones: operaciones,
            obtenerSesion: obtenerSesion
        };
        return factory;

        function opciones(ref) {
            return APIFactory.listar(API_CONFIG.url + 'seguridad/opciones', {
                'prm1': ref
            });
        }

        function operaciones(ref, id) {
            //$log.log('ref+id '+ref+id);
            return APIFactory.listar(API_CONFIG.url + 'seguridad/operaciones', {
                'prm1': ref,
                'prm2': id
            });
        }

        function obtenerSesion(prmData) {
            //$log.log('ref+id '+ref+id);
            return APIFactory.consultaPOST(API_CONFIG.url + 'seguridad/obtener-session', prmData);
        }
        /*fin de factory*/
    }
})();
(function() {
	'use strict';

	angular
		.module('spapp')
		.factory('MonitoreoPeriodosFactory', MonitoreoPeriodosFactory);

	/* @ngInject */
	function MonitoreoPeriodosFactory(API_CONFIG, APIFactory,MaestroFactory,UbigeoFactory,InstalacionFactory,InformeMonitoreoFactory) {
		
		/*inicializacion y declaracion de metodos del factory*/
		var factory = {
			model 		: model,
			listar 		: listar,
			registrarArchivoMonitoreo : registrarArchivoMonitoreo,
			validarInformePresentacionPeriodo : validarInformePresentacionPeriodo
			/*  registrar 	: registrar,
			actualizar 	: actualizar,
			eliminar 	: eliminar,
			registrarArchivo : registrarArchivo*/
		};

		return factory;

		/* implementacion de metodos */

	
		
		function model(){
			return {

				  idMonitoreoPeriodos	: 0,
				  informeMonitoreo 		:InformeMonitoreoFactory.model(),
				  anio 					: 0,
				  tipoPeriodo 			: MaestroFactory.model(),
				  estado				: 0
				

			};
		}
		

/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url+'monitoreoPeriodos/listar-informes-presentacion', prmData);
		}


			function validarInformePresentacionPeriodo(prmData) {
			return APIFactory.listar(API_CONFIG.url+'monitoreoPeriodos/validar-informe-presentacion-periodo', prmData);
		}
		
	

		function registrarArchivoMonitoreo(files,prmData) {

				var formData = new FormData();

			for( var x in files)
				{
					formData.append("file",files[x]);
				}


				formData.append("strContenido",angular.toJson(prmData));

			return APIFactory.guardarArchivo(API_CONFIG.url+'monitoreoPeriodos/registrar',formData);
		}
		


//		function registrar(prmData) {
//			return APIFactory.registrar(API_CONFIG.url+'informeMonitoreo/registrar', prmData);
//		}
//
//		function actualizar(prmData) {
//			return APIFactory.actualizar(API_CONFIG.url+'informeMonitoreo/actualizar', prmData);
//		}
//
//		function eliminar(prmData) {
//			return APIFactory.eliminar(API_CONFIG.url+'informeMonitoreo/eliminar', prmData);
//		}
//		
//		function registrarArchivo(files, prmDenuncia) {
//			
//				var formData = new FormData();
//				formData.append("file",files);
//				formData.append("strContenido",angular.toJson(prmDenuncia));
//				return APIFactory.guardarArchivo(API_CONFIG.url+'informeMonitoreo/registrar', formData);
//			}
//		
/* ******************************************************************************** */
	
/* ******************************************************************************** */
	
		/*fin de factory*/
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('InstalacionPresentacionFactory',
			InstalacionPresentacionFactory);

	/* @ngInject */
	function InstalacionPresentacionFactory(API_CONFIG, APIFactory,
			MaestroFactory, UbigeoFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			actualizarFrecuencia : actualizarFrecuencia,
			registrarArchivo : registrarArchivo
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				codigoTipoInforme : 0,
				idInstalacion : 0,
				idAdministrado : 0,
				periodo : (new Date).getFullYear(),
				frecuencia : 0,
				numero_frecuencia : 0,
				fechapresentacion : new Date(),
				nombredocumento : "",
				rutadocumento : "",
				estado : 1,
				uiid : "",
				tiene_incidente : null,
				fechahora_incidente: null,
				lugar_incidente: null,
				descripcion_incidente: null,
				observaciones_incidente: null,
				fechahora_incidente_texto: null,
				fechadesde : null,
				fechahasta : null
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'instalacionPresentacion/listar', prmData);
		}

		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'instalacionPresentacion/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'instalacionPresentacion/actualizar', prmData);
		}

		function actualizarFrecuencia(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'instalacionPresentacion/modificarFrecuencia', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'instalacionPresentacion/eliminar', prmData);
		}

		function registrarArchivo(archivos, prmData) {

			if (archivos.length == 0) {
				return registrar(prmData);
			} else {
				var formData = new FormData();
				for ( var x in archivos) {
					formData.append("file", archivos[x]);
				}
				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'instalacionPresentacion/registrarArchivo', formData);
			}
		}

		/* ******************************************************************************** */

		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('InformeMonitoreoFactory',
			InformeMonitoreoFactory);

	/* @ngInject */
	function InformeMonitoreoFactory(API_CONFIG, APIFactory, MaestroFactory,
			UbigeoFactory, InstalacionFactory, CookiesFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			listarHistorial : listarHistorial,
			registrar : registrar,
			registrarConArchivo : registrarConArchivo,
			actualizar : actualizar,
			eliminar : eliminar,
			registrarArchivo : registrarArchivo,
			obtenerFrecuencia : obtenerFrecuencia,
			registrarDetalle : registrarDetalle,
			abrirInforme : abrirInforme,
			cerrarInforme : cerrarInforme,
			actualizarArchivo : actualizarArchivo,
			eliminarDetalle : eliminarDetalle,
			acciones : acciones,
			registrarMasivo : registrarMasivo
		};

		return factory;
		
		function acciones(){
			return APIFactory.acciones();
		}

		/* implementacion de metodos */

		function model() {
			return {
				idInformeMonitoreo : 0,
				idAdministrado : 0,
				idIga : 0,
				idInstalacion : 0,
				idEtapa : 0,
				periodo : '',
				frecuencia : 0,
				numero_frecuencia : 0,
				componente : '',
				fechaPresentacion : new Date(),
				fechadesde : null,
				fechahasta : null,
				nombreArchivo : '',
				rutaAlfresco : '',
				uiid : '',
				comentario : '',
				prm1 : CookiesFactory.obtenerCookie(),
				estado : '1',
				flgEliminaDet : 'S',
				lstInformeMonitoreo : []
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(
					API_CONFIG.url + 'informeMonitoreo/listar', prmData);
		}

		function listarHistorial(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'informeMonitoreo/listarHistorial', prmData);
		}

		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'informeMonitoreo/registrar', prmData);
		}

		function registrarDetalle(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'informeMonitoreo/registrarDetalle', prmData);
		}

		function registrarConArchivo(files, prmData) {

			var formData = new FormData();

			for ( var x in files) {
				formData.append("file", files[x]);
			}

			formData.append("strContenido", angular.toJson(prmData));

			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'informeMonitoreo/registrarConArchivo', formData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'informeMonitoreo/actualizar', prmData);
		}

		function actualizarArchivo(files, prmData) {

			if (files.length == 0) {
				return APIFactory.actualizar(API_CONFIG.url
						+ 'informeMonitoreo/actualizar', prmData);
			} else {
				var formData = new FormData();

				for ( var x in files) {
					formData.append("file", files[x]);
				}

				formData.append("strContenido", angular.toJson(prmData));

				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'informeMonitoreo/actualizarArchivo', formData);
			}

		}

		function abrirInforme(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'informeMonitoreo/abrirInforme', prmData);
		}

		function cerrarInforme(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'informeMonitoreo/cerrarInforme', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'informeMonitoreo/eliminar', prmData);
		}

		function eliminarDetalle(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'informeMonitoreo/eliminarDetalle', prmData);
		}

		function obtenerFrecuencia(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'informeMonitoreo/obtenerFrecuencia', prmData);
		}

		function registrarArchivo(files, prmDenuncia) {

			var formData = new FormData();
			formData.append("file", files);
			formData.append("strContenido", angular.toJson(prmDenuncia));
			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'informeMonitoreo/registrar', formData);
		}
		
		function registrarMasivo(files, prmData) {

			var formData = new FormData();

			for ( var x in files) {
				formData.append("file", files[x]);
			}

			formData.append("strContenido", angular.toJson(prmData));

			return APIFactory.guardarArchivo(API_CONFIG.url
					+ 'informeMonitoreo/registrarMasivo', formData);
		}

		/* ******************************************************************************** */

		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
(function() {
	'use strict';

	angular.module('spapp').factory('InformeEnsayoFactory',
			InformeEnsayoFactory);

	/* @ngInject */
	function InformeEnsayoFactory(API_CONFIG, APIFactory, MaestroFactory,
			UbigeoFactory, InstalacionFactory, CookiesFactory) {

		/* inicializacion y declaracion de metodos del factory */
		var factory = {
			model : model,
			listar : listar,
			registrar : registrar,
			actualizar : actualizar,
			eliminar : eliminar,
			registrarArchivo : registrarArchivo,
			obtenerFrecuencia : obtenerFrecuencia
		};

		return factory;

		/* implementacion de metodos */

		function model() {
			return {
				ruc_laboratorio : '',
				razon_laboratorio : '',
				idAdministrado : 0,
				idInstalacion : 0,
				idIga : 0,
				codigo_ensayo : '',
				uiid : '',
				rutaAlfresco : '',
				nombreArchivo : '',
				prm1 : CookiesFactory.obtenerCookie(),
				estado : '1',
			};
		}

		/* ************************************CASO**************************************** */
		function listar(prmData) {
			return APIFactory.listar(API_CONFIG.url + 'informeEnsayo/listar',
					prmData);
		}

		function registrar(prmData) {
			return APIFactory.registrar(API_CONFIG.url
					+ 'informeEnsayo/registrar', prmData);
		}

		function actualizar(prmData) {
			return APIFactory.actualizar(API_CONFIG.url
					+ 'informeEnsayo/actualizar', prmData);
		}

		function eliminar(prmData) {
			return APIFactory.eliminar(API_CONFIG.url
					+ 'informeEnsayo/eliminar', prmData);
		}

		function obtenerFrecuencia(prmData) {
			return APIFactory.listar(API_CONFIG.url
					+ 'informeEnsayo/obtenerFrecuencia', prmData);
		}

		function registrarArchivo(archivos, prmData) {

			if (archivos.length == 0) {
				return APIFactory.registrar(API_CONFIG.url
						+ 'informeEnsayo/registrar', prmData);
			} else {
				var formData = new FormData();
				for ( var x in archivos) {
					formData.append("file", archivos[x]);
				}
				formData.append("strContenido", angular.toJson(prmData));
				return APIFactory.guardarArchivo(API_CONFIG.url
						+ 'informeEnsayo/registrar-archivo', formData);
			}
		}

		/* ******************************************************************************** */

		/* ******************************************************************************** */

		/* fin de factory */
	}
})();
/*
 CanvasJS HTML5 & JavaScript Charts - v2.2 GA - https://canvasjs.com/ 
 Copyright 2018 fenopix

  --------------------- License Information --------------------
 CanvasJS is a commercial product which requires purchase of license. Without a commercial license you can use it for evaluation purposes for upto 30 days. Please refer to the following link for further details.
     https://canvasjs.com/license/

*/
/*eslint-disable*/
/*jshint ignore:start*/
(function(){function na(m,s){m.prototype=$a(s.prototype);m.prototype.constructor=m;m.base=s.prototype}function $a(m){function s(){}s.prototype=m;return new s}function Ta(m,s,q){"millisecond"===q?m.setMilliseconds(m.getMilliseconds()+1*s):"second"===q?m.setSeconds(m.getSeconds()+1*s):"minute"===q?m.setMinutes(m.getMinutes()+1*s):"hour"===q?m.setHours(m.getHours()+1*s):"day"===q?m.setDate(m.getDate()+1*s):"week"===q?m.setDate(m.getDate()+7*s):"month"===q?m.setMonth(m.getMonth()+1*s):"year"===q&&m.setFullYear(m.getFullYear()+
1*s);return m}function ha(m,s){var q=!1;0>m&&(q=!0,m*=-1);m=""+m;for(s=s?s:1;m.length<s;)m="0"+m;return q?"-"+m:m}function Fa(m){if(!m)return m;m=m.replace(/^\s\s*/,"");for(var s=/\s/,q=m.length;s.test(m.charAt(--q)););return m.slice(0,q+1)}function Ba(m){m.roundRect=function(m,q,v,y,x,z,S,C){S&&(this.fillStyle=S);C&&(this.strokeStyle=C);"undefined"===typeof x&&(x=5);this.lineWidth=z;this.beginPath();this.moveTo(m+x,q);this.lineTo(m+v-x,q);this.quadraticCurveTo(m+v,q,m+v,q+x);this.lineTo(m+v,q+y-
x);this.quadraticCurveTo(m+v,q+y,m+v-x,q+y);this.lineTo(m+x,q+y);this.quadraticCurveTo(m,q+y,m,q+y-x);this.lineTo(m,q+x);this.quadraticCurveTo(m,q,m+x,q);this.closePath();S&&this.fill();C&&0<z&&this.stroke()}}function Pa(m,s){return m-s}function R(m){var s=((m&16711680)>>16).toString(16),q=((m&65280)>>8).toString(16);m=((m&255)>>0).toString(16);s=2>s.length?"0"+s:s;q=2>q.length?"0"+q:q;m=2>m.length?"0"+m:m;return"#"+s+q+m}function ab(m,s){var q=this.length>>>0,v=Number(s)||0,v=0>v?Math.ceil(v):Math.floor(v);
for(0>v&&(v+=q);v<q;v++)if(v in this&&this[v]===m)return v;return-1}function y(m){return null===m||"undefined"===typeof m}function Ca(m){m.indexOf||(m.indexOf=ab);return m}function bb(m){if(W.fSDec)m[ga("`eeDwdouMhrudods")](ga("e`u`@ohl`uhnoHuds`uhnoDoe"),function(){W._fTWm&&W._fTWm(m)})}function Ua(m,s,q){q=q||"normal";var v=m+"_"+s+"_"+q,y=Va[v];if(isNaN(y)){try{m="position:absolute; left:0px; top:-20000px; padding:0px;margin:0px;border:none;white-space:pre;line-height:normal;font-family:"+m+"; font-size:"+
s+"px; font-weight:"+q+";";if(!pa){var x=document.body;pa=document.createElement("span");pa.innerHTML="";var z=document.createTextNode("Mpgyi");pa.appendChild(z);x.appendChild(pa)}pa.style.display="";pa.setAttribute("style",m);y=Math.round(pa.offsetHeight);pa.style.display="none"}catch(S){y=Math.ceil(1.1*s)}y=Math.max(y,s);Va[v]=y}return y}function F(m,s){var q=[];if(q={solid:[],shortDash:[3,1],shortDot:[1,1],shortDashDot:[3,1,1,1],shortDashDotDot:[3,1,1,1,1,1],dot:[1,2],dash:[4,2],dashDot:[4,2,1,
2],longDash:[8,2],longDashDot:[8,2,1,2],longDashDotDot:[8,2,1,2,1,2]}[m||"solid"])for(var v=0;v<q.length;v++)q[v]*=s;else q=[];return q}function P(m,s,q,v,y){v=v||[];y=y||!1;v.push([m,s,q,y]);return m.addEventListener?(m.addEventListener(s,q,y),q):m.attachEvent?(v=function(s){s=s||window.event;s.preventDefault=s.preventDefault||function(){s.returnValue=!1};s.stopPropagation=s.stopPropagation||function(){s.cancelBubble=!0};q.call(m,s)},m.attachEvent("on"+s,v),v):!1}function Wa(m,s,q){m*=ia;s*=ia;m=
q.getImageData(m,s,2,2).data;s=!0;for(q=0;4>q;q++)if(m[q]!==m[q+4]|m[q]!==m[q+8]|m[q]!==m[q+12]){s=!1;break}return s?m[0]<<16|m[1]<<8|m[2]:0}function ja(m,s,q){return m in s?s[m]:q[m]}function Ga(m,s,q){if(v&&Xa){var y=m.getContext("2d");La=y.webkitBackingStorePixelRatio||y.mozBackingStorePixelRatio||y.msBackingStorePixelRatio||y.oBackingStorePixelRatio||y.backingStorePixelRatio||1;ia=Qa/La;m.width=s*ia;m.height=q*ia;Qa!==La&&(m.style.width=s+"px",m.style.height=q+"px",y.scale(ia,ia))}else m.width=
s,m.height=q}function cb(m){if(!db){var s=!1,q=!1;"undefined"===typeof qa.Chart.creditHref?(m.creditHref=ga("iuuqr;..b`ow`rkr/bnl."),m.creditText=ga("B`ow`rKR/bnl")):(s=m.updateOption("creditText"),q=m.updateOption("creditHref"));if(m.creditHref&&m.creditText){m._creditLink||(m._creditLink=document.createElement("a"),m._creditLink.setAttribute("class","canvasjs-chart-credit"),m._creditLink.setAttribute("title","JavaScript Charts"),m._creditLink.setAttribute("style","outline:none;margin:0px;position:absolute;right:2px;top:"+
(m.height-14)+"px;color:dimgrey;text-decoration:none;font-size:11px;font-family: Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif"),m._creditLink.setAttribute("tabIndex",-1),m._creditLink.setAttribute("target","_blank"));if(0===m.renderCount||s||q)m._creditLink.setAttribute("href",m.creditHref),m._creditLink.innerHTML=m.creditText;m._creditLink&&m.creditHref&&m.creditText?(m._creditLink.parentElement||m._canvasJSContainer.appendChild(m._creditLink),m._creditLink.style.top=m.height-14+
"px"):m._creditLink.parentElement&&m._canvasJSContainer.removeChild(m._creditLink)}}}function ta(m,s){var q=document.createElement("canvas");q.setAttribute("class","canvasjs-chart-canvas");Ga(q,m,s);v||"undefined"===typeof G_vmlCanvasManager||G_vmlCanvasManager.initElement(q);return q}function oa(m,s,q){for(var v in q)s.style[v]=q[v]}function ua(m,s,q){s.getAttribute("state")||(s.style.backgroundColor=m.toolbar.backgroundColor,s.style.color=m.toolbar.fontColor,s.style.border="none",oa(m,s,{WebkitUserSelect:"none",
MozUserSelect:"none",msUserSelect:"none",userSelect:"none"}));s.getAttribute("state")!==q&&(s.setAttribute("state",q),s.setAttribute("type","button"),oa(m,s,{padding:"5px 12px",cursor:"pointer","float":"left",width:"40px",height:"25px",outline:"0px",verticalAlign:"baseline",lineHeight:"0"}),s.setAttribute("title",m._cultureInfo[q+"Text"]),s.innerHTML="<img style='height:95%;' src='"+eb[q].image+"' alt='"+m._cultureInfo[q+"Text"]+"' />")}function Ma(){for(var m=null,s=0;s<arguments.length;s++)m=arguments[s],
m.style&&(m.style.display="inline")}function va(){for(var m=null,s=0;s<arguments.length;s++)(m=arguments[s])&&m.style&&(m.style.display="none")}function Y(m,s,q,v,x){this._defaultsKey=m;this._themeOptionsKey=s;this._index=v;this.parent=x;this._eventListeners=[];m={};this.theme&&y(s)&&y(v)?m=y(xa[this.theme])?xa.light1:xa[this.theme]:this.parent&&(this.parent.themeOptions&&this.parent.themeOptions[s])&&(null===v?m=this.parent.themeOptions[s]:0<this.parent.themeOptions[s].length&&(v=Math.min(this.parent.themeOptions[s].length-
1,v),m=this.parent.themeOptions[s][v]));this.themeOptions=m;this.options=q?q:{_isPlaceholder:!0};this.setOptions(this.options,m)}function Da(m,s,q,v,y){"undefined"===typeof y&&(y=0);this._padding=y;this._x1=m;this._y1=s;this._x2=q;this._y2=v;this._rightOccupied=this._leftOccupied=this._bottomOccupied=this._topOccupied=this._padding}function ka(m,s){ka.base.constructor.call(this,"TextBlock",null,s,null,null);this.ctx=m;this._isDirty=!0;this._wrappedText=null;this._initialize()}function Ra(m,s){Ra.base.constructor.call(this,
"Toolbar","toolbar",s,null,m);this.chart=m;this.canvas=m.canvas;this.ctx=this.chart.ctx;this.optionsName="toolbar"}function Ha(m,s){Ha.base.constructor.call(this,"Title","title",s,null,m);this.chart=m;this.canvas=m.canvas;this.ctx=this.chart.ctx;this.optionsName="title";if(y(this.options.margin)&&m.options.subtitles)for(var q=m.options.subtitles,v=0;v<q.length;v++)if((y(q[v].horizontalAlign)&&"center"===this.horizontalAlign||q[v].horizontalAlign===this.horizontalAlign)&&(y(q[v].verticalAlign)&&"top"===
this.verticalAlign||q[v].verticalAlign===this.verticalAlign)&&!q[v].dockInsidePlotArea===!this.dockInsidePlotArea){this.margin=0;break}"undefined"===typeof this.options.fontSize&&(this.fontSize=this.chart.getAutoFontSize(this.fontSize));this.height=this.width=null;this.bounds={x1:null,y1:null,x2:null,y2:null}}function Na(m,s,q){Na.base.constructor.call(this,"Subtitle","subtitles",s,q,m);this.chart=m;this.canvas=m.canvas;this.ctx=this.chart.ctx;this.optionsName="subtitles";this.isOptionsInArray=!0;
"undefined"===typeof this.options.fontSize&&(this.fontSize=this.chart.getAutoFontSize(this.fontSize));this.height=this.width=null;this.bounds={x1:null,y1:null,x2:null,y2:null}}function Ia(m){var s;m&&Ja[m]&&(s=Ja[m]);Ia.base.constructor.call(this,"CultureInfo",null,s,null,null)}var W={},v=!!document.createElement("canvas").getContext,qa={Chart:{width:500,height:400,zoomEnabled:!1,zoomType:"x",backgroundColor:"white",theme:"light1",animationEnabled:!1,animationDuration:1200,dataPointWidth:null,dataPointMinWidth:null,
dataPointMaxWidth:null,colorSet:"colorSet1",culture:"en",creditHref:"",creditText:"CanvasJS",interactivityEnabled:!0,exportEnabled:!1,exportFileName:"Chart",rangeChanging:null,rangeChanged:null,publicProperties:{title:"readWrite",subtitles:"readWrite",toolbar:"readWrite",toolTip:"readWrite",legend:"readWrite",axisX:"readWrite",axisY:"readWrite",axisX2:"readWrite",axisY2:"readWrite",data:"readWrite",options:"readWrite",bounds:"readOnly",container:"readOnly"}},Title:{padding:0,text:null,verticalAlign:"top",
horizontalAlign:"center",fontSize:20,fontFamily:"Calibri",fontWeight:"normal",fontColor:"black",fontStyle:"normal",borderThickness:0,borderColor:"black",cornerRadius:0,backgroundColor:v?"transparent":null,margin:5,wrap:!0,maxWidth:null,dockInsidePlotArea:!1,publicProperties:{options:"readWrite",bounds:"readOnly",chart:"readOnly"}},Subtitle:{padding:0,text:null,verticalAlign:"top",horizontalAlign:"center",fontSize:14,fontFamily:"Calibri",fontWeight:"normal",fontColor:"black",fontStyle:"normal",borderThickness:0,
borderColor:"black",cornerRadius:0,backgroundColor:null,margin:2,wrap:!0,maxWidth:null,dockInsidePlotArea:!1,publicProperties:{options:"readWrite",bounds:"readOnly",chart:"readOnly"}},Toolbar:{backgroundColor:"white",backgroundColorOnHover:"#2196f3",borderColor:"#2196f3",borderThickness:1,fontColor:"black",fontColorOnHover:"white",publicProperties:{options:"readWrite",chart:"readOnly"}},Legend:{name:null,verticalAlign:"center",horizontalAlign:"right",fontSize:14,fontFamily:"calibri",fontWeight:"normal",
fontColor:"black",fontStyle:"normal",cursor:null,itemmouseover:null,itemmouseout:null,itemmousemove:null,itemclick:null,dockInsidePlotArea:!1,reversed:!1,backgroundColor:v?"transparent":null,borderColor:v?"transparent":null,borderThickness:0,cornerRadius:0,maxWidth:null,maxHeight:null,markerMargin:null,itemMaxWidth:null,itemWidth:null,itemWrap:!0,itemTextFormatter:null,publicProperties:{options:"readWrite",bounds:"readOnly",chart:"readOnly"}},ToolTip:{enabled:!0,shared:!1,animationEnabled:!0,content:null,
contentFormatter:null,reversed:!1,backgroundColor:v?"rgba(255,255,255,.9)":"rgb(255,255,255)",borderColor:null,borderThickness:2,cornerRadius:5,fontSize:14,fontColor:"black",fontFamily:"Calibri, Arial, Georgia, serif;",fontWeight:"normal",fontStyle:"italic",publicProperties:{options:"readWrite",chart:"readOnly"}},Axis:{minimum:null,maximum:null,viewportMinimum:null,viewportMaximum:null,interval:null,intervalType:null,reversed:!1,logarithmic:!1,logarithmBase:10,title:null,titleFontColor:"black",titleFontSize:20,
titleFontFamily:"arial",titleFontWeight:"normal",titleFontStyle:"normal",titleWrap:!0,titleMaxWidth:null,titleBackgroundColor:v?"transparent":null,titleBorderColor:v?"transparent":null,titleBorderThickness:0,titleCornerRadius:0,labelAngle:0,labelFontFamily:"arial",labelFontColor:"black",labelFontSize:12,labelFontWeight:"normal",labelFontStyle:"normal",labelAutoFit:!0,labelWrap:!0,labelMaxWidth:null,labelFormatter:null,labelBackgroundColor:v?"transparent":null,labelBorderColor:v?"transparent":null,
labelBorderThickness:0,labelCornerRadius:0,labelPlacement:"outside",prefix:"",suffix:"",includeZero:!0,tickLength:5,tickColor:"black",tickThickness:1,lineColor:"black",lineThickness:1,lineDashType:"solid",gridColor:"A0A0A0",gridThickness:0,gridDashType:"solid",interlacedColor:v?"transparent":null,valueFormatString:null,margin:2,publicProperties:{options:"readWrite",stripLines:"readWrite",scaleBreaks:"readWrite",crosshair:"readWrite",bounds:"readOnly",chart:"readOnly"}},StripLine:{value:null,startValue:null,
endValue:null,color:"orange",opacity:null,thickness:2,lineDashType:"solid",label:"",labelPlacement:"inside",labelAlign:"far",labelWrap:!0,labelMaxWidth:null,labelBackgroundColor:null,labelBorderColor:v?"transparent":null,labelBorderThickness:0,labelCornerRadius:0,labelFontFamily:"arial",labelFontColor:"orange",labelFontSize:12,labelFontWeight:"normal",labelFontStyle:"normal",labelFormatter:null,showOnTop:!1,publicProperties:{options:"readWrite",axis:"readOnly",bounds:"readOnly",chart:"readOnly"}},
ScaleBreaks:{autoCalculate:!1,collapsibleThreshold:"25%",maxNumberOfAutoBreaks:2,spacing:8,type:"straight",color:"#FFFFFF",fillOpacity:0.9,lineThickness:2,lineColor:"#E16E6E",lineDashType:"solid",publicProperties:{options:"readWrite",customBreaks:"readWrite",axis:"readOnly",autoBreaks:"readOnly",bounds:"readOnly",chart:"readOnly"}},Break:{startValue:null,endValue:null,spacing:8,type:"straight",color:"#FFFFFF",fillOpacity:0.9,lineThickness:2,lineColor:"#E16E6E",lineDashType:"solid",publicProperties:{options:"readWrite",
scaleBreaks:"readOnly",bounds:"readOnly",chart:"readOnly"}},Crosshair:{enabled:!1,snapToDataPoint:!1,color:"grey",opacity:null,thickness:2,lineDashType:"solid",label:"",labelWrap:!0,labelMaxWidth:null,labelBackgroundColor:v?"grey":null,labelBorderColor:v?"grey":null,labelBorderThickness:0,labelCornerRadius:0,labelFontFamily:v?"Calibri, Optima, Candara, Verdana, Geneva, sans-serif":"calibri",labelFontSize:12,labelFontColor:"#fff",labelFontWeight:"normal",labelFontStyle:"normal",labelFormatter:null,
valueFormatString:null,publicProperties:{options:"readWrite",axis:"readOnly",bounds:"readOnly",chart:"readOnly"}},DataSeries:{name:null,dataPoints:null,label:"",bevelEnabled:!1,highlightEnabled:!0,cursor:"default",indexLabel:"",indexLabelPlacement:"auto",indexLabelOrientation:"horizontal",indexLabelFontColor:"black",indexLabelFontSize:12,indexLabelFontStyle:"normal",indexLabelFontFamily:"Arial",indexLabelFontWeight:"normal",indexLabelBackgroundColor:null,indexLabelLineColor:"gray",indexLabelLineThickness:1,
indexLabelLineDashType:"solid",indexLabelMaxWidth:null,indexLabelWrap:!0,indexLabelFormatter:null,lineThickness:2,lineDashType:"solid",connectNullData:!1,nullDataLineDashType:"dash",color:null,lineColor:null,risingColor:"white",fallingColor:"red",fillOpacity:null,startAngle:0,radius:null,innerRadius:null,neckHeight:null,neckWidth:null,reversed:!1,valueRepresents:null,linkedDataSeriesIndex:null,whiskerThickness:2,whiskerDashType:"solid",whiskerColor:null,whiskerLength:null,stemThickness:2,stemColor:null,
stemDashType:"solid",upperBoxColor:"white",lowerBoxColor:"white",type:"column",xValueType:"number",axisXType:"primary",axisYType:"primary",axisXIndex:0,axisYIndex:0,xValueFormatString:null,yValueFormatString:null,zValueFormatString:null,percentFormatString:null,showInLegend:null,legendMarkerType:null,legendMarkerColor:null,legendText:null,legendMarkerBorderColor:v?"transparent":null,legendMarkerBorderThickness:0,markerType:"circle",markerColor:null,markerSize:null,markerBorderColor:v?"transparent":
null,markerBorderThickness:0,mouseover:null,mouseout:null,mousemove:null,click:null,toolTipContent:null,visible:!0,publicProperties:{options:"readWrite",axisX:"readWrite",axisY:"readWrite",chart:"readOnly"}},TextBlock:{x:0,y:0,width:null,height:null,maxWidth:null,maxHeight:null,padding:0,angle:0,text:"",horizontalAlign:"center",fontSize:12,fontFamily:"calibri",fontWeight:"normal",fontColor:"black",fontStyle:"normal",borderThickness:0,borderColor:"black",cornerRadius:0,backgroundColor:null,textBaseline:"top"},
CultureInfo:{decimalSeparator:".",digitGroupSeparator:",",zoomText:"Zoom",panText:"Pan",resetText:"Reset",menuText:"More Options",saveJPGText:"Save as JPEG",savePNGText:"Save as PNG",printText:"Print",days:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),shortDays:"Sun Mon Tue Wed Thu Fri Sat".split(" "),months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ")}},
Ja={en:{}},x=v?"Trebuchet MS, Helvetica, sans-serif":"Arial",Ea=v?"Impact, Charcoal, sans-serif":"Arial",za={colorSet1:"#4F81BC #C0504E #9BBB58 #23BFAA #8064A1 #4AACC5 #F79647 #7F6084 #77A033 #33558B #E59566".split(" "),colorSet2:"#6D78AD #51CDA0 #DF7970 #4C9CA0 #AE7D99 #C9D45C #5592AD #DF874D #52BCA8 #8E7AA3 #E3CB64 #C77B85 #C39762 #8DD17E #B57952 #FCC26C".split(" "),colorSet3:"#8CA1BC #36845C #017E82 #8CB9D0 #708C98 #94838D #F08891 #0366A7 #008276 #EE7757 #E5BA3A #F2990B #03557B #782970".split(" ")},
J,fa,T,Z,ea;fa="#333333";T="#000000";J="#666666";ea=Z="#000000";var ba=20,z=14,Sa={colorSet:"colorSet1",backgroundColor:"#FFFFFF",title:{fontFamily:Ea,fontSize:32,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5},subtitles:[{fontFamily:Ea,fontSize:z,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5}],data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:fa,indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,
titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},
scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,
labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,
labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,
labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,
lineDashType:"solid"}}],legend:{fontFamily:x,fontSize:14,fontColor:fa,fontWeight:"bold",verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,fontStyle:"normal",cornerRadius:0,borderThickness:1}};T=fa="#F5F5F5";J="#FFFFFF";Z="#40BAF1";ea="#F5F5F5";var ba=20,z=14,Ya={colorSet:"colorSet2",title:{fontFamily:x,fontSize:33,fontColor:"#3A3A3A",fontWeight:"bold",verticalAlign:"top",margin:5},subtitles:[{fontFamily:x,fontSize:z,fontColor:"#3A3A3A",fontWeight:"normal",verticalAlign:"top",
margin:5}],data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:"#666666",indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",labelFontWeight:"normal",lineThickness:1,lineColor:"#BBBBBB",tickThickness:1,tickColor:"#BBBBBB",gridThickness:1,gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",
labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",
labelFontWeight:"normal",lineThickness:1,lineColor:"#BBBBBB",tickColor:"#BBBBBB",tickThickness:1,gridThickness:1,gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",
lineThickness:1,lineDashType:"solid"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",labelFontWeight:"normal",lineThickness:0,lineColor:"#BBBBBB",tickColor:"#BBBBBB",tickThickness:1,gridThickness:1,gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,
labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",labelFontWeight:"normal",lineThickness:0,lineColor:"#BBBBBB",tickColor:"#BBBBBB",tickThickness:1,gridThickness:1,
gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],legend:{fontFamily:x,fontSize:14,fontColor:"#3A3A3A",fontWeight:"bold",
verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,fontStyle:"normal",cornerRadius:0,borderThickness:1}};T=fa="#F5F5F5";J="#FFFFFF";Z="#40BAF1";ea="#F5F5F5";ba=20;z=14;Ea={colorSet:"colorSet12",backgroundColor:"#2A2A2A",title:{fontFamily:Ea,fontSize:32,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5},subtitles:[{fontFamily:Ea,fontSize:z,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5}],toolbar:{backgroundColor:"#666666",backgroundColorOnHover:"#FF7372",
borderColor:"#FF7372",borderThickness:1,fontColor:"#F5F5F5",fontColorOnHover:"#F5F5F5"},data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:T,indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,
labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,
labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,
lineDashType:"solid",color:"#111111"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",
labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",
labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],legend:{fontFamily:x,fontSize:14,fontColor:fa,fontWeight:"bold",verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,
fontStyle:"normal",cornerRadius:0,borderThickness:1,fontColor:T,backgroundColor:"rgba(0, 0, 0, .7)"}};J="#FFFFFF";T=fa="#FAFAFA";Z="#40BAF1";ea="#F5F5F5";var ba=20,z=14,xa={light1:Sa,light2:Ya,dark1:Ea,dark2:{colorSet:"colorSet2",backgroundColor:"#32373A",title:{fontFamily:x,fontSize:32,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5},subtitles:[{fontFamily:x,fontSize:z,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5}],toolbar:{backgroundColor:"#666666",backgroundColorOnHover:"#FF7372",
borderColor:"#FF7372",borderThickness:1,fontColor:"#F5F5F5",fontColorOnHover:"#F5F5F5"},data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:T,indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,
labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,
labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,
lineDashType:"solid",color:"#111111"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:0,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",
labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:0,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",
labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],legend:{fontFamily:x,fontSize:14,fontColor:fa,fontWeight:"bold",verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,
fontStyle:"normal",cornerRadius:0,borderThickness:1,fontColor:T,backgroundColor:"rgba(0, 0, 0, .7)"}},theme1:Sa,theme2:Ya,theme3:Sa},U={numberDuration:1,yearDuration:314496E5,monthDuration:2592E6,weekDuration:6048E5,dayDuration:864E5,hourDuration:36E5,minuteDuration:6E4,secondDuration:1E3,millisecondDuration:1,dayOfWeekFromInt:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" ")};(function(){W.fSDec=function(m){for(var s="",q=0;q<m.length;q++)s+=String.fromCharCode(Math.ceil(m.length/
57/5)^m.charCodeAt(q));return s};W.obj={trVs:"Ush`m!Wdsrhno",fntStr:"qy!B`mhcsh-!Mtbhe`!Fs`oed-!Mtbhe`!R`or!Tohbned-!@sh`m-!r`or,rdshg",txtBl:"udyuC`rdmhod",fnt:"gnou",fSy:"ghmmRuxmd",fTx:"ghmmUdyu",grClr:"fsdx",cntx:"buy",tp:"unq"};delete qa[W.fSDec("Bi`su")][W.fSDec("bsdehuIsdg")];W.pro={sCH:qa[W.fSDec("Bi`su")][W.fSDec("bsdehuIsdg")]};W._fTWm=function(m){if("undefined"===typeof W.pro.sCH&&!Za)try{var s=m[W.fSDec(W.obj.cntx)];s[W.fSDec(W.obj.txtBl)]=W.fSDec(W.obj.tp);s[W.fSDec(W.obj.fnt)]=11+W.fSDec(W.obj.fntStr);
s[W.fSDec(W.obj.fSy)]=W.fSDec(W.obj.grClr);s[W.fSDec(W.obj.fTx)](W.fSDec(W.obj.trVs),2,m.height-11-2)}catch(q){}}})();var Va={},pa=null,Aa=function(){var m=/D{1,4}|M{1,4}|Y{1,4}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|f{1,3}|t{1,2}|T{1,2}|K|z{1,3}|"[^"]*"|'[^']*'/g,s="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),q="Sun Mon Tue Wed Thu Fri Sat".split(" "),v="January February March April May June July August September October November December".split(" "),y="Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
x=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,z=/[^-+\dA-Z]/g;return function(S,C,I){var F=I?I.days:s,J=I?I.months:v,R=I?I.shortDays:q,P=I?I.shortMonths:y;I="";var U=!1;S=S&&S.getTime?S:S?new Date(S):new Date;if(isNaN(S))throw SyntaxError("invalid date");"UTC:"===C.slice(0,4)&&(C=C.slice(4),U=!0);I=U?"getUTC":"get";var W=S[I+"Date"](),X=S[I+"Day"](),Y=S[I+"Month"](),T=S[I+"FullYear"](),O=S[I+"Hours"](),V=S[I+
"Minutes"](),a=S[I+"Seconds"](),f=S[I+"Milliseconds"](),b=U?0:S.getTimezoneOffset();return I=C.replace(m,function(c){switch(c){case "D":return W;case "DD":return ha(W,2);case "DDD":return R[X];case "DDDD":return F[X];case "M":return Y+1;case "MM":return ha(Y+1,2);case "MMM":return P[Y];case "MMMM":return J[Y];case "Y":return parseInt(String(T).slice(-2));case "YY":return ha(String(T).slice(-2),2);case "YYY":return ha(String(T).slice(-3),3);case "YYYY":return ha(T,4);case "h":return O%12||12;case "hh":return ha(O%
12||12,2);case "H":return O;case "HH":return ha(O,2);case "m":return V;case "mm":return ha(V,2);case "s":return a;case "ss":return ha(a,2);case "f":return String(f).slice(0,1);case "ff":return ha(String(f).slice(0,2),2);case "fff":return ha(String(f).slice(0,3),3);case "t":return 12>O?"a":"p";case "tt":return 12>O?"am":"pm";case "T":return 12>O?"A":"P";case "TT":return 12>O?"AM":"PM";case "K":return U?"UTC":(String(S).match(x)||[""]).pop().replace(z,"");case "z":return(0<b?"-":"+")+Math.floor(Math.abs(b)/
60);case "zz":return(0<b?"-":"+")+ha(Math.floor(Math.abs(b)/60),2);case "zzz":return(0<b?"-":"+")+ha(Math.floor(Math.abs(b)/60),2)+ha(Math.abs(b)%60,2);default:return c.slice(1,c.length-1)}})}}(),V=function(m,s,q){if(null===m)return"";if(!isFinite(m))return m;m=Number(m);var v=0>m?!0:!1;v&&(m*=-1);var y=q?q.decimalSeparator:".",x=q?q.digitGroupSeparator:",",z="";s=String(s);var z=1,S=q="",C=-1,I=[],F=[],J=0,R=0,U=0,P=!1,W=0,S=s.match(/"[^"]*"|'[^']*'|[eE][+-]*[0]+|[,]+[.]|\u2030|./g);s=null;for(var X=
0;S&&X<S.length;X++)if(s=S[X],"."===s&&0>C)C=X;else{if("%"===s)z*=100;else if("\u2030"===s){z*=1E3;continue}else if(","===s[0]&&"."===s[s.length-1]){z/=Math.pow(1E3,s.length-1);C=X+s.length-1;continue}else"E"!==s[0]&&"e"!==s[0]||"0"!==s[s.length-1]||(P=!0);0>C?(I.push(s),"#"===s||"0"===s?J++:","===s&&U++):(F.push(s),"#"!==s&&"0"!==s||R++)}P&&(s=Math.floor(m),S=-Math.floor(Math.log(m)/Math.LN10+1),W=0===m?0:0===s?-(J+S):String(s).length-J,z/=Math.pow(10,W));0>C&&(C=X);z=(m*z).toFixed(R);s=z.split(".");
z=(s[0]+"").split("");m=(s[1]+"").split("");z&&"0"===z[0]&&z.shift();for(P=S=X=R=C=0;0<I.length;)if(s=I.pop(),"#"===s||"0"===s)if(C++,C===J){var Y=z,z=[];if("0"===s)for(s=J-R-(Y?Y.length:0);0<s;)Y.unshift("0"),s--;for(;0<Y.length;)q=Y.pop()+q,P++,0===P%S&&(X===U&&0<Y.length)&&(q=x+q)}else 0<z.length?(q=z.pop()+q,R++,P++):"0"===s&&(q="0"+q,R++,P++),0===P%S&&(X===U&&0<z.length)&&(q=x+q);else"E"!==s[0]&&"e"!==s[0]||"0"!==s[s.length-1]||!/[eE][+-]*[0]+/.test(s)?","===s?(X++,S=P,P=0,0<z.length&&(q=x+q)):
q=1<s.length&&('"'===s[0]&&'"'===s[s.length-1]||"'"===s[0]&&"'"===s[s.length-1])?s.slice(1,s.length-1)+q:s+q:(s=0>W?s.replace("+","").replace("-",""):s.replace("-",""),q+=s.replace(/[0]+/,function(m){return ha(W,m.length)}));x="";for(I=!1;0<F.length;)s=F.shift(),"#"===s||"0"===s?0<m.length&&0!==Number(m.join(""))?(x+=m.shift(),I=!0):"0"===s&&(x+="0",I=!0):1<s.length&&('"'===s[0]&&'"'===s[s.length-1]||"'"===s[0]&&"'"===s[s.length-1])?x+=s.slice(1,s.length-1):"E"!==s[0]&&"e"!==s[0]||"0"!==s[s.length-
1]||!/[eE][+-]*[0]+/.test(s)?x+=s:(s=0>W?s.replace("+","").replace("-",""):s.replace("-",""),x+=s.replace(/[0]+/,function(m){return ha(W,m.length)}));q+=(I?y:"")+x;return v?"-"+q:q},Oa=function(m){var s=0,q=0;m=m||window.event;m.offsetX||0===m.offsetX?(s=m.offsetX,q=m.offsetY):m.layerX||0==m.layerX?(s=m.layerX,q=m.layerY):(s=m.pageX-m.target.offsetLeft,q=m.pageY-m.target.offsetTop);return{x:s,y:q}},Xa=!0,Qa=window.devicePixelRatio||1,La=1,ia=Xa?Qa/La:1,ga=function(m){for(var s="",q=0;q<m.length;q++)s+=
String.fromCharCode(Math.ceil(m.length/57/5)^m.charCodeAt(q));return s},Za=window&&window[ga("mnb`uhno")]&&window[ga("mnb`uhno")].href&&window[ga("mnb`uhno")].href.indexOf&&(-1!==window[ga("mnb`uhno")].href.indexOf(ga("b`ow`rkr/bnl"))||-1!==window[ga("mnb`uhno")].href.indexOf(ga("gdonqhy/bnl"))||-1!==window[ga("mnb`uhno")].href.indexOf(ga("gheemd"))),db=Za&&-1===window[ga("mnb`uhno")].href.indexOf(ga("gheemd")),eb={reset:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPjSURBVFhHxVdJaFNRFP1J/jwkP5MxsbaC1WJEglSxOFAXIsFpVRE3ggi1K90obioRRBA33XXnQnciirhQcMCdorgQxBkXWlREkFKsWkv5npvckp/XnzRpKh64kLw733fffe9L/wrL0+mVUdO8uTSZ3MBL/we2qg4rkuSpodCELstXE46ziVkLQ6FQcGOmeSSq6wd4aV50d3drWjj8kQKZJTUc9kxFGenv79dZrDksTSTWWJp2QYtEPiErysyzdX0LsxsCQR8keX8gs6RHIk8ysdgKFg2G53mhuOPsshTlBjKaFo1g7SqLNoShKLdFXT8huQ/paLSbxatYnc2mHMM4hr18Vi8TIvCmXF3vYrW6cF23gGTOk0M1wA4RKvOmq6vLZRVJipvmSWT6tZ6CSEYkco5V50VPT4+D7RwOqi6RiSZm0fJ+vggSqkeoypdsNmuyelNwbXsbgvkWYMtzDWNvWaijoyOBqE+hVK8abcssUeXQ/YfKyi0gFYv1Ipgfoj34fYGTJLOYJA0ODirok32GLN8XhUWCwSes1hIwBg6LydJ/tEeRRapAdUp+wSAiZchtZZWWgAZ+JNpD8peYXQVK9UwUxNpzOK8pq97kURZhYTCKBwPD7h2zK+js7Myi7D8Fod+0TkMI8+EMAngLGc/WtBFWawkFHFnoj/t9KLgGmF0B3QfkxC+EarxkdhnFYlFLY06USqUwL7UMjICHfh/wOc2sCqhpxGbCkLvL7EUDbF73+6DkmVWB6zi7xUDQSLeYvWjAILvm9zEnkJhlbRcDQZcv6Kg2AipyT/Axw6wKlqVSqxDdjF8Izfod13qURdrG/nxehY+xGh+h0CSzKygGvSNQIcc097BI24jb9hax6kj2E7OrMFX1il+ICEf2NrPbhiXLl+fYl+U7zK4iYdsDcyLGf+ofFlkwcN+s10KhmpuYhhtm0hCLVIFL0MDsqNlDIqy9x2CLs1jL6OvrI7vPRbtohXG6eFmsFnHDGAp6n9AgyuVySRZrGvROxRgIfLXhzjrNYnNBUxNX/dMgRWT1mt4XLDovaApD53E9W3ilNX5M55LJHpRtIsgAvciR4WWcgK2Dvb1YqgXevmF8z2zEBTcKG39EfSKsT9EbhVUaI2FZO+oZIqImxol6j66/hcAu4sSN4vc1ZPoKeoE6RGhYL2YYA+ymOSSi0Z0wWntbtkGUWCvfSDXIxONraZ/FY90KUfNTpfC5spnNLgxoYNnR9RO4F8ofXEHOgogCQE99w+fF2Xw+b7O59rEOsyRqGEfpVoaDMQQ1CZrG46bcM6AZ0C/wPqNfHliqejyTySxh9TqQpL+xmbIlkB9SlAAAAABJRU5ErkJggg=="},
pan:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAICSURBVEhLxZbPahNRGMUn/5MpuAiBEAIufQGfzr5E40YptBXajYzudCEuGqS+gGlrFwquDGRTutBdYfydzJ3LzeQmJGZue+Dw/Z17Mnfmu5Pof9Hr9Z61Wq0bWZMKj263O6xWq99wU9lOpzPMKgEhEcRucNOcioOK+0RzBhNvt9tPV4nmVF19+OWhVqt9xXgFXZq+8lCv119UKpUJ7iX2FmvFTKz8RH34YdBsNk8wVtjE4fGYwm8wrrDi3WBG5oKXZGRSS9hGuNFojLTe2lFz5xThWZIktayyiE2FdT3rzXBXz7krKiL8c17wAKFDjCus2AvW+YGZ9y2JF0VFRuMPfI//rsCE/C+s26s4gQu9ul7r4NteKx7H8XOC724xNNGbaNu++IrBqbOV7Tj3FgMRvc/YKOr3+3sE47wgEt/Bl/gaK5cHbNU11vYSXylfpK7XOvjuumPp4Wcoipu30Qsez2uMXYz4lfI+mOmwothY+SLiXJy7mKVpWs3Si0CoOMfeI9Od43Wic+jO+ZVv+crsm9QSNhUW9LXSeoPBYLXopthGuFQgdIxxhY+UDwlt1x5CZ1hX+NTUdt/OIvjKaDSmuOJfaIVNPKX+W18j/PLA2/kR44p5Sd8HbHngT/yTfNRWUXX14ZcL3wmX0+TLf8YO7CGT8yFE5zB3/gney25/OETRP9CtPDFe5jShAAAAAElFTkSuQmCC"},
zoom:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALWSURBVEhLvZZLaBNRFIabyftBIgEfqCCBoCC6MYqiXYiIj4U76U4X7sUHbhQhUBfixhZEUBDB16YuFERaUaQLK7ooCOJj4UKtYEFU0EptShO/A9Ph3js3k8lo/eHnP7n3nP/M3LlzMz1hkUwmNziOcyKRSFyFt+LxeD/c2Wq1Ym7Kv0M2m11Os1OxWGycn1OwZXCGuXfwIhezkd9/jRgNT2L4ldhs1pbkX5OLJe4euVxuGQaPCa3mnUjtJx7BDuKusJTCV6jVVGHTMuYRjxma7yIOhTgFY6jNaAKew2xPKpVay9ganmkvj+M448/MfJdT5K5Gg4HJacRngPFgqVRaRNwW1B4i7yehWfsEDdz1K+A01AoxPIqGAiuwGfkOTY8+1A6u7AyiFTB2Hu0KPIrdiOnzHLWDybeImvy+Wq2mZa5bUHsD0Zpz+KxHdWQymV6kAb1ElqeORgJLvgnRdj1+R1AfzkIvSUjxVjQSarVakrueIPT8+H1F5jSUy+WXiJrUYBVWyVxU4PEU8TzhfaijUqnMIWrjaY492eWRwdKOIqrnIxnXwLLeRLwk2GQzrEMjg0avEbXxkIxr4OoOImpj2QwyFgms1koa/SZUG8s+0iGnEhNfCNXEhzIXBVz0McTzEvJ+70P9oNFtxEzei3aFYrFYxmuSUPWSv9Yi9IMm2xE1We56Mp1OV4nDwqFmBDV9gk9AEh4gZtFHNt8W4kAUCoXF5MorY9Z/kDni9nDv7hc0i2fhgLvTtX8a99PoMPPagTFPxofRzmDJ9yM+AyEmTfgGysYbQcfhDzPPJDmX0c7gDg4gs9BqFIWhm/Nct5H8gtBq1I7UfIbtvmIuoaGQcp+fdpbbSM43eEH5wrwLbXmhm/fU63VHXjcuok7hEByFY/AeHGC8L5/PL3HT5xGH1uYwfPOICGo+CBcU0vwO1BqzUqILDl/z/9VYIMfpddiAc47jDP8BsUpb13wOLRwAAAAASUVORK5CYII="},
menu:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVFhH7dc9CsJAFATgRxIIBCwCqZKATX5sbawsY2MvWOtF9AB6AU8gguAJbD2AnZ2VXQT/Ko2TYGCL2OYtYQc+BuYA+1hCtnCVwMm27SGaXpDJIAiCvCkVR05hGOZNN3HkFMdx3nQRR06+76/R1IcFLJlNQEWlmWlBTwJtKLKHynehZqnjOGM0PYWRVXk61C37p7xlZ3Hk5HneCk1dmMH811xGoKLSzDiQwIBZB4ocoPJdqNkDt2yKlueWRVGUtzy3rPwo3sWRU3nLjuLI6OO67oZM00wMw3hrmpZx0XU9syxrR0T0BeMpb9dneSR2AAAAAElFTkSuQmCC"}};
Y.prototype.setOptions=function(m,s){if(qa[this._defaultsKey]){var q=qa[this._defaultsKey],v;for(v in q)"publicProperties"!==v&&q.hasOwnProperty(v)&&(this[v]=m&&v in m?m[v]:s&&v in s?s[v]:q[v])}};Y.prototype.get=function(m){var s=qa[this._defaultsKey];if("options"===m)return this.options&&this.options._isPlaceholder?null:this.options;if(s.hasOwnProperty(m)||s.publicProperties&&s.publicProperties.hasOwnProperty(m))return this[m];window.console&&window.console.log('Property "'+m+"\" doesn't exist. Please check for typo.")};
Y.prototype.set=function(m,s,q){q="undefined"===typeof q?!0:q;var v=qa[this._defaultsKey];if("options"===m)this.createUserOptions(s);else if(v.hasOwnProperty(m)||v.publicProperties&&v.publicProperties.hasOwnProperty(m)&&"readWrite"===v.publicProperties[m])this.options._isPlaceholder&&this.createUserOptions(),this.options[m]=s;else{window.console&&(v.publicProperties&&v.publicProperties.hasOwnProperty(m)&&"readOnly"===v.publicProperties[m]?window.console.log('Property "'+m+'" is read-only.'):window.console.log('Property "'+
m+"\" doesn't exist. Please check for typo."));return}q&&(this.chart||this).render()};Y.prototype.addTo=function(m,s,q,v){v="undefined"===typeof v?!0:v;var y=qa[this._defaultsKey];y.hasOwnProperty(m)||y.publicProperties&&y.publicProperties.hasOwnProperty(m)&&"readWrite"===y.publicProperties[m]?(this.options._isPlaceholder&&this.createUserOptions(),"undefined"===typeof this.options[m]&&(this.options[m]=[]),m=this.options[m],q="undefined"===typeof q||null===q?m.length:q,m.splice(q,0,s),v&&(this.chart||
this).render()):window.console&&(y.publicProperties&&y.publicProperties.hasOwnProperty(m)&&"readOnly"===y.publicProperties[m]?window.console.log('Property "'+m+'" is read-only.'):window.console.log('Property "'+m+"\" doesn't exist. Please check for typo."))};Y.prototype.createUserOptions=function(m){if("undefined"!==typeof m||this.options._isPlaceholder)if(this.parent.options._isPlaceholder&&this.parent.createUserOptions(),this.isOptionsInArray){this.parent.options[this.optionsName]||(this.parent.options[this.optionsName]=
[]);var s=this.parent.options[this.optionsName],v=s.length;this.options._isPlaceholder||(Ca(s),v=s.indexOf(this.options));this.options="undefined"===typeof m?{}:m;s[v]=this.options}else this.options="undefined"===typeof m?{}:m,m=this.parent.options,this.optionsName?s=this.optionsName:(s=this._defaultsKey)&&0!==s.length?(v=s.charAt(0).toLowerCase(),1<s.length&&(v=v.concat(s.slice(1))),s=v):s=void 0,m[s]=this.options};Y.prototype.remove=function(m){m="undefined"===typeof m?!0:m;if(this.isOptionsInArray){var s=
this.parent.options[this.optionsName];Ca(s);var v=s.indexOf(this.options);0<=v&&s.splice(v,1)}else delete this.parent.options[this.optionsName];m&&(this.chart||this).render()};Y.prototype.updateOption=function(m){var s=qa[this._defaultsKey],v={},x=this[m],z=this._themeOptionsKey,F=this._index;this.theme&&y(z)&&y(F)?v=y(xa[this.theme])?xa.light1:xa[this.theme]:this.parent&&(this.parent.themeOptions&&this.parent.themeOptions[z])&&(null===F?v=this.parent.themeOptions[z]:0<this.parent.themeOptions[z].length&&
(v=Math.min(this.parent.themeOptions[z].length-1,F),v=this.parent.themeOptions[z][v]));this.themeOptions=v;m in s&&(x=m in this.options?this.options[m]:v&&m in v?v[m]:s[m]);if(x===this[m])return!1;this[m]=x;return!0};Y.prototype.trackChanges=function(m){if(!this.sessionVariables)throw"Session Variable Store not set";this.sessionVariables[m]=this.options[m]};Y.prototype.isBeingTracked=function(m){this.options._oldOptions||(this.options._oldOptions={});return this.options._oldOptions[m]?!0:!1};Y.prototype.hasOptionChanged=
function(m){if(!this.sessionVariables)throw"Session Variable Store not set";return this.sessionVariables[m]!==this.options[m]};Y.prototype.addEventListener=function(m,s,v){m&&s&&(this._eventListeners[m]=this._eventListeners[m]||[],this._eventListeners[m].push({context:v||this,eventHandler:s}))};Y.prototype.removeEventListener=function(m,v){if(m&&v&&this._eventListeners[m])for(var q=this._eventListeners[m],y=0;y<q.length;y++)if(q[y].eventHandler===v){q[y].splice(y,1);break}};Y.prototype.removeAllEventListeners=
function(){this._eventListeners=[]};Y.prototype.dispatchEvent=function(m,v,q){if(m&&this._eventListeners[m]){v=v||{};for(var y=this._eventListeners[m],x=0;x<y.length;x++)y[x].eventHandler.call(y[x].context,v)}"function"===typeof this[m]&&this[m].call(q||this.chart,v)};Da.prototype.registerSpace=function(m,v){"top"===m?this._topOccupied+=v.height:"bottom"===m?this._bottomOccupied+=v.height:"left"===m?this._leftOccupied+=v.width:"right"===m&&(this._rightOccupied+=v.width)};Da.prototype.unRegisterSpace=
function(m,v){"top"===m?this._topOccupied-=v.height:"bottom"===m?this._bottomOccupied-=v.height:"left"===m?this._leftOccupied-=v.width:"right"===m&&(this._rightOccupied-=v.width)};Da.prototype.getFreeSpace=function(){return{x1:this._x1+this._leftOccupied,y1:this._y1+this._topOccupied,x2:this._x2-this._rightOccupied,y2:this._y2-this._bottomOccupied,width:this._x2-this._x1-this._rightOccupied-this._leftOccupied,height:this._y2-this._y1-this._bottomOccupied-this._topOccupied}};Da.prototype.reset=function(){this._rightOccupied=
this._leftOccupied=this._bottomOccupied=this._topOccupied=this._padding};na(ka,Y);ka.prototype._initialize=function(){y(this.padding)||"object"!==typeof this.padding?this.topPadding=this.rightPadding=this.bottomPadding=this.leftPadding=Number(this.padding)|0:(this.topPadding=y(this.padding.top)?0:Number(this.padding.top)|0,this.rightPadding=y(this.padding.right)?0:Number(this.padding.right)|0,this.bottomPadding=y(this.padding.bottom)?0:Number(this.padding.bottom)|0,this.leftPadding=y(this.padding.left)?
0:Number(this.padding.left)|0)};ka.prototype.render=function(m){if(0!==this.fontSize){m&&this.ctx.save();var v=this.ctx.font;this.ctx.textBaseline=this.textBaseline;var q=0;this._isDirty&&this.measureText(this.ctx);this.ctx.translate(this.x,this.y+q);"middle"===this.textBaseline&&(q=-this._lineHeight/2);this.ctx.font=this._getFontString();this.ctx.rotate(Math.PI/180*this.angle);var y=0,x=this.topPadding,z=null;this.ctx.roundRect||Ba(this.ctx);(0<this.borderThickness&&this.borderColor||this.backgroundColor)&&
this.ctx.roundRect(0,q,this.width,this.height,this.cornerRadius,this.borderThickness,this.backgroundColor,this.borderColor);this.ctx.fillStyle=this.fontColor;for(q=0;q<this._wrappedText.lines.length;q++)z=this._wrappedText.lines[q],"right"===this.horizontalAlign?y=(this.width-(this.leftPadding+this.rightPadding))/2-z.width/2+this.leftPadding:"left"===this.horizontalAlign?y=this.leftPadding:"center"===this.horizontalAlign&&(y=(this.width-(this.leftPadding+this.rightPadding))/2-z.width/2+this.leftPadding),
this.ctx.fillText(z.text,y,x),x+=z.height;this.ctx.font=v;m&&this.ctx.restore()}};ka.prototype.setText=function(m){this.text=m;this._isDirty=!0;this._wrappedText=null};ka.prototype.measureText=function(){this._lineHeight=Ua(this.fontFamily,this.fontSize,this.fontWeight);if(null===this.maxWidth)throw"Please set maxWidth and height for TextBlock";this._wrapText(this.ctx);this._isDirty=!1;return{width:this.width,height:this.height}};ka.prototype._getLineWithWidth=function(m,v,q){m=String(m);if(!m)return{text:"",
width:0};var y=q=0,x=m.length-1,z=Infinity;for(this.ctx.font=this._getFontString();y<=x;){var z=Math.floor((y+x)/2),F=m.substr(0,z+1);q=this.ctx.measureText(F).width;if(q<v)y=z+1;else if(q>v)x=z-1;else break}q>v&&1<F.length&&(F=F.substr(0,F.length-1),q=this.ctx.measureText(F).width);v=!0;if(F.length===m.length||" "===m[F.length])v=!1;v&&(m=F.split(" "),1<m.length&&m.pop(),F=m.join(" "),q=this.ctx.measureText(F).width);return{text:F,width:q}};ka.prototype._wrapText=function(){var m=new String(Fa(String(this.text))),
v=[],q=this.ctx.font,y=0,x=0;this.ctx.font=this._getFontString();if(0===this.frontSize)x=y=0;else for(;0<m.length;){var z=this.maxHeight-(this.topPadding+this.bottomPadding),F=this._getLineWithWidth(m,this.maxWidth-(this.leftPadding+this.rightPadding),!1);F.height=this._lineHeight;v.push(F);var S=x,x=Math.max(x,F.width),y=y+F.height,m=Fa(m.slice(F.text.length,m.length));z&&y>z&&(F=v.pop(),y-=F.height,x=S)}this._wrappedText={lines:v,width:x,height:y};this.width=x+(this.leftPadding+this.rightPadding);
this.height=y+(this.topPadding+this.bottomPadding);this.ctx.font=q};ka.prototype._getFontString=function(){var m;m=""+(this.fontStyle?this.fontStyle+" ":"");m+=this.fontWeight?this.fontWeight+" ":"";m+=this.fontSize?this.fontSize+"px ":"";var s=this.fontFamily?this.fontFamily+"":"";!v&&s&&(s=s.split(",")[0],"'"!==s[0]&&'"'!==s[0]&&(s="'"+s+"'"));return m+=s};na(Ra,Y);na(Ha,Y);Ha.prototype.render=function(){if(this.text){var m=this.dockInsidePlotArea?this.chart.plotArea:this.chart,v=m.layoutManager.getFreeSpace(),
q=v.x1,x=v.y1,z=0,F=0,R=this.chart._menuButton&&this.chart.exportEnabled&&"top"===this.verticalAlign?22:0,S,C;"top"===this.verticalAlign||"bottom"===this.verticalAlign?(null===this.maxWidth&&(this.maxWidth=v.width-4-R*("center"===this.horizontalAlign?2:1)),F=0.5*v.height-this.margin-2,z=0):"center"===this.verticalAlign&&("left"===this.horizontalAlign||"right"===this.horizontalAlign?(null===this.maxWidth&&(this.maxWidth=v.height-4),F=0.5*v.width-this.margin-2):"center"===this.horizontalAlign&&(null===
this.maxWidth&&(this.maxWidth=v.width-4),F=0.5*v.height-4));var I;y(this.padding)||"number"!==typeof this.padding?y(this.padding)||"object"!==typeof this.padding||(I=this.padding.top?this.padding.top:this.padding.bottom?this.padding.bottom:0,I+=this.padding.bottom?this.padding.bottom:this.padding.top?this.padding.top:0,I*=1.25):I=2.5*this.padding;this.wrap||(F=Math.min(F,Math.max(1.5*this.fontSize,this.fontSize+I)));F=new ka(this.ctx,{fontSize:this.fontSize,fontFamily:this.fontFamily,fontColor:this.fontColor,
fontStyle:this.fontStyle,fontWeight:this.fontWeight,horizontalAlign:this.horizontalAlign,verticalAlign:this.verticalAlign,borderColor:this.borderColor,borderThickness:this.borderThickness,backgroundColor:this.backgroundColor,maxWidth:this.maxWidth,maxHeight:F,cornerRadius:this.cornerRadius,text:this.text,padding:this.padding,textBaseline:"top"});I=F.measureText();"top"===this.verticalAlign||"bottom"===this.verticalAlign?("top"===this.verticalAlign?(x=v.y1+2,C="top"):"bottom"===this.verticalAlign&&
(x=v.y2-2-I.height,C="bottom"),"left"===this.horizontalAlign?q=v.x1+2:"center"===this.horizontalAlign?q=v.x1+v.width/2-I.width/2:"right"===this.horizontalAlign&&(q=v.x2-2-I.width-R),S=this.horizontalAlign,this.width=I.width,this.height=I.height):"center"===this.verticalAlign&&("left"===this.horizontalAlign?(q=v.x1+2,x=v.y2-2-(this.maxWidth/2-I.width/2),z=-90,C="left",this.width=I.height,this.height=I.width):"right"===this.horizontalAlign?(q=v.x2-2,x=v.y1+2+(this.maxWidth/2-I.width/2),z=90,C="right",
this.width=I.height,this.height=I.width):"center"===this.horizontalAlign&&(x=m.y1+(m.height/2-I.height/2),q=m.x1+(m.width/2-I.width/2),C="center",this.width=I.width,this.height=I.height),S="center");F.x=q;F.y=x;F.angle=z;F.horizontalAlign=S;F.render(!0);m.layoutManager.registerSpace(C,{width:this.width+("left"===C||"right"===C?this.margin+2:0),height:this.height+("top"===C||"bottom"===C?this.margin+2:0)});this.bounds={x1:q,y1:x,x2:q+this.width,y2:x+this.height};this.ctx.textBaseline="top"}};na(Na,
Y);Na.prototype.render=Ha.prototype.render;na(Ia,Y);var Ka={addTheme:function(m,v){xa[m]=v},addColorSet:function(m,v){za[m]=v},addCultureInfo:function(m,v){Ja[m]=v},formatNumber:function(m,v,q){q=q||"en";if(Ja[q])return V(m,v||"#,##0.##",new Ia(q));throw"Unknown Culture Name";},formatDate:function(m,v,q){q=q||"en";if(Ja[q])return Aa(m,v||"DD MMM YYYY",new Ia(q));throw"Unknown Culture Name";}};"undefined"!==typeof module&&"undefined"!==typeof module.exports?module.exports=Ka:"function"===typeof define&&
define.amd?define([],function(){return Ka}):window.CanvasJS=Ka;Ka.Chart=function(){function m(a,f){return a.x-f.x}function s(a,f,b){if(a&&f&&b){b=b+"."+f;var c="image/"+f;a=a.toDataURL(c);var e=!1,g=document.createElement("a");g.download=b;g.href=a;if("undefined"!==typeof Blob&&new Blob){for(var h=a.replace(/^data:[a-z\/]*;base64,/,""),h=atob(h),l=new ArrayBuffer(h.length),l=new Uint8Array(l),t=0;t<h.length;t++)l[t]=h.charCodeAt(t);f=new Blob([l.buffer],{type:"image/"+f});try{window.navigator.msSaveBlob(f,
b),e=!0}catch(k){g.dataset.downloadurl=[c,g.download,g.href].join(":"),g.href=window.URL.createObjectURL(f)}}if(!e)try{event=document.createEvent("MouseEvents"),event.initMouseEvent("click",!0,!1,window,0,0,0,0,0,!1,!1,!1,!1,0,null),g.dispatchEvent?g.dispatchEvent(event):g.fireEvent&&g.fireEvent("onclick")}catch(r){f=window.open(),f.document.write("<img src='"+a+"'></img><div>Please right click on the image and save it to your device</div>"),f.document.close()}}}function q(a,f){f=f||{};this.theme=
y(f.theme)||y(xa[f.theme])?"light1":f.theme;q.base.constructor.call(this,"Chart",null,f,null,null);var b=this;this._containerId=a;this._objectsInitialized=!1;this.overlaidCanvasCtx=this.ctx=null;this._indexLabels=[];this._panTimerId=0;this._lastTouchEventType="";this._lastTouchData=null;this.isAnimating=!1;this.renderCount=0;this.disableToolTip=this.animatedRender=!1;this.allDOMEventHandlers=[];this.panEnabled=!1;this._defaultCursor="default";this.plotArea={canvas:null,ctx:null,x1:0,y1:0,x2:0,y2:0,
width:0,height:0};this._dataInRenderedOrder=[];if(this.container="string"===typeof this._containerId?document.getElementById(this._containerId):this._containerId){this.container.innerHTML="";var c=0,e=0,c=this.options.width?this.width:0<this.container.clientWidth?this.container.clientWidth:this.width,e=this.options.height?this.height:0<this.container.clientHeight?this.container.clientHeight:this.height;this.width=c;this.height=e;this.x1=this.y1=0;this.x2=this.width;this.y2=this.height;this._selectedColorSet=
"undefined"!==typeof za[this.colorSet]?za[this.colorSet]:za.colorSet1;this._canvasJSContainer=document.createElement("div");this._canvasJSContainer.setAttribute("class","canvasjs-chart-container");this._canvasJSContainer.style.position="relative";this._canvasJSContainer.style.textAlign="left";this._canvasJSContainer.style.cursor="auto";v||(this._canvasJSContainer.style.height="0px");this.container.appendChild(this._canvasJSContainer);this.canvas=ta(c,e);this._preRenderCanvas=ta(c,e);this.canvas.style.position=
"absolute";this.canvas.getContext&&(this._canvasJSContainer.appendChild(this.canvas),this.ctx=this.canvas.getContext("2d"),this.ctx.textBaseline="top",Ba(this.ctx),this._preRenderCtx=this._preRenderCanvas.getContext("2d"),this._preRenderCtx.textBaseline="top",Ba(this._preRenderCtx),v?this.plotArea.ctx=this.ctx:(this.plotArea.canvas=ta(c,e),this.plotArea.canvas.style.position="absolute",this.plotArea.canvas.setAttribute("class","plotAreaCanvas"),this._canvasJSContainer.appendChild(this.plotArea.canvas),
this.plotArea.ctx=this.plotArea.canvas.getContext("2d")),this.overlaidCanvas=ta(c,e),this.overlaidCanvas.style.position="absolute",this.overlaidCanvas.style.webkitTapHighlightColor="transparent",this.overlaidCanvas.getContext&&(this._canvasJSContainer.appendChild(this.overlaidCanvas),this.overlaidCanvasCtx=this.overlaidCanvas.getContext("2d"),this.overlaidCanvasCtx.textBaseline="top",Ba(this.overlaidCanvasCtx)),this._eventManager=new ea(this),this.windowResizeHandler=P(window,"resize",function(){b._updateSize()&&
b.render()},this.allDOMEventHandlers),this._toolBar=document.createElement("div"),this._toolBar.setAttribute("class","canvasjs-chart-toolbar"),this._toolBar.style.cssText="position: absolute; right: 1px; top: 1px;",this._canvasJSContainer.appendChild(this._toolBar),this.bounds={x1:0,y1:0,x2:this.width,y2:this.height},P(this.overlaidCanvas,"click",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,"mousemove",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),
P(this.overlaidCanvas,"mouseup",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,"mousedown",function(a){b._mouseEventHandler(a);va(b._dropdownMenu)},this.allDOMEventHandlers),P(this.overlaidCanvas,"mouseout",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?"MSPointerDown":"touchstart",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?
"MSPointerMove":"touchmove",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?"MSPointerUp":"touchend",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?"MSPointerCancel":"touchcancel",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),this.toolTip=new Z(this,this.options.toolTip),this.data=null,this.axisX=[],this.axisX2=[],this.axisY=[],this.axisY2=
[],this.sessionVariables={axisX:[],axisX2:[],axisY:[],axisY2:[]})}else window.console&&window.console.log('CanvasJS Error: Chart Container with id "'+this._containerId+'" was not found')}function x(a,f){for(var b=[],c,e=0;e<a.length;e++)if(0==e)b.push(a[0]);else{var g,h,l;l=e-1;g=0===l?0:l-1;h=l===a.length-1?l:l+1;c=Math.abs((a[h].x-a[g].x)/(0===a[h].x-a[l].x?0.01:a[h].x-a[l].x))*(f-1)/2+1;var t=(a[h].x-a[g].x)/c;c=(a[h].y-a[g].y)/c;b[b.length]=a[l].x>a[g].x&&0<t||a[l].x<a[g].x&&0>t?{x:a[l].x+t/3,
y:a[l].y+c/3}:{x:a[l].x,y:a[l].y+c/9};l=e;g=0===l?0:l-1;h=l===a.length-1?l:l+1;c=Math.abs((a[h].x-a[g].x)/(0===a[l].x-a[g].x?0.01:a[l].x-a[g].x))*(f-1)/2+1;t=(a[h].x-a[g].x)/c;c=(a[h].y-a[g].y)/c;b[b.length]=a[l].x>a[g].x&&0<t||a[l].x<a[g].x&&0>t?{x:a[l].x-t/3,y:a[l].y-c/3}:{x:a[l].x,y:a[l].y-c/9};b[b.length]=a[e]}return b}function z(a,f,b,c,e,g,h,l,t,k){var r=0;k?(h.color=g,l.color=g):k=1;r=t?Math.abs(e-b):Math.abs(c-f);r=0<h.trimLength?Math.abs(r*h.trimLength/100):Math.abs(r-h.length);t?(b+=r/2,
e-=r/2):(f+=r/2,c-=r/2);var r=1===Math.round(h.thickness)%2?0.5:0,p=1===Math.round(l.thickness)%2?0.5:0;a.save();a.globalAlpha=k;a.strokeStyle=l.color||g;a.lineWidth=l.thickness||2;a.setLineDash&&a.setLineDash(F(l.dashType,l.thickness));a.beginPath();t&&0<l.thickness?(a.moveTo(c-h.thickness/2,Math.round((b+e)/2)-p),a.lineTo(f+h.thickness/2,Math.round((b+e)/2)-p)):0<l.thickness&&(a.moveTo(Math.round((f+c)/2)-p,b+h.thickness/2),a.lineTo(Math.round((f+c)/2)-p,e-h.thickness/2));a.stroke();a.strokeStyle=
h.color||g;a.lineWidth=h.thickness||2;a.setLineDash&&a.setLineDash(F(h.dashType,h.thickness));a.beginPath();t&&0<h.thickness?(a.moveTo(c-r,b),a.lineTo(c-r,e),a.moveTo(f+r,b),a.lineTo(f+r,e)):0<h.thickness&&(a.moveTo(f,b+r),a.lineTo(c,b+r),a.moveTo(f,e-r),a.lineTo(c,e-r));a.stroke();a.restore()}function J(a,f,b,c,e){if(null===a||"undefined"===typeof a)return"undefined"===typeof b?f:b;a=parseFloat(a.toString())*(0<=a.toString().indexOf("%")?f/100:1);"undefined"!==typeof c&&(a=Math.min(c,a),"undefined"!==
typeof e&&(a=Math.max(e,a)));return!isNaN(a)&&a<=f&&0<=a?a:"undefined"===typeof b?f:b}function T(a,f){T.base.constructor.call(this,"Legend","legend",f,null,a);this.chart=a;this.canvas=a.canvas;this.ctx=this.chart.ctx;this.ghostCtx=this.chart._eventManager.ghostCtx;this.items=[];this.optionsName="legend";this.height=this.width=0;this.orientation=null;this.dataSeries=[];this.bounds={x1:null,y1:null,x2:null,y2:null};"undefined"===typeof this.options.fontSize&&(this.fontSize=this.chart.getAutoFontSize(this.fontSize));
this.lineHeight=Ua(this.fontFamily,this.fontSize,this.fontWeight);this.horizontalSpacing=this.fontSize}function S(a,f,b,c){S.base.constructor.call(this,"DataSeries","data",f,b,a);this.chart=a;this.canvas=a.canvas;this._ctx=a.canvas.ctx;this.index=b;this.noDataPointsInPlotArea=0;this.id=c;this.chart._eventManager.objectMap[c]={id:c,objectType:"dataSeries",dataSeriesIndex:b};a=f.dataPoints?f.dataPoints.length:0;this.dataPointEOs=[];for(f=0;f<a;f++)this.dataPointEOs[f]={};this.dataPointIds=[];this.plotUnit=
[];this.axisY=this.axisX=null;this.optionsName="data";this.isOptionsInArray=!0;null===this.fillOpacity&&(this.type.match(/area/i)?this.fillOpacity=0.7:this.fillOpacity=1);this.axisPlacement=this.getDefaultAxisPlacement();"undefined"===typeof this.options.indexLabelFontSize&&(this.indexLabelFontSize=this.chart.getAutoFontSize(this.indexLabelFontSize))}function C(a,f,b,c,e,g){C.base.constructor.call(this,"Axis",f,b,c,a);this.chart=a;this.canvas=a.canvas;this.ctx=a.ctx;this.intervalStartPosition=this.maxHeight=
this.maxWidth=0;this.labels=[];this.dataSeries=[];this._stripLineLabels=this._ticks=this._labels=null;this.dataInfo={min:Infinity,max:-Infinity,viewPortMin:Infinity,viewPortMax:-Infinity,minDiff:Infinity};this.isOptionsInArray=!0;"axisX"===e?("left"===g||"bottom"===g?(this.optionsName="axisX",y(this.chart.sessionVariables.axisX[c])&&(this.chart.sessionVariables.axisX[c]={}),this.sessionVariables=this.chart.sessionVariables.axisX[c]):(this.optionsName="axisX2",y(this.chart.sessionVariables.axisX2[c])&&
(this.chart.sessionVariables.axisX2[c]={}),this.sessionVariables=this.chart.sessionVariables.axisX2[c]),this.options.interval||(this.intervalType=null)):"left"===g||"bottom"===g?(this.optionsName="axisY",y(this.chart.sessionVariables.axisY[c])&&(this.chart.sessionVariables.axisY[c]={}),this.sessionVariables=this.chart.sessionVariables.axisY[c]):(this.optionsName="axisY2",y(this.chart.sessionVariables.axisY2[c])&&(this.chart.sessionVariables.axisY2[c]={}),this.sessionVariables=this.chart.sessionVariables.axisY2[c]);
"undefined"===typeof this.options.titleFontSize&&(this.titleFontSize=this.chart.getAutoFontSize(this.titleFontSize));"undefined"===typeof this.options.labelFontSize&&(this.labelFontSize=this.chart.getAutoFontSize(this.labelFontSize));this.type=e;"axisX"!==e||b&&"undefined"!==typeof b.gridThickness||(this.gridThickness=0);this._position=g;this.lineCoordinates={x1:null,y1:null,x2:null,y2:null,width:null};this.labelAngle=(this.labelAngle%360+360)%360;90<this.labelAngle&&270>this.labelAngle?this.labelAngle-=
180:270<=this.labelAngle&&360>=this.labelAngle&&(this.labelAngle-=360);this.options.scaleBreaks&&(this.scaleBreaks=new I(this.chart,this.options.scaleBreaks,++this.chart._eventManager.lastObjectId,this));this.stripLines=[];if(this.options.stripLines&&0<this.options.stripLines.length)for(a=0;a<this.options.stripLines.length;a++)this.stripLines.push(new fa(this.chart,this.options.stripLines[a],a,++this.chart._eventManager.lastObjectId,this));this.options.crosshair&&(this.crosshair=new ha(this.chart,
this.options.crosshair,this));this._titleTextBlock=null;this.hasOptionChanged("viewportMinimum")&&null===this.viewportMinimum&&(this.options.viewportMinimum=void 0,this.sessionVariables.viewportMinimum=null);this.hasOptionChanged("viewportMinimum")||isNaN(this.sessionVariables.newViewportMinimum)||null===this.sessionVariables.newViewportMinimum?this.sessionVariables.newViewportMinimum=null:this.viewportMinimum=this.sessionVariables.newViewportMinimum;this.hasOptionChanged("viewportMaximum")&&null===
this.viewportMaximum&&(this.options.viewportMaximum=void 0,this.sessionVariables.viewportMaximum=null);this.hasOptionChanged("viewportMaximum")||isNaN(this.sessionVariables.newViewportMaximum)||null===this.sessionVariables.newViewportMaximum?this.sessionVariables.newViewportMaximum=null:this.viewportMaximum=this.sessionVariables.newViewportMaximum;null!==this.minimum&&null!==this.viewportMinimum&&(this.viewportMinimum=Math.max(this.viewportMinimum,this.minimum));null!==this.maximum&&null!==this.viewportMaximum&&
(this.viewportMaximum=Math.min(this.viewportMaximum,this.maximum));this.trackChanges("viewportMinimum");this.trackChanges("viewportMaximum")}function I(a,f,b,c){I.base.constructor.call(this,"ScaleBreaks","scaleBreaks",f,null,c);this.id=b;this.chart=a;this.ctx=this.chart.ctx;this.axis=c;this.optionsName="scaleBreaks";this.isOptionsInArray=!1;this._appliedBreaks=[];this.customBreaks=[];this.autoBreaks=[];"string"===typeof this.spacing?(this.spacing=parseFloat(this.spacing),this.spacing=isNaN(this.spacing)?
8:(10<this.spacing?10:this.spacing)+"%"):"number"!==typeof this.spacing&&(this.spacing=8);this.autoCalculate&&(this.maxNumberOfAutoBreaks=Math.min(this.maxNumberOfAutoBreaks,5));if(this.options.customBreaks&&0<this.options.customBreaks.length){for(a=0;a<this.options.customBreaks.length;a++)this.customBreaks.push(new ba(this.chart,"customBreaks",this.options.customBreaks[a],a,++this.chart._eventManager.lastObjectId,this)),"number"===typeof this.customBreaks[a].startValue&&("number"===typeof this.customBreaks[a].endValue&&
this.customBreaks[a].endValue!==this.customBreaks[a].startValue)&&this._appliedBreaks.push(this.customBreaks[a]);this._appliedBreaks.sort(function(a,c){return a.startValue-c.startValue});for(a=0;a<this._appliedBreaks.length-1;a++)this._appliedBreaks[a].endValue>=this._appliedBreaks[a+1].startValue&&(this._appliedBreaks[a].endValue=Math.max(this._appliedBreaks[a].endValue,this._appliedBreaks[a+1].endValue),window.console&&window.console.log("CanvasJS Error: Breaks "+a+" and "+(a+1)+" are overlapping."),
this._appliedBreaks.splice(a,2),a--)}}function ba(a,f,b,c,e,g){ba.base.constructor.call(this,"Break",f,b,c,g);this.id=e;this.chart=a;this.ctx=this.chart.ctx;this.scaleBreaks=g;this.optionsName=f;this.isOptionsInArray=!0;this.type=b.type?this.type:g.type;this.fillOpacity=y(b.fillOpacity)?g.fillOpacity:this.fillOpacity;this.lineThickness=y(b.lineThickness)?g.lineThickness:this.lineThickness;this.color=b.color?this.color:g.color;this.lineColor=b.lineColor?this.lineColor:g.lineColor;this.lineDashType=
b.lineDashType?this.lineDashType:g.lineDashType;!y(this.startValue)&&this.startValue.getTime&&(this.startValue=this.startValue.getTime());!y(this.endValue)&&this.endValue.getTime&&(this.endValue=this.endValue.getTime());"number"===typeof this.startValue&&("number"===typeof this.endValue&&this.endValue<this.startValue)&&(a=this.startValue,this.startValue=this.endValue,this.endValue=a);this.spacing="undefined"===typeof b.spacing?g.spacing:b.spacing;"string"===typeof this.options.spacing?(this.spacing=
parseFloat(this.spacing),this.spacing=isNaN(this.spacing)?0:(10<this.spacing?10:this.spacing)+"%"):"number"!==typeof this.options.spacing&&(this.spacing=g.spacing);this.size=g.parent.logarithmic?1:0}function fa(a,f,b,c,e){fa.base.constructor.call(this,"StripLine","stripLines",f,b,e);this.id=c;this.chart=a;this.ctx=this.chart.ctx;this.label=this.label;this.axis=e;this.optionsName="stripLines";this.isOptionsInArray=!0;this._thicknessType="pixel";null!==this.startValue&&null!==this.endValue&&(this.value=
e.logarithmic?Math.sqrt((this.startValue.getTime?this.startValue.getTime():this.startValue)*(this.endValue.getTime?this.endValue.getTime():this.endValue)):((this.startValue.getTime?this.startValue.getTime():this.startValue)+(this.endValue.getTime?this.endValue.getTime():this.endValue))/2,this._thicknessType=null)}function ha(a,f,b){ha.base.constructor.call(this,"Crosshair","crosshair",f,null,b);this.chart=a;this.ctx=this.chart.ctx;this.axis=b;this.optionsName="crosshair";this._thicknessType="pixel"}
function Z(a,f){Z.base.constructor.call(this,"ToolTip","toolTip",f,null,a);this.chart=a;this.canvas=a.canvas;this.ctx=this.chart.ctx;this.currentDataPointIndex=this.currentSeriesIndex=-1;this._prevY=this._prevX=NaN;this.containerTransitionDuration=0.1;this.mozContainerTransition=this.getContainerTransition(this.containerTransitionDuration);this.optionsName="toolTip";this._initialize()}function ea(a){this.chart=a;this.lastObjectId=0;this.objectMap=[];this.rectangularRegionEventSubscriptions=[];this.previousDataPointEventObject=
null;this.ghostCanvas=ta(this.chart.width,this.chart.height);this.ghostCtx=this.ghostCanvas.getContext("2d");this.mouseoveredObjectMaps=[]}function ga(a){this.chart=a;this.ctx=this.chart.plotArea.ctx;this.animations=[];this.animationRequestId=null}na(q,Y);q.prototype.destroy=function(){var a=this.allDOMEventHandlers;this._animator&&this._animator.cancelAllAnimations();this._panTimerId&&clearTimeout(this._panTimerId);for(i=0;i<a.length;i++){var f=a[i][0],b=a[i][1],c=a[i][2],e=a[i][3],e=e||!1;f.removeEventListener?
f.removeEventListener(b,c,e):f.detachEvent&&f.detachEvent("on"+b,c)}this.allDOMEventHandlers=[];for(this.removeAllEventListeners();this._canvasJSContainer&&this._canvasJSContainer.hasChildNodes();)this._canvasJSContainer.removeChild(this._canvasJSContainer.lastChild);for(;this.container&&this.container.hasChildNodes();)this.container.removeChild(this.container.lastChild);for(;this._dropdownMenu&&this._dropdownMenu.hasChildNodes();)this._dropdownMenu.removeChild(this._dropdownMenu.lastChild);this.overlaidCanvas=
this.canvas=this.container=this._canvasJSContainer=null;this._toolBar=this._dropdownMenu=this._menuButton=this._resetButton=this._zoomButton=this._breaksCanvas=this._preRenderCanvas=this.toolTip.container=null};q.prototype._updateOptions=function(){var a=this;this.updateOption("width");this.updateOption("height");this.updateOption("dataPointWidth");this.updateOption("dataPointMinWidth");this.updateOption("dataPointMaxWidth");this.updateOption("interactivityEnabled");this.updateOption("theme");this.updateOption("colorSet")&&
(this._selectedColorSet="undefined"!==typeof za[this.colorSet]?za[this.colorSet]:za.colorSet1);this.updateOption("backgroundColor");this.backgroundColor||(this.backgroundColor="rgba(0,0,0,0)");this.updateOption("culture");this._cultureInfo=new Ia(this.options.culture);this.updateOption("animationEnabled");this.animationEnabled=this.animationEnabled&&v;this.updateOption("animationDuration");this.updateOption("rangeChanging");this.updateOption("rangeChanged");this.updateOption("exportEnabled");this.updateOption("exportFileName");
this.updateOption("zoomType");if(this.options.zoomEnabled){if(!this._zoomButton){var f=!1;va(this._zoomButton=document.createElement("button"));ua(this,this._zoomButton,"pan");this._toolBar.appendChild(this._zoomButton);this._zoomButton.style.borderRight=this.toolbar.borderThickness+"px solid "+this.toolbar.borderColor;P(this._zoomButton,"touchstart",function(a){f=!0},this.allDOMEventHandlers);P(this._zoomButton,"click",function(){a.zoomEnabled?(a.zoomEnabled=!1,a.panEnabled=!0,ua(a,a._zoomButton,
"zoom")):(a.zoomEnabled=!0,a.panEnabled=!1,ua(a,a._zoomButton,"pan"));a.render()},this.allDOMEventHandlers);P(this._zoomButton,"mouseover",function(){f?f=!1:(oa(a,a._zoomButton,{backgroundColor:a.toolbar.backgroundColorOnHover,color:a.toolbar.fontColorOnHover,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._zoomButton.childNodes[0],{WebkitFilter:"invert(100%)",filter:"invert(100%)"}))},this.allDOMEventHandlers);P(this._zoomButton,"mouseout",function(){f||
(oa(a,a._zoomButton,{backgroundColor:a.toolbar.backgroundColor,color:a.toolbar.fontColor,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._zoomButton.childNodes[0],{WebkitFilter:"invert(0%)",filter:"invert(0%)"}))},this.allDOMEventHandlers)}this._resetButton||(f=!1,va(this._resetButton=document.createElement("button")),ua(this,this._resetButton,"reset"),this._resetButton.style.borderRight=(this.exportEnabled?this.toolbar.borderThickness:0)+"px solid "+this.toolbar.borderColor,
this._toolBar.appendChild(this._resetButton),P(this._resetButton,"touchstart",function(a){f=!0},this.allDOMEventHandlers),P(this._resetButton,"click",function(){a.toolTip.hide();a.zoomEnabled||a.panEnabled?(a.zoomEnabled=!0,a.panEnabled=!1,ua(a,a._zoomButton,"pan"),a._defaultCursor="default",a.overlaidCanvas.style.cursor=a._defaultCursor):(a.zoomEnabled=!1,a.panEnabled=!1);if(a.sessionVariables.axisX)for(var c=0;c<a.sessionVariables.axisX.length;c++)a.sessionVariables.axisX[c].newViewportMinimum=
null,a.sessionVariables.axisX[c].newViewportMaximum=null;if(a.sessionVariables.axisX2)for(c=0;c<a.sessionVariables.axisX2.length;c++)a.sessionVariables.axisX2[c].newViewportMinimum=null,a.sessionVariables.axisX2[c].newViewportMaximum=null;if(a.sessionVariables.axisY)for(c=0;c<a.sessionVariables.axisY.length;c++)a.sessionVariables.axisY[c].newViewportMinimum=null,a.sessionVariables.axisY[c].newViewportMaximum=null;if(a.sessionVariables.axisY2)for(c=0;c<a.sessionVariables.axisY2.length;c++)a.sessionVariables.axisY2[c].newViewportMinimum=
null,a.sessionVariables.axisY2[c].newViewportMaximum=null;a.resetOverlayedCanvas();va(a._zoomButton,a._resetButton);a._dispatchRangeEvent("rangeChanging","reset");a.render();a._dispatchRangeEvent("rangeChanged","reset")},this.allDOMEventHandlers),P(this._resetButton,"mouseover",function(){f||(oa(a,a._resetButton,{backgroundColor:a.toolbar.backgroundColorOnHover,color:a.toolbar.hoverFfontColorOnHoverontColor,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._resetButton.childNodes[0],
{WebkitFilter:"invert(100%)",filter:"invert(100%)"}))},this.allDOMEventHandlers),P(this._resetButton,"mouseout",function(){f||(oa(a,a._resetButton,{backgroundColor:a.toolbar.backgroundColor,color:a.toolbar.fontColor,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._resetButton.childNodes[0],{WebkitFilter:"invert(0%)",filter:"invert(0%)"}))},this.allDOMEventHandlers),this.overlaidCanvas.style.cursor=a._defaultCursor);this.zoomEnabled||this.panEnabled||(this._zoomButton?
(a._zoomButton.getAttribute("state")===a._cultureInfo.zoomText?(this.panEnabled=!0,this.zoomEnabled=!1):(this.zoomEnabled=!0,this.panEnabled=!1),Ma(a._zoomButton,a._resetButton)):(this.zoomEnabled=!0,this.panEnabled=!1))}else this.panEnabled=this.zoomEnabled=!1;this._menuButton?this.exportEnabled?Ma(this._menuButton):va(this._menuButton):this.exportEnabled&&v&&(f=!1,this._menuButton=document.createElement("button"),ua(this,this._menuButton,"menu"),this._toolBar.appendChild(this._menuButton),P(this._menuButton,
"touchstart",function(a){f=!0},this.allDOMEventHandlers),P(this._menuButton,"click",function(){"none"!==a._dropdownMenu.style.display||a._dropDownCloseTime&&500>=(new Date).getTime()-a._dropDownCloseTime.getTime()||(a._dropdownMenu.style.display="block",a._menuButton.blur(),a._dropdownMenu.focus())},this.allDOMEventHandlers,!0),P(this._menuButton,"mouseover",function(){f||(oa(a,a._menuButton,{backgroundColor:a.toolbar.backgroundColorOnHover,color:a.toolbar.fontColorOnHover}),0>=navigator.userAgent.search("MSIE")&&
oa(a,a._menuButton.childNodes[0],{WebkitFilter:"invert(100%)",filter:"invert(100%)"}))},this.allDOMEventHandlers,!0),P(this._menuButton,"mouseout",function(){f||(oa(a,a._menuButton,{backgroundColor:a.toolbar.backgroundColor,color:a.toolbar.fontColor}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._menuButton.childNodes[0],{WebkitFilter:"invert(0%)",filter:"invert(0%)"}))},this.allDOMEventHandlers,!0));if(!this._dropdownMenu&&this.exportEnabled&&v){f=!1;this._dropdownMenu=document.createElement("div");
this._dropdownMenu.setAttribute("tabindex",-1);var b=-1!==this.theme.indexOf("dark")?"black":"#888888";this._dropdownMenu.style.cssText="position: absolute; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; cursor: pointer;right: 0px;top: 25px;min-width: 120px;outline: 0;font-size: 14px; font-family: Arial, Helvetica, sans-serif;padding: 5px 0px 5px 0px;text-align: left;line-height: 10px;background-color:"+this.toolbar.backgroundColor+";box-shadow: 2px 2px 10px "+
b;a._dropdownMenu.style.display="none";this._toolBar.appendChild(this._dropdownMenu);P(this._dropdownMenu,"blur",function(){va(a._dropdownMenu);a._dropDownCloseTime=new Date},this.allDOMEventHandlers,!0);b=document.createElement("div");b.style.cssText="padding: 12px 8px 12px 8px";b.innerHTML=this._cultureInfo.printText;b.style.backgroundColor=this.toolbar.backgroundColor;b.style.color=this.toolbar.fontColor;this._dropdownMenu.appendChild(b);P(b,"touchstart",function(a){f=!0},this.allDOMEventHandlers);
P(b,"mouseover",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColorOnHover,this.style.color=a.toolbar.fontColorOnHover)},this.allDOMEventHandlers,!0);P(b,"mouseout",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColor,this.style.color=a.toolbar.fontColor)},this.allDOMEventHandlers,!0);P(b,"click",function(){a.print();va(a._dropdownMenu)},this.allDOMEventHandlers,!0);b=document.createElement("div");b.style.cssText="padding: 12px 8px 12px 8px";b.innerHTML=this._cultureInfo.saveJPGText;
b.style.backgroundColor=this.toolbar.backgroundColor;b.style.color=this.toolbar.fontColor;this._dropdownMenu.appendChild(b);P(b,"touchstart",function(a){f=!0},this.allDOMEventHandlers);P(b,"mouseover",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColorOnHover,this.style.color=a.toolbar.fontColorOnHover)},this.allDOMEventHandlers,!0);P(b,"mouseout",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColor,this.style.color=a.toolbar.fontColor)},this.allDOMEventHandlers,!0);
P(b,"click",function(){s(a.canvas,"jpeg",a.exportFileName);va(a._dropdownMenu)},this.allDOMEventHandlers,!0);b=document.createElement("div");b.style.cssText="padding: 12px 8px 12px 8px";b.innerHTML=this._cultureInfo.savePNGText;b.style.backgroundColor=this.toolbar.backgroundColor;b.style.color=this.toolbar.fontColor;this._dropdownMenu.appendChild(b);P(b,"touchstart",function(a){f=!0},this.allDOMEventHandlers);P(b,"mouseover",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColorOnHover,
this.style.color=a.toolbar.fontColorOnHover)},this.allDOMEventHandlers,!0);P(b,"mouseout",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColor,this.style.color=a.toolbar.fontColor)},this.allDOMEventHandlers,!0);P(b,"click",function(){s(a.canvas,"png",a.exportFileName);va(a._dropdownMenu)},this.allDOMEventHandlers,!0)}"none"!==this._toolBar.style.display&&this._zoomButton&&(this.panEnabled?ua(a,a._zoomButton,"zoom"):ua(a,a._zoomButton,"pan"),a._resetButton.getAttribute("state")!==a._cultureInfo.resetText&&
ua(a,a._resetButton,"reset"));this.options.toolTip&&this.toolTip.options!==this.options.toolTip&&(this.toolTip.options=this.options.toolTip);for(var c in this.toolTip.options)this.toolTip.options.hasOwnProperty(c)&&this.toolTip.updateOption(c)};q.prototype._updateSize=function(){var a=0,f=0;this.options.width?a=this.width:this.width=a=0<this.container.clientWidth?this.container.clientWidth:this.width;this.options.height?f=this.height:this.height=f=0<this.container.clientHeight?this.container.clientHeight:
this.height;return this.canvas.width!==a*ia||this.canvas.height!==f*ia?(Ga(this.canvas,a,f),Ga(this._preRenderCanvas,a,f),Ga(this.overlaidCanvas,a,f),Ga(this._eventManager.ghostCanvas,a,f),this.bounds={x1:0,y1:0,x2:this.width,y2:this.height},!0):!1};q.prototype._initialize=function(){this.toolbar=new Ra(this,this.options.toolbar);this._animator?this._animator.cancelAllAnimations():this._animator=new ga(this);this.removeAllEventListeners();this.disableToolTip=!1;this._axes=[];this.funnelPyramidClickHandler=
this.pieDoughnutClickHandler=null;this._updateOptions();this.animatedRender=v&&this.animationEnabled&&0===this.renderCount;this._updateSize();this.clearCanvas();this.ctx.beginPath();this.axisX=[];this.axisX2=[];this.axisY=[];this.axisY2=[];this._indexLabels=[];this._dataInRenderedOrder=[];this._events=[];this._eventManager&&this._eventManager.reset();this.plotInfo={axisPlacement:null,plotTypes:[]};this.layoutManager=new Da(0,0,this.width,this.height,2);this.plotArea.layoutManager&&this.plotArea.layoutManager.reset();
this.data=[];var a=0,f=null;if(this.options.data){for(var b=0;b<this.options.data.length;b++)if(a++,!this.options.data[b].type||0<=q._supportedChartTypes.indexOf(this.options.data[b].type)){var c=new S(this,this.options.data[b],a-1,++this._eventManager.lastObjectId);"error"===c.type&&(c.linkedDataSeriesIndex=y(this.options.data[b].linkedDataSeriesIndex)?b-1:this.options.data[b].linkedDataSeriesIndex,0>c.linkedDataSeriesIndex||c.linkedDataSeriesIndex>=this.options.data.length||"number"!==typeof c.linkedDataSeriesIndex||
"error"===this.options.data[c.linkedDataSeriesIndex].type)&&(c.linkedDataSeriesIndex=null);null===c.name&&(c.name="DataSeries "+a);null===c.color?1<this.options.data.length?(c._colorSet=[this._selectedColorSet[c.index%this._selectedColorSet.length]],c.color=this._selectedColorSet[c.index%this._selectedColorSet.length]):c._colorSet="line"===c.type||"stepLine"===c.type||"spline"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"stackedArea"===c.type||"stackedArea100"===c.type||
"rangeArea"===c.type||"rangeSplineArea"===c.type||"candlestick"===c.type||"ohlc"===c.type||"waterfall"===c.type||"boxAndWhisker"===c.type?[this._selectedColorSet[0]]:this._selectedColorSet:c._colorSet=[c.color];null===c.markerSize&&(("line"===c.type||"stepLine"===c.type||"spline"===c.type||0<=c.type.toLowerCase().indexOf("area"))&&c.dataPoints&&c.dataPoints.length<this.width/16||"scatter"===c.type)&&(c.markerSize=8);"bubble"!==c.type&&"scatter"!==c.type||!c.dataPoints||(c.dataPoints.some?c.dataPoints.some(function(a){return a.x})&&
c.dataPoints.sort(m):c.dataPoints.sort(m));this.data.push(c);var e=c.axisPlacement,f=f||e,g;"normal"===e?"xySwapped"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with bar chart':"none"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with pie chart':null===this.plotInfo.axisPlacement&&(this.plotInfo.axisPlacement="normal"):"xySwapped"===e?"normal"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with line, area, column or pie chart':"none"===this.plotInfo.axisPlacement?
g='You cannot combine "'+c.type+'" with pie chart':null===this.plotInfo.axisPlacement&&(this.plotInfo.axisPlacement="xySwapped"):"none"===e?"normal"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with line, area, column or bar chart':"xySwapped"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with bar chart':null===this.plotInfo.axisPlacement&&(this.plotInfo.axisPlacement="none"):null===e&&"none"===this.plotInfo.axisPlacement&&(g='You cannot combine "'+c.type+'" with pie chart');
if(g&&window.console){window.console.log(g);return}}for(b=0;b<this.data.length;b++){if("none"==f&&"error"===this.data[b].type&&window.console){window.console.log('You cannot combine "'+c.type+'" with error chart');return}"error"===this.data[b].type&&(this.data[b].axisPlacement=this.plotInfo.axisPlacement=f||"normal",this.data[b]._linkedSeries=null===this.data[b].linkedDataSeriesIndex?null:this.data[this.data[b].linkedDataSeriesIndex])}}this._objectsInitialized=!0};q._supportedChartTypes=Ca("line stepLine spline column area stepArea splineArea bar bubble scatter stackedColumn stackedColumn100 stackedBar stackedBar100 stackedArea stackedArea100 candlestick ohlc boxAndWhisker rangeColumn error rangeBar rangeArea rangeSplineArea pie doughnut funnel pyramid waterfall".split(" "));
q.prototype.render=function(a){a&&(this.options=a);this._initialize();var f=[];for(a=0;a<this.data.length;a++)if("normal"===this.plotInfo.axisPlacement||"xySwapped"===this.plotInfo.axisPlacement){if(!this.data[a].axisYType||"primary"===this.data[a].axisYType)if(this.options.axisY&&0<this.options.axisY.length){if(!this.axisY.length)for(var b=0;b<this.options.axisY.length;b++)"normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisY[b]=new C(this,"axisY",this.options.axisY[b],b,"axisY","left")):
"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY[b]=new C(this,"axisY",this.options.axisY[b],b,"axisY","bottom"));this.data[a].axisY=this.axisY[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY.length?this.data[a].axisYIndex:0];this.axisY[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY.length?this.data[a].axisYIndex:0].dataSeries.push(this.data[a])}else this.axisY.length||("normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisY[0]=new C(this,
"axisY",this.options.axisY,0,"axisY","left")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY[0]=new C(this,"axisY",this.options.axisY,0,"axisY","bottom"))),this.data[a].axisY=this.axisY[0],this.axisY[0].dataSeries.push(this.data[a]);if("secondary"===this.data[a].axisYType)if(this.options.axisY2&&0<this.options.axisY2.length){if(!this.axisY2.length)for(b=0;b<this.options.axisY2.length;b++)"normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisY2[b]=new C(this,"axisY2",
this.options.axisY2[b],b,"axisY","right")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY2[b]=new C(this,"axisY2",this.options.axisY2[b],b,"axisY","top"));this.data[a].axisY=this.axisY2[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY2.length?this.data[a].axisYIndex:0];this.axisY2[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY2.length?this.data[a].axisYIndex:0].dataSeries.push(this.data[a])}else this.axisY2.length||("normal"===this.plotInfo.axisPlacement?
this._axes.push(this.axisY2[0]=new C(this,"axisY2",this.options.axisY2,0,"axisY","right")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY2[0]=new C(this,"axisY2",this.options.axisY2,0,"axisY","top"))),this.data[a].axisY=this.axisY2[0],this.axisY2[0].dataSeries.push(this.data[a]);if(!this.data[a].axisXType||"primary"===this.data[a].axisXType)if(this.options.axisX&&0<this.options.axisX.length){if(!this.axisX.length)for(b=0;b<this.options.axisX.length;b++)"normal"===this.plotInfo.axisPlacement?
this._axes.push(this.axisX[b]=new C(this,"axisX",this.options.axisX[b],b,"axisX","bottom")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX[b]=new C(this,"axisX",this.options.axisX[b],b,"axisX","left"));this.data[a].axisX=this.axisX[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX.length?this.data[a].axisXIndex:0];this.axisX[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX.length?this.data[a].axisXIndex:0].dataSeries.push(this.data[a])}else this.axisX.length||
("normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisX[0]=new C(this,"axisX",this.options.axisX,0,"axisX","bottom")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX[0]=new C(this,"axisX",this.options.axisX,0,"axisX","left"))),this.data[a].axisX=this.axisX[0],this.axisX[0].dataSeries.push(this.data[a]);if("secondary"===this.data[a].axisXType)if(this.options.axisX2&&0<this.options.axisX2.length){if(!this.axisX2.length)for(b=0;b<this.options.axisX2.length;b++)"normal"===
this.plotInfo.axisPlacement?this._axes.push(this.axisX2[b]=new C(this,"axisX2",this.options.axisX2[b],b,"axisX","top")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX2[b]=new C(this,"axisX2",this.options.axisX2[b],b,"axisX","right"));this.data[a].axisX=this.axisX2[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX2.length?this.data[a].axisXIndex:0];this.axisX2[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX2.length?this.data[a].axisXIndex:0].dataSeries.push(this.data[a])}else this.axisX2.length||
("normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisX2[0]=new C(this,"axisX2",this.options.axisX2,0,"axisX","top")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX2[0]=new C(this,"axisX2",this.options.axisX2,0,"axisX","right"))),this.data[a].axisX=this.axisX2[0],this.axisX2[0].dataSeries.push(this.data[a])}if(this.axisY){for(b=1;b<this.axisY.length;b++)"undefined"===typeof this.axisY[b].options.gridThickness&&(this.axisY[b].gridThickness=0);for(b=0;b<this.axisY.length-
1;b++)"undefined"===typeof this.axisY[b].options.margin&&(this.axisY[b].margin=10)}if(this.axisY2){for(b=1;b<this.axisY2.length;b++)"undefined"===typeof this.axisY2[b].options.gridThickness&&(this.axisY2[b].gridThickness=0);for(b=0;b<this.axisY2.length-1;b++)"undefined"===typeof this.axisY2[b].options.margin&&(this.axisY2[b].margin=10)}this.axisY&&0<this.axisY.length&&(this.axisY2&&0<this.axisY2.length)&&(0<this.axisY[0].gridThickness&&"undefined"===typeof this.axisY2[0].options.gridThickness?this.axisY2[0].gridThickness=
0:0<this.axisY2[0].gridThickness&&"undefined"===typeof this.axisY[0].options.gridThickness&&(this.axisY[0].gridThickness=0));if(this.axisX)for(b=0;b<this.axisX.length;b++)"undefined"===typeof this.axisX[b].options.gridThickness&&(this.axisX[b].gridThickness=0);if(this.axisX2)for(b=0;b<this.axisX2.length;b++)"undefined"===typeof this.axisX2[b].options.gridThickness&&(this.axisX2[b].gridThickness=0);this.axisX&&0<this.axisX.length&&(this.axisX2&&0<this.axisX2.length)&&(0<this.axisX[0].gridThickness&&
"undefined"===typeof this.axisX2[0].options.gridThickness?this.axisX2[0].gridThickness=0:0<this.axisX2[0].gridThickness&&"undefined"===typeof this.axisX[0].options.gridThickness&&(this.axisX[0].gridThickness=0));b=!1;if(0<this._axes.length&&(this.zoomEnabled||this.panEnabled))for(a=0;a<this._axes.length;a++)if(null!==this._axes[a].viewportMinimum||null!==this._axes[a].viewportMaximum){b=!0;break}b?(Ma(this._zoomButton,this._resetButton),this._toolBar.style.border=this.toolbar.borderThickness+"px solid "+
this.toolbar.borderColor,this._zoomButton.style.borderRight=this.toolbar.borderThickness+"px solid "+this.toolbar.borderColor,this._resetButton.style.borderRight=(this.exportEnabled?this.toolbar.borderThickness:0)+"px solid "+this.toolbar.borderColor):(va(this._zoomButton,this._resetButton),this._toolBar.style.border=this.toolbar.borderThickness+"px solid transparent",this.options.zoomEnabled&&(this.zoomEnabled=!0,this.panEnabled=!1));bb(this);this._processData();this.options.title&&(this.title=new Ha(this,
this.options.title),this.title.dockInsidePlotArea?f.push(this.title):this.title.render());if(this.options.subtitles)for(this.subtitles=[],a=0;a<this.options.subtitles.length;a++)b=new Na(this,this.options.subtitles[a],a),this.subtitles.push(b),b.dockInsidePlotArea?f.push(b):b.render();this.legend=new T(this,this.options.legend);for(a=0;a<this.data.length;a++)(this.data[a].showInLegend||"pie"===this.data[a].type||"doughnut"===this.data[a].type||"funnel"===this.data[a].type||"pyramid"===this.data[a].type)&&
this.legend.dataSeries.push(this.data[a]);this.legend.dockInsidePlotArea?f.push(this.legend):this.legend.render();for(a=0;a<this._axes.length;a++)if(this._axes[a].scaleBreaks&&this._axes[a].scaleBreaks._appliedBreaks.length){v?(this._breaksCanvas=ta(this.width,this.height,!0),this._breaksCanvasCtx=this._breaksCanvas.getContext("2d")):(this._breaksCanvas=this.canvas,this._breaksCanvasCtx=this.ctx);break}this._preRenderCanvas=ta(this.width,this.height);this._preRenderCtx=this._preRenderCanvas.getContext("2d");
if("normal"===this.plotInfo.axisPlacement||"xySwapped"===this.plotInfo.axisPlacement)C.setLayoutAndRender(this.axisX,this.axisX2,this.axisY,this.axisY2,this.plotInfo.axisPlacement,this.layoutManager.getFreeSpace());else if("none"===this.plotInfo.axisPlacement)this.preparePlotArea();else return;for(a=0;a<f.length;a++)f[a].render();var c=[];if(this.animatedRender){var e=ta(this.width,this.height);e.getContext("2d").drawImage(this.canvas,0,0,this.width,this.height)}cb(this);var f=this.ctx.miterLimit,
g;this.ctx.miterLimit=3;v&&this._breaksCanvas&&(this._preRenderCtx.drawImage(this.canvas,0,0,this.width,this.height),this._preRenderCtx.drawImage(this._breaksCanvas,0,0,this.width,this.height),this._breaksCanvasCtx.globalCompositeOperation="source-atop",this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),this._preRenderCtx.clearRect(0,0,this.width,this.height));for(a=0;a<this.plotInfo.plotTypes.length;a++)for(var h=this.plotInfo.plotTypes[a],l=0;l<h.plotUnits.length;l++){var t=
h.plotUnits[l],k=null;t.targetCanvas=null;this.animatedRender&&(t.targetCanvas=ta(this.width,this.height),t.targetCanvasCtx=t.targetCanvas.getContext("2d"),g=t.targetCanvasCtx.miterLimit,t.targetCanvasCtx.miterLimit=3);"line"===t.type?k=this.renderLine(t):"stepLine"===t.type?k=this.renderStepLine(t):"spline"===t.type?k=this.renderSpline(t):"column"===t.type?k=this.renderColumn(t):"bar"===t.type?k=this.renderBar(t):"area"===t.type?k=this.renderArea(t):"stepArea"===t.type?k=this.renderStepArea(t):"splineArea"===
t.type?k=this.renderSplineArea(t):"stackedColumn"===t.type?k=this.renderStackedColumn(t):"stackedColumn100"===t.type?k=this.renderStackedColumn100(t):"stackedBar"===t.type?k=this.renderStackedBar(t):"stackedBar100"===t.type?k=this.renderStackedBar100(t):"stackedArea"===t.type?k=this.renderStackedArea(t):"stackedArea100"===t.type?k=this.renderStackedArea100(t):"bubble"===t.type?k=k=this.renderBubble(t):"scatter"===t.type?k=this.renderScatter(t):"pie"===t.type?this.renderPie(t):"doughnut"===t.type?
this.renderPie(t):"funnel"===t.type?k=this.renderFunnel(t):"pyramid"===t.type?k=this.renderFunnel(t):"candlestick"===t.type?k=this.renderCandlestick(t):"ohlc"===t.type?k=this.renderCandlestick(t):"rangeColumn"===t.type?k=this.renderRangeColumn(t):"error"===t.type?k=this.renderError(t):"rangeBar"===t.type?k=this.renderRangeBar(t):"rangeArea"===t.type?k=this.renderRangeArea(t):"rangeSplineArea"===t.type?k=this.renderRangeSplineArea(t):"waterfall"===t.type?k=this.renderWaterfall(t):"boxAndWhisker"===
t.type&&(k=this.renderBoxAndWhisker(t));for(b=0;b<t.dataSeriesIndexes.length;b++)this._dataInRenderedOrder.push(this.data[t.dataSeriesIndexes[b]]);this.animatedRender&&(t.targetCanvasCtx.miterLimit=g,k&&c.push(k))}this.ctx.miterLimit=f;this.animatedRender&&this._breaksCanvasCtx&&c.push({source:this._breaksCanvasCtx,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0,startTimePercent:0.7});this.animatedRender&&0<this._indexLabels.length&&(g=
ta(this.width,this.height).getContext("2d"),c.push(this.renderIndexLabels(g)));var r=this;if(0<c.length)r.disableToolTip=!0,r._animator.animate(200,r.animationDuration,function(a){r.ctx.clearRect(0,0,r.width,r.height);r.ctx.drawImage(e,0,0,Math.floor(r.width*ia),Math.floor(r.height*ia),0,0,r.width,r.height);for(var b=0;b<c.length;b++)k=c[b],1>a&&"undefined"!==typeof k.startTimePercent?a>=k.startTimePercent&&k.animationCallback(k.easingFunction(a-k.startTimePercent,0,1,1-k.startTimePercent),k):k.animationCallback(k.easingFunction(a,
0,1,1),k);r.dispatchEvent("dataAnimationIterationEnd",{chart:r})},function(){c=[];for(var a=0;a<r.plotInfo.plotTypes.length;a++)for(var b=r.plotInfo.plotTypes[a],d=0;d<b.plotUnits.length;d++)b.plotUnits[d].targetCanvas=null;e=null;r.disableToolTip=!1});else{if(r._breaksCanvas)if(v)r.plotArea.ctx.drawImage(r._breaksCanvas,0,0,this.width,this.height);else for(b=0;b<r._axes.length;b++)r._axes[b].createMask();0<r._indexLabels.length&&r.renderIndexLabels();r.dispatchEvent("dataAnimationIterationEnd",{chart:r})}this.attachPlotAreaEventHandlers();
this.zoomEnabled||(this.panEnabled||!this._zoomButton||"none"===this._zoomButton.style.display)||va(this._zoomButton,this._resetButton);this.toolTip._updateToolTip();this.renderCount++;this._breaksCanvas&&(delete this._breaksCanvas,delete this._breaksCanvasCtx);for(b=0;b<this._axes.length;b++)this._axes[b].maskCanvas&&(delete this._axes[b].maskCanvas,delete this._axes[b].maskCtx)};q.prototype.attachPlotAreaEventHandlers=function(){this.attachEvent({context:this,chart:this,mousedown:this._plotAreaMouseDown,
mouseup:this._plotAreaMouseUp,mousemove:this._plotAreaMouseMove,cursor:this.panEnabled?"move":"default",capture:!0,bounds:this.plotArea})};q.prototype.categoriseDataSeries=function(){for(var a="",f=0;f<this.data.length;f++)if(a=this.data[f],a.dataPoints&&(0!==a.dataPoints.length&&a.visible)&&0<=q._supportedChartTypes.indexOf(a.type)){for(var b=null,c=!1,e=null,g=!1,h=0;h<this.plotInfo.plotTypes.length;h++)if(this.plotInfo.plotTypes[h].type===a.type){c=!0;b=this.plotInfo.plotTypes[h];break}c||(b={type:a.type,
totalDataSeries:0,plotUnits:[]},this.plotInfo.plotTypes.push(b));for(h=0;h<b.plotUnits.length;h++)if(b.plotUnits[h].axisYType===a.axisYType&&b.plotUnits[h].axisXType===a.axisXType&&b.plotUnits[h].axisYIndex===a.axisYIndex&&b.plotUnits[h].axisXIndex===a.axisXIndex){g=!0;e=b.plotUnits[h];break}g||(e={type:a.type,previousDataSeriesCount:0,index:b.plotUnits.length,plotType:b,axisXType:a.axisXType,axisYType:a.axisYType,axisYIndex:a.axisYIndex,axisXIndex:a.axisXIndex,axisY:"primary"===a.axisYType?this.axisY[0<=
a.axisYIndex&&a.axisYIndex<this.axisY.length?a.axisYIndex:0]:this.axisY2[0<=a.axisYIndex&&a.axisYIndex<this.axisY2.length?a.axisYIndex:0],axisX:"primary"===a.axisXType?this.axisX[0<=a.axisXIndex&&a.axisXIndex<this.axisX.length?a.axisXIndex:0]:this.axisX2[0<=a.axisXIndex&&a.axisXIndex<this.axisX2.length?a.axisXIndex:0],dataSeriesIndexes:[],yTotals:[]},b.plotUnits.push(e));b.totalDataSeries++;e.dataSeriesIndexes.push(f);a.plotUnit=e}for(f=0;f<this.plotInfo.plotTypes.length;f++)for(b=this.plotInfo.plotTypes[f],
h=a=0;h<b.plotUnits.length;h++)b.plotUnits[h].previousDataSeriesCount=a,a+=b.plotUnits[h].dataSeriesIndexes.length};q.prototype.assignIdToDataPoints=function(){for(var a=0;a<this.data.length;a++){var f=this.data[a];if(f.dataPoints)for(var b=f.dataPoints.length,c=0;c<b;c++)f.dataPointIds[c]=++this._eventManager.lastObjectId}};q.prototype._processData=function(){this.assignIdToDataPoints();this.categoriseDataSeries();for(var a=0;a<this.plotInfo.plotTypes.length;a++)for(var f=this.plotInfo.plotTypes[a],
b=0;b<f.plotUnits.length;b++){var c=f.plotUnits[b];"line"===c.type||"stepLine"===c.type||"spline"===c.type||"column"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"bar"===c.type||"bubble"===c.type||"scatter"===c.type?this._processMultiseriesPlotUnit(c):"stackedColumn"===c.type||"stackedBar"===c.type||"stackedArea"===c.type?this._processStackedPlotUnit(c):"stackedColumn100"===c.type||"stackedBar100"===c.type||"stackedArea100"===c.type?this._processStacked100PlotUnit(c):"candlestick"===
c.type||"ohlc"===c.type||"rangeColumn"===c.type||"rangeBar"===c.type||"rangeArea"===c.type||"rangeSplineArea"===c.type||"error"===c.type||"boxAndWhisker"===c.type?this._processMultiYPlotUnit(c):"waterfall"===c.type&&this._processSpecificPlotUnit(c)}this.calculateAutoBreaks()};q.prototype._processMultiseriesPlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length))for(var f=a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=0;h<a.dataSeriesIndexes.length;h++){var l=this.data[a.dataSeriesIndexes[h]],
t=0,k=!1,r=!1,p;if("normal"===l.axisPlacement||"xySwapped"===l.axisPlacement)var n=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:a.axisX.logarithmic?0:-Infinity,d=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?
this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(l.dataPoints[t].x&&l.dataPoints[t].x.getTime||"dateTime"===l.xValueType)g=!0;for(t=0;t<l.dataPoints.length;t++){"undefined"===typeof l.dataPoints[t].x&&(l.dataPoints[t].x=t+(a.axisX.logarithmic?1:0));l.dataPoints[t].x.getTime?(g=!0,c=l.dataPoints[t].x.getTime()):c=l.dataPoints[t].x;e=l.dataPoints[t].y;c<b.min&&(b.min=c);c>b.max&&(b.max=c);e<f.min&&"number"===typeof e&&(f.min=e);
e>f.max&&"number"===typeof e&&(f.max=e);if(0<t){if(a.axisX.logarithmic){var w=c/l.dataPoints[t-1].x;1>w&&(w=1/w);b.minDiff>w&&1!==w&&(b.minDiff=w)}else w=c-l.dataPoints[t-1].x,0>w&&(w*=-1),b.minDiff>w&&0!==w&&(b.minDiff=w);null!==e&&null!==l.dataPoints[t-1].y&&(a.axisY.logarithmic?(w=e/l.dataPoints[t-1].y,1>w&&(w=1/w),f.minDiff>w&&1!==w&&(f.minDiff=w)):(w=e-l.dataPoints[t-1].y,0>w&&(w*=-1),f.minDiff>w&&0!==w&&(f.minDiff=w)))}if(c<n&&!k)null!==e&&(p=c);else{if(!k&&(k=!0,0<t)){t-=2;continue}if(c>d&&
!r)r=!0;else if(c>d&&r)continue;l.dataPoints[t].label&&(a.axisX.labels[c]=l.dataPoints[t].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);null===e?b.viewPortMin===c&&p<c&&(b.viewPortMin=p):(e<f.viewPortMin&&"number"===typeof e&&(f.viewPortMin=e),e>f.viewPortMax&&"number"===typeof e&&(f.viewPortMax=e))}}l.axisX.valueType=l.xValueType=g?"dateTime":"number"}};q.prototype._processStackedPlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)){for(var f=
a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=[],l=[],t=Infinity,k=-Infinity,r=0;r<a.dataSeriesIndexes.length;r++){var p=this.data[a.dataSeriesIndexes[r]],n=0,d=!1,w=!1,ya;if("normal"===p.axisPlacement||"xySwapped"===p.axisPlacement)var D=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:-Infinity,
u=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(p.dataPoints[n].x&&p.dataPoints[n].x.getTime||"dateTime"===p.xValueType)g=!0;for(n=0;n<p.dataPoints.length;n++){"undefined"===typeof p.dataPoints[n].x&&(p.dataPoints[n].x=n+(a.axisX.logarithmic?1:0));p.dataPoints[n].x.getTime?(g=!0,c=p.dataPoints[n].x.getTime()):
c=p.dataPoints[n].x;e=y(p.dataPoints[n].y)?0:p.dataPoints[n].y;c<b.min&&(b.min=c);c>b.max&&(b.max=c);if(0<n){if(a.axisX.logarithmic){var m=c/p.dataPoints[n-1].x;1>m&&(m=1/m);b.minDiff>m&&1!==m&&(b.minDiff=m)}else m=c-p.dataPoints[n-1].x,0>m&&(m*=-1),b.minDiff>m&&0!==m&&(b.minDiff=m);null!==e&&null!==p.dataPoints[n-1].y&&(a.axisY.logarithmic?0<e&&(m=e/p.dataPoints[n-1].y,1>m&&(m=1/m),f.minDiff>m&&1!==m&&(f.minDiff=m)):(m=e-p.dataPoints[n-1].y,0>m&&(m*=-1),f.minDiff>m&&0!==m&&(f.minDiff=m)))}if(c<D&&
!d)null!==p.dataPoints[n].y&&(ya=c);else{if(!d&&(d=!0,0<n)){n-=2;continue}if(c>u&&!w)w=!0;else if(c>u&&w)continue;p.dataPoints[n].label&&(a.axisX.labels[c]=p.dataPoints[n].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);null===p.dataPoints[n].y?b.viewPortMin===c&&ya<c&&(b.viewPortMin=ya):(a.yTotals[c]=(a.yTotals[c]?a.yTotals[c]:0)+e,0<=e?h[c]?h[c]+=e:(h[c]=e,t=Math.min(e,t)):l[c]?l[c]+=e:(l[c]=e,k=Math.max(e,k)))}}a.axisY.scaleBreaks&&(a.axisY.scaleBreaks.autoCalculate&&
1<=a.axisY.scaleBreaks.maxNumberOfAutoBreaks)&&(f.dataPointYPositiveSums?(f.dataPointYPositiveSums.push.apply(f.dataPointYPositiveSums,h),f.dataPointYNegativeSums.push.apply(f.dataPointYPositiveSums,l)):(f.dataPointYPositiveSums=h,f.dataPointYNegativeSums=l));p.axisX.valueType=p.xValueType=g?"dateTime":"number"}for(n in h)h.hasOwnProperty(n)&&!isNaN(n)&&(a=h[n],a<f.min&&(f.min=Math.min(a,t)),a>f.max&&(f.max=a),n<b.viewPortMin||n>b.viewPortMax||(a<f.viewPortMin&&(f.viewPortMin=Math.min(a,t)),a>f.viewPortMax&&
(f.viewPortMax=a)));for(n in l)l.hasOwnProperty(n)&&!isNaN(n)&&(a=l[n],a<f.min&&(f.min=a),a>f.max&&(f.max=Math.max(a,k)),n<b.viewPortMin||n>b.viewPortMax||(a<f.viewPortMin&&(f.viewPortMin=a),a>f.viewPortMax&&(f.viewPortMax=Math.max(a,k))))}};q.prototype._processStacked100PlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)){for(var f=a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=!1,l=!1,t=[],k=0;k<a.dataSeriesIndexes.length;k++){var r=this.data[a.dataSeriesIndexes[k]],p=0,
n=!1,d=!1,w;if("normal"===r.axisPlacement||"xySwapped"===r.axisPlacement)var m=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:-Infinity,D=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:
this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(r.dataPoints[p].x&&r.dataPoints[p].x.getTime||"dateTime"===r.xValueType)g=!0;for(p=0;p<r.dataPoints.length;p++){"undefined"===typeof r.dataPoints[p].x&&(r.dataPoints[p].x=p+(a.axisX.logarithmic?1:0));r.dataPoints[p].x.getTime?(g=!0,c=r.dataPoints[p].x.getTime()):c=r.dataPoints[p].x;e=y(r.dataPoints[p].y)?null:r.dataPoints[p].y;c<b.min&&(b.min=c);c>b.max&&(b.max=c);if(0<p){if(a.axisX.logarithmic){var u=c/r.dataPoints[p-
1].x;1>u&&(u=1/u);b.minDiff>u&&1!==u&&(b.minDiff=u)}else u=c-r.dataPoints[p-1].x,0>u&&(u*=-1),b.minDiff>u&&0!==u&&(b.minDiff=u);y(e)||null===r.dataPoints[p-1].y||(a.axisY.logarithmic?0<e&&(u=e/r.dataPoints[p-1].y,1>u&&(u=1/u),f.minDiff>u&&1!==u&&(f.minDiff=u)):(u=e-r.dataPoints[p-1].y,0>u&&(u*=-1),f.minDiff>u&&0!==u&&(f.minDiff=u)))}if(c<m&&!n)null!==e&&(w=c);else{if(!n&&(n=!0,0<p)){p-=2;continue}if(c>D&&!d)d=!0;else if(c>D&&d)continue;r.dataPoints[p].label&&(a.axisX.labels[c]=r.dataPoints[p].label);
c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);null===e?b.viewPortMin===c&&w<c&&(b.viewPortMin=w):(a.yTotals[c]=(a.yTotals[c]?a.yTotals[c]:0)+e,0<=e?h=!0:0>e&&(l=!0),t[c]=t[c]?t[c]+Math.abs(e):Math.abs(e))}}r.axisX.valueType=r.xValueType=g?"dateTime":"number"}a.axisY.logarithmic?(f.max=y(f.viewPortMax)?99*Math.pow(a.axisY.logarithmBase,-0.05):Math.max(f.viewPortMax,99*Math.pow(a.axisY.logarithmBase,-0.05)),f.min=y(f.viewPortMin)?1:Math.min(f.viewPortMin,1)):h&&!l?(f.max=y(f.viewPortMax)?
99:Math.max(f.viewPortMax,99),f.min=y(f.viewPortMin)?1:Math.min(f.viewPortMin,1)):h&&l?(f.max=y(f.viewPortMax)?99:Math.max(f.viewPortMax,99),f.min=y(f.viewPortMin)?-99:Math.min(f.viewPortMin,-99)):!h&&l&&(f.max=y(f.viewPortMax)?-1:Math.max(f.viewPortMax,-1),f.min=y(f.viewPortMin)?-99:Math.min(f.viewPortMin,-99));f.viewPortMin=f.min;f.viewPortMax=f.max;a.dataPointYSums=t}};q.prototype._processMultiYPlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length))for(var f=a.axisY.dataInfo,
b=a.axisX.dataInfo,c,e,g,h,l=!1,t=0;t<a.dataSeriesIndexes.length;t++){var k=this.data[a.dataSeriesIndexes[t]],r=0,p=!1,n=!1,d,w,m;if("normal"===k.axisPlacement||"xySwapped"===k.axisPlacement)var D=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:a.axisX.logarithmic?0:-Infinity,u=a.axisX.sessionVariables.newViewportMaximum?
a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(k.dataPoints[r].x&&k.dataPoints[r].x.getTime||"dateTime"===k.xValueType)l=!0;for(r=0;r<k.dataPoints.length;r++){"undefined"===typeof k.dataPoints[r].x&&(k.dataPoints[r].x=r+(a.axisX.logarithmic?1:0));k.dataPoints[r].x.getTime?(l=!0,c=k.dataPoints[r].x.getTime()):c=k.dataPoints[r].x;
if((e=k.dataPoints[r].y)&&e.length){g=Math.min.apply(null,e);h=Math.max.apply(null,e);w=!0;for(var v=0;v<e.length;v++)null===e.k&&(w=!1);w&&(p||(m=d),d=c)}c<b.min&&(b.min=c);c>b.max&&(b.max=c);g<f.min&&(f.min=g);h>f.max&&(f.max=h);0<r&&(a.axisX.logarithmic?(w=c/k.dataPoints[r-1].x,1>w&&(w=1/w),b.minDiff>w&&1!==w&&(b.minDiff=w)):(w=c-k.dataPoints[r-1].x,0>w&&(w*=-1),b.minDiff>w&&0!==w&&(b.minDiff=w)),e&&(null!==e[0]&&k.dataPoints[r-1].y&&null!==k.dataPoints[r-1].y[0])&&(a.axisY.logarithmic?(w=e[0]/
k.dataPoints[r-1].y[0],1>w&&(w=1/w),f.minDiff>w&&1!==w&&(f.minDiff=w)):(w=e[0]-k.dataPoints[r-1].y[0],0>w&&(w*=-1),f.minDiff>w&&0!==w&&(f.minDiff=w))));if(!(c<D)||p){if(!p&&(p=!0,0<r)){r-=2;d=m;continue}if(c>u&&!n)n=!0;else if(c>u&&n)continue;k.dataPoints[r].label&&(a.axisX.labels[c]=k.dataPoints[r].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);if(b.viewPortMin===c&&e)for(v=0;v<e.length;v++)if(null===e[v]&&d<c){b.viewPortMin=d;break}null===e?b.viewPortMin===c&&d<c&&
(b.viewPortMin=d):(g<f.viewPortMin&&(f.viewPortMin=g),h>f.viewPortMax&&(f.viewPortMax=h))}}k.axisX.valueType=k.xValueType=l?"dateTime":"number"}};q.prototype._processSpecificPlotUnit=function(a){if("waterfall"===a.type&&a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length))for(var f=a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=0;h<a.dataSeriesIndexes.length;h++){var l=this.data[a.dataSeriesIndexes[h]],t=0,k=!1,r=!1,p=c=0;if("normal"===l.axisPlacement||"xySwapped"===l.axisPlacement)var n=a.axisX.sessionVariables.newViewportMinimum?
a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:a.axisX.logarithmic?0:-Infinity,d=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;
if(l.dataPoints[t].x&&l.dataPoints[t].x.getTime||"dateTime"===l.xValueType)g=!0;for(t=0;t<l.dataPoints.length;t++)"undefined"!==typeof l.dataPoints[t].isCumulativeSum&&!0===l.dataPoints[t].isCumulativeSum?(l.dataPointEOs[t].cumulativeSumYStartValue=0,l.dataPointEOs[t].cumulativeSum=0===t?0:l.dataPointEOs[t-1].cumulativeSum,l.dataPoints[t].y=0===t?0:l.dataPointEOs[t-1].cumulativeSum):"undefined"!==typeof l.dataPoints[t].isIntermediateSum&&!0===l.dataPoints[t].isIntermediateSum?(l.dataPointEOs[t].cumulativeSumYStartValue=
p,l.dataPointEOs[t].cumulativeSum=0===t?0:l.dataPointEOs[t-1].cumulativeSum,l.dataPoints[t].y=0===t?0:c,p=0===t?0:l.dataPointEOs[t-1].cumulativeSum,c=0):(e="number"!==typeof l.dataPoints[t].y?0:l.dataPoints[t].y,l.dataPointEOs[t].cumulativeSumYStartValue=0===t?0:l.dataPointEOs[t-1].cumulativeSum,l.dataPointEOs[t].cumulativeSum=0===t?e:l.dataPointEOs[t-1].cumulativeSum+e,c+=e);for(t=0;t<l.dataPoints.length;t++)if("undefined"===typeof l.dataPoints[t].x&&(l.dataPoints[t].x=t+(a.axisX.logarithmic?1:0)),
l.dataPoints[t].x.getTime?(g=!0,c=l.dataPoints[t].x.getTime()):c=l.dataPoints[t].x,e=l.dataPoints[t].y,c<b.min&&(b.min=c),c>b.max&&(b.max=c),l.dataPointEOs[t].cumulativeSum<f.min&&(f.min=l.dataPointEOs[t].cumulativeSum),l.dataPointEOs[t].cumulativeSum>f.max&&(f.max=l.dataPointEOs[t].cumulativeSum),0<t&&(a.axisX.logarithmic?(p=c/l.dataPoints[t-1].x,1>p&&(p=1/p),b.minDiff>p&&1!==p&&(b.minDiff=p)):(p=c-l.dataPoints[t-1].x,0>p&&(p*=-1),b.minDiff>p&&0!==p&&(b.minDiff=p)),null!==e&&null!==l.dataPoints[t-
1].y&&(a.axisY.logarithmic?(e=l.dataPointEOs[t].cumulativeSum/l.dataPointEOs[t-1].cumulativeSum,1>e&&(e=1/e),f.minDiff>e&&1!==e&&(f.minDiff=e)):(e=l.dataPointEOs[t].cumulativeSum-l.dataPointEOs[t-1].cumulativeSum,0>e&&(e*=-1),f.minDiff>e&&0!==e&&(f.minDiff=e)))),!(c<n)||k){if(!k&&(k=!0,0<t)){t-=2;continue}if(c>d&&!r)r=!0;else if(c>d&&r)continue;l.dataPoints[t].label&&(a.axisX.labels[c]=l.dataPoints[t].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);0<t&&(l.dataPointEOs[t-
1].cumulativeSum<f.viewPortMin&&(f.viewPortMin=l.dataPointEOs[t-1].cumulativeSum),l.dataPointEOs[t-1].cumulativeSum>f.viewPortMax&&(f.viewPortMax=l.dataPointEOs[t-1].cumulativeSum));l.dataPointEOs[t].cumulativeSum<f.viewPortMin&&(f.viewPortMin=l.dataPointEOs[t].cumulativeSum);l.dataPointEOs[t].cumulativeSum>f.viewPortMax&&(f.viewPortMax=l.dataPointEOs[t].cumulativeSum)}l.axisX.valueType=l.xValueType=g?"dateTime":"number"}};q.prototype.calculateAutoBreaks=function(){function a(a,c,b,e){if(e)return b=
Math.pow(Math.min(b*a/c,c/a),0.2),1>=b&&(b=Math.pow(1>a?1/a:Math.min(c/a,a),0.25)),{startValue:a*b,endValue:c/b};b=0.2*Math.min(b-c+a,c-a);0>=b&&(b=0.25*Math.min(c-a,Math.abs(a)));return{startValue:a+b,endValue:c-b}}function f(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)){var c=a.axisX.scaleBreaks&&a.axisX.scaleBreaks.autoCalculate&&1<=a.axisX.scaleBreaks.maxNumberOfAutoBreaks,b=a.axisY.scaleBreaks&&a.axisY.scaleBreaks.autoCalculate&&1<=a.axisY.scaleBreaks.maxNumberOfAutoBreaks;if(c||
b)for(var f=a.axisY.dataInfo,g=a.axisX.dataInfo,k,h=g.min,n=g.max,l=f.min,t=f.max,g=g._dataRanges,f=f._dataRanges,p,r=0,m=0;m<a.dataSeriesIndexes.length;m++){var v=e.data[a.dataSeriesIndexes[m]];if(!(4>v.dataPoints.length))for(r=0;r<v.dataPoints.length;r++)if(c&&(p=(n+1-h)*Math.max(parseFloat(a.axisX.scaleBreaks.collapsibleThreshold)||10,10)/100,k=v.dataPoints[r].x.getTime?v.dataPoints[r].x.getTime():v.dataPoints[r].x,p=Math.floor((k-h)/p),k<g[p].min&&(g[p].min=k),k>g[p].max&&(g[p].max=k)),b){var q=
(t+1-l)*Math.max(parseFloat(a.axisY.scaleBreaks.collapsibleThreshold)||10,10)/100;if((k="waterfall"===a.type?v.dataPointEOs[r].cumulativeSum:v.dataPoints[r].y)&&k.length)for(var s=0;s<k.length;s++)p=Math.floor((k[s]-l)/q),k[s]<f[p].min&&(f[p].min=k[s]),k[s]>f[p].max&&(f[p].max=k[s]);else y(k)||(p=Math.floor((k-l)/q),k<f[p].min&&(f[p].min=k),k>f[p].max&&(f[p].max=k))}}}}function b(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)&&a.axisX.scaleBreaks&&a.axisX.scaleBreaks.autoCalculate&&1<=
a.axisX.scaleBreaks.maxNumberOfAutoBreaks)for(var c=a.axisX.dataInfo,b=c.min,f=c.max,g=c._dataRanges,k,h=0,n=0;n<a.dataSeriesIndexes.length;n++){var l=e.data[a.dataSeriesIndexes[n]];if(!(4>l.dataPoints.length))for(h=0;h<l.dataPoints.length;h++)k=(f+1-b)*Math.max(parseFloat(a.axisX.scaleBreaks.collapsibleThreshold)||10,10)/100,c=l.dataPoints[h].x.getTime?l.dataPoints[h].x.getTime():l.dataPoints[h].x,k=Math.floor((c-b)/k),c<g[k].min&&(g[k].min=c),c>g[k].max&&(g[k].max=c)}}for(var c,e=this,g=!1,h=0;h<
this._axes.length;h++)if(this._axes[h].scaleBreaks&&this._axes[h].scaleBreaks.autoCalculate&&1<=this._axes[h].scaleBreaks.maxNumberOfAutoBreaks){g=!0;this._axes[h].dataInfo._dataRanges=[];for(var l=0;l<100/Math.max(parseFloat(this._axes[h].scaleBreaks.collapsibleThreshold)||10,10);l++)this._axes[h].dataInfo._dataRanges.push({min:Infinity,max:-Infinity})}if(g){for(h=0;h<this.plotInfo.plotTypes.length;h++)for(g=this.plotInfo.plotTypes[h],l=0;l<g.plotUnits.length;l++)c=g.plotUnits[l],"line"===c.type||
"stepLine"===c.type||"spline"===c.type||"column"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"bar"===c.type||"bubble"===c.type||"scatter"===c.type||"candlestick"===c.type||"ohlc"===c.type||"rangeColumn"===c.type||"rangeBar"===c.type||"rangeArea"===c.type||"rangeSplineArea"===c.type||"waterfall"===c.type||"error"===c.type||"boxAndWhisker"===c.type?f(c):0<=c.type.indexOf("stacked")&&b(c);for(h=0;h<this._axes.length;h++)if(this._axes[h].dataInfo._dataRanges){var t=this._axes[h].dataInfo.min;
c=(this._axes[h].dataInfo.max+1-t)*Math.max(parseFloat(this._axes[h].scaleBreaks.collapsibleThreshold)||10,10)/100;var k=this._axes[h].dataInfo._dataRanges,r,p,g=[];if(this._axes[h].dataInfo.dataPointYPositiveSums){var n=this._axes[h].dataInfo.dataPointYPositiveSums;r=k;for(l in n)n.hasOwnProperty(l)&&!isNaN(l)&&(p=n[l],y(p)||(index=Math.floor((p-t)/c),p<r[index].min&&(r[index].min=p),p>r[index].max&&(r[index].max=p)));delete this._axes[h].dataInfo.dataPointYPositiveSums}if(this._axes[h].dataInfo.dataPointYNegativeSums){n=
this._axes[h].dataInfo.dataPointYNegativeSums;r=k;for(l in n)n.hasOwnProperty(l)&&!isNaN(l)&&(p=-1*n[l],y(p)||(index=Math.floor((p-t)/c),p<r[index].min&&(r[index].min=p),p>r[index].max&&(r[index].max=p)));delete this._axes[h].dataInfo.dataPointYNegativeSums}for(l=0;l<k.length-1;l++)if(r=k[l].max,isFinite(r))for(;l<k.length-1;)if(t=k[l+1].min,isFinite(t)){p=t-r;p>c&&g.push({diff:p,start:r,end:t});break}else l++;if(this._axes[h].scaleBreaks.customBreaks)for(l=0;l<this._axes[h].scaleBreaks.customBreaks.length;l++)for(c=
0;c<g.length;c++)if(this._axes[h].scaleBreaks.customBreaks[l].startValue<=g[c].start&&g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].endValue||this._axes[h].scaleBreaks.customBreaks[l].startValue<=g[c].start&&g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].endValue||g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].startValue&&this._axes[h].scaleBreaks.customBreaks[l].startValue<=g[c].end||g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].endValue&&this._axes[h].scaleBreaks.customBreaks[l].endValue<=
g[c].end)g.splice(c,1),c--;g.sort(function(a,c){return c.diff-a.diff});for(l=0;l<Math.min(g.length,this._axes[h].scaleBreaks.maxNumberOfAutoBreaks);l++)c=a(g[l].start,g[l].end,this._axes[h].logarithmic?this._axes[h].dataInfo.max/this._axes[h].dataInfo.min:this._axes[h].dataInfo.max-this._axes[h].dataInfo.min,this._axes[h].logarithmic),this._axes[h].scaleBreaks.autoBreaks.push(new ba(this,"autoBreaks",c,l,++this._eventManager.lastObjectId,this._axes[h].scaleBreaks)),this._axes[h].scaleBreaks._appliedBreaks.push(this._axes[h].scaleBreaks.autoBreaks[this._axes[h].scaleBreaks.autoBreaks.length-
1]);this._axes[h].scaleBreaks._appliedBreaks.sort(function(a,c){return a.startValue-c.startValue})}}};q.prototype.getDataPointAtXY=function(a,f,b){b=b||!1;for(var c=[],e=this._dataInRenderedOrder.length-1;0<=e;e--){var g=null;(g=this._dataInRenderedOrder[e].getDataPointAtXY(a,f,b))&&c.push(g)}a=null;f=!1;for(b=0;b<c.length;b++)if("line"===c[b].dataSeries.type||"stepLine"===c[b].dataSeries.type||"area"===c[b].dataSeries.type||"stepArea"===c[b].dataSeries.type)if(e=ja("markerSize",c[b].dataPoint,c[b].dataSeries)||
8,c[b].distance<=e/2){f=!0;break}for(b=0;b<c.length;b++)f&&"line"!==c[b].dataSeries.type&&"stepLine"!==c[b].dataSeries.type&&"area"!==c[b].dataSeries.type&&"stepArea"!==c[b].dataSeries.type||(a?c[b].distance<=a.distance&&(a=c[b]):a=c[b]);return a};q.prototype.getObjectAtXY=function(a,f,b){var c=null;if(b=this.getDataPointAtXY(a,f,b||!1))c=b.dataSeries.dataPointIds[b.dataPointIndex];else if(v)c=Wa(a,f,this._eventManager.ghostCtx);else for(b=0;b<this.legend.items.length;b++){var e=this.legend.items[b];
a>=e.x1&&(a<=e.x2&&f>=e.y1&&f<=e.y2)&&(c=e.id)}return c};q.prototype.getAutoFontSize=function(a,f,b){f=Math.min(this.width,this.height);return Math.max("theme4"===this.theme?0:300<=f?12:10,Math.round(f*(a/400)))};q.prototype.resetOverlayedCanvas=function(){this.overlaidCanvasCtx.clearRect(0,0,this.width,this.height)};q.prototype.clearCanvas=function(){this.ctx.clearRect(0,0,this.width,this.height);this.backgroundColor&&(this.ctx.fillStyle=this.backgroundColor,this.ctx.fillRect(0,0,this.width,this.height))};
q.prototype.attachEvent=function(a){this._events.push(a)};q.prototype._touchEventHandler=function(a){if(a.changedTouches&&this.interactivityEnabled){var f=[],b=a.changedTouches,c=b?b[0]:a,e=null;switch(a.type){case "touchstart":case "MSPointerDown":f=["mousemove","mousedown"];this._lastTouchData=Oa(c);this._lastTouchData.time=new Date;break;case "touchmove":case "MSPointerMove":f=["mousemove"];break;case "touchend":case "MSPointerUp":var g=this._lastTouchData&&this._lastTouchData.time?new Date-this._lastTouchData.time:
0,f="touchstart"===this._lastTouchEventType||"MSPointerDown"===this._lastTouchEventType||300>g?["mouseup","click"]:["mouseup"];break;default:return}if(!(b&&1<b.length)){e=Oa(c);e.time=new Date;try{var h=e.y-this._lastTouchData.y,g=e.time-this._lastTouchData.time;if(15<Math.abs(h)&&(this._lastTouchData.scroll||300>g)){this._lastTouchData.scroll=!0;var l=window.parent||window;l&&l.scrollBy&&l.scrollBy(0,-h)}}catch(t){}this._lastTouchEventType=a.type;if(this._lastTouchData.scroll&&this.zoomEnabled)this.isDrag&&
this.resetOverlayedCanvas(),this.isDrag=!1;else for(b=0;b<f.length;b++)e=f[b],g=document.createEvent("MouseEvent"),g.initMouseEvent(e,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),c.target.dispatchEvent(g),a.preventManipulation&&a.preventManipulation(),a.preventDefault&&a.preventDefault()}}};q.prototype._dispatchRangeEvent=function(a,f){var b={chart:this};b.type=a;b.trigger=f;var c=[];this.axisX&&0<this.axisX.length&&c.push("axisX");this.axisX2&&0<this.axisX2.length&&
c.push("axisX2");this.axisY&&0<this.axisY.length&&c.push("axisY");this.axisY2&&0<this.axisY2.length&&c.push("axisY2");for(var e=0;e<c.length;e++)if(y(b[c[e]])&&(b[c[e]]=[]),"axisY"===c[e])for(var g=0;g<this.axisY.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});else if("axisY2"===c[e])for(g=0;g<this.axisY2.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,
viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});else if("axisX"===c[e])for(g=0;g<this.axisX.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});else if("axisX2"===c[e])for(g=0;g<this.axisX2.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});this.dispatchEvent(a,b,this)};
q.prototype._mouseEventHandler=function(a){"undefined"===typeof a.target&&a.srcElement&&(a.target=a.srcElement);var f=Oa(a),b=a.type,c,e;a.which?e=3==a.which:a.button&&(e=2==a.button);q.capturedEventParam&&(c=q.capturedEventParam,"mouseup"===b&&(q.capturedEventParam=null,c.chart.overlaidCanvas.releaseCapture?c.chart.overlaidCanvas.releaseCapture():document.documentElement.removeEventListener("mouseup",c.chart._mouseEventHandler,!1)),c.hasOwnProperty(b)&&("mouseup"!==b||c.chart.overlaidCanvas.releaseCapture?
a.target!==c.chart.overlaidCanvas&&v||c[b].call(c.context,f.x,f.y):a.target!==c.chart.overlaidCanvas&&(c.chart.isDrag=!1)));if(this.interactivityEnabled)if(this._ignoreNextEvent)this._ignoreNextEvent=!1;else if(a.preventManipulation&&a.preventManipulation(),a.preventDefault&&a.preventDefault(),!e){if(!q.capturedEventParam&&this._events){for(var g=0;g<this._events.length;g++)if(this._events[g].hasOwnProperty(b))if(c=this._events[g],e=c.bounds,f.x>=e.x1&&f.x<=e.x2&&f.y>=e.y1&&f.y<=e.y2){c[b].call(c.context,
f.x,f.y);"mousedown"===b&&!0===c.capture?(q.capturedEventParam=c,this.overlaidCanvas.setCapture?this.overlaidCanvas.setCapture():document.documentElement.addEventListener("mouseup",this._mouseEventHandler,!1)):"mouseup"===b&&(c.chart.overlaidCanvas.releaseCapture?c.chart.overlaidCanvas.releaseCapture():document.documentElement.removeEventListener("mouseup",this._mouseEventHandler,!1));break}else c=null;a.target.style.cursor=c&&c.cursor?c.cursor:this._defaultCursor}b=this.plotArea;if(f.x<b.x1||f.x>
b.x2||f.y<b.y1||f.y>b.y2)this.toolTip&&this.toolTip.enabled?this.toolTip.hide():this.resetOverlayedCanvas();this.isDrag&&this.zoomEnabled||!this._eventManager||this._eventManager.mouseEventHandler(a)}};q.prototype._plotAreaMouseDown=function(a,f){this.isDrag=!0;this.dragStartPoint={x:a,y:f}};q.prototype._plotAreaMouseUp=function(a,f){if(("normal"===this.plotInfo.axisPlacement||"xySwapped"===this.plotInfo.axisPlacement)&&this.isDrag){var b=f-this.dragStartPoint.y,c=a-this.dragStartPoint.x,e=0<=this.zoomType.indexOf("x"),
g=0<=this.zoomType.indexOf("y"),h=!1;this.resetOverlayedCanvas();if("xySwapped"===this.plotInfo.axisPlacement)var l=g,g=e,e=l;if(this.panEnabled||this.zoomEnabled){if(this.panEnabled)for(e=g=0;e<this._axes.length;e++)b=this._axes[e],b.logarithmic?b.viewportMinimum<b.minimum?(g=b.minimum/b.viewportMinimum,b.sessionVariables.newViewportMinimum=b.viewportMinimum*g,b.sessionVariables.newViewportMaximum=b.viewportMaximum*g,h=!0):b.viewportMaximum>b.maximum&&(g=b.viewportMaximum/b.maximum,b.sessionVariables.newViewportMinimum=
b.viewportMinimum/g,b.sessionVariables.newViewportMaximum=b.viewportMaximum/g,h=!0):b.viewportMinimum<b.minimum?(g=b.minimum-b.viewportMinimum,b.sessionVariables.newViewportMinimum=b.viewportMinimum+g,b.sessionVariables.newViewportMaximum=b.viewportMaximum+g,h=!0):b.viewportMaximum>b.maximum&&(g=b.viewportMaximum-b.maximum,b.sessionVariables.newViewportMinimum=b.viewportMinimum-g,b.sessionVariables.newViewportMaximum=b.viewportMaximum-g,h=!0);else if((!e||2<Math.abs(c))&&(!g||2<Math.abs(b))&&this.zoomEnabled){if(!this.dragStartPoint)return;
b=e?this.dragStartPoint.x:this.plotArea.x1;c=g?this.dragStartPoint.y:this.plotArea.y1;e=e?a:this.plotArea.x2;g=g?f:this.plotArea.y2;2<Math.abs(b-e)&&2<Math.abs(c-g)&&this._zoomPanToSelectedRegion(b,c,e,g)&&(h=!0)}h&&(this._ignoreNextEvent=!0,this._dispatchRangeEvent("rangeChanging","zoom"),this.render(),this._dispatchRangeEvent("rangeChanged","zoom"),h&&(this.zoomEnabled&&"none"===this._zoomButton.style.display)&&(Ma(this._zoomButton,this._resetButton),ua(this,this._zoomButton,"pan"),ua(this,this._resetButton,
"reset")))}}this.isDrag=!1;if("none"!==this.plotInfo.axisPlacement){this.resetOverlayedCanvas();if(this.axisX&&0<this.axisX.length)for(h=0;h<this.axisX.length;h++)this.axisX[h].crosshair&&this.axisX[h].crosshair.enabled&&this.axisX[h].renderCrosshair(a,f);if(this.axisX2&&0<this.axisX2.length)for(h=0;h<this.axisX2.length;h++)this.axisX2[h].crosshair&&this.axisX2[h].crosshair.enabled&&this.axisX2[h].renderCrosshair(a,f);if(this.axisY&&0<this.axisY.length)for(h=0;h<this.axisY.length;h++)this.axisY[h].crosshair&&
this.axisY[h].crosshair.enabled&&this.axisY[h].renderCrosshair(a,f);if(this.axisY2&&0<this.axisY2.length)for(h=0;h<this.axisY2.length;h++)this.axisY2[h].crosshair&&this.axisY2[h].crosshair.enabled&&this.axisY2[h].renderCrosshair(a,f)}};q.prototype._plotAreaMouseMove=function(a,f){if(this.isDrag&&"none"!==this.plotInfo.axisPlacement){var b=0,c=0,e=b=null,e=0<=this.zoomType.indexOf("x"),g=0<=this.zoomType.indexOf("y"),h=this;"xySwapped"===this.plotInfo.axisPlacement&&(b=g,g=e,e=b);b=this.dragStartPoint.x-
a;c=this.dragStartPoint.y-f;2<Math.abs(b)&&8>Math.abs(b)&&(this.panEnabled||this.zoomEnabled)?this.toolTip.hide():this.panEnabled||this.zoomEnabled||this.toolTip.mouseMoveHandler(a,f);if((!e||2<Math.abs(b)||!g||2<Math.abs(c))&&(this.panEnabled||this.zoomEnabled))if(this.panEnabled)e={x1:e?this.plotArea.x1+b:this.plotArea.x1,y1:g?this.plotArea.y1+c:this.plotArea.y1,x2:e?this.plotArea.x2+b:this.plotArea.x2,y2:g?this.plotArea.y2+c:this.plotArea.y2},clearTimeout(h._panTimerId),h._panTimerId=setTimeout(function(c,
b,e,d){return function(){h._zoomPanToSelectedRegion(c,b,e,d,!0)&&(h._dispatchRangeEvent("rangeChanging","pan"),h.render(),h._dispatchRangeEvent("rangeChanged","pan"),h.dragStartPoint.x=a,h.dragStartPoint.y=f)}}(e.x1,e.y1,e.x2,e.y2),0);else if(this.zoomEnabled){this.resetOverlayedCanvas();b=this.overlaidCanvasCtx.globalAlpha;this.overlaidCanvasCtx.fillStyle="#A89896";var c=e?this.dragStartPoint.x:this.plotArea.x1,l=g?this.dragStartPoint.y:this.plotArea.y1,t=e?a-this.dragStartPoint.x:this.plotArea.x2-
this.plotArea.x1,k=g?f-this.dragStartPoint.y:this.plotArea.y2-this.plotArea.y1;this.validateRegion(c,l,e?a:this.plotArea.x2-this.plotArea.x1,g?f:this.plotArea.y2-this.plotArea.y1,"xy"!==this.zoomType).isValid&&(this.resetOverlayedCanvas(),this.overlaidCanvasCtx.fillStyle="#99B2B5");this.overlaidCanvasCtx.globalAlpha=0.7;this.overlaidCanvasCtx.fillRect(c,l,t,k);this.overlaidCanvasCtx.globalAlpha=b}}else if(this.toolTip.mouseMoveHandler(a,f),"none"!==this.plotInfo.axisPlacement){if(this.axisX&&0<this.axisX.length)for(e=
0;e<this.axisX.length;e++)this.axisX[e].crosshair&&this.axisX[e].crosshair.enabled&&this.axisX[e].renderCrosshair(a,f);if(this.axisX2&&0<this.axisX2.length)for(e=0;e<this.axisX2.length;e++)this.axisX2[e].crosshair&&this.axisX2[e].crosshair.enabled&&this.axisX2[e].renderCrosshair(a,f);if(this.axisY&&0<this.axisY.length)for(e=0;e<this.axisY.length;e++)this.axisY[e].crosshair&&this.axisY[e].crosshair.enabled&&this.axisY[e].renderCrosshair(a,f);if(this.axisY2&&0<this.axisY2.length)for(e=0;e<this.axisY2.length;e++)this.axisY2[e].crosshair&&
this.axisY2[e].crosshair.enabled&&this.axisY2[e].renderCrosshair(a,f)}};q.prototype._zoomPanToSelectedRegion=function(a,f,b,c,e){a=this.validateRegion(a,f,b,c,e);f=a.axesWithValidRange;b=a.axesRanges;if(a.isValid)for(c=0;c<f.length;c++)e=b[c],f[c].setViewPortRange(e.val1,e.val2);return a.isValid};q.prototype.validateRegion=function(a,f,b,c,e){e=e||!1;for(var g=0<=this.zoomType.indexOf("x"),h=0<=this.zoomType.indexOf("y"),l=!1,t=[],k=[],r=[],p=0;p<this._axes.length;p++)("axisX"===this._axes[p].type&&
g||"axisY"===this._axes[p].type&&h)&&k.push(this._axes[p]);for(h=0;h<k.length;h++){var p=k[h],g=!1,n=p.convertPixelToValue({x:a,y:f}),d=p.convertPixelToValue({x:b,y:c});if(n>d)var w=d,d=n,n=w;if(p.scaleBreaks)for(w=0;!g&&w<p.scaleBreaks._appliedBreaks.length;w++)g=p.scaleBreaks._appliedBreaks[w].startValue<=n&&p.scaleBreaks._appliedBreaks[w].endValue>=d;if(isFinite(p.dataInfo.minDiff))if(w=p.getApparentDifference(n,d,null,!0),!(g||!(this.panEnabled&&p.scaleBreaks&&p.scaleBreaks._appliedBreaks.length)&&
(p.logarithmic&&w<Math.pow(p.dataInfo.minDiff,3)||!p.logarithmic&&w<3*Math.abs(p.dataInfo.minDiff))||n<p.minimum||d>p.maximum))t.push(p),r.push({val1:n,val2:d}),l=!0;else if(!e){l=!1;break}}return{isValid:l,axesWithValidRange:t,axesRanges:r}};q.prototype.preparePlotArea=function(){var a=this.plotArea;!v&&(0<a.x1||0<a.y1)&&a.ctx.translate(a.x1,a.y1);if((this.axisX[0]||this.axisX2[0])&&(this.axisY[0]||this.axisY2[0])){var f=this.axisX[0]?this.axisX[0].lineCoordinates:this.axisX2[0].lineCoordinates;
if(this.axisY&&0<this.axisY.length&&this.axisY[0]){var b=this.axisY[0];a.x1=f.x1<f.x2?f.x1:b.lineCoordinates.x1;a.y1=f.y1<b.lineCoordinates.y1?f.y1:b.lineCoordinates.y1;a.x2=f.x2>b.lineCoordinates.x2?f.x2:b.lineCoordinates.x2;a.y2=f.y2>f.y1?f.y2:b.lineCoordinates.y2;a.width=a.x2-a.x1;a.height=a.y2-a.y1}this.axisY2&&0<this.axisY2.length&&this.axisY2[0]&&(b=this.axisY2[0],a.x1=f.x1<f.x2?f.x1:b.lineCoordinates.x1,a.y1=f.y1<b.lineCoordinates.y1?f.y1:b.lineCoordinates.y1,a.x2=f.x2>b.lineCoordinates.x2?
f.x2:b.lineCoordinates.x2,a.y2=f.y2>f.y1?f.y2:b.lineCoordinates.y2,a.width=a.x2-a.x1,a.height=a.y2-a.y1)}else f=this.layoutManager.getFreeSpace(),a.x1=f.x1,a.x2=f.x2,a.y1=f.y1,a.y2=f.y2,a.width=f.width,a.height=f.height;v||(a.canvas.width=a.width,a.canvas.height=a.height,a.canvas.style.left=a.x1+"px",a.canvas.style.top=a.y1+"px",(0<a.x1||0<a.y1)&&a.ctx.translate(-a.x1,-a.y1));a.layoutManager=new Da(a.x1,a.y1,a.x2,a.y2,2)};q.prototype.renderIndexLabels=function(a){var f=a||this.plotArea.ctx,b=this.plotArea,
c=0,e=0,g=0,h=0,l=c=h=e=g=0,t=0;for(a=0;a<this._indexLabels.length;a++){var k=this._indexLabels[a],r=k.chartType.toLowerCase(),p,n,l=ja("indexLabelFontColor",k.dataPoint,k.dataSeries),t=ja("indexLabelFontSize",k.dataPoint,k.dataSeries);p=ja("indexLabelFontFamily",k.dataPoint,k.dataSeries);n=ja("indexLabelFontStyle",k.dataPoint,k.dataSeries);var h=ja("indexLabelFontWeight",k.dataPoint,k.dataSeries),d=ja("indexLabelBackgroundColor",k.dataPoint,k.dataSeries),e=ja("indexLabelMaxWidth",k.dataPoint,k.dataSeries),
g=ja("indexLabelWrap",k.dataPoint,k.dataSeries),w=ja("indexLabelLineDashType",k.dataPoint,k.dataSeries),m=ja("indexLabelLineColor",k.dataPoint,k.dataSeries),D=y(k.dataPoint.indexLabelLineThickness)?y(k.dataSeries.options.indexLabelLineThickness)?0:k.dataSeries.options.indexLabelLineThickness:k.dataPoint.indexLabelLineThickness,c=0<D?Math.min(10,("normal"===this.plotInfo.axisPlacement?this.plotArea.height:this.plotArea.width)<<0):0,u={percent:null,total:null},Q=null;if(0<=k.dataSeries.type.indexOf("stacked")||
"pie"===k.dataSeries.type||"doughnut"===k.dataSeries.type)u=this.getPercentAndTotal(k.dataSeries,k.dataPoint);if(k.dataSeries.indexLabelFormatter||k.dataPoint.indexLabelFormatter)Q={chart:this,dataSeries:k.dataSeries,dataPoint:k.dataPoint,index:k.indexKeyword,total:u.total,percent:u.percent};var H=k.dataPoint.indexLabelFormatter?k.dataPoint.indexLabelFormatter(Q):k.dataPoint.indexLabel?this.replaceKeywordsWithValue(k.dataPoint.indexLabel,k.dataPoint,k.dataSeries,null,k.indexKeyword):k.dataSeries.indexLabelFormatter?
k.dataSeries.indexLabelFormatter(Q):k.dataSeries.indexLabel?this.replaceKeywordsWithValue(k.dataSeries.indexLabel,k.dataPoint,k.dataSeries,null,k.indexKeyword):null;if(null!==H&&""!==H){var u=ja("indexLabelPlacement",k.dataPoint,k.dataSeries),Q=ja("indexLabelOrientation",k.dataPoint,k.dataSeries),q=k.direction,s=k.dataSeries.axisX,A=k.dataSeries.axisY,x=!1,d=new ka(f,{x:0,y:0,maxWidth:e?e:0.5*this.width,maxHeight:g?5*t:1.5*t,angle:"horizontal"===Q?0:-90,text:H,padding:0,backgroundColor:d,horizontalAlign:"left",
fontSize:t,fontFamily:p,fontWeight:h,fontColor:l,fontStyle:n,textBaseline:"top"});d.measureText();k.dataSeries.indexLabelMaxWidth=d.maxWidth;if("stackedarea100"===r){if(k.point.x<b.x1||k.point.x>b.x2||k.point.y<b.y1-1||k.point.y>b.y2+1)continue}else if("rangearea"===r||"rangesplinearea"===r){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||Math.max.apply(null,k.dataPoint.y)<A.viewportMinimum||Math.min.apply(null,k.dataPoint.y)>A.viewportMaximum)continue}else if(0<=r.indexOf("line")||
0<=r.indexOf("area")||0<=r.indexOf("bubble")||0<=r.indexOf("scatter")){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||k.dataPoint.y<A.viewportMinimum||k.dataPoint.y>A.viewportMaximum)continue}else if(0<=r.indexOf("column")||"waterfall"===r||"error"===r&&!k.axisSwapped){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||k.bounds.y1>b.y2||k.bounds.y2<b.y1)continue}else if(0<=r.indexOf("bar")||"error"===r){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||
k.bounds.x1>b.x2||k.bounds.x2<b.x1)continue}else if("candlestick"===r||"ohlc"===r){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||Math.max.apply(null,k.dataPoint.y)<A.viewportMinimum||Math.min.apply(null,k.dataPoint.y)>A.viewportMaximum)continue}else if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum)continue;e=h=2;"horizontal"===Q?(l=d.width,t=d.height):(t=d.width,l=d.height);if("normal"===this.plotInfo.axisPlacement){if(0<=r.indexOf("line")||0<=r.indexOf("area"))u=
"auto",h=4;else if(0<=r.indexOf("stacked"))"auto"===u&&(u="inside");else if("bubble"===r||"scatter"===r)u="inside";p=k.point.x-l/2;"inside"!==u?(e=b.y1,g=b.y2,0<q?(n=k.point.y-t-h-c,n<e&&(n="auto"===u?Math.max(k.point.y,e)+h+c:e+h+c,x=n+t>k.point.y)):(n=k.point.y+h+c,n>g-t-h-c&&(n="auto"===u?Math.min(k.point.y,g)-t-h-c:g-t-h-c,x=n<k.point.y))):(e=Math.max(k.bounds.y1,b.y1),g=Math.min(k.bounds.y2,b.y2),c=0<=r.indexOf("range")||"error"===r?0<q?Math.max(k.bounds.y1,b.y1)+t/2+h:Math.min(k.bounds.y2,b.y2)-
t/2-h:(Math.max(k.bounds.y1,b.y1)+Math.min(k.bounds.y2,b.y2))/2,0<q?(n=Math.max(k.point.y,c)-t/2,n<e&&("bubble"===r||"scatter"===r)&&(n=Math.max(k.point.y-t-h,b.y1+h))):(n=Math.min(k.point.y,c)-t/2,n>g-t-h&&("bubble"===r||"scatter"===r)&&(n=Math.min(k.point.y+h,b.y2-t-h))),n=Math.min(n,g-t))}else 0<=r.indexOf("line")||0<=r.indexOf("area")||0<=r.indexOf("scatter")?(u="auto",e=4):0<=r.indexOf("stacked")?"auto"===u&&(u="inside"):"bubble"===r&&(u="inside"),n=k.point.y-t/2,"inside"!==u?(h=b.x1,g=b.x2,
0>q?(p=k.point.x-l-e-c,p<h&&(p="auto"===u?Math.max(k.point.x,h)+e+c:h+e+c,x=p+l>k.point.x)):(p=k.point.x+e+c,p>g-l-e-c&&(p="auto"===u?Math.min(k.point.x,g)-l-e-c:g-l-e-c,x=p<k.point.x))):(h=Math.max(k.bounds.x1,b.x1),Math.min(k.bounds.x2,b.x2),c=0<=r.indexOf("range")||"error"===r?0>q?Math.max(k.bounds.x1,b.x1)+l/2+e:Math.min(k.bounds.x2,b.x2)-l/2-e:(Math.max(k.bounds.x1,b.x1)+Math.min(k.bounds.x2,b.x2))/2,p=0>q?Math.max(k.point.x,c)-l/2:Math.min(k.point.x,c)-l/2,p=Math.max(p,h));"vertical"===Q&&(n+=
t);d.x=p;d.y=n;d.render(!0);D&&("inside"!==u&&(0>r.indexOf("bar")&&("error"!==r||!k.axisSwapped)&&k.point.x>b.x1&&k.point.x<b.x2||!x)&&(0>r.indexOf("column")&&("error"!==r||k.axisSwapped)&&k.point.y>b.y1&&k.point.y<b.y2||!x))&&(f.lineWidth=D,f.strokeStyle=m?m:"gray",f.setLineDash&&f.setLineDash(F(w,D)),f.beginPath(),f.moveTo(k.point.x,k.point.y),0<=r.indexOf("bar")||"error"===r&&k.axisSwapped?f.lineTo(p+(0<k.direction?0:l),n+("horizontal"===Q?t:-t)/2):0<=r.indexOf("column")||"error"===r&&!k.axisSwapped?
f.lineTo(p+l/2,n+((0<k.direction?t:-t)+("horizontal"===Q?t:-t))/2):f.lineTo(p+l/2,n+((n<k.point.y?t:-t)+("horizontal"===Q?t:-t))/2),f.stroke())}}f={source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0,startTimePercent:0.7};for(a=0;a<this._indexLabels.length;a++)k=this._indexLabels[a],d=ja("indexLabelBackgroundColor",k.dataPoint,k.dataSeries),k.dataSeries.indexLabelBackgroundColor=y(d)?v?"transparent":null:d;return f};q.prototype.renderLine=
function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this._eventManager.ghostCtx;b.save();var e=this.plotArea;b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();for(var g=[],h,l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t];b.lineWidth=k.lineThickness;var r=k.dataPoints,p="solid";if(b.setLineDash){var n=F(k.nullDataLineDashType,k.lineThickness),p=k.lineDashType,d=F(p,k.lineThickness);b.setLineDash(d)}var w=
k.id;this._eventManager.objectMap[w]={objectType:"dataSeries",dataSeriesIndex:t};w=R(w);c.strokeStyle=w;c.lineWidth=0<k.lineThickness?Math.max(k.lineThickness,4):0;var w=k._colorSet,m=w=k.lineColor=k.options.lineColor?k.options.lineColor:w[0];b.strokeStyle=w;var D=!0,u=0,Q,H;b.beginPath();if(0<r.length){for(var q=!1,u=0;u<r.length;u++)if(Q=r[u].x.getTime?r[u].x.getTime():r[u].x,!(Q<a.axisX.dataInfo.viewPortMin||Q>a.axisX.dataInfo.viewPortMax&&(!k.connectNullData||!q)))if("number"!==typeof r[u].y)0<
u&&!(k.connectNullData||q||D)&&(b.stroke(),v&&c.stroke()),q=!0;else{Q=a.axisX.convertValueToPixel(Q);H=a.axisY.convertValueToPixel(r[u].y);var s=k.dataPointIds[u];this._eventManager.objectMap[s]={id:s,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:u,x1:Q,y1:H};D||q?(!D&&k.connectNullData?(b.setLineDash&&(k.options.nullDataLineDashType||p===k.lineDashType&&k.lineDashType!==k.nullDataLineDashType)&&(b.stroke(),b.beginPath(),b.moveTo(h.x,h.y),p=k.nullDataLineDashType,b.setLineDash(n)),b.lineTo(Q,
H),v&&c.lineTo(Q,H)):(b.beginPath(),b.moveTo(Q,H),v&&(c.beginPath(),c.moveTo(Q,H))),q=D=!1):(b.lineTo(Q,H),v&&c.lineTo(Q,H),0==u%500&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),v&&(c.stroke(),c.beginPath(),c.moveTo(Q,H))));h={x:Q,y:H};u<r.length-1&&(m!==(r[u].lineColor||w)||p!==(r[u].lineDashType||k.lineDashType))&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),m=r[u].lineColor||w,b.strokeStyle=m,b.setLineDash&&(r[u].lineDashType?(p=r[u].lineDashType,b.setLineDash(F(p,k.lineThickness))):(p=k.lineDashType,b.setLineDash(d))));
if(0<r[u].markerSize||0<k.markerSize){var A=k.getMarkerProperties(u,Q,H,b);g.push(A);s=R(s);v&&g.push({x:Q,y:H,ctx:c,type:A.type,size:A.size,color:s,borderColor:s,borderThickness:A.borderThickness})}(r[u].indexLabel||k.indexLabel||r[u].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"line",dataPoint:r[u],dataSeries:k,point:{x:Q,y:H},direction:0>r[u].y===a.axisY.reversed?1:-1,color:w})}b.stroke();v&&c.stroke()}}$.drawMarkers(g);v&&(f.drawImage(this._preRenderCanvas,0,
0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),c.beginPath());b.restore();b.beginPath();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,
animationBase:0}}};q.prototype.renderStepLine=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this._eventManager.ghostCtx;b.save();var e=this.plotArea;b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();for(var g=[],h,l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t];b.lineWidth=k.lineThickness;var r=k.dataPoints,p="solid";if(b.setLineDash){var n=F(k.nullDataLineDashType,k.lineThickness),
p=k.lineDashType,d=F(p,k.lineThickness);b.setLineDash(d)}var w=k.id;this._eventManager.objectMap[w]={objectType:"dataSeries",dataSeriesIndex:t};w=R(w);c.strokeStyle=w;c.lineWidth=0<k.lineThickness?Math.max(k.lineThickness,4):0;var w=k._colorSet,m=w=k.lineColor=k.options.lineColor?k.options.lineColor:w[0];b.strokeStyle=w;var D=!0,u=0,Q,H;b.beginPath();if(0<r.length){for(var q=!1,u=0;u<r.length;u++)if(Q=r[u].getTime?r[u].x.getTime():r[u].x,!(Q<a.axisX.dataInfo.viewPortMin||Q>a.axisX.dataInfo.viewPortMax&&
(!k.connectNullData||!q)))if("number"!==typeof r[u].y)0<u&&!(k.connectNullData||q||D)&&(b.stroke(),v&&c.stroke()),q=!0;else{var s=H;Q=a.axisX.convertValueToPixel(Q);H=a.axisY.convertValueToPixel(r[u].y);var A=k.dataPointIds[u];this._eventManager.objectMap[A]={id:A,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:u,x1:Q,y1:H};D||q?(!D&&k.connectNullData?(b.setLineDash&&(k.options.nullDataLineDashType||p===k.lineDashType&&k.lineDashType!==k.nullDataLineDashType)&&(b.stroke(),b.beginPath(),b.moveTo(h.x,
h.y),p=k.nullDataLineDashType,b.setLineDash(n)),b.lineTo(Q,s),b.lineTo(Q,H),v&&(c.lineTo(Q,s),c.lineTo(Q,H))):(b.beginPath(),b.moveTo(Q,H),v&&(c.beginPath(),c.moveTo(Q,H))),q=D=!1):(b.lineTo(Q,s),v&&c.lineTo(Q,s),b.lineTo(Q,H),v&&c.lineTo(Q,H),0==u%500&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),v&&(c.stroke(),c.beginPath(),c.moveTo(Q,H))));h={x:Q,y:H};u<r.length-1&&(m!==(r[u].lineColor||w)||p!==(r[u].lineDashType||k.lineDashType))&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),m=r[u].lineColor||w,b.strokeStyle=
m,b.setLineDash&&(r[u].lineDashType?(p=r[u].lineDashType,b.setLineDash(F(p,k.lineThickness))):(p=k.lineDashType,b.setLineDash(d))));if(0<r[u].markerSize||0<k.markerSize)s=k.getMarkerProperties(u,Q,H,b),g.push(s),A=R(A),v&&g.push({x:Q,y:H,ctx:c,type:s.type,size:s.size,color:A,borderColor:A,borderThickness:s.borderThickness});(r[u].indexLabel||k.indexLabel||r[u].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"stepLine",dataPoint:r[u],dataSeries:k,point:{x:Q,y:H},direction:0>
r[u].y===a.axisY.reversed?1:-1,color:w})}b.stroke();v&&c.stroke()}}$.drawMarkers(g);v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),c.beginPath());
b.restore();b.beginPath();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderSpline=function(a){function f(a){a=x(a,2);if(0<a.length){c.beginPath();v&&e.beginPath();c.moveTo(a[0].x,a[0].y);a[0].newStrokeStyle&&(c.strokeStyle=a[0].newStrokeStyle);a[0].newLineDashArray&&c.setLineDash(a[0].newLineDashArray);v&&e.moveTo(a[0].x,a[0].y);for(var b=0;b<a.length-3;b+=3)if(c.bezierCurveTo(a[b+1].x,a[b+1].y,a[b+2].x,a[b+
2].y,a[b+3].x,a[b+3].y),v&&e.bezierCurveTo(a[b+1].x,a[b+1].y,a[b+2].x,a[b+2].y,a[b+3].x,a[b+3].y),0<b&&0===b%3E3||a[b+3].newStrokeStyle||a[b+3].newLineDashArray)c.stroke(),c.beginPath(),c.moveTo(a[b+3].x,a[b+3].y),a[b+3].newStrokeStyle&&(c.strokeStyle=a[b+3].newStrokeStyle),a[b+3].newLineDashArray&&c.setLineDash(a[b+3].newLineDashArray),v&&(e.stroke(),e.beginPath(),e.moveTo(a[b+3].x,a[b+3].y));c.stroke();v&&e.stroke()}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=
this._eventManager.ghostCtx;c.save();var g=this.plotArea;c.beginPath();c.rect(g.x1,g.y1,g.width,g.height);c.clip();for(var h=[],l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t];c.lineWidth=k.lineThickness;var r=k.dataPoints,p="solid";if(c.setLineDash){var n=F(k.nullDataLineDashType,k.lineThickness),p=k.lineDashType,d=F(p,k.lineThickness);c.setLineDash(d)}var w=k.id;this._eventManager.objectMap[w]={objectType:"dataSeries",dataSeriesIndex:t};w=R(w);e.strokeStyle=w;e.lineWidth=
0<k.lineThickness?Math.max(k.lineThickness,4):0;var w=k._colorSet,m=w=k.lineColor=k.options.lineColor?k.options.lineColor:w[0];c.strokeStyle=w;var D=0,u,Q,H=[];c.beginPath();if(0<r.length)for(Q=!1,D=0;D<r.length;D++)if(u=r[D].getTime?r[D].x.getTime():r[D].x,!(u<a.axisX.dataInfo.viewPortMin||u>a.axisX.dataInfo.viewPortMax&&(!k.connectNullData||!Q)))if("number"!==typeof r[D].y)0<D&&!Q&&(k.connectNullData?c.setLineDash&&(0<H.length&&(k.options.nullDataLineDashType||!r[D-1].lineDashType))&&(H[H.length-
1].newLineDashArray=n,p=k.nullDataLineDashType):(f(H),H=[])),Q=!0;else{u=a.axisX.convertValueToPixel(u);Q=a.axisY.convertValueToPixel(r[D].y);var s=k.dataPointIds[D];this._eventManager.objectMap[s]={id:s,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:D,x1:u,y1:Q};H[H.length]={x:u,y:Q};D<r.length-1&&(m!==(r[D].lineColor||w)||p!==(r[D].lineDashType||k.lineDashType))&&(m=r[D].lineColor||w,H[H.length-1].newStrokeStyle=m,c.setLineDash&&(r[D].lineDashType?(p=r[D].lineDashType,H[H.length-1].newLineDashArray=
F(p,k.lineThickness)):(p=k.lineDashType,H[H.length-1].newLineDashArray=d)));if(0<r[D].markerSize||0<k.markerSize){var q=k.getMarkerProperties(D,u,Q,c);h.push(q);s=R(s);v&&h.push({x:u,y:Q,ctx:e,type:q.type,size:q.size,color:s,borderColor:s,borderThickness:q.borderThickness})}(r[D].indexLabel||k.indexLabel||r[D].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"spline",dataPoint:r[D],dataSeries:k,point:{x:u,y:Q},direction:0>r[D].y===a.axisY.reversed?1:-1,color:w});Q=!1}f(H)}$.drawMarkers(h);
v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(g.x1,g.y1,g.width,g.height),e.beginPath());c.restore();c.beginPath();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,
easingFunction:O.easing.linear,animationBase:0}}};var X=function(a,f,b,c,e,g,h,l,t,k,r,p,n){"undefined"===typeof n&&(n=1);h=h||0;l=l||"black";var d=15<c-f&&15<e-b?8:0.35*Math.min(c-f,e-b);a.beginPath();a.moveTo(f,b);a.save();a.fillStyle=g;a.globalAlpha=n;a.fillRect(f,b,c-f,e-b);a.globalAlpha=1;0<h&&(n=0===h%2?0:0.5,a.beginPath(),a.lineWidth=h,a.strokeStyle=l,a.moveTo(f,b),a.rect(f-n,b-n,c-f+2*n,e-b+2*n),a.stroke());a.restore();!0===t&&(a.save(),a.beginPath(),a.moveTo(f,b),a.lineTo(f+d,b+d),a.lineTo(c-
d,b+d),a.lineTo(c,b),a.closePath(),h=a.createLinearGradient((c+f)/2,b+d,(c+f)/2,b),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, .4)"),a.fillStyle=h,a.fill(),a.restore());!0===k&&(a.save(),a.beginPath(),a.moveTo(f,e),a.lineTo(f+d,e-d),a.lineTo(c-d,e-d),a.lineTo(c,e),a.closePath(),h=a.createLinearGradient((c+f)/2,e-d,(c+f)/2,e),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, .4)"),a.fillStyle=h,a.fill(),a.restore());!0===r&&(a.save(),a.beginPath(),a.moveTo(f,b),a.lineTo(f+d,b+
d),a.lineTo(f+d,e-d),a.lineTo(f,e),a.closePath(),h=a.createLinearGradient(f+d,(e+b)/2,f,(e+b)/2),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, 0.1)"),a.fillStyle=h,a.fill(),a.restore());!0===p&&(a.save(),a.beginPath(),a.moveTo(c,b),a.lineTo(c-d,b+d),a.lineTo(c-d,e-d),a.lineTo(c,e),h=a.createLinearGradient(c-d,(e+b)/2,c,(e+b)/2),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, 0.1)"),a.fillStyle=h,h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, 0.1)"),a.fillStyle=h,a.fill(),
a.closePath(),a.restore())};q.prototype.renderColumn=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=0,h,l,t,k=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*
this.width,0.9*(this.plotArea.width/a.plotType.totalDataSeries))<<0,p=a.axisX.dataInfo.minDiff;isFinite(p)||(p=0.3*Math.abs(a.axisX.range));p=this.dataPointWidth=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(p)/Math.log(a.axisX.range):Math.abs(p)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>r&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<
g)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));p<g&&(p=g);p>r&&(p=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(r=0;r<a.dataSeriesIndexes.length;r++){var n=a.dataSeriesIndexes[r],d=this.data[n],w=d.dataPoints;if(0<w.length)for(var m=5<p&&d.bevelEnabled?!0:!1,g=0;g<
w.length;g++)if(w[g].getTime?t=w[g].x.getTime():t=w[g].x,!(t<a.axisX.dataInfo.viewPortMin||t>a.axisX.dataInfo.viewPortMax)&&"number"===typeof w[g].y){h=a.axisX.convertValueToPixel(t);l=a.axisY.convertValueToPixel(w[g].y);h=a.axisX.reversed?h+a.plotType.totalDataSeries*p/2-(a.previousDataSeriesCount+r)*p<<0:h-a.plotType.totalDataSeries*p/2+(a.previousDataSeriesCount+r)*p<<0;var D=a.axisX.reversed?h-p<<0:h+p<<0,u;0<=w[g].y?u=k:(u=l,l=k);l>u&&(c=l,l=u,u=c);c=w[g].color?w[g].color:d._colorSet[g%d._colorSet.length];
X(b,h,l,D,u,c,0,null,m&&0<=w[g].y,0>w[g].y&&m,!1,!1,d.fillOpacity);c=d.dataPointIds[g];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:n,dataPointIndex:g,x1:h,y1:l,x2:D,y2:u};c=R(c);v&&X(this._eventManager.ghostCtx,h,l,D,u,c,0,null,!1,!1,!1,!1);(w[g].indexLabel||d.indexLabel||w[g].indexLabelFormatter||d.indexLabelFormatter)&&this._indexLabels.push({chartType:"column",dataPoint:w[g],dataSeries:d,point:{x:h+(D-h)/2,y:0>w[g].y===a.axisY.reversed?l:u},direction:0>w[g].y===
a.axisY.reversed?1:-1,bounds:{x1:h,y1:Math.min(l,u),x2:D,y2:Math.max(l,u)},color:c})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.yScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:k<a.axisY.bounds.y1?a.axisY.bounds.y1:k>a.axisY.bounds.y2?a.axisY.bounds.y2:k}}};q.prototype.renderStackedColumn=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),k=
this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.width<<0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&
k>r&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<k)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<k&&(d=k);d>r&&(d=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=
a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length){var Q=5<d&&D.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===typeof u[k].y){r=a.axisX.convertValueToPixel(c);var H=r-a.plotType.plotUnits.length*d/2+a.index*d<<0,s=H+d<<0,q;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0<u[k].y)l[c]=u[k].y+(l[c]?l[c]:
0),0<l[c]&&(p=a.axisY.convertValueToPixel(l[c]),q="undefined"!==typeof g[c]?g[c]:n,g[c]=p);else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=u[k].y+(t[c]?t[c]:0),q=a.axisY.convertValueToPixel(t[c]),p="undefined"!==typeof h[c]?h[c]:n,h[c]=q;else if(p=a.axisY.convertValueToPixel(u[k].y),0<=u[k].y){var y="undefined"!==typeof g[c]?g[c]:0;p-=y;q=n-y;g[c]=y+(q-p)}else y=h[c]?h[c]:0,q=p+y,p=n+y,h[c]=y+(q-p);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];
X(b,H,p,s,q,c,0,null,Q&&0<=u[k].y,0>u[k].y&&Q,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:H,y1:p,x2:s,y2:q};c=R(c);v&&X(this._eventManager.ghostCtx,H,p,s,q,c,0,null,!1,!1,!1,!1);(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedColumn",dataPoint:u[k],dataSeries:D,point:{x:r,y:0<=u[k].y?p:q},direction:0>u[k].y===a.axisY.reversed?1:
-1,bounds:{x1:H,y1:Math.min(p,q),x2:s,y2:Math.max(p,q)},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.yScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.y1?a.axisY.bounds.y1:n>a.axisY.bounds.y2?a.axisY.bounds.y2:n}}};q.prototype.renderStackedColumn100=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),
k=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.width<<0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&
k>r&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<k)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<k&&(d=k);d>r&&(d=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=
a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length)for(var Q=5<d&&D.bevelEnabled?!0:!1,k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===typeof u[k].y){r=a.axisX.convertValueToPixel(c);p=0!==a.dataPointYSums[c]?100*(u[k].y/a.dataPointYSums[c]):0;var q=r-a.plotType.plotUnits.length*d/2+a.index*d<<0,s=q+d<<0,y;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&
0<u[k].y){l[c]=p+("undefined"!==typeof l[c]?l[c]:0);if(0>=l[c])continue;p=a.axisY.convertValueToPixel(l[c]);y=g[c]?g[c]:n;g[c]=p}else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=p+("undefined"!==typeof t[c]?t[c]:0),y=a.axisY.convertValueToPixel(t[c]),p=h[c]?h[c]:n,h[c]=y;else if(p=a.axisY.convertValueToPixel(p),0<=u[k].y){var A="undefined"!==typeof g[c]?g[c]:0;p-=A;y=n-A;a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.y1-p)&&(p=e.y1);g[c]=A+(y-p)}else A="undefined"!==
typeof h[c]?h[c]:0,y=p+A,p=n+A,a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.y2-y)&&(y=e.y2),h[c]=A+(y-p);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];X(b,q,p,s,y,c,0,null,Q&&0<=u[k].y,0>u[k].y&&Q,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:q,y1:p,x2:s,y2:y};c=R(c);v&&X(this._eventManager.ghostCtx,q,p,s,y,c,0,null,!1,!1,!1,!1);(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&
this._indexLabels.push({chartType:"stackedColumn100",dataPoint:u[k],dataSeries:D,point:{x:r,y:0<=u[k].y?p:y},direction:0>u[k].y===a.axisY.reversed?1:-1,bounds:{x1:q,y1:Math.min(p,y),x2:s,y2:Math.max(p,y)},color:c})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&
this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.yScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.y1?a.axisY.bounds.y1:n>a.axisY.bounds.y2?a.axisY.bounds.y2:n}}};q.prototype.renderBar=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=
null,e=this.plotArea,g=0,h,l,t,k=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*this.height,0.9*(this.plotArea.height/a.plotType.totalDataSeries))<<0,p=a.axisX.dataInfo.minDiff;isFinite(p)||(p=0.3*Math.abs(a.axisX.range));p=this.options.dataPointWidth?
this.dataPointWidth:0.9*(e.height*(a.axisX.logarithmic?Math.log(p)/Math.log(a.axisX.range):Math.abs(p)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>r&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<g)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));p<g&&(p=g);p>r&&(p=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);
b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(r=0;r<a.dataSeriesIndexes.length;r++){var n=a.dataSeriesIndexes[r],d=this.data[n],w=d.dataPoints;if(0<w.length){var m=5<p&&d.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(g=0;g<w.length;g++)if(w[g].getTime?t=w[g].x.getTime():t=w[g].x,!(t<a.axisX.dataInfo.viewPortMin||t>a.axisX.dataInfo.viewPortMax)&&"number"===typeof w[g].y){l=a.axisX.convertValueToPixel(t);
h=a.axisY.convertValueToPixel(w[g].y);l=a.axisX.reversed?l+a.plotType.totalDataSeries*p/2-(a.previousDataSeriesCount+r)*p<<0:l-a.plotType.totalDataSeries*p/2+(a.previousDataSeriesCount+r)*p<<0;var D=a.axisX.reversed?l-p<<0:l+p<<0,u;0<=w[g].y?u=k:(u=h,h=k);c=w[g].color?w[g].color:d._colorSet[g%d._colorSet.length];X(b,u,l,h,D,c,0,null,m,!1,!1,!1,d.fillOpacity);c=d.dataPointIds[g];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:n,dataPointIndex:g,x1:u,y1:l,x2:h,y2:D};c=R(c);
v&&X(this._eventManager.ghostCtx,u,l,h,D,c,0,null,!1,!1,!1,!1);(w[g].indexLabel||d.indexLabel||w[g].indexLabelFormatter||d.indexLabelFormatter)&&this._indexLabels.push({chartType:"bar",dataPoint:w[g],dataSeries:d,point:{x:0<=w[g].y?h:u,y:l+(D-l)/2},direction:0>w[g].y===a.axisY.reversed?1:-1,bounds:{x1:Math.min(u,h),y1:l,x2:Math.max(u,h),y2:D},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,
0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:k<a.axisY.bounds.x1?a.axisY.bounds.x1:k>a.axisY.bounds.x2?a.axisY.bounds.x2:
k}}};q.prototype.renderStackedBar=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),k=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;p=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.height<<
0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.height*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&k>p&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,p));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&p<k)&&(p=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<
k&&(d=k);d>p&&(d=p);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length){var q=5<d&&D.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():
u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===typeof u[k].y){p=a.axisX.convertValueToPixel(c);var s=p-a.plotType.plotUnits.length*d/2+a.index*d<<0,y=s+d<<0,B;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0<u[k].y)l[c]=u[k].y+(l[c]?l[c]:0),0<l[c]&&(B=g[c]?g[c]:n,g[c]=r=a.axisY.convertValueToPixel(l[c]));else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=u[k].y+(t[c]?t[c]:0),r=h[c]?
h[c]:n,h[c]=B=a.axisY.convertValueToPixel(t[c]);else if(r=a.axisY.convertValueToPixel(u[k].y),0<=u[k].y){var A=g[c]?g[c]:0;B=n+A;r+=A;g[c]=A+(r-B)}else A=h[c]?h[c]:0,B=r-A,r=n-A,h[c]=A+(r-B);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];X(b,B,s,r,y,c,0,null,q,!1,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:B,y1:s,x2:r,y2:y};c=R(c);v&&X(this._eventManager.ghostCtx,B,s,r,y,c,0,null,!1,!1,!1,!1);
(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedBar",dataPoint:u[k],dataSeries:D,point:{x:0<=u[k].y?r:B,y:p},direction:0>u[k].y===a.axisY.reversed?1:-1,bounds:{x1:Math.min(B,r),y1:s,x2:Math.max(B,r),y2:y},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,
0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.x1?a.axisY.bounds.x1:n>a.axisY.bounds.x2?a.axisY.bounds.x2:n}}};q.prototype.renderStackedBar100=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,
b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),k=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;p=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.height<<0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=
this.options.dataPointWidth?this.dataPointWidth:0.9*(e.height*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&k>p&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,p));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&p<k)&&(p=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<k&&(d=k);d>p&&(d=p);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();
b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length){var q=5<d&&D.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===
typeof u[k].y){p=a.axisX.convertValueToPixel(c);var s;s=0!==a.dataPointYSums[c]?100*(u[k].y/a.dataPointYSums[c]):0;var y=p-a.plotType.plotUnits.length*d/2+a.index*d<<0,B=y+d<<0;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0<u[k].y){l[c]=s+(l[c]?l[c]:0);if(0>=l[c])continue;s=g[c]?g[c]:n;g[c]=r=a.axisY.convertValueToPixel(l[c])}else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=s+(t[c]?t[c]:0),r=h[c]?h[c]:n,h[c]=s=a.axisY.convertValueToPixel(t[c]);
else if(r=a.axisY.convertValueToPixel(s),0<=u[k].y){var A=g[c]?g[c]:0;s=n+A;r+=A;a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.x2-r)&&(r=e.x2);g[c]=A+(r-s)}else A=h[c]?h[c]:0,s=r-A,r=n-A,a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.x1-s)&&(s=e.x1),h[c]=A+(r-s);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];X(b,s,y,r,B,c,0,null,q,!1,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:s,y1:y,x2:r,
y2:B};c=R(c);v&&X(this._eventManager.ghostCtx,s,y,r,B,c,0,null,!1,!1,!1,!1);(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedBar100",dataPoint:u[k],dataSeries:D,point:{x:0<=u[k].y?r:s,y:p},direction:0>u[k].y===a.axisY.reversed?1:-1,bounds:{x1:Math.min(s,r),y1:y,x2:Math.max(s,r),y2:B},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,
0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.x1?a.axisY.bounds.x1:n>a.axisY.bounds.x2?a.axisY.bounds.x2:
n}}};q.prototype.renderArea=function(a){var f,b;function c(){A&&(0<w.lineThickness&&g.stroke(),a.axisY.logarithmic||0>=a.axisY.viewportMinimum&&0<=a.axisY.viewportMaximum?B=y:0>a.axisY.viewportMaximum?B=t.y1:0<a.axisY.viewportMinimum&&(B=l.y2),g.lineTo(u,B),g.lineTo(A.x,B),g.closePath(),g.globalAlpha=w.fillOpacity,g.fill(),g.globalAlpha=1,v&&(h.lineTo(u,B),h.lineTo(A.x,B),h.closePath(),h.fill()),g.beginPath(),g.moveTo(u,s),h.beginPath(),h.moveTo(u,s),A={x:u,y:s})}var e=a.targetCanvasCtx||this.plotArea.ctx,
g=v?this._preRenderCtx:e;if(!(0>=a.dataSeriesIndexes.length)){var h=this._eventManager.ghostCtx,l=a.axisX.lineCoordinates,t=a.axisY.lineCoordinates,k=[],r=this.plotArea,p;g.save();v&&h.save();g.beginPath();g.rect(r.x1,r.y1,r.width,r.height);g.clip();v&&(h.beginPath(),h.rect(r.x1,r.y1,r.width,r.height),h.clip());for(var n=0;n<a.dataSeriesIndexes.length;n++){var d=a.dataSeriesIndexes[n],w=this.data[d],m=w.dataPoints,k=w.id;this._eventManager.objectMap[k]={objectType:"dataSeries",dataSeriesIndex:d};
k=R(k);h.fillStyle=k;k=[];f=!0;var D=0,u,s,q,y=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),B,A=null;if(0<m.length){var x=w._colorSet[D%w._colorSet.length],z=w.lineColor=w.options.lineColor||x,L=z;g.fillStyle=x;g.strokeStyle=z;g.lineWidth=w.lineThickness;b="solid";if(g.setLineDash){var K=F(w.nullDataLineDashType,w.lineThickness);b=w.lineDashType;var da=F(b,w.lineThickness);g.setLineDash(da)}for(var ca=!0;D<m.length;D++)if(q=m[D].x.getTime?m[D].x.getTime():m[D].x,!(q<
a.axisX.dataInfo.viewPortMin||q>a.axisX.dataInfo.viewPortMax&&(!w.connectNullData||!ca)))if("number"!==typeof m[D].y)w.connectNullData||(ca||f)||c(),ca=!0;else{u=a.axisX.convertValueToPixel(q);s=a.axisY.convertValueToPixel(m[D].y);f||ca?(!f&&w.connectNullData?(g.setLineDash&&(w.options.nullDataLineDashType||b===w.lineDashType&&w.lineDashType!==w.nullDataLineDashType)&&(f=u,b=s,u=p.x,s=p.y,c(),g.moveTo(p.x,p.y),u=f,s=b,A=p,b=w.nullDataLineDashType,g.setLineDash(K)),g.lineTo(u,s),v&&h.lineTo(u,s)):
(g.beginPath(),g.moveTo(u,s),v&&(h.beginPath(),h.moveTo(u,s)),A={x:u,y:s}),ca=f=!1):(g.lineTo(u,s),v&&h.lineTo(u,s),0==D%250&&c());p={x:u,y:s};D<m.length-1&&(L!==(m[D].lineColor||z)||b!==(m[D].lineDashType||w.lineDashType))&&(c(),L=m[D].lineColor||z,g.strokeStyle=L,g.setLineDash&&(m[D].lineDashType?(b=m[D].lineDashType,g.setLineDash(F(b,w.lineThickness))):(b=w.lineDashType,g.setLineDash(da))));var aa=w.dataPointIds[D];this._eventManager.objectMap[aa]={id:aa,objectType:"dataPoint",dataSeriesIndex:d,
dataPointIndex:D,x1:u,y1:s};0!==m[D].markerSize&&(0<m[D].markerSize||0<w.markerSize)&&(q=w.getMarkerProperties(D,u,s,g),k.push(q),aa=R(aa),v&&k.push({x:u,y:s,ctx:h,type:q.type,size:q.size,color:aa,borderColor:aa,borderThickness:q.borderThickness}));(m[D].indexLabel||w.indexLabel||m[D].indexLabelFormatter||w.indexLabelFormatter)&&this._indexLabels.push({chartType:"area",dataPoint:m[D],dataSeries:w,point:{x:u,y:s},direction:0>m[D].y===a.axisY.reversed?1:-1,color:x})}c();$.drawMarkers(k)}}v&&(e.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),g.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&g.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&g.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),g.clearRect(r.x1,r.y1,r.width,r.height),this._eventManager.ghostCtx.restore());g.restore();return{source:e,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,
animationBase:0}}};q.prototype.renderSplineArea=function(a){function f(){var b=x(q,2);if(0<b.length){if(0<p.lineThickness){c.beginPath();c.moveTo(b[0].x,b[0].y);b[0].newStrokeStyle&&(c.strokeStyle=b[0].newStrokeStyle);b[0].newLineDashArray&&c.setLineDash(b[0].newLineDashArray);for(var d=0;d<b.length-3;d+=3)if(c.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y),v&&e.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y),b[d+3].newStrokeStyle||b[d+3].newLineDashArray)c.stroke(),
c.beginPath(),c.moveTo(b[d+3].x,b[d+3].y),b[d+3].newStrokeStyle&&(c.strokeStyle=b[d+3].newStrokeStyle),b[d+3].newLineDashArray&&c.setLineDash(b[d+3].newLineDashArray);c.stroke()}c.beginPath();c.moveTo(b[0].x,b[0].y);v&&(e.beginPath(),e.moveTo(b[0].x,b[0].y));for(d=0;d<b.length-3;d+=3)c.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y),v&&e.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y);a.axisY.logarithmic||0>=a.axisY.viewportMinimum&&0<=a.axisY.viewportMaximum?
u=D:0>a.axisY.viewportMaximum?u=h.y1:0<a.axisY.viewportMinimum&&(u=g.y2);s={x:b[0].x,y:b[0].y};c.lineTo(b[b.length-1].x,u);c.lineTo(s.x,u);c.closePath();c.globalAlpha=p.fillOpacity;c.fill();c.globalAlpha=1;v&&(e.lineTo(b[b.length-1].x,u),e.lineTo(s.x,u),e.closePath(),e.fill())}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=this._eventManager.ghostCtx,g=a.axisX.lineCoordinates,h=a.axisY.lineCoordinates,l=[],t=this.plotArea;c.save();v&&
e.save();c.beginPath();c.rect(t.x1,t.y1,t.width,t.height);c.clip();v&&(e.beginPath(),e.rect(t.x1,t.y1,t.width,t.height),e.clip());for(var k=0;k<a.dataSeriesIndexes.length;k++){var r=a.dataSeriesIndexes[k],p=this.data[r],n=p.dataPoints,l=p.id;this._eventManager.objectMap[l]={objectType:"dataSeries",dataSeriesIndex:r};l=R(l);e.fillStyle=l;var l=[],d=0,w,m,D=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),u,s=null,q=[];if(0<n.length){var y=p._colorSet[d%p._colorSet.length],
B=p.lineColor=p.options.lineColor||y,A=B;c.fillStyle=y;c.strokeStyle=B;c.lineWidth=p.lineThickness;var z="solid";if(c.setLineDash){var la=F(p.nullDataLineDashType,p.lineThickness),z=p.lineDashType,L=F(z,p.lineThickness);c.setLineDash(L)}for(m=!1;d<n.length;d++)if(w=n[d].x.getTime?n[d].x.getTime():n[d].x,!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax&&(!p.connectNullData||!m)))if("number"!==typeof n[d].y)0<d&&!m&&(p.connectNullData?c.setLineDash&&(0<q.length&&(p.options.nullDataLineDashType||
!n[d-1].lineDashType))&&(q[q.length-1].newLineDashArray=la,z=p.nullDataLineDashType):(f(),q=[])),m=!0;else{w=a.axisX.convertValueToPixel(w);m=a.axisY.convertValueToPixel(n[d].y);var K=p.dataPointIds[d];this._eventManager.objectMap[K]={id:K,objectType:"dataPoint",dataSeriesIndex:r,dataPointIndex:d,x1:w,y1:m};q[q.length]={x:w,y:m};d<n.length-1&&(A!==(n[d].lineColor||B)||z!==(n[d].lineDashType||p.lineDashType))&&(A=n[d].lineColor||B,q[q.length-1].newStrokeStyle=A,c.setLineDash&&(n[d].lineDashType?(z=
n[d].lineDashType,q[q.length-1].newLineDashArray=F(z,p.lineThickness)):(z=p.lineDashType,q[q.length-1].newLineDashArray=L)));if(0!==n[d].markerSize&&(0<n[d].markerSize||0<p.markerSize)){var da=p.getMarkerProperties(d,w,m,c);l.push(da);K=R(K);v&&l.push({x:w,y:m,ctx:e,type:da.type,size:da.size,color:K,borderColor:K,borderThickness:da.borderThickness})}(n[d].indexLabel||p.indexLabel||n[d].indexLabelFormatter||p.indexLabelFormatter)&&this._indexLabels.push({chartType:"splineArea",dataPoint:n[d],dataSeries:p,
point:{x:w,y:m},direction:0>n[d].y===a.axisY.reversed?1:-1,color:y});m=!1}f();$.drawMarkers(l)}}v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(t.x1,t.y1,t.width,t.height),
this._eventManager.ghostCtx.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderStepArea=function(a){var f,b;function c(){A&&(0<w.lineThickness&&g.stroke(),a.axisY.logarithmic||0>=a.axisY.viewportMinimum&&0<=a.axisY.viewportMaximum?B=y:0>a.axisY.viewportMaximum?B=t.y1:0<a.axisY.viewportMinimum&&(B=l.y2),g.lineTo(u,B),g.lineTo(A.x,B),g.closePath(),g.globalAlpha=w.fillOpacity,g.fill(),g.globalAlpha=
1,v&&(h.lineTo(u,B),h.lineTo(A.x,B),h.closePath(),h.fill()),g.beginPath(),g.moveTo(u,s),h.beginPath(),h.moveTo(u,s),A={x:u,y:s})}var e=a.targetCanvasCtx||this.plotArea.ctx,g=v?this._preRenderCtx:e;if(!(0>=a.dataSeriesIndexes.length)){var h=this._eventManager.ghostCtx,l=a.axisX.lineCoordinates,t=a.axisY.lineCoordinates,k=[],r=this.plotArea,p;g.save();v&&h.save();g.beginPath();g.rect(r.x1,r.y1,r.width,r.height);g.clip();v&&(h.beginPath(),h.rect(r.x1,r.y1,r.width,r.height),h.clip());for(var n=0;n<a.dataSeriesIndexes.length;n++){var d=
a.dataSeriesIndexes[n],w=this.data[d],m=w.dataPoints,k=w.id;this._eventManager.objectMap[k]={objectType:"dataSeries",dataSeriesIndex:d};k=R(k);h.fillStyle=k;k=[];f=!0;var D=0,u,s,q,y=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),B,A=null;b=!1;if(0<m.length){var x=w._colorSet[D%w._colorSet.length],z=w.lineColor=w.options.lineColor||x,L=z;g.fillStyle=x;g.strokeStyle=z;g.lineWidth=w.lineThickness;var K="solid";if(g.setLineDash){var da=F(w.nullDataLineDashType,w.lineThickness),
K=w.lineDashType,ca=F(K,w.lineThickness);g.setLineDash(ca)}for(;D<m.length;D++)if(q=m[D].x.getTime?m[D].x.getTime():m[D].x,!(q<a.axisX.dataInfo.viewPortMin||q>a.axisX.dataInfo.viewPortMax&&(!w.connectNullData||!b))){var aa=s;"number"!==typeof m[D].y?(w.connectNullData||(b||f)||c(),b=!0):(u=a.axisX.convertValueToPixel(q),s=a.axisY.convertValueToPixel(m[D].y),f||b?(!f&&w.connectNullData?(g.setLineDash&&(w.options.nullDataLineDashType||K===w.lineDashType&&w.lineDashType!==w.nullDataLineDashType)&&(f=
u,b=s,u=p.x,s=p.y,c(),g.moveTo(p.x,p.y),u=f,s=b,A=p,K=w.nullDataLineDashType,g.setLineDash(da)),g.lineTo(u,aa),g.lineTo(u,s),v&&(h.lineTo(u,aa),h.lineTo(u,s))):(g.beginPath(),g.moveTo(u,s),v&&(h.beginPath(),h.moveTo(u,s)),A={x:u,y:s}),b=f=!1):(g.lineTo(u,aa),v&&h.lineTo(u,aa),g.lineTo(u,s),v&&h.lineTo(u,s),0==D%250&&c()),p={x:u,y:s},D<m.length-1&&(L!==(m[D].lineColor||z)||K!==(m[D].lineDashType||w.lineDashType))&&(c(),L=m[D].lineColor||z,g.strokeStyle=L,g.setLineDash&&(m[D].lineDashType?(K=m[D].lineDashType,
g.setLineDash(F(K,w.lineThickness))):(K=w.lineDashType,g.setLineDash(ca)))),q=w.dataPointIds[D],this._eventManager.objectMap[q]={id:q,objectType:"dataPoint",dataSeriesIndex:d,dataPointIndex:D,x1:u,y1:s},0!==m[D].markerSize&&(0<m[D].markerSize||0<w.markerSize)&&(aa=w.getMarkerProperties(D,u,s,g),k.push(aa),q=R(q),v&&k.push({x:u,y:s,ctx:h,type:aa.type,size:aa.size,color:q,borderColor:q,borderThickness:aa.borderThickness})),(m[D].indexLabel||w.indexLabel||m[D].indexLabelFormatter||w.indexLabelFormatter)&&
this._indexLabels.push({chartType:"stepArea",dataPoint:m[D],dataSeries:w,point:{x:u,y:s},direction:0>m[D].y===a.axisY.reversed?1:-1,color:x}))}c();$.drawMarkers(k)}}v&&(e.drawImage(this._preRenderCanvas,0,0,this.width,this.height),g.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&g.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&g.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),g.clearRect(r.x1,r.y1,r.width,r.height),this._eventManager.ghostCtx.restore());g.restore();return{source:e,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderStackedArea=function(a){function f(){if(!(1>t.length)){for(0<A.lineThickness&&c.stroke();0<t.length;){var a=t.pop();c.lineTo(a.x,a.y);v&&D.lineTo(a.x,a.y)}c.closePath();c.globalAlpha=A.fillOpacity;c.fill();c.globalAlpha=1;c.beginPath();v&&(D.closePath(),
D.fill(),D.beginPath());t=[]}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=[],h=this.plotArea,l=[],t=[],k=[],r=[],p=0,n,d,w,m=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),D=this._eventManager.ghostCtx,u,s,q;v&&D.beginPath();c.save();v&&D.save();c.beginPath();c.rect(h.x1,h.y1,h.width,h.height);c.clip();v&&(D.beginPath(),D.rect(h.x1,h.y1,h.width,h.height),D.clip());for(var e=[],y=0;y<a.dataSeriesIndexes.length;y++){var B=
a.dataSeriesIndexes[y],A=this.data[B],x=A.dataPoints;A.dataPointIndexes=[];for(p=0;p<x.length;p++)B=x[p].x.getTime?x[p].x.getTime():x[p].x,A.dataPointIndexes[B]=p,e[B]||(k.push(B),e[B]=!0);k.sort(Pa)}for(y=0;y<a.dataSeriesIndexes.length;y++){B=a.dataSeriesIndexes[y];A=this.data[B];x=A.dataPoints;s=!0;t=[];p=A.id;this._eventManager.objectMap[p]={objectType:"dataSeries",dataSeriesIndex:B};p=R(p);D.fillStyle=p;if(0<k.length){var e=A._colorSet[0],z=A.lineColor=A.options.lineColor||e,L=z;c.fillStyle=e;
c.strokeStyle=z;c.lineWidth=A.lineThickness;q="solid";if(c.setLineDash){var K=F(A.nullDataLineDashType,A.lineThickness);q=A.lineDashType;var da=F(q,A.lineThickness);c.setLineDash(da)}for(var ca=!0,p=0;p<k.length;p++){w=k[p];var aa=null,aa=0<=A.dataPointIndexes[w]?x[A.dataPointIndexes[w]]:{x:w,y:null};if(!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax&&(!A.connectNullData||!ca)))if("number"!==typeof aa.y)A.connectNullData||(ca||s)||f(),ca=!0;else{n=a.axisX.convertValueToPixel(w);var wa=
l[w]?l[w]:0;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length){r[w]=aa.y+(r[w]?r[w]:0);if(0>=r[w]&&a.axisY.logarithmic)continue;d=a.axisY.convertValueToPixel(r[w])}else d=a.axisY.convertValueToPixel(aa.y),d-=wa;t.push({x:n,y:m-wa});l[w]=m-d;s||ca?(!s&&A.connectNullData?(c.setLineDash&&(A.options.nullDataLineDashType||q===A.lineDashType&&A.lineDashType!==A.nullDataLineDashType)&&(s=t.pop(),q=t[t.length-1],f(),c.moveTo(u.x,u.y),t.push(q),t.push(s),q=A.nullDataLineDashType,
c.setLineDash(K)),c.lineTo(n,d),v&&D.lineTo(n,d)):(c.beginPath(),c.moveTo(n,d),v&&(D.beginPath(),D.moveTo(n,d))),ca=s=!1):(c.lineTo(n,d),v&&D.lineTo(n,d),0==p%250&&(f(),c.moveTo(n,d),v&&D.moveTo(n,d),t.push({x:n,y:m-wa})));u={x:n,y:d};p<x.length-1&&(L!==(x[p].lineColor||z)||q!==(x[p].lineDashType||A.lineDashType))&&(f(),c.beginPath(),c.moveTo(n,d),t.push({x:n,y:m-wa}),L=x[p].lineColor||z,c.strokeStyle=L,c.setLineDash&&(x[p].lineDashType?(q=x[p].lineDashType,c.setLineDash(F(q,A.lineThickness))):(q=
A.lineDashType,c.setLineDash(da))));if(0<=A.dataPointIndexes[w]){var ma=A.dataPointIds[A.dataPointIndexes[w]];this._eventManager.objectMap[ma]={id:ma,objectType:"dataPoint",dataSeriesIndex:B,dataPointIndex:A.dataPointIndexes[w],x1:n,y1:d}}0<=A.dataPointIndexes[w]&&0!==aa.markerSize&&(0<aa.markerSize||0<A.markerSize)&&(w=A.getMarkerProperties(A.dataPointIndexes[w],n,d,c),g.push(w),markerColor=R(ma),v&&g.push({x:n,y:d,ctx:D,type:w.type,size:w.size,color:markerColor,borderColor:markerColor,borderThickness:w.borderThickness}));
(aa.indexLabel||A.indexLabel||aa.indexLabelFormatter||A.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedArea",dataPoint:aa,dataSeries:A,point:{x:n,y:d},direction:0>x[p].y===a.axisY.reversed?1:-1,color:e})}}f();c.moveTo(n,d);v&&D.moveTo(n,d)}delete A.dataPointIndexes}$.drawMarkers(g);v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&
c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(h.x1,h.y1,h.width,h.height),D.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderStackedArea100=function(a){function f(){for(0<A.lineThickness&&c.stroke();0<t.length;){var a=t.pop();c.lineTo(a.x,a.y);v&&y.lineTo(a.x,
a.y)}c.closePath();c.globalAlpha=A.fillOpacity;c.fill();c.globalAlpha=1;c.beginPath();v&&(y.closePath(),y.fill(),y.beginPath());t=[]}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=this.plotArea,h=[],l=[],t=[],k=[],r=[],p=0,n,d,w,m,s,u,q=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),y=this._eventManager.ghostCtx;c.save();v&&y.save();c.beginPath();c.rect(g.x1,g.y1,g.width,g.height);c.clip();v&&(y.beginPath(),
y.rect(g.x1,g.y1,g.width,g.height),y.clip());for(var e=[],x=0;x<a.dataSeriesIndexes.length;x++){var B=a.dataSeriesIndexes[x],A=this.data[B],z=A.dataPoints;A.dataPointIndexes=[];for(p=0;p<z.length;p++)B=z[p].x.getTime?z[p].x.getTime():z[p].x,A.dataPointIndexes[B]=p,e[B]||(k.push(B),e[B]=!0);k.sort(Pa)}for(x=0;x<a.dataSeriesIndexes.length;x++){B=a.dataSeriesIndexes[x];A=this.data[B];z=A.dataPoints;s=!0;e=A.id;this._eventManager.objectMap[e]={objectType:"dataSeries",dataSeriesIndex:B};e=R(e);y.fillStyle=
e;t=[];if(0<k.length){var e=A._colorSet[p%A._colorSet.length],C=A.lineColor=A.options.lineColor||e,L=C;c.fillStyle=e;c.strokeStyle=C;c.lineWidth=A.lineThickness;u="solid";if(c.setLineDash){var K=F(A.nullDataLineDashType,A.lineThickness);u=A.lineDashType;var da=F(u,A.lineThickness);c.setLineDash(da)}for(var ca=!0,p=0;p<k.length;p++){w=k[p];var aa=null,aa=0<=A.dataPointIndexes[w]?z[A.dataPointIndexes[w]]:{x:w,y:null};if(!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax&&(!A.connectNullData||
!ca)))if("number"!==typeof aa.y)A.connectNullData||(ca||s)||f(),ca=!0;else{var wa;wa=0!==a.dataPointYSums[w]?100*(aa.y/a.dataPointYSums[w]):0;n=a.axisX.convertValueToPixel(w);var ma=l[w]?l[w]:0;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length){r[w]=wa+(r[w]?r[w]:0);if(0>=r[w]&&a.axisY.logarithmic)continue;d=a.axisY.convertValueToPixel(r[w])}else d=a.axisY.convertValueToPixel(wa),d-=ma;t.push({x:n,y:q-ma});l[w]=q-d;s||ca?(!s&&A.connectNullData?(c.setLineDash&&
(A.options.nullDataLineDashType||u===A.lineDashType&&A.lineDashType!==A.nullDataLineDashType)&&(s=t.pop(),u=t[t.length-1],f(),c.moveTo(m.x,m.y),t.push(u),t.push(s),u=A.nullDataLineDashType,c.setLineDash(K)),c.lineTo(n,d),v&&y.lineTo(n,d)):(c.beginPath(),c.moveTo(n,d),v&&(y.beginPath(),y.moveTo(n,d))),ca=s=!1):(c.lineTo(n,d),v&&y.lineTo(n,d),0==p%250&&(f(),c.moveTo(n,d),v&&y.moveTo(n,d),t.push({x:n,y:q-ma})));m={x:n,y:d};p<z.length-1&&(L!==(z[p].lineColor||C)||u!==(z[p].lineDashType||A.lineDashType))&&
(f(),c.beginPath(),c.moveTo(n,d),t.push({x:n,y:q-ma}),L=z[p].lineColor||C,c.strokeStyle=L,c.setLineDash&&(z[p].lineDashType?(u=z[p].lineDashType,c.setLineDash(F(u,A.lineThickness))):(u=A.lineDashType,c.setLineDash(da))));if(0<=A.dataPointIndexes[w]){var E=A.dataPointIds[A.dataPointIndexes[w]];this._eventManager.objectMap[E]={id:E,objectType:"dataPoint",dataSeriesIndex:B,dataPointIndex:A.dataPointIndexes[w],x1:n,y1:d}}0<=A.dataPointIndexes[w]&&0!==aa.markerSize&&(0<aa.markerSize||0<A.markerSize)&&
(w=A.getMarkerProperties(p,n,d,c),h.push(w),markerColor=R(E),v&&h.push({x:n,y:d,ctx:y,type:w.type,size:w.size,color:markerColor,borderColor:markerColor,borderThickness:w.borderThickness}));(aa.indexLabel||A.indexLabel||aa.indexLabelFormatter||A.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedArea100",dataPoint:aa,dataSeries:A,point:{x:n,y:d},direction:0>z[p].y===a.axisY.reversed?1:-1,color:e})}}f();c.moveTo(n,d);v&&y.moveTo(n,d)}delete A.dataPointIndexes}$.drawMarkers(h);v&&(b.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(g.x1,g.y1,g.width,g.height),y.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,
animationBase:0}}};q.prototype.renderBubble=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this.plotArea,e=0,g,h;b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(c.x1,c.y1,c.width,c.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.clip());for(var l=-Infinity,t=Infinity,k=0;k<a.dataSeriesIndexes.length;k++)for(var r=
a.dataSeriesIndexes[k],p=this.data[r],n=p.dataPoints,d=0,e=0;e<n.length;e++)g=n[e].getTime?g=n[e].x.getTime():g=n[e].x,g<a.axisX.dataInfo.viewPortMin||g>a.axisX.dataInfo.viewPortMax||"undefined"===typeof n[e].z||(d=n[e].z,d>l&&(l=d),d<t&&(t=d));for(var w=25*Math.PI,m=Math.max(Math.pow(0.25*Math.min(c.height,c.width)/2,2)*Math.PI,w),k=0;k<a.dataSeriesIndexes.length;k++)if(r=a.dataSeriesIndexes[k],p=this.data[r],n=p.dataPoints,0<n.length)for(b.strokeStyle="#4572A7 ",e=0;e<n.length;e++)if(g=n[e].getTime?
g=n[e].x.getTime():g=n[e].x,!(g<a.axisX.dataInfo.viewPortMin||g>a.axisX.dataInfo.viewPortMax)&&"number"===typeof n[e].y){g=a.axisX.convertValueToPixel(g);h=a.axisY.convertValueToPixel(n[e].y);var d=n[e].z,s=2*Math.max(Math.sqrt((l===t?m/2:w+(m-w)/(l-t)*(d-t))/Math.PI)<<0,1),d=p.getMarkerProperties(e,b);d.size=s;b.globalAlpha=p.fillOpacity;$.drawMarker(g,h,b,d.type,d.size,d.color,d.borderColor,d.borderThickness);b.globalAlpha=1;var u=p.dataPointIds[e];this._eventManager.objectMap[u]={id:u,objectType:"dataPoint",
dataSeriesIndex:r,dataPointIndex:e,x1:g,y1:h,size:s};s=R(u);v&&$.drawMarker(g,h,this._eventManager.ghostCtx,d.type,d.size,s,s,d.borderThickness);(n[e].indexLabel||p.indexLabel||n[e].indexLabelFormatter||p.indexLabelFormatter)&&this._indexLabels.push({chartType:"bubble",dataPoint:n[e],dataSeries:p,point:{x:g,y:h},direction:1,bounds:{x1:g-d.size/2,y1:h-d.size/2,x2:g+d.size/2,y2:h+d.size/2},color:null})}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",
a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderScatter=
function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this.plotArea,e=0,g,h;b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(c.x1,c.y1,c.width,c.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.clip());for(var l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t],r=k.dataPoints;if(0<
r.length){b.strokeStyle="#4572A7 ";Math.pow(0.3*Math.min(c.height,c.width)/2,2);for(var p=0,n=0,e=0;e<r.length;e++)if(g=r[e].getTime?g=r[e].x.getTime():g=r[e].x,!(g<a.axisX.dataInfo.viewPortMin||g>a.axisX.dataInfo.viewPortMax)&&"number"===typeof r[e].y){g=a.axisX.convertValueToPixel(g);h=a.axisY.convertValueToPixel(r[e].y);var d=k.getMarkerProperties(e,g,h,b);b.globalAlpha=k.fillOpacity;$.drawMarker(d.x,d.y,d.ctx,d.type,d.size,d.color,d.borderColor,d.borderThickness);b.globalAlpha=1;Math.sqrt((p-
g)*(p-g)+(n-h)*(n-h))<Math.min(d.size,5)&&r.length>Math.min(this.plotArea.width,this.plotArea.height)||(p=k.dataPointIds[e],this._eventManager.objectMap[p]={id:p,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:e,x1:g,y1:h},p=R(p),v&&$.drawMarker(d.x,d.y,this._eventManager.ghostCtx,d.type,d.size,p,p,d.borderThickness),(r[e].indexLabel||k.indexLabel||r[e].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"scatter",dataPoint:r[e],dataSeries:k,point:{x:g,y:h},direction:1,
bounds:{x1:g-d.size/2,y1:h-d.size/2,x2:g+d.size/2,y2:h+d.size/2},color:null}),p=g,n=h)}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderCandlestick=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f,c=this._eventManager.ghostCtx;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=null,h=this.plotArea,l=0,t,k,r,p,n,d,e=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,g=this.options.dataPointMaxWidth?
this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.015*this.width,w=a.axisX.dataInfo.minDiff;isFinite(w)||(w=0.3*Math.abs(a.axisX.range));w=this.options.dataPointWidth?this.dataPointWidth:0.7*h.width*(a.axisX.logarithmic?Math.log(w)/Math.log(a.axisX.range):Math.abs(w)/Math.abs(a.axisX.range))<<0;this.dataPointMaxWidth&&e>g&&(e=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,g));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&g<e)&&(g=Math.max(this.options.dataPointWidth?
this.dataPointWidth:-Infinity,e));w<e&&(w=e);w>g&&(w=g);b.save();v&&c.save();b.beginPath();b.rect(h.x1,h.y1,h.width,h.height);b.clip();v&&(c.beginPath(),c.rect(h.x1,h.y1,h.width,h.height),c.clip());for(var m=0;m<a.dataSeriesIndexes.length;m++){var s=a.dataSeriesIndexes[m],u=this.data[s],q=u.dataPoints;if(0<q.length)for(var H=5<w&&u.bevelEnabled?!0:!1,l=0;l<q.length;l++)if(q[l].getTime?d=q[l].x.getTime():d=q[l].x,!(d<a.axisX.dataInfo.viewPortMin||d>a.axisX.dataInfo.viewPortMax)&&!y(q[l].y)&&q[l].y.length&&
"number"===typeof q[l].y[0]&&"number"===typeof q[l].y[1]&&"number"===typeof q[l].y[2]&&"number"===typeof q[l].y[3]){t=a.axisX.convertValueToPixel(d);k=a.axisY.convertValueToPixel(q[l].y[0]);r=a.axisY.convertValueToPixel(q[l].y[1]);p=a.axisY.convertValueToPixel(q[l].y[2]);n=a.axisY.convertValueToPixel(q[l].y[3]);var x=t-w/2<<0,B=x+w<<0,g=u.options.fallingColor?u.fallingColor:u._colorSet[0],e=q[l].color?q[l].color:u._colorSet[0],A=Math.round(Math.max(1,0.15*w)),z=0===A%2?0:0.5,C=u.dataPointIds[l];this._eventManager.objectMap[C]=
{id:C,objectType:"dataPoint",dataSeriesIndex:s,dataPointIndex:l,x1:x,y1:k,x2:B,y2:r,x3:t,y3:p,x4:t,y4:n,borderThickness:A,color:e};b.strokeStyle=e;b.beginPath();b.lineWidth=A;c.lineWidth=Math.max(A,4);"candlestick"===u.type?(b.moveTo(t-z,r),b.lineTo(t-z,Math.min(k,n)),b.stroke(),b.moveTo(t-z,Math.max(k,n)),b.lineTo(t-z,p),b.stroke(),X(b,x,Math.min(k,n),B,Math.max(k,n),q[l].y[0]<=q[l].y[3]?u.risingColor:g,A,e,H,H,!1,!1,u.fillOpacity),v&&(e=R(C),c.strokeStyle=e,c.moveTo(t-z,r),c.lineTo(t-z,Math.min(k,
n)),c.stroke(),c.moveTo(t-z,Math.max(k,n)),c.lineTo(t-z,p),c.stroke(),X(c,x,Math.min(k,n),B,Math.max(k,n),e,0,null,!1,!1,!1,!1))):"ohlc"===u.type&&(b.moveTo(t-z,r),b.lineTo(t-z,p),b.stroke(),b.beginPath(),b.moveTo(t,k),b.lineTo(x,k),b.stroke(),b.beginPath(),b.moveTo(t,n),b.lineTo(B,n),b.stroke(),v&&(e=R(C),c.strokeStyle=e,c.moveTo(t-z,r),c.lineTo(t-z,p),c.stroke(),c.beginPath(),c.moveTo(t,k),c.lineTo(x,k),c.stroke(),c.beginPath(),c.moveTo(t,n),c.lineTo(B,n),c.stroke()));(q[l].indexLabel||u.indexLabel||
q[l].indexLabelFormatter||u.indexLabelFormatter)&&this._indexLabels.push({chartType:u.type,dataPoint:q[l],dataSeries:u,point:{x:x+(B-x)/2,y:a.axisY.reversed?p:r},direction:1,bounds:{x1:x,y1:Math.min(r,p),x2:B,y2:Math.max(r,p)},color:e})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),
this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(h.x1,h.y1,h.width,h.height),c.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderBoxAndWhisker=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f,c=this._eventManager.ghostCtx;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=this.plotArea,
h=0,l,t,k,r,p,n,d,e=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,h=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.015*this.width,w=a.axisX.dataInfo.minDiff;isFinite(w)||(w=0.3*Math.abs(a.axisX.range));w=this.options.dataPointWidth?this.dataPointWidth:0.7*g.width*(a.axisX.logarithmic?Math.log(w)/Math.log(a.axisX.range):Math.abs(w)/Math.abs(a.axisX.range))<<0;this.dataPointMaxWidth&&e>
h&&(e=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,h));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&h<e)&&(h=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,e));w<e&&(w=e);w>h&&(w=h);b.save();v&&c.save();b.beginPath();b.rect(g.x1,g.y1,g.width,g.height);b.clip();v&&(c.beginPath(),c.rect(g.x1,g.y1,g.width,g.height),c.clip());for(var m=!1,m=!!a.axisY.reversed,s=0;s<a.dataSeriesIndexes.length;s++){var u=a.dataSeriesIndexes[s],q=this.data[u],H=q.dataPoints;
if(0<H.length)for(var x=5<w&&q.bevelEnabled?!0:!1,h=0;h<H.length;h++)if(H[h].getTime?d=H[h].x.getTime():d=H[h].x,!(d<a.axisX.dataInfo.viewPortMin||d>a.axisX.dataInfo.viewPortMax)&&!y(H[h].y)&&H[h].y.length&&"number"===typeof H[h].y[0]&&"number"===typeof H[h].y[1]&&"number"===typeof H[h].y[2]&&"number"===typeof H[h].y[3]&&"number"===typeof H[h].y[4]&&5===H[h].y.length){l=a.axisX.convertValueToPixel(d);t=a.axisY.convertValueToPixel(H[h].y[0]);k=a.axisY.convertValueToPixel(H[h].y[1]);r=a.axisY.convertValueToPixel(H[h].y[2]);
p=a.axisY.convertValueToPixel(H[h].y[3]);n=a.axisY.convertValueToPixel(H[h].y[4]);var B=l-w/2<<0,A=l+w/2<<0,e=H[h].color?H[h].color:q._colorSet[0],z=Math.round(Math.max(1,0.15*w)),C=0===z%2?0:0.5,L=H[h].whiskerColor?H[h].whiskerColor:H[h].color?q.whiskerColor?q.whiskerColor:H[h].color:q.whiskerColor?q.whiskerColor:e,K="number"===typeof H[h].whiskerThickness?H[h].whiskerThickness:"number"===typeof q.options.whiskerThickness?q.whiskerThickness:z,da=H[h].whiskerDashType?H[h].whiskerDashType:q.whiskerDashType,
ca=y(H[h].whiskerLength)?y(q.options.whiskerLength)?w:q.whiskerLength:H[h].whiskerLength,ca="number"===typeof ca?0>=ca?0:ca>=w?w:ca:"string"===typeof ca?parseInt(ca)*w/100>w?w:parseInt(ca)*w/100:w,aa=1===Math.round(K)%2?0.5:0,wa=H[h].stemColor?H[h].stemColor:H[h].color?q.stemColor?q.stemColor:H[h].color:q.stemColor?q.stemColor:e,ma="number"===typeof H[h].stemThickness?H[h].stemThickness:"number"===typeof q.options.stemThickness?q.stemThickness:z,E=1===Math.round(ma)%2?0.5:0,fb=H[h].stemDashType?H[h].stemDashType:
q.stemDashType,I=H[h].lineColor?H[h].lineColor:H[h].color?q.lineColor?q.lineColor:H[h].color:q.lineColor?q.lineColor:e,J="number"===typeof H[h].lineThickness?H[h].lineThickness:"number"===typeof q.options.lineThickness?q.lineThickness:z,S=H[h].lineDashType?H[h].lineDashType:q.lineDashType,M=1===Math.round(J)%2?0.5:0,P=q.upperBoxColor,U=q.lowerBoxColor,ra=y(q.options.fillOpacity)?1:q.fillOpacity,N=q.dataPointIds[h];this._eventManager.objectMap[N]={id:N,objectType:"dataPoint",dataSeriesIndex:u,dataPointIndex:h,
x1:B,y1:t,x2:A,y2:k,x3:l,y3:r,x4:l,y4:p,y5:n,borderThickness:z,color:e,stemThickness:ma,stemColor:wa,whiskerThickness:K,whiskerLength:ca,whiskerColor:L,lineThickness:J,lineColor:I};b.save();0<ma&&(b.beginPath(),b.strokeStyle=wa,b.lineWidth=ma,b.setLineDash&&b.setLineDash(F(fb,ma)),b.moveTo(l-E,k),b.lineTo(l-E,t),b.stroke(),b.moveTo(l-E,p),b.lineTo(l-E,r),b.stroke());b.restore();c.lineWidth=Math.max(z,4);b.beginPath();X(b,B,Math.min(n,k),A,Math.max(k,n),U,0,e,m?x:!1,m?!1:x,!1,!1,ra);b.beginPath();
X(b,B,Math.min(r,n),A,Math.max(n,r),P,0,e,m?!1:x,m?x:!1,!1,!1,ra);b.beginPath();b.lineWidth=z;b.strokeStyle=e;b.rect(B-C,Math.min(k,r)-C,A-B+2*C,Math.max(k,r)-Math.min(k,r)+2*C);b.stroke();b.save();0<J&&(b.beginPath(),b.globalAlpha=1,b.setLineDash&&b.setLineDash(F(S,J)),b.strokeStyle=I,b.lineWidth=J,b.moveTo(B,n-M),b.lineTo(A,n-M),b.stroke());b.restore();b.save();0<K&&(b.beginPath(),b.setLineDash&&b.setLineDash(F(da,K)),b.strokeStyle=L,b.lineWidth=K,b.moveTo(l-ca/2<<0,p-aa),b.lineTo(l+ca/2<<0,p-aa),
b.stroke(),b.moveTo(l-ca/2<<0,t+aa),b.lineTo(l+ca/2<<0,t+aa),b.stroke());b.restore();v&&(e=R(N),c.strokeStyle=e,c.lineWidth=ma,0<ma&&(c.moveTo(l-C-E,k),c.lineTo(l-C-E,Math.max(t,p)),c.stroke(),c.moveTo(l-C-E,Math.min(t,p)),c.lineTo(l-C-E,r),c.stroke()),X(c,B,Math.max(k,r),A,Math.min(k,r),e,0,null,!1,!1,!1,!1),0<K&&(c.beginPath(),c.lineWidth=K,c.moveTo(l+ca/2,p-aa),c.lineTo(l-ca/2,p-aa),c.stroke(),c.moveTo(l+ca/2,t+aa),c.lineTo(l-ca/2,t+aa),c.stroke()));(H[h].indexLabel||q.indexLabel||H[h].indexLabelFormatter||
q.indexLabelFormatter)&&this._indexLabels.push({chartType:q.type,dataPoint:H[h],dataSeries:q,point:{x:B+(A-B)/2,y:a.axisY.reversed?t:p},direction:1,bounds:{x1:B,y1:Math.min(t,p),x2:A,y2:Math.max(t,p)},color:e})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),b.clearRect(g.x1,g.y1,g.width,g.height),c.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderRangeColumn=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=0,h,l,t,g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:
1;h=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.03*this.width;var k=a.axisX.dataInfo.minDiff;isFinite(k)||(k=0.3*Math.abs(a.axisX.range));k=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(k)/Math.log(a.axisX.range):Math.abs(k)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>h&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,h));!this.dataPointMaxWidth&&
(this.dataPointMinWidth&&h<g)&&(h=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));k<g&&(k=g);k>h&&(k=h);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var r=0;r<a.dataSeriesIndexes.length;r++){var p=a.dataSeriesIndexes[r],n=this.data[p],d=n.dataPoints;if(0<d.length)for(var w=
5<k&&n.bevelEnabled?!0:!1,g=0;g<d.length;g++)if(d[g].getTime?t=d[g].x.getTime():t=d[g].x,!(t<a.axisX.dataInfo.viewPortMin||t>a.axisX.dataInfo.viewPortMax)&&!y(d[g].y)&&d[g].y.length&&"number"===typeof d[g].y[0]&&"number"===typeof d[g].y[1]){c=a.axisX.convertValueToPixel(t);h=a.axisY.convertValueToPixel(d[g].y[0]);l=a.axisY.convertValueToPixel(d[g].y[1]);var m=a.axisX.reversed?c+a.plotType.totalDataSeries*k/2-(a.previousDataSeriesCount+r)*k<<0:c-a.plotType.totalDataSeries*k/2+(a.previousDataSeriesCount+
r)*k<<0,q=a.axisX.reversed?m-k<<0:m+k<<0,c=d[g].color?d[g].color:n._colorSet[g%n._colorSet.length];if(h>l){var u=h;h=l;l=u}u=n.dataPointIds[g];this._eventManager.objectMap[u]={id:u,objectType:"dataPoint",dataSeriesIndex:p,dataPointIndex:g,x1:m,y1:h,x2:q,y2:l};X(b,m,h,q,l,c,0,c,w,w,!1,!1,n.fillOpacity);c=R(u);v&&X(this._eventManager.ghostCtx,m,h,q,l,c,0,null,!1,!1,!1,!1);if(d[g].indexLabel||n.indexLabel||d[g].indexLabelFormatter||n.indexLabelFormatter)this._indexLabels.push({chartType:"rangeColumn",
dataPoint:d[g],dataSeries:n,indexKeyword:0,point:{x:m+(q-m)/2,y:d[g].y[1]>=d[g].y[0]?l:h},direction:d[g].y[1]>=d[g].y[0]?-1:1,bounds:{x1:m,y1:Math.min(h,l),x2:q,y2:Math.max(h,l)},color:c}),this._indexLabels.push({chartType:"rangeColumn",dataPoint:d[g],dataSeries:n,indexKeyword:1,point:{x:m+(q-m)/2,y:d[g].y[1]>=d[g].y[0]?h:l},direction:d[g].y[1]>=d[g].y[0]?1:-1,bounds:{x1:m,y1:Math.min(h,l),x2:q,y2:Math.max(h,l)},color:c})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation=
"source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderError=
function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f,c=a.axisY._position?"left"===a.axisY._position||"right"===a.axisY._position?!1:!0:!1;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=!1,h=this.plotArea,l=0,t,k,r,p,n,d,w,m=a.axisX.dataInfo.minDiff;isFinite(m)||(m=0.3*Math.abs(a.axisX.range));b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(h.x1,h.y1,h.width,h.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(h.x1,
h.y1,h.width,h.height),this._eventManager.ghostCtx.clip());for(var q=0,u=0;u<this.data.length;u++)!this.data[u].type.match(/(bar|column)/ig)||!this.data[u].visible||this.data[u].type.match(/(stacked)/ig)&&q||q++;for(var s=0;s<a.dataSeriesIndexes.length;s++){var H=a.dataSeriesIndexes[s],x=this.data[H],B=x.dataPoints,A=y(x._linkedSeries)?!1:x._linkedSeries.type.match(/(bar|column)/ig)&&x._linkedSeries.visible?!0:!1,C=0;if(A)for(e=x._linkedSeries.id,u=0;u<e;u++)!this.data[u].type.match(/(bar|column)/ig)||
!this.data[u].visible||this.data[u].type.match(/(stacked)/ig)&&C||(this.data[u].type.match(/(range)/ig)&&(g=!0),C++);e=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;l=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:c?Math.min(0.15*this.height,0.9*(this.plotArea.height/(A?q:1)))<<0:0.3*this.width;g&&(l=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:
c?Math.min(0.15*this.height,0.9*(this.plotArea.height/(A?q:1)))<<0:0.03*this.width);u=this.options.dataPointWidth?this.dataPointWidth:0.9*((c?h.height:h.width)*(a.axisX.logarithmic?Math.log(m)/Math.log(a.axisX.range):Math.abs(m)/Math.abs(a.axisX.range))/(A?q:1))<<0;this.dataPointMaxWidth&&e>l&&(e=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,l));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&l<e)&&(l=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,e));u<e&&
(u=e);u>l&&(u=l);if(0<B.length)for(var F=x._colorSet,l=0;l<B.length;l++){var e=x.lineColor=x.options.color?x.options.color:F[0],L={color:B[l].whiskerColor?B[l].whiskerColor:B[l].color?x.whiskerColor?x.whiskerColor:B[l].color:x.whiskerColor?x.whiskerColor:e,thickness:y(B[l].whiskerThickness)?x.whiskerThickness:B[l].whiskerThickness,dashType:B[l].whiskerDashType?B[l].whiskerDashType:x.whiskerDashType,length:y(B[l].whiskerLength)?y(x.options.whiskerLength)?u:x.options.whiskerLength:B[l].whiskerLength,
trimLength:y(B[l].whiskerLength)?y(x.options.whiskerLength)?50:0:0};L.length="number"===typeof L.length?0>=L.length?0:L.length>=u?u:L.length:"string"===typeof L.length?parseInt(L.length)*u/100>u?u:parseInt(L.length)*u/100>u:u;L.thickness="number"===typeof L.thickness?0>L.thickness?0:Math.round(L.thickness):2;var K={color:B[l].stemColor?B[l].stemColor:B[l].color?x.stemColor?x.stemColor:B[l].color:x.stemColor?x.stemColor:e,thickness:B[l].stemThickness?B[l].stemThickness:x.stemThickness,dashType:B[l].stemDashType?
B[l].stemDashType:x.stemDashType};K.thickness="number"===typeof K.thickness?0>K.thickness?0:Math.round(K.thickness):2;B[l].getTime?w=B[l].x.getTime():w=B[l].x;if(!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax)&&!y(B[l].y)&&B[l].y.length&&"number"===typeof B[l].y[0]&&"number"===typeof B[l].y[1]){var da=a.axisX.convertValueToPixel(w);c?k=da:t=da;da=a.axisY.convertValueToPixel(B[l].y[0]);c?r=da:n=da;da=a.axisY.convertValueToPixel(B[l].y[1]);c?p=da:d=da;c?(n=a.axisX.reversed?k+(A?q:
1)*u/2-(A?C-1:0)*u<<0:k-(A?q:1)*u/2+(A?C-1:0)*u<<0,d=a.axisX.reversed?n-u<<0:n+u<<0):(r=a.axisX.reversed?t+(A?q:1)*u/2-(A?C-1:0)*u<<0:t-(A?q:1)*u/2+(A?C-1:0)*u<<0,p=a.axisX.reversed?r-u<<0:r+u<<0);!c&&n>d&&(da=n,n=d,d=da);c&&r>p&&(da=r,r=p,p=da);da=x.dataPointIds[l];this._eventManager.objectMap[da]={id:da,objectType:"dataPoint",dataSeriesIndex:H,dataPointIndex:l,x1:Math.min(r,p),y1:Math.min(n,d),x2:Math.max(p,r),y2:Math.max(d,n),isXYSwapped:c,stemProperties:K,whiskerProperties:L};z(b,Math.min(r,p),
Math.min(n,d),Math.max(p,r),Math.max(d,n),e,L,K,c);v&&z(this._eventManager.ghostCtx,r,n,p,d,e,L,K,c);if(B[l].indexLabel||x.indexLabel||B[l].indexLabelFormatter||x.indexLabelFormatter)this._indexLabels.push({chartType:"error",dataPoint:B[l],dataSeries:x,indexKeyword:0,point:{x:c?B[l].y[1]>=B[l].y[0]?r:p:r+(p-r)/2,y:c?n+(d-n)/2:B[l].y[1]>=B[l].y[0]?d:n},direction:B[l].y[1]>=B[l].y[0]?-1:1,bounds:{x1:c?Math.min(r,p):r,y1:c?n:Math.min(n,d),x2:c?Math.max(r,p):p,y2:c?d:Math.max(n,d)},color:e,axisSwapped:c}),
this._indexLabels.push({chartType:"error",dataPoint:B[l],dataSeries:x,indexKeyword:1,point:{x:c?B[l].y[1]>=B[l].y[0]?p:r:r+(p-r)/2,y:c?n+(d-n)/2:B[l].y[1]>=B[l].y[0]?n:d},direction:B[l].y[1]>=B[l].y[0]?1:-1,bounds:{x1:c?Math.min(r,p):r,y1:c?n:Math.min(n,d),x2:c?Math.max(r,p):p,y2:c?d:Math.max(n,d)},color:e,axisSwapped:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),
a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(h.x1,h.y1,h.width,h.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderRangeBar=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:
f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=0,h,l,t,k,g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;h=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*this.height,0.9*(this.plotArea.height/a.plotType.totalDataSeries))<<0;var r=a.axisX.dataInfo.minDiff;isFinite(r)||(r=0.3*Math.abs(a.axisX.range));r=this.options.dataPointWidth?this.dataPointWidth:0.9*
(e.height*(a.axisX.logarithmic?Math.log(r)/Math.log(a.axisX.range):Math.abs(r)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>h&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,h));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&h<g)&&(h=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));r<g&&(r=g);r>h&&(r=h);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),
this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var p=0;p<a.dataSeriesIndexes.length;p++){var n=a.dataSeriesIndexes[p],d=this.data[n],w=d.dataPoints;if(0<w.length){var m=5<r&&d.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(g=0;g<w.length;g++)if(w[g].getTime?k=w[g].x.getTime():k=w[g].x,!(k<a.axisX.dataInfo.viewPortMin||k>a.axisX.dataInfo.viewPortMax)&&!y(w[g].y)&&w[g].y.length&&"number"===typeof w[g].y[0]&&"number"===typeof w[g].y[1]){h=a.axisY.convertValueToPixel(w[g].y[0]);
l=a.axisY.convertValueToPixel(w[g].y[1]);t=a.axisX.convertValueToPixel(k);t=a.axisX.reversed?t+a.plotType.totalDataSeries*r/2-(a.previousDataSeriesCount+p)*r<<0:t-a.plotType.totalDataSeries*r/2+(a.previousDataSeriesCount+p)*r<<0;var q=a.axisX.reversed?t-r<<0:t+r<<0;h>l&&(c=h,h=l,l=c);c=w[g].color?w[g].color:d._colorSet[g%d._colorSet.length];X(b,h,t,l,q,c,0,null,m,!1,!1,!1,d.fillOpacity);c=d.dataPointIds[g];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:n,dataPointIndex:g,
x1:h,y1:t,x2:l,y2:q};c=R(c);v&&X(this._eventManager.ghostCtx,h,t,l,q,c,0,null,!1,!1,!1,!1);if(w[g].indexLabel||d.indexLabel||w[g].indexLabelFormatter||d.indexLabelFormatter)this._indexLabels.push({chartType:"rangeBar",dataPoint:w[g],dataSeries:d,indexKeyword:0,point:{x:w[g].y[1]>=w[g].y[0]?h:l,y:t+(q-t)/2},direction:w[g].y[1]>=w[g].y[0]?-1:1,bounds:{x1:Math.min(h,l),y1:t,x2:Math.max(h,l),y2:q},color:c}),this._indexLabels.push({chartType:"rangeBar",dataPoint:w[g],dataSeries:d,indexKeyword:1,point:{x:w[g].y[1]>=
w[g].y[0]?l:h,y:t+(q-t)/2},direction:w[g].y[1]>=w[g].y[0]?1:-1,bounds:{x1:Math.min(h,l),y1:t,x2:Math.max(h,l),y2:q},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,
e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderRangeArea=function(a){function f(){if(s){var a=null;0<r.lineThickness&&c.stroke();for(var b=t.length-1;0<=b;b--)a=t[b],c.lineTo(a.x,a.y),e.lineTo(a.x,a.y);c.closePath();c.globalAlpha=r.fillOpacity;c.fill();c.globalAlpha=1;e.fill();if(0<r.lineThickness){c.beginPath();c.moveTo(a.x,
a.y);for(b=0;b<t.length;b++)a=t[b],c.lineTo(a.x,a.y);c.stroke()}c.beginPath();c.moveTo(w,m);e.beginPath();e.moveTo(w,m);s={x:w,y:m};t=[];t.push({x:w,y:q})}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=this._eventManager.ghostCtx,g=[],h=this.plotArea;c.save();v&&e.save();c.beginPath();c.rect(h.x1,h.y1,h.width,h.height);c.clip();v&&(e.beginPath(),e.rect(h.x1,h.y1,h.width,h.height),e.clip());for(var l=0;l<a.dataSeriesIndexes.length;l++){var t=
[],k=a.dataSeriesIndexes[l],r=this.data[k],p=r.dataPoints,g=r.id;this._eventManager.objectMap[g]={objectType:"dataSeries",dataSeriesIndex:k};g=R(g);e.fillStyle=g;var g=[],n=!0,d=0,w,m,q,u,s=null;if(0<p.length){var y=r._colorSet[d%r._colorSet.length],x=r.lineColor=r.options.lineColor||y,B=x;c.fillStyle=y;c.strokeStyle=x;c.lineWidth=r.lineThickness;var A="solid";if(c.setLineDash){var z=F(r.nullDataLineDashType,r.lineThickness),A=r.lineDashType,C=F(A,r.lineThickness);c.setLineDash(C)}for(var L=!0;d<
p.length;d++)if(u=p[d].x.getTime?p[d].x.getTime():p[d].x,!(u<a.axisX.dataInfo.viewPortMin||u>a.axisX.dataInfo.viewPortMax&&(!r.connectNullData||!L)))if(null!==p[d].y&&p[d].y.length&&"number"===typeof p[d].y[0]&&"number"===typeof p[d].y[1]){w=a.axisX.convertValueToPixel(u);m=a.axisY.convertValueToPixel(p[d].y[0]);q=a.axisY.convertValueToPixel(p[d].y[1]);n||L?(r.connectNullData&&!n?(c.setLineDash&&(r.options.nullDataLineDashType||A===r.lineDashType&&r.lineDashType!==r.nullDataLineDashType)&&(t[t.length-
1].newLineDashArray=C,A=r.nullDataLineDashType,c.setLineDash(z)),c.lineTo(w,m),v&&e.lineTo(w,m),t.push({x:w,y:q})):(c.beginPath(),c.moveTo(w,m),s={x:w,y:m},t=[],t.push({x:w,y:q}),v&&(e.beginPath(),e.moveTo(w,m))),L=n=!1):(c.lineTo(w,m),t.push({x:w,y:q}),v&&e.lineTo(w,m),0==d%250&&f());u=r.dataPointIds[d];this._eventManager.objectMap[u]={id:u,objectType:"dataPoint",dataSeriesIndex:k,dataPointIndex:d,x1:w,y1:m,y2:q};d<p.length-1&&(B!==(p[d].lineColor||x)||A!==(p[d].lineDashType||r.lineDashType))&&(f(),
B=p[d].lineColor||x,t[t.length-1].newStrokeStyle=B,c.strokeStyle=B,c.setLineDash&&(p[d].lineDashType?(A=p[d].lineDashType,t[t.length-1].newLineDashArray=F(A,r.lineThickness),c.setLineDash(t[t.length-1].newLineDashArray)):(A=r.lineDashType,t[t.length-1].newLineDashArray=C,c.setLineDash(C))));if(0!==p[d].markerSize&&(0<p[d].markerSize||0<r.markerSize)){var K=r.getMarkerProperties(d,w,q,c);g.push(K);var da=R(u);v&&g.push({x:w,y:q,ctx:e,type:K.type,size:K.size,color:da,borderColor:da,borderThickness:K.borderThickness});
K=r.getMarkerProperties(d,w,m,c);g.push(K);da=R(u);v&&g.push({x:w,y:m,ctx:e,type:K.type,size:K.size,color:da,borderColor:da,borderThickness:K.borderThickness})}if(p[d].indexLabel||r.indexLabel||p[d].indexLabelFormatter||r.indexLabelFormatter)this._indexLabels.push({chartType:"rangeArea",dataPoint:p[d],dataSeries:r,indexKeyword:0,point:{x:w,y:m},direction:p[d].y[0]>p[d].y[1]===a.axisY.reversed?-1:1,color:y}),this._indexLabels.push({chartType:"rangeArea",dataPoint:p[d],dataSeries:r,indexKeyword:1,point:{x:w,
y:q},direction:p[d].y[0]>p[d].y[1]===a.axisY.reversed?1:-1,color:y})}else L||n||f(),L=!0;f();$.drawMarkers(g)}}v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(h.x1,h.y1,
h.width,h.height),this._eventManager.ghostCtx.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderRangeSplineArea=function(a){function f(a,b){var d=x(m,2);if(0<d.length){if(0<k.lineThickness){c.strokeStyle=b;c.setLineDash&&c.setLineDash(a);c.beginPath();c.moveTo(d[0].x,d[0].y);for(var f=0;f<d.length-3;f+=3){if(d[f].newStrokeStyle||d[f].newLineDashArray)c.stroke(),c.beginPath(),c.moveTo(d[f].x,
d[f].y),d[f].newStrokeStyle&&(c.strokeStyle=d[f].newStrokeStyle),d[f].newLineDashArray&&c.setLineDash(d[f].newLineDashArray);c.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y)}c.stroke()}c.beginPath();c.moveTo(d[0].x,d[0].y);v&&(e.beginPath(),e.moveTo(d[0].x,d[0].y));for(f=0;f<d.length-3;f+=3)c.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y),v&&e.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y);d=x(q,2);c.lineTo(q[q.length-1].x,q[q.length-
1].y);for(f=d.length-1;2<f;f-=3)c.bezierCurveTo(d[f-1].x,d[f-1].y,d[f-2].x,d[f-2].y,d[f-3].x,d[f-3].y),v&&e.bezierCurveTo(d[f-1].x,d[f-1].y,d[f-2].x,d[f-2].y,d[f-3].x,d[f-3].y);c.closePath();c.globalAlpha=k.fillOpacity;c.fill();v&&(e.closePath(),e.fill());c.globalAlpha=1;if(0<k.lineThickness){c.strokeStyle=b;c.setLineDash&&c.setLineDash(a);c.beginPath();c.moveTo(d[0].x,d[0].y);for(var g=f=0;f<d.length-3;f+=3,g++){if(m[g].newStrokeStyle||m[g].newLineDashArray)c.stroke(),c.beginPath(),c.moveTo(d[f].x,
d[f].y),m[g].newStrokeStyle&&(c.strokeStyle=m[g].newStrokeStyle),m[g].newLineDashArray&&c.setLineDash(m[g].newLineDashArray);c.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y)}c.stroke()}c.beginPath()}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=this._eventManager.ghostCtx,g=[],h=this.plotArea;c.save();v&&e.save();c.beginPath();c.rect(h.x1,h.y1,h.width,h.height);c.clip();v&&(e.beginPath(),e.rect(h.x1,h.y1,h.width,
h.height),e.clip());for(var l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t],r=k.dataPoints,g=k.id;this._eventManager.objectMap[g]={objectType:"dataSeries",dataSeriesIndex:t};g=R(g);e.fillStyle=g;var g=[],p=0,n,d,w,m=[],q=[];if(0<r.length){var u=k._colorSet[p%k._colorSet.length],s=k.lineColor=k.options.lineColor||u,y=s;c.fillStyle=u;c.lineWidth=k.lineThickness;var z="solid",B;if(c.setLineDash){var A=F(k.nullDataLineDashType,k.lineThickness),z=k.lineDashType;B=F(z,
k.lineThickness)}for(d=!1;p<r.length;p++)if(n=r[p].x.getTime?r[p].x.getTime():r[p].x,!(n<a.axisX.dataInfo.viewPortMin||n>a.axisX.dataInfo.viewPortMax&&(!k.connectNullData||!d)))if(null!==r[p].y&&r[p].y.length&&"number"===typeof r[p].y[0]&&"number"===typeof r[p].y[1]){n=a.axisX.convertValueToPixel(n);d=a.axisY.convertValueToPixel(r[p].y[0]);w=a.axisY.convertValueToPixel(r[p].y[1]);var C=k.dataPointIds[p];this._eventManager.objectMap[C]={id:C,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:p,
x1:n,y1:d,y2:w};m[m.length]={x:n,y:d};q[q.length]={x:n,y:w};p<r.length-1&&(y!==(r[p].lineColor||s)||z!==(r[p].lineDashType||k.lineDashType))&&(y=r[p].lineColor||s,m[m.length-1].newStrokeStyle=y,c.setLineDash&&(r[p].lineDashType?(z=r[p].lineDashType,m[m.length-1].newLineDashArray=F(z,k.lineThickness)):(z=k.lineDashType,m[m.length-1].newLineDashArray=B)));if(0!==r[p].markerSize&&(0<r[p].markerSize||0<k.markerSize)){var la=k.getMarkerProperties(p,n,d,c);g.push(la);var L=R(C);v&&g.push({x:n,y:d,ctx:e,
type:la.type,size:la.size,color:L,borderColor:L,borderThickness:la.borderThickness});la=k.getMarkerProperties(p,n,w,c);g.push(la);L=R(C);v&&g.push({x:n,y:w,ctx:e,type:la.type,size:la.size,color:L,borderColor:L,borderThickness:la.borderThickness})}if(r[p].indexLabel||k.indexLabel||r[p].indexLabelFormatter||k.indexLabelFormatter)this._indexLabels.push({chartType:"rangeSplineArea",dataPoint:r[p],dataSeries:k,indexKeyword:0,point:{x:n,y:d},direction:r[p].y[0]<=r[p].y[1]?-1:1,color:u}),this._indexLabels.push({chartType:"rangeSplineArea",
dataPoint:r[p],dataSeries:k,indexKeyword:1,point:{x:n,y:w},direction:r[p].y[0]<=r[p].y[1]?1:-1,color:u});d=!1}else 0<p&&!d&&(k.connectNullData?c.setLineDash&&(0<m.length&&(k.options.nullDataLineDashType||!r[p-1].lineDashType))&&(m[m.length-1].newLineDashArray=A,z=k.nullDataLineDashType):(f(B,s),m=[],q=[])),d=!0;f(B,s);$.drawMarkers(g)}}v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,
this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(h.x1,h.y1,h.width,h.height),this._eventManager.ghostCtx.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderWaterfall=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:
f;if(!(0>=a.dataSeriesIndexes.length)){var c=this._eventManager.ghostCtx,e=null,g=this.plotArea,h=0,l,t,k,r,p=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),h=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;t=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*this.width,0.9*(this.plotArea.width/a.plotType.totalDataSeries))<<0;var n=a.axisX.dataInfo.minDiff;
isFinite(n)||(n=0.3*Math.abs(a.axisX.range));n=this.options.dataPointWidth?this.dataPointWidth:0.6*(g.width*(a.axisX.logarithmic?Math.log(n)/Math.log(a.axisX.range):Math.abs(n)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&h>t&&(h=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,t));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&t<h)&&(t=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,h));n<h&&(n=h);n>t&&(n=t);b.save();v&&this._eventManager.ghostCtx.save();
b.beginPath();b.rect(g.x1,g.y1,g.width,g.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(g.x1,g.y1,g.width,g.height),this._eventManager.ghostCtx.clip());for(var d=0;d<a.dataSeriesIndexes.length;d++){var w=a.dataSeriesIndexes[d],m=this.data[w],q=m.dataPoints,e=m._colorSet[0];m.risingColor=m.options.risingColor?m.options.risingColor:e;m.fallingColor=m.options.fallingColor?m.options.fallingColor:"#e40a0a";var u="number"===typeof m.options.lineThickness?Math.round(m.lineThickness):
1,s=1===Math.round(u)%2?-0.5:0;if(0<q.length)for(var y=5<n&&m.bevelEnabled?!0:!1,x=!1,z=null,A=null,h=0;h<q.length;h++)if(q[h].getTime?r=q[h].x.getTime():r=q[h].x,"number"!==typeof q[h].y){if(0<h&&!x&&m.connectNullData)var C=m.options.nullDataLineDashType||!q[h-1].lineDashType?m.nullDataLineDashType:q[h-1].lineDashType;x=!0}else{l=a.axisX.convertValueToPixel(r);t=0===m.dataPointEOs[h].cumulativeSum?p:a.axisY.convertValueToPixel(m.dataPointEOs[h].cumulativeSum);k=0===m.dataPointEOs[h].cumulativeSumYStartValue?
p:a.axisY.convertValueToPixel(m.dataPointEOs[h].cumulativeSumYStartValue);l=a.axisX.reversed?l+a.plotType.totalDataSeries*n/2-(a.previousDataSeriesCount+d)*n<<0:l-a.plotType.totalDataSeries*n/2+(a.previousDataSeriesCount+d)*n<<0;var la=a.axisX.reversed?l-n<<0:l+n<<0;t>k&&(e=t,t=k,k=e);a.axisY.reversed&&(e=t,t=k,k=e);e=m.dataPointIds[h];this._eventManager.objectMap[e]={id:e,objectType:"dataPoint",dataSeriesIndex:w,dataPointIndex:h,x1:l,y1:t,x2:la,y2:k};var L=q[h].color?q[h].color:0<q[h].y?m.risingColor:
m.fallingColor;X(b,l,t,la,k,L,0,L,y,y,!1,!1,m.fillOpacity);e=R(e);v&&X(this._eventManager.ghostCtx,l,t,la,k,e,0,null,!1,!1,!1,!1);var K,L=l;K="undefined"!==typeof q[h].isIntermediateSum&&!0===q[h].isIntermediateSum||"undefined"!==typeof q[h].isCumulativeSum&&!0===q[h].isCumulativeSum?0<q[h].y?t:k:0<q[h].y?k:t;0<h&&z&&(!x||m.connectNullData)&&(x&&b.setLineDash&&b.setLineDash(F(C,u)),b.beginPath(),b.moveTo(z,A-s),b.lineTo(L,K-s),0<u&&b.stroke(),v&&(c.beginPath(),c.moveTo(z,A-s),c.lineTo(L,K-s),0<u&&
c.stroke()));x=!1;z=la;A=0<q[h].y?t:k;L=q[h].lineDashType?q[h].lineDashType:m.options.lineDashType?m.options.lineDashType:"shortDash";b.strokeStyle=q[h].lineColor?q[h].lineColor:m.options.lineColor?m.options.lineColor:"#9e9e9e";b.lineWidth=u;b.setLineDash&&(L=F(L,u),b.setLineDash(L));(q[h].indexLabel||m.indexLabel||q[h].indexLabelFormatter||m.indexLabelFormatter)&&this._indexLabels.push({chartType:"waterfall",dataPoint:q[h],dataSeries:m,point:{x:l+(la-l)/2,y:0<=q[h].y?t:k},direction:0>q[h].y===a.axisY.reversed?
1:-1,bounds:{x1:l,y1:Math.min(t,k),x2:la,y2:Math.max(t,k)},color:e})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(g.x1,g.y1,g.width,g.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};var pa=function(a,f,b,c,e,g,h,l,t){if(!(0>b)){"undefined"===typeof l&&(l=1);if(!v){var k=Number((h%(2*Math.PI)).toFixed(8));Number((g%(2*Math.PI)).toFixed(8))===k&&(h-=1E-4)}a.save();a.globalAlpha=l;"pie"===e?(a.beginPath(),a.moveTo(f.x,f.y),a.arc(f.x,f.y,b,g,h,!1),a.fillStyle=c,a.strokeStyle="white",a.lineWidth=2,a.closePath(),a.fill()):"doughnut"===e&&(a.beginPath(),
a.arc(f.x,f.y,b,g,h,!1),0<=t&&a.arc(f.x,f.y,t*b,h,g,!0),a.closePath(),a.fillStyle=c,a.strokeStyle="white",a.lineWidth=2,a.fill());a.globalAlpha=1;a.restore()}};q.prototype.renderPie=function(a){function f(){if(k&&r){for(var a=0,b=0,c=0,e=0,f=0;f<r.length;f++){var g=r[f],h=k.dataPointIds[f];d[f].id=h;d[f].objectType="dataPoint";d[f].dataPointIndex=f;d[f].dataSeriesIndex=0;var l=d[f],p={percent:null,total:null},m=null,p=t.getPercentAndTotal(k,g);if(k.indexLabelFormatter||g.indexLabelFormatter)m={chart:t.options,
dataSeries:k,dataPoint:g,total:p.total,percent:p.percent};p=g.indexLabelFormatter?g.indexLabelFormatter(m):g.indexLabel?t.replaceKeywordsWithValue(g.indexLabel,g,k,f):k.indexLabelFormatter?k.indexLabelFormatter(m):k.indexLabel?t.replaceKeywordsWithValue(k.indexLabel,g,k,f):g.label?g.label:"";t._eventManager.objectMap[h]=l;l.center={x:x.x,y:x.y};l.y=g.y;l.radius=A;l.percentInnerRadius=O;l.indexLabelText=p;l.indexLabelPlacement=k.indexLabelPlacement;l.indexLabelLineColor=g.indexLabelLineColor?g.indexLabelLineColor:
k.options.indexLabelLineColor?k.options.indexLabelLineColor:g.color?g.color:k._colorSet[f%k._colorSet.length];l.indexLabelLineThickness=y(g.indexLabelLineThickness)?k.indexLabelLineThickness:g.indexLabelLineThickness;l.indexLabelLineDashType=g.indexLabelLineDashType?g.indexLabelLineDashType:k.indexLabelLineDashType;l.indexLabelFontColor=g.indexLabelFontColor?g.indexLabelFontColor:k.indexLabelFontColor;l.indexLabelFontStyle=g.indexLabelFontStyle?g.indexLabelFontStyle:k.indexLabelFontStyle;l.indexLabelFontWeight=
g.indexLabelFontWeight?g.indexLabelFontWeight:k.indexLabelFontWeight;l.indexLabelFontSize=y(g.indexLabelFontSize)?k.indexLabelFontSize:g.indexLabelFontSize;l.indexLabelFontFamily=g.indexLabelFontFamily?g.indexLabelFontFamily:k.indexLabelFontFamily;l.indexLabelBackgroundColor=g.indexLabelBackgroundColor?g.indexLabelBackgroundColor:k.options.indexLabelBackgroundColor?k.options.indexLabelBackgroundColor:k.indexLabelBackgroundColor;l.indexLabelMaxWidth=g.indexLabelMaxWidth?g.indexLabelMaxWidth:k.indexLabelMaxWidth?
k.indexLabelMaxWidth:0.33*n.width;l.indexLabelWrap="undefined"!==typeof g.indexLabelWrap?g.indexLabelWrap:k.indexLabelWrap;l.startAngle=0===f?k.startAngle?k.startAngle/180*Math.PI:0:d[f-1].endAngle;l.startAngle=(l.startAngle+2*Math.PI)%(2*Math.PI);l.endAngle=l.startAngle+2*Math.PI/z*Math.abs(g.y);g=(l.endAngle+l.startAngle)/2;g=(g+2*Math.PI)%(2*Math.PI);l.midAngle=g;if(l.midAngle>Math.PI/2-u&&l.midAngle<Math.PI/2+u){if(0===a||d[c].midAngle>l.midAngle)c=f;a++}else if(l.midAngle>3*Math.PI/2-u&&l.midAngle<
3*Math.PI/2+u){if(0===b||d[e].midAngle>l.midAngle)e=f;b++}l.hemisphere=g>Math.PI/2&&g<=3*Math.PI/2?"left":"right";l.indexLabelTextBlock=new ka(t.plotArea.ctx,{fontSize:l.indexLabelFontSize,fontFamily:l.indexLabelFontFamily,fontColor:l.indexLabelFontColor,fontStyle:l.indexLabelFontStyle,fontWeight:l.indexLabelFontWeight,horizontalAlign:"left",backgroundColor:l.indexLabelBackgroundColor,maxWidth:l.indexLabelMaxWidth,maxHeight:l.indexLabelWrap?5*l.indexLabelFontSize:1.5*l.indexLabelFontSize,text:l.indexLabelText,
padding:0,textBaseline:"top"});l.indexLabelTextBlock.measureText()}h=g=0;p=!1;for(f=0;f<r.length;f++)l=d[(c+f)%r.length],1<a&&(l.midAngle>Math.PI/2-u&&l.midAngle<Math.PI/2+u)&&(g<=a/2&&!p?(l.hemisphere="right",g++):(l.hemisphere="left",p=!0));p=!1;for(f=0;f<r.length;f++)l=d[(e+f)%r.length],1<b&&(l.midAngle>3*Math.PI/2-u&&l.midAngle<3*Math.PI/2+u)&&(h<=b/2&&!p?(l.hemisphere="left",h++):(l.hemisphere="right",p=!0))}}function b(a){var b=t.plotArea.ctx;b.clearRect(n.x1,n.y1,n.width,n.height);b.fillStyle=
t.backgroundColor;b.fillRect(n.x1,n.y1,n.width,n.height);for(b=0;b<r.length;b++){var c=d[b].startAngle,e=d[b].endAngle;if(e>c){var f=0.07*A*Math.cos(d[b].midAngle),g=0.07*A*Math.sin(d[b].midAngle),h=!1;if(r[b].exploded){if(1E-9<Math.abs(d[b].center.x-(x.x+f))||1E-9<Math.abs(d[b].center.y-(x.y+g)))d[b].center.x=x.x+f*a,d[b].center.y=x.y+g*a,h=!0}else if(0<Math.abs(d[b].center.x-x.x)||0<Math.abs(d[b].center.y-x.y))d[b].center.x=x.x+f*(1-a),d[b].center.y=x.y+g*(1-a),h=!0;h&&(f={},f.dataSeries=k,f.dataPoint=
k.dataPoints[b],f.index=b,t.toolTip.highlightObjects([f]));pa(t.plotArea.ctx,d[b].center,d[b].radius,r[b].color?r[b].color:k._colorSet[b%k._colorSet.length],k.type,c,e,k.fillOpacity,d[b].percentInnerRadius)}}a=t.plotArea.ctx;a.save();a.fillStyle="black";a.strokeStyle="grey";a.textBaseline="middle";a.lineJoin="round";for(b=b=0;b<r.length;b++)c=d[b],c.indexLabelText&&(c.indexLabelTextBlock.y-=c.indexLabelTextBlock.height/2,e=0,e="left"===c.hemisphere?"inside"!==k.indexLabelPlacement?-(c.indexLabelTextBlock.width+
p):-c.indexLabelTextBlock.width/2:"inside"!==k.indexLabelPlacement?p:-c.indexLabelTextBlock.width/2,c.indexLabelTextBlock.x+=e,c.indexLabelTextBlock.render(!0),c.indexLabelTextBlock.x-=e,c.indexLabelTextBlock.y+=c.indexLabelTextBlock.height/2,"inside"!==c.indexLabelPlacement&&0<c.indexLabelLineThickness&&(e=c.center.x+A*Math.cos(c.midAngle),f=c.center.y+A*Math.sin(c.midAngle),a.strokeStyle=c.indexLabelLineColor,a.lineWidth=c.indexLabelLineThickness,a.setLineDash&&a.setLineDash(F(c.indexLabelLineDashType,
c.indexLabelLineThickness)),a.beginPath(),a.moveTo(e,f),a.lineTo(c.indexLabelTextBlock.x,c.indexLabelTextBlock.y),a.lineTo(c.indexLabelTextBlock.x+("left"===c.hemisphere?-p:p),c.indexLabelTextBlock.y),a.stroke()),a.lineJoin="miter");a.save()}function c(a,b){var c=0,c=a.indexLabelTextBlock.y-a.indexLabelTextBlock.height/2,d=a.indexLabelTextBlock.y+a.indexLabelTextBlock.height/2,e=b.indexLabelTextBlock.y-b.indexLabelTextBlock.height/2,f=b.indexLabelTextBlock.y+b.indexLabelTextBlock.height/2;return c=
b.indexLabelTextBlock.y>a.indexLabelTextBlock.y?e-d:c-f}function e(a){for(var b=null,e=1;e<r.length;e++)if(b=(a+e+d.length)%d.length,d[b].hemisphere!==d[a].hemisphere){b=null;break}else if(d[b].indexLabelText&&b!==a&&(0>c(d[b],d[a])||("right"===d[a].hemisphere?d[b].indexLabelTextBlock.y>=d[a].indexLabelTextBlock.y:d[b].indexLabelTextBlock.y<=d[a].indexLabelTextBlock.y)))break;else b=null;return b}function g(a,b,f){f=(f||0)+1;if(1E3<f)return 0;b=b||0;var k=0,h=x.y-1*q,n=x.y+1*q;if(0<=a&&a<r.length){var l=
d[a];if(0>b&&l.indexLabelTextBlock.y<h||0<b&&l.indexLabelTextBlock.y>n)return 0;var t=0,p=0,p=t=t=0;0>b?l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2>h&&l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2+b<h&&(b=-(h-(l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2+b))):l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2<h&&l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2+b>n&&(b=l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2+b-n);b=l.indexLabelTextBlock.y+b;h=
0;h="right"===l.hemisphere?x.x+Math.sqrt(Math.pow(q,2)-Math.pow(b-x.y,2)):x.x-Math.sqrt(Math.pow(q,2)-Math.pow(b-x.y,2));p=x.x+A*Math.cos(l.midAngle);t=x.y+A*Math.sin(l.midAngle);t=Math.sqrt(Math.pow(h-p,2)+Math.pow(b-t,2));p=Math.acos(A/q);t=Math.acos((q*q+A*A-t*t)/(2*A*q));b=t<p?b-l.indexLabelTextBlock.y:0;h=null;for(n=1;n<r.length;n++)if(h=(a-n+d.length)%d.length,d[h].hemisphere!==d[a].hemisphere){h=null;break}else if(d[h].indexLabelText&&d[h].hemisphere===d[a].hemisphere&&h!==a&&(0>c(d[h],d[a])||
("right"===d[a].hemisphere?d[h].indexLabelTextBlock.y<=d[a].indexLabelTextBlock.y:d[h].indexLabelTextBlock.y>=d[a].indexLabelTextBlock.y)))break;else h=null;p=h;t=e(a);n=h=0;0>b?(n="right"===l.hemisphere?p:t,k=b,null!==n&&(p=-b,b=l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2-(d[n].indexLabelTextBlock.y+d[n].indexLabelTextBlock.height/2),b-p<m&&(h=-p,n=g(n,h,f+1),+n.toFixed(v)>+h.toFixed(v)&&(k=b>m?-(b-m):-(p-(n-h)))))):0<b&&(n="right"===l.hemisphere?t:p,k=b,null!==n&&(p=b,b=d[n].indexLabelTextBlock.y-
d[n].indexLabelTextBlock.height/2-(l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2),b-p<m&&(h=p,n=g(n,h,f+1),+n.toFixed(v)<+h.toFixed(v)&&(k=b>m?b-m:p-(h-n)))));k&&(f=l.indexLabelTextBlock.y+k,b=0,b="right"===l.hemisphere?x.x+Math.sqrt(Math.pow(q,2)-Math.pow(f-x.y,2)):x.x-Math.sqrt(Math.pow(q,2)-Math.pow(f-x.y,2)),l.midAngle>Math.PI/2-u&&l.midAngle<Math.PI/2+u?(h=(a-1+d.length)%d.length,h=d[h],a=d[(a+1+d.length)%d.length],"left"===l.hemisphere&&"right"===h.hemisphere&&b>h.indexLabelTextBlock.x?
b=h.indexLabelTextBlock.x-15:"right"===l.hemisphere&&("left"===a.hemisphere&&b<a.indexLabelTextBlock.x)&&(b=a.indexLabelTextBlock.x+15)):l.midAngle>3*Math.PI/2-u&&l.midAngle<3*Math.PI/2+u&&(h=(a-1+d.length)%d.length,h=d[h],a=d[(a+1+d.length)%d.length],"right"===l.hemisphere&&"left"===h.hemisphere&&b<h.indexLabelTextBlock.x?b=h.indexLabelTextBlock.x+15:"left"===l.hemisphere&&("right"===a.hemisphere&&b>a.indexLabelTextBlock.x)&&(b=a.indexLabelTextBlock.x-15)),l.indexLabelTextBlock.y=f,l.indexLabelTextBlock.x=
b,l.indexLabelAngle=Math.atan2(l.indexLabelTextBlock.y-x.y,l.indexLabelTextBlock.x-x.x))}return k}function h(){var a=t.plotArea.ctx;a.fillStyle="grey";a.strokeStyle="grey";a.font="16px Arial";a.textBaseline="middle";for(var b=a=0,f=0,h=!0,b=0;10>b&&(1>b||0<f);b++){if(k.radius||!k.radius&&"undefined"!==typeof k.innerRadius&&null!==k.innerRadius&&A-f<=C)h=!1;h&&(A-=f);f=0;if("inside"!==k.indexLabelPlacement){q=A*s;for(a=0;a<r.length;a++){var l=d[a];l.indexLabelTextBlock.x=x.x+q*Math.cos(l.midAngle);
l.indexLabelTextBlock.y=x.y+q*Math.sin(l.midAngle);l.indexLabelAngle=l.midAngle;l.radius=A;l.percentInnerRadius=O}for(var u,y,a=0;a<r.length;a++){var l=d[a],z=e(a);if(null!==z){u=d[a];y=d[z];var B=0,B=c(u,y)-m;if(0>B){for(var F=y=0,sa=0;sa<r.length;sa++)sa!==a&&d[sa].hemisphere===l.hemisphere&&(d[sa].indexLabelTextBlock.y<l.indexLabelTextBlock.y?y++:F++);y=B/(y+F||1)*F;var F=-1*(B-y),J=sa=0;"right"===l.hemisphere?(sa=g(a,y),F=-1*(B-sa),J=g(z,F),+J.toFixed(v)<+F.toFixed(v)&&+sa.toFixed(v)<=+y.toFixed(v)&&
g(a,-(F-J))):(sa=g(z,y),F=-1*(B-sa),J=g(a,F),+J.toFixed(v)<+F.toFixed(v)&&+sa.toFixed(v)<=+y.toFixed(v)&&g(z,-(F-J)))}}}}else for(a=0;a<r.length;a++)l=d[a],q="pie"===k.type?0.7*A:0.8*A,z=x.x+q*Math.cos(l.midAngle),y=x.y+q*Math.sin(l.midAngle),l.indexLabelTextBlock.x=z,l.indexLabelTextBlock.y=y;for(a=0;a<r.length;a++)if(l=d[a],z=l.indexLabelTextBlock.measureText(),0!==z.height&&0!==z.width)z=z=0,"right"===l.hemisphere?(z=n.x2-(l.indexLabelTextBlock.x+l.indexLabelTextBlock.width+p),z*=-1):z=n.x1-(l.indexLabelTextBlock.x-
l.indexLabelTextBlock.width-p),0<z&&(!h&&l.indexLabelText&&(y="right"===l.hemisphere?n.x2-l.indexLabelTextBlock.x:l.indexLabelTextBlock.x-n.x1,0.3*l.indexLabelTextBlock.maxWidth>y?l.indexLabelText="":l.indexLabelTextBlock.maxWidth=0.85*y,0.3*l.indexLabelTextBlock.maxWidth<y&&(l.indexLabelTextBlock.x-="right"===l.hemisphere?2:-2)),Math.abs(l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2-x.y)<A||Math.abs(l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2-x.y)<A)&&(z/=Math.abs(Math.cos(l.indexLabelAngle)),
9<z&&(z*=0.3),z>f&&(f=z)),z=z=0,0<l.indexLabelAngle&&l.indexLabelAngle<Math.PI?(z=n.y2-(l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2+5),z*=-1):z=n.y1-(l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2-5),0<z&&(!h&&l.indexLabelText&&(y=0<l.indexLabelAngle&&l.indexLabelAngle<Math.PI?-1:1,0===g(a,z*y)&&g(a,2*y)),Math.abs(l.indexLabelTextBlock.x-x.x)<A&&(z/=Math.abs(Math.sin(l.indexLabelAngle)),9<z&&(z*=0.3),z>f&&(f=z)));var M=function(a,b,c){for(var e=[],f=0;e.push(d[b]),b!==c;b=(b+1+
r.length)%r.length);e.sort(function(a,b){return a.y-b.y});for(b=0;b<e.length;b++)if(c=e[b],f<0.7*a)f+=c.indexLabelTextBlock.height,c.indexLabelTextBlock.text="",c.indexLabelText="",c.indexLabelTextBlock.measureText();else break};(function(){for(var a=-1,b=-1,f=0,g=!1,h=0;h<r.length;h++)if(g=!1,u=d[h],u.indexLabelText){var k=e(h);if(null!==k){var l=d[k];B=0;B=c(u,l);var n;if(n=0>B){n=u.indexLabelTextBlock.x;var t=u.indexLabelTextBlock.y-u.indexLabelTextBlock.height/2,m=u.indexLabelTextBlock.y+u.indexLabelTextBlock.height/
2,w=l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2,q=l.indexLabelTextBlock.x+l.indexLabelTextBlock.width,s=l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2;n=u.indexLabelTextBlock.x+u.indexLabelTextBlock.width<l.indexLabelTextBlock.x-p||n>q+p||t>s+p||m<w-p?!1:!0}n?(0>a&&(a=h),k!==a&&(b=k,f+=-B),0===h%Math.max(r.length/10,3)&&(g=!0)):g=!0;g&&(0<f&&0<=a&&0<=b)&&(M(f,a,b),b=a=-1,f=0)}}0<f&&M(f,a,b)})()}}function l(){t.plotArea.layoutManager.reset();t.title&&(t.title.dockInsidePlotArea||
"center"===t.title.horizontalAlign&&"center"===t.title.verticalAlign)&&t.title.render();if(t.subtitles)for(var a=0;a<t.subtitles.length;a++){var b=t.subtitles[a];(b.dockInsidePlotArea||"center"===b.horizontalAlign&&"center"===b.verticalAlign)&&b.render()}t.legend&&(t.legend.dockInsidePlotArea||"center"===t.legend.horizontalAlign&&"center"===t.legend.verticalAlign)&&t.legend.render()}var t=this;if(!(0>=a.dataSeriesIndexes.length)){var k=this.data[a.dataSeriesIndexes[0]],r=k.dataPoints,p=10,n=this.plotArea,
d=k.dataPointEOs,m=2,q,s=1.3,u=20/180*Math.PI,v=6,x={x:(n.x2+n.x1)/2,y:(n.y2+n.y1)/2},z=0;a=!1;for(var B=0;B<r.length;B++)z+=Math.abs(r[B].y),!a&&("undefined"!==typeof r[B].indexLabel&&null!==r[B].indexLabel&&0<r[B].indexLabel.toString().length)&&(a=!0),!a&&("undefined"!==typeof r[B].label&&null!==r[B].label&&0<r[B].label.toString().length)&&(a=!0);if(0!==z){a=a||"undefined"!==typeof k.indexLabel&&null!==k.indexLabel&&0<k.indexLabel.toString().length;var A="inside"!==k.indexLabelPlacement&&a?0.75*
Math.min(n.width,n.height)/2:0.92*Math.min(n.width,n.height)/2;k.radius&&(A=J(k.radius,A));var C="undefined"!==typeof k.innerRadius&&null!==k.innerRadius?J(k.innerRadius,A):0.7*A;k.radius=A;"doughnut"===k.type&&(k.innerRadius=C);var O=Math.min(C/A,(A-1)/A);this.pieDoughnutClickHandler=function(a){t.isAnimating||!y(a.dataSeries.explodeOnClick)&&!a.dataSeries.explodeOnClick||(a=a.dataPoint,a.exploded=a.exploded?!1:!0,1<this.dataPoints.length&&t._animator.animate(0,500,function(a){b(a);l()}))};f();h();
h();h();h();this.disableToolTip=!0;this._animator.animate(0,this.animatedRender?this.animationDuration:0,function(a){var b=t.plotArea.ctx;b.clearRect(n.x1,n.y1,n.width,n.height);b.fillStyle=t.backgroundColor;b.fillRect(n.x1,n.y1,n.width,n.height);a=d[0].startAngle+2*Math.PI*a;for(b=0;b<r.length;b++){var c=0===b?d[b].startAngle:e,e=c+(d[b].endAngle-d[b].startAngle),f=!1;e>a&&(e=a,f=!0);var g=r[b].color?r[b].color:k._colorSet[b%k._colorSet.length];e>c&&pa(t.plotArea.ctx,d[b].center,d[b].radius,g,k.type,
c,e,k.fillOpacity,d[b].percentInnerRadius);if(f)break}l()},function(){t.disableToolTip=!1;t._animator.animate(0,t.animatedRender?500:0,function(a){b(a);l()})})}}};var qa=function(a,f,b,c){"undefined"===typeof b&&(b=1);0>=Math.round(f.y4-f.y1)||(a.save(),a.globalAlpha=b,a.beginPath(),a.moveTo(Math.round(f.x1),Math.round(f.y1)),a.lineTo(Math.round(f.x2),Math.round(f.y2)),a.lineTo(Math.round(f.x3),Math.round(f.y3)),a.lineTo(Math.round(f.x4),Math.round(f.y4)),"undefined"!==f.x5&&(a.lineTo(Math.round(f.x5),
Math.round(f.y5)),a.lineTo(Math.round(f.x6),Math.round(f.y6))),a.closePath(),a.fillStyle=c?c:f.color,a.fill(),a.globalAplha=1,a.restore())};q.prototype.renderFunnel=function(a){function f(){for(var a=0,b=[],c=0;c<x.length;c++){if("undefined"===typeof x[c].y)return-1;x[c].y="number"===typeof x[c].y?x[c].y:0;a+=Math.abs(x[c].y)}if(0===a)return-1;for(c=b[0]=0;c<x.length;c++)b.push(Math.abs(x[c].y)*J/a);return b}function b(){var a=Y,b=X,c=M,d=Z,e,f;e=ca;f=aa-P;headArea=(f-e)*(b-a+(d-c))/2;headArea=Math.abs(headArea);
c=Z-M;e=f-e;f=c*(f-aa);f=Math.abs(f);f=headArea+f;for(var d=[],g=0,h=0;h<x.length;h++){if("undefined"===typeof x[h].y)return-1;x[h].y="number"===typeof x[h].y?x[h].y:0;g+=Math.abs(x[h].y)}if(0===g)return-1;for(var k=d[0]=0,l=0,n,b=b-a,t=!1,h=0;h<x.length;h++)a=Math.abs(x[h].y)*f/g,t?k=0==Number(c.toFixed(3))?0:a/c:(sqrt=ea*ea*b*b-4*Math.abs(ea)*a,0>sqrt?(n=c,k=(b+n)*(e-l)/2,a-=k,k=e-l,l+=e-l,k+=0==n?0:a/n,l+=a/n,t=!0):(k=(Math.abs(ea)*b-Math.sqrt(sqrt))/2,n=b-2*k/Math.abs(ea),l+=k,l>e&&(l-=k,n=c,
k=(b+n)*(e-l)/2,a-=k,k=e-l,l+=e-l,k+=a/n,l+=a/n,t=!0),b=n)),d.push(k);return d}function c(){if(u&&x){for(var a,b,c,e,f,g,h,k,l,n,t,p,r,m,w=[],q=[],z={percent:null,total:null},A=null,B=0;B<x.length;B++)m=N[B],m="undefined"!==typeof m.x5?(m.y2+m.y4)/2:(m.y2+m.y3)/2,m=d(m).x2+1,w[B]=S-m-U;m=0.5*U;for(var B=0,ya=x.length-1;B<x.length||0<=ya;B++,ya--){b=u.reversed?x[ya]:x[B];a=b.color?b.color:u.reversed?u._colorSet[(x.length-1-B)%u._colorSet.length]:u._colorSet[B%u._colorSet.length];c=b.indexLabelPlacement||
u.indexLabelPlacement||"outside";e=b.indexLabelBackgroundColor||u.indexLabelBackgroundColor||(v?"transparent":null);f=b.indexLabelFontColor||u.indexLabelFontColor||"#979797";g=y(b.indexLabelFontSize)?u.indexLabelFontSize:b.indexLabelFontSize;h=b.indexLabelFontStyle||u.indexLabelFontStyle||"normal";k=b.indexLabelFontFamily||u.indexLabelFontFamily||"arial";l=b.indexLabelFontWeight||u.indexLabelFontWeight||"normal";a=b.indexLabelLineColor||u.options.indexLabelLineColor||a;n="number"===typeof b.indexLabelLineThickness?
b.indexLabelLineThickness:"number"===typeof u.indexLabelLineThickness?u.indexLabelLineThickness:2;t=b.indexLabelLineDashType||u.indexLabelLineDashType||"solid";p="undefined"!==typeof b.indexLabelWrap?b.indexLabelWrap:"undefined"!==typeof u.indexLabelWrap?u.indexLabelWrap:!0;r=u.dataPointIds[B];s._eventManager.objectMap[r]={id:r,objectType:"dataPoint",dataPointIndex:B,dataSeriesIndex:0,funnelSection:N[u.reversed?x.length-1-B:B]};"inside"===u.indexLabelPlacement&&(w[B]=B!==fa?u.reversed?N[B].x2-N[B].x1:
N[B].x3-N[B].x4:N[B].x3-N[B].x6,20>w[B]&&(w[B]=B!==fa?u.reversed?N[B].x3-N[B].x4:N[B].x2-N[B].x1:N[B].x2-N[B].x1,w[B]/=2));r=b.indexLabelMaxWidth?b.indexLabelMaxWidth:u.options.indexLabelMaxWidth?u.indexLabelMaxWidth:w[B];if(r>w[B]||0>r)r=w[B];q[B]="inside"===u.indexLabelPlacement?N[B].height:!1;z=s.getPercentAndTotal(u,b);if(u.indexLabelFormatter||b.indexLabelFormatter)A={chart:s.options,dataSeries:u,dataPoint:b,total:z.total,percent:z.percent};b=b.indexLabelFormatter?b.indexLabelFormatter(A):b.indexLabel?
s.replaceKeywordsWithValue(b.indexLabel,b,u,B):u.indexLabelFormatter?u.indexLabelFormatter(A):u.indexLabel?s.replaceKeywordsWithValue(u.indexLabel,b,u,B):b.label?b.label:"";0>=n&&(n=0);1E3>r&&1E3-r<m&&(r+=1E3-r);R.roundRect||Ba(R);c=new ka(R,{fontSize:g,fontFamily:k,fontColor:f,fontStyle:h,fontWeight:l,horizontalAlign:c,backgroundColor:e,maxWidth:r,maxHeight:!1===q[B]?p?4.28571429*g:1.5*g:q[B],text:b,padding:ga});c.measureText();G.push({textBlock:c,id:u.reversed?ya:B,isDirty:!1,lineColor:a,lineThickness:n,
lineDashType:t,height:c.height<c.maxHeight?c.height:c.maxHeight,width:c.width<c.maxWidth?c.width:c.maxWidth})}}}function e(){var a,b,c,d,e,f=[];e=!1;c=0;for(var g=S-X-U/2,g=u.options.indexLabelMaxWidth?u.indexLabelMaxWidth>g?g:u.indexLabelMaxWidth:g,h=G.length-1;0<=h;h--){dataPoint=x[G[h].id];c=G[h];d=c.textBlock;b=(a=n(h)<N.length?G[n(h)]:null)?a.textBlock:null;c=c.height;a&&d.y+c+ga>b.y&&(e=!0);c=dataPoint.indexLabelMaxWidth||g;if(c>g||0>c)c=g;f.push(c)}if(e)for(h=G.length-1;0<=h;h--)a=N[h],G[h].textBlock.maxWidth=
f[f.length-(h+1)],G[h].textBlock.measureText(),G[h].textBlock.x=S-g,c=G[h].textBlock.height<G[h].textBlock.maxHeight?G[h].textBlock.height:G[h].textBlock.maxHeight,e=G[h].textBlock.width<G[h].textBlock.maxWidth?G[h].textBlock.width:G[h].textBlock.maxWidth,G[h].height=c,G[h].width=e,c="undefined"!==typeof a.x5?(a.y2+a.y4)/2:(a.y2+a.y3)/2,G[h].textBlock.y=c-G[h].height/2,u.reversed?(G[h].textBlock.y+G[h].height>T+C&&(G[h].textBlock.y=T+C-G[h].height),G[h].textBlock.y<ra-C&&(G[h].textBlock.y=ra-C)):
(G[h].textBlock.y<T-C&&(G[h].textBlock.y=T-C),G[h].textBlock.y+G[h].height>ra+C&&(G[h].textBlock.y=ra+C-G[h].height))}function g(){var a,b,c,e;if("inside"!==u.indexLabelPlacement)for(var f=0;f<N.length;f++)0==G[f].textBlock.text.length?G[f].isDirty=!0:(a=N[f],c="undefined"!==typeof a.x5?(a.y2+a.y4)/2:(a.y2+a.y3)/2,b=u.reversed?"undefined"!==typeof a.x5?c>ba?d(c).x2+1:(a.x2+a.x3)/2+1:(a.x2+a.x3)/2+1:"undefined"!==typeof a.x5?c<ba?d(c).x2+1:(a.x4+a.x3)/2+1:(a.x2+a.x3)/2+1,G[f].textBlock.x=b+U,G[f].textBlock.y=
c-G[f].height/2,u.reversed?(G[f].textBlock.y+G[f].height>T+C&&(G[f].textBlock.y=T+C-G[f].height),G[f].textBlock.y<ra-C&&(G[f].textBlock.y=ra-C)):(G[f].textBlock.y<T-C&&(G[f].textBlock.y=T-C),G[f].textBlock.y+G[f].height>ra+C&&(G[f].textBlock.y=ra+C-G[f].height)));else for(f=0;f<N.length;f++)0==G[f].textBlock.text.length?G[f].isDirty=!0:(a=N[f],b=a.height,c=G[f].height,e=G[f].width,b>=c?(b=f!=fa?(a.x4+a.x3)/2-e/2:(a.x5+a.x4)/2-e/2,c=f!=fa?(a.y1+a.y3)/2-c/2:(a.y1+a.y4)/2-c/2,G[f].textBlock.x=b,G[f].textBlock.y=
c):G[f].isDirty=!0)}function h(){function a(b,c){var d;if(0>b||b>=G.length)return 0;var e,f=G[b].textBlock;if(0>c){c*=-1;e=p(b);d=l(e,b);if(d>=c)return f.y-=c,c;if(0==b)return 0<d&&(f.y-=d),d;d+=a(e,-(c-d));0<d&&(f.y-=d);return d}e=n(b);d=l(b,e);if(d>=c)return f.y+=c,c;if(b==N.length-1)return 0<d&&(f.y+=d),d;d+=a(e,c-d);0<d&&(f.y+=d);return d}function b(){var a,d,e,f,g=0,h;f=(aa-ca+2*C)/t;h=t;for(var k,l=1;l<h;l++){e=l*f;for(var r=G.length-1;0<=r;r--)!G[r].isDirty&&(G[r].textBlock.y<e&&G[r].textBlock.y+
G[r].height>e)&&(k=n(r),!(k>=G.length-1)&&G[r].textBlock.y+G[r].height+ga>G[k].textBlock.y&&(G[r].textBlock.y=G[r].textBlock.y+G[r].height-e>e-G[r].textBlock.y?e+1:e-G[r].height-1))}for(k=N.length-1;0<k;k--)if(!G[k].isDirty){e=p(k);if(0>e&&(e=0,G[e].isDirty))break;if(G[k].textBlock.y<G[e].textBlock.y+G[e].height){d=d||k;f=k;for(h=0;G[f].textBlock.y<G[e].textBlock.y+G[e].height+ga;){a=a||G[f].textBlock.y+G[f].height;h+=G[f].height;h+=ga;f=e;if(0>=f){f=0;h+=G[f].height;break}e=p(f);if(0>e){f=0;h+=G[f].height;
break}}if(f!=k){g=G[f].textBlock.y;a-=g;a=h-a;g=c(a,d,f);break}}}return g}function c(a,b,d){var e=[],f=0,g=0;for(a=Math.abs(a);d<=b;d++)e.push(N[d]);e.sort(function(a,b){return a.height-b.height});for(d=0;d<e.length;d++)if(b=e[d],f<a)g++,f+=G[b.id].height+ga,G[b.id].textBlock.text="",G[b.id].indexLabelText="",G[b.id].isDirty=!0,G[b.id].textBlock.measureText();else break;return g}for(var d,e,f,g,h,k,t=1,r=0;r<2*t;r++){for(var m=G.length-1;0<=m&&!(previousTextBlock=(previousLabel=0<=p(m)?G[p(m)]:null)?
previousLabel.textBlock:null,f=G[m],g=f.textBlock,k=(h=n(m)<N.length?G[n(m)]:null)?h.textBlock:null,d=+f.height.toFixed(6),e=+g.y.toFixed(6),!f.isDirty&&(h&&e+d+ga>+k.y.toFixed(6))&&(d=g.y+d+ga-k.y,e=a(m,-d),e<d&&(0<e&&(d-=e),e=a(n(m),d),e!=d)));m--);b()}}function l(a,b){return(b<N.length?G[b].textBlock.y:u.reversed?T+C:ra+C)-(0>a?u.reversed?ra-C:T-C:G[a].textBlock.y+G[a].height+ga)}function t(a,b,c){var d,e,f,h=[],l=C,n=[];-1!==b&&(0<=$.indexOf(b)?(e=$.indexOf(b),$.splice(e,1)):($.push(b),$=$.sort(function(a,
b){return a-b})));if(0===$.length)h=ja;else{e=C*(1!=$.length||0!=$[0]&&$[0]!=N.length-1?2:1)/k();for(var t=0;t<N.length;t++){if(1==$.length&&0==$[0]){if(0===t){h.push(ja[t]);d=l;continue}}else 0===t&&(d=-1*l);h.push(ja[t]+d);if(0<=$.indexOf(t)||t<N.length&&0<=$.indexOf(t+1))d+=e}}f=function(){for(var a=[],b=0;b<N.length;b++)a.push(h[b]-N[b].y1);return a}();var p={startTime:(new Date).getTime(),duration:c||500,easingFunction:function(a,b,c,d){return O.easing.easeOutQuart(a,b,c,d)},changeSection:function(a){for(var b,
c,d=0;d<N.length;d++)b=f[d],c=N[d],newY=b*a,"undefined"===typeof n[d]&&(n[d]=0),0>n&&(n*=-1),c.y1+=newY-n[d],c.y2+=newY-n[d],c.y3+=newY-n[d],c.y4+=newY-n[d],c.y5&&(c.y5+=newY-n[d],c.y6+=newY-n[d]),n[d]=newY}};a._animator.animate(0,c,function(c){var d=a.plotArea.ctx||a.ctx;ia=!0;d.clearRect(z.x1,z.y1,z.x2-z.x1,z.y2-z.y1);d.fillStyle=a.backgroundColor;d.fillRect(z.x1,z.y1,z.width,z.height);p.changeSection(c,b);var e={};e.dataSeries=u;e.dataPoint=u.reversed?u.dataPoints[x.length-1-b]:u.dataPoints[b];
e.index=u.reversed?x.length-1-b:b;a.toolTip.highlightObjects([e]);for(e=0;e<N.length;e++)qa(d,N[e],u.fillOpacity);q(d);L&&("inside"!==u.indexLabelPlacement?r(d):g(),m(d));1<=c&&(ia=!1)},null,O.easing.easeOutQuart)}function k(){for(var a=0,b=0;b<N.length-1;b++)(0<=$.indexOf(b)||0<=$.indexOf(b+1))&&a++;return a}function r(a){for(var b,c,e,f,g=0;g<N.length;g++)f=1===G[g].lineThickness%2?0.5:0,c=((N[g].y2+N[g].y4)/2<<0)+f,b=d(c).x2-1,e=G[g].textBlock.x,f=(G[g].textBlock.y+G[g].height/2<<0)+f,G[g].isDirty||
0==G[g].lineThickness||(a.strokeStyle=G[g].lineColor,a.lineWidth=G[g].lineThickness,a.setLineDash&&a.setLineDash(F(G[g].lineDashType,G[g].lineThickness)),a.beginPath(),a.moveTo(b,c),a.lineTo(e,f),a.stroke())}function p(a){for(a-=1;-1<=a&&-1!=a&&G[a].isDirty;a--);return a}function n(a){for(a+=1;a<=N.length&&a!=N.length&&G[a].isDirty;a++);return a}function d(a){for(var b,c=0;c<x.length;c++)if(N[c].y1<a&&N[c].y4>a){b=N[c];break}return b?(a=b.y6?a>b.y6?b.x3+(b.x4-b.x3)/(b.y4-b.y3)*(a-b.y3):b.x2+(b.x3-
b.x2)/(b.y3-b.y2)*(a-b.y2):b.x2+(b.x3-b.x2)/(b.y3-b.y2)*(a-b.y2),{x1:a,x2:a}):-1}function m(a){for(var b=0;b<N.length;b++)G[b].isDirty||(a&&(G[b].textBlock.ctx=a),G[b].textBlock.render(!0))}function q(a){s.plotArea.layoutManager.reset();a.roundRect||Ba(a);s.title&&(s.title.dockInsidePlotArea||"center"===s.title.horizontalAlign&&"center"===s.title.verticalAlign)&&(s.title.ctx=a,s.title.render());if(s.subtitles)for(var b=0;b<s.subtitles.length;b++){var c=s.subtitles[b];if(c.dockInsidePlotArea||"center"===
c.horizontalAlign&&"center"===c.verticalAlign)s.subtitles.ctx=a,c.render()}s.legend&&(s.legend.dockInsidePlotArea||"center"===s.legend.horizontalAlign&&"center"===s.legend.verticalAlign)&&(s.legend.ctx=a,s.legend.render());W.fNg&&W.fNg(s)}var s=this;if(!(0>=a.dataSeriesIndexes.length)){for(var u=this.data[a.dataSeriesIndexes[0]],x=u.dataPoints,z=this.plotArea,C=0.025*z.width,B=0.01*z.width,A=0,J=z.height-2*C,I=Math.min(z.width-2*B,2.8*z.height),L=!1,K=0;K<x.length;K++)if(!L&&("undefined"!==typeof x[K].indexLabel&&
null!==x[K].indexLabel&&0<x[K].indexLabel.toString().length)&&(L=!0),!L&&("undefined"!==typeof x[K].label&&null!==x[K].label&&0<x[K].label.toString().length)&&(L=!0),!L&&"function"===typeof u.indexLabelFormatter||"function"===typeof x[K].indexLabelFormatter)L=!0;L=L||"undefined"!==typeof u.indexLabel&&null!==u.indexLabel&&0<u.indexLabel.toString().length;"inside"!==u.indexLabelPlacement&&L||(B=(z.width-0.75*I)/2);var K=z.x1+B,S=z.x2-B,ca=z.y1+C,aa=z.y2-C,R=a.targetCanvasCtx||this.plotArea.ctx||this.ctx;
if(0!=u.length&&(u.dataPoints&&u.visible)&&0!==x.length){var P,E;a=75*I/100;var U=30*(S-a)/100;"funnel"===u.type?(P=y(u.options.neckHeight)?0.35*J:u.neckHeight,E=y(u.options.neckWidth)?0.25*a:u.neckWidth,"string"===typeof P&&P.match(/%$/)?(P=parseInt(P),P=P*J/100):P=parseInt(P),"string"===typeof E&&E.match(/%$/)?(E=parseInt(E),E=E*a/100):E=parseInt(E),P>J?P=J:0>=P&&(P=0),E>a?E=a-0.5:0>=E&&(E=0)):"pyramid"===u.type&&(E=P=0,u.reversed=u.reversed?!1:!0);var B=K+a/2,Y=K,X=K+a,T=u.reversed?aa:ca,M=B-E/
2,Z=B+E/2,ba=u.reversed?ca+P:aa-P,ra=u.reversed?ca:aa;a=[];var B=[],N=[],I=[],V=ca,fa,ea=(ba-T)/(M-Y),ha=-ea,K="area"===(u.valueRepresents?u.valueRepresents:"height")?b():f();if(-1!==K){if(u.reversed)for(I.push(V),E=K.length-1;0<E;E--)V+=K[E],I.push(V);else for(E=0;E<K.length;E++)V+=K[E],I.push(V);if(u.reversed)for(E=0;E<K.length;E++)I[E]<ba?(a.push(M),B.push(Z),fa=E):(a.push((I[E]-T+ea*Y)/ea),B.push((I[E]-T+ha*X)/ha));else for(E=0;E<K.length;E++)I[E]<ba?(a.push((I[E]-T+ea*Y)/ea),B.push((I[E]-T+ha*
X)/ha),fa=E):(a.push(M),B.push(Z));for(E=0;E<K.length-1;E++)V=u.reversed?x[x.length-1-E].color?x[x.length-1-E].color:u._colorSet[(x.length-1-E)%u._colorSet.length]:x[E].color?x[E].color:u._colorSet[E%u._colorSet.length],E===fa?N.push({x1:a[E],y1:I[E],x2:B[E],y2:I[E],x3:Z,y3:ba,x4:B[E+1],y4:I[E+1],x5:a[E+1],y5:I[E+1],x6:M,y6:ba,id:E,height:I[E+1]-I[E],color:V}):N.push({x1:a[E],y1:I[E],x2:B[E],y2:I[E],x3:B[E+1],y3:I[E+1],x4:a[E+1],y4:I[E+1],id:E,height:I[E+1]-I[E],color:V});var ga=2,G=[],ia=!1,$=[],
ja=[],K=!1;a=a=0;Ca($);for(E=0;E<x.length;E++)x[E].exploded&&(K=!0,u.reversed?$.push(x.length-1-E):$.push(E));R.clearRect(z.x1,z.y1,z.width,z.height);R.fillStyle=s.backgroundColor;R.fillRect(z.x1,z.y1,z.width,z.height);if(L&&u.visible&&(c(),g(),e(),"inside"!==u.indexLabelPlacement)){h();for(E=0;E<x.length;E++)G[E].isDirty||(a=G[E].textBlock.x+G[E].width,a=(S-a)/2,0==E&&(A=a),A>a&&(A=a));for(E=0;E<N.length;E++)N[E].x1+=A,N[E].x2+=A,N[E].x3+=A,N[E].x4+=A,N[E].x5&&(N[E].x5+=A,N[E].x6+=A),G[E].textBlock.x+=
A}for(E=0;E<N.length;E++)A=N[E],qa(R,A,u.fillOpacity),ja.push(A.y1);q(R);L&&u.visible&&("inside"===u.indexLabelPlacement||s.animationEnabled||r(R),s.animationEnabled||m());if(!L)for(E=0;E<x.length;E++)A=u.dataPointIds[E],a={id:A,objectType:"dataPoint",dataPointIndex:E,dataSeriesIndex:0,funnelSection:N[u.reversed?x.length-1-E:E]},s._eventManager.objectMap[A]=a;!s.animationEnabled&&K?t(s,-1,0):s.animationEnabled&&!s.animatedRender&&t(s,-1,0);this.funnelPyramidClickHandler=function(a){var b=-1;if(!ia&&
!s.isAnimating&&(y(a.dataSeries.explodeOnClick)||a.dataSeries.explodeOnClick)&&(b=u.reversed?x.length-1-a.dataPointIndex:a.dataPointIndex,0<=b)){a=b;if("funnel"===u.type||"pyramid"===u.type)u.reversed?x[x.length-1-a].exploded=x[x.length-1-a].exploded?!1:!0:x[a].exploded=x[a].exploded?!1:!0;t(s,b,500)}};return{source:R,dest:this.plotArea.ctx,animationCallback:function(a,b){O.fadeInAnimation(a,b);1<=a&&(t(s,-1,500),q(s.plotArea.ctx||s.ctx))},easingFunction:O.easing.easeInQuad,animationBase:0}}}}};q.prototype.requestAnimFrame=
function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(a){window.setTimeout(a,1E3/60)}}();q.prototype.cancelRequestAnimFrame=window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.mozCancelRequestAnimationFrame||window.oCancelRequestAnimationFrame||window.msCancelRequestAnimationFrame||clearTimeout;q.prototype.set=function(a,f,b){b="undefined"===
typeof b?!0:b;"options"===a?(this.options=f,b&&this.render()):q.base.set.call(this,a,f,b)};q.prototype.exportChart=function(a){a="undefined"===typeof a?{}:a;var f=a.format?a.format:"png",b=a.fileName?a.fileName:this.exportFileName;if(a.toDataURL)return this.canvas.toDataURL("image/"+f);s(this.canvas,f,b)};q.prototype.print=function(){var a=this.exportChart({toDataURL:!0}),f=document.createElement("iframe");f.setAttribute("class","canvasjs-chart-print-frame");f.setAttribute("style","position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;");
f.style.height=this.height+"px";this._canvasJSContainer.appendChild(f);var b=this,c=f.contentWindow||f.contentDocument.document||f.contentDocument;c.document.open();c.document.write('<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="'+a+'"/><body/></html>');c.document.close();setTimeout(function(){c.focus();c.print();setTimeout(function(){b._canvasJSContainer.removeChild(f)},1E3)},500)};q.prototype.getPercentAndTotal=function(a,f){var b=null,c=null,
e=null;if(0<=a.type.indexOf("stacked"))c=0,b=f.x.getTime?f.x.getTime():f.x,b in a.plotUnit.yTotals&&(c=a.plotUnit.yTotals[b],e=isNaN(f.y)?0:100*(f.y/c));else if("pie"===a.type||"doughnut"===a.type||"funnel"===a.type||"pyramid"===a.type){for(i=c=0;i<a.dataPoints.length;i++)isNaN(a.dataPoints[i].y)||(c+=a.dataPoints[i].y);e=isNaN(f.y)?0:100*(f.y/c)}return{percent:e,total:c}};q.prototype.replaceKeywordsWithValue=function(a,f,b,c,e){var g=this;e="undefined"===typeof e?0:e;if((0<=b.type.indexOf("stacked")||
"pie"===b.type||"doughnut"===b.type||"funnel"===b.type||"pyramid"===b.type)&&(0<=a.indexOf("#percent")||0<=a.indexOf("#total"))){var h="#percent",l="#total",t=this.getPercentAndTotal(b,f),l=isNaN(t.total)?l:t.total,h=isNaN(t.percent)?h:t.percent;do{t="";if(b.percentFormatString)t=b.percentFormatString;else{var t="#,##0.",k=Math.max(Math.ceil(Math.log(1/Math.abs(h))/Math.LN10),2);if(isNaN(k)||!isFinite(k))k=2;for(var r=0;r<k;r++)t+="#";b.percentFormatString=t}a=a.replace("#percent",V(h,t,g._cultureInfo));
a=a.replace("#total",V(l,b.yValueFormatString?b.yValueFormatString:"#,##0.########",g._cultureInfo))}while(0<=a.indexOf("#percent")||0<=a.indexOf("#total"))}return a.replace(/\{.*?\}|"[^"]*"|'[^']*'/g,function(a){if('"'===a[0]&&'"'===a[a.length-1]||"'"===a[0]&&"'"===a[a.length-1])return a.slice(1,a.length-1);a=Fa(a.slice(1,a.length-1));a=a.replace("#index",e);var h=null;try{var d=a.match(/(.*?)\s*\[\s*(.*?)\s*\]/);d&&0<d.length&&(h=Fa(d[2]),a=Fa(d[1]))}catch(k){}d=null;if("color"===a)return"waterfall"===
b.type?f.color?f.color:0<f.y?b.risingColor:b.fallingColor:"error"===b.type?b.color?b.color:b._colorSet[h%b._colorSet.length]:f.color?f.color:b.color?b.color:b._colorSet[c%b._colorSet.length];if(f.hasOwnProperty(a))d=f;else if(b.hasOwnProperty(a))d=b;else return"";d=d[a];null!==h&&(d=d[h]);if("x"===a)if("dateTime"===b.axisX.valueType||"dateTime"===b.xValueType||f.x&&f.x.getTime){if(g.plotInfo.plotTypes[0].plotUnits[0].axisX&&!g.plotInfo.plotTypes[0].plotUnits[0].axisX.logarithmic)return Aa(d,f.xValueFormatString?
f.xValueFormatString:b.xValueFormatString?b.xValueFormatString:b.xValueFormatString=g.axisX&&g.axisX.autoValueFormatString?g.axisX.autoValueFormatString:"DD MMM YY",g._cultureInfo)}else return V(d,f.xValueFormatString?f.xValueFormatString:b.xValueFormatString?b.xValueFormatString:b.xValueFormatString="#,##0.########",g._cultureInfo);else return"y"===a?V(d,f.yValueFormatString?f.yValueFormatString:b.yValueFormatString?b.yValueFormatString:b.yValueFormatString="#,##0.########",g._cultureInfo):"z"===
a?V(d,f.zValueFormatString?f.zValueFormatString:b.zValueFormatString?b.zValueFormatString:b.zValueFormatString="#,##0.########",g._cultureInfo):d})};na(T,Y);T.prototype.render=function(){var a=this.dockInsidePlotArea?this.chart.plotArea:this.chart,f=a.layoutManager.getFreeSpace(),b=null,c=0,e=0,g=0,h=0,l=this.markerMargin=this.chart.options.legend&&!y(this.chart.options.legend.markerMargin)?this.chart.options.legend.markerMargin:0.3*this.fontSize;this.height=0;var t=[],k=[];"top"===this.verticalAlign||
"bottom"===this.verticalAlign?(this.orientation="horizontal",b=this.verticalAlign,g=this.maxWidth=null!==this.maxWidth?this.maxWidth:f.width,h=this.maxHeight=null!==this.maxHeight?this.maxHeight:0.5*f.height):"center"===this.verticalAlign&&(this.orientation="vertical",b=this.horizontalAlign,g=this.maxWidth=null!==this.maxWidth?this.maxWidth:0.5*f.width,h=this.maxHeight=null!==this.maxHeight?this.maxHeight:f.height);for(var r=[],p=0;p<this.dataSeries.length;p++){var n=this.dataSeries[p];if(n.dataPoints&&
n.dataPoints.length)if("pie"!==n.type&&"doughnut"!==n.type&&"funnel"!==n.type&&"pyramid"!==n.type){var d=n.legendMarkerType=n.legendMarkerType?n.legendMarkerType:"line"!==n.type&&"stepLine"!==n.type&&"spline"!==n.type&&"scatter"!==n.type&&"bubble"!==n.type||!n.markerType?"error"===n.type&&n._linkedSeries?n._linkedSeries.legendMarkerType?n._linkedSeries.legendMarkerType:S.getDefaultLegendMarker(n._linkedSeries.type):S.getDefaultLegendMarker(n.type):n.markerType,m=n.legendText?n.legendText:this.itemTextFormatter?
this.itemTextFormatter({chart:this.chart,legend:this.options,dataSeries:n,dataPoint:null}):n.name,q=n.legendMarkerColor=n.legendMarkerColor?n.legendMarkerColor:n.markerColor?n.markerColor:"error"===n.type?y(n.whiskerColor)?n._colorSet[0]:n.whiskerColor:n._colorSet[0],s=n.markerSize||"line"!==n.type&&"stepLine"!==n.type&&"spline"!==n.type?0.75*this.lineHeight:0,u=n.legendMarkerBorderColor?n.legendMarkerBorderColor:n.markerBorderColor,v=n.legendMarkerBorderThickness?n.legendMarkerBorderThickness:n.markerBorderThickness?
Math.max(1,Math.round(0.2*s)):0;"error"===n.type&&r.push(q);m=this.chart.replaceKeywordsWithValue(m,n.dataPoints[0],n,p);d={markerType:d,markerColor:q,text:m,textBlock:null,chartType:n.type,markerSize:s,lineColor:n._colorSet[0],dataSeriesIndex:n.index,dataPointIndex:null,markerBorderColor:u,markerBorderThickness:v};t.push(d)}else for(var x=0;x<n.dataPoints.length;x++){var z=n.dataPoints[x],d=z.legendMarkerType?z.legendMarkerType:n.legendMarkerType?n.legendMarkerType:S.getDefaultLegendMarker(n.type),
m=z.legendText?z.legendText:n.legendText?n.legendText:this.itemTextFormatter?this.itemTextFormatter({chart:this.chart,legend:this.options,dataSeries:n,dataPoint:z}):z.name?z.name:"DataPoint: "+(x+1),q=z.legendMarkerColor?z.legendMarkerColor:n.legendMarkerColor?n.legendMarkerColor:z.color?z.color:n.color?n.color:n._colorSet[x%n._colorSet.length],s=0.75*this.lineHeight,u=z.legendMarkerBorderColor?z.legendMarkerBorderColor:n.legendMarkerBorderColor?n.legendMarkerBorderColor:z.markerBorderColor?z.markerBorderColor:
n.markerBorderColor,v=z.legendMarkerBorderThickness?z.legendMarkerBorderThickness:n.legendMarkerBorderThickness?n.legendMarkerBorderThickness:z.markerBorderThickness||n.markerBorderThickness?Math.max(1,Math.round(0.2*s)):0,m=this.chart.replaceKeywordsWithValue(m,z,n,x),d={markerType:d,markerColor:q,text:m,textBlock:null,chartType:n.type,markerSize:s,dataSeriesIndex:p,dataPointIndex:x,markerBorderColor:u,markerBorderThickness:v};(z.showInLegend||n.showInLegend&&!1!==z.showInLegend)&&t.push(d)}}!0===
this.reversed&&t.reverse();if(0<t.length){n=null;m=x=z=v=0;z=null!==this.itemWidth?null!==this.itemMaxWidth?Math.min(this.itemWidth,this.itemMaxWidth,g):this.itemMaxWidth=Math.min(this.itemWidth,g):null!==this.itemMaxWidth?Math.min(this.itemMaxWidth,g):this.itemMaxWidth=g;s=0===s?0.75*this.lineHeight:s;z-=s+l;for(p=0;p<t.length;p++){d=t[p];q=z;if("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType)q-=2*0.1*this.lineHeight;if(!(0>=h||"undefined"===typeof h||0>=q||"undefined"===typeof q)){if("horizontal"===
this.orientation){d.textBlock=new ka(this.ctx,{x:0,y:0,maxWidth:q,maxHeight:this.itemWrap?h:this.lineHeight,angle:0,text:d.text,horizontalAlign:"left",fontSize:this.fontSize,fontFamily:this.fontFamily,fontWeight:this.fontWeight,fontColor:this.fontColor,fontStyle:this.fontStyle,textBaseline:"middle"});d.textBlock.measureText();null!==this.itemWidth&&(d.textBlock.width=this.itemWidth-(s+l+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0)));if(!n||n.width+
Math.round(d.textBlock.width+s+l+(0===n.width?0:this.horizontalSpacing)+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0))>g)n={items:[],width:0},k.push(n),this.height+=x,x=0;x=Math.max(x,d.textBlock.height)}else d.textBlock=new ka(this.ctx,{x:0,y:0,maxWidth:z,maxHeight:!0===this.itemWrap?h:1.5*this.fontSize,angle:0,text:d.text,horizontalAlign:"left",fontSize:this.fontSize,fontFamily:this.fontFamily,fontWeight:this.fontWeight,fontColor:this.fontColor,
fontStyle:this.fontStyle,textBaseline:"middle"}),d.textBlock.measureText(),null!==this.itemWidth&&(d.textBlock.width=this.itemWidth-(s+l+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0))),this.height<h-this.lineHeight?(n={items:[],width:0},k.push(n)):(n=k[v],v=(v+1)%k.length),this.height+=d.textBlock.height;d.textBlock.x=n.width;d.textBlock.y=0;n.width+=Math.round(d.textBlock.width+s+l+(0===n.width?0:this.horizontalSpacing)+("line"===d.chartType||"spline"===
d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0));n.items.push(d);this.width=Math.max(n.width,this.width);m=d.textBlock.width+(s+l+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0))}}this.itemWidth=m;this.height=!1===this.itemWrap?k.length*this.lineHeight:this.height+x;this.height=Math.min(h,this.height);this.width=Math.min(g,this.width)}"top"===this.verticalAlign?(e="left"===this.horizontalAlign?f.x1:"right"===this.horizontalAlign?f.x2-
this.width:f.x1+f.width/2-this.width/2,c=f.y1):"center"===this.verticalAlign?(e="left"===this.horizontalAlign?f.x1:"right"===this.horizontalAlign?f.x2-this.width:f.x1+f.width/2-this.width/2,c=f.y1+f.height/2-this.height/2):"bottom"===this.verticalAlign&&(e="left"===this.horizontalAlign?f.x1:"right"===this.horizontalAlign?f.x2-this.width:f.x1+f.width/2-this.width/2,c=f.y2-this.height);this.items=t;for(p=0;p<this.items.length;p++)d=t[p],d.id=++this.chart._eventManager.lastObjectId,this.chart._eventManager.objectMap[d.id]=
{id:d.id,objectType:"legendItem",legendItemIndex:p,dataSeriesIndex:d.dataSeriesIndex,dataPointIndex:d.dataPointIndex};(0<this.borderThickness&&this.borderColor||this.backgroundColor)&&this.ctx.roundRect(e,c,this.width,this.height,this.cornerRadius,this.borderThickness,this.backgroundColor,this.borderColor);for(p=f=0;p<k.length;p++){n=k[p];for(z=x=0;z<n.items.length;z++){d=n.items[z];q=d.textBlock.x+e+(0===z?0.2*s:this.horizontalSpacing);u=c+f;m=q;this.chart.data[d.dataSeriesIndex].visible||(this.ctx.globalAlpha=
0.5);this.ctx.save();this.ctx.beginPath();this.ctx.rect(e,c,g,Math.max(h-h%this.lineHeight,0));this.ctx.clip();if("line"===d.chartType||"stepLine"===d.chartType||"spline"===d.chartType)this.ctx.strokeStyle=d.lineColor,this.ctx.lineWidth=Math.ceil(this.lineHeight/8),this.ctx.beginPath(),this.ctx.moveTo(q-0.1*this.lineHeight,u+this.lineHeight/2),this.ctx.lineTo(q+0.85*this.lineHeight,u+this.lineHeight/2),this.ctx.stroke(),m-=0.1*this.lineHeight;if("error"===d.chartType){this.ctx.strokeStyle=r[0];v=
s/8;this.ctx.lineWidth=v;this.ctx.beginPath();var v=q-0.08*this.lineHeight+0.1*this.lineHeight,B=u+0.15*this.lineHeight,A=0.7*this.lineHeight,C=A+0.02*this.lineHeight;this.ctx.moveTo(v,B);this.ctx.lineTo(v+A,B);this.ctx.stroke();this.ctx.beginPath();this.ctx.moveTo(v+A/2,B);this.ctx.lineTo(v+A/2,B+C);this.ctx.stroke();this.ctx.beginPath();this.ctx.moveTo(v,B+C);this.ctx.lineTo(v+A,B+C);this.ctx.stroke();r.shift()}$.drawMarker(q+s/2,u+this.lineHeight/2,this.ctx,d.markerType,"error"===d.chartType||
"line"===d.chartType||"spline"===d.chartType?d.markerSize/2:d.markerSize,d.markerColor,d.markerBorderColor,d.markerBorderThickness);d.textBlock.x=q+l+s;if("line"===d.chartType||"stepLine"===d.chartType||"spline"===d.chartType)d.textBlock.x+=0.1*this.lineHeight;d.textBlock.y=Math.round(u+this.lineHeight/2);d.textBlock.render(!0);this.ctx.restore();x=0<z?Math.max(x,d.textBlock.height):d.textBlock.height;this.chart.data[d.dataSeriesIndex].visible||(this.ctx.globalAlpha=1);v=R(d.id);this.ghostCtx.fillStyle=
v;this.ghostCtx.beginPath();this.ghostCtx.fillRect(m,d.textBlock.y-this.lineHeight/2,d.textBlock.x+d.textBlock.width-m,d.textBlock.height);d.x1=this.chart._eventManager.objectMap[d.id].x1=m;d.y1=this.chart._eventManager.objectMap[d.id].y1=d.textBlock.y-this.lineHeight/2;d.x2=this.chart._eventManager.objectMap[d.id].x2=d.textBlock.x+d.textBlock.width;d.y2=this.chart._eventManager.objectMap[d.id].y2=d.textBlock.y+d.textBlock.height-this.lineHeight/2}f+=x}0<t.length&&a.layoutManager.registerSpace(b,
{width:this.width+2+2,height:this.height+5+5});this.bounds={x1:e,y1:c,x2:e+this.width,y2:c+this.height}};na(S,Y);S.prototype.getDefaultAxisPlacement=function(){var a=this.type;if("column"===a||"line"===a||"stepLine"===a||"spline"===a||"area"===a||"stepArea"===a||"splineArea"===a||"stackedColumn"===a||"stackedLine"===a||"bubble"===a||"scatter"===a||"stackedArea"===a||"stackedColumn100"===a||"stackedLine100"===a||"stackedArea100"===a||"candlestick"===a||"ohlc"===a||"rangeColumn"===a||"rangeArea"===
a||"rangeSplineArea"===a||"boxAndWhisker"===a||"waterfall"===a)return"normal";if("bar"===a||"stackedBar"===a||"stackedBar100"===a||"rangeBar"===a)return"xySwapped";if("pie"===a||"doughnut"===a||"funnel"===a||"pyramid"===a)return"none";"error"!==a&&window.console.log("Unknown Chart Type: "+a);return null};S.getDefaultLegendMarker=function(a){if("column"===a||"stackedColumn"===a||"stackedLine"===a||"bar"===a||"stackedBar"===a||"stackedBar100"===a||"bubble"===a||"scatter"===a||"stackedColumn100"===a||
"stackedLine100"===a||"stepArea"===a||"candlestick"===a||"ohlc"===a||"rangeColumn"===a||"rangeBar"===a||"rangeArea"===a||"rangeSplineArea"===a||"boxAndWhisker"===a||"waterfall"===a)return"square";if("line"===a||"stepLine"===a||"spline"===a||"pie"===a||"doughnut"===a)return"circle";if("area"===a||"splineArea"===a||"stackedArea"===a||"stackedArea100"===a||"funnel"===a||"pyramid"===a)return"triangle";if("error"===a)return"none";window.console.log("Unknown Chart Type: "+a);return null};S.prototype.getDataPointAtX=
function(a,f){if(!this.dataPoints||0===this.dataPoints.length)return null;var b={dataPoint:null,distance:Infinity,index:NaN},c=null,e=0,g=0,h=1,l=Infinity,t=0,k=0,r=0;"none"!==this.chart.plotInfo.axisPlacement&&(this.axisX.logarithmic?(r=Math.log(this.dataPoints[this.dataPoints.length-1].x/this.dataPoints[0].x),r=1<r?Math.min(Math.max((this.dataPoints.length-1)/r*Math.log(a/this.dataPoints[0].x)>>0,0),this.dataPoints.length):0):(r=this.dataPoints[this.dataPoints.length-1].x-this.dataPoints[0].x,r=
0<r?Math.min(Math.max((this.dataPoints.length-1)/r*(a-this.dataPoints[0].x)>>0,0),this.dataPoints.length):0));for(;;){g=0<h?r+e:r-e;if(0<=g&&g<this.dataPoints.length){var c=this.dataPoints[g],p=this.axisX.logarithmic?c.x>a?c.x/a:a/c.x:Math.abs(c.x-a);p<b.distance&&(b.dataPoint=c,b.distance=p,b.index=g);c=p;c<=l?l=c:0<h?t++:k++;if(1E3<t&&1E3<k)break}else if(0>r-e&&r+e>=this.dataPoints.length)break;-1===h?(e++,h=1):h=-1}return f||b.dataPoint.x!==a?f&&null!==b.dataPoint?b:null:b};S.prototype.getDataPointAtXY=
function(a,f,b){if(!this.dataPoints||0===this.dataPoints.length||a<this.chart.plotArea.x1||a>this.chart.plotArea.x2||f<this.chart.plotArea.y1||f>this.chart.plotArea.y2)return null;b=b||!1;var c=[],e=0,g=0,h=1,l=!1,t=Infinity,k=0,r=0,p=0;if("none"!==this.chart.plotInfo.axisPlacement)if(p=(this.chart.axisX[0]?this.chart.axisX[0]:this.chart.axisX2[0]).getXValueAt({x:a,y:f}),this.axisX.logarithmic)var n=Math.log(this.dataPoints[this.dataPoints.length-1].x/this.dataPoints[0].x),p=1<n?Math.min(Math.max((this.dataPoints.length-
1)/n*Math.log(p/this.dataPoints[0].x)>>0,0),this.dataPoints.length):0;else n=this.dataPoints[this.dataPoints.length-1].x-this.dataPoints[0].x,p=0<n?Math.min(Math.max((this.dataPoints.length-1)/n*(p-this.dataPoints[0].x)>>0,0),this.dataPoints.length):0;for(;;){g=0<h?p+e:p-e;if(0<=g&&g<this.dataPoints.length){var n=this.chart._eventManager.objectMap[this.dataPointIds[g]],d=this.dataPoints[g],m=null;if(n){switch(this.type){case "column":case "stackedColumn":case "stackedColumn100":case "bar":case "stackedBar":case "stackedBar100":case "rangeColumn":case "rangeBar":case "waterfall":case "error":a>=
n.x1&&(a<=n.x2&&f>=n.y1&&f<=n.y2)&&(c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),Math.abs(n.x2-a),Math.abs(n.y1-f),Math.abs(n.y2-f))}),l=!0);break;case "line":case "stepLine":case "spline":case "area":case "stepArea":case "stackedArea":case "stackedArea100":case "splineArea":case "scatter":var q=ja("markerSize",d,this)||4,s=b?20:q,m=Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y1-f,2));m<=s&&c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:m});n=
Math.abs(n.x1-a);n<=t?t=n:0<h?k++:r++;m<=q/2&&(l=!0);break;case "rangeArea":case "rangeSplineArea":q=ja("markerSize",d,this)||4;s=b?20:q;m=Math.min(Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y1-f,2)),Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y2-f,2)));m<=s&&c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:m});n=Math.abs(n.x1-a);n<=t?t=n:0<h?k++:r++;m<=q/2&&(l=!0);break;case "bubble":q=n.size;m=Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y1-f,2));m<=q/2&&(c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,
distance:m}),l=!0);break;case "pie":case "doughnut":q=n.center;s="doughnut"===this.type?n.percentInnerRadius*n.radius:0;m=Math.sqrt(Math.pow(q.x-a,2)+Math.pow(q.y-f,2));m<n.radius&&m>s&&(m=Math.atan2(f-q.y,a-q.x),0>m&&(m+=2*Math.PI),m=Number(((180*(m/Math.PI)%360+360)%360).toFixed(12)),q=Number(((180*(n.startAngle/Math.PI)%360+360)%360).toFixed(12)),s=Number(((180*(n.endAngle/Math.PI)%360+360)%360).toFixed(12)),0===s&&1<n.endAngle&&(s=360),q>=s&&0!==d.y&&(s+=360,m<q&&(m+=360)),m>q&&m<s&&(c.push({dataPoint:d,
dataPointIndex:g,dataSeries:this,distance:0}),l=!0));break;case "funnel":case "pyramid":m=n.funnelSection;f>m.y1&&f<m.y4&&(m.y6?f>m.y6?(g=m.x6+(m.x5-m.x6)/(m.y5-m.y6)*(f-m.y6),m=m.x3+(m.x4-m.x3)/(m.y4-m.y3)*(f-m.y3)):(g=m.x1+(m.x6-m.x1)/(m.y6-m.y1)*(f-m.y1),m=m.x2+(m.x3-m.x2)/(m.y3-m.y2)*(f-m.y2)):(g=m.x1+(m.x4-m.x1)/(m.y4-m.y1)*(f-m.y1),m=m.x2+(m.x3-m.x2)/(m.y3-m.y2)*(f-m.y2)),a>g&&a<m&&(c.push({dataPoint:d,dataPointIndex:n.dataPointIndex,dataSeries:this,distance:0}),l=!0));break;case "boxAndWhisker":if(a>=
n.x1-n.borderThickness/2&&a<=n.x2+n.borderThickness/2&&f>=n.y4-n.borderThickness/2&&f<=n.y1+n.borderThickness/2||Math.abs(n.x2-a+n.x1-a)<n.borderThickness&&f>=n.y1&&f<=n.y4)c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),Math.abs(n.x2-a),Math.abs(n.y2-f),Math.abs(n.y3-f))}),l=!0;break;case "candlestick":if(a>=n.x1-n.borderThickness/2&&a<=n.x2+n.borderThickness/2&&f>=n.y2-n.borderThickness/2&&f<=n.y3+n.borderThickness/2||Math.abs(n.x2-a+n.x1-a)<n.borderThickness&&
f>=n.y1&&f<=n.y4)c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),Math.abs(n.x2-a),Math.abs(n.y2-f),Math.abs(n.y3-f))}),l=!0;break;case "ohlc":if(Math.abs(n.x2-a+n.x1-a)<n.borderThickness&&f>=n.y2&&f<=n.y3||a>=n.x1&&a<=(n.x2+n.x1)/2&&f>=n.y1-n.borderThickness/2&&f<=n.y1+n.borderThickness/2||a>=(n.x1+n.x2)/2&&a<=n.x2&&f>=n.y4-n.borderThickness/2&&f<=n.y4+n.borderThickness/2)c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),
Math.abs(n.x2-a),Math.abs(n.y2-f),Math.abs(n.y3-f))}),l=!0}if(l||1E3<k&&1E3<r)break}}else if(0>p-e&&p+e>=this.dataPoints.length)break;-1===h?(e++,h=1):h=-1}a=null;for(f=0;f<c.length;f++)a?c[f].distance<=a.distance&&(a=c[f]):a=c[f];return a};S.prototype.getMarkerProperties=function(a,f,b,c){var e=this.dataPoints;return{x:f,y:b,ctx:c,type:e[a].markerType?e[a].markerType:this.markerType,size:e[a].markerSize?e[a].markerSize:this.markerSize,color:e[a].markerColor?e[a].markerColor:this.markerColor?this.markerColor:
e[a].color?e[a].color:this.color?this.color:this._colorSet[a%this._colorSet.length],borderColor:e[a].markerBorderColor?e[a].markerBorderColor:this.markerBorderColor?this.markerBorderColor:null,borderThickness:e[a].markerBorderThickness?e[a].markerBorderThickness:this.markerBorderThickness?this.markerBorderThickness:null}};na(C,Y);C.prototype.createExtraLabelsForLog=function(a){a=(a||0)+1;if(!(5<a)){var f=this.logLabelValues[0]||this.intervalStartPosition;if(Math.log(this.range)/Math.log(f/this.viewportMinimum)<
this.noTicks-1){for(var b=C.getNiceNumber((f-this.viewportMinimum)/Math.min(Math.max(2,this.noTicks-this.logLabelValues.length),3),!0),c=Math.ceil(this.viewportMinimum/b)*b;c<f;c+=b)c<this.viewportMinimum||this.logLabelValues.push(c);this.logLabelValues.sort(Pa);this.createExtraLabelsForLog(a)}}};C.prototype.createLabels=function(){var a,f,b=0,c=0,e,g=0,h=0,c=0,c=this.interval,l=0,t,k=0.6*this.chart.height,m;a=!1;var p=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[],n=p.length?y(this.scaleBreaks.firstBreakIndex)?
0:this.scaleBreaks.firstBreakIndex:0;if("axisX"!==this.type||"dateTime"!==this.valueType||this.logarithmic){e=this.viewportMaximum;if(this.labels){a=Math.ceil(c);for(var c=Math.ceil(this.intervalStartPosition),d=!1,b=c;b<this.viewportMaximum;b+=a)if(this.labels[b])d=!0;else{d=!1;break}d&&(this.interval=a,this.intervalStartPosition=c)}if(this.logarithmic&&!this.equidistantInterval)for(this.logLabelValues||(this.logLabelValues=[],this.createExtraLabelsForLog()),c=0,d=n;c<this.logLabelValues.length;c++)if(b=
this.logLabelValues[c],b<this.viewportMinimum)c++;else{for(;d<p.length&&b>p[d].endValue;d++);a=d<p.length&&b>=p[d].startValue&&b<=p[d].endValue;m=b;a||(a=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.options,value:m,label:this.labels[m]?this.labels[m]:null}):"axisX"===this.type&&this.labels[m]?this.labels[m]:V(m,this.valueFormatString,this.chart._cultureInfo),a=new ka(this.ctx,{x:0,y:0,maxWidth:g,maxHeight:h,angle:this.labelAngle,text:this.prefix+a+this.suffix,backgroundColor:this.labelBackgroundColor,
borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,horizontalAlign:"left",fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle",borderThickness:0}),this._labels.push({position:m,textBlock:a,effectiveHeight:null}))}d=n;for(b=this.intervalStartPosition;b<=e;b=parseFloat(1E-12>this.interval?this.logarithmic&&this.equidistantInterval?
b*Math.pow(this.logarithmBase,this.interval):b+this.interval:(this.logarithmic&&this.equidistantInterval?b*Math.pow(this.logarithmBase,this.interval):b+this.interval).toFixed(12))){for(;d<p.length&&b>p[d].endValue;d++);a=d<p.length&&b>=p[d].startValue&&b<=p[d].endValue;m=b;a||(a=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.options,value:m,label:this.labels[m]?this.labels[m]:null}):"axisX"===this.type&&this.labels[m]?this.labels[m]:V(m,this.valueFormatString,this.chart._cultureInfo),
a=new ka(this.ctx,{x:0,y:0,maxWidth:g,maxHeight:h,angle:this.labelAngle,text:this.prefix+a+this.suffix,horizontalAlign:"left",backgroundColor:this.labelBackgroundColor,borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle"}),this._labels.push({position:m,textBlock:a,effectiveHeight:null}))}}else for(this.intervalStartPosition=
this.getLabelStartPoint(new Date(this.viewportMinimum),this.intervalType,this.interval),e=Ta(new Date(this.viewportMaximum),this.interval,this.intervalType),d=n,b=this.intervalStartPosition;b<e;Ta(b,c,this.intervalType)){for(a=b.getTime();d<p.length&&a>p[d].endValue;d++);m=a;a=d<p.length&&a>=p[d].startValue&&a<=p[d].endValue;a||(a=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.options,value:new Date(m),label:this.labels[m]?this.labels[m]:null}):"axisX"===this.type&&this.labels[m]?
this.labels[m]:Aa(m,this.valueFormatString,this.chart._cultureInfo),a=new ka(this.ctx,{x:0,y:0,maxWidth:g,backgroundColor:this.labelBackgroundColor,borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,maxHeight:h,angle:this.labelAngle,text:this.prefix+a+this.suffix,horizontalAlign:"left",fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle"}),
this._labels.push({position:m,textBlock:a,effectiveHeight:null,breaksLabelType:void 0}))}if("bottom"===this._position||"top"===this._position)l=this.logarithmic&&!this.equidistantInterval&&2<=this._labels.length?this.lineCoordinates.width*Math.log(Math.min(this._labels[this._labels.length-1].position/this._labels[this._labels.length-2].position,this._labels[1].position/this._labels[0].position))/Math.log(this.range):this.lineCoordinates.width/(this.logarithmic&&this.equidistantInterval?Math.log(this.range)/
Math.log(this.logarithmBase):Math.abs(this.range))*U[this.intervalType+"Duration"]*this.interval,g="undefined"===typeof this.options.labelMaxWidth?0.5*this.chart.width>>0:this.options.labelMaxWidth,this.chart.panEnabled||(h="undefined"===typeof this.options.labelWrap||this.labelWrap?0.8*this.chart.height>>0:1.5*this.labelFontSize);else if("left"===this._position||"right"===this._position)l=this.logarithmic&&!this.equidistantInterval&&2<=this._labels.length?this.lineCoordinates.height*Math.log(Math.min(this._labels[this._labels.length-
1].position/this._labels[this._labels.length-2].position,this._labels[1].position/this._labels[0].position))/Math.log(this.range):this.lineCoordinates.height/(this.logarithmic&&this.equidistantInterval?Math.log(this.range)/Math.log(this.logarithmBase):Math.abs(this.range))*U[this.intervalType+"Duration"]*this.interval,this.chart.panEnabled||(g="undefined"===typeof this.options.labelMaxWidth?0.3*this.chart.width>>0:this.options.labelMaxWidth),h="undefined"===typeof this.options.labelWrap||this.labelWrap?
0.3*this.chart.height>>0:1.5*this.labelFontSize;for(c=0;c<this._labels.length;c++){a=this._labels[c].textBlock;a.maxWidth=g;a.maxHeight=h;var q=a.measureText();t=q.height}e=[];n=p=0;if(this.labelAutoFit||this.options.labelAutoFit)if(y(this.labelAngle)||(this.labelAngle=(this.labelAngle%360+360)%360,90<this.labelAngle&&270>this.labelAngle?this.labelAngle-=180:270<=this.labelAngle&&360>=this.labelAngle&&(this.labelAngle-=360)),"bottom"===this._position||"top"===this._position)if(g=0.9*l>>0,n=0,!this.chart.panEnabled&&
1<=this._labels.length){this.sessionVariables.labelFontSize=this.labelFontSize;this.sessionVariables.labelMaxWidth=g;this.sessionVariables.labelMaxHeight=h;this.sessionVariables.labelAngle=this.labelAngle;this.sessionVariables.labelWrap=this.labelWrap;for(b=0;b<this._labels.length;b++)if(!this._labels[b].breaksLabelType){a=this._labels[b].textBlock;for(var s,d=a.text.split(" "),c=0;c<d.length;c++)m=d[c],this.ctx.font=a.fontStyle+" "+a.fontWeight+" "+a.fontSize+"px "+a.fontFamily,m=this.ctx.measureText(m),
m.width>n&&(s=b,n=m.width)}b=0;for(b=this.intervalStartPosition<this.viewportMinimum?1:0;b<this._labels.length;b++)if(!this._labels[b].breaksLabelType){a=this._labels[b].textBlock;q=a.measureText();for(d=b+1;d<this._labels.length;d++)if(!this._labels[d].breaksLabelType){f=this._labels[d].textBlock;f=f.measureText();break}e.push(a.height);this.sessionVariables.labelMaxHeight=Math.max.apply(Math,e);Math.cos(Math.PI/180*Math.abs(this.labelAngle));Math.sin(Math.PI/180*Math.abs(this.labelAngle));c=g*Math.sin(Math.PI/
180*Math.abs(this.labelAngle))+(h-a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle));if(y(this.options.labelAngle)&&isNaN(this.options.labelAngle)&&0!==this.options.labelAngle)if(this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:Math.min((c-g*Math.cos(Math.PI/180*Math.abs(this.labelAngle)))/Math.sin(Math.PI/180*Math.abs(this.labelAngle)),c),m=(k-(t+a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(-25)))/Math.sin(Math.PI/180*Math.abs(-25)),!y(this.options.labelWrap))this.labelWrap?y(this.options.labelMaxWidth)?
(this.sessionVariables.labelMaxWidth=Math.min(Math.max(g,n),m),this.sessionVariables.labelWrap=this.labelWrap,q.width+f.width>>0>2*g&&(this.sessionVariables.labelAngle=-25)):(this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth,this.sessionVariables.labelAngle=this.sessionVariables.labelMaxWidth>g?-25:this.sessionVariables.labelAngle):y(this.options.labelMaxWidth)?(this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxHeight=
h,this.sessionVariables.labelMaxWidth=g,q.width+f.width>>0>2*g&&(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=m)):(this.sessionVariables.labelAngle=this.sessionVariables.labelMaxWidth>g?-25:this.sessionVariables.labelAngle,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelWrap=this.labelWrap);else{if(y(this.options.labelWrap))if(!y(this.options.labelMaxWidth))this.options.labelMaxWidth<g?(this.sessionVariables.labelMaxWidth=
this.options.labelMaxWidth,this.sessionVariables.labelMaxHeight=c):(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth,this.sessionVariables.labelMaxHeight=h);else if(!y(f))if(c=q.width+f.width>>0,d=this.labelFontSize,n<g)c-2*g>p&&(p=c-2*g,c>=2*g&&c<2.2*g?(this.sessionVariables.labelMaxWidth=g,y(this.options.labelFontSize)&&12<d&&(d=Math.floor(12/13*d),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,
this.sessionVariables.labelAngle=this.labelAngle):c>=2.2*g&&c<2.8*g?(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=m,this.sessionVariables.labelFontSize=d):c>=2.8*g&&c<3.2*g?(this.sessionVariables.labelMaxWidth=Math.max(g,n),this.sessionVariables.labelWrap=!0,y(this.options.labelFontSize)&&12<this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,
this.sessionVariables.labelAngle=this.labelAngle):c>=3.2*g&&c<3.6*g?(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelMaxWidth=m,this.sessionVariables.labelFontSize=this.labelFontSize):c>3.6*g&&c<5*g?(y(this.options.labelFontSize)&&12<d&&(d=Math.floor(12/13*d),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=
m):c>5*g&&(this.sessionVariables.labelWrap=!0,this.sessionVariables.labelMaxWidth=g,this.sessionVariables.labelFontSize=d,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelAngle=this.labelAngle));else if(s===b&&(0===s&&n+this._labels[s+1].textBlock.measureText().width-2*g>p||s===this._labels.length-1&&n+this._labels[s-1].textBlock.measureText().width-2*g>p||0<s&&s<this._labels.length-1&&n+this._labels[s+1].textBlock.measureText().width-2*g>p&&n+this._labels[s-1].textBlock.measureText().width-
2*g>p))p=0===s?n+this._labels[s+1].textBlock.measureText().width-2*g:n+this._labels[s-1].textBlock.measureText().width-2*g,this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=m;else if(0===p)for(this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,this.sessionVariables.labelWrap=!0,c=0;c<this._labels.length;c++)a=
this._labels[c].textBlock,a.maxWidth=this.sessionVariables.labelMaxWidth=Math.min(Math.max(g,n),m),q=a.measureText(),c<this._labels.length-1&&(d=c+1,f=this._labels[d].textBlock,f.maxWidth=this.sessionVariables.labelMaxWidth=Math.min(Math.max(g,n),m),f=f.measureText(),q.width+f.width>>0>2*g&&(this.sessionVariables.labelAngle=-25))}else(this.sessionVariables.labelAngle=this.labelAngle,this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:Math.min((c-g*Math.cos(Math.PI/180*Math.abs(this.labelAngle)))/
Math.sin(Math.PI/180*Math.abs(this.labelAngle)),c),m=0!=this.labelAngle?(k-(t+a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle)))/Math.sin(Math.PI/180*Math.abs(this.labelAngle)):g,this.sessionVariables.labelMaxHeight=h=this.labelWrap?(k-m*Math.sin(Math.PI/180*Math.abs(this.labelAngle)))/Math.cos(Math.PI/180*Math.abs(this.labelAngle)):1.5*this.labelFontSize,y(this.options.labelWrap))?y(this.options.labelWrap)&&(this.labelWrap&&!y(this.options.labelMaxWidth)?(this.sessionVariables.labelWrap=
this.labelWrap,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:m,this.sessionVariables.labelMaxHeight=h):(this.sessionVariables.labelAngle=this.labelAngle,this.sessionVariables.labelMaxWidth=m,this.sessionVariables.labelMaxHeight=c<0.9*l?0.9*l:c,this.sessionVariables.labelWrap=this.labelWrap)):(this.options.labelWrap?(this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:m):
(y(this.options.labelMaxWidth),this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:m,this.sessionVariables.labelWrap=this.labelWrap),this.sessionVariables.labelMaxHeight=h)}for(c=0;c<this._labels.length;c++)a=this._labels[c].textBlock,a.maxWidth=this.labelMaxWidth=this.sessionVariables.labelMaxWidth,a.fontSize=this.sessionVariables.labelFontSize,a.angle=this.labelAngle=this.sessionVariables.labelAngle,a.wrap=this.labelWrap=this.sessionVariables.labelWrap,a.maxHeight=
this.sessionVariables.labelMaxHeight,a.measureText()}else for(b=0;b<this._labels.length;b++)a=this._labels[b].textBlock,a.maxWidth=this.labelMaxWidth=y(this.options.labelMaxWidth)?this.sessionVariables.labelMaxWidth:this.options.labelMaxWidth,a.fontSize=this.labelFontSize=y(this.options.labelFontSize)?this.sessionVariables.labelFontSize:this.options.labelFontSize,a.angle=this.labelAngle=y(this.options.labelAngle)?this.sessionVariables.labelAngle:this.labelAngle,a.wrap=this.labelWrap=y(this.options.labelWrap)?
this.sessionVariables.labelWrap:this.options.labelWrap,a.maxHeight=this.sessionVariables.labelMaxHeight,a.measureText();else if("left"===this._position||"right"===this._position)if(g=y(this.options.labelMaxWidth)?0.3*this.chart.width>>0:this.options.labelMaxWidth,h="undefined"===typeof this.options.labelWrap||this.labelWrap?0.3*this.chart.height>>0:1.5*this.labelFontSize,!this.chart.panEnabled&&1<=this._labels.length){this.sessionVariables.labelFontSize=this.labelFontSize;this.sessionVariables.labelMaxWidth=
g;this.sessionVariables.labelMaxHeight=h;this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle;this.sessionVariables.labelWrap=this.labelWrap;for(b=0;b<this._labels.length;b++)if(!this._labels[b].breaksLabelType){a=this._labels[b].textBlock;q=a.measureText();for(d=b+1;d<this._labels.length;d++)if(!this._labels[d].breaksLabelType){f=this._labels[d].textBlock;f=f.measureText();break}e.push(a.height);this.sessionVariables.labelMaxHeight=Math.max.apply(Math,
e);c=g*Math.sin(Math.PI/180*Math.abs(this.labelAngle))+(h-a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle));Math.cos(Math.PI/180*Math.abs(this.labelAngle));Math.sin(Math.PI/180*Math.abs(this.labelAngle));y(this.options.labelAngle)&&isNaN(this.options.labelAngle)&&0!==this.options.labelAngle?y(this.options.labelWrap)?y(this.options.labelWrap)&&(y(this.options.labelMaxWidth)?y(f)||(l=q.height+f.height>>0,l-2*h>n&&(n=l-2*h,l>=2*h&&l<2.4*h?(y(this.options.labelFontSize)&&12<this.labelFontSize&&
(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize):l>=2.4*h&&l<2.8*h?(this.sessionVariables.labelMaxHeight=c,this.sessionVariables.labelFontSize=this.labelFontSize,this.sessionVariables.labelWrap=!0):l>=2.8*h&&l<3.2*h?(this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelWrap=!0,y(this.options.labelFontSize)&&12<
this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize,this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle):l>=3.2*h&&l<3.6*h?(this.sessionVariables.labelMaxHeight=c,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelFontSize=this.labelFontSize):l>3.6*h&&l<10*h?(y(this.options.labelFontSize)&&
12<this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize,this.sessionVariables.labelMaxWidth=g,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle):l>10*h&&l<50*h&&(y(this.options.labelFontSize)&&12<this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),
a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelMaxWidth=g,this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle))):(this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth)):(this.sessionVariables.labelMaxWidth=
this.labelWrap?this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth:this.labelMaxWidth?this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth:g,this.sessionVariables.labelMaxHeight=h):(this.sessionVariables.labelAngle=this.labelAngle,this.sessionVariables.labelMaxWidth=0===this.labelAngle?g:Math.min((c-h*Math.sin(Math.PI/180*Math.abs(this.labelAngle)))/Math.cos(Math.PI/180*Math.abs(this.labelAngle)),h),y(this.options.labelWrap))?
y(this.options.labelWrap)&&(this.labelWrap&&!y(this.options.labelMaxWidth)?(this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth>this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth,this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxHeight=c):(this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:g,this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:c,y(this.options.labelMaxWidth)&&
(this.sessionVariables.labelAngle=this.labelAngle))):this.options.labelWrap?(this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:c,this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxWidth=g):(this.sessionVariables.labelMaxHeight=h,y(this.options.labelMaxWidth),this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth,this.sessionVariables.labelWrap=this.labelWrap)}for(c=0;c<this._labels.length;c++)a=
this._labels[c].textBlock,a.maxWidth=this.labelMaxWidth=this.sessionVariables.labelMaxWidth,a.fontSize=this.labelFontSize=this.sessionVariables.labelFontSize,a.angle=this.labelAngle=this.sessionVariables.labelAngle,a.wrap=this.labelWrap=this.sessionVariables.labelWrap,a.maxHeight=this.sessionVariables.labelMaxHeight,a.measureText()}else for(b=0;b<this._labels.length;b++)a=this._labels[b].textBlock,a.maxWidth=this.labelMaxWidth=y(this.options.labelMaxWidth)?this.sessionVariables.labelMaxWidth:this.options.labelMaxWidth,
a.fontSize=this.labelFontSize=y(this.options.labelFontSize)?this.sessionVariables.labelFontSize:this.options.labelFontSize,a.angle=this.labelAngle=y(this.options.labelAngle)?this.sessionVariables.labelAngle:this.labelAngle,a.wrap=this.labelWrap=y(this.options.labelWrap)?this.sessionVariables.labelWrap:this.options.labelWrap,a.maxHeight=this.sessionVariables.labelMaxHeight,a.measureText();for(b=0;b<this.stripLines.length;b++){var g=this.stripLines[b],x;if("outside"===g.labelPlacement){h=this.sessionVariables.labelMaxWidth;
if("bottom"===this._position||"top"===this._position)x=y(g.options.labelWrap)?this.sessionVariables.labelMaxHeight:g.labelWrap?0.8*this.chart.height>>0:1.5*this.labelFontSize;if("left"===this._position||"right"===this._position)x=y(g.options.labelWrap)?this.sessionVariables.labelMaxHeight:g.labelWrap?0.8*this.chart.width>>0:1.5*this.labelFontSize;y(g.labelBackgroundColor)&&(g.labelBackgroundColor="#EEEEEE")}else h="bottom"===this._position||"top"===this._position?0.9*this.chart.width>>0:0.9*this.chart.height>>
0,x=y(g.options.labelWrap)||g.labelWrap?"bottom"===this._position||"top"===this._position?0.8*this.chart.width>>0:0.8*this.chart.height>>0:1.5*this.labelFontSize,y(g.labelBackgroundColor)&&(y(g.startValue)&&0!==g.startValue?g.labelBackgroundColor=v?"transparent":null:g.labelBackgroundColor="#EEEEEE");a=new ka(this.ctx,{x:0,y:0,backgroundColor:g.labelBackgroundColor,borderColor:g.labelBorderColor,borderThickness:g.labelBorderThickness,cornerRadius:g.labelCornerRadius,maxWidth:g.options.labelMaxWidth?
g.options.labelMaxWidth:h,maxHeight:x,angle:this.labelAngle,text:g.labelFormatter?g.labelFormatter({chart:this.chart,axis:this,stripLine:g}):g.label,horizontalAlign:"left",fontSize:"outside"===g.labelPlacement?g.options.labelFontSize?g.labelFontSize:this.labelFontSize:g.labelFontSize,fontFamily:"outside"===g.labelPlacement?g.options.labelFontFamily?g.labelFontFamily:this.labelFontFamily:g.labelFontFamily,fontWeight:"outside"===g.labelPlacement?g.options.labelFontWeight?g.labelFontWeight:this.labelFontWeight:
g.labelFontWeight,fontColor:g.labelFontColor||g.color,fontStyle:"outside"===g.labelPlacement?g.options.labelFontStyle?g.labelFontStyle:this.fontWeight:g.labelFontStyle,textBaseline:"middle"});this._stripLineLabels.push({position:g.value,textBlock:a,effectiveHeight:null,stripLine:g})}};C.prototype.createLabelsAndCalculateWidth=function(){var a=0,f=0;this._labels=[];this._stripLineLabels=[];if("left"===this._position||"right"===this._position){this.createLabels();for(f=0;f<this._labels.length;f++){var b=
this._labels[f].textBlock,c=b.measureText(),e=0,e=0===this.labelAngle?c.width:c.width*Math.cos(Math.PI/180*Math.abs(this.labelAngle))+(c.height-b.fontSize/2)*Math.sin(Math.PI/180*Math.abs(this.labelAngle));a<e&&(a=e);this._labels[f].effectiveWidth=e}for(f=0;f<this._stripLineLabels.length;f++)"outside"===this._stripLineLabels[f].stripLine.labelPlacement&&(this._stripLineLabels[f].stripLine.value>=this.viewportMinimum&&this._stripLineLabels[f].stripLine.value<=this.viewportMaximum)&&(b=this._stripLineLabels[f].textBlock,
c=b.measureText(),e=0===this.labelAngle?c.width:c.width*Math.cos(Math.PI/180*Math.abs(this.labelAngle))+(c.height-b.fontSize/2)*Math.sin(Math.PI/180*Math.abs(this.labelAngle)),a<e&&(a=e),this._stripLineLabels[f].effectiveWidth=e)}f=this.title?this._titleTextBlock.measureText().height+2:0;return b="inside"===this.labelPlacement?b=f+5:f+a+this.tickLength+5};C.prototype.createLabelsAndCalculateHeight=function(){var a=0;this._labels=[];this._stripLineLabels=[];var f,b=0;this.createLabels();if("bottom"===
this._position||"top"===this._position){for(b=0;b<this._labels.length;b++){f=this._labels[b].textBlock;var c=f.measureText(),e=0,e=0===this.labelAngle?c.height:c.width*Math.sin(Math.PI/180*Math.abs(this.labelAngle))+(c.height-f.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle));a<e&&(a=e);this._labels[b].effectiveHeight=e}for(b=0;b<this._stripLineLabels.length;b++)"outside"===this._stripLineLabels[b].stripLine.labelPlacement&&(this._stripLineLabels[b].stripLine.value>=this.viewportMinimum&&
this._stripLineLabels[b].stripLine.value<=this.viewportMaximum)&&(f=this._stripLineLabels[b].textBlock,c=f.measureText(),e=0===this.labelAngle?c.height:c.width*Math.sin(Math.PI/180*Math.abs(this.labelAngle))+(c.height-f.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle)),a<e&&(a=e),this._stripLineLabels[b].effectiveHeight=e)}f=this.title?this._titleTextBlock.measureText().height+2:0;return b="inside"===this.labelPlacement?b=f+5:f+a+this.tickLength+5};C.setLayoutAndRender=function(a,f,b,c,
e,g){var h,l,t,k,m=a[0]?a[0].chart:f[0].chart,p=m.ctx,n=m._axes;if(a&&0<a.length)for(var d=0;d<a.length;d++)a[d]&&a[d].calculateAxisParameters();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateAxisParameters();if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].calculateAxisParameters();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].calculateAxisParameters();for(d=0;d<n.length;d++)if(n[d]&&n[d].scaleBreaks&&n[d].scaleBreaks._appliedBreaks.length)for(var q=n[d].scaleBreaks._appliedBreaks,s=0;s<q.length&&
!(q[s].startValue>n[d].viewportMaximum);s++)q[s].endValue<n[d].viewportMinimum||(y(n[d].scaleBreaks.firstBreakIndex)&&(n[d].scaleBreaks.firstBreakIndex=s),q[s].startValue>=n[d].viewPortMinimum&&(n[d].scaleBreaks.lastBreakIndex=s));for(var x=s=0,u=0,z=0,C=0,F=0,B=0,A,I,J=l=0,L,K,O,q=L=K=O=!1,d=0;d<n.length;d++)n[d]&&n[d].title&&(n[d]._titleTextBlock=new ka(n[d].ctx,{text:n[d].title,horizontalAlign:"center",fontSize:n[d].titleFontSize,fontFamily:n[d].titleFontFamily,fontWeight:n[d].titleFontWeight,
fontColor:n[d].titleFontColor,fontStyle:n[d].titleFontStyle,borderColor:n[d].titleBorderColor,borderThickness:n[d].titleBorderThickness,backgroundColor:n[d].titleBackgroundColor,cornerRadius:n[d].titleCornerRadius,textBaseline:"top"}));for(d=0;d<n.length;d++)if(n[d].title)switch(n[d]._position){case "left":n[d]._titleTextBlock.maxWidth=n[d].titleMaxWidth||g.height;n[d]._titleTextBlock.maxHeight=n[d].titleWrap?0.8*g.width:1.5*n[d].titleFontSize;n[d]._titleTextBlock.angle=-90;break;case "right":n[d]._titleTextBlock.maxWidth=
n[d].titleMaxWidth||g.height;n[d]._titleTextBlock.maxHeight=n[d].titleWrap?0.8*g.width:1.5*n[d].titleFontSize;n[d]._titleTextBlock.angle=90;break;default:n[d]._titleTextBlock.maxWidth=n[d].titleMaxWidth||g.width,n[d]._titleTextBlock.maxHeight=n[d].titleWrap?0.8*g.height:1.5*n[d].titleFontSize,n[d]._titleTextBlock.angle=0}if("normal"===e){for(var z=[],C=[],F=[],B=[],P=[],R=[],S=[],T=[];4>s;){var E=0,U=0,Y=0,X=0,W=e=0,M=0,$=0,Z=0,V=0,N=0,ba=0;if(b&&0<b.length)for(F=[],d=N=0;d<b.length;d++)F.push(Math.ceil(b[d]?
b[d].createLabelsAndCalculateWidth():0)),N+=F[d],M+=b[d]?b[d].margin:0;else F.push(Math.ceil(b[0]?b[0].createLabelsAndCalculateWidth():0));S.push(F);if(c&&0<c.length)for(B=[],d=ba=0;d<c.length;d++)B.push(Math.ceil(c[d]?c[d].createLabelsAndCalculateWidth():0)),ba+=B[d],$+=c[d]?c[d].margin:0;else B.push(Math.ceil(c[0]?c[0].createLabelsAndCalculateWidth():0));T.push(B);h=Math.round(g.x1+N+M);t=Math.round(g.x2-ba-$>m.width-10?m.width-10:g.x2-ba-$);if(a&&0<a.length)for(z=[],d=Z=0;d<a.length;d++)a[d]&&
(a[d].lineCoordinates={}),a[d].lineCoordinates.width=Math.abs(t-h),a[d].title&&(a[d]._titleTextBlock.maxWidth=0<a[d].titleMaxWidth&&a[d].titleMaxWidth<a[d].lineCoordinates.width?a[d].titleMaxWidth:a[d].lineCoordinates.width),z.push(Math.ceil(a[d]?a[d].createLabelsAndCalculateHeight():0)),Z+=z[d],e+=a[d]?a[d].margin:0;else z.push(Math.ceil(a[0]?a[0].createLabelsAndCalculateHeight():0));P.push(z);if(f&&0<f.length)for(C=[],d=V=0;d<f.length;d++)f[d]&&(f[d].lineCoordinates={}),f[d].lineCoordinates.width=
Math.abs(t-h),f[d].title&&(f[d]._titleTextBlock.maxWidth=0<f[d].titleMaxWidth&&f[d].titleMaxWidth<f[d].lineCoordinates.width?f[d].titleMaxWidth:f[d].lineCoordinates.width),C.push(Math.ceil(f[d]?f[d].createLabelsAndCalculateHeight():0)),V+=C[d],W+=f[d]?f[d].margin:0;else C.push(Math.ceil(f[0]?f[0].createLabelsAndCalculateHeight():0));R.push(C);if(a&&0<a.length)for(d=0;d<a.length;d++)a[d]&&(a[d].lineCoordinates.x1=h,t=Math.round(g.x2-ba-$>m.width-10?m.width-10:g.x2-ba-$),a[d]._labels&&1<a[d]._labels.length&&
(l=k=0,k=a[d]._labels[1],l="dateTime"===a[d].valueType?a[d]._labels[a[d]._labels.length-2]:a[d]._labels[a[d]._labels.length-1],x=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),u=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle))),a[d]&&(a[d].labelAutoFit&&!y(A)&&!y(I))&&(l=0,
0<a[d].labelAngle?I+u>t&&(l+=0<a[d].labelAngle?I+u-t-ba:0):0>a[d].labelAngle?A-x<h&&A-x<a[d].viewportMinimum&&(J=h-(M+a[d].tickLength+F+A-x+a[d].labelFontSize/2)):0===a[d].labelAngle&&(I+u>t&&(l=I+u/2-t-ba),A-x<h&&A-x<a[d].viewportMinimum&&(J=h-M-a[d].tickLength-F-A+x/2)),a[d].viewportMaximum===a[d].maximum&&a[d].viewportMinimum===a[d].minimum&&0<a[d].labelAngle&&0<l?t-=l:a[d].viewportMaximum===a[d].maximum&&a[d].viewportMinimum===a[d].minimum&&0>a[d].labelAngle&&0<J?h+=J:a[d].viewportMaximum===a[d].maximum&&
a[d].viewportMinimum===a[d].minimum&&0===a[d].labelAngle&&(0<J&&(h+=J),0<l&&(t-=l))),m.panEnabled?Z=m.sessionVariables.axisX.height:m.sessionVariables.axisX.height=Z,l=Math.round(g.y2-Z-e+E),k=Math.round(g.y2),a[d].lineCoordinates.x2=t,a[d].lineCoordinates.width=t-h,a[d].lineCoordinates.y1=l,a[d].lineCoordinates.y2=l,a[d].bounds={x1:h,y1:l,x2:t,y2:k-(Z+e-z[d]-E),width:t-h,height:k-l}),E+=z[d]+a[d].margin;if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].lineCoordinates.x1=Math.round(g.x1+N+M),f[d].lineCoordinates.x2=
Math.round(g.x2-ba-$>m.width-10?m.width-10:g.x2-ba-$),f[d].lineCoordinates.width=Math.abs(t-h),f[d]._labels&&1<f[d]._labels.length&&(k=f[d]._labels[1],l="dateTime"===f[d].valueType?f[d]._labels[f[d]._labels.length-2]:f[d]._labels[f[d]._labels.length-1],x=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),u=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-
l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle))),m.panEnabled?V=m.sessionVariables.axisX2.height:m.sessionVariables.axisX2.height=V,l=Math.round(g.y1),k=Math.round(g.y2+f[d].margin),f[d].lineCoordinates.y1=l+V+W-U,f[d].lineCoordinates.y2=l,f[d].bounds={x1:h,y1:l+(V+W-C[d]-U),x2:t,y2:k,width:t-h,height:k-l},U+=C[d]+f[d].margin;if(b&&0<b.length)for(d=0;d<b.length;d++)M=10,b[d]&&(h=Math.round(a[0]?a[0].lineCoordinates.x1:f[0].lineCoordinates.x1),M=b[d]._labels&&0<b[d]._labels.length?
b[d]._labels[b[d]._labels.length-1].textBlock.height/2:10,l=Math.round(g.y1+V+W<Math.max(M,10)?Math.max(M,10):g.y1+V+W),t=Math.round(a[0]?a[0].lineCoordinates.x1:f[0].lineCoordinates.x1),M=0<a.length?0:b[d]._labels&&0<b[d]._labels.length?b[d]._labels[0].textBlock.height/2:10,k=Math.round(g.y2-Z-e-M),b[d].lineCoordinates={x1:t-Y,y1:l,x2:t-Y,y2:k,height:Math.abs(k-l)},b[d].bounds={x1:h-(F[d]+Y),y1:l,x2:t,y2:k,width:t-h,height:k-l},b[d].title&&(b[d]._titleTextBlock.maxWidth=0<b[d].titleMaxWidth&&b[d].titleMaxWidth<
b[d].lineCoordinates.height?b[d].titleMaxWidth:b[d].lineCoordinates.height),Y+=F[d]+b[d].margin);if(c&&0<c.length)for(d=0;d<c.length;d++)c[d]&&(h=Math.round(a[0]?a[0].lineCoordinates.x2:f[0].lineCoordinates.x2),t=Math.round(h),M=c[d]._labels&&0<c[d]._labels.length?c[d]._labels[c[d]._labels.length-1].textBlock.height/2:0,l=Math.round(g.y1+V+W<Math.max(M,10)?Math.max(M,10):g.y1+V+W),M=0<a.length?0:c[d]._labels&&0<c[d]._labels.length?c[d]._labels[0].textBlock.height/2:0,k=Math.round(g.y2-(Z+e+M)),c[d].lineCoordinates=
{x1:h+X,y1:l,x2:h+X,y2:k,height:Math.abs(k-l)},c[d].bounds={x1:h,y1:l,x2:t+(B[d]+X),y2:k,width:t-h,height:k-l},c[d].title&&(c[d]._titleTextBlock.maxWidth=0<c[d].titleMaxWidth&&c[d].titleMaxWidth<c[d].lineCoordinates.height?c[d].titleMaxWidth:c[d].lineCoordinates.height),X+=B[d]+c[d].margin);if(a&&0<a.length)for(d=0;d<a.length;d++)a[d]&&(a[d].calculateValueToPixelConversionParameters(),a[d].calculateBreaksSizeInValues(),a[d]._labels&&1<a[d]._labels.length&&(A=(a[d].logarithmic?Math.log(a[d]._labels[1].position/
a[d].viewportMinimum)/a[d].conversionParameters.lnLogarithmBase:a[d]._labels[1].position-a[d].viewportMinimum)*Math.abs(a[d].conversionParameters.pixelPerUnit)+a[d].lineCoordinates.x1,h=a[d]._labels[a[d]._labels.length-("dateTime"===a[d].valueType?2:1)].position,h=a[d].getApparentDifference(a[d].viewportMinimum,h),I=a[d].logarithmic?(1<h?Math.log(h)/a[d].conversionParameters.lnLogarithmBase*Math.abs(a[d].conversionParameters.pixelPerUnit):0)+a[d].lineCoordinates.x1:(0<h?h*Math.abs(a[d].conversionParameters.pixelPerUnit):
0)+a[d].lineCoordinates.x1));if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateValueToPixelConversionParameters(),f[d].calculateBreaksSizeInValues(),f[d]._labels&&1<f[d]._labels.length&&(A=(f[d].logarithmic?Math.log(f[d]._labels[1].position/f[d].viewportMinimum)/f[d].conversionParameters.lnLogarithmBase:f[d]._labels[1].position-f[d].viewportMinimum)*Math.abs(f[d].conversionParameters.pixelPerUnit)+f[d].lineCoordinates.x1,h=f[d]._labels[f[d]._labels.length-("dateTime"===f[d].valueType?2:1)].position,
h=f[d].getApparentDifference(f[d].viewportMinimum,h),I=f[d].logarithmic?(1<h?Math.log(h)/f[d].conversionParameters.lnLogarithmBase*Math.abs(f[d].conversionParameters.pixelPerUnit):0)+f[d].lineCoordinates.x1:(0<h?h*Math.abs(f[d].conversionParameters.pixelPerUnit):0)+f[d].lineCoordinates.x1);for(d=0;d<n.length;d++)"axisY"===n[d].type&&(n[d].calculateValueToPixelConversionParameters(),n[d].calculateBreaksSizeInValues());if(0<s){if(a&&0<a.length)for(d=0;d<a.length;d++)q=P[s-1][d]===P[s][d]?!0:!1;else q=
!0;if(f&&0<f.length)for(d=0;d<f.length;d++)L=R[s-1][d]===R[s][d]?!0:!1;else L=!0;if(b&&0<b.length)for(d=0;d<b.length;d++)K=S[s-1][d]===S[s][d]?!0:!1;else K=!0;if(c&&0<c.length)for(d=0;d<c.length;d++)O=T[s-1][d]===T[s][d]?!0:!1;else O=!0}if(q&&L&&K&&O)break;s++}p.save();p.beginPath();a[0]&&p.rect(5,a[0].bounds.y1,a[0].chart.width-10,a[0].bounds.height);f[0]&&p.rect(5,f[f.length-1].bounds.y1,f[0].chart.width-10,f[0].bounds.height);p.clip();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].calculateStripLinesThicknessInValues(),
a[d].calculateBreaksInPixels(),a[d].renderLabelsTicksAndTitle();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateStripLinesThicknessInValues(),f[d].calculateBreaksInPixels(),f[d].renderLabelsTicksAndTitle();p.restore();if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].calculateStripLinesThicknessInValues(),b[d].calculateBreaksInPixels(),b[d].renderLabelsTicksAndTitle();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].calculateStripLinesThicknessInValues(),c[d].calculateBreaksInPixels(),c[d].renderLabelsTicksAndTitle()}else{A=
[];J=[];x=[];I=[];u=[];P=[];R=[];for(S=[];4>s;){V=Z=N=X=$=M=W=e=Y=T=U=E=0;if(a&&0<a.length)for(x=[],d=Z=0;d<a.length;d++)x.push(Math.ceil(a[d]?a[d].createLabelsAndCalculateWidth():0)),Z+=x[d],e+=a[d]?a[d].margin:0;else x.push(Math.ceil(a[0]?a[0].createLabelsAndCalculateWidth():0));R.push(x);if(f&&0<f.length)for(I=[],d=V=0;d<f.length;d++)I.push(Math.ceil(f[d]?f[d].createLabelsAndCalculateWidth():0)),V+=I[d],W+=f[d]?f[d].margin:0;else I.push(Math.ceil(f[0]?f[0].createLabelsAndCalculateWidth():0));S.push(I);
if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].lineCoordinates={},h=Math.round(g.x1+Z+e),t=Math.round(g.x2-V-W>m.width-10?m.width-10:g.x2-V-W),b[d].labelAutoFit&&!y(z)&&(0<!a.length&&(h=0>b[d].labelAngle?Math.max(h,z):0===b[d].labelAngle?Math.max(h,z/2):h),0<!f.length&&(t=0<b[d].labelAngle?t-C/2:0===b[d].labelAngle?t-C/2:t)),b[d].lineCoordinates.x1=h,b[d].lineCoordinates.x2=t,b[d].lineCoordinates.width=Math.abs(t-h),b[d].title&&(b[d]._titleTextBlock.maxWidth=0<b[d].titleMaxWidth&&b[d].titleMaxWidth<
b[d].lineCoordinates.width?b[d].titleMaxWidth:b[d].lineCoordinates.width);if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].lineCoordinates={},h=Math.round(g.x1+Z+e),t=Math.round(g.x2-V-W>c[d].chart.width-10?c[d].chart.width-10:g.x2-V-W),c[d]&&c[d].labelAutoFit&&!y(F)&&(0<!a.length&&(h=0<c[d].labelAngle?Math.max(h,F):0===c[d].labelAngle?Math.max(h,F/2):h),0<!f.length&&(t-=B/2)),c[d].lineCoordinates.x1=h,c[d].lineCoordinates.x2=t,c[d].lineCoordinates.width=Math.abs(t-h),c[d].title&&(c[d]._titleTextBlock.maxWidth=
0<c[d].titleMaxWidth&&c[d].titleMaxWidth<c[d].lineCoordinates.width?c[d].titleMaxWidth:c[d].lineCoordinates.width);if(b&&0<b.length)for(A=[],d=X=0;d<b.length;d++)A.push(Math.ceil(b[d]?b[d].createLabelsAndCalculateHeight():0)),X+=A[d]+b[d].margin,M+=b[d].margin;else A.push(Math.ceil(b[0]?b[0].createLabelsAndCalculateHeight():0));u.push(A);if(c&&0<c.length)for(J=[],d=N=0;d<c.length;d++)J.push(Math.ceil(c[d]?c[d].createLabelsAndCalculateHeight():0)),N+=J[d],$+=c[d].margin;else J.push(Math.ceil(c[0]?
c[0].createLabelsAndCalculateHeight():0));P.push(J);if(b&&0<b.length)for(d=0;d<b.length;d++)0<b[d]._labels.length&&(k=b[d]._labels[0],l=b[d]._labels[b[d]._labels.length-1],z=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),C=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle)));
if(c&&0<c.length)for(d=0;d<c.length;d++)c[d]&&0<c[d]._labels.length&&(k=c[d]._labels[0],l=c[d]._labels[c[d]._labels.length-1],F=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),B=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle)));if(m.panEnabled)for(d=0;d<b.length;d++)A[d]=m.sessionVariables.axisY.height;
else for(d=0;d<b.length;d++)m.sessionVariables.axisY.height=A[d];if(b&&0<b.length)for(d=b.length-1;0<=d;d--)l=Math.round(g.y2),k=Math.round(g.y2>b[d].chart.height-10?b[d].chart.height-10:g.y2),b[d].lineCoordinates.y1=l-(A[d]+b[d].margin+E),b[d].lineCoordinates.y2=l-(A[d]+b[d].margin+E),b[d].bounds={x1:h,y1:l-(A[d]+E+b[d].margin),x2:t,y2:k-(E+b[d].margin),width:t-h,height:A[d]},b[d].title&&(b[d]._titleTextBlock.maxWidth=0<b[d].titleMaxWidth&&b[d].titleMaxWidth<b[d].lineCoordinates.width?b[d].titleMaxWidth:
b[d].lineCoordinates.width),E+=A[d]+b[d].margin;if(c&&0<c.length)for(d=c.length-1;0<=d;d--)c[d]&&(l=Math.round(g.y1),k=Math.round(g.y1+(J[d]+c[d].margin+U)),c[d].lineCoordinates.y1=k,c[d].lineCoordinates.y2=k,c[d].bounds={x1:h,y1:l+(c[d].margin+U),x2:t,y2:k,width:t-h,height:N},c[d].title&&(c[d]._titleTextBlock.maxWidth=0<c[d].titleMaxWidth&&c[d].titleMaxWidth<c[d].lineCoordinates.width?c[d].titleMaxWidth:c[d].lineCoordinates.width),U+=J[d]+c[d].margin);if(a&&0<a.length)for(d=0;d<a.length;d++){M=a[d]._labels&&
0<a[d]._labels.length?a[d]._labels[0].textBlock.fontSize/2:0;h=Math.round(g.x1+e);l=c&&0<c.length?Math.round(c[0]?c[0].lineCoordinates.y2:g.y1<Math.max(M,10)?Math.max(M,10):g.y1):g.y1<Math.max(M,10)?Math.max(M,10):g.y1;t=Math.round(g.x1+Z+e);k=b&&0<b.length?Math.round(b[0]?b[0].lineCoordinates.y1:g.y2-X>m.height-Math.max(M,10)?m.height-Math.max(M,10):g.y2-X):g.y2>m.height-Math.max(M,10)?m.height-Math.max(M,10):g.y2;if(b&&0<b.length)for(M=0;M<b.length;M++)b[M]&&b[M].labelAutoFit&&(t=0>b[M].labelAngle?
Math.max(t,z):0===b[M].labelAngle?Math.max(t,z/2):t,h=0>b[M].labelAngle||0===b[M].labelAngle?t-Z:h);if(c&&0<c.length)for(M=0;M<c.length;M++)c[M]&&c[M].labelAutoFit&&(t=c[M].lineCoordinates.x1,h=t-Z);a[d].lineCoordinates={x1:t-T,y1:l,x2:t-T,y2:k,height:Math.abs(k-l)};a[d].bounds={x1:t-(x[d]+T),y1:l,x2:t,y2:k,width:t-h,height:k-l};a[d].title&&(a[d]._titleTextBlock.maxWidth=0<a[d].titleMaxWidth&&a[d].titleMaxWidth<a[d].lineCoordinates.height?a[d].titleMaxWidth:a[d].lineCoordinates.height);a[d].calculateValueToPixelConversionParameters();
a[d].calculateBreaksSizeInValues();T+=x[d]+a[d].margin}if(f&&0<f.length)for(d=0;d<f.length;d++){M=f[d]._labels&&0<f[d]._labels.length?f[d]._labels[0].textBlock.fontSize/2:0;h=Math.round(g.x1-e);l=c&&0<c.length?Math.round(c[0]?c[0].lineCoordinates.y2:g.y1<Math.max(M,10)?Math.max(M,10):g.y1):g.y1<Math.max(M,10)?Math.max(M,10):g.y1;t=Math.round(g.x2-V-W);k=b&&0<b.length?Math.round(b[0]?b[0].lineCoordinates.y1:g.y2-X>m.height-Math.max(M,10)?m.height-Math.max(M,10):g.y2-X):g.y2>m.height-Math.max(M,10)?
m.height-Math.max(M,10):g.y2;if(b&&0<b.length)for(M=0;M<b.length;M++)b[M]&&b[M].labelAutoFit&&(t=0>b[M].labelAngle?Math.max(t,z):0===b[M].labelAngle?Math.max(t,z/2):t,h=0>b[M].labelAngle||0===b[M].labelAngle?t-V:h);if(c&&0<c.length)for(M=0;M<c.length;M++)c[M]&&c[M].labelAutoFit&&(t=c[M].lineCoordinates.x2,h=t-V);f[d].lineCoordinates={x1:t+Y,y1:l,x2:t+Y,y2:k,height:Math.abs(k-l)};f[d].bounds={x1:h,y1:l,x2:t+I[d]+Y,y2:k,width:t-h,height:k-l};f[d].title&&(f[d]._titleTextBlock.maxWidth=0<f[d].titleMaxWidth&&
f[d].titleMaxWidth<f[d].lineCoordinates.height?f[d].titleMaxWidth:f[d].lineCoordinates.height);f[d].calculateValueToPixelConversionParameters();f[d].calculateBreaksSizeInValues();Y+=I[d]+f[d].margin}for(d=0;d<n.length;d++)"axisY"===n[d].type&&(n[d].calculateValueToPixelConversionParameters(),n[d].calculateBreaksSizeInValues());if(0<s){if(a&&0<a.length)for(d=0;d<a.length;d++)q=R[s-1][d]===R[s][d]?!0:!1;else q=!0;if(f&&0<f.length)for(d=0;d<f.length;d++)L=S[s-1][d]===S[s][d]?!0:!1;else L=!0;if(b&&0<
b.length)for(d=0;d<b.length;d++)K=u[s-1][d]===u[s][d]?!0:!1;else K=!0;if(c&&0<c.length)for(d=0;d<c.length;d++)O=P[s-1][d]===P[s][d]?!0:!1;else O=!0}if(q&&L&&K&&O)break;s++}if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].calculateStripLinesThicknessInValues(),b[d].calculateBreaksInPixels(),b[d].renderLabelsTicksAndTitle();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].calculateStripLinesThicknessInValues(),c[d].calculateBreaksInPixels(),c[d].renderLabelsTicksAndTitle();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].calculateStripLinesThicknessInValues(),
a[d].calculateBreaksInPixels(),a[d].renderLabelsTicksAndTitle();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateStripLinesThicknessInValues(),f[d].calculateBreaksInPixels(),f[d].renderLabelsTicksAndTitle()}m.preparePlotArea();g=m.plotArea;p.save();p.beginPath();p.rect(g.x1,g.y1,Math.abs(g.x2-g.x1),Math.abs(g.y2-g.y1));p.clip();if(a&&0<a.length)for(d=0;d<n.length;d++)n[d].renderStripLinesOfThicknessType("value");if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderStripLinesOfThicknessType("value");
if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderStripLinesOfThicknessType("value");if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderStripLinesOfThicknessType("value");if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderInterlacedColors();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderInterlacedColors();if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderInterlacedColors();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderInterlacedColors();p.restore();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderGrid(),
v&&(a[d].createMask(),a[d].renderBreaksBackground());if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderGrid(),v&&(f[d].createMask(),f[d].renderBreaksBackground());if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderGrid(),v&&(b[d].createMask(),b[d].renderBreaksBackground());if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderGrid(),v&&(c[d].createMask(),c[d].renderBreaksBackground());if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderAxisLine();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderAxisLine();
if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderAxisLine();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderAxisLine();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderStripLinesOfThicknessType("pixel");if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderStripLinesOfThicknessType("pixel");if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderStripLinesOfThicknessType("pixel");if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderStripLinesOfThicknessType("pixel")};C.prototype.calculateStripLinesThicknessInValues=
function(){for(var a=0;a<this.stripLines.length;a++)if(null!==this.stripLines[a].startValue&&null!==this.stripLines[a].endValue){var f=Math.min(this.stripLines[a].startValue,this.stripLines[a].endValue),b=Math.max(this.stripLines[a].startValue,this.stripLines[a].endValue),f=this.getApparentDifference(f,b);this.stripLines[a].value=this.logarithmic?this.stripLines[a].value*Math.sqrt(Math.log(this.stripLines[a].endValue/this.stripLines[a].startValue)/Math.log(f)):this.stripLines[a].value+(Math.abs(this.stripLines[a].endValue-
this.stripLines[a].startValue)-f)/2;this.stripLines[a].thickness=f;this.stripLines[a]._thicknessType="value"}};C.prototype.calculateBreaksSizeInValues=function(){for(var a="left"===this._position||"right"===this._position?this.lineCoordinates.height||this.chart.height:this.lineCoordinates.width||this.chart.width,f=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[],b=this.conversionParameters.pixelPerUnit||a/(this.logarithmic?this.conversionParameters.maximum/this.conversionParameters.minimum:this.conversionParameters.maximum-
this.conversionParameters.minimum),c=this.scaleBreaks&&!y(this.scaleBreaks.options.spacing),e,g=0;g<f.length;g++)e=c||!y(f[g].options.spacing),f[g].spacing=J(f[g].spacing,a,8,e?0.1*a:8,e?0:3)<<0,f[g].size=0>f[g].spacing?0:Math.abs(f[g].spacing/b),this.logarithmic&&(f[g].size=Math.pow(this.logarithmBase,f[g].size))};C.prototype.calculateBreaksInPixels=function(){if(!(this.scaleBreaks&&0>=this.scaleBreaks._appliedBreaks.length)){var a=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[];a.length&&(this.scaleBreaks.firstBreakIndex=
this.scaleBreaks.lastBreakIndex=null);for(var f=0;f<a.length&&!(a[f].startValue>this.conversionParameters.maximum);f++)a[f].endValue<this.conversionParameters.minimum||(y(this.scaleBreaks.firstBreakIndex)&&(this.scaleBreaks.firstBreakIndex=f),a[f].startValue>=this.conversionParameters.minimum&&(a[f].startPixel=this.convertValueToPixel(a[f].startValue),this.scaleBreaks.lastBreakIndex=f),a[f].endValue<=this.conversionParameters.maximum&&(a[f].endPixel=this.convertValueToPixel(a[f].endValue)))}};C.prototype.renderLabelsTicksAndTitle=
function(){var a=this,f=!1,b=0,c=0,e=1,g=0;0!==this.labelAngle&&360!==this.labelAngle&&(e=1.2);if("undefined"===typeof this.options.interval){if("bottom"===this._position||"top"===this._position)if(this.logarithmic&&!this.equidistantInterval&&this.labelAutoFit){for(var b=[],e=0!==this.labelAngle&&360!==this.labelAngle?1:1.2,h,l=this.viewportMaximum,m=this.lineCoordinates.width/Math.log(this.range),k=this._labels.length-1;0<=k;k--){p=this._labels[k];if(p.position<this.viewportMinimum)break;p.position>
this.viewportMaximum||!(k===this._labels.length-1||h<Math.log(l/p.position)*m/e)||(b.push(p),l=p.position,h=p.textBlock.width*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+p.textBlock.height*Math.abs(Math.sin(Math.PI/180*this.labelAngle)))}this._labels=b}else{for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(h=p.textBlock.width*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+p.textBlock.height*Math.abs(Math.sin(Math.PI/180*this.labelAngle)),b+=h);b>this.lineCoordinates.width*
e&&this.labelAutoFit&&(f=!0)}if("left"===this._position||"right"===this._position)if(this.logarithmic&&!this.equidistantInterval&&this.labelAutoFit){for(var b=[],r,l=this.viewportMaximum,m=this.lineCoordinates.height/Math.log(this.range),k=this._labels.length-1;0<=k;k--){p=this._labels[k];if(p.position<this.viewportMinimum)break;p.position>this.viewportMaximum||!(k===this._labels.length-1||r<Math.log(l/p.position)*m)||(b.push(p),l=p.position,r=p.textBlock.height*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+
p.textBlock.width*Math.abs(Math.sin(Math.PI/180*this.labelAngle)))}this._labels=b}else{for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(r=p.textBlock.height*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+p.textBlock.width*Math.abs(Math.sin(Math.PI/180*this.labelAngle)),c+=r);c>this.lineCoordinates.height*e&&this.labelAutoFit&&(f=!0)}}this.logarithmic&&(!this.equidistantInterval&&this.labelAutoFit)&&this._labels.sort(function(a,b){return a.position-b.position});
var k=0,p,n;if("bottom"===this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0,this.ctx.beginPath(),this.ctx.moveTo(c,n.y<<0),this.ctx.lineTo(c,n.y+this.tickLength<<0),
this.ctx.stroke()),0===p.textBlock.angle?(n.x-=p.textBlock.width/2,n.y="inside"===this.labelPlacement?n.y-(this.tickLength+p.textBlock.fontSize/2):n.y+this.tickLength+p.textBlock.fontSize/2):(n.x="inside"===this.labelPlacement?0>this.labelAngle?n.x:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):n.x-(0>this.labelAngle?p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0),n.y="inside"===this.labelPlacement?0>this.labelAngle?n.y-this.tickLength-5:n.y-this.tickLength-Math.abs(p.textBlock.width*
Math.sin(Math.PI/180*this.labelAngle)+5):n.y+this.tickLength+Math.abs(0>this.labelAngle?p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle)-5:5)),p.textBlock.x=n.x,p.textBlock.y=n.y);"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),a.tickThickness)){a.ctx.lineWidth=
a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===a.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(b,n.y<<0);a.ctx.lineTo(b,n.y-a.tickLength<<0);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.lineCoordinates.x1+this.lineCoordinates.width/2-this._titleTextBlock.width/2,this._titleTextBlock.y=this.bounds.y2-this._titleTextBlock.height-3,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}else if("top"===
this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0,this.ctx.beginPath(),this.ctx.moveTo(c,n.y<<0),this.ctx.lineTo(c,n.y-this.tickLength<<0),this.ctx.stroke()),0===p.textBlock.angle?
(n.x-=p.textBlock.width/2,n.y="inside"===this.labelPlacement?n.y+this.labelFontSize/2+this.tickLength+5:n.y-(this.tickLength+p.textBlock.height-p.textBlock.fontSize/2)):(n.x="inside"===this.labelPlacement?0<this.labelAngle?n.x:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):n.x+(p.textBlock.height-this.tickLength-this.labelFontSize)*Math.sin(Math.PI/180*this.labelAngle)-(0<this.labelAngle?p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0),n.y="inside"===this.labelPlacement?0<this.labelAngle?
n.y+this.tickLength+5:n.y-p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle)+this.tickLength+5:n.y-(this.tickLength+((p.textBlock.height-p.textBlock.fontSize/2)*Math.cos(Math.PI/180*this.labelAngle)+(0<this.labelAngle?p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle):0)))),p.textBlock.x=n.x,p.textBlock.y=n.y);"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||
p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),a.tickThickness)){a.ctx.lineWidth=a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===this.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(b,n.y<<0);a.ctx.lineTo(b,n.y+a.tickLength<<0);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.lineCoordinates.x1+this.lineCoordinates.width/2-this._titleTextBlock.width/
2,this._titleTextBlock.y=this.bounds.y1+1,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}else if("left"===this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%
2?(n.y<<0)+0.5:n.y<<0,this.ctx.beginPath(),this.ctx.moveTo(n.x<<0,c),this.ctx.lineTo(n.x-this.tickLength<<0,c),this.ctx.stroke()),0===this.labelAngle?(p.textBlock.y=n.y,p.textBlock.x="inside"===this.labelPlacement?n.x+this.tickLength+5:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5):(p.textBlock.y="inside"===this.labelPlacement?n.y:n.y-p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle),p.textBlock.x="inside"===this.labelPlacement?n.x+this.tickLength+5:0<this.labelAngle?
n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)+(p.textBlock.height-p.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)-this.tickLength));"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),
a.tickThickness)){a.ctx.lineWidth=a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===a.ctx.lineWidth%2?(n.y<<0)+0.5:n.y<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(n.x<<0,b);a.ctx.lineTo(n.x+a.tickLength<<0,b);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.bounds.x1+1,this._titleTextBlock.y=this.lineCoordinates.height/2+this._titleTextBlock.width/2+this.lineCoordinates.y1,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}else if("right"===
this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%2?(n.y<<0)+0.5:n.y<<0,this.ctx.beginPath(),this.ctx.moveTo(n.x<<0,c),this.ctx.lineTo(n.x+this.tickLength<<0,c),this.ctx.stroke()),0===this.labelAngle?
(p.textBlock.y=n.y,p.textBlock.x="inside"===this.labelPlacement?n.x-p.textBlock.width-this.tickLength-5:n.x+this.tickLength+5):(p.textBlock.y="inside"===this.labelPlacement?n.y-p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle):0>this.labelAngle?n.y:n.y-(p.textBlock.height-p.textBlock.fontSize/2-5)*Math.cos(Math.PI/180*this.labelAngle),p.textBlock.x="inside"===this.labelPlacement?n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:0<this.labelAngle?n.x+(p.textBlock.height-
p.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)+this.tickLength:n.x+this.tickLength+5));"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),a.tickThickness)){a.ctx.lineWidth=a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===a.ctx.lineWidth%2?(n.y<<
0)+0.5:n.y<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(n.x<<0,b);a.ctx.lineTo(n.x-a.tickLength<<0,b);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.bounds.x2-1,this._titleTextBlock.y=this.lineCoordinates.height/2-this._titleTextBlock.width/2+this.lineCoordinates.y1,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}g=0;if("inside"===this.labelPlacement)this.chart.addEventListener("dataAnimationIterationEnd",
function(){for(k=0;k<a._labels.length;k++)p=a._labels[k],p.position<a.viewportMinimum||(p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)||(a.ctx.save(),a.ctx.beginPath(),p.textBlock.render(!0),a.ctx.restore())},p.textBlock);else for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||p.textBlock.render(!0)};C.prototype.renderInterlacedColors=function(){var a=this.chart.plotArea.ctx,f,b,c=this.chart.plotArea,
e=0;f=!0;if(("bottom"===this._position||"top"===this._position)&&this.interlacedColor)for(a.fillStyle=this.interlacedColor,e=0;e<this._labels.length;e++)f?(f=this.getPixelCoordinatesOnAxis(this._labels[e].position),b=e+1>this._labels.length-1?this.getPixelCoordinatesOnAxis(this.viewportMaximum):this.getPixelCoordinatesOnAxis(this._labels[e+1].position),a.fillRect(Math.min(b.x,f.x),c.y1,Math.abs(b.x-f.x),Math.abs(c.y1-c.y2)),f=!1):f=!0;else if(("left"===this._position||"right"===this._position)&&this.interlacedColor)for(a.fillStyle=
this.interlacedColor,e=0;e<this._labels.length;e++)f?(b=this.getPixelCoordinatesOnAxis(this._labels[e].position),f=e+1>this._labels.length-1?this.getPixelCoordinatesOnAxis(this.viewportMaximum):this.getPixelCoordinatesOnAxis(this._labels[e+1].position),a.fillRect(c.x1,Math.min(b.y,f.y),Math.abs(c.x1-c.x2),Math.abs(f.y-b.y)),f=!1):f=!0;a.beginPath()};C.prototype.renderStripLinesOfThicknessType=function(a){if(this.stripLines&&0<this.stripLines.length&&a){for(var f=this,b,c=0,e=0,g=!1,h=!1,l=[],m=[],
h=!1,c=0;c<this.stripLines.length;c++){var k=this.stripLines[c];k._thicknessType===a&&("pixel"===a&&(k.value<this.viewportMinimum||k.value>this.viewportMaximum||y(k.value)||isNaN(this.range))||l.push(k))}for(c=0;c<this._stripLineLabels.length;c++)if(k=this.stripLines[c],b=this._stripLineLabels[c],!(b.position<this.viewportMinimum||b.position>this.viewportMaximum||isNaN(this.range))){a=this.getPixelCoordinatesOnAxis(b.position);if("outside"===b.stripLine.labelPlacement)if(k&&(this.ctx.strokeStyle=
k.color,"pixel"===k._thicknessType&&(this.ctx.lineWidth=k.thickness)),"bottom"===this._position){var r=1===this.ctx.lineWidth%2?(a.x<<0)+0.5:a.x<<0;this.ctx.beginPath();this.ctx.moveTo(r,a.y<<0);this.ctx.lineTo(r,a.y+this.tickLength<<0);this.ctx.stroke();0===this.labelAngle?(a.x-=b.textBlock.width/2,a.y+=this.tickLength+b.textBlock.fontSize/2):(a.x-=0>this.labelAngle?b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0,a.y+=this.tickLength+Math.abs(0>this.labelAngle?b.textBlock.width*Math.sin(Math.PI/
180*this.labelAngle)-5:5))}else"top"===this._position?(r=1===this.ctx.lineWidth%2?(a.x<<0)+0.5:a.x<<0,this.ctx.beginPath(),this.ctx.moveTo(r,a.y<<0),this.ctx.lineTo(r,a.y-this.tickLength<<0),this.ctx.stroke(),0===this.labelAngle?(a.x-=b.textBlock.width/2,a.y-=this.tickLength+b.textBlock.height):(a.x+=(b.textBlock.height-this.tickLength-this.labelFontSize/2)*Math.sin(Math.PI/180*this.labelAngle)-(0<this.labelAngle?b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0),a.y-=this.tickLength+(b.textBlock.height*
Math.cos(Math.PI/180*this.labelAngle)+(0<this.labelAngle?b.textBlock.width*Math.sin(Math.PI/180*this.labelAngle):0)))):"left"===this._position?(r=1===this.ctx.lineWidth%2?(a.y<<0)+0.5:a.y<<0,this.ctx.beginPath(),this.ctx.moveTo(a.x<<0,r),this.ctx.lineTo(a.x-this.tickLength<<0,r),this.ctx.stroke(),0===this.labelAngle?a.x=a.x-b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:(a.y-=b.textBlock.width*Math.sin(Math.PI/180*this.labelAngle),a.x=0<this.labelAngle?a.x-b.textBlock.width*
Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:a.x-b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)+(b.textBlock.height-b.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)-this.tickLength)):"right"===this._position&&(r=1===this.ctx.lineWidth%2?(a.y<<0)+0.5:a.y<<0,this.ctx.beginPath(),this.ctx.moveTo(a.x<<0,r),this.ctx.lineTo(a.x+this.tickLength<<0,r),this.ctx.stroke(),0===this.labelAngle?a.x=a.x+this.tickLength+5:(a.y=0>this.labelAngle?a.y:a.y-(b.textBlock.height-b.textBlock.fontSize/
2-5)*Math.cos(Math.PI/180*this.labelAngle),a.x=0<this.labelAngle?a.x+(b.textBlock.height-b.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)+this.tickLength:a.x+this.tickLength+5));else b.textBlock.angle=-90,"bottom"===this._position?(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.height-3,b.textBlock.measureText(),a.x-b.textBlock.height>this.chart.plotArea.x1?y(k.startValue)?a.x-=b.textBlock.height-b.textBlock.fontSize/
2:a.x-=b.textBlock.height/2-b.textBlock.fontSize/2+3:(b.textBlock.angle=90,y(k.startValue)?a.x+=b.textBlock.height-b.textBlock.fontSize/2:a.x+=b.textBlock.height/2-b.textBlock.fontSize/2+3),a.y=-90===b.textBlock.angle?"near"===b.stripLine.labelAlign?this.chart.plotArea.y2-3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1+b.textBlock.width)/2:this.chart.plotArea.y1+b.textBlock.width+3:"near"===b.stripLine.labelAlign?this.chart.plotArea.y2-b.textBlock.width-3:"center"===
b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1-b.textBlock.width)/2:this.chart.plotArea.y1+3):"top"===this._position?(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.height-3,b.textBlock.measureText(),a.x-b.textBlock.height>this.chart.plotArea.x1?y(k.startValue)?a.x-=b.textBlock.height-b.textBlock.fontSize/2:a.x-=b.textBlock.height/2-b.textBlock.fontSize/2+3:(b.textBlock.angle=90,y(k.startValue)?a.x+=
b.textBlock.height-b.textBlock.fontSize/2:a.x+=b.textBlock.height/2-b.textBlock.fontSize/2+3),a.y=-90===b.textBlock.angle?"near"===b.stripLine.labelAlign?this.chart.plotArea.y1+b.textBlock.width+3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1+b.textBlock.width)/2:this.chart.plotArea.y2-3:"near"===b.stripLine.labelAlign?this.chart.plotArea.y1+3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1-b.textBlock.width)/2:this.chart.plotArea.y2-
b.textBlock.width-3):"left"===this._position?(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.width-3,b.textBlock.angle=0,b.textBlock.measureText(),a.y-b.textBlock.height>this.chart.plotArea.y1?y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/2:a.y-=b.textBlock.height/2-b.textBlock.fontSize+3:a.y-b.textBlock.height<this.chart.plotArea.y2?a.y+=b.textBlock.fontSize/2+3:y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/
2:a.y-=b.textBlock.height/2-b.textBlock.fontSize+3,a.x="near"===b.stripLine.labelAlign?this.chart.plotArea.x1+3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.x2+this.chart.plotArea.x1)/2-b.textBlock.width/2:this.chart.plotArea.x2-b.textBlock.width-3):"right"===this._position&&(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.width-3,b.textBlock.angle=0,b.textBlock.measureText(),a.y-+b.textBlock.height>this.chart.plotArea.y1?
y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/2:a.y-=b.textBlock.height/2-b.textBlock.fontSize/2-3:a.y-b.textBlock.height<this.chart.plotArea.y2?a.y+=b.textBlock.fontSize/2+3:y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/2:a.y-=b.textBlock.height/2-b.textBlock.fontSize/2+3,a.x="near"===b.stripLine.labelAlign?this.chart.plotArea.x2-b.textBlock.width-3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.x2+this.chart.plotArea.x1)/2-b.textBlock.width/2:this.chart.plotArea.x1+
3);b.textBlock.x=a.x;b.textBlock.y=a.y;m.push(b)}if(!h){h=!1;this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.ctx.clip();for(c=0;c<l.length;c++)k=l[c],k.showOnTop?g||(g=!0,this.chart.addEventListener("dataAnimationIterationEnd",function(){this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.ctx.clip();
for(e=0;e<l.length;e++)k=l[e],k.showOnTop&&k.render();this.ctx.restore()},k)):k.render();for(c=0;c<m.length;c++)b=m[c],b.stripLine.showOnTop?h||(h=!0,this.chart.addEventListener("dataAnimationIterationEnd",function(){for(e=0;e<m.length;e++)b=m[e],"inside"===b.stripLine.labelPlacement&&b.stripLine.showOnTop&&(f.ctx.save(),f.ctx.beginPath(),f.ctx.rect(f.chart.plotArea.x1,f.chart.plotArea.y1,f.chart.plotArea.width,f.chart.plotArea.height),f.ctx.clip(),b.textBlock.render(!0),f.ctx.restore())},b.textBlock)):
"inside"===b.stripLine.labelPlacement&&b.textBlock.render(!0);this.ctx.restore();h=!0}if(h)for(h=!1,c=0;c<m.length;c++)b=m[c],b.stripLine.showOnTop?h||(h=!0,this.chart.addEventListener("dataAnimationIterationEnd",function(){for(e=0;e<m.length;e++)b=m[e],"outside"===b.stripLine.labelPlacement&&b.stripLine.showOnTop&&b.textBlock.render(!0)},b.textBlock)):"outside"===b.stripLine.labelPlacement&&b.textBlock.render(!0)}};C.prototype.renderBreaksBackground=function(){this.chart._breaksCanvas&&(this.scaleBreaks&&
0<this.scaleBreaks._appliedBreaks.length&&this.maskCanvas)&&(this.chart._breaksCanvasCtx.save(),this.chart._breaksCanvasCtx.beginPath(),this.chart._breaksCanvasCtx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height),this.chart._breaksCanvasCtx.clip(),this.chart._breaksCanvasCtx.drawImage(this.maskCanvas,0,0,this.chart.width,this.chart.height),this.chart._breaksCanvasCtx.restore())};C.prototype.createMask=function(){if(this.scaleBreaks&&0<this.scaleBreaks._appliedBreaks.length){var a=
this.scaleBreaks._appliedBreaks;v?(this.maskCanvas=ta(this.chart.width,this.chart.height),this.maskCtx=this.maskCanvas.getContext("2d")):(this.maskCanvas=this.chart.plotArea.canvas,this.maskCtx=this.chart.plotArea.ctx);this.maskCtx.save();this.maskCtx.beginPath();this.maskCtx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.maskCtx.clip();for(var f=0;f<a.length;f++)a[f].endValue<this.viewportMinimum||(a[f].startValue>this.viewportMaximum||
isNaN(this.range))||a[f].render(this.maskCtx);this.maskCtx.restore()}};C.prototype.renderCrosshair=function(a,f){this.crosshair.render(a,f)};C.prototype.renderGrid=function(){if(this.gridThickness&&0<this.gridThickness){var a=this.chart.ctx;a.save();var f,b=this.chart.plotArea;a.lineWidth=this.gridThickness;a.strokeStyle=this.gridColor;a.setLineDash&&a.setLineDash(F(this.gridDashType,this.gridThickness));if("bottom"===this._position||"top"===this._position)for(c=0;c<this._labels.length;c++)this._labels[c].position<
this.viewportMinimum||(this._labels[c].position>this.viewportMaximum||this._labels[c].breaksLabelType)||(a.beginPath(),f=this.getPixelCoordinatesOnAxis(this._labels[c].position),f=1===a.lineWidth%2?(f.x<<0)+0.5:f.x<<0,a.moveTo(f,b.y1<<0),a.lineTo(f,b.y2<<0),a.stroke());else if("left"===this._position||"right"===this._position)for(var c=0;c<this._labels.length;c++)this._labels[c].position<this.viewportMinimum||(this._labels[c].position>this.viewportMaximum||this._labels[c].breaksLabelType)||(a.beginPath(),
f=this.getPixelCoordinatesOnAxis(this._labels[c].position),f=1===a.lineWidth%2?(f.y<<0)+0.5:f.y<<0,a.moveTo(b.x1<<0,f),a.lineTo(b.x2<<0,f),a.stroke());a.restore()}};C.prototype.renderAxisLine=function(){var a=this.chart.ctx,f=v?this.chart._preRenderCtx:a,b=Math.ceil(this.tickThickness/(this.reversed?-2:2)),c=Math.ceil(this.tickThickness/(this.reversed?2:-2)),e,g;f.save();if("bottom"===this._position||"top"===this._position){if(this.lineThickness){this.reversed?(e=this.lineCoordinates.x2,g=this.lineCoordinates.x1):
(e=this.lineCoordinates.x1,g=this.lineCoordinates.x2);f.lineWidth=this.lineThickness;f.strokeStyle=this.lineColor?this.lineColor:"black";f.setLineDash&&f.setLineDash(F(this.lineDashType,this.lineThickness));var h=1===this.lineThickness%2?(this.lineCoordinates.y1<<0)+0.5:this.lineCoordinates.y1<<0;f.beginPath();if(this.scaleBreaks&&!y(this.scaleBreaks.firstBreakIndex))if(y(this.scaleBreaks.lastBreakIndex))e=this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex].endPixel+c;else for(var l=
this.scaleBreaks.firstBreakIndex;l<=this.scaleBreaks.lastBreakIndex;l++)f.moveTo(e,h),f.lineTo(this.scaleBreaks._appliedBreaks[l].startPixel+b,h),e=this.scaleBreaks._appliedBreaks[l].endPixel+c;e&&(f.moveTo(e,h),f.lineTo(g,h));f.stroke()}}else if(("left"===this._position||"right"===this._position)&&this.lineThickness){this.reversed?(e=this.lineCoordinates.y1,g=this.lineCoordinates.y2):(e=this.lineCoordinates.y2,g=this.lineCoordinates.y1);f.lineWidth=this.lineThickness;f.strokeStyle=this.lineColor;
f.setLineDash&&f.setLineDash(F(this.lineDashType,this.lineThickness));h=1===this.lineThickness%2?(this.lineCoordinates.x1<<0)+0.5:this.lineCoordinates.x1<<0;f.beginPath();if(this.scaleBreaks&&!y(this.scaleBreaks.firstBreakIndex))if(y(this.scaleBreaks.lastBreakIndex))e=this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex].endPixel+b;else for(l=this.scaleBreaks.firstBreakIndex;l<=this.scaleBreaks.lastBreakIndex;l++)f.moveTo(h,e),f.lineTo(h,this.scaleBreaks._appliedBreaks[l].startPixel+c),
e=this.scaleBreaks._appliedBreaks[l].endPixel+b;e&&(f.moveTo(h,e),f.lineTo(h,g));f.stroke()}v&&(a.drawImage(this.chart._preRenderCanvas,0,0,this.chart.width,this.chart.height),this.chart._breaksCanvasCtx&&this.chart._breaksCanvasCtx.drawImage(this.chart._preRenderCanvas,0,0,this.chart.width,this.chart.height),f.clearRect(0,0,this.chart.width,this.chart.height));f.restore()};C.prototype.getPixelCoordinatesOnAxis=function(a){var f={};if("bottom"===this._position||"top"===this._position)f.x=this.convertValueToPixel(a),
f.y=this.lineCoordinates.y1;if("left"===this._position||"right"===this._position)f.y=this.convertValueToPixel(a),f.x=this.lineCoordinates.x2;return f};C.prototype.convertPixelToValue=function(a){if("undefined"===typeof a)return null;var f=0,b=0,c,f=!0,e=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[],b="number"===typeof a?a:"left"===this._position||"right"===this._position?a.y:a.x;if(this.logarithmic){a=c=Math.pow(this.logarithmBase,(b-this.conversionParameters.reference)/this.conversionParameters.pixelPerUnit);
if(b<=this.conversionParameters.reference===("left"===this._position||"right"===this._position)!==this.reversed)for(b=0;b<e.length;b++){if(!(e[b].endValue<this.conversionParameters.minimum))if(f)if(e[b].startValue<this.conversionParameters.minimum){if(1<e[b].size&&this.conversionParameters.minimum*Math.pow(e[b].endValue/e[b].startValue,Math.log(c)/Math.log(e[b].size))<e[b].endValue){a=Math.pow(e[b].endValue/e[b].startValue,Math.log(c)/Math.log(e[b].size));break}else a*=e[b].endValue/this.conversionParameters.minimum/
Math.pow(e[b].size,Math.log(e[b].endValue/this.conversionParameters.minimum)/Math.log(e[b].endValue/e[b].startValue)),c/=Math.pow(e[b].size,Math.log(e[b].endValue/this.conversionParameters.minimum)/Math.log(e[b].endValue/e[b].startValue));f=!1}else if(c>e[b].startValue/this.conversionParameters.minimum){c/=e[b].startValue/this.conversionParameters.minimum;if(c<e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1===e[b].size?1:Math.log(c)/Math.log(e[b].size))/c;break}else a*=e[b].endValue/e[b].startValue/
e[b].size;c/=e[b].size;f=!1}else break;else if(c>e[b].startValue/e[b-1].endValue){c/=e[b].startValue/e[b-1].endValue;if(c<e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1===e[b].size?1:Math.log(c)/Math.log(e[b].size))/c;break}else a*=e[b].endValue/e[b].startValue/e[b].size;c/=e[b].size}else break}else for(b=e.length-1;0<=b;b--)if(!(e[b].startValue>this.conversionParameters.minimum))if(f)if(e[b].endValue>this.conversionParameters.minimum){if(1<e[b].size&&this.conversionParameters.minimum*Math.pow(e[b].endValue/
e[b].startValue,Math.log(c)/Math.log(e[b].size))>e[b].startValue){a=Math.pow(e[b].endValue/e[b].startValue,Math.log(c)/Math.log(e[b].size));break}else a*=e[b].startValue/this.conversionParameters.minimum*Math.pow(e[b].size,Math.log(e[b].startValue/this.conversionParameters.minimum)/Math.log(e[b].endValue/e[b].startValue))*c,c*=Math.pow(e[b].size,Math.log(this.conversionParameters.minimum/e[b].startValue)/Math.log(e[b].endValue/e[b].startValue));f=!1}else if(c<e[b].endValue/this.conversionParameters.minimum){c/=
e[b].endValue/this.conversionParameters.minimum;if(c>1/e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1>=e[b].size?1:Math.log(c)/Math.log(e[b].size))*c;break}else a/=e[b].endValue/e[b].startValue/e[b].size;c*=e[b].size;f=!1}else break;else if(c<e[b].endValue/e[b+1].startValue){c/=e[b].endValue/e[b+1].startValue;if(c>1/e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1>=e[b].size?1:Math.log(c)/Math.log(e[b].size))*c;break}else a/=e[b].endValue/e[b].startValue/e[b].size;c*=e[b].size}else break;
f=a*this.viewportMinimum}else{a=c=(b-this.conversionParameters.reference)/this.conversionParameters.pixelPerUnit;if(b<=this.conversionParameters.reference===("left"===this._position||"right"===this._position)!==this.reversed)for(b=0;b<e.length;b++){if(!(e[b].endValue<this.conversionParameters.minimum))if(f)if(e[b].startValue<this.conversionParameters.minimum){if(e[b].size&&this.conversionParameters.minimum+c*(e[b].endValue-e[b].startValue)/e[b].size<e[b].endValue){a=0>=e[b].size?0:c*(e[b].endValue-
e[b].startValue)/e[b].size;break}else a+=e[b].endValue-this.conversionParameters.minimum-e[b].size*(e[b].endValue-this.conversionParameters.minimum)/(e[b].endValue-e[b].startValue),c-=e[b].size*(e[b].endValue-this.conversionParameters.minimum)/(e[b].endValue-e[b].startValue);f=!1}else if(c>e[b].startValue-this.conversionParameters.minimum){c-=e[b].startValue-this.conversionParameters.minimum;if(c<e[b].size){a+=(e[b].endValue-e[b].startValue)*(0===e[b].size?1:c/e[b].size)-c;break}else a+=e[b].endValue-
e[b].startValue-e[b].size;c-=e[b].size;f=!1}else break;else if(c>e[b].startValue-e[b-1].endValue){c-=e[b].startValue-e[b-1].endValue;if(c<e[b].size){a+=(e[b].endValue-e[b].startValue)*(0===e[b].size?1:c/e[b].size)-c;break}else a+=e[b].endValue-e[b].startValue-e[b].size;c-=e[b].size}else break}else for(b=e.length-1;0<=b;b--)if(!(e[b].startValue>this.conversionParameters.minimum))if(f)if(e[b].endValue>this.conversionParameters.minimum)if(e[b].size&&this.conversionParameters.minimum+c*(e[b].endValue-
e[b].startValue)/e[b].size>e[b].startValue){a=0>=e[b].size?0:c*(e[b].endValue-e[b].startValue)/e[b].size;break}else a+=e[b].startValue-this.conversionParameters.minimum+e[b].size*(this.conversionParameters.minimum-e[b].startValue)/(e[b].endValue-e[b].startValue),c+=e[b].size*(this.conversionParameters.minimum-e[b].startValue)/(e[b].endValue-e[b].startValue),f=!1;else if(c<e[b].endValue-this.conversionParameters.minimum){c-=e[b].endValue-this.conversionParameters.minimum;if(c>-1*e[b].size){a+=(e[b].endValue-
e[b].startValue)*(0===e[b].size?1:c/e[b].size)+c;break}else a-=e[b].endValue-e[b].startValue-e[b].size;c+=e[b].size;f=!1}else break;else if(c<e[b].endValue-e[b+1].startValue){c-=e[b].endValue-e[b+1].startValue;if(c>-1*e[b].size){a+=(e[b].endValue-e[b].startValue)*(0===e[b].size?1:c/e[b].size)+c;break}else a-=e[b].endValue-e[b].startValue-e[b].size;c+=e[b].size}else break;f=this.conversionParameters.minimum+a}return f};C.prototype.convertValueToPixel=function(a){a=this.getApparentDifference(this.conversionParameters.minimum,
a,a);return this.logarithmic?this.conversionParameters.reference+this.conversionParameters.pixelPerUnit*Math.log(a/this.conversionParameters.minimum)/this.conversionParameters.lnLogarithmBase+0.5<<0:"axisX"===this.type?this.conversionParameters.reference+this.conversionParameters.pixelPerUnit*(a-this.conversionParameters.minimum)+0.5<<0:this.conversionParameters.reference+this.conversionParameters.pixelPerUnit*(a-this.conversionParameters.minimum)+0.5};C.prototype.getApparentDifference=function(a,
f,b,c){var e=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[];if(this.logarithmic){b=y(b)?f/a:b;for(var g=0;g<e.length&&!(f<e[g].startValue);g++)a>e[g].endValue||(a<=e[g].startValue&&f>=e[g].endValue?b=b/e[g].endValue*e[g].startValue*e[g].size:a>=e[g].startValue&&f>=e[g].endValue?b=b/e[g].endValue*a*Math.pow(e[g].size,Math.log(e[g].endValue/a)/Math.log(e[g].endValue/e[g].startValue)):a<=e[g].startValue&&f<=e[g].endValue?b=b/f*e[g].startValue*Math.pow(e[g].size,Math.log(f/e[g].startValue)/Math.log(e[g].endValue/
e[g].startValue)):!c&&(a>e[g].startValue&&f<e[g].endValue)&&(b=a*Math.pow(e[g].size,Math.log(f/a)/Math.log(e[g].endValue/e[g].startValue))))}else for(b=y(b)?Math.abs(f-a):b,g=0;g<e.length&&!(f<e[g].startValue);g++)a>e[g].endValue||(a<=e[g].startValue&&f>=e[g].endValue?b=b-e[g].endValue+e[g].startValue+e[g].size:a>e[g].startValue&&f>=e[g].endValue?b=b-e[g].endValue+a+e[g].size*(e[g].endValue-a)/(e[g].endValue-e[g].startValue):a<=e[g].startValue&&f<e[g].endValue?b=b-f+e[g].startValue+e[g].size*(f-e[g].startValue)/
(e[g].endValue-e[g].startValue):!c&&(a>e[g].startValue&&f<e[g].endValue)&&(b=a+e[g].size*(f-a)/(e[g].endValue-e[g].startValue)));return b};C.prototype.setViewPortRange=function(a,f){this.sessionVariables.newViewportMinimum=this.viewportMinimum=Math.min(a,f);this.sessionVariables.newViewportMaximum=this.viewportMaximum=Math.max(a,f)};C.prototype.getXValueAt=function(a){if(!a)return null;var f=null;"left"===this._position?f=this.convertPixelToValue(a.y):"bottom"===this._position&&(f=this.convertPixelToValue(a.x));
return f};C.prototype.calculateValueToPixelConversionParameters=function(a){a=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[];var f={pixelPerUnit:null,minimum:null,reference:null},b=this.lineCoordinates.width,c=this.lineCoordinates.height,b="bottom"===this._position||"top"===this._position?b:c,c=Math.abs(this.range);if(this.logarithmic)for(var e=0;e<a.length&&!(this.viewportMaximum<a[e].startValue);e++)this.viewportMinimum>a[e].endValue||(this.viewportMinimum>=a[e].startValue&&this.viewportMaximum<=
a[e].endValue?b=0:this.viewportMinimum<=a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c/a[e].endValue*a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100):b-Math.min(a[e].spacing,0.1*b)):this.viewportMinimum>a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c/a[e].endValue*this.viewportMinimum,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*Math.log(a[e].endValue/this.viewportMinimum)/Math.log(a[e].endValue/a[e].startValue)):
b-Math.min(a[e].spacing,0.1*b)*Math.log(a[e].endValue/this.viewportMinimum)/Math.log(a[e].endValue/a[e].startValue)):this.viewportMinimum<=a[e].startValue&&this.viewportMaximum<a[e].endValue&&(c=c/this.viewportMaximum*a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*Math.log(this.viewportMaximum/a[e].startValue)/Math.log(a[e].endValue/a[e].startValue)):b-Math.min(a[e].spacing,0.1*b)*Math.log(this.viewportMaximum/a[e].startValue)/Math.log(a[e].endValue/a[e].startValue)));
else for(e=0;e<a.length&&!(this.viewportMaximum<a[e].startValue);e++)this.viewportMinimum>a[e].endValue||(this.viewportMinimum>=a[e].startValue&&this.viewportMaximum<=a[e].endValue?b=0:this.viewportMinimum<=a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c-a[e].endValue+a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100):b-Math.min(a[e].spacing,0.1*b)):this.viewportMinimum>a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c-a[e].endValue+this.viewportMinimum,
b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*(a[e].endValue-this.viewportMinimum)/(a[e].endValue-a[e].startValue)):b-Math.min(a[e].spacing,0.1*b)*(a[e].endValue-this.viewportMinimum)/(a[e].endValue-a[e].startValue)):this.viewportMinimum<=a[e].startValue&&this.viewportMaximum<a[e].endValue&&(c=c-this.viewportMaximum+a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*(this.viewportMaximum-a[e].startValue)/(a[e].endValue-a[e].startValue)):
b-Math.min(a[e].spacing,0.1*b)*(this.viewportMaximum-a[e].startValue)/(a[e].endValue-a[e].startValue)));f.minimum=this.viewportMinimum;f.maximum=this.viewportMaximum;f.range=c;if("bottom"===this._position||"top"===this._position)this.logarithmic?(f.lnLogarithmBase=Math.log(this.logarithmBase),f.pixelPerUnit=(this.reversed?-1:1)*b*f.lnLogarithmBase/Math.log(Math.abs(c))):f.pixelPerUnit=(this.reversed?-1:1)*b/Math.abs(c),f.reference=this.reversed?this.lineCoordinates.x2:this.lineCoordinates.x1;if("left"===
this._position||"right"===this._position)this.logarithmic?(f.lnLogarithmBase=Math.log(this.logarithmBase),f.pixelPerUnit=(this.reversed?1:-1)*b*f.lnLogarithmBase/Math.log(Math.abs(c))):f.pixelPerUnit=(this.reversed?1:-1)*b/Math.abs(c),f.reference=this.reversed?this.lineCoordinates.y1:this.lineCoordinates.y2;this.conversionParameters=f};C.prototype.calculateAxisParameters=function(){if(this.logarithmic)this.calculateLogarithmicAxisParameters();else{var a=this.chart.layoutManager.getFreeSpace(),f=!1,
b=!1;"bottom"===this._position||"top"===this._position?(this.maxWidth=a.width,this.maxHeight=a.height):(this.maxWidth=a.height,this.maxHeight=a.width);var a="axisX"===this.type?"xySwapped"===this.chart.plotInfo.axisPlacement?62:70:"xySwapped"===this.chart.plotInfo.axisPlacement?50:40,c=4;"axisX"===this.type&&(c=600>this.maxWidth?8:6);var a=Math.max(c,Math.floor(this.maxWidth/a)),e,g,h,c=0;!y(this.options.viewportMinimum)&&(!y(this.options.viewportMaximum)&&this.options.viewportMinimum>=this.options.viewportMaximum)&&
(this.viewportMinimum=this.viewportMaximum=null);if(y(this.options.viewportMinimum)&&!y(this.sessionVariables.newViewportMinimum)&&!isNaN(this.sessionVariables.newViewportMinimum))this.viewportMinimum=this.sessionVariables.newViewportMinimum;else if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum=this.minimum;if(y(this.options.viewportMaximum)&&!y(this.sessionVariables.newViewportMaximum)&&!isNaN(this.sessionVariables.newViewportMaximum))this.viewportMaximum=this.sessionVariables.newViewportMaximum;
else if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum=this.maximum;if(this.scaleBreaks)for(c=0;c<this.scaleBreaks._appliedBreaks.length;c++)if((!y(this.sessionVariables.newViewportMinimum)&&this.sessionVariables.newViewportMinimum>=this.scaleBreaks._appliedBreaks[c].startValue||!y(this.options.minimum)&&this.options.minimum>=this.scaleBreaks._appliedBreaks[c].startValue||!y(this.options.viewportMinimum)&&this.viewportMinimum>=this.scaleBreaks._appliedBreaks[c].startValue)&&
(!y(this.sessionVariables.newViewportMaximum)&&this.sessionVariables.newViewportMaximum<=this.scaleBreaks._appliedBreaks[c].endValue||!y(this.options.maximum)&&this.options.maximum<=this.scaleBreaks._appliedBreaks[c].endValue||!y(this.options.viewportMaximum)&&this.viewportMaximum<=this.scaleBreaks._appliedBreaks[c].endValue)){this.scaleBreaks._appliedBreaks.splice(c,1);break}if("axisX"===this.type){if(this.dataSeries&&0<this.dataSeries.length)for(e=0;e<this.dataSeries.length;e++)"dateTime"===this.dataSeries[e].xValueType&&
(b=!0);e=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin;g=null!==this.viewportMaximum?this.viewportMaximum:this.dataInfo.viewPortMax;0===g-e&&(c="undefined"===typeof this.options.interval?0.4:this.options.interval,g+=c,e-=c);Infinity!==this.dataInfo.minDiff?h=this.dataInfo.minDiff:1<g-e?h=0.5*Math.abs(g-e):(h=1,b&&(f=!0))}else"axisY"===this.type&&(e=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin,g=null!==this.viewportMaximum?this.viewportMaximum:
this.dataInfo.viewPortMax,isFinite(e)||isFinite(g)?isFinite(e)?isFinite(g)||(g=e):e=g:(g="undefined"===typeof this.options.interval?-Infinity:this.options.interval,e="undefined"!==typeof this.options.interval||isFinite(this.dataInfo.minDiff)?0:Infinity),0===e&&0===g?(g+=9,e=0):0===g-e?(c=Math.min(Math.abs(0.01*Math.abs(g)),5),g+=c,e-=c):e>g?(c=Math.min(0.01*Math.abs(this.getApparentDifference(g,e,null,!0)),5),0<=g?e=g-c:g=isFinite(e)?e+c:0):(c=Math.min(0.01*Math.abs(this.getApparentDifference(e,g,
null,!0)),0.05),0!==g&&(g+=c),0!==e&&(e-=c)),h=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:1<g-e?0.5*Math.abs(g-e):1,this.includeZero&&(null===this.viewportMinimum||isNaN(this.viewportMinimum))&&0<e&&(e=0),this.includeZero&&(null===this.viewportMaximum||isNaN(this.viewportMaximum))&&0>g&&(g=0));c=this.getApparentDifference(isNaN(this.viewportMinimum)||null===this.viewportMinimum?e:this.viewportMinimum,isNaN(this.viewportMaximum)||null===this.viewportMaximum?g:this.viewportMaximum,null,
!0);if("axisX"===this.type&&b){this.intervalType||(c/1<=a?(this.interval=1,this.intervalType="millisecond"):c/2<=a?(this.interval=2,this.intervalType="millisecond"):c/5<=a?(this.interval=5,this.intervalType="millisecond"):c/10<=a?(this.interval=10,this.intervalType="millisecond"):c/20<=a?(this.interval=20,this.intervalType="millisecond"):c/50<=a?(this.interval=50,this.intervalType="millisecond"):c/100<=a?(this.interval=100,this.intervalType="millisecond"):c/200<=a?(this.interval=200,this.intervalType=
"millisecond"):c/250<=a?(this.interval=250,this.intervalType="millisecond"):c/300<=a?(this.interval=300,this.intervalType="millisecond"):c/400<=a?(this.interval=400,this.intervalType="millisecond"):c/500<=a?(this.interval=500,this.intervalType="millisecond"):c/(1*U.secondDuration)<=a?(this.interval=1,this.intervalType="second"):c/(2*U.secondDuration)<=a?(this.interval=2,this.intervalType="second"):c/(5*U.secondDuration)<=a?(this.interval=5,this.intervalType="second"):c/(10*U.secondDuration)<=a?(this.interval=
10,this.intervalType="second"):c/(15*U.secondDuration)<=a?(this.interval=15,this.intervalType="second"):c/(20*U.secondDuration)<=a?(this.interval=20,this.intervalType="second"):c/(30*U.secondDuration)<=a?(this.interval=30,this.intervalType="second"):c/(1*U.minuteDuration)<=a?(this.interval=1,this.intervalType="minute"):c/(2*U.minuteDuration)<=a?(this.interval=2,this.intervalType="minute"):c/(5*U.minuteDuration)<=a?(this.interval=5,this.intervalType="minute"):c/(10*U.minuteDuration)<=a?(this.interval=
10,this.intervalType="minute"):c/(15*U.minuteDuration)<=a?(this.interval=15,this.intervalType="minute"):c/(20*U.minuteDuration)<=a?(this.interval=20,this.intervalType="minute"):c/(30*U.minuteDuration)<=a?(this.interval=30,this.intervalType="minute"):c/(1*U.hourDuration)<=a?(this.interval=1,this.intervalType="hour"):c/(2*U.hourDuration)<=a?(this.interval=2,this.intervalType="hour"):c/(3*U.hourDuration)<=a?(this.interval=3,this.intervalType="hour"):c/(6*U.hourDuration)<=a?(this.interval=6,this.intervalType=
"hour"):c/(1*U.dayDuration)<=a?(this.interval=1,this.intervalType="day"):c/(2*U.dayDuration)<=a?(this.interval=2,this.intervalType="day"):c/(4*U.dayDuration)<=a?(this.interval=4,this.intervalType="day"):c/(1*U.weekDuration)<=a?(this.interval=1,this.intervalType="week"):c/(2*U.weekDuration)<=a?(this.interval=2,this.intervalType="week"):c/(3*U.weekDuration)<=a?(this.interval=3,this.intervalType="week"):c/(1*U.monthDuration)<=a?(this.interval=1,this.intervalType="month"):c/(2*U.monthDuration)<=a?(this.interval=
2,this.intervalType="month"):c/(3*U.monthDuration)<=a?(this.interval=3,this.intervalType="month"):c/(6*U.monthDuration)<=a?(this.interval=6,this.intervalType="month"):(this.interval=c/(1*U.yearDuration)<=a?1:c/(2*U.yearDuration)<=a?2:c/(4*U.yearDuration)<=a?4:Math.floor(C.getNiceNumber(c/(a-1),!0)/U.yearDuration),this.intervalType="year"));if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum=e-h/2;if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum=
g+h/2;f?this.autoValueFormatString="MMM DD YYYY HH:mm":"year"===this.intervalType?this.autoValueFormatString="YYYY":"month"===this.intervalType?this.autoValueFormatString="MMM YYYY":"week"===this.intervalType?this.autoValueFormatString="MMM DD YYYY":"day"===this.intervalType?this.autoValueFormatString="MMM DD YYYY":"hour"===this.intervalType?this.autoValueFormatString="hh:mm TT":"minute"===this.intervalType?this.autoValueFormatString="hh:mm TT":"second"===this.intervalType?this.autoValueFormatString=
"hh:mm:ss TT":"millisecond"===this.intervalType&&(this.autoValueFormatString="fff'ms'");this.valueFormatString||(this.valueFormatString=this.autoValueFormatString)}else{this.intervalType="number";c=C.getNiceNumber(c,!1);this.interval=this.options&&0<this.options.interval?this.options.interval:C.getNiceNumber(c/(a-1),!0);if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum="axisX"===this.type?e-h/2:Math.floor(e/this.interval)*this.interval;if(null===this.viewportMaximum||
isNaN(this.viewportMaximum))this.viewportMaximum="axisX"===this.type?g+h/2:Math.ceil(g/this.interval)*this.interval;0===this.viewportMaximum&&0===this.viewportMinimum&&(0===this.options.viewportMinimum?this.viewportMaximum+=10:0===this.options.viewportMaximum&&(this.viewportMinimum-=10),this.options&&"undefined"===typeof this.options.interval&&(this.interval=C.getNiceNumber((this.viewportMaximum-this.viewportMinimum)/(a-1),!0)))}if(null===this.minimum||null===this.maximum)if("axisX"===this.type?(e=
null!==this.minimum?this.minimum:this.dataInfo.min,g=null!==this.maximum?this.maximum:this.dataInfo.max,0===g-e&&(c="undefined"===typeof this.options.interval?0.4:this.options.interval,g+=c,e-=c),h=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:1<g-e?0.5*Math.abs(g-e):1):"axisY"===this.type&&(e=null!==this.minimum?this.minimum:this.dataInfo.min,g=null!==this.maximum?this.maximum:this.dataInfo.max,isFinite(e)||isFinite(g)?0===e&&0===g?(g+=9,e=0):0===g-e?(c=Math.min(Math.abs(0.01*Math.abs(g)),
5),g+=c,e-=c):e>g?(c=Math.min(0.01*Math.abs(this.getApparentDifference(g,e,null,!0)),5),0<=g?e=g-c:g=isFinite(e)?e+c:0):(c=Math.min(0.01*Math.abs(this.getApparentDifference(e,g,null,!0)),0.05),0!==g&&(g+=c),0!==e&&(e-=c)):(g="undefined"===typeof this.options.interval?-Infinity:this.options.interval,e="undefined"!==typeof this.options.interval||isFinite(this.dataInfo.minDiff)?0:Infinity),h=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:1<g-e?0.5*Math.abs(g-e):1,this.includeZero&&(null===this.minimum||
isNaN(this.minimum))&&0<e&&(e=0),this.includeZero&&(null===this.maximum||isNaN(this.maximum))&&0>g&&(g=0)),Math.abs(this.getApparentDifference(e,g,null,!0)),"axisX"===this.type&&b){this.valueType="dateTime";if(null===this.minimum||isNaN(this.minimum))this.minimum=e-h/2;if(null===this.maximum||isNaN(this.maximum))this.maximum=g+h/2}else this.intervalType=this.valueType="number",null===this.minimum&&(this.minimum="axisX"===this.type?e-h/2:Math.floor(e/this.interval)*this.interval,this.minimum=Math.min(this.minimum,
null===this.sessionVariables.viewportMinimum||isNaN(this.sessionVariables.viewportMinimum)?Infinity:this.sessionVariables.viewportMinimum)),null===this.maximum&&(this.maximum="axisX"===this.type?g+h/2:Math.ceil(g/this.interval)*this.interval,this.maximum=Math.max(this.maximum,null===this.sessionVariables.viewportMaximum||isNaN(this.sessionVariables.viewportMaximum)?-Infinity:this.sessionVariables.viewportMaximum)),0===this.maximum&&0===this.minimum&&(0===this.options.minimum?this.maximum+=10:0===
this.options.maximum&&(this.minimum-=10));y(this.sessionVariables.newViewportMinimum)&&(this.viewportMinimum=Math.max(this.viewportMinimum,this.minimum));y(this.sessionVariables.newViewportMaximum)&&(this.viewportMaximum=Math.min(this.viewportMaximum,this.maximum));this.range=this.viewportMaximum-this.viewportMinimum;this.intervalStartPosition="axisX"===this.type&&b?this.getLabelStartPoint(new Date(this.viewportMinimum),this.intervalType,this.interval):Math.floor((this.viewportMinimum+0.2*this.interval)/
this.interval)*this.interval;this.valueFormatString||(this.valueFormatString=C.generateValueFormatString(this.range,2))}};C.prototype.calculateLogarithmicAxisParameters=function(){var a=this.chart.layoutManager.getFreeSpace(),f=Math.log(this.logarithmBase),b;"bottom"===this._position||"top"===this._position?(this.maxWidth=a.width,this.maxHeight=a.height):(this.maxWidth=a.height,this.maxHeight=a.width);var a="axisX"===this.type?500>this.maxWidth?7:Math.max(7,Math.floor(this.maxWidth/100)):Math.max(Math.floor(this.maxWidth/
50),3),c,e,g,h;h=1;if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum=this.minimum;if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum=this.maximum;if(this.scaleBreaks)for(h=0;h<this.scaleBreaks._appliedBreaks.length;h++)if((!y(this.sessionVariables.newViewportMinimum)&&this.sessionVariables.newViewportMinimum>=this.scaleBreaks._appliedBreaks[h].startValue||!y(this.options.minimum)&&this.options.minimum>=this.scaleBreaks._appliedBreaks[h].startValue||
!y(this.options.viewportMinimum)&&this.viewportMinimum>=this.scaleBreaks._appliedBreaks[h].startValue)&&(!y(this.sessionVariables.newViewportMaximum)&&this.sessionVariables.newViewportMaximum<=this.scaleBreaks._appliedBreaks[h].endValue||!y(this.options.maximum)&&this.options.maximum<=this.scaleBreaks._appliedBreaks[h].endValue||!y(this.options.viewportMaximum)&&this.viewportMaximum<=this.scaleBreaks._appliedBreaks[h].endValue)){this.scaleBreaks._appliedBreaks.splice(h,1);break}"axisX"===this.type?
(c=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin,e=null!==this.viewportMaximum?this.viewportMaximum:this.dataInfo.viewPortMax,1===e/c&&(h=Math.pow(this.logarithmBase,"undefined"===typeof this.options.interval?0.4:this.options.interval),e*=h,c/=h),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase):"axisY"===this.type&&(c=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin,
e=null!==this.viewportMaximum?this.viewportMaximum:this.dataInfo.viewPortMax,0>=c&&!isFinite(e)?(e="undefined"===typeof this.options.interval?0:this.options.interval,c=1):0>=c?c=e:isFinite(e)||(e=c),1===c&&1===e?(e*=this.logarithmBase-1/this.logarithmBase,c=1):1===e/c?(h=Math.min(e*Math.pow(this.logarithmBase,0.01),Math.pow(this.logarithmBase,5)),e*=h,c/=h):c>e?(h=Math.min(c/e*Math.pow(this.logarithmBase,0.01),Math.pow(this.logarithmBase,5)),1<=e?c=e/h:e=c*h):(h=Math.min(e/c*Math.pow(this.logarithmBase,
0.01),Math.pow(this.logarithmBase,0.04)),1!==e&&(e*=h),1!==c&&(c/=h)),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase,this.includeZero&&(null===this.viewportMinimum||isNaN(this.viewportMinimum))&&1<c&&(c=1),this.includeZero&&(null===this.viewportMaximum||isNaN(this.viewportMaximum))&&1>e&&(e=1));h=(isNaN(this.viewportMaximum)||null===this.viewportMaximum?e:this.viewportMaximum)/(isNaN(this.viewportMinimum)||null===
this.viewportMinimum?c:this.viewportMinimum);linearRange=(isNaN(this.viewportMaximum)||null===this.viewportMaximum?e:this.viewportMaximum)-(isNaN(this.viewportMinimum)||null===this.viewportMinimum?c:this.viewportMinimum);this.intervalType="number";h=Math.pow(this.logarithmBase,C.getNiceNumber(Math.abs(Math.log(h)/f),!1));this.options&&0<this.options.interval?this.interval=this.options.interval:(this.interval=C.getNiceExponent(Math.log(h)/f/(a-1),!0),b=C.getNiceNumber(linearRange/(a-1),!0));if(null===
this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum="axisX"===this.type?c/Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.floor(Math.log(c)/f/this.interval));if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum="axisX"===this.type?e*Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.ceil(Math.log(e)/f/this.interval));1===this.viewportMaximum&&1===this.viewportMinimum&&(1===this.options.viewportMinimum?this.viewportMaximum*=this.logarithmBase-
1/this.logarithmBase:1===this.options.viewportMaximum&&(this.viewportMinimum/=this.logarithmBase-1/this.logarithmBase),this.options&&"undefined"===typeof this.options.interval&&(this.interval=C.getNiceExponent(Math.ceil(Math.log(h)/f)/(a-1)),b=C.getNiceNumber((this.viewportMaximum-this.viewportMinimum)/(a-1),!0)));if(null===this.minimum||null===this.maximum)"axisX"===this.type?(c=null!==this.minimum?this.minimum:this.dataInfo.min,e=null!==this.maximum?this.maximum:this.dataInfo.max,1===e/c&&(h=Math.pow(this.logarithmBase,
"undefined"===typeof this.options.interval?0.4:this.options.interval),e*=h,c/=h),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase):"axisY"===this.type&&(c=null!==this.minimum?this.minimum:this.dataInfo.min,e=null!==this.maximum?this.maximum:this.dataInfo.max,isFinite(c)||isFinite(e)?1===c&&1===e?(e*=this.logarithmBase,c/=this.logarithmBase):1===e/c?(h=Math.pow(this.logarithmBase,this.interval),e*=h,c/=h):c>e?(h=
Math.min(0.01*(c/e),5),1<=e?c=e/h:e=c*h):(h=Math.min(e/c*Math.pow(this.logarithmBase,0.01),Math.pow(this.logarithmBase,0.04)),1!==e&&(e*=h),1!==c&&(c/=h)):(e="undefined"===typeof this.options.interval?0:this.options.interval,c=1),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase,this.includeZero&&(null===this.minimum||isNaN(this.minimum))&&1<c&&(c=1),this.includeZero&&(null===this.maximum||isNaN(this.maximum))&&
1>e&&(e=1)),this.intervalType="number",null===this.minimum&&(this.minimum="axisX"===this.type?c/Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.floor(Math.log(c)/f/this.interval)),this.minimum=Math.min(this.minimum,null===this.sessionVariables.viewportMinimum||isNaN(this.sessionVariables.viewportMinimum)?"undefined"===typeof this.sessionVariables.newViewportMinimum?Infinity:this.sessionVariables.newViewportMinimum:this.sessionVariables.viewportMinimum)),null===this.maximum&&(this.maximum=
"axisX"===this.type?e*Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.ceil(Math.log(e)/f/this.interval)),this.maximum=Math.max(this.maximum,null===this.sessionVariables.viewportMaximum||isNaN(this.sessionVariables.viewportMaximum)?"undefined"===typeof this.sessionVariables.newViewportMaximum?0:this.sessionVariables.newViewportMaximum:this.sessionVariables.viewportMaximum)),1===this.maximum&&1===this.minimum&&(1===this.options.minimum?this.maximum*=this.logarithmBase-1/this.logarithmBase:
1===this.options.maximum&&(this.minimum/=this.logarithmBase-1/this.logarithmBase));this.viewportMinimum=Math.max(this.viewportMinimum,this.minimum);this.viewportMaximum=Math.min(this.viewportMaximum,this.maximum);this.viewportMinimum>this.viewportMaximum&&(!this.options.viewportMinimum&&!this.options.minimum||this.options.viewportMaximum||this.options.maximum?this.options.viewportMinimum||this.options.minimum||!this.options.viewportMaximum&&!this.options.maximum||(this.viewportMinimum=this.minimum=
(this.options.viewportMaximum||this.options.maximum)/Math.pow(this.logarithmBase,2*Math.ceil(this.interval))):this.viewportMaximum=this.maximum=this.options.viewportMinimum||this.options.minimum);c=Math.pow(this.logarithmBase,Math.floor(Math.log(this.viewportMinimum)/(f*this.interval)+0.2)*this.interval);this.range=this.viewportMaximum/this.viewportMinimum;this.noTicks=a;if(!this.options.interval&&this.range<Math.pow(this.logarithmBase,8>this.viewportMaximum||3>a?2:3)){for(f=Math.floor(this.viewportMinimum/
b+0.5)*b;f<this.viewportMinimum;)f+=b;this.equidistantInterval=!1;this.intervalStartPosition=f;this.interval=b}else this.options.interval||(b=Math.ceil(this.interval),this.range>this.interval&&(this.interval=b,c=Math.pow(this.logarithmBase,Math.floor(Math.log(this.viewportMinimum)/(f*this.interval)+0.2)*this.interval))),this.equidistantInterval=!0,this.intervalStartPosition=c;if(!this.valueFormatString&&(this.valueFormatString="#,##0.##",1>this.viewportMinimum)){f=Math.floor(Math.abs(Math.log(this.viewportMinimum)/
Math.LN10))+2;if(isNaN(f)||!isFinite(f))f=2;if(2<f)for(h=0;h<f-2;h++)this.valueFormatString+="#"}};C.generateValueFormatString=function(a,f){var b="#,##0.",c=f;1>a&&(c+=Math.floor(Math.abs(Math.log(a)/Math.LN10)),isNaN(c)||!isFinite(c))&&(c=f);for(var e=0;e<c;e++)b+="#";return b};C.getNiceExponent=function(a,f){var b=Math.floor(Math.log(a)/Math.LN10),c=a/Math.pow(10,b),c=0>b?1>=c?1:5>=c?5:10:Math.max(Math.floor(c),1);return-20>b?Number(c*Math.pow(10,b)):Number((c*Math.pow(10,b)).toFixed(20))};C.getNiceNumber=
function(a,f){var b=Math.floor(Math.log(a)/Math.LN10),c=a/Math.pow(10,b),c=f?1.5>c?1:3>c?2:7>c?5:10:1>=c?1:2>=c?2:5>=c?5:10;return-20>b?Number(c*Math.pow(10,b)):Number((c*Math.pow(10,b)).toFixed(20))};C.prototype.getLabelStartPoint=function(){var a=U[this.intervalType+"Duration"]*this.interval,a=new Date(Math.floor(this.viewportMinimum/a)*a);if("millisecond"!==this.intervalType)if("second"===this.intervalType)0<a.getMilliseconds()&&(a.setSeconds(a.getSeconds()+1),a.setMilliseconds(0));else if("minute"===
this.intervalType){if(0<a.getSeconds()||0<a.getMilliseconds())a.setMinutes(a.getMinutes()+1),a.setSeconds(0),a.setMilliseconds(0)}else if("hour"===this.intervalType){if(0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setHours(a.getHours()+1),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else if("day"===this.intervalType){if(0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setDate(a.getDate()+1),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else if("week"===
this.intervalType){if(0<a.getDay()||0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setDate(a.getDate()+(7-a.getDay())),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else if("month"===this.intervalType){if(1<a.getDate()||0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setMonth(a.getMonth()+1),a.setDate(1),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else"year"===this.intervalType&&(0<a.getMonth()||1<
a.getDate()||0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())&&(a.setFullYear(a.getFullYear()+1),a.setMonth(0),a.setDate(1),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0));return a};na(I,Y);na(ba,Y);ba.prototype.createUserOptions=function(a){if("undefined"!==typeof a||this.options._isPlaceholder){var f=0;this.parent.options._isPlaceholder&&this.parent.createUserOptions();this.options._isPlaceholder||(Ca(this.parent[this.optionsName]),f=this.parent.options[this.optionsName].indexOf(this.options));
this.options="undefined"===typeof a?{}:a;this.parent.options[this.optionsName][f]=this.options}};ba.prototype.render=function(a){if(0!==this.spacing||0!==this.options.lineThickness&&("undefined"!==typeof this.options.lineThickness||0!==this.parent.lineThickness)){var f=this.ctx,b=this.ctx.globalAlpha;this.ctx=a||this.ctx;this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.ctx.clip();var c=this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.startValue),
e=this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.endValue);this.ctx.strokeStyle=this.lineColor;this.ctx.fillStyle=this.color;this.ctx.beginPath();this.ctx.globalAlpha=1;R(this.id);var g,h,l,m,k,r;a=Math.max(this.spacing,3);var p=Math.max(0,this.lineThickness);this.ctx.lineWidth=p;this.ctx.setLineDash&&this.ctx.setLineDash(F(this.lineDashType,p));if("bottom"===this.scaleBreaks.parent._position||"top"===this.scaleBreaks.parent._position)if(c=1===p%2?(c.x<<0)+0.5:c.x<<0,h=1===p%2?(e.x<<0)+0.5:
e.x<<0,"top"===this.scaleBreaks.parent._position?(e=this.chart.plotArea.y1,l=this.chart.plotArea.y2+p/2+0.5<<0):(e=this.chart.plotArea.y2,l=this.chart.plotArea.y1-p/2+0.5<<0,a*=-1),this.bounds={x1:c-p/2,y1:e,x2:h+p/2,y2:l},this.ctx.moveTo(c,e),"straight"===this.type||"top"===this.scaleBreaks.parent._position&&0>=a||"bottom"===this.scaleBreaks.parent._position&&0<=a)this.ctx.lineTo(c,l),this.ctx.lineTo(h,l),this.ctx.lineTo(h,e);else if("wavy"===this.type){m=c;k=e;g=0.5;r=(l-k)/a/3;for(var n=0;n<r;n++)this.ctx.bezierCurveTo(m+
g*a,k+a,m+g*a,k+2*a,m,k+3*a),k+=3*a,g*=-1;this.ctx.bezierCurveTo(m+g*a,k+a,m+g*a,k+2*a,m,k+3*a);m=h;g*=-1;this.ctx.lineTo(m,k);for(n=0;n<r;n++)this.ctx.bezierCurveTo(m+g*a,k-a,m+g*a,k-2*a,m,k-3*a),k-=3*a,g*=-1}else{if("zigzag"===this.type){g=-1;k=e+a;m=c+a;r=(l-k)/a/2;for(n=0;n<r;n++)this.ctx.lineTo(m,k),m+=2*g*a,k+=2*a,g*=-1;this.ctx.lineTo(m,k);m+=h-c;for(n=0;n<r+1;n++)this.ctx.lineTo(m,k),m+=2*g*a,k-=2*a,g*=-1;this.ctx.lineTo(m+g*a,k+a)}}else if("left"===this.scaleBreaks.parent._position||"right"===
this.scaleBreaks.parent._position)if(e=1===p%2?(e.y<<0)+0.5:e.y<<0,l=1===p%2?(c.y<<0)+0.5:c.y<<0,"left"===this.scaleBreaks.parent._position?(c=this.chart.plotArea.x1,h=this.chart.plotArea.x2+p/2+0.5<<0):(c=this.chart.plotArea.x2,h=this.chart.plotArea.x1-p/2+0.5<<0,a*=-1),this.bounds={x1:c,y1:e-p/2,x2:h,y2:l+p/2},this.ctx.moveTo(c,e),"straight"===this.type||"left"===this.scaleBreaks.parent._position&&0>=a||"right"===this.scaleBreaks.parent._position&&0<=a)this.ctx.lineTo(h,e),this.ctx.lineTo(h,l),
this.ctx.lineTo(c,l);else if("wavy"===this.type){m=c;k=e;g=0.5;r=(h-m)/a/3;for(n=0;n<r;n++)this.ctx.bezierCurveTo(m+a,k+g*a,m+2*a,k+g*a,m+3*a,k),m+=3*a,g*=-1;this.ctx.bezierCurveTo(m+a,k+g*a,m+2*a,k+g*a,m+3*a,k);k=l;g*=-1;this.ctx.lineTo(m,k);for(n=0;n<r;n++)this.ctx.bezierCurveTo(m-a,k+g*a,m-2*a,k+g*a,m-3*a,k),m-=3*a,g*=-1}else if("zigzag"===this.type){g=1;k=e-a;m=c+a;r=(h-m)/a/2;for(n=0;n<r;n++)this.ctx.lineTo(m,k),k+=2*g*a,m+=2*a,g*=-1;this.ctx.lineTo(m,k);k+=l-e;for(n=0;n<r+1;n++)this.ctx.lineTo(m,
k),k+=2*g*a,m-=2*a,g*=-1;this.ctx.lineTo(m+a,k+g*a)}0<p&&this.ctx.stroke();this.ctx.closePath();this.ctx.globalAlpha=this.fillOpacity;this.ctx.globalCompositeOperation="destination-over";this.ctx.fill();this.ctx.restore();this.ctx.globalAlpha=b;this.ctx=f}};na(fa,Y);fa.prototype.createUserOptions=function(a){if("undefined"!==typeof a||this.options._isPlaceholder){var f=0;this.parent.options._isPlaceholder&&this.parent.createUserOptions();this.options._isPlaceholder||(Ca(this.parent.stripLines),f=
this.parent.options.stripLines.indexOf(this.options));this.options="undefined"===typeof a?{}:a;this.parent.options.stripLines[f]=this.options}};fa.prototype.render=function(){this.ctx.save();var a=this.parent.getPixelCoordinatesOnAxis(this.value),f=Math.abs("pixel"===this._thicknessType?this.thickness:this.parent.conversionParameters.pixelPerUnit*this.thickness);if(0<f){var b=null===this.opacity?1:this.opacity;this.ctx.strokeStyle=this.color;this.ctx.beginPath();var c=this.ctx.globalAlpha;this.ctx.globalAlpha=
b;R(this.id);var e,g,h,l;this.ctx.lineWidth=f;this.ctx.setLineDash&&this.ctx.setLineDash(F(this.lineDashType,f));if("bottom"===this.parent._position||"top"===this.parent._position)e=g=1===this.ctx.lineWidth%2?(a.x<<0)+0.5:a.x<<0,h=this.chart.plotArea.y1,l=this.chart.plotArea.y2,this.bounds={x1:e-f/2,y1:h,x2:g+f/2,y2:l};else if("left"===this.parent._position||"right"===this.parent._position)h=l=1===this.ctx.lineWidth%2?(a.y<<0)+0.5:a.y<<0,e=this.chart.plotArea.x1,g=this.chart.plotArea.x2,this.bounds=
{x1:e,y1:h-f/2,x2:g,y2:l+f/2};this.ctx.moveTo(e,h);this.ctx.lineTo(g,l);this.ctx.stroke();this.ctx.globalAlpha=c}this.ctx.restore()};na(ha,Y);ha.prototype.render=function(a,f){var b,c,e,g,h=null,l=h=null,m="";if(!this.valueFormatString)if("dateTime"===this.parent.valueType)this.valueFormatString=this.parent.valueFormatString;else{var k=0,k="xySwapped"===this.chart.plotInfo.axisPlacement?50<this.parent.range?0:500<this.chart.width&&25>this.parent.range?2:Math.floor(Math.abs(Math.log(this.parent.range)/
Math.LN10))+(5>this.parent.range?2:10>this.parent.range?1:0):50<this.parent.range?0:Math.floor(Math.abs(Math.log(this.parent.range)/Math.LN10))+(5>this.parent.range?2:10>this.parent.range?1:0);this.valueFormatString=C.generateValueFormatString(this.parent.range,k)}var l=null===this.opacity?1:this.opacity,k=Math.abs("pixel"===this._thicknessType?this.thickness:this.parent.conversionParameters.pixelPerUnit*this.thickness),r=this.chart.overlaidCanvasCtx,p=r.globalAlpha;r.globalAlpha=l;r.beginPath();
r.strokeStyle=this.color;r.lineWidth=k;r.save();this.labelFontSize=y(this.options.labelFontSize)?this.parent.labelFontSize:this.labelFontSize;if("left"===this.parent._position||"right"===this.parent._position)this.labelMaxWidth=y(this.options.labelMaxWidth)?this.parent.bounds.x2-this.parent.bounds.x1:this.labelMaxWidth,this.labelMaxHeight=y(this.options.labelWrap)||this.labelWrap?3*this.chart.height:2*this.labelFontSize;else if("top"===this.parent._position||"bottom"===this.parent._position)this.labelMaxWidth=
y(this.options.labelMaxWidth)?3*this.chart.width:this.labelMaxWidth,this.labelMaxHeight=y(this.options.labelWrap)||this.labelWrap?this.parent.bounds.height:2*this.labelFontSize;0<k&&r.setLineDash&&r.setLineDash(F(this.lineDashType,k));l=new ka(r,{x:0,y:0,padding:{top:2,right:3,bottom:2,left:4},backgroundColor:this.labelBackgroundColor,borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,maxWidth:this.labelMaxWidth,maxHeight:this.labelMaxHeight,
angle:this.labelAngle,text:m,horizontalAlign:"left",fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle"});if(this.snapToDataPoint){var n=0,h=[];if("xySwapped"===this.chart.plotInfo.axisPlacement){var d=null;if("bottom"===this.parent._position||"top"===this.parent._position)n=this.parent.dataSeries[0].axisX.convertPixelToValue({y:f});else if("left"===this.parent._position||"right"===
this.parent._position)n=this.parent.convertPixelToValue({y:f});for(var q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(d.dataSeries=this.parent.dataSeries[q],null!==d.dataPoint.y&&h.push(d));d=null;if(0===h.length)return;h.sort(function(a,b){return a.distance-b.distance});d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y));q=0;if("rangeBar"===h[0].dataSeries.type||"error"===h[0].dataSeries.type)for(var d=Math.abs(a-this.parent.convertValueToPixel(h[q].dataPoint.y[0])),
s=0,n=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,q=n);else if("stackedBar"===h[0].dataSeries.type)for(var d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y)),v=s=0,n=q=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-
this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,s=Math.abs(a-this.parent.convertValueToPixel(v)),s<d&&(d=s,q=n);else if("stackedBar100"===h[0].dataSeries.type)for(var d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y)),u=v=s=0,n=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?
h[n].dataPoint.x.getTime():h[n].dataPoint.x,u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(a-this.parent.convertValueToPixel(u)),s<d&&(d=s,q=n);else for(d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=q=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,
q=n);m=h[q];if("bottom"===this.parent._position||"top"===this.parent._position){b=0;if("rangeBar"===this.parent.dataSeries[q].type||"error"===this.parent.dataSeries[q].type){d=Math.abs(a-this.parent.convertValueToPixel(m.dataPoint.y[0]));for(n=s=0;n<m.dataPoint.y.length;n++)s=Math.abs(a-this.parent.convertValueToPixel(m.dataPoint.y[n])),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y[b])<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y[b])<<0;l.text=this.labelFormatter?
this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y[b]}):y(this.options.label)?V(m.dataPoint.y[b],this.valueFormatString,this.chart._cultureInfo):this.label}else if("stackedBar"===this.parent.dataSeries[q].type){d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y));v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,s=Math.abs(a-this.parent.convertValueToPixel(v)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(v)<<0)+0.5:
this.parent.convertValueToPixel(v)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,this.chart._cultureInfo):this.label}else if("stackedBar100"===this.parent.dataSeries[q].type){d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y));u=v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?h[n].dataPoint.x.getTime():h[n].dataPoint.x,
u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(a-this.parent.convertValueToPixel(u)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(u)<<0)+0.5:this.parent.convertValueToPixel(u)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:u}):y(this.options.label)?V(u,this.valueFormatString,this.chart._cultureInfo):this.label}else h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y)<<
0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y)<<0,l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,this.chart._cultureInfo):this.label;b=c=h;e=this.chart.plotArea.y1;g=this.chart.plotArea.y2;this.bounds={x1:b-k/2,y1:e,x2:c+k/2,y2:g};l.x=b-l.measureText().width/2;l.x+l.width>this.chart.bounds.x2?l.x=this.chart.bounds.x2-l.width:l.x<this.chart.bounds.x1&&
(l.x=this.chart.bounds.x1);l.y=this.parent.lineCoordinates.y2+l.fontSize/2+2}else if("left"===this.parent._position||"right"===this.parent._position){e=g=h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.x)<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.x)<<0;b=this.chart.plotArea.x1;c=this.chart.plotArea.x2;this.bounds={x1:b,y1:e-k/2,x2:c,y2:g+k/2};u=!1;if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=
!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=this.parent.convertPixelToValue({y:f}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?Aa(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?V(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label);l.y=g+l.fontSize/2-l.measureText().height/2+2;l.y-l.fontSize/2<this.chart.bounds.y1?
l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2);"left"===this.parent._position?l.x=this.parent.lineCoordinates.x2-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2)}}else if("bottom"===this.parent._position||"top"===this.parent._position){n=this.parent.convertPixelToValue({x:a});for(q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,
!0))&&0<=d.index&&(d.dataSeries=this.parent.dataSeries[q],null!==d.dataPoint.y&&h.push(d));if(0===h.length)return;h.sort(function(a,b){return a.distance-b.distance});m=h[0];b=c=h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.x)<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.x)<<0;e=this.chart.plotArea.y1;g=this.chart.plotArea.y2;this.bounds={x1:b-k/2,y1:e,x2:c+k/2,y2:g};u=!1;if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=
!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=this.parent.convertPixelToValue({x:a}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?Aa(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?V(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label);l.x=b-l.measureText().width/2;l.x+l.width>this.chart.bounds.x2&&(l.x=
this.chart.bounds.x2-l.width);l.x<this.chart.bounds.x1&&(l.x=this.chart.bounds.x1);"bottom"===this.parent._position?l.y=this.parent.lineCoordinates.y2+l.fontSize/2+2:"top"===this.parent._position&&(l.y=this.parent.lineCoordinates.y1-l.height+l.fontSize/2+2)}else if("left"===this.parent._position||"right"===this.parent._position){!y(this.parent.dataSeries)&&0<this.parent.dataSeries.length&&(n=this.parent.dataSeries[0].axisX.convertPixelToValue({x:a}));for(q=0;q<this.parent.dataSeries.length;q++)(d=
this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(d.dataSeries=this.parent.dataSeries[q],null!==d.dataPoint.y&&h.push(d));if(0===h.length)return;h.sort(function(a,b){return a.distance-b.distance});q=0;if("rangeColumn"===h[0].dataSeries.type||"rangeArea"===h[0].dataSeries.type||"error"===h[0].dataSeries.type||"rangeSplineArea"===h[0].dataSeries.type||"candlestick"===h[0].dataSeries.type||"ohlc"===h[0].dataSeries.type||"boxAndWhisker"===h[0].dataSeries.type)for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y[0])),
n=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,q=n);else if("stackedColumn"===h[0].dataSeries.type||"stackedArea"===h[0].dataSeries.type)for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=v=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<
h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,s=Math.abs(f-this.parent.convertValueToPixel(v)),s<d&&(d=s,q=n);else if("stackedColumn100"===h[0].dataSeries.type||"stackedArea100"===h[0].dataSeries.type)for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=u=v=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),
s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?h[n].dataPoint.x.getTime():h[n].dataPoint.x,u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(f-this.parent.convertValueToPixel(u)),s<d&&(d=s,q=n);else for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(f-
this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,q=n);m=h[q];b=0;if("rangeColumn"===this.parent.dataSeries[q].type||"rangeArea"===this.parent.dataSeries[q].type||"error"===this.parent.dataSeries[q].type||"rangeSplineArea"===this.parent.dataSeries[q].type||"candlestick"===this.parent.dataSeries[q].type||"ohlc"===this.parent.dataSeries[q].type||"boxAndWhisker"===this.parent.dataSeries[q].type){d=Math.abs(f-this.parent.convertValueToPixel(m.dataPoint.y[0]));for(n=s=0;n<m.dataPoint.y.length;n++)s=
Math.abs(f-this.parent.convertValueToPixel(m.dataPoint.y[n])),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y[b])<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y[b])<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y[b]}):y(this.options.label)?V(m.dataPoint.y[b],this.valueFormatString,this.chart._cultureInfo):this.label}else if("stackedColumn"===this.parent.dataSeries[q].type||
"stackedArea"===this.parent.dataSeries[q].type){d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y));v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,s=Math.abs(f-this.parent.convertValueToPixel(v)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(v)<<0)+0.5:this.parent.convertValueToPixel(v)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,
this.chart._cultureInfo):this.label}else if("stackedColumn100"===this.parent.dataSeries[q].type||"stackedArea100"===this.parent.dataSeries[q].type){d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y));v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?h[n].dataPoint.x.getTime():h[n].dataPoint.x,u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(f-this.parent.convertValueToPixel(u)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(u)<<0)+
0.5:this.parent.convertValueToPixel(u)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:u}):y(this.options.label)?V(u,this.valueFormatString,this.chart._cultureInfo):this.label}else"waterfall"===this.parent.dataSeries[q].type?(h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataSeries.dataPointEOs[m.index].cumulativeSum)<<0)+0.5:this.parent.convertValueToPixel(m.dataSeries.dataPointEOs[m.index].cumulativeSum)<<0,l.text=
this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataSeries.dataPointEOs[m.index].cumulativeSum}):y(this.options.label)?V(m.dataSeries.dataPointEOs[m.index].cumulativeSum,this.valueFormatString,this.chart._cultureInfo):this.label):(h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y)<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y)<<0,l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,
crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,this.chart._cultureInfo):this.label);e=g=h;b=this.chart.plotArea.x1;c=this.chart.plotArea.x2;this.bounds={x1:b,y1:e-k/2,x2:c,y2:g+k/2};l.y=g+l.fontSize/2-l.measureText().height/2+2;l.y-l.fontSize/2<this.chart.bounds.y1?l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2);"left"===this.parent._position?
l.x=this.parent.lineCoordinates.x2-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2)}h=null;("bottom"===this.parent._position||"top"===this.parent._position)&&(b>=this.parent.convertValueToPixel(this.parent.viewportMinimum)&&c<=this.parent.convertValueToPixel(this.parent.viewportMaximum))&&(0<k&&(r.moveTo(b,e),r.lineTo(c,g),r.stroke()),r.restore(),!y(l.text)&&("number"===typeof l.text.valueOf()||0<l.text.length)&&l.render(!0));("left"===this.parent._position||
"right"===this.parent._position)&&(g>=this.parent.convertValueToPixel(this.parent.viewportMaximum)&&e<=this.parent.convertValueToPixel(this.parent.viewportMinimum))&&(0<k&&(r.moveTo(b,e),r.lineTo(c,g),r.stroke()),r.restore(),!y(l.text)&&("number"===typeof l.text.valueOf()||0<l.text.length)&&l.render(!0))}else{if("bottom"===this.parent._position||"top"===this.parent._position)b=c=h=1===r.lineWidth%2?(a<<0)+0.5:a<<0,e=this.chart.plotArea.y1,g=this.chart.plotArea.y2,this.bounds={x1:b-k/2,y1:e,x2:c+k/
2,y2:g};else if("left"===this.parent._position||"right"===this.parent._position)e=g=h=1===r.lineWidth%2?(f<<0)+0.5:f<<0,b=this.chart.plotArea.x1,c=this.chart.plotArea.x2,this.bounds={x1:b,y1:e-k/2,x2:c,y2:g+k/2};if("xySwapped"===this.chart.plotInfo.axisPlacement)if("left"===this.parent._position||"right"===this.parent._position){u=!1;if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=
this.parent.convertPixelToValue({y:f}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,
value:this.parent.convertPixelToValue(f)}):y(this.options.label)?Aa(this.parent.convertPixelToValue(f),this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(f)}):y(this.options.label)?V(this.parent.convertPixelToValue(f),this.valueFormatString,this.chart._cultureInfo):this.label);l.y=f+l.fontSize/2-l.measureText().height/
2+2;l.y-l.fontSize/2<this.chart.bounds.y1?l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2);"left"===this.parent._position?l.x=this.parent.lineCoordinates.x1-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2)}else{if("bottom"===this.parent._position||"top"===this.parent._position)l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?V(this.parent.convertPixelToValue(a),this.valueFormatString,this.chart._cultureInfo):this.label,l.x=b-l.measureText().width/2,l.x+l.width>this.chart.bounds.x2&&(l.x=this.chart.bounds.x2-l.width),l.x<this.chart.bounds.x1&&(l.x=this.chart.bounds.x1),"bottom"===this.parent._position&&(l.y=this.parent.lineCoordinates.y2+l.fontSize/2+2),"top"===this.parent._position&&(l.y=this.parent.lineCoordinates.y1-
l.height+l.fontSize/2+2)}else if("bottom"===this.parent._position||"top"===this.parent._position){u=!1;m="";if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=this.parent.convertPixelToValue({x:a}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?Aa(this.parent.convertPixelToValue(a),this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?
this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:0<this.parent.dataSeries.length?this.parent.convertPixelToValue(a):""}):y(this.options.label)?V(this.parent.convertPixelToValue(a),this.valueFormatString,this.chart._cultureInfo):this.label);l.x=b-l.measureText().width/2;l.x+l.width>this.chart.bounds.x2&&(l.x=this.chart.bounds.x2-l.width);l.x<this.chart.bounds.x1&&(l.x=this.chart.bounds.x1);"bottom"===this.parent._position?l.y=this.parent.lineCoordinates.y2+
l.fontSize/2+2:"top"===this.parent._position&&(l.y=this.parent.lineCoordinates.y1-l.height+l.fontSize/2+2)}else if("left"===this.parent._position||"right"===this.parent._position)l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(f)}):y(this.options.label)?V(this.parent.convertPixelToValue(f),this.valueFormatString,this.chart._cultureInfo):this.label,l.y=f+l.fontSize/2-l.measureText().height/2+2,l.y-
l.fontSize/2<this.chart.bounds.y1?l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2),"left"===this.parent._position?l.x=this.parent.lineCoordinates.x2-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2);0<k&&(r.moveTo(b,e),r.lineTo(c,g),r.stroke());r.restore();!y(l.text)&&("number"===typeof l.text.valueOf()||0<l.text.length)&&l.render(!0)}r.globalAlpha=
p};na(Z,Y);Z.prototype._initialize=function(){if(this.enabled){this.container=document.createElement("div");this.container.setAttribute("class","canvasjs-chart-tooltip");this.container.style.position="absolute";this.container.style.height="auto";this.container.style.boxShadow="1px 1px 2px 2px rgba(0,0,0,0.1)";this.container.style.zIndex="1000";this.container.style.pointerEvents="none";this.container.style.display="none";var a;a='<div style=" width: auto;height: auto;min-width: 50px;';a+="line-height: auto;";
a+="margin: 0px 0px 0px 0px;";a+="padding: 5px;";a+="font-family: Calibri, Arial, Georgia, serif;";a+="font-weight: normal;";a+="font-style: "+(v?"italic;":"normal;");a+="font-size: 14px;";a+="color: #000000;";a+="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);";a+="text-align: left;";a+="border: 2px solid gray;";a+=v?"background: rgba(255,255,255,.9);":"background: rgb(255,255,255);";a+="text-indent: 0px;";a+="white-space: nowrap;";a+="border-radius: 5px;";a+="-moz-user-select:none;";a+="-khtml-user-select: none;";
a+="-webkit-user-select: none;";a+="-ms-user-select: none;";a+="user-select: none;";v||(a+="filter: alpha(opacity = 90);",a+="filter: progid:DXImageTransform.Microsoft.Shadow(Strength=3, Direction=135, Color='#666666');");a+='} "> Sample Tooltip</div>';this.container.innerHTML=a;this.contentDiv=this.container.firstChild;this.container.style.borderRadius=this.contentDiv.style.borderRadius;this.chart._canvasJSContainer.appendChild(this.container)}};Z.prototype.mouseMoveHandler=function(a,f){this._lastUpdated&&
4>(new Date).getTime()-this._lastUpdated||(this._lastUpdated=(new Date).getTime(),this.chart.resetOverlayedCanvas(),this._updateToolTip(a,f))};Z.prototype._updateToolTip=function(a,f,b){b="undefined"===typeof b?!0:b;this.container||this._initialize();this.enabled||this.hide();if(!this.chart.disableToolTip){if("undefined"===typeof a||"undefined"===typeof f){if(isNaN(this._prevX)||isNaN(this._prevY))return;a=this._prevX;f=this._prevY}else this._prevX=a,this._prevY=f;var c=null,e=null,g=[],h=0;if(this.shared&&
this.enabled&&"none"!==this.chart.plotInfo.axisPlacement){if("xySwapped"===this.chart.plotInfo.axisPlacement){var l=[];if(this.chart.axisX)for(var m=0;m<this.chart.axisX.length;m++){for(var h=this.chart.axisX[m].convertPixelToValue({y:f}),k=null,c=0;c<this.chart.axisX[m].dataSeries.length;c++)(k=this.chart.axisX[m].dataSeries[c].getDataPointAtX(h,b))&&0<=k.index&&(k.dataSeries=this.chart.axisX[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k));k=null}if(this.chart.axisX2)for(m=0;m<this.chart.axisX2.length;m++){h=
this.chart.axisX2[m].convertPixelToValue({y:f});k=null;for(c=0;c<this.chart.axisX2[m].dataSeries.length;c++)(k=this.chart.axisX2[m].dataSeries[c].getDataPointAtX(h,b))&&0<=k.index&&(k.dataSeries=this.chart.axisX2[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k));k=null}}else{l=[];if(this.chart.axisX)for(m=0;m<this.chart.axisX.length;m++)for(h=this.chart.axisX[m].convertPixelToValue({x:a}),k=null,c=0;c<this.chart.axisX[m].dataSeries.length;c++)(k=this.chart.axisX[m].dataSeries[c].getDataPointAtX(h,
b))&&0<=k.index&&(k.dataSeries=this.chart.axisX[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k));if(this.chart.axisX2)for(m=0;m<this.chart.axisX2.length;m++)for(h=this.chart.axisX2[m].convertPixelToValue({x:a}),k=null,c=0;c<this.chart.axisX2[m].dataSeries.length;c++)(k=this.chart.axisX2[m].dataSeries[c].getDataPointAtX(h,b))&&0<=k.index&&(k.dataSeries=this.chart.axisX2[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k))}if(0===l.length)return;l.sort(function(a,b){return a.distance-b.distance});b=l[0];
for(c=0;c<l.length;c++)l[c].dataPoint.x.valueOf()===b.dataPoint.x.valueOf()&&g.push(l[c]);l=null}else{if(k=this.chart.getDataPointAtXY(a,f,b))this.currentDataPointIndex=k.dataPointIndex,this.currentSeriesIndex=k.dataSeries.index;else if(v)if(k=Wa(a,f,this.chart._eventManager.ghostCtx),0<k&&"undefined"!==typeof this.chart._eventManager.objectMap[k]){k=this.chart._eventManager.objectMap[k];if("legendItem"===k.objectType)return;this.currentSeriesIndex=k.dataSeriesIndex;this.currentDataPointIndex=0<=
k.dataPointIndex?k.dataPointIndex:-1}else this.currentDataPointIndex=-1;else this.currentDataPointIndex=-1;if(0<=this.currentSeriesIndex){e=this.chart.data[this.currentSeriesIndex];k={};if(0<=this.currentDataPointIndex)c=e.dataPoints[this.currentDataPointIndex],k.dataSeries=e,k.dataPoint=c,k.index=this.currentDataPointIndex,k.distance=Math.abs(c.x-h),"waterfall"===e.type&&(k.cumulativeSumYStartValue=e.dataPointEOs[this.currentDataPointIndex].cumulativeSumYStartValue,k.cumulativeSum=e.dataPointEOs[this.currentDataPointIndex].cumulativeSum);
else{if(!this.enabled||"line"!==e.type&&"stepLine"!==e.type&&"spline"!==e.type&&"area"!==e.type&&"stepArea"!==e.type&&"splineArea"!==e.type&&"stackedArea"!==e.type&&"stackedArea100"!==e.type&&"rangeArea"!==e.type&&"rangeSplineArea"!==e.type&&"candlestick"!==e.type&&"ohlc"!==e.type&&"boxAndWhisker"!==e.type)return;h=e.axisX.convertPixelToValue({x:a});k=e.getDataPointAtX(h,b);k.dataSeries=e;this.currentDataPointIndex=k.index;c=k.dataPoint}if(!y(k.dataPoint.y))if(k.dataSeries.axisY)if(0<k.dataPoint.y.length){for(c=
b=0;c<k.dataPoint.y.length;c++)k.dataPoint.y[c]<k.dataSeries.axisY.viewportMinimum?b--:k.dataPoint.y[c]>k.dataSeries.axisY.viewportMaximum&&b++;b<k.dataPoint.y.length&&b>-k.dataPoint.y.length&&g.push(k)}else"column"===e.type||"bar"===e.type?0>k.dataPoint.y?0>k.dataSeries.axisY.viewportMinimum&&k.dataSeries.axisY.viewportMaximum>=k.dataPoint.y&&g.push(k):k.dataSeries.axisY.viewportMinimum<=k.dataPoint.y&&0<=k.dataSeries.axisY.viewportMaximum&&g.push(k):"bubble"===e.type?(b=this.chart._eventManager.objectMap[e.dataPointIds[k.index]].size/
2,k.dataPoint.y>=k.dataSeries.axisY.viewportMinimum-b&&k.dataPoint.y<=k.dataSeries.axisY.viewportMaximum+b&&g.push(k)):"waterfall"===e.type?(b=0,k.cumulativeSumYStartValue<k.dataSeries.axisY.viewportMinimum?b--:k.cumulativeSumYStartValue>k.dataSeries.axisY.viewportMaximum&&b++,k.cumulativeSum<k.dataSeries.axisY.viewportMinimum?b--:k.cumulativeSum>k.dataSeries.axisY.viewportMaximum&&b++,2>b&&-2<b&&g.push(k)):(0<=k.dataSeries.type.indexOf("100")||"stackedColumn"===e.type||"stackedBar"===e.type||k.dataPoint.y>=
k.dataSeries.axisY.viewportMinimum&&k.dataPoint.y<=k.dataSeries.axisY.viewportMaximum)&&g.push(k);else g.push(k)}}if(0<g.length&&(this.highlightObjects(g),this.enabled))if(b="",b=this.getToolTipInnerHTML({entries:g}),null!==b){this.contentDiv.innerHTML=b;b=!1;"none"===this.container.style.display&&(b=!0,this.container.style.display="block");try{this.contentDiv.style.background=this.backgroundColor?this.backgroundColor:v?"rgba(255,255,255,.9)":"rgb(255,255,255)",this.borderColor="waterfall"===g[0].dataSeries.type?
this.contentDiv.style.borderRightColor=this.contentDiv.style.borderLeftColor=this.contentDiv.style.borderColor=this.options.borderColor?this.options.borderColor:g[0].dataPoint.color?g[0].dataPoint.color:0<g[0].dataPoint.y?g[0].dataSeries.risingColor:g[0].dataSeries.fallingColor:"error"===g[0].dataSeries.type?this.contentDiv.style.borderRightColor=this.contentDiv.style.borderLeftColor=this.contentDiv.style.borderColor=this.options.borderColor?this.options.borderColor:g[0].dataSeries.color?g[0].dataSeries.color:
g[0].dataSeries._colorSet[e.index%g[0].dataSeries._colorSet.length]:this.contentDiv.style.borderRightColor=this.contentDiv.style.borderLeftColor=this.contentDiv.style.borderColor=this.options.borderColor?this.options.borderColor:g[0].dataPoint.color?g[0].dataPoint.color:g[0].dataSeries.color?g[0].dataSeries.color:g[0].dataSeries._colorSet[g[0].index%g[0].dataSeries._colorSet.length],this.contentDiv.style.borderWidth=this.borderThickness||0===this.borderThickness?this.borderThickness+"px":"2px",this.contentDiv.style.borderRadius=
this.cornerRadius||0===this.cornerRadius?this.cornerRadius+"px":"5px",this.container.style.borderRadius=this.contentDiv.style.borderRadius,this.contentDiv.style.fontSize=this.fontSize||0===this.fontSize?this.fontSize+"px":"14px",this.contentDiv.style.color=this.fontColor?this.fontColor:"#000000",this.contentDiv.style.fontFamily=this.fontFamily?this.fontFamily:"Calibri, Arial, Georgia, serif;",this.contentDiv.style.fontWeight=this.fontWeight?this.fontWeight:"normal",this.contentDiv.style.fontStyle=
this.fontStyle?this.fontStyle:v?"italic":"normal"}catch(q){}"pie"===g[0].dataSeries.type||"doughnut"===g[0].dataSeries.type||"funnel"===g[0].dataSeries.type||"pyramid"===g[0].dataSeries.type||"bar"===g[0].dataSeries.type||"rangeBar"===g[0].dataSeries.type||"stackedBar"===g[0].dataSeries.type||"stackedBar100"===g[0].dataSeries.type?a=a-10-this.container.clientWidth:(a=g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x)-this.container.clientWidth<<0,a-=10);0>a&&(a+=this.container.clientWidth+
20);a+this.container.clientWidth>Math.max(this.chart.container.clientWidth,this.chart.width)&&(a=Math.max(0,Math.max(this.chart.container.clientWidth,this.chart.width)-this.container.clientWidth));f=1!==g.length||this.shared||"line"!==g[0].dataSeries.type&&"stepLine"!==g[0].dataSeries.type&&"spline"!==g[0].dataSeries.type&&"area"!==g[0].dataSeries.type&&"stepArea"!==g[0].dataSeries.type&&"splineArea"!==g[0].dataSeries.type?"bar"===g[0].dataSeries.type||"rangeBar"===g[0].dataSeries.type||"stackedBar"===
g[0].dataSeries.type||"stackedBar100"===g[0].dataSeries.type?g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x):f:g[0].dataSeries.axisY.convertValueToPixel(g[0].dataPoint.y);f=-f+10;0<f+this.container.clientHeight+5&&(f-=f+this.container.clientHeight+5-0);this.fixMozTransitionDelay(a,f);!this.animationEnabled||b?this.disableAnimation():(this.enableAnimation(),this.container.style.MozTransition=this.mozContainerTransition);this.container.style.left=a+"px";this.container.style.bottom=f+"px"}else this.hide(!1)}};
Z.prototype.highlightObjects=function(a){var f=this.chart.overlaidCanvasCtx;this.chart.resetOverlayedCanvas();f.clearRect(0,0,this.chart.width,this.chart.height);f.save();var b=this.chart.plotArea,c=0;f.beginPath();f.rect(b.x1,b.y1,b.x2-b.x1,b.y2-b.y1);f.clip();for(b=0;b<a.length;b++){var e=a[b];if((e=this.chart._eventManager.objectMap[e.dataSeries.dataPointIds[e.index]])&&e.objectType&&"dataPoint"===e.objectType){var c=this.chart.data[e.dataSeriesIndex],g=c.dataPoints[e.dataPointIndex],h=e.dataPointIndex;
!1===g.highlightEnabled||!0!==c.highlightEnabled&&!0!==g.highlightEnabled||("line"===c.type||"stepLine"===c.type||"spline"===c.type||"scatter"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"stackedArea"===c.type||"stackedArea100"===c.type||"rangeArea"===c.type||"rangeSplineArea"===c.type?(g=c.getMarkerProperties(h,e.x1,e.y1,this.chart.overlaidCanvasCtx),g.size=Math.max(1.5*g.size<<0,10),g.borderColor=g.borderColor||"#FFFFFF",g.borderThickness=g.borderThickness||Math.ceil(0.1*
g.size),$.drawMarkers([g]),"undefined"!==typeof e.y2&&(g=c.getMarkerProperties(h,e.x1,e.y2,this.chart.overlaidCanvasCtx),g.size=Math.max(1.5*g.size<<0,10),g.borderColor=g.borderColor||"#FFFFFF",g.borderThickness=g.borderThickness||Math.ceil(0.1*g.size),$.drawMarkers([g]))):"bubble"===c.type?(g=c.getMarkerProperties(h,e.x1,e.y1,this.chart.overlaidCanvasCtx),g.size=e.size,g.color="white",g.borderColor="white",f.globalAlpha=0.3,$.drawMarkers([g]),f.globalAlpha=1):"column"===c.type||"stackedColumn"===
c.type||"stackedColumn100"===c.type||"bar"===c.type||"rangeBar"===c.type||"stackedBar"===c.type||"stackedBar100"===c.type||"rangeColumn"===c.type||"waterfall"===c.type?X(f,e.x1,e.y1,e.x2,e.y2,"white",0,null,!1,!1,!1,!1,0.3):"pie"===c.type||"doughnut"===c.type?pa(f,e.center,e.radius,"white",c.type,e.startAngle,e.endAngle,0.3,e.percentInnerRadius):"funnel"===c.type||"pyramid"===c.type?qa(f,e.funnelSection,0.3,"white"):"candlestick"===c.type?(f.globalAlpha=1,f.strokeStyle=e.color,f.lineWidth=2*e.borderThickness,
c=0===f.lineWidth%2?0:0.5,f.beginPath(),f.moveTo(e.x3-c,Math.min(e.y2,e.y3)),f.lineTo(e.x3-c,Math.min(e.y1,e.y4)),f.stroke(),f.beginPath(),f.moveTo(e.x3-c,Math.max(e.y1,e.y4)),f.lineTo(e.x3-c,Math.max(e.y2,e.y3)),f.stroke(),X(f,e.x1,Math.min(e.y1,e.y4),e.x2,Math.max(e.y1,e.y4),"transparent",2*e.borderThickness,e.color,!1,!1,!1,!1),f.globalAlpha=1):"ohlc"===c.type?(f.globalAlpha=1,f.strokeStyle=e.color,f.lineWidth=2*e.borderThickness,c=0===f.lineWidth%2?0:0.5,f.beginPath(),f.moveTo(e.x3-c,e.y2),f.lineTo(e.x3-
c,e.y3),f.stroke(),f.beginPath(),f.moveTo(e.x3,e.y1),f.lineTo(e.x1,e.y1),f.stroke(),f.beginPath(),f.moveTo(e.x3,e.y4),f.lineTo(e.x2,e.y4),f.stroke(),f.globalAlpha=1):"boxAndWhisker"===c.type?(f.save(),f.globalAlpha=1,f.strokeStyle=e.stemColor,f.lineWidth=2*e.stemThickness,0<e.stemThickness&&(f.beginPath(),f.moveTo(e.x3,e.y2+e.borderThickness/2),f.lineTo(e.x3,e.y1+e.whiskerThickness/2),f.stroke(),f.beginPath(),f.moveTo(e.x3,e.y4-e.whiskerThickness/2),f.lineTo(e.x3,e.y3-e.borderThickness/2),f.stroke()),
f.beginPath(),X(f,e.x1-e.borderThickness/2,Math.max(e.y2+e.borderThickness/2,e.y3+e.borderThickness/2),e.x2+e.borderThickness/2,Math.min(e.y2-e.borderThickness/2,e.y3-e.borderThickness/2),"transparent",e.borderThickness,e.color,!1,!1,!1,!1),f.globalAlpha=1,f.strokeStyle=e.whiskerColor,f.lineWidth=2*e.whiskerThickness,0<e.whiskerThickness&&(f.beginPath(),f.moveTo(Math.floor(e.x3-e.whiskerLength/2),e.y4),f.lineTo(Math.ceil(e.x3+e.whiskerLength/2),e.y4),f.stroke(),f.beginPath(),f.moveTo(Math.floor(e.x3-
e.whiskerLength/2),e.y1),f.lineTo(Math.ceil(e.x3+e.whiskerLength/2),e.y1),f.stroke()),f.globalAlpha=1,f.strokeStyle=e.lineColor,f.lineWidth=2*e.lineThickness,0<e.lineThickness&&(f.beginPath(),f.moveTo(e.x1,e.y5),f.lineTo(e.x2,e.y5),f.stroke()),f.restore(),f.globalAlpha=1):"error"===c.type&&z(f,e.x1,e.y1,e.x2,e.y2,"white",e.whiskerProperties,e.stemProperties,e.isXYSwapped,0.3))}}f.restore();f.globalAlpha=1;f.beginPath()};Z.prototype.getToolTipInnerHTML=function(a){a=a.entries;for(var f=null,b=null,
c=null,e=0,g="",h=!0,l=0;l<a.length;l++)if(a[l].dataSeries.toolTipContent||a[l].dataPoint.toolTipContent){h=!1;break}if(h&&(this.content&&"function"===typeof this.content||this.contentFormatter))a={chart:this.chart,toolTip:this.options,entries:a},f=this.contentFormatter?this.contentFormatter(a):this.content(a);else if(this.shared&&"none"!==this.chart.plotInfo.axisPlacement){for(var m=null,k="",l=0;l<a.length;l++)b=a[l].dataSeries,c=a[l].dataPoint,e=a[l].index,g="",0===l&&(h&&!this.content)&&(this.chart.axisX&&
0<this.chart.axisX.length?k+="undefined"!==typeof this.chart.axisX[0].labels[c.x]?this.chart.axisX[0].labels[c.x]:"{x}":this.chart.axisX2&&0<this.chart.axisX2.length&&(k+="undefined"!==typeof this.chart.axisX2[0].labels[c.x]?this.chart.axisX2[0].labels[c.x]:"{x}"),k+="</br>",k=this.chart.replaceKeywordsWithValue(k,c,b,e)),null===c.toolTipContent||"undefined"===typeof c.toolTipContent&&null===b.options.toolTipContent||("line"===b.type||"stepLine"===b.type||"spline"===b.type||"area"===b.type||"stepArea"===
b.type||"splineArea"===b.type||"column"===b.type||"bar"===b.type||"scatter"===b.type||"stackedColumn"===b.type||"stackedColumn100"===b.type||"stackedBar"===b.type||"stackedBar100"===b.type||"stackedArea"===b.type||"stackedArea100"===b.type||"waterfall"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?
this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span>&nbsp;&nbsp;{y}",m=b.axisXIndex):"bubble"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}"):
"rangeColumn"===b.type||"rangeBar"===b.type||"rangeArea"===b.type||"rangeSplineArea"===b.type||"error"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span>&nbsp;&nbsp;{y[0]},&nbsp;{y[1]}"):"candlestick"===
b.type||"ohlc"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low:&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}"):"boxAndWhisker"===
b.type&&(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}"),
null===f&&(f=""),!0===this.reversed?(f=this.chart.replaceKeywordsWithValue(g,c,b,e)+f,l<a.length-1&&(f="</br>"+f)):(f+=this.chart.replaceKeywordsWithValue(g,c,b,e),l<a.length-1&&(f+="</br>")));null!==f&&(f=k+f)}else{b=a[0].dataSeries;c=a[0].dataPoint;e=a[0].index;if(null===c.toolTipContent||"undefined"===typeof c.toolTipContent&&null===b.options.toolTipContent)return null;"line"===b.type||"stepLine"===b.type||"spline"===b.type||"area"===b.type||"stepArea"===b.type||"splineArea"===b.type||"column"===
b.type||"bar"===b.type||"scatter"===b.type||"stackedColumn"===b.type||"stackedColumn100"===b.type||"stackedBar"===b.type||"stackedBar100"===b.type||"stackedArea"===b.type||"stackedArea100"===b.type||"waterfall"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+":</span>&nbsp;&nbsp;{y}":"bubble"===b.type?g=c.toolTipContent?
c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+":</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}":"pie"===b.type||"doughnut"===b.type||"funnel"===b.type||"pyramid"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":
"'color:{color};'")+"\"'>"+(c.name?"{name}:</span>&nbsp;&nbsp;":c.label?"{label}:</span>&nbsp;&nbsp;":"</span>")+"{y}":"rangeColumn"===b.type||"rangeBar"===b.type||"rangeArea"===b.type||"rangeSplineArea"===b.type||"error"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+" :</span>&nbsp;&nbsp;{y[0]}, &nbsp;{y[1]}":
"candlestick"===b.type||"ohlc"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+"</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low: &nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}":"boxAndWhisker"===b.type&&(g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:
this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+"</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}");
null===f&&(f="");f+=this.chart.replaceKeywordsWithValue(g,c,b,e)}return f};Z.prototype.enableAnimation=function(){if(!this.container.style.WebkitTransition){var a=this.getContainerTransition(this.containerTransitionDuration);this.container.style.WebkitTransition=a;this.container.style.MsTransition=a;this.container.style.transition=a;this.container.style.MozTransition=this.mozContainerTransition}};Z.prototype.disableAnimation=function(){this.container.style.WebkitTransition&&(this.container.style.WebkitTransition=
"",this.container.style.MozTransition="",this.container.style.MsTransition="",this.container.style.transition="")};Z.prototype.hide=function(a){this.container&&(this.container.style.display="none",this.currentSeriesIndex=-1,this._prevY=this._prevX=NaN,("undefined"===typeof a||a)&&this.chart.resetOverlayedCanvas())};Z.prototype.show=function(a,f,b){this._updateToolTip(a,f,"undefined"===typeof b?!1:b)};Z.prototype.fixMozTransitionDelay=function(a,f){if(20<this.chart._eventManager.lastObjectId)this.mozContainerTransition=
this.getContainerTransition(0);else{var b=parseFloat(this.container.style.left),b=isNaN(b)?0:b,c=parseFloat(this.container.style.bottom),c=isNaN(c)?0:c;10<Math.sqrt(Math.pow(b-a,2)+Math.pow(c-f,2))?this.mozContainerTransition=this.getContainerTransition(0.1):this.mozContainerTransition=this.getContainerTransition(0)}};Z.prototype.getContainerTransition=function(a){return"left "+a+"s ease-out 0s, bottom "+a+"s ease-out 0s"};ea.prototype.reset=function(){this.lastObjectId=0;this.objectMap=[];this.rectangularRegionEventSubscriptions=
[];this.previousDataPointEventObject=null;this.eventObjects=[];v&&(this.ghostCtx.clearRect(0,0,this.chart.width,this.chart.height),this.ghostCtx.beginPath())};ea.prototype.getNewObjectTrackingId=function(){return++this.lastObjectId};ea.prototype.mouseEventHandler=function(a){if("mousemove"===a.type||"click"===a.type){var f=[],b=Oa(a),c=null;if((c=this.chart.getObjectAtXY(b.x,b.y,!1))&&"undefined"!==typeof this.objectMap[c])if(c=this.objectMap[c],"dataPoint"===c.objectType){var e=this.chart.data[c.dataSeriesIndex],
g=e.dataPoints[c.dataPointIndex],h=c.dataPointIndex;c.eventParameter={x:b.x,y:b.y,dataPoint:g,dataSeries:e.options,dataPointIndex:h,dataSeriesIndex:e.index,chart:this.chart};c.eventContext={context:g,userContext:g,mouseover:"mouseover",mousemove:"mousemove",mouseout:"mouseout",click:"click"};f.push(c);c=this.objectMap[e.id];c.eventParameter={x:b.x,y:b.y,dataPoint:g,dataSeries:e.options,dataPointIndex:h,dataSeriesIndex:e.index,chart:this.chart};c.eventContext={context:e,userContext:e.options,mouseover:"mouseover",
mousemove:"mousemove",mouseout:"mouseout",click:"click"};f.push(this.objectMap[e.id])}else"legendItem"===c.objectType&&(e=this.chart.data[c.dataSeriesIndex],g=null!==c.dataPointIndex?e.dataPoints[c.dataPointIndex]:null,c.eventParameter={x:b.x,y:b.y,dataSeries:e.options,dataPoint:g,dataPointIndex:c.dataPointIndex,dataSeriesIndex:c.dataSeriesIndex,chart:this.chart},c.eventContext={context:this.chart.legend,userContext:this.chart.legend.options,mouseover:"itemmouseover",mousemove:"itemmousemove",mouseout:"itemmouseout",
click:"itemclick"},f.push(c));e=[];for(b=0;b<this.mouseoveredObjectMaps.length;b++){g=!0;for(c=0;c<f.length;c++)if(f[c].id===this.mouseoveredObjectMaps[b].id){g=!1;break}g?this.fireEvent(this.mouseoveredObjectMaps[b],"mouseout",a):e.push(this.mouseoveredObjectMaps[b])}this.mouseoveredObjectMaps=e;for(b=0;b<f.length;b++){e=!1;for(c=0;c<this.mouseoveredObjectMaps.length;c++)if(f[b].id===this.mouseoveredObjectMaps[c].id){e=!0;break}e||(this.fireEvent(f[b],"mouseover",a),this.mouseoveredObjectMaps.push(f[b]));
"click"===a.type?this.fireEvent(f[b],"click",a):"mousemove"===a.type&&this.fireEvent(f[b],"mousemove",a)}}};ea.prototype.fireEvent=function(a,f,b){if(a&&f){var c=a.eventParameter,e=a.eventContext,g=a.eventContext.userContext;g&&(e&&g[e[f]])&&g[e[f]].call(g,c);"mouseout"!==f?g.cursor&&g.cursor!==b.target.style.cursor&&(b.target.style.cursor=g.cursor):(b.target.style.cursor=this.chart._defaultCursor,delete a.eventParameter,delete a.eventContext);"click"===f&&("dataPoint"===a.objectType&&this.chart.pieDoughnutClickHandler)&&
this.chart.pieDoughnutClickHandler.call(this.chart.data[a.dataSeriesIndex],c);"click"===f&&("dataPoint"===a.objectType&&this.chart.funnelPyramidClickHandler)&&this.chart.funnelPyramidClickHandler.call(this.chart.data[a.dataSeriesIndex],c)}};ga.prototype.animate=function(a,f,b,c,e){var g=this;this.chart.isAnimating=!0;e=e||O.easing.linear;b&&this.animations.push({startTime:(new Date).getTime()+(a?a:0),duration:f,animationCallback:b,onComplete:c});for(a=[];0<this.animations.length;)if(f=this.animations.shift(),
b=(new Date).getTime(),c=0,f.startTime<=b&&(c=e(Math.min(b-f.startTime,f.duration),0,1,f.duration),c=Math.min(c,1),isNaN(c)||!isFinite(c))&&(c=1),1>c&&a.push(f),f.animationCallback(c),1<=c&&f.onComplete)f.onComplete();this.animations=a;0<this.animations.length?this.animationRequestId=this.chart.requestAnimFrame.call(window,function(){g.animate.call(g)}):this.chart.isAnimating=!1};ga.prototype.cancelAllAnimations=function(){this.animations=[];this.animationRequestId&&this.chart.cancelRequestAnimFrame.call(window,
this.animationRequestId);this.animationRequestId=null;this.chart.isAnimating=!1};var O={yScaleAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas,e=f.animationBase;b.drawImage(c,0,0,c.width,c.height,0,e-e*a,b.canvas.width/ia,a*b.canvas.height/ia)}},xScaleAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas,e=f.animationBase;b.drawImage(c,0,0,c.width,c.height,e-e*a,0,a*b.canvas.width/ia,b.canvas.height/ia)}},xClipAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas;
b.save();0<a&&b.drawImage(c,0,0,c.width*a,c.height,0,0,c.width*a/ia,c.height/ia);b.restore()}},fadeInAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas;b.save();b.globalAlpha=a;b.drawImage(c,0,0,c.width,c.height,0,0,b.canvas.width/ia,b.canvas.height/ia);b.restore()}},easing:{linear:function(a,f,b,c){return b*a/c+f},easeOutQuad:function(a,f,b,c){return-b*(a/=c)*(a-2)+f},easeOutQuart:function(a,f,b,c){return-b*((a=a/c-1)*a*a*a-1)+f},easeInQuad:function(a,f,b,c){return b*(a/=c)*a+f},easeInQuart:function(a,
f,b,c){return b*(a/=c)*a*a*a+f}}},$={drawMarker:function(a,f,b,c,e,g,h,l){if(b){var m=1;b.fillStyle=g?g:"#000000";b.strokeStyle=h?h:"#000000";b.lineWidth=l?l:0;b.setLineDash&&b.setLineDash(F("solid",l));"circle"===c?(b.moveTo(a,f),b.beginPath(),b.arc(a,f,e/2,0,2*Math.PI,!1),g&&b.fill(),l&&(h?b.stroke():(m=b.globalAlpha,b.globalAlpha=0.15,b.strokeStyle="black",b.stroke(),b.globalAlpha=m))):"square"===c?(b.beginPath(),b.rect(a-e/2,f-e/2,e,e),g&&b.fill(),l&&(h?b.stroke():(m=b.globalAlpha,b.globalAlpha=
0.15,b.strokeStyle="black",b.stroke(),b.globalAlpha=m))):"triangle"===c?(b.beginPath(),b.moveTo(a-e/2,f+e/2),b.lineTo(a+e/2,f+e/2),b.lineTo(a,f-e/2),b.closePath(),g&&b.fill(),l&&(h?b.stroke():(m=b.globalAlpha,b.globalAlpha=0.15,b.strokeStyle="black",b.stroke(),b.globalAlpha=m)),b.beginPath()):"cross"===c&&(b.strokeStyle=g,b.lineWidth=e/4,b.beginPath(),b.moveTo(a-e/2,f-e/2),b.lineTo(a+e/2,f+e/2),b.stroke(),b.moveTo(a+e/2,f-e/2),b.lineTo(a-e/2,f+e/2),b.stroke())}},drawMarkers:function(a){for(var f=
0;f<a.length;f++){var b=a[f];$.drawMarker(b.x,b.y,b.ctx,b.type,b.size,b.color,b.borderColor,b.borderThickness)}}};return q}();Ka.Chart.version="v2.2 GA"})();

/*
  excanvas is used to support IE678 which do not implement HTML5 Canvas Element. You can safely remove the following excanvas code if you don't need to support older browsers.

  Copyright 2006 Google Inc. https://code.google.com/p/explorercanvas/
  Licensed under the Apache License, Version 2.0
*/
document.createElement("canvas").getContext||function(){function V(){return this.context_||(this.context_=new C(this))}function W(a,b,c){var g=M.call(arguments,2);return function(){return a.apply(b,g.concat(M.call(arguments)))}}function N(a){return String(a).replace(/&/g,"&amp;").replace(/"/g,"&quot;")}function O(a){a.namespaces.g_vml_||a.namespaces.add("g_vml_","urn:schemas-microsoft-com:vml","#default#VML");a.namespaces.g_o_||a.namespaces.add("g_o_","urn:schemas-microsoft-com:office:office","#default#VML");
a.styleSheets.ex_canvas_||(a=a.createStyleSheet(),a.owningElement.id="ex_canvas_",a.cssText="canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}")}function X(a){var b=a.srcElement;switch(a.propertyName){case "width":b.getContext().clearRect();b.style.width=b.attributes.width.nodeValue+"px";b.firstChild.style.width=b.clientWidth+"px";break;case "height":b.getContext().clearRect(),b.style.height=b.attributes.height.nodeValue+"px",b.firstChild.style.height=b.clientHeight+
"px"}}function Y(a){a=a.srcElement;a.firstChild&&(a.firstChild.style.width=a.clientWidth+"px",a.firstChild.style.height=a.clientHeight+"px")}function D(){return[[1,0,0],[0,1,0],[0,0,1]]}function t(a,b){for(var c=D(),g=0;3>g;g++)for(var e=0;3>e;e++){for(var f=0,d=0;3>d;d++)f+=a[g][d]*b[d][e];c[g][e]=f}return c}function P(a,b){b.fillStyle=a.fillStyle;b.lineCap=a.lineCap;b.lineJoin=a.lineJoin;b.lineWidth=a.lineWidth;b.miterLimit=a.miterLimit;b.shadowBlur=a.shadowBlur;b.shadowColor=a.shadowColor;b.shadowOffsetX=
a.shadowOffsetX;b.shadowOffsetY=a.shadowOffsetY;b.strokeStyle=a.strokeStyle;b.globalAlpha=a.globalAlpha;b.font=a.font;b.textAlign=a.textAlign;b.textBaseline=a.textBaseline;b.arcScaleX_=a.arcScaleX_;b.arcScaleY_=a.arcScaleY_;b.lineScale_=a.lineScale_}function Q(a){var b=a.indexOf("(",3),c=a.indexOf(")",b+1),b=a.substring(b+1,c).split(",");if(4!=b.length||"a"!=a.charAt(3))b[3]=1;return b}function E(a,b,c){return Math.min(c,Math.max(b,a))}function F(a,b,c){0>c&&c++;1<c&&c--;return 1>6*c?a+6*(b-a)*c:
1>2*c?b:2>3*c?a+6*(b-a)*(2/3-c):a}function G(a){if(a in H)return H[a];var b,c=1;a=String(a);if("#"==a.charAt(0))b=a;else if(/^rgb/.test(a)){c=Q(a);b="#";for(var g,e=0;3>e;e++)g=-1!=c[e].indexOf("%")?Math.floor(255*(parseFloat(c[e])/100)):+c[e],b+=v[E(g,0,255)];c=+c[3]}else if(/^hsl/.test(a)){e=c=Q(a);b=parseFloat(e[0])/360%360;0>b&&b++;g=E(parseFloat(e[1])/100,0,1);e=E(parseFloat(e[2])/100,0,1);if(0==g)g=e=b=e;else{var f=0.5>e?e*(1+g):e+g-e*g,d=2*e-f;g=F(d,f,b+1/3);e=F(d,f,b);b=F(d,f,b-1/3)}b="#"+
v[Math.floor(255*g)]+v[Math.floor(255*e)]+v[Math.floor(255*b)];c=c[3]}else b=Z[a]||a;return H[a]={color:b,alpha:c}}function C(a){this.m_=D();this.mStack_=[];this.aStack_=[];this.currentPath_=[];this.fillStyle=this.strokeStyle="#000";this.lineWidth=1;this.lineJoin="miter";this.lineCap="butt";this.miterLimit=1*q;this.globalAlpha=1;this.font="10px sans-serif";this.textAlign="left";this.textBaseline="alphabetic";this.canvas=a;var b="width:"+a.clientWidth+"px;height:"+a.clientHeight+"px;overflow:hidden;position:absolute",
c=a.ownerDocument.createElement("div");c.style.cssText=b;a.appendChild(c);b=c.cloneNode(!1);b.style.backgroundColor="red";b.style.filter="alpha(opacity=0)";a.appendChild(b);this.element_=c;this.lineScale_=this.arcScaleY_=this.arcScaleX_=1}function R(a,b,c,g){a.currentPath_.push({type:"bezierCurveTo",cp1x:b.x,cp1y:b.y,cp2x:c.x,cp2y:c.y,x:g.x,y:g.y});a.currentX_=g.x;a.currentY_=g.y}function S(a,b){var c=G(a.strokeStyle),g=c.color,c=c.alpha*a.globalAlpha,e=a.lineScale_*a.lineWidth;1>e&&(c*=e);b.push("<g_vml_:stroke",
' opacity="',c,'"',' joinstyle="',a.lineJoin,'"',' miterlimit="',a.miterLimit,'"',' endcap="',$[a.lineCap]||"square",'"',' weight="',e,'px"',' color="',g,'" />')}function T(a,b,c,g){var e=a.fillStyle,f=a.arcScaleX_,d=a.arcScaleY_,k=g.x-c.x,n=g.y-c.y;if(e instanceof w){var h=0,l=g=0,u=0,m=1;if("gradient"==e.type_){h=e.x1_/f;c=e.y1_/d;var p=s(a,e.x0_/f,e.y0_/d),h=s(a,h,c),h=180*Math.atan2(h.x-p.x,h.y-p.y)/Math.PI;0>h&&(h+=360);1E-6>h&&(h=0)}else p=s(a,e.x0_,e.y0_),g=(p.x-c.x)/k,l=(p.y-c.y)/n,k/=f*q,
n/=d*q,m=x.max(k,n),u=2*e.r0_/m,m=2*e.r1_/m-u;f=e.colors_;f.sort(function(a,b){return a.offset-b.offset});d=f.length;p=f[0].color;c=f[d-1].color;k=f[0].alpha*a.globalAlpha;a=f[d-1].alpha*a.globalAlpha;for(var n=[],r=0;r<d;r++){var t=f[r];n.push(t.offset*m+u+" "+t.color)}b.push('<g_vml_:fill type="',e.type_,'"',' method="none" focus="100%"',' color="',p,'"',' color2="',c,'"',' colors="',n.join(","),'"',' opacity="',a,'"',' g_o_:opacity2="',k,'"',' angle="',h,'"',' focusposition="',g,",",l,'" />')}else e instanceof
I?k&&n&&b.push("<g_vml_:fill",' position="',-c.x/k*f*f,",",-c.y/n*d*d,'"',' type="tile"',' src="',e.src_,'" />'):(e=G(a.fillStyle),b.push('<g_vml_:fill color="',e.color,'" opacity="',e.alpha*a.globalAlpha,'" />'))}function s(a,b,c){a=a.m_;return{x:q*(b*a[0][0]+c*a[1][0]+a[2][0])-r,y:q*(b*a[0][1]+c*a[1][1]+a[2][1])-r}}function z(a,b,c){isFinite(b[0][0])&&(isFinite(b[0][1])&&isFinite(b[1][0])&&isFinite(b[1][1])&&isFinite(b[2][0])&&isFinite(b[2][1]))&&(a.m_=b,c&&(a.lineScale_=aa(ba(b[0][0]*b[1][1]-b[0][1]*
b[1][0]))))}function w(a){this.type_=a;this.r1_=this.y1_=this.x1_=this.r0_=this.y0_=this.x0_=0;this.colors_=[]}function I(a,b){if(!a||1!=a.nodeType||"IMG"!=a.tagName)throw new A("TYPE_MISMATCH_ERR");if("complete"!=a.readyState)throw new A("INVALID_STATE_ERR");switch(b){case "repeat":case null:case "":this.repetition_="repeat";break;case "repeat-x":case "repeat-y":case "no-repeat":this.repetition_=b;break;default:throw new A("SYNTAX_ERR");}this.src_=a.src;this.width_=a.width;this.height_=a.height}
function A(a){this.code=this[a];this.message=a+": DOM Exception "+this.code}var x=Math,k=x.round,J=x.sin,K=x.cos,ba=x.abs,aa=x.sqrt,q=10,r=q/2;navigator.userAgent.match(/MSIE ([\d.]+)?/);var M=Array.prototype.slice;O(document);var U={init:function(a){a=a||document;a.createElement("canvas");a.attachEvent("onreadystatechange",W(this.init_,this,a))},init_:function(a){a=a.getElementsByTagName("canvas");for(var b=0;b<a.length;b++)this.initElement(a[b])},initElement:function(a){if(!a.getContext){a.getContext=
V;O(a.ownerDocument);a.innerHTML="";a.attachEvent("onpropertychange",X);a.attachEvent("onresize",Y);var b=a.attributes;b.width&&b.width.specified?a.style.width=b.width.nodeValue+"px":a.width=a.clientWidth;b.height&&b.height.specified?a.style.height=b.height.nodeValue+"px":a.height=a.clientHeight}return a}};U.init();for(var v=[],d=0;16>d;d++)for(var B=0;16>B;B++)v[16*d+B]=d.toString(16)+B.toString(16);var Z={aliceblue:"#F0F8FF",antiquewhite:"#FAEBD7",aquamarine:"#7FFFD4",azure:"#F0FFFF",beige:"#F5F5DC",
bisque:"#FFE4C4",black:"#000000",blanchedalmond:"#FFEBCD",blueviolet:"#8A2BE2",brown:"#A52A2A",burlywood:"#DEB887",cadetblue:"#5F9EA0",chartreuse:"#7FFF00",chocolate:"#D2691E",coral:"#FF7F50",cornflowerblue:"#6495ED",cornsilk:"#FFF8DC",crimson:"#DC143C",cyan:"#00FFFF",darkblue:"#00008B",darkcyan:"#008B8B",darkgoldenrod:"#B8860B",darkgray:"#A9A9A9",darkgreen:"#006400",darkgrey:"#A9A9A9",darkkhaki:"#BDB76B",darkmagenta:"#8B008B",darkolivegreen:"#556B2F",darkorange:"#FF8C00",darkorchid:"#9932CC",darkred:"#8B0000",
darksalmon:"#E9967A",darkseagreen:"#8FBC8F",darkslateblue:"#483D8B",darkslategray:"#2F4F4F",darkslategrey:"#2F4F4F",darkturquoise:"#00CED1",darkviolet:"#9400D3",deeppink:"#FF1493",deepskyblue:"#00BFFF",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1E90FF",firebrick:"#B22222",floralwhite:"#FFFAF0",forestgreen:"#228B22",gainsboro:"#DCDCDC",ghostwhite:"#F8F8FF",gold:"#FFD700",goldenrod:"#DAA520",grey:"#808080",greenyellow:"#ADFF2F",honeydew:"#F0FFF0",hotpink:"#FF69B4",indianred:"#CD5C5C",indigo:"#4B0082",
ivory:"#FFFFF0",khaki:"#F0E68C",lavender:"#E6E6FA",lavenderblush:"#FFF0F5",lawngreen:"#7CFC00",lemonchiffon:"#FFFACD",lightblue:"#ADD8E6",lightcoral:"#F08080",lightcyan:"#E0FFFF",lightgoldenrodyellow:"#FAFAD2",lightgreen:"#90EE90",lightgrey:"#D3D3D3",lightpink:"#FFB6C1",lightsalmon:"#FFA07A",lightseagreen:"#20B2AA",lightskyblue:"#87CEFA",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#B0C4DE",lightyellow:"#FFFFE0",limegreen:"#32CD32",linen:"#FAF0E6",magenta:"#FF00FF",mediumaquamarine:"#66CDAA",
mediumblue:"#0000CD",mediumorchid:"#BA55D3",mediumpurple:"#9370DB",mediumseagreen:"#3CB371",mediumslateblue:"#7B68EE",mediumspringgreen:"#00FA9A",mediumturquoise:"#48D1CC",mediumvioletred:"#C71585",midnightblue:"#191970",mintcream:"#F5FFFA",mistyrose:"#FFE4E1",moccasin:"#FFE4B5",navajowhite:"#FFDEAD",oldlace:"#FDF5E6",olivedrab:"#6B8E23",orange:"#FFA500",orangered:"#FF4500",orchid:"#DA70D6",palegoldenrod:"#EEE8AA",palegreen:"#98FB98",paleturquoise:"#AFEEEE",palevioletred:"#DB7093",papayawhip:"#FFEFD5",
peachpuff:"#FFDAB9",peru:"#CD853F",pink:"#FFC0CB",plum:"#DDA0DD",powderblue:"#B0E0E6",rosybrown:"#BC8F8F",royalblue:"#4169E1",saddlebrown:"#8B4513",salmon:"#FA8072",sandybrown:"#F4A460",seagreen:"#2E8B57",seashell:"#FFF5EE",sienna:"#A0522D",skyblue:"#87CEEB",slateblue:"#6A5ACD",slategray:"#708090",slategrey:"#708090",snow:"#FFFAFA",springgreen:"#00FF7F",steelblue:"#4682B4",tan:"#D2B48C",thistle:"#D8BFD8",tomato:"#FF6347",turquoise:"#40E0D0",violet:"#EE82EE",wheat:"#F5DEB3",whitesmoke:"#F5F5F5",yellowgreen:"#9ACD32"},
H={},L={},$={butt:"flat",round:"round"},d=C.prototype;d.clearRect=function(){this.textMeasureEl_&&(this.textMeasureEl_.removeNode(!0),this.textMeasureEl_=null);this.element_.innerHTML=""};d.beginPath=function(){this.currentPath_=[]};d.moveTo=function(a,b){var c=s(this,a,b);this.currentPath_.push({type:"moveTo",x:c.x,y:c.y});this.currentX_=c.x;this.currentY_=c.y};d.lineTo=function(a,b){var c=s(this,a,b);this.currentPath_.push({type:"lineTo",x:c.x,y:c.y});this.currentX_=c.x;this.currentY_=c.y};d.bezierCurveTo=
function(a,b,c,g,e,f){e=s(this,e,f);a=s(this,a,b);c=s(this,c,g);R(this,a,c,e)};d.quadraticCurveTo=function(a,b,c,g){a=s(this,a,b);c=s(this,c,g);g={x:this.currentX_+2/3*(a.x-this.currentX_),y:this.currentY_+2/3*(a.y-this.currentY_)};R(this,g,{x:g.x+(c.x-this.currentX_)/3,y:g.y+(c.y-this.currentY_)/3},c)};d.arc=function(a,b,c,g,e,f){c*=q;var d=f?"at":"wa",k=a+K(g)*c-r,n=b+J(g)*c-r;g=a+K(e)*c-r;e=b+J(e)*c-r;k!=g||f||(k+=0.125);a=s(this,a,b);k=s(this,k,n);g=s(this,g,e);this.currentPath_.push({type:d,
x:a.x,y:a.y,radius:c,xStart:k.x,yStart:k.y,xEnd:g.x,yEnd:g.y})};d.rect=function(a,b,c,g){this.moveTo(a,b);this.lineTo(a+c,b);this.lineTo(a+c,b+g);this.lineTo(a,b+g);this.closePath()};d.strokeRect=function(a,b,c,g){var e=this.currentPath_;this.beginPath();this.moveTo(a,b);this.lineTo(a+c,b);this.lineTo(a+c,b+g);this.lineTo(a,b+g);this.closePath();this.stroke();this.currentPath_=e};d.fillRect=function(a,b,c,g){var e=this.currentPath_;this.beginPath();this.moveTo(a,b);this.lineTo(a+c,b);this.lineTo(a+
c,b+g);this.lineTo(a,b+g);this.closePath();this.fill();this.currentPath_=e};d.createLinearGradient=function(a,b,c,g){var e=new w("gradient");e.x0_=a;e.y0_=b;e.x1_=c;e.y1_=g;return e};d.createRadialGradient=function(a,b,c,g,e,f){var d=new w("gradientradial");d.x0_=a;d.y0_=b;d.r0_=c;d.x1_=g;d.y1_=e;d.r1_=f;return d};d.drawImage=function(a,b){var c,g,e,d,r,y,n,h;e=a.runtimeStyle.width;d=a.runtimeStyle.height;a.runtimeStyle.width="auto";a.runtimeStyle.height="auto";var l=a.width,u=a.height;a.runtimeStyle.width=
e;a.runtimeStyle.height=d;if(3==arguments.length)c=arguments[1],g=arguments[2],r=y=0,n=e=l,h=d=u;else if(5==arguments.length)c=arguments[1],g=arguments[2],e=arguments[3],d=arguments[4],r=y=0,n=l,h=u;else if(9==arguments.length)r=arguments[1],y=arguments[2],n=arguments[3],h=arguments[4],c=arguments[5],g=arguments[6],e=arguments[7],d=arguments[8];else throw Error("Invalid number of arguments");var m=s(this,c,g),p=[];p.push(" <g_vml_:group",' coordsize="',10*q,",",10*q,'"',' coordorigin="0,0"',' style="width:',
10,"px;height:",10,"px;position:absolute;");if(1!=this.m_[0][0]||this.m_[0][1]||1!=this.m_[1][1]||this.m_[1][0]){var t=[];t.push("M11=",this.m_[0][0],",","M12=",this.m_[1][0],",","M21=",this.m_[0][1],",","M22=",this.m_[1][1],",","Dx=",k(m.x/q),",","Dy=",k(m.y/q),"");var v=s(this,c+e,g),w=s(this,c,g+d);c=s(this,c+e,g+d);m.x=x.max(m.x,v.x,w.x,c.x);m.y=x.max(m.y,v.y,w.y,c.y);p.push("padding:0 ",k(m.x/q),"px ",k(m.y/q),"px 0;filter:progid:DXImageTransform.Microsoft.Matrix(",t.join(""),", sizingmethod='clip');")}else p.push("top:",
k(m.y/q),"px;left:",k(m.x/q),"px;");p.push(' ">','<g_vml_:image src="',a.src,'"',' style="width:',q*e,"px;"," height:",q*d,'px"',' cropleft="',r/l,'"',' croptop="',y/u,'"',' cropright="',(l-r-n)/l,'"',' cropbottom="',(u-y-h)/u,'"'," />","</g_vml_:group>");this.element_.insertAdjacentHTML("BeforeEnd",p.join(""))};d.stroke=function(a){var b=[];b.push("<g_vml_:shape",' filled="',!!a,'"',' style="position:absolute;width:',10,"px;height:",10,'px;"',' coordorigin="0,0"',' coordsize="',10*q,",",10*q,'"',
' stroked="',!a,'"',' path="');for(var c={x:null,y:null},d={x:null,y:null},e=0;e<this.currentPath_.length;e++){var f=this.currentPath_[e];switch(f.type){case "moveTo":b.push(" m ",k(f.x),",",k(f.y));break;case "lineTo":b.push(" l ",k(f.x),",",k(f.y));break;case "close":b.push(" x ");f=null;break;case "bezierCurveTo":b.push(" c ",k(f.cp1x),",",k(f.cp1y),",",k(f.cp2x),",",k(f.cp2y),",",k(f.x),",",k(f.y));break;case "at":case "wa":b.push(" ",f.type," ",k(f.x-this.arcScaleX_*f.radius),",",k(f.y-this.arcScaleY_*
f.radius)," ",k(f.x+this.arcScaleX_*f.radius),",",k(f.y+this.arcScaleY_*f.radius)," ",k(f.xStart),",",k(f.yStart)," ",k(f.xEnd),",",k(f.yEnd))}if(f){if(null==c.x||f.x<c.x)c.x=f.x;if(null==d.x||f.x>d.x)d.x=f.x;if(null==c.y||f.y<c.y)c.y=f.y;if(null==d.y||f.y>d.y)d.y=f.y}}b.push(' ">');a?T(this,b,c,d):S(this,b);b.push("</g_vml_:shape>");this.element_.insertAdjacentHTML("beforeEnd",b.join(""))};d.fill=function(){this.stroke(!0)};d.closePath=function(){this.currentPath_.push({type:"close"})};d.save=function(){var a=
{};P(this,a);this.aStack_.push(a);this.mStack_.push(this.m_);this.m_=t(D(),this.m_)};d.restore=function(){this.aStack_.length&&(P(this.aStack_.pop(),this),this.m_=this.mStack_.pop())};d.translate=function(a,b){z(this,t([[1,0,0],[0,1,0],[a,b,1]],this.m_),!1)};d.rotate=function(a){var b=K(a);a=J(a);z(this,t([[b,a,0],[-a,b,0],[0,0,1]],this.m_),!1)};d.scale=function(a,b){this.arcScaleX_*=a;this.arcScaleY_*=b;z(this,t([[a,0,0],[0,b,0],[0,0,1]],this.m_),!0)};d.transform=function(a,b,c,d,e,f){z(this,t([[a,
b,0],[c,d,0],[e,f,1]],this.m_),!0)};d.setTransform=function(a,b,c,d,e,f){z(this,[[a,b,0],[c,d,0],[e,f,1]],!0)};d.drawText_=function(a,b,c,d,e){var f=this.m_;d=0;var r=1E3,t=0,n=[],h;h=this.font;if(L[h])h=L[h];else{var l=document.createElement("div").style;try{l.font=h}catch(u){}h=L[h]={style:l.fontStyle||"normal",variant:l.fontVariant||"normal",weight:l.fontWeight||"normal",size:l.fontSize||10,family:l.fontFamily||"sans-serif"}}var l=h,m=this.element_;h={};for(var p in l)h[p]=l[p];p=parseFloat(m.currentStyle.fontSize);
m=parseFloat(l.size);"number"==typeof l.size?h.size=l.size:-1!=l.size.indexOf("px")?h.size=m:-1!=l.size.indexOf("em")?h.size=p*m:-1!=l.size.indexOf("%")?h.size=p/100*m:-1!=l.size.indexOf("pt")?h.size=m/0.75:h.size=p;h.size*=0.981;p=h.style+" "+h.variant+" "+h.weight+" "+h.size+"px "+h.family;m=this.element_.currentStyle;l=this.textAlign.toLowerCase();switch(l){case "left":case "center":case "right":break;case "end":l="ltr"==m.direction?"right":"left";break;case "start":l="rtl"==m.direction?"right":
"left";break;default:l="left"}switch(this.textBaseline){case "hanging":case "top":t=h.size/1.75;break;case "middle":break;default:case null:case "alphabetic":case "ideographic":case "bottom":t=-h.size/2.25}switch(l){case "right":d=1E3;r=0.05;break;case "center":d=r=500}b=s(this,b+0,c+t);n.push('<g_vml_:line from="',-d,' 0" to="',r,' 0.05" ',' coordsize="100 100" coordorigin="0 0"',' filled="',!e,'" stroked="',!!e,'" style="position:absolute;width:1px;height:1px;">');e?S(this,n):T(this,n,{x:-d,y:0},
{x:r,y:h.size});e=f[0][0].toFixed(3)+","+f[1][0].toFixed(3)+","+f[0][1].toFixed(3)+","+f[1][1].toFixed(3)+",0,0";b=k(b.x/q)+","+k(b.y/q);n.push('<g_vml_:skew on="t" matrix="',e,'" ',' offset="',b,'" origin="',d,' 0" />','<g_vml_:path textpathok="true" />','<g_vml_:textpath on="true" string="',N(a),'" style="v-text-align:',l,";font:",N(p),'" /></g_vml_:line>');this.element_.insertAdjacentHTML("beforeEnd",n.join(""))};d.fillText=function(a,b,c,d){this.drawText_(a,b,c,d,!1)};d.strokeText=function(a,
b,c,d){this.drawText_(a,b,c,d,!0)};d.measureText=function(a){this.textMeasureEl_||(this.element_.insertAdjacentHTML("beforeEnd",'<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>'),this.textMeasureEl_=this.element_.lastChild);var b=this.element_.ownerDocument;this.textMeasureEl_.innerHTML="";this.textMeasureEl_.style.font=this.font;this.textMeasureEl_.appendChild(b.createTextNode(a));return{width:this.textMeasureEl_.offsetWidth}};d.clip=function(){};
d.arcTo=function(){};d.createPattern=function(a,b){return new I(a,b)};w.prototype.addColorStop=function(a,b){b=G(b);this.colors_.push({offset:a,color:b.color,alpha:b.alpha})};d=A.prototype=Error();d.INDEX_SIZE_ERR=1;d.DOMSTRING_SIZE_ERR=2;d.HIERARCHY_REQUEST_ERR=3;d.WRONG_DOCUMENT_ERR=4;d.INVALID_CHARACTER_ERR=5;d.NO_DATA_ALLOWED_ERR=6;d.NO_MODIFICATION_ALLOWED_ERR=7;d.NOT_FOUND_ERR=8;d.NOT_SUPPORTED_ERR=9;d.INUSE_ATTRIBUTE_ERR=10;d.INVALID_STATE_ERR=11;d.SYNTAX_ERR=12;d.INVALID_MODIFICATION_ERR=
13;d.NAMESPACE_ERR=14;d.INVALID_ACCESS_ERR=15;d.VALIDATION_ERR=16;d.TYPE_MISMATCH_ERR=17;G_vmlCanvasManager=U;CanvasRenderingContext2D=C;CanvasGradient=w;CanvasPattern=I;DOMException=A}();

/*
 CanvasJS jQuery Charting Plugin - https://canvasjs.com/ 
 Copyright 2017 fenopix

  --------------------- License Information --------------------
 CanvasJS is a commercial product which requires purchase of license. Without a commercial license you can use it for evaluation purposes for upto 30 days. Please refer to the following link for further details.
     https://canvasjs.com/license/

*/
(function(b,c,d,e){b.fn.CanvasJSChart=function(a){if(a){var b=this.first();a=new CanvasJS.Chart(this[0],a);b.children(".canvasjs-chart-container").data("canvasjsChartRef",a);a.render();return this}return this.first().children(".canvasjs-chart-container").data("canvasjsChartRef")}})(jQuery,window,document);
/*jshint ignore:end*/
/*
 CanvasJS HTML5 & JavaScript Charts - v2.2 GA - https://canvasjs.com/ 
 Copyright 2018 fenopix

*/
/*eslint-disable*/
/*jshint ignore:start*/
(function(){function na(m,s){m.prototype=$a(s.prototype);m.prototype.constructor=m;m.base=s.prototype}function $a(m){function s(){}s.prototype=m;return new s}function Ta(m,s,q){"millisecond"===q?m.setMilliseconds(m.getMilliseconds()+1*s):"second"===q?m.setSeconds(m.getSeconds()+1*s):"minute"===q?m.setMinutes(m.getMinutes()+1*s):"hour"===q?m.setHours(m.getHours()+1*s):"day"===q?m.setDate(m.getDate()+1*s):"week"===q?m.setDate(m.getDate()+7*s):"month"===q?m.setMonth(m.getMonth()+1*s):"year"===q&&m.setFullYear(m.getFullYear()+
1*s);return m}function ha(m,s){var q=!1;0>m&&(q=!0,m*=-1);m=""+m;for(s=s?s:1;m.length<s;)m="0"+m;return q?"-"+m:m}function Fa(m){if(!m)return m;m=m.replace(/^\s\s*/,"");for(var s=/\s/,q=m.length;s.test(m.charAt(--q)););return m.slice(0,q+1)}function Ba(m){m.roundRect=function(m,q,v,y,x,z,S,C){S&&(this.fillStyle=S);C&&(this.strokeStyle=C);"undefined"===typeof x&&(x=5);this.lineWidth=z;this.beginPath();this.moveTo(m+x,q);this.lineTo(m+v-x,q);this.quadraticCurveTo(m+v,q,m+v,q+x);this.lineTo(m+v,q+y-
x);this.quadraticCurveTo(m+v,q+y,m+v-x,q+y);this.lineTo(m+x,q+y);this.quadraticCurveTo(m,q+y,m,q+y-x);this.lineTo(m,q+x);this.quadraticCurveTo(m,q,m+x,q);this.closePath();S&&this.fill();C&&0<z&&this.stroke()}}function Pa(m,s){return m-s}function R(m){var s=((m&16711680)>>16).toString(16),q=((m&65280)>>8).toString(16);m=((m&255)>>0).toString(16);s=2>s.length?"0"+s:s;q=2>q.length?"0"+q:q;m=2>m.length?"0"+m:m;return"#"+s+q+m}function ab(m,s){var q=this.length>>>0,v=Number(s)||0,v=0>v?Math.ceil(v):Math.floor(v);
for(0>v&&(v+=q);v<q;v++)if(v in this&&this[v]===m)return v;return-1}function y(m){return null===m||"undefined"===typeof m}function Ca(m){m.indexOf||(m.indexOf=ab);return m}function bb(m){if(W.fSDec)m[ga("`eeDwdouMhrudods")](ga("e`u`@ohl`uhnoHuds`uhnoDoe"),function(){W._fTWm&&W._fTWm(m)})}function Ua(m,s,q){q=q||"normal";var v=m+"_"+s+"_"+q,y=Va[v];if(isNaN(y)){try{m="position:absolute; left:0px; top:-20000px; padding:0px;margin:0px;border:none;white-space:pre;line-height:normal;font-family:"+m+"; font-size:"+
s+"px; font-weight:"+q+";";if(!pa){var x=document.body;pa=document.createElement("span");pa.innerHTML="";var z=document.createTextNode("Mpgyi");pa.appendChild(z);x.appendChild(pa)}pa.style.display="";pa.setAttribute("style",m);y=Math.round(pa.offsetHeight);pa.style.display="none"}catch(S){y=Math.ceil(1.1*s)}y=Math.max(y,s);Va[v]=y}return y}function F(m,s){var q=[];if(q={solid:[],shortDash:[3,1],shortDot:[1,1],shortDashDot:[3,1,1,1],shortDashDotDot:[3,1,1,1,1,1],dot:[1,2],dash:[4,2],dashDot:[4,2,1,
2],longDash:[8,2],longDashDot:[8,2,1,2],longDashDotDot:[8,2,1,2,1,2]}[m||"solid"])for(var v=0;v<q.length;v++)q[v]*=s;else q=[];return q}function P(m,s,q,v,y){v=v||[];y=y||!1;v.push([m,s,q,y]);return m.addEventListener?(m.addEventListener(s,q,y),q):m.attachEvent?(v=function(s){s=s||window.event;s.preventDefault=s.preventDefault||function(){s.returnValue=!1};s.stopPropagation=s.stopPropagation||function(){s.cancelBubble=!0};q.call(m,s)},m.attachEvent("on"+s,v),v):!1}function Wa(m,s,q){m*=ia;s*=ia;m=
q.getImageData(m,s,2,2).data;s=!0;for(q=0;4>q;q++)if(m[q]!==m[q+4]|m[q]!==m[q+8]|m[q]!==m[q+12]){s=!1;break}return s?m[0]<<16|m[1]<<8|m[2]:0}function ja(m,s,q){return m in s?s[m]:q[m]}function Ga(m,s,q){if(v&&Xa){var y=m.getContext("2d");La=y.webkitBackingStorePixelRatio||y.mozBackingStorePixelRatio||y.msBackingStorePixelRatio||y.oBackingStorePixelRatio||y.backingStorePixelRatio||1;ia=Qa/La;m.width=s*ia;m.height=q*ia;Qa!==La&&(m.style.width=s+"px",m.style.height=q+"px",y.scale(ia,ia))}else m.width=
s,m.height=q}function cb(m){if(!db){var s=!1,q=!1;"undefined"===typeof qa.Chart.creditHref?(m.creditHref=ga("iuuqr;..b`ow`rkr/bnl."),m.creditText=ga("B`ow`rKR/bnl")):(s=m.updateOption("creditText"),q=m.updateOption("creditHref"));if(m.creditHref&&m.creditText){m._creditLink||(m._creditLink=document.createElement("a"),m._creditLink.setAttribute("class","canvasjs-chart-credit"),m._creditLink.setAttribute("title","JavaScript Charts"),m._creditLink.setAttribute("style","outline:none;margin:0px;position:absolute;right:2px;top:"+
(m.height-14)+"px;color:dimgrey;text-decoration:none;font-size:11px;font-family: Calibri, Lucida Grande, Lucida Sans Unicode, Arial, sans-serif"),m._creditLink.setAttribute("tabIndex",-1),m._creditLink.setAttribute("target","_blank"));if(0===m.renderCount||s||q)m._creditLink.setAttribute("href",m.creditHref),m._creditLink.innerHTML=m.creditText;m._creditLink&&m.creditHref&&m.creditText?(m._creditLink.parentElement||m._canvasJSContainer.appendChild(m._creditLink),m._creditLink.style.top=m.height-14+
"px"):m._creditLink.parentElement&&m._canvasJSContainer.removeChild(m._creditLink)}}}function ta(m,s){var q=document.createElement("canvas");q.setAttribute("class","canvasjs-chart-canvas");Ga(q,m,s);v||"undefined"===typeof G_vmlCanvasManager||G_vmlCanvasManager.initElement(q);return q}function oa(m,s,q){for(var v in q)s.style[v]=q[v]}function ua(m,s,q){s.getAttribute("state")||(s.style.backgroundColor=m.toolbar.backgroundColor,s.style.color=m.toolbar.fontColor,s.style.border="none",oa(m,s,{WebkitUserSelect:"none",
MozUserSelect:"none",msUserSelect:"none",userSelect:"none"}));s.getAttribute("state")!==q&&(s.setAttribute("state",q),s.setAttribute("type","button"),oa(m,s,{padding:"5px 12px",cursor:"pointer","float":"left",width:"40px",height:"25px",outline:"0px",verticalAlign:"baseline",lineHeight:"0"}),s.setAttribute("title",m._cultureInfo[q+"Text"]),s.innerHTML="<img style='height:95%;' src='"+eb[q].image+"' alt='"+m._cultureInfo[q+"Text"]+"' />")}function Ma(){for(var m=null,s=0;s<arguments.length;s++)m=arguments[s],
m.style&&(m.style.display="inline")}function va(){for(var m=null,s=0;s<arguments.length;s++)(m=arguments[s])&&m.style&&(m.style.display="none")}function Y(m,s,q,v,x){this._defaultsKey=m;this._themeOptionsKey=s;this._index=v;this.parent=x;this._eventListeners=[];m={};this.theme&&y(s)&&y(v)?m=y(xa[this.theme])?xa.light1:xa[this.theme]:this.parent&&(this.parent.themeOptions&&this.parent.themeOptions[s])&&(null===v?m=this.parent.themeOptions[s]:0<this.parent.themeOptions[s].length&&(v=Math.min(this.parent.themeOptions[s].length-
1,v),m=this.parent.themeOptions[s][v]));this.themeOptions=m;this.options=q?q:{_isPlaceholder:!0};this.setOptions(this.options,m)}function Da(m,s,q,v,y){"undefined"===typeof y&&(y=0);this._padding=y;this._x1=m;this._y1=s;this._x2=q;this._y2=v;this._rightOccupied=this._leftOccupied=this._bottomOccupied=this._topOccupied=this._padding}function ka(m,s){ka.base.constructor.call(this,"TextBlock",null,s,null,null);this.ctx=m;this._isDirty=!0;this._wrappedText=null;this._initialize()}function Ra(m,s){Ra.base.constructor.call(this,
"Toolbar","toolbar",s,null,m);this.chart=m;this.canvas=m.canvas;this.ctx=this.chart.ctx;this.optionsName="toolbar"}function Ha(m,s){Ha.base.constructor.call(this,"Title","title",s,null,m);this.chart=m;this.canvas=m.canvas;this.ctx=this.chart.ctx;this.optionsName="title";if(y(this.options.margin)&&m.options.subtitles)for(var q=m.options.subtitles,v=0;v<q.length;v++)if((y(q[v].horizontalAlign)&&"center"===this.horizontalAlign||q[v].horizontalAlign===this.horizontalAlign)&&(y(q[v].verticalAlign)&&"top"===
this.verticalAlign||q[v].verticalAlign===this.verticalAlign)&&!q[v].dockInsidePlotArea===!this.dockInsidePlotArea){this.margin=0;break}"undefined"===typeof this.options.fontSize&&(this.fontSize=this.chart.getAutoFontSize(this.fontSize));this.height=this.width=null;this.bounds={x1:null,y1:null,x2:null,y2:null}}function Na(m,s,q){Na.base.constructor.call(this,"Subtitle","subtitles",s,q,m);this.chart=m;this.canvas=m.canvas;this.ctx=this.chart.ctx;this.optionsName="subtitles";this.isOptionsInArray=!0;
"undefined"===typeof this.options.fontSize&&(this.fontSize=this.chart.getAutoFontSize(this.fontSize));this.height=this.width=null;this.bounds={x1:null,y1:null,x2:null,y2:null}}function Ia(m){var s;m&&Ja[m]&&(s=Ja[m]);Ia.base.constructor.call(this,"CultureInfo",null,s,null,null)}var W={},v=!!document.createElement("canvas").getContext,qa={Chart:{width:500,height:400,zoomEnabled:!1,zoomType:"x",backgroundColor:"white",theme:"light1",animationEnabled:!1,animationDuration:1200,dataPointWidth:null,dataPointMinWidth:null,
dataPointMaxWidth:null,colorSet:"colorSet1",culture:"en",creditHref:"",creditText:"CanvasJS",interactivityEnabled:!0,exportEnabled:!1,exportFileName:"Chart",rangeChanging:null,rangeChanged:null,publicProperties:{title:"readWrite",subtitles:"readWrite",toolbar:"readWrite",toolTip:"readWrite",legend:"readWrite",axisX:"readWrite",axisY:"readWrite",axisX2:"readWrite",axisY2:"readWrite",data:"readWrite",options:"readWrite",bounds:"readOnly",container:"readOnly"}},Title:{padding:0,text:null,verticalAlign:"top",
horizontalAlign:"center",fontSize:20,fontFamily:"Calibri",fontWeight:"normal",fontColor:"black",fontStyle:"normal",borderThickness:0,borderColor:"black",cornerRadius:0,backgroundColor:v?"transparent":null,margin:5,wrap:!0,maxWidth:null,dockInsidePlotArea:!1,publicProperties:{options:"readWrite",bounds:"readOnly",chart:"readOnly"}},Subtitle:{padding:0,text:null,verticalAlign:"top",horizontalAlign:"center",fontSize:14,fontFamily:"Calibri",fontWeight:"normal",fontColor:"black",fontStyle:"normal",borderThickness:0,
borderColor:"black",cornerRadius:0,backgroundColor:null,margin:2,wrap:!0,maxWidth:null,dockInsidePlotArea:!1,publicProperties:{options:"readWrite",bounds:"readOnly",chart:"readOnly"}},Toolbar:{backgroundColor:"white",backgroundColorOnHover:"#2196f3",borderColor:"#2196f3",borderThickness:1,fontColor:"black",fontColorOnHover:"white",publicProperties:{options:"readWrite",chart:"readOnly"}},Legend:{name:null,verticalAlign:"center",horizontalAlign:"right",fontSize:14,fontFamily:"calibri",fontWeight:"normal",
fontColor:"black",fontStyle:"normal",cursor:null,itemmouseover:null,itemmouseout:null,itemmousemove:null,itemclick:null,dockInsidePlotArea:!1,reversed:!1,backgroundColor:v?"transparent":null,borderColor:v?"transparent":null,borderThickness:0,cornerRadius:0,maxWidth:null,maxHeight:null,markerMargin:null,itemMaxWidth:null,itemWidth:null,itemWrap:!0,itemTextFormatter:null,publicProperties:{options:"readWrite",bounds:"readOnly",chart:"readOnly"}},ToolTip:{enabled:!0,shared:!1,animationEnabled:!0,content:null,
contentFormatter:null,reversed:!1,backgroundColor:v?"rgba(255,255,255,.9)":"rgb(255,255,255)",borderColor:null,borderThickness:2,cornerRadius:5,fontSize:14,fontColor:"black",fontFamily:"Calibri, Arial, Georgia, serif;",fontWeight:"normal",fontStyle:"italic",publicProperties:{options:"readWrite",chart:"readOnly"}},Axis:{minimum:null,maximum:null,viewportMinimum:null,viewportMaximum:null,interval:null,intervalType:null,reversed:!1,logarithmic:!1,logarithmBase:10,title:null,titleFontColor:"black",titleFontSize:20,
titleFontFamily:"arial",titleFontWeight:"normal",titleFontStyle:"normal",titleWrap:!0,titleMaxWidth:null,titleBackgroundColor:v?"transparent":null,titleBorderColor:v?"transparent":null,titleBorderThickness:0,titleCornerRadius:0,labelAngle:0,labelFontFamily:"arial",labelFontColor:"black",labelFontSize:12,labelFontWeight:"normal",labelFontStyle:"normal",labelAutoFit:!0,labelWrap:!0,labelMaxWidth:null,labelFormatter:null,labelBackgroundColor:v?"transparent":null,labelBorderColor:v?"transparent":null,
labelBorderThickness:0,labelCornerRadius:0,labelPlacement:"outside",prefix:"",suffix:"",includeZero:!0,tickLength:5,tickColor:"black",tickThickness:1,lineColor:"black",lineThickness:1,lineDashType:"solid",gridColor:"A0A0A0",gridThickness:0,gridDashType:"solid",interlacedColor:v?"transparent":null,valueFormatString:null,margin:2,publicProperties:{options:"readWrite",stripLines:"readWrite",scaleBreaks:"readWrite",crosshair:"readWrite",bounds:"readOnly",chart:"readOnly"}},StripLine:{value:null,startValue:null,
endValue:null,color:"orange",opacity:null,thickness:2,lineDashType:"solid",label:"",labelPlacement:"inside",labelAlign:"far",labelWrap:!0,labelMaxWidth:null,labelBackgroundColor:null,labelBorderColor:v?"transparent":null,labelBorderThickness:0,labelCornerRadius:0,labelFontFamily:"arial",labelFontColor:"orange",labelFontSize:12,labelFontWeight:"normal",labelFontStyle:"normal",labelFormatter:null,showOnTop:!1,publicProperties:{options:"readWrite",axis:"readOnly",bounds:"readOnly",chart:"readOnly"}},
ScaleBreaks:{autoCalculate:!1,collapsibleThreshold:"25%",maxNumberOfAutoBreaks:2,spacing:8,type:"straight",color:"#FFFFFF",fillOpacity:0.9,lineThickness:2,lineColor:"#E16E6E",lineDashType:"solid",publicProperties:{options:"readWrite",customBreaks:"readWrite",axis:"readOnly",autoBreaks:"readOnly",bounds:"readOnly",chart:"readOnly"}},Break:{startValue:null,endValue:null,spacing:8,type:"straight",color:"#FFFFFF",fillOpacity:0.9,lineThickness:2,lineColor:"#E16E6E",lineDashType:"solid",publicProperties:{options:"readWrite",
scaleBreaks:"readOnly",bounds:"readOnly",chart:"readOnly"}},Crosshair:{enabled:!1,snapToDataPoint:!1,color:"grey",opacity:null,thickness:2,lineDashType:"solid",label:"",labelWrap:!0,labelMaxWidth:null,labelBackgroundColor:v?"grey":null,labelBorderColor:v?"grey":null,labelBorderThickness:0,labelCornerRadius:0,labelFontFamily:v?"Calibri, Optima, Candara, Verdana, Geneva, sans-serif":"calibri",labelFontSize:12,labelFontColor:"#fff",labelFontWeight:"normal",labelFontStyle:"normal",labelFormatter:null,
valueFormatString:null,publicProperties:{options:"readWrite",axis:"readOnly",bounds:"readOnly",chart:"readOnly"}},DataSeries:{name:null,dataPoints:null,label:"",bevelEnabled:!1,highlightEnabled:!0,cursor:"default",indexLabel:"",indexLabelPlacement:"auto",indexLabelOrientation:"horizontal",indexLabelFontColor:"black",indexLabelFontSize:12,indexLabelFontStyle:"normal",indexLabelFontFamily:"Arial",indexLabelFontWeight:"normal",indexLabelBackgroundColor:null,indexLabelLineColor:"gray",indexLabelLineThickness:1,
indexLabelLineDashType:"solid",indexLabelMaxWidth:null,indexLabelWrap:!0,indexLabelFormatter:null,lineThickness:2,lineDashType:"solid",connectNullData:!1,nullDataLineDashType:"dash",color:null,lineColor:null,risingColor:"white",fallingColor:"red",fillOpacity:null,startAngle:0,radius:null,innerRadius:null,neckHeight:null,neckWidth:null,reversed:!1,valueRepresents:null,linkedDataSeriesIndex:null,whiskerThickness:2,whiskerDashType:"solid",whiskerColor:null,whiskerLength:null,stemThickness:2,stemColor:null,
stemDashType:"solid",upperBoxColor:"white",lowerBoxColor:"white",type:"column",xValueType:"number",axisXType:"primary",axisYType:"primary",axisXIndex:0,axisYIndex:0,xValueFormatString:null,yValueFormatString:null,zValueFormatString:null,percentFormatString:null,showInLegend:null,legendMarkerType:null,legendMarkerColor:null,legendText:null,legendMarkerBorderColor:v?"transparent":null,legendMarkerBorderThickness:0,markerType:"circle",markerColor:null,markerSize:null,markerBorderColor:v?"transparent":
null,markerBorderThickness:0,mouseover:null,mouseout:null,mousemove:null,click:null,toolTipContent:null,visible:!0,publicProperties:{options:"readWrite",axisX:"readWrite",axisY:"readWrite",chart:"readOnly"}},TextBlock:{x:0,y:0,width:null,height:null,maxWidth:null,maxHeight:null,padding:0,angle:0,text:"",horizontalAlign:"center",fontSize:12,fontFamily:"calibri",fontWeight:"normal",fontColor:"black",fontStyle:"normal",borderThickness:0,borderColor:"black",cornerRadius:0,backgroundColor:null,textBaseline:"top"},
CultureInfo:{decimalSeparator:".",digitGroupSeparator:",",zoomText:"Zoom",panText:"Pan",resetText:"Reset",menuText:"More Options",saveJPGText:"Save as JPEG",savePNGText:"Save as PNG",printText:"Print",days:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),shortDays:"Sun Mon Tue Wed Thu Fri Sat".split(" "),months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ")}},
Ja={en:{}},x=v?"Trebuchet MS, Helvetica, sans-serif":"Arial",Ea=v?"Impact, Charcoal, sans-serif":"Arial",za={colorSet1:"#4F81BC #C0504E #9BBB58 #23BFAA #8064A1 #4AACC5 #F79647 #7F6084 #77A033 #33558B #E59566".split(" "),colorSet2:"#6D78AD #51CDA0 #DF7970 #4C9CA0 #AE7D99 #C9D45C #5592AD #DF874D #52BCA8 #8E7AA3 #E3CB64 #C77B85 #C39762 #8DD17E #B57952 #FCC26C".split(" "),colorSet3:"#8CA1BC #36845C #017E82 #8CB9D0 #708C98 #94838D #F08891 #0366A7 #008276 #EE7757 #E5BA3A #F2990B #03557B #782970".split(" ")},
J,fa,T,Z,ea;fa="#333333";T="#000000";J="#666666";ea=Z="#000000";var ba=20,z=14,Sa={colorSet:"colorSet1",backgroundColor:"#FFFFFF",title:{fontFamily:Ea,fontSize:32,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5},subtitles:[{fontFamily:Ea,fontSize:z,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5}],data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:fa,indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,
titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},
scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,
labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,
labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:fa,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,
labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,
lineDashType:"solid"}}],legend:{fontFamily:x,fontSize:14,fontColor:fa,fontWeight:"bold",verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,fontStyle:"normal",cornerRadius:0,borderThickness:1}};T=fa="#F5F5F5";J="#FFFFFF";Z="#40BAF1";ea="#F5F5F5";var ba=20,z=14,Ya={colorSet:"colorSet2",title:{fontFamily:x,fontSize:33,fontColor:"#3A3A3A",fontWeight:"bold",verticalAlign:"top",margin:5},subtitles:[{fontFamily:x,fontSize:z,fontColor:"#3A3A3A",fontWeight:"normal",verticalAlign:"top",
margin:5}],data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:"#666666",indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",labelFontWeight:"normal",lineThickness:1,lineColor:"#BBBBBB",tickThickness:1,tickColor:"#BBBBBB",gridThickness:1,gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",
labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",
labelFontWeight:"normal",lineThickness:1,lineColor:"#BBBBBB",tickColor:"#BBBBBB",tickThickness:1,gridThickness:1,gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",
lineThickness:1,lineDashType:"solid"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",labelFontWeight:"normal",lineThickness:0,lineColor:"#BBBBBB",tickColor:"#BBBBBB",tickThickness:1,gridThickness:1,gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,
labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:"#666666",titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:"#666666",labelFontWeight:"normal",lineThickness:0,lineColor:"#BBBBBB",tickColor:"#BBBBBB",tickThickness:1,gridThickness:1,
gridColor:"#BBBBBB",stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FFA500",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FFA500",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#EEEEEE",labelFontWeight:"normal",labelBackgroundColor:"black",color:"black",thickness:1,lineDashType:"dot"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#BBBBBB",lineThickness:1,lineDashType:"solid"}}],legend:{fontFamily:x,fontSize:14,fontColor:"#3A3A3A",fontWeight:"bold",
verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,fontStyle:"normal",cornerRadius:0,borderThickness:1}};T=fa="#F5F5F5";J="#FFFFFF";Z="#40BAF1";ea="#F5F5F5";ba=20;z=14;Ea={colorSet:"colorSet12",backgroundColor:"#2A2A2A",title:{fontFamily:Ea,fontSize:32,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5},subtitles:[{fontFamily:Ea,fontSize:z,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5}],toolbar:{backgroundColor:"#666666",backgroundColorOnHover:"#FF7372",
borderColor:"#FF7372",borderThickness:1,fontColor:"#F5F5F5",fontColorOnHover:"#F5F5F5"},data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:T,indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,
labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,
labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,
lineDashType:"solid",color:"#111111"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",
labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",
labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],legend:{fontFamily:x,fontSize:14,fontColor:fa,fontWeight:"bold",verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,
fontStyle:"normal",cornerRadius:0,borderThickness:1,fontColor:T,backgroundColor:"rgba(0, 0, 0, .7)"}};J="#FFFFFF";T=fa="#FAFAFA";Z="#40BAF1";ea="#F5F5F5";var ba=20,z=14,xa={light1:Sa,light2:Ya,dark1:Ea,dark2:{colorSet:"colorSet2",backgroundColor:"#32373A",title:{fontFamily:x,fontSize:32,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5},subtitles:[{fontFamily:x,fontSize:z,fontColor:fa,fontWeight:"normal",verticalAlign:"top",margin:5}],toolbar:{backgroundColor:"#666666",backgroundColorOnHover:"#FF7372",
borderColor:"#FF7372",borderThickness:1,fontColor:"#F5F5F5",fontColorOnHover:"#F5F5F5"},data:[{indexLabelFontFamily:x,indexLabelFontSize:z,indexLabelFontColor:T,indexLabelFontWeight:"normal",indexLabelLineThickness:1}],axisX:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,
labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisX2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,
labelFontColor:T,labelFontWeight:"normal",lineThickness:1,lineColor:J,tickThickness:1,tickColor:J,gridThickness:0,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,
lineDashType:"solid",color:"#111111"}}],axisY:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:0,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",
labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],axisY2:[{titleFontFamily:x,titleFontSize:ba,titleFontColor:T,titleFontWeight:"normal",labelFontFamily:x,labelFontSize:z,labelFontColor:T,labelFontWeight:"normal",lineThickness:0,lineColor:J,tickThickness:1,tickColor:J,gridThickness:1,gridColor:J,stripLines:[{labelFontFamily:x,labelFontSize:z,labelFontColor:"#FF7300",
labelFontWeight:"normal",labelBackgroundColor:null,color:"#FF7300",thickness:1}],crosshair:{labelFontFamily:x,labelFontSize:z,labelFontColor:"#000000",labelFontWeight:"normal",labelBackgroundColor:ea,color:Z,thickness:1,lineDashType:"dash"},scaleBreaks:{type:"zigzag",spacing:"2%",lineColor:"#777777",lineThickness:1,lineDashType:"solid",color:"#111111"}}],legend:{fontFamily:x,fontSize:14,fontColor:fa,fontWeight:"bold",verticalAlign:"bottom",horizontalAlign:"center"},toolTip:{fontFamily:x,fontSize:14,
fontStyle:"normal",cornerRadius:0,borderThickness:1,fontColor:T,backgroundColor:"rgba(0, 0, 0, .7)"}},theme1:Sa,theme2:Ya,theme3:Sa},U={numberDuration:1,yearDuration:314496E5,monthDuration:2592E6,weekDuration:6048E5,dayDuration:864E5,hourDuration:36E5,minuteDuration:6E4,secondDuration:1E3,millisecondDuration:1,dayOfWeekFromInt:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" ")};(function(){W.fSDec=function(m){for(var s="",q=0;q<m.length;q++)s+=String.fromCharCode(Math.ceil(m.length/
57/5)^m.charCodeAt(q));return s};W.obj={trVs:"Ush`m!Wdsrhno",fntStr:"qy!B`mhcsh-!Mtbhe`!Fs`oed-!Mtbhe`!R`or!Tohbned-!@sh`m-!r`or,rdshg",txtBl:"udyuC`rdmhod",fnt:"gnou",fSy:"ghmmRuxmd",fTx:"ghmmUdyu",grClr:"fsdx",cntx:"buy",tp:"unq"};delete qa[W.fSDec("Bi`su")][W.fSDec("bsdehuIsdg")];W.pro={sCH:qa[W.fSDec("Bi`su")][W.fSDec("bsdehuIsdg")]};W._fTWm=function(m){if("undefined"===typeof W.pro.sCH&&!Za)try{var s=m[W.fSDec(W.obj.cntx)];s[W.fSDec(W.obj.txtBl)]=W.fSDec(W.obj.tp);s[W.fSDec(W.obj.fnt)]=11+W.fSDec(W.obj.fntStr);
s[W.fSDec(W.obj.fSy)]=W.fSDec(W.obj.grClr);s[W.fSDec(W.obj.fTx)](W.fSDec(W.obj.trVs),2,m.height-11-2)}catch(q){}}})();var Va={},pa=null,Aa=function(){var m=/D{1,4}|M{1,4}|Y{1,4}|h{1,2}|H{1,2}|m{1,2}|s{1,2}|f{1,3}|t{1,2}|T{1,2}|K|z{1,3}|"[^"]*"|'[^']*'/g,s="Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),q="Sun Mon Tue Wed Thu Fri Sat".split(" "),v="January February March April May June July August September October November December".split(" "),y="Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
x=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,z=/[^-+\dA-Z]/g;return function(S,C,I){var F=I?I.days:s,J=I?I.months:v,R=I?I.shortDays:q,P=I?I.shortMonths:y;I="";var U=!1;S=S&&S.getTime?S:S?new Date(S):new Date;if(isNaN(S))throw SyntaxError("invalid date");"UTC:"===C.slice(0,4)&&(C=C.slice(4),U=!0);I=U?"getUTC":"get";var W=S[I+"Date"](),X=S[I+"Day"](),Y=S[I+"Month"](),T=S[I+"FullYear"](),O=S[I+"Hours"](),V=S[I+
"Minutes"](),a=S[I+"Seconds"](),f=S[I+"Milliseconds"](),b=U?0:S.getTimezoneOffset();return I=C.replace(m,function(c){switch(c){case "D":return W;case "DD":return ha(W,2);case "DDD":return R[X];case "DDDD":return F[X];case "M":return Y+1;case "MM":return ha(Y+1,2);case "MMM":return P[Y];case "MMMM":return J[Y];case "Y":return parseInt(String(T).slice(-2));case "YY":return ha(String(T).slice(-2),2);case "YYY":return ha(String(T).slice(-3),3);case "YYYY":return ha(T,4);case "h":return O%12||12;case "hh":return ha(O%
12||12,2);case "H":return O;case "HH":return ha(O,2);case "m":return V;case "mm":return ha(V,2);case "s":return a;case "ss":return ha(a,2);case "f":return String(f).slice(0,1);case "ff":return ha(String(f).slice(0,2),2);case "fff":return ha(String(f).slice(0,3),3);case "t":return 12>O?"a":"p";case "tt":return 12>O?"am":"pm";case "T":return 12>O?"A":"P";case "TT":return 12>O?"AM":"PM";case "K":return U?"UTC":(String(S).match(x)||[""]).pop().replace(z,"");case "z":return(0<b?"-":"+")+Math.floor(Math.abs(b)/
60);case "zz":return(0<b?"-":"+")+ha(Math.floor(Math.abs(b)/60),2);case "zzz":return(0<b?"-":"+")+ha(Math.floor(Math.abs(b)/60),2)+ha(Math.abs(b)%60,2);default:return c.slice(1,c.length-1)}})}}(),V=function(m,s,q){if(null===m)return"";if(!isFinite(m))return m;m=Number(m);var v=0>m?!0:!1;v&&(m*=-1);var y=q?q.decimalSeparator:".",x=q?q.digitGroupSeparator:",",z="";s=String(s);var z=1,S=q="",C=-1,I=[],F=[],J=0,R=0,U=0,P=!1,W=0,S=s.match(/"[^"]*"|'[^']*'|[eE][+-]*[0]+|[,]+[.]|\u2030|./g);s=null;for(var X=
0;S&&X<S.length;X++)if(s=S[X],"."===s&&0>C)C=X;else{if("%"===s)z*=100;else if("\u2030"===s){z*=1E3;continue}else if(","===s[0]&&"."===s[s.length-1]){z/=Math.pow(1E3,s.length-1);C=X+s.length-1;continue}else"E"!==s[0]&&"e"!==s[0]||"0"!==s[s.length-1]||(P=!0);0>C?(I.push(s),"#"===s||"0"===s?J++:","===s&&U++):(F.push(s),"#"!==s&&"0"!==s||R++)}P&&(s=Math.floor(m),S=-Math.floor(Math.log(m)/Math.LN10+1),W=0===m?0:0===s?-(J+S):String(s).length-J,z/=Math.pow(10,W));0>C&&(C=X);z=(m*z).toFixed(R);s=z.split(".");
z=(s[0]+"").split("");m=(s[1]+"").split("");z&&"0"===z[0]&&z.shift();for(P=S=X=R=C=0;0<I.length;)if(s=I.pop(),"#"===s||"0"===s)if(C++,C===J){var Y=z,z=[];if("0"===s)for(s=J-R-(Y?Y.length:0);0<s;)Y.unshift("0"),s--;for(;0<Y.length;)q=Y.pop()+q,P++,0===P%S&&(X===U&&0<Y.length)&&(q=x+q)}else 0<z.length?(q=z.pop()+q,R++,P++):"0"===s&&(q="0"+q,R++,P++),0===P%S&&(X===U&&0<z.length)&&(q=x+q);else"E"!==s[0]&&"e"!==s[0]||"0"!==s[s.length-1]||!/[eE][+-]*[0]+/.test(s)?","===s?(X++,S=P,P=0,0<z.length&&(q=x+q)):
q=1<s.length&&('"'===s[0]&&'"'===s[s.length-1]||"'"===s[0]&&"'"===s[s.length-1])?s.slice(1,s.length-1)+q:s+q:(s=0>W?s.replace("+","").replace("-",""):s.replace("-",""),q+=s.replace(/[0]+/,function(m){return ha(W,m.length)}));x="";for(I=!1;0<F.length;)s=F.shift(),"#"===s||"0"===s?0<m.length&&0!==Number(m.join(""))?(x+=m.shift(),I=!0):"0"===s&&(x+="0",I=!0):1<s.length&&('"'===s[0]&&'"'===s[s.length-1]||"'"===s[0]&&"'"===s[s.length-1])?x+=s.slice(1,s.length-1):"E"!==s[0]&&"e"!==s[0]||"0"!==s[s.length-
1]||!/[eE][+-]*[0]+/.test(s)?x+=s:(s=0>W?s.replace("+","").replace("-",""):s.replace("-",""),x+=s.replace(/[0]+/,function(m){return ha(W,m.length)}));q+=(I?y:"")+x;return v?"-"+q:q},Oa=function(m){var s=0,q=0;m=m||window.event;m.offsetX||0===m.offsetX?(s=m.offsetX,q=m.offsetY):m.layerX||0==m.layerX?(s=m.layerX,q=m.layerY):(s=m.pageX-m.target.offsetLeft,q=m.pageY-m.target.offsetTop);return{x:s,y:q}},Xa=!0,Qa=window.devicePixelRatio||1,La=1,ia=Xa?Qa/La:1,ga=function(m){for(var s="",q=0;q<m.length;q++)s+=
String.fromCharCode(Math.ceil(m.length/57/5)^m.charCodeAt(q));return s},Za=true/*,Za=window&&window[ga("mnb`uhno")]&&window[ga("mnb`uhno")].href&&window[ga("mnb`uhno")].href.indexOf&&(-1!==window[ga("mnb`uhno")].href.indexOf(ga("b`ow`rkr/bnl"))||-1!==window[ga("mnb`uhno")].href.indexOf(ga("gdonqhy/bnl"))||-1!==window[ga("mnb`uhno")].href.indexOf(ga("gheemd")))*/,db=Za&&-1===window[ga("mnb`uhno")].href.indexOf(ga("gheemd")),eb={reset:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAPjSURBVFhHxVdJaFNRFP1J/jwkP5MxsbaC1WJEglSxOFAXIsFpVRE3ggi1K90obioRRBA33XXnQnciirhQcMCdorgQxBkXWlREkFKsWkv5npvckp/XnzRpKh64kLw733fffe9L/wrL0+mVUdO8uTSZ3MBL/we2qg4rkuSpodCELstXE46ziVkLQ6FQcGOmeSSq6wd4aV50d3drWjj8kQKZJTUc9kxFGenv79dZrDksTSTWWJp2QYtEPiErysyzdX0LsxsCQR8keX8gs6RHIk8ysdgKFg2G53mhuOPsshTlBjKaFo1g7SqLNoShKLdFXT8huQ/paLSbxatYnc2mHMM4hr18Vi8TIvCmXF3vYrW6cF23gGTOk0M1wA4RKvOmq6vLZRVJipvmSWT6tZ6CSEYkco5V50VPT4+D7RwOqi6RiSZm0fJ+vggSqkeoypdsNmuyelNwbXsbgvkWYMtzDWNvWaijoyOBqE+hVK8abcssUeXQ/YfKyi0gFYv1Ipgfoj34fYGTJLOYJA0ODirok32GLN8XhUWCwSes1hIwBg6LydJ/tEeRRapAdUp+wSAiZchtZZWWgAZ+JNpD8peYXQVK9UwUxNpzOK8pq97kURZhYTCKBwPD7h2zK+js7Myi7D8Fod+0TkMI8+EMAngLGc/WtBFWawkFHFnoj/t9KLgGmF0B3QfkxC+EarxkdhnFYlFLY06USqUwL7UMjICHfh/wOc2sCqhpxGbCkLvL7EUDbF73+6DkmVWB6zi7xUDQSLeYvWjAILvm9zEnkJhlbRcDQZcv6Kg2AipyT/Axw6wKlqVSqxDdjF8Izfod13qURdrG/nxehY+xGh+h0CSzKygGvSNQIcc097BI24jb9hax6kj2E7OrMFX1il+ICEf2NrPbhiXLl+fYl+U7zK4iYdsDcyLGf+ofFlkwcN+s10KhmpuYhhtm0hCLVIFL0MDsqNlDIqy9x2CLs1jL6OvrI7vPRbtohXG6eFmsFnHDGAp6n9AgyuVySRZrGvROxRgIfLXhzjrNYnNBUxNX/dMgRWT1mt4XLDovaApD53E9W3ilNX5M55LJHpRtIsgAvciR4WWcgK2Dvb1YqgXevmF8z2zEBTcKG39EfSKsT9EbhVUaI2FZO+oZIqImxol6j66/hcAu4sSN4vc1ZPoKeoE6RGhYL2YYA+ymOSSi0Z0wWntbtkGUWCvfSDXIxONraZ/FY90KUfNTpfC5spnNLgxoYNnR9RO4F8ofXEHOgogCQE99w+fF2Xw+b7O59rEOsyRqGEfpVoaDMQQ1CZrG46bcM6AZ0C/wPqNfHliqejyTySxh9TqQpL+xmbIlkB9SlAAAAABJRU5ErkJggg=="},
pan:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAICSURBVEhLxZbPahNRGMUn/5MpuAiBEAIufQGfzr5E40YptBXajYzudCEuGqS+gGlrFwquDGRTutBdYfydzJ3LzeQmJGZue+Dw/Z17Mnfmu5Pof9Hr9Z61Wq0bWZMKj263O6xWq99wU9lOpzPMKgEhEcRucNOcioOK+0RzBhNvt9tPV4nmVF19+OWhVqt9xXgFXZq+8lCv119UKpUJ7iX2FmvFTKz8RH34YdBsNk8wVtjE4fGYwm8wrrDi3WBG5oKXZGRSS9hGuNFojLTe2lFz5xThWZIktayyiE2FdT3rzXBXz7krKiL8c17wAKFDjCus2AvW+YGZ9y2JF0VFRuMPfI//rsCE/C+s26s4gQu9ul7r4NteKx7H8XOC724xNNGbaNu++IrBqbOV7Tj3FgMRvc/YKOr3+3sE47wgEt/Bl/gaK5cHbNU11vYSXylfpK7XOvjuumPp4Wcoipu30Qsez2uMXYz4lfI+mOmwothY+SLiXJy7mKVpWs3Si0CoOMfeI9Od43Wic+jO+ZVv+crsm9QSNhUW9LXSeoPBYLXopthGuFQgdIxxhY+UDwlt1x5CZ1hX+NTUdt/OIvjKaDSmuOJfaIVNPKX+W18j/PLA2/kR44p5Sd8HbHngT/yTfNRWUXX14ZcL3wmX0+TLf8YO7CGT8yFE5zB3/gney25/OETRP9CtPDFe5jShAAAAAElFTkSuQmCC"},
zoom:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAALWSURBVEhLvZZLaBNRFIabyftBIgEfqCCBoCC6MYqiXYiIj4U76U4X7sUHbhQhUBfixhZEUBDB16YuFERaUaQLK7ooCOJj4UKtYEFU0EptShO/A9Ph3js3k8lo/eHnP7n3nP/M3LlzMz1hkUwmNziOcyKRSFyFt+LxeD/c2Wq1Ym7Kv0M2m11Os1OxWGycn1OwZXCGuXfwIhezkd9/jRgNT2L4ldhs1pbkX5OLJe4euVxuGQaPCa3mnUjtJx7BDuKusJTCV6jVVGHTMuYRjxma7yIOhTgFY6jNaAKew2xPKpVay9ganmkvj+M448/MfJdT5K5Gg4HJacRngPFgqVRaRNwW1B4i7yehWfsEDdz1K+A01AoxPIqGAiuwGfkOTY8+1A6u7AyiFTB2Hu0KPIrdiOnzHLWDybeImvy+Wq2mZa5bUHsD0Zpz+KxHdWQymV6kAb1ElqeORgJLvgnRdj1+R1AfzkIvSUjxVjQSarVakrueIPT8+H1F5jSUy+WXiJrUYBVWyVxU4PEU8TzhfaijUqnMIWrjaY492eWRwdKOIqrnIxnXwLLeRLwk2GQzrEMjg0avEbXxkIxr4OoOImpj2QwyFgms1koa/SZUG8s+0iGnEhNfCNXEhzIXBVz0McTzEvJ+70P9oNFtxEzei3aFYrFYxmuSUPWSv9Yi9IMm2xE1We56Mp1OV4nDwqFmBDV9gk9AEh4gZtFHNt8W4kAUCoXF5MorY9Z/kDni9nDv7hc0i2fhgLvTtX8a99PoMPPagTFPxofRzmDJ9yM+AyEmTfgGysYbQcfhDzPPJDmX0c7gDg4gs9BqFIWhm/Nct5H8gtBq1I7UfIbtvmIuoaGQcp+fdpbbSM43eEH5wrwLbXmhm/fU63VHXjcuok7hEByFY/AeHGC8L5/PL3HT5xGH1uYwfPOICGo+CBcU0vwO1BqzUqILDl/z/9VYIMfpddiAc47jDP8BsUpb13wOLRwAAAAASUVORK5CYII="},
menu:{image:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAeCAYAAABE4bxTAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADoSURBVFhH7dc9CsJAFATgRxIIBCwCqZKATX5sbawsY2MvWOtF9AB6AU8gguAJbD2AnZ2VXQT/Ko2TYGCL2OYtYQc+BuYA+1hCtnCVwMm27SGaXpDJIAiCvCkVR05hGOZNN3HkFMdx3nQRR06+76/R1IcFLJlNQEWlmWlBTwJtKLKHynehZqnjOGM0PYWRVXk61C37p7xlZ3Hk5HneCk1dmMH811xGoKLSzDiQwIBZB4ocoPJdqNkDt2yKlueWRVGUtzy3rPwo3sWRU3nLjuLI6OO67oZM00wMw3hrmpZx0XU9syxrR0T0BeMpb9dneSR2AAAAAElFTkSuQmCC"}};
Y.prototype.setOptions=function(m,s){if(qa[this._defaultsKey]){var q=qa[this._defaultsKey],v;for(v in q)"publicProperties"!==v&&q.hasOwnProperty(v)&&(this[v]=m&&v in m?m[v]:s&&v in s?s[v]:q[v])}};Y.prototype.get=function(m){var s=qa[this._defaultsKey];if("options"===m)return this.options&&this.options._isPlaceholder?null:this.options;if(s.hasOwnProperty(m)||s.publicProperties&&s.publicProperties.hasOwnProperty(m))return this[m];window.console&&window.console.log('Property "'+m+"\" doesn't exist. Please check for typo.")};
Y.prototype.set=function(m,s,q){q="undefined"===typeof q?!0:q;var v=qa[this._defaultsKey];if("options"===m)this.createUserOptions(s);else if(v.hasOwnProperty(m)||v.publicProperties&&v.publicProperties.hasOwnProperty(m)&&"readWrite"===v.publicProperties[m])this.options._isPlaceholder&&this.createUserOptions(),this.options[m]=s;else{window.console&&(v.publicProperties&&v.publicProperties.hasOwnProperty(m)&&"readOnly"===v.publicProperties[m]?window.console.log('Property "'+m+'" is read-only.'):window.console.log('Property "'+
m+"\" doesn't exist. Please check for typo."));return}q&&(this.chart||this).render()};Y.prototype.addTo=function(m,s,q,v){v="undefined"===typeof v?!0:v;var y=qa[this._defaultsKey];y.hasOwnProperty(m)||y.publicProperties&&y.publicProperties.hasOwnProperty(m)&&"readWrite"===y.publicProperties[m]?(this.options._isPlaceholder&&this.createUserOptions(),"undefined"===typeof this.options[m]&&(this.options[m]=[]),m=this.options[m],q="undefined"===typeof q||null===q?m.length:q,m.splice(q,0,s),v&&(this.chart||
this).render()):window.console&&(y.publicProperties&&y.publicProperties.hasOwnProperty(m)&&"readOnly"===y.publicProperties[m]?window.console.log('Property "'+m+'" is read-only.'):window.console.log('Property "'+m+"\" doesn't exist. Please check for typo."))};Y.prototype.createUserOptions=function(m){if("undefined"!==typeof m||this.options._isPlaceholder)if(this.parent.options._isPlaceholder&&this.parent.createUserOptions(),this.isOptionsInArray){this.parent.options[this.optionsName]||(this.parent.options[this.optionsName]=
[]);var s=this.parent.options[this.optionsName],v=s.length;this.options._isPlaceholder||(Ca(s),v=s.indexOf(this.options));this.options="undefined"===typeof m?{}:m;s[v]=this.options}else this.options="undefined"===typeof m?{}:m,m=this.parent.options,this.optionsName?s=this.optionsName:(s=this._defaultsKey)&&0!==s.length?(v=s.charAt(0).toLowerCase(),1<s.length&&(v=v.concat(s.slice(1))),s=v):s=void 0,m[s]=this.options};Y.prototype.remove=function(m){m="undefined"===typeof m?!0:m;if(this.isOptionsInArray){var s=
this.parent.options[this.optionsName];Ca(s);var v=s.indexOf(this.options);0<=v&&s.splice(v,1)}else delete this.parent.options[this.optionsName];m&&(this.chart||this).render()};Y.prototype.updateOption=function(m){var s=qa[this._defaultsKey],v={},x=this[m],z=this._themeOptionsKey,F=this._index;this.theme&&y(z)&&y(F)?v=y(xa[this.theme])?xa.light1:xa[this.theme]:this.parent&&(this.parent.themeOptions&&this.parent.themeOptions[z])&&(null===F?v=this.parent.themeOptions[z]:0<this.parent.themeOptions[z].length&&
(v=Math.min(this.parent.themeOptions[z].length-1,F),v=this.parent.themeOptions[z][v]));this.themeOptions=v;m in s&&(x=m in this.options?this.options[m]:v&&m in v?v[m]:s[m]);if(x===this[m])return!1;this[m]=x;return!0};Y.prototype.trackChanges=function(m){if(!this.sessionVariables)throw"Session Variable Store not set";this.sessionVariables[m]=this.options[m]};Y.prototype.isBeingTracked=function(m){this.options._oldOptions||(this.options._oldOptions={});return this.options._oldOptions[m]?!0:!1};Y.prototype.hasOptionChanged=
function(m){if(!this.sessionVariables)throw"Session Variable Store not set";return this.sessionVariables[m]!==this.options[m]};Y.prototype.addEventListener=function(m,s,v){m&&s&&(this._eventListeners[m]=this._eventListeners[m]||[],this._eventListeners[m].push({context:v||this,eventHandler:s}))};Y.prototype.removeEventListener=function(m,v){if(m&&v&&this._eventListeners[m])for(var q=this._eventListeners[m],y=0;y<q.length;y++)if(q[y].eventHandler===v){q[y].splice(y,1);break}};Y.prototype.removeAllEventListeners=
function(){this._eventListeners=[]};Y.prototype.dispatchEvent=function(m,v,q){if(m&&this._eventListeners[m]){v=v||{};for(var y=this._eventListeners[m],x=0;x<y.length;x++)y[x].eventHandler.call(y[x].context,v)}"function"===typeof this[m]&&this[m].call(q||this.chart,v)};Da.prototype.registerSpace=function(m,v){"top"===m?this._topOccupied+=v.height:"bottom"===m?this._bottomOccupied+=v.height:"left"===m?this._leftOccupied+=v.width:"right"===m&&(this._rightOccupied+=v.width)};Da.prototype.unRegisterSpace=
function(m,v){"top"===m?this._topOccupied-=v.height:"bottom"===m?this._bottomOccupied-=v.height:"left"===m?this._leftOccupied-=v.width:"right"===m&&(this._rightOccupied-=v.width)};Da.prototype.getFreeSpace=function(){return{x1:this._x1+this._leftOccupied,y1:this._y1+this._topOccupied,x2:this._x2-this._rightOccupied,y2:this._y2-this._bottomOccupied,width:this._x2-this._x1-this._rightOccupied-this._leftOccupied,height:this._y2-this._y1-this._bottomOccupied-this._topOccupied}};Da.prototype.reset=function(){this._rightOccupied=
this._leftOccupied=this._bottomOccupied=this._topOccupied=this._padding};na(ka,Y);ka.prototype._initialize=function(){y(this.padding)||"object"!==typeof this.padding?this.topPadding=this.rightPadding=this.bottomPadding=this.leftPadding=Number(this.padding)|0:(this.topPadding=y(this.padding.top)?0:Number(this.padding.top)|0,this.rightPadding=y(this.padding.right)?0:Number(this.padding.right)|0,this.bottomPadding=y(this.padding.bottom)?0:Number(this.padding.bottom)|0,this.leftPadding=y(this.padding.left)?
0:Number(this.padding.left)|0)};ka.prototype.render=function(m){if(0!==this.fontSize){m&&this.ctx.save();var v=this.ctx.font;this.ctx.textBaseline=this.textBaseline;var q=0;this._isDirty&&this.measureText(this.ctx);this.ctx.translate(this.x,this.y+q);"middle"===this.textBaseline&&(q=-this._lineHeight/2);this.ctx.font=this._getFontString();this.ctx.rotate(Math.PI/180*this.angle);var y=0,x=this.topPadding,z=null;this.ctx.roundRect||Ba(this.ctx);(0<this.borderThickness&&this.borderColor||this.backgroundColor)&&
this.ctx.roundRect(0,q,this.width,this.height,this.cornerRadius,this.borderThickness,this.backgroundColor,this.borderColor);this.ctx.fillStyle=this.fontColor;for(q=0;q<this._wrappedText.lines.length;q++)z=this._wrappedText.lines[q],"right"===this.horizontalAlign?y=(this.width-(this.leftPadding+this.rightPadding))/2-z.width/2+this.leftPadding:"left"===this.horizontalAlign?y=this.leftPadding:"center"===this.horizontalAlign&&(y=(this.width-(this.leftPadding+this.rightPadding))/2-z.width/2+this.leftPadding),
this.ctx.fillText(z.text,y,x),x+=z.height;this.ctx.font=v;m&&this.ctx.restore()}};ka.prototype.setText=function(m){this.text=m;this._isDirty=!0;this._wrappedText=null};ka.prototype.measureText=function(){this._lineHeight=Ua(this.fontFamily,this.fontSize,this.fontWeight);if(null===this.maxWidth)throw"Please set maxWidth and height for TextBlock";this._wrapText(this.ctx);this._isDirty=!1;return{width:this.width,height:this.height}};ka.prototype._getLineWithWidth=function(m,v,q){m=String(m);if(!m)return{text:"",
width:0};var y=q=0,x=m.length-1,z=Infinity;for(this.ctx.font=this._getFontString();y<=x;){var z=Math.floor((y+x)/2),F=m.substr(0,z+1);q=this.ctx.measureText(F).width;if(q<v)y=z+1;else if(q>v)x=z-1;else break}q>v&&1<F.length&&(F=F.substr(0,F.length-1),q=this.ctx.measureText(F).width);v=!0;if(F.length===m.length||" "===m[F.length])v=!1;v&&(m=F.split(" "),1<m.length&&m.pop(),F=m.join(" "),q=this.ctx.measureText(F).width);return{text:F,width:q}};ka.prototype._wrapText=function(){var m=new String(Fa(String(this.text))),
v=[],q=this.ctx.font,y=0,x=0;this.ctx.font=this._getFontString();if(0===this.frontSize)x=y=0;else for(;0<m.length;){var z=this.maxHeight-(this.topPadding+this.bottomPadding),F=this._getLineWithWidth(m,this.maxWidth-(this.leftPadding+this.rightPadding),!1);F.height=this._lineHeight;v.push(F);var S=x,x=Math.max(x,F.width),y=y+F.height,m=Fa(m.slice(F.text.length,m.length));z&&y>z&&(F=v.pop(),y-=F.height,x=S)}this._wrappedText={lines:v,width:x,height:y};this.width=x+(this.leftPadding+this.rightPadding);
this.height=y+(this.topPadding+this.bottomPadding);this.ctx.font=q};ka.prototype._getFontString=function(){var m;m=""+(this.fontStyle?this.fontStyle+" ":"");m+=this.fontWeight?this.fontWeight+" ":"";m+=this.fontSize?this.fontSize+"px ":"";var s=this.fontFamily?this.fontFamily+"":"";!v&&s&&(s=s.split(",")[0],"'"!==s[0]&&'"'!==s[0]&&(s="'"+s+"'"));return m+=s};na(Ra,Y);na(Ha,Y);Ha.prototype.render=function(){if(this.text){var m=this.dockInsidePlotArea?this.chart.plotArea:this.chart,v=m.layoutManager.getFreeSpace(),
q=v.x1,x=v.y1,z=0,F=0,R=this.chart._menuButton&&this.chart.exportEnabled&&"top"===this.verticalAlign?22:0,S,C;"top"===this.verticalAlign||"bottom"===this.verticalAlign?(null===this.maxWidth&&(this.maxWidth=v.width-4-R*("center"===this.horizontalAlign?2:1)),F=0.5*v.height-this.margin-2,z=0):"center"===this.verticalAlign&&("left"===this.horizontalAlign||"right"===this.horizontalAlign?(null===this.maxWidth&&(this.maxWidth=v.height-4),F=0.5*v.width-this.margin-2):"center"===this.horizontalAlign&&(null===
this.maxWidth&&(this.maxWidth=v.width-4),F=0.5*v.height-4));var I;y(this.padding)||"number"!==typeof this.padding?y(this.padding)||"object"!==typeof this.padding||(I=this.padding.top?this.padding.top:this.padding.bottom?this.padding.bottom:0,I+=this.padding.bottom?this.padding.bottom:this.padding.top?this.padding.top:0,I*=1.25):I=2.5*this.padding;this.wrap||(F=Math.min(F,Math.max(1.5*this.fontSize,this.fontSize+I)));F=new ka(this.ctx,{fontSize:this.fontSize,fontFamily:this.fontFamily,fontColor:this.fontColor,
fontStyle:this.fontStyle,fontWeight:this.fontWeight,horizontalAlign:this.horizontalAlign,verticalAlign:this.verticalAlign,borderColor:this.borderColor,borderThickness:this.borderThickness,backgroundColor:this.backgroundColor,maxWidth:this.maxWidth,maxHeight:F,cornerRadius:this.cornerRadius,text:this.text,padding:this.padding,textBaseline:"top"});I=F.measureText();"top"===this.verticalAlign||"bottom"===this.verticalAlign?("top"===this.verticalAlign?(x=v.y1+2,C="top"):"bottom"===this.verticalAlign&&
(x=v.y2-2-I.height,C="bottom"),"left"===this.horizontalAlign?q=v.x1+2:"center"===this.horizontalAlign?q=v.x1+v.width/2-I.width/2:"right"===this.horizontalAlign&&(q=v.x2-2-I.width-R),S=this.horizontalAlign,this.width=I.width,this.height=I.height):"center"===this.verticalAlign&&("left"===this.horizontalAlign?(q=v.x1+2,x=v.y2-2-(this.maxWidth/2-I.width/2),z=-90,C="left",this.width=I.height,this.height=I.width):"right"===this.horizontalAlign?(q=v.x2-2,x=v.y1+2+(this.maxWidth/2-I.width/2),z=90,C="right",
this.width=I.height,this.height=I.width):"center"===this.horizontalAlign&&(x=m.y1+(m.height/2-I.height/2),q=m.x1+(m.width/2-I.width/2),C="center",this.width=I.width,this.height=I.height),S="center");F.x=q;F.y=x;F.angle=z;F.horizontalAlign=S;F.render(!0);m.layoutManager.registerSpace(C,{width:this.width+("left"===C||"right"===C?this.margin+2:0),height:this.height+("top"===C||"bottom"===C?this.margin+2:0)});this.bounds={x1:q,y1:x,x2:q+this.width,y2:x+this.height};this.ctx.textBaseline="top"}};na(Na,
Y);Na.prototype.render=Ha.prototype.render;na(Ia,Y);var Ka={addTheme:function(m,v){xa[m]=v},addColorSet:function(m,v){za[m]=v},addCultureInfo:function(m,v){Ja[m]=v},formatNumber:function(m,v,q){q=q||"en";if(Ja[q])return V(m,v||"#,##0.##",new Ia(q));throw"Unknown Culture Name";},formatDate:function(m,v,q){q=q||"en";if(Ja[q])return Aa(m,v||"DD MMM YYYY",new Ia(q));throw"Unknown Culture Name";}};"undefined"!==typeof module&&"undefined"!==typeof module.exports?module.exports=Ka:"function"===typeof define&&
define.amd?define([],function(){return Ka}):window.CanvasJS=Ka;Ka.Chart=function(){function m(a,f){return a.x-f.x}function s(a,f,b){if(a&&f&&b){b=b+"."+f;var c="image/"+f;a=a.toDataURL(c);var e=!1,g=document.createElement("a");g.download=b;g.href=a;if("undefined"!==typeof Blob&&new Blob){for(var h=a.replace(/^data:[a-z\/]*;base64,/,""),h=atob(h),l=new ArrayBuffer(h.length),l=new Uint8Array(l),t=0;t<h.length;t++)l[t]=h.charCodeAt(t);f=new Blob([l.buffer],{type:"image/"+f});try{window.navigator.msSaveBlob(f,
b),e=!0}catch(k){g.dataset.downloadurl=[c,g.download,g.href].join(":"),g.href=window.URL.createObjectURL(f)}}if(!e)try{event=document.createEvent("MouseEvents"),event.initMouseEvent("click",!0,!1,window,0,0,0,0,0,!1,!1,!1,!1,0,null),g.dispatchEvent?g.dispatchEvent(event):g.fireEvent&&g.fireEvent("onclick")}catch(r){f=window.open(),f.document.write("<img src='"+a+"'></img><div>Please right click on the image and save it to your device</div>"),f.document.close()}}}function q(a,f){f=f||{};this.theme=
y(f.theme)||y(xa[f.theme])?"light1":f.theme;q.base.constructor.call(this,"Chart",null,f,null,null);var b=this;this._containerId=a;this._objectsInitialized=!1;this.overlaidCanvasCtx=this.ctx=null;this._indexLabels=[];this._panTimerId=0;this._lastTouchEventType="";this._lastTouchData=null;this.isAnimating=!1;this.renderCount=0;this.disableToolTip=this.animatedRender=!1;this.allDOMEventHandlers=[];this.panEnabled=!1;this._defaultCursor="default";this.plotArea={canvas:null,ctx:null,x1:0,y1:0,x2:0,y2:0,
width:0,height:0};this._dataInRenderedOrder=[];if(this.container="string"===typeof this._containerId?document.getElementById(this._containerId):this._containerId){this.container.innerHTML="";var c=0,e=0,c=this.options.width?this.width:0<this.container.clientWidth?this.container.clientWidth:this.width,e=this.options.height?this.height:0<this.container.clientHeight?this.container.clientHeight:this.height;this.width=c;this.height=e;this.x1=this.y1=0;this.x2=this.width;this.y2=this.height;this._selectedColorSet=
"undefined"!==typeof za[this.colorSet]?za[this.colorSet]:za.colorSet1;this._canvasJSContainer=document.createElement("div");this._canvasJSContainer.setAttribute("class","canvasjs-chart-container");this._canvasJSContainer.style.position="relative";this._canvasJSContainer.style.textAlign="left";this._canvasJSContainer.style.cursor="auto";v||(this._canvasJSContainer.style.height="0px");this.container.appendChild(this._canvasJSContainer);this.canvas=ta(c,e);this._preRenderCanvas=ta(c,e);this.canvas.style.position=
"absolute";this.canvas.getContext&&(this._canvasJSContainer.appendChild(this.canvas),this.ctx=this.canvas.getContext("2d"),this.ctx.textBaseline="top",Ba(this.ctx),this._preRenderCtx=this._preRenderCanvas.getContext("2d"),this._preRenderCtx.textBaseline="top",Ba(this._preRenderCtx),v?this.plotArea.ctx=this.ctx:(this.plotArea.canvas=ta(c,e),this.plotArea.canvas.style.position="absolute",this.plotArea.canvas.setAttribute("class","plotAreaCanvas"),this._canvasJSContainer.appendChild(this.plotArea.canvas),
this.plotArea.ctx=this.plotArea.canvas.getContext("2d")),this.overlaidCanvas=ta(c,e),this.overlaidCanvas.style.position="absolute",this.overlaidCanvas.style.webkitTapHighlightColor="transparent",this.overlaidCanvas.getContext&&(this._canvasJSContainer.appendChild(this.overlaidCanvas),this.overlaidCanvasCtx=this.overlaidCanvas.getContext("2d"),this.overlaidCanvasCtx.textBaseline="top",Ba(this.overlaidCanvasCtx)),this._eventManager=new ea(this),this.windowResizeHandler=P(window,"resize",function(){b._updateSize()&&
b.render()},this.allDOMEventHandlers),this._toolBar=document.createElement("div"),this._toolBar.setAttribute("class","canvasjs-chart-toolbar"),this._toolBar.style.cssText="position: absolute; right: 1px; top: 1px;",this._canvasJSContainer.appendChild(this._toolBar),this.bounds={x1:0,y1:0,x2:this.width,y2:this.height},P(this.overlaidCanvas,"click",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,"mousemove",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),
P(this.overlaidCanvas,"mouseup",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,"mousedown",function(a){b._mouseEventHandler(a);va(b._dropdownMenu)},this.allDOMEventHandlers),P(this.overlaidCanvas,"mouseout",function(a){b._mouseEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?"MSPointerDown":"touchstart",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?
"MSPointerMove":"touchmove",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?"MSPointerUp":"touchend",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),P(this.overlaidCanvas,window.navigator.msPointerEnabled?"MSPointerCancel":"touchcancel",function(a){b._touchEventHandler(a)},this.allDOMEventHandlers),this.toolTip=new Z(this,this.options.toolTip),this.data=null,this.axisX=[],this.axisX2=[],this.axisY=[],this.axisY2=
[],this.sessionVariables={axisX:[],axisX2:[],axisY:[],axisY2:[]})}else window.console&&window.console.log('CanvasJS Error: Chart Container with id "'+this._containerId+'" was not found')}function x(a,f){for(var b=[],c,e=0;e<a.length;e++)if(0==e)b.push(a[0]);else{var g,h,l;l=e-1;g=0===l?0:l-1;h=l===a.length-1?l:l+1;c=Math.abs((a[h].x-a[g].x)/(0===a[h].x-a[l].x?0.01:a[h].x-a[l].x))*(f-1)/2+1;var t=(a[h].x-a[g].x)/c;c=(a[h].y-a[g].y)/c;b[b.length]=a[l].x>a[g].x&&0<t||a[l].x<a[g].x&&0>t?{x:a[l].x+t/3,
y:a[l].y+c/3}:{x:a[l].x,y:a[l].y+c/9};l=e;g=0===l?0:l-1;h=l===a.length-1?l:l+1;c=Math.abs((a[h].x-a[g].x)/(0===a[l].x-a[g].x?0.01:a[l].x-a[g].x))*(f-1)/2+1;t=(a[h].x-a[g].x)/c;c=(a[h].y-a[g].y)/c;b[b.length]=a[l].x>a[g].x&&0<t||a[l].x<a[g].x&&0>t?{x:a[l].x-t/3,y:a[l].y-c/3}:{x:a[l].x,y:a[l].y-c/9};b[b.length]=a[e]}return b}function z(a,f,b,c,e,g,h,l,t,k){var r=0;k?(h.color=g,l.color=g):k=1;r=t?Math.abs(e-b):Math.abs(c-f);r=0<h.trimLength?Math.abs(r*h.trimLength/100):Math.abs(r-h.length);t?(b+=r/2,
e-=r/2):(f+=r/2,c-=r/2);var r=1===Math.round(h.thickness)%2?0.5:0,p=1===Math.round(l.thickness)%2?0.5:0;a.save();a.globalAlpha=k;a.strokeStyle=l.color||g;a.lineWidth=l.thickness||2;a.setLineDash&&a.setLineDash(F(l.dashType,l.thickness));a.beginPath();t&&0<l.thickness?(a.moveTo(c-h.thickness/2,Math.round((b+e)/2)-p),a.lineTo(f+h.thickness/2,Math.round((b+e)/2)-p)):0<l.thickness&&(a.moveTo(Math.round((f+c)/2)-p,b+h.thickness/2),a.lineTo(Math.round((f+c)/2)-p,e-h.thickness/2));a.stroke();a.strokeStyle=
h.color||g;a.lineWidth=h.thickness||2;a.setLineDash&&a.setLineDash(F(h.dashType,h.thickness));a.beginPath();t&&0<h.thickness?(a.moveTo(c-r,b),a.lineTo(c-r,e),a.moveTo(f+r,b),a.lineTo(f+r,e)):0<h.thickness&&(a.moveTo(f,b+r),a.lineTo(c,b+r),a.moveTo(f,e-r),a.lineTo(c,e-r));a.stroke();a.restore()}function J(a,f,b,c,e){if(null===a||"undefined"===typeof a)return"undefined"===typeof b?f:b;a=parseFloat(a.toString())*(0<=a.toString().indexOf("%")?f/100:1);"undefined"!==typeof c&&(a=Math.min(c,a),"undefined"!==
typeof e&&(a=Math.max(e,a)));return!isNaN(a)&&a<=f&&0<=a?a:"undefined"===typeof b?f:b}function T(a,f){T.base.constructor.call(this,"Legend","legend",f,null,a);this.chart=a;this.canvas=a.canvas;this.ctx=this.chart.ctx;this.ghostCtx=this.chart._eventManager.ghostCtx;this.items=[];this.optionsName="legend";this.height=this.width=0;this.orientation=null;this.dataSeries=[];this.bounds={x1:null,y1:null,x2:null,y2:null};"undefined"===typeof this.options.fontSize&&(this.fontSize=this.chart.getAutoFontSize(this.fontSize));
this.lineHeight=Ua(this.fontFamily,this.fontSize,this.fontWeight);this.horizontalSpacing=this.fontSize}function S(a,f,b,c){S.base.constructor.call(this,"DataSeries","data",f,b,a);this.chart=a;this.canvas=a.canvas;this._ctx=a.canvas.ctx;this.index=b;this.noDataPointsInPlotArea=0;this.id=c;this.chart._eventManager.objectMap[c]={id:c,objectType:"dataSeries",dataSeriesIndex:b};a=f.dataPoints?f.dataPoints.length:0;this.dataPointEOs=[];for(f=0;f<a;f++)this.dataPointEOs[f]={};this.dataPointIds=[];this.plotUnit=
[];this.axisY=this.axisX=null;this.optionsName="data";this.isOptionsInArray=!0;null===this.fillOpacity&&(this.type.match(/area/i)?this.fillOpacity=0.7:this.fillOpacity=1);this.axisPlacement=this.getDefaultAxisPlacement();"undefined"===typeof this.options.indexLabelFontSize&&(this.indexLabelFontSize=this.chart.getAutoFontSize(this.indexLabelFontSize))}function C(a,f,b,c,e,g){C.base.constructor.call(this,"Axis",f,b,c,a);this.chart=a;this.canvas=a.canvas;this.ctx=a.ctx;this.intervalStartPosition=this.maxHeight=
this.maxWidth=0;this.labels=[];this.dataSeries=[];this._stripLineLabels=this._ticks=this._labels=null;this.dataInfo={min:Infinity,max:-Infinity,viewPortMin:Infinity,viewPortMax:-Infinity,minDiff:Infinity};this.isOptionsInArray=!0;"axisX"===e?("left"===g||"bottom"===g?(this.optionsName="axisX",y(this.chart.sessionVariables.axisX[c])&&(this.chart.sessionVariables.axisX[c]={}),this.sessionVariables=this.chart.sessionVariables.axisX[c]):(this.optionsName="axisX2",y(this.chart.sessionVariables.axisX2[c])&&
(this.chart.sessionVariables.axisX2[c]={}),this.sessionVariables=this.chart.sessionVariables.axisX2[c]),this.options.interval||(this.intervalType=null)):"left"===g||"bottom"===g?(this.optionsName="axisY",y(this.chart.sessionVariables.axisY[c])&&(this.chart.sessionVariables.axisY[c]={}),this.sessionVariables=this.chart.sessionVariables.axisY[c]):(this.optionsName="axisY2",y(this.chart.sessionVariables.axisY2[c])&&(this.chart.sessionVariables.axisY2[c]={}),this.sessionVariables=this.chart.sessionVariables.axisY2[c]);
"undefined"===typeof this.options.titleFontSize&&(this.titleFontSize=this.chart.getAutoFontSize(this.titleFontSize));"undefined"===typeof this.options.labelFontSize&&(this.labelFontSize=this.chart.getAutoFontSize(this.labelFontSize));this.type=e;"axisX"!==e||b&&"undefined"!==typeof b.gridThickness||(this.gridThickness=0);this._position=g;this.lineCoordinates={x1:null,y1:null,x2:null,y2:null,width:null};this.labelAngle=(this.labelAngle%360+360)%360;90<this.labelAngle&&270>this.labelAngle?this.labelAngle-=
180:270<=this.labelAngle&&360>=this.labelAngle&&(this.labelAngle-=360);this.options.scaleBreaks&&(this.scaleBreaks=new I(this.chart,this.options.scaleBreaks,++this.chart._eventManager.lastObjectId,this));this.stripLines=[];if(this.options.stripLines&&0<this.options.stripLines.length)for(a=0;a<this.options.stripLines.length;a++)this.stripLines.push(new fa(this.chart,this.options.stripLines[a],a,++this.chart._eventManager.lastObjectId,this));this.options.crosshair&&(this.crosshair=new ha(this.chart,
this.options.crosshair,this));this._titleTextBlock=null;this.hasOptionChanged("viewportMinimum")&&null===this.viewportMinimum&&(this.options.viewportMinimum=void 0,this.sessionVariables.viewportMinimum=null);this.hasOptionChanged("viewportMinimum")||isNaN(this.sessionVariables.newViewportMinimum)||null===this.sessionVariables.newViewportMinimum?this.sessionVariables.newViewportMinimum=null:this.viewportMinimum=this.sessionVariables.newViewportMinimum;this.hasOptionChanged("viewportMaximum")&&null===
this.viewportMaximum&&(this.options.viewportMaximum=void 0,this.sessionVariables.viewportMaximum=null);this.hasOptionChanged("viewportMaximum")||isNaN(this.sessionVariables.newViewportMaximum)||null===this.sessionVariables.newViewportMaximum?this.sessionVariables.newViewportMaximum=null:this.viewportMaximum=this.sessionVariables.newViewportMaximum;null!==this.minimum&&null!==this.viewportMinimum&&(this.viewportMinimum=Math.max(this.viewportMinimum,this.minimum));null!==this.maximum&&null!==this.viewportMaximum&&
(this.viewportMaximum=Math.min(this.viewportMaximum,this.maximum));this.trackChanges("viewportMinimum");this.trackChanges("viewportMaximum")}function I(a,f,b,c){I.base.constructor.call(this,"ScaleBreaks","scaleBreaks",f,null,c);this.id=b;this.chart=a;this.ctx=this.chart.ctx;this.axis=c;this.optionsName="scaleBreaks";this.isOptionsInArray=!1;this._appliedBreaks=[];this.customBreaks=[];this.autoBreaks=[];"string"===typeof this.spacing?(this.spacing=parseFloat(this.spacing),this.spacing=isNaN(this.spacing)?
8:(10<this.spacing?10:this.spacing)+"%"):"number"!==typeof this.spacing&&(this.spacing=8);this.autoCalculate&&(this.maxNumberOfAutoBreaks=Math.min(this.maxNumberOfAutoBreaks,5));if(this.options.customBreaks&&0<this.options.customBreaks.length){for(a=0;a<this.options.customBreaks.length;a++)this.customBreaks.push(new ba(this.chart,"customBreaks",this.options.customBreaks[a],a,++this.chart._eventManager.lastObjectId,this)),"number"===typeof this.customBreaks[a].startValue&&("number"===typeof this.customBreaks[a].endValue&&
this.customBreaks[a].endValue!==this.customBreaks[a].startValue)&&this._appliedBreaks.push(this.customBreaks[a]);this._appliedBreaks.sort(function(a,c){return a.startValue-c.startValue});for(a=0;a<this._appliedBreaks.length-1;a++)this._appliedBreaks[a].endValue>=this._appliedBreaks[a+1].startValue&&(this._appliedBreaks[a].endValue=Math.max(this._appliedBreaks[a].endValue,this._appliedBreaks[a+1].endValue),window.console&&window.console.log("CanvasJS Error: Breaks "+a+" and "+(a+1)+" are overlapping."),
this._appliedBreaks.splice(a,2),a--)}}function ba(a,f,b,c,e,g){ba.base.constructor.call(this,"Break",f,b,c,g);this.id=e;this.chart=a;this.ctx=this.chart.ctx;this.scaleBreaks=g;this.optionsName=f;this.isOptionsInArray=!0;this.type=b.type?this.type:g.type;this.fillOpacity=y(b.fillOpacity)?g.fillOpacity:this.fillOpacity;this.lineThickness=y(b.lineThickness)?g.lineThickness:this.lineThickness;this.color=b.color?this.color:g.color;this.lineColor=b.lineColor?this.lineColor:g.lineColor;this.lineDashType=
b.lineDashType?this.lineDashType:g.lineDashType;!y(this.startValue)&&this.startValue.getTime&&(this.startValue=this.startValue.getTime());!y(this.endValue)&&this.endValue.getTime&&(this.endValue=this.endValue.getTime());"number"===typeof this.startValue&&("number"===typeof this.endValue&&this.endValue<this.startValue)&&(a=this.startValue,this.startValue=this.endValue,this.endValue=a);this.spacing="undefined"===typeof b.spacing?g.spacing:b.spacing;"string"===typeof this.options.spacing?(this.spacing=
parseFloat(this.spacing),this.spacing=isNaN(this.spacing)?0:(10<this.spacing?10:this.spacing)+"%"):"number"!==typeof this.options.spacing&&(this.spacing=g.spacing);this.size=g.parent.logarithmic?1:0}function fa(a,f,b,c,e){fa.base.constructor.call(this,"StripLine","stripLines",f,b,e);this.id=c;this.chart=a;this.ctx=this.chart.ctx;this.label=this.label;this.axis=e;this.optionsName="stripLines";this.isOptionsInArray=!0;this._thicknessType="pixel";null!==this.startValue&&null!==this.endValue&&(this.value=
e.logarithmic?Math.sqrt((this.startValue.getTime?this.startValue.getTime():this.startValue)*(this.endValue.getTime?this.endValue.getTime():this.endValue)):((this.startValue.getTime?this.startValue.getTime():this.startValue)+(this.endValue.getTime?this.endValue.getTime():this.endValue))/2,this._thicknessType=null)}function ha(a,f,b){ha.base.constructor.call(this,"Crosshair","crosshair",f,null,b);this.chart=a;this.ctx=this.chart.ctx;this.axis=b;this.optionsName="crosshair";this._thicknessType="pixel"}
function Z(a,f){Z.base.constructor.call(this,"ToolTip","toolTip",f,null,a);this.chart=a;this.canvas=a.canvas;this.ctx=this.chart.ctx;this.currentDataPointIndex=this.currentSeriesIndex=-1;this._prevY=this._prevX=NaN;this.containerTransitionDuration=0.1;this.mozContainerTransition=this.getContainerTransition(this.containerTransitionDuration);this.optionsName="toolTip";this._initialize()}function ea(a){this.chart=a;this.lastObjectId=0;this.objectMap=[];this.rectangularRegionEventSubscriptions=[];this.previousDataPointEventObject=
null;this.ghostCanvas=ta(this.chart.width,this.chart.height);this.ghostCtx=this.ghostCanvas.getContext("2d");this.mouseoveredObjectMaps=[]}function ga(a){this.chart=a;this.ctx=this.chart.plotArea.ctx;this.animations=[];this.animationRequestId=null}na(q,Y);q.prototype.destroy=function(){var a=this.allDOMEventHandlers;this._animator&&this._animator.cancelAllAnimations();this._panTimerId&&clearTimeout(this._panTimerId);for(i=0;i<a.length;i++){var f=a[i][0],b=a[i][1],c=a[i][2],e=a[i][3],e=e||!1;f.removeEventListener?
f.removeEventListener(b,c,e):f.detachEvent&&f.detachEvent("on"+b,c)}this.allDOMEventHandlers=[];for(this.removeAllEventListeners();this._canvasJSContainer&&this._canvasJSContainer.hasChildNodes();)this._canvasJSContainer.removeChild(this._canvasJSContainer.lastChild);for(;this.container&&this.container.hasChildNodes();)this.container.removeChild(this.container.lastChild);for(;this._dropdownMenu&&this._dropdownMenu.hasChildNodes();)this._dropdownMenu.removeChild(this._dropdownMenu.lastChild);this.overlaidCanvas=
this.canvas=this.container=this._canvasJSContainer=null;this._toolBar=this._dropdownMenu=this._menuButton=this._resetButton=this._zoomButton=this._breaksCanvas=this._preRenderCanvas=this.toolTip.container=null};q.prototype._updateOptions=function(){var a=this;this.updateOption("width");this.updateOption("height");this.updateOption("dataPointWidth");this.updateOption("dataPointMinWidth");this.updateOption("dataPointMaxWidth");this.updateOption("interactivityEnabled");this.updateOption("theme");this.updateOption("colorSet")&&
(this._selectedColorSet="undefined"!==typeof za[this.colorSet]?za[this.colorSet]:za.colorSet1);this.updateOption("backgroundColor");this.backgroundColor||(this.backgroundColor="rgba(0,0,0,0)");this.updateOption("culture");this._cultureInfo=new Ia(this.options.culture);this.updateOption("animationEnabled");this.animationEnabled=this.animationEnabled&&v;this.updateOption("animationDuration");this.updateOption("rangeChanging");this.updateOption("rangeChanged");this.updateOption("exportEnabled");this.updateOption("exportFileName");
this.updateOption("zoomType");if(this.options.zoomEnabled){if(!this._zoomButton){var f=!1;va(this._zoomButton=document.createElement("button"));ua(this,this._zoomButton,"pan");this._toolBar.appendChild(this._zoomButton);this._zoomButton.style.borderRight=this.toolbar.borderThickness+"px solid "+this.toolbar.borderColor;P(this._zoomButton,"touchstart",function(a){f=!0},this.allDOMEventHandlers);P(this._zoomButton,"click",function(){a.zoomEnabled?(a.zoomEnabled=!1,a.panEnabled=!0,ua(a,a._zoomButton,
"zoom")):(a.zoomEnabled=!0,a.panEnabled=!1,ua(a,a._zoomButton,"pan"));a.render()},this.allDOMEventHandlers);P(this._zoomButton,"mouseover",function(){f?f=!1:(oa(a,a._zoomButton,{backgroundColor:a.toolbar.backgroundColorOnHover,color:a.toolbar.fontColorOnHover,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._zoomButton.childNodes[0],{WebkitFilter:"invert(100%)",filter:"invert(100%)"}))},this.allDOMEventHandlers);P(this._zoomButton,"mouseout",function(){f||
(oa(a,a._zoomButton,{backgroundColor:a.toolbar.backgroundColor,color:a.toolbar.fontColor,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._zoomButton.childNodes[0],{WebkitFilter:"invert(0%)",filter:"invert(0%)"}))},this.allDOMEventHandlers)}this._resetButton||(f=!1,va(this._resetButton=document.createElement("button")),ua(this,this._resetButton,"reset"),this._resetButton.style.borderRight=(this.exportEnabled?this.toolbar.borderThickness:0)+"px solid "+this.toolbar.borderColor,
this._toolBar.appendChild(this._resetButton),P(this._resetButton,"touchstart",function(a){f=!0},this.allDOMEventHandlers),P(this._resetButton,"click",function(){a.toolTip.hide();a.zoomEnabled||a.panEnabled?(a.zoomEnabled=!0,a.panEnabled=!1,ua(a,a._zoomButton,"pan"),a._defaultCursor="default",a.overlaidCanvas.style.cursor=a._defaultCursor):(a.zoomEnabled=!1,a.panEnabled=!1);if(a.sessionVariables.axisX)for(var c=0;c<a.sessionVariables.axisX.length;c++)a.sessionVariables.axisX[c].newViewportMinimum=
null,a.sessionVariables.axisX[c].newViewportMaximum=null;if(a.sessionVariables.axisX2)for(c=0;c<a.sessionVariables.axisX2.length;c++)a.sessionVariables.axisX2[c].newViewportMinimum=null,a.sessionVariables.axisX2[c].newViewportMaximum=null;if(a.sessionVariables.axisY)for(c=0;c<a.sessionVariables.axisY.length;c++)a.sessionVariables.axisY[c].newViewportMinimum=null,a.sessionVariables.axisY[c].newViewportMaximum=null;if(a.sessionVariables.axisY2)for(c=0;c<a.sessionVariables.axisY2.length;c++)a.sessionVariables.axisY2[c].newViewportMinimum=
null,a.sessionVariables.axisY2[c].newViewportMaximum=null;a.resetOverlayedCanvas();va(a._zoomButton,a._resetButton);a._dispatchRangeEvent("rangeChanging","reset");a.render();a._dispatchRangeEvent("rangeChanged","reset")},this.allDOMEventHandlers),P(this._resetButton,"mouseover",function(){f||(oa(a,a._resetButton,{backgroundColor:a.toolbar.backgroundColorOnHover,color:a.toolbar.hoverFfontColorOnHoverontColor,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._resetButton.childNodes[0],
{WebkitFilter:"invert(100%)",filter:"invert(100%)"}))},this.allDOMEventHandlers),P(this._resetButton,"mouseout",function(){f||(oa(a,a._resetButton,{backgroundColor:a.toolbar.backgroundColor,color:a.toolbar.fontColor,transition:"0.4s",WebkitTransition:"0.4s"}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._resetButton.childNodes[0],{WebkitFilter:"invert(0%)",filter:"invert(0%)"}))},this.allDOMEventHandlers),this.overlaidCanvas.style.cursor=a._defaultCursor);this.zoomEnabled||this.panEnabled||(this._zoomButton?
(a._zoomButton.getAttribute("state")===a._cultureInfo.zoomText?(this.panEnabled=!0,this.zoomEnabled=!1):(this.zoomEnabled=!0,this.panEnabled=!1),Ma(a._zoomButton,a._resetButton)):(this.zoomEnabled=!0,this.panEnabled=!1))}else this.panEnabled=this.zoomEnabled=!1;this._menuButton?this.exportEnabled?Ma(this._menuButton):va(this._menuButton):this.exportEnabled&&v&&(f=!1,this._menuButton=document.createElement("button"),ua(this,this._menuButton,"menu"),this._toolBar.appendChild(this._menuButton),P(this._menuButton,
"touchstart",function(a){f=!0},this.allDOMEventHandlers),P(this._menuButton,"click",function(){"none"!==a._dropdownMenu.style.display||a._dropDownCloseTime&&500>=(new Date).getTime()-a._dropDownCloseTime.getTime()||(a._dropdownMenu.style.display="block",a._menuButton.blur(),a._dropdownMenu.focus())},this.allDOMEventHandlers,!0),P(this._menuButton,"mouseover",function(){f||(oa(a,a._menuButton,{backgroundColor:a.toolbar.backgroundColorOnHover,color:a.toolbar.fontColorOnHover}),0>=navigator.userAgent.search("MSIE")&&
oa(a,a._menuButton.childNodes[0],{WebkitFilter:"invert(100%)",filter:"invert(100%)"}))},this.allDOMEventHandlers,!0),P(this._menuButton,"mouseout",function(){f||(oa(a,a._menuButton,{backgroundColor:a.toolbar.backgroundColor,color:a.toolbar.fontColor}),0>=navigator.userAgent.search("MSIE")&&oa(a,a._menuButton.childNodes[0],{WebkitFilter:"invert(0%)",filter:"invert(0%)"}))},this.allDOMEventHandlers,!0));if(!this._dropdownMenu&&this.exportEnabled&&v){f=!1;this._dropdownMenu=document.createElement("div");
this._dropdownMenu.setAttribute("tabindex",-1);var b=-1!==this.theme.indexOf("dark")?"black":"#888888";this._dropdownMenu.style.cssText="position: absolute; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; cursor: pointer;right: 0px;top: 25px;min-width: 120px;outline: 0;font-size: 14px; font-family: Arial, Helvetica, sans-serif;padding: 5px 0px 5px 0px;text-align: left;line-height: 10px;background-color:"+this.toolbar.backgroundColor+";box-shadow: 2px 2px 10px "+
b;a._dropdownMenu.style.display="none";this._toolBar.appendChild(this._dropdownMenu);P(this._dropdownMenu,"blur",function(){va(a._dropdownMenu);a._dropDownCloseTime=new Date},this.allDOMEventHandlers,!0);b=document.createElement("div");b.style.cssText="padding: 12px 8px 12px 8px";b.innerHTML=this._cultureInfo.printText;b.style.backgroundColor=this.toolbar.backgroundColor;b.style.color=this.toolbar.fontColor;this._dropdownMenu.appendChild(b);P(b,"touchstart",function(a){f=!0},this.allDOMEventHandlers);
P(b,"mouseover",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColorOnHover,this.style.color=a.toolbar.fontColorOnHover)},this.allDOMEventHandlers,!0);P(b,"mouseout",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColor,this.style.color=a.toolbar.fontColor)},this.allDOMEventHandlers,!0);P(b,"click",function(){a.print();va(a._dropdownMenu)},this.allDOMEventHandlers,!0);b=document.createElement("div");b.style.cssText="padding: 12px 8px 12px 8px";b.innerHTML=this._cultureInfo.saveJPGText;
b.style.backgroundColor=this.toolbar.backgroundColor;b.style.color=this.toolbar.fontColor;this._dropdownMenu.appendChild(b);P(b,"touchstart",function(a){f=!0},this.allDOMEventHandlers);P(b,"mouseover",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColorOnHover,this.style.color=a.toolbar.fontColorOnHover)},this.allDOMEventHandlers,!0);P(b,"mouseout",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColor,this.style.color=a.toolbar.fontColor)},this.allDOMEventHandlers,!0);
P(b,"click",function(){s(a.canvas,"jpeg",a.exportFileName);va(a._dropdownMenu)},this.allDOMEventHandlers,!0);b=document.createElement("div");b.style.cssText="padding: 12px 8px 12px 8px";b.innerHTML=this._cultureInfo.savePNGText;b.style.backgroundColor=this.toolbar.backgroundColor;b.style.color=this.toolbar.fontColor;this._dropdownMenu.appendChild(b);P(b,"touchstart",function(a){f=!0},this.allDOMEventHandlers);P(b,"mouseover",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColorOnHover,
this.style.color=a.toolbar.fontColorOnHover)},this.allDOMEventHandlers,!0);P(b,"mouseout",function(){f||(this.style.backgroundColor=a.toolbar.backgroundColor,this.style.color=a.toolbar.fontColor)},this.allDOMEventHandlers,!0);P(b,"click",function(){s(a.canvas,"png",a.exportFileName);va(a._dropdownMenu)},this.allDOMEventHandlers,!0)}"none"!==this._toolBar.style.display&&this._zoomButton&&(this.panEnabled?ua(a,a._zoomButton,"zoom"):ua(a,a._zoomButton,"pan"),a._resetButton.getAttribute("state")!==a._cultureInfo.resetText&&
ua(a,a._resetButton,"reset"));this.options.toolTip&&this.toolTip.options!==this.options.toolTip&&(this.toolTip.options=this.options.toolTip);for(var c in this.toolTip.options)this.toolTip.options.hasOwnProperty(c)&&this.toolTip.updateOption(c)};q.prototype._updateSize=function(){var a=0,f=0;this.options.width?a=this.width:this.width=a=0<this.container.clientWidth?this.container.clientWidth:this.width;this.options.height?f=this.height:this.height=f=0<this.container.clientHeight?this.container.clientHeight:
this.height;return this.canvas.width!==a*ia||this.canvas.height!==f*ia?(Ga(this.canvas,a,f),Ga(this._preRenderCanvas,a,f),Ga(this.overlaidCanvas,a,f),Ga(this._eventManager.ghostCanvas,a,f),this.bounds={x1:0,y1:0,x2:this.width,y2:this.height},!0):!1};q.prototype._initialize=function(){this.toolbar=new Ra(this,this.options.toolbar);this._animator?this._animator.cancelAllAnimations():this._animator=new ga(this);this.removeAllEventListeners();this.disableToolTip=!1;this._axes=[];this.funnelPyramidClickHandler=
this.pieDoughnutClickHandler=null;this._updateOptions();this.animatedRender=v&&this.animationEnabled&&0===this.renderCount;this._updateSize();this.clearCanvas();this.ctx.beginPath();this.axisX=[];this.axisX2=[];this.axisY=[];this.axisY2=[];this._indexLabels=[];this._dataInRenderedOrder=[];this._events=[];this._eventManager&&this._eventManager.reset();this.plotInfo={axisPlacement:null,plotTypes:[]};this.layoutManager=new Da(0,0,this.width,this.height,2);this.plotArea.layoutManager&&this.plotArea.layoutManager.reset();
this.data=[];var a=0,f=null;if(this.options.data){for(var b=0;b<this.options.data.length;b++)if(a++,!this.options.data[b].type||0<=q._supportedChartTypes.indexOf(this.options.data[b].type)){var c=new S(this,this.options.data[b],a-1,++this._eventManager.lastObjectId);"error"===c.type&&(c.linkedDataSeriesIndex=y(this.options.data[b].linkedDataSeriesIndex)?b-1:this.options.data[b].linkedDataSeriesIndex,0>c.linkedDataSeriesIndex||c.linkedDataSeriesIndex>=this.options.data.length||"number"!==typeof c.linkedDataSeriesIndex||
"error"===this.options.data[c.linkedDataSeriesIndex].type)&&(c.linkedDataSeriesIndex=null);null===c.name&&(c.name="DataSeries "+a);null===c.color?1<this.options.data.length?(c._colorSet=[this._selectedColorSet[c.index%this._selectedColorSet.length]],c.color=this._selectedColorSet[c.index%this._selectedColorSet.length]):c._colorSet="line"===c.type||"stepLine"===c.type||"spline"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"stackedArea"===c.type||"stackedArea100"===c.type||
"rangeArea"===c.type||"rangeSplineArea"===c.type||"candlestick"===c.type||"ohlc"===c.type||"waterfall"===c.type||"boxAndWhisker"===c.type?[this._selectedColorSet[0]]:this._selectedColorSet:c._colorSet=[c.color];null===c.markerSize&&(("line"===c.type||"stepLine"===c.type||"spline"===c.type||0<=c.type.toLowerCase().indexOf("area"))&&c.dataPoints&&c.dataPoints.length<this.width/16||"scatter"===c.type)&&(c.markerSize=8);"bubble"!==c.type&&"scatter"!==c.type||!c.dataPoints||(c.dataPoints.some?c.dataPoints.some(function(a){return a.x})&&
c.dataPoints.sort(m):c.dataPoints.sort(m));this.data.push(c);var e=c.axisPlacement,f=f||e,g;"normal"===e?"xySwapped"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with bar chart':"none"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with pie chart':null===this.plotInfo.axisPlacement&&(this.plotInfo.axisPlacement="normal"):"xySwapped"===e?"normal"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with line, area, column or pie chart':"none"===this.plotInfo.axisPlacement?
g='You cannot combine "'+c.type+'" with pie chart':null===this.plotInfo.axisPlacement&&(this.plotInfo.axisPlacement="xySwapped"):"none"===e?"normal"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with line, area, column or bar chart':"xySwapped"===this.plotInfo.axisPlacement?g='You cannot combine "'+c.type+'" with bar chart':null===this.plotInfo.axisPlacement&&(this.plotInfo.axisPlacement="none"):null===e&&"none"===this.plotInfo.axisPlacement&&(g='You cannot combine "'+c.type+'" with pie chart');
if(g&&window.console){window.console.log(g);return}}for(b=0;b<this.data.length;b++){if("none"==f&&"error"===this.data[b].type&&window.console){window.console.log('You cannot combine "'+c.type+'" with error chart');return}"error"===this.data[b].type&&(this.data[b].axisPlacement=this.plotInfo.axisPlacement=f||"normal",this.data[b]._linkedSeries=null===this.data[b].linkedDataSeriesIndex?null:this.data[this.data[b].linkedDataSeriesIndex])}}this._objectsInitialized=!0};q._supportedChartTypes=Ca("line stepLine spline column area stepArea splineArea bar bubble scatter stackedColumn stackedColumn100 stackedBar stackedBar100 stackedArea stackedArea100 candlestick ohlc boxAndWhisker rangeColumn error rangeBar rangeArea rangeSplineArea pie doughnut funnel pyramid waterfall".split(" "));
q.prototype.render=function(a){a&&(this.options=a);this._initialize();var f=[];for(a=0;a<this.data.length;a++)if("normal"===this.plotInfo.axisPlacement||"xySwapped"===this.plotInfo.axisPlacement){if(!this.data[a].axisYType||"primary"===this.data[a].axisYType)if(this.options.axisY&&0<this.options.axisY.length){if(!this.axisY.length)for(var b=0;b<this.options.axisY.length;b++)"normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisY[b]=new C(this,"axisY",this.options.axisY[b],b,"axisY","left")):
"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY[b]=new C(this,"axisY",this.options.axisY[b],b,"axisY","bottom"));this.data[a].axisY=this.axisY[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY.length?this.data[a].axisYIndex:0];this.axisY[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY.length?this.data[a].axisYIndex:0].dataSeries.push(this.data[a])}else this.axisY.length||("normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisY[0]=new C(this,
"axisY",this.options.axisY,0,"axisY","left")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY[0]=new C(this,"axisY",this.options.axisY,0,"axisY","bottom"))),this.data[a].axisY=this.axisY[0],this.axisY[0].dataSeries.push(this.data[a]);if("secondary"===this.data[a].axisYType)if(this.options.axisY2&&0<this.options.axisY2.length){if(!this.axisY2.length)for(b=0;b<this.options.axisY2.length;b++)"normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisY2[b]=new C(this,"axisY2",
this.options.axisY2[b],b,"axisY","right")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY2[b]=new C(this,"axisY2",this.options.axisY2[b],b,"axisY","top"));this.data[a].axisY=this.axisY2[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY2.length?this.data[a].axisYIndex:0];this.axisY2[0<=this.data[a].axisYIndex&&this.data[a].axisYIndex<this.axisY2.length?this.data[a].axisYIndex:0].dataSeries.push(this.data[a])}else this.axisY2.length||("normal"===this.plotInfo.axisPlacement?
this._axes.push(this.axisY2[0]=new C(this,"axisY2",this.options.axisY2,0,"axisY","right")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisY2[0]=new C(this,"axisY2",this.options.axisY2,0,"axisY","top"))),this.data[a].axisY=this.axisY2[0],this.axisY2[0].dataSeries.push(this.data[a]);if(!this.data[a].axisXType||"primary"===this.data[a].axisXType)if(this.options.axisX&&0<this.options.axisX.length){if(!this.axisX.length)for(b=0;b<this.options.axisX.length;b++)"normal"===this.plotInfo.axisPlacement?
this._axes.push(this.axisX[b]=new C(this,"axisX",this.options.axisX[b],b,"axisX","bottom")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX[b]=new C(this,"axisX",this.options.axisX[b],b,"axisX","left"));this.data[a].axisX=this.axisX[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX.length?this.data[a].axisXIndex:0];this.axisX[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX.length?this.data[a].axisXIndex:0].dataSeries.push(this.data[a])}else this.axisX.length||
("normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisX[0]=new C(this,"axisX",this.options.axisX,0,"axisX","bottom")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX[0]=new C(this,"axisX",this.options.axisX,0,"axisX","left"))),this.data[a].axisX=this.axisX[0],this.axisX[0].dataSeries.push(this.data[a]);if("secondary"===this.data[a].axisXType)if(this.options.axisX2&&0<this.options.axisX2.length){if(!this.axisX2.length)for(b=0;b<this.options.axisX2.length;b++)"normal"===
this.plotInfo.axisPlacement?this._axes.push(this.axisX2[b]=new C(this,"axisX2",this.options.axisX2[b],b,"axisX","top")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX2[b]=new C(this,"axisX2",this.options.axisX2[b],b,"axisX","right"));this.data[a].axisX=this.axisX2[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX2.length?this.data[a].axisXIndex:0];this.axisX2[0<=this.data[a].axisXIndex&&this.data[a].axisXIndex<this.axisX2.length?this.data[a].axisXIndex:0].dataSeries.push(this.data[a])}else this.axisX2.length||
("normal"===this.plotInfo.axisPlacement?this._axes.push(this.axisX2[0]=new C(this,"axisX2",this.options.axisX2,0,"axisX","top")):"xySwapped"===this.plotInfo.axisPlacement&&this._axes.push(this.axisX2[0]=new C(this,"axisX2",this.options.axisX2,0,"axisX","right"))),this.data[a].axisX=this.axisX2[0],this.axisX2[0].dataSeries.push(this.data[a])}if(this.axisY){for(b=1;b<this.axisY.length;b++)"undefined"===typeof this.axisY[b].options.gridThickness&&(this.axisY[b].gridThickness=0);for(b=0;b<this.axisY.length-
1;b++)"undefined"===typeof this.axisY[b].options.margin&&(this.axisY[b].margin=10)}if(this.axisY2){for(b=1;b<this.axisY2.length;b++)"undefined"===typeof this.axisY2[b].options.gridThickness&&(this.axisY2[b].gridThickness=0);for(b=0;b<this.axisY2.length-1;b++)"undefined"===typeof this.axisY2[b].options.margin&&(this.axisY2[b].margin=10)}this.axisY&&0<this.axisY.length&&(this.axisY2&&0<this.axisY2.length)&&(0<this.axisY[0].gridThickness&&"undefined"===typeof this.axisY2[0].options.gridThickness?this.axisY2[0].gridThickness=
0:0<this.axisY2[0].gridThickness&&"undefined"===typeof this.axisY[0].options.gridThickness&&(this.axisY[0].gridThickness=0));if(this.axisX)for(b=0;b<this.axisX.length;b++)"undefined"===typeof this.axisX[b].options.gridThickness&&(this.axisX[b].gridThickness=0);if(this.axisX2)for(b=0;b<this.axisX2.length;b++)"undefined"===typeof this.axisX2[b].options.gridThickness&&(this.axisX2[b].gridThickness=0);this.axisX&&0<this.axisX.length&&(this.axisX2&&0<this.axisX2.length)&&(0<this.axisX[0].gridThickness&&
"undefined"===typeof this.axisX2[0].options.gridThickness?this.axisX2[0].gridThickness=0:0<this.axisX2[0].gridThickness&&"undefined"===typeof this.axisX[0].options.gridThickness&&(this.axisX[0].gridThickness=0));b=!1;if(0<this._axes.length&&(this.zoomEnabled||this.panEnabled))for(a=0;a<this._axes.length;a++)if(null!==this._axes[a].viewportMinimum||null!==this._axes[a].viewportMaximum){b=!0;break}b?(Ma(this._zoomButton,this._resetButton),this._toolBar.style.border=this.toolbar.borderThickness+"px solid "+
this.toolbar.borderColor,this._zoomButton.style.borderRight=this.toolbar.borderThickness+"px solid "+this.toolbar.borderColor,this._resetButton.style.borderRight=(this.exportEnabled?this.toolbar.borderThickness:0)+"px solid "+this.toolbar.borderColor):(va(this._zoomButton,this._resetButton),this._toolBar.style.border=this.toolbar.borderThickness+"px solid transparent",this.options.zoomEnabled&&(this.zoomEnabled=!0,this.panEnabled=!1));bb(this);this._processData();this.options.title&&(this.title=new Ha(this,
this.options.title),this.title.dockInsidePlotArea?f.push(this.title):this.title.render());if(this.options.subtitles)for(this.subtitles=[],a=0;a<this.options.subtitles.length;a++)b=new Na(this,this.options.subtitles[a],a),this.subtitles.push(b),b.dockInsidePlotArea?f.push(b):b.render();this.legend=new T(this,this.options.legend);for(a=0;a<this.data.length;a++)(this.data[a].showInLegend||"pie"===this.data[a].type||"doughnut"===this.data[a].type||"funnel"===this.data[a].type||"pyramid"===this.data[a].type)&&
this.legend.dataSeries.push(this.data[a]);this.legend.dockInsidePlotArea?f.push(this.legend):this.legend.render();for(a=0;a<this._axes.length;a++)if(this._axes[a].scaleBreaks&&this._axes[a].scaleBreaks._appliedBreaks.length){v?(this._breaksCanvas=ta(this.width,this.height,!0),this._breaksCanvasCtx=this._breaksCanvas.getContext("2d")):(this._breaksCanvas=this.canvas,this._breaksCanvasCtx=this.ctx);break}this._preRenderCanvas=ta(this.width,this.height);this._preRenderCtx=this._preRenderCanvas.getContext("2d");
if("normal"===this.plotInfo.axisPlacement||"xySwapped"===this.plotInfo.axisPlacement)C.setLayoutAndRender(this.axisX,this.axisX2,this.axisY,this.axisY2,this.plotInfo.axisPlacement,this.layoutManager.getFreeSpace());else if("none"===this.plotInfo.axisPlacement)this.preparePlotArea();else return;for(a=0;a<f.length;a++)f[a].render();var c=[];if(this.animatedRender){var e=ta(this.width,this.height);e.getContext("2d").drawImage(this.canvas,0,0,this.width,this.height)}cb(this);var f=this.ctx.miterLimit,
g;this.ctx.miterLimit=3;v&&this._breaksCanvas&&(this._preRenderCtx.drawImage(this.canvas,0,0,this.width,this.height),this._preRenderCtx.drawImage(this._breaksCanvas,0,0,this.width,this.height),this._breaksCanvasCtx.globalCompositeOperation="source-atop",this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),this._preRenderCtx.clearRect(0,0,this.width,this.height));for(a=0;a<this.plotInfo.plotTypes.length;a++)for(var h=this.plotInfo.plotTypes[a],l=0;l<h.plotUnits.length;l++){var t=
h.plotUnits[l],k=null;t.targetCanvas=null;this.animatedRender&&(t.targetCanvas=ta(this.width,this.height),t.targetCanvasCtx=t.targetCanvas.getContext("2d"),g=t.targetCanvasCtx.miterLimit,t.targetCanvasCtx.miterLimit=3);"line"===t.type?k=this.renderLine(t):"stepLine"===t.type?k=this.renderStepLine(t):"spline"===t.type?k=this.renderSpline(t):"column"===t.type?k=this.renderColumn(t):"bar"===t.type?k=this.renderBar(t):"area"===t.type?k=this.renderArea(t):"stepArea"===t.type?k=this.renderStepArea(t):"splineArea"===
t.type?k=this.renderSplineArea(t):"stackedColumn"===t.type?k=this.renderStackedColumn(t):"stackedColumn100"===t.type?k=this.renderStackedColumn100(t):"stackedBar"===t.type?k=this.renderStackedBar(t):"stackedBar100"===t.type?k=this.renderStackedBar100(t):"stackedArea"===t.type?k=this.renderStackedArea(t):"stackedArea100"===t.type?k=this.renderStackedArea100(t):"bubble"===t.type?k=k=this.renderBubble(t):"scatter"===t.type?k=this.renderScatter(t):"pie"===t.type?this.renderPie(t):"doughnut"===t.type?
this.renderPie(t):"funnel"===t.type?k=this.renderFunnel(t):"pyramid"===t.type?k=this.renderFunnel(t):"candlestick"===t.type?k=this.renderCandlestick(t):"ohlc"===t.type?k=this.renderCandlestick(t):"rangeColumn"===t.type?k=this.renderRangeColumn(t):"error"===t.type?k=this.renderError(t):"rangeBar"===t.type?k=this.renderRangeBar(t):"rangeArea"===t.type?k=this.renderRangeArea(t):"rangeSplineArea"===t.type?k=this.renderRangeSplineArea(t):"waterfall"===t.type?k=this.renderWaterfall(t):"boxAndWhisker"===
t.type&&(k=this.renderBoxAndWhisker(t));for(b=0;b<t.dataSeriesIndexes.length;b++)this._dataInRenderedOrder.push(this.data[t.dataSeriesIndexes[b]]);this.animatedRender&&(t.targetCanvasCtx.miterLimit=g,k&&c.push(k))}this.ctx.miterLimit=f;this.animatedRender&&this._breaksCanvasCtx&&c.push({source:this._breaksCanvasCtx,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0,startTimePercent:0.7});this.animatedRender&&0<this._indexLabels.length&&(g=
ta(this.width,this.height).getContext("2d"),c.push(this.renderIndexLabels(g)));var r=this;if(0<c.length)r.disableToolTip=!0,r._animator.animate(200,r.animationDuration,function(a){r.ctx.clearRect(0,0,r.width,r.height);r.ctx.drawImage(e,0,0,Math.floor(r.width*ia),Math.floor(r.height*ia),0,0,r.width,r.height);for(var b=0;b<c.length;b++)k=c[b],1>a&&"undefined"!==typeof k.startTimePercent?a>=k.startTimePercent&&k.animationCallback(k.easingFunction(a-k.startTimePercent,0,1,1-k.startTimePercent),k):k.animationCallback(k.easingFunction(a,
0,1,1),k);r.dispatchEvent("dataAnimationIterationEnd",{chart:r})},function(){c=[];for(var a=0;a<r.plotInfo.plotTypes.length;a++)for(var b=r.plotInfo.plotTypes[a],d=0;d<b.plotUnits.length;d++)b.plotUnits[d].targetCanvas=null;e=null;r.disableToolTip=!1});else{if(r._breaksCanvas)if(v)r.plotArea.ctx.drawImage(r._breaksCanvas,0,0,this.width,this.height);else for(b=0;b<r._axes.length;b++)r._axes[b].createMask();0<r._indexLabels.length&&r.renderIndexLabels();r.dispatchEvent("dataAnimationIterationEnd",{chart:r})}this.attachPlotAreaEventHandlers();
this.zoomEnabled||(this.panEnabled||!this._zoomButton||"none"===this._zoomButton.style.display)||va(this._zoomButton,this._resetButton);this.toolTip._updateToolTip();this.renderCount++;this._breaksCanvas&&(delete this._breaksCanvas,delete this._breaksCanvasCtx);for(b=0;b<this._axes.length;b++)this._axes[b].maskCanvas&&(delete this._axes[b].maskCanvas,delete this._axes[b].maskCtx)};q.prototype.attachPlotAreaEventHandlers=function(){this.attachEvent({context:this,chart:this,mousedown:this._plotAreaMouseDown,
mouseup:this._plotAreaMouseUp,mousemove:this._plotAreaMouseMove,cursor:this.panEnabled?"move":"default",capture:!0,bounds:this.plotArea})};q.prototype.categoriseDataSeries=function(){for(var a="",f=0;f<this.data.length;f++)if(a=this.data[f],a.dataPoints&&(0!==a.dataPoints.length&&a.visible)&&0<=q._supportedChartTypes.indexOf(a.type)){for(var b=null,c=!1,e=null,g=!1,h=0;h<this.plotInfo.plotTypes.length;h++)if(this.plotInfo.plotTypes[h].type===a.type){c=!0;b=this.plotInfo.plotTypes[h];break}c||(b={type:a.type,
totalDataSeries:0,plotUnits:[]},this.plotInfo.plotTypes.push(b));for(h=0;h<b.plotUnits.length;h++)if(b.plotUnits[h].axisYType===a.axisYType&&b.plotUnits[h].axisXType===a.axisXType&&b.plotUnits[h].axisYIndex===a.axisYIndex&&b.plotUnits[h].axisXIndex===a.axisXIndex){g=!0;e=b.plotUnits[h];break}g||(e={type:a.type,previousDataSeriesCount:0,index:b.plotUnits.length,plotType:b,axisXType:a.axisXType,axisYType:a.axisYType,axisYIndex:a.axisYIndex,axisXIndex:a.axisXIndex,axisY:"primary"===a.axisYType?this.axisY[0<=
a.axisYIndex&&a.axisYIndex<this.axisY.length?a.axisYIndex:0]:this.axisY2[0<=a.axisYIndex&&a.axisYIndex<this.axisY2.length?a.axisYIndex:0],axisX:"primary"===a.axisXType?this.axisX[0<=a.axisXIndex&&a.axisXIndex<this.axisX.length?a.axisXIndex:0]:this.axisX2[0<=a.axisXIndex&&a.axisXIndex<this.axisX2.length?a.axisXIndex:0],dataSeriesIndexes:[],yTotals:[]},b.plotUnits.push(e));b.totalDataSeries++;e.dataSeriesIndexes.push(f);a.plotUnit=e}for(f=0;f<this.plotInfo.plotTypes.length;f++)for(b=this.plotInfo.plotTypes[f],
h=a=0;h<b.plotUnits.length;h++)b.plotUnits[h].previousDataSeriesCount=a,a+=b.plotUnits[h].dataSeriesIndexes.length};q.prototype.assignIdToDataPoints=function(){for(var a=0;a<this.data.length;a++){var f=this.data[a];if(f.dataPoints)for(var b=f.dataPoints.length,c=0;c<b;c++)f.dataPointIds[c]=++this._eventManager.lastObjectId}};q.prototype._processData=function(){this.assignIdToDataPoints();this.categoriseDataSeries();for(var a=0;a<this.plotInfo.plotTypes.length;a++)for(var f=this.plotInfo.plotTypes[a],
b=0;b<f.plotUnits.length;b++){var c=f.plotUnits[b];"line"===c.type||"stepLine"===c.type||"spline"===c.type||"column"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"bar"===c.type||"bubble"===c.type||"scatter"===c.type?this._processMultiseriesPlotUnit(c):"stackedColumn"===c.type||"stackedBar"===c.type||"stackedArea"===c.type?this._processStackedPlotUnit(c):"stackedColumn100"===c.type||"stackedBar100"===c.type||"stackedArea100"===c.type?this._processStacked100PlotUnit(c):"candlestick"===
c.type||"ohlc"===c.type||"rangeColumn"===c.type||"rangeBar"===c.type||"rangeArea"===c.type||"rangeSplineArea"===c.type||"error"===c.type||"boxAndWhisker"===c.type?this._processMultiYPlotUnit(c):"waterfall"===c.type&&this._processSpecificPlotUnit(c)}this.calculateAutoBreaks()};q.prototype._processMultiseriesPlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length))for(var f=a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=0;h<a.dataSeriesIndexes.length;h++){var l=this.data[a.dataSeriesIndexes[h]],
t=0,k=!1,r=!1,p;if("normal"===l.axisPlacement||"xySwapped"===l.axisPlacement)var n=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:a.axisX.logarithmic?0:-Infinity,d=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?
this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(l.dataPoints[t].x&&l.dataPoints[t].x.getTime||"dateTime"===l.xValueType)g=!0;for(t=0;t<l.dataPoints.length;t++){"undefined"===typeof l.dataPoints[t].x&&(l.dataPoints[t].x=t+(a.axisX.logarithmic?1:0));l.dataPoints[t].x.getTime?(g=!0,c=l.dataPoints[t].x.getTime()):c=l.dataPoints[t].x;e=l.dataPoints[t].y;c<b.min&&(b.min=c);c>b.max&&(b.max=c);e<f.min&&"number"===typeof e&&(f.min=e);
e>f.max&&"number"===typeof e&&(f.max=e);if(0<t){if(a.axisX.logarithmic){var w=c/l.dataPoints[t-1].x;1>w&&(w=1/w);b.minDiff>w&&1!==w&&(b.minDiff=w)}else w=c-l.dataPoints[t-1].x,0>w&&(w*=-1),b.minDiff>w&&0!==w&&(b.minDiff=w);null!==e&&null!==l.dataPoints[t-1].y&&(a.axisY.logarithmic?(w=e/l.dataPoints[t-1].y,1>w&&(w=1/w),f.minDiff>w&&1!==w&&(f.minDiff=w)):(w=e-l.dataPoints[t-1].y,0>w&&(w*=-1),f.minDiff>w&&0!==w&&(f.minDiff=w)))}if(c<n&&!k)null!==e&&(p=c);else{if(!k&&(k=!0,0<t)){t-=2;continue}if(c>d&&
!r)r=!0;else if(c>d&&r)continue;l.dataPoints[t].label&&(a.axisX.labels[c]=l.dataPoints[t].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);null===e?b.viewPortMin===c&&p<c&&(b.viewPortMin=p):(e<f.viewPortMin&&"number"===typeof e&&(f.viewPortMin=e),e>f.viewPortMax&&"number"===typeof e&&(f.viewPortMax=e))}}l.axisX.valueType=l.xValueType=g?"dateTime":"number"}};q.prototype._processStackedPlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)){for(var f=
a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=[],l=[],t=Infinity,k=-Infinity,r=0;r<a.dataSeriesIndexes.length;r++){var p=this.data[a.dataSeriesIndexes[r]],n=0,d=!1,w=!1,ya;if("normal"===p.axisPlacement||"xySwapped"===p.axisPlacement)var D=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:-Infinity,
u=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(p.dataPoints[n].x&&p.dataPoints[n].x.getTime||"dateTime"===p.xValueType)g=!0;for(n=0;n<p.dataPoints.length;n++){"undefined"===typeof p.dataPoints[n].x&&(p.dataPoints[n].x=n+(a.axisX.logarithmic?1:0));p.dataPoints[n].x.getTime?(g=!0,c=p.dataPoints[n].x.getTime()):
c=p.dataPoints[n].x;e=y(p.dataPoints[n].y)?0:p.dataPoints[n].y;c<b.min&&(b.min=c);c>b.max&&(b.max=c);if(0<n){if(a.axisX.logarithmic){var m=c/p.dataPoints[n-1].x;1>m&&(m=1/m);b.minDiff>m&&1!==m&&(b.minDiff=m)}else m=c-p.dataPoints[n-1].x,0>m&&(m*=-1),b.minDiff>m&&0!==m&&(b.minDiff=m);null!==e&&null!==p.dataPoints[n-1].y&&(a.axisY.logarithmic?0<e&&(m=e/p.dataPoints[n-1].y,1>m&&(m=1/m),f.minDiff>m&&1!==m&&(f.minDiff=m)):(m=e-p.dataPoints[n-1].y,0>m&&(m*=-1),f.minDiff>m&&0!==m&&(f.minDiff=m)))}if(c<D&&
!d)null!==p.dataPoints[n].y&&(ya=c);else{if(!d&&(d=!0,0<n)){n-=2;continue}if(c>u&&!w)w=!0;else if(c>u&&w)continue;p.dataPoints[n].label&&(a.axisX.labels[c]=p.dataPoints[n].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);null===p.dataPoints[n].y?b.viewPortMin===c&&ya<c&&(b.viewPortMin=ya):(a.yTotals[c]=(a.yTotals[c]?a.yTotals[c]:0)+e,0<=e?h[c]?h[c]+=e:(h[c]=e,t=Math.min(e,t)):l[c]?l[c]+=e:(l[c]=e,k=Math.max(e,k)))}}a.axisY.scaleBreaks&&(a.axisY.scaleBreaks.autoCalculate&&
1<=a.axisY.scaleBreaks.maxNumberOfAutoBreaks)&&(f.dataPointYPositiveSums?(f.dataPointYPositiveSums.push.apply(f.dataPointYPositiveSums,h),f.dataPointYNegativeSums.push.apply(f.dataPointYPositiveSums,l)):(f.dataPointYPositiveSums=h,f.dataPointYNegativeSums=l));p.axisX.valueType=p.xValueType=g?"dateTime":"number"}for(n in h)h.hasOwnProperty(n)&&!isNaN(n)&&(a=h[n],a<f.min&&(f.min=Math.min(a,t)),a>f.max&&(f.max=a),n<b.viewPortMin||n>b.viewPortMax||(a<f.viewPortMin&&(f.viewPortMin=Math.min(a,t)),a>f.viewPortMax&&
(f.viewPortMax=a)));for(n in l)l.hasOwnProperty(n)&&!isNaN(n)&&(a=l[n],a<f.min&&(f.min=a),a>f.max&&(f.max=Math.max(a,k)),n<b.viewPortMin||n>b.viewPortMax||(a<f.viewPortMin&&(f.viewPortMin=a),a>f.viewPortMax&&(f.viewPortMax=Math.max(a,k))))}};q.prototype._processStacked100PlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)){for(var f=a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=!1,l=!1,t=[],k=0;k<a.dataSeriesIndexes.length;k++){var r=this.data[a.dataSeriesIndexes[k]],p=0,
n=!1,d=!1,w;if("normal"===r.axisPlacement||"xySwapped"===r.axisPlacement)var m=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:-Infinity,D=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:
this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(r.dataPoints[p].x&&r.dataPoints[p].x.getTime||"dateTime"===r.xValueType)g=!0;for(p=0;p<r.dataPoints.length;p++){"undefined"===typeof r.dataPoints[p].x&&(r.dataPoints[p].x=p+(a.axisX.logarithmic?1:0));r.dataPoints[p].x.getTime?(g=!0,c=r.dataPoints[p].x.getTime()):c=r.dataPoints[p].x;e=y(r.dataPoints[p].y)?null:r.dataPoints[p].y;c<b.min&&(b.min=c);c>b.max&&(b.max=c);if(0<p){if(a.axisX.logarithmic){var u=c/r.dataPoints[p-
1].x;1>u&&(u=1/u);b.minDiff>u&&1!==u&&(b.minDiff=u)}else u=c-r.dataPoints[p-1].x,0>u&&(u*=-1),b.minDiff>u&&0!==u&&(b.minDiff=u);y(e)||null===r.dataPoints[p-1].y||(a.axisY.logarithmic?0<e&&(u=e/r.dataPoints[p-1].y,1>u&&(u=1/u),f.minDiff>u&&1!==u&&(f.minDiff=u)):(u=e-r.dataPoints[p-1].y,0>u&&(u*=-1),f.minDiff>u&&0!==u&&(f.minDiff=u)))}if(c<m&&!n)null!==e&&(w=c);else{if(!n&&(n=!0,0<p)){p-=2;continue}if(c>D&&!d)d=!0;else if(c>D&&d)continue;r.dataPoints[p].label&&(a.axisX.labels[c]=r.dataPoints[p].label);
c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);null===e?b.viewPortMin===c&&w<c&&(b.viewPortMin=w):(a.yTotals[c]=(a.yTotals[c]?a.yTotals[c]:0)+e,0<=e?h=!0:0>e&&(l=!0),t[c]=t[c]?t[c]+Math.abs(e):Math.abs(e))}}r.axisX.valueType=r.xValueType=g?"dateTime":"number"}a.axisY.logarithmic?(f.max=y(f.viewPortMax)?99*Math.pow(a.axisY.logarithmBase,-0.05):Math.max(f.viewPortMax,99*Math.pow(a.axisY.logarithmBase,-0.05)),f.min=y(f.viewPortMin)?1:Math.min(f.viewPortMin,1)):h&&!l?(f.max=y(f.viewPortMax)?
99:Math.max(f.viewPortMax,99),f.min=y(f.viewPortMin)?1:Math.min(f.viewPortMin,1)):h&&l?(f.max=y(f.viewPortMax)?99:Math.max(f.viewPortMax,99),f.min=y(f.viewPortMin)?-99:Math.min(f.viewPortMin,-99)):!h&&l&&(f.max=y(f.viewPortMax)?-1:Math.max(f.viewPortMax,-1),f.min=y(f.viewPortMin)?-99:Math.min(f.viewPortMin,-99));f.viewPortMin=f.min;f.viewPortMax=f.max;a.dataPointYSums=t}};q.prototype._processMultiYPlotUnit=function(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length))for(var f=a.axisY.dataInfo,
b=a.axisX.dataInfo,c,e,g,h,l=!1,t=0;t<a.dataSeriesIndexes.length;t++){var k=this.data[a.dataSeriesIndexes[t]],r=0,p=!1,n=!1,d,w,m;if("normal"===k.axisPlacement||"xySwapped"===k.axisPlacement)var D=a.axisX.sessionVariables.newViewportMinimum?a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:a.axisX.logarithmic?0:-Infinity,u=a.axisX.sessionVariables.newViewportMaximum?
a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;if(k.dataPoints[r].x&&k.dataPoints[r].x.getTime||"dateTime"===k.xValueType)l=!0;for(r=0;r<k.dataPoints.length;r++){"undefined"===typeof k.dataPoints[r].x&&(k.dataPoints[r].x=r+(a.axisX.logarithmic?1:0));k.dataPoints[r].x.getTime?(l=!0,c=k.dataPoints[r].x.getTime()):c=k.dataPoints[r].x;
if((e=k.dataPoints[r].y)&&e.length){g=Math.min.apply(null,e);h=Math.max.apply(null,e);w=!0;for(var v=0;v<e.length;v++)null===e.k&&(w=!1);w&&(p||(m=d),d=c)}c<b.min&&(b.min=c);c>b.max&&(b.max=c);g<f.min&&(f.min=g);h>f.max&&(f.max=h);0<r&&(a.axisX.logarithmic?(w=c/k.dataPoints[r-1].x,1>w&&(w=1/w),b.minDiff>w&&1!==w&&(b.minDiff=w)):(w=c-k.dataPoints[r-1].x,0>w&&(w*=-1),b.minDiff>w&&0!==w&&(b.minDiff=w)),e&&(null!==e[0]&&k.dataPoints[r-1].y&&null!==k.dataPoints[r-1].y[0])&&(a.axisY.logarithmic?(w=e[0]/
k.dataPoints[r-1].y[0],1>w&&(w=1/w),f.minDiff>w&&1!==w&&(f.minDiff=w)):(w=e[0]-k.dataPoints[r-1].y[0],0>w&&(w*=-1),f.minDiff>w&&0!==w&&(f.minDiff=w))));if(!(c<D)||p){if(!p&&(p=!0,0<r)){r-=2;d=m;continue}if(c>u&&!n)n=!0;else if(c>u&&n)continue;k.dataPoints[r].label&&(a.axisX.labels[c]=k.dataPoints[r].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);if(b.viewPortMin===c&&e)for(v=0;v<e.length;v++)if(null===e[v]&&d<c){b.viewPortMin=d;break}null===e?b.viewPortMin===c&&d<c&&
(b.viewPortMin=d):(g<f.viewPortMin&&(f.viewPortMin=g),h>f.viewPortMax&&(f.viewPortMax=h))}}k.axisX.valueType=k.xValueType=l?"dateTime":"number"}};q.prototype._processSpecificPlotUnit=function(a){if("waterfall"===a.type&&a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length))for(var f=a.axisY.dataInfo,b=a.axisX.dataInfo,c,e,g=!1,h=0;h<a.dataSeriesIndexes.length;h++){var l=this.data[a.dataSeriesIndexes[h]],t=0,k=!1,r=!1,p=c=0;if("normal"===l.axisPlacement||"xySwapped"===l.axisPlacement)var n=a.axisX.sessionVariables.newViewportMinimum?
a.axisX.sessionVariables.newViewportMinimum:this.options.axisX&&this.options.axisX.viewportMinimum?this.options.axisX.viewportMinimum:this.options.axisX&&this.options.axisX.minimum?this.options.axisX.minimum:a.axisX.logarithmic?0:-Infinity,d=a.axisX.sessionVariables.newViewportMaximum?a.axisX.sessionVariables.newViewportMaximum:this.options.axisX&&this.options.axisX.viewportMaximum?this.options.axisX.viewportMaximum:this.options.axisX&&this.options.axisX.maximum?this.options.axisX.maximum:Infinity;
if(l.dataPoints[t].x&&l.dataPoints[t].x.getTime||"dateTime"===l.xValueType)g=!0;for(t=0;t<l.dataPoints.length;t++)"undefined"!==typeof l.dataPoints[t].isCumulativeSum&&!0===l.dataPoints[t].isCumulativeSum?(l.dataPointEOs[t].cumulativeSumYStartValue=0,l.dataPointEOs[t].cumulativeSum=0===t?0:l.dataPointEOs[t-1].cumulativeSum,l.dataPoints[t].y=0===t?0:l.dataPointEOs[t-1].cumulativeSum):"undefined"!==typeof l.dataPoints[t].isIntermediateSum&&!0===l.dataPoints[t].isIntermediateSum?(l.dataPointEOs[t].cumulativeSumYStartValue=
p,l.dataPointEOs[t].cumulativeSum=0===t?0:l.dataPointEOs[t-1].cumulativeSum,l.dataPoints[t].y=0===t?0:c,p=0===t?0:l.dataPointEOs[t-1].cumulativeSum,c=0):(e="number"!==typeof l.dataPoints[t].y?0:l.dataPoints[t].y,l.dataPointEOs[t].cumulativeSumYStartValue=0===t?0:l.dataPointEOs[t-1].cumulativeSum,l.dataPointEOs[t].cumulativeSum=0===t?e:l.dataPointEOs[t-1].cumulativeSum+e,c+=e);for(t=0;t<l.dataPoints.length;t++)if("undefined"===typeof l.dataPoints[t].x&&(l.dataPoints[t].x=t+(a.axisX.logarithmic?1:0)),
l.dataPoints[t].x.getTime?(g=!0,c=l.dataPoints[t].x.getTime()):c=l.dataPoints[t].x,e=l.dataPoints[t].y,c<b.min&&(b.min=c),c>b.max&&(b.max=c),l.dataPointEOs[t].cumulativeSum<f.min&&(f.min=l.dataPointEOs[t].cumulativeSum),l.dataPointEOs[t].cumulativeSum>f.max&&(f.max=l.dataPointEOs[t].cumulativeSum),0<t&&(a.axisX.logarithmic?(p=c/l.dataPoints[t-1].x,1>p&&(p=1/p),b.minDiff>p&&1!==p&&(b.minDiff=p)):(p=c-l.dataPoints[t-1].x,0>p&&(p*=-1),b.minDiff>p&&0!==p&&(b.minDiff=p)),null!==e&&null!==l.dataPoints[t-
1].y&&(a.axisY.logarithmic?(e=l.dataPointEOs[t].cumulativeSum/l.dataPointEOs[t-1].cumulativeSum,1>e&&(e=1/e),f.minDiff>e&&1!==e&&(f.minDiff=e)):(e=l.dataPointEOs[t].cumulativeSum-l.dataPointEOs[t-1].cumulativeSum,0>e&&(e*=-1),f.minDiff>e&&0!==e&&(f.minDiff=e)))),!(c<n)||k){if(!k&&(k=!0,0<t)){t-=2;continue}if(c>d&&!r)r=!0;else if(c>d&&r)continue;l.dataPoints[t].label&&(a.axisX.labels[c]=l.dataPoints[t].label);c<b.viewPortMin&&(b.viewPortMin=c);c>b.viewPortMax&&(b.viewPortMax=c);0<t&&(l.dataPointEOs[t-
1].cumulativeSum<f.viewPortMin&&(f.viewPortMin=l.dataPointEOs[t-1].cumulativeSum),l.dataPointEOs[t-1].cumulativeSum>f.viewPortMax&&(f.viewPortMax=l.dataPointEOs[t-1].cumulativeSum));l.dataPointEOs[t].cumulativeSum<f.viewPortMin&&(f.viewPortMin=l.dataPointEOs[t].cumulativeSum);l.dataPointEOs[t].cumulativeSum>f.viewPortMax&&(f.viewPortMax=l.dataPointEOs[t].cumulativeSum)}l.axisX.valueType=l.xValueType=g?"dateTime":"number"}};q.prototype.calculateAutoBreaks=function(){function a(a,c,b,e){if(e)return b=
Math.pow(Math.min(b*a/c,c/a),0.2),1>=b&&(b=Math.pow(1>a?1/a:Math.min(c/a,a),0.25)),{startValue:a*b,endValue:c/b};b=0.2*Math.min(b-c+a,c-a);0>=b&&(b=0.25*Math.min(c-a,Math.abs(a)));return{startValue:a+b,endValue:c-b}}function f(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)){var c=a.axisX.scaleBreaks&&a.axisX.scaleBreaks.autoCalculate&&1<=a.axisX.scaleBreaks.maxNumberOfAutoBreaks,b=a.axisY.scaleBreaks&&a.axisY.scaleBreaks.autoCalculate&&1<=a.axisY.scaleBreaks.maxNumberOfAutoBreaks;if(c||
b)for(var f=a.axisY.dataInfo,g=a.axisX.dataInfo,k,h=g.min,n=g.max,l=f.min,t=f.max,g=g._dataRanges,f=f._dataRanges,p,r=0,m=0;m<a.dataSeriesIndexes.length;m++){var v=e.data[a.dataSeriesIndexes[m]];if(!(4>v.dataPoints.length))for(r=0;r<v.dataPoints.length;r++)if(c&&(p=(n+1-h)*Math.max(parseFloat(a.axisX.scaleBreaks.collapsibleThreshold)||10,10)/100,k=v.dataPoints[r].x.getTime?v.dataPoints[r].x.getTime():v.dataPoints[r].x,p=Math.floor((k-h)/p),k<g[p].min&&(g[p].min=k),k>g[p].max&&(g[p].max=k)),b){var q=
(t+1-l)*Math.max(parseFloat(a.axisY.scaleBreaks.collapsibleThreshold)||10,10)/100;if((k="waterfall"===a.type?v.dataPointEOs[r].cumulativeSum:v.dataPoints[r].y)&&k.length)for(var s=0;s<k.length;s++)p=Math.floor((k[s]-l)/q),k[s]<f[p].min&&(f[p].min=k[s]),k[s]>f[p].max&&(f[p].max=k[s]);else y(k)||(p=Math.floor((k-l)/q),k<f[p].min&&(f[p].min=k),k>f[p].max&&(f[p].max=k))}}}}function b(a){if(a.dataSeriesIndexes&&!(1>a.dataSeriesIndexes.length)&&a.axisX.scaleBreaks&&a.axisX.scaleBreaks.autoCalculate&&1<=
a.axisX.scaleBreaks.maxNumberOfAutoBreaks)for(var c=a.axisX.dataInfo,b=c.min,f=c.max,g=c._dataRanges,k,h=0,n=0;n<a.dataSeriesIndexes.length;n++){var l=e.data[a.dataSeriesIndexes[n]];if(!(4>l.dataPoints.length))for(h=0;h<l.dataPoints.length;h++)k=(f+1-b)*Math.max(parseFloat(a.axisX.scaleBreaks.collapsibleThreshold)||10,10)/100,c=l.dataPoints[h].x.getTime?l.dataPoints[h].x.getTime():l.dataPoints[h].x,k=Math.floor((c-b)/k),c<g[k].min&&(g[k].min=c),c>g[k].max&&(g[k].max=c)}}for(var c,e=this,g=!1,h=0;h<
this._axes.length;h++)if(this._axes[h].scaleBreaks&&this._axes[h].scaleBreaks.autoCalculate&&1<=this._axes[h].scaleBreaks.maxNumberOfAutoBreaks){g=!0;this._axes[h].dataInfo._dataRanges=[];for(var l=0;l<100/Math.max(parseFloat(this._axes[h].scaleBreaks.collapsibleThreshold)||10,10);l++)this._axes[h].dataInfo._dataRanges.push({min:Infinity,max:-Infinity})}if(g){for(h=0;h<this.plotInfo.plotTypes.length;h++)for(g=this.plotInfo.plotTypes[h],l=0;l<g.plotUnits.length;l++)c=g.plotUnits[l],"line"===c.type||
"stepLine"===c.type||"spline"===c.type||"column"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"bar"===c.type||"bubble"===c.type||"scatter"===c.type||"candlestick"===c.type||"ohlc"===c.type||"rangeColumn"===c.type||"rangeBar"===c.type||"rangeArea"===c.type||"rangeSplineArea"===c.type||"waterfall"===c.type||"error"===c.type||"boxAndWhisker"===c.type?f(c):0<=c.type.indexOf("stacked")&&b(c);for(h=0;h<this._axes.length;h++)if(this._axes[h].dataInfo._dataRanges){var t=this._axes[h].dataInfo.min;
c=(this._axes[h].dataInfo.max+1-t)*Math.max(parseFloat(this._axes[h].scaleBreaks.collapsibleThreshold)||10,10)/100;var k=this._axes[h].dataInfo._dataRanges,r,p,g=[];if(this._axes[h].dataInfo.dataPointYPositiveSums){var n=this._axes[h].dataInfo.dataPointYPositiveSums;r=k;for(l in n)n.hasOwnProperty(l)&&!isNaN(l)&&(p=n[l],y(p)||(index=Math.floor((p-t)/c),p<r[index].min&&(r[index].min=p),p>r[index].max&&(r[index].max=p)));delete this._axes[h].dataInfo.dataPointYPositiveSums}if(this._axes[h].dataInfo.dataPointYNegativeSums){n=
this._axes[h].dataInfo.dataPointYNegativeSums;r=k;for(l in n)n.hasOwnProperty(l)&&!isNaN(l)&&(p=-1*n[l],y(p)||(index=Math.floor((p-t)/c),p<r[index].min&&(r[index].min=p),p>r[index].max&&(r[index].max=p)));delete this._axes[h].dataInfo.dataPointYNegativeSums}for(l=0;l<k.length-1;l++)if(r=k[l].max,isFinite(r))for(;l<k.length-1;)if(t=k[l+1].min,isFinite(t)){p=t-r;p>c&&g.push({diff:p,start:r,end:t});break}else l++;if(this._axes[h].scaleBreaks.customBreaks)for(l=0;l<this._axes[h].scaleBreaks.customBreaks.length;l++)for(c=
0;c<g.length;c++)if(this._axes[h].scaleBreaks.customBreaks[l].startValue<=g[c].start&&g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].endValue||this._axes[h].scaleBreaks.customBreaks[l].startValue<=g[c].start&&g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].endValue||g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].startValue&&this._axes[h].scaleBreaks.customBreaks[l].startValue<=g[c].end||g[c].start<=this._axes[h].scaleBreaks.customBreaks[l].endValue&&this._axes[h].scaleBreaks.customBreaks[l].endValue<=
g[c].end)g.splice(c,1),c--;g.sort(function(a,c){return c.diff-a.diff});for(l=0;l<Math.min(g.length,this._axes[h].scaleBreaks.maxNumberOfAutoBreaks);l++)c=a(g[l].start,g[l].end,this._axes[h].logarithmic?this._axes[h].dataInfo.max/this._axes[h].dataInfo.min:this._axes[h].dataInfo.max-this._axes[h].dataInfo.min,this._axes[h].logarithmic),this._axes[h].scaleBreaks.autoBreaks.push(new ba(this,"autoBreaks",c,l,++this._eventManager.lastObjectId,this._axes[h].scaleBreaks)),this._axes[h].scaleBreaks._appliedBreaks.push(this._axes[h].scaleBreaks.autoBreaks[this._axes[h].scaleBreaks.autoBreaks.length-
1]);this._axes[h].scaleBreaks._appliedBreaks.sort(function(a,c){return a.startValue-c.startValue})}}};q.prototype.getDataPointAtXY=function(a,f,b){b=b||!1;for(var c=[],e=this._dataInRenderedOrder.length-1;0<=e;e--){var g=null;(g=this._dataInRenderedOrder[e].getDataPointAtXY(a,f,b))&&c.push(g)}a=null;f=!1;for(b=0;b<c.length;b++)if("line"===c[b].dataSeries.type||"stepLine"===c[b].dataSeries.type||"area"===c[b].dataSeries.type||"stepArea"===c[b].dataSeries.type)if(e=ja("markerSize",c[b].dataPoint,c[b].dataSeries)||
8,c[b].distance<=e/2){f=!0;break}for(b=0;b<c.length;b++)f&&"line"!==c[b].dataSeries.type&&"stepLine"!==c[b].dataSeries.type&&"area"!==c[b].dataSeries.type&&"stepArea"!==c[b].dataSeries.type||(a?c[b].distance<=a.distance&&(a=c[b]):a=c[b]);return a};q.prototype.getObjectAtXY=function(a,f,b){var c=null;if(b=this.getDataPointAtXY(a,f,b||!1))c=b.dataSeries.dataPointIds[b.dataPointIndex];else if(v)c=Wa(a,f,this._eventManager.ghostCtx);else for(b=0;b<this.legend.items.length;b++){var e=this.legend.items[b];
a>=e.x1&&(a<=e.x2&&f>=e.y1&&f<=e.y2)&&(c=e.id)}return c};q.prototype.getAutoFontSize=function(a,f,b){f=Math.min(this.width,this.height);return Math.max("theme4"===this.theme?0:300<=f?12:10,Math.round(f*(a/400)))};q.prototype.resetOverlayedCanvas=function(){this.overlaidCanvasCtx.clearRect(0,0,this.width,this.height)};q.prototype.clearCanvas=function(){this.ctx.clearRect(0,0,this.width,this.height);this.backgroundColor&&(this.ctx.fillStyle=this.backgroundColor,this.ctx.fillRect(0,0,this.width,this.height))};
q.prototype.attachEvent=function(a){this._events.push(a)};q.prototype._touchEventHandler=function(a){if(a.changedTouches&&this.interactivityEnabled){var f=[],b=a.changedTouches,c=b?b[0]:a,e=null;switch(a.type){case "touchstart":case "MSPointerDown":f=["mousemove","mousedown"];this._lastTouchData=Oa(c);this._lastTouchData.time=new Date;break;case "touchmove":case "MSPointerMove":f=["mousemove"];break;case "touchend":case "MSPointerUp":var g=this._lastTouchData&&this._lastTouchData.time?new Date-this._lastTouchData.time:
0,f="touchstart"===this._lastTouchEventType||"MSPointerDown"===this._lastTouchEventType||300>g?["mouseup","click"]:["mouseup"];break;default:return}if(!(b&&1<b.length)){e=Oa(c);e.time=new Date;try{var h=e.y-this._lastTouchData.y,g=e.time-this._lastTouchData.time;if(15<Math.abs(h)&&(this._lastTouchData.scroll||300>g)){this._lastTouchData.scroll=!0;var l=window.parent||window;l&&l.scrollBy&&l.scrollBy(0,-h)}}catch(t){}this._lastTouchEventType=a.type;if(this._lastTouchData.scroll&&this.zoomEnabled)this.isDrag&&
this.resetOverlayedCanvas(),this.isDrag=!1;else for(b=0;b<f.length;b++)e=f[b],g=document.createEvent("MouseEvent"),g.initMouseEvent(e,!0,!0,window,1,c.screenX,c.screenY,c.clientX,c.clientY,!1,!1,!1,!1,0,null),c.target.dispatchEvent(g),a.preventManipulation&&a.preventManipulation(),a.preventDefault&&a.preventDefault()}}};q.prototype._dispatchRangeEvent=function(a,f){var b={chart:this};b.type=a;b.trigger=f;var c=[];this.axisX&&0<this.axisX.length&&c.push("axisX");this.axisX2&&0<this.axisX2.length&&
c.push("axisX2");this.axisY&&0<this.axisY.length&&c.push("axisY");this.axisY2&&0<this.axisY2.length&&c.push("axisY2");for(var e=0;e<c.length;e++)if(y(b[c[e]])&&(b[c[e]]=[]),"axisY"===c[e])for(var g=0;g<this.axisY.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});else if("axisY2"===c[e])for(g=0;g<this.axisY2.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,
viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});else if("axisX"===c[e])for(g=0;g<this.axisX.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});else if("axisX2"===c[e])for(g=0;g<this.axisX2.length;g++)b[c[e]].push({viewportMinimum:this[c[e]][g].sessionVariables.newViewportMinimum,viewportMaximum:this[c[e]][g].sessionVariables.newViewportMaximum});this.dispatchEvent(a,b,this)};
q.prototype._mouseEventHandler=function(a){"undefined"===typeof a.target&&a.srcElement&&(a.target=a.srcElement);var f=Oa(a),b=a.type,c,e;a.which?e=3==a.which:a.button&&(e=2==a.button);q.capturedEventParam&&(c=q.capturedEventParam,"mouseup"===b&&(q.capturedEventParam=null,c.chart.overlaidCanvas.releaseCapture?c.chart.overlaidCanvas.releaseCapture():document.documentElement.removeEventListener("mouseup",c.chart._mouseEventHandler,!1)),c.hasOwnProperty(b)&&("mouseup"!==b||c.chart.overlaidCanvas.releaseCapture?
a.target!==c.chart.overlaidCanvas&&v||c[b].call(c.context,f.x,f.y):a.target!==c.chart.overlaidCanvas&&(c.chart.isDrag=!1)));if(this.interactivityEnabled)if(this._ignoreNextEvent)this._ignoreNextEvent=!1;else if(a.preventManipulation&&a.preventManipulation(),a.preventDefault&&a.preventDefault(),!e){if(!q.capturedEventParam&&this._events){for(var g=0;g<this._events.length;g++)if(this._events[g].hasOwnProperty(b))if(c=this._events[g],e=c.bounds,f.x>=e.x1&&f.x<=e.x2&&f.y>=e.y1&&f.y<=e.y2){c[b].call(c.context,
f.x,f.y);"mousedown"===b&&!0===c.capture?(q.capturedEventParam=c,this.overlaidCanvas.setCapture?this.overlaidCanvas.setCapture():document.documentElement.addEventListener("mouseup",this._mouseEventHandler,!1)):"mouseup"===b&&(c.chart.overlaidCanvas.releaseCapture?c.chart.overlaidCanvas.releaseCapture():document.documentElement.removeEventListener("mouseup",this._mouseEventHandler,!1));break}else c=null;a.target.style.cursor=c&&c.cursor?c.cursor:this._defaultCursor}b=this.plotArea;if(f.x<b.x1||f.x>
b.x2||f.y<b.y1||f.y>b.y2)this.toolTip&&this.toolTip.enabled?this.toolTip.hide():this.resetOverlayedCanvas();this.isDrag&&this.zoomEnabled||!this._eventManager||this._eventManager.mouseEventHandler(a)}};q.prototype._plotAreaMouseDown=function(a,f){this.isDrag=!0;this.dragStartPoint={x:a,y:f}};q.prototype._plotAreaMouseUp=function(a,f){if(("normal"===this.plotInfo.axisPlacement||"xySwapped"===this.plotInfo.axisPlacement)&&this.isDrag){var b=f-this.dragStartPoint.y,c=a-this.dragStartPoint.x,e=0<=this.zoomType.indexOf("x"),
g=0<=this.zoomType.indexOf("y"),h=!1;this.resetOverlayedCanvas();if("xySwapped"===this.plotInfo.axisPlacement)var l=g,g=e,e=l;if(this.panEnabled||this.zoomEnabled){if(this.panEnabled)for(e=g=0;e<this._axes.length;e++)b=this._axes[e],b.logarithmic?b.viewportMinimum<b.minimum?(g=b.minimum/b.viewportMinimum,b.sessionVariables.newViewportMinimum=b.viewportMinimum*g,b.sessionVariables.newViewportMaximum=b.viewportMaximum*g,h=!0):b.viewportMaximum>b.maximum&&(g=b.viewportMaximum/b.maximum,b.sessionVariables.newViewportMinimum=
b.viewportMinimum/g,b.sessionVariables.newViewportMaximum=b.viewportMaximum/g,h=!0):b.viewportMinimum<b.minimum?(g=b.minimum-b.viewportMinimum,b.sessionVariables.newViewportMinimum=b.viewportMinimum+g,b.sessionVariables.newViewportMaximum=b.viewportMaximum+g,h=!0):b.viewportMaximum>b.maximum&&(g=b.viewportMaximum-b.maximum,b.sessionVariables.newViewportMinimum=b.viewportMinimum-g,b.sessionVariables.newViewportMaximum=b.viewportMaximum-g,h=!0);else if((!e||2<Math.abs(c))&&(!g||2<Math.abs(b))&&this.zoomEnabled){if(!this.dragStartPoint)return;
b=e?this.dragStartPoint.x:this.plotArea.x1;c=g?this.dragStartPoint.y:this.plotArea.y1;e=e?a:this.plotArea.x2;g=g?f:this.plotArea.y2;2<Math.abs(b-e)&&2<Math.abs(c-g)&&this._zoomPanToSelectedRegion(b,c,e,g)&&(h=!0)}h&&(this._ignoreNextEvent=!0,this._dispatchRangeEvent("rangeChanging","zoom"),this.render(),this._dispatchRangeEvent("rangeChanged","zoom"),h&&(this.zoomEnabled&&"none"===this._zoomButton.style.display)&&(Ma(this._zoomButton,this._resetButton),ua(this,this._zoomButton,"pan"),ua(this,this._resetButton,
"reset")))}}this.isDrag=!1;if("none"!==this.plotInfo.axisPlacement){this.resetOverlayedCanvas();if(this.axisX&&0<this.axisX.length)for(h=0;h<this.axisX.length;h++)this.axisX[h].crosshair&&this.axisX[h].crosshair.enabled&&this.axisX[h].renderCrosshair(a,f);if(this.axisX2&&0<this.axisX2.length)for(h=0;h<this.axisX2.length;h++)this.axisX2[h].crosshair&&this.axisX2[h].crosshair.enabled&&this.axisX2[h].renderCrosshair(a,f);if(this.axisY&&0<this.axisY.length)for(h=0;h<this.axisY.length;h++)this.axisY[h].crosshair&&
this.axisY[h].crosshair.enabled&&this.axisY[h].renderCrosshair(a,f);if(this.axisY2&&0<this.axisY2.length)for(h=0;h<this.axisY2.length;h++)this.axisY2[h].crosshair&&this.axisY2[h].crosshair.enabled&&this.axisY2[h].renderCrosshair(a,f)}};q.prototype._plotAreaMouseMove=function(a,f){if(this.isDrag&&"none"!==this.plotInfo.axisPlacement){var b=0,c=0,e=b=null,e=0<=this.zoomType.indexOf("x"),g=0<=this.zoomType.indexOf("y"),h=this;"xySwapped"===this.plotInfo.axisPlacement&&(b=g,g=e,e=b);b=this.dragStartPoint.x-
a;c=this.dragStartPoint.y-f;2<Math.abs(b)&&8>Math.abs(b)&&(this.panEnabled||this.zoomEnabled)?this.toolTip.hide():this.panEnabled||this.zoomEnabled||this.toolTip.mouseMoveHandler(a,f);if((!e||2<Math.abs(b)||!g||2<Math.abs(c))&&(this.panEnabled||this.zoomEnabled))if(this.panEnabled)e={x1:e?this.plotArea.x1+b:this.plotArea.x1,y1:g?this.plotArea.y1+c:this.plotArea.y1,x2:e?this.plotArea.x2+b:this.plotArea.x2,y2:g?this.plotArea.y2+c:this.plotArea.y2},clearTimeout(h._panTimerId),h._panTimerId=setTimeout(function(c,
b,e,d){return function(){h._zoomPanToSelectedRegion(c,b,e,d,!0)&&(h._dispatchRangeEvent("rangeChanging","pan"),h.render(),h._dispatchRangeEvent("rangeChanged","pan"),h.dragStartPoint.x=a,h.dragStartPoint.y=f)}}(e.x1,e.y1,e.x2,e.y2),0);else if(this.zoomEnabled){this.resetOverlayedCanvas();b=this.overlaidCanvasCtx.globalAlpha;this.overlaidCanvasCtx.fillStyle="#A89896";var c=e?this.dragStartPoint.x:this.plotArea.x1,l=g?this.dragStartPoint.y:this.plotArea.y1,t=e?a-this.dragStartPoint.x:this.plotArea.x2-
this.plotArea.x1,k=g?f-this.dragStartPoint.y:this.plotArea.y2-this.plotArea.y1;this.validateRegion(c,l,e?a:this.plotArea.x2-this.plotArea.x1,g?f:this.plotArea.y2-this.plotArea.y1,"xy"!==this.zoomType).isValid&&(this.resetOverlayedCanvas(),this.overlaidCanvasCtx.fillStyle="#99B2B5");this.overlaidCanvasCtx.globalAlpha=0.7;this.overlaidCanvasCtx.fillRect(c,l,t,k);this.overlaidCanvasCtx.globalAlpha=b}}else if(this.toolTip.mouseMoveHandler(a,f),"none"!==this.plotInfo.axisPlacement){if(this.axisX&&0<this.axisX.length)for(e=
0;e<this.axisX.length;e++)this.axisX[e].crosshair&&this.axisX[e].crosshair.enabled&&this.axisX[e].renderCrosshair(a,f);if(this.axisX2&&0<this.axisX2.length)for(e=0;e<this.axisX2.length;e++)this.axisX2[e].crosshair&&this.axisX2[e].crosshair.enabled&&this.axisX2[e].renderCrosshair(a,f);if(this.axisY&&0<this.axisY.length)for(e=0;e<this.axisY.length;e++)this.axisY[e].crosshair&&this.axisY[e].crosshair.enabled&&this.axisY[e].renderCrosshair(a,f);if(this.axisY2&&0<this.axisY2.length)for(e=0;e<this.axisY2.length;e++)this.axisY2[e].crosshair&&
this.axisY2[e].crosshair.enabled&&this.axisY2[e].renderCrosshair(a,f)}};q.prototype._zoomPanToSelectedRegion=function(a,f,b,c,e){a=this.validateRegion(a,f,b,c,e);f=a.axesWithValidRange;b=a.axesRanges;if(a.isValid)for(c=0;c<f.length;c++)e=b[c],f[c].setViewPortRange(e.val1,e.val2);return a.isValid};q.prototype.validateRegion=function(a,f,b,c,e){e=e||!1;for(var g=0<=this.zoomType.indexOf("x"),h=0<=this.zoomType.indexOf("y"),l=!1,t=[],k=[],r=[],p=0;p<this._axes.length;p++)("axisX"===this._axes[p].type&&
g||"axisY"===this._axes[p].type&&h)&&k.push(this._axes[p]);for(h=0;h<k.length;h++){var p=k[h],g=!1,n=p.convertPixelToValue({x:a,y:f}),d=p.convertPixelToValue({x:b,y:c});if(n>d)var w=d,d=n,n=w;if(p.scaleBreaks)for(w=0;!g&&w<p.scaleBreaks._appliedBreaks.length;w++)g=p.scaleBreaks._appliedBreaks[w].startValue<=n&&p.scaleBreaks._appliedBreaks[w].endValue>=d;if(isFinite(p.dataInfo.minDiff))if(w=p.getApparentDifference(n,d,null,!0),!(g||!(this.panEnabled&&p.scaleBreaks&&p.scaleBreaks._appliedBreaks.length)&&
(p.logarithmic&&w<Math.pow(p.dataInfo.minDiff,3)||!p.logarithmic&&w<3*Math.abs(p.dataInfo.minDiff))||n<p.minimum||d>p.maximum))t.push(p),r.push({val1:n,val2:d}),l=!0;else if(!e){l=!1;break}}return{isValid:l,axesWithValidRange:t,axesRanges:r}};q.prototype.preparePlotArea=function(){var a=this.plotArea;!v&&(0<a.x1||0<a.y1)&&a.ctx.translate(a.x1,a.y1);if((this.axisX[0]||this.axisX2[0])&&(this.axisY[0]||this.axisY2[0])){var f=this.axisX[0]?this.axisX[0].lineCoordinates:this.axisX2[0].lineCoordinates;
if(this.axisY&&0<this.axisY.length&&this.axisY[0]){var b=this.axisY[0];a.x1=f.x1<f.x2?f.x1:b.lineCoordinates.x1;a.y1=f.y1<b.lineCoordinates.y1?f.y1:b.lineCoordinates.y1;a.x2=f.x2>b.lineCoordinates.x2?f.x2:b.lineCoordinates.x2;a.y2=f.y2>f.y1?f.y2:b.lineCoordinates.y2;a.width=a.x2-a.x1;a.height=a.y2-a.y1}this.axisY2&&0<this.axisY2.length&&this.axisY2[0]&&(b=this.axisY2[0],a.x1=f.x1<f.x2?f.x1:b.lineCoordinates.x1,a.y1=f.y1<b.lineCoordinates.y1?f.y1:b.lineCoordinates.y1,a.x2=f.x2>b.lineCoordinates.x2?
f.x2:b.lineCoordinates.x2,a.y2=f.y2>f.y1?f.y2:b.lineCoordinates.y2,a.width=a.x2-a.x1,a.height=a.y2-a.y1)}else f=this.layoutManager.getFreeSpace(),a.x1=f.x1,a.x2=f.x2,a.y1=f.y1,a.y2=f.y2,a.width=f.width,a.height=f.height;v||(a.canvas.width=a.width,a.canvas.height=a.height,a.canvas.style.left=a.x1+"px",a.canvas.style.top=a.y1+"px",(0<a.x1||0<a.y1)&&a.ctx.translate(-a.x1,-a.y1));a.layoutManager=new Da(a.x1,a.y1,a.x2,a.y2,2)};q.prototype.renderIndexLabels=function(a){var f=a||this.plotArea.ctx,b=this.plotArea,
c=0,e=0,g=0,h=0,l=c=h=e=g=0,t=0;for(a=0;a<this._indexLabels.length;a++){var k=this._indexLabels[a],r=k.chartType.toLowerCase(),p,n,l=ja("indexLabelFontColor",k.dataPoint,k.dataSeries),t=ja("indexLabelFontSize",k.dataPoint,k.dataSeries);p=ja("indexLabelFontFamily",k.dataPoint,k.dataSeries);n=ja("indexLabelFontStyle",k.dataPoint,k.dataSeries);var h=ja("indexLabelFontWeight",k.dataPoint,k.dataSeries),d=ja("indexLabelBackgroundColor",k.dataPoint,k.dataSeries),e=ja("indexLabelMaxWidth",k.dataPoint,k.dataSeries),
g=ja("indexLabelWrap",k.dataPoint,k.dataSeries),w=ja("indexLabelLineDashType",k.dataPoint,k.dataSeries),m=ja("indexLabelLineColor",k.dataPoint,k.dataSeries),D=y(k.dataPoint.indexLabelLineThickness)?y(k.dataSeries.options.indexLabelLineThickness)?0:k.dataSeries.options.indexLabelLineThickness:k.dataPoint.indexLabelLineThickness,c=0<D?Math.min(10,("normal"===this.plotInfo.axisPlacement?this.plotArea.height:this.plotArea.width)<<0):0,u={percent:null,total:null},Q=null;if(0<=k.dataSeries.type.indexOf("stacked")||
"pie"===k.dataSeries.type||"doughnut"===k.dataSeries.type)u=this.getPercentAndTotal(k.dataSeries,k.dataPoint);if(k.dataSeries.indexLabelFormatter||k.dataPoint.indexLabelFormatter)Q={chart:this,dataSeries:k.dataSeries,dataPoint:k.dataPoint,index:k.indexKeyword,total:u.total,percent:u.percent};var H=k.dataPoint.indexLabelFormatter?k.dataPoint.indexLabelFormatter(Q):k.dataPoint.indexLabel?this.replaceKeywordsWithValue(k.dataPoint.indexLabel,k.dataPoint,k.dataSeries,null,k.indexKeyword):k.dataSeries.indexLabelFormatter?
k.dataSeries.indexLabelFormatter(Q):k.dataSeries.indexLabel?this.replaceKeywordsWithValue(k.dataSeries.indexLabel,k.dataPoint,k.dataSeries,null,k.indexKeyword):null;if(null!==H&&""!==H){var u=ja("indexLabelPlacement",k.dataPoint,k.dataSeries),Q=ja("indexLabelOrientation",k.dataPoint,k.dataSeries),q=k.direction,s=k.dataSeries.axisX,A=k.dataSeries.axisY,x=!1,d=new ka(f,{x:0,y:0,maxWidth:e?e:0.5*this.width,maxHeight:g?5*t:1.5*t,angle:"horizontal"===Q?0:-90,text:H,padding:0,backgroundColor:d,horizontalAlign:"left",
fontSize:t,fontFamily:p,fontWeight:h,fontColor:l,fontStyle:n,textBaseline:"top"});d.measureText();k.dataSeries.indexLabelMaxWidth=d.maxWidth;if("stackedarea100"===r){if(k.point.x<b.x1||k.point.x>b.x2||k.point.y<b.y1-1||k.point.y>b.y2+1)continue}else if("rangearea"===r||"rangesplinearea"===r){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||Math.max.apply(null,k.dataPoint.y)<A.viewportMinimum||Math.min.apply(null,k.dataPoint.y)>A.viewportMaximum)continue}else if(0<=r.indexOf("line")||
0<=r.indexOf("area")||0<=r.indexOf("bubble")||0<=r.indexOf("scatter")){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||k.dataPoint.y<A.viewportMinimum||k.dataPoint.y>A.viewportMaximum)continue}else if(0<=r.indexOf("column")||"waterfall"===r||"error"===r&&!k.axisSwapped){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||k.bounds.y1>b.y2||k.bounds.y2<b.y1)continue}else if(0<=r.indexOf("bar")||"error"===r){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||
k.bounds.x1>b.x2||k.bounds.x2<b.x1)continue}else if("candlestick"===r||"ohlc"===r){if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum||Math.max.apply(null,k.dataPoint.y)<A.viewportMinimum||Math.min.apply(null,k.dataPoint.y)>A.viewportMaximum)continue}else if(k.dataPoint.x<s.viewportMinimum||k.dataPoint.x>s.viewportMaximum)continue;e=h=2;"horizontal"===Q?(l=d.width,t=d.height):(t=d.width,l=d.height);if("normal"===this.plotInfo.axisPlacement){if(0<=r.indexOf("line")||0<=r.indexOf("area"))u=
"auto",h=4;else if(0<=r.indexOf("stacked"))"auto"===u&&(u="inside");else if("bubble"===r||"scatter"===r)u="inside";p=k.point.x-l/2;"inside"!==u?(e=b.y1,g=b.y2,0<q?(n=k.point.y-t-h-c,n<e&&(n="auto"===u?Math.max(k.point.y,e)+h+c:e+h+c,x=n+t>k.point.y)):(n=k.point.y+h+c,n>g-t-h-c&&(n="auto"===u?Math.min(k.point.y,g)-t-h-c:g-t-h-c,x=n<k.point.y))):(e=Math.max(k.bounds.y1,b.y1),g=Math.min(k.bounds.y2,b.y2),c=0<=r.indexOf("range")||"error"===r?0<q?Math.max(k.bounds.y1,b.y1)+t/2+h:Math.min(k.bounds.y2,b.y2)-
t/2-h:(Math.max(k.bounds.y1,b.y1)+Math.min(k.bounds.y2,b.y2))/2,0<q?(n=Math.max(k.point.y,c)-t/2,n<e&&("bubble"===r||"scatter"===r)&&(n=Math.max(k.point.y-t-h,b.y1+h))):(n=Math.min(k.point.y,c)-t/2,n>g-t-h&&("bubble"===r||"scatter"===r)&&(n=Math.min(k.point.y+h,b.y2-t-h))),n=Math.min(n,g-t))}else 0<=r.indexOf("line")||0<=r.indexOf("area")||0<=r.indexOf("scatter")?(u="auto",e=4):0<=r.indexOf("stacked")?"auto"===u&&(u="inside"):"bubble"===r&&(u="inside"),n=k.point.y-t/2,"inside"!==u?(h=b.x1,g=b.x2,
0>q?(p=k.point.x-l-e-c,p<h&&(p="auto"===u?Math.max(k.point.x,h)+e+c:h+e+c,x=p+l>k.point.x)):(p=k.point.x+e+c,p>g-l-e-c&&(p="auto"===u?Math.min(k.point.x,g)-l-e-c:g-l-e-c,x=p<k.point.x))):(h=Math.max(k.bounds.x1,b.x1),Math.min(k.bounds.x2,b.x2),c=0<=r.indexOf("range")||"error"===r?0>q?Math.max(k.bounds.x1,b.x1)+l/2+e:Math.min(k.bounds.x2,b.x2)-l/2-e:(Math.max(k.bounds.x1,b.x1)+Math.min(k.bounds.x2,b.x2))/2,p=0>q?Math.max(k.point.x,c)-l/2:Math.min(k.point.x,c)-l/2,p=Math.max(p,h));"vertical"===Q&&(n+=
t);d.x=p;d.y=n;d.render(!0);D&&("inside"!==u&&(0>r.indexOf("bar")&&("error"!==r||!k.axisSwapped)&&k.point.x>b.x1&&k.point.x<b.x2||!x)&&(0>r.indexOf("column")&&("error"!==r||k.axisSwapped)&&k.point.y>b.y1&&k.point.y<b.y2||!x))&&(f.lineWidth=D,f.strokeStyle=m?m:"gray",f.setLineDash&&f.setLineDash(F(w,D)),f.beginPath(),f.moveTo(k.point.x,k.point.y),0<=r.indexOf("bar")||"error"===r&&k.axisSwapped?f.lineTo(p+(0<k.direction?0:l),n+("horizontal"===Q?t:-t)/2):0<=r.indexOf("column")||"error"===r&&!k.axisSwapped?
f.lineTo(p+l/2,n+((0<k.direction?t:-t)+("horizontal"===Q?t:-t))/2):f.lineTo(p+l/2,n+((n<k.point.y?t:-t)+("horizontal"===Q?t:-t))/2),f.stroke())}}f={source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0,startTimePercent:0.7};for(a=0;a<this._indexLabels.length;a++)k=this._indexLabels[a],d=ja("indexLabelBackgroundColor",k.dataPoint,k.dataSeries),k.dataSeries.indexLabelBackgroundColor=y(d)?v?"transparent":null:d;return f};q.prototype.renderLine=
function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this._eventManager.ghostCtx;b.save();var e=this.plotArea;b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();for(var g=[],h,l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t];b.lineWidth=k.lineThickness;var r=k.dataPoints,p="solid";if(b.setLineDash){var n=F(k.nullDataLineDashType,k.lineThickness),p=k.lineDashType,d=F(p,k.lineThickness);b.setLineDash(d)}var w=
k.id;this._eventManager.objectMap[w]={objectType:"dataSeries",dataSeriesIndex:t};w=R(w);c.strokeStyle=w;c.lineWidth=0<k.lineThickness?Math.max(k.lineThickness,4):0;var w=k._colorSet,m=w=k.lineColor=k.options.lineColor?k.options.lineColor:w[0];b.strokeStyle=w;var D=!0,u=0,Q,H;b.beginPath();if(0<r.length){for(var q=!1,u=0;u<r.length;u++)if(Q=r[u].x.getTime?r[u].x.getTime():r[u].x,!(Q<a.axisX.dataInfo.viewPortMin||Q>a.axisX.dataInfo.viewPortMax&&(!k.connectNullData||!q)))if("number"!==typeof r[u].y)0<
u&&!(k.connectNullData||q||D)&&(b.stroke(),v&&c.stroke()),q=!0;else{Q=a.axisX.convertValueToPixel(Q);H=a.axisY.convertValueToPixel(r[u].y);var s=k.dataPointIds[u];this._eventManager.objectMap[s]={id:s,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:u,x1:Q,y1:H};D||q?(!D&&k.connectNullData?(b.setLineDash&&(k.options.nullDataLineDashType||p===k.lineDashType&&k.lineDashType!==k.nullDataLineDashType)&&(b.stroke(),b.beginPath(),b.moveTo(h.x,h.y),p=k.nullDataLineDashType,b.setLineDash(n)),b.lineTo(Q,
H),v&&c.lineTo(Q,H)):(b.beginPath(),b.moveTo(Q,H),v&&(c.beginPath(),c.moveTo(Q,H))),q=D=!1):(b.lineTo(Q,H),v&&c.lineTo(Q,H),0==u%500&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),v&&(c.stroke(),c.beginPath(),c.moveTo(Q,H))));h={x:Q,y:H};u<r.length-1&&(m!==(r[u].lineColor||w)||p!==(r[u].lineDashType||k.lineDashType))&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),m=r[u].lineColor||w,b.strokeStyle=m,b.setLineDash&&(r[u].lineDashType?(p=r[u].lineDashType,b.setLineDash(F(p,k.lineThickness))):(p=k.lineDashType,b.setLineDash(d))));
if(0<r[u].markerSize||0<k.markerSize){var A=k.getMarkerProperties(u,Q,H,b);g.push(A);s=R(s);v&&g.push({x:Q,y:H,ctx:c,type:A.type,size:A.size,color:s,borderColor:s,borderThickness:A.borderThickness})}(r[u].indexLabel||k.indexLabel||r[u].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"line",dataPoint:r[u],dataSeries:k,point:{x:Q,y:H},direction:0>r[u].y===a.axisY.reversed?1:-1,color:w})}b.stroke();v&&c.stroke()}}$.drawMarkers(g);v&&(f.drawImage(this._preRenderCanvas,0,
0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),c.beginPath());b.restore();b.beginPath();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,
animationBase:0}}};q.prototype.renderStepLine=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this._eventManager.ghostCtx;b.save();var e=this.plotArea;b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();for(var g=[],h,l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t];b.lineWidth=k.lineThickness;var r=k.dataPoints,p="solid";if(b.setLineDash){var n=F(k.nullDataLineDashType,k.lineThickness),
p=k.lineDashType,d=F(p,k.lineThickness);b.setLineDash(d)}var w=k.id;this._eventManager.objectMap[w]={objectType:"dataSeries",dataSeriesIndex:t};w=R(w);c.strokeStyle=w;c.lineWidth=0<k.lineThickness?Math.max(k.lineThickness,4):0;var w=k._colorSet,m=w=k.lineColor=k.options.lineColor?k.options.lineColor:w[0];b.strokeStyle=w;var D=!0,u=0,Q,H;b.beginPath();if(0<r.length){for(var q=!1,u=0;u<r.length;u++)if(Q=r[u].getTime?r[u].x.getTime():r[u].x,!(Q<a.axisX.dataInfo.viewPortMin||Q>a.axisX.dataInfo.viewPortMax&&
(!k.connectNullData||!q)))if("number"!==typeof r[u].y)0<u&&!(k.connectNullData||q||D)&&(b.stroke(),v&&c.stroke()),q=!0;else{var s=H;Q=a.axisX.convertValueToPixel(Q);H=a.axisY.convertValueToPixel(r[u].y);var A=k.dataPointIds[u];this._eventManager.objectMap[A]={id:A,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:u,x1:Q,y1:H};D||q?(!D&&k.connectNullData?(b.setLineDash&&(k.options.nullDataLineDashType||p===k.lineDashType&&k.lineDashType!==k.nullDataLineDashType)&&(b.stroke(),b.beginPath(),b.moveTo(h.x,
h.y),p=k.nullDataLineDashType,b.setLineDash(n)),b.lineTo(Q,s),b.lineTo(Q,H),v&&(c.lineTo(Q,s),c.lineTo(Q,H))):(b.beginPath(),b.moveTo(Q,H),v&&(c.beginPath(),c.moveTo(Q,H))),q=D=!1):(b.lineTo(Q,s),v&&c.lineTo(Q,s),b.lineTo(Q,H),v&&c.lineTo(Q,H),0==u%500&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),v&&(c.stroke(),c.beginPath(),c.moveTo(Q,H))));h={x:Q,y:H};u<r.length-1&&(m!==(r[u].lineColor||w)||p!==(r[u].lineDashType||k.lineDashType))&&(b.stroke(),b.beginPath(),b.moveTo(Q,H),m=r[u].lineColor||w,b.strokeStyle=
m,b.setLineDash&&(r[u].lineDashType?(p=r[u].lineDashType,b.setLineDash(F(p,k.lineThickness))):(p=k.lineDashType,b.setLineDash(d))));if(0<r[u].markerSize||0<k.markerSize)s=k.getMarkerProperties(u,Q,H,b),g.push(s),A=R(A),v&&g.push({x:Q,y:H,ctx:c,type:s.type,size:s.size,color:A,borderColor:A,borderThickness:s.borderThickness});(r[u].indexLabel||k.indexLabel||r[u].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"stepLine",dataPoint:r[u],dataSeries:k,point:{x:Q,y:H},direction:0>
r[u].y===a.axisY.reversed?1:-1,color:w})}b.stroke();v&&c.stroke()}}$.drawMarkers(g);v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),c.beginPath());
b.restore();b.beginPath();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderSpline=function(a){function f(a){a=x(a,2);if(0<a.length){c.beginPath();v&&e.beginPath();c.moveTo(a[0].x,a[0].y);a[0].newStrokeStyle&&(c.strokeStyle=a[0].newStrokeStyle);a[0].newLineDashArray&&c.setLineDash(a[0].newLineDashArray);v&&e.moveTo(a[0].x,a[0].y);for(var b=0;b<a.length-3;b+=3)if(c.bezierCurveTo(a[b+1].x,a[b+1].y,a[b+2].x,a[b+
2].y,a[b+3].x,a[b+3].y),v&&e.bezierCurveTo(a[b+1].x,a[b+1].y,a[b+2].x,a[b+2].y,a[b+3].x,a[b+3].y),0<b&&0===b%3E3||a[b+3].newStrokeStyle||a[b+3].newLineDashArray)c.stroke(),c.beginPath(),c.moveTo(a[b+3].x,a[b+3].y),a[b+3].newStrokeStyle&&(c.strokeStyle=a[b+3].newStrokeStyle),a[b+3].newLineDashArray&&c.setLineDash(a[b+3].newLineDashArray),v&&(e.stroke(),e.beginPath(),e.moveTo(a[b+3].x,a[b+3].y));c.stroke();v&&e.stroke()}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=
this._eventManager.ghostCtx;c.save();var g=this.plotArea;c.beginPath();c.rect(g.x1,g.y1,g.width,g.height);c.clip();for(var h=[],l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t];c.lineWidth=k.lineThickness;var r=k.dataPoints,p="solid";if(c.setLineDash){var n=F(k.nullDataLineDashType,k.lineThickness),p=k.lineDashType,d=F(p,k.lineThickness);c.setLineDash(d)}var w=k.id;this._eventManager.objectMap[w]={objectType:"dataSeries",dataSeriesIndex:t};w=R(w);e.strokeStyle=w;e.lineWidth=
0<k.lineThickness?Math.max(k.lineThickness,4):0;var w=k._colorSet,m=w=k.lineColor=k.options.lineColor?k.options.lineColor:w[0];c.strokeStyle=w;var D=0,u,Q,H=[];c.beginPath();if(0<r.length)for(Q=!1,D=0;D<r.length;D++)if(u=r[D].getTime?r[D].x.getTime():r[D].x,!(u<a.axisX.dataInfo.viewPortMin||u>a.axisX.dataInfo.viewPortMax&&(!k.connectNullData||!Q)))if("number"!==typeof r[D].y)0<D&&!Q&&(k.connectNullData?c.setLineDash&&(0<H.length&&(k.options.nullDataLineDashType||!r[D-1].lineDashType))&&(H[H.length-
1].newLineDashArray=n,p=k.nullDataLineDashType):(f(H),H=[])),Q=!0;else{u=a.axisX.convertValueToPixel(u);Q=a.axisY.convertValueToPixel(r[D].y);var s=k.dataPointIds[D];this._eventManager.objectMap[s]={id:s,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:D,x1:u,y1:Q};H[H.length]={x:u,y:Q};D<r.length-1&&(m!==(r[D].lineColor||w)||p!==(r[D].lineDashType||k.lineDashType))&&(m=r[D].lineColor||w,H[H.length-1].newStrokeStyle=m,c.setLineDash&&(r[D].lineDashType?(p=r[D].lineDashType,H[H.length-1].newLineDashArray=
F(p,k.lineThickness)):(p=k.lineDashType,H[H.length-1].newLineDashArray=d)));if(0<r[D].markerSize||0<k.markerSize){var q=k.getMarkerProperties(D,u,Q,c);h.push(q);s=R(s);v&&h.push({x:u,y:Q,ctx:e,type:q.type,size:q.size,color:s,borderColor:s,borderThickness:q.borderThickness})}(r[D].indexLabel||k.indexLabel||r[D].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"spline",dataPoint:r[D],dataSeries:k,point:{x:u,y:Q},direction:0>r[D].y===a.axisY.reversed?1:-1,color:w});Q=!1}f(H)}$.drawMarkers(h);
v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(g.x1,g.y1,g.width,g.height),e.beginPath());c.restore();c.beginPath();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,
easingFunction:O.easing.linear,animationBase:0}}};var X=function(a,f,b,c,e,g,h,l,t,k,r,p,n){"undefined"===typeof n&&(n=1);h=h||0;l=l||"black";var d=15<c-f&&15<e-b?8:0.35*Math.min(c-f,e-b);a.beginPath();a.moveTo(f,b);a.save();a.fillStyle=g;a.globalAlpha=n;a.fillRect(f,b,c-f,e-b);a.globalAlpha=1;0<h&&(n=0===h%2?0:0.5,a.beginPath(),a.lineWidth=h,a.strokeStyle=l,a.moveTo(f,b),a.rect(f-n,b-n,c-f+2*n,e-b+2*n),a.stroke());a.restore();!0===t&&(a.save(),a.beginPath(),a.moveTo(f,b),a.lineTo(f+d,b+d),a.lineTo(c-
d,b+d),a.lineTo(c,b),a.closePath(),h=a.createLinearGradient((c+f)/2,b+d,(c+f)/2,b),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, .4)"),a.fillStyle=h,a.fill(),a.restore());!0===k&&(a.save(),a.beginPath(),a.moveTo(f,e),a.lineTo(f+d,e-d),a.lineTo(c-d,e-d),a.lineTo(c,e),a.closePath(),h=a.createLinearGradient((c+f)/2,e-d,(c+f)/2,e),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, .4)"),a.fillStyle=h,a.fill(),a.restore());!0===r&&(a.save(),a.beginPath(),a.moveTo(f,b),a.lineTo(f+d,b+
d),a.lineTo(f+d,e-d),a.lineTo(f,e),a.closePath(),h=a.createLinearGradient(f+d,(e+b)/2,f,(e+b)/2),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, 0.1)"),a.fillStyle=h,a.fill(),a.restore());!0===p&&(a.save(),a.beginPath(),a.moveTo(c,b),a.lineTo(c-d,b+d),a.lineTo(c-d,e-d),a.lineTo(c,e),h=a.createLinearGradient(c-d,(e+b)/2,c,(e+b)/2),h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, 0.1)"),a.fillStyle=h,h.addColorStop(0,g),h.addColorStop(1,"rgba(255, 255, 255, 0.1)"),a.fillStyle=h,a.fill(),
a.closePath(),a.restore())};q.prototype.renderColumn=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=0,h,l,t,k=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*
this.width,0.9*(this.plotArea.width/a.plotType.totalDataSeries))<<0,p=a.axisX.dataInfo.minDiff;isFinite(p)||(p=0.3*Math.abs(a.axisX.range));p=this.dataPointWidth=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(p)/Math.log(a.axisX.range):Math.abs(p)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>r&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<
g)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));p<g&&(p=g);p>r&&(p=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(r=0;r<a.dataSeriesIndexes.length;r++){var n=a.dataSeriesIndexes[r],d=this.data[n],w=d.dataPoints;if(0<w.length)for(var m=5<p&&d.bevelEnabled?!0:!1,g=0;g<
w.length;g++)if(w[g].getTime?t=w[g].x.getTime():t=w[g].x,!(t<a.axisX.dataInfo.viewPortMin||t>a.axisX.dataInfo.viewPortMax)&&"number"===typeof w[g].y){h=a.axisX.convertValueToPixel(t);l=a.axisY.convertValueToPixel(w[g].y);h=a.axisX.reversed?h+a.plotType.totalDataSeries*p/2-(a.previousDataSeriesCount+r)*p<<0:h-a.plotType.totalDataSeries*p/2+(a.previousDataSeriesCount+r)*p<<0;var D=a.axisX.reversed?h-p<<0:h+p<<0,u;0<=w[g].y?u=k:(u=l,l=k);l>u&&(c=l,l=u,u=c);c=w[g].color?w[g].color:d._colorSet[g%d._colorSet.length];
X(b,h,l,D,u,c,0,null,m&&0<=w[g].y,0>w[g].y&&m,!1,!1,d.fillOpacity);c=d.dataPointIds[g];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:n,dataPointIndex:g,x1:h,y1:l,x2:D,y2:u};c=R(c);v&&X(this._eventManager.ghostCtx,h,l,D,u,c,0,null,!1,!1,!1,!1);(w[g].indexLabel||d.indexLabel||w[g].indexLabelFormatter||d.indexLabelFormatter)&&this._indexLabels.push({chartType:"column",dataPoint:w[g],dataSeries:d,point:{x:h+(D-h)/2,y:0>w[g].y===a.axisY.reversed?l:u},direction:0>w[g].y===
a.axisY.reversed?1:-1,bounds:{x1:h,y1:Math.min(l,u),x2:D,y2:Math.max(l,u)},color:c})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.yScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:k<a.axisY.bounds.y1?a.axisY.bounds.y1:k>a.axisY.bounds.y2?a.axisY.bounds.y2:k}}};q.prototype.renderStackedColumn=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),k=
this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.width<<0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&
k>r&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<k)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<k&&(d=k);d>r&&(d=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=
a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length){var Q=5<d&&D.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===typeof u[k].y){r=a.axisX.convertValueToPixel(c);var H=r-a.plotType.plotUnits.length*d/2+a.index*d<<0,s=H+d<<0,q;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0<u[k].y)l[c]=u[k].y+(l[c]?l[c]:
0),0<l[c]&&(p=a.axisY.convertValueToPixel(l[c]),q="undefined"!==typeof g[c]?g[c]:n,g[c]=p);else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=u[k].y+(t[c]?t[c]:0),q=a.axisY.convertValueToPixel(t[c]),p="undefined"!==typeof h[c]?h[c]:n,h[c]=q;else if(p=a.axisY.convertValueToPixel(u[k].y),0<=u[k].y){var y="undefined"!==typeof g[c]?g[c]:0;p-=y;q=n-y;g[c]=y+(q-p)}else y=h[c]?h[c]:0,q=p+y,p=n+y,h[c]=y+(q-p);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];
X(b,H,p,s,q,c,0,null,Q&&0<=u[k].y,0>u[k].y&&Q,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:H,y1:p,x2:s,y2:q};c=R(c);v&&X(this._eventManager.ghostCtx,H,p,s,q,c,0,null,!1,!1,!1,!1);(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedColumn",dataPoint:u[k],dataSeries:D,point:{x:r,y:0<=u[k].y?p:q},direction:0>u[k].y===a.axisY.reversed?1:
-1,bounds:{x1:H,y1:Math.min(p,q),x2:s,y2:Math.max(p,q)},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.yScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.y1?a.axisY.bounds.y1:n>a.axisY.bounds.y2?a.axisY.bounds.y2:n}}};q.prototype.renderStackedColumn100=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),
k=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.width<<0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&
k>r&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<k)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<k&&(d=k);d>r&&(d=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=
a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length)for(var Q=5<d&&D.bevelEnabled?!0:!1,k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===typeof u[k].y){r=a.axisX.convertValueToPixel(c);p=0!==a.dataPointYSums[c]?100*(u[k].y/a.dataPointYSums[c]):0;var q=r-a.plotType.plotUnits.length*d/2+a.index*d<<0,s=q+d<<0,y;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&
0<u[k].y){l[c]=p+("undefined"!==typeof l[c]?l[c]:0);if(0>=l[c])continue;p=a.axisY.convertValueToPixel(l[c]);y=g[c]?g[c]:n;g[c]=p}else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=p+("undefined"!==typeof t[c]?t[c]:0),y=a.axisY.convertValueToPixel(t[c]),p=h[c]?h[c]:n,h[c]=y;else if(p=a.axisY.convertValueToPixel(p),0<=u[k].y){var A="undefined"!==typeof g[c]?g[c]:0;p-=A;y=n-A;a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.y1-p)&&(p=e.y1);g[c]=A+(y-p)}else A="undefined"!==
typeof h[c]?h[c]:0,y=p+A,p=n+A,a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.y2-y)&&(y=e.y2),h[c]=A+(y-p);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];X(b,q,p,s,y,c,0,null,Q&&0<=u[k].y,0>u[k].y&&Q,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:q,y1:p,x2:s,y2:y};c=R(c);v&&X(this._eventManager.ghostCtx,q,p,s,y,c,0,null,!1,!1,!1,!1);(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&
this._indexLabels.push({chartType:"stackedColumn100",dataPoint:u[k],dataSeries:D,point:{x:r,y:0<=u[k].y?p:y},direction:0>u[k].y===a.axisY.reversed?1:-1,bounds:{x1:q,y1:Math.min(p,y),x2:s,y2:Math.max(p,y)},color:c})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&
this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.yScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.y1?a.axisY.bounds.y1:n>a.axisY.bounds.y2?a.axisY.bounds.y2:n}}};q.prototype.renderBar=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=
null,e=this.plotArea,g=0,h,l,t,k=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,r=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*this.height,0.9*(this.plotArea.height/a.plotType.totalDataSeries))<<0,p=a.axisX.dataInfo.minDiff;isFinite(p)||(p=0.3*Math.abs(a.axisX.range));p=this.options.dataPointWidth?
this.dataPointWidth:0.9*(e.height*(a.axisX.logarithmic?Math.log(p)/Math.log(a.axisX.range):Math.abs(p)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>r&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,r));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&r<g)&&(r=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));p<g&&(p=g);p>r&&(p=r);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);
b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(r=0;r<a.dataSeriesIndexes.length;r++){var n=a.dataSeriesIndexes[r],d=this.data[n],w=d.dataPoints;if(0<w.length){var m=5<p&&d.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(g=0;g<w.length;g++)if(w[g].getTime?t=w[g].x.getTime():t=w[g].x,!(t<a.axisX.dataInfo.viewPortMin||t>a.axisX.dataInfo.viewPortMax)&&"number"===typeof w[g].y){l=a.axisX.convertValueToPixel(t);
h=a.axisY.convertValueToPixel(w[g].y);l=a.axisX.reversed?l+a.plotType.totalDataSeries*p/2-(a.previousDataSeriesCount+r)*p<<0:l-a.plotType.totalDataSeries*p/2+(a.previousDataSeriesCount+r)*p<<0;var D=a.axisX.reversed?l-p<<0:l+p<<0,u;0<=w[g].y?u=k:(u=h,h=k);c=w[g].color?w[g].color:d._colorSet[g%d._colorSet.length];X(b,u,l,h,D,c,0,null,m,!1,!1,!1,d.fillOpacity);c=d.dataPointIds[g];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:n,dataPointIndex:g,x1:u,y1:l,x2:h,y2:D};c=R(c);
v&&X(this._eventManager.ghostCtx,u,l,h,D,c,0,null,!1,!1,!1,!1);(w[g].indexLabel||d.indexLabel||w[g].indexLabelFormatter||d.indexLabelFormatter)&&this._indexLabels.push({chartType:"bar",dataPoint:w[g],dataSeries:d,point:{x:0<=w[g].y?h:u,y:l+(D-l)/2},direction:0>w[g].y===a.axisY.reversed?1:-1,bounds:{x1:Math.min(u,h),y1:l,x2:Math.max(u,h),y2:D},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,
0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:k<a.axisY.bounds.x1?a.axisY.bounds.x1:k>a.axisY.bounds.x2?a.axisY.bounds.x2:
k}}};q.prototype.renderStackedBar=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),k=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;p=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.height<<
0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.height*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&k>p&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,p));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&p<k)&&(p=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<
k&&(d=k);d>p&&(d=p);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length){var q=5<d&&D.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():
u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===typeof u[k].y){p=a.axisX.convertValueToPixel(c);var s=p-a.plotType.plotUnits.length*d/2+a.index*d<<0,y=s+d<<0,B;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0<u[k].y)l[c]=u[k].y+(l[c]?l[c]:0),0<l[c]&&(B=g[c]?g[c]:n,g[c]=r=a.axisY.convertValueToPixel(l[c]));else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=u[k].y+(t[c]?t[c]:0),r=h[c]?
h[c]:n,h[c]=B=a.axisY.convertValueToPixel(t[c]);else if(r=a.axisY.convertValueToPixel(u[k].y),0<=u[k].y){var A=g[c]?g[c]:0;B=n+A;r+=A;g[c]=A+(r-B)}else A=h[c]?h[c]:0,B=r-A,r=n-A,h[c]=A+(r-B);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];X(b,B,s,r,y,c,0,null,q,!1,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:B,y1:s,x2:r,y2:y};c=R(c);v&&X(this._eventManager.ghostCtx,B,s,r,y,c,0,null,!1,!1,!1,!1);
(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedBar",dataPoint:u[k],dataSeries:D,point:{x:0<=u[k].y?r:B,y:p},direction:0>u[k].y===a.axisY.reversed?1:-1,bounds:{x1:Math.min(B,r),y1:s,x2:Math.max(B,r),y2:y},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,
0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.x1?a.axisY.bounds.x1:n>a.axisY.bounds.x2?a.axisY.bounds.x2:n}}};q.prototype.renderStackedBar100=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,
b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=[],h=[],l=[],t=[],k=0,r,p,n=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),k=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;p=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.15*this.height<<0;var d=a.axisX.dataInfo.minDiff;isFinite(d)||(d=0.3*Math.abs(a.axisX.range));d=
this.options.dataPointWidth?this.dataPointWidth:0.9*(e.height*(a.axisX.logarithmic?Math.log(d)/Math.log(a.axisX.range):Math.abs(d)/Math.abs(a.axisX.range))/a.plotType.plotUnits.length)<<0;this.dataPointMaxWidth&&k>p&&(k=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,p));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&p<k)&&(p=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,k));d<k&&(d=k);d>p&&(d=p);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();
b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var w=0;w<a.dataSeriesIndexes.length;w++){var m=a.dataSeriesIndexes[w],D=this.data[m],u=D.dataPoints;if(0<u.length){var q=5<d&&D.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(k=0;k<u.length;k++)if(c=u[k].x.getTime?u[k].x.getTime():u[k].x,!(c<a.axisX.dataInfo.viewPortMin||c>a.axisX.dataInfo.viewPortMax)&&"number"===
typeof u[k].y){p=a.axisX.convertValueToPixel(c);var s;s=0!==a.dataPointYSums[c]?100*(u[k].y/a.dataPointYSums[c]):0;var y=p-a.plotType.plotUnits.length*d/2+a.index*d<<0,B=y+d<<0;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0<u[k].y){l[c]=s+(l[c]?l[c]:0);if(0>=l[c])continue;s=g[c]?g[c]:n;g[c]=r=a.axisY.convertValueToPixel(l[c])}else if(a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length&&0>=u[k].y)t[c]=s+(t[c]?t[c]:0),r=h[c]?h[c]:n,h[c]=s=a.axisY.convertValueToPixel(t[c]);
else if(r=a.axisY.convertValueToPixel(s),0<=u[k].y){var A=g[c]?g[c]:0;s=n+A;r+=A;a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.x2-r)&&(r=e.x2);g[c]=A+(r-s)}else A=h[c]?h[c]:0,s=r-A,r=n-A,a.dataSeriesIndexes.length-1===w&&1>=Math.abs(e.x1-s)&&(s=e.x1),h[c]=A+(r-s);c=u[k].color?u[k].color:D._colorSet[k%D._colorSet.length];X(b,s,y,r,B,c,0,null,q,!1,!1,!1,D.fillOpacity);c=D.dataPointIds[k];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:m,dataPointIndex:k,x1:s,y1:y,x2:r,
y2:B};c=R(c);v&&X(this._eventManager.ghostCtx,s,y,r,B,c,0,null,!1,!1,!1,!1);(u[k].indexLabel||D.indexLabel||u[k].indexLabelFormatter||D.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedBar100",dataPoint:u[k],dataSeries:D,point:{x:0<=u[k].y?r:s,y:p},direction:0>u[k].y===a.axisY.reversed?1:-1,bounds:{x1:Math.min(s,r),y1:y,x2:Math.max(s,r),y2:B},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,
0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.xScaleAnimation,easingFunction:O.easing.easeOutQuart,animationBase:n<a.axisY.bounds.x1?a.axisY.bounds.x1:n>a.axisY.bounds.x2?a.axisY.bounds.x2:
n}}};q.prototype.renderArea=function(a){var f,b;function c(){A&&(0<w.lineThickness&&g.stroke(),a.axisY.logarithmic||0>=a.axisY.viewportMinimum&&0<=a.axisY.viewportMaximum?B=y:0>a.axisY.viewportMaximum?B=t.y1:0<a.axisY.viewportMinimum&&(B=l.y2),g.lineTo(u,B),g.lineTo(A.x,B),g.closePath(),g.globalAlpha=w.fillOpacity,g.fill(),g.globalAlpha=1,v&&(h.lineTo(u,B),h.lineTo(A.x,B),h.closePath(),h.fill()),g.beginPath(),g.moveTo(u,s),h.beginPath(),h.moveTo(u,s),A={x:u,y:s})}var e=a.targetCanvasCtx||this.plotArea.ctx,
g=v?this._preRenderCtx:e;if(!(0>=a.dataSeriesIndexes.length)){var h=this._eventManager.ghostCtx,l=a.axisX.lineCoordinates,t=a.axisY.lineCoordinates,k=[],r=this.plotArea,p;g.save();v&&h.save();g.beginPath();g.rect(r.x1,r.y1,r.width,r.height);g.clip();v&&(h.beginPath(),h.rect(r.x1,r.y1,r.width,r.height),h.clip());for(var n=0;n<a.dataSeriesIndexes.length;n++){var d=a.dataSeriesIndexes[n],w=this.data[d],m=w.dataPoints,k=w.id;this._eventManager.objectMap[k]={objectType:"dataSeries",dataSeriesIndex:d};
k=R(k);h.fillStyle=k;k=[];f=!0;var D=0,u,s,q,y=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),B,A=null;if(0<m.length){var x=w._colorSet[D%w._colorSet.length],z=w.lineColor=w.options.lineColor||x,L=z;g.fillStyle=x;g.strokeStyle=z;g.lineWidth=w.lineThickness;b="solid";if(g.setLineDash){var K=F(w.nullDataLineDashType,w.lineThickness);b=w.lineDashType;var da=F(b,w.lineThickness);g.setLineDash(da)}for(var ca=!0;D<m.length;D++)if(q=m[D].x.getTime?m[D].x.getTime():m[D].x,!(q<
a.axisX.dataInfo.viewPortMin||q>a.axisX.dataInfo.viewPortMax&&(!w.connectNullData||!ca)))if("number"!==typeof m[D].y)w.connectNullData||(ca||f)||c(),ca=!0;else{u=a.axisX.convertValueToPixel(q);s=a.axisY.convertValueToPixel(m[D].y);f||ca?(!f&&w.connectNullData?(g.setLineDash&&(w.options.nullDataLineDashType||b===w.lineDashType&&w.lineDashType!==w.nullDataLineDashType)&&(f=u,b=s,u=p.x,s=p.y,c(),g.moveTo(p.x,p.y),u=f,s=b,A=p,b=w.nullDataLineDashType,g.setLineDash(K)),g.lineTo(u,s),v&&h.lineTo(u,s)):
(g.beginPath(),g.moveTo(u,s),v&&(h.beginPath(),h.moveTo(u,s)),A={x:u,y:s}),ca=f=!1):(g.lineTo(u,s),v&&h.lineTo(u,s),0==D%250&&c());p={x:u,y:s};D<m.length-1&&(L!==(m[D].lineColor||z)||b!==(m[D].lineDashType||w.lineDashType))&&(c(),L=m[D].lineColor||z,g.strokeStyle=L,g.setLineDash&&(m[D].lineDashType?(b=m[D].lineDashType,g.setLineDash(F(b,w.lineThickness))):(b=w.lineDashType,g.setLineDash(da))));var aa=w.dataPointIds[D];this._eventManager.objectMap[aa]={id:aa,objectType:"dataPoint",dataSeriesIndex:d,
dataPointIndex:D,x1:u,y1:s};0!==m[D].markerSize&&(0<m[D].markerSize||0<w.markerSize)&&(q=w.getMarkerProperties(D,u,s,g),k.push(q),aa=R(aa),v&&k.push({x:u,y:s,ctx:h,type:q.type,size:q.size,color:aa,borderColor:aa,borderThickness:q.borderThickness}));(m[D].indexLabel||w.indexLabel||m[D].indexLabelFormatter||w.indexLabelFormatter)&&this._indexLabels.push({chartType:"area",dataPoint:m[D],dataSeries:w,point:{x:u,y:s},direction:0>m[D].y===a.axisY.reversed?1:-1,color:x})}c();$.drawMarkers(k)}}v&&(e.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),g.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&g.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&g.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),g.clearRect(r.x1,r.y1,r.width,r.height),this._eventManager.ghostCtx.restore());g.restore();return{source:e,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,
animationBase:0}}};q.prototype.renderSplineArea=function(a){function f(){var b=x(q,2);if(0<b.length){if(0<p.lineThickness){c.beginPath();c.moveTo(b[0].x,b[0].y);b[0].newStrokeStyle&&(c.strokeStyle=b[0].newStrokeStyle);b[0].newLineDashArray&&c.setLineDash(b[0].newLineDashArray);for(var d=0;d<b.length-3;d+=3)if(c.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y),v&&e.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y),b[d+3].newStrokeStyle||b[d+3].newLineDashArray)c.stroke(),
c.beginPath(),c.moveTo(b[d+3].x,b[d+3].y),b[d+3].newStrokeStyle&&(c.strokeStyle=b[d+3].newStrokeStyle),b[d+3].newLineDashArray&&c.setLineDash(b[d+3].newLineDashArray);c.stroke()}c.beginPath();c.moveTo(b[0].x,b[0].y);v&&(e.beginPath(),e.moveTo(b[0].x,b[0].y));for(d=0;d<b.length-3;d+=3)c.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y),v&&e.bezierCurveTo(b[d+1].x,b[d+1].y,b[d+2].x,b[d+2].y,b[d+3].x,b[d+3].y);a.axisY.logarithmic||0>=a.axisY.viewportMinimum&&0<=a.axisY.viewportMaximum?
u=D:0>a.axisY.viewportMaximum?u=h.y1:0<a.axisY.viewportMinimum&&(u=g.y2);s={x:b[0].x,y:b[0].y};c.lineTo(b[b.length-1].x,u);c.lineTo(s.x,u);c.closePath();c.globalAlpha=p.fillOpacity;c.fill();c.globalAlpha=1;v&&(e.lineTo(b[b.length-1].x,u),e.lineTo(s.x,u),e.closePath(),e.fill())}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=this._eventManager.ghostCtx,g=a.axisX.lineCoordinates,h=a.axisY.lineCoordinates,l=[],t=this.plotArea;c.save();v&&
e.save();c.beginPath();c.rect(t.x1,t.y1,t.width,t.height);c.clip();v&&(e.beginPath(),e.rect(t.x1,t.y1,t.width,t.height),e.clip());for(var k=0;k<a.dataSeriesIndexes.length;k++){var r=a.dataSeriesIndexes[k],p=this.data[r],n=p.dataPoints,l=p.id;this._eventManager.objectMap[l]={objectType:"dataSeries",dataSeriesIndex:r};l=R(l);e.fillStyle=l;var l=[],d=0,w,m,D=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),u,s=null,q=[];if(0<n.length){var y=p._colorSet[d%p._colorSet.length],
B=p.lineColor=p.options.lineColor||y,A=B;c.fillStyle=y;c.strokeStyle=B;c.lineWidth=p.lineThickness;var z="solid";if(c.setLineDash){var la=F(p.nullDataLineDashType,p.lineThickness),z=p.lineDashType,L=F(z,p.lineThickness);c.setLineDash(L)}for(m=!1;d<n.length;d++)if(w=n[d].x.getTime?n[d].x.getTime():n[d].x,!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax&&(!p.connectNullData||!m)))if("number"!==typeof n[d].y)0<d&&!m&&(p.connectNullData?c.setLineDash&&(0<q.length&&(p.options.nullDataLineDashType||
!n[d-1].lineDashType))&&(q[q.length-1].newLineDashArray=la,z=p.nullDataLineDashType):(f(),q=[])),m=!0;else{w=a.axisX.convertValueToPixel(w);m=a.axisY.convertValueToPixel(n[d].y);var K=p.dataPointIds[d];this._eventManager.objectMap[K]={id:K,objectType:"dataPoint",dataSeriesIndex:r,dataPointIndex:d,x1:w,y1:m};q[q.length]={x:w,y:m};d<n.length-1&&(A!==(n[d].lineColor||B)||z!==(n[d].lineDashType||p.lineDashType))&&(A=n[d].lineColor||B,q[q.length-1].newStrokeStyle=A,c.setLineDash&&(n[d].lineDashType?(z=
n[d].lineDashType,q[q.length-1].newLineDashArray=F(z,p.lineThickness)):(z=p.lineDashType,q[q.length-1].newLineDashArray=L)));if(0!==n[d].markerSize&&(0<n[d].markerSize||0<p.markerSize)){var da=p.getMarkerProperties(d,w,m,c);l.push(da);K=R(K);v&&l.push({x:w,y:m,ctx:e,type:da.type,size:da.size,color:K,borderColor:K,borderThickness:da.borderThickness})}(n[d].indexLabel||p.indexLabel||n[d].indexLabelFormatter||p.indexLabelFormatter)&&this._indexLabels.push({chartType:"splineArea",dataPoint:n[d],dataSeries:p,
point:{x:w,y:m},direction:0>n[d].y===a.axisY.reversed?1:-1,color:y});m=!1}f();$.drawMarkers(l)}}v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(t.x1,t.y1,t.width,t.height),
this._eventManager.ghostCtx.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderStepArea=function(a){var f,b;function c(){A&&(0<w.lineThickness&&g.stroke(),a.axisY.logarithmic||0>=a.axisY.viewportMinimum&&0<=a.axisY.viewportMaximum?B=y:0>a.axisY.viewportMaximum?B=t.y1:0<a.axisY.viewportMinimum&&(B=l.y2),g.lineTo(u,B),g.lineTo(A.x,B),g.closePath(),g.globalAlpha=w.fillOpacity,g.fill(),g.globalAlpha=
1,v&&(h.lineTo(u,B),h.lineTo(A.x,B),h.closePath(),h.fill()),g.beginPath(),g.moveTo(u,s),h.beginPath(),h.moveTo(u,s),A={x:u,y:s})}var e=a.targetCanvasCtx||this.plotArea.ctx,g=v?this._preRenderCtx:e;if(!(0>=a.dataSeriesIndexes.length)){var h=this._eventManager.ghostCtx,l=a.axisX.lineCoordinates,t=a.axisY.lineCoordinates,k=[],r=this.plotArea,p;g.save();v&&h.save();g.beginPath();g.rect(r.x1,r.y1,r.width,r.height);g.clip();v&&(h.beginPath(),h.rect(r.x1,r.y1,r.width,r.height),h.clip());for(var n=0;n<a.dataSeriesIndexes.length;n++){var d=
a.dataSeriesIndexes[n],w=this.data[d],m=w.dataPoints,k=w.id;this._eventManager.objectMap[k]={objectType:"dataSeries",dataSeriesIndex:d};k=R(k);h.fillStyle=k;k=[];f=!0;var D=0,u,s,q,y=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),B,A=null;b=!1;if(0<m.length){var x=w._colorSet[D%w._colorSet.length],z=w.lineColor=w.options.lineColor||x,L=z;g.fillStyle=x;g.strokeStyle=z;g.lineWidth=w.lineThickness;var K="solid";if(g.setLineDash){var da=F(w.nullDataLineDashType,w.lineThickness),
K=w.lineDashType,ca=F(K,w.lineThickness);g.setLineDash(ca)}for(;D<m.length;D++)if(q=m[D].x.getTime?m[D].x.getTime():m[D].x,!(q<a.axisX.dataInfo.viewPortMin||q>a.axisX.dataInfo.viewPortMax&&(!w.connectNullData||!b))){var aa=s;"number"!==typeof m[D].y?(w.connectNullData||(b||f)||c(),b=!0):(u=a.axisX.convertValueToPixel(q),s=a.axisY.convertValueToPixel(m[D].y),f||b?(!f&&w.connectNullData?(g.setLineDash&&(w.options.nullDataLineDashType||K===w.lineDashType&&w.lineDashType!==w.nullDataLineDashType)&&(f=
u,b=s,u=p.x,s=p.y,c(),g.moveTo(p.x,p.y),u=f,s=b,A=p,K=w.nullDataLineDashType,g.setLineDash(da)),g.lineTo(u,aa),g.lineTo(u,s),v&&(h.lineTo(u,aa),h.lineTo(u,s))):(g.beginPath(),g.moveTo(u,s),v&&(h.beginPath(),h.moveTo(u,s)),A={x:u,y:s}),b=f=!1):(g.lineTo(u,aa),v&&h.lineTo(u,aa),g.lineTo(u,s),v&&h.lineTo(u,s),0==D%250&&c()),p={x:u,y:s},D<m.length-1&&(L!==(m[D].lineColor||z)||K!==(m[D].lineDashType||w.lineDashType))&&(c(),L=m[D].lineColor||z,g.strokeStyle=L,g.setLineDash&&(m[D].lineDashType?(K=m[D].lineDashType,
g.setLineDash(F(K,w.lineThickness))):(K=w.lineDashType,g.setLineDash(ca)))),q=w.dataPointIds[D],this._eventManager.objectMap[q]={id:q,objectType:"dataPoint",dataSeriesIndex:d,dataPointIndex:D,x1:u,y1:s},0!==m[D].markerSize&&(0<m[D].markerSize||0<w.markerSize)&&(aa=w.getMarkerProperties(D,u,s,g),k.push(aa),q=R(q),v&&k.push({x:u,y:s,ctx:h,type:aa.type,size:aa.size,color:q,borderColor:q,borderThickness:aa.borderThickness})),(m[D].indexLabel||w.indexLabel||m[D].indexLabelFormatter||w.indexLabelFormatter)&&
this._indexLabels.push({chartType:"stepArea",dataPoint:m[D],dataSeries:w,point:{x:u,y:s},direction:0>m[D].y===a.axisY.reversed?1:-1,color:x}))}c();$.drawMarkers(k)}}v&&(e.drawImage(this._preRenderCanvas,0,0,this.width,this.height),g.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&g.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&g.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),g.clearRect(r.x1,r.y1,r.width,r.height),this._eventManager.ghostCtx.restore());g.restore();return{source:e,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderStackedArea=function(a){function f(){if(!(1>t.length)){for(0<A.lineThickness&&c.stroke();0<t.length;){var a=t.pop();c.lineTo(a.x,a.y);v&&D.lineTo(a.x,a.y)}c.closePath();c.globalAlpha=A.fillOpacity;c.fill();c.globalAlpha=1;c.beginPath();v&&(D.closePath(),
D.fill(),D.beginPath());t=[]}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=[],h=this.plotArea,l=[],t=[],k=[],r=[],p=0,n,d,w,m=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),D=this._eventManager.ghostCtx,u,s,q;v&&D.beginPath();c.save();v&&D.save();c.beginPath();c.rect(h.x1,h.y1,h.width,h.height);c.clip();v&&(D.beginPath(),D.rect(h.x1,h.y1,h.width,h.height),D.clip());for(var e=[],y=0;y<a.dataSeriesIndexes.length;y++){var B=
a.dataSeriesIndexes[y],A=this.data[B],x=A.dataPoints;A.dataPointIndexes=[];for(p=0;p<x.length;p++)B=x[p].x.getTime?x[p].x.getTime():x[p].x,A.dataPointIndexes[B]=p,e[B]||(k.push(B),e[B]=!0);k.sort(Pa)}for(y=0;y<a.dataSeriesIndexes.length;y++){B=a.dataSeriesIndexes[y];A=this.data[B];x=A.dataPoints;s=!0;t=[];p=A.id;this._eventManager.objectMap[p]={objectType:"dataSeries",dataSeriesIndex:B};p=R(p);D.fillStyle=p;if(0<k.length){var e=A._colorSet[0],z=A.lineColor=A.options.lineColor||e,L=z;c.fillStyle=e;
c.strokeStyle=z;c.lineWidth=A.lineThickness;q="solid";if(c.setLineDash){var K=F(A.nullDataLineDashType,A.lineThickness);q=A.lineDashType;var da=F(q,A.lineThickness);c.setLineDash(da)}for(var ca=!0,p=0;p<k.length;p++){w=k[p];var aa=null,aa=0<=A.dataPointIndexes[w]?x[A.dataPointIndexes[w]]:{x:w,y:null};if(!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax&&(!A.connectNullData||!ca)))if("number"!==typeof aa.y)A.connectNullData||(ca||s)||f(),ca=!0;else{n=a.axisX.convertValueToPixel(w);var wa=
l[w]?l[w]:0;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length){r[w]=aa.y+(r[w]?r[w]:0);if(0>=r[w]&&a.axisY.logarithmic)continue;d=a.axisY.convertValueToPixel(r[w])}else d=a.axisY.convertValueToPixel(aa.y),d-=wa;t.push({x:n,y:m-wa});l[w]=m-d;s||ca?(!s&&A.connectNullData?(c.setLineDash&&(A.options.nullDataLineDashType||q===A.lineDashType&&A.lineDashType!==A.nullDataLineDashType)&&(s=t.pop(),q=t[t.length-1],f(),c.moveTo(u.x,u.y),t.push(q),t.push(s),q=A.nullDataLineDashType,
c.setLineDash(K)),c.lineTo(n,d),v&&D.lineTo(n,d)):(c.beginPath(),c.moveTo(n,d),v&&(D.beginPath(),D.moveTo(n,d))),ca=s=!1):(c.lineTo(n,d),v&&D.lineTo(n,d),0==p%250&&(f(),c.moveTo(n,d),v&&D.moveTo(n,d),t.push({x:n,y:m-wa})));u={x:n,y:d};p<x.length-1&&(L!==(x[p].lineColor||z)||q!==(x[p].lineDashType||A.lineDashType))&&(f(),c.beginPath(),c.moveTo(n,d),t.push({x:n,y:m-wa}),L=x[p].lineColor||z,c.strokeStyle=L,c.setLineDash&&(x[p].lineDashType?(q=x[p].lineDashType,c.setLineDash(F(q,A.lineThickness))):(q=
A.lineDashType,c.setLineDash(da))));if(0<=A.dataPointIndexes[w]){var ma=A.dataPointIds[A.dataPointIndexes[w]];this._eventManager.objectMap[ma]={id:ma,objectType:"dataPoint",dataSeriesIndex:B,dataPointIndex:A.dataPointIndexes[w],x1:n,y1:d}}0<=A.dataPointIndexes[w]&&0!==aa.markerSize&&(0<aa.markerSize||0<A.markerSize)&&(w=A.getMarkerProperties(A.dataPointIndexes[w],n,d,c),g.push(w),markerColor=R(ma),v&&g.push({x:n,y:d,ctx:D,type:w.type,size:w.size,color:markerColor,borderColor:markerColor,borderThickness:w.borderThickness}));
(aa.indexLabel||A.indexLabel||aa.indexLabelFormatter||A.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedArea",dataPoint:aa,dataSeries:A,point:{x:n,y:d},direction:0>x[p].y===a.axisY.reversed?1:-1,color:e})}}f();c.moveTo(n,d);v&&D.moveTo(n,d)}delete A.dataPointIndexes}$.drawMarkers(g);v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&
c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(h.x1,h.y1,h.width,h.height),D.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderStackedArea100=function(a){function f(){for(0<A.lineThickness&&c.stroke();0<t.length;){var a=t.pop();c.lineTo(a.x,a.y);v&&y.lineTo(a.x,
a.y)}c.closePath();c.globalAlpha=A.fillOpacity;c.fill();c.globalAlpha=1;c.beginPath();v&&(y.closePath(),y.fill(),y.beginPath());t=[]}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=this.plotArea,h=[],l=[],t=[],k=[],r=[],p=0,n,d,w,m,s,u,q=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),y=this._eventManager.ghostCtx;c.save();v&&y.save();c.beginPath();c.rect(g.x1,g.y1,g.width,g.height);c.clip();v&&(y.beginPath(),
y.rect(g.x1,g.y1,g.width,g.height),y.clip());for(var e=[],x=0;x<a.dataSeriesIndexes.length;x++){var B=a.dataSeriesIndexes[x],A=this.data[B],z=A.dataPoints;A.dataPointIndexes=[];for(p=0;p<z.length;p++)B=z[p].x.getTime?z[p].x.getTime():z[p].x,A.dataPointIndexes[B]=p,e[B]||(k.push(B),e[B]=!0);k.sort(Pa)}for(x=0;x<a.dataSeriesIndexes.length;x++){B=a.dataSeriesIndexes[x];A=this.data[B];z=A.dataPoints;s=!0;e=A.id;this._eventManager.objectMap[e]={objectType:"dataSeries",dataSeriesIndex:B};e=R(e);y.fillStyle=
e;t=[];if(0<k.length){var e=A._colorSet[p%A._colorSet.length],C=A.lineColor=A.options.lineColor||e,L=C;c.fillStyle=e;c.strokeStyle=C;c.lineWidth=A.lineThickness;u="solid";if(c.setLineDash){var K=F(A.nullDataLineDashType,A.lineThickness);u=A.lineDashType;var da=F(u,A.lineThickness);c.setLineDash(da)}for(var ca=!0,p=0;p<k.length;p++){w=k[p];var aa=null,aa=0<=A.dataPointIndexes[w]?z[A.dataPointIndexes[w]]:{x:w,y:null};if(!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax&&(!A.connectNullData||
!ca)))if("number"!==typeof aa.y)A.connectNullData||(ca||s)||f(),ca=!0;else{var wa;wa=0!==a.dataPointYSums[w]?100*(aa.y/a.dataPointYSums[w]):0;n=a.axisX.convertValueToPixel(w);var ma=l[w]?l[w]:0;if(a.axisY.logarithmic||a.axisY.scaleBreaks&&0<a.axisY.scaleBreaks._appliedBreaks.length){r[w]=wa+(r[w]?r[w]:0);if(0>=r[w]&&a.axisY.logarithmic)continue;d=a.axisY.convertValueToPixel(r[w])}else d=a.axisY.convertValueToPixel(wa),d-=ma;t.push({x:n,y:q-ma});l[w]=q-d;s||ca?(!s&&A.connectNullData?(c.setLineDash&&
(A.options.nullDataLineDashType||u===A.lineDashType&&A.lineDashType!==A.nullDataLineDashType)&&(s=t.pop(),u=t[t.length-1],f(),c.moveTo(m.x,m.y),t.push(u),t.push(s),u=A.nullDataLineDashType,c.setLineDash(K)),c.lineTo(n,d),v&&y.lineTo(n,d)):(c.beginPath(),c.moveTo(n,d),v&&(y.beginPath(),y.moveTo(n,d))),ca=s=!1):(c.lineTo(n,d),v&&y.lineTo(n,d),0==p%250&&(f(),c.moveTo(n,d),v&&y.moveTo(n,d),t.push({x:n,y:q-ma})));m={x:n,y:d};p<z.length-1&&(L!==(z[p].lineColor||C)||u!==(z[p].lineDashType||A.lineDashType))&&
(f(),c.beginPath(),c.moveTo(n,d),t.push({x:n,y:q-ma}),L=z[p].lineColor||C,c.strokeStyle=L,c.setLineDash&&(z[p].lineDashType?(u=z[p].lineDashType,c.setLineDash(F(u,A.lineThickness))):(u=A.lineDashType,c.setLineDash(da))));if(0<=A.dataPointIndexes[w]){var E=A.dataPointIds[A.dataPointIndexes[w]];this._eventManager.objectMap[E]={id:E,objectType:"dataPoint",dataSeriesIndex:B,dataPointIndex:A.dataPointIndexes[w],x1:n,y1:d}}0<=A.dataPointIndexes[w]&&0!==aa.markerSize&&(0<aa.markerSize||0<A.markerSize)&&
(w=A.getMarkerProperties(p,n,d,c),h.push(w),markerColor=R(E),v&&h.push({x:n,y:d,ctx:y,type:w.type,size:w.size,color:markerColor,borderColor:markerColor,borderThickness:w.borderThickness}));(aa.indexLabel||A.indexLabel||aa.indexLabelFormatter||A.indexLabelFormatter)&&this._indexLabels.push({chartType:"stackedArea100",dataPoint:aa,dataSeries:A,point:{x:n,y:d},direction:0>z[p].y===a.axisY.reversed?1:-1,color:e})}}f();c.moveTo(n,d);v&&y.moveTo(n,d)}delete A.dataPointIndexes}$.drawMarkers(h);v&&(b.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(g.x1,g.y1,g.width,g.height),y.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,
animationBase:0}}};q.prototype.renderBubble=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this.plotArea,e=0,g,h;b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(c.x1,c.y1,c.width,c.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.clip());for(var l=-Infinity,t=Infinity,k=0;k<a.dataSeriesIndexes.length;k++)for(var r=
a.dataSeriesIndexes[k],p=this.data[r],n=p.dataPoints,d=0,e=0;e<n.length;e++)g=n[e].getTime?g=n[e].x.getTime():g=n[e].x,g<a.axisX.dataInfo.viewPortMin||g>a.axisX.dataInfo.viewPortMax||"undefined"===typeof n[e].z||(d=n[e].z,d>l&&(l=d),d<t&&(t=d));for(var w=25*Math.PI,m=Math.max(Math.pow(0.25*Math.min(c.height,c.width)/2,2)*Math.PI,w),k=0;k<a.dataSeriesIndexes.length;k++)if(r=a.dataSeriesIndexes[k],p=this.data[r],n=p.dataPoints,0<n.length)for(b.strokeStyle="#4572A7 ",e=0;e<n.length;e++)if(g=n[e].getTime?
g=n[e].x.getTime():g=n[e].x,!(g<a.axisX.dataInfo.viewPortMin||g>a.axisX.dataInfo.viewPortMax)&&"number"===typeof n[e].y){g=a.axisX.convertValueToPixel(g);h=a.axisY.convertValueToPixel(n[e].y);var d=n[e].z,s=2*Math.max(Math.sqrt((l===t?m/2:w+(m-w)/(l-t)*(d-t))/Math.PI)<<0,1),d=p.getMarkerProperties(e,b);d.size=s;b.globalAlpha=p.fillOpacity;$.drawMarker(g,h,b,d.type,d.size,d.color,d.borderColor,d.borderThickness);b.globalAlpha=1;var u=p.dataPointIds[e];this._eventManager.objectMap[u]={id:u,objectType:"dataPoint",
dataSeriesIndex:r,dataPointIndex:e,x1:g,y1:h,size:s};s=R(u);v&&$.drawMarker(g,h,this._eventManager.ghostCtx,d.type,d.size,s,s,d.borderThickness);(n[e].indexLabel||p.indexLabel||n[e].indexLabelFormatter||p.indexLabelFormatter)&&this._indexLabels.push({chartType:"bubble",dataPoint:n[e],dataSeries:p,point:{x:g,y:h},direction:1,bounds:{x1:g-d.size/2,y1:h-d.size/2,x2:g+d.size/2,y2:h+d.size/2},color:null})}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",
a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderScatter=
function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=this.plotArea,e=0,g,h;b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(c.x1,c.y1,c.width,c.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.clip());for(var l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t],r=k.dataPoints;if(0<
r.length){b.strokeStyle="#4572A7 ";Math.pow(0.3*Math.min(c.height,c.width)/2,2);for(var p=0,n=0,e=0;e<r.length;e++)if(g=r[e].getTime?g=r[e].x.getTime():g=r[e].x,!(g<a.axisX.dataInfo.viewPortMin||g>a.axisX.dataInfo.viewPortMax)&&"number"===typeof r[e].y){g=a.axisX.convertValueToPixel(g);h=a.axisY.convertValueToPixel(r[e].y);var d=k.getMarkerProperties(e,g,h,b);b.globalAlpha=k.fillOpacity;$.drawMarker(d.x,d.y,d.ctx,d.type,d.size,d.color,d.borderColor,d.borderThickness);b.globalAlpha=1;Math.sqrt((p-
g)*(p-g)+(n-h)*(n-h))<Math.min(d.size,5)&&r.length>Math.min(this.plotArea.width,this.plotArea.height)||(p=k.dataPointIds[e],this._eventManager.objectMap[p]={id:p,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:e,x1:g,y1:h},p=R(p),v&&$.drawMarker(d.x,d.y,this._eventManager.ghostCtx,d.type,d.size,p,p,d.borderThickness),(r[e].indexLabel||k.indexLabel||r[e].indexLabelFormatter||k.indexLabelFormatter)&&this._indexLabels.push({chartType:"scatter",dataPoint:r[e],dataSeries:k,point:{x:g,y:h},direction:1,
bounds:{x1:g-d.size/2,y1:h-d.size/2,x2:g+d.size/2,y2:h+d.size/2},color:null}),p=g,n=h)}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(c.x1,c.y1,c.width,c.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderCandlestick=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f,c=this._eventManager.ghostCtx;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=null,h=this.plotArea,l=0,t,k,r,p,n,d,e=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,g=this.options.dataPointMaxWidth?
this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.015*this.width,w=a.axisX.dataInfo.minDiff;isFinite(w)||(w=0.3*Math.abs(a.axisX.range));w=this.options.dataPointWidth?this.dataPointWidth:0.7*h.width*(a.axisX.logarithmic?Math.log(w)/Math.log(a.axisX.range):Math.abs(w)/Math.abs(a.axisX.range))<<0;this.dataPointMaxWidth&&e>g&&(e=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,g));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&g<e)&&(g=Math.max(this.options.dataPointWidth?
this.dataPointWidth:-Infinity,e));w<e&&(w=e);w>g&&(w=g);b.save();v&&c.save();b.beginPath();b.rect(h.x1,h.y1,h.width,h.height);b.clip();v&&(c.beginPath(),c.rect(h.x1,h.y1,h.width,h.height),c.clip());for(var m=0;m<a.dataSeriesIndexes.length;m++){var s=a.dataSeriesIndexes[m],u=this.data[s],q=u.dataPoints;if(0<q.length)for(var H=5<w&&u.bevelEnabled?!0:!1,l=0;l<q.length;l++)if(q[l].getTime?d=q[l].x.getTime():d=q[l].x,!(d<a.axisX.dataInfo.viewPortMin||d>a.axisX.dataInfo.viewPortMax)&&!y(q[l].y)&&q[l].y.length&&
"number"===typeof q[l].y[0]&&"number"===typeof q[l].y[1]&&"number"===typeof q[l].y[2]&&"number"===typeof q[l].y[3]){t=a.axisX.convertValueToPixel(d);k=a.axisY.convertValueToPixel(q[l].y[0]);r=a.axisY.convertValueToPixel(q[l].y[1]);p=a.axisY.convertValueToPixel(q[l].y[2]);n=a.axisY.convertValueToPixel(q[l].y[3]);var x=t-w/2<<0,B=x+w<<0,g=u.options.fallingColor?u.fallingColor:u._colorSet[0],e=q[l].color?q[l].color:u._colorSet[0],A=Math.round(Math.max(1,0.15*w)),z=0===A%2?0:0.5,C=u.dataPointIds[l];this._eventManager.objectMap[C]=
{id:C,objectType:"dataPoint",dataSeriesIndex:s,dataPointIndex:l,x1:x,y1:k,x2:B,y2:r,x3:t,y3:p,x4:t,y4:n,borderThickness:A,color:e};b.strokeStyle=e;b.beginPath();b.lineWidth=A;c.lineWidth=Math.max(A,4);"candlestick"===u.type?(b.moveTo(t-z,r),b.lineTo(t-z,Math.min(k,n)),b.stroke(),b.moveTo(t-z,Math.max(k,n)),b.lineTo(t-z,p),b.stroke(),X(b,x,Math.min(k,n),B,Math.max(k,n),q[l].y[0]<=q[l].y[3]?u.risingColor:g,A,e,H,H,!1,!1,u.fillOpacity),v&&(e=R(C),c.strokeStyle=e,c.moveTo(t-z,r),c.lineTo(t-z,Math.min(k,
n)),c.stroke(),c.moveTo(t-z,Math.max(k,n)),c.lineTo(t-z,p),c.stroke(),X(c,x,Math.min(k,n),B,Math.max(k,n),e,0,null,!1,!1,!1,!1))):"ohlc"===u.type&&(b.moveTo(t-z,r),b.lineTo(t-z,p),b.stroke(),b.beginPath(),b.moveTo(t,k),b.lineTo(x,k),b.stroke(),b.beginPath(),b.moveTo(t,n),b.lineTo(B,n),b.stroke(),v&&(e=R(C),c.strokeStyle=e,c.moveTo(t-z,r),c.lineTo(t-z,p),c.stroke(),c.beginPath(),c.moveTo(t,k),c.lineTo(x,k),c.stroke(),c.beginPath(),c.moveTo(t,n),c.lineTo(B,n),c.stroke()));(q[l].indexLabel||u.indexLabel||
q[l].indexLabelFormatter||u.indexLabelFormatter)&&this._indexLabels.push({chartType:u.type,dataPoint:q[l],dataSeries:u,point:{x:x+(B-x)/2,y:a.axisY.reversed?p:r},direction:1,bounds:{x1:x,y1:Math.min(r,p),x2:B,y2:Math.max(r,p)},color:e})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),
this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(h.x1,h.y1,h.width,h.height),c.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderBoxAndWhisker=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f,c=this._eventManager.ghostCtx;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=this.plotArea,
h=0,l,t,k,r,p,n,d,e=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1,h=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.015*this.width,w=a.axisX.dataInfo.minDiff;isFinite(w)||(w=0.3*Math.abs(a.axisX.range));w=this.options.dataPointWidth?this.dataPointWidth:0.7*g.width*(a.axisX.logarithmic?Math.log(w)/Math.log(a.axisX.range):Math.abs(w)/Math.abs(a.axisX.range))<<0;this.dataPointMaxWidth&&e>
h&&(e=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,h));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&h<e)&&(h=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,e));w<e&&(w=e);w>h&&(w=h);b.save();v&&c.save();b.beginPath();b.rect(g.x1,g.y1,g.width,g.height);b.clip();v&&(c.beginPath(),c.rect(g.x1,g.y1,g.width,g.height),c.clip());for(var m=!1,m=!!a.axisY.reversed,s=0;s<a.dataSeriesIndexes.length;s++){var u=a.dataSeriesIndexes[s],q=this.data[u],H=q.dataPoints;
if(0<H.length)for(var x=5<w&&q.bevelEnabled?!0:!1,h=0;h<H.length;h++)if(H[h].getTime?d=H[h].x.getTime():d=H[h].x,!(d<a.axisX.dataInfo.viewPortMin||d>a.axisX.dataInfo.viewPortMax)&&!y(H[h].y)&&H[h].y.length&&"number"===typeof H[h].y[0]&&"number"===typeof H[h].y[1]&&"number"===typeof H[h].y[2]&&"number"===typeof H[h].y[3]&&"number"===typeof H[h].y[4]&&5===H[h].y.length){l=a.axisX.convertValueToPixel(d);t=a.axisY.convertValueToPixel(H[h].y[0]);k=a.axisY.convertValueToPixel(H[h].y[1]);r=a.axisY.convertValueToPixel(H[h].y[2]);
p=a.axisY.convertValueToPixel(H[h].y[3]);n=a.axisY.convertValueToPixel(H[h].y[4]);var B=l-w/2<<0,A=l+w/2<<0,e=H[h].color?H[h].color:q._colorSet[0],z=Math.round(Math.max(1,0.15*w)),C=0===z%2?0:0.5,L=H[h].whiskerColor?H[h].whiskerColor:H[h].color?q.whiskerColor?q.whiskerColor:H[h].color:q.whiskerColor?q.whiskerColor:e,K="number"===typeof H[h].whiskerThickness?H[h].whiskerThickness:"number"===typeof q.options.whiskerThickness?q.whiskerThickness:z,da=H[h].whiskerDashType?H[h].whiskerDashType:q.whiskerDashType,
ca=y(H[h].whiskerLength)?y(q.options.whiskerLength)?w:q.whiskerLength:H[h].whiskerLength,ca="number"===typeof ca?0>=ca?0:ca>=w?w:ca:"string"===typeof ca?parseInt(ca)*w/100>w?w:parseInt(ca)*w/100:w,aa=1===Math.round(K)%2?0.5:0,wa=H[h].stemColor?H[h].stemColor:H[h].color?q.stemColor?q.stemColor:H[h].color:q.stemColor?q.stemColor:e,ma="number"===typeof H[h].stemThickness?H[h].stemThickness:"number"===typeof q.options.stemThickness?q.stemThickness:z,E=1===Math.round(ma)%2?0.5:0,fb=H[h].stemDashType?H[h].stemDashType:
q.stemDashType,I=H[h].lineColor?H[h].lineColor:H[h].color?q.lineColor?q.lineColor:H[h].color:q.lineColor?q.lineColor:e,J="number"===typeof H[h].lineThickness?H[h].lineThickness:"number"===typeof q.options.lineThickness?q.lineThickness:z,S=H[h].lineDashType?H[h].lineDashType:q.lineDashType,M=1===Math.round(J)%2?0.5:0,P=q.upperBoxColor,U=q.lowerBoxColor,ra=y(q.options.fillOpacity)?1:q.fillOpacity,N=q.dataPointIds[h];this._eventManager.objectMap[N]={id:N,objectType:"dataPoint",dataSeriesIndex:u,dataPointIndex:h,
x1:B,y1:t,x2:A,y2:k,x3:l,y3:r,x4:l,y4:p,y5:n,borderThickness:z,color:e,stemThickness:ma,stemColor:wa,whiskerThickness:K,whiskerLength:ca,whiskerColor:L,lineThickness:J,lineColor:I};b.save();0<ma&&(b.beginPath(),b.strokeStyle=wa,b.lineWidth=ma,b.setLineDash&&b.setLineDash(F(fb,ma)),b.moveTo(l-E,k),b.lineTo(l-E,t),b.stroke(),b.moveTo(l-E,p),b.lineTo(l-E,r),b.stroke());b.restore();c.lineWidth=Math.max(z,4);b.beginPath();X(b,B,Math.min(n,k),A,Math.max(k,n),U,0,e,m?x:!1,m?!1:x,!1,!1,ra);b.beginPath();
X(b,B,Math.min(r,n),A,Math.max(n,r),P,0,e,m?!1:x,m?x:!1,!1,!1,ra);b.beginPath();b.lineWidth=z;b.strokeStyle=e;b.rect(B-C,Math.min(k,r)-C,A-B+2*C,Math.max(k,r)-Math.min(k,r)+2*C);b.stroke();b.save();0<J&&(b.beginPath(),b.globalAlpha=1,b.setLineDash&&b.setLineDash(F(S,J)),b.strokeStyle=I,b.lineWidth=J,b.moveTo(B,n-M),b.lineTo(A,n-M),b.stroke());b.restore();b.save();0<K&&(b.beginPath(),b.setLineDash&&b.setLineDash(F(da,K)),b.strokeStyle=L,b.lineWidth=K,b.moveTo(l-ca/2<<0,p-aa),b.lineTo(l+ca/2<<0,p-aa),
b.stroke(),b.moveTo(l-ca/2<<0,t+aa),b.lineTo(l+ca/2<<0,t+aa),b.stroke());b.restore();v&&(e=R(N),c.strokeStyle=e,c.lineWidth=ma,0<ma&&(c.moveTo(l-C-E,k),c.lineTo(l-C-E,Math.max(t,p)),c.stroke(),c.moveTo(l-C-E,Math.min(t,p)),c.lineTo(l-C-E,r),c.stroke()),X(c,B,Math.max(k,r),A,Math.min(k,r),e,0,null,!1,!1,!1,!1),0<K&&(c.beginPath(),c.lineWidth=K,c.moveTo(l+ca/2,p-aa),c.lineTo(l-ca/2,p-aa),c.stroke(),c.moveTo(l+ca/2,t+aa),c.lineTo(l-ca/2,t+aa),c.stroke()));(H[h].indexLabel||q.indexLabel||H[h].indexLabelFormatter||
q.indexLabelFormatter)&&this._indexLabels.push({chartType:q.type,dataPoint:H[h],dataSeries:q,point:{x:B+(A-B)/2,y:a.axisY.reversed?t:p},direction:1,bounds:{x1:B,y1:Math.min(t,p),x2:A,y2:Math.max(t,p)},color:e})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,
0,0,this.width,this.height),b.clearRect(g.x1,g.y1,g.width,g.height),c.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderRangeColumn=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=0,h,l,t,g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:
1;h=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:0.03*this.width;var k=a.axisX.dataInfo.minDiff;isFinite(k)||(k=0.3*Math.abs(a.axisX.range));k=this.options.dataPointWidth?this.dataPointWidth:0.9*(e.width*(a.axisX.logarithmic?Math.log(k)/Math.log(a.axisX.range):Math.abs(k)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>h&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,h));!this.dataPointMaxWidth&&
(this.dataPointMinWidth&&h<g)&&(h=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));k<g&&(k=g);k>h&&(k=h);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var r=0;r<a.dataSeriesIndexes.length;r++){var p=a.dataSeriesIndexes[r],n=this.data[p],d=n.dataPoints;if(0<d.length)for(var w=
5<k&&n.bevelEnabled?!0:!1,g=0;g<d.length;g++)if(d[g].getTime?t=d[g].x.getTime():t=d[g].x,!(t<a.axisX.dataInfo.viewPortMin||t>a.axisX.dataInfo.viewPortMax)&&!y(d[g].y)&&d[g].y.length&&"number"===typeof d[g].y[0]&&"number"===typeof d[g].y[1]){c=a.axisX.convertValueToPixel(t);h=a.axisY.convertValueToPixel(d[g].y[0]);l=a.axisY.convertValueToPixel(d[g].y[1]);var m=a.axisX.reversed?c+a.plotType.totalDataSeries*k/2-(a.previousDataSeriesCount+r)*k<<0:c-a.plotType.totalDataSeries*k/2+(a.previousDataSeriesCount+
r)*k<<0,q=a.axisX.reversed?m-k<<0:m+k<<0,c=d[g].color?d[g].color:n._colorSet[g%n._colorSet.length];if(h>l){var u=h;h=l;l=u}u=n.dataPointIds[g];this._eventManager.objectMap[u]={id:u,objectType:"dataPoint",dataSeriesIndex:p,dataPointIndex:g,x1:m,y1:h,x2:q,y2:l};X(b,m,h,q,l,c,0,c,w,w,!1,!1,n.fillOpacity);c=R(u);v&&X(this._eventManager.ghostCtx,m,h,q,l,c,0,null,!1,!1,!1,!1);if(d[g].indexLabel||n.indexLabel||d[g].indexLabelFormatter||n.indexLabelFormatter)this._indexLabels.push({chartType:"rangeColumn",
dataPoint:d[g],dataSeries:n,indexKeyword:0,point:{x:m+(q-m)/2,y:d[g].y[1]>=d[g].y[0]?l:h},direction:d[g].y[1]>=d[g].y[0]?-1:1,bounds:{x1:m,y1:Math.min(h,l),x2:q,y2:Math.max(h,l)},color:c}),this._indexLabels.push({chartType:"rangeColumn",dataPoint:d[g],dataSeries:n,indexKeyword:1,point:{x:m+(q-m)/2,y:d[g].y[1]>=d[g].y[0]?h:l},direction:d[g].y[1]>=d[g].y[0]?1:-1,bounds:{x1:m,y1:Math.min(h,l),x2:q,y2:Math.max(h,l)},color:c})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation=
"source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderError=
function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:f,c=a.axisY._position?"left"===a.axisY._position||"right"===a.axisY._position?!1:!0:!1;if(!(0>=a.dataSeriesIndexes.length)){var e=null,g=!1,h=this.plotArea,l=0,t,k,r,p,n,d,w,m=a.axisX.dataInfo.minDiff;isFinite(m)||(m=0.3*Math.abs(a.axisX.range));b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(h.x1,h.y1,h.width,h.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(h.x1,
h.y1,h.width,h.height),this._eventManager.ghostCtx.clip());for(var q=0,u=0;u<this.data.length;u++)!this.data[u].type.match(/(bar|column)/ig)||!this.data[u].visible||this.data[u].type.match(/(stacked)/ig)&&q||q++;for(var s=0;s<a.dataSeriesIndexes.length;s++){var H=a.dataSeriesIndexes[s],x=this.data[H],B=x.dataPoints,A=y(x._linkedSeries)?!1:x._linkedSeries.type.match(/(bar|column)/ig)&&x._linkedSeries.visible?!0:!1,C=0;if(A)for(e=x._linkedSeries.id,u=0;u<e;u++)!this.data[u].type.match(/(bar|column)/ig)||
!this.data[u].visible||this.data[u].type.match(/(stacked)/ig)&&C||(this.data[u].type.match(/(range)/ig)&&(g=!0),C++);e=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;l=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:c?Math.min(0.15*this.height,0.9*(this.plotArea.height/(A?q:1)))<<0:0.3*this.width;g&&(l=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:
c?Math.min(0.15*this.height,0.9*(this.plotArea.height/(A?q:1)))<<0:0.03*this.width);u=this.options.dataPointWidth?this.dataPointWidth:0.9*((c?h.height:h.width)*(a.axisX.logarithmic?Math.log(m)/Math.log(a.axisX.range):Math.abs(m)/Math.abs(a.axisX.range))/(A?q:1))<<0;this.dataPointMaxWidth&&e>l&&(e=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,l));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&l<e)&&(l=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,e));u<e&&
(u=e);u>l&&(u=l);if(0<B.length)for(var F=x._colorSet,l=0;l<B.length;l++){var e=x.lineColor=x.options.color?x.options.color:F[0],L={color:B[l].whiskerColor?B[l].whiskerColor:B[l].color?x.whiskerColor?x.whiskerColor:B[l].color:x.whiskerColor?x.whiskerColor:e,thickness:y(B[l].whiskerThickness)?x.whiskerThickness:B[l].whiskerThickness,dashType:B[l].whiskerDashType?B[l].whiskerDashType:x.whiskerDashType,length:y(B[l].whiskerLength)?y(x.options.whiskerLength)?u:x.options.whiskerLength:B[l].whiskerLength,
trimLength:y(B[l].whiskerLength)?y(x.options.whiskerLength)?50:0:0};L.length="number"===typeof L.length?0>=L.length?0:L.length>=u?u:L.length:"string"===typeof L.length?parseInt(L.length)*u/100>u?u:parseInt(L.length)*u/100>u:u;L.thickness="number"===typeof L.thickness?0>L.thickness?0:Math.round(L.thickness):2;var K={color:B[l].stemColor?B[l].stemColor:B[l].color?x.stemColor?x.stemColor:B[l].color:x.stemColor?x.stemColor:e,thickness:B[l].stemThickness?B[l].stemThickness:x.stemThickness,dashType:B[l].stemDashType?
B[l].stemDashType:x.stemDashType};K.thickness="number"===typeof K.thickness?0>K.thickness?0:Math.round(K.thickness):2;B[l].getTime?w=B[l].x.getTime():w=B[l].x;if(!(w<a.axisX.dataInfo.viewPortMin||w>a.axisX.dataInfo.viewPortMax)&&!y(B[l].y)&&B[l].y.length&&"number"===typeof B[l].y[0]&&"number"===typeof B[l].y[1]){var da=a.axisX.convertValueToPixel(w);c?k=da:t=da;da=a.axisY.convertValueToPixel(B[l].y[0]);c?r=da:n=da;da=a.axisY.convertValueToPixel(B[l].y[1]);c?p=da:d=da;c?(n=a.axisX.reversed?k+(A?q:
1)*u/2-(A?C-1:0)*u<<0:k-(A?q:1)*u/2+(A?C-1:0)*u<<0,d=a.axisX.reversed?n-u<<0:n+u<<0):(r=a.axisX.reversed?t+(A?q:1)*u/2-(A?C-1:0)*u<<0:t-(A?q:1)*u/2+(A?C-1:0)*u<<0,p=a.axisX.reversed?r-u<<0:r+u<<0);!c&&n>d&&(da=n,n=d,d=da);c&&r>p&&(da=r,r=p,p=da);da=x.dataPointIds[l];this._eventManager.objectMap[da]={id:da,objectType:"dataPoint",dataSeriesIndex:H,dataPointIndex:l,x1:Math.min(r,p),y1:Math.min(n,d),x2:Math.max(p,r),y2:Math.max(d,n),isXYSwapped:c,stemProperties:K,whiskerProperties:L};z(b,Math.min(r,p),
Math.min(n,d),Math.max(p,r),Math.max(d,n),e,L,K,c);v&&z(this._eventManager.ghostCtx,r,n,p,d,e,L,K,c);if(B[l].indexLabel||x.indexLabel||B[l].indexLabelFormatter||x.indexLabelFormatter)this._indexLabels.push({chartType:"error",dataPoint:B[l],dataSeries:x,indexKeyword:0,point:{x:c?B[l].y[1]>=B[l].y[0]?r:p:r+(p-r)/2,y:c?n+(d-n)/2:B[l].y[1]>=B[l].y[0]?d:n},direction:B[l].y[1]>=B[l].y[0]?-1:1,bounds:{x1:c?Math.min(r,p):r,y1:c?n:Math.min(n,d),x2:c?Math.max(r,p):p,y2:c?d:Math.max(n,d)},color:e,axisSwapped:c}),
this._indexLabels.push({chartType:"error",dataPoint:B[l],dataSeries:x,indexKeyword:1,point:{x:c?B[l].y[1]>=B[l].y[0]?p:r:r+(p-r)/2,y:c?n+(d-n)/2:B[l].y[1]>=B[l].y[0]?n:d},direction:B[l].y[1]>=B[l].y[0]?1:-1,bounds:{x1:c?Math.min(r,p):r,y1:c?n:Math.min(n,d),x2:c?Math.max(r,p):p,y2:c?d:Math.max(n,d)},color:e,axisSwapped:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),
a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(h.x1,h.y1,h.width,h.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderRangeBar=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:
f;if(!(0>=a.dataSeriesIndexes.length)){var c=null,e=this.plotArea,g=0,h,l,t,k,g=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;h=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*this.height,0.9*(this.plotArea.height/a.plotType.totalDataSeries))<<0;var r=a.axisX.dataInfo.minDiff;isFinite(r)||(r=0.3*Math.abs(a.axisX.range));r=this.options.dataPointWidth?this.dataPointWidth:0.9*
(e.height*(a.axisX.logarithmic?Math.log(r)/Math.log(a.axisX.range):Math.abs(r)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&g>h&&(g=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,h));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&h<g)&&(h=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,g));r<g&&(r=g);r>h&&(r=h);b.save();v&&this._eventManager.ghostCtx.save();b.beginPath();b.rect(e.x1,e.y1,e.width,e.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),
this._eventManager.ghostCtx.rect(e.x1,e.y1,e.width,e.height),this._eventManager.ghostCtx.clip());for(var p=0;p<a.dataSeriesIndexes.length;p++){var n=a.dataSeriesIndexes[p],d=this.data[n],w=d.dataPoints;if(0<w.length){var m=5<r&&d.bevelEnabled?!0:!1;b.strokeStyle="#4572A7 ";for(g=0;g<w.length;g++)if(w[g].getTime?k=w[g].x.getTime():k=w[g].x,!(k<a.axisX.dataInfo.viewPortMin||k>a.axisX.dataInfo.viewPortMax)&&!y(w[g].y)&&w[g].y.length&&"number"===typeof w[g].y[0]&&"number"===typeof w[g].y[1]){h=a.axisY.convertValueToPixel(w[g].y[0]);
l=a.axisY.convertValueToPixel(w[g].y[1]);t=a.axisX.convertValueToPixel(k);t=a.axisX.reversed?t+a.plotType.totalDataSeries*r/2-(a.previousDataSeriesCount+p)*r<<0:t-a.plotType.totalDataSeries*r/2+(a.previousDataSeriesCount+p)*r<<0;var q=a.axisX.reversed?t-r<<0:t+r<<0;h>l&&(c=h,h=l,l=c);c=w[g].color?w[g].color:d._colorSet[g%d._colorSet.length];X(b,h,t,l,q,c,0,null,m,!1,!1,!1,d.fillOpacity);c=d.dataPointIds[g];this._eventManager.objectMap[c]={id:c,objectType:"dataPoint",dataSeriesIndex:n,dataPointIndex:g,
x1:h,y1:t,x2:l,y2:q};c=R(c);v&&X(this._eventManager.ghostCtx,h,t,l,q,c,0,null,!1,!1,!1,!1);if(w[g].indexLabel||d.indexLabel||w[g].indexLabelFormatter||d.indexLabelFormatter)this._indexLabels.push({chartType:"rangeBar",dataPoint:w[g],dataSeries:d,indexKeyword:0,point:{x:w[g].y[1]>=w[g].y[0]?h:l,y:t+(q-t)/2},direction:w[g].y[1]>=w[g].y[0]?-1:1,bounds:{x1:Math.min(h,l),y1:t,x2:Math.max(h,l),y2:q},color:c}),this._indexLabels.push({chartType:"rangeBar",dataPoint:w[g],dataSeries:d,indexKeyword:1,point:{x:w[g].y[1]>=
w[g].y[0]?l:h,y:t+(q-t)/2},direction:w[g].y[1]>=w[g].y[0]?1:-1,bounds:{x1:Math.min(h,l),y1:t,x2:Math.max(h,l),y2:q},color:c})}}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(e.x1,
e.y1,e.width,e.height),this._eventManager.ghostCtx.restore());b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};q.prototype.renderRangeArea=function(a){function f(){if(s){var a=null;0<r.lineThickness&&c.stroke();for(var b=t.length-1;0<=b;b--)a=t[b],c.lineTo(a.x,a.y),e.lineTo(a.x,a.y);c.closePath();c.globalAlpha=r.fillOpacity;c.fill();c.globalAlpha=1;e.fill();if(0<r.lineThickness){c.beginPath();c.moveTo(a.x,
a.y);for(b=0;b<t.length;b++)a=t[b],c.lineTo(a.x,a.y);c.stroke()}c.beginPath();c.moveTo(w,m);e.beginPath();e.moveTo(w,m);s={x:w,y:m};t=[];t.push({x:w,y:q})}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=this._eventManager.ghostCtx,g=[],h=this.plotArea;c.save();v&&e.save();c.beginPath();c.rect(h.x1,h.y1,h.width,h.height);c.clip();v&&(e.beginPath(),e.rect(h.x1,h.y1,h.width,h.height),e.clip());for(var l=0;l<a.dataSeriesIndexes.length;l++){var t=
[],k=a.dataSeriesIndexes[l],r=this.data[k],p=r.dataPoints,g=r.id;this._eventManager.objectMap[g]={objectType:"dataSeries",dataSeriesIndex:k};g=R(g);e.fillStyle=g;var g=[],n=!0,d=0,w,m,q,u,s=null;if(0<p.length){var y=r._colorSet[d%r._colorSet.length],x=r.lineColor=r.options.lineColor||y,B=x;c.fillStyle=y;c.strokeStyle=x;c.lineWidth=r.lineThickness;var A="solid";if(c.setLineDash){var z=F(r.nullDataLineDashType,r.lineThickness),A=r.lineDashType,C=F(A,r.lineThickness);c.setLineDash(C)}for(var L=!0;d<
p.length;d++)if(u=p[d].x.getTime?p[d].x.getTime():p[d].x,!(u<a.axisX.dataInfo.viewPortMin||u>a.axisX.dataInfo.viewPortMax&&(!r.connectNullData||!L)))if(null!==p[d].y&&p[d].y.length&&"number"===typeof p[d].y[0]&&"number"===typeof p[d].y[1]){w=a.axisX.convertValueToPixel(u);m=a.axisY.convertValueToPixel(p[d].y[0]);q=a.axisY.convertValueToPixel(p[d].y[1]);n||L?(r.connectNullData&&!n?(c.setLineDash&&(r.options.nullDataLineDashType||A===r.lineDashType&&r.lineDashType!==r.nullDataLineDashType)&&(t[t.length-
1].newLineDashArray=C,A=r.nullDataLineDashType,c.setLineDash(z)),c.lineTo(w,m),v&&e.lineTo(w,m),t.push({x:w,y:q})):(c.beginPath(),c.moveTo(w,m),s={x:w,y:m},t=[],t.push({x:w,y:q}),v&&(e.beginPath(),e.moveTo(w,m))),L=n=!1):(c.lineTo(w,m),t.push({x:w,y:q}),v&&e.lineTo(w,m),0==d%250&&f());u=r.dataPointIds[d];this._eventManager.objectMap[u]={id:u,objectType:"dataPoint",dataSeriesIndex:k,dataPointIndex:d,x1:w,y1:m,y2:q};d<p.length-1&&(B!==(p[d].lineColor||x)||A!==(p[d].lineDashType||r.lineDashType))&&(f(),
B=p[d].lineColor||x,t[t.length-1].newStrokeStyle=B,c.strokeStyle=B,c.setLineDash&&(p[d].lineDashType?(A=p[d].lineDashType,t[t.length-1].newLineDashArray=F(A,r.lineThickness),c.setLineDash(t[t.length-1].newLineDashArray)):(A=r.lineDashType,t[t.length-1].newLineDashArray=C,c.setLineDash(C))));if(0!==p[d].markerSize&&(0<p[d].markerSize||0<r.markerSize)){var K=r.getMarkerProperties(d,w,q,c);g.push(K);var da=R(u);v&&g.push({x:w,y:q,ctx:e,type:K.type,size:K.size,color:da,borderColor:da,borderThickness:K.borderThickness});
K=r.getMarkerProperties(d,w,m,c);g.push(K);da=R(u);v&&g.push({x:w,y:m,ctx:e,type:K.type,size:K.size,color:da,borderColor:da,borderThickness:K.borderThickness})}if(p[d].indexLabel||r.indexLabel||p[d].indexLabelFormatter||r.indexLabelFormatter)this._indexLabels.push({chartType:"rangeArea",dataPoint:p[d],dataSeries:r,indexKeyword:0,point:{x:w,y:m},direction:p[d].y[0]>p[d].y[1]===a.axisY.reversed?-1:1,color:y}),this._indexLabels.push({chartType:"rangeArea",dataPoint:p[d],dataSeries:r,indexKeyword:1,point:{x:w,
y:q},direction:p[d].y[0]>p[d].y[1]===a.axisY.reversed?1:-1,color:y})}else L||n||f(),L=!0;f();$.drawMarkers(g)}}v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(h.x1,h.y1,
h.width,h.height),this._eventManager.ghostCtx.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderRangeSplineArea=function(a){function f(a,b){var d=x(m,2);if(0<d.length){if(0<k.lineThickness){c.strokeStyle=b;c.setLineDash&&c.setLineDash(a);c.beginPath();c.moveTo(d[0].x,d[0].y);for(var f=0;f<d.length-3;f+=3){if(d[f].newStrokeStyle||d[f].newLineDashArray)c.stroke(),c.beginPath(),c.moveTo(d[f].x,
d[f].y),d[f].newStrokeStyle&&(c.strokeStyle=d[f].newStrokeStyle),d[f].newLineDashArray&&c.setLineDash(d[f].newLineDashArray);c.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y)}c.stroke()}c.beginPath();c.moveTo(d[0].x,d[0].y);v&&(e.beginPath(),e.moveTo(d[0].x,d[0].y));for(f=0;f<d.length-3;f+=3)c.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y),v&&e.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y);d=x(q,2);c.lineTo(q[q.length-1].x,q[q.length-
1].y);for(f=d.length-1;2<f;f-=3)c.bezierCurveTo(d[f-1].x,d[f-1].y,d[f-2].x,d[f-2].y,d[f-3].x,d[f-3].y),v&&e.bezierCurveTo(d[f-1].x,d[f-1].y,d[f-2].x,d[f-2].y,d[f-3].x,d[f-3].y);c.closePath();c.globalAlpha=k.fillOpacity;c.fill();v&&(e.closePath(),e.fill());c.globalAlpha=1;if(0<k.lineThickness){c.strokeStyle=b;c.setLineDash&&c.setLineDash(a);c.beginPath();c.moveTo(d[0].x,d[0].y);for(var g=f=0;f<d.length-3;f+=3,g++){if(m[g].newStrokeStyle||m[g].newLineDashArray)c.stroke(),c.beginPath(),c.moveTo(d[f].x,
d[f].y),m[g].newStrokeStyle&&(c.strokeStyle=m[g].newStrokeStyle),m[g].newLineDashArray&&c.setLineDash(m[g].newLineDashArray);c.bezierCurveTo(d[f+1].x,d[f+1].y,d[f+2].x,d[f+2].y,d[f+3].x,d[f+3].y)}c.stroke()}c.beginPath()}}var b=a.targetCanvasCtx||this.plotArea.ctx,c=v?this._preRenderCtx:b;if(!(0>=a.dataSeriesIndexes.length)){var e=this._eventManager.ghostCtx,g=[],h=this.plotArea;c.save();v&&e.save();c.beginPath();c.rect(h.x1,h.y1,h.width,h.height);c.clip();v&&(e.beginPath(),e.rect(h.x1,h.y1,h.width,
h.height),e.clip());for(var l=0;l<a.dataSeriesIndexes.length;l++){var t=a.dataSeriesIndexes[l],k=this.data[t],r=k.dataPoints,g=k.id;this._eventManager.objectMap[g]={objectType:"dataSeries",dataSeriesIndex:t};g=R(g);e.fillStyle=g;var g=[],p=0,n,d,w,m=[],q=[];if(0<r.length){var u=k._colorSet[p%k._colorSet.length],s=k.lineColor=k.options.lineColor||u,y=s;c.fillStyle=u;c.lineWidth=k.lineThickness;var z="solid",B;if(c.setLineDash){var A=F(k.nullDataLineDashType,k.lineThickness),z=k.lineDashType;B=F(z,
k.lineThickness)}for(d=!1;p<r.length;p++)if(n=r[p].x.getTime?r[p].x.getTime():r[p].x,!(n<a.axisX.dataInfo.viewPortMin||n>a.axisX.dataInfo.viewPortMax&&(!k.connectNullData||!d)))if(null!==r[p].y&&r[p].y.length&&"number"===typeof r[p].y[0]&&"number"===typeof r[p].y[1]){n=a.axisX.convertValueToPixel(n);d=a.axisY.convertValueToPixel(r[p].y[0]);w=a.axisY.convertValueToPixel(r[p].y[1]);var C=k.dataPointIds[p];this._eventManager.objectMap[C]={id:C,objectType:"dataPoint",dataSeriesIndex:t,dataPointIndex:p,
x1:n,y1:d,y2:w};m[m.length]={x:n,y:d};q[q.length]={x:n,y:w};p<r.length-1&&(y!==(r[p].lineColor||s)||z!==(r[p].lineDashType||k.lineDashType))&&(y=r[p].lineColor||s,m[m.length-1].newStrokeStyle=y,c.setLineDash&&(r[p].lineDashType?(z=r[p].lineDashType,m[m.length-1].newLineDashArray=F(z,k.lineThickness)):(z=k.lineDashType,m[m.length-1].newLineDashArray=B)));if(0!==r[p].markerSize&&(0<r[p].markerSize||0<k.markerSize)){var la=k.getMarkerProperties(p,n,d,c);g.push(la);var L=R(C);v&&g.push({x:n,y:d,ctx:e,
type:la.type,size:la.size,color:L,borderColor:L,borderThickness:la.borderThickness});la=k.getMarkerProperties(p,n,w,c);g.push(la);L=R(C);v&&g.push({x:n,y:w,ctx:e,type:la.type,size:la.size,color:L,borderColor:L,borderThickness:la.borderThickness})}if(r[p].indexLabel||k.indexLabel||r[p].indexLabelFormatter||k.indexLabelFormatter)this._indexLabels.push({chartType:"rangeSplineArea",dataPoint:r[p],dataSeries:k,indexKeyword:0,point:{x:n,y:d},direction:r[p].y[0]<=r[p].y[1]?-1:1,color:u}),this._indexLabels.push({chartType:"rangeSplineArea",
dataPoint:r[p],dataSeries:k,indexKeyword:1,point:{x:n,y:w},direction:r[p].y[0]<=r[p].y[1]?1:-1,color:u});d=!1}else 0<p&&!d&&(k.connectNullData?c.setLineDash&&(0<m.length&&(k.options.nullDataLineDashType||!r[p-1].lineDashType))&&(m[m.length-1].newLineDashArray=A,z=k.nullDataLineDashType):(f(B,s),m=[],q=[])),d=!0;f(B,s);$.drawMarkers(g)}}v&&(b.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&c.drawImage(a.axisX.maskCanvas,0,0,this.width,
this.height),a.axisY.maskCanvas&&c.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),c.clearRect(h.x1,h.y1,h.width,h.height),this._eventManager.ghostCtx.restore());c.restore();return{source:b,dest:this.plotArea.ctx,animationCallback:O.xClipAnimation,easingFunction:O.easing.linear,animationBase:0}}};q.prototype.renderWaterfall=function(a){var f=a.targetCanvasCtx||this.plotArea.ctx,b=v?this._preRenderCtx:
f;if(!(0>=a.dataSeriesIndexes.length)){var c=this._eventManager.ghostCtx,e=null,g=this.plotArea,h=0,l,t,k,r,p=a.axisY.convertValueToPixel(a.axisY.logarithmic?a.axisY.viewportMinimum:0),h=this.options.dataPointMinWidth?this.dataPointMinWidth:this.options.dataPointWidth?this.dataPointWidth:1;t=this.options.dataPointMaxWidth?this.dataPointMaxWidth:this.options.dataPointWidth?this.dataPointWidth:Math.min(0.15*this.width,0.9*(this.plotArea.width/a.plotType.totalDataSeries))<<0;var n=a.axisX.dataInfo.minDiff;
isFinite(n)||(n=0.3*Math.abs(a.axisX.range));n=this.options.dataPointWidth?this.dataPointWidth:0.6*(g.width*(a.axisX.logarithmic?Math.log(n)/Math.log(a.axisX.range):Math.abs(n)/Math.abs(a.axisX.range))/a.plotType.totalDataSeries)<<0;this.dataPointMaxWidth&&h>t&&(h=Math.min(this.options.dataPointWidth?this.dataPointWidth:Infinity,t));!this.dataPointMaxWidth&&(this.dataPointMinWidth&&t<h)&&(t=Math.max(this.options.dataPointWidth?this.dataPointWidth:-Infinity,h));n<h&&(n=h);n>t&&(n=t);b.save();v&&this._eventManager.ghostCtx.save();
b.beginPath();b.rect(g.x1,g.y1,g.width,g.height);b.clip();v&&(this._eventManager.ghostCtx.beginPath(),this._eventManager.ghostCtx.rect(g.x1,g.y1,g.width,g.height),this._eventManager.ghostCtx.clip());for(var d=0;d<a.dataSeriesIndexes.length;d++){var w=a.dataSeriesIndexes[d],m=this.data[w],q=m.dataPoints,e=m._colorSet[0];m.risingColor=m.options.risingColor?m.options.risingColor:e;m.fallingColor=m.options.fallingColor?m.options.fallingColor:"#e40a0a";var u="number"===typeof m.options.lineThickness?Math.round(m.lineThickness):
1,s=1===Math.round(u)%2?-0.5:0;if(0<q.length)for(var y=5<n&&m.bevelEnabled?!0:!1,x=!1,z=null,A=null,h=0;h<q.length;h++)if(q[h].getTime?r=q[h].x.getTime():r=q[h].x,"number"!==typeof q[h].y){if(0<h&&!x&&m.connectNullData)var C=m.options.nullDataLineDashType||!q[h-1].lineDashType?m.nullDataLineDashType:q[h-1].lineDashType;x=!0}else{l=a.axisX.convertValueToPixel(r);t=0===m.dataPointEOs[h].cumulativeSum?p:a.axisY.convertValueToPixel(m.dataPointEOs[h].cumulativeSum);k=0===m.dataPointEOs[h].cumulativeSumYStartValue?
p:a.axisY.convertValueToPixel(m.dataPointEOs[h].cumulativeSumYStartValue);l=a.axisX.reversed?l+a.plotType.totalDataSeries*n/2-(a.previousDataSeriesCount+d)*n<<0:l-a.plotType.totalDataSeries*n/2+(a.previousDataSeriesCount+d)*n<<0;var la=a.axisX.reversed?l-n<<0:l+n<<0;t>k&&(e=t,t=k,k=e);a.axisY.reversed&&(e=t,t=k,k=e);e=m.dataPointIds[h];this._eventManager.objectMap[e]={id:e,objectType:"dataPoint",dataSeriesIndex:w,dataPointIndex:h,x1:l,y1:t,x2:la,y2:k};var L=q[h].color?q[h].color:0<q[h].y?m.risingColor:
m.fallingColor;X(b,l,t,la,k,L,0,L,y,y,!1,!1,m.fillOpacity);e=R(e);v&&X(this._eventManager.ghostCtx,l,t,la,k,e,0,null,!1,!1,!1,!1);var K,L=l;K="undefined"!==typeof q[h].isIntermediateSum&&!0===q[h].isIntermediateSum||"undefined"!==typeof q[h].isCumulativeSum&&!0===q[h].isCumulativeSum?0<q[h].y?t:k:0<q[h].y?k:t;0<h&&z&&(!x||m.connectNullData)&&(x&&b.setLineDash&&b.setLineDash(F(C,u)),b.beginPath(),b.moveTo(z,A-s),b.lineTo(L,K-s),0<u&&b.stroke(),v&&(c.beginPath(),c.moveTo(z,A-s),c.lineTo(L,K-s),0<u&&
c.stroke()));x=!1;z=la;A=0<q[h].y?t:k;L=q[h].lineDashType?q[h].lineDashType:m.options.lineDashType?m.options.lineDashType:"shortDash";b.strokeStyle=q[h].lineColor?q[h].lineColor:m.options.lineColor?m.options.lineColor:"#9e9e9e";b.lineWidth=u;b.setLineDash&&(L=F(L,u),b.setLineDash(L));(q[h].indexLabel||m.indexLabel||q[h].indexLabelFormatter||m.indexLabelFormatter)&&this._indexLabels.push({chartType:"waterfall",dataPoint:q[h],dataSeries:m,point:{x:l+(la-l)/2,y:0<=q[h].y?t:k},direction:0>q[h].y===a.axisY.reversed?
1:-1,bounds:{x1:l,y1:Math.min(t,k),x2:la,y2:Math.max(t,k)},color:e})}}v&&(f.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.globalCompositeOperation="source-atop",a.axisX.maskCanvas&&b.drawImage(a.axisX.maskCanvas,0,0,this.width,this.height),a.axisY.maskCanvas&&b.drawImage(a.axisY.maskCanvas,0,0,this.width,this.height),this._breaksCanvasCtx&&this._breaksCanvasCtx.drawImage(this._preRenderCanvas,0,0,this.width,this.height),b.clearRect(g.x1,g.y1,g.width,g.height),this._eventManager.ghostCtx.restore());
b.restore();return{source:f,dest:this.plotArea.ctx,animationCallback:O.fadeInAnimation,easingFunction:O.easing.easeInQuad,animationBase:0}}};var pa=function(a,f,b,c,e,g,h,l,t){if(!(0>b)){"undefined"===typeof l&&(l=1);if(!v){var k=Number((h%(2*Math.PI)).toFixed(8));Number((g%(2*Math.PI)).toFixed(8))===k&&(h-=1E-4)}a.save();a.globalAlpha=l;"pie"===e?(a.beginPath(),a.moveTo(f.x,f.y),a.arc(f.x,f.y,b,g,h,!1),a.fillStyle=c,a.strokeStyle="white",a.lineWidth=2,a.closePath(),a.fill()):"doughnut"===e&&(a.beginPath(),
a.arc(f.x,f.y,b,g,h,!1),0<=t&&a.arc(f.x,f.y,t*b,h,g,!0),a.closePath(),a.fillStyle=c,a.strokeStyle="white",a.lineWidth=2,a.fill());a.globalAlpha=1;a.restore()}};q.prototype.renderPie=function(a){function f(){if(k&&r){for(var a=0,b=0,c=0,e=0,f=0;f<r.length;f++){var g=r[f],h=k.dataPointIds[f];d[f].id=h;d[f].objectType="dataPoint";d[f].dataPointIndex=f;d[f].dataSeriesIndex=0;var l=d[f],p={percent:null,total:null},m=null,p=t.getPercentAndTotal(k,g);if(k.indexLabelFormatter||g.indexLabelFormatter)m={chart:t.options,
dataSeries:k,dataPoint:g,total:p.total,percent:p.percent};p=g.indexLabelFormatter?g.indexLabelFormatter(m):g.indexLabel?t.replaceKeywordsWithValue(g.indexLabel,g,k,f):k.indexLabelFormatter?k.indexLabelFormatter(m):k.indexLabel?t.replaceKeywordsWithValue(k.indexLabel,g,k,f):g.label?g.label:"";t._eventManager.objectMap[h]=l;l.center={x:x.x,y:x.y};l.y=g.y;l.radius=A;l.percentInnerRadius=O;l.indexLabelText=p;l.indexLabelPlacement=k.indexLabelPlacement;l.indexLabelLineColor=g.indexLabelLineColor?g.indexLabelLineColor:
k.options.indexLabelLineColor?k.options.indexLabelLineColor:g.color?g.color:k._colorSet[f%k._colorSet.length];l.indexLabelLineThickness=y(g.indexLabelLineThickness)?k.indexLabelLineThickness:g.indexLabelLineThickness;l.indexLabelLineDashType=g.indexLabelLineDashType?g.indexLabelLineDashType:k.indexLabelLineDashType;l.indexLabelFontColor=g.indexLabelFontColor?g.indexLabelFontColor:k.indexLabelFontColor;l.indexLabelFontStyle=g.indexLabelFontStyle?g.indexLabelFontStyle:k.indexLabelFontStyle;l.indexLabelFontWeight=
g.indexLabelFontWeight?g.indexLabelFontWeight:k.indexLabelFontWeight;l.indexLabelFontSize=y(g.indexLabelFontSize)?k.indexLabelFontSize:g.indexLabelFontSize;l.indexLabelFontFamily=g.indexLabelFontFamily?g.indexLabelFontFamily:k.indexLabelFontFamily;l.indexLabelBackgroundColor=g.indexLabelBackgroundColor?g.indexLabelBackgroundColor:k.options.indexLabelBackgroundColor?k.options.indexLabelBackgroundColor:k.indexLabelBackgroundColor;l.indexLabelMaxWidth=g.indexLabelMaxWidth?g.indexLabelMaxWidth:k.indexLabelMaxWidth?
k.indexLabelMaxWidth:0.33*n.width;l.indexLabelWrap="undefined"!==typeof g.indexLabelWrap?g.indexLabelWrap:k.indexLabelWrap;l.startAngle=0===f?k.startAngle?k.startAngle/180*Math.PI:0:d[f-1].endAngle;l.startAngle=(l.startAngle+2*Math.PI)%(2*Math.PI);l.endAngle=l.startAngle+2*Math.PI/z*Math.abs(g.y);g=(l.endAngle+l.startAngle)/2;g=(g+2*Math.PI)%(2*Math.PI);l.midAngle=g;if(l.midAngle>Math.PI/2-u&&l.midAngle<Math.PI/2+u){if(0===a||d[c].midAngle>l.midAngle)c=f;a++}else if(l.midAngle>3*Math.PI/2-u&&l.midAngle<
3*Math.PI/2+u){if(0===b||d[e].midAngle>l.midAngle)e=f;b++}l.hemisphere=g>Math.PI/2&&g<=3*Math.PI/2?"left":"right";l.indexLabelTextBlock=new ka(t.plotArea.ctx,{fontSize:l.indexLabelFontSize,fontFamily:l.indexLabelFontFamily,fontColor:l.indexLabelFontColor,fontStyle:l.indexLabelFontStyle,fontWeight:l.indexLabelFontWeight,horizontalAlign:"left",backgroundColor:l.indexLabelBackgroundColor,maxWidth:l.indexLabelMaxWidth,maxHeight:l.indexLabelWrap?5*l.indexLabelFontSize:1.5*l.indexLabelFontSize,text:l.indexLabelText,
padding:0,textBaseline:"top"});l.indexLabelTextBlock.measureText()}h=g=0;p=!1;for(f=0;f<r.length;f++)l=d[(c+f)%r.length],1<a&&(l.midAngle>Math.PI/2-u&&l.midAngle<Math.PI/2+u)&&(g<=a/2&&!p?(l.hemisphere="right",g++):(l.hemisphere="left",p=!0));p=!1;for(f=0;f<r.length;f++)l=d[(e+f)%r.length],1<b&&(l.midAngle>3*Math.PI/2-u&&l.midAngle<3*Math.PI/2+u)&&(h<=b/2&&!p?(l.hemisphere="left",h++):(l.hemisphere="right",p=!0))}}function b(a){var b=t.plotArea.ctx;b.clearRect(n.x1,n.y1,n.width,n.height);b.fillStyle=
t.backgroundColor;b.fillRect(n.x1,n.y1,n.width,n.height);for(b=0;b<r.length;b++){var c=d[b].startAngle,e=d[b].endAngle;if(e>c){var f=0.07*A*Math.cos(d[b].midAngle),g=0.07*A*Math.sin(d[b].midAngle),h=!1;if(r[b].exploded){if(1E-9<Math.abs(d[b].center.x-(x.x+f))||1E-9<Math.abs(d[b].center.y-(x.y+g)))d[b].center.x=x.x+f*a,d[b].center.y=x.y+g*a,h=!0}else if(0<Math.abs(d[b].center.x-x.x)||0<Math.abs(d[b].center.y-x.y))d[b].center.x=x.x+f*(1-a),d[b].center.y=x.y+g*(1-a),h=!0;h&&(f={},f.dataSeries=k,f.dataPoint=
k.dataPoints[b],f.index=b,t.toolTip.highlightObjects([f]));pa(t.plotArea.ctx,d[b].center,d[b].radius,r[b].color?r[b].color:k._colorSet[b%k._colorSet.length],k.type,c,e,k.fillOpacity,d[b].percentInnerRadius)}}a=t.plotArea.ctx;a.save();a.fillStyle="black";a.strokeStyle="grey";a.textBaseline="middle";a.lineJoin="round";for(b=b=0;b<r.length;b++)c=d[b],c.indexLabelText&&(c.indexLabelTextBlock.y-=c.indexLabelTextBlock.height/2,e=0,e="left"===c.hemisphere?"inside"!==k.indexLabelPlacement?-(c.indexLabelTextBlock.width+
p):-c.indexLabelTextBlock.width/2:"inside"!==k.indexLabelPlacement?p:-c.indexLabelTextBlock.width/2,c.indexLabelTextBlock.x+=e,c.indexLabelTextBlock.render(!0),c.indexLabelTextBlock.x-=e,c.indexLabelTextBlock.y+=c.indexLabelTextBlock.height/2,"inside"!==c.indexLabelPlacement&&0<c.indexLabelLineThickness&&(e=c.center.x+A*Math.cos(c.midAngle),f=c.center.y+A*Math.sin(c.midAngle),a.strokeStyle=c.indexLabelLineColor,a.lineWidth=c.indexLabelLineThickness,a.setLineDash&&a.setLineDash(F(c.indexLabelLineDashType,
c.indexLabelLineThickness)),a.beginPath(),a.moveTo(e,f),a.lineTo(c.indexLabelTextBlock.x,c.indexLabelTextBlock.y),a.lineTo(c.indexLabelTextBlock.x+("left"===c.hemisphere?-p:p),c.indexLabelTextBlock.y),a.stroke()),a.lineJoin="miter");a.save()}function c(a,b){var c=0,c=a.indexLabelTextBlock.y-a.indexLabelTextBlock.height/2,d=a.indexLabelTextBlock.y+a.indexLabelTextBlock.height/2,e=b.indexLabelTextBlock.y-b.indexLabelTextBlock.height/2,f=b.indexLabelTextBlock.y+b.indexLabelTextBlock.height/2;return c=
b.indexLabelTextBlock.y>a.indexLabelTextBlock.y?e-d:c-f}function e(a){for(var b=null,e=1;e<r.length;e++)if(b=(a+e+d.length)%d.length,d[b].hemisphere!==d[a].hemisphere){b=null;break}else if(d[b].indexLabelText&&b!==a&&(0>c(d[b],d[a])||("right"===d[a].hemisphere?d[b].indexLabelTextBlock.y>=d[a].indexLabelTextBlock.y:d[b].indexLabelTextBlock.y<=d[a].indexLabelTextBlock.y)))break;else b=null;return b}function g(a,b,f){f=(f||0)+1;if(1E3<f)return 0;b=b||0;var k=0,h=x.y-1*q,n=x.y+1*q;if(0<=a&&a<r.length){var l=
d[a];if(0>b&&l.indexLabelTextBlock.y<h||0<b&&l.indexLabelTextBlock.y>n)return 0;var t=0,p=0,p=t=t=0;0>b?l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2>h&&l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2+b<h&&(b=-(h-(l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2+b))):l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2<h&&l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2+b>n&&(b=l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2+b-n);b=l.indexLabelTextBlock.y+b;h=
0;h="right"===l.hemisphere?x.x+Math.sqrt(Math.pow(q,2)-Math.pow(b-x.y,2)):x.x-Math.sqrt(Math.pow(q,2)-Math.pow(b-x.y,2));p=x.x+A*Math.cos(l.midAngle);t=x.y+A*Math.sin(l.midAngle);t=Math.sqrt(Math.pow(h-p,2)+Math.pow(b-t,2));p=Math.acos(A/q);t=Math.acos((q*q+A*A-t*t)/(2*A*q));b=t<p?b-l.indexLabelTextBlock.y:0;h=null;for(n=1;n<r.length;n++)if(h=(a-n+d.length)%d.length,d[h].hemisphere!==d[a].hemisphere){h=null;break}else if(d[h].indexLabelText&&d[h].hemisphere===d[a].hemisphere&&h!==a&&(0>c(d[h],d[a])||
("right"===d[a].hemisphere?d[h].indexLabelTextBlock.y<=d[a].indexLabelTextBlock.y:d[h].indexLabelTextBlock.y>=d[a].indexLabelTextBlock.y)))break;else h=null;p=h;t=e(a);n=h=0;0>b?(n="right"===l.hemisphere?p:t,k=b,null!==n&&(p=-b,b=l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2-(d[n].indexLabelTextBlock.y+d[n].indexLabelTextBlock.height/2),b-p<m&&(h=-p,n=g(n,h,f+1),+n.toFixed(v)>+h.toFixed(v)&&(k=b>m?-(b-m):-(p-(n-h)))))):0<b&&(n="right"===l.hemisphere?t:p,k=b,null!==n&&(p=b,b=d[n].indexLabelTextBlock.y-
d[n].indexLabelTextBlock.height/2-(l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2),b-p<m&&(h=p,n=g(n,h,f+1),+n.toFixed(v)<+h.toFixed(v)&&(k=b>m?b-m:p-(h-n)))));k&&(f=l.indexLabelTextBlock.y+k,b=0,b="right"===l.hemisphere?x.x+Math.sqrt(Math.pow(q,2)-Math.pow(f-x.y,2)):x.x-Math.sqrt(Math.pow(q,2)-Math.pow(f-x.y,2)),l.midAngle>Math.PI/2-u&&l.midAngle<Math.PI/2+u?(h=(a-1+d.length)%d.length,h=d[h],a=d[(a+1+d.length)%d.length],"left"===l.hemisphere&&"right"===h.hemisphere&&b>h.indexLabelTextBlock.x?
b=h.indexLabelTextBlock.x-15:"right"===l.hemisphere&&("left"===a.hemisphere&&b<a.indexLabelTextBlock.x)&&(b=a.indexLabelTextBlock.x+15)):l.midAngle>3*Math.PI/2-u&&l.midAngle<3*Math.PI/2+u&&(h=(a-1+d.length)%d.length,h=d[h],a=d[(a+1+d.length)%d.length],"right"===l.hemisphere&&"left"===h.hemisphere&&b<h.indexLabelTextBlock.x?b=h.indexLabelTextBlock.x+15:"left"===l.hemisphere&&("right"===a.hemisphere&&b>a.indexLabelTextBlock.x)&&(b=a.indexLabelTextBlock.x-15)),l.indexLabelTextBlock.y=f,l.indexLabelTextBlock.x=
b,l.indexLabelAngle=Math.atan2(l.indexLabelTextBlock.y-x.y,l.indexLabelTextBlock.x-x.x))}return k}function h(){var a=t.plotArea.ctx;a.fillStyle="grey";a.strokeStyle="grey";a.font="16px Arial";a.textBaseline="middle";for(var b=a=0,f=0,h=!0,b=0;10>b&&(1>b||0<f);b++){if(k.radius||!k.radius&&"undefined"!==typeof k.innerRadius&&null!==k.innerRadius&&A-f<=C)h=!1;h&&(A-=f);f=0;if("inside"!==k.indexLabelPlacement){q=A*s;for(a=0;a<r.length;a++){var l=d[a];l.indexLabelTextBlock.x=x.x+q*Math.cos(l.midAngle);
l.indexLabelTextBlock.y=x.y+q*Math.sin(l.midAngle);l.indexLabelAngle=l.midAngle;l.radius=A;l.percentInnerRadius=O}for(var u,y,a=0;a<r.length;a++){var l=d[a],z=e(a);if(null!==z){u=d[a];y=d[z];var B=0,B=c(u,y)-m;if(0>B){for(var F=y=0,sa=0;sa<r.length;sa++)sa!==a&&d[sa].hemisphere===l.hemisphere&&(d[sa].indexLabelTextBlock.y<l.indexLabelTextBlock.y?y++:F++);y=B/(y+F||1)*F;var F=-1*(B-y),J=sa=0;"right"===l.hemisphere?(sa=g(a,y),F=-1*(B-sa),J=g(z,F),+J.toFixed(v)<+F.toFixed(v)&&+sa.toFixed(v)<=+y.toFixed(v)&&
g(a,-(F-J))):(sa=g(z,y),F=-1*(B-sa),J=g(a,F),+J.toFixed(v)<+F.toFixed(v)&&+sa.toFixed(v)<=+y.toFixed(v)&&g(z,-(F-J)))}}}}else for(a=0;a<r.length;a++)l=d[a],q="pie"===k.type?0.7*A:0.8*A,z=x.x+q*Math.cos(l.midAngle),y=x.y+q*Math.sin(l.midAngle),l.indexLabelTextBlock.x=z,l.indexLabelTextBlock.y=y;for(a=0;a<r.length;a++)if(l=d[a],z=l.indexLabelTextBlock.measureText(),0!==z.height&&0!==z.width)z=z=0,"right"===l.hemisphere?(z=n.x2-(l.indexLabelTextBlock.x+l.indexLabelTextBlock.width+p),z*=-1):z=n.x1-(l.indexLabelTextBlock.x-
l.indexLabelTextBlock.width-p),0<z&&(!h&&l.indexLabelText&&(y="right"===l.hemisphere?n.x2-l.indexLabelTextBlock.x:l.indexLabelTextBlock.x-n.x1,0.3*l.indexLabelTextBlock.maxWidth>y?l.indexLabelText="":l.indexLabelTextBlock.maxWidth=0.85*y,0.3*l.indexLabelTextBlock.maxWidth<y&&(l.indexLabelTextBlock.x-="right"===l.hemisphere?2:-2)),Math.abs(l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2-x.y)<A||Math.abs(l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2-x.y)<A)&&(z/=Math.abs(Math.cos(l.indexLabelAngle)),
9<z&&(z*=0.3),z>f&&(f=z)),z=z=0,0<l.indexLabelAngle&&l.indexLabelAngle<Math.PI?(z=n.y2-(l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2+5),z*=-1):z=n.y1-(l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2-5),0<z&&(!h&&l.indexLabelText&&(y=0<l.indexLabelAngle&&l.indexLabelAngle<Math.PI?-1:1,0===g(a,z*y)&&g(a,2*y)),Math.abs(l.indexLabelTextBlock.x-x.x)<A&&(z/=Math.abs(Math.sin(l.indexLabelAngle)),9<z&&(z*=0.3),z>f&&(f=z)));var M=function(a,b,c){for(var e=[],f=0;e.push(d[b]),b!==c;b=(b+1+
r.length)%r.length);e.sort(function(a,b){return a.y-b.y});for(b=0;b<e.length;b++)if(c=e[b],f<0.7*a)f+=c.indexLabelTextBlock.height,c.indexLabelTextBlock.text="",c.indexLabelText="",c.indexLabelTextBlock.measureText();else break};(function(){for(var a=-1,b=-1,f=0,g=!1,h=0;h<r.length;h++)if(g=!1,u=d[h],u.indexLabelText){var k=e(h);if(null!==k){var l=d[k];B=0;B=c(u,l);var n;if(n=0>B){n=u.indexLabelTextBlock.x;var t=u.indexLabelTextBlock.y-u.indexLabelTextBlock.height/2,m=u.indexLabelTextBlock.y+u.indexLabelTextBlock.height/
2,w=l.indexLabelTextBlock.y-l.indexLabelTextBlock.height/2,q=l.indexLabelTextBlock.x+l.indexLabelTextBlock.width,s=l.indexLabelTextBlock.y+l.indexLabelTextBlock.height/2;n=u.indexLabelTextBlock.x+u.indexLabelTextBlock.width<l.indexLabelTextBlock.x-p||n>q+p||t>s+p||m<w-p?!1:!0}n?(0>a&&(a=h),k!==a&&(b=k,f+=-B),0===h%Math.max(r.length/10,3)&&(g=!0)):g=!0;g&&(0<f&&0<=a&&0<=b)&&(M(f,a,b),b=a=-1,f=0)}}0<f&&M(f,a,b)})()}}function l(){t.plotArea.layoutManager.reset();t.title&&(t.title.dockInsidePlotArea||
"center"===t.title.horizontalAlign&&"center"===t.title.verticalAlign)&&t.title.render();if(t.subtitles)for(var a=0;a<t.subtitles.length;a++){var b=t.subtitles[a];(b.dockInsidePlotArea||"center"===b.horizontalAlign&&"center"===b.verticalAlign)&&b.render()}t.legend&&(t.legend.dockInsidePlotArea||"center"===t.legend.horizontalAlign&&"center"===t.legend.verticalAlign)&&t.legend.render()}var t=this;if(!(0>=a.dataSeriesIndexes.length)){var k=this.data[a.dataSeriesIndexes[0]],r=k.dataPoints,p=10,n=this.plotArea,
d=k.dataPointEOs,m=2,q,s=1.3,u=20/180*Math.PI,v=6,x={x:(n.x2+n.x1)/2,y:(n.y2+n.y1)/2},z=0;a=!1;for(var B=0;B<r.length;B++)z+=Math.abs(r[B].y),!a&&("undefined"!==typeof r[B].indexLabel&&null!==r[B].indexLabel&&0<r[B].indexLabel.toString().length)&&(a=!0),!a&&("undefined"!==typeof r[B].label&&null!==r[B].label&&0<r[B].label.toString().length)&&(a=!0);if(0!==z){a=a||"undefined"!==typeof k.indexLabel&&null!==k.indexLabel&&0<k.indexLabel.toString().length;var A="inside"!==k.indexLabelPlacement&&a?0.75*
Math.min(n.width,n.height)/2:0.92*Math.min(n.width,n.height)/2;k.radius&&(A=J(k.radius,A));var C="undefined"!==typeof k.innerRadius&&null!==k.innerRadius?J(k.innerRadius,A):0.7*A;k.radius=A;"doughnut"===k.type&&(k.innerRadius=C);var O=Math.min(C/A,(A-1)/A);this.pieDoughnutClickHandler=function(a){t.isAnimating||!y(a.dataSeries.explodeOnClick)&&!a.dataSeries.explodeOnClick||(a=a.dataPoint,a.exploded=a.exploded?!1:!0,1<this.dataPoints.length&&t._animator.animate(0,500,function(a){b(a);l()}))};f();h();
h();h();h();this.disableToolTip=!0;this._animator.animate(0,this.animatedRender?this.animationDuration:0,function(a){var b=t.plotArea.ctx;b.clearRect(n.x1,n.y1,n.width,n.height);b.fillStyle=t.backgroundColor;b.fillRect(n.x1,n.y1,n.width,n.height);a=d[0].startAngle+2*Math.PI*a;for(b=0;b<r.length;b++){var c=0===b?d[b].startAngle:e,e=c+(d[b].endAngle-d[b].startAngle),f=!1;e>a&&(e=a,f=!0);var g=r[b].color?r[b].color:k._colorSet[b%k._colorSet.length];e>c&&pa(t.plotArea.ctx,d[b].center,d[b].radius,g,k.type,
c,e,k.fillOpacity,d[b].percentInnerRadius);if(f)break}l()},function(){t.disableToolTip=!1;t._animator.animate(0,t.animatedRender?500:0,function(a){b(a);l()})})}}};var qa=function(a,f,b,c){"undefined"===typeof b&&(b=1);0>=Math.round(f.y4-f.y1)||(a.save(),a.globalAlpha=b,a.beginPath(),a.moveTo(Math.round(f.x1),Math.round(f.y1)),a.lineTo(Math.round(f.x2),Math.round(f.y2)),a.lineTo(Math.round(f.x3),Math.round(f.y3)),a.lineTo(Math.round(f.x4),Math.round(f.y4)),"undefined"!==f.x5&&(a.lineTo(Math.round(f.x5),
Math.round(f.y5)),a.lineTo(Math.round(f.x6),Math.round(f.y6))),a.closePath(),a.fillStyle=c?c:f.color,a.fill(),a.globalAplha=1,a.restore())};q.prototype.renderFunnel=function(a){function f(){for(var a=0,b=[],c=0;c<x.length;c++){if("undefined"===typeof x[c].y)return-1;x[c].y="number"===typeof x[c].y?x[c].y:0;a+=Math.abs(x[c].y)}if(0===a)return-1;for(c=b[0]=0;c<x.length;c++)b.push(Math.abs(x[c].y)*J/a);return b}function b(){var a=Y,b=X,c=M,d=Z,e,f;e=ca;f=aa-P;headArea=(f-e)*(b-a+(d-c))/2;headArea=Math.abs(headArea);
c=Z-M;e=f-e;f=c*(f-aa);f=Math.abs(f);f=headArea+f;for(var d=[],g=0,h=0;h<x.length;h++){if("undefined"===typeof x[h].y)return-1;x[h].y="number"===typeof x[h].y?x[h].y:0;g+=Math.abs(x[h].y)}if(0===g)return-1;for(var k=d[0]=0,l=0,n,b=b-a,t=!1,h=0;h<x.length;h++)a=Math.abs(x[h].y)*f/g,t?k=0==Number(c.toFixed(3))?0:a/c:(sqrt=ea*ea*b*b-4*Math.abs(ea)*a,0>sqrt?(n=c,k=(b+n)*(e-l)/2,a-=k,k=e-l,l+=e-l,k+=0==n?0:a/n,l+=a/n,t=!0):(k=(Math.abs(ea)*b-Math.sqrt(sqrt))/2,n=b-2*k/Math.abs(ea),l+=k,l>e&&(l-=k,n=c,
k=(b+n)*(e-l)/2,a-=k,k=e-l,l+=e-l,k+=a/n,l+=a/n,t=!0),b=n)),d.push(k);return d}function c(){if(u&&x){for(var a,b,c,e,f,g,h,k,l,n,t,p,r,m,w=[],q=[],z={percent:null,total:null},A=null,B=0;B<x.length;B++)m=N[B],m="undefined"!==typeof m.x5?(m.y2+m.y4)/2:(m.y2+m.y3)/2,m=d(m).x2+1,w[B]=S-m-U;m=0.5*U;for(var B=0,ya=x.length-1;B<x.length||0<=ya;B++,ya--){b=u.reversed?x[ya]:x[B];a=b.color?b.color:u.reversed?u._colorSet[(x.length-1-B)%u._colorSet.length]:u._colorSet[B%u._colorSet.length];c=b.indexLabelPlacement||
u.indexLabelPlacement||"outside";e=b.indexLabelBackgroundColor||u.indexLabelBackgroundColor||(v?"transparent":null);f=b.indexLabelFontColor||u.indexLabelFontColor||"#979797";g=y(b.indexLabelFontSize)?u.indexLabelFontSize:b.indexLabelFontSize;h=b.indexLabelFontStyle||u.indexLabelFontStyle||"normal";k=b.indexLabelFontFamily||u.indexLabelFontFamily||"arial";l=b.indexLabelFontWeight||u.indexLabelFontWeight||"normal";a=b.indexLabelLineColor||u.options.indexLabelLineColor||a;n="number"===typeof b.indexLabelLineThickness?
b.indexLabelLineThickness:"number"===typeof u.indexLabelLineThickness?u.indexLabelLineThickness:2;t=b.indexLabelLineDashType||u.indexLabelLineDashType||"solid";p="undefined"!==typeof b.indexLabelWrap?b.indexLabelWrap:"undefined"!==typeof u.indexLabelWrap?u.indexLabelWrap:!0;r=u.dataPointIds[B];s._eventManager.objectMap[r]={id:r,objectType:"dataPoint",dataPointIndex:B,dataSeriesIndex:0,funnelSection:N[u.reversed?x.length-1-B:B]};"inside"===u.indexLabelPlacement&&(w[B]=B!==fa?u.reversed?N[B].x2-N[B].x1:
N[B].x3-N[B].x4:N[B].x3-N[B].x6,20>w[B]&&(w[B]=B!==fa?u.reversed?N[B].x3-N[B].x4:N[B].x2-N[B].x1:N[B].x2-N[B].x1,w[B]/=2));r=b.indexLabelMaxWidth?b.indexLabelMaxWidth:u.options.indexLabelMaxWidth?u.indexLabelMaxWidth:w[B];if(r>w[B]||0>r)r=w[B];q[B]="inside"===u.indexLabelPlacement?N[B].height:!1;z=s.getPercentAndTotal(u,b);if(u.indexLabelFormatter||b.indexLabelFormatter)A={chart:s.options,dataSeries:u,dataPoint:b,total:z.total,percent:z.percent};b=b.indexLabelFormatter?b.indexLabelFormatter(A):b.indexLabel?
s.replaceKeywordsWithValue(b.indexLabel,b,u,B):u.indexLabelFormatter?u.indexLabelFormatter(A):u.indexLabel?s.replaceKeywordsWithValue(u.indexLabel,b,u,B):b.label?b.label:"";0>=n&&(n=0);1E3>r&&1E3-r<m&&(r+=1E3-r);R.roundRect||Ba(R);c=new ka(R,{fontSize:g,fontFamily:k,fontColor:f,fontStyle:h,fontWeight:l,horizontalAlign:c,backgroundColor:e,maxWidth:r,maxHeight:!1===q[B]?p?4.28571429*g:1.5*g:q[B],text:b,padding:ga});c.measureText();G.push({textBlock:c,id:u.reversed?ya:B,isDirty:!1,lineColor:a,lineThickness:n,
lineDashType:t,height:c.height<c.maxHeight?c.height:c.maxHeight,width:c.width<c.maxWidth?c.width:c.maxWidth})}}}function e(){var a,b,c,d,e,f=[];e=!1;c=0;for(var g=S-X-U/2,g=u.options.indexLabelMaxWidth?u.indexLabelMaxWidth>g?g:u.indexLabelMaxWidth:g,h=G.length-1;0<=h;h--){dataPoint=x[G[h].id];c=G[h];d=c.textBlock;b=(a=n(h)<N.length?G[n(h)]:null)?a.textBlock:null;c=c.height;a&&d.y+c+ga>b.y&&(e=!0);c=dataPoint.indexLabelMaxWidth||g;if(c>g||0>c)c=g;f.push(c)}if(e)for(h=G.length-1;0<=h;h--)a=N[h],G[h].textBlock.maxWidth=
f[f.length-(h+1)],G[h].textBlock.measureText(),G[h].textBlock.x=S-g,c=G[h].textBlock.height<G[h].textBlock.maxHeight?G[h].textBlock.height:G[h].textBlock.maxHeight,e=G[h].textBlock.width<G[h].textBlock.maxWidth?G[h].textBlock.width:G[h].textBlock.maxWidth,G[h].height=c,G[h].width=e,c="undefined"!==typeof a.x5?(a.y2+a.y4)/2:(a.y2+a.y3)/2,G[h].textBlock.y=c-G[h].height/2,u.reversed?(G[h].textBlock.y+G[h].height>T+C&&(G[h].textBlock.y=T+C-G[h].height),G[h].textBlock.y<ra-C&&(G[h].textBlock.y=ra-C)):
(G[h].textBlock.y<T-C&&(G[h].textBlock.y=T-C),G[h].textBlock.y+G[h].height>ra+C&&(G[h].textBlock.y=ra+C-G[h].height))}function g(){var a,b,c,e;if("inside"!==u.indexLabelPlacement)for(var f=0;f<N.length;f++)0==G[f].textBlock.text.length?G[f].isDirty=!0:(a=N[f],c="undefined"!==typeof a.x5?(a.y2+a.y4)/2:(a.y2+a.y3)/2,b=u.reversed?"undefined"!==typeof a.x5?c>ba?d(c).x2+1:(a.x2+a.x3)/2+1:(a.x2+a.x3)/2+1:"undefined"!==typeof a.x5?c<ba?d(c).x2+1:(a.x4+a.x3)/2+1:(a.x2+a.x3)/2+1,G[f].textBlock.x=b+U,G[f].textBlock.y=
c-G[f].height/2,u.reversed?(G[f].textBlock.y+G[f].height>T+C&&(G[f].textBlock.y=T+C-G[f].height),G[f].textBlock.y<ra-C&&(G[f].textBlock.y=ra-C)):(G[f].textBlock.y<T-C&&(G[f].textBlock.y=T-C),G[f].textBlock.y+G[f].height>ra+C&&(G[f].textBlock.y=ra+C-G[f].height)));else for(f=0;f<N.length;f++)0==G[f].textBlock.text.length?G[f].isDirty=!0:(a=N[f],b=a.height,c=G[f].height,e=G[f].width,b>=c?(b=f!=fa?(a.x4+a.x3)/2-e/2:(a.x5+a.x4)/2-e/2,c=f!=fa?(a.y1+a.y3)/2-c/2:(a.y1+a.y4)/2-c/2,G[f].textBlock.x=b,G[f].textBlock.y=
c):G[f].isDirty=!0)}function h(){function a(b,c){var d;if(0>b||b>=G.length)return 0;var e,f=G[b].textBlock;if(0>c){c*=-1;e=p(b);d=l(e,b);if(d>=c)return f.y-=c,c;if(0==b)return 0<d&&(f.y-=d),d;d+=a(e,-(c-d));0<d&&(f.y-=d);return d}e=n(b);d=l(b,e);if(d>=c)return f.y+=c,c;if(b==N.length-1)return 0<d&&(f.y+=d),d;d+=a(e,c-d);0<d&&(f.y+=d);return d}function b(){var a,d,e,f,g=0,h;f=(aa-ca+2*C)/t;h=t;for(var k,l=1;l<h;l++){e=l*f;for(var r=G.length-1;0<=r;r--)!G[r].isDirty&&(G[r].textBlock.y<e&&G[r].textBlock.y+
G[r].height>e)&&(k=n(r),!(k>=G.length-1)&&G[r].textBlock.y+G[r].height+ga>G[k].textBlock.y&&(G[r].textBlock.y=G[r].textBlock.y+G[r].height-e>e-G[r].textBlock.y?e+1:e-G[r].height-1))}for(k=N.length-1;0<k;k--)if(!G[k].isDirty){e=p(k);if(0>e&&(e=0,G[e].isDirty))break;if(G[k].textBlock.y<G[e].textBlock.y+G[e].height){d=d||k;f=k;for(h=0;G[f].textBlock.y<G[e].textBlock.y+G[e].height+ga;){a=a||G[f].textBlock.y+G[f].height;h+=G[f].height;h+=ga;f=e;if(0>=f){f=0;h+=G[f].height;break}e=p(f);if(0>e){f=0;h+=G[f].height;
break}}if(f!=k){g=G[f].textBlock.y;a-=g;a=h-a;g=c(a,d,f);break}}}return g}function c(a,b,d){var e=[],f=0,g=0;for(a=Math.abs(a);d<=b;d++)e.push(N[d]);e.sort(function(a,b){return a.height-b.height});for(d=0;d<e.length;d++)if(b=e[d],f<a)g++,f+=G[b.id].height+ga,G[b.id].textBlock.text="",G[b.id].indexLabelText="",G[b.id].isDirty=!0,G[b.id].textBlock.measureText();else break;return g}for(var d,e,f,g,h,k,t=1,r=0;r<2*t;r++){for(var m=G.length-1;0<=m&&!(previousTextBlock=(previousLabel=0<=p(m)?G[p(m)]:null)?
previousLabel.textBlock:null,f=G[m],g=f.textBlock,k=(h=n(m)<N.length?G[n(m)]:null)?h.textBlock:null,d=+f.height.toFixed(6),e=+g.y.toFixed(6),!f.isDirty&&(h&&e+d+ga>+k.y.toFixed(6))&&(d=g.y+d+ga-k.y,e=a(m,-d),e<d&&(0<e&&(d-=e),e=a(n(m),d),e!=d)));m--);b()}}function l(a,b){return(b<N.length?G[b].textBlock.y:u.reversed?T+C:ra+C)-(0>a?u.reversed?ra-C:T-C:G[a].textBlock.y+G[a].height+ga)}function t(a,b,c){var d,e,f,h=[],l=C,n=[];-1!==b&&(0<=$.indexOf(b)?(e=$.indexOf(b),$.splice(e,1)):($.push(b),$=$.sort(function(a,
b){return a-b})));if(0===$.length)h=ja;else{e=C*(1!=$.length||0!=$[0]&&$[0]!=N.length-1?2:1)/k();for(var t=0;t<N.length;t++){if(1==$.length&&0==$[0]){if(0===t){h.push(ja[t]);d=l;continue}}else 0===t&&(d=-1*l);h.push(ja[t]+d);if(0<=$.indexOf(t)||t<N.length&&0<=$.indexOf(t+1))d+=e}}f=function(){for(var a=[],b=0;b<N.length;b++)a.push(h[b]-N[b].y1);return a}();var p={startTime:(new Date).getTime(),duration:c||500,easingFunction:function(a,b,c,d){return O.easing.easeOutQuart(a,b,c,d)},changeSection:function(a){for(var b,
c,d=0;d<N.length;d++)b=f[d],c=N[d],newY=b*a,"undefined"===typeof n[d]&&(n[d]=0),0>n&&(n*=-1),c.y1+=newY-n[d],c.y2+=newY-n[d],c.y3+=newY-n[d],c.y4+=newY-n[d],c.y5&&(c.y5+=newY-n[d],c.y6+=newY-n[d]),n[d]=newY}};a._animator.animate(0,c,function(c){var d=a.plotArea.ctx||a.ctx;ia=!0;d.clearRect(z.x1,z.y1,z.x2-z.x1,z.y2-z.y1);d.fillStyle=a.backgroundColor;d.fillRect(z.x1,z.y1,z.width,z.height);p.changeSection(c,b);var e={};e.dataSeries=u;e.dataPoint=u.reversed?u.dataPoints[x.length-1-b]:u.dataPoints[b];
e.index=u.reversed?x.length-1-b:b;a.toolTip.highlightObjects([e]);for(e=0;e<N.length;e++)qa(d,N[e],u.fillOpacity);q(d);L&&("inside"!==u.indexLabelPlacement?r(d):g(),m(d));1<=c&&(ia=!1)},null,O.easing.easeOutQuart)}function k(){for(var a=0,b=0;b<N.length-1;b++)(0<=$.indexOf(b)||0<=$.indexOf(b+1))&&a++;return a}function r(a){for(var b,c,e,f,g=0;g<N.length;g++)f=1===G[g].lineThickness%2?0.5:0,c=((N[g].y2+N[g].y4)/2<<0)+f,b=d(c).x2-1,e=G[g].textBlock.x,f=(G[g].textBlock.y+G[g].height/2<<0)+f,G[g].isDirty||
0==G[g].lineThickness||(a.strokeStyle=G[g].lineColor,a.lineWidth=G[g].lineThickness,a.setLineDash&&a.setLineDash(F(G[g].lineDashType,G[g].lineThickness)),a.beginPath(),a.moveTo(b,c),a.lineTo(e,f),a.stroke())}function p(a){for(a-=1;-1<=a&&-1!=a&&G[a].isDirty;a--);return a}function n(a){for(a+=1;a<=N.length&&a!=N.length&&G[a].isDirty;a++);return a}function d(a){for(var b,c=0;c<x.length;c++)if(N[c].y1<a&&N[c].y4>a){b=N[c];break}return b?(a=b.y6?a>b.y6?b.x3+(b.x4-b.x3)/(b.y4-b.y3)*(a-b.y3):b.x2+(b.x3-
b.x2)/(b.y3-b.y2)*(a-b.y2):b.x2+(b.x3-b.x2)/(b.y3-b.y2)*(a-b.y2),{x1:a,x2:a}):-1}function m(a){for(var b=0;b<N.length;b++)G[b].isDirty||(a&&(G[b].textBlock.ctx=a),G[b].textBlock.render(!0))}function q(a){s.plotArea.layoutManager.reset();a.roundRect||Ba(a);s.title&&(s.title.dockInsidePlotArea||"center"===s.title.horizontalAlign&&"center"===s.title.verticalAlign)&&(s.title.ctx=a,s.title.render());if(s.subtitles)for(var b=0;b<s.subtitles.length;b++){var c=s.subtitles[b];if(c.dockInsidePlotArea||"center"===
c.horizontalAlign&&"center"===c.verticalAlign)s.subtitles.ctx=a,c.render()}s.legend&&(s.legend.dockInsidePlotArea||"center"===s.legend.horizontalAlign&&"center"===s.legend.verticalAlign)&&(s.legend.ctx=a,s.legend.render());W.fNg&&W.fNg(s)}var s=this;if(!(0>=a.dataSeriesIndexes.length)){for(var u=this.data[a.dataSeriesIndexes[0]],x=u.dataPoints,z=this.plotArea,C=0.025*z.width,B=0.01*z.width,A=0,J=z.height-2*C,I=Math.min(z.width-2*B,2.8*z.height),L=!1,K=0;K<x.length;K++)if(!L&&("undefined"!==typeof x[K].indexLabel&&
null!==x[K].indexLabel&&0<x[K].indexLabel.toString().length)&&(L=!0),!L&&("undefined"!==typeof x[K].label&&null!==x[K].label&&0<x[K].label.toString().length)&&(L=!0),!L&&"function"===typeof u.indexLabelFormatter||"function"===typeof x[K].indexLabelFormatter)L=!0;L=L||"undefined"!==typeof u.indexLabel&&null!==u.indexLabel&&0<u.indexLabel.toString().length;"inside"!==u.indexLabelPlacement&&L||(B=(z.width-0.75*I)/2);var K=z.x1+B,S=z.x2-B,ca=z.y1+C,aa=z.y2-C,R=a.targetCanvasCtx||this.plotArea.ctx||this.ctx;
if(0!=u.length&&(u.dataPoints&&u.visible)&&0!==x.length){var P,E;a=75*I/100;var U=30*(S-a)/100;"funnel"===u.type?(P=y(u.options.neckHeight)?0.35*J:u.neckHeight,E=y(u.options.neckWidth)?0.25*a:u.neckWidth,"string"===typeof P&&P.match(/%$/)?(P=parseInt(P),P=P*J/100):P=parseInt(P),"string"===typeof E&&E.match(/%$/)?(E=parseInt(E),E=E*a/100):E=parseInt(E),P>J?P=J:0>=P&&(P=0),E>a?E=a-0.5:0>=E&&(E=0)):"pyramid"===u.type&&(E=P=0,u.reversed=u.reversed?!1:!0);var B=K+a/2,Y=K,X=K+a,T=u.reversed?aa:ca,M=B-E/
2,Z=B+E/2,ba=u.reversed?ca+P:aa-P,ra=u.reversed?ca:aa;a=[];var B=[],N=[],I=[],V=ca,fa,ea=(ba-T)/(M-Y),ha=-ea,K="area"===(u.valueRepresents?u.valueRepresents:"height")?b():f();if(-1!==K){if(u.reversed)for(I.push(V),E=K.length-1;0<E;E--)V+=K[E],I.push(V);else for(E=0;E<K.length;E++)V+=K[E],I.push(V);if(u.reversed)for(E=0;E<K.length;E++)I[E]<ba?(a.push(M),B.push(Z),fa=E):(a.push((I[E]-T+ea*Y)/ea),B.push((I[E]-T+ha*X)/ha));else for(E=0;E<K.length;E++)I[E]<ba?(a.push((I[E]-T+ea*Y)/ea),B.push((I[E]-T+ha*
X)/ha),fa=E):(a.push(M),B.push(Z));for(E=0;E<K.length-1;E++)V=u.reversed?x[x.length-1-E].color?x[x.length-1-E].color:u._colorSet[(x.length-1-E)%u._colorSet.length]:x[E].color?x[E].color:u._colorSet[E%u._colorSet.length],E===fa?N.push({x1:a[E],y1:I[E],x2:B[E],y2:I[E],x3:Z,y3:ba,x4:B[E+1],y4:I[E+1],x5:a[E+1],y5:I[E+1],x6:M,y6:ba,id:E,height:I[E+1]-I[E],color:V}):N.push({x1:a[E],y1:I[E],x2:B[E],y2:I[E],x3:B[E+1],y3:I[E+1],x4:a[E+1],y4:I[E+1],id:E,height:I[E+1]-I[E],color:V});var ga=2,G=[],ia=!1,$=[],
ja=[],K=!1;a=a=0;Ca($);for(E=0;E<x.length;E++)x[E].exploded&&(K=!0,u.reversed?$.push(x.length-1-E):$.push(E));R.clearRect(z.x1,z.y1,z.width,z.height);R.fillStyle=s.backgroundColor;R.fillRect(z.x1,z.y1,z.width,z.height);if(L&&u.visible&&(c(),g(),e(),"inside"!==u.indexLabelPlacement)){h();for(E=0;E<x.length;E++)G[E].isDirty||(a=G[E].textBlock.x+G[E].width,a=(S-a)/2,0==E&&(A=a),A>a&&(A=a));for(E=0;E<N.length;E++)N[E].x1+=A,N[E].x2+=A,N[E].x3+=A,N[E].x4+=A,N[E].x5&&(N[E].x5+=A,N[E].x6+=A),G[E].textBlock.x+=
A}for(E=0;E<N.length;E++)A=N[E],qa(R,A,u.fillOpacity),ja.push(A.y1);q(R);L&&u.visible&&("inside"===u.indexLabelPlacement||s.animationEnabled||r(R),s.animationEnabled||m());if(!L)for(E=0;E<x.length;E++)A=u.dataPointIds[E],a={id:A,objectType:"dataPoint",dataPointIndex:E,dataSeriesIndex:0,funnelSection:N[u.reversed?x.length-1-E:E]},s._eventManager.objectMap[A]=a;!s.animationEnabled&&K?t(s,-1,0):s.animationEnabled&&!s.animatedRender&&t(s,-1,0);this.funnelPyramidClickHandler=function(a){var b=-1;if(!ia&&
!s.isAnimating&&(y(a.dataSeries.explodeOnClick)||a.dataSeries.explodeOnClick)&&(b=u.reversed?x.length-1-a.dataPointIndex:a.dataPointIndex,0<=b)){a=b;if("funnel"===u.type||"pyramid"===u.type)u.reversed?x[x.length-1-a].exploded=x[x.length-1-a].exploded?!1:!0:x[a].exploded=x[a].exploded?!1:!0;t(s,b,500)}};return{source:R,dest:this.plotArea.ctx,animationCallback:function(a,b){O.fadeInAnimation(a,b);1<=a&&(t(s,-1,500),q(s.plotArea.ctx||s.ctx))},easingFunction:O.easing.easeInQuad,animationBase:0}}}}};q.prototype.requestAnimFrame=
function(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame||window.oRequestAnimationFrame||window.msRequestAnimationFrame||function(a){window.setTimeout(a,1E3/60)}}();q.prototype.cancelRequestAnimFrame=window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.mozCancelRequestAnimationFrame||window.oCancelRequestAnimationFrame||window.msCancelRequestAnimationFrame||clearTimeout;q.prototype.set=function(a,f,b){b="undefined"===
typeof b?!0:b;"options"===a?(this.options=f,b&&this.render()):q.base.set.call(this,a,f,b)};q.prototype.exportChart=function(a){a="undefined"===typeof a?{}:a;var f=a.format?a.format:"png",b=a.fileName?a.fileName:this.exportFileName;if(a.toDataURL)return this.canvas.toDataURL("image/"+f);s(this.canvas,f,b)};q.prototype.print=function(){var a=this.exportChart({toDataURL:!0}),f=document.createElement("iframe");f.setAttribute("class","canvasjs-chart-print-frame");f.setAttribute("style","position:absolute; width:100%; border: 0px; margin: 0px 0px 0px 0px; padding 0px 0px 0px 0px;");
f.style.height=this.height+"px";this._canvasJSContainer.appendChild(f);var b=this,c=f.contentWindow||f.contentDocument.document||f.contentDocument;c.document.open();c.document.write('<!DOCTYPE HTML>\n<html><body style="margin: 0px 0px 0px 0px; padding: 0px 0px 0px 0px;"><img src="'+a+'"/><body/></html>');c.document.close();setTimeout(function(){c.focus();c.print();setTimeout(function(){b._canvasJSContainer.removeChild(f)},1E3)},500)};q.prototype.getPercentAndTotal=function(a,f){var b=null,c=null,
e=null;if(0<=a.type.indexOf("stacked"))c=0,b=f.x.getTime?f.x.getTime():f.x,b in a.plotUnit.yTotals&&(c=a.plotUnit.yTotals[b],e=isNaN(f.y)?0:100*(f.y/c));else if("pie"===a.type||"doughnut"===a.type||"funnel"===a.type||"pyramid"===a.type){for(i=c=0;i<a.dataPoints.length;i++)isNaN(a.dataPoints[i].y)||(c+=a.dataPoints[i].y);e=isNaN(f.y)?0:100*(f.y/c)}return{percent:e,total:c}};q.prototype.replaceKeywordsWithValue=function(a,f,b,c,e){var g=this;e="undefined"===typeof e?0:e;if((0<=b.type.indexOf("stacked")||
"pie"===b.type||"doughnut"===b.type||"funnel"===b.type||"pyramid"===b.type)&&(0<=a.indexOf("#percent")||0<=a.indexOf("#total"))){var h="#percent",l="#total",t=this.getPercentAndTotal(b,f),l=isNaN(t.total)?l:t.total,h=isNaN(t.percent)?h:t.percent;do{t="";if(b.percentFormatString)t=b.percentFormatString;else{var t="#,##0.",k=Math.max(Math.ceil(Math.log(1/Math.abs(h))/Math.LN10),2);if(isNaN(k)||!isFinite(k))k=2;for(var r=0;r<k;r++)t+="#";b.percentFormatString=t}a=a.replace("#percent",V(h,t,g._cultureInfo));
a=a.replace("#total",V(l,b.yValueFormatString?b.yValueFormatString:"#,##0.########",g._cultureInfo))}while(0<=a.indexOf("#percent")||0<=a.indexOf("#total"))}return a.replace(/\{.*?\}|"[^"]*"|'[^']*'/g,function(a){if('"'===a[0]&&'"'===a[a.length-1]||"'"===a[0]&&"'"===a[a.length-1])return a.slice(1,a.length-1);a=Fa(a.slice(1,a.length-1));a=a.replace("#index",e);var h=null;try{var d=a.match(/(.*?)\s*\[\s*(.*?)\s*\]/);d&&0<d.length&&(h=Fa(d[2]),a=Fa(d[1]))}catch(k){}d=null;if("color"===a)return"waterfall"===
b.type?f.color?f.color:0<f.y?b.risingColor:b.fallingColor:"error"===b.type?b.color?b.color:b._colorSet[h%b._colorSet.length]:f.color?f.color:b.color?b.color:b._colorSet[c%b._colorSet.length];if(f.hasOwnProperty(a))d=f;else if(b.hasOwnProperty(a))d=b;else return"";d=d[a];null!==h&&(d=d[h]);if("x"===a)if("dateTime"===b.axisX.valueType||"dateTime"===b.xValueType||f.x&&f.x.getTime){if(g.plotInfo.plotTypes[0].plotUnits[0].axisX&&!g.plotInfo.plotTypes[0].plotUnits[0].axisX.logarithmic)return Aa(d,f.xValueFormatString?
f.xValueFormatString:b.xValueFormatString?b.xValueFormatString:b.xValueFormatString=g.axisX&&g.axisX.autoValueFormatString?g.axisX.autoValueFormatString:"DD MMM YY",g._cultureInfo)}else return V(d,f.xValueFormatString?f.xValueFormatString:b.xValueFormatString?b.xValueFormatString:b.xValueFormatString="#,##0.########",g._cultureInfo);else return"y"===a?V(d,f.yValueFormatString?f.yValueFormatString:b.yValueFormatString?b.yValueFormatString:b.yValueFormatString="#,##0.########",g._cultureInfo):"z"===
a?V(d,f.zValueFormatString?f.zValueFormatString:b.zValueFormatString?b.zValueFormatString:b.zValueFormatString="#,##0.########",g._cultureInfo):d})};na(T,Y);T.prototype.render=function(){var a=this.dockInsidePlotArea?this.chart.plotArea:this.chart,f=a.layoutManager.getFreeSpace(),b=null,c=0,e=0,g=0,h=0,l=this.markerMargin=this.chart.options.legend&&!y(this.chart.options.legend.markerMargin)?this.chart.options.legend.markerMargin:0.3*this.fontSize;this.height=0;var t=[],k=[];"top"===this.verticalAlign||
"bottom"===this.verticalAlign?(this.orientation="horizontal",b=this.verticalAlign,g=this.maxWidth=null!==this.maxWidth?this.maxWidth:f.width,h=this.maxHeight=null!==this.maxHeight?this.maxHeight:0.5*f.height):"center"===this.verticalAlign&&(this.orientation="vertical",b=this.horizontalAlign,g=this.maxWidth=null!==this.maxWidth?this.maxWidth:0.5*f.width,h=this.maxHeight=null!==this.maxHeight?this.maxHeight:f.height);for(var r=[],p=0;p<this.dataSeries.length;p++){var n=this.dataSeries[p];if(n.dataPoints&&
n.dataPoints.length)if("pie"!==n.type&&"doughnut"!==n.type&&"funnel"!==n.type&&"pyramid"!==n.type){var d=n.legendMarkerType=n.legendMarkerType?n.legendMarkerType:"line"!==n.type&&"stepLine"!==n.type&&"spline"!==n.type&&"scatter"!==n.type&&"bubble"!==n.type||!n.markerType?"error"===n.type&&n._linkedSeries?n._linkedSeries.legendMarkerType?n._linkedSeries.legendMarkerType:S.getDefaultLegendMarker(n._linkedSeries.type):S.getDefaultLegendMarker(n.type):n.markerType,m=n.legendText?n.legendText:this.itemTextFormatter?
this.itemTextFormatter({chart:this.chart,legend:this.options,dataSeries:n,dataPoint:null}):n.name,q=n.legendMarkerColor=n.legendMarkerColor?n.legendMarkerColor:n.markerColor?n.markerColor:"error"===n.type?y(n.whiskerColor)?n._colorSet[0]:n.whiskerColor:n._colorSet[0],s=n.markerSize||"line"!==n.type&&"stepLine"!==n.type&&"spline"!==n.type?0.75*this.lineHeight:0,u=n.legendMarkerBorderColor?n.legendMarkerBorderColor:n.markerBorderColor,v=n.legendMarkerBorderThickness?n.legendMarkerBorderThickness:n.markerBorderThickness?
Math.max(1,Math.round(0.2*s)):0;"error"===n.type&&r.push(q);m=this.chart.replaceKeywordsWithValue(m,n.dataPoints[0],n,p);d={markerType:d,markerColor:q,text:m,textBlock:null,chartType:n.type,markerSize:s,lineColor:n._colorSet[0],dataSeriesIndex:n.index,dataPointIndex:null,markerBorderColor:u,markerBorderThickness:v};t.push(d)}else for(var x=0;x<n.dataPoints.length;x++){var z=n.dataPoints[x],d=z.legendMarkerType?z.legendMarkerType:n.legendMarkerType?n.legendMarkerType:S.getDefaultLegendMarker(n.type),
m=z.legendText?z.legendText:n.legendText?n.legendText:this.itemTextFormatter?this.itemTextFormatter({chart:this.chart,legend:this.options,dataSeries:n,dataPoint:z}):z.name?z.name:"DataPoint: "+(x+1),q=z.legendMarkerColor?z.legendMarkerColor:n.legendMarkerColor?n.legendMarkerColor:z.color?z.color:n.color?n.color:n._colorSet[x%n._colorSet.length],s=0.75*this.lineHeight,u=z.legendMarkerBorderColor?z.legendMarkerBorderColor:n.legendMarkerBorderColor?n.legendMarkerBorderColor:z.markerBorderColor?z.markerBorderColor:
n.markerBorderColor,v=z.legendMarkerBorderThickness?z.legendMarkerBorderThickness:n.legendMarkerBorderThickness?n.legendMarkerBorderThickness:z.markerBorderThickness||n.markerBorderThickness?Math.max(1,Math.round(0.2*s)):0,m=this.chart.replaceKeywordsWithValue(m,z,n,x),d={markerType:d,markerColor:q,text:m,textBlock:null,chartType:n.type,markerSize:s,dataSeriesIndex:p,dataPointIndex:x,markerBorderColor:u,markerBorderThickness:v};(z.showInLegend||n.showInLegend&&!1!==z.showInLegend)&&t.push(d)}}!0===
this.reversed&&t.reverse();if(0<t.length){n=null;m=x=z=v=0;z=null!==this.itemWidth?null!==this.itemMaxWidth?Math.min(this.itemWidth,this.itemMaxWidth,g):this.itemMaxWidth=Math.min(this.itemWidth,g):null!==this.itemMaxWidth?Math.min(this.itemMaxWidth,g):this.itemMaxWidth=g;s=0===s?0.75*this.lineHeight:s;z-=s+l;for(p=0;p<t.length;p++){d=t[p];q=z;if("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType)q-=2*0.1*this.lineHeight;if(!(0>=h||"undefined"===typeof h||0>=q||"undefined"===typeof q)){if("horizontal"===
this.orientation){d.textBlock=new ka(this.ctx,{x:0,y:0,maxWidth:q,maxHeight:this.itemWrap?h:this.lineHeight,angle:0,text:d.text,horizontalAlign:"left",fontSize:this.fontSize,fontFamily:this.fontFamily,fontWeight:this.fontWeight,fontColor:this.fontColor,fontStyle:this.fontStyle,textBaseline:"middle"});d.textBlock.measureText();null!==this.itemWidth&&(d.textBlock.width=this.itemWidth-(s+l+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0)));if(!n||n.width+
Math.round(d.textBlock.width+s+l+(0===n.width?0:this.horizontalSpacing)+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0))>g)n={items:[],width:0},k.push(n),this.height+=x,x=0;x=Math.max(x,d.textBlock.height)}else d.textBlock=new ka(this.ctx,{x:0,y:0,maxWidth:z,maxHeight:!0===this.itemWrap?h:1.5*this.fontSize,angle:0,text:d.text,horizontalAlign:"left",fontSize:this.fontSize,fontFamily:this.fontFamily,fontWeight:this.fontWeight,fontColor:this.fontColor,
fontStyle:this.fontStyle,textBaseline:"middle"}),d.textBlock.measureText(),null!==this.itemWidth&&(d.textBlock.width=this.itemWidth-(s+l+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0))),this.height<h-this.lineHeight?(n={items:[],width:0},k.push(n)):(n=k[v],v=(v+1)%k.length),this.height+=d.textBlock.height;d.textBlock.x=n.width;d.textBlock.y=0;n.width+=Math.round(d.textBlock.width+s+l+(0===n.width?0:this.horizontalSpacing)+("line"===d.chartType||"spline"===
d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0));n.items.push(d);this.width=Math.max(n.width,this.width);m=d.textBlock.width+(s+l+("line"===d.chartType||"spline"===d.chartType||"stepLine"===d.chartType?2*0.1*this.lineHeight:0))}}this.itemWidth=m;this.height=!1===this.itemWrap?k.length*this.lineHeight:this.height+x;this.height=Math.min(h,this.height);this.width=Math.min(g,this.width)}"top"===this.verticalAlign?(e="left"===this.horizontalAlign?f.x1:"right"===this.horizontalAlign?f.x2-
this.width:f.x1+f.width/2-this.width/2,c=f.y1):"center"===this.verticalAlign?(e="left"===this.horizontalAlign?f.x1:"right"===this.horizontalAlign?f.x2-this.width:f.x1+f.width/2-this.width/2,c=f.y1+f.height/2-this.height/2):"bottom"===this.verticalAlign&&(e="left"===this.horizontalAlign?f.x1:"right"===this.horizontalAlign?f.x2-this.width:f.x1+f.width/2-this.width/2,c=f.y2-this.height);this.items=t;for(p=0;p<this.items.length;p++)d=t[p],d.id=++this.chart._eventManager.lastObjectId,this.chart._eventManager.objectMap[d.id]=
{id:d.id,objectType:"legendItem",legendItemIndex:p,dataSeriesIndex:d.dataSeriesIndex,dataPointIndex:d.dataPointIndex};(0<this.borderThickness&&this.borderColor||this.backgroundColor)&&this.ctx.roundRect(e,c,this.width,this.height,this.cornerRadius,this.borderThickness,this.backgroundColor,this.borderColor);for(p=f=0;p<k.length;p++){n=k[p];for(z=x=0;z<n.items.length;z++){d=n.items[z];q=d.textBlock.x+e+(0===z?0.2*s:this.horizontalSpacing);u=c+f;m=q;this.chart.data[d.dataSeriesIndex].visible||(this.ctx.globalAlpha=
0.5);this.ctx.save();this.ctx.beginPath();this.ctx.rect(e,c,g,Math.max(h-h%this.lineHeight,0));this.ctx.clip();if("line"===d.chartType||"stepLine"===d.chartType||"spline"===d.chartType)this.ctx.strokeStyle=d.lineColor,this.ctx.lineWidth=Math.ceil(this.lineHeight/8),this.ctx.beginPath(),this.ctx.moveTo(q-0.1*this.lineHeight,u+this.lineHeight/2),this.ctx.lineTo(q+0.85*this.lineHeight,u+this.lineHeight/2),this.ctx.stroke(),m-=0.1*this.lineHeight;if("error"===d.chartType){this.ctx.strokeStyle=r[0];v=
s/8;this.ctx.lineWidth=v;this.ctx.beginPath();var v=q-0.08*this.lineHeight+0.1*this.lineHeight,B=u+0.15*this.lineHeight,A=0.7*this.lineHeight,C=A+0.02*this.lineHeight;this.ctx.moveTo(v,B);this.ctx.lineTo(v+A,B);this.ctx.stroke();this.ctx.beginPath();this.ctx.moveTo(v+A/2,B);this.ctx.lineTo(v+A/2,B+C);this.ctx.stroke();this.ctx.beginPath();this.ctx.moveTo(v,B+C);this.ctx.lineTo(v+A,B+C);this.ctx.stroke();r.shift()}$.drawMarker(q+s/2,u+this.lineHeight/2,this.ctx,d.markerType,"error"===d.chartType||
"line"===d.chartType||"spline"===d.chartType?d.markerSize/2:d.markerSize,d.markerColor,d.markerBorderColor,d.markerBorderThickness);d.textBlock.x=q+l+s;if("line"===d.chartType||"stepLine"===d.chartType||"spline"===d.chartType)d.textBlock.x+=0.1*this.lineHeight;d.textBlock.y=Math.round(u+this.lineHeight/2);d.textBlock.render(!0);this.ctx.restore();x=0<z?Math.max(x,d.textBlock.height):d.textBlock.height;this.chart.data[d.dataSeriesIndex].visible||(this.ctx.globalAlpha=1);v=R(d.id);this.ghostCtx.fillStyle=
v;this.ghostCtx.beginPath();this.ghostCtx.fillRect(m,d.textBlock.y-this.lineHeight/2,d.textBlock.x+d.textBlock.width-m,d.textBlock.height);d.x1=this.chart._eventManager.objectMap[d.id].x1=m;d.y1=this.chart._eventManager.objectMap[d.id].y1=d.textBlock.y-this.lineHeight/2;d.x2=this.chart._eventManager.objectMap[d.id].x2=d.textBlock.x+d.textBlock.width;d.y2=this.chart._eventManager.objectMap[d.id].y2=d.textBlock.y+d.textBlock.height-this.lineHeight/2}f+=x}0<t.length&&a.layoutManager.registerSpace(b,
{width:this.width+2+2,height:this.height+5+5});this.bounds={x1:e,y1:c,x2:e+this.width,y2:c+this.height}};na(S,Y);S.prototype.getDefaultAxisPlacement=function(){var a=this.type;if("column"===a||"line"===a||"stepLine"===a||"spline"===a||"area"===a||"stepArea"===a||"splineArea"===a||"stackedColumn"===a||"stackedLine"===a||"bubble"===a||"scatter"===a||"stackedArea"===a||"stackedColumn100"===a||"stackedLine100"===a||"stackedArea100"===a||"candlestick"===a||"ohlc"===a||"rangeColumn"===a||"rangeArea"===
a||"rangeSplineArea"===a||"boxAndWhisker"===a||"waterfall"===a)return"normal";if("bar"===a||"stackedBar"===a||"stackedBar100"===a||"rangeBar"===a)return"xySwapped";if("pie"===a||"doughnut"===a||"funnel"===a||"pyramid"===a)return"none";"error"!==a&&window.console.log("Unknown Chart Type: "+a);return null};S.getDefaultLegendMarker=function(a){if("column"===a||"stackedColumn"===a||"stackedLine"===a||"bar"===a||"stackedBar"===a||"stackedBar100"===a||"bubble"===a||"scatter"===a||"stackedColumn100"===a||
"stackedLine100"===a||"stepArea"===a||"candlestick"===a||"ohlc"===a||"rangeColumn"===a||"rangeBar"===a||"rangeArea"===a||"rangeSplineArea"===a||"boxAndWhisker"===a||"waterfall"===a)return"square";if("line"===a||"stepLine"===a||"spline"===a||"pie"===a||"doughnut"===a)return"circle";if("area"===a||"splineArea"===a||"stackedArea"===a||"stackedArea100"===a||"funnel"===a||"pyramid"===a)return"triangle";if("error"===a)return"none";window.console.log("Unknown Chart Type: "+a);return null};S.prototype.getDataPointAtX=
function(a,f){if(!this.dataPoints||0===this.dataPoints.length)return null;var b={dataPoint:null,distance:Infinity,index:NaN},c=null,e=0,g=0,h=1,l=Infinity,t=0,k=0,r=0;"none"!==this.chart.plotInfo.axisPlacement&&(this.axisX.logarithmic?(r=Math.log(this.dataPoints[this.dataPoints.length-1].x/this.dataPoints[0].x),r=1<r?Math.min(Math.max((this.dataPoints.length-1)/r*Math.log(a/this.dataPoints[0].x)>>0,0),this.dataPoints.length):0):(r=this.dataPoints[this.dataPoints.length-1].x-this.dataPoints[0].x,r=
0<r?Math.min(Math.max((this.dataPoints.length-1)/r*(a-this.dataPoints[0].x)>>0,0),this.dataPoints.length):0));for(;;){g=0<h?r+e:r-e;if(0<=g&&g<this.dataPoints.length){var c=this.dataPoints[g],p=this.axisX.logarithmic?c.x>a?c.x/a:a/c.x:Math.abs(c.x-a);p<b.distance&&(b.dataPoint=c,b.distance=p,b.index=g);c=p;c<=l?l=c:0<h?t++:k++;if(1E3<t&&1E3<k)break}else if(0>r-e&&r+e>=this.dataPoints.length)break;-1===h?(e++,h=1):h=-1}return f||b.dataPoint.x!==a?f&&null!==b.dataPoint?b:null:b};S.prototype.getDataPointAtXY=
function(a,f,b){if(!this.dataPoints||0===this.dataPoints.length||a<this.chart.plotArea.x1||a>this.chart.plotArea.x2||f<this.chart.plotArea.y1||f>this.chart.plotArea.y2)return null;b=b||!1;var c=[],e=0,g=0,h=1,l=!1,t=Infinity,k=0,r=0,p=0;if("none"!==this.chart.plotInfo.axisPlacement)if(p=(this.chart.axisX[0]?this.chart.axisX[0]:this.chart.axisX2[0]).getXValueAt({x:a,y:f}),this.axisX.logarithmic)var n=Math.log(this.dataPoints[this.dataPoints.length-1].x/this.dataPoints[0].x),p=1<n?Math.min(Math.max((this.dataPoints.length-
1)/n*Math.log(p/this.dataPoints[0].x)>>0,0),this.dataPoints.length):0;else n=this.dataPoints[this.dataPoints.length-1].x-this.dataPoints[0].x,p=0<n?Math.min(Math.max((this.dataPoints.length-1)/n*(p-this.dataPoints[0].x)>>0,0),this.dataPoints.length):0;for(;;){g=0<h?p+e:p-e;if(0<=g&&g<this.dataPoints.length){var n=this.chart._eventManager.objectMap[this.dataPointIds[g]],d=this.dataPoints[g],m=null;if(n){switch(this.type){case "column":case "stackedColumn":case "stackedColumn100":case "bar":case "stackedBar":case "stackedBar100":case "rangeColumn":case "rangeBar":case "waterfall":case "error":a>=
n.x1&&(a<=n.x2&&f>=n.y1&&f<=n.y2)&&(c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),Math.abs(n.x2-a),Math.abs(n.y1-f),Math.abs(n.y2-f))}),l=!0);break;case "line":case "stepLine":case "spline":case "area":case "stepArea":case "stackedArea":case "stackedArea100":case "splineArea":case "scatter":var q=ja("markerSize",d,this)||4,s=b?20:q,m=Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y1-f,2));m<=s&&c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:m});n=
Math.abs(n.x1-a);n<=t?t=n:0<h?k++:r++;m<=q/2&&(l=!0);break;case "rangeArea":case "rangeSplineArea":q=ja("markerSize",d,this)||4;s=b?20:q;m=Math.min(Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y1-f,2)),Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y2-f,2)));m<=s&&c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:m});n=Math.abs(n.x1-a);n<=t?t=n:0<h?k++:r++;m<=q/2&&(l=!0);break;case "bubble":q=n.size;m=Math.sqrt(Math.pow(n.x1-a,2)+Math.pow(n.y1-f,2));m<=q/2&&(c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,
distance:m}),l=!0);break;case "pie":case "doughnut":q=n.center;s="doughnut"===this.type?n.percentInnerRadius*n.radius:0;m=Math.sqrt(Math.pow(q.x-a,2)+Math.pow(q.y-f,2));m<n.radius&&m>s&&(m=Math.atan2(f-q.y,a-q.x),0>m&&(m+=2*Math.PI),m=Number(((180*(m/Math.PI)%360+360)%360).toFixed(12)),q=Number(((180*(n.startAngle/Math.PI)%360+360)%360).toFixed(12)),s=Number(((180*(n.endAngle/Math.PI)%360+360)%360).toFixed(12)),0===s&&1<n.endAngle&&(s=360),q>=s&&0!==d.y&&(s+=360,m<q&&(m+=360)),m>q&&m<s&&(c.push({dataPoint:d,
dataPointIndex:g,dataSeries:this,distance:0}),l=!0));break;case "funnel":case "pyramid":m=n.funnelSection;f>m.y1&&f<m.y4&&(m.y6?f>m.y6?(g=m.x6+(m.x5-m.x6)/(m.y5-m.y6)*(f-m.y6),m=m.x3+(m.x4-m.x3)/(m.y4-m.y3)*(f-m.y3)):(g=m.x1+(m.x6-m.x1)/(m.y6-m.y1)*(f-m.y1),m=m.x2+(m.x3-m.x2)/(m.y3-m.y2)*(f-m.y2)):(g=m.x1+(m.x4-m.x1)/(m.y4-m.y1)*(f-m.y1),m=m.x2+(m.x3-m.x2)/(m.y3-m.y2)*(f-m.y2)),a>g&&a<m&&(c.push({dataPoint:d,dataPointIndex:n.dataPointIndex,dataSeries:this,distance:0}),l=!0));break;case "boxAndWhisker":if(a>=
n.x1-n.borderThickness/2&&a<=n.x2+n.borderThickness/2&&f>=n.y4-n.borderThickness/2&&f<=n.y1+n.borderThickness/2||Math.abs(n.x2-a+n.x1-a)<n.borderThickness&&f>=n.y1&&f<=n.y4)c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),Math.abs(n.x2-a),Math.abs(n.y2-f),Math.abs(n.y3-f))}),l=!0;break;case "candlestick":if(a>=n.x1-n.borderThickness/2&&a<=n.x2+n.borderThickness/2&&f>=n.y2-n.borderThickness/2&&f<=n.y3+n.borderThickness/2||Math.abs(n.x2-a+n.x1-a)<n.borderThickness&&
f>=n.y1&&f<=n.y4)c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),Math.abs(n.x2-a),Math.abs(n.y2-f),Math.abs(n.y3-f))}),l=!0;break;case "ohlc":if(Math.abs(n.x2-a+n.x1-a)<n.borderThickness&&f>=n.y2&&f<=n.y3||a>=n.x1&&a<=(n.x2+n.x1)/2&&f>=n.y1-n.borderThickness/2&&f<=n.y1+n.borderThickness/2||a>=(n.x1+n.x2)/2&&a<=n.x2&&f>=n.y4-n.borderThickness/2&&f<=n.y4+n.borderThickness/2)c.push({dataPoint:d,dataPointIndex:g,dataSeries:this,distance:Math.min(Math.abs(n.x1-a),
Math.abs(n.x2-a),Math.abs(n.y2-f),Math.abs(n.y3-f))}),l=!0}if(l||1E3<k&&1E3<r)break}}else if(0>p-e&&p+e>=this.dataPoints.length)break;-1===h?(e++,h=1):h=-1}a=null;for(f=0;f<c.length;f++)a?c[f].distance<=a.distance&&(a=c[f]):a=c[f];return a};S.prototype.getMarkerProperties=function(a,f,b,c){var e=this.dataPoints;return{x:f,y:b,ctx:c,type:e[a].markerType?e[a].markerType:this.markerType,size:e[a].markerSize?e[a].markerSize:this.markerSize,color:e[a].markerColor?e[a].markerColor:this.markerColor?this.markerColor:
e[a].color?e[a].color:this.color?this.color:this._colorSet[a%this._colorSet.length],borderColor:e[a].markerBorderColor?e[a].markerBorderColor:this.markerBorderColor?this.markerBorderColor:null,borderThickness:e[a].markerBorderThickness?e[a].markerBorderThickness:this.markerBorderThickness?this.markerBorderThickness:null}};na(C,Y);C.prototype.createExtraLabelsForLog=function(a){a=(a||0)+1;if(!(5<a)){var f=this.logLabelValues[0]||this.intervalStartPosition;if(Math.log(this.range)/Math.log(f/this.viewportMinimum)<
this.noTicks-1){for(var b=C.getNiceNumber((f-this.viewportMinimum)/Math.min(Math.max(2,this.noTicks-this.logLabelValues.length),3),!0),c=Math.ceil(this.viewportMinimum/b)*b;c<f;c+=b)c<this.viewportMinimum||this.logLabelValues.push(c);this.logLabelValues.sort(Pa);this.createExtraLabelsForLog(a)}}};C.prototype.createLabels=function(){var a,f,b=0,c=0,e,g=0,h=0,c=0,c=this.interval,l=0,t,k=0.6*this.chart.height,m;a=!1;var p=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[],n=p.length?y(this.scaleBreaks.firstBreakIndex)?
0:this.scaleBreaks.firstBreakIndex:0;if("axisX"!==this.type||"dateTime"!==this.valueType||this.logarithmic){e=this.viewportMaximum;if(this.labels){a=Math.ceil(c);for(var c=Math.ceil(this.intervalStartPosition),d=!1,b=c;b<this.viewportMaximum;b+=a)if(this.labels[b])d=!0;else{d=!1;break}d&&(this.interval=a,this.intervalStartPosition=c)}if(this.logarithmic&&!this.equidistantInterval)for(this.logLabelValues||(this.logLabelValues=[],this.createExtraLabelsForLog()),c=0,d=n;c<this.logLabelValues.length;c++)if(b=
this.logLabelValues[c],b<this.viewportMinimum)c++;else{for(;d<p.length&&b>p[d].endValue;d++);a=d<p.length&&b>=p[d].startValue&&b<=p[d].endValue;m=b;a||(a=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.options,value:m,label:this.labels[m]?this.labels[m]:null}):"axisX"===this.type&&this.labels[m]?this.labels[m]:V(m,this.valueFormatString,this.chart._cultureInfo),a=new ka(this.ctx,{x:0,y:0,maxWidth:g,maxHeight:h,angle:this.labelAngle,text:this.prefix+a+this.suffix,backgroundColor:this.labelBackgroundColor,
borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,horizontalAlign:"left",fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle",borderThickness:0}),this._labels.push({position:m,textBlock:a,effectiveHeight:null}))}d=n;for(b=this.intervalStartPosition;b<=e;b=parseFloat(1E-12>this.interval?this.logarithmic&&this.equidistantInterval?
b*Math.pow(this.logarithmBase,this.interval):b+this.interval:(this.logarithmic&&this.equidistantInterval?b*Math.pow(this.logarithmBase,this.interval):b+this.interval).toFixed(12))){for(;d<p.length&&b>p[d].endValue;d++);a=d<p.length&&b>=p[d].startValue&&b<=p[d].endValue;m=b;a||(a=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.options,value:m,label:this.labels[m]?this.labels[m]:null}):"axisX"===this.type&&this.labels[m]?this.labels[m]:V(m,this.valueFormatString,this.chart._cultureInfo),
a=new ka(this.ctx,{x:0,y:0,maxWidth:g,maxHeight:h,angle:this.labelAngle,text:this.prefix+a+this.suffix,horizontalAlign:"left",backgroundColor:this.labelBackgroundColor,borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle"}),this._labels.push({position:m,textBlock:a,effectiveHeight:null}))}}else for(this.intervalStartPosition=
this.getLabelStartPoint(new Date(this.viewportMinimum),this.intervalType,this.interval),e=Ta(new Date(this.viewportMaximum),this.interval,this.intervalType),d=n,b=this.intervalStartPosition;b<e;Ta(b,c,this.intervalType)){for(a=b.getTime();d<p.length&&a>p[d].endValue;d++);m=a;a=d<p.length&&a>=p[d].startValue&&a<=p[d].endValue;a||(a=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.options,value:new Date(m),label:this.labels[m]?this.labels[m]:null}):"axisX"===this.type&&this.labels[m]?
this.labels[m]:Aa(m,this.valueFormatString,this.chart._cultureInfo),a=new ka(this.ctx,{x:0,y:0,maxWidth:g,backgroundColor:this.labelBackgroundColor,borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,maxHeight:h,angle:this.labelAngle,text:this.prefix+a+this.suffix,horizontalAlign:"left",fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle"}),
this._labels.push({position:m,textBlock:a,effectiveHeight:null,breaksLabelType:void 0}))}if("bottom"===this._position||"top"===this._position)l=this.logarithmic&&!this.equidistantInterval&&2<=this._labels.length?this.lineCoordinates.width*Math.log(Math.min(this._labels[this._labels.length-1].position/this._labels[this._labels.length-2].position,this._labels[1].position/this._labels[0].position))/Math.log(this.range):this.lineCoordinates.width/(this.logarithmic&&this.equidistantInterval?Math.log(this.range)/
Math.log(this.logarithmBase):Math.abs(this.range))*U[this.intervalType+"Duration"]*this.interval,g="undefined"===typeof this.options.labelMaxWidth?0.5*this.chart.width>>0:this.options.labelMaxWidth,this.chart.panEnabled||(h="undefined"===typeof this.options.labelWrap||this.labelWrap?0.8*this.chart.height>>0:1.5*this.labelFontSize);else if("left"===this._position||"right"===this._position)l=this.logarithmic&&!this.equidistantInterval&&2<=this._labels.length?this.lineCoordinates.height*Math.log(Math.min(this._labels[this._labels.length-
1].position/this._labels[this._labels.length-2].position,this._labels[1].position/this._labels[0].position))/Math.log(this.range):this.lineCoordinates.height/(this.logarithmic&&this.equidistantInterval?Math.log(this.range)/Math.log(this.logarithmBase):Math.abs(this.range))*U[this.intervalType+"Duration"]*this.interval,this.chart.panEnabled||(g="undefined"===typeof this.options.labelMaxWidth?0.3*this.chart.width>>0:this.options.labelMaxWidth),h="undefined"===typeof this.options.labelWrap||this.labelWrap?
0.3*this.chart.height>>0:1.5*this.labelFontSize;for(c=0;c<this._labels.length;c++){a=this._labels[c].textBlock;a.maxWidth=g;a.maxHeight=h;var q=a.measureText();t=q.height}e=[];n=p=0;if(this.labelAutoFit||this.options.labelAutoFit)if(y(this.labelAngle)||(this.labelAngle=(this.labelAngle%360+360)%360,90<this.labelAngle&&270>this.labelAngle?this.labelAngle-=180:270<=this.labelAngle&&360>=this.labelAngle&&(this.labelAngle-=360)),"bottom"===this._position||"top"===this._position)if(g=0.9*l>>0,n=0,!this.chart.panEnabled&&
1<=this._labels.length){this.sessionVariables.labelFontSize=this.labelFontSize;this.sessionVariables.labelMaxWidth=g;this.sessionVariables.labelMaxHeight=h;this.sessionVariables.labelAngle=this.labelAngle;this.sessionVariables.labelWrap=this.labelWrap;for(b=0;b<this._labels.length;b++)if(!this._labels[b].breaksLabelType){a=this._labels[b].textBlock;for(var s,d=a.text.split(" "),c=0;c<d.length;c++)m=d[c],this.ctx.font=a.fontStyle+" "+a.fontWeight+" "+a.fontSize+"px "+a.fontFamily,m=this.ctx.measureText(m),
m.width>n&&(s=b,n=m.width)}b=0;for(b=this.intervalStartPosition<this.viewportMinimum?1:0;b<this._labels.length;b++)if(!this._labels[b].breaksLabelType){a=this._labels[b].textBlock;q=a.measureText();for(d=b+1;d<this._labels.length;d++)if(!this._labels[d].breaksLabelType){f=this._labels[d].textBlock;f=f.measureText();break}e.push(a.height);this.sessionVariables.labelMaxHeight=Math.max.apply(Math,e);Math.cos(Math.PI/180*Math.abs(this.labelAngle));Math.sin(Math.PI/180*Math.abs(this.labelAngle));c=g*Math.sin(Math.PI/
180*Math.abs(this.labelAngle))+(h-a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle));if(y(this.options.labelAngle)&&isNaN(this.options.labelAngle)&&0!==this.options.labelAngle)if(this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:Math.min((c-g*Math.cos(Math.PI/180*Math.abs(this.labelAngle)))/Math.sin(Math.PI/180*Math.abs(this.labelAngle)),c),m=(k-(t+a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(-25)))/Math.sin(Math.PI/180*Math.abs(-25)),!y(this.options.labelWrap))this.labelWrap?y(this.options.labelMaxWidth)?
(this.sessionVariables.labelMaxWidth=Math.min(Math.max(g,n),m),this.sessionVariables.labelWrap=this.labelWrap,q.width+f.width>>0>2*g&&(this.sessionVariables.labelAngle=-25)):(this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth,this.sessionVariables.labelAngle=this.sessionVariables.labelMaxWidth>g?-25:this.sessionVariables.labelAngle):y(this.options.labelMaxWidth)?(this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxHeight=
h,this.sessionVariables.labelMaxWidth=g,q.width+f.width>>0>2*g&&(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=m)):(this.sessionVariables.labelAngle=this.sessionVariables.labelMaxWidth>g?-25:this.sessionVariables.labelAngle,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelWrap=this.labelWrap);else{if(y(this.options.labelWrap))if(!y(this.options.labelMaxWidth))this.options.labelMaxWidth<g?(this.sessionVariables.labelMaxWidth=
this.options.labelMaxWidth,this.sessionVariables.labelMaxHeight=c):(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth,this.sessionVariables.labelMaxHeight=h);else if(!y(f))if(c=q.width+f.width>>0,d=this.labelFontSize,n<g)c-2*g>p&&(p=c-2*g,c>=2*g&&c<2.2*g?(this.sessionVariables.labelMaxWidth=g,y(this.options.labelFontSize)&&12<d&&(d=Math.floor(12/13*d),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,
this.sessionVariables.labelAngle=this.labelAngle):c>=2.2*g&&c<2.8*g?(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=m,this.sessionVariables.labelFontSize=d):c>=2.8*g&&c<3.2*g?(this.sessionVariables.labelMaxWidth=Math.max(g,n),this.sessionVariables.labelWrap=!0,y(this.options.labelFontSize)&&12<this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,
this.sessionVariables.labelAngle=this.labelAngle):c>=3.2*g&&c<3.6*g?(this.sessionVariables.labelAngle=-25,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelMaxWidth=m,this.sessionVariables.labelFontSize=this.labelFontSize):c>3.6*g&&c<5*g?(y(this.options.labelFontSize)&&12<d&&(d=Math.floor(12/13*d),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=
m):c>5*g&&(this.sessionVariables.labelWrap=!0,this.sessionVariables.labelMaxWidth=g,this.sessionVariables.labelFontSize=d,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelAngle=this.labelAngle));else if(s===b&&(0===s&&n+this._labels[s+1].textBlock.measureText().width-2*g>p||s===this._labels.length-1&&n+this._labels[s-1].textBlock.measureText().width-2*g>p||0<s&&s<this._labels.length-1&&n+this._labels[s+1].textBlock.measureText().width-2*g>p&&n+this._labels[s-1].textBlock.measureText().width-
2*g>p))p=0===s?n+this._labels[s+1].textBlock.measureText().width-2*g:n+this._labels[s-1].textBlock.measureText().width-2*g,this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelAngle=-25,this.sessionVariables.labelMaxWidth=m;else if(0===p)for(this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?d:this.options.labelFontSize,this.sessionVariables.labelWrap=!0,c=0;c<this._labels.length;c++)a=
this._labels[c].textBlock,a.maxWidth=this.sessionVariables.labelMaxWidth=Math.min(Math.max(g,n),m),q=a.measureText(),c<this._labels.length-1&&(d=c+1,f=this._labels[d].textBlock,f.maxWidth=this.sessionVariables.labelMaxWidth=Math.min(Math.max(g,n),m),f=f.measureText(),q.width+f.width>>0>2*g&&(this.sessionVariables.labelAngle=-25))}else(this.sessionVariables.labelAngle=this.labelAngle,this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:Math.min((c-g*Math.cos(Math.PI/180*Math.abs(this.labelAngle)))/
Math.sin(Math.PI/180*Math.abs(this.labelAngle)),c),m=0!=this.labelAngle?(k-(t+a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle)))/Math.sin(Math.PI/180*Math.abs(this.labelAngle)):g,this.sessionVariables.labelMaxHeight=h=this.labelWrap?(k-m*Math.sin(Math.PI/180*Math.abs(this.labelAngle)))/Math.cos(Math.PI/180*Math.abs(this.labelAngle)):1.5*this.labelFontSize,y(this.options.labelWrap))?y(this.options.labelWrap)&&(this.labelWrap&&!y(this.options.labelMaxWidth)?(this.sessionVariables.labelWrap=
this.labelWrap,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:m,this.sessionVariables.labelMaxHeight=h):(this.sessionVariables.labelAngle=this.labelAngle,this.sessionVariables.labelMaxWidth=m,this.sessionVariables.labelMaxHeight=c<0.9*l?0.9*l:c,this.sessionVariables.labelWrap=this.labelWrap)):(this.options.labelWrap?(this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:m):
(y(this.options.labelMaxWidth),this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:m,this.sessionVariables.labelWrap=this.labelWrap),this.sessionVariables.labelMaxHeight=h)}for(c=0;c<this._labels.length;c++)a=this._labels[c].textBlock,a.maxWidth=this.labelMaxWidth=this.sessionVariables.labelMaxWidth,a.fontSize=this.sessionVariables.labelFontSize,a.angle=this.labelAngle=this.sessionVariables.labelAngle,a.wrap=this.labelWrap=this.sessionVariables.labelWrap,a.maxHeight=
this.sessionVariables.labelMaxHeight,a.measureText()}else for(b=0;b<this._labels.length;b++)a=this._labels[b].textBlock,a.maxWidth=this.labelMaxWidth=y(this.options.labelMaxWidth)?this.sessionVariables.labelMaxWidth:this.options.labelMaxWidth,a.fontSize=this.labelFontSize=y(this.options.labelFontSize)?this.sessionVariables.labelFontSize:this.options.labelFontSize,a.angle=this.labelAngle=y(this.options.labelAngle)?this.sessionVariables.labelAngle:this.labelAngle,a.wrap=this.labelWrap=y(this.options.labelWrap)?
this.sessionVariables.labelWrap:this.options.labelWrap,a.maxHeight=this.sessionVariables.labelMaxHeight,a.measureText();else if("left"===this._position||"right"===this._position)if(g=y(this.options.labelMaxWidth)?0.3*this.chart.width>>0:this.options.labelMaxWidth,h="undefined"===typeof this.options.labelWrap||this.labelWrap?0.3*this.chart.height>>0:1.5*this.labelFontSize,!this.chart.panEnabled&&1<=this._labels.length){this.sessionVariables.labelFontSize=this.labelFontSize;this.sessionVariables.labelMaxWidth=
g;this.sessionVariables.labelMaxHeight=h;this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle;this.sessionVariables.labelWrap=this.labelWrap;for(b=0;b<this._labels.length;b++)if(!this._labels[b].breaksLabelType){a=this._labels[b].textBlock;q=a.measureText();for(d=b+1;d<this._labels.length;d++)if(!this._labels[d].breaksLabelType){f=this._labels[d].textBlock;f=f.measureText();break}e.push(a.height);this.sessionVariables.labelMaxHeight=Math.max.apply(Math,
e);c=g*Math.sin(Math.PI/180*Math.abs(this.labelAngle))+(h-a.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle));Math.cos(Math.PI/180*Math.abs(this.labelAngle));Math.sin(Math.PI/180*Math.abs(this.labelAngle));y(this.options.labelAngle)&&isNaN(this.options.labelAngle)&&0!==this.options.labelAngle?y(this.options.labelWrap)?y(this.options.labelWrap)&&(y(this.options.labelMaxWidth)?y(f)||(l=q.height+f.height>>0,l-2*h>n&&(n=l-2*h,l>=2*h&&l<2.4*h?(y(this.options.labelFontSize)&&12<this.labelFontSize&&
(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize):l>=2.4*h&&l<2.8*h?(this.sessionVariables.labelMaxHeight=c,this.sessionVariables.labelFontSize=this.labelFontSize,this.sessionVariables.labelWrap=!0):l>=2.8*h&&l<3.2*h?(this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelWrap=!0,y(this.options.labelFontSize)&&12<
this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize,this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle):l>=3.2*h&&l<3.6*h?(this.sessionVariables.labelMaxHeight=c,this.sessionVariables.labelWrap=!0,this.sessionVariables.labelFontSize=this.labelFontSize):l>3.6*h&&l<10*h?(y(this.options.labelFontSize)&&
12<this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize,this.sessionVariables.labelMaxWidth=g,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle):l>10*h&&l<50*h&&(y(this.options.labelFontSize)&&12<this.labelFontSize&&(this.labelFontSize=Math.floor(12/13*this.labelFontSize),
a.measureText()),this.sessionVariables.labelFontSize=y(this.options.labelFontSize)?this.labelFontSize:this.options.labelFontSize,this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelMaxWidth=g,this.sessionVariables.labelAngle=y(this.sessionVariables.labelAngle)?0:this.sessionVariables.labelAngle))):(this.sessionVariables.labelMaxHeight=h,this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth)):(this.sessionVariables.labelMaxWidth=
this.labelWrap?this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth:this.labelMaxWidth?this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth:g,this.sessionVariables.labelMaxHeight=h):(this.sessionVariables.labelAngle=this.labelAngle,this.sessionVariables.labelMaxWidth=0===this.labelAngle?g:Math.min((c-h*Math.sin(Math.PI/180*Math.abs(this.labelAngle)))/Math.cos(Math.PI/180*Math.abs(this.labelAngle)),h),y(this.options.labelWrap))?
y(this.options.labelWrap)&&(this.labelWrap&&!y(this.options.labelMaxWidth)?(this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth>this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth,this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxHeight=c):(this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:g,this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:c,y(this.options.labelMaxWidth)&&
(this.sessionVariables.labelAngle=this.labelAngle))):this.options.labelWrap?(this.sessionVariables.labelMaxHeight=0===this.labelAngle?h:c,this.sessionVariables.labelWrap=this.labelWrap,this.sessionVariables.labelMaxWidth=g):(this.sessionVariables.labelMaxHeight=h,y(this.options.labelMaxWidth),this.sessionVariables.labelMaxWidth=this.options.labelMaxWidth?this.options.labelMaxWidth:this.sessionVariables.labelMaxWidth,this.sessionVariables.labelWrap=this.labelWrap)}for(c=0;c<this._labels.length;c++)a=
this._labels[c].textBlock,a.maxWidth=this.labelMaxWidth=this.sessionVariables.labelMaxWidth,a.fontSize=this.labelFontSize=this.sessionVariables.labelFontSize,a.angle=this.labelAngle=this.sessionVariables.labelAngle,a.wrap=this.labelWrap=this.sessionVariables.labelWrap,a.maxHeight=this.sessionVariables.labelMaxHeight,a.measureText()}else for(b=0;b<this._labels.length;b++)a=this._labels[b].textBlock,a.maxWidth=this.labelMaxWidth=y(this.options.labelMaxWidth)?this.sessionVariables.labelMaxWidth:this.options.labelMaxWidth,
a.fontSize=this.labelFontSize=y(this.options.labelFontSize)?this.sessionVariables.labelFontSize:this.options.labelFontSize,a.angle=this.labelAngle=y(this.options.labelAngle)?this.sessionVariables.labelAngle:this.labelAngle,a.wrap=this.labelWrap=y(this.options.labelWrap)?this.sessionVariables.labelWrap:this.options.labelWrap,a.maxHeight=this.sessionVariables.labelMaxHeight,a.measureText();for(b=0;b<this.stripLines.length;b++){var g=this.stripLines[b],x;if("outside"===g.labelPlacement){h=this.sessionVariables.labelMaxWidth;
if("bottom"===this._position||"top"===this._position)x=y(g.options.labelWrap)?this.sessionVariables.labelMaxHeight:g.labelWrap?0.8*this.chart.height>>0:1.5*this.labelFontSize;if("left"===this._position||"right"===this._position)x=y(g.options.labelWrap)?this.sessionVariables.labelMaxHeight:g.labelWrap?0.8*this.chart.width>>0:1.5*this.labelFontSize;y(g.labelBackgroundColor)&&(g.labelBackgroundColor="#EEEEEE")}else h="bottom"===this._position||"top"===this._position?0.9*this.chart.width>>0:0.9*this.chart.height>>
0,x=y(g.options.labelWrap)||g.labelWrap?"bottom"===this._position||"top"===this._position?0.8*this.chart.width>>0:0.8*this.chart.height>>0:1.5*this.labelFontSize,y(g.labelBackgroundColor)&&(y(g.startValue)&&0!==g.startValue?g.labelBackgroundColor=v?"transparent":null:g.labelBackgroundColor="#EEEEEE");a=new ka(this.ctx,{x:0,y:0,backgroundColor:g.labelBackgroundColor,borderColor:g.labelBorderColor,borderThickness:g.labelBorderThickness,cornerRadius:g.labelCornerRadius,maxWidth:g.options.labelMaxWidth?
g.options.labelMaxWidth:h,maxHeight:x,angle:this.labelAngle,text:g.labelFormatter?g.labelFormatter({chart:this.chart,axis:this,stripLine:g}):g.label,horizontalAlign:"left",fontSize:"outside"===g.labelPlacement?g.options.labelFontSize?g.labelFontSize:this.labelFontSize:g.labelFontSize,fontFamily:"outside"===g.labelPlacement?g.options.labelFontFamily?g.labelFontFamily:this.labelFontFamily:g.labelFontFamily,fontWeight:"outside"===g.labelPlacement?g.options.labelFontWeight?g.labelFontWeight:this.labelFontWeight:
g.labelFontWeight,fontColor:g.labelFontColor||g.color,fontStyle:"outside"===g.labelPlacement?g.options.labelFontStyle?g.labelFontStyle:this.fontWeight:g.labelFontStyle,textBaseline:"middle"});this._stripLineLabels.push({position:g.value,textBlock:a,effectiveHeight:null,stripLine:g})}};C.prototype.createLabelsAndCalculateWidth=function(){var a=0,f=0;this._labels=[];this._stripLineLabels=[];if("left"===this._position||"right"===this._position){this.createLabels();for(f=0;f<this._labels.length;f++){var b=
this._labels[f].textBlock,c=b.measureText(),e=0,e=0===this.labelAngle?c.width:c.width*Math.cos(Math.PI/180*Math.abs(this.labelAngle))+(c.height-b.fontSize/2)*Math.sin(Math.PI/180*Math.abs(this.labelAngle));a<e&&(a=e);this._labels[f].effectiveWidth=e}for(f=0;f<this._stripLineLabels.length;f++)"outside"===this._stripLineLabels[f].stripLine.labelPlacement&&(this._stripLineLabels[f].stripLine.value>=this.viewportMinimum&&this._stripLineLabels[f].stripLine.value<=this.viewportMaximum)&&(b=this._stripLineLabels[f].textBlock,
c=b.measureText(),e=0===this.labelAngle?c.width:c.width*Math.cos(Math.PI/180*Math.abs(this.labelAngle))+(c.height-b.fontSize/2)*Math.sin(Math.PI/180*Math.abs(this.labelAngle)),a<e&&(a=e),this._stripLineLabels[f].effectiveWidth=e)}f=this.title?this._titleTextBlock.measureText().height+2:0;return b="inside"===this.labelPlacement?b=f+5:f+a+this.tickLength+5};C.prototype.createLabelsAndCalculateHeight=function(){var a=0;this._labels=[];this._stripLineLabels=[];var f,b=0;this.createLabels();if("bottom"===
this._position||"top"===this._position){for(b=0;b<this._labels.length;b++){f=this._labels[b].textBlock;var c=f.measureText(),e=0,e=0===this.labelAngle?c.height:c.width*Math.sin(Math.PI/180*Math.abs(this.labelAngle))+(c.height-f.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle));a<e&&(a=e);this._labels[b].effectiveHeight=e}for(b=0;b<this._stripLineLabels.length;b++)"outside"===this._stripLineLabels[b].stripLine.labelPlacement&&(this._stripLineLabels[b].stripLine.value>=this.viewportMinimum&&
this._stripLineLabels[b].stripLine.value<=this.viewportMaximum)&&(f=this._stripLineLabels[b].textBlock,c=f.measureText(),e=0===this.labelAngle?c.height:c.width*Math.sin(Math.PI/180*Math.abs(this.labelAngle))+(c.height-f.fontSize/2)*Math.cos(Math.PI/180*Math.abs(this.labelAngle)),a<e&&(a=e),this._stripLineLabels[b].effectiveHeight=e)}f=this.title?this._titleTextBlock.measureText().height+2:0;return b="inside"===this.labelPlacement?b=f+5:f+a+this.tickLength+5};C.setLayoutAndRender=function(a,f,b,c,
e,g){var h,l,t,k,m=a[0]?a[0].chart:f[0].chart,p=m.ctx,n=m._axes;if(a&&0<a.length)for(var d=0;d<a.length;d++)a[d]&&a[d].calculateAxisParameters();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateAxisParameters();if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].calculateAxisParameters();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].calculateAxisParameters();for(d=0;d<n.length;d++)if(n[d]&&n[d].scaleBreaks&&n[d].scaleBreaks._appliedBreaks.length)for(var q=n[d].scaleBreaks._appliedBreaks,s=0;s<q.length&&
!(q[s].startValue>n[d].viewportMaximum);s++)q[s].endValue<n[d].viewportMinimum||(y(n[d].scaleBreaks.firstBreakIndex)&&(n[d].scaleBreaks.firstBreakIndex=s),q[s].startValue>=n[d].viewPortMinimum&&(n[d].scaleBreaks.lastBreakIndex=s));for(var x=s=0,u=0,z=0,C=0,F=0,B=0,A,I,J=l=0,L,K,O,q=L=K=O=!1,d=0;d<n.length;d++)n[d]&&n[d].title&&(n[d]._titleTextBlock=new ka(n[d].ctx,{text:n[d].title,horizontalAlign:"center",fontSize:n[d].titleFontSize,fontFamily:n[d].titleFontFamily,fontWeight:n[d].titleFontWeight,
fontColor:n[d].titleFontColor,fontStyle:n[d].titleFontStyle,borderColor:n[d].titleBorderColor,borderThickness:n[d].titleBorderThickness,backgroundColor:n[d].titleBackgroundColor,cornerRadius:n[d].titleCornerRadius,textBaseline:"top"}));for(d=0;d<n.length;d++)if(n[d].title)switch(n[d]._position){case "left":n[d]._titleTextBlock.maxWidth=n[d].titleMaxWidth||g.height;n[d]._titleTextBlock.maxHeight=n[d].titleWrap?0.8*g.width:1.5*n[d].titleFontSize;n[d]._titleTextBlock.angle=-90;break;case "right":n[d]._titleTextBlock.maxWidth=
n[d].titleMaxWidth||g.height;n[d]._titleTextBlock.maxHeight=n[d].titleWrap?0.8*g.width:1.5*n[d].titleFontSize;n[d]._titleTextBlock.angle=90;break;default:n[d]._titleTextBlock.maxWidth=n[d].titleMaxWidth||g.width,n[d]._titleTextBlock.maxHeight=n[d].titleWrap?0.8*g.height:1.5*n[d].titleFontSize,n[d]._titleTextBlock.angle=0}if("normal"===e){for(var z=[],C=[],F=[],B=[],P=[],R=[],S=[],T=[];4>s;){var E=0,U=0,Y=0,X=0,W=e=0,M=0,$=0,Z=0,V=0,N=0,ba=0;if(b&&0<b.length)for(F=[],d=N=0;d<b.length;d++)F.push(Math.ceil(b[d]?
b[d].createLabelsAndCalculateWidth():0)),N+=F[d],M+=b[d]?b[d].margin:0;else F.push(Math.ceil(b[0]?b[0].createLabelsAndCalculateWidth():0));S.push(F);if(c&&0<c.length)for(B=[],d=ba=0;d<c.length;d++)B.push(Math.ceil(c[d]?c[d].createLabelsAndCalculateWidth():0)),ba+=B[d],$+=c[d]?c[d].margin:0;else B.push(Math.ceil(c[0]?c[0].createLabelsAndCalculateWidth():0));T.push(B);h=Math.round(g.x1+N+M);t=Math.round(g.x2-ba-$>m.width-10?m.width-10:g.x2-ba-$);if(a&&0<a.length)for(z=[],d=Z=0;d<a.length;d++)a[d]&&
(a[d].lineCoordinates={}),a[d].lineCoordinates.width=Math.abs(t-h),a[d].title&&(a[d]._titleTextBlock.maxWidth=0<a[d].titleMaxWidth&&a[d].titleMaxWidth<a[d].lineCoordinates.width?a[d].titleMaxWidth:a[d].lineCoordinates.width),z.push(Math.ceil(a[d]?a[d].createLabelsAndCalculateHeight():0)),Z+=z[d],e+=a[d]?a[d].margin:0;else z.push(Math.ceil(a[0]?a[0].createLabelsAndCalculateHeight():0));P.push(z);if(f&&0<f.length)for(C=[],d=V=0;d<f.length;d++)f[d]&&(f[d].lineCoordinates={}),f[d].lineCoordinates.width=
Math.abs(t-h),f[d].title&&(f[d]._titleTextBlock.maxWidth=0<f[d].titleMaxWidth&&f[d].titleMaxWidth<f[d].lineCoordinates.width?f[d].titleMaxWidth:f[d].lineCoordinates.width),C.push(Math.ceil(f[d]?f[d].createLabelsAndCalculateHeight():0)),V+=C[d],W+=f[d]?f[d].margin:0;else C.push(Math.ceil(f[0]?f[0].createLabelsAndCalculateHeight():0));R.push(C);if(a&&0<a.length)for(d=0;d<a.length;d++)a[d]&&(a[d].lineCoordinates.x1=h,t=Math.round(g.x2-ba-$>m.width-10?m.width-10:g.x2-ba-$),a[d]._labels&&1<a[d]._labels.length&&
(l=k=0,k=a[d]._labels[1],l="dateTime"===a[d].valueType?a[d]._labels[a[d]._labels.length-2]:a[d]._labels[a[d]._labels.length-1],x=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),u=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle))),a[d]&&(a[d].labelAutoFit&&!y(A)&&!y(I))&&(l=0,
0<a[d].labelAngle?I+u>t&&(l+=0<a[d].labelAngle?I+u-t-ba:0):0>a[d].labelAngle?A-x<h&&A-x<a[d].viewportMinimum&&(J=h-(M+a[d].tickLength+F+A-x+a[d].labelFontSize/2)):0===a[d].labelAngle&&(I+u>t&&(l=I+u/2-t-ba),A-x<h&&A-x<a[d].viewportMinimum&&(J=h-M-a[d].tickLength-F-A+x/2)),a[d].viewportMaximum===a[d].maximum&&a[d].viewportMinimum===a[d].minimum&&0<a[d].labelAngle&&0<l?t-=l:a[d].viewportMaximum===a[d].maximum&&a[d].viewportMinimum===a[d].minimum&&0>a[d].labelAngle&&0<J?h+=J:a[d].viewportMaximum===a[d].maximum&&
a[d].viewportMinimum===a[d].minimum&&0===a[d].labelAngle&&(0<J&&(h+=J),0<l&&(t-=l))),m.panEnabled?Z=m.sessionVariables.axisX.height:m.sessionVariables.axisX.height=Z,l=Math.round(g.y2-Z-e+E),k=Math.round(g.y2),a[d].lineCoordinates.x2=t,a[d].lineCoordinates.width=t-h,a[d].lineCoordinates.y1=l,a[d].lineCoordinates.y2=l,a[d].bounds={x1:h,y1:l,x2:t,y2:k-(Z+e-z[d]-E),width:t-h,height:k-l}),E+=z[d]+a[d].margin;if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].lineCoordinates.x1=Math.round(g.x1+N+M),f[d].lineCoordinates.x2=
Math.round(g.x2-ba-$>m.width-10?m.width-10:g.x2-ba-$),f[d].lineCoordinates.width=Math.abs(t-h),f[d]._labels&&1<f[d]._labels.length&&(k=f[d]._labels[1],l="dateTime"===f[d].valueType?f[d]._labels[f[d]._labels.length-2]:f[d]._labels[f[d]._labels.length-1],x=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),u=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-
l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle))),m.panEnabled?V=m.sessionVariables.axisX2.height:m.sessionVariables.axisX2.height=V,l=Math.round(g.y1),k=Math.round(g.y2+f[d].margin),f[d].lineCoordinates.y1=l+V+W-U,f[d].lineCoordinates.y2=l,f[d].bounds={x1:h,y1:l+(V+W-C[d]-U),x2:t,y2:k,width:t-h,height:k-l},U+=C[d]+f[d].margin;if(b&&0<b.length)for(d=0;d<b.length;d++)M=10,b[d]&&(h=Math.round(a[0]?a[0].lineCoordinates.x1:f[0].lineCoordinates.x1),M=b[d]._labels&&0<b[d]._labels.length?
b[d]._labels[b[d]._labels.length-1].textBlock.height/2:10,l=Math.round(g.y1+V+W<Math.max(M,10)?Math.max(M,10):g.y1+V+W),t=Math.round(a[0]?a[0].lineCoordinates.x1:f[0].lineCoordinates.x1),M=0<a.length?0:b[d]._labels&&0<b[d]._labels.length?b[d]._labels[0].textBlock.height/2:10,k=Math.round(g.y2-Z-e-M),b[d].lineCoordinates={x1:t-Y,y1:l,x2:t-Y,y2:k,height:Math.abs(k-l)},b[d].bounds={x1:h-(F[d]+Y),y1:l,x2:t,y2:k,width:t-h,height:k-l},b[d].title&&(b[d]._titleTextBlock.maxWidth=0<b[d].titleMaxWidth&&b[d].titleMaxWidth<
b[d].lineCoordinates.height?b[d].titleMaxWidth:b[d].lineCoordinates.height),Y+=F[d]+b[d].margin);if(c&&0<c.length)for(d=0;d<c.length;d++)c[d]&&(h=Math.round(a[0]?a[0].lineCoordinates.x2:f[0].lineCoordinates.x2),t=Math.round(h),M=c[d]._labels&&0<c[d]._labels.length?c[d]._labels[c[d]._labels.length-1].textBlock.height/2:0,l=Math.round(g.y1+V+W<Math.max(M,10)?Math.max(M,10):g.y1+V+W),M=0<a.length?0:c[d]._labels&&0<c[d]._labels.length?c[d]._labels[0].textBlock.height/2:0,k=Math.round(g.y2-(Z+e+M)),c[d].lineCoordinates=
{x1:h+X,y1:l,x2:h+X,y2:k,height:Math.abs(k-l)},c[d].bounds={x1:h,y1:l,x2:t+(B[d]+X),y2:k,width:t-h,height:k-l},c[d].title&&(c[d]._titleTextBlock.maxWidth=0<c[d].titleMaxWidth&&c[d].titleMaxWidth<c[d].lineCoordinates.height?c[d].titleMaxWidth:c[d].lineCoordinates.height),X+=B[d]+c[d].margin);if(a&&0<a.length)for(d=0;d<a.length;d++)a[d]&&(a[d].calculateValueToPixelConversionParameters(),a[d].calculateBreaksSizeInValues(),a[d]._labels&&1<a[d]._labels.length&&(A=(a[d].logarithmic?Math.log(a[d]._labels[1].position/
a[d].viewportMinimum)/a[d].conversionParameters.lnLogarithmBase:a[d]._labels[1].position-a[d].viewportMinimum)*Math.abs(a[d].conversionParameters.pixelPerUnit)+a[d].lineCoordinates.x1,h=a[d]._labels[a[d]._labels.length-("dateTime"===a[d].valueType?2:1)].position,h=a[d].getApparentDifference(a[d].viewportMinimum,h),I=a[d].logarithmic?(1<h?Math.log(h)/a[d].conversionParameters.lnLogarithmBase*Math.abs(a[d].conversionParameters.pixelPerUnit):0)+a[d].lineCoordinates.x1:(0<h?h*Math.abs(a[d].conversionParameters.pixelPerUnit):
0)+a[d].lineCoordinates.x1));if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateValueToPixelConversionParameters(),f[d].calculateBreaksSizeInValues(),f[d]._labels&&1<f[d]._labels.length&&(A=(f[d].logarithmic?Math.log(f[d]._labels[1].position/f[d].viewportMinimum)/f[d].conversionParameters.lnLogarithmBase:f[d]._labels[1].position-f[d].viewportMinimum)*Math.abs(f[d].conversionParameters.pixelPerUnit)+f[d].lineCoordinates.x1,h=f[d]._labels[f[d]._labels.length-("dateTime"===f[d].valueType?2:1)].position,
h=f[d].getApparentDifference(f[d].viewportMinimum,h),I=f[d].logarithmic?(1<h?Math.log(h)/f[d].conversionParameters.lnLogarithmBase*Math.abs(f[d].conversionParameters.pixelPerUnit):0)+f[d].lineCoordinates.x1:(0<h?h*Math.abs(f[d].conversionParameters.pixelPerUnit):0)+f[d].lineCoordinates.x1);for(d=0;d<n.length;d++)"axisY"===n[d].type&&(n[d].calculateValueToPixelConversionParameters(),n[d].calculateBreaksSizeInValues());if(0<s){if(a&&0<a.length)for(d=0;d<a.length;d++)q=P[s-1][d]===P[s][d]?!0:!1;else q=
!0;if(f&&0<f.length)for(d=0;d<f.length;d++)L=R[s-1][d]===R[s][d]?!0:!1;else L=!0;if(b&&0<b.length)for(d=0;d<b.length;d++)K=S[s-1][d]===S[s][d]?!0:!1;else K=!0;if(c&&0<c.length)for(d=0;d<c.length;d++)O=T[s-1][d]===T[s][d]?!0:!1;else O=!0}if(q&&L&&K&&O)break;s++}p.save();p.beginPath();a[0]&&p.rect(5,a[0].bounds.y1,a[0].chart.width-10,a[0].bounds.height);f[0]&&p.rect(5,f[f.length-1].bounds.y1,f[0].chart.width-10,f[0].bounds.height);p.clip();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].calculateStripLinesThicknessInValues(),
a[d].calculateBreaksInPixels(),a[d].renderLabelsTicksAndTitle();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateStripLinesThicknessInValues(),f[d].calculateBreaksInPixels(),f[d].renderLabelsTicksAndTitle();p.restore();if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].calculateStripLinesThicknessInValues(),b[d].calculateBreaksInPixels(),b[d].renderLabelsTicksAndTitle();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].calculateStripLinesThicknessInValues(),c[d].calculateBreaksInPixels(),c[d].renderLabelsTicksAndTitle()}else{A=
[];J=[];x=[];I=[];u=[];P=[];R=[];for(S=[];4>s;){V=Z=N=X=$=M=W=e=Y=T=U=E=0;if(a&&0<a.length)for(x=[],d=Z=0;d<a.length;d++)x.push(Math.ceil(a[d]?a[d].createLabelsAndCalculateWidth():0)),Z+=x[d],e+=a[d]?a[d].margin:0;else x.push(Math.ceil(a[0]?a[0].createLabelsAndCalculateWidth():0));R.push(x);if(f&&0<f.length)for(I=[],d=V=0;d<f.length;d++)I.push(Math.ceil(f[d]?f[d].createLabelsAndCalculateWidth():0)),V+=I[d],W+=f[d]?f[d].margin:0;else I.push(Math.ceil(f[0]?f[0].createLabelsAndCalculateWidth():0));S.push(I);
if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].lineCoordinates={},h=Math.round(g.x1+Z+e),t=Math.round(g.x2-V-W>m.width-10?m.width-10:g.x2-V-W),b[d].labelAutoFit&&!y(z)&&(0<!a.length&&(h=0>b[d].labelAngle?Math.max(h,z):0===b[d].labelAngle?Math.max(h,z/2):h),0<!f.length&&(t=0<b[d].labelAngle?t-C/2:0===b[d].labelAngle?t-C/2:t)),b[d].lineCoordinates.x1=h,b[d].lineCoordinates.x2=t,b[d].lineCoordinates.width=Math.abs(t-h),b[d].title&&(b[d]._titleTextBlock.maxWidth=0<b[d].titleMaxWidth&&b[d].titleMaxWidth<
b[d].lineCoordinates.width?b[d].titleMaxWidth:b[d].lineCoordinates.width);if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].lineCoordinates={},h=Math.round(g.x1+Z+e),t=Math.round(g.x2-V-W>c[d].chart.width-10?c[d].chart.width-10:g.x2-V-W),c[d]&&c[d].labelAutoFit&&!y(F)&&(0<!a.length&&(h=0<c[d].labelAngle?Math.max(h,F):0===c[d].labelAngle?Math.max(h,F/2):h),0<!f.length&&(t-=B/2)),c[d].lineCoordinates.x1=h,c[d].lineCoordinates.x2=t,c[d].lineCoordinates.width=Math.abs(t-h),c[d].title&&(c[d]._titleTextBlock.maxWidth=
0<c[d].titleMaxWidth&&c[d].titleMaxWidth<c[d].lineCoordinates.width?c[d].titleMaxWidth:c[d].lineCoordinates.width);if(b&&0<b.length)for(A=[],d=X=0;d<b.length;d++)A.push(Math.ceil(b[d]?b[d].createLabelsAndCalculateHeight():0)),X+=A[d]+b[d].margin,M+=b[d].margin;else A.push(Math.ceil(b[0]?b[0].createLabelsAndCalculateHeight():0));u.push(A);if(c&&0<c.length)for(J=[],d=N=0;d<c.length;d++)J.push(Math.ceil(c[d]?c[d].createLabelsAndCalculateHeight():0)),N+=J[d],$+=c[d].margin;else J.push(Math.ceil(c[0]?
c[0].createLabelsAndCalculateHeight():0));P.push(J);if(b&&0<b.length)for(d=0;d<b.length;d++)0<b[d]._labels.length&&(k=b[d]._labels[0],l=b[d]._labels[b[d]._labels.length-1],z=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),C=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle)));
if(c&&0<c.length)for(d=0;d<c.length;d++)c[d]&&0<c[d]._labels.length&&(k=c[d]._labels[0],l=c[d]._labels[c[d]._labels.length-1],F=k.textBlock.width*Math.cos(Math.PI/180*Math.abs(k.textBlock.angle))+(k.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(k.textBlock.angle)),B=l.textBlock.width*Math.cos(Math.PI/180*Math.abs(l.textBlock.angle))+(l.textBlock.height-l.textBlock.fontSize/2)*Math.sin(Math.PI/180*Math.abs(l.textBlock.angle)));if(m.panEnabled)for(d=0;d<b.length;d++)A[d]=m.sessionVariables.axisY.height;
else for(d=0;d<b.length;d++)m.sessionVariables.axisY.height=A[d];if(b&&0<b.length)for(d=b.length-1;0<=d;d--)l=Math.round(g.y2),k=Math.round(g.y2>b[d].chart.height-10?b[d].chart.height-10:g.y2),b[d].lineCoordinates.y1=l-(A[d]+b[d].margin+E),b[d].lineCoordinates.y2=l-(A[d]+b[d].margin+E),b[d].bounds={x1:h,y1:l-(A[d]+E+b[d].margin),x2:t,y2:k-(E+b[d].margin),width:t-h,height:A[d]},b[d].title&&(b[d]._titleTextBlock.maxWidth=0<b[d].titleMaxWidth&&b[d].titleMaxWidth<b[d].lineCoordinates.width?b[d].titleMaxWidth:
b[d].lineCoordinates.width),E+=A[d]+b[d].margin;if(c&&0<c.length)for(d=c.length-1;0<=d;d--)c[d]&&(l=Math.round(g.y1),k=Math.round(g.y1+(J[d]+c[d].margin+U)),c[d].lineCoordinates.y1=k,c[d].lineCoordinates.y2=k,c[d].bounds={x1:h,y1:l+(c[d].margin+U),x2:t,y2:k,width:t-h,height:N},c[d].title&&(c[d]._titleTextBlock.maxWidth=0<c[d].titleMaxWidth&&c[d].titleMaxWidth<c[d].lineCoordinates.width?c[d].titleMaxWidth:c[d].lineCoordinates.width),U+=J[d]+c[d].margin);if(a&&0<a.length)for(d=0;d<a.length;d++){M=a[d]._labels&&
0<a[d]._labels.length?a[d]._labels[0].textBlock.fontSize/2:0;h=Math.round(g.x1+e);l=c&&0<c.length?Math.round(c[0]?c[0].lineCoordinates.y2:g.y1<Math.max(M,10)?Math.max(M,10):g.y1):g.y1<Math.max(M,10)?Math.max(M,10):g.y1;t=Math.round(g.x1+Z+e);k=b&&0<b.length?Math.round(b[0]?b[0].lineCoordinates.y1:g.y2-X>m.height-Math.max(M,10)?m.height-Math.max(M,10):g.y2-X):g.y2>m.height-Math.max(M,10)?m.height-Math.max(M,10):g.y2;if(b&&0<b.length)for(M=0;M<b.length;M++)b[M]&&b[M].labelAutoFit&&(t=0>b[M].labelAngle?
Math.max(t,z):0===b[M].labelAngle?Math.max(t,z/2):t,h=0>b[M].labelAngle||0===b[M].labelAngle?t-Z:h);if(c&&0<c.length)for(M=0;M<c.length;M++)c[M]&&c[M].labelAutoFit&&(t=c[M].lineCoordinates.x1,h=t-Z);a[d].lineCoordinates={x1:t-T,y1:l,x2:t-T,y2:k,height:Math.abs(k-l)};a[d].bounds={x1:t-(x[d]+T),y1:l,x2:t,y2:k,width:t-h,height:k-l};a[d].title&&(a[d]._titleTextBlock.maxWidth=0<a[d].titleMaxWidth&&a[d].titleMaxWidth<a[d].lineCoordinates.height?a[d].titleMaxWidth:a[d].lineCoordinates.height);a[d].calculateValueToPixelConversionParameters();
a[d].calculateBreaksSizeInValues();T+=x[d]+a[d].margin}if(f&&0<f.length)for(d=0;d<f.length;d++){M=f[d]._labels&&0<f[d]._labels.length?f[d]._labels[0].textBlock.fontSize/2:0;h=Math.round(g.x1-e);l=c&&0<c.length?Math.round(c[0]?c[0].lineCoordinates.y2:g.y1<Math.max(M,10)?Math.max(M,10):g.y1):g.y1<Math.max(M,10)?Math.max(M,10):g.y1;t=Math.round(g.x2-V-W);k=b&&0<b.length?Math.round(b[0]?b[0].lineCoordinates.y1:g.y2-X>m.height-Math.max(M,10)?m.height-Math.max(M,10):g.y2-X):g.y2>m.height-Math.max(M,10)?
m.height-Math.max(M,10):g.y2;if(b&&0<b.length)for(M=0;M<b.length;M++)b[M]&&b[M].labelAutoFit&&(t=0>b[M].labelAngle?Math.max(t,z):0===b[M].labelAngle?Math.max(t,z/2):t,h=0>b[M].labelAngle||0===b[M].labelAngle?t-V:h);if(c&&0<c.length)for(M=0;M<c.length;M++)c[M]&&c[M].labelAutoFit&&(t=c[M].lineCoordinates.x2,h=t-V);f[d].lineCoordinates={x1:t+Y,y1:l,x2:t+Y,y2:k,height:Math.abs(k-l)};f[d].bounds={x1:h,y1:l,x2:t+I[d]+Y,y2:k,width:t-h,height:k-l};f[d].title&&(f[d]._titleTextBlock.maxWidth=0<f[d].titleMaxWidth&&
f[d].titleMaxWidth<f[d].lineCoordinates.height?f[d].titleMaxWidth:f[d].lineCoordinates.height);f[d].calculateValueToPixelConversionParameters();f[d].calculateBreaksSizeInValues();Y+=I[d]+f[d].margin}for(d=0;d<n.length;d++)"axisY"===n[d].type&&(n[d].calculateValueToPixelConversionParameters(),n[d].calculateBreaksSizeInValues());if(0<s){if(a&&0<a.length)for(d=0;d<a.length;d++)q=R[s-1][d]===R[s][d]?!0:!1;else q=!0;if(f&&0<f.length)for(d=0;d<f.length;d++)L=S[s-1][d]===S[s][d]?!0:!1;else L=!0;if(b&&0<
b.length)for(d=0;d<b.length;d++)K=u[s-1][d]===u[s][d]?!0:!1;else K=!0;if(c&&0<c.length)for(d=0;d<c.length;d++)O=P[s-1][d]===P[s][d]?!0:!1;else O=!0}if(q&&L&&K&&O)break;s++}if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].calculateStripLinesThicknessInValues(),b[d].calculateBreaksInPixels(),b[d].renderLabelsTicksAndTitle();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].calculateStripLinesThicknessInValues(),c[d].calculateBreaksInPixels(),c[d].renderLabelsTicksAndTitle();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].calculateStripLinesThicknessInValues(),
a[d].calculateBreaksInPixels(),a[d].renderLabelsTicksAndTitle();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].calculateStripLinesThicknessInValues(),f[d].calculateBreaksInPixels(),f[d].renderLabelsTicksAndTitle()}m.preparePlotArea();g=m.plotArea;p.save();p.beginPath();p.rect(g.x1,g.y1,Math.abs(g.x2-g.x1),Math.abs(g.y2-g.y1));p.clip();if(a&&0<a.length)for(d=0;d<n.length;d++)n[d].renderStripLinesOfThicknessType("value");if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderStripLinesOfThicknessType("value");
if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderStripLinesOfThicknessType("value");if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderStripLinesOfThicknessType("value");if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderInterlacedColors();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderInterlacedColors();if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderInterlacedColors();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderInterlacedColors();p.restore();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderGrid(),
v&&(a[d].createMask(),a[d].renderBreaksBackground());if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderGrid(),v&&(f[d].createMask(),f[d].renderBreaksBackground());if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderGrid(),v&&(b[d].createMask(),b[d].renderBreaksBackground());if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderGrid(),v&&(c[d].createMask(),c[d].renderBreaksBackground());if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderAxisLine();if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderAxisLine();
if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderAxisLine();if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderAxisLine();if(a&&0<a.length)for(d=0;d<a.length;d++)a[d].renderStripLinesOfThicknessType("pixel");if(f&&0<f.length)for(d=0;d<f.length;d++)f[d].renderStripLinesOfThicknessType("pixel");if(b&&0<b.length)for(d=0;d<b.length;d++)b[d].renderStripLinesOfThicknessType("pixel");if(c&&0<c.length)for(d=0;d<c.length;d++)c[d].renderStripLinesOfThicknessType("pixel")};C.prototype.calculateStripLinesThicknessInValues=
function(){for(var a=0;a<this.stripLines.length;a++)if(null!==this.stripLines[a].startValue&&null!==this.stripLines[a].endValue){var f=Math.min(this.stripLines[a].startValue,this.stripLines[a].endValue),b=Math.max(this.stripLines[a].startValue,this.stripLines[a].endValue),f=this.getApparentDifference(f,b);this.stripLines[a].value=this.logarithmic?this.stripLines[a].value*Math.sqrt(Math.log(this.stripLines[a].endValue/this.stripLines[a].startValue)/Math.log(f)):this.stripLines[a].value+(Math.abs(this.stripLines[a].endValue-
this.stripLines[a].startValue)-f)/2;this.stripLines[a].thickness=f;this.stripLines[a]._thicknessType="value"}};C.prototype.calculateBreaksSizeInValues=function(){for(var a="left"===this._position||"right"===this._position?this.lineCoordinates.height||this.chart.height:this.lineCoordinates.width||this.chart.width,f=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[],b=this.conversionParameters.pixelPerUnit||a/(this.logarithmic?this.conversionParameters.maximum/this.conversionParameters.minimum:this.conversionParameters.maximum-
this.conversionParameters.minimum),c=this.scaleBreaks&&!y(this.scaleBreaks.options.spacing),e,g=0;g<f.length;g++)e=c||!y(f[g].options.spacing),f[g].spacing=J(f[g].spacing,a,8,e?0.1*a:8,e?0:3)<<0,f[g].size=0>f[g].spacing?0:Math.abs(f[g].spacing/b),this.logarithmic&&(f[g].size=Math.pow(this.logarithmBase,f[g].size))};C.prototype.calculateBreaksInPixels=function(){if(!(this.scaleBreaks&&0>=this.scaleBreaks._appliedBreaks.length)){var a=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[];a.length&&(this.scaleBreaks.firstBreakIndex=
this.scaleBreaks.lastBreakIndex=null);for(var f=0;f<a.length&&!(a[f].startValue>this.conversionParameters.maximum);f++)a[f].endValue<this.conversionParameters.minimum||(y(this.scaleBreaks.firstBreakIndex)&&(this.scaleBreaks.firstBreakIndex=f),a[f].startValue>=this.conversionParameters.minimum&&(a[f].startPixel=this.convertValueToPixel(a[f].startValue),this.scaleBreaks.lastBreakIndex=f),a[f].endValue<=this.conversionParameters.maximum&&(a[f].endPixel=this.convertValueToPixel(a[f].endValue)))}};C.prototype.renderLabelsTicksAndTitle=
function(){var a=this,f=!1,b=0,c=0,e=1,g=0;0!==this.labelAngle&&360!==this.labelAngle&&(e=1.2);if("undefined"===typeof this.options.interval){if("bottom"===this._position||"top"===this._position)if(this.logarithmic&&!this.equidistantInterval&&this.labelAutoFit){for(var b=[],e=0!==this.labelAngle&&360!==this.labelAngle?1:1.2,h,l=this.viewportMaximum,m=this.lineCoordinates.width/Math.log(this.range),k=this._labels.length-1;0<=k;k--){p=this._labels[k];if(p.position<this.viewportMinimum)break;p.position>
this.viewportMaximum||!(k===this._labels.length-1||h<Math.log(l/p.position)*m/e)||(b.push(p),l=p.position,h=p.textBlock.width*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+p.textBlock.height*Math.abs(Math.sin(Math.PI/180*this.labelAngle)))}this._labels=b}else{for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(h=p.textBlock.width*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+p.textBlock.height*Math.abs(Math.sin(Math.PI/180*this.labelAngle)),b+=h);b>this.lineCoordinates.width*
e&&this.labelAutoFit&&(f=!0)}if("left"===this._position||"right"===this._position)if(this.logarithmic&&!this.equidistantInterval&&this.labelAutoFit){for(var b=[],r,l=this.viewportMaximum,m=this.lineCoordinates.height/Math.log(this.range),k=this._labels.length-1;0<=k;k--){p=this._labels[k];if(p.position<this.viewportMinimum)break;p.position>this.viewportMaximum||!(k===this._labels.length-1||r<Math.log(l/p.position)*m)||(b.push(p),l=p.position,r=p.textBlock.height*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+
p.textBlock.width*Math.abs(Math.sin(Math.PI/180*this.labelAngle)))}this._labels=b}else{for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(r=p.textBlock.height*Math.abs(Math.cos(Math.PI/180*this.labelAngle))+p.textBlock.width*Math.abs(Math.sin(Math.PI/180*this.labelAngle)),c+=r);c>this.lineCoordinates.height*e&&this.labelAutoFit&&(f=!0)}}this.logarithmic&&(!this.equidistantInterval&&this.labelAutoFit)&&this._labels.sort(function(a,b){return a.position-b.position});
var k=0,p,n;if("bottom"===this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0,this.ctx.beginPath(),this.ctx.moveTo(c,n.y<<0),this.ctx.lineTo(c,n.y+this.tickLength<<0),
this.ctx.stroke()),0===p.textBlock.angle?(n.x-=p.textBlock.width/2,n.y="inside"===this.labelPlacement?n.y-(this.tickLength+p.textBlock.fontSize/2):n.y+this.tickLength+p.textBlock.fontSize/2):(n.x="inside"===this.labelPlacement?0>this.labelAngle?n.x:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):n.x-(0>this.labelAngle?p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0),n.y="inside"===this.labelPlacement?0>this.labelAngle?n.y-this.tickLength-5:n.y-this.tickLength-Math.abs(p.textBlock.width*
Math.sin(Math.PI/180*this.labelAngle)+5):n.y+this.tickLength+Math.abs(0>this.labelAngle?p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle)-5:5)),p.textBlock.x=n.x,p.textBlock.y=n.y);"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),a.tickThickness)){a.ctx.lineWidth=
a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===a.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(b,n.y<<0);a.ctx.lineTo(b,n.y-a.tickLength<<0);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.lineCoordinates.x1+this.lineCoordinates.width/2-this._titleTextBlock.width/2,this._titleTextBlock.y=this.bounds.y2-this._titleTextBlock.height-3,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}else if("top"===
this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0,this.ctx.beginPath(),this.ctx.moveTo(c,n.y<<0),this.ctx.lineTo(c,n.y-this.tickLength<<0),this.ctx.stroke()),0===p.textBlock.angle?
(n.x-=p.textBlock.width/2,n.y="inside"===this.labelPlacement?n.y+this.labelFontSize/2+this.tickLength+5:n.y-(this.tickLength+p.textBlock.height-p.textBlock.fontSize/2)):(n.x="inside"===this.labelPlacement?0<this.labelAngle?n.x:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):n.x+(p.textBlock.height-this.tickLength-this.labelFontSize)*Math.sin(Math.PI/180*this.labelAngle)-(0<this.labelAngle?p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0),n.y="inside"===this.labelPlacement?0<this.labelAngle?
n.y+this.tickLength+5:n.y-p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle)+this.tickLength+5:n.y-(this.tickLength+((p.textBlock.height-p.textBlock.fontSize/2)*Math.cos(Math.PI/180*this.labelAngle)+(0<this.labelAngle?p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle):0)))),p.textBlock.x=n.x,p.textBlock.y=n.y);"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||
p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),a.tickThickness)){a.ctx.lineWidth=a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===this.ctx.lineWidth%2?(n.x<<0)+0.5:n.x<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(b,n.y<<0);a.ctx.lineTo(b,n.y+a.tickLength<<0);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.lineCoordinates.x1+this.lineCoordinates.width/2-this._titleTextBlock.width/
2,this._titleTextBlock.y=this.bounds.y1+1,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}else if("left"===this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%
2?(n.y<<0)+0.5:n.y<<0,this.ctx.beginPath(),this.ctx.moveTo(n.x<<0,c),this.ctx.lineTo(n.x-this.tickLength<<0,c),this.ctx.stroke()),0===this.labelAngle?(p.textBlock.y=n.y,p.textBlock.x="inside"===this.labelPlacement?n.x+this.tickLength+5:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5):(p.textBlock.y="inside"===this.labelPlacement?n.y:n.y-p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle),p.textBlock.x="inside"===this.labelPlacement?n.x+this.tickLength+5:0<this.labelAngle?
n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)+(p.textBlock.height-p.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)-this.tickLength));"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),
a.tickThickness)){a.ctx.lineWidth=a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===a.ctx.lineWidth%2?(n.y<<0)+0.5:n.y<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(n.x<<0,b);a.ctx.lineTo(n.x+a.tickLength<<0,b);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.bounds.x1+1,this._titleTextBlock.y=this.lineCoordinates.height/2+this._titleTextBlock.width/2+this.lineCoordinates.y1,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}else if("right"===
this._position){for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||(n=this.getPixelCoordinatesOnAxis(p.position),this.tickThickness&&"inside"!=this.labelPlacement&&(this.ctx.lineWidth=this.tickThickness,this.ctx.strokeStyle=this.tickColor,c=1===this.ctx.lineWidth%2?(n.y<<0)+0.5:n.y<<0,this.ctx.beginPath(),this.ctx.moveTo(n.x<<0,c),this.ctx.lineTo(n.x+this.tickLength<<0,c),this.ctx.stroke()),0===this.labelAngle?
(p.textBlock.y=n.y,p.textBlock.x="inside"===this.labelPlacement?n.x-p.textBlock.width-this.tickLength-5:n.x+this.tickLength+5):(p.textBlock.y="inside"===this.labelPlacement?n.y-p.textBlock.width*Math.sin(Math.PI/180*this.labelAngle):0>this.labelAngle?n.y:n.y-(p.textBlock.height-p.textBlock.fontSize/2-5)*Math.cos(Math.PI/180*this.labelAngle),p.textBlock.x="inside"===this.labelPlacement?n.x-p.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:0<this.labelAngle?n.x+(p.textBlock.height-
p.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)+this.tickLength:n.x+this.tickLength+5));"inside"===this.labelPlacement&&this.chart.addEventListener("dataAnimationIterationEnd",function(){for(k=0;k<a._labels.length;k++)if(p=a._labels[k],!(p.position<a.viewportMinimum||p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)&&(n=a.getPixelCoordinatesOnAxis(p.position),a.tickThickness)){a.ctx.lineWidth=a.tickThickness;a.ctx.strokeStyle=a.tickColor;var b=1===a.ctx.lineWidth%2?(n.y<<
0)+0.5:n.y<<0;a.ctx.save();a.ctx.beginPath();a.ctx.moveTo(n.x<<0,b);a.ctx.lineTo(n.x-a.tickLength<<0,b);a.ctx.stroke();a.ctx.restore()}},this);this.title&&(this._titleTextBlock.measureText(),this._titleTextBlock.x=this.bounds.x2-1,this._titleTextBlock.y=this.lineCoordinates.height/2-this._titleTextBlock.width/2+this.lineCoordinates.y1,this.titleMaxWidth=this._titleTextBlock.maxWidth,this._titleTextBlock.render(!0))}g=0;if("inside"===this.labelPlacement)this.chart.addEventListener("dataAnimationIterationEnd",
function(){for(k=0;k<a._labels.length;k++)p=a._labels[k],p.position<a.viewportMinimum||(p.position>a.viewportMaximum||f&&0!==g++%2&&a.labelAutoFit)||(a.ctx.save(),a.ctx.beginPath(),p.textBlock.render(!0),a.ctx.restore())},p.textBlock);else for(k=0;k<this._labels.length;k++)p=this._labels[k],p.position<this.viewportMinimum||(p.position>this.viewportMaximum||f&&0!==g++%2&&this.labelAutoFit)||p.textBlock.render(!0)};C.prototype.renderInterlacedColors=function(){var a=this.chart.plotArea.ctx,f,b,c=this.chart.plotArea,
e=0;f=!0;if(("bottom"===this._position||"top"===this._position)&&this.interlacedColor)for(a.fillStyle=this.interlacedColor,e=0;e<this._labels.length;e++)f?(f=this.getPixelCoordinatesOnAxis(this._labels[e].position),b=e+1>this._labels.length-1?this.getPixelCoordinatesOnAxis(this.viewportMaximum):this.getPixelCoordinatesOnAxis(this._labels[e+1].position),a.fillRect(Math.min(b.x,f.x),c.y1,Math.abs(b.x-f.x),Math.abs(c.y1-c.y2)),f=!1):f=!0;else if(("left"===this._position||"right"===this._position)&&this.interlacedColor)for(a.fillStyle=
this.interlacedColor,e=0;e<this._labels.length;e++)f?(b=this.getPixelCoordinatesOnAxis(this._labels[e].position),f=e+1>this._labels.length-1?this.getPixelCoordinatesOnAxis(this.viewportMaximum):this.getPixelCoordinatesOnAxis(this._labels[e+1].position),a.fillRect(c.x1,Math.min(b.y,f.y),Math.abs(c.x1-c.x2),Math.abs(f.y-b.y)),f=!1):f=!0;a.beginPath()};C.prototype.renderStripLinesOfThicknessType=function(a){if(this.stripLines&&0<this.stripLines.length&&a){for(var f=this,b,c=0,e=0,g=!1,h=!1,l=[],m=[],
h=!1,c=0;c<this.stripLines.length;c++){var k=this.stripLines[c];k._thicknessType===a&&("pixel"===a&&(k.value<this.viewportMinimum||k.value>this.viewportMaximum||y(k.value)||isNaN(this.range))||l.push(k))}for(c=0;c<this._stripLineLabels.length;c++)if(k=this.stripLines[c],b=this._stripLineLabels[c],!(b.position<this.viewportMinimum||b.position>this.viewportMaximum||isNaN(this.range))){a=this.getPixelCoordinatesOnAxis(b.position);if("outside"===b.stripLine.labelPlacement)if(k&&(this.ctx.strokeStyle=
k.color,"pixel"===k._thicknessType&&(this.ctx.lineWidth=k.thickness)),"bottom"===this._position){var r=1===this.ctx.lineWidth%2?(a.x<<0)+0.5:a.x<<0;this.ctx.beginPath();this.ctx.moveTo(r,a.y<<0);this.ctx.lineTo(r,a.y+this.tickLength<<0);this.ctx.stroke();0===this.labelAngle?(a.x-=b.textBlock.width/2,a.y+=this.tickLength+b.textBlock.fontSize/2):(a.x-=0>this.labelAngle?b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0,a.y+=this.tickLength+Math.abs(0>this.labelAngle?b.textBlock.width*Math.sin(Math.PI/
180*this.labelAngle)-5:5))}else"top"===this._position?(r=1===this.ctx.lineWidth%2?(a.x<<0)+0.5:a.x<<0,this.ctx.beginPath(),this.ctx.moveTo(r,a.y<<0),this.ctx.lineTo(r,a.y-this.tickLength<<0),this.ctx.stroke(),0===this.labelAngle?(a.x-=b.textBlock.width/2,a.y-=this.tickLength+b.textBlock.height):(a.x+=(b.textBlock.height-this.tickLength-this.labelFontSize/2)*Math.sin(Math.PI/180*this.labelAngle)-(0<this.labelAngle?b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle):0),a.y-=this.tickLength+(b.textBlock.height*
Math.cos(Math.PI/180*this.labelAngle)+(0<this.labelAngle?b.textBlock.width*Math.sin(Math.PI/180*this.labelAngle):0)))):"left"===this._position?(r=1===this.ctx.lineWidth%2?(a.y<<0)+0.5:a.y<<0,this.ctx.beginPath(),this.ctx.moveTo(a.x<<0,r),this.ctx.lineTo(a.x-this.tickLength<<0,r),this.ctx.stroke(),0===this.labelAngle?a.x=a.x-b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:(a.y-=b.textBlock.width*Math.sin(Math.PI/180*this.labelAngle),a.x=0<this.labelAngle?a.x-b.textBlock.width*
Math.cos(Math.PI/180*this.labelAngle)-this.tickLength-5:a.x-b.textBlock.width*Math.cos(Math.PI/180*this.labelAngle)+(b.textBlock.height-b.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)-this.tickLength)):"right"===this._position&&(r=1===this.ctx.lineWidth%2?(a.y<<0)+0.5:a.y<<0,this.ctx.beginPath(),this.ctx.moveTo(a.x<<0,r),this.ctx.lineTo(a.x+this.tickLength<<0,r),this.ctx.stroke(),0===this.labelAngle?a.x=a.x+this.tickLength+5:(a.y=0>this.labelAngle?a.y:a.y-(b.textBlock.height-b.textBlock.fontSize/
2-5)*Math.cos(Math.PI/180*this.labelAngle),a.x=0<this.labelAngle?a.x+(b.textBlock.height-b.textBlock.fontSize/2-5)*Math.sin(Math.PI/180*this.labelAngle)+this.tickLength:a.x+this.tickLength+5));else b.textBlock.angle=-90,"bottom"===this._position?(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.height-3,b.textBlock.measureText(),a.x-b.textBlock.height>this.chart.plotArea.x1?y(k.startValue)?a.x-=b.textBlock.height-b.textBlock.fontSize/
2:a.x-=b.textBlock.height/2-b.textBlock.fontSize/2+3:(b.textBlock.angle=90,y(k.startValue)?a.x+=b.textBlock.height-b.textBlock.fontSize/2:a.x+=b.textBlock.height/2-b.textBlock.fontSize/2+3),a.y=-90===b.textBlock.angle?"near"===b.stripLine.labelAlign?this.chart.plotArea.y2-3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1+b.textBlock.width)/2:this.chart.plotArea.y1+b.textBlock.width+3:"near"===b.stripLine.labelAlign?this.chart.plotArea.y2-b.textBlock.width-3:"center"===
b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1-b.textBlock.width)/2:this.chart.plotArea.y1+3):"top"===this._position?(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.height-3,b.textBlock.measureText(),a.x-b.textBlock.height>this.chart.plotArea.x1?y(k.startValue)?a.x-=b.textBlock.height-b.textBlock.fontSize/2:a.x-=b.textBlock.height/2-b.textBlock.fontSize/2+3:(b.textBlock.angle=90,y(k.startValue)?a.x+=
b.textBlock.height-b.textBlock.fontSize/2:a.x+=b.textBlock.height/2-b.textBlock.fontSize/2+3),a.y=-90===b.textBlock.angle?"near"===b.stripLine.labelAlign?this.chart.plotArea.y1+b.textBlock.width+3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1+b.textBlock.width)/2:this.chart.plotArea.y2-3:"near"===b.stripLine.labelAlign?this.chart.plotArea.y1+3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.y2+this.chart.plotArea.y1-b.textBlock.width)/2:this.chart.plotArea.y2-
b.textBlock.width-3):"left"===this._position?(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.width-3,b.textBlock.angle=0,b.textBlock.measureText(),a.y-b.textBlock.height>this.chart.plotArea.y1?y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/2:a.y-=b.textBlock.height/2-b.textBlock.fontSize+3:a.y-b.textBlock.height<this.chart.plotArea.y2?a.y+=b.textBlock.fontSize/2+3:y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/
2:a.y-=b.textBlock.height/2-b.textBlock.fontSize+3,a.x="near"===b.stripLine.labelAlign?this.chart.plotArea.x1+3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.x2+this.chart.plotArea.x1)/2-b.textBlock.width/2:this.chart.plotArea.x2-b.textBlock.width-3):"right"===this._position&&(b.textBlock.maxWidth=this.options.stripLines[c].labelMaxWidth?this.options.stripLines[c].labelMaxWidth:this.chart.plotArea.width-3,b.textBlock.angle=0,b.textBlock.measureText(),a.y-+b.textBlock.height>this.chart.plotArea.y1?
y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/2:a.y-=b.textBlock.height/2-b.textBlock.fontSize/2-3:a.y-b.textBlock.height<this.chart.plotArea.y2?a.y+=b.textBlock.fontSize/2+3:y(k.startValue)?a.y-=b.textBlock.height-b.textBlock.fontSize/2:a.y-=b.textBlock.height/2-b.textBlock.fontSize/2+3,a.x="near"===b.stripLine.labelAlign?this.chart.plotArea.x2-b.textBlock.width-3:"center"===b.stripLine.labelAlign?(this.chart.plotArea.x2+this.chart.plotArea.x1)/2-b.textBlock.width/2:this.chart.plotArea.x1+
3);b.textBlock.x=a.x;b.textBlock.y=a.y;m.push(b)}if(!h){h=!1;this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.ctx.clip();for(c=0;c<l.length;c++)k=l[c],k.showOnTop?g||(g=!0,this.chart.addEventListener("dataAnimationIterationEnd",function(){this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.ctx.clip();
for(e=0;e<l.length;e++)k=l[e],k.showOnTop&&k.render();this.ctx.restore()},k)):k.render();for(c=0;c<m.length;c++)b=m[c],b.stripLine.showOnTop?h||(h=!0,this.chart.addEventListener("dataAnimationIterationEnd",function(){for(e=0;e<m.length;e++)b=m[e],"inside"===b.stripLine.labelPlacement&&b.stripLine.showOnTop&&(f.ctx.save(),f.ctx.beginPath(),f.ctx.rect(f.chart.plotArea.x1,f.chart.plotArea.y1,f.chart.plotArea.width,f.chart.plotArea.height),f.ctx.clip(),b.textBlock.render(!0),f.ctx.restore())},b.textBlock)):
"inside"===b.stripLine.labelPlacement&&b.textBlock.render(!0);this.ctx.restore();h=!0}if(h)for(h=!1,c=0;c<m.length;c++)b=m[c],b.stripLine.showOnTop?h||(h=!0,this.chart.addEventListener("dataAnimationIterationEnd",function(){for(e=0;e<m.length;e++)b=m[e],"outside"===b.stripLine.labelPlacement&&b.stripLine.showOnTop&&b.textBlock.render(!0)},b.textBlock)):"outside"===b.stripLine.labelPlacement&&b.textBlock.render(!0)}};C.prototype.renderBreaksBackground=function(){this.chart._breaksCanvas&&(this.scaleBreaks&&
0<this.scaleBreaks._appliedBreaks.length&&this.maskCanvas)&&(this.chart._breaksCanvasCtx.save(),this.chart._breaksCanvasCtx.beginPath(),this.chart._breaksCanvasCtx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height),this.chart._breaksCanvasCtx.clip(),this.chart._breaksCanvasCtx.drawImage(this.maskCanvas,0,0,this.chart.width,this.chart.height),this.chart._breaksCanvasCtx.restore())};C.prototype.createMask=function(){if(this.scaleBreaks&&0<this.scaleBreaks._appliedBreaks.length){var a=
this.scaleBreaks._appliedBreaks;v?(this.maskCanvas=ta(this.chart.width,this.chart.height),this.maskCtx=this.maskCanvas.getContext("2d")):(this.maskCanvas=this.chart.plotArea.canvas,this.maskCtx=this.chart.plotArea.ctx);this.maskCtx.save();this.maskCtx.beginPath();this.maskCtx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.maskCtx.clip();for(var f=0;f<a.length;f++)a[f].endValue<this.viewportMinimum||(a[f].startValue>this.viewportMaximum||
isNaN(this.range))||a[f].render(this.maskCtx);this.maskCtx.restore()}};C.prototype.renderCrosshair=function(a,f){this.crosshair.render(a,f)};C.prototype.renderGrid=function(){if(this.gridThickness&&0<this.gridThickness){var a=this.chart.ctx;a.save();var f,b=this.chart.plotArea;a.lineWidth=this.gridThickness;a.strokeStyle=this.gridColor;a.setLineDash&&a.setLineDash(F(this.gridDashType,this.gridThickness));if("bottom"===this._position||"top"===this._position)for(c=0;c<this._labels.length;c++)this._labels[c].position<
this.viewportMinimum||(this._labels[c].position>this.viewportMaximum||this._labels[c].breaksLabelType)||(a.beginPath(),f=this.getPixelCoordinatesOnAxis(this._labels[c].position),f=1===a.lineWidth%2?(f.x<<0)+0.5:f.x<<0,a.moveTo(f,b.y1<<0),a.lineTo(f,b.y2<<0),a.stroke());else if("left"===this._position||"right"===this._position)for(var c=0;c<this._labels.length;c++)this._labels[c].position<this.viewportMinimum||(this._labels[c].position>this.viewportMaximum||this._labels[c].breaksLabelType)||(a.beginPath(),
f=this.getPixelCoordinatesOnAxis(this._labels[c].position),f=1===a.lineWidth%2?(f.y<<0)+0.5:f.y<<0,a.moveTo(b.x1<<0,f),a.lineTo(b.x2<<0,f),a.stroke());a.restore()}};C.prototype.renderAxisLine=function(){var a=this.chart.ctx,f=v?this.chart._preRenderCtx:a,b=Math.ceil(this.tickThickness/(this.reversed?-2:2)),c=Math.ceil(this.tickThickness/(this.reversed?2:-2)),e,g;f.save();if("bottom"===this._position||"top"===this._position){if(this.lineThickness){this.reversed?(e=this.lineCoordinates.x2,g=this.lineCoordinates.x1):
(e=this.lineCoordinates.x1,g=this.lineCoordinates.x2);f.lineWidth=this.lineThickness;f.strokeStyle=this.lineColor?this.lineColor:"black";f.setLineDash&&f.setLineDash(F(this.lineDashType,this.lineThickness));var h=1===this.lineThickness%2?(this.lineCoordinates.y1<<0)+0.5:this.lineCoordinates.y1<<0;f.beginPath();if(this.scaleBreaks&&!y(this.scaleBreaks.firstBreakIndex))if(y(this.scaleBreaks.lastBreakIndex))e=this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex].endPixel+c;else for(var l=
this.scaleBreaks.firstBreakIndex;l<=this.scaleBreaks.lastBreakIndex;l++)f.moveTo(e,h),f.lineTo(this.scaleBreaks._appliedBreaks[l].startPixel+b,h),e=this.scaleBreaks._appliedBreaks[l].endPixel+c;e&&(f.moveTo(e,h),f.lineTo(g,h));f.stroke()}}else if(("left"===this._position||"right"===this._position)&&this.lineThickness){this.reversed?(e=this.lineCoordinates.y1,g=this.lineCoordinates.y2):(e=this.lineCoordinates.y2,g=this.lineCoordinates.y1);f.lineWidth=this.lineThickness;f.strokeStyle=this.lineColor;
f.setLineDash&&f.setLineDash(F(this.lineDashType,this.lineThickness));h=1===this.lineThickness%2?(this.lineCoordinates.x1<<0)+0.5:this.lineCoordinates.x1<<0;f.beginPath();if(this.scaleBreaks&&!y(this.scaleBreaks.firstBreakIndex))if(y(this.scaleBreaks.lastBreakIndex))e=this.scaleBreaks._appliedBreaks[this.scaleBreaks.firstBreakIndex].endPixel+b;else for(l=this.scaleBreaks.firstBreakIndex;l<=this.scaleBreaks.lastBreakIndex;l++)f.moveTo(h,e),f.lineTo(h,this.scaleBreaks._appliedBreaks[l].startPixel+c),
e=this.scaleBreaks._appliedBreaks[l].endPixel+b;e&&(f.moveTo(h,e),f.lineTo(h,g));f.stroke()}v&&(a.drawImage(this.chart._preRenderCanvas,0,0,this.chart.width,this.chart.height),this.chart._breaksCanvasCtx&&this.chart._breaksCanvasCtx.drawImage(this.chart._preRenderCanvas,0,0,this.chart.width,this.chart.height),f.clearRect(0,0,this.chart.width,this.chart.height));f.restore()};C.prototype.getPixelCoordinatesOnAxis=function(a){var f={};if("bottom"===this._position||"top"===this._position)f.x=this.convertValueToPixel(a),
f.y=this.lineCoordinates.y1;if("left"===this._position||"right"===this._position)f.y=this.convertValueToPixel(a),f.x=this.lineCoordinates.x2;return f};C.prototype.convertPixelToValue=function(a){if("undefined"===typeof a)return null;var f=0,b=0,c,f=!0,e=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[],b="number"===typeof a?a:"left"===this._position||"right"===this._position?a.y:a.x;if(this.logarithmic){a=c=Math.pow(this.logarithmBase,(b-this.conversionParameters.reference)/this.conversionParameters.pixelPerUnit);
if(b<=this.conversionParameters.reference===("left"===this._position||"right"===this._position)!==this.reversed)for(b=0;b<e.length;b++){if(!(e[b].endValue<this.conversionParameters.minimum))if(f)if(e[b].startValue<this.conversionParameters.minimum){if(1<e[b].size&&this.conversionParameters.minimum*Math.pow(e[b].endValue/e[b].startValue,Math.log(c)/Math.log(e[b].size))<e[b].endValue){a=Math.pow(e[b].endValue/e[b].startValue,Math.log(c)/Math.log(e[b].size));break}else a*=e[b].endValue/this.conversionParameters.minimum/
Math.pow(e[b].size,Math.log(e[b].endValue/this.conversionParameters.minimum)/Math.log(e[b].endValue/e[b].startValue)),c/=Math.pow(e[b].size,Math.log(e[b].endValue/this.conversionParameters.minimum)/Math.log(e[b].endValue/e[b].startValue));f=!1}else if(c>e[b].startValue/this.conversionParameters.minimum){c/=e[b].startValue/this.conversionParameters.minimum;if(c<e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1===e[b].size?1:Math.log(c)/Math.log(e[b].size))/c;break}else a*=e[b].endValue/e[b].startValue/
e[b].size;c/=e[b].size;f=!1}else break;else if(c>e[b].startValue/e[b-1].endValue){c/=e[b].startValue/e[b-1].endValue;if(c<e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1===e[b].size?1:Math.log(c)/Math.log(e[b].size))/c;break}else a*=e[b].endValue/e[b].startValue/e[b].size;c/=e[b].size}else break}else for(b=e.length-1;0<=b;b--)if(!(e[b].startValue>this.conversionParameters.minimum))if(f)if(e[b].endValue>this.conversionParameters.minimum){if(1<e[b].size&&this.conversionParameters.minimum*Math.pow(e[b].endValue/
e[b].startValue,Math.log(c)/Math.log(e[b].size))>e[b].startValue){a=Math.pow(e[b].endValue/e[b].startValue,Math.log(c)/Math.log(e[b].size));break}else a*=e[b].startValue/this.conversionParameters.minimum*Math.pow(e[b].size,Math.log(e[b].startValue/this.conversionParameters.minimum)/Math.log(e[b].endValue/e[b].startValue))*c,c*=Math.pow(e[b].size,Math.log(this.conversionParameters.minimum/e[b].startValue)/Math.log(e[b].endValue/e[b].startValue));f=!1}else if(c<e[b].endValue/this.conversionParameters.minimum){c/=
e[b].endValue/this.conversionParameters.minimum;if(c>1/e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1>=e[b].size?1:Math.log(c)/Math.log(e[b].size))*c;break}else a/=e[b].endValue/e[b].startValue/e[b].size;c*=e[b].size;f=!1}else break;else if(c<e[b].endValue/e[b+1].startValue){c/=e[b].endValue/e[b+1].startValue;if(c>1/e[b].size){a*=Math.pow(e[b].endValue/e[b].startValue,1>=e[b].size?1:Math.log(c)/Math.log(e[b].size))*c;break}else a/=e[b].endValue/e[b].startValue/e[b].size;c*=e[b].size}else break;
f=a*this.viewportMinimum}else{a=c=(b-this.conversionParameters.reference)/this.conversionParameters.pixelPerUnit;if(b<=this.conversionParameters.reference===("left"===this._position||"right"===this._position)!==this.reversed)for(b=0;b<e.length;b++){if(!(e[b].endValue<this.conversionParameters.minimum))if(f)if(e[b].startValue<this.conversionParameters.minimum){if(e[b].size&&this.conversionParameters.minimum+c*(e[b].endValue-e[b].startValue)/e[b].size<e[b].endValue){a=0>=e[b].size?0:c*(e[b].endValue-
e[b].startValue)/e[b].size;break}else a+=e[b].endValue-this.conversionParameters.minimum-e[b].size*(e[b].endValue-this.conversionParameters.minimum)/(e[b].endValue-e[b].startValue),c-=e[b].size*(e[b].endValue-this.conversionParameters.minimum)/(e[b].endValue-e[b].startValue);f=!1}else if(c>e[b].startValue-this.conversionParameters.minimum){c-=e[b].startValue-this.conversionParameters.minimum;if(c<e[b].size){a+=(e[b].endValue-e[b].startValue)*(0===e[b].size?1:c/e[b].size)-c;break}else a+=e[b].endValue-
e[b].startValue-e[b].size;c-=e[b].size;f=!1}else break;else if(c>e[b].startValue-e[b-1].endValue){c-=e[b].startValue-e[b-1].endValue;if(c<e[b].size){a+=(e[b].endValue-e[b].startValue)*(0===e[b].size?1:c/e[b].size)-c;break}else a+=e[b].endValue-e[b].startValue-e[b].size;c-=e[b].size}else break}else for(b=e.length-1;0<=b;b--)if(!(e[b].startValue>this.conversionParameters.minimum))if(f)if(e[b].endValue>this.conversionParameters.minimum)if(e[b].size&&this.conversionParameters.minimum+c*(e[b].endValue-
e[b].startValue)/e[b].size>e[b].startValue){a=0>=e[b].size?0:c*(e[b].endValue-e[b].startValue)/e[b].size;break}else a+=e[b].startValue-this.conversionParameters.minimum+e[b].size*(this.conversionParameters.minimum-e[b].startValue)/(e[b].endValue-e[b].startValue),c+=e[b].size*(this.conversionParameters.minimum-e[b].startValue)/(e[b].endValue-e[b].startValue),f=!1;else if(c<e[b].endValue-this.conversionParameters.minimum){c-=e[b].endValue-this.conversionParameters.minimum;if(c>-1*e[b].size){a+=(e[b].endValue-
e[b].startValue)*(0===e[b].size?1:c/e[b].size)+c;break}else a-=e[b].endValue-e[b].startValue-e[b].size;c+=e[b].size;f=!1}else break;else if(c<e[b].endValue-e[b+1].startValue){c-=e[b].endValue-e[b+1].startValue;if(c>-1*e[b].size){a+=(e[b].endValue-e[b].startValue)*(0===e[b].size?1:c/e[b].size)+c;break}else a-=e[b].endValue-e[b].startValue-e[b].size;c+=e[b].size}else break;f=this.conversionParameters.minimum+a}return f};C.prototype.convertValueToPixel=function(a){a=this.getApparentDifference(this.conversionParameters.minimum,
a,a);return this.logarithmic?this.conversionParameters.reference+this.conversionParameters.pixelPerUnit*Math.log(a/this.conversionParameters.minimum)/this.conversionParameters.lnLogarithmBase+0.5<<0:"axisX"===this.type?this.conversionParameters.reference+this.conversionParameters.pixelPerUnit*(a-this.conversionParameters.minimum)+0.5<<0:this.conversionParameters.reference+this.conversionParameters.pixelPerUnit*(a-this.conversionParameters.minimum)+0.5};C.prototype.getApparentDifference=function(a,
f,b,c){var e=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[];if(this.logarithmic){b=y(b)?f/a:b;for(var g=0;g<e.length&&!(f<e[g].startValue);g++)a>e[g].endValue||(a<=e[g].startValue&&f>=e[g].endValue?b=b/e[g].endValue*e[g].startValue*e[g].size:a>=e[g].startValue&&f>=e[g].endValue?b=b/e[g].endValue*a*Math.pow(e[g].size,Math.log(e[g].endValue/a)/Math.log(e[g].endValue/e[g].startValue)):a<=e[g].startValue&&f<=e[g].endValue?b=b/f*e[g].startValue*Math.pow(e[g].size,Math.log(f/e[g].startValue)/Math.log(e[g].endValue/
e[g].startValue)):!c&&(a>e[g].startValue&&f<e[g].endValue)&&(b=a*Math.pow(e[g].size,Math.log(f/a)/Math.log(e[g].endValue/e[g].startValue))))}else for(b=y(b)?Math.abs(f-a):b,g=0;g<e.length&&!(f<e[g].startValue);g++)a>e[g].endValue||(a<=e[g].startValue&&f>=e[g].endValue?b=b-e[g].endValue+e[g].startValue+e[g].size:a>e[g].startValue&&f>=e[g].endValue?b=b-e[g].endValue+a+e[g].size*(e[g].endValue-a)/(e[g].endValue-e[g].startValue):a<=e[g].startValue&&f<e[g].endValue?b=b-f+e[g].startValue+e[g].size*(f-e[g].startValue)/
(e[g].endValue-e[g].startValue):!c&&(a>e[g].startValue&&f<e[g].endValue)&&(b=a+e[g].size*(f-a)/(e[g].endValue-e[g].startValue)));return b};C.prototype.setViewPortRange=function(a,f){this.sessionVariables.newViewportMinimum=this.viewportMinimum=Math.min(a,f);this.sessionVariables.newViewportMaximum=this.viewportMaximum=Math.max(a,f)};C.prototype.getXValueAt=function(a){if(!a)return null;var f=null;"left"===this._position?f=this.convertPixelToValue(a.y):"bottom"===this._position&&(f=this.convertPixelToValue(a.x));
return f};C.prototype.calculateValueToPixelConversionParameters=function(a){a=this.scaleBreaks?this.scaleBreaks._appliedBreaks:[];var f={pixelPerUnit:null,minimum:null,reference:null},b=this.lineCoordinates.width,c=this.lineCoordinates.height,b="bottom"===this._position||"top"===this._position?b:c,c=Math.abs(this.range);if(this.logarithmic)for(var e=0;e<a.length&&!(this.viewportMaximum<a[e].startValue);e++)this.viewportMinimum>a[e].endValue||(this.viewportMinimum>=a[e].startValue&&this.viewportMaximum<=
a[e].endValue?b=0:this.viewportMinimum<=a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c/a[e].endValue*a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100):b-Math.min(a[e].spacing,0.1*b)):this.viewportMinimum>a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c/a[e].endValue*this.viewportMinimum,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*Math.log(a[e].endValue/this.viewportMinimum)/Math.log(a[e].endValue/a[e].startValue)):
b-Math.min(a[e].spacing,0.1*b)*Math.log(a[e].endValue/this.viewportMinimum)/Math.log(a[e].endValue/a[e].startValue)):this.viewportMinimum<=a[e].startValue&&this.viewportMaximum<a[e].endValue&&(c=c/this.viewportMaximum*a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*Math.log(this.viewportMaximum/a[e].startValue)/Math.log(a[e].endValue/a[e].startValue)):b-Math.min(a[e].spacing,0.1*b)*Math.log(this.viewportMaximum/a[e].startValue)/Math.log(a[e].endValue/a[e].startValue)));
else for(e=0;e<a.length&&!(this.viewportMaximum<a[e].startValue);e++)this.viewportMinimum>a[e].endValue||(this.viewportMinimum>=a[e].startValue&&this.viewportMaximum<=a[e].endValue?b=0:this.viewportMinimum<=a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c-a[e].endValue+a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100):b-Math.min(a[e].spacing,0.1*b)):this.viewportMinimum>a[e].startValue&&this.viewportMaximum>=a[e].endValue?(c=c-a[e].endValue+this.viewportMinimum,
b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*(a[e].endValue-this.viewportMinimum)/(a[e].endValue-a[e].startValue)):b-Math.min(a[e].spacing,0.1*b)*(a[e].endValue-this.viewportMinimum)/(a[e].endValue-a[e].startValue)):this.viewportMinimum<=a[e].startValue&&this.viewportMaximum<a[e].endValue&&(c=c-this.viewportMaximum+a[e].startValue,b=0<a[e].spacing.toString().indexOf("%")?b*(1-parseFloat(a[e].spacing)/100*(this.viewportMaximum-a[e].startValue)/(a[e].endValue-a[e].startValue)):
b-Math.min(a[e].spacing,0.1*b)*(this.viewportMaximum-a[e].startValue)/(a[e].endValue-a[e].startValue)));f.minimum=this.viewportMinimum;f.maximum=this.viewportMaximum;f.range=c;if("bottom"===this._position||"top"===this._position)this.logarithmic?(f.lnLogarithmBase=Math.log(this.logarithmBase),f.pixelPerUnit=(this.reversed?-1:1)*b*f.lnLogarithmBase/Math.log(Math.abs(c))):f.pixelPerUnit=(this.reversed?-1:1)*b/Math.abs(c),f.reference=this.reversed?this.lineCoordinates.x2:this.lineCoordinates.x1;if("left"===
this._position||"right"===this._position)this.logarithmic?(f.lnLogarithmBase=Math.log(this.logarithmBase),f.pixelPerUnit=(this.reversed?1:-1)*b*f.lnLogarithmBase/Math.log(Math.abs(c))):f.pixelPerUnit=(this.reversed?1:-1)*b/Math.abs(c),f.reference=this.reversed?this.lineCoordinates.y1:this.lineCoordinates.y2;this.conversionParameters=f};C.prototype.calculateAxisParameters=function(){if(this.logarithmic)this.calculateLogarithmicAxisParameters();else{var a=this.chart.layoutManager.getFreeSpace(),f=!1,
b=!1;"bottom"===this._position||"top"===this._position?(this.maxWidth=a.width,this.maxHeight=a.height):(this.maxWidth=a.height,this.maxHeight=a.width);var a="axisX"===this.type?"xySwapped"===this.chart.plotInfo.axisPlacement?62:70:"xySwapped"===this.chart.plotInfo.axisPlacement?50:40,c=4;"axisX"===this.type&&(c=600>this.maxWidth?8:6);var a=Math.max(c,Math.floor(this.maxWidth/a)),e,g,h,c=0;!y(this.options.viewportMinimum)&&(!y(this.options.viewportMaximum)&&this.options.viewportMinimum>=this.options.viewportMaximum)&&
(this.viewportMinimum=this.viewportMaximum=null);if(y(this.options.viewportMinimum)&&!y(this.sessionVariables.newViewportMinimum)&&!isNaN(this.sessionVariables.newViewportMinimum))this.viewportMinimum=this.sessionVariables.newViewportMinimum;else if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum=this.minimum;if(y(this.options.viewportMaximum)&&!y(this.sessionVariables.newViewportMaximum)&&!isNaN(this.sessionVariables.newViewportMaximum))this.viewportMaximum=this.sessionVariables.newViewportMaximum;
else if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum=this.maximum;if(this.scaleBreaks)for(c=0;c<this.scaleBreaks._appliedBreaks.length;c++)if((!y(this.sessionVariables.newViewportMinimum)&&this.sessionVariables.newViewportMinimum>=this.scaleBreaks._appliedBreaks[c].startValue||!y(this.options.minimum)&&this.options.minimum>=this.scaleBreaks._appliedBreaks[c].startValue||!y(this.options.viewportMinimum)&&this.viewportMinimum>=this.scaleBreaks._appliedBreaks[c].startValue)&&
(!y(this.sessionVariables.newViewportMaximum)&&this.sessionVariables.newViewportMaximum<=this.scaleBreaks._appliedBreaks[c].endValue||!y(this.options.maximum)&&this.options.maximum<=this.scaleBreaks._appliedBreaks[c].endValue||!y(this.options.viewportMaximum)&&this.viewportMaximum<=this.scaleBreaks._appliedBreaks[c].endValue)){this.scaleBreaks._appliedBreaks.splice(c,1);break}if("axisX"===this.type){if(this.dataSeries&&0<this.dataSeries.length)for(e=0;e<this.dataSeries.length;e++)"dateTime"===this.dataSeries[e].xValueType&&
(b=!0);e=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin;g=null!==this.viewportMaximum?this.viewportMaximum:this.dataInfo.viewPortMax;0===g-e&&(c="undefined"===typeof this.options.interval?0.4:this.options.interval,g+=c,e-=c);Infinity!==this.dataInfo.minDiff?h=this.dataInfo.minDiff:1<g-e?h=0.5*Math.abs(g-e):(h=1,b&&(f=!0))}else"axisY"===this.type&&(e=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin,g=null!==this.viewportMaximum?this.viewportMaximum:
this.dataInfo.viewPortMax,isFinite(e)||isFinite(g)?isFinite(e)?isFinite(g)||(g=e):e=g:(g="undefined"===typeof this.options.interval?-Infinity:this.options.interval,e="undefined"!==typeof this.options.interval||isFinite(this.dataInfo.minDiff)?0:Infinity),0===e&&0===g?(g+=9,e=0):0===g-e?(c=Math.min(Math.abs(0.01*Math.abs(g)),5),g+=c,e-=c):e>g?(c=Math.min(0.01*Math.abs(this.getApparentDifference(g,e,null,!0)),5),0<=g?e=g-c:g=isFinite(e)?e+c:0):(c=Math.min(0.01*Math.abs(this.getApparentDifference(e,g,
null,!0)),0.05),0!==g&&(g+=c),0!==e&&(e-=c)),h=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:1<g-e?0.5*Math.abs(g-e):1,this.includeZero&&(null===this.viewportMinimum||isNaN(this.viewportMinimum))&&0<e&&(e=0),this.includeZero&&(null===this.viewportMaximum||isNaN(this.viewportMaximum))&&0>g&&(g=0));c=this.getApparentDifference(isNaN(this.viewportMinimum)||null===this.viewportMinimum?e:this.viewportMinimum,isNaN(this.viewportMaximum)||null===this.viewportMaximum?g:this.viewportMaximum,null,
!0);if("axisX"===this.type&&b){this.intervalType||(c/1<=a?(this.interval=1,this.intervalType="millisecond"):c/2<=a?(this.interval=2,this.intervalType="millisecond"):c/5<=a?(this.interval=5,this.intervalType="millisecond"):c/10<=a?(this.interval=10,this.intervalType="millisecond"):c/20<=a?(this.interval=20,this.intervalType="millisecond"):c/50<=a?(this.interval=50,this.intervalType="millisecond"):c/100<=a?(this.interval=100,this.intervalType="millisecond"):c/200<=a?(this.interval=200,this.intervalType=
"millisecond"):c/250<=a?(this.interval=250,this.intervalType="millisecond"):c/300<=a?(this.interval=300,this.intervalType="millisecond"):c/400<=a?(this.interval=400,this.intervalType="millisecond"):c/500<=a?(this.interval=500,this.intervalType="millisecond"):c/(1*U.secondDuration)<=a?(this.interval=1,this.intervalType="second"):c/(2*U.secondDuration)<=a?(this.interval=2,this.intervalType="second"):c/(5*U.secondDuration)<=a?(this.interval=5,this.intervalType="second"):c/(10*U.secondDuration)<=a?(this.interval=
10,this.intervalType="second"):c/(15*U.secondDuration)<=a?(this.interval=15,this.intervalType="second"):c/(20*U.secondDuration)<=a?(this.interval=20,this.intervalType="second"):c/(30*U.secondDuration)<=a?(this.interval=30,this.intervalType="second"):c/(1*U.minuteDuration)<=a?(this.interval=1,this.intervalType="minute"):c/(2*U.minuteDuration)<=a?(this.interval=2,this.intervalType="minute"):c/(5*U.minuteDuration)<=a?(this.interval=5,this.intervalType="minute"):c/(10*U.minuteDuration)<=a?(this.interval=
10,this.intervalType="minute"):c/(15*U.minuteDuration)<=a?(this.interval=15,this.intervalType="minute"):c/(20*U.minuteDuration)<=a?(this.interval=20,this.intervalType="minute"):c/(30*U.minuteDuration)<=a?(this.interval=30,this.intervalType="minute"):c/(1*U.hourDuration)<=a?(this.interval=1,this.intervalType="hour"):c/(2*U.hourDuration)<=a?(this.interval=2,this.intervalType="hour"):c/(3*U.hourDuration)<=a?(this.interval=3,this.intervalType="hour"):c/(6*U.hourDuration)<=a?(this.interval=6,this.intervalType=
"hour"):c/(1*U.dayDuration)<=a?(this.interval=1,this.intervalType="day"):c/(2*U.dayDuration)<=a?(this.interval=2,this.intervalType="day"):c/(4*U.dayDuration)<=a?(this.interval=4,this.intervalType="day"):c/(1*U.weekDuration)<=a?(this.interval=1,this.intervalType="week"):c/(2*U.weekDuration)<=a?(this.interval=2,this.intervalType="week"):c/(3*U.weekDuration)<=a?(this.interval=3,this.intervalType="week"):c/(1*U.monthDuration)<=a?(this.interval=1,this.intervalType="month"):c/(2*U.monthDuration)<=a?(this.interval=
2,this.intervalType="month"):c/(3*U.monthDuration)<=a?(this.interval=3,this.intervalType="month"):c/(6*U.monthDuration)<=a?(this.interval=6,this.intervalType="month"):(this.interval=c/(1*U.yearDuration)<=a?1:c/(2*U.yearDuration)<=a?2:c/(4*U.yearDuration)<=a?4:Math.floor(C.getNiceNumber(c/(a-1),!0)/U.yearDuration),this.intervalType="year"));if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum=e-h/2;if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum=
g+h/2;f?this.autoValueFormatString="MMM DD YYYY HH:mm":"year"===this.intervalType?this.autoValueFormatString="YYYY":"month"===this.intervalType?this.autoValueFormatString="MMM YYYY":"week"===this.intervalType?this.autoValueFormatString="MMM DD YYYY":"day"===this.intervalType?this.autoValueFormatString="MMM DD YYYY":"hour"===this.intervalType?this.autoValueFormatString="hh:mm TT":"minute"===this.intervalType?this.autoValueFormatString="hh:mm TT":"second"===this.intervalType?this.autoValueFormatString=
"hh:mm:ss TT":"millisecond"===this.intervalType&&(this.autoValueFormatString="fff'ms'");this.valueFormatString||(this.valueFormatString=this.autoValueFormatString)}else{this.intervalType="number";c=C.getNiceNumber(c,!1);this.interval=this.options&&0<this.options.interval?this.options.interval:C.getNiceNumber(c/(a-1),!0);if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum="axisX"===this.type?e-h/2:Math.floor(e/this.interval)*this.interval;if(null===this.viewportMaximum||
isNaN(this.viewportMaximum))this.viewportMaximum="axisX"===this.type?g+h/2:Math.ceil(g/this.interval)*this.interval;0===this.viewportMaximum&&0===this.viewportMinimum&&(0===this.options.viewportMinimum?this.viewportMaximum+=10:0===this.options.viewportMaximum&&(this.viewportMinimum-=10),this.options&&"undefined"===typeof this.options.interval&&(this.interval=C.getNiceNumber((this.viewportMaximum-this.viewportMinimum)/(a-1),!0)))}if(null===this.minimum||null===this.maximum)if("axisX"===this.type?(e=
null!==this.minimum?this.minimum:this.dataInfo.min,g=null!==this.maximum?this.maximum:this.dataInfo.max,0===g-e&&(c="undefined"===typeof this.options.interval?0.4:this.options.interval,g+=c,e-=c),h=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:1<g-e?0.5*Math.abs(g-e):1):"axisY"===this.type&&(e=null!==this.minimum?this.minimum:this.dataInfo.min,g=null!==this.maximum?this.maximum:this.dataInfo.max,isFinite(e)||isFinite(g)?0===e&&0===g?(g+=9,e=0):0===g-e?(c=Math.min(Math.abs(0.01*Math.abs(g)),
5),g+=c,e-=c):e>g?(c=Math.min(0.01*Math.abs(this.getApparentDifference(g,e,null,!0)),5),0<=g?e=g-c:g=isFinite(e)?e+c:0):(c=Math.min(0.01*Math.abs(this.getApparentDifference(e,g,null,!0)),0.05),0!==g&&(g+=c),0!==e&&(e-=c)):(g="undefined"===typeof this.options.interval?-Infinity:this.options.interval,e="undefined"!==typeof this.options.interval||isFinite(this.dataInfo.minDiff)?0:Infinity),h=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:1<g-e?0.5*Math.abs(g-e):1,this.includeZero&&(null===this.minimum||
isNaN(this.minimum))&&0<e&&(e=0),this.includeZero&&(null===this.maximum||isNaN(this.maximum))&&0>g&&(g=0)),Math.abs(this.getApparentDifference(e,g,null,!0)),"axisX"===this.type&&b){this.valueType="dateTime";if(null===this.minimum||isNaN(this.minimum))this.minimum=e-h/2;if(null===this.maximum||isNaN(this.maximum))this.maximum=g+h/2}else this.intervalType=this.valueType="number",null===this.minimum&&(this.minimum="axisX"===this.type?e-h/2:Math.floor(e/this.interval)*this.interval,this.minimum=Math.min(this.minimum,
null===this.sessionVariables.viewportMinimum||isNaN(this.sessionVariables.viewportMinimum)?Infinity:this.sessionVariables.viewportMinimum)),null===this.maximum&&(this.maximum="axisX"===this.type?g+h/2:Math.ceil(g/this.interval)*this.interval,this.maximum=Math.max(this.maximum,null===this.sessionVariables.viewportMaximum||isNaN(this.sessionVariables.viewportMaximum)?-Infinity:this.sessionVariables.viewportMaximum)),0===this.maximum&&0===this.minimum&&(0===this.options.minimum?this.maximum+=10:0===
this.options.maximum&&(this.minimum-=10));y(this.sessionVariables.newViewportMinimum)&&(this.viewportMinimum=Math.max(this.viewportMinimum,this.minimum));y(this.sessionVariables.newViewportMaximum)&&(this.viewportMaximum=Math.min(this.viewportMaximum,this.maximum));this.range=this.viewportMaximum-this.viewportMinimum;this.intervalStartPosition="axisX"===this.type&&b?this.getLabelStartPoint(new Date(this.viewportMinimum),this.intervalType,this.interval):Math.floor((this.viewportMinimum+0.2*this.interval)/
this.interval)*this.interval;this.valueFormatString||(this.valueFormatString=C.generateValueFormatString(this.range,2))}};C.prototype.calculateLogarithmicAxisParameters=function(){var a=this.chart.layoutManager.getFreeSpace(),f=Math.log(this.logarithmBase),b;"bottom"===this._position||"top"===this._position?(this.maxWidth=a.width,this.maxHeight=a.height):(this.maxWidth=a.height,this.maxHeight=a.width);var a="axisX"===this.type?500>this.maxWidth?7:Math.max(7,Math.floor(this.maxWidth/100)):Math.max(Math.floor(this.maxWidth/
50),3),c,e,g,h;h=1;if(null===this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum=this.minimum;if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum=this.maximum;if(this.scaleBreaks)for(h=0;h<this.scaleBreaks._appliedBreaks.length;h++)if((!y(this.sessionVariables.newViewportMinimum)&&this.sessionVariables.newViewportMinimum>=this.scaleBreaks._appliedBreaks[h].startValue||!y(this.options.minimum)&&this.options.minimum>=this.scaleBreaks._appliedBreaks[h].startValue||
!y(this.options.viewportMinimum)&&this.viewportMinimum>=this.scaleBreaks._appliedBreaks[h].startValue)&&(!y(this.sessionVariables.newViewportMaximum)&&this.sessionVariables.newViewportMaximum<=this.scaleBreaks._appliedBreaks[h].endValue||!y(this.options.maximum)&&this.options.maximum<=this.scaleBreaks._appliedBreaks[h].endValue||!y(this.options.viewportMaximum)&&this.viewportMaximum<=this.scaleBreaks._appliedBreaks[h].endValue)){this.scaleBreaks._appliedBreaks.splice(h,1);break}"axisX"===this.type?
(c=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin,e=null!==this.viewportMaximum?this.viewportMaximum:this.dataInfo.viewPortMax,1===e/c&&(h=Math.pow(this.logarithmBase,"undefined"===typeof this.options.interval?0.4:this.options.interval),e*=h,c/=h),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase):"axisY"===this.type&&(c=null!==this.viewportMinimum?this.viewportMinimum:this.dataInfo.viewPortMin,
e=null!==this.viewportMaximum?this.viewportMaximum:this.dataInfo.viewPortMax,0>=c&&!isFinite(e)?(e="undefined"===typeof this.options.interval?0:this.options.interval,c=1):0>=c?c=e:isFinite(e)||(e=c),1===c&&1===e?(e*=this.logarithmBase-1/this.logarithmBase,c=1):1===e/c?(h=Math.min(e*Math.pow(this.logarithmBase,0.01),Math.pow(this.logarithmBase,5)),e*=h,c/=h):c>e?(h=Math.min(c/e*Math.pow(this.logarithmBase,0.01),Math.pow(this.logarithmBase,5)),1<=e?c=e/h:e=c*h):(h=Math.min(e/c*Math.pow(this.logarithmBase,
0.01),Math.pow(this.logarithmBase,0.04)),1!==e&&(e*=h),1!==c&&(c/=h)),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase,this.includeZero&&(null===this.viewportMinimum||isNaN(this.viewportMinimum))&&1<c&&(c=1),this.includeZero&&(null===this.viewportMaximum||isNaN(this.viewportMaximum))&&1>e&&(e=1));h=(isNaN(this.viewportMaximum)||null===this.viewportMaximum?e:this.viewportMaximum)/(isNaN(this.viewportMinimum)||null===
this.viewportMinimum?c:this.viewportMinimum);linearRange=(isNaN(this.viewportMaximum)||null===this.viewportMaximum?e:this.viewportMaximum)-(isNaN(this.viewportMinimum)||null===this.viewportMinimum?c:this.viewportMinimum);this.intervalType="number";h=Math.pow(this.logarithmBase,C.getNiceNumber(Math.abs(Math.log(h)/f),!1));this.options&&0<this.options.interval?this.interval=this.options.interval:(this.interval=C.getNiceExponent(Math.log(h)/f/(a-1),!0),b=C.getNiceNumber(linearRange/(a-1),!0));if(null===
this.viewportMinimum||isNaN(this.viewportMinimum))this.viewportMinimum="axisX"===this.type?c/Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.floor(Math.log(c)/f/this.interval));if(null===this.viewportMaximum||isNaN(this.viewportMaximum))this.viewportMaximum="axisX"===this.type?e*Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.ceil(Math.log(e)/f/this.interval));1===this.viewportMaximum&&1===this.viewportMinimum&&(1===this.options.viewportMinimum?this.viewportMaximum*=this.logarithmBase-
1/this.logarithmBase:1===this.options.viewportMaximum&&(this.viewportMinimum/=this.logarithmBase-1/this.logarithmBase),this.options&&"undefined"===typeof this.options.interval&&(this.interval=C.getNiceExponent(Math.ceil(Math.log(h)/f)/(a-1)),b=C.getNiceNumber((this.viewportMaximum-this.viewportMinimum)/(a-1),!0)));if(null===this.minimum||null===this.maximum)"axisX"===this.type?(c=null!==this.minimum?this.minimum:this.dataInfo.min,e=null!==this.maximum?this.maximum:this.dataInfo.max,1===e/c&&(h=Math.pow(this.logarithmBase,
"undefined"===typeof this.options.interval?0.4:this.options.interval),e*=h,c/=h),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase):"axisY"===this.type&&(c=null!==this.minimum?this.minimum:this.dataInfo.min,e=null!==this.maximum?this.maximum:this.dataInfo.max,isFinite(c)||isFinite(e)?1===c&&1===e?(e*=this.logarithmBase,c/=this.logarithmBase):1===e/c?(h=Math.pow(this.logarithmBase,this.interval),e*=h,c/=h):c>e?(h=
Math.min(0.01*(c/e),5),1<=e?c=e/h:e=c*h):(h=Math.min(e/c*Math.pow(this.logarithmBase,0.01),Math.pow(this.logarithmBase,0.04)),1!==e&&(e*=h),1!==c&&(c/=h)):(e="undefined"===typeof this.options.interval?0:this.options.interval,c=1),g=Infinity!==this.dataInfo.minDiff?this.dataInfo.minDiff:e/c>this.logarithmBase?e/c*Math.pow(this.logarithmBase,0.5):this.logarithmBase,this.includeZero&&(null===this.minimum||isNaN(this.minimum))&&1<c&&(c=1),this.includeZero&&(null===this.maximum||isNaN(this.maximum))&&
1>e&&(e=1)),this.intervalType="number",null===this.minimum&&(this.minimum="axisX"===this.type?c/Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.floor(Math.log(c)/f/this.interval)),this.minimum=Math.min(this.minimum,null===this.sessionVariables.viewportMinimum||isNaN(this.sessionVariables.viewportMinimum)?"undefined"===typeof this.sessionVariables.newViewportMinimum?Infinity:this.sessionVariables.newViewportMinimum:this.sessionVariables.viewportMinimum)),null===this.maximum&&(this.maximum=
"axisX"===this.type?e*Math.sqrt(g):Math.pow(this.logarithmBase,this.interval*Math.ceil(Math.log(e)/f/this.interval)),this.maximum=Math.max(this.maximum,null===this.sessionVariables.viewportMaximum||isNaN(this.sessionVariables.viewportMaximum)?"undefined"===typeof this.sessionVariables.newViewportMaximum?0:this.sessionVariables.newViewportMaximum:this.sessionVariables.viewportMaximum)),1===this.maximum&&1===this.minimum&&(1===this.options.minimum?this.maximum*=this.logarithmBase-1/this.logarithmBase:
1===this.options.maximum&&(this.minimum/=this.logarithmBase-1/this.logarithmBase));this.viewportMinimum=Math.max(this.viewportMinimum,this.minimum);this.viewportMaximum=Math.min(this.viewportMaximum,this.maximum);this.viewportMinimum>this.viewportMaximum&&(!this.options.viewportMinimum&&!this.options.minimum||this.options.viewportMaximum||this.options.maximum?this.options.viewportMinimum||this.options.minimum||!this.options.viewportMaximum&&!this.options.maximum||(this.viewportMinimum=this.minimum=
(this.options.viewportMaximum||this.options.maximum)/Math.pow(this.logarithmBase,2*Math.ceil(this.interval))):this.viewportMaximum=this.maximum=this.options.viewportMinimum||this.options.minimum);c=Math.pow(this.logarithmBase,Math.floor(Math.log(this.viewportMinimum)/(f*this.interval)+0.2)*this.interval);this.range=this.viewportMaximum/this.viewportMinimum;this.noTicks=a;if(!this.options.interval&&this.range<Math.pow(this.logarithmBase,8>this.viewportMaximum||3>a?2:3)){for(f=Math.floor(this.viewportMinimum/
b+0.5)*b;f<this.viewportMinimum;)f+=b;this.equidistantInterval=!1;this.intervalStartPosition=f;this.interval=b}else this.options.interval||(b=Math.ceil(this.interval),this.range>this.interval&&(this.interval=b,c=Math.pow(this.logarithmBase,Math.floor(Math.log(this.viewportMinimum)/(f*this.interval)+0.2)*this.interval))),this.equidistantInterval=!0,this.intervalStartPosition=c;if(!this.valueFormatString&&(this.valueFormatString="#,##0.##",1>this.viewportMinimum)){f=Math.floor(Math.abs(Math.log(this.viewportMinimum)/
Math.LN10))+2;if(isNaN(f)||!isFinite(f))f=2;if(2<f)for(h=0;h<f-2;h++)this.valueFormatString+="#"}};C.generateValueFormatString=function(a,f){var b="#,##0.",c=f;1>a&&(c+=Math.floor(Math.abs(Math.log(a)/Math.LN10)),isNaN(c)||!isFinite(c))&&(c=f);for(var e=0;e<c;e++)b+="#";return b};C.getNiceExponent=function(a,f){var b=Math.floor(Math.log(a)/Math.LN10),c=a/Math.pow(10,b),c=0>b?1>=c?1:5>=c?5:10:Math.max(Math.floor(c),1);return-20>b?Number(c*Math.pow(10,b)):Number((c*Math.pow(10,b)).toFixed(20))};C.getNiceNumber=
function(a,f){var b=Math.floor(Math.log(a)/Math.LN10),c=a/Math.pow(10,b),c=f?1.5>c?1:3>c?2:7>c?5:10:1>=c?1:2>=c?2:5>=c?5:10;return-20>b?Number(c*Math.pow(10,b)):Number((c*Math.pow(10,b)).toFixed(20))};C.prototype.getLabelStartPoint=function(){var a=U[this.intervalType+"Duration"]*this.interval,a=new Date(Math.floor(this.viewportMinimum/a)*a);if("millisecond"!==this.intervalType)if("second"===this.intervalType)0<a.getMilliseconds()&&(a.setSeconds(a.getSeconds()+1),a.setMilliseconds(0));else if("minute"===
this.intervalType){if(0<a.getSeconds()||0<a.getMilliseconds())a.setMinutes(a.getMinutes()+1),a.setSeconds(0),a.setMilliseconds(0)}else if("hour"===this.intervalType){if(0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setHours(a.getHours()+1),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else if("day"===this.intervalType){if(0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setDate(a.getDate()+1),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else if("week"===
this.intervalType){if(0<a.getDay()||0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setDate(a.getDate()+(7-a.getDay())),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else if("month"===this.intervalType){if(1<a.getDate()||0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())a.setMonth(a.getMonth()+1),a.setDate(1),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0)}else"year"===this.intervalType&&(0<a.getMonth()||1<
a.getDate()||0<a.getHours()||0<a.getMinutes()||0<a.getSeconds()||0<a.getMilliseconds())&&(a.setFullYear(a.getFullYear()+1),a.setMonth(0),a.setDate(1),a.setHours(0),a.setMinutes(0),a.setSeconds(0),a.setMilliseconds(0));return a};na(I,Y);na(ba,Y);ba.prototype.createUserOptions=function(a){if("undefined"!==typeof a||this.options._isPlaceholder){var f=0;this.parent.options._isPlaceholder&&this.parent.createUserOptions();this.options._isPlaceholder||(Ca(this.parent[this.optionsName]),f=this.parent.options[this.optionsName].indexOf(this.options));
this.options="undefined"===typeof a?{}:a;this.parent.options[this.optionsName][f]=this.options}};ba.prototype.render=function(a){if(0!==this.spacing||0!==this.options.lineThickness&&("undefined"!==typeof this.options.lineThickness||0!==this.parent.lineThickness)){var f=this.ctx,b=this.ctx.globalAlpha;this.ctx=a||this.ctx;this.ctx.save();this.ctx.beginPath();this.ctx.rect(this.chart.plotArea.x1,this.chart.plotArea.y1,this.chart.plotArea.width,this.chart.plotArea.height);this.ctx.clip();var c=this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.startValue),
e=this.scaleBreaks.parent.getPixelCoordinatesOnAxis(this.endValue);this.ctx.strokeStyle=this.lineColor;this.ctx.fillStyle=this.color;this.ctx.beginPath();this.ctx.globalAlpha=1;R(this.id);var g,h,l,m,k,r;a=Math.max(this.spacing,3);var p=Math.max(0,this.lineThickness);this.ctx.lineWidth=p;this.ctx.setLineDash&&this.ctx.setLineDash(F(this.lineDashType,p));if("bottom"===this.scaleBreaks.parent._position||"top"===this.scaleBreaks.parent._position)if(c=1===p%2?(c.x<<0)+0.5:c.x<<0,h=1===p%2?(e.x<<0)+0.5:
e.x<<0,"top"===this.scaleBreaks.parent._position?(e=this.chart.plotArea.y1,l=this.chart.plotArea.y2+p/2+0.5<<0):(e=this.chart.plotArea.y2,l=this.chart.plotArea.y1-p/2+0.5<<0,a*=-1),this.bounds={x1:c-p/2,y1:e,x2:h+p/2,y2:l},this.ctx.moveTo(c,e),"straight"===this.type||"top"===this.scaleBreaks.parent._position&&0>=a||"bottom"===this.scaleBreaks.parent._position&&0<=a)this.ctx.lineTo(c,l),this.ctx.lineTo(h,l),this.ctx.lineTo(h,e);else if("wavy"===this.type){m=c;k=e;g=0.5;r=(l-k)/a/3;for(var n=0;n<r;n++)this.ctx.bezierCurveTo(m+
g*a,k+a,m+g*a,k+2*a,m,k+3*a),k+=3*a,g*=-1;this.ctx.bezierCurveTo(m+g*a,k+a,m+g*a,k+2*a,m,k+3*a);m=h;g*=-1;this.ctx.lineTo(m,k);for(n=0;n<r;n++)this.ctx.bezierCurveTo(m+g*a,k-a,m+g*a,k-2*a,m,k-3*a),k-=3*a,g*=-1}else{if("zigzag"===this.type){g=-1;k=e+a;m=c+a;r=(l-k)/a/2;for(n=0;n<r;n++)this.ctx.lineTo(m,k),m+=2*g*a,k+=2*a,g*=-1;this.ctx.lineTo(m,k);m+=h-c;for(n=0;n<r+1;n++)this.ctx.lineTo(m,k),m+=2*g*a,k-=2*a,g*=-1;this.ctx.lineTo(m+g*a,k+a)}}else if("left"===this.scaleBreaks.parent._position||"right"===
this.scaleBreaks.parent._position)if(e=1===p%2?(e.y<<0)+0.5:e.y<<0,l=1===p%2?(c.y<<0)+0.5:c.y<<0,"left"===this.scaleBreaks.parent._position?(c=this.chart.plotArea.x1,h=this.chart.plotArea.x2+p/2+0.5<<0):(c=this.chart.plotArea.x2,h=this.chart.plotArea.x1-p/2+0.5<<0,a*=-1),this.bounds={x1:c,y1:e-p/2,x2:h,y2:l+p/2},this.ctx.moveTo(c,e),"straight"===this.type||"left"===this.scaleBreaks.parent._position&&0>=a||"right"===this.scaleBreaks.parent._position&&0<=a)this.ctx.lineTo(h,e),this.ctx.lineTo(h,l),
this.ctx.lineTo(c,l);else if("wavy"===this.type){m=c;k=e;g=0.5;r=(h-m)/a/3;for(n=0;n<r;n++)this.ctx.bezierCurveTo(m+a,k+g*a,m+2*a,k+g*a,m+3*a,k),m+=3*a,g*=-1;this.ctx.bezierCurveTo(m+a,k+g*a,m+2*a,k+g*a,m+3*a,k);k=l;g*=-1;this.ctx.lineTo(m,k);for(n=0;n<r;n++)this.ctx.bezierCurveTo(m-a,k+g*a,m-2*a,k+g*a,m-3*a,k),m-=3*a,g*=-1}else if("zigzag"===this.type){g=1;k=e-a;m=c+a;r=(h-m)/a/2;for(n=0;n<r;n++)this.ctx.lineTo(m,k),k+=2*g*a,m+=2*a,g*=-1;this.ctx.lineTo(m,k);k+=l-e;for(n=0;n<r+1;n++)this.ctx.lineTo(m,
k),k+=2*g*a,m-=2*a,g*=-1;this.ctx.lineTo(m+a,k+g*a)}0<p&&this.ctx.stroke();this.ctx.closePath();this.ctx.globalAlpha=this.fillOpacity;this.ctx.globalCompositeOperation="destination-over";this.ctx.fill();this.ctx.restore();this.ctx.globalAlpha=b;this.ctx=f}};na(fa,Y);fa.prototype.createUserOptions=function(a){if("undefined"!==typeof a||this.options._isPlaceholder){var f=0;this.parent.options._isPlaceholder&&this.parent.createUserOptions();this.options._isPlaceholder||(Ca(this.parent.stripLines),f=
this.parent.options.stripLines.indexOf(this.options));this.options="undefined"===typeof a?{}:a;this.parent.options.stripLines[f]=this.options}};fa.prototype.render=function(){this.ctx.save();var a=this.parent.getPixelCoordinatesOnAxis(this.value),f=Math.abs("pixel"===this._thicknessType?this.thickness:this.parent.conversionParameters.pixelPerUnit*this.thickness);if(0<f){var b=null===this.opacity?1:this.opacity;this.ctx.strokeStyle=this.color;this.ctx.beginPath();var c=this.ctx.globalAlpha;this.ctx.globalAlpha=
b;R(this.id);var e,g,h,l;this.ctx.lineWidth=f;this.ctx.setLineDash&&this.ctx.setLineDash(F(this.lineDashType,f));if("bottom"===this.parent._position||"top"===this.parent._position)e=g=1===this.ctx.lineWidth%2?(a.x<<0)+0.5:a.x<<0,h=this.chart.plotArea.y1,l=this.chart.plotArea.y2,this.bounds={x1:e-f/2,y1:h,x2:g+f/2,y2:l};else if("left"===this.parent._position||"right"===this.parent._position)h=l=1===this.ctx.lineWidth%2?(a.y<<0)+0.5:a.y<<0,e=this.chart.plotArea.x1,g=this.chart.plotArea.x2,this.bounds=
{x1:e,y1:h-f/2,x2:g,y2:l+f/2};this.ctx.moveTo(e,h);this.ctx.lineTo(g,l);this.ctx.stroke();this.ctx.globalAlpha=c}this.ctx.restore()};na(ha,Y);ha.prototype.render=function(a,f){var b,c,e,g,h=null,l=h=null,m="";if(!this.valueFormatString)if("dateTime"===this.parent.valueType)this.valueFormatString=this.parent.valueFormatString;else{var k=0,k="xySwapped"===this.chart.plotInfo.axisPlacement?50<this.parent.range?0:500<this.chart.width&&25>this.parent.range?2:Math.floor(Math.abs(Math.log(this.parent.range)/
Math.LN10))+(5>this.parent.range?2:10>this.parent.range?1:0):50<this.parent.range?0:Math.floor(Math.abs(Math.log(this.parent.range)/Math.LN10))+(5>this.parent.range?2:10>this.parent.range?1:0);this.valueFormatString=C.generateValueFormatString(this.parent.range,k)}var l=null===this.opacity?1:this.opacity,k=Math.abs("pixel"===this._thicknessType?this.thickness:this.parent.conversionParameters.pixelPerUnit*this.thickness),r=this.chart.overlaidCanvasCtx,p=r.globalAlpha;r.globalAlpha=l;r.beginPath();
r.strokeStyle=this.color;r.lineWidth=k;r.save();this.labelFontSize=y(this.options.labelFontSize)?this.parent.labelFontSize:this.labelFontSize;if("left"===this.parent._position||"right"===this.parent._position)this.labelMaxWidth=y(this.options.labelMaxWidth)?this.parent.bounds.x2-this.parent.bounds.x1:this.labelMaxWidth,this.labelMaxHeight=y(this.options.labelWrap)||this.labelWrap?3*this.chart.height:2*this.labelFontSize;else if("top"===this.parent._position||"bottom"===this.parent._position)this.labelMaxWidth=
y(this.options.labelMaxWidth)?3*this.chart.width:this.labelMaxWidth,this.labelMaxHeight=y(this.options.labelWrap)||this.labelWrap?this.parent.bounds.height:2*this.labelFontSize;0<k&&r.setLineDash&&r.setLineDash(F(this.lineDashType,k));l=new ka(r,{x:0,y:0,padding:{top:2,right:3,bottom:2,left:4},backgroundColor:this.labelBackgroundColor,borderColor:this.labelBorderColor,borderThickness:this.labelBorderThickness,cornerRadius:this.labelCornerRadius,maxWidth:this.labelMaxWidth,maxHeight:this.labelMaxHeight,
angle:this.labelAngle,text:m,horizontalAlign:"left",fontSize:this.labelFontSize,fontFamily:this.labelFontFamily,fontWeight:this.labelFontWeight,fontColor:this.labelFontColor,fontStyle:this.labelFontStyle,textBaseline:"middle"});if(this.snapToDataPoint){var n=0,h=[];if("xySwapped"===this.chart.plotInfo.axisPlacement){var d=null;if("bottom"===this.parent._position||"top"===this.parent._position)n=this.parent.dataSeries[0].axisX.convertPixelToValue({y:f});else if("left"===this.parent._position||"right"===
this.parent._position)n=this.parent.convertPixelToValue({y:f});for(var q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(d.dataSeries=this.parent.dataSeries[q],null!==d.dataPoint.y&&h.push(d));d=null;if(0===h.length)return;h.sort(function(a,b){return a.distance-b.distance});d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y));q=0;if("rangeBar"===h[0].dataSeries.type||"error"===h[0].dataSeries.type)for(var d=Math.abs(a-this.parent.convertValueToPixel(h[q].dataPoint.y[0])),
s=0,n=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,q=n);else if("stackedBar"===h[0].dataSeries.type)for(var d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y)),v=s=0,n=q=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-
this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,s=Math.abs(a-this.parent.convertValueToPixel(v)),s<d&&(d=s,q=n);else if("stackedBar100"===h[0].dataSeries.type)for(var d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y)),u=v=s=0,n=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?
h[n].dataPoint.x.getTime():h[n].dataPoint.x,u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(a-this.parent.convertValueToPixel(u)),s<d&&(d=s,q=n);else for(d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=q=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(a-this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,
q=n);m=h[q];if("bottom"===this.parent._position||"top"===this.parent._position){b=0;if("rangeBar"===this.parent.dataSeries[q].type||"error"===this.parent.dataSeries[q].type){d=Math.abs(a-this.parent.convertValueToPixel(m.dataPoint.y[0]));for(n=s=0;n<m.dataPoint.y.length;n++)s=Math.abs(a-this.parent.convertValueToPixel(m.dataPoint.y[n])),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y[b])<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y[b])<<0;l.text=this.labelFormatter?
this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y[b]}):y(this.options.label)?V(m.dataPoint.y[b],this.valueFormatString,this.chart._cultureInfo):this.label}else if("stackedBar"===this.parent.dataSeries[q].type){d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y));v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,s=Math.abs(a-this.parent.convertValueToPixel(v)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(v)<<0)+0.5:
this.parent.convertValueToPixel(v)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,this.chart._cultureInfo):this.label}else if("stackedBar100"===this.parent.dataSeries[q].type){d=Math.abs(a-this.parent.convertValueToPixel(h[0].dataPoint.y));u=v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?h[n].dataPoint.x.getTime():h[n].dataPoint.x,
u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(a-this.parent.convertValueToPixel(u)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(u)<<0)+0.5:this.parent.convertValueToPixel(u)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:u}):y(this.options.label)?V(u,this.valueFormatString,this.chart._cultureInfo):this.label}else h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y)<<
0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y)<<0,l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,this.chart._cultureInfo):this.label;b=c=h;e=this.chart.plotArea.y1;g=this.chart.plotArea.y2;this.bounds={x1:b-k/2,y1:e,x2:c+k/2,y2:g};l.x=b-l.measureText().width/2;l.x+l.width>this.chart.bounds.x2?l.x=this.chart.bounds.x2-l.width:l.x<this.chart.bounds.x1&&
(l.x=this.chart.bounds.x1);l.y=this.parent.lineCoordinates.y2+l.fontSize/2+2}else if("left"===this.parent._position||"right"===this.parent._position){e=g=h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.x)<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.x)<<0;b=this.chart.plotArea.x1;c=this.chart.plotArea.x2;this.bounds={x1:b,y1:e-k/2,x2:c,y2:g+k/2};u=!1;if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=
!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=this.parent.convertPixelToValue({y:f}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?Aa(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?V(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label);l.y=g+l.fontSize/2-l.measureText().height/2+2;l.y-l.fontSize/2<this.chart.bounds.y1?
l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2);"left"===this.parent._position?l.x=this.parent.lineCoordinates.x2-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2)}}else if("bottom"===this.parent._position||"top"===this.parent._position){n=this.parent.convertPixelToValue({x:a});for(q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,
!0))&&0<=d.index&&(d.dataSeries=this.parent.dataSeries[q],null!==d.dataPoint.y&&h.push(d));if(0===h.length)return;h.sort(function(a,b){return a.distance-b.distance});m=h[0];b=c=h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.x)<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.x)<<0;e=this.chart.plotArea.y1;g=this.chart.plotArea.y2;this.bounds={x1:b-k/2,y1:e,x2:c+k/2,y2:g};u=!1;if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=
!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=this.parent.convertPixelToValue({x:a}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?Aa(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.x}):y(this.options.label)?V(m.dataPoint.x,this.valueFormatString,this.chart._cultureInfo):this.label);l.x=b-l.measureText().width/2;l.x+l.width>this.chart.bounds.x2&&(l.x=
this.chart.bounds.x2-l.width);l.x<this.chart.bounds.x1&&(l.x=this.chart.bounds.x1);"bottom"===this.parent._position?l.y=this.parent.lineCoordinates.y2+l.fontSize/2+2:"top"===this.parent._position&&(l.y=this.parent.lineCoordinates.y1-l.height+l.fontSize/2+2)}else if("left"===this.parent._position||"right"===this.parent._position){!y(this.parent.dataSeries)&&0<this.parent.dataSeries.length&&(n=this.parent.dataSeries[0].axisX.convertPixelToValue({x:a}));for(q=0;q<this.parent.dataSeries.length;q++)(d=
this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(d.dataSeries=this.parent.dataSeries[q],null!==d.dataPoint.y&&h.push(d));if(0===h.length)return;h.sort(function(a,b){return a.distance-b.distance});q=0;if("rangeColumn"===h[0].dataSeries.type||"rangeArea"===h[0].dataSeries.type||"error"===h[0].dataSeries.type||"rangeSplineArea"===h[0].dataSeries.type||"candlestick"===h[0].dataSeries.type||"ohlc"===h[0].dataSeries.type||"boxAndWhisker"===h[0].dataSeries.type)for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y[0])),
n=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,q=n);else if("stackedColumn"===h[0].dataSeries.type||"stackedArea"===h[0].dataSeries.type)for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=v=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<
h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,s=Math.abs(f-this.parent.convertValueToPixel(v)),s<d&&(d=s,q=n);else if("stackedColumn100"===h[0].dataSeries.type||"stackedArea100"===h[0].dataSeries.type)for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=u=v=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),
s<d&&(d=s,q=n);else v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?h[n].dataPoint.x.getTime():h[n].dataPoint.x,u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(f-this.parent.convertValueToPixel(u)),s<d&&(d=s,q=n);else for(d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y)),n=s=0;n<h.length;n++)if(h[n].dataPoint.y&&h[n].dataPoint.y.length)for(m=0;m<h[n].dataPoint.y.length;m++)s=Math.abs(f-this.parent.convertValueToPixel(h[n].dataPoint.y[m])),s<d&&(d=s,q=n);else s=Math.abs(f-
this.parent.convertValueToPixel(h[n].dataPoint.y)),s<d&&(d=s,q=n);m=h[q];b=0;if("rangeColumn"===this.parent.dataSeries[q].type||"rangeArea"===this.parent.dataSeries[q].type||"error"===this.parent.dataSeries[q].type||"rangeSplineArea"===this.parent.dataSeries[q].type||"candlestick"===this.parent.dataSeries[q].type||"ohlc"===this.parent.dataSeries[q].type||"boxAndWhisker"===this.parent.dataSeries[q].type){d=Math.abs(f-this.parent.convertValueToPixel(m.dataPoint.y[0]));for(n=s=0;n<m.dataPoint.y.length;n++)s=
Math.abs(f-this.parent.convertValueToPixel(m.dataPoint.y[n])),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y[b])<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y[b])<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y[b]}):y(this.options.label)?V(m.dataPoint.y[b],this.valueFormatString,this.chart._cultureInfo):this.label}else if("stackedColumn"===this.parent.dataSeries[q].type||
"stackedArea"===this.parent.dataSeries[q].type){d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y));v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,s=Math.abs(f-this.parent.convertValueToPixel(v)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(v)<<0)+0.5:this.parent.convertValueToPixel(v)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,
this.chart._cultureInfo):this.label}else if("stackedColumn100"===this.parent.dataSeries[q].type||"stackedArea100"===this.parent.dataSeries[q].type){d=Math.abs(f-this.parent.convertValueToPixel(h[0].dataPoint.y));v=s=0;for(n=q;0<=n;n--)v+=h[n].dataPoint.y,u=h[n].dataPoint.x.getTime?h[n].dataPoint.x.getTime():h[n].dataPoint.x,u=100*(v/h[n].dataSeries.plotUnit.dataPointYSums[u]),s=Math.abs(f-this.parent.convertValueToPixel(u)),s<d&&(d=s,b=n);h=1===r.lineWidth%2?(this.parent.convertValueToPixel(u)<<0)+
0.5:this.parent.convertValueToPixel(u)<<0;l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:u}):y(this.options.label)?V(u,this.valueFormatString,this.chart._cultureInfo):this.label}else"waterfall"===this.parent.dataSeries[q].type?(h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataSeries.dataPointEOs[m.index].cumulativeSum)<<0)+0.5:this.parent.convertValueToPixel(m.dataSeries.dataPointEOs[m.index].cumulativeSum)<<0,l.text=
this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:m.dataSeries.dataPointEOs[m.index].cumulativeSum}):y(this.options.label)?V(m.dataSeries.dataPointEOs[m.index].cumulativeSum,this.valueFormatString,this.chart._cultureInfo):this.label):(h=1===r.lineWidth%2?(this.parent.convertValueToPixel(m.dataPoint.y)<<0)+0.5:this.parent.convertValueToPixel(m.dataPoint.y)<<0,l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,
crosshair:this.options,value:m.dataPoint.y}):y(this.options.label)?V(m.dataPoint.y,this.valueFormatString,this.chart._cultureInfo):this.label);e=g=h;b=this.chart.plotArea.x1;c=this.chart.plotArea.x2;this.bounds={x1:b,y1:e-k/2,x2:c,y2:g+k/2};l.y=g+l.fontSize/2-l.measureText().height/2+2;l.y-l.fontSize/2<this.chart.bounds.y1?l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2);"left"===this.parent._position?
l.x=this.parent.lineCoordinates.x2-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2)}h=null;("bottom"===this.parent._position||"top"===this.parent._position)&&(b>=this.parent.convertValueToPixel(this.parent.viewportMinimum)&&c<=this.parent.convertValueToPixel(this.parent.viewportMaximum))&&(0<k&&(r.moveTo(b,e),r.lineTo(c,g),r.stroke()),r.restore(),!y(l.text)&&("number"===typeof l.text.valueOf()||0<l.text.length)&&l.render(!0));("left"===this.parent._position||
"right"===this.parent._position)&&(g>=this.parent.convertValueToPixel(this.parent.viewportMaximum)&&e<=this.parent.convertValueToPixel(this.parent.viewportMinimum))&&(0<k&&(r.moveTo(b,e),r.lineTo(c,g),r.stroke()),r.restore(),!y(l.text)&&("number"===typeof l.text.valueOf()||0<l.text.length)&&l.render(!0))}else{if("bottom"===this.parent._position||"top"===this.parent._position)b=c=h=1===r.lineWidth%2?(a<<0)+0.5:a<<0,e=this.chart.plotArea.y1,g=this.chart.plotArea.y2,this.bounds={x1:b-k/2,y1:e,x2:c+k/
2,y2:g};else if("left"===this.parent._position||"right"===this.parent._position)e=g=h=1===r.lineWidth%2?(f<<0)+0.5:f<<0,b=this.chart.plotArea.x1,c=this.chart.plotArea.x2,this.bounds={x1:b,y1:e-k/2,x2:c,y2:g+k/2};if("xySwapped"===this.chart.plotInfo.axisPlacement)if("left"===this.parent._position||"right"===this.parent._position){u=!1;if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=
this.parent.convertPixelToValue({y:f}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,
value:this.parent.convertPixelToValue(f)}):y(this.options.label)?Aa(this.parent.convertPixelToValue(f),this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(f)}):y(this.options.label)?V(this.parent.convertPixelToValue(f),this.valueFormatString,this.chart._cultureInfo):this.label);l.y=f+l.fontSize/2-l.measureText().height/
2+2;l.y-l.fontSize/2<this.chart.bounds.y1?l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2);"left"===this.parent._position?l.x=this.parent.lineCoordinates.x1-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2)}else{if("bottom"===this.parent._position||"top"===this.parent._position)l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?V(this.parent.convertPixelToValue(a),this.valueFormatString,this.chart._cultureInfo):this.label,l.x=b-l.measureText().width/2,l.x+l.width>this.chart.bounds.x2&&(l.x=this.chart.bounds.x2-l.width),l.x<this.chart.bounds.x1&&(l.x=this.chart.bounds.x1),"bottom"===this.parent._position&&(l.y=this.parent.lineCoordinates.y2+l.fontSize/2+2),"top"===this.parent._position&&(l.y=this.parent.lineCoordinates.y1-
l.height+l.fontSize/2+2)}else if("bottom"===this.parent._position||"top"===this.parent._position){u=!1;m="";if(this.parent.labels)for(h=Math.ceil(this.parent.interval),n=0;n<this.parent.viewportMaximum;n+=h)if(this.parent.labels[n])u=!0;else{u=!1;break}if(u){if("axisX"===this.parent.type)for(n=this.parent.convertPixelToValue({x:a}),d=null,q=0;q<this.parent.dataSeries.length;q++)(d=this.parent.dataSeries[q].getDataPointAtX(n,!0))&&0<=d.index&&(l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,
axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?d.dataPoint.label:this.label)}else"dateTime"===this.parent.valueType?l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(a)}):y(this.options.label)?Aa(this.parent.convertPixelToValue(a),this.valueFormatString,this.chart._cultureInfo):this.label:"number"===this.parent.valueType&&(l.text=this.labelFormatter?
this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:0<this.parent.dataSeries.length?this.parent.convertPixelToValue(a):""}):y(this.options.label)?V(this.parent.convertPixelToValue(a),this.valueFormatString,this.chart._cultureInfo):this.label);l.x=b-l.measureText().width/2;l.x+l.width>this.chart.bounds.x2&&(l.x=this.chart.bounds.x2-l.width);l.x<this.chart.bounds.x1&&(l.x=this.chart.bounds.x1);"bottom"===this.parent._position?l.y=this.parent.lineCoordinates.y2+
l.fontSize/2+2:"top"===this.parent._position&&(l.y=this.parent.lineCoordinates.y1-l.height+l.fontSize/2+2)}else if("left"===this.parent._position||"right"===this.parent._position)l.text=this.labelFormatter?this.labelFormatter({chart:this.chart,axis:this.parent.options,crosshair:this.options,value:this.parent.convertPixelToValue(f)}):y(this.options.label)?V(this.parent.convertPixelToValue(f),this.valueFormatString,this.chart._cultureInfo):this.label,l.y=f+l.fontSize/2-l.measureText().height/2+2,l.y-
l.fontSize/2<this.chart.bounds.y1?l.y=this.chart.bounds.y1+l.fontSize/2+2:l.y+l.measureText().height-l.fontSize/2>this.chart.bounds.y2&&(l.y=this.chart.bounds.y2-l.measureText().height+l.fontSize/2),"left"===this.parent._position?l.x=this.parent.lineCoordinates.x2-l.measureText().width:"right"===this.parent._position&&(l.x=this.parent.lineCoordinates.x2);0<k&&(r.moveTo(b,e),r.lineTo(c,g),r.stroke());r.restore();!y(l.text)&&("number"===typeof l.text.valueOf()||0<l.text.length)&&l.render(!0)}r.globalAlpha=
p};na(Z,Y);Z.prototype._initialize=function(){if(this.enabled){this.container=document.createElement("div");this.container.setAttribute("class","canvasjs-chart-tooltip");this.container.style.position="absolute";this.container.style.height="auto";this.container.style.boxShadow="1px 1px 2px 2px rgba(0,0,0,0.1)";this.container.style.zIndex="1000";this.container.style.pointerEvents="none";this.container.style.display="none";var a;a='<div style=" width: auto;height: auto;min-width: 50px;';a+="line-height: auto;";
a+="margin: 0px 0px 0px 0px;";a+="padding: 5px;";a+="font-family: Calibri, Arial, Georgia, serif;";a+="font-weight: normal;";a+="font-style: "+(v?"italic;":"normal;");a+="font-size: 14px;";a+="color: #000000;";a+="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);";a+="text-align: left;";a+="border: 2px solid gray;";a+=v?"background: rgba(255,255,255,.9);":"background: rgb(255,255,255);";a+="text-indent: 0px;";a+="white-space: nowrap;";a+="border-radius: 5px;";a+="-moz-user-select:none;";a+="-khtml-user-select: none;";
a+="-webkit-user-select: none;";a+="-ms-user-select: none;";a+="user-select: none;";v||(a+="filter: alpha(opacity = 90);",a+="filter: progid:DXImageTransform.Microsoft.Shadow(Strength=3, Direction=135, Color='#666666');");a+='} "> Sample Tooltip</div>';this.container.innerHTML=a;this.contentDiv=this.container.firstChild;this.container.style.borderRadius=this.contentDiv.style.borderRadius;this.chart._canvasJSContainer.appendChild(this.container)}};Z.prototype.mouseMoveHandler=function(a,f){this._lastUpdated&&
4>(new Date).getTime()-this._lastUpdated||(this._lastUpdated=(new Date).getTime(),this.chart.resetOverlayedCanvas(),this._updateToolTip(a,f))};Z.prototype._updateToolTip=function(a,f,b){b="undefined"===typeof b?!0:b;this.container||this._initialize();this.enabled||this.hide();if(!this.chart.disableToolTip){if("undefined"===typeof a||"undefined"===typeof f){if(isNaN(this._prevX)||isNaN(this._prevY))return;a=this._prevX;f=this._prevY}else this._prevX=a,this._prevY=f;var c=null,e=null,g=[],h=0;if(this.shared&&
this.enabled&&"none"!==this.chart.plotInfo.axisPlacement){if("xySwapped"===this.chart.plotInfo.axisPlacement){var l=[];if(this.chart.axisX)for(var m=0;m<this.chart.axisX.length;m++){for(var h=this.chart.axisX[m].convertPixelToValue({y:f}),k=null,c=0;c<this.chart.axisX[m].dataSeries.length;c++)(k=this.chart.axisX[m].dataSeries[c].getDataPointAtX(h,b))&&0<=k.index&&(k.dataSeries=this.chart.axisX[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k));k=null}if(this.chart.axisX2)for(m=0;m<this.chart.axisX2.length;m++){h=
this.chart.axisX2[m].convertPixelToValue({y:f});k=null;for(c=0;c<this.chart.axisX2[m].dataSeries.length;c++)(k=this.chart.axisX2[m].dataSeries[c].getDataPointAtX(h,b))&&0<=k.index&&(k.dataSeries=this.chart.axisX2[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k));k=null}}else{l=[];if(this.chart.axisX)for(m=0;m<this.chart.axisX.length;m++)for(h=this.chart.axisX[m].convertPixelToValue({x:a}),k=null,c=0;c<this.chart.axisX[m].dataSeries.length;c++)(k=this.chart.axisX[m].dataSeries[c].getDataPointAtX(h,
b))&&0<=k.index&&(k.dataSeries=this.chart.axisX[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k));if(this.chart.axisX2)for(m=0;m<this.chart.axisX2.length;m++)for(h=this.chart.axisX2[m].convertPixelToValue({x:a}),k=null,c=0;c<this.chart.axisX2[m].dataSeries.length;c++)(k=this.chart.axisX2[m].dataSeries[c].getDataPointAtX(h,b))&&0<=k.index&&(k.dataSeries=this.chart.axisX2[m].dataSeries[c],null!==k.dataPoint.y&&l.push(k))}if(0===l.length)return;l.sort(function(a,b){return a.distance-b.distance});b=l[0];
for(c=0;c<l.length;c++)l[c].dataPoint.x.valueOf()===b.dataPoint.x.valueOf()&&g.push(l[c]);l=null}else{if(k=this.chart.getDataPointAtXY(a,f,b))this.currentDataPointIndex=k.dataPointIndex,this.currentSeriesIndex=k.dataSeries.index;else if(v)if(k=Wa(a,f,this.chart._eventManager.ghostCtx),0<k&&"undefined"!==typeof this.chart._eventManager.objectMap[k]){k=this.chart._eventManager.objectMap[k];if("legendItem"===k.objectType)return;this.currentSeriesIndex=k.dataSeriesIndex;this.currentDataPointIndex=0<=
k.dataPointIndex?k.dataPointIndex:-1}else this.currentDataPointIndex=-1;else this.currentDataPointIndex=-1;if(0<=this.currentSeriesIndex){e=this.chart.data[this.currentSeriesIndex];k={};if(0<=this.currentDataPointIndex)c=e.dataPoints[this.currentDataPointIndex],k.dataSeries=e,k.dataPoint=c,k.index=this.currentDataPointIndex,k.distance=Math.abs(c.x-h),"waterfall"===e.type&&(k.cumulativeSumYStartValue=e.dataPointEOs[this.currentDataPointIndex].cumulativeSumYStartValue,k.cumulativeSum=e.dataPointEOs[this.currentDataPointIndex].cumulativeSum);
else{if(!this.enabled||"line"!==e.type&&"stepLine"!==e.type&&"spline"!==e.type&&"area"!==e.type&&"stepArea"!==e.type&&"splineArea"!==e.type&&"stackedArea"!==e.type&&"stackedArea100"!==e.type&&"rangeArea"!==e.type&&"rangeSplineArea"!==e.type&&"candlestick"!==e.type&&"ohlc"!==e.type&&"boxAndWhisker"!==e.type)return;h=e.axisX.convertPixelToValue({x:a});k=e.getDataPointAtX(h,b);k.dataSeries=e;this.currentDataPointIndex=k.index;c=k.dataPoint}if(!y(k.dataPoint.y))if(k.dataSeries.axisY)if(0<k.dataPoint.y.length){for(c=
b=0;c<k.dataPoint.y.length;c++)k.dataPoint.y[c]<k.dataSeries.axisY.viewportMinimum?b--:k.dataPoint.y[c]>k.dataSeries.axisY.viewportMaximum&&b++;b<k.dataPoint.y.length&&b>-k.dataPoint.y.length&&g.push(k)}else"column"===e.type||"bar"===e.type?0>k.dataPoint.y?0>k.dataSeries.axisY.viewportMinimum&&k.dataSeries.axisY.viewportMaximum>=k.dataPoint.y&&g.push(k):k.dataSeries.axisY.viewportMinimum<=k.dataPoint.y&&0<=k.dataSeries.axisY.viewportMaximum&&g.push(k):"bubble"===e.type?(b=this.chart._eventManager.objectMap[e.dataPointIds[k.index]].size/
2,k.dataPoint.y>=k.dataSeries.axisY.viewportMinimum-b&&k.dataPoint.y<=k.dataSeries.axisY.viewportMaximum+b&&g.push(k)):"waterfall"===e.type?(b=0,k.cumulativeSumYStartValue<k.dataSeries.axisY.viewportMinimum?b--:k.cumulativeSumYStartValue>k.dataSeries.axisY.viewportMaximum&&b++,k.cumulativeSum<k.dataSeries.axisY.viewportMinimum?b--:k.cumulativeSum>k.dataSeries.axisY.viewportMaximum&&b++,2>b&&-2<b&&g.push(k)):(0<=k.dataSeries.type.indexOf("100")||"stackedColumn"===e.type||"stackedBar"===e.type||k.dataPoint.y>=
k.dataSeries.axisY.viewportMinimum&&k.dataPoint.y<=k.dataSeries.axisY.viewportMaximum)&&g.push(k);else g.push(k)}}if(0<g.length&&(this.highlightObjects(g),this.enabled))if(b="",b=this.getToolTipInnerHTML({entries:g}),null!==b){this.contentDiv.innerHTML=b;b=!1;"none"===this.container.style.display&&(b=!0,this.container.style.display="block");try{this.contentDiv.style.background=this.backgroundColor?this.backgroundColor:v?"rgba(255,255,255,.9)":"rgb(255,255,255)",this.borderColor="waterfall"===g[0].dataSeries.type?
this.contentDiv.style.borderRightColor=this.contentDiv.style.borderLeftColor=this.contentDiv.style.borderColor=this.options.borderColor?this.options.borderColor:g[0].dataPoint.color?g[0].dataPoint.color:0<g[0].dataPoint.y?g[0].dataSeries.risingColor:g[0].dataSeries.fallingColor:"error"===g[0].dataSeries.type?this.contentDiv.style.borderRightColor=this.contentDiv.style.borderLeftColor=this.contentDiv.style.borderColor=this.options.borderColor?this.options.borderColor:g[0].dataSeries.color?g[0].dataSeries.color:
g[0].dataSeries._colorSet[e.index%g[0].dataSeries._colorSet.length]:this.contentDiv.style.borderRightColor=this.contentDiv.style.borderLeftColor=this.contentDiv.style.borderColor=this.options.borderColor?this.options.borderColor:g[0].dataPoint.color?g[0].dataPoint.color:g[0].dataSeries.color?g[0].dataSeries.color:g[0].dataSeries._colorSet[g[0].index%g[0].dataSeries._colorSet.length],this.contentDiv.style.borderWidth=this.borderThickness||0===this.borderThickness?this.borderThickness+"px":"2px",this.contentDiv.style.borderRadius=
this.cornerRadius||0===this.cornerRadius?this.cornerRadius+"px":"5px",this.container.style.borderRadius=this.contentDiv.style.borderRadius,this.contentDiv.style.fontSize=this.fontSize||0===this.fontSize?this.fontSize+"px":"14px",this.contentDiv.style.color=this.fontColor?this.fontColor:"#000000",this.contentDiv.style.fontFamily=this.fontFamily?this.fontFamily:"Calibri, Arial, Georgia, serif;",this.contentDiv.style.fontWeight=this.fontWeight?this.fontWeight:"normal",this.contentDiv.style.fontStyle=
this.fontStyle?this.fontStyle:v?"italic":"normal"}catch(q){}"pie"===g[0].dataSeries.type||"doughnut"===g[0].dataSeries.type||"funnel"===g[0].dataSeries.type||"pyramid"===g[0].dataSeries.type||"bar"===g[0].dataSeries.type||"rangeBar"===g[0].dataSeries.type||"stackedBar"===g[0].dataSeries.type||"stackedBar100"===g[0].dataSeries.type?a=a-10-this.container.clientWidth:(a=g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x)-this.container.clientWidth<<0,a-=10);0>a&&(a+=this.container.clientWidth+
20);a+this.container.clientWidth>Math.max(this.chart.container.clientWidth,this.chart.width)&&(a=Math.max(0,Math.max(this.chart.container.clientWidth,this.chart.width)-this.container.clientWidth));f=1!==g.length||this.shared||"line"!==g[0].dataSeries.type&&"stepLine"!==g[0].dataSeries.type&&"spline"!==g[0].dataSeries.type&&"area"!==g[0].dataSeries.type&&"stepArea"!==g[0].dataSeries.type&&"splineArea"!==g[0].dataSeries.type?"bar"===g[0].dataSeries.type||"rangeBar"===g[0].dataSeries.type||"stackedBar"===
g[0].dataSeries.type||"stackedBar100"===g[0].dataSeries.type?g[0].dataSeries.axisX.convertValueToPixel(g[0].dataPoint.x):f:g[0].dataSeries.axisY.convertValueToPixel(g[0].dataPoint.y);f=-f+10;0<f+this.container.clientHeight+5&&(f-=f+this.container.clientHeight+5-0);this.fixMozTransitionDelay(a,f);!this.animationEnabled||b?this.disableAnimation():(this.enableAnimation(),this.container.style.MozTransition=this.mozContainerTransition);this.container.style.left=a+"px";this.container.style.bottom=f+"px"}else this.hide(!1)}};
Z.prototype.highlightObjects=function(a){var f=this.chart.overlaidCanvasCtx;this.chart.resetOverlayedCanvas();f.clearRect(0,0,this.chart.width,this.chart.height);f.save();var b=this.chart.plotArea,c=0;f.beginPath();f.rect(b.x1,b.y1,b.x2-b.x1,b.y2-b.y1);f.clip();for(b=0;b<a.length;b++){var e=a[b];if((e=this.chart._eventManager.objectMap[e.dataSeries.dataPointIds[e.index]])&&e.objectType&&"dataPoint"===e.objectType){var c=this.chart.data[e.dataSeriesIndex],g=c.dataPoints[e.dataPointIndex],h=e.dataPointIndex;
!1===g.highlightEnabled||!0!==c.highlightEnabled&&!0!==g.highlightEnabled||("line"===c.type||"stepLine"===c.type||"spline"===c.type||"scatter"===c.type||"area"===c.type||"stepArea"===c.type||"splineArea"===c.type||"stackedArea"===c.type||"stackedArea100"===c.type||"rangeArea"===c.type||"rangeSplineArea"===c.type?(g=c.getMarkerProperties(h,e.x1,e.y1,this.chart.overlaidCanvasCtx),g.size=Math.max(1.5*g.size<<0,10),g.borderColor=g.borderColor||"#FFFFFF",g.borderThickness=g.borderThickness||Math.ceil(0.1*
g.size),$.drawMarkers([g]),"undefined"!==typeof e.y2&&(g=c.getMarkerProperties(h,e.x1,e.y2,this.chart.overlaidCanvasCtx),g.size=Math.max(1.5*g.size<<0,10),g.borderColor=g.borderColor||"#FFFFFF",g.borderThickness=g.borderThickness||Math.ceil(0.1*g.size),$.drawMarkers([g]))):"bubble"===c.type?(g=c.getMarkerProperties(h,e.x1,e.y1,this.chart.overlaidCanvasCtx),g.size=e.size,g.color="white",g.borderColor="white",f.globalAlpha=0.3,$.drawMarkers([g]),f.globalAlpha=1):"column"===c.type||"stackedColumn"===
c.type||"stackedColumn100"===c.type||"bar"===c.type||"rangeBar"===c.type||"stackedBar"===c.type||"stackedBar100"===c.type||"rangeColumn"===c.type||"waterfall"===c.type?X(f,e.x1,e.y1,e.x2,e.y2,"white",0,null,!1,!1,!1,!1,0.3):"pie"===c.type||"doughnut"===c.type?pa(f,e.center,e.radius,"white",c.type,e.startAngle,e.endAngle,0.3,e.percentInnerRadius):"funnel"===c.type||"pyramid"===c.type?qa(f,e.funnelSection,0.3,"white"):"candlestick"===c.type?(f.globalAlpha=1,f.strokeStyle=e.color,f.lineWidth=2*e.borderThickness,
c=0===f.lineWidth%2?0:0.5,f.beginPath(),f.moveTo(e.x3-c,Math.min(e.y2,e.y3)),f.lineTo(e.x3-c,Math.min(e.y1,e.y4)),f.stroke(),f.beginPath(),f.moveTo(e.x3-c,Math.max(e.y1,e.y4)),f.lineTo(e.x3-c,Math.max(e.y2,e.y3)),f.stroke(),X(f,e.x1,Math.min(e.y1,e.y4),e.x2,Math.max(e.y1,e.y4),"transparent",2*e.borderThickness,e.color,!1,!1,!1,!1),f.globalAlpha=1):"ohlc"===c.type?(f.globalAlpha=1,f.strokeStyle=e.color,f.lineWidth=2*e.borderThickness,c=0===f.lineWidth%2?0:0.5,f.beginPath(),f.moveTo(e.x3-c,e.y2),f.lineTo(e.x3-
c,e.y3),f.stroke(),f.beginPath(),f.moveTo(e.x3,e.y1),f.lineTo(e.x1,e.y1),f.stroke(),f.beginPath(),f.moveTo(e.x3,e.y4),f.lineTo(e.x2,e.y4),f.stroke(),f.globalAlpha=1):"boxAndWhisker"===c.type?(f.save(),f.globalAlpha=1,f.strokeStyle=e.stemColor,f.lineWidth=2*e.stemThickness,0<e.stemThickness&&(f.beginPath(),f.moveTo(e.x3,e.y2+e.borderThickness/2),f.lineTo(e.x3,e.y1+e.whiskerThickness/2),f.stroke(),f.beginPath(),f.moveTo(e.x3,e.y4-e.whiskerThickness/2),f.lineTo(e.x3,e.y3-e.borderThickness/2),f.stroke()),
f.beginPath(),X(f,e.x1-e.borderThickness/2,Math.max(e.y2+e.borderThickness/2,e.y3+e.borderThickness/2),e.x2+e.borderThickness/2,Math.min(e.y2-e.borderThickness/2,e.y3-e.borderThickness/2),"transparent",e.borderThickness,e.color,!1,!1,!1,!1),f.globalAlpha=1,f.strokeStyle=e.whiskerColor,f.lineWidth=2*e.whiskerThickness,0<e.whiskerThickness&&(f.beginPath(),f.moveTo(Math.floor(e.x3-e.whiskerLength/2),e.y4),f.lineTo(Math.ceil(e.x3+e.whiskerLength/2),e.y4),f.stroke(),f.beginPath(),f.moveTo(Math.floor(e.x3-
e.whiskerLength/2),e.y1),f.lineTo(Math.ceil(e.x3+e.whiskerLength/2),e.y1),f.stroke()),f.globalAlpha=1,f.strokeStyle=e.lineColor,f.lineWidth=2*e.lineThickness,0<e.lineThickness&&(f.beginPath(),f.moveTo(e.x1,e.y5),f.lineTo(e.x2,e.y5),f.stroke()),f.restore(),f.globalAlpha=1):"error"===c.type&&z(f,e.x1,e.y1,e.x2,e.y2,"white",e.whiskerProperties,e.stemProperties,e.isXYSwapped,0.3))}}f.restore();f.globalAlpha=1;f.beginPath()};Z.prototype.getToolTipInnerHTML=function(a){a=a.entries;for(var f=null,b=null,
c=null,e=0,g="",h=!0,l=0;l<a.length;l++)if(a[l].dataSeries.toolTipContent||a[l].dataPoint.toolTipContent){h=!1;break}if(h&&(this.content&&"function"===typeof this.content||this.contentFormatter))a={chart:this.chart,toolTip:this.options,entries:a},f=this.contentFormatter?this.contentFormatter(a):this.content(a);else if(this.shared&&"none"!==this.chart.plotInfo.axisPlacement){for(var m=null,k="",l=0;l<a.length;l++)b=a[l].dataSeries,c=a[l].dataPoint,e=a[l].index,g="",0===l&&(h&&!this.content)&&(this.chart.axisX&&
0<this.chart.axisX.length?k+="undefined"!==typeof this.chart.axisX[0].labels[c.x]?this.chart.axisX[0].labels[c.x]:"{x}":this.chart.axisX2&&0<this.chart.axisX2.length&&(k+="undefined"!==typeof this.chart.axisX2[0].labels[c.x]?this.chart.axisX2[0].labels[c.x]:"{x}"),k+="</br>",k=this.chart.replaceKeywordsWithValue(k,c,b,e)),null===c.toolTipContent||"undefined"===typeof c.toolTipContent&&null===b.options.toolTipContent||("line"===b.type||"stepLine"===b.type||"spline"===b.type||"area"===b.type||"stepArea"===
b.type||"splineArea"===b.type||"column"===b.type||"bar"===b.type||"scatter"===b.type||"stackedColumn"===b.type||"stackedColumn100"===b.type||"stackedBar"===b.type||"stackedBar100"===b.type||"stackedArea"===b.type||"stackedArea100"===b.type||"waterfall"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?
this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span>&nbsp;&nbsp;{y}",m=b.axisXIndex):"bubble"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}"):
"rangeColumn"===b.type||"rangeBar"===b.type||"rangeArea"===b.type||"rangeSplineArea"===b.type||"error"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span>&nbsp;&nbsp;{y[0]},&nbsp;{y[1]}"):"candlestick"===
b.type||"ohlc"===b.type?(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low:&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}"):"boxAndWhisker"===
b.type&&(this.chart.axisX&&1<this.chart.axisX.length&&(g+=m!=b.axisXIndex?b.axisX.title?b.axisX.title+"<br/>":"X:{axisXIndex}<br/>":""),g+=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>{name}:</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}"),
null===f&&(f=""),!0===this.reversed?(f=this.chart.replaceKeywordsWithValue(g,c,b,e)+f,l<a.length-1&&(f="</br>"+f)):(f+=this.chart.replaceKeywordsWithValue(g,c,b,e),l<a.length-1&&(f+="</br>")));null!==f&&(f=k+f)}else{b=a[0].dataSeries;c=a[0].dataPoint;e=a[0].index;if(null===c.toolTipContent||"undefined"===typeof c.toolTipContent&&null===b.options.toolTipContent)return null;"line"===b.type||"stepLine"===b.type||"spline"===b.type||"area"===b.type||"stepArea"===b.type||"splineArea"===b.type||"column"===
b.type||"bar"===b.type||"scatter"===b.type||"stackedColumn"===b.type||"stackedColumn100"===b.type||"stackedBar"===b.type||"stackedBar100"===b.type||"stackedArea"===b.type||"stackedArea100"===b.type||"waterfall"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+":</span>&nbsp;&nbsp;{y}":"bubble"===b.type?g=c.toolTipContent?
c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+":</span>&nbsp;&nbsp;{y}, &nbsp;&nbsp;{z}":"pie"===b.type||"doughnut"===b.type||"funnel"===b.type||"pyramid"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":
"'color:{color};'")+"\"'>"+(c.name?"{name}:</span>&nbsp;&nbsp;":c.label?"{label}:</span>&nbsp;&nbsp;":"</span>")+"{y}":"rangeColumn"===b.type||"rangeBar"===b.type||"rangeArea"===b.type||"rangeSplineArea"===b.type||"error"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+" :</span>&nbsp;&nbsp;{y[0]}, &nbsp;{y[1]}":
"candlestick"===b.type||"ohlc"===b.type?g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+"</span><br/>Open: &nbsp;&nbsp;{y[0]}<br/>High: &nbsp;&nbsp;&nbsp;{y[1]}<br/>Low: &nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Close: &nbsp;&nbsp;{y[3]}":"boxAndWhisker"===b.type&&(g=c.toolTipContent?c.toolTipContent:b.toolTipContent?b.toolTipContent:
this.content&&"function"!==typeof this.content?this.content:"<span style='\""+(this.options.fontColor?"":"'color:{color};'")+"\"'>"+(c.label?"{label}":"{x}")+"</span><br/>Minimum: &nbsp;&nbsp;{y[0]}<br/>Q1: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[1]}<br/>Q2: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[4]}<br/>Q3: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{y[2]}<br/>Maximum: &nbsp;{y[3]}");
null===f&&(f="");f+=this.chart.replaceKeywordsWithValue(g,c,b,e)}return f};Z.prototype.enableAnimation=function(){if(!this.container.style.WebkitTransition){var a=this.getContainerTransition(this.containerTransitionDuration);this.container.style.WebkitTransition=a;this.container.style.MsTransition=a;this.container.style.transition=a;this.container.style.MozTransition=this.mozContainerTransition}};Z.prototype.disableAnimation=function(){this.container.style.WebkitTransition&&(this.container.style.WebkitTransition=
"",this.container.style.MozTransition="",this.container.style.MsTransition="",this.container.style.transition="")};Z.prototype.hide=function(a){this.container&&(this.container.style.display="none",this.currentSeriesIndex=-1,this._prevY=this._prevX=NaN,("undefined"===typeof a||a)&&this.chart.resetOverlayedCanvas())};Z.prototype.show=function(a,f,b){this._updateToolTip(a,f,"undefined"===typeof b?!1:b)};Z.prototype.fixMozTransitionDelay=function(a,f){if(20<this.chart._eventManager.lastObjectId)this.mozContainerTransition=
this.getContainerTransition(0);else{var b=parseFloat(this.container.style.left),b=isNaN(b)?0:b,c=parseFloat(this.container.style.bottom),c=isNaN(c)?0:c;10<Math.sqrt(Math.pow(b-a,2)+Math.pow(c-f,2))?this.mozContainerTransition=this.getContainerTransition(0.1):this.mozContainerTransition=this.getContainerTransition(0)}};Z.prototype.getContainerTransition=function(a){return"left "+a+"s ease-out 0s, bottom "+a+"s ease-out 0s"};ea.prototype.reset=function(){this.lastObjectId=0;this.objectMap=[];this.rectangularRegionEventSubscriptions=
[];this.previousDataPointEventObject=null;this.eventObjects=[];v&&(this.ghostCtx.clearRect(0,0,this.chart.width,this.chart.height),this.ghostCtx.beginPath())};ea.prototype.getNewObjectTrackingId=function(){return++this.lastObjectId};ea.prototype.mouseEventHandler=function(a){if("mousemove"===a.type||"click"===a.type){var f=[],b=Oa(a),c=null;if((c=this.chart.getObjectAtXY(b.x,b.y,!1))&&"undefined"!==typeof this.objectMap[c])if(c=this.objectMap[c],"dataPoint"===c.objectType){var e=this.chart.data[c.dataSeriesIndex],
g=e.dataPoints[c.dataPointIndex],h=c.dataPointIndex;c.eventParameter={x:b.x,y:b.y,dataPoint:g,dataSeries:e.options,dataPointIndex:h,dataSeriesIndex:e.index,chart:this.chart};c.eventContext={context:g,userContext:g,mouseover:"mouseover",mousemove:"mousemove",mouseout:"mouseout",click:"click"};f.push(c);c=this.objectMap[e.id];c.eventParameter={x:b.x,y:b.y,dataPoint:g,dataSeries:e.options,dataPointIndex:h,dataSeriesIndex:e.index,chart:this.chart};c.eventContext={context:e,userContext:e.options,mouseover:"mouseover",
mousemove:"mousemove",mouseout:"mouseout",click:"click"};f.push(this.objectMap[e.id])}else"legendItem"===c.objectType&&(e=this.chart.data[c.dataSeriesIndex],g=null!==c.dataPointIndex?e.dataPoints[c.dataPointIndex]:null,c.eventParameter={x:b.x,y:b.y,dataSeries:e.options,dataPoint:g,dataPointIndex:c.dataPointIndex,dataSeriesIndex:c.dataSeriesIndex,chart:this.chart},c.eventContext={context:this.chart.legend,userContext:this.chart.legend.options,mouseover:"itemmouseover",mousemove:"itemmousemove",mouseout:"itemmouseout",
click:"itemclick"},f.push(c));e=[];for(b=0;b<this.mouseoveredObjectMaps.length;b++){g=!0;for(c=0;c<f.length;c++)if(f[c].id===this.mouseoveredObjectMaps[b].id){g=!1;break}g?this.fireEvent(this.mouseoveredObjectMaps[b],"mouseout",a):e.push(this.mouseoveredObjectMaps[b])}this.mouseoveredObjectMaps=e;for(b=0;b<f.length;b++){e=!1;for(c=0;c<this.mouseoveredObjectMaps.length;c++)if(f[b].id===this.mouseoveredObjectMaps[c].id){e=!0;break}e||(this.fireEvent(f[b],"mouseover",a),this.mouseoveredObjectMaps.push(f[b]));
"click"===a.type?this.fireEvent(f[b],"click",a):"mousemove"===a.type&&this.fireEvent(f[b],"mousemove",a)}}};ea.prototype.fireEvent=function(a,f,b){if(a&&f){var c=a.eventParameter,e=a.eventContext,g=a.eventContext.userContext;g&&(e&&g[e[f]])&&g[e[f]].call(g,c);"mouseout"!==f?g.cursor&&g.cursor!==b.target.style.cursor&&(b.target.style.cursor=g.cursor):(b.target.style.cursor=this.chart._defaultCursor,delete a.eventParameter,delete a.eventContext);"click"===f&&("dataPoint"===a.objectType&&this.chart.pieDoughnutClickHandler)&&
this.chart.pieDoughnutClickHandler.call(this.chart.data[a.dataSeriesIndex],c);"click"===f&&("dataPoint"===a.objectType&&this.chart.funnelPyramidClickHandler)&&this.chart.funnelPyramidClickHandler.call(this.chart.data[a.dataSeriesIndex],c)}};ga.prototype.animate=function(a,f,b,c,e){var g=this;this.chart.isAnimating=!0;e=e||O.easing.linear;b&&this.animations.push({startTime:(new Date).getTime()+(a?a:0),duration:f,animationCallback:b,onComplete:c});for(a=[];0<this.animations.length;)if(f=this.animations.shift(),
b=(new Date).getTime(),c=0,f.startTime<=b&&(c=e(Math.min(b-f.startTime,f.duration),0,1,f.duration),c=Math.min(c,1),isNaN(c)||!isFinite(c))&&(c=1),1>c&&a.push(f),f.animationCallback(c),1<=c&&f.onComplete)f.onComplete();this.animations=a;0<this.animations.length?this.animationRequestId=this.chart.requestAnimFrame.call(window,function(){g.animate.call(g)}):this.chart.isAnimating=!1};ga.prototype.cancelAllAnimations=function(){this.animations=[];this.animationRequestId&&this.chart.cancelRequestAnimFrame.call(window,
this.animationRequestId);this.animationRequestId=null;this.chart.isAnimating=!1};var O={yScaleAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas,e=f.animationBase;b.drawImage(c,0,0,c.width,c.height,0,e-e*a,b.canvas.width/ia,a*b.canvas.height/ia)}},xScaleAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas,e=f.animationBase;b.drawImage(c,0,0,c.width,c.height,e-e*a,0,a*b.canvas.width/ia,b.canvas.height/ia)}},xClipAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas;
b.save();0<a&&b.drawImage(c,0,0,c.width*a,c.height,0,0,c.width*a/ia,c.height/ia);b.restore()}},fadeInAnimation:function(a,f){if(0!==a){var b=f.dest,c=f.source.canvas;b.save();b.globalAlpha=a;b.drawImage(c,0,0,c.width,c.height,0,0,b.canvas.width/ia,b.canvas.height/ia);b.restore()}},easing:{linear:function(a,f,b,c){return b*a/c+f},easeOutQuad:function(a,f,b,c){return-b*(a/=c)*(a-2)+f},easeOutQuart:function(a,f,b,c){return-b*((a=a/c-1)*a*a*a-1)+f},easeInQuad:function(a,f,b,c){return b*(a/=c)*a+f},easeInQuart:function(a,
f,b,c){return b*(a/=c)*a*a*a+f}}},$={drawMarker:function(a,f,b,c,e,g,h,l){if(b){var m=1;b.fillStyle=g?g:"#000000";b.strokeStyle=h?h:"#000000";b.lineWidth=l?l:0;b.setLineDash&&b.setLineDash(F("solid",l));"circle"===c?(b.moveTo(a,f),b.beginPath(),b.arc(a,f,e/2,0,2*Math.PI,!1),g&&b.fill(),l&&(h?b.stroke():(m=b.globalAlpha,b.globalAlpha=0.15,b.strokeStyle="black",b.stroke(),b.globalAlpha=m))):"square"===c?(b.beginPath(),b.rect(a-e/2,f-e/2,e,e),g&&b.fill(),l&&(h?b.stroke():(m=b.globalAlpha,b.globalAlpha=
0.15,b.strokeStyle="black",b.stroke(),b.globalAlpha=m))):"triangle"===c?(b.beginPath(),b.moveTo(a-e/2,f+e/2),b.lineTo(a+e/2,f+e/2),b.lineTo(a,f-e/2),b.closePath(),g&&b.fill(),l&&(h?b.stroke():(m=b.globalAlpha,b.globalAlpha=0.15,b.strokeStyle="black",b.stroke(),b.globalAlpha=m)),b.beginPath()):"cross"===c&&(b.strokeStyle=g,b.lineWidth=e/4,b.beginPath(),b.moveTo(a-e/2,f-e/2),b.lineTo(a+e/2,f+e/2),b.stroke(),b.moveTo(a+e/2,f-e/2),b.lineTo(a-e/2,f+e/2),b.stroke())}},drawMarkers:function(a){for(var f=
0;f<a.length;f++){var b=a[f];$.drawMarker(b.x,b.y,b.ctx,b.type,b.size,b.color,b.borderColor,b.borderThickness)}}};return q}();Ka.Chart.version="v2.2 GA"})();

/*
  excanvas is used to support IE678 which do not implement HTML5 Canvas Element. You can safely remove the following excanvas code if you don't need to support older browsers.

  Copyright 2006 Google Inc. https://code.google.com/p/explorercanvas/
  Licensed under the Apache License, Version 2.0
*/
document.createElement("canvas").getContext||function(){function V(){return this.context_||(this.context_=new C(this))}function W(a,b,c){var g=M.call(arguments,2);return function(){return a.apply(b,g.concat(M.call(arguments)))}}function N(a){return String(a).replace(/&/g,"&amp;").replace(/"/g,"&quot;")}function O(a){a.namespaces.g_vml_||a.namespaces.add("g_vml_","urn:schemas-microsoft-com:vml","#default#VML");a.namespaces.g_o_||a.namespaces.add("g_o_","urn:schemas-microsoft-com:office:office","#default#VML");
a.styleSheets.ex_canvas_||(a=a.createStyleSheet(),a.owningElement.id="ex_canvas_",a.cssText="canvas{display:inline-block;overflow:hidden;text-align:left;width:300px;height:150px}")}function X(a){var b=a.srcElement;switch(a.propertyName){case "width":b.getContext().clearRect();b.style.width=b.attributes.width.nodeValue+"px";b.firstChild.style.width=b.clientWidth+"px";break;case "height":b.getContext().clearRect(),b.style.height=b.attributes.height.nodeValue+"px",b.firstChild.style.height=b.clientHeight+
"px"}}function Y(a){a=a.srcElement;a.firstChild&&(a.firstChild.style.width=a.clientWidth+"px",a.firstChild.style.height=a.clientHeight+"px")}function D(){return[[1,0,0],[0,1,0],[0,0,1]]}function t(a,b){for(var c=D(),g=0;3>g;g++)for(var e=0;3>e;e++){for(var f=0,d=0;3>d;d++)f+=a[g][d]*b[d][e];c[g][e]=f}return c}function P(a,b){b.fillStyle=a.fillStyle;b.lineCap=a.lineCap;b.lineJoin=a.lineJoin;b.lineWidth=a.lineWidth;b.miterLimit=a.miterLimit;b.shadowBlur=a.shadowBlur;b.shadowColor=a.shadowColor;b.shadowOffsetX=
a.shadowOffsetX;b.shadowOffsetY=a.shadowOffsetY;b.strokeStyle=a.strokeStyle;b.globalAlpha=a.globalAlpha;b.font=a.font;b.textAlign=a.textAlign;b.textBaseline=a.textBaseline;b.arcScaleX_=a.arcScaleX_;b.arcScaleY_=a.arcScaleY_;b.lineScale_=a.lineScale_}function Q(a){var b=a.indexOf("(",3),c=a.indexOf(")",b+1),b=a.substring(b+1,c).split(",");if(4!=b.length||"a"!=a.charAt(3))b[3]=1;return b}function E(a,b,c){return Math.min(c,Math.max(b,a))}function F(a,b,c){0>c&&c++;1<c&&c--;return 1>6*c?a+6*(b-a)*c:
1>2*c?b:2>3*c?a+6*(b-a)*(2/3-c):a}function G(a){if(a in H)return H[a];var b,c=1;a=String(a);if("#"==a.charAt(0))b=a;else if(/^rgb/.test(a)){c=Q(a);b="#";for(var g,e=0;3>e;e++)g=-1!=c[e].indexOf("%")?Math.floor(255*(parseFloat(c[e])/100)):+c[e],b+=v[E(g,0,255)];c=+c[3]}else if(/^hsl/.test(a)){e=c=Q(a);b=parseFloat(e[0])/360%360;0>b&&b++;g=E(parseFloat(e[1])/100,0,1);e=E(parseFloat(e[2])/100,0,1);if(0==g)g=e=b=e;else{var f=0.5>e?e*(1+g):e+g-e*g,d=2*e-f;g=F(d,f,b+1/3);e=F(d,f,b);b=F(d,f,b-1/3)}b="#"+
v[Math.floor(255*g)]+v[Math.floor(255*e)]+v[Math.floor(255*b)];c=c[3]}else b=Z[a]||a;return H[a]={color:b,alpha:c}}function C(a){this.m_=D();this.mStack_=[];this.aStack_=[];this.currentPath_=[];this.fillStyle=this.strokeStyle="#000";this.lineWidth=1;this.lineJoin="miter";this.lineCap="butt";this.miterLimit=1*q;this.globalAlpha=1;this.font="10px sans-serif";this.textAlign="left";this.textBaseline="alphabetic";this.canvas=a;var b="width:"+a.clientWidth+"px;height:"+a.clientHeight+"px;overflow:hidden;position:absolute",
c=a.ownerDocument.createElement("div");c.style.cssText=b;a.appendChild(c);b=c.cloneNode(!1);b.style.backgroundColor="red";b.style.filter="alpha(opacity=0)";a.appendChild(b);this.element_=c;this.lineScale_=this.arcScaleY_=this.arcScaleX_=1}function R(a,b,c,g){a.currentPath_.push({type:"bezierCurveTo",cp1x:b.x,cp1y:b.y,cp2x:c.x,cp2y:c.y,x:g.x,y:g.y});a.currentX_=g.x;a.currentY_=g.y}function S(a,b){var c=G(a.strokeStyle),g=c.color,c=c.alpha*a.globalAlpha,e=a.lineScale_*a.lineWidth;1>e&&(c*=e);b.push("<g_vml_:stroke",
' opacity="',c,'"',' joinstyle="',a.lineJoin,'"',' miterlimit="',a.miterLimit,'"',' endcap="',$[a.lineCap]||"square",'"',' weight="',e,'px"',' color="',g,'" />')}function T(a,b,c,g){var e=a.fillStyle,f=a.arcScaleX_,d=a.arcScaleY_,k=g.x-c.x,n=g.y-c.y;if(e instanceof w){var h=0,l=g=0,u=0,m=1;if("gradient"==e.type_){h=e.x1_/f;c=e.y1_/d;var p=s(a,e.x0_/f,e.y0_/d),h=s(a,h,c),h=180*Math.atan2(h.x-p.x,h.y-p.y)/Math.PI;0>h&&(h+=360);1E-6>h&&(h=0)}else p=s(a,e.x0_,e.y0_),g=(p.x-c.x)/k,l=(p.y-c.y)/n,k/=f*q,
n/=d*q,m=x.max(k,n),u=2*e.r0_/m,m=2*e.r1_/m-u;f=e.colors_;f.sort(function(a,b){return a.offset-b.offset});d=f.length;p=f[0].color;c=f[d-1].color;k=f[0].alpha*a.globalAlpha;a=f[d-1].alpha*a.globalAlpha;for(var n=[],r=0;r<d;r++){var t=f[r];n.push(t.offset*m+u+" "+t.color)}b.push('<g_vml_:fill type="',e.type_,'"',' method="none" focus="100%"',' color="',p,'"',' color2="',c,'"',' colors="',n.join(","),'"',' opacity="',a,'"',' g_o_:opacity2="',k,'"',' angle="',h,'"',' focusposition="',g,",",l,'" />')}else e instanceof
I?k&&n&&b.push("<g_vml_:fill",' position="',-c.x/k*f*f,",",-c.y/n*d*d,'"',' type="tile"',' src="',e.src_,'" />'):(e=G(a.fillStyle),b.push('<g_vml_:fill color="',e.color,'" opacity="',e.alpha*a.globalAlpha,'" />'))}function s(a,b,c){a=a.m_;return{x:q*(b*a[0][0]+c*a[1][0]+a[2][0])-r,y:q*(b*a[0][1]+c*a[1][1]+a[2][1])-r}}function z(a,b,c){isFinite(b[0][0])&&(isFinite(b[0][1])&&isFinite(b[1][0])&&isFinite(b[1][1])&&isFinite(b[2][0])&&isFinite(b[2][1]))&&(a.m_=b,c&&(a.lineScale_=aa(ba(b[0][0]*b[1][1]-b[0][1]*
b[1][0]))))}function w(a){this.type_=a;this.r1_=this.y1_=this.x1_=this.r0_=this.y0_=this.x0_=0;this.colors_=[]}function I(a,b){if(!a||1!=a.nodeType||"IMG"!=a.tagName)throw new A("TYPE_MISMATCH_ERR");if("complete"!=a.readyState)throw new A("INVALID_STATE_ERR");switch(b){case "repeat":case null:case "":this.repetition_="repeat";break;case "repeat-x":case "repeat-y":case "no-repeat":this.repetition_=b;break;default:throw new A("SYNTAX_ERR");}this.src_=a.src;this.width_=a.width;this.height_=a.height}
function A(a){this.code=this[a];this.message=a+": DOM Exception "+this.code}var x=Math,k=x.round,J=x.sin,K=x.cos,ba=x.abs,aa=x.sqrt,q=10,r=q/2;navigator.userAgent.match(/MSIE ([\d.]+)?/);var M=Array.prototype.slice;O(document);var U={init:function(a){a=a||document;a.createElement("canvas");a.attachEvent("onreadystatechange",W(this.init_,this,a))},init_:function(a){a=a.getElementsByTagName("canvas");for(var b=0;b<a.length;b++)this.initElement(a[b])},initElement:function(a){if(!a.getContext){a.getContext=
V;O(a.ownerDocument);a.innerHTML="";a.attachEvent("onpropertychange",X);a.attachEvent("onresize",Y);var b=a.attributes;b.width&&b.width.specified?a.style.width=b.width.nodeValue+"px":a.width=a.clientWidth;b.height&&b.height.specified?a.style.height=b.height.nodeValue+"px":a.height=a.clientHeight}return a}};U.init();for(var v=[],d=0;16>d;d++)for(var B=0;16>B;B++)v[16*d+B]=d.toString(16)+B.toString(16);var Z={aliceblue:"#F0F8FF",antiquewhite:"#FAEBD7",aquamarine:"#7FFFD4",azure:"#F0FFFF",beige:"#F5F5DC",
bisque:"#FFE4C4",black:"#000000",blanchedalmond:"#FFEBCD",blueviolet:"#8A2BE2",brown:"#A52A2A",burlywood:"#DEB887",cadetblue:"#5F9EA0",chartreuse:"#7FFF00",chocolate:"#D2691E",coral:"#FF7F50",cornflowerblue:"#6495ED",cornsilk:"#FFF8DC",crimson:"#DC143C",cyan:"#00FFFF",darkblue:"#00008B",darkcyan:"#008B8B",darkgoldenrod:"#B8860B",darkgray:"#A9A9A9",darkgreen:"#006400",darkgrey:"#A9A9A9",darkkhaki:"#BDB76B",darkmagenta:"#8B008B",darkolivegreen:"#556B2F",darkorange:"#FF8C00",darkorchid:"#9932CC",darkred:"#8B0000",
darksalmon:"#E9967A",darkseagreen:"#8FBC8F",darkslateblue:"#483D8B",darkslategray:"#2F4F4F",darkslategrey:"#2F4F4F",darkturquoise:"#00CED1",darkviolet:"#9400D3",deeppink:"#FF1493",deepskyblue:"#00BFFF",dimgray:"#696969",dimgrey:"#696969",dodgerblue:"#1E90FF",firebrick:"#B22222",floralwhite:"#FFFAF0",forestgreen:"#228B22",gainsboro:"#DCDCDC",ghostwhite:"#F8F8FF",gold:"#FFD700",goldenrod:"#DAA520",grey:"#808080",greenyellow:"#ADFF2F",honeydew:"#F0FFF0",hotpink:"#FF69B4",indianred:"#CD5C5C",indigo:"#4B0082",
ivory:"#FFFFF0",khaki:"#F0E68C",lavender:"#E6E6FA",lavenderblush:"#FFF0F5",lawngreen:"#7CFC00",lemonchiffon:"#FFFACD",lightblue:"#ADD8E6",lightcoral:"#F08080",lightcyan:"#E0FFFF",lightgoldenrodyellow:"#FAFAD2",lightgreen:"#90EE90",lightgrey:"#D3D3D3",lightpink:"#FFB6C1",lightsalmon:"#FFA07A",lightseagreen:"#20B2AA",lightskyblue:"#87CEFA",lightslategray:"#778899",lightslategrey:"#778899",lightsteelblue:"#B0C4DE",lightyellow:"#FFFFE0",limegreen:"#32CD32",linen:"#FAF0E6",magenta:"#FF00FF",mediumaquamarine:"#66CDAA",
mediumblue:"#0000CD",mediumorchid:"#BA55D3",mediumpurple:"#9370DB",mediumseagreen:"#3CB371",mediumslateblue:"#7B68EE",mediumspringgreen:"#00FA9A",mediumturquoise:"#48D1CC",mediumvioletred:"#C71585",midnightblue:"#191970",mintcream:"#F5FFFA",mistyrose:"#FFE4E1",moccasin:"#FFE4B5",navajowhite:"#FFDEAD",oldlace:"#FDF5E6",olivedrab:"#6B8E23",orange:"#FFA500",orangered:"#FF4500",orchid:"#DA70D6",palegoldenrod:"#EEE8AA",palegreen:"#98FB98",paleturquoise:"#AFEEEE",palevioletred:"#DB7093",papayawhip:"#FFEFD5",
peachpuff:"#FFDAB9",peru:"#CD853F",pink:"#FFC0CB",plum:"#DDA0DD",powderblue:"#B0E0E6",rosybrown:"#BC8F8F",royalblue:"#4169E1",saddlebrown:"#8B4513",salmon:"#FA8072",sandybrown:"#F4A460",seagreen:"#2E8B57",seashell:"#FFF5EE",sienna:"#A0522D",skyblue:"#87CEEB",slateblue:"#6A5ACD",slategray:"#708090",slategrey:"#708090",snow:"#FFFAFA",springgreen:"#00FF7F",steelblue:"#4682B4",tan:"#D2B48C",thistle:"#D8BFD8",tomato:"#FF6347",turquoise:"#40E0D0",violet:"#EE82EE",wheat:"#F5DEB3",whitesmoke:"#F5F5F5",yellowgreen:"#9ACD32"},
H={},L={},$={butt:"flat",round:"round"},d=C.prototype;d.clearRect=function(){this.textMeasureEl_&&(this.textMeasureEl_.removeNode(!0),this.textMeasureEl_=null);this.element_.innerHTML=""};d.beginPath=function(){this.currentPath_=[]};d.moveTo=function(a,b){var c=s(this,a,b);this.currentPath_.push({type:"moveTo",x:c.x,y:c.y});this.currentX_=c.x;this.currentY_=c.y};d.lineTo=function(a,b){var c=s(this,a,b);this.currentPath_.push({type:"lineTo",x:c.x,y:c.y});this.currentX_=c.x;this.currentY_=c.y};d.bezierCurveTo=
function(a,b,c,g,e,f){e=s(this,e,f);a=s(this,a,b);c=s(this,c,g);R(this,a,c,e)};d.quadraticCurveTo=function(a,b,c,g){a=s(this,a,b);c=s(this,c,g);g={x:this.currentX_+2/3*(a.x-this.currentX_),y:this.currentY_+2/3*(a.y-this.currentY_)};R(this,g,{x:g.x+(c.x-this.currentX_)/3,y:g.y+(c.y-this.currentY_)/3},c)};d.arc=function(a,b,c,g,e,f){c*=q;var d=f?"at":"wa",k=a+K(g)*c-r,n=b+J(g)*c-r;g=a+K(e)*c-r;e=b+J(e)*c-r;k!=g||f||(k+=0.125);a=s(this,a,b);k=s(this,k,n);g=s(this,g,e);this.currentPath_.push({type:d,
x:a.x,y:a.y,radius:c,xStart:k.x,yStart:k.y,xEnd:g.x,yEnd:g.y})};d.rect=function(a,b,c,g){this.moveTo(a,b);this.lineTo(a+c,b);this.lineTo(a+c,b+g);this.lineTo(a,b+g);this.closePath()};d.strokeRect=function(a,b,c,g){var e=this.currentPath_;this.beginPath();this.moveTo(a,b);this.lineTo(a+c,b);this.lineTo(a+c,b+g);this.lineTo(a,b+g);this.closePath();this.stroke();this.currentPath_=e};d.fillRect=function(a,b,c,g){var e=this.currentPath_;this.beginPath();this.moveTo(a,b);this.lineTo(a+c,b);this.lineTo(a+
c,b+g);this.lineTo(a,b+g);this.closePath();this.fill();this.currentPath_=e};d.createLinearGradient=function(a,b,c,g){var e=new w("gradient");e.x0_=a;e.y0_=b;e.x1_=c;e.y1_=g;return e};d.createRadialGradient=function(a,b,c,g,e,f){var d=new w("gradientradial");d.x0_=a;d.y0_=b;d.r0_=c;d.x1_=g;d.y1_=e;d.r1_=f;return d};d.drawImage=function(a,b){var c,g,e,d,r,y,n,h;e=a.runtimeStyle.width;d=a.runtimeStyle.height;a.runtimeStyle.width="auto";a.runtimeStyle.height="auto";var l=a.width,u=a.height;a.runtimeStyle.width=
e;a.runtimeStyle.height=d;if(3==arguments.length)c=arguments[1],g=arguments[2],r=y=0,n=e=l,h=d=u;else if(5==arguments.length)c=arguments[1],g=arguments[2],e=arguments[3],d=arguments[4],r=y=0,n=l,h=u;else if(9==arguments.length)r=arguments[1],y=arguments[2],n=arguments[3],h=arguments[4],c=arguments[5],g=arguments[6],e=arguments[7],d=arguments[8];else throw Error("Invalid number of arguments");var m=s(this,c,g),p=[];p.push(" <g_vml_:group",' coordsize="',10*q,",",10*q,'"',' coordorigin="0,0"',' style="width:',
10,"px;height:",10,"px;position:absolute;");if(1!=this.m_[0][0]||this.m_[0][1]||1!=this.m_[1][1]||this.m_[1][0]){var t=[];t.push("M11=",this.m_[0][0],",","M12=",this.m_[1][0],",","M21=",this.m_[0][1],",","M22=",this.m_[1][1],",","Dx=",k(m.x/q),",","Dy=",k(m.y/q),"");var v=s(this,c+e,g),w=s(this,c,g+d);c=s(this,c+e,g+d);m.x=x.max(m.x,v.x,w.x,c.x);m.y=x.max(m.y,v.y,w.y,c.y);p.push("padding:0 ",k(m.x/q),"px ",k(m.y/q),"px 0;filter:progid:DXImageTransform.Microsoft.Matrix(",t.join(""),", sizingmethod='clip');")}else p.push("top:",
k(m.y/q),"px;left:",k(m.x/q),"px;");p.push(' ">','<g_vml_:image src="',a.src,'"',' style="width:',q*e,"px;"," height:",q*d,'px"',' cropleft="',r/l,'"',' croptop="',y/u,'"',' cropright="',(l-r-n)/l,'"',' cropbottom="',(u-y-h)/u,'"'," />","</g_vml_:group>");this.element_.insertAdjacentHTML("BeforeEnd",p.join(""))};d.stroke=function(a){var b=[];b.push("<g_vml_:shape",' filled="',!!a,'"',' style="position:absolute;width:',10,"px;height:",10,'px;"',' coordorigin="0,0"',' coordsize="',10*q,",",10*q,'"',
' stroked="',!a,'"',' path="');for(var c={x:null,y:null},d={x:null,y:null},e=0;e<this.currentPath_.length;e++){var f=this.currentPath_[e];switch(f.type){case "moveTo":b.push(" m ",k(f.x),",",k(f.y));break;case "lineTo":b.push(" l ",k(f.x),",",k(f.y));break;case "close":b.push(" x ");f=null;break;case "bezierCurveTo":b.push(" c ",k(f.cp1x),",",k(f.cp1y),",",k(f.cp2x),",",k(f.cp2y),",",k(f.x),",",k(f.y));break;case "at":case "wa":b.push(" ",f.type," ",k(f.x-this.arcScaleX_*f.radius),",",k(f.y-this.arcScaleY_*
f.radius)," ",k(f.x+this.arcScaleX_*f.radius),",",k(f.y+this.arcScaleY_*f.radius)," ",k(f.xStart),",",k(f.yStart)," ",k(f.xEnd),",",k(f.yEnd))}if(f){if(null==c.x||f.x<c.x)c.x=f.x;if(null==d.x||f.x>d.x)d.x=f.x;if(null==c.y||f.y<c.y)c.y=f.y;if(null==d.y||f.y>d.y)d.y=f.y}}b.push(' ">');a?T(this,b,c,d):S(this,b);b.push("</g_vml_:shape>");this.element_.insertAdjacentHTML("beforeEnd",b.join(""))};d.fill=function(){this.stroke(!0)};d.closePath=function(){this.currentPath_.push({type:"close"})};d.save=function(){var a=
{};P(this,a);this.aStack_.push(a);this.mStack_.push(this.m_);this.m_=t(D(),this.m_)};d.restore=function(){this.aStack_.length&&(P(this.aStack_.pop(),this),this.m_=this.mStack_.pop())};d.translate=function(a,b){z(this,t([[1,0,0],[0,1,0],[a,b,1]],this.m_),!1)};d.rotate=function(a){var b=K(a);a=J(a);z(this,t([[b,a,0],[-a,b,0],[0,0,1]],this.m_),!1)};d.scale=function(a,b){this.arcScaleX_*=a;this.arcScaleY_*=b;z(this,t([[a,0,0],[0,b,0],[0,0,1]],this.m_),!0)};d.transform=function(a,b,c,d,e,f){z(this,t([[a,
b,0],[c,d,0],[e,f,1]],this.m_),!0)};d.setTransform=function(a,b,c,d,e,f){z(this,[[a,b,0],[c,d,0],[e,f,1]],!0)};d.drawText_=function(a,b,c,d,e){var f=this.m_;d=0;var r=1E3,t=0,n=[],h;h=this.font;if(L[h])h=L[h];else{var l=document.createElement("div").style;try{l.font=h}catch(u){}h=L[h]={style:l.fontStyle||"normal",variant:l.fontVariant||"normal",weight:l.fontWeight||"normal",size:l.fontSize||10,family:l.fontFamily||"sans-serif"}}var l=h,m=this.element_;h={};for(var p in l)h[p]=l[p];p=parseFloat(m.currentStyle.fontSize);
m=parseFloat(l.size);"number"==typeof l.size?h.size=l.size:-1!=l.size.indexOf("px")?h.size=m:-1!=l.size.indexOf("em")?h.size=p*m:-1!=l.size.indexOf("%")?h.size=p/100*m:-1!=l.size.indexOf("pt")?h.size=m/0.75:h.size=p;h.size*=0.981;p=h.style+" "+h.variant+" "+h.weight+" "+h.size+"px "+h.family;m=this.element_.currentStyle;l=this.textAlign.toLowerCase();switch(l){case "left":case "center":case "right":break;case "end":l="ltr"==m.direction?"right":"left";break;case "start":l="rtl"==m.direction?"right":
"left";break;default:l="left"}switch(this.textBaseline){case "hanging":case "top":t=h.size/1.75;break;case "middle":break;default:case null:case "alphabetic":case "ideographic":case "bottom":t=-h.size/2.25}switch(l){case "right":d=1E3;r=0.05;break;case "center":d=r=500}b=s(this,b+0,c+t);n.push('<g_vml_:line from="',-d,' 0" to="',r,' 0.05" ',' coordsize="100 100" coordorigin="0 0"',' filled="',!e,'" stroked="',!!e,'" style="position:absolute;width:1px;height:1px;">');e?S(this,n):T(this,n,{x:-d,y:0},
{x:r,y:h.size});e=f[0][0].toFixed(3)+","+f[1][0].toFixed(3)+","+f[0][1].toFixed(3)+","+f[1][1].toFixed(3)+",0,0";b=k(b.x/q)+","+k(b.y/q);n.push('<g_vml_:skew on="t" matrix="',e,'" ',' offset="',b,'" origin="',d,' 0" />','<g_vml_:path textpathok="true" />','<g_vml_:textpath on="true" string="',N(a),'" style="v-text-align:',l,";font:",N(p),'" /></g_vml_:line>');this.element_.insertAdjacentHTML("beforeEnd",n.join(""))};d.fillText=function(a,b,c,d){this.drawText_(a,b,c,d,!1)};d.strokeText=function(a,
b,c,d){this.drawText_(a,b,c,d,!0)};d.measureText=function(a){this.textMeasureEl_||(this.element_.insertAdjacentHTML("beforeEnd",'<span style="position:absolute;top:-20000px;left:0;padding:0;margin:0;border:none;white-space:pre;"></span>'),this.textMeasureEl_=this.element_.lastChild);var b=this.element_.ownerDocument;this.textMeasureEl_.innerHTML="";this.textMeasureEl_.style.font=this.font;this.textMeasureEl_.appendChild(b.createTextNode(a));return{width:this.textMeasureEl_.offsetWidth}};d.clip=function(){};
d.arcTo=function(){};d.createPattern=function(a,b){return new I(a,b)};w.prototype.addColorStop=function(a,b){b=G(b);this.colors_.push({offset:a,color:b.color,alpha:b.alpha})};d=A.prototype=Error();d.INDEX_SIZE_ERR=1;d.DOMSTRING_SIZE_ERR=2;d.HIERARCHY_REQUEST_ERR=3;d.WRONG_DOCUMENT_ERR=4;d.INVALID_CHARACTER_ERR=5;d.NO_DATA_ALLOWED_ERR=6;d.NO_MODIFICATION_ALLOWED_ERR=7;d.NOT_FOUND_ERR=8;d.NOT_SUPPORTED_ERR=9;d.INUSE_ATTRIBUTE_ERR=10;d.INVALID_STATE_ERR=11;d.SYNTAX_ERR=12;d.INVALID_MODIFICATION_ERR=
13;d.NAMESPACE_ERR=14;d.INVALID_ACCESS_ERR=15;d.VALIDATION_ERR=16;d.TYPE_MISMATCH_ERR=17;G_vmlCanvasManager=U;CanvasRenderingContext2D=C;CanvasGradient=w;CanvasPattern=I;DOMException=A}();
/*jshint ignore:end*/
(function() {
  'use strict';

  angular
    .module('spapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope) {
	$rootScope.cargandoInformacion = 0;
	$rootScope.menus = [];
	
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('spapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, EXTERNAL_HOME_PAGE, LOGIN_PAGE) {
    $stateProvider
      .state('ingreso', {
        url: '/ingreso',
        views : {
          'root': {
           templateUrl: 'app/modules/autenticacion/ingreso/ingresoinicio.html',
            controller: 'IngresoInicioController',
            controllerAs: 'vm'
          }
        }
      })
       $stateProvider
      .state('login', {
        url: '/login',
        views : {
          'root': {
           templateUrl: 'app/modules/autenticacion/login.html',
            controller: 'LoginController',
            controllerAs: 'vm'
          }
        }
      })
       $stateProvider
      .state('ingreso-hidrocarburos', {
        url: '/ingreso-hidrocarburos',
        views : {
          'root': {
           templateUrl: 'app/modules/autenticacion/ingreso/ingreso_hidrocarburos.html',
            controller: 'IngresoHidrocarburosController',
            controllerAs: 'vm'
          }
        }
      })
    
      /*.state('ingreso',{
				url : '/login/ingreso',
				templateUrl : 'app/modules/autenticacion/ingreso/ingresoinicio.html',
				controller : 'IngresoInicioController',
				controllerAs : 'vm'
			})*/
      .state('404', {
        url: '/404',
        views : {
          'root': {
            templateUrl: 'app/layout/error/404.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        }
      })
      .state('500', {
        url: '/500',
        views: {
          'root': {
            templateUrl: 'app/layout/error/500.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        }
      })
      .state('spapp', {
        abstract : true,
        views : {
          'root': {
            templateUrl : 'app/layout/root/root.html',
            controller  : 'RootController',
            controllerAs: 'vmRoot'
          },
          'header@spapp': {
            templateUrl : 'app/layout/header/header.html',
            controller  : 'HeaderController',
            controllerAs: 'vmHeader'
          },
          /*'navbar@spapp': {
            templateUrl : 'app/layout/navbar/navbar.html',
            controller  : 'NavbarController',
            controllerAs: 'vmNavbar'
          },*/
          'footer@spapp': {
            templateUrl : 'app/layout/footer/footer.html',
            controller  : 'FooterController',
            controllerAs: 'vmFooter'
          }
        }
      })

      /******************************/
        
       .state('acceso', {
        url : '/acceso',
        views : {
          'root': {
            templateUrl : 'app/modules/acceso/acceso.html',
            controller  : 'AccesoController',
            controllerAs: 'vm'
          },
          
        }
      })
      
      
     
      /******************************/
      .state('spapp.home', {
        url : '/home',
        views : {
          /*'main@spapp': {
            templateUrl : 'app/layout/main/main.html',
            controller  : 'MainController',
            controllerAs: 'vm'
          },*/
          'sidebar@spapp': {
            templateUrl : 'app/layout/sidebar/sidebar.html',
            controller  : 'SidebarController',
            controllerAs: 'vmSidebar'
          }
        }
      })
      .state('spapp.home.inicio', {
        url         : '/inicio',
        templateUrl : 'app/modules/inicio/inicio.html',
        controller  : 'InicioController',
        controllerAs: 'vm'
      });

    $urlRouterProvider.when('', LOGIN_PAGE.url);
    $urlRouterProvider.when('/', LOGIN_PAGE.url);

    $urlRouterProvider.otherwise('/404');
  }

})();

/* global malarkey:false, moment:false */
(function() {
	'use strict';

	angular.module('spapp').constant('malarkey', malarkey).constant('moment',
			moment).constant('API_CONFIG', {
		/* 'url' : 'rest/api/' */

		'url' : 'https://sistemas.oefa.gob.pe/siso/rest/api/',
		// 'url' : 'http://localhost:8080/oefa-siso-web/rest/api/',
		// 'urlSSO' : 'http://10.1.1.69/OEFA.STS'
		// 'urlSSO' : 'http://desarrollo.oefa.gob.pe/OEFA.STS',
		// 'urlSSO' : 'http://srvssoqa.oefa.gob.pe/OEFA.STS',
		// 'urlSSO' : 'http://10.1.1.80/OEFA.STS',
		'urlSSO' : 'https://sso.oefa.gob.pe/OEFA.STS/'
	// 'url' : 'http://10.1.1.170:8680/siso/rest/api/'
	// 'url' : 'https://desarrollo.oefa.gob.pe/siso/rest/api/'
	// 'url' : 'http://10.1.1.162/siso/rest/api/'
	}).constant('EXTERNAL_HOME_PAGE', {
		'state' : 'spapp-portal.main.eventos',
		'url' : '/portal/eventos'
	}).constant('INTERNAL_HOME_PAGE', {
		'state' : 'spapp.home.inicio',
		'url' : '/home/inicio'
	}).constant('LOGIN_PAGE', {
		'state' : 'ingreso',
		'url' : '/ingreso'
	});

})();

(function() {
  'use strict';

  angular
    .module('spapp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

  }

})();

angular.module("spapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=container><div><acme-navbar creation-date=main.creationDate></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=lead><img src=assets/images/yeoman.png alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=main.classAnimation><button type=button class=\"btn btn-lg btn-success\" ng-click=main.showToastr()>Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=row><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=thumbnail><img class=pull-right ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=caption><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href={{awesomeThing.url}}>{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/layout/error/404.html","<div id=bg><img src=assets/images/fondo/imagen-login.jpg alt=\"\"></div><div class=container><div class=row><div class=col-md-12><div class=\"base-bg error-bg\"><div class=center-block><!--<img class=\"img-responsive\" width=\"250\" src=\"assets/images/error_401_app.png\" alt=\"\">--><h2 style=\"font-size: 4em\">ERROR 404</h2><hr><h5>Usted no tiene permiso para acceder al recurso solicitado.</h5><a class=\"btn btn-primary btn-sm\" ui-sref=mtp.home>Volver al inicio</a></div></div></div></div></div><!--style=\"background-image: url(../assets/images/fondo/imagen-login.jpg)\"-->");
$templateCache.put("app/layout/error/500.html","<div id=bg><img src=assets/images/fondo/imagen-login.jpg alt=\"\"></div><div class=container><div class=row><div class=col-md-12><div class=\"base-bg error-bg\"><div class=center-block><!--<img class=\"img-responsive\" width=\"250\" src=\"assets/images/error_500_app.png\" alt=\"\">--><h2 style=\"font-size: 4em\">ERROR 500</h2><hr><h5>Ha ocurrido una excepci&oacute;n con la aplicaci&oacute;n, por favor cont&acute;ctese con el administrador.</h5><a class=\"btn btn-primary btn-sm\" ui-sref=mtp.home>Volver al inicio</a></div></div></div></div></div>");
$templateCache.put("app/layout/footer/footer.html","<!--<footer class=\"footer\">\r\n  <div class=\"footer-content\">\r\n    <div class=\"content-box-app\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-4\" id=\"footer-left\">\r\n          <a href=\"https://www.oefa.gob.pe/\" target=\"_blank\">\r\n            <img src=\"assets/images/oefa-logo-white.png\" alt=\"\" width=\"\">\r\n          </a>\r\n        </div>\r\n        <div class=\"col-sm-8\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-6\">\r\n              <h5 class=\"title-footer\">Contáctenos</h5>\r\n              <ul class=\"fotter-inf-cont colum-inf\">\r\n                <li>\r\n                  <span>\r\n                  Central: 204-9900 <br>\r\n                  Atención al Ciudadano: 204-9278 / 204-9279<br>\r\n                  Ayuda Informática: 204-9344 / 204-9228\r\n                  </span>\r\n                </li>\r\n                <li>\r\n                  <span>\r\n                  Avenida Faustino Sánchez Carrión<br>\r\n                  N° 603, 607 y 615 - Jesús María<br>\r\n                  Horario de Atención al Público:<br>\r\n                  Lunes a viernes 8:45 a 16:45<br>\r\n                  </span>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n            <div class=\"col-md-6\">\r\n              <ul class=\"fotter-inf-cont\">\r\n                <h5 class=\"title-footer\">Redes Sociales | Correos </h5>\r\n                  <li style=\"display: table;margin-bottom: 15px;\">\r\n                      <ul class=\"lst-rsocial\">\r\n                        <li><a href=\"https://www.facebook.com/oefa.peru\" title=\"Facebook OEFA\" target=\"_blank\"><i class=\"fa fa-facebook\"></i></a></li>\r\n                        <li><a href=\"https://twitter.com/#!/oefaperu\" title=\"Twitter OEFA\" target=\"_blank\"><i class=\"fa fa-twitter\"></i></a></li>\r\n                        <li><a href=\"http://www.flickr.com/photos/oefa/sets/\" title=\"Flickr OEFA\" target=\"_blank\"><i class=\"fa fa-flickr\"></i></a></li>\r\n                        <li><a href=\"http://www.youtube.com/user/OEFAperu\" title=\"Youtube OEFA\" target=\"_blank\"><i class=\"fa fa-youtube-play\"></i></a></li>\r\n                      </ul>\r\n                  </li>\r\n                  <li>\r\n                    <span class=\"mb-1\">\r\n                    Sistema de Supervisión Online - SISO:\r\n                    <a href=\"mailto:denuncias@oefa.gob.pe\">denuncias@oefa.gob.pe</a>\r\n                    </span>\r\n                  </li>\r\n                  <li>\r\n                    <span class=\"mb-1\">\r\n                    Servicio de Información y Atención al Ciudadano - SIAC:\r\n                    <a href=\"mailto:consultas@oefa.gob.pe\">consultas@oefa.gob.pe</a>\r\n                    </span>\r\n                  </li>\r\n                  <li>\r\n                    <span class=\"mb-1\">\r\n                    Ayuda Informática:\r\n                    <a href=\"mailto:ayudainformatica@oefa.gob.pe\">ayudainformatica@oefa.gob.pe</a>\r\n                    </span>\r\n                  </li>\r\n                  <li>\r\n                    <span class=\"mb-1\">\r\n                    Webmaster:\r\n                    <a href=\"mailto:webmaster@oefa.gob.pe\">webmaster@oefa.gob.pe</a>\r\n                    </span>\r\n                  </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"bottom-bar\" style=\"display: none\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n\r\n        <small class=\"copyright col-md-6 col-sm-12 col-xs-12\">\r\n          <span>Copyright &copy; 2017 galaxybis | Website template by</span>\r\n          <a target=\"blank\" href=\"http://galaxybis.pe\">GALAXY BIS</a>\r\n        </small>\r\n        <ul class=\"social pull-right col-md-6 col-sm-12 col-xs-12\">\r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</footer>-->");
$templateCache.put("app/layout/header/header-login.html","<div class=wrapper><header class=header><div class=top-bar><div class=content-box-app><span class=pull-right><ul id=head-top-menu class=\"header-menu col-md-12 col-sm-12 col-xs-12\" style=\"height: 38px\"><!-- <li><a><i class=\"glyphicon glyphicon-globe\"></i> Inicio</a></li> --></ul></span></div></div></header></div>");
$templateCache.put("app/layout/header/header.html","<div class=wrapper><header class=header><div class=top-bar><div class=content-box-app><div class=\"row barra-top-oefa-movil\"><span class=pull-left id=logo-movilx><img ng-src=assets/images/logo-siso_movil.png alt=\"\" height=30><label class=app-name></label><img src=assets/images/iconos/hidrocarburos_menores.png alt=\"\" height=30> </span><span class=\"pull-right span-movil\" style=padding:0px><ul id=head-top-menu class=\"header-menu col-md-12 col-sm-12 col-xs-12\"><!--<li ><a href=\"assets/manual/Manual_de_usuario.pdf\" ><i class=\"glyphicon glyphicon-question-sign\"></i> Ayuda</a></li>--><li><a ng-click=vmHeader.cerrarSesion()><i class=\"glyphicon glyphicon-off\"></i> Cerrar sesi&oacute;n</a></li></ul></span></div><div class=\"col-md-6 col-sm-6 col-xs-12\"><img style=\"width: 220px;padding: 5% 0\" id=logo-web-oefa src=assets/images/logo-siso-registrado.png alt=\"\"> <img ng-src=assets/images/iconos/hidrocarburos_menores.png alt=Hidrocarburos height=70 title=\"Grifos y estaciones de servicio\"></div><div class=\"col-md-3 col-sm-3 col-xs-6 user-header text-left\" style=\"color: white!important\"><div class=user-box><div class=\"img-user-perfil text-center col-md-2\"><img src=./assets/images/user_icon.png class=\"img-responsive img-circle\" alt=\"\"> <span ng-if=\"$parent.usuarioActivo.listaUsuarioPerfil!=null && $parent.usuarioActivo.listaUsuarioPerfil.length==1\" class=name-perfil>{{$parent.usuarioActivo.listaUsuarioPerfil[0].nombrePrefil}} Juan Carlos Rodrigo</span> <span ng-if=\"$parent.usuarioActivo.listaUsuarioPerfil!=null && $parent.usuarioActivo.listaUsuarioPerfil.length>1\" class=name-perfil><select class=\"form-control input-sm\" ng-model=vmHeader.prmComponente.idPerfil ng-change=vmHeader.obtenerAccesoMenu()><option ng-repeat=\"item in $parent.usuarioActivo.listaUsuarioPerfil\" ng-value=item.idPerfil*1>{{item.nombrePrefil}} Administrador</option></select></span></div><table class=\"text-left col-md-9\"><tbody><tr><td colspan=2>Bienvenido(a)</td><td rowspan=2></td><td></td></tr><tr><td colspan=3><span class=name-user>{{vmHeader.nombreUsuario.replace(\'\\\\u0026\', \'&\')}}</span></td></tr><tr><td colspan=3></td></tr></tbody></table></div></div><!--//info--> <span class=\"pull-right col-md-3 col-sm-3 col-xs-6 nom-sesion\"><ul id=head-top-menu class=\"header-menu col-md-12 col-sm-12 col-xs-12\"><!--<li ><a href=\"assets/manual/Manual_de_usuario.pdf\" ><i class=\"glyphicon glyphicon-question-sign\"></i> Ayuda</a></li>--><li><a ng-click=vmHeader.cerrarSesion()><i class=\"glyphicon glyphicon-off\"></i> Cerrar sesi&oacute;n</a></li></ul></span><div class=\"col-md-6 col-sm-6 col-xs-12 user-header-movil text-right\" style=\"color: white!important;padding:10px 0\"><div class=user-box><div class=\"img-user-perfil text-center\"><img src=./assets/images/user_icon.png class=\"img-responsive img-circle\" alt=\"\"> <span ng-if=\"$parent.usuarioActivo.listaUsuarioPerfil!=null && $parent.usuarioActivo.listaUsuarioPerfil.length==1\" class=name-perfil>{{$parent.usuarioActivo.listaUsuarioPerfil[0].nombrePrefil}} Juan Carlos Rodrigo</span> <span ng-if=\"$parent.usuarioActivo.listaUsuarioPerfil!=null && $parent.usuarioActivo.listaUsuarioPerfil.length>1\" class=name-perfil><select class=\"form-control input-sm\" ng-model=vmHeader.prmComponente.idPerfil ng-change=vmHeader.obtenerAccesoMenu()><option ng-repeat=\"item in $parent.usuarioActivo.listaUsuarioPerfil\" ng-value=item.idPerfil*1>{{item.nombrePrefil}} Administrador</option></select></span></div><table class=text-left><tbody><tr><td colspan=2>Bienvenido(a)</td><td rowspan=2></td><td></td></tr><tr><td colspan=3><span class=name-user>{{vmHeader.nombreUsuario}}</span></td></tr><tr><td colspan=3><!--                   <b>Administrador</b> --></td></tr></tbody></table></div></div><!--//info--></div></div></header></div><div class=bg-header><div class=\"header-main content-box-app\" style=\"margin-top: 15px\"><div class=row><!--...--></div></div></div>");
$templateCache.put("app/layout/main/main.html","<div class=content-box-app><div class=row><div class=col-md-12><!-- The carousel --><div id=transition-timer-carousel class=\"carousel slide transition-timer-carousel\" data-ride=carousel><!-- Indicators --><ol class=carousel-indicators><li data-target=#transition-timer-carousel data-slide-to=0 class=active></li></ol><!-- Wrapper for slides --><div class=carousel-inner><div class=\"item active\"><img src=/assets/images/slider1.jpg><div class=carousel-caption><h1 class=carousel-caption-header>Gestión Integral de Servicios de Salud</h1><p class=\"carousel-caption-text hidden-sm hidden-xs\">Promoción y protección de los derechos fundamentales y la seguridad y salud en el trabajo; así como, modelo de organización y gestión en el sector público, que favorezca la generación del Trabajo Decente y la consolidación de una Cultura por la Prevención de los accidentes de trabajo y las enfermedades profesionales</p></div></div></div><!-- Controls --> <a class=\"left carousel-control\" href=#transition-timer-carousel data-slide=prev><span class=\"glyphicon glyphicon-chevron-left\"></span> </a><a class=\"right carousel-control\" href=#transition-timer-carousel data-slide=next><span class=\"glyphicon glyphicon-chevron-right\"></span> </a><!-- Timer \"progress bar\" --><hr class=\"transition-timer-carousel-progress-bar animate\"></div></div></div><div class=row style=\"margin-top: 30px;display: none\"><div class=col-lg-4><span class=box-bg><h3>Safari bug warning!</h3><p class=text-danger>As of v9.1.2, Safari exhibits a bug in which resizing your browser horizontally causes rendering errors in the justified nav that are cleared upon refreshing.</p><p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui.</p><p><a class=\"btn btn-primary btn-labeled\" href=# role=button>View details &raquo;</a></p></span></div><div class=col-lg-4><span class=box-bg><h3>Heading</h3><p>Donec id elit non mi porta gravida at eget metus. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Etiam porta sem malesuada magna mollis euismod. Donec sed odio dui.</p><p><button type=button class=\"btn btn-labeled btn-success\"><span class=btn-label><i class=\"glyphicon glyphicon-ok\"></i></span>Success</button></p></span></div><div class=col-lg-4><span class=box-bg><h3>Heading</h3><p>Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa.</p><p><button type=button class=\"btn btn-labeled btn-success\"><span class=btn-label><i class=\"glyphicon glyphicon-ok\"></i></span>Success</button> <button type=button class=\"btn btn-labeled btn-success\"><span class=btn-label><i class=\"glyphicon glyphicon-ok\"></i></span>Success</button></p></span></div></div></div><!-- /content-box-app -->");
$templateCache.put("app/layout/navbar/navbar.html","<div class=\"header-main content-box-app\"><div class=row><div class=\"col-md-2 col-sm-2\"><h1 class=logo style=\"margin-top: 20px;margin-bottom: 10px\"><img src=assets/images/logo/galaxy-training-logo.png alt=\"\" height=80 style=\"margin-bottom: 10px\"></h1></div><div class=\"col-md-10 col-sm-10\" style=\"margin-top: 20px\"><div class=\"user-box pull-right\"><div class=\"img-user-perfil text-center\"><img src=./assets/images/user-example.jpg class=\"img-responsive img-circle\" alt=\"\"> <span class=name-perfil>{{vmNavbar.usuarioActual.nombrePerfil}}</span></div><table><tbody><tr><td colspan=2>Bienvenido</td><td rowspan=2></td><td></td></tr><tr><td colspan=3><span class=name-user>{{vmNavbar.usuarioActual.nombreCompletoPersona}}</span></td></tr></tbody></table></div></div><!--//info--></div></div><nav class=main-nav role=navigation><div class=content-box-app><div class=row><div class=navbar-header><button class=navbar-toggle type=button data-toggle=collapse data-target=#navbar-collapse><span class=sr-only>Toggle navigation</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button></div><div class=\"navbar-collapse collapse\" id=navbar-collapse><ul class=\"nav navbar-nav box-shadow\" style=\"width: 100%\"><li class=nav-item ng-repeat=\"menuItem in $parent.menus | orderBy : indice\"><a ng-click=vmRoot.menuClick(menuItem.indice) ng-class=\"{ \'active\' : menuItem.activo}\"><i class={{menuItem.icono}}></i> {{menuItem.titulo}}</a></li></ul></div></div></div></nav><!--<nav class=\"main-nav\" role=\"navigation\">\r\n  <div class=\"content-box-app\">\r\n    <div class=\"row\">\r\n      <div class=\"navbar-header\">\r\n        <button class=\"navbar-toggle\" type=\"button\" data-toggle=\"collapse\" data-target=\"#navbar-collapse\">\r\n          <span class=\"sr-only\">Toggle navigation</span>\r\n          <span class=\"icon-bar\"></span>\r\n          <span class=\"icon-bar\"></span>\r\n          <span class=\"icon-bar\"></span>\r\n        </button>\r\n      </div>\r\n      <div class=\"navbar-collapse collapse\" id=\"navbar-collapse\">\r\n        <ul class=\"nav navbar-nav box-shadow\" style=\"width: 100%;\">\r\n          <li class=\"nav-item\" ng-repeat=\"menuItem in $parent.menus | orderBy : indice\">\r\n            <a ng-click=\"vmRoot.menuClick(menuItem.indice)\" ng-class=\"{ \'active\' : menuItem.activo}\">\r\n              <i class=\"{{menuItem.icono}}\"></i>\r\n              {{menuItem.titulo}}\r\n            </a>\r\n          </li>  \r\n        </ul>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</nav>-->");
$templateCache.put("app/layout/root/root.html","<span ui-view=header></span> <span ui-view=navbar></span> <span ui-view=main></span> <span ui-view=sidebar></span> <span ui-view=footer></span> <span ng-if=\"$parent.cargandoInformacion>0\" class=overlay-block><div class=contenedor_load><img ng-src=assets/images/gif/gears-red.gif alt=\"\"><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/autenticacion/login.html","<div id=bg><img alt=\"\" src=assets/images/fondo/amazonas-fondo.jpg></div><div class=container ng-if=false><div class=row style=\"margin-top: 8%\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-offset-2\"><div id=contenedor-table><div id=cell-table-login><div id=fondo-contert-form><div id=title-bg-ad><span id=v-01></span> <span id=txt-dt>Sistema de supervisión online </span><span id=v-02></span></div><div id=img-logo-form><img alt=\"\" src=assets/images/oefa-logo-white.png></div></div><div id=login-box><form class=login-form id=vm.loginForm name=vm.loginForm><div class=\"form-group text-center\"><img alt=\"\" class=\"img-responsive center-block\" src=assets/images/siso-sistema-de-supervisión-online.png style=\"margin-bottom: 20px;margin-top: 10px\"></div><div class=form-group><label class=control-label for=usuario>Usuario</label><div class=input-group><div class=input-group-addon><span class=\"fa fa-user\"></span></div><input autocomplete=off class=form-control id=usuario input-restrict=alfanumerico maxlength=8 name=usuario ng-keyup=vm.keyLogin($event.keyCode) ng-model=vm.usuarioLogin.nombreUsuario title=\"Ingrese nombre de usuario\" type=text></div><span class=help-block></span></div><div class=form-group><label class=control-label for=clave>Contraseña</label><div class=input-group><div class=input-group-addon><span class=\"fa fa-key\"></span></div><input class=form-control id=clave maxlength=20 name=clave ng-keyup=vm.keyLogin($event.keyCode) ng-model=vm.usuarioLogin.clave title=\"Ingrese clave de usuario\" type=password></div><span class=help-block></span></div><div class=\"alert alert-error hide\" id=loginErrorMsg>Usuario o clave incorrecta</div><div class=form-group style=\"padding-top: 5px\"><button class=\"btn btn-primary-inv login-button\" ng-click=vm.validarUsuario() type=button>Iniciar Sesión</button><!-- ng-disabled=\"vm.loginForm.$invalid\" --></div><!-- <span class=\"link_text\"><a ui-sref=\"recuperrar_clave\" title=\"\">¿Olvidaste tu contraseña?</a></span>--></form></div></div></div></div></div></div><span class=overlay-block ng-if=\"$parent.cargandoInformacion>0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/bandeja/bandeja.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><!--       <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.usuarios.listado\" >Listado</a>\r\n        </li>\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n          <a ui-sref=\"spapp.home.usuarios.registro\" >Registro</a>\r\n        </li>\r\n      </ul> --><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/layout/sidebar/sidebar.html","<div class=content-box-app><span class=box-sn-pd><div id=nav_oefa class=no-padding ng-class=\"{\'movil-menu\': !windowSistem}\" style=\"z-index: 1\"><nav class=nav-sidebar><span class=bnt-listar-tab><div class=menu-toggle ng-click=\"windowSistem = !windowSistem\" ng-class=\"{\'on\': windowSistem}\"><div class=one></div><div class=two></div><div class=three></div></div><span id=name-menu-oefa>MEN&Uacute;</span></span><div class=well style=\"border-top: 0; padding-top: 25px\"><div><ul class=\"nav nav-list\"><li class=item-menu-nav ng-click=\"vmSidebar.moduloActivo = 0\" ng-class=\"{ \'active\' : vmSidebar.moduloActivo == 0 }\"><a ui-sref=spapp.home.inicio style=\"padding: 6px 26px\"><label class=\"tree-toggler nav-header\"><span class=\"glyphicon glyphicon-home\"></span> Inicio</label></a></li><li class=item-menu-nav ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Maestro\')\"><span class=navigation-header ng-click=vmSidebar.activarModulo(2) ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 2, \'des-m\' : vmSidebar.moduloActivo != 2 }\">Maestros <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 2, \'fa-angle-right\' : vmSidebar.moduloActivo != 2 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 2\"><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Generico\')\" ng-click=\"vmSidebar.subModuloActivo = 2.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.1 }\"><a ui-sref=spapp.home.maestros.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> Maestros Genéricos</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 2.2.1\" ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Core\')\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.2.1 }\"><a ui-sref=spapp.home.etapa.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> Etapas del Proyecto</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 2.2.2\" ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Core\')\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.2.2 }\"><a ui-sref=spapp.home.normalegal.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> Normas</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 2.2.3\" ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Core\')\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.2.3 }\"><a ui-sref=spapp.home.parametro.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> Parámetros Ambientales</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 2.2.4\" ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Core\')\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.2.4 }\"><a ui-sref=spapp.home.componente.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> Componente Ambiental</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 2.2.5\" ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Core\')\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.2.5 }\"><a ui-sref=spapp.home.tipoiga.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> Tipo de IGAS</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 2.2.6\" ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Mantenimiento Core\')\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.2.6 }\"><a ui-sref=spapp.home.eor.listado><label class=\"tree-toggler nav-header\"><i class=\"flaticon-negocios ico-nav\" aria-hidden=true></i> EOR</label></a></li></ul></li><!-- 	<li class=\"item-menu-nav\"><span class=\"navigation-header\"\r\n								ng-click=\"vmSidebar.activarModulo(5)\"\r\n								ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Información de Coordinador\')\"\r\n								ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 5, \'des-m\' : vmSidebar.moduloActivo != 5 }\">\r\n									Mi Informaci&oacute;n <i class=\"fa\"\r\n									ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 5, \'fa-angle-right\' : vmSidebar.moduloActivo != 5 }\"></i>\r\n							</span>\r\n								<ul class=\"sub-menu-oefa\" ng-show=\"vmSidebar.moduloActivo == 5\">\r\n\r\n									<li\r\n										ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Coordinador de Subsector\')\"\r\n										ng-click=\"vmSidebar.subModuloActivo = 5.1\"\r\n										ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 5.1 }\">\r\n										<a ui-sref=\"spapp.home.supervision.online\"><label\r\n											class=\"tree-toggler nav-header\"><span\r\n												class=\"flaticon-perfil ico-nav\"></span> Supervisi&oacute;n\r\n												Online </label></a>\r\n									</li>\r\n								</ul></li> --><li class=item-menu-nav ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Bandejas\')\"><span class=navigation-header ng-click=vmSidebar.activarModulo(6) ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 6, \'des-m\' : vmSidebar.moduloActivo != 6 }\">Bandejas <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 6, \'fa-angle-right\' : vmSidebar.moduloActivo != 6 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 6\"><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Bandeja de Solicitudes\')\" ng-click=\"vmSidebar.subModuloActivo = 6.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 6.1 }\"><a ui-sref=spapp.home.bandeja.solicitud><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Bandeja de solicitudes</label></a></li></ul></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(7) ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Informacion de Administrado\')\" ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 7, \'des-m\' : vmSidebar.moduloActivo != 7 }\">Mi Informaci&oacute;n <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 7, \'fa-angle-right\' : vmSidebar.moduloActivo != 7 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 7\"><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Administrado\')\" ng-click=\"vmSidebar.subModuloActivo = 7.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 7.1 }\"><a ui-sref=spapp.home.supervision.administrado><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span><!-- Mi informaci&oacute;n  --> Administrado</label></a></li><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Unidad Fiscalizable\')\" ng-click=\"vmSidebar.subModuloActivo = 7.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 7.2 }\"><a ui-sref=spapp.home.supervision.accion-instalacion><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Unidades Fiscalizables</label></a></li><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Solicitud Administrado\')\" ng-click=\"vmSidebar.subModuloActivo = 7.3\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 7.3 }\"><a ui-sref=spapp.home.supervision.solicitudes><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Solicitudes De Acceso</label></a></li></ul></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(8) ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Carga de Informacion\')\" ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 8, \'des-m\' : vmSidebar.moduloActivo != 8 }\">Carga de Informaci&oacute;n</span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 8\"><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Inf. Unidades Fiscalizables\')\" ng-click=\"vmSidebar.subModuloActivo = 8.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 8.1 }\"><a ui-sref=spapp.home.supervision.cargainfo-instalacion><label class=\"tree-toggler nav-header\"><span class=\"glyphicon glyphicon-edit\"></span> Registro de Datos</label></a></li></ul></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(9) ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Reportes\') || $parent.validaOpcionSSOSisoWeb(\'Reporte de Control de Calidad\') || $parent.validaOpcionSSOSisoWeb(\'Reporte de Supervisión\') || $parent.validaOpcionSSOSisoWeb(\'Reporte preliminar\')\" ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 9, \'des-m\' : vmSidebar.moduloActivo != 9 }\">Reportes <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 9, \'fa-angle-right\' : vmSidebar.moduloActivo != 9 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 9\"><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Reporte de Control de Calidad\')\" ng-click=\"vmSidebar.subModuloActivo = 9.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 9.1 }\"><a ui-sref=spapp.home.supervision.reporte-control-calidad><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Reporte de Control de Calidad</label></a></li><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Reporte de Supervisión\')\" ng-click=\"vmSidebar.subModuloActivo = 9.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 9.2 }\"><a ui-sref=spapp.home.supervision.reporte-supervision><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Reporte de Supervisión</label></a></li><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Reporte preliminar\')\" ng-click=\"vmSidebar.subModuloActivo = 9.3\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 9.3 }\"><a ui-sref=spapp.home.supervision.reporte-preliminar><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Reporte Preliminar</label></a></li></ul></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(10) ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Seguridad\')\" ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 10, \'des-m\' : vmSidebar.moduloActivo != 10 }\">Seguridad <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 10, \'fa-angle-right\' : vmSidebar.moduloActivo != 10 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 10\"><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Usuarios por ubigeo\')\" ng-click=\"vmSidebar.subModuloActivo = 10.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 10.1 }\"><a ui-sref=spapp.home.seguridad.usuario-ubigeo><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span><!-- Mi informaci&oacute;n  --> Usuarios por Ubigeo</label></a></li><li ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Usuarios por ubigeo\')\" ng-click=\"vmSidebar.subModuloActivo = 10.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 10.2 }\"><a ui-sref=spapp.home.seguridad.configuraciones><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span><!-- Mi informaci&oacute;n  --> Configuraciones</label></a></li></ul></li><!-- PRUEBA --><!-- <li class=\"item-menu-nav\"\r\n								ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Preguntas\')\"><span\r\n								class=\"navigation-header\" ng-click=\"vmSidebar.activarModulo(8)\"\r\n								ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 8, \'des-m\' : vmSidebar.moduloActivo != 8 }\">\r\n									Preguntas <i class=\"fa\"\r\n									ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 8, \'fa-angle-right\' : vmSidebar.moduloActivo != 8 }\"></i>\r\n							</span>\r\n								<ul class=\"sub-menu-oefa\" ng-show=\"vmSidebar.moduloActivo == 8\">\r\n\r\n									<li\r\n										ng-if=\"$parent.validaOpcionSSOSisoWeb(\'Banco de Preguntas\')\"\r\n										ng-click=\"vmSidebar.subModuloActivo = 8.2\"\r\n										ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 8.2 }\">\r\n										<a ui-sref=\"spapp.home.preguntas.banco-pregunta\"><label\r\n											class=\"tree-toggler nav-header\"><span\r\n												class=\"flaticon-perfil ico-nav\"></span> Banco de preguntas </label></a>\r\n									</li>\r\n\r\n\r\n								</ul></li> --></ul></div></div></nav></div><!-- tab content --> <span id=content_oefa ui-view></span></span></div>");
$templateCache.put("app/layout/sidebar/sidebar_v1.html","<div class=\"container animated bounceInUp\"><span class=box-sn-pd><div id=nav_oefa class=no-padding style=\"z-index: 1\"><nav class=nav-sidebar><span class=bnt-listar-tab>MENÚ</span><div class=well style=\"border-top:0;padding-top: 25px\"><div><ul class=\"nav nav-list\"><li class=item-menu-nav ng-click=\"vmSidebar.moduloActivo = 0\" ng-class=\"{ \'active\' : vmSidebar.moduloActivo == 0 }\"><a ui-sref=spapp.home.inicio style=\"padding: 6px 12px\"><label class=\"tree-toggler nav-header\"><span class=\"flaticon-casa ico-nav\"></span> Inicjjjio</label></a></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(1) ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 1, \'des-m\' : vmSidebar.moduloActivo != 1 }\">Maestros <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 1, \'fa-angle-right\' : vmSidebar.moduloActivo != 1 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 1\"><!--  <li ng-click=\"vmSidebar.subModuloActivo = 1.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 1.1 }\">\r\n                      <a ui-sref=\"spapp.home.productos.listado\">\r\n                        <label class=\"tree-toggler nav-header\" ><i class=\"flaticon-negocios ico-nav\" aria-hidden=\"true\"></i> Productos</label>\r\n                      </a>\r\n                    </li>\r\n                    <li ng-click=\"vmSidebar.subModuloActivo = 1.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 1.2 }\">\r\n                      <a ui-sref=\"spapp.home.productos.listado\">\r\n                        <label class=\"tree-toggler nav-header\" ><i class=\"flaticon-mercado ico-nav\" aria-hidden=\"true\"></i> Categoria</label>\r\n                      </a>\r\n                    </li> --></ul></li><!--               <li class=\"item-menu-nav\">\r\n                <span class=\"navigation-header\" ng-click=\"vmSidebar.activarModulo(2)\" ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 2, \'des-m\' : vmSidebar.moduloActivo != 2 }\">\r\n                  Procesos\r\n                  <i class=\"fa\" ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 2, \'fa-angle-right\' : vmSidebar.moduloActivo != 2 }\"></i>\r\n                </span>\r\n                  <ul class=\"sub-menu-oefa\" ng-show=\"vmSidebar.moduloActivo == 2\">\r\n                    <li ng-click=\"vmSidebar.subModuloActivo = 2.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 2.1 }\">\r\n                      <a ui-sref=\"spapp.home.pedidos.listado\"><label class=\"tree-toggler nav-header\" ><span class=\"flaticon-mercado ico-nav\"></span> Pedido</label></a>\r\n                    </li>\r\n                  </ul>\r\n              </li> --><!--               <li class=\"item-menu-nav\">\r\n                <span class=\"navigation-header\" ng-click=\"vmSidebar.activarModulo(3)\" ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 3, \'des-m\' : vmSidebar.moduloActivo != 3 }\">\r\n                  Reportes\r\n                  <i class=\"fa\" ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 3, \'fa-angle-right\' : vmSidebar.moduloActivo != 3 }\"></i>\r\n                </span>\r\n                  <ul class=\"sub-menu-oefa\" ng-show=\"vmSidebar.moduloActivo == 3\">\r\n                    <li ng-click=\"vmSidebar.subModuloActivo = 3.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 3.1 }\">\r\n                      <a ui-sref=\"spapp.home.reportes.anio\"><label class=\"tree-togler nav-header\"><span class=\"flaticon-grafico-de-barras ico-nav\"></span> Estadísticas</label></a>\r\n                    </li>\r\n                  </ul>\r\n              </li> --><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(4) ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 4, \'des-m\' : vmSidebar.moduloActivo != 4 }\">Denuncias <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 4, \'fa-angle-right\' : vmSidebar.moduloActivo != 4 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 4\"><li ng-click=\"vmSidebar.subModuloActivo = 4.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 4.1 }\"><a ui-sref=spapp.home.denuncias.casos><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Casos</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 4.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 4.2 }\"><a ui-sref=spapp.home.denuncias.listado><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Denuncias</label></a></li><!--                     <li ng-click=\"vmSidebar.subModuloActivo = 4.3\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 4.3 }\">\r\n                      <a ui-sref=\"spapp.home.denuncias.estado\"><label class=\"tree-toggler nav-header\" ><span class=\"flaticon-perfil ico-nav\"></span> Estado General</label></a>\r\n                    </li> --><li ng-click=\"vmSidebar.subModuloActivo = 4.4\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 4.4 }\"><a ui-sref=spapp.home.denuncias.seguimiento><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span>Seguimiento</label></a></li></ul></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(6) ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 6, \'des-m\' : vmSidebar.moduloActivo != 6 }\">Bandeja <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 6, \'fa-angle-right\' : vmSidebar.moduloActivo != 6 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 6\"><li ng-click=\"vmSidebar.subModuloActivo = 6.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 6.1 }\"><a ui-sref=spapp.home.bandeja.asignadas><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> EFA</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 6.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 6.2 }\"><a ui-sref=spapp.home.bandeja.asignacion><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Denuncias</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 6.3\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 6.3 }\"><a ui-sref=spapp.home.bandeja.denunciante><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Denunciante</label></a></li></ul></li><li class=item-menu-nav><span class=navigation-header ng-click=vmSidebar.activarModulo(5) ng-class=\"{\'act-m\' : vmSidebar.moduloActivo == 5, \'des-m\' : vmSidebar.moduloActivo != 5 }\">Seguridad <i class=fa ng-class=\"{\'fa-angle-down\' : vmSidebar.moduloActivo == 5, \'fa-angle-right\' : vmSidebar.moduloActivo != 5 }\"></i></span><ul class=sub-menu-oefa ng-show=\"vmSidebar.moduloActivo == 5\"><li ng-click=\"vmSidebar.subModuloActivo = 5.1\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 5.1 }\"><a ui-sref=spapp.home.seguridad.usuarios><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Usuarios</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 5.2\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 5.2 }\"><a ui-sref=\" spapp.home.seguridad.listado\"><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Listado Usuarios</label></a></li><li ng-click=\"vmSidebar.subModuloActivo = 5.3\" ng-class=\"{ \'active\' : vmSidebar.subModuloActivo == 5.3 }\"><a ui-sref=\"  spapp.home.seguridad.clave\"><label class=\"tree-toggler nav-header\"><span class=\"flaticon-perfil ico-nav\"></span> Cambio de Clave</label></a></li></ul></li></ul></div></div></nav></div><!-- tab content --> <span id=content_oefa ui-view></span></span></div>");
$templateCache.put("app/modules/eor/eor.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/componente-parametro/componente-parametro-selector.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector de Parametro Relacionados al Componente: {{vm.prmComponente.auxComponenteNombre}}</h4></div></div><div class=modal-body name=parametroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=col-md-12><h3 class=title-slider-nt>Filtros de Búsqueda</h3></div></div><br><div class=row><div class=\"form-group col-md-3\"><label>Parámetro</label><input class=form-control type=text ng-model=vm.prmComponenteParametro.auxParametroNombre></div><div class=\"form-group col-lg-3\"><label>Unidad de Medida:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.auxCodUnidad class=\"form-control input-sm\" id=unidadmedida name=unidadmedida><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstUnidadMedida\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-md-3\"><label>Periodo:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.prmComponenteParametro.auxCodPeriodo class=\"form-control input-sm\" id=periodoeca name=periodoeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstFrecuencia\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-md-3\"><label>Norma Legal:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.auxCodNorma class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstNormaLegal\" ng-value=itemCombo.idNorma>{{itemCombo.numeroNorma}}</option></select></div></div></div><div class=row><div class=\"form-group col-lg-3\"><label>Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.matriz class=\"form-control input-sm\" id=matriz ng-change=\"vm.listarSubMatriz(vm.prmComponenteParametro.matriz);vm.prmComponenteParametro.submatriz=0 \" name=matriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Sub Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.submatriz class=\"form-control input-sm\" id=submatriz name=submatriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstSubMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Componente</th><th style=\"text-align: center\">Parámetro</th><th style=\"text-align: center\">Unidad Medida</th><th style=\"text-align: center\">Periodo</th><th style=\"text-align: center\">Valor</th><th style=\"text-align: center\">Norma</th><th style=\"text-align: center\">Selección</th></tr></thead><tbody><tr ng-show=\"vm.lstParametrosComponente.length==0\"><td colspan=8 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametrosComponente | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=Componente style=\"text-align: center\">{{item.auxComponenteNombre}}</td><td data-label=Nombre style=\"text-align: center\">{{item.auxParametroNombre}}</td><td data-label=\"Unidad Medida\" style=\"text-align: center\">{{item.auxUnidadNombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.auxPeriodoNombre}}</td><td data-label=Valor style=\"text-align: center\">{{item.auxValor}}</td><td data-label=Norma style=\"text-align: center\">{{item.auxNormaNombre}}</td><td class=text-center data-label=Selección><input type=checkbox ng-model=item.blSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.guardar()><i aria-hidden=true></i> Aceptar</button></div></div></span></div>");
$templateCache.put("app/modules/componente-parametro/componente-parametro.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Parámetros relacionados al componente</h4></div></div><div class=modal-body name=parametroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-3\"><label>Parámetro</label><input class=form-control type=text ng-model=vm.prmComponenteParametro.auxParametroNombre></div><div class=\"form-group col-lg-3\"><label>Unidad de Medida:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.auxCodUnidad class=\"form-control input-sm\" id=unidadmedida name=unidadmedida><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstUnidadMedida\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-md-3\"><label>Periodo:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.prmComponenteParametro.auxCodPeriodo class=\"form-control input-sm\" id=periodoeca name=periodoeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstFrecuencia\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-md-3\"><label>Norma Legal:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.auxCodNorma class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstNormaLegal\" ng-value=itemCombo.idNorma>{{itemCombo.numeroNorma}}</option></select></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregar() type=button><span class=icon-agregar></span> Agregar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Parámetro</th><th style=\"text-align: center\">Unidad Medida</th><th style=\"text-align: center\">Periodo</th><th style=\"text-align: center\">Valor</th><th style=\"text-align: center\">Norma</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstParametrosComponente.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametrosComponente | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=Nombre style=\"text-align: center\">{{item.auxParametroNombre}}</td><td data-label=\"Unidad Medida\" style=\"text-align: center\">{{item.auxUnidadNombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.auxPeriodoNombre}}</td><td data-label=Valor style=\"text-align: center\">{{item.auxValor}}</td><td data-label=Norma style=\"text-align: center\">{{item.auxNormaNombre}}</td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=text-center><dir-pagination-controls boundary-links=true></dir-pagination-controls></div></div></span></div>");
$templateCache.put("app/modules/informe/informe-presentacion.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Informes de Presentación</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Informes</li><li>Informes de Presentación</li></ol></span></div></div><div class=row><div class=\"form-group col-lg-12\" style=\"border: solid 1px #144aa7\"><label style=\"font-weight: bold; font-size: 15px; color: #111\">UNIDAD FISCALIZABLE SELECCIONADA:</label>{{vm.prmInstalacion.numeroInstalacion}}:<label>{{ vm.prmInstalacion.direccion}}</label>; {{vm.prmInstalacion.departamento.descripcionDepartamento}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.distrito.descripcionDistrito}}</div></div><div class=row><div class=\"form-group col-md-2\"><label>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>--Todos--</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option></select></div><div class=\"form-group col-md-2\"><label>Tipo</label><select class=\"form-control input-sm\" id=tipodocumento ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoInformes\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row ng-show=vm.mostrarNuevo><div class=col-md-12><h3 class=title-slider-nt>Nuevo Informe</h3></div><br><div class=\"form-group col-md-2\"><label>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>--Todos--</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option></select></div><div class=\"form-group col-md-2\"><label>Tipo</label><select class=\"form-control input-sm\" id=tipodocumento ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoInformes\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-4\"><label>Comentario</label><input class=\"form-control input-sm\" maxlength=4000 ng-model=vm.objInformeMonitoreo.comentario type=text></div><div class=\"form-group col-lg-3\"><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumentoInformeMonitoreo id=fileArchivoInformeMonitoreo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardarItem() type=button><span class=icon-agregar></span> Grabar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=10%>N° Item</th><th style=\"text-align: center\" width=50%>Periodo</th><th style=\"text-align: center\" width=20%>Informe</th><th style=\"text-align: center\" width=20%>Comentario</th><th style=\"text-align: center\" width=20%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstEtapas.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstInformes | itemsPerPage: config.itemsPerPage\" pagination-id=coutinforme><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Periodo style=\"text-align: center\">{{item.informenombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.comentario}}</td><td class=text-center data-label=Acciones></td></tr></tbody></table><dir-pagination-controls pagination-id=coutinforme></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/inicio/inicio.html","<style type=text/css>.titulo {\r\n	/* background-color: #144AA7; */\r\n	font-size: 15px;\r\n	font-weight: bolder;\r\n	margin-left: 15px;\r\n	font-weight: bolder;\r\n	/* border-bottom: solid 2px #144AA7; */\r\n	font-size: 15px;\r\n	font-weight: bolder;\r\n	text-align: center;\r\n}</style><a ui-sref=spapp.home.supervision.accion-instalacion id=linkInstalacion></a><div class=\"col-lg-12 animated bounceInUp\"><div class=panel-tab-app><div class=row ng-show=!vm.verGrafico><div class=\"col-md-12 slider-desing\"><div active=vm.activeSliderImagenes2 interval=vm.myInterval no-wrap=vm.noWrapSlides uib-carousel=\"\"><div index=slide.id ng-repeat=\"slide in vm.slider track by slide.id\" uib-slide=\"\"><div class=box-img-carrucel></div><img ng-src={{slide.image}} style=\"margin: auto\"><div class=carousel-caption><h4><span>{{slide.title}}</span></h4><p>{{slide.subtitulo}}</p></div></div></div></div></div><br><div class=row ng-show=vm.verGrafico><div class=row style=\"margin-left: 0px\" ng-show=!vm.esAdministrado><div class=\"form-group col-md-12\"><div id=chartBarCoorporativo style=\"height: 300px\" class=col-md-6></div><div id=chartBarRanking style=\"height: 300px\" class=col-md-6></div></div></div><br><div class=row style=\"border: solid 0px #144AA7; margin-left: 0px\"><div class=\"form-group col-md-2\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.changeDepartamento();vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigodepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-2\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=vm.changeProvincia() ng-model=vm.filtro.codigoprovincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p>Administrado</p></strong><input ng-model=vm.administrado.entidad.razonSocial type=text class=\"form-control input-sm\" disabled></div><div class=\"input-group col-md-2\"><strong><p>Acción</p></strong><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.buscarAdministrado()><span class=\"glyphicon glyphicon-search\"></span></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.limpiarAdministrado()><span class=\"glyphicon glyphicon-trash\"></span></button></div></div><br><div class=row style=\"margin-left: 0px\"><div class=\"form-group col-md-12\"><div id=chartPieTipoEstablecimiento style=\"height: 300px\" class=col-md-4 ng-show=vm.verTipoEstablecimiento></div><div id=chartBarInstalaciones style=\"height: 300px\" class=col-md-8 ng-show=vm.verDistribucionUbigeo></div></div></div><div class=row style=\"margin-left: 0px\"><div class=\"form-group col-md-12\" ng-show=vm.verIncumplimiento><div id=chartBarCumplimiento style=\"height: 300px\" class=col-md-8></div><div id=chartPieIncParametros style=\"height: 300px\" class=col-md-4 ng-show=vm.verIncumplimientoParametro></div></div></div><!--  <div class=\"row\" style=\"margin-left: 0px\"\r\n				ng-show=\"!vm.esAdministrado\">\r\n				<div class=\"form-group col-md-6\">\r\n					<div id=\"chartBarExcedeConcetra\" style=\"height: 300px\"\r\n						class=\"col-md-12\" ng-show=\"vm.verDistribucionUbigeoExcedeConcetra\"></div>\r\n				</div>\r\n			</div>  --></div></div></div>");
$templateCache.put("app/modules/acceso/acceso.html","<!-- <div class=\"col-md-12 sin_padding block-page\">\r\n  <div>\r\n    <div class=\"panel panel-tab-app with-nav-tabs panel-default\">\r\n      <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.usuarios.listado\" >Listado</a>\r\n        </li>\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n          <a ui-sref=\"spapp.home.usuarios.registro\" >Registro</a>\r\n        </li>\r\n      </ul> \r\n      <div class=\"panel-body\" ui-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n--><!-- <div id=\"bg\">\r\n  <img src=\"assets/images/fondo/amazonas-fondo.jpg\" alt=\"\">\r\n</div> --><nav class=\"navbar navbar-fixed-top\" id=nav-top-web><div class=container><div class=navbar-header><!--<button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\">\r\n            <span class=\"sr-only\">Toggle navigation</span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            </button>--> <a class=navbar-brand href=#><img alt=\"\" class=\"img-responsive logo-oefa-inicio\" src=assets/images/oefa-logo-header.svg></a><a class=navbar-brand href=#><img alt=\"\" class=\"img-responsive logo-sinada-inicio\" src=assets/images/logo-siso.svg></a></div></div></nav><section class=barra-img></section><section class=seccion-sinada_denuncia-invitado><div class=container style=\"padding: 50px;background: white;border-radius: 5px;    margin-top: 70px\"><div class=panel-body ui-view=\"\"></div></div></section><span class=overlay-block ng-if=\"$parent.cargandoInformacion>0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/maestro/maestro.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><!--       <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.maestros.listado\" >Listado</a>\r\n        </li>\r\n              <li id=\"link-tab-01\" ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n                <a ui-sref=\"vlibrary.home.usuario.listado\" >Listado</a>\r\n              </li>\r\n              <li id=\"link-tab-02\" ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n                <a ui-sref=\"vlibrary.home.usuario.registro\" >Registro</a>\r\n              </li>\r\n      </ul> --><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/parametro/parametro.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/normalegal/normalegal.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/preguntas/preguntas.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><!--       <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.usuarios.listado\" >Listado</a>\r\n        </li>\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n          <a ui-sref=\"spapp.home.usuarios.registro\" >Registro</a>\r\n        </li>\r\n      </ul> --><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/residuos/declaracion_anual_residuos.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Residuos Sólidos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Residuos Sólidos</li><li>Declaración de Manejo de Residuos Sólidos No Municipales</li></ol></span></div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-md-2\"><label>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmResiduo.periodo><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO DMRS\')\"><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>N°</th><th style=\"text-align: center\" width=10%>Periodo</th><th style=\"text-align: center\" width=20%>Documento</th><th style=\"text-align: center\" width=10%>Peligrosos (TN)</th><th style=\"text-align: center\" width=10%>Otros (TN)</th><th style=\"text-align: center\" width=10%>Fecha Presentación</th><th style=\"text-align: center\" width=10%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstResiduos.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstResiduos | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduomain><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Documento style=\"text-align: center\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{item.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{item.idresiduo}}>{{item.nombredocumento}}</a></td><td data-label=\"Peligrosos (TN)\" style=\"text-align: center\">{{item.peligrosos}}</td><td data-label=\"Otros (TN)\" style=\"text-align: center\">{{item.otros}}</td><td data-label=\"Fecha Presentación\" style=\"text-align: center\">{{item.fechapresentaciontexto}}</td><td data-label=Acción style=\"text-align: center\"><button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR DMRS\')\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=\"glyphicon glyphicon-pencil\"></span></button><!-- <button class=\"btn btn-default btn-sm\"\r\n										ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'VER DMRS\')\"\r\n										ng-click=\"vm.agregarItem(item)\" type=\"button\"\r\n										uib-tooltip=\"Ver\">\r\n										<span class=\"glyphicon glyphicon-eye-open\"> </span>\r\n									</button> --> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" uib-tooltip=Eliminar ng-click=vm.confirmarEliminacionResultado(item)><i aria-hidden=true class=\"glyphicon glyphicon-trash\"></i></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduomain></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></span></div>");
$templateCache.put("app/modules/residuos/declaracion_anual_residuos_edicion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmResiduo.idresiduo == 0 ? \'Registro de \' : \'Detalle de \' }} Declaración de Manejo de Residuos Sólidos No Municipales</h4></div></div><div class=modal-body name=declaracionresiduoDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><label class=important-box>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmResiduo.periodo ng-disabled=\"vm.prmResiduo.idresiduo!=0 && !vm.blEditar\"><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-2\"><strong>Fecha Presentación</strong> <input type=date ng-model=vm.prmResiduo.fechapresentacion ng-disabled=\"vm.prmResiduo.idresiduo!=0 && !vm.blEditar\" class=\"form-control input-sm\"></div><div class=\"form-group col-lg-3\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><label class=important-box>Archivo</label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div ng-show=\"vm.prmResiduo.idresiduo!=0\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{vm.prmResiduo.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{vm.prmResiduo.idresiduo}}>{{vm.prmResiduo.nombredocumento}}</a></div></div><uib-tabset active=vm.active><uib-tab heading=\"Características del Residuo\" index=0><br><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>Residuo</th><th style=\"text-align: center\" width=5%>Unidad Medida</th><th style=\"text-align: center\" width=5%>Enero</th><th style=\"text-align: center\" width=5%>Febrero</th><th style=\"text-align: center\" width=5%>Marzo</th><th style=\"text-align: center\" width=5%>Abril</th><th style=\"text-align: center\" width=5%>Mayo</th><th style=\"text-align: center\" width=5%>Junio</th><th style=\"text-align: center\" width=5%>Julio</th><th style=\"text-align: center\" width=5%>Agosto</th><th style=\"text-align: center\" width=5%>Septiembre</th><th style=\"text-align: center\" width=5%>Octubre</th><th style=\"text-align: center\" width=5%>Noviembre</th><th style=\"text-align: center\" width=5%>Diciembre</th><th ng-show=\"item.idresiduo == 0 || vm.blEditar\" style=\"text-align: center\" width=5%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmResiduo.lstCaracteristicas.length==0\"><td colspan=15 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmResiduo.lstCaracteristicas | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduos><td data-label=Residuo style=\"text-align: center\"><div ng-show=\"item.idTipo == 1\">Peligroso</div><div ng-show=\"item.idTipo == 2\">Otros</div></td><td data-label=\"Unidad Medida\" style=\"text-align: center\">TONELADA (TN)</td><td data-label=Enero style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantEnero ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantEnero}}</label></td><td data-label=Febrero style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantFebrero ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantFebrero}}</label></td><td data-label=Marzo style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantMarzo ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantMarzo}}</label></td><td data-label=Abril style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantAbril ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantAbril}}</label></td><td data-label=Mayo style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantMayo ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantMayo}}</label></td><td data-label=Junio style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantJunio ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantJunio}}</label></td><td data-label=Julio style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantJulio ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantJulio}}</label></td><td data-label=Agosto style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantAgosto ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantAgosto}}</label></td><td data-label=Septiembre style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantSeptiembre ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantSeptiembre}}</label></td><td data-label=Octubre style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantOctubre ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantOctubre}}</label></td><td data-label=Noviembre style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantNoviembre ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantNoviembre}}</label></td><td data-label=Diciembre style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ style=\"width: 90px\" ng-model=item.cantDiciembre ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantDiciembre}}</label></td><td data-label=Acción style=\"text-align: center\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-click=vm.confirmarEliminacionCarac($index,item) type=button uib-tooltip=Limpiar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduos></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=Transporte index=1><br><div class=row ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><div class=\"form-group col-md-2\" style=\"margin-top: 10px\"><p style=\"text-align: justify\">&iquest;Tiene residuos que declarar?</p></div><div class=\"form-group col-md-10\"><button class=\"btn btn-default btn-sm\" ng-click=vm.tieneResiduosTransporte(false)><i class=\"glyphicon glyphicon-remove\" aria-hidden=true></i> No tengo residuos</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.tieneResiduosTransporte(true)><i class=\"glyphicon glyphicon-ok\" aria-hidden=true></i> Si tengo residuos</button></div></div><div class=row ng-if=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResTransporte==true\"><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" ng-disabled=true placeholder=Ruc maxlength=11 ng-model=vm.dataResiduoTrans.ruceps type=text></div><div class=\"form-group col-md-6\"><input class=\"form-control input-sm\" disabled ng-model=vm.dataResiduoTrans.nombreeps type=text></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.obtenerEor(\'TRANSPORTE\')\" type=button><span class=icon-check></span> Buscar</button></div></div><div class=row ng-if=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResTransporte==true\"><div class=\"form-group col-md-2\"><label>N° Registro</label><input type=text class=\"form-control input-sm\" ng-disabled=true ng-model=vm.dataResiduoTrans.nroregistro></div><div class=\"form-group col-md-2\"><label>Fecha de Venc.</label><input type=date class=\"form-control input-sm\" ng-model=vm.dataResiduoTrans.fechavencimiento></div><!-- <div class=\"form-group col-md-2\">\r\n				<label>Fecha de Ejecución</label> <input type=\"date\"\r\n					class=\"form-control input-sm\"\r\n					ng-model=\"vm.dataResiduoTrans.fechaejecucion\" />\r\n			</div> --><div class=\"form-group col-md-2\"><label>Cantidad Transportada (TN)</label><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ ng-model=vm.dataResiduoTrans.cantidad></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.dataResiduoTrans.nombreeps==null || vm.dataResiduoTrans.nombreeps == \'\' || \r\n					vm.dataResiduoTrans.nroregistro==null || vm.dataResiduoTrans.nroregistro==\'\'\" ng-click=vm.agregarResiduoTransporte() type=button><span class=icon-plus></span> Agregar</button></div></div><div class=row ng-show=\"vm.tieneResTransporte==true || vm.prmResiduo.lstTransporte.length>0\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>RUC</th><th style=\"text-align: center\" width=5%>EO-RS</th><th style=\"text-align: center\" width=5%>N° Registro</th><th style=\"text-align: center\" width=5%>Fecha de Venc.</th><!-- <th style=\"text-align: center\" width=\"5%\">Fecha de Ejec.</th> --><th style=\"text-align: center\" width=5%>Cantidad</th><th style=\"text-align: center\" width=5% ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmResiduo.lstTransporte.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmResiduo.lstTransporte | itemsPerPage: config.itemsPerPage\" pagination-id=couttransporte><td data-label=RUC style=\"text-align: center\">{{item.ruceps}}</td><td data-label=EO-RS style=\"text-align: center\">{{item.nombreeps}}</td><td data-label=\"N° Registro\" style=\"text-align: center\">{{item.nroregistro}}</td><td data-label=\"Fecha de Venc.\" style=\"text-align: center\">{{item.fechavencimientotexto}}</td><!-- 	<td data-label=\"Fecha de Ejec.\" style=\"text-align: center\">{{item.fechaejecuciontexto}}</td> --><td data-label=Cantidad style=\"text-align: center\">{{item.cantidad}}</td><td data-label=Acción style=\"text-align: center\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-click=vm.confirmarEliminacionTrans($index,item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=couttransporte></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=\"Disposición Final\" index=2><br><div class=row ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><div class=\"form-group col-md-2\" style=\"margin-top: 10px\"><p style=\"text-align: justify\">&iquest;Tiene residuos que declarar?</p></div><div class=\"form-group col-md-10\"><button class=\"btn btn-default btn-sm\" ng-click=vm.tieneResiduosDisposicion(false)><i class=\"glyphicon glyphicon-remove\" aria-hidden=true></i> No tengo residuos</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.tieneResiduosDisposicion(true)><i class=\"glyphicon glyphicon-ok\" aria-hidden=true></i> Si tengo residuos</button></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResDisposicion\"><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" ng-disabled=true placeholder=RUC maxlength=11 ng-model=vm.dataResiduoDispo.ruceps type=text></div><div class=\"form-group col-md-6\"><input class=\"form-control input-sm\" disabled ng-model=vm.dataResiduoDispo.nombreeps type=text></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.obtenerEor(\'DISPOSICION\')\" type=button><span class=icon-check></span> Buscar</button></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResDisposicion\"><div class=\"form-group col-md-2\"><label>N° Registro</label><input type=text ng-disabled=true ng-model=vm.dataResiduoDispo.nroregistro class=\"form-control input-sm\"></div><div class=\"form-group col-md-2\"><label>Fecha de Venc.</label><input type=date ng-model=vm.dataResiduoDispo.fechavencimiento class=\"form-control input-sm\"></div><!-- 	<div class=\"form-group col-md-2\">\r\n				<label>Fecha de Ejecución</label> <input type=\"date\"\r\n					class=\"form-control input-sm\"\r\n					ng-model=\"vm.dataResiduoDispo.fechaejecucion\" />\r\n			</div> --><div class=\"form-group col-md-2\"><label>Cantidad (TN)</label><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ ng-model=vm.dataResiduoDispo.cantidad></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.dataResiduoDispo.nombreeps==null || vm.dataResiduoDispo.nombreeps==\'\' ||\r\n					vm.dataResiduoDispo.nroregistro==null || vm.dataResiduoDispo.nroregistro == \'\'\" ng-click=vm.agregarResiduoDisposicion() type=button><span class=icon-plus></span> Agregar</button></div></div><div class=row ng-show=\"vm.tieneResDisposicion==true || vm.prmResiduo.lstDisposicion.length>0\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>RUC</th><th style=\"text-align: center\" width=5%>EO-RS</th><th style=\"text-align: center\" width=5%>N° Registro</th><th style=\"text-align: center\" width=5%>Fecha de Venc.</th><th style=\"text-align: center\" width=5%>Cantidad</th><th style=\"text-align: center\" width=5% ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmResiduo.lstDisposicion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmResiduo.lstDisposicion | itemsPerPage: config.itemsPerPage\" pagination-id=couttransporte><td data-label=RUC style=\"text-align: center\">{{item.ruceps}}</td><td data-label=EO-RS style=\"text-align: center\">{{item.nombreeps}}</td><td data-label=\"N° Registro\" style=\"text-align: center\">{{item.nroregistro}}</td><td data-label=\"Fecha de Venc.\" style=\"text-align: center\">{{item.fechavencimientotexto}}</td><td data-label=Cantidad style=\"text-align: center\">{{item.cantidad}}</td><td data-label=Acción style=\"text-align: center\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-click=vm.confirmarEliminacionDispo($index,item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutdisposicion></dir-pagination-controls></div></div></div></uib-tab></uib-tabset><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() type=button id=btnRegistrarDeclaracion ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\" ng-disabled=\"vm.prmResiduo.lstCaracteristicas.length==0 || (vm.tieneResTransporte==true && vm.prmResiduo.lstTransporte.length==0) || (vm.tieneResDisposicion==true && vm.prmResiduo.lstDisposicion.length==0) || vm.prmResiduo.periodo==0 || vm.prmResiduo.frecuencia==0 || vm.prmResiduo.numero_frecuencia==0 || (vm.listaArchivos.length == 0 && (vm.prmResiduo.uiid==null || vm.prmResiduo.uiid==\'\'))\" uib-tooltip=\"{{ vm.prmResiduo.idresiduo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmResiduo.idresiduo == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"glyphicon glyphicon-arrow-left\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><span class=important-box></span> Campo obligatorio.</div></div><button id=btnRefrescar style=\"display: none\" ng-click=vm.refrescar() type=button></button></span></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/residuos/manifiesto_residuos.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Residuos Sólidos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Residuos Sólidos</li><li>Manifiesto de Residuos Peligrosos</li></ol></span></div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-md-2\"><label>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmResiduo.periodo><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO MMRS\')\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>N°</th><th style=\"text-align: center\" width=10%>Periodo</th><th style=\"text-align: center\" width=10%>Frecuencia</th><th style=\"text-align: center\" width=10%>N° Frecuencia</th><th style=\"text-align: center\" width=10%>Fecha Presentación</th><th style=\"text-align: center\" width=10%>Cantidad (TN)</th><th style=\"text-align: center\" width=20%>Documento</th><th style=\"text-align: center\" width=10%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstResiduos.length==0\"><td colspan=8 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstResiduos | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduomain><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Frecuencia style=\"text-align: center\">{{item.frecuenciaNombre}}</td><td data-label=\"N° Frecuencia\" style=\"text-align: center\"><div ng-show=\"item.numero_frecuencia == 1\">I</div><div ng-show=\"item.numero_frecuencia == 2\">II</div><div ng-show=\"item.numero_frecuencia == 3\">III</div><div ng-show=\"item.numero_frecuencia == 4\">IV</div></td><td data-label=\"Fecha Presentación\" style=\"text-align: center\">{{item.fechapresentaciontexto}}</td><td data-label=\"Cantidad (TN)\" style=\"text-align: center\">{{item.cantTotal}}</td><td data-label=Documento style=\"text-align: center\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{item.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{item.idresiduo}}>{{item.nombredocumento}}</a></td><td data-label=Acción style=\"text-align: center\"><button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR DMRS\')\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=\"glyphicon glyphicon-pencil\"></span></button><!-- <button class=\"btn btn-default btn-sm\"\r\n										ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'VER MMRS\')\"\r\n										ng-click=\"vm.agregarItem(item)\" type=\"button\"\r\n										uib-tooltip=\"Ver\">\r\n										<span class=\"glyphicon glyphicon-eye-open\"> </span>\r\n									</button> --> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" uib-tooltip=Eliminar ng-click=vm.confirmarEliminacionResultado(item)><i aria-hidden=true class=\"glyphicon glyphicon-trash\"></i></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduomain></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></span></div>");
$templateCache.put("app/modules/residuos/manifiesto_residuos_edicion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmResiduo.idresiduo == 0 ? \'Registro de \' : \'Detalle de \' }} Manifiesto de Residuos Peligrosos:</h4></div></div><div class=modal-body name=manifiestoresiduoDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-1\"><label class=important-box>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmResiduo.periodo ng-disabled=\"vm.prmResiduo.idresiduo!=0 && !vm.blEditar\"><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option></select></div><div class=\"form-group col-md-2\"><strong>Fecha Presentación</strong> <input type=date ng-model=vm.prmResiduo.fechapresentacion ng-disabled=\"vm.prmResiduo.idresiduo!=0 && !vm.blEditar\" class=\"form-control input-sm\"></div><div class=\"form-group col-md-2\"><label class=important-box>Frecuencia</label><select disabled ng-model=vm.prmResiduo.frecuencia class=\"form-control input-sm\"><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><label class=important-box>N° Frecuencia</label><select ng-model=vm.prmResiduo.numero_frecuencia ng-disabled=\"vm.prmResiduo.idresiduo!=0 && !vm.blEditar\" class=\"form-control input-sm\"><option ng-value=1>I</option><option ng-value=2>II</option><option ng-value=3>III</option><option ng-value=4>IV</option></select></div><div class=\"form-group col-lg-3\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><label class=important-box>Archivo</label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmResiduo.idresiduo!=0\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{vm.prmResiduo.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{vm.prmResiduo.idresiduo}}>{{vm.prmResiduo.nombredocumento}}</a></div></div><uib-tabset active=vm.active><uib-tab heading=\"Características del Residuo\" index=0><br><!-- <div class=\"row\" ng-show=\"vm.prmResiduo.idresiduo==0\">\r\n			<div class=\"form-group col-md-2\">\r\n				<label class=\"important-box\">Estado</label> <select\r\n					class=\"form-control input-sm\" id=\"tipodocumento\"\r\n					ng-model=\"vm.dataResiduoCarac.estadoResiduo\">\r\n					<option ng-value=\"0\">Seleccione</option>\r\n					<option ng-value=\"1\">Sólido</option>\r\n					<option ng-value=\"2\">Semi-Sólido</option>\r\n				</select>\r\n			</div>\r\n			<div class=\"form-group col-md-2\">\r\n				<label class=\"important-box\">Unidad Medida</label> <select\r\n					class=\"form-control input-sm\" id=\"tipodocumento\"\r\n					ng-model=\"vm.dataResiduoCarac.codUnidad\">\r\n					<option ng-repeat=\"item in vm.lstUnidadMedida\"\r\n						ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion\r\n						}}</option>\r\n				</select>\r\n			</div>\r\n			<div class=\"form-group col-md-2\">\r\n				<label class=\"important-box\">Cantidad</label> <input type=\"text\"\r\n					class=\"form-control input-sm\" id=\"tipodocumento\"\r\n					ng-model=\"vm.dataResiduoCarac.cantTotal\" />\r\n			</div>\r\n			<div class=\"form-group col-md-2\">\r\n				<button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n					ng-disabled=\"vm.dataResiduoCarac.codUnidad==0|| vm.dataResiduoCarac.estadoResiduo==0 ||\r\n					  vm.dataResiduoCarac.cantTotal==0.0\"\r\n					ng-click=\"vm.agregarResiduoCaracteristica()\" type=\"button\"\r\n					uib-tooltip=\"Agregar Característica\">\r\n					<span class=\"glyphicon glyphicon-ok spac-btn-r\"> </span>Agregar\r\n				</button>\r\n			</div>\r\n		</div> --><!-- <div class=\"row\" ng-show=\"vm.prmResiduo.idresiduo==0\">\r\n			<div class=\"form-group col-md-12\">\r\n				<label class=\"title-slider-nt\"> <span>Peligrosidad</span>\r\n				</label>\r\n			</div>\r\n		</div> --><!-- <div class=\"row\" ng-show=\"vm.prmResiduo.idresiduo==0\">\r\n			<div class=\"form-group col-md-3\"\r\n				ng-repeat=\"item in vm.lstPeligrosidad\">\r\n				{{item.descripcion}} <input type=\"checkbox\"\r\n					ng-model=\"item.peligrosidad\" />\r\n			</div>\r\n		</div>\r\n --><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=1% ng-show=\"item.idresiduo == 0 || vm.blEditar\"></th><th style=\"text-align: center\" width=5%>Estado</th><th style=\"text-align: center\" width=5%>Descripcion</th><th style=\"text-align: center\" width=5%>Unidad Medida</th><th style=\"text-align: center\" width=5%>Cantidad</th><th style=\"text-align: center\" width=40%>Peligrosidad</th></tr></thead><tbody><tr ng-show=\"vm.prmResiduo.lstCaracteristicas.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmResiduo.lstCaracteristicas | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduos><td data-label=Agregar style=\"text-align: center\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><div ng-show=\"item.estadoResiduo == 1\"><button class=\"btn btn-flat btn-primary-inv btn-xs btn-pd-5\" ng-click=vm.agregarResiduoCaracteristica(1) type=button uib-tooltip=\"Agregar Sólido\"><span class=\"glyphicon glyphicon-plus\"></span></button></div><div ng-show=\"item.estadoResiduo == 2\"><button class=\"btn btn-flat btn-primary-inv btn-xs btn-pd-5\" ng-click=vm.agregarResiduoCaracteristica(2) type=button uib-tooltip=\"Agregar Semi-Sólido\"><span class=\"glyphicon glyphicon-plus\"></span></button></div><div ng-show=\"item.estadoResiduo == 1 && vm.cantSolido>1\"><button class=\"btn btn-flat btn-primary-inv btn-xs btn-pd-5\" ng-click=vm.eliminarResiduoCaracteristica(item) type=button uib-tooltip=\"Eliminar Sólido\"><span class=\"glyphicon glyphicon-minus\"></span></button></div><div ng-show=\"item.estadoResiduo == 2 && vm.cantSemisolido>1\"><button class=\"btn btn-flat btn-primary-inv btn-xs btn-pd-5\" ng-click=vm.eliminarResiduoCaracteristica(item) type=button uib-tooltip=\"Eliminar Semi-Sólido\"><span class=\"glyphicon glyphicon-minus\"></span></button></div></td><td data-label=Estado style=\"text-align: center\"><div ng-show=\"item.estadoResiduo == 1\">Sólido</div><div ng-show=\"item.estadoResiduo == 2\">Semi-Sólido</div></td><td data-label=Descripcion style=\"text-align: center\"><input type=text class=\"form-control input-sm\" ng-model=item.descripcion ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.descripcion}}</label></td><td data-label=\"Unidad Medida\" style=\"text-align: center\">TONELADA (TN)</td><td data-label=Cantidad style=\"text-align: center\"><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ ng-model=item.cantTotal ng-show=\"item.idresiduo == 0 || vm.blEditar\"><label ng-show=\"item.idresiduo != 0 && !vm.blEditar\">{{item.cantTotal}}</label></td><td data-label=Peligrosidad style=\"text-align: center\"><div class=\"form-group col-md-12\">Autombustibilidad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isAutocombustibilidad> Reactividad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isRadiactividad> Patogenicidad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isPatogenisidad> Explosividad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isExplosividad> Toxicidad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isToxicidad> Corrosividad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isCorrosividad> Radiactividad &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isReactividad> Otros &nbsp;<input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=item.isOtros></div><div class=\"form-group col-md-3\" ng-repeat=\"it in item.peligrosidadArray\">{{it.descripcion}} <input type=checkbox ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-model=it.peligrosidad></div></td><!-- <td data-label=\"Acción\" style=\"text-align: center\">\r\n									<button class=\"btn btn-default btn-sm\"\r\n										ng-disabled=\"item.idresiduo != 0\"\r\n										ng-click=\"vm.confirmarEliminacionCarac($index,item)\"\r\n										type=\"button\" uib-tooltip=\"Eliminar\">\r\n										<span class=\"glyphicon glyphicon-trash\"> </span>\r\n									</button>\r\n								</td> --></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduos></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=Transporte index=1><br><div class=row ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><div class=\"form-group col-md-2\" style=\"margin-top: 10px\"><p style=\"text-align: justify\">&iquest;Tiene residuos que declarar?</p></div><div class=\"form-group col-md-10\"><button class=\"btn btn-default btn-sm\" ng-click=vm.tieneResiduosTransporte(false)><i class=\"glyphicon glyphicon-remove\" aria-hidden=true></i> No tengo residuos</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.tieneResiduosTransporte(true)><i class=\"glyphicon glyphicon-ok\" aria-hidden=true></i> Si tengo residuos</button></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResTransporte==true\"><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" disabled placeholder=RUC maxlength=11 ng-model=vm.dataResiduoTrans.ruceps type=text></div><div class=\"form-group col-md-6\"><input class=\"form-control input-sm\" disabled ng-model=vm.dataResiduoTrans.nombreeps type=text></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.obtenerEor(\'TRANSPORTE\')\" type=button><span class=icon-check></span> Buscar</button></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResTransporte==true\"><div class=\"form-group col-md-2\"><label>N° Registro</label><input type=text class=\"form-control input-sm\" ng-disabled=true ng-model=vm.dataResiduoTrans.nroregistro></div><div class=\"form-group col-md-2\"><label>Fecha de Venc.</label><input type=date class=\"form-control input-sm\" ng-model=vm.dataResiduoTrans.fechavencimiento></div><!-- <div class=\"form-group col-md-2\">\r\n				<label>Fecha de Ejec.</label> <input type=\"date\"\r\n					class=\"form-control input-sm\"\r\n					ng-model=\"vm.dataResiduoTrans.fechaejecucion\" />\r\n			</div> --><div class=\"form-group col-md-2\"><label>Cantidad Transportada (TN)</label><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ ng-model=vm.dataResiduoTrans.cantidad></div><!-- 			<div class=\"form-group col-md-2\">\r\n				<label>N° Autoriza. Municipal</label> <input type=\"text\"\r\n					class=\"form-control input-sm\" />\r\n			</div>\r\n			<div class=\"form-group col-md-2\">\r\n				<label>N° Aprobación Ruta</label> <input type=\"text\"\r\n					class=\"form-control input-sm\" />\r\n			</div>\r\n --><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.dataResiduoTrans.nombreeps==null || vm.dataResiduoTrans.nombreeps == \'\' || \r\n					vm.dataResiduoTrans.nroregistro==null || vm.dataResiduoTrans.nroregistro==\'\'\" ng-click=vm.agregarResiduoTransporte() type=button><span class=icon-plus></span> Agregar</button></div></div><div class=row ng-show=\"vm.tieneResTransporte==true || vm.prmResiduo.lstTransporte.length>0\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>RUC</th><th style=\"text-align: center\" width=5%>EO-RS</th><th style=\"text-align: center\" width=5%>N° Registro</th><th style=\"text-align: center\" width=5%>Fecha de Venc.</th><th style=\"text-align: center\" width=5%>Cantidad</th><th style=\"text-align: center\" width=5% ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmResiduo.lstTransporte.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmResiduo.lstTransporte | itemsPerPage: config.itemsPerPage\" pagination-id=couttransporte><td data-label=RUC style=\"text-align: center\">{{item.ruceps}}</td><td data-label=EO-RS style=\"text-align: center\">{{item.nombreeps}}</td><td data-label=\"N° Registro\" style=\"text-align: center\">{{item.nroregistro}}</td><td data-label=\"Fecha de Venc.\" style=\"text-align: center\">{{item.fechavencimientotexto}}</td><!-- <td data-label=\"Fecha de Ejec.\" style=\"text-align: center\">{{item.fechaejecuciontexto}}</td> --><td data-label=Cantidad style=\"text-align: center\">{{item.cantidad}}</td><!-- <td data-label=\"N° Autoriza. Municipal\"\r\n									style=\"text-align: center\"></td>\r\n								<td data-label=\"N° Aprobación Ruta\" style=\"text-align: center\"></td> --><td data-label=Acción style=\"text-align: center\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-click=vm.confirmarEliminacionTrans($index,item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=couttransporte></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=\"Disposición Final\" index=2><br><div class=row ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><div class=\"form-group col-md-2\" style=\"margin-top: 10px\"><p style=\"text-align: justify\">&iquest;Tiene residuos que declarar?</p></div><div class=\"form-group col-md-10\"><button class=\"btn btn-default btn-sm\" ng-click=vm.tieneResiduosDisposicion(false)><i class=\"glyphicon glyphicon-remove\" aria-hidden=true></i> No tengo residuos</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.tieneResiduosDisposicion(true)><i class=\"glyphicon glyphicon-ok\" aria-hidden=true></i> Si tengo residuos</button></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResDisposicion\"><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" placeholder=RUC maxlength=11 disabled ng-model=vm.dataResiduoDispo.ruceps type=text></div><div class=\"form-group col-md-6\"><input class=\"form-control input-sm\" disabled ng-model=vm.dataResiduoDispo.nombreeps type=text></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.obtenerEor(\'DISPOSICION\')\" type=button><span class=icon-check></span> Buscar</button></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResDisposicion\"><div class=\"form-group col-md-8\"><label>Dirección</label><input type=text class=\"form-control input-sm\" ng-disabled=true ng-model=vm.dataResiduoDispo.direccion></div></div><div class=row ng-show=\"(vm.prmResiduo.idresiduo==0 || vm.blEditar) && vm.tieneResDisposicion\"><div class=\"form-group col-md-2\"><label>N° Registro</label><input type=text ng-model=vm.dataResiduoDispo.nroregistro ng-disabled=true class=\"form-control input-sm\"></div><div class=\"form-group col-md-2\"><label>Fecha de Venc.</label><input type=date ng-model=vm.dataResiduoDispo.fechavencimiento class=\"form-control input-sm\"></div><!-- <div class=\"form-group col-md-2\">\r\n				<label>Fecha de ejecución</label> <input type=\"date\"\r\n					ng-model=\"vm.dataResiduoDispo.fechaejecucion\"\r\n					class=\"form-control input-sm\" />\r\n			</div> --><div class=\"form-group col-md-2\"><label>Cantidad (TN)</label><input type=number min=0 onkeyup=\"validarFormato(this,\'N+\')\" class=\"form-control input-sm\" pattern=^[0-9]+ ng-model=vm.dataResiduoDispo.cantidad></div><!-- <div class=\"form-group col-md-2\">\r\n				<label>N° Autoriza. Municipal</label> <input type=\"text\"\r\n					class=\"form-control input-sm\" />\r\n			</div>\r\n			<div class=\"form-group col-md-2\">\r\n				<label>N° Autoriza. relleno</label> <input type=\"text\"\r\n					class=\"form-control input-sm\" />\r\n			</div> --><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.dataResiduoDispo.nombreeps==null || vm.dataResiduoDispo.nombreeps==\'\' ||\r\n					vm.dataResiduoDispo.nroregistro==null || vm.dataResiduoDispo.nroregistro == \'\'\" ng-click=vm.agregarResiduoDisposicion() type=button><span class=icon-plus></span> Agregar</button></div></div><div class=row ng-show=\"vm.tieneResDisposicion==true || vm.prmResiduo.lstDisposicion.length>0\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>RUC</th><th style=\"text-align: center\" width=5%>EO-RS</th><th style=\"text-align: center\" width=5%>Dirección</th><th style=\"text-align: center\" width=5%>N° Registro</th><th style=\"text-align: center\" width=5%>Fecha de Venc.</th><th style=\"text-align: center\" width=5%>Cantidad</th><th style=\"text-align: center\" width=5% ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmResiduo.lstDisposicion.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmResiduo.lstDisposicion | itemsPerPage: config.itemsPerPage\" pagination-id=couttransporte><td data-label=RUC style=\"text-align: center\">{{item.ruceps}}</td><td data-label=EO-RS style=\"text-align: center\">{{item.nombreeps}}</td><td data-label=Dirección style=\"text-align: center\">{{item.direccion}}</td><td data-label=\"N° Registro\" style=\"text-align: center\">{{item.nroregistro}}</td><td data-label=\"Fecha de Venc.\" style=\"text-align: center\">{{item.fechavencimientotexto}}</td><td data-label=Cantidad style=\"text-align: center\">{{item.cantidad}}</td><td data-label=Acción style=\"text-align: center\" ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\"><button class=\"btn btn-default btn-sm\" ng-disabled=\"item.idresiduo != 0 && !vm.blEditar\" ng-click=vm.confirmarEliminacionDispo($index,item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutdisposicion></dir-pagination-controls></div></div></div></uib-tab></uib-tabset><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() type=button id=btnRegistrarManifiesto ng-show=\"vm.prmResiduo.idresiduo==0 || vm.blEditar\" ng-disabled=\"vm.prmResiduo.lstCaracteristicas.length==0 || (vm.tieneResTransporte==true && vm.prmResiduo.lstTransporte.length==0) || (vm.tieneResDisposicion==true && vm.prmResiduo.lstDisposicion.length==0) || vm.prmResiduo.periodo==0 || vm.prmResiduo.frecuencia==0 || vm.prmResiduo.numero_frecuencia==0 || (vm.listaArchivos.length == 0 && (vm.prmResiduo.uiid==null || vm.prmResiduo.uiid==\'\'))\" uib-tooltip=\"{{ vm.prmResiduo.idresiduo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmResiduo.idresiduo == 0 ? \'Registrar\' : \'Actualizar\' }}<!-- ng-disabled=\"vm.prmResiduo.lstCaracteristicas.length==0 || vm.prmResiduo.lstTransporte.length==0 || vm.prmResiduo.lstDisposicion.length==0 || vm.prmResiduo.periodo==0 || vm.prmResiduo.frecuencia==0 || vm.prmResiduo.numero_frecuencia==0 || vm.listaArchivos.length == 0\" --></button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"glyphicon glyphicon-arrow-left\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><span class=important-box></span> Campo obligatorio.</div></div><button id=btnRefrescar style=\"display: none\" ng-click=vm.refrescar() type=button></button></span></div><script type=text/javascript>$(document).ready(\n			function() {\n				$(\'button.ngdialog-close\').remove();\n				$(\'.ngdialog-content\').append(\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\n			});</script>");
$templateCache.put("app/modules/supervision/supervision.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><!--       <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.usuarios.listado\" >Listado</a>\r\n        </li>\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n          <a ui-sref=\"spapp.home.usuarios.registro\" >Registro</a>\r\n        </li>\r\n      </ul> --><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/componente/componente.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/seguridad/seguridad.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><!--       <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.usuarios.listado\" >Listado</a>\r\n        </li>\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n          <a ui-sref=\"spapp.home.usuarios.registro\" >Registro</a>\r\n        </li>\r\n      </ul> --><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/etapa/etapa.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/tipoiga/tipoiga.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/modules/usuario/usuario.html","<div class=\"col-md-12 sin_padding\"><div><div class=\"panel panel-tab-app with-nav-tabs panel-default\"><!--       <ul class=\"nav nav-tabs\" >\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 1 }\" ng-click=\"vm.itemTabActivo = 1\">\r\n          <a ui-sref=\"spapp.home.usuarios.listado\" >Listado</a>\r\n        </li>\r\n        <li ng-class=\"{ \'active\' : vm.itemTabActivo == 2 }\" ng-click=\"vm.itemTabActivo = 2\">\r\n          <a ui-sref=\"spapp.home.usuarios.registro\" >Registro</a>\r\n        </li>\r\n      </ul> --><div class=panel-body ui-view=\"\"></div></div></div></div>");
$templateCache.put("app/third-party/angularUtils-pagination/dirPagination.tpl.html","<ul class=pagination ng-if=\"1 < pages.length || !autoHide\"><li ng-if=boundaryLinks ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=setCurrent(1)>&laquo;</a></li><li ng-if=directionLinks ng-class=\"{ disabled : pagination.current == 1 }\"><a href=\"\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a></li><li ng-repeat=\"pageNumber in pages track by tracker(pageNumber, $index)\" ng-class=\"{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }\"><a href=\"\" ng-click=setCurrent(pageNumber)>{{ pageNumber }}</a></li><li ng-if=directionLinks ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></li><li ng-if=boundaryLinks ng-class=\"{ disabled : pagination.current == pagination.last }\"><a href=\"\" ng-click=setCurrent(pagination.last)>&raquo;</a></li></ul>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=container-fluid><div class=navbar-header><a class=navbar-brand href=https://github.com/Swiip/generator-gulp-angular><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=bs-example-navbar-collapse-6><ul class=\"nav navbar-nav\"><li class=active><a ng-href=#>Home</a></li><li><a ng-href=#>About</a></li><li><a ng-href=#>Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/base/template/app-carousel/app-carousel-slide.tpl.html","<div ng-class=\"{\'active\': active}\" class=\"item text-center\" ng-transclude></div>");
$templateCache.put("app/base/template/app-carousel/app-carousel.tpl.html","<div ng-mouseenter=pause() ng-mouseleave=play() class=carousel ng-swipe-right=prev() ng-swipe-left=next()><div class=carousel-inner ng-transclude></div><a role=button href class=\"left carousel-control\" ng-click=prev() ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\"><span aria-hidden=true class=\"glyphicon glyphicon-chevron-left\"></span> <span class=sr-only>previous</span> </a><a role=button href class=\"right carousel-control\" ng-click=next() ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\"><span aria-hidden=true class=\"glyphicon glyphicon-chevron-right\"></span> <span class=sr-only>next</span></a><ol class=carousel-indicators ng-show=\"slides.length > 1\"><li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=select(slide)><span class=sr-only>slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=isActive(slide)>, currently active</span></span></li></ol></div>");
$templateCache.put("app/base/template/app-dropdown/app-dropdown.tpl.html","<!-- <ul class=\"dropdown-menu\" uib-dropdown-menu role=\"menu\" aria-labelledby=\"button-template-url\">\r\n  <li role=\"menuitem\"><a href=\"#\">Action in Template</a></li>\r\n  <li role=\"menuitem\"><a href=\"#\">Another action in Template</a></li>\r\n  <li role=\"menuitem\"><a href=\"#\">Something else here</a></li>\r\n  <li class=\"divider\"></li>\r\n  <li role=\"menuitem\"><a href=\"#\">Separated link in Template</a></li>\r\n</ul>\r\n --><ul class=dropdown-menu uib-dropdown-menu role=menu aria-labelledby=button-template-url><li ng-repeat=\"itemOption in vm.dropdownOptions\"><a href ng-click=vm.clickItemDropdown()>{{itemOption}}</a></li></ul>");
$templateCache.put("app/modules/eor/listado/eor-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de Empresas operadoras de residuos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>EOR</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><label>RUC</label><input class=form-control type=text ng-model=vm.prmEor.ruc maxlength=11></div><div class=\"form-group col-md-3\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmEor.nombre></div><div class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmEor.estado class=form-control id=estado name=estado><option value=\"\">--TODOS--</option><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-2\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center; vertical-align: middle !important\" width=5%>N° Item</th><th style=\"text-align: center; vertical-align: middle !important\" width=10%>RUC</th><th style=\"text-align: center; vertical-align: middle !important\" width=25%>Nombre</th><th style=\"text-align: center; vertical-align: middle !important\" width=18%>Dirección</th><th style=\"text-align: center; vertical-align: middle !important\" width=10%>Nro. registro</th><th style=\"text-align: center; vertical-align: middle !important\" width=10%>Fecha vencimiento</th><th style=\"text-align: center; vertical-align: middle !important\" width=5%>Certificador</th><th style=\"text-align: center; vertical-align: middle !important\" width=5%>Estado</th><th style=\"text-align: center; vertical-align: middle !important\" width=20%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstEor.length==0\"><td colspan=9 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstEor | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center; vertical-align: middle !important\">{{item.numeroItem}}</td><td data-label=RUC style=\"text-align: center; vertical-align: middle !important\">{{item.ruc}}</td><td data-label=Nombre style=\"text-align: center; vertical-align: middle !important\">{{item.nombre}}</td><td data-label=Dirección style=\"text-align: center; vertical-align: middle !important\">{{item.direccion}}</td><td data-label=\"Nro registro\" style=\"text-align: center; vertical-align: middle !important\">{{item.nroregistro}}</td><td data-label=\"Fecha vencimiento\" style=\"text-align: center; vertical-align: middle !important\">{{item.fechavencimientotexto}}</td><td data-label=Certificador style=\"text-align: center; vertical-align: middle !important\">{{item.nombrecertificador}}</td><td data-label=Estado style=\"text-align: center; vertical-align: middle !important\"><div ng-show=\"{{item.estado == \'1\'}}\">ACTIVO</div><div ng-show=\"{{item.estado == \'0\'}}\">INACTIVO</div></td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarInactivacion(item) type=button ng-show=\"{{item.estado == \'1\'}}\" uib-tooltip=Inactivar><span class=\"glyphicon glyphicon-minus-sign\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/acceso/inicio/acceso-inicio.html","<!-- linea --><!-- <div id=\"bg\">\r\n  <img src=\"assets/images/fondo/amazonas-fondo.jpg\" alt=\"\">\r\n</div> --><nav class=\"navbar navbar-fixed-top\" id=nav-top-web><div class=container><div class=navbar-header><!--<button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\">\r\n            <span class=\"sr-only\">Toggle navigation</span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            </button>--> <a class=navbar-brand href=#><img alt=\"\" class=img-responsive src=assets/images/sinada-big.png></a></div><div class=\"navbar-collapse collapse\" id=navbar><ul class=\"nav navbar-nav pull-right\" style=margin:0px><li id=login-link><a ng-click=vm.iraLogin()>Iniciar Sessión</a></li></ul></div></div></nav><section class=barra-img></section><section class=seccion-sinada_inicio><div class=container><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6\"><h2 class=size-title>LOREM IPSON</h2><p class=font-text>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p></div><div class=\"col-xs-12 col-sm-6 col-md-6\"><div id=contenedor-table><!--           <div class=\"modal-header\">\r\n            <div class=\"form-group col-md-12\" >\r\n                  <img src=\"assets/images/oefa-logo-header.png\" alt=\"\"  style=\"margin-bottom: 0px;margin-top: 10px;\" height=\"55\">\r\n                  <img src=\"assets/images/sinada.png\" alt=\"\"  style=\"margin-bottom: 0px;margin-top: 10px;float: right;\">\r\n            </div>\r\n          </div> --><div class=row style=\"margin-bottom: 15px\"><div class=\"form-group col-md-12\"><h5>Seleccione como desea Ingresar:</h5></div><div class=\"form-group col-xs-6 col-md-6 text-center item-icon-link\"><div class=\"center-block animated fadeInDown green-color\" ng-click=vm.irARegistroDenuncia()><span class=icon-buscar-a></span><!-- <img src=\"assets/images/user-01.png\"   ng-click=\"vm.iraconsultas()\"  alt=\"\" class=\"img-responsive center-block icono-user-x user-01\" style=\"margin-bottom: 20px;margin-top: 10px;border-width:3px;\"> --> <b>Registrar Denuncia</b></div></div><div class=\"form-group col-xs-6 col-md-6 text-center item-icon-link\"><div class=\"center-block animated fadeInDown blue-color\" ng-click=vm.mostrarModalContenido()><span class=icon-buscar-o></span><!-- <img src=\"assets/images/user-02.png\" alt=\"\" ng-click=\"vm.iraLogin()\"\r\n                        class=\"img-responsive center-block icono-user-x user-02\"\r\n                        style=\"margin-bottom: 20px; margin-top: 10px;border-width:3px;\"> --> <b>Buscar Denuncia</b></div></div></div><div class=row><div class=col-md-12><div class=form-group><span style=\"opacity: .6\">Si deseas registrarte, haz </span><span><a class=spapp-link href=#/invitado/nuevo-usuario>click aqui</a></span></div></div></div></div></div></div></div></section><span class=overlay-block ng-if=\"$parent.cargandoInformacion>0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/autenticacion/ingreso/ingreso_hidrocarburos.html","<!-- <div id=\"bg\">\r\n  <img src=\"assets/images/fondo/amazonas-fondo.jpg\" alt=\"\">\r\n</div> --><nav class=\"navbar navbar-fixed-top\" id=nav-top-web><div class=container><div class=navbar-header><!--<button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\">\r\n            <span class=\"sr-only\">Toggle navigation</span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            </button>--> <a class=navbar-brand href=#><img alt=\"\" class=\"img-responsive logo-oefa-inicio\" src=assets/images/oefa-logo-header.svg></a><a class=navbar-brand href=#><img alt=\"\" class=\"img-responsive logo-sinada-inicio\" src=assets/images/logo-siso.svg></a></div><div class=navbar-collapse id=navbar><!--\r\n            <ul class=\"nav navbar-nav pull-right\">\r\n                <li class=\"\" id=\"login-link\">\r\n                    <a ng-click=\"vm.iraLogin()\">\r\n                        Iniciar sessión\r\n                    </a>\r\n                </li>\r\n            </ul>--></div></div></nav><section class=barra-img></section><section class=seccion-hidrocarburos_inicio><div class=container><div class=row><div class=\"col-md-8 col-md-offset-2 text-center\" style=\"color: #154ba7\"><h2 class=size-title-inicio style=\"text-shadow: 1px 1px 5px #000;padding-bottom: 180px; color: white\">BIENVENIDOS</h2><!-- <p class=\"font-text text-left\"\r\n					style=\"padding: 14px; background: white; opacity: 0.9; color: #154ba7; text-align: justify;\">\r\n					Estimados usuarios, <br /> El Organismo de Evaluación y\r\n					Fiscalización Ambiental OEFA, encargado de la fiscalización\r\n					ambiental y de asegurar el adecuado equilibrio entre la inversión\r\n					privada en actividades económicas y la protección ambiental, pone a\r\n					disposición el “Sistema de Supervisión Online – SISO” como\r\n					herramienta tecnológica para los administrados de actividades de\r\n					comercialización del Subsector Hidrocarburos, a fin de facilitar el\r\n					cumplimiento de sus obligaciones ambientales fiscalizables. <a\r\n						href=\"{{vm.rutaBase}}seguridad/descargar-manual\" target=\"_blank\"\r\n						style=\"text-decoration: underline;\">Descargar manual aquí</a>\r\n\r\n				</p> --></div><div class=\"col-md-8 col-md-offset-2\"><div id=contenedor-table><!--           <div class=\"modal-header\">\r\n            <div class=\"form-group col-md-12\" >\r\n                  <img src=\"assets/images/oefa-logo-header.png\" alt=\"\"  style=\"margin-bottom: 0px;margin-top: 10px;\" height=\"55\">\r\n                  <img src=\"assets/images/sinada.png\" alt=\"\"  style=\"margin-bottom: 0px;margin-top: 10px;float: right;\">\r\n            </div>\r\n          </div> --><div class=row style=\"margin-bottom: 15px\"><!--<div class=\"form-group col-md-12\">\r\n                <h5>Seleccione como desea Ingresar:</h5>\r\n            </div>--><div class=\"form-group col-md-4 col-md-offset-2 col-sm-offset-2 col-sm-4 col-xs-12 text-center item-icon-link\"><div class=\"center-block animated fadeInDown blue-color-new\" ng-click=vm.irmenores()><img width=100% alt=\"Hidrocarburos menores\" src=assets/images/iconos/hidrocarburos_menores.png style=\"display: block\"> <span></span> <b>HIDROCARBUROS MENORES</b></div></div><div class=\"form-group col-md-4 col-sm-4 col-xs-12 text-center item-icon-link\"><div class=\"center-block animated fadeInDown blue-color-new\" ng-click=vm.irmayores()><img width=100% alt=\"Hidrocarburos menores\" src=assets/images/iconos/hidrocarburos_mayores.png style=\"display: block\"> <span></span> <b>HIDROCARBUROS MAYORES</b></div></div></div></div></div></div></div></section><span class=overlay-block ng-if=\"$parent.cargandoInformacion>0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/autenticacion/ingreso/ingresoinicio.html","<!-- <div id=\"bg\">\r\n  <img src=\"assets/images/fondo/amazonas-fondo.jpg\" alt=\"\">\r\n</div> --><nav class=\"navbar navbar-fixed-top\" id=nav-top-web><div class=container><div class=navbar-header><!--<button type=\"button\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#navbar\" aria-expanded=\"false\" aria-controls=\"navbar\">\r\n            <span class=\"sr-only\">Toggle navigation</span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            <span class=\"icon-bar\"></span>\r\n            </button>--> <a class=navbar-brand href=#><img alt=\"\" class=\"img-responsive logo-oefa-inicio\" src=assets/images/oefa-logo-header.svg></a><a class=navbar-brand href=#><img alt=\"\" class=\"img-responsive logo-sinada-inicio\" src=assets/images/logo-siso.svg></a></div><div class=navbar-collapse id=navbar><!--\r\n            <ul class=\"nav navbar-nav pull-right\">\r\n                <li class=\"\" id=\"login-link\">\r\n                    <a ng-click=\"vm.iraLogin()\">\r\n                        Iniciar sessión\r\n                    </a>\r\n                </li>\r\n            </ul>--></div></div></nav><section class=barra-img></section><section class=seccion-sinada_inicio><div class=container><div class=row><div class=\"col-md-8 col-md-offset-2 text-center\" style=\"color: #154ba7\"><h2 class=size-title-inicio style=\"text-shadow: 1px 1px 5px #000; color: white\">BIENVENIDOS</h2><p class=\"font-text text-left\" style=\"padding: 14px; background: white; opacity: 0.9; color: #154ba7; text-align: justify\">Estimados usuarios,<br>El Organismo de Evaluación y Fiscalización Ambiental OEFA, encargado de la fiscalización ambiental y de asegurar el adecuado equilibrio entre la inversión privada en actividades económicas y la protección ambiental, pone a disposición el “Sistema de Supervisión Online – SISO” como herramienta tecnológica para los administrados de actividades de comercialización del Subsector Hidrocarburos, a fin de facilitar el cumplimiento de sus obligaciones ambientales fiscalizables. <a href={{vm.rutaBase}}seguridad/descargar-manual target=_blank style=\"text-decoration: underline\">Descargar manual aquí</a></p></div><div class=\"col-md-8 col-md-offset-2\"><div id=contenedor-table><!--           <div class=\"modal-header\">\r\n            <div class=\"form-group col-md-12\" >\r\n                  <img src=\"assets/images/oefa-logo-header.png\" alt=\"\"  style=\"margin-bottom: 0px;margin-top: 10px;\" height=\"55\">\r\n                  <img src=\"assets/images/sinada.png\" alt=\"\"  style=\"margin-bottom: 0px;margin-top: 10px;float: right;\">\r\n            </div>\r\n          </div> --><div class=row style=\"margin-bottom: 15px\"><!--<div class=\"form-group col-md-12\">\r\n                <h5>Seleccione como desea Ingresar:</h5>\r\n            </div>--><div class=\"form-group col-md-4 col-md-offset-2 col-sm-offset-2 col-sm-4 col-xs-12 text-center item-icon-link\"><div class=\"center-block animated fadeInDown blue-color-new\" ng-click=vm.iraconsultas()><span class=icon-usuario-invitado></span><!-- <img src=\"assets/images/user-01.png\"   ng-click=\"vm.iraconsultas()\"  alt=\"\" class=\"img-responsive center-block icono-user-x user-01\" style=\"margin-bottom: 20px;margin-top: 10px;border-width:3px;\"> --> <b>Registro de solicitud</b></div></div><div class=\"form-group col-md-4 col-sm-4 col-xs-12 text-center item-icon-link\"><div class=\"center-block animated fadeInDown blue-color-new\" ng-click=vm.iraLogin()><span class=icon-usuario-registrado></span><!-- <img src=\"assets/images/user-02.png\" alt=\"\" ng-click=\"vm.iraLogin()\"\r\n                        class=\"img-responsive center-block icono-user-x user-02\"\r\n                        style=\"margin-bottom: 20px; margin-top: 10px;border-width:3px;\"> --> <b>Usuario registrado</b></div></div></div><!--\r\n           <div class=\"row\">\r\n             <div class=\"col-md-12\">\r\n                 <div class=\"form-group\">\r\n                    <span style=\"opacity: .6\">Si deseas registrarte, haz</span>  <span><a class=\"spapp-link\" ng-click=\"vm.registrarse()\">click aqui</a></span>\r\n                 </div>\r\n             </div>\r\n           </div>\r\n\r\n--></div></div></div></div></section><span class=overlay-block ng-if=\"$parent.cargandoInformacion>0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/autenticacion/ingreso/ingresoinicio_backap.html","<!-- <div id=\"bg\">\r\n  <img src=\"assets/images/fondo/amazonas-fondo.jpg\" alt=\"\">\r\n</div> --><nav class=\"navbar navbar-fixed-top\" id=nav-top-web><div class=container><div class=navbar-header><button aria-controls=navbar aria-expanded=false class=\"navbar-toggle collapsed\" data-target=#navbar data-toggle=collapse type=button><span class=sr-only>Toggle navigation </span><span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand href=#><img alt=\"\" class=img-responsive src=assets/images/SISO-LOGO.png></a></div><div class=\"navbar-collapse collapse\" id=navbar><ul class=\"nav navbar-nav pull-right\"><li id=login-link><a href=#>Iniciar Sessión</a></li></ul></div></div></nav><div class=container><div class=row style=\"margin-top: 8%\"><div class=\"col-xs-8 col-md-offset-2\"><div id=contenedor-table><div class=modal-dialog><div class=modal-content><div class=modal-header><div class=\"form-group col-md-12\"><img alt=\"\" height=55 src=assets/images/oefa-logo-header.png style=\"margin-bottom: 0px;margin-top: 10px\"> <img alt=\"\" src=assets/images/sinada.png style=\"margin-bottom: 0px;margin-top: 10px;float: right\"></div></div><div class=modal-body><div class=row style=\"margin-bottom: 15px\"><div class=\"form-group col-md-12\"><h5>Seleccione como desea Ingresar:</h5></div><div class=\"form-group col-md-6 text-center\"><div class=center-block><img alt=\"\" class=\"img-responsive center-block icono-user-x user-01\" ng-click=vm.iraconsultas() src=assets/images/user-01.png style=\"margin-bottom: 20px;margin-top: 10px;border-width:3px\"> <b>Usuario Invitado</b></div></div><div class=\"form-group col-md-6 text-center\"><div class=center-block><img alt=\"\" class=\"img-responsive center-block icono-user-x user-02\" ng-click=vm.iraLogin() src=assets/images/user-02.png style=\"margin-bottom: 20px; margin-top: 10px;border-width:3px\"> <b>Usuario Registrado</b></div></div></div><div class=row><div class=col-md-12><div class=form-group><span style=\"opacity: .6\">Si deseas registrarte, haz </span><span><a class=spapp-link ng-click=vm.registrarse()>click aqui</a></span></div></div></div></div></div></div></div></div></div></div><span class=overlay-block ng-if=\"$parent.cargandoInformacion>0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/maestro/data-dialog/maestro-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Agregar ítem de maestro</h4></div><div class=modal-body name=maestroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=form-group><label class=important-box>Descripción de ítem</label><div class=\"input-group col-lg-6\" ng-class=\"{\'has-error\':maestroDataDialogForm.NombreCorto.$invalid && maestroDataDialogForm.NombreCorto.$touched}\"><input class=\"form-control input-sm\" id=NombreCorto name=NombreCorto type=text maxlength=250> <span class=input-group-btn><button class=\"btn btn-primary btn-sm\" ng-click=vm.agregarItem() title=\"Agregar Item\" type=button uib-tooltip=\"Agregar Item\">Guardar</button></span><div class=field-message ng-cloak=\"\" ng-if=maestroDataDialogForm.NombreCorto.$touched ng-messages=maestroDataDialogForm.NombreCorto.$error><div class=help-block ng-message=required>Ingrese descripción del ítem</div></div></div></div></div></span></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/maestro/dialog/maestro-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmMaestro.codigoRegistro == 0 ? \'Agregar\' : \'Modificar\' }} ítem de maestro:</h4></div><div class=modal-body name=maestroDataDialogForm ng-form=\"\"><span class=content-box><div class=row ng-if=\"vm.prmMaestro.codigoMaestro!=\'PeriodoPregunta\'\"><div class=\"form-group col-lg-12\"><label class=important-box>Nombre:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':maestroDataDialogForm.NombreCorto.$invalid && maestroDataDialogForm.NombreCorto.$touched}\"><input class=\"form-control input-sm\" id=NombreCorto name=NombreCorto ng-disabled=\"vm.prmMaestro.codigoMaestro==\'FechasNoLaborables\'\" ng-model=vm.prmMaestro.descripcion required type=text maxlength=250><div class=field-message ng-cloak=\"\" ng-if=maestroDataDialogForm.NombreCorto.$touched ng-messages=maestroDataDialogForm.NombreCorto.$error><div class=help-block ng-message=required>Campo obligatorio</div></div></div></div></div><div class=row ng-if=\"vm.prmMaestro.codigoMaestro==\'PeriodoPregunta\'\"><div class=\"form-group col-lg-12\"><label class=important-box>Ingrese año periodo:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':maestroDataDialogForm.NombreCorto.$invalid && maestroDataDialogForm.NombreCorto.$touched}\"><input class=\"form-control input-sm\" id=NombreCorto input-restrict=numero name=NombreCorto ng-init=vm.fechaValidaPregunta(vm.prmMaestro.descripcion) ng-keyup=vm.fechaValidaPregunta(vm.prmMaestro.descripcion) ng-model=vm.prmMaestro.descripcion required type=text><div class=field-message ng-cloak=\"\" ng-if=maestroDataDialogForm.NombreCorto.$touched ng-messages=maestroDataDialogForm.NombreCorto.$error><div class=help-block ng-message=required>Campo obligatorio</div></div></div></div></div><div class=row ng-if=\"vm.prmMaestro.codigoMaestro==\'FechasNoLaborables\' && vm.prmMaestro.idMaestro==0\"><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\':vm.normasForm.nombre.$invalid && vm.normasForm.nombre.$touched}\"><label class=important-box for=nombre>Fecha no laborable</label><div class=form-group><input class=\"form-control input-sm\" datepicker-options=vm.option is-open=vm.openDatePickerFechaInicio name=fechaAtencion ng-change=vm.obtenerDatosFecha() ng-click=\"vm.openDatePickerFechaInicio = true\" ng-init=\"vm.openDatePickerFechaInicio = false\" ng-model=vm.dataFechaNoLaborable required show-button-bar=false type=text uib-datepicker-popup=dd/MM/yyyy></div></div></div><div class=row ng-if=\"vm.prmMaestro.codigoMaestro==\'PeriodoPregunta\'\"><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\':vm.normasForm.nombre.$invalid && vm.normasForm.nombre.$touched}\"><label class=important-box for=nombre>Fecha valida de inicio</label><div class=form-group><input class=\"form-control input-sm\" datepicker-options=vm.option is-open=vm.openDatePickerFechaInicio name=fechaAtencion ng-click=\"vm.openDatePickerFechaInicio = true\" ng-disabled=true ng-init=\"vm.openDatePickerFechaInicio = false\" ng-model=vm.dataFechaInicioPreguntaValida required show-button-bar=false type=text uib-datepicker-popup=dd/MM/yyyy></div></div><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\':vm.normasForm.nombre.$invalid && vm.normasForm.nombre.$touched}\" ng-show=\"vm.dataNormas.idNorma!=0\"><label class=important-box for=nombre>Fecha valida final</label><div class=form-group><input class=\"form-control input-sm\" datepicker-options=vm.dtFechaAtencionOptions is-open=vm.openDatePickerFechaAtencion name=fechaAtencion ng-change=vm.validarConcordanteNorma() ng-click=\"vm.openDatePickerFechaAtencion = true\" ng-disabled=true ng-init=\"vm.openDatePickerFechaAtencion = false\" ng-model=vm.dataFechaFinPreguntaValida show-button-bar=false type=text uib-datepicker-popup=dd/MM/yyyy></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmMaestro.descripcion==\'\' ||vm.prmMaestro.descripcion.length<1\" type=button uib-tooltip=\"{{ vm.prmMaestro.codigoRegistro == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmMaestro.codigoRegistro == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() ng-show=\"vm.dataNormas.idNorma==0\" uib-tooltip=\"Limpiar formulario\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/maestro/listado/maestro-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de maestro</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>Listado</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><label for=estadoNorma>Maestros</label><div class=form-group><select class=\"form-control input-sm\" id=estadoNorma name=codigoMaestro ng-change=vm.listarItemMaestros() ng-disabled=\"vm.activaRegistroHijo ==\'1\'\" ng-model=vm.dataMaestros.codigoMaestro><option value=\"\">Seleccione</option><option ng-repeat=\"item in vm.lstMaestros\" ng-value=item.codigoMaestro>{{item.descripcion}}</option></select></div></div><div class=\"input-group col-md-2\" ng-show=\"vm.activaRegistroHijo ==\'0\'\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.agregarItem() ng-disabled=\"vm.dataMaestros.codigoMaestro == \'\' || vm.activaRegistroHijo ==\'1\'\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'AGREGAR\')\"><span class=icon-agregar></span> Agregar</button></div></div><div class=\"input-group col-md-2\" ng-show=\"vm.activaRegistroHijo ==\'1\' && vm.activaRegistroHijoActividades ==\'0\'\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.cancelarRegistroHijo() ng-disabled=\"vm.activaRegistroHijo ==\'0\'\"><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div><div class=\"input-group col-md-2\" ng-show=\"vm.activaRegistroHijoActividades ==\'1\'\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.cancelarRegistroHijoActividades() ng-disabled=\"vm.activaRegistroHijoActividades ==\'0\'\"><span class=\"glyphicon glyphicon-remove\"></span>Cancelar registro actividades</button></div></div></div><div><div class=\"input-group col-md-2\" ng-show=\"vm.activaRegistroHijo ==\'1\'\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.agregarRegistroHijoDatos() ng-disabled=\"vm.dataMaestros.codigoMaestro == \'\' \"><span class=icon-agregar ng-show=\"vm.activaRegistroHijo ==\'1\' && vm.activaRegistroHijoActividades ==\'0\'\"></span><span ng-show=\"vm.activaRegistroHijo ==\'1\' && vm.activaRegistroHijoActividades ==\'0\'\"> Agregar registro - {{vm.dataRegistrar}}</span> <span class=icon-agregar ng-show=\"vm.activaRegistroHijoActividades ==\'1\'\"></span><span ng-show=\"vm.activaRegistroHijoActividades ==\'1\'\">Agregar registro - {{vm.dataRegistrarActividades}}</span></button></div></div></div><div class=row ng-show=\"vm.activaRegistroHijo ==\'0\'\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Nombre de la tabla</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr dir-paginate=\"item in vm.lstMaestrosItem | itemsPerPage: config.itemsPerPage\" pagination-id=coutmain><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=\"Nombre de la Tabla\" style=\"text-align: center\">{{item.descripcion}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarRegistroHijo(item) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'AGREGAR\')\" type=button><span class=icon-agregar></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'MODIFICAR\')\" ng-click=vm.agregarItem(item) type=button><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR\')\" type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutmain></dir-pagination-controls></div></div></div><div class=row ng-show=\"vm.activaRegistroHijo ==\'1\' && vm.activaRegistroHijoActividades==\'0\'\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Nombre de la tabla</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr dir-paginate=\"item in vm.listaRegistroHijo | itemsPerPage: config.itemsPerPage\" pagination-id=\"cout \"><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=\"Nombre de la tabla\" style=\"text-align: center\">{{item.descripcion}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarRegistroActividades(item) type=button><span class=icon-agregar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionRegistroHijo(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row ng-show=\"vm.activaRegistroHijoActividades ==\'1\'\"><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Nombre de la tabla</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr dir-paginate=\"item in vm.listaRegistroHijoActividades | itemsPerPage: config.itemsPerPage\" pagination-id=cout2><td data-label=N° style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=\"Nombre de la tabla\" style=\"text-align: center\">{{item.descripcion}}</td><td class=text-center data-label=AcciÃ³n><!--<button class=\"btn btn-default btn-sm\" ng-click=\"vm.agregarRegistroActividades(item)\" type=\"button\">\r\n                                        <span class=\"icon-agregar\">\r\n                                        </span>\r\n                                    </button>--> <button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionRegistroHijo(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout2></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/eor/dialog/eor-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.titulo }} Empresas operadoras de residuos:</h4></div></div><div class=modal-body name=tipoigaDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><label class=important-box>RUC:</label><div class=form-group><input class=\"form-control input-sm\" id=ruc ng-disabled=\"vm.prmEor.nombre!=null && vm.prmEor.nombre!=\'\'\" maxlength=11 required name=ruc ng-model=vm.prmEor.ruc type=text></div></div><div class=\"input-group col-md-5\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-if=\"vm.titulo != \'Editar\'\" ng-disabled=\"vm.prmEor.ruc.length <11 || vm.prmEor.ruc==null || vm.prmEor.ruc==\'\'\" ng-click=vm.validarRuc() type=button><span class=\"glyphicon glyphicon-search\"></span> Buscar</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-if=\"vm.titulo != \'Editar\'\" ng-click=vm.limpiarBusqueda() type=button><span class=\"glyphicon glyphicon-repeat\"></span> Nueva Búsqueda</button></div></div></div><div class=row><div class=\"form-group col-md-12\"><label class=important-box>Nombre:</label><div class=form-group><input class=\"form-control input-sm\" id=Nombre name=nombre maxlength=200 ng-model=vm.prmEor.nombre type=text ng-disabled=true></div></div></div><div class=row><div class=\"form-group col-md-8\"><label class=important-box>Dirección:</label><div class=form-group><input class=\"form-control input-sm\" id=Direcion name=direccion maxlength=200 ng-model=vm.prmEor.direccion type=text></div></div><div class=\"form-group col-md-4\"><label class=important-box>Estado:</label><select ng-model=vm.prmEor.estado class=\"form-control input-sm\" id=estado name=estado><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div></div><div class=row><div class=\"form-group col-md-4\"><label class=important-box>Nro. registro:</label><div class=form-group><input class=\"form-control input-sm\" id=nroregistro name=nroregistro maxlength=40 ng-model=vm.prmEor.nroregistro type=text></div></div><div class=\"form-group col-md-4\"><label>Fecha de vencimiento:</label><div class=form-group><input class=\"form-control input-sm\" type=date ng-model=vm.prmEor.fechavencimiento></div></div><div class=\"form-group col-md-4\"><label class=important-box>Certificador:</label><div class=form-group><select ng-model=vm.prmEor.codigocertificador class=\"form-control input-sm\" id=certificador name=estado><option value=\"\">Seleccione</option><option value=MI>MINAM</option><option value=DI>DIGESA</option></select></div></div></div><div class=row><div class=\"form-group col-md-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmEor.ruc==\'\' || vm.prmEor.ruc==null || vm.prmEor.nombre==\'\' || vm.prmEor.nombre==null \r\n					|| vm.prmEor.nroregistro ==\'\' || vm.prmEor.nroregistro==null || vm.prmEor.codigocertificador ==\'\' || vm.prmEor.codigocertificador ==null\r\n					|| vm.prmEor.estado ==\'\' || vm.prmEor.estado==null || vm.prmEor.direccion ==\'\' || vm.prmEor.direccion==null\" type=button uib-tooltip=\"{{ vm.prmEor.secuencia == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok\"></span> {{ vm.tituloAccion }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-md-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/eor/dialog/eor-listado-seleccion.html","<style type=text/css>.inactivo {\r\n	color: red !important;\r\n}</style><div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Empresas operadoras de residuos:</h4></div></div><div class=modal-body name=tipoigaDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-3\"><label>RUC</label><input class=form-control type=text ng-model=vm.prmEor.ruc maxlength=11></div><div class=\"form-group col-md-3\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmEor.nombre></div><div class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmEor.estado class=form-control id=estado name=estado><option value=\"\">--TODOS--</option><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center; vertical-align: middle !important\" width=5%>N° Item</th><th style=\"text-align: center; vertical-align: middle !important\" width=10%>RUC</th><th style=\"text-align: center; vertical-align: middle !important\" width=25%>Nombre</th><th style=\"text-align: center; vertical-align: middle !important\" width=18%>Dirección</th><th style=\"text-align: center; vertical-align: middle !important\" width=10%>Nro. registro</th><th style=\"text-align: center; vertical-align: middle !important\" width=10%>Fecha vencimiento</th><th style=\"text-align: center; vertical-align: middle !important\" width=5%>Certificador</th><th style=\"text-align: center; vertical-align: middle !important\" width=5%>Estado</th><th style=\"text-align: center; vertical-align: middle !important\" width=20%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstEor.length==0\"><td colspan=9 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{inactivo: item.estado == \'0\', null:  item.estado == \'1\'}\" dir-paginate=\"item in vm.lstEor | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center; vertical-align: middle !important\">{{item.numeroItem}}</td><td data-label=RUC style=\"text-align: center; vertical-align: middle !important\">{{item.ruc}}</td><td data-label=Nombre style=\"text-align: center; vertical-align: middle !important\">{{item.nombre}}</td><td data-label=Dirección style=\"text-align: center; vertical-align: middle !important\">{{item.direccion}}</td><td data-label=\"Nro registro\" style=\"text-align: center; vertical-align: middle !important\">{{item.nroregistro}}</td><td data-label=\"Fecha vencimiento\" style=\"text-align: center; vertical-align: middle !important\">{{item.fechavencimientotexto}}</td><td data-label=Certificador style=\"text-align: center; vertical-align: middle !important\">{{item.nombrecertificador}}</td><td data-label=Estado style=\"text-align: center; vertical-align: middle !important\"><div ng-show=\"{{item.estado == \'1\'}}\">ACTIVO</div><div ng-show=\"{{item.estado == \'0\'}}\">INACTIVO</div></td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.seleccionarEor(item) type=button uib-tooltip=Seleccionar><span class=\"glyphicon glyphicon-check\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/parametro/listado/parametro-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de Parámetros</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>Parámetros</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmParametro.descripcion></div><div class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmParametro.estado class=form-control id=estado name=estado><option value=T>--TODOS--</option><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div><div class=\"form-group col-md-1\"><label></label><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Nombre</th><th style=\"text-align: center\">Unidad Medida</th><th style=\"text-align: center\">Estado</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstParametros.length==0\"><td colspan=5 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametros | itemsPerPage: config.itemsPerPage\" pagination-id=coutparam><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Nombre style=\"text-align: center\">{{item.descripcion}}</td><td data-label=\"Unidad Medida\" style=\"text-align: center\">{{item.auxunidadnombre}}</td><td data-label=Estado style=\"text-align: center\"><div ng-show=\"{{item.estado == \'1\'}}\">ACTIVO</div><div ng-show=\"{{item.estado == \'0\'}}\">INACTIVO</div></td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarInactivacion(item) type=button ng-show=\"{{item.estado == \'1\'}}\" uib-tooltip=Inactivar><span class=\"glyphicon glyphicon-minus-sign\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutparam></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/normalegal/dialog/normalegal-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmNormaLegal.codigo == 0 ? \'Nueva\' : \'Editar\' }} Norma Legal:</h4></div></div><div class=modal-body name=normalegalDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-lg-6\"><label class=important-box>Descripci&oacuten:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':normalegalDataDialogForm.descripcion.$invalid && normalegalDataDialogForm.descripcion.$touched}\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion ng-model=vm.prmNormaLegal.descripcion type=text></div></div><div class=\"form-group col-lg-4\"><label class=important-box>Estado:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmNormaLegal.estado class=\"form-control input-sm\" id=estado name=estado><option value=1>Activo</option><option value=0>Inactivo</option></select></div></div></div><br><div class=row><div class=\"form-group col-lg-6\"><label>Comentario:</label><div class=\"input-group col-lg-12\"><input class=\"form-control input-sm\" id=Comentario ng-model=vm.prmNormaLegal.comentario type=text multiple></div></div></div><br><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmNormaLegal.descripcion==\'\' ||vm.prmNormaLegal.descripcion.length==0\" type=button uib-tooltip=\"{{ vm.prmNormaLegal.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmNormaLegal.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/normalegal/listado/normalegal-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de Normas</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>Normas</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><label>Norma</label><input class=form-control type=text ng-model=vm.prmNormaLegal.descripcion></div><div class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmNormaLegal.estado class=form-control id=estado name=estado><option value=1>VIGENTE</option><option value=2>MODIFICADA</option><option value=3>DEROGADA</option></select></div><div class=\"form-group col-md-1\"><label></label><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div><div class=\"form-group col-md-1\"><label></label><a href={{vm.urlSirin}} target=_blank class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"><span class=icon-agregar></span> Agregar</a></div></div><div class=row><div class=col-md-12><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N&#176; Item</th><th style=\"text-align: center\">Tipo de Dispositivo</th><th style=\"text-align: center\">Norma</th><th style=\"text-align: center\">Nro. de Norma</th><th style=\"text-align: center\">Fecha Aprobación</th><th style=\"text-align: center\">Estado Dispositivo</th><!-- <th style=\"text-align: center\">Acciones</th> --></tr></thead><tbody><tr ng-show=\"vm.lstNormaLegal.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstNormaLegal | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=\"Tipo Dispositivo\" style=\"text-align: center\">{{item.nombreTipoDispositivo}}</td><td data-label=Norma>{{item.descripcion}}</td><td data-label=\"Nro. de Norma\" style=\"text-align: center\">{{item.numeroNorma}}</td><td data-label=\"Fecha Aprobación\" style=\"text-align: center\">{{item.fechaVigencia}}</td><td data-label=\"Estado Dispositivo\" style=\"text-align: center\">{{item.nombreEstado}}</td><!-- <td class=\"text-center\" data-label=\"Acciones\">\r\n									<button class=\"btn btn-default btn-sm\" ng-show=\"false\"\r\n										ng-click=\"vm.agregarItem(item)\" type=\"button\"\r\n										uib-tooltip=\"Editar\">\r\n										<span class=\"icon-editar\"> </span>\r\n									</button>\r\n									<button class=\"btn btn-default btn-sm\" ng-show=\"false\"\r\n										ng-click=\"vm.confirmarInactivacion(item)\" type=\"button\"\r\n										ng-show=\"{{item.estado == \'1\'}}\" uib-tooltip=\"Inactivar\">\r\n										<span class=\"glyphicon glyphicon-minus-sign\"> </span>\r\n									</button>\r\n									<button class=\"btn btn-default btn-sm\" ng-show=\"false\"\r\n										ng-click=\"vm.confirmarEliminacion(item)\" type=\"button\"\r\n										uib-tooltip=\"Eliminar\">\r\n										<span class=\"glyphicon glyphicon-trash\"> </span>\r\n									</button>\r\n								</td> --></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/base/template/dialog-confirm/dialog-confirm.html","<div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{vm.titulo}}</h4></div><div class=modal-body><p class=modal-message style=\"text-align: justify\">{{vm.mensaje}}</p><p class=modal-message style=\"text-align: justify\">{{vm.mensajeadicional}}</p></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" ng-click=closeThisDialog(0)><i class=\"glyphicon glyphicon-remove\" aria-hidden=true></i> Cancelar</button> <button class=\"btn btn-primary btn-sm\" ng-click=confirm(1)><i class=\"glyphicon glyphicon-ok\" aria-hidden=true></i> Confirmar</button></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/reporte/reporte-control-calidad/reporte-control-calidad.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Reporte de Calidad de Datos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Reportes</li><li>Calidad de Datos</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p>Mostrar</p></strong><select class=\"form-control input-sm\" ng-model=vm.dataListaInstalacion.tipoReporte><option value=UF>Unidades Fiscalizables</option><option value=FI>Fichas de Hidrocarburos</option><option value=ID>IGA y Declaración</option><option value=IM>Informe de Monitoreo</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><a class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" download=Reporte.xls href={{vm.urlData}}reporte/descargar-reporte-calidad/{{vm.dataListaInstalacion.tipoReporte}}>Descargar</a></div></div></div></span></div>");
$templateCache.put("app/modules/bandeja/solicitudes/solicitud-acceso.html","<style type=text/css>.red {\r\n	background-color: #FFA5A5 !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Bandeja de solicitudes</span></h3></div></div><br><div id=BandejaSolicitud ng-show=\"vm.flagActivoBandeja==\'1\'\"><!-- <div class=\"row\">\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"tipoPersona\"> Sector: </label> <select\r\n						class=\"form-control input-sm\" id=\"tipoPersona\" name=\"tipoPersona\"\r\n						ng-change=\" vm.listarSubSector()\"\r\n						ng-model=\"vm.datafiltroSolicitudes.sector\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"itemCombo in vm.listaSector\"\r\n							ng-value=\"itemCombo.codigoRegistro*1\">\r\n							{{itemCombo.descripcion}}</option>\r\n					</select>\r\n				</div>\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"tipoPersona\"> Subsector: </label> <select\r\n						class=\"form-control input-sm\" id=\"tipoPersona\" name=\"tipoPersona\"\r\n						ng-change=\"vm.listarActividad()\"\r\n						ng-model=\"vm.datafiltroSolicitudes.subSector\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"itemCombo in vm.listaSubSector\"\r\n							ng-value=\"itemCombo.codigoRegistro*1\">\r\n							{{itemCombo.descripcion}}</option>\r\n					</select>\r\n				</div>\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"tipoPersona\"> Actividad: </label> <select\r\n						class=\"form-control input-sm\" id=\"tipoPersona\" name=\"tipoPersona\"\r\n						ng-model=\"vm.datafiltroSolicitudes.actividad\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"itemCombo in vm.listaActividad\"\r\n							ng-value=\"itemCombo.codigoRegistro*1\">\r\n							{{itemCombo.descripcion}}</option>\r\n					</select>\r\n				</div>\r\n			</div> --><div class=row><div class=\"form-group col-md-2\"><label for=numeroDocumento>Nro de documento:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero maxlength=11 name=numeroDocumento ng-model=vm.datafiltroSolicitudes.documento placeholder=\"Ingrese nro de documento\" type=text></div></div><div class=\"form-group col-md-5\"><label for=razonSocial>Razón social:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=100 name=razonSocial ng-model=vm.datafiltroSolicitudes.nombreCompleto type=text></div></div><div class=\"form-group col-md-2\"><label for=tipoPersona>Estado:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.datafiltroSolicitudes.estado><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaEstadoSolicitud\" ng-value=item.codigoRegistro>{{item.descripcion}}</option></select></div></div><!-- <div class=\"row\">\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"tipoPersona\"> Estado: </label> <select\r\n						class=\"form-control input-sm\" id=\"tipoPersona\" name=\"tipoPersona\"\r\n						ng-model=\"vm.datafiltroSolicitudes.estado\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"item in vm.listaEstadoSolicitud\"\r\n							ng-value=\"item.codigoRegistro\">{{item.descripcion}}</option>\r\n					</select>\r\n				</div>\r\n				<div class=\"form-group col-md-5\">\r\n					<label for=\"tipoPersona\"> Tipo solicitud: </label> <select\r\n						class=\"form-control input-sm\" id=\"tipoPersona\" name=\"tipoPersona\"\r\n						ng-model=\"vm.datafiltroSolicitudes.tipoSolicitud\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"item in vm.listaTipoSolicitud\"\r\n							ng-value=\"item.codigoRegistro\">{{item.descripcion}}</option>\r\n					</select>\r\n				</div> \r\n			</div> --><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'LIMPIAR\')\" type=button uib-tooltip=\"Limpiar filtros\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnRef_recurso ng-click=vm.listarSolicitudes() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'BUSCAR\')\" type=button uib-tooltip=\"Buscar norma\"><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Tipo persona</th><th class=text-center>Documento</th><th class=text-center>Razón social / nombre</th><th class=\"text-center td-tabla-01\">Fecha de registro</th><th class=\"text-center td-tabla-01\">Carta Poder</th><th class=\"text-center td-tabla-01\">Estado</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemSolicitud in vm.listaSolicitudes | orderBy:\'-idSolicitud\' | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center>{{itemSolicitud.nombreTipoPersona}}</td><td class=text-center>{{itemSolicitud.documento}}</td><td class=text-center>{{itemSolicitud.nombreCompleto}}</td><td class=\"text-center td-tabla-01\">{{itemSolicitud.fechaRegistroSolicitud}}</td><td class=\"text-center td-tabla-01\"><a download={{itemSolicitud.contactoAdministrado.nombreArchivo}} target=_blank href={{vm.urlData}}solicitud/descargar-contacto-administrado/{{itemSolicitud.contactoAdministrado.idContactoAdministrado}}>{{itemSolicitud.contactoAdministrado.nombreArchivo}} <span class=icon-ficha title=\"click para descargar\"></span> </a></td><td class=\"text-center td-tabla-01\">{{itemSolicitud.nombreEstado}}</td><td class=text-center style=\"vertical-align: middle !important\"><button class=\"btn btn-default btn-sm\" ng-click=vm.validarDetalleSolicitudEstado(1,itemSolicitud,2) ng-disabled=\"itemSolicitud.estado!=1 && itemSolicitud.estado!=4\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR\')\" type=button uib-tooltip=Aprobar><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.validarDetalleSolicitudEstado(1,itemSolicitud,3) ng-disabled=\"itemSolicitud.estado!=1 && itemSolicitud.estado!=4\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'RECHAZAR\')\" type=button uib-tooltip=Rechazar><span class=\"glyphicon glyphicon-ban-circle\"></span></button></td></tr><!--    <tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n                                <td colspan=\"5\">No se encontraron resultados</td>\r\n                            </tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><br><!--\r\n        <div class=\"row\">\r\n            <div class=\"form-group col-lg-12 text-right\">\r\n                <button type=\"button\" ng-disabled=\"vm.formUsuario.$invalid\" ng-click=\"vm.guardar()\" class=\"btn btn-flat btn-success btn-sm\">\r\n                    <span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar Solicitud\r\n                </button>\r\n                <a class=\"btn btn-flat btn-primary btn-sm\" ng-click=\"vm.limpiar()\">\r\n                    <span class=\"glyphicon glyphicon-erase spac-btn-r\"></span> Limpiar\r\n                </a>\r\n                <button type=\"button\" ng-click=\"vm.cancelar()\" class=\"btn btn-flat btn-default btn-sm\">\r\n                    <span class=\"glyphicon glyphicon- spac-btn-r\"></span> Cancelar\r\n                </button>  \r\n            </div>\r\n        </div>\r\n--></div><div class=datoSolicitudAcceso ng-show=\"vm.flagActivoBandeja==\'0\'\"><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Tipo de Solicitud</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.dataSolicitudes.nombreSolicitud}}</label><br></div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Datos de solicitante</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.dataSolicitudes.documento}} - {{vm.dataSolicitudes.nombreCompleto}}</label><br><label>{{vm.dataSolicitudes.direccionFiscalizacion}}</label><br>{{vm.dataSolicitudes.distrito}} - {{vm.dataSolicitudes.provincia}} - {{vm.dataSolicitudes.departamento}}</div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Representante legal</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.dataSolicitudes.nombreResponsable}}</label><br></div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Contactos</label></center></div><div class=\"form-group col-lg-9\" ng-repeat=\"contacto in vm.listaContactoAdministrado\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{contacto.nombres}}</label><br><labal>( <strong>Cargo:</strong> {{contacto.cargo}} | <strong>Correo:</strong> {{contacto.valor}} | <strong>Teléfono:</strong> {{contacto.telefono}})</labal></div></div><br><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center style=\"vertical-align: middle !important\">Instalación</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Tipo de establecimiento</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Número registro</th><th class=text-center style=\"vertical-align: middle !important\">Sector</th><th class=text-center style=\"vertical-align: middle !important\">Subsector</th><th class=text-center style=\"vertical-align: middle !important\">Competencia</th><th class=text-center style=\"vertical-align: middle !important\">Actividad</th><th class=text-center style=\"vertical-align: middle !important\">Departamento</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Provincia</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Distrito</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Dirección</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Documento</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Estado</th><th class=text-center style=\"vertical-align: middle !important\">Acción</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Selec.</th><th class=\"text-center td-tabla-01\" style=\"vertical-align: middle !important\">Motivo de rechazo</th></tr></thead><tbody><tr ng-class=\'{red : itemInstalacion.instalacion.flgRegistroManual==\"S\", null: itemInstalacion.instalacion.flgRegistroManual != \"S\"}\' dir-paginate=\"itemInstalacion in vm.listaDetalleSolicitud | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.numeroInstalacion}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.nombreTipoEstablecimiento}}</td><td class=text-center style=\"vertical-align: middle !important\"><a download={{itemInstalacion.instalacion.fichaRegistro}} target=_blank href={{vm.urlData}}solicitud/descargar-ficha-instalacion-solicitud/{{itemInstalacion.instalacion.idInstalacion}}>{{itemInstalacion.instalacion.numeroRegistro}} <span class=icon-ficha title=\"Ver Ficha de Registro\"></span> </a></td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.sectorDescripcion}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.subSectorDescripcion}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.competenciaDescripcion}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.actividadDescripcion}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.departamento.descripcionDepartamento}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.provincia.descripcion}}</td><td class=text-center style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.distrito.descripcionDistrito}}</td><td style=\"vertical-align: middle !important\">{{itemInstalacion.instalacion.direccion}}</td><td class=text-center style=\"vertical-align: middle !important\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.descargarFicha(); uib-tooltip=\"Ver ficha Acceso\"><span class=icon-ficha></span></button></td><td style=\"vertical-align: middle !important\">{{itemInstalacion.estado.descripcion}}</td><td class=text-center style=\"vertical-align: middle !important\"><button class=\"btn btn-default btn-sm\" ng-click=vm.validarDetalleSolicitudEstado(1,itemInstalacion,2) ng-disabled=\"itemInstalacion.estado.codigoRegistro!=1 && itemInstalacion.estado.codigoRegistro!=4\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR\')\" type=button uib-tooltip=Aprobar><span class=\"glyphicon glyphicon-ok\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.validarDetalleSolicitudEstado(1,itemInstalacion,3) ng-disabled=\"itemInstalacion.estado.codigoRegistro!=1 && itemInstalacion.estado.codigoRegistro!=4\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'RECHAZAR\')\" type=button uib-tooltip=Rechazar><span class=\"glyphicon glyphicon-ban-circle\"></span></button></td><td class=text-center style=\"vertical-align: middle !important\"><input ng-disabled=\"itemInstalacion.estado.codigoRegistro!=1 && itemInstalacion.estado.codigoRegistro!=4\" ng-model=vm.listaCheck[$index] type=checkbox></td><td style=\"vertical-align: middle !important\"><div style=\"width: 150px\">{{itemInstalacion.instalacion.motivoRechazoInstalacion}}</div></td></tr><!--    <tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n                                <td colspan=\"5\">No se encontraron resultados</td>\r\n                            </tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.aprobarSolicitudesSelecc() ng-disabled=!vm.tieneParaAprobar ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR SELECCIONADAS\')\" type=button uib-tooltip=\"Aprobar seleccionadas\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Aprobar seleccionadas</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.aprobarTodasSolicitudes() ng-disabled=!vm.tieneParaAprobar ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR TODAS\')\" type=button uib-tooltip=\"Aprobar todas\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Aprobar todas</button></div></div></div><div class=row ng-if=\"vm.dataSolicitudes.tipoSolicitud == 2\"><div class=\"form-group col-md-12\"><h3>Instalacion Vigente:</h3></div></div><div class=row ng-if=\"vm.dataSolicitudes.tipoSolicitud == 2\"><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Instalación</th><th class=\"text-center td-tabla-01\">Tipo de establecimiento</th><th class=\"text-center td-tabla-01\">Número registro</th><th class=text-center>Sector</th><th class=text-center>Subsector</th><th class=text-center>Actividad</th><th class=text-center>Departamento</th><th class=\"text-center td-tabla-01\">Provincia</th><th class=\"text-center td-tabla-01\">Distrito</th><th class=\"text-center td-tabla-01\">Dirección</th><th class=\"text-center td-tabla-01\">Documento</th></tr></thead><tbody><tr><td>{{vm.dataInstacionVigente.numeroInstalacion}}</td><td>{{vm.dataInstacionVigente.nombreTipoEstablecimiento}}</td><td><a style=\"color: #337ab7 !important\" download={{vm.dataInstacionVigente.fichaRegistro}} href={{vm.urlData}}instalacion/descargar-ficha-instalacion/{{vm.dataInstacionVigente.idInstalacion}}>{{vm.dataInstacionVigente.numeroRegistro}} </a></td><td>{{vm.dataInstacionVigente.sector.descripcion}}</td><td>{{vm.dataInstacionVigente.subSector.descripcion}}</td><td>{{vm.dataInstacionVigente.actividad.descripcion}}</td><td>{{vm.dataInstacionVigente.departamento.descripcionDepartamento}}</td><td>{{vm.dataInstacionVigente.provincia.descripcion}}</td><td>{{vm.dataInstacionVigente.distrito.descripcionDistrito}}</td><td>{{vm.dataInstacionVigente.direccion}}</td><td><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.descargarFicha(); uib-tooltip=\"Ver ficha\"><span class=icon-ficha></span></button></td></tr><!--    <tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n                                <td colspan=\"5\">No se encontraron resultados</td>\r\n                            </tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><!--\r\n                <div class=\"\">\r\n                    <div class=\"col-lg-12 text-right\">\r\n                        <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.aprobarSolicitudesSelecc()\" ng-disabled=\"!vm.tieneParaAprobar\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR SELECCIONADAS\')\" type=\"button\" uib-tooltip=\"Aprobar seleccionadas\">\r\n                            <span class=\"glyphicon glyphicon-ok spac-btn-r\">\r\n                            </span>\r\n                            Aprobar seleccionadas\r\n                        </button>\r\n                        <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.aprobarTodasSolicitudes()\" ng-disabled=\"!vm.tieneParaAprobar\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR TODAS\')\" type=\"button\" uib-tooltip=\"Aprobar todas\">\r\n                            <span class=\"glyphicon glyphicon-ok spac-btn-r\">\r\n                            </span>\r\n                            Aprobar todas\r\n                        </button>\r\n                    </div>\r\n                </div>\r\n--></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() type=button uib-tooltip=Regresar><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/parametro/dialog/parametro-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmParametro.codigo == 0 ? \'Nuevo\' : \'Editar\' }} Parámetro:</h4></div></div><div class=modal-body name=parametroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-lg-6\"><label class=important-box>Descripci&oacuten:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.descripcion.$invalid && parametroDataDialogForm.descripcion.$touched}\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion maxlength=500 ng-model=vm.prmParametro.descripcion type=text></div></div><div class=\"form-group col-lg-4\"><label class=important-box>Estado:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.prmParametro.estado class=\"form-control input-sm\" id=estado name=estado><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div></div></div><br><div class=row><div class=\"form-group col-lg-4\"><label class=important-box>Unidad de Medida:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.unidadmedida.$invalid && parametroDataDialogForm.unidadmedida.$touched}\"><select ng-model=vm.prmParametro.cod_unidad class=\"form-control input-sm\" id=unidadmedida name=unidadmedida><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstUnidadMedida\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div></div></div><br><div class=row><uib-tabset active=0><uib-tab heading=\"Estándares de Calidad Ambiental (ECA)\" index=0><br><div class=col-md-12><div class=row><div class=\"form-group col-lg-3\"><label class=important-box>Periodo:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.dataParametroECA.cod_periodo class=\"form-control input-sm\" id=periodoeca name=periodoeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstFrecuencia\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Norma Legal:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroECA.cod_norma class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstNormaLegal\" ng-value=itemCombo.idNorma>{{itemCombo.numeroNorma}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Clasificación:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.dataParametroECA.cod_actividad class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstActividad\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div></div><div class=row><div class=\"form-group col-lg-3\"><label>Concentración:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroECA.concentracion_codigo ng-change=vm.validarConcentracion(vm.dataParametroECA.concentracion_codigo); class=\"form-control input-sm\" id=normaeca name=normaeca><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.lstConcetracion\" value={{itemCombo.codigoRegistro}}>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Valor:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion ng-model=vm.dataParametroECA.valor type=text></div></div><div class=\"form-group col-lg-3\" ng-show=vm.mostrarValor2><label class=important-box>Valor 2:</label><div class=\"input-group col-lg-12\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion ng-model=vm.dataParametroECA.valor2 type=text></div></div></div><div class=row><div class=\"form-group col-lg-3\"><label>Componente:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroECA.componente class=\"form-control input-sm\" id=matriz ng-change=\"vm.listarMatriz(vm.dataParametroECA.componente);vm.dataParametroECA.matriz=0;vm.dataParametroECA.submatriz=0\" name=matriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstComponente\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroECA.matriz class=\"form-control input-sm\" id=matriz ng-change=\"vm.listarSubMatriz(vm.dataParametroECA.matriz);vm.dataParametroECA.submatriz=0\" name=matriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Sub Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroECA.submatriz class=\"form-control input-sm\" id=submatriz name=submatriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstSubMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarECA() type=button uib-tooltip=\"Agregar ECA\" ng-disabled=\"vm.dataParametroECA.cod_periodo == 0 ||  vm.dataParametroECA.valor==null || \r\n							   ((vm.dataParametroECA.valor==0 || vm.dataParametroECA.valor==\'\' ) && (vm.dataParametroECA.concentracion_codigo==0 || vm.dataParametroECA.concentracion_codigo==null))\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span>Agregar</button></div></div><br><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Componente</th><th style=\"text-align: center\">Norma Legal</th><th style=\"text-align: center\">Periodo</th><th style=\"text-align: center\">Clasificación</th><th style=\"text-align: center\">ECA</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmParametro.lstEcas.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmParametro.lstEcas | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=Componente style=\"text-align: center\">{{item.componenteNombre}}</td><td data-label=\"Norma Legal\" style=\"text-align: center\">{{item.auxNormaNombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.auxPeriodoNombre}}</td><td data-label=Clasificación style=\"text-align: center\">{{item.auxActividadNombre}}</td><td data-label=ECA style=\"text-align: center\"><div ng-show=\"{{item.concentracion_texto.toUpperCase() == \'RANGO\'}}\">Rango: {{item.valor}} a {{item.valor2}}</div><div ng-show=\"{{item.concentracion_texto.toUpperCase() == null || item.concentracion_texto.toUpperCase() == \'\'}}\">{{item.valor}}</div><div ng-show=\"{{item.concentracion_texto.toUpperCase() == \'<\'}}\">{{item.concentracion_texto}} {{item.valor}}</div><div ng-show=\"{{item.concentracion_texto.toUpperCase() != \'RANGO\' && item.concentracion_texto.toUpperCase() != \'<\'}}\">{{item.concentracion_texto.toUpperCase()}}</div></td><td data-label=Acción style=\"text-align: center\"><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionECA(item,$index) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></uib-tab><uib-tab heading=\"Límites Máximos Permisibles (LMP)\" index=1><br><div class=col-md-12><div class=row><div class=\"form-group col-lg-3\"><label class=important-box>Periodo:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.dataParametroLMP.cod_periodo class=\"form-control input-sm\" id=periodoeca name=periodoeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstFrecuencia\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Norma Legal:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroLMP.cod_norma class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstNormaLegal\" ng-value=itemCombo.idNorma>{{itemCombo.numeroNorma}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Clasificación:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.dataParametroLMP.cod_actividad class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstActividad\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div></div><div class=row><div class=\"form-group col-lg-3\"><label>Concentración:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroLMP.concentracion_codigo ng-change=vm.validarConcentracionLMP(vm.dataParametroLMP.concentracion_codigo); class=\"form-control input-sm\" id=normaeca name=normaeca><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.lstConcetracion\" value={{itemCombo.codigoRegistro}}>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Valor:</label><div class=\"input-group col-lg-12\"><input class=\"form-control input-sm\" id=Descripcion ng-model=vm.dataParametroLMP.valor type=text></div></div><div class=\"form-group col-lg-3\" ng-show=vm.mostrarValorLMP2><label class=important-box>Valor 2:</label><div class=\"input-group col-lg-12\"><input class=\"form-control input-sm\" id=Descripcion ng-model=vm.dataParametroLMP.valor2 type=text></div></div></div><div class=row><div class=\"form-group col-lg-3\"><label>Componente:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroLMP.componente class=\"form-control input-sm\" id=matriz ng-change=\"vm.listarMatriz(vm.dataParametroLMP.componente);vm.dataParametroLMP.matriz=0;vm.dataParametroLMP.submatriz=0\" name=matriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstComponente\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroLMP.matriz class=\"form-control input-sm\" id=matriz ng-change=\"vm.listarSubMatriz(vm.dataParametroLMP.matriz);vm.dataParametroLMP.submatriz=0\" name=matriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-3\"><label>Sub Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.dataParametroLMP.submatriz class=\"form-control input-sm\" id=submatriz name=submatriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstSubMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarLMP() type=button uib-tooltip=\"Agregar LMP\" ng-disabled=\"vm.dataParametroLMP.cod_periodo == 0  || vm.dataParametroLMP.valor==null || \r\n							   ((vm.dataParametroLMP.valor==0 || vm.dataParametroLMP.valor==\'\' ) && (vm.dataParametroLMP.concentracion_codigo==0 || vm.dataParametroLMP.concentracion_codigo==null))\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span>Agregar</button></div></div><br><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Componente</th><th style=\"text-align: center\">Norma Legal</th><th style=\"text-align: center\">Periodo</th><th style=\"text-align: center\">Clasificación</th><th style=\"text-align: center\">LMP</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmParametro.lstLmps.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmParametro.lstLmps | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=Componente style=\"text-align: center\">{{item.componenteNombre}}</td><td data-label=\"Norma Legal\" style=\"text-align: center\">{{item.auxNormaNombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.auxPeriodoNombre}}</td><td data-label=Actividad style=\"text-align: center\">{{item.auxActividadNombre}}</td><td data-label=LMP style=\"text-align: center\"><div ng-show=\"{{item.concentracion_texto.toUpperCase() == \'RANGO\'}}\">Rango: {{item.valor}} a {{item.valor2}}</div><div ng-show=\"{{item.concentracion_texto.toUpperCase() == null || item.concentracion_texto.toUpperCase() == \'\'}}\">{{item.valor}}</div><div ng-show=\"{{item.concentracion_texto.toUpperCase() == \'<\'}}\">{{item.concentracion_texto}} {{item.valor}}</div><div ng-show=\"{{item.concentracion_texto.toUpperCase() != \'RANGO\' && item.concentracion_texto.toUpperCase() != \'<\'}}\">{{item.concentracion_texto.toUpperCase()}}</div></td><td data-label=Acción style=\"text-align: center\"><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionLMP(item,$index) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></uib-tab></uib-tabset></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmParametro.descripcion==null ||vm.prmParametro.descripcion.length==0 || vm.prmParametro.cod_unidad == 0\" type=button uib-tooltip=\"{{ vm.prmParametro.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmParametro.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/parametro/dialog/parametro-selector.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector de Parámetros</h4></div></div><div class=modal-body name=parametroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-3\"><label>Parámetro</label><input class=form-control type=text ng-model=vm.prmParametroValor.auxParametroNombre></div><div class=\"form-group col-lg-3\"><label>Unidad de Medida:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmParametroValor.cod_unidad class=\"form-control input-sm\" id=unidadmedida name=unidadmedida><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstUnidadMedida\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-md-3\"><label>Periodo:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\"><select ng-model=vm.prmParametroValor.cod_periodo class=\"form-control input-sm\" id=periodoeca name=periodoeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstFrecuencia\" ng-value=itemCombo.idMaestro>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-md-3\"><label>Norma Legal:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmParametroValor.cod_norma class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstNormaLegal\" ng-value=itemCombo.idNorma>{{itemCombo.numeroNorma}}</option></select></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Parámetro</th><th style=\"text-align: center\">Unidad Medida</th><th style=\"text-align: center\">Periodo</th><th style=\"text-align: center\">Valor</th><th style=\"text-align: center\">Norma</th><th style=\"text-align: center\">Selección</th></tr></thead><tbody><tr ng-show=\"vm.lstParametros.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametros | itemsPerPage: config.itemsPerPage\" pagination-id=coutps><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Nombre style=\"text-align: center\">{{item.auxParametroNombre}}</td><td data-label=\"Unidad Medida\" style=\"text-align: center\">{{item.auxUnidadNombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.auxPeriodoNombre}}</td><td data-label=Valor style=\"text-align: center\" title={{item.auxActividadNombre}}>{{item.tipo}}: {{item.valor}}</td><td data-label=Norma style=\"text-align: center\">{{item.auxNormaNombre}}</td><td class=text-center data-label=Selección><input type=checkbox ng-model=item.blSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=coutps></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.guardar()><i aria-hidden=true></i> Aceptar</button></div></div></span></div>");
$templateCache.put("app/modules/preguntas/banco-preguntas/banco-pregunta.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Banco de preguntas</span></h3></div></div><br><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Sector:</label><select class=\"form-control input-sm\" ng-change=\" vm.listarSubSector()\" ng-model=vm.dataPregunta.codigoSector><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaSector\" ng-value=item.codigoRegistro*1>{{item.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Subsector:</label><select class=\"form-control input-sm\" ng-model=vm.dataPregunta.codigoSubSector><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaSubSector\" ng-value=item.codigoRegistro*1>{{item.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Periodo:</label><select class=\"form-control input-sm\" ng-model=vm.dataPregunta.codigoPeriodo><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaPeriodoPreguntas\" ng-value=item.codigoRegistro*1>{{item.descripcion}}</option></select></div><!--\r\n					  <div class=\"form-group col-md-3\">\r\n							<label for=\"tipoPersona\">Actividad:</label>\r\n					\r\n							<select ng-options=\"item as item.descripcion for item in vm.listaActividad track by item.codigoRegistro\" \r\n								ng-model=\"vm.dataPreguntaSector.actividad\"  class=\"form-control input-sm\" >\r\n								<option ng-value=\"0\">Seleccione</option>\r\n							</select>\r\n\r\n						</div>\r\n				--></div><!--\r\n		<div class=\"row\">\r\n			<div class=\"form-group col-md-3\">\r\n				<label for=\"tipoPersona\">Sector:</label> <select id=\"tipoPersona\"\r\n					name=\"tipoPersona\" ng-model=\"vm.dataInstalacion.sector\"\r\n					class=\"form-control input-sm\">\r\n					<option ng-value=\"0\">Seleccione</option>\r\n					<option ng-repeat=\"itemCombo in vm.listaSector\"\r\n						ng-value=\"itemCombo.codigoRegistro*1\">{{itemCombo.descripcion}}</option>\r\n				</select>\r\n			</div>\r\n\r\n			<div class=\"form-group col-md-3\">\r\n				<label for=\"tipoPersona\">Sub Sector:</label> <select\r\n					id=\"tipoPersona\" name=\"tipoPersona\"\r\n					ng-model=\"vm.dataInstalacion.subSector\"\r\n					class=\"form-control input-sm\">\r\n					<option ng-value=\"0\">Seleccione</option>\r\n					<option ng-repeat=\"itemCombo in vm.listaSubSector\"\r\n						ng-value=\"itemCombo.codigoRegistro*1\">{{itemCombo.descripcion}}</option>\r\n				</select>\r\n			</div>\r\n\r\n		</div>\r\n		--><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Tipo pregunta:</label><select class=\"form-control input-sm\" ng-model=vm.dataPregunta.tipoPregunta.codigoRegistro><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoPregunta\" ng-value=item.codigoRegistro*1>{{item.descripcion}}</option></select></div><div class=\"form-group col-md-6\"><label for=numeroDocumento>Pregunta:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=400 name=\"descripcion Pregunta\" ng-model=vm.dataPregunta.descripcion placeholder=\"Ingrese pregunta\" type=text></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.limpiar() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'LIMPIAR\')\" type=button uib-tooltip=\"Limpiar filtros\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary btn-sm\" id=btnRef_recurso ng-click=vm.listarPregunta() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'BUSCAR\')\" type=button uib-tooltip=\"Buscar pregunta\"><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button> <a class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.nuevoRegistroPregunta() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO\')\" uib-tooltip=\"Nuevo registro\"><span class=\"icon-nuevo spac-btn-r\"></span> Nuevo</a></div></div><br><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Tipo pregunta</th><th class=text-center>Pregunta</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"item in vm.listaPreguntas | orderBy:\'idPregunta\' | itemsPerPage: config.itemsPerPage  track by $index\" pagination-id=coutListadoPregunta><td class=text-center data-label=Ítem>{{ $index + serial}}</td><td class=text-center data-label=\"Tipo pregunta\">{{item.tipoPregunta.descripcion}}</td><td class=text-center data-label=Pregunta>{{item.descripcion}}</td><td class=\"text-center td-tabla-01\" data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.buscarPregunta(item) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR\')\" type=button uib-tooltip=\"Editar pregunta\"><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminarPregunta(item) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR\')\" type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"vm.listaPreguntas==null || vm.listaPreguntas.length==0\"><td colspan=4>No se encontraron resultados.</td></tr></tbody></table><!--<dir-pagination-controls pagination-id=\"cout\" ></dir-pagination-controls>\r\n				--><dir-pagination-controls boundary-links=true direction-links=true max-size=8 on-page-change=indexCount(newPageNumber) pagination-id=coutListadoPregunta></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/reporte/reporte-preliminar/reporte-preliminar-datos.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Datos del Reporte {{ vm.dataInstalacion.numeroInstalacion}}</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Intrumento de Gestión</p></strong></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" id=iga name=iga ng-model=vm.dataInstalacion.idIga><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaInstrumentos\" ng-value=\"{{ item.idInstrumentoGestion }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Etapa</p></strong></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" id=etapa name=etapa ng-model=vm.idEtapa><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaEtapas\" ng-value=\"{{ item.codetapa }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Periodo</p></strong></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" ng-model=vm.periodo><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option><option ng-value=2015>2015</option><option ng-value=2014>2014</option><option ng-value=2013>2013</option><option ng-value=2012>2012</option><option ng-value=2011>2011</option><option ng-value=2010>2010</option><option ng-value=2009>2009</option><option ng-value=2008>2008</option></select></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><a download=Rep_Supervision.pdf href={{vm.urlData}}reporte/descargar-reporte-supervision/{{vm.dataInstalacion.idAdministrado}}/{{vm.dataInstalacion.idInstalacion}}/{{vm.dataInstalacion.idIga}}/{{vm.idEtapa}}/{{vm.periodo}} target=_blank>Descargar Reporte</a> <button class=\"btn btn-primary btn-sm\" ng-click=closeThisDialog(0)><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i> Cerrar</button></div></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/reporte/reporte-preliminar/reporte-preliminar.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Reportes</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Reportes</li><li>Reporte Preliminar</li></ol></span></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p>RUC</p></strong><input class=form-control type=text ng-model=vm.dataListaInstalacion.ruc></div><div class=\"form-group col-md-3\"><strong><p>Administrado</p></strong><input class=form-control type=text ng-model=vm.dataListaInstalacion.razonsocial></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-change=\"vm.listarProvincia();vm.dataUbigeo.codigoProvincia = \'\';vm.dataUbigeo.codigoDistrito = \'\';\" ng-model=vm.dataListaInstalacion.departamento.codigoDepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=vm.listarDistrito() ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataListaInstalacion.provincia.codigoProvincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataListaInstalacion.distrito.codigoDistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.buscar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>RUC</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Administrado</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Unidad Fiscalizable</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Dirección</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Provincia</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Departamento</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Actividad</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1 width=20%>Reporte de Supervisión</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1 width=20%>Reporte IMA</th></tr></thead><tbody><tr ng-show=\"vm.listaInstalacionAdm.length==0\"><td colspan=10>No se encontraron resultados</td></tr><tr dir-paginate=\"itemInstalacion in vm.listaInstalacionAdm | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutListadoInstalacionAdm><td class=text-center data-label=N&#176;>{{itemInstalacion.numeroItem}}</td><td data-label=RUC>{{itemInstalacion.ruc}}</td><td data-label=Administrado>{{itemInstalacion.razonsocial}}</td><td data-label=\"Unidad Fiscalizable\">{{itemInstalacion.numeroInstalacion}}</td><td data-label=Dirección>{{itemInstalacion.direccion}}</td><td data-label=Distrito>{{itemInstalacion.distrito.descripcionDistrito}}</td><td data-label=Provincia>{{itemInstalacion.provincia.descripcion}}</td><td data-label=Departamento>{{itemInstalacion.departamento.descripcionDepartamento}}</td><td data-label=Actividad>{{itemInstalacion.actividadDescripcion}}</td><td class=text-center data-label=Acción><a download=Rep_Supervision.pdf ng-show=\"itemInstalacion.periodo!=0 && itemInstalacion.periodo != null\" href={{vm.urlData}}reporte/descargar-reporte-supervision/{{itemInstalacion.idAdministrado}}/{{itemInstalacion.idInstalacion}}/{{itemInstalacion.periodo}} target=_blank>Descargar</a><select class=\"form-control input-sm\" ng-model=itemInstalacion.periodo><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option></select></td><td class=text-center data-label=\"Reporte IMA\"><a download=Rep_IMA.pdf ng-show=\"itemInstalacion.periodo!=0 && itemInstalacion.periodo != null\" href={{vm.urlData}}reporte/descargar-reporte-ima/{{itemInstalacion.idAdministrado}}/{{itemInstalacion.idInstalacion}}/{{itemInstalacion.periodo}} target=_blank>Descargar</a><select class=\"form-control input-sm\" ng-model=itemInstalacion.periodo><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option></select></td></tr></tbody></table><dir-pagination-controls pagination-id=coutListadoInstalacionAdm></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/base/template/dialog-confirm-registro/dialog-mensaje-registro.html","<div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{vm.titulo}}</h4></div><div class=modal-body><p class=modal-message style=\"text-align: justify\">{{vm.mensaje}}</p></div><div class=\"modal-footer text-center\"><button ng-show=!swBuscar class=\"btn btn-primary btn-sm\" ng-click=vm.operacion(0)><i class=\"glyphicon glyphicon-remove\" aria-hidden=true></i> No</button> <button ng-show=swBuscar class=\"btn btn-primary btn-sm\" ng-click=vm.operacion(1)><i class=\"glyphicon glyphicon-search\" aria-hidden=true></i> Buscar</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.operacion(2)><i class=\"glyphicon glyphicon-plus\" aria-hidden=true></i> {{tituloBtnRegistrar + vm.tituloBtnRegistrar}}</button></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/base/template/dialog-info/dialog-info.html","<div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.titulo }}</h4></div><div class=modal-body><p class=modal-message style=\"text-align: justify\">{{ vm.mensaje }}</p></div><div class=modal-footer><button class=\"btn btn-default btn-sm\" ng-click=closeThisDialog(0)>Salir</button></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/administrado/administrado-supervicion-online.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Módulo de supervisión administrado</span></h3></div></div><br><!-- 	<uib-tabset active=\"active\"> \r\n		<uib-tab heading=\"Datos del Administrado\" index=\"0\"> <br />\r\n		<uib-tabset active=\"informacion\"> <uib-tab\r\n			heading=\"Mis datos\" index=\"0\"> <br /> --><fieldset class=\"well unp-fieldset\"><legend class=\"unp-legend title-slider-nt\">Mis datos</legend><div class=row><div class=\"form-group col-md-6\"><label for=tipoPersona>Tipo de persona:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-disabled=true ng-model=vm.dataAdministrado.tipoAdministrado><option ng-repeat=\"itemCombo in vm.listaTipoPersona\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div></div><div class=row><div class=\"form-group col-md-6\"><label for=tipoDocumento>Tipo de documento:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-disabled=true ng-model=vm.dataAdministrado.tipoAdministrado><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaTipoDocumento\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><label for=numeroDocumento>Nro de documento:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero maxlength=8 name=numeroDocumento ng-disabled=true ng-model=vm.dataAdministrado.persona.documento type=text></div></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataAdministrado.tipoAdministrado==2\"><label for=numeroDocumento>Nro de documento:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero maxlength=11 name=numeroDocumento ng-disabled=true ng-model=vm.dataAdministrado.entidad.ruc type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==2\"><label for=razonSocial>Razón social:</label><div class=form-group><input class=\"form-control input-sm\" name=razonSocial ng-disabled=true ng-model=vm.dataAdministrado.entidad.razonSocial type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==2\"><label for=cargo>Cargo:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-disabled=true ng-model=vm.dataEntidad.nomCargo type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=representanteLegal>Representante legal:</label><div class=form-group><input class=\"form-control input-sm\" name=representanteLegal ng-disabled=true ng-model=vm.dataEntidad.representanteLegal.idPersona type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><label for=nombres>Nombres:</label><div class=form-group><input class=\"form-control input-sm\" name=nombres ng-disabled=true ng-model=vm.dataAdministrado.persona.nombreCompleto type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==2\"><label for=nombres>Nombre de representante:</label><div class=form-group><input class=\"form-control input-sm\" name=nombres ng-disabled=true ng-model=vm.dataAdministrado.entidad.representanteLegal.nombreCompleto type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><label for=apellidoPaterno>Apellido paterno:</label><div class=form-group><input class=\"form-control input-sm\" name=apellidoPaterno ng-disabled=true ng-model=vm.dataAdministrado.persona.apellidoPaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><label for=apellidoMaterno>Apellido materno:</label><div class=form-group><input class=\"form-control input-sm\" name=apellidoMaterno ng-disabled=true ng-model=vm.dataAdministrado.persona.apellidoMaterno type=text></div></div></div><div class=row ng-show=\"vm.dataAdministrado.tipoAdministrado==2\"><div class=\"form-group col-md-6\"><label for=departamento>Departamento:</label><div class=form-group><input class=\"form-control input-sm\" name=departamento ng-disabled=true ng-model=vm.dataAdministrado.entidad.nombreDepartamento type=text></div></div><div class=\"form-group col-md-6\"><label for=provincia>Provincia:</label><div class=form-group><input class=\"form-control input-sm\" name=provincia ng-disabled=true ng-model=vm.dataAdministrado.entidad.nombreProvincia type=text></div></div></div><div class=row ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><div class=\"form-group col-md-6\"><label for=departamento>Departamento:</label><div class=form-group><input class=\"form-control input-sm\" name=departamento ng-disabled=true ng-model=vm.dataAdministrado.persona.nombreDepartamento type=text></div></div><div class=\"form-group col-md-6\"><label for=provincia>Provincia:</label><div class=form-group><input class=\"form-control input-sm\" name=provincia ng-disabled=true ng-model=vm.dataAdministrado.persona.nombreProvincia type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><label for=distrito>Distrito:</label><div class=form-group><input class=\"form-control input-sm\" name=distrito ng-disabled=true ng-model=vm.dataAdministrado.persona.nombreDistrito type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataAdministrado.tipoAdministrado==1\"><label for=direccion>Dirección:</label><div class=form-group><input class=\"form-control input-sm\" name=direccion ng-disabled=true ng-model=vm.dataAdministrado.persona.direccion type=text></div></div></div><div class=row ng-show=\"vm.dataAdministrado.tipoAdministrado==2\"><div class=\"form-group col-md-6\"><label for=distrito>Distrito:</label><div class=form-group><input class=\"form-control input-sm\" name=distrito ng-disabled=true ng-model=vm.dataAdministrado.entidad.nombreDistrito type=text></div></div><div class=\"form-group col-md-6\"><label for=domicilio>Domicilio fiscal:</label><div class=form-group><input class=\"form-control input-sm\" name=domicilio ng-disabled=true ng-model=vm.dataAdministrado.entidad.direccion type=text></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><!--   <button type=\"button\" ng-click=\"vm.guardar()\" class=\"btn btn-flat btn-primary btn-sm btn-sm\">\r\n                                <span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Modificar\r\n                            </button>--><!-- <button type=\"button\" ng-disabled=\"vm.formUsuario.$invalid\" ng-click=\"vm.guardar()\" class=\"btn btn-flat btn-success btn-sm\">\r\n                                <span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Nueva Instalacion\r\n                            </button> --><!--\r\n                            <button type=\"button\" ng-click=\"vm.cancelar()\" class=\"btn btn-flat btn-primary btn-sm\">\r\n                                <span class=\"glyphicon glyphicon-remove-circle spac-btn-r\"></span> Cancelar\r\n                            </button>--></div></div><div class=row ng-show=false><div class=\"form-group col-md-3\"><label for=tipoContacto>Tipo contacto:</label><select class=\"form-control input-sm\" ng-change=\"vm.dataContactoAdministrado.valor=\'\'\" ng-model=vm.dataContactoAdministrado.tipoContacto ng-options=\"item as item.descripcion for item in vm.listaCboTipoContacto track by item.codigoRegistro\"></select></div><br><div class=\"form-group col-md-3\"><label for=tipoDocumento></label><button class=\"btn btn-primary btn-sm\" ng-click=vm.agregarContactoAdministrado() ng-disabled=\"vm.dataContactoAdministrado.valor==\'\'\" ng-show=\"vm.dataContactoAdministrado.tipoContacto.codigoRegistro!=0\" type=button uib-tooltip=\"Agregar contacto\"><span class=icon-agregar></span></button></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=false><label for=correo>Valor contacto:</label><div class=form-group ng-show=\"vm.dataContactoAdministrado.tipoContacto.codigoRegistro==1\"><input autocomplete=off class=\"form-control input-sm\" id=txtTelefono maxlength=15 name=correo ng-keyup=vm.valorTelefono(vm.dataContactoAdministrado.valor) ng-model=vm.dataContactoAdministrado.valor ng-pattern=vm.validarTelefono placeholder=\"Ingresar TelÃ©fono\" required type=text></div><div class=form-group ng-show=\"vm.dataContactoAdministrado.tipoContacto.codigoRegistro==2\"><div class=input-group><span autocomplete=off class=input-group-addon>Email </span><input autocomplete=off class=\"form-control input-sm\" data-error=\"Bruh, that email address is invalid\" name=correo ng-class=\"\'minuscula\'\" ng-model=vm.dataContactoAdministrado.valor ng-pattern=/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,8}$/ ng-show=\"vm.dataContactoAdministrado.tipoContacto.codigoRegistro==2\" onkeyup=\"this.value=this.value.toLowerCase()\" placeholder=\"Ingresar Contacto \" required type=text></div></div></div><div class=\"form-group col-md-12 text-right\"><div class=form-group><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.agregarContacto()><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12><div class=table-rpv><table class=\"table table-bordered\"><thead><tr><th class=text-center>Contacto</th><th class=text-center>Cargo</th><th class=text-center>Correo</th><th class=text-center>Teléfono</th><th class=text-center>Acción</th></tr></thead><tbody><tr dir-paginate=\"item in vm.dataAdministrado.lstContactoAdministrado  | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Contacto>{{ item.nombres }}</td><td class=text-center data-label=Cargo>{{ item.cargo }}</td><td class=text-center data-label=Correo>{{ item.valor }}</td><td class=text-center data-label=Teléfono>{{ item.telefono }}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarContacto(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarContacto($index) style=\"background: rgba(255, 255, 0, 0) !important; border: 0px\" type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></fieldset></span></div>");
$templateCache.put("app/modules/supervision/administrado/administrado-supervision-online-contacto.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Contactos de Administrado</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-6\"><label for=cargo>Nombre:</label><input class=\"form-control input-sm\" type=text ng-model=vm.prmContacto.nombres></div><div class=\"form-group col-md-6\"><label for=cargo>Cargo:</label><input class=\"form-control input-sm\" type=text ng-model=vm.prmContacto.cargo></div></div><div class=row><div class=\"form-group col-md-6\"><label for=cargo>Correo:</label><input ng-pattern=/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,8}$/ class=\"form-control input-sm\" ng-model=vm.prmContacto.valor type=text></div><div class=\"form-group col-md-6\"><label for=cargo>Teléfono:</label><input maxlength=12 class=\"form-control input-sm\" ng-model=vm.prmContacto.telefono type=text></div></div><br><div class=row><div class=\"form-group col-md-6\"><label for=cargo>Estado:</label><div><select ng-model=vm.prmContacto.estado.codigoRegistro class=\"form-control input-sm\" id=estado name=estado><option value=1 ng-value=1>Activo</option><option value=0 ng-value=0>Inactivo</option></select></div></div><div class=\"form-group col-md-6\"><label for=cargo class=important-box>¿Contacto principal?:</label><div><input type=checkbox ng-model=vm.prmContacto.isPredeterminado id=predeterminado name=predeterminado></div><a download={{vm.prmContacto.nombreArchivo}} target=_blank ng-if=\"vm.prmContacto.uuid != null && vm.prmContacto.uuid != \'\'\" href={{vm.urlData}}solicitud/descargar-contacto-administrado/{{vm.prmContacto.idContactoAdministrado}}>{{vm.prmContacto.nombreArchivo}} <span class=icon-ficha title=\"click para descargar\"></span></a></div></div><br><div class=row ng-show=vm.prmContacto.isPredeterminado><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Carta Poder:</label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.prmContacto.nombres==null || vm.prmContacto.nombres ==\'\' || vm.prmContacto.cargo==null || vm.prmContacto.cargo==\'\' || vm.prmContacto.valor==null || vm.prmContacto.valor==\'\'\r\n					|| vm.prmContacto.telefono ==null || vm.prmContacto.telefono ==\'\'\" ng-click=vm.guardarContacto()><i aria-hidden=true></i> Grabar</button></div></div><br></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/iga/instrumento-gestion.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Instrumentos de Gestión Ambiental</span></h3></div></div><br><h3 class=title-slider-nt style=\"color: gray; font-weight: lighter\">Datos de la Unidad Fiscalizable:</h3><br><div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">N° de Registro:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.prmInstalacion.numeroRegistro}}</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Nombre:</label></div><div class=\"form-group col-lg-4\"><label>{{vm.prmInstalacion.numeroInstalacion}}</label></div></div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Departamento:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.prmInstalacion.departamento.descripcionDepartamento}}</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Provincia:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.prmInstalacion.provincia.descripcion}}</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Distrito:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.prmInstalacion.distrito.descripcionDistrito}}</label></div></div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Dirección:</label></div><div class=\"form-group col-lg-4\"><label>{{ vm.prmInstalacion.direccion}}</label></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.nuevoIGA()><span class=icon-agregar></span> Registro de IGA</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Tipo</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución>{{item.resolucion}}</td><td data-label=Fecha>{{item.fechaAprobacion}}</td><td align=center><a class=icon-ficha target=_blank download={{item.archivoNombre}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{item.idInstrumentoGestion}}>{{item.archivoNombre}}</a></td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.nuevoIGA(item) ng-disabled=false type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) ng-disabled=false type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.irDeclaracion(item) type=button uib-tooltip=\"Declaración de la Información\"><span class=\"glyphicon glyphicon-cog\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/reporte/reporte-supervision/reporte-supervision-datos.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Datos del Reporte {{ vm.dataInstalacion.numeroInstalacion}}</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Intrumento de Gestión</p></strong></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" id=iga name=iga ng-model=vm.dataInstalacion.idIga><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaInstrumentos\" ng-value=\"{{ item.idInstrumentoGestion }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Etapa</p></strong></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" id=etapa name=etapa ng-model=vm.idEtapa><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaEtapas\" ng-value=\"{{ item.codetapa }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Periodo</p></strong></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" ng-model=vm.periodo><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option><option ng-value=2015>2015</option><option ng-value=2014>2014</option><option ng-value=2013>2013</option><option ng-value=2012>2012</option><option ng-value=2011>2011</option><option ng-value=2010>2010</option><option ng-value=2009>2009</option><option ng-value=2008>2008</option></select></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><a download=Rep_Supervision.pdf href={{vm.urlData}}reporte/descargar-reporte-supervision/{{vm.dataInstalacion.idAdministrado}}/{{vm.dataInstalacion.idInstalacion}}/{{vm.dataInstalacion.idIga}}/{{vm.idEtapa}}/{{vm.periodo}} target=_blank>Descargar Reporte</a> <button class=\"btn btn-primary btn-sm\" ng-click=closeThisDialog(0)><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i> Cerrar</button></div></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/reporte/reporte-supervision/reporte-supervision.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Reportes</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Reportes</li><li>Reporte de Supervisión</li></ol></span></div></div><uib-tabset active=vm.active><uib-tab ng-click=vm.limpiarfiltros() heading=\"Reporte de Unidades Fiscalizables\" index=0><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarProvincia();vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigodepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistrito();vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigoprovincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-model=vm.filtro.codigodistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"input-group col-md-2\"><strong><p>Acción</p></strong><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.verReporteUnidadesFiscalizables()><span class=\"glyphicon glyphicon-search\"></span></button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Regi&oacute;n</th><th class=text-center ng-show=\"vm.filtro.codigodepartamento!=null && vm.filtro.codigodepartamento!=0\" style=\"vertical-align: middle !important\" rowspan=1>Provincia</th><th class=text-center ng-show=\"vm.filtro.codigoprovincia!=null && vm.filtro.codigoprovincia!=0\" style=\"vertical-align: middle !important\" rowspan=1>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Administrados</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Unidades Fiscalizables</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Porcentaje</th></tr></thead><tbody><tr ng-show=\"vm.listaReporteUnidadesFiscalizables.length==0\"><td colspan=12>No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaReporteUnidadesFiscalizables | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutlistaReporteUnidadesFiscalizables><td class=text-center style=\"vertical-align: middle !important\" data-label=N&#176;>{{vm.listaReporteUnidadesFiscalizables.indexOf(item) + 1}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Regi&oacute;n>{{item.nombredepartamento}}</td><td class=text-center ng-show=\"vm.filtro.codigodepartamento!=null && vm.filtro.codigodepartamento!=0\" style=\"vertical-align: middle !important\" data-label=Provincia>{{item.nombreprovincia}}</td><td class=text-center ng-show=\"vm.filtro.codigoprovincia!=null && vm.filtro.codigoprovincia!=0\" style=\"vertical-align: middle !important\" data-label=Distrito>{{item.nombredistrito}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Administrados>{{item.cantadministrados}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Unidades Fiscalizables\">{{item.cantunidades}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Porcentaje>{{item.porcentaje}}</td></tr></tbody></table><dir-pagination-controls pagination-id=coutlistaReporteUnidadesFiscalizables></dir-pagination-controls></div></div><div class=\"input-group col-md-12\" ng-show=\"vm.listaReporteUnidadesFiscalizables.length>0\"><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnExportar ng-click=\"vm.exportarExcel(\'REP_SUP_UF\')\" type=button uib-tooltip=Buscar><span class=\"glyphicon glyphicon-export\"></span> Exportar Excel</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.verGrafico(1) type=button><span class=\"glyphicon glyphicon-adjust\"></span> Generar Gr&aacute;fico</button></div></div></div><div class=row><div class=\"input-group col-md-12\"><div id=chartPieUnidadesFiscalizables style=\"height: 300px; width: 100%\"></div></div></div></uib-tab><uib-tab heading=\"Reporte de UF por administrado\" index=1 ng-click=vm.limpiarfiltros()><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarProvincia();vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigodepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistrito();vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigoprovincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-model=vm.filtro.codigodistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"input-group col-md-3\"><strong><p>Acción</p></strong><button class=\"btn btn-flat btn-primary-inv btn-sm\" style=\"margin-right: 4px\" ng-click=vm.verReporteUnidadesFiscalizablesPorAdmin()><span class=\"glyphicon glyphicon-search\"></span></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.verGrafico(2) type=button><span class=\"glyphicon glyphicon-adjust\"></span> Generar Gr&aacute;fico</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"width: 20px; vertical-align: middle !important\" rowspan=1>N&#176;</th><th class=text-center style=\"width: 80px; vertical-align: middle !important\" rowspan=1>Regi&oacute;n</th><th class=text-center ng-show=\"vm.filtro.codigodepartamento!=null && vm.filtro.codigodepartamento!=0\" style=\"width: 80px; vertical-align: middle !important\" rowspan=1>Provincia</th><th class=text-center ng-show=\"vm.filtro.codigoprovincia!=null && vm.filtro.codigoprovincia!=0\" style=\"width: 80px; vertical-align: middle !important\" rowspan=1>Distrito</th><th class=text-center style=\"width: 250px; vertical-align: middle !important\" rowspan=1>Administrados</th><th class=text-center style=\"width: 20px; vertical-align: middle !important\" rowspan=1>UF</th><th class=text-center style=\"width: 20px; vertical-align: middle !important\" rowspan=1>Porcentaje</th><th style=\"width: 200px; vertical-align: middle !important\" rowspan=1></th></tr></thead><tbody><tr ng-show=\"vm.listaReporteUnidadesFiscalizablesAdmin.length==0\"><td colspan=12>No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaReporteUnidadesFiscalizablesAdmin | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutlistaReporteUnidadesFiscalizablesAdmin><td class=text-center style=\"width: 20px; vertical-align: middle !important\" data-label=N&#176;>{{vm.listaReporteUnidadesFiscalizablesAdmin.indexOf(item) + 1}}</td><td class=text-center style=\"width: 80px; vertical-align: middle !important\" data-label=Regi&oacute;n>{{item.nombredepartamento}} <a style=\"cursor: pointer\" ng-click=\"vm.exportarPDF(\'REP_UF_ADM\',item)\" type=button uib-tooltip=\"Exportar por Administrado\">Descargar reporte</a></td><td class=text-center ng-show=\"vm.filtro.codigodepartamento!=null && vm.filtro.codigodepartamento!=0\" style=\"width: 80px; vertical-align: middle !important\" data-label=Provincia>{{item.nombreprovincia}}</td><td class=text-center ng-show=\"vm.filtro.codigoprovincia!=null && vm.filtro.codigoprovincia!=0\" style=\"width: 80px; vertical-align: middle !important\" data-label=Distrito>{{item.nombredistrito}}</td><td style=\"width: 250px; vertical-align: middle !important\" data-label=Administrados>{{item.razonsocial}}</td><td class=text-center style=\"width: 20px; vertical-align: middle !important\" data-label=UF>{{item.cantunidades}}</td><td class=text-center style=\"width: 20px; vertical-align: middle !important\" data-label=Porcentaje>{{item.porcentaje}}</td><td style=\"width: 200px; vertical-align: middle !important\" data-label=\"\"><div style=\"background-color: green; float: left; height: 20px; width: {{item.widthbarra}}\"></div><div style=\"float: left; height: 20px; margin-left: 5px\"><label>{{item.cantunidades}}</label></div></td></tr></tbody></table><dir-pagination-controls pagination-id=coutlistaReporteUnidadesFiscalizablesAdmin></dir-pagination-controls></div></div></div><div class=row><div class=\"input-group col-md-12\"><div id=chartColumnUnidadesFiscalizables style=\"height: 400px; width: 100%\"></div></div></div><br><br><div class=row><div class=\"input-group col-md-12\"><div id=chartPieUnidadesFiscalizablesAdminPorc style=\"height: 300px; width: 100%\"></div></div></div></uib-tab><uib-tab heading=\"Reporte de IGA\" index=2 ng-click=vm.limpiarfiltros()><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Administrado</p></strong><input ng-model=vm.filtro.razonsocial type=text class=\"form-control input-sm\" disabled> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.buscarAdministrado()><span class=\"glyphicon glyphicon-search\"></span></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=\"vm.filtro.idAdministrado=null;vm.filtro.razonsocial=null\"><span class=\"glyphicon glyphicon-trash\"></span></button></div><div class=\"form-group col-md-3\"><strong><p>Oficina desconcentrado</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDepartamento();vm.filtro.codigodepartamento = \'\'; vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigood><option ng-repeat=\"itemCombo in vm.listaOD\" ng-value=itemCombo.idod>{{ itemCombo.nombre}}</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarProvincia();vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigodepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistrito();vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigoprovincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-model=vm.filtro.codigodistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p>Fecha desde</p></strong><input class=\"form-control input-sm\" type=date ng-model=vm.filtro.fechadesde></div><div class=\"form-group col-md-3\"><strong><p>Fecha hasta</p></strong><input class=\"form-control input-sm\" type=date ng-model=vm.filtro.fechahasta></div><div class=\"input-group col-md-2\"><strong><p>Acción</p></strong><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-disabled=\"vm.filtro.codigood==\'\' && vm.filtro.idAdministrado==\'\' && (vm.filtro.codigodepartamento==null || vm.filtro.codigodepartamento==\'\')\" ng-click=vm.verReporteIgas()><span class=\"glyphicon glyphicon-search\"></span></button></div></div><div class=row ng-show=vm.verReporteIgaPorAdministrado><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>N&#176;</th><th style=\"vertical-align: middle !important\" rowspan=1>Administrado</th><th style=\"vertical-align: middle !important\" rowspan=1>Unidades Fiscalizables</th><th style=\"vertical-align: middle !important\" rowspan=1>Direcci&oacute;n</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Provincia</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Regi&oacute;n</th><th style=\"vertical-align: middle !important\" rowspan=1>IGA</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Fecha registro</th></tr></thead><tbody><tr ng-show=\"vm.listaReporteIga.length==0\"><td colspan=15>No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaReporteIga | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutlistaReporteIga1><td class=text-center style=\"vertical-align: middle !important\" data-label=N&#176;>{{vm.listaReporteIga.indexOf(item) + 1}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Administrado>{{item.razonsocial}}<br></td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Unidades Fiscalizables\">{{item.instalacion}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Direcci&oacute;n>{{item.direccion}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Distrito>{{item.nombredistrito}}</td><td class=text-center data-label=Provincia style=\"vertical-align: middle !important\">{{item.nombreprovincia}}</td><td class=text-center data-label=Regi&oacute;n style=\"vertical-align: middle !important\">{{item.nombredepartamento}}</td><td class=text-center data-label=IGA style=\"vertical-align: middle !important\">{{item.nombreiga}}</td><td class=text-center data-label=\"Fecha registro\" style=\"vertical-align: middle !important\">{{item.fechaiga}}</td></tr></tbody></table><dir-pagination-controls pagination-id=coutlistaReporteIga1></dir-pagination-controls></div></div><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnExportar ng-click=\"vm.exportarExcel(\'REP_SUP_IGA_ADM\')\" type=button uib-tooltip=Buscar><span class=\"glyphicon glyphicon-export\"></span> Exportar Excel</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.verGrafico(3) type=button><span class=\"glyphicon glyphicon-adjust\"></span> Generar Gr&aacute;fico</button></div><div class=row ng-show=vm.verReporteIgaPorOd><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Oficina desconcentrada</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Administrado</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Unidades Fiscalizables</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Cant. IGA</th></tr></thead><tbody><tr ng-show=\"vm.listaReporteIga.length==0\"><td colspan=15>No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaReporteIga | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutlistalistaReporteIga2><td class=text-center style=\"vertical-align: middle !important\" data-label=N&#176;>{{vm.listaReporteIga.indexOf(item) + 1}}</td><td style=\"vertical-align: middle !important\" data-label=\"Oficina desconcentrada\">{{item.nombreod}}<br></td><td style=\"vertical-align: middle !important\" data-label=Administrado>{{item.razonsocial}}<br></td><td tyle=\"vertical-align: middle !important;\" data-label=\"Unidades Fiscalizables\">{{item.instalacion}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Cant IGA\">{{item.cantiga}}</td></tr></tbody></table><dir-pagination-controls pagination-id=coutlistalistaReporteIga2></dir-pagination-controls></div></div><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnExportar ng-click=\"vm.exportarExcel(\'REP_SUP_IGA_OD\')\" type=button uib-tooltip=Buscar><span class=\"glyphicon glyphicon-export\"></span> Exportar Excel</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.verGrafico(3) type=button><span class=\"glyphicon glyphicon-adjust\"></span> Generar Gr&aacute;fico</button></div><div class=row ng-show=vm.verReporteIgaPorUbigeo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Departamento</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Provincia</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Cant. IGA</th></tr></thead><tbody><tr ng-show=\"vm.listaReporteIga.length==0\"><td colspan=15>No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaReporteIga | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutlistalistaReporteIga3><td class=text-center style=\"vertical-align: middle !important\" data-label=N&#176;>{{vm.listaReporteIga.indexOf(item) + 1}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Departamento>{{item.nombredepartamento}}<br></td><td class=text-center style=\"vertical-align: middle !important\" data-label=Provincia>{{item.nombreprovincia}}<br></td><td class=text-center s tyle=\"vertical-align: middle !important;\" data-label=Distrito>{{item.nombredistrito}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Cant. IGA\">{{item.cantiga}}</td></tr></tbody></table><dir-pagination-controls pagination-id=coutlistalistaReporteIga3></dir-pagination-controls></div></div><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnExportar ng-click=\"vm.exportarExcel(\'REP_SUP_IGA_UBIGEO\')\" type=button uib-tooltip=Buscar><span class=\"glyphicon glyphicon-export\"></span> Exportar Excel</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.verGrafico(3) type=button><span class=\"glyphicon glyphicon-adjust\"></span> Generar Gr&aacute;fico</button></div><div class=row ng-show=vm.verReporteIgaPorAdministrado><div class=\"input-group col-md-12\"><div id=chartColumnIgasUnidades style=\"height: 300px; width: 100%\"></div></div></div><div class=row ng-show=vm.verReporteIgaPorOd><div class=\"input-group col-md-12\"><div id=chartColumnIgasAdministrado style=\"height: 100%; width: 100%\"></div></div></div><div class=row ng-show=vm.verReporteIgaPorUbigeo><div class=\"input-group col-md-12\"><div id=chartColumnIgasUbigeo style=\"height: 100%; width: 100%\"></div></div></div></uib-tab><uib-tab heading=\"Reporte Preliminar por Administrado\" index=3 ng-click=vm.limpiarfiltros()><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Administrado</p></strong><input ng-model=vm.filtro.razonsocial type=text class=\"form-control input-sm\" disabled> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.buscarAdministrado()><span class=\"glyphicon glyphicon-search\"></span></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=\"vm.filtro.idAdministrado=null;vm.filtro.razonsocial=null\"><span class=\"glyphicon glyphicon-trash\"></span></button></div><div class=\"form-group col-md-3\"><strong><p>Oficina desconcentrado</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDepartamento();vm.filtro.codigodepartamento = \'\'; vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigood><option ng-repeat=\"itemCombo in vm.listaOD\" ng-value=itemCombo.idod>{{ itemCombo.nombre}}</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarProvincia();vm.filtro.codigoprovincia = \'\';vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigodepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistrito();vm.filtro.codigodistrito = \'\';\" ng-model=vm.filtro.codigoprovincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-model=vm.filtro.codigodistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p>Fecha desde</p></strong><input class=\"form-control input-sm\" type=date ng-model=vm.filtro.fechadesde></div><div class=\"form-group col-md-3\"><strong><p>Fecha hasta</p></strong><input class=\"form-control input-sm\" type=date ng-model=vm.filtro.fechahasta></div><div class=\"input-group col-md-2\"><strong><p>Acción</p></strong><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-disabled=\"vm.filtro.codigood==\'\' && vm.filtro.idAdministrado==\'\'\" ng-click=vm.verReportePreliminarAdministrado()><span class=\"glyphicon glyphicon-search\"></span></button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>RUC</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Administrado</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Unidades Fiscalizables</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Direcci&oacute;n</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Provincia</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Regi&oacute;n</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>IGA</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>IMA</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>DMRS</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>MRP</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>PC</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>IAA</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>PMR</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>RI</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=1>Reporta</th></tr></thead><tbody><tr ng-show=\"vm.listaReportePreliminarAdministrado.length==0\"><td colspan=15>No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaReportePreliminarAdministrado | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutlistaReportePreliminarAdministrado><td class=text-center style=\"vertical-align: middle !important\" data-label=N&#176;>{{vm.listaReportePreliminarAdministrado.indexOf(item) + 1}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=RUC>{{item.ruc}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Administrado>{{item.razonsocial}}<br><a style=\"cursor: pointer\" ng-click=\"vm.exportarPDF(\'REP_PRE_ADM\',item)\" type=button uib-tooltip=\"Exportar por Administrado\">Descargar reporte</a></td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Unidades Fiscalizables\">{{item.instalacion}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Direcci&oacute;n>{{item.direccion}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Distrito>{{item.nombredistrito}}</td><td class=text-center data-label=Provincia style=\"vertical-align: middle !important\">{{item.nombreprovincia}}</td><td class=text-center data-label=Regi&oacute;n style=\"vertical-align: middle !important\">{{item.nombredepartamento}}</td><td data-label=IGA class=text-center style=\"vertical-align: middle !important\"><label>{{item.cantiga}} <span ng-click=vm.verIgas(item) ng-if=\"item.cantiga>0\" uib-tooltip=\"Ver IGAS\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=IMA><label>{{item.cantima}} <span ng-click=vm.verImas(item) ng-if=\"item.cantima>0\" uib-tooltip=\"Ver IMAS\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=DMRS><label>{{item.cantdmrs}} <span ng-click=vm.verDMR(item) ng-if=\"item.cantdmrs>0\" uib-tooltip=\"Ver Declaraci&oacute;n de manejo de residuos\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=MRP><label>{{item.cantmrsp}} <span ng-click=vm.verMRSP(item) ng-if=\"item.cantmrsp>0\" uib-tooltip=\"Ver Manifiesto de residuos s&oacute;lidos\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=PC><label>{{item.cantpc}} <span ng-click=vm.verPC(item) ng-if=\"item.cantpc>0\" uib-tooltip=\"Ver Plan de contingencia\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=IAA><label>{{item.cantia}} <span ng-click=vm.verIAA(item) ng-if=\"item.cantia>0\" uib-tooltip=\"Ver Informe ambiental anual\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=PMR><label>{{item.cantpmrs}} <span ng-click=vm.verPMR(item) ng-if=\"item.cantpmrs>0\" uib-tooltip=\"Ver Plan de manejo de residuos\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=RI><label>{{item.cantri}} <span ng-click=vm.verRI(item) ng-if=\"item.cantri>0\" uib-tooltip=\"Ver registro de incidentes\" class=\"glyphicon glyphicon-chevron-right\"></span></label></td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Descargar reporte\"><a style=\"cursor: pointer\" ng-click=\"vm.exportarPDF(\'REP_PRE_ADM_INS\',item)\" type=button uib-tooltip=\"Exportar por Instalaci&oacute;n\">Descargar reporte</a></td></tr></tbody></table><dir-pagination-controls pagination-id=coutlistaReportePreliminarAdministrado></dir-pagination-controls></div></div></div></uib-tab></uib-tabset></span></div>");
$templateCache.put("app/modules/acceso/registro/acceso-registro-contacto.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Contactos de Administrado</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Nombre:</label><input class=\"form-control input-sm\" type=text ng-model=vm.prmContacto.nombres></div><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Cargo:</label><input class=\"form-control input-sm\" type=text ng-model=vm.prmContacto.cargo></div></div><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Correo:</label><input ng-pattern=/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/ class=\"form-control input-sm\" ng-model=vm.prmContacto.valor type=text></div><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Teléfono:</label><input maxlength=12 class=\"form-control input-sm\" ng-model=vm.prmContacto.telefono type=text></div></div><br><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Estado:</label><div><select ng-model=vm.prmContacto.estado.codigoRegistro class=\"form-control input-sm\" id=estado name=estado><option value=1>Activo</option><option value=0>Inactivo</option></select></div></div><div class=\"form-group col-md-6\"><label for=cargo class=important-box>¿Contacto principal?:</label><div><input type=checkbox ng-model=vm.prmContacto.isPredeterminado id=predeterminado name=predeterminado></div></div></div><br><div class=row ng-show=vm.prmContacto.isPredeterminado><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Carta Poder:</label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnGrabar ng-disabled=\"vm.prmContacto.nombres==null || vm.prmContacto.nombres ==\'\' || vm.prmContacto.cargo==null || vm.prmContacto.cargo==\'\' || vm.prmContacto.valor==null || vm.prmContacto.valor==\'\'\r\n					|| vm.prmContacto.telefono ==null || vm.prmContacto.telefono ==\'\' || (vm.listaArchivos.length == 0 && vm.prmContacto.isPredeterminado)\" ng-click=vm.guardarContacto()><i aria-hidden=true class=\"glyphicon glyphicon-floppy-disk\"></i> Grabar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.cerrar()><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i> Cerrar</button></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/acceso/registro/acceso-registro.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" id=registrousuario name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Registro de solicitud</span></h3></div></div><br><uib-tabset active=vm.active><uib-tab heading=\"Datos del Administrado\" index=0><br><fieldset class=\"well unp-fieldset\"><legend class=\"unp-legend title-slider-nt\"></legend><div class=row><div class=\"form-group col-md-6\"><label class=important-box for=tipoPersona>Tipo de persona:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-change=\"vm.dataUsuario.tipoDocumento=vm.dataUsuario.tipoPersona\" ng-disabled=\"vm.dataPersona.idPersona> 0 || vm.dataEntidad.idEntidad> 0 || vm.flagRegistrarPersona ==1\" ng-model=vm.dataUsuario.tipoPersona><option ng-repeat=\"itemCombo in vm.listaTipoPersona\" ng-value=itemCombo.codigoRegistro>{{ itemCombo.descripcion }}</option></select></div></div><div class=row><div class=\"form-group col-md-6\"><label class=important-box for=tipoDocumento>Tipo de documento:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-disabled=true ng-model=vm.dataUsuario.tipoDocumento><option ng-repeat=\"itemCombo in vm.listaTipoDocumento\" ng-value=\"itemCombo.codigoRegistro | number\">{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label class=important-box for=numeroDocumento>N&uacute;mero de DNI:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero maxlength=8 name=numeroDocumento ng-disabled=\"vm.dataPersona.idPersona> 0 || vm.dataEntidad.idEntidad> 0 || vm.flagRegistrarPersona ==1\" ng-model=vm.dataPersona.documento placeholder=\"Ingrese n&uacute;mero de DNI\" type=text></div></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label class=important-box for=numeroDocumento>N&uacute;mero de RUC:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero maxlength=11 name=numeroDocumento ng-disabled=\"vm.dataPersona.idPersona> 0 || vm.dataEntidad.idEntidad> 0 || vm.flagRegistrarPersona ==1\" ng-model=vm.dataEntidad.ruc placeholder=\"Ingrese número de RUC\" title=\"Ejemplo: 20111111111\" type=text></div></div><div class=\"input-group col-md-3\" ng-if=\"vm.flagRegistrarPersona==0 && vm.dataUsuario.tipoPersona==1\"><label></label><div class=form-group ng-if=\"vm.dataPersona.idPersona == 0\"><a class=\"btn btn-flat btn-primary btn-sm\" ng-class=\"vm.dataPersona.documento.length    <8 ? \'bloquear\' : \'\'\" ng-click=vm.buscarPersonaXNumeroDocumento() ng-disabled=\"vm.dataPersona.documento.length<8\"><span class=icon-buscar></span> Buscar</a></div><div class=form-group ng-if=\"vm.dataPersona.idPersona> 0\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.limpiarPersona() type=button><span class=icon-buscar></span> Nueva Búsqueda</button></div></div><div class=\"form-group col-md-3\" ng-if=\"vm.flagRegistrarPersona==0 && vm.dataUsuario.tipoPersona==2\"><label></label><div class=form-group ng-if=\"vm.dataEntidad.idEntidad == 0\"><a class=\"btn btn-flat btn-primary btn-sm\" ng-class=\"vm.dataEntidad.ruc.length<11 ? \'bloquear\' : \'\'\" ng-click=vm.buscarEntidadXNumeroDocumento() ng-disabled=\"vm.dataEntidad.ruc.length    <11\"><span class=icon-buscar></span> Buscar</a></div><div class=form-group ng-if=\"vm.dataEntidad.idEntidad> 0\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.limpiarPersona() type=button><span class=icon-buscar></span> Nueva Búsqueda</button></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label class=important-box for=razonSocial>Raz&oacute;n social:</label><div class=form-group><input class=\"form-control input-sm\" name=razonSocial ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataEntidad.razonSocial title=\"{{ vm.dataEntidad.razonSocial }}\" type=text></div></div><div class=\"form-group col-md-6\" ng-if=\"vm.dataUsuario.tipoDocumento ==2 && vm.flagRegistrarPersona==1\"><label for=razonSocial></label><div class=form-group><input name=activaRepre ng-true-value=1 ng-change=vm.limpiarRepresentanteLegal() ng-false-value=0 ng-model=vm.flagAgregarRepresentanteLegal type=checkbox> <span ng-if=\"vm.flagAgregarRepresentanteLegal==0\">Agregar representante legal</span> <span ng-if=\"vm.flagAgregarRepresentanteLegal==1\">Sin representante legal</span></div></div></div><fieldset class=\"well unp-fieldset\" ng-if=\"vm.flagRegistrarPersona ==1 && vm.flagAgregarRepresentanteLegal==1\"><legend class=unp-legend>Datos representante legal</legend><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Documento:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo maxlength=8 input-restrict=numero ng-disabled=\"vm.dataEntidad.representanteLegal.idPersona !=null  && vm.dataEntidad.representanteLegal.idPersona!=0\" ng-model=vm.dataEntidad.representanteLegal.documento type=text></div></div><div class=\"form-group col-md-6\" ng-if=\"vm.dataEntidad.representanteLegal.idPersona ==null || vm.dataEntidad.representanteLegal.idPersona==0\"><br><a class=\"btn btn-flat btn-primary btn-sm\" ng-class=\"vm.dataEntidad.representanteLegal.documento == null || vm.dataEntidad.representanteLegal.documento.length    <8 ? \'bloquear\' : \'\'\" ng-click=vm.buscarRepresentanteLegal() ng-disabled=\"vm.dataEntidad.representanteLegal.documento == null || vm.dataEntidad.representanteLegal.documento <8 \"><span class=icon-buscar></span> Buscar representante</a></div><div class=\"form-group col-md-6\" ng-if=\"vm.dataEntidad.representanteLegal.idPersona !=null  && vm.dataEntidad.representanteLegal.idPersona!=0\"><br><a class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.limpiarRepresentanteLegal()><span class=icon-buscar></span> Nueva Busqueda representante</a></div></div><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Nombres representante:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-disabled=\"vm.flagAgregarManualmenteRepresentanteLegal==0\" ng-model=vm.dataEntidad.representanteLegal.nombres type=text></div></div><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Apellido paterno representante:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-disabled=\"vm.flagAgregarManualmenteRepresentanteLegal==0\" ng-model=vm.dataEntidad.representanteLegal.apellidoPaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Apellido materno representante:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-disabled=\"vm.flagAgregarManualmenteRepresentanteLegal==0\" ng-model=vm.dataEntidad.representanteLegal.apellidoMaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\"><label for=cargo class=important-box>Cargo:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-model=vm.dataEntidad.nomCargo type=text></div></div></div></fieldset><div class=row ng-if=\"vm.flagRegistrarPersona ==0\"><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=representanteLegal>Representante legal:</label><div class=form-group><input class=\"form-control input-sm\" name=representanteLegal ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataEntidad.nomRepresentante type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=cargo>Cargo:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataEntidad.nomCargo type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label class=important-box for=nombres>Nombres:</label><div class=form-group><input class=\"form-control input-sm\" name=nombres ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataPersona.nombres type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label class=important-box for=apellidoPaterno>Apellido paterno:</label><div class=form-group><input class=\"form-control input-sm\" name=apellidoPaterno ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataPersona.apellidoPaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label class=important-box for=apellidoMaterno>Apellido materno:</label><div class=form-group><input class=\"form-control input-sm\" name=apellidoMaterno ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataPersona.apellidoMaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1 || vm.dataUsuario.tipoPersona==2\"><label class=important-box for=departamento>Departamento</label><select class=\"form-control input-sm\" id=departamento name=departamento ng-change=\"vm.listarProvinciaPersona();vm.dataUbigeo.codigoProvincia = \'\';vm.dataUbigeo.codigoDistrito = \'\';\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataUbigeo.codigoDepartamento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDepartamentoPersona\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1  || vm.dataUsuario.tipoPersona==2\"><label class=important-box for=provincia>Provincia</label><select class=\"form-control input-sm\" id=provincia name=provincia ng-change=vm.listarDistritoPersona() ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataUbigeo.codigoProvincia><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaProvinciaPersona\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1  || vm.dataUsuario.tipoPersona==2\"><label class=important-box for=distrito>Distrito</label><select class=\"form-control input-sm\" id=distrito name=distrito ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataUbigeo.codigoDistrito><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDistritoPersona\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label class=important-box for=direccion>Direcci&oacute;n:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=500 name=direccion ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataPersona.direccion title=\"{{ vm.dataPersona.direccion }}\" type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label class=important-box for=domicilio>Domicilio fiscal:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=500 name=domicilio ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataEntidad.direccion title=\"{{ vm.dataEntidad.direccion }}\" type=text></div></div></div><!-- ************************************************************************************* --><div ng-if=\"(vm.flagActivoEdicionDatosPersona==0 && vm.dataPersona.idPersona!=0 ) ||  (vm.flagActivoEdicionDatosPersona==0 && vm.dataEntidad.idEntidad!=0) \"><div class=row><div class=\"form-group col-md-6\"><h5><b>Datos de contacto</b></h5></div><div class=\"form-group col-md-6 text-right\"><div class=form-group><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.agregarContacto()><span class=icon-agregar></span> Agregar</button></div></div></div><!-- <div class=\"row\">\r\n					<div class=\"form-group col-md-3\" ng-show=\"false\">\r\n						<label class=\"important-box\" for=\"tipoDatoContacto\"> Tipo\r\n						</label> <select class=\"form-control input-sm\"\r\n							ng-change=\"vm.dataContactoAdministrado.valor=\'\'\"\r\n							ng-model=\"vm.dataContactoAdministrado.tipoContacto\"\r\n							ng-options=\"item as item.descripcion for item in vm.listaCboTipoContacto track by item.codigoRegistro\">\r\n						</select>\r\n\r\n					</div>\r\n					<div class=\"form-group col-md-4\" ng-show=\"false\">\r\n						<label class=\"important-box\" for=\"correo\"> Contacto </label>\r\n\r\n						<div class=\"form-group\"\r\n							ng-show=\"vm.dataContactoAdministrado.tipoContacto.codigoRegistro==1\">\r\n							<input autocomplete=\"off\" class=\"form-control input-sm\"\r\n								id=\"txtTelefono\" maxlength=\"15\" name=\"telefono\"\r\n								ng-keyup=\"vm.valorTelefono(vm.dataContactoAdministrado.valor)\"\r\n								ng-model=\"vm.dataContactoAdministrado.valor\"\r\n								ng-pattern=\"vm.validarTelefono\" placeholder=\"Ingresar contacto\"\r\n								required=\"\" type=\"text\" />\r\n						</div>\r\n						<div class=\"form-group\"\r\n							ng-show=\"vm.dataContactoAdministrado.tipoContacto.codigoRegistro==2\">\r\n							<input autocomplete=\"off\" class=\"form-control input-sm\"\r\n								maxlength=\"50\" name=\"correo\"\r\n								ng-model=\"vm.dataContactoAdministrado.valor\"\r\n								ng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,8}$/\"\r\n								placeholder=\"Ingresar contacto \" required=\"\" type=\"text\" />\r\n						</div>\r\n					</div>\r\n					<div class=\"form-group col-md-12 text-right\">\r\n						<div class=\"form-group\">\r\n							<button class=\"btn btn-flat btn-primary btn-sm\"\r\n								ng-click=\"vm.agregarContacto()\">\r\n								<span class=\"icon-agregar\"> </span> Agregar\r\n							</button>\r\n						</div>\r\n					</div>\r\n				</div> --><div class=row><div class=col-md-12><div class=table-rpv><table class=\"table table-bordered\"><thead><tr><th class=text-center>Contacto</th><th class=text-center>Cargo</th><th class=text-center>Correo</th><th class=text-center>Teléfono</th><th class=text-center>Acción</th></tr></thead><tbody><tr dir-paginate=\"item in vm.dataAdministrado.lstContactoAdministrado  | itemsPerPage: config.itemsPerPage\" pagination-id=cout2><td data-label=Contacto>{{ item.nombres }}</td><td data-label=Cargo>{{ item.cargo }}</td><td data-label=Correo class=text-center>{{ item.valor }}</td><td data-label=Teléfono class=text-center>{{ item.telefono }}</td><!-- <td data-label=\"Predeterminado\"><input\r\n											ng-change=\"vm.contactoPredeterminado($index)\"\r\n											ng-false-value=\"\'0\'\" ng-model=\"item.flagPredeterminado\"\r\n											ng-true-value=\"\'1\'\" type=\"checkbox\" /></td> --><td data-label=Acción class=text-center><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarContacto(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarContacto($index) style=\"background: rgba(255, 255, 0, 0) !important; border: 0px\" type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout2></dir-pagination-controls></div></div></div></div><!-- ************************************************************************************** --><div class=row><div id=campoObligatorio class=\"col-lg-4 text-left ng-scope\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div><div class=\"form-group col-lg-8 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left\"></span> Salir</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-if=\"vm.flagRegistrarPersona==0\" ng-click=vm.limpiarPersona()><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar </a><!-- <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\"\r\n						ng-if=\"vm.flagRegistrarPersona==1\"\r\n						ng-click=\"vm.cancelarRegistro()\"> <span\r\n						class=\"icon-limpiar spac-btn-r\"> </span> Cancelar Registro\r\n					</a> --><!-- <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n						ng-click=\"vm.registrarPersonaOEntidad()\"\r\n						ng-if=\"vm.flagRegistrarPersona ==1\" type=\"button\">\r\n						<span class=\"glyphicon glyphicon-floppy-disk\"> </span> Registrar\r\n					</button> --> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.registrarSolicitudArchivo() ng-disabled=\"vm.dataPersona.idPersona==0 && vm.dataEntidad.idEntidad==0 || vm.dataAdministrado.lstContactoAdministrado.length==0 || vm.dataAdministrado.estado == 2\" type=button><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar solicitud</button><!-- 	<button class=\"btn btn-flat btn-primary-inv btn-sm\"\r\n						ng-click=\"vm.siguiente()\"\r\n						ng-disabled=\"vm.dataPersona.idPersona==0 && vm.dataEntidad.idEntidad==0 || vm.dataAdministrado.lstContactoAdministrado.length==0 || vm.dataAdministrado.estado == 2\"\r\n						ng-if=\"vm.flagActivoEdicionDatosPersona==0\" type=\"button\">\r\n						<span class=\"glyphicon glyphicon-arrow-right\"> </span> Siguiente\r\n					</button> --></div></div></fieldset></uib-tab><uib-tab heading=\"Datos de las instalaciones\" index=1 ng-if=false><!-- ng-if=\"vm.validaCorreoAdministrado() != 0\" --><!-- ng-show=\"vm.dataPersona.idPersona!=0 && vm.dataAdministrado.lstContactoAdministrado.length!=0 || vm.dataEntidad.idEntidad!=0\" --><br><div class=row ng-show=vm.isnuevaInstalacion><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Nombre</p></strong></div><div class=\"form-group col-md-10\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=100 ng-model=vm.dataInstalacion.numeroInstalacion type=text></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Tipo establecimiento</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoEstablecimiento\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Estado</p></strong></div><div class=\"form-group col-md-3\"><div class=form-group><select ng-model=vm.dataInstalacion.estado ng-disabled=\"vm.RucValido==false\" class=\"form-control input-sm\" id=estado name=estado><option ng-value=1>CON ACTIVIDAD</option><option ng-value=0>SIN ACTIVIDAD</option></select></div></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Sector</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.changeSector() ng-model=vm.dataInstalacion.sector><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSector\" ng-value=itemCombo.codigosector>{{itemCombo.sector}}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Subsector</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.changeSubSector() ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.subSector><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSubSector\" ng-value=itemCombo.codigosubsector>{{itemCombo.subsector}}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Competencia</p><span><label>(Para seleccionar más de una opción presione la tecla ctrl)</label></span></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" multiple ng-disabled=\"vm.RucValido==false\" ng-change=vm.changeCompetencia() ng-model=vm.dataInstalacion.competenciaArray><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaCompetencia\" ng-value=itemCombo.codigocompetencia>{{itemCombo.competencia}}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Actividad</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.actividad><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaActividad\" ng-value=itemCombo.codigoactividad>{{itemCombo.actividad}}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Departamento</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=\"vm.listarProvincia();vm.dataUbigeo.codigoProvincia = \'\';vm.dataUbigeo.codigoDistrito = \'\';\" ng-model=vm.dataInstalacion.departamento.codigoDepartamento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Provincia</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.listarDistrito() ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataInstalacion.provincia.codigoProvincia><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Distrito</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataInstalacion.distrito.codigoDistrito><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Dirección</p></strong></div><div class=\"form-group col-md-10\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=300 ng-model=vm.dataInstalacion.direccion type=text></div></div><div class=row><div class=\"form-group col-md-12\"><h6>Toda la información de Coordenadas debe estar en datum WGS-84 (UTM)</h6></div></div><div class=row><div class=\"form-group col-md-3\"><strong><label for=tipoPersona class=important-box>Zona</label></strong><select class=\"form-control input-sm\" id=tipoPersona ng-model=vm.dataInstalacion.idzona><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaZonas\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><label for=departamento class=important-box>Norte (7\'950,000 - 9\'999,900)</label><input class=\"form-control input-sm\" maxlength=100 name=distrito type=text ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.puntoNorte></div><div class=\"form-group col-md-3\"><label for=departamento class=important-box>Este (160,000 - 840,000)</label><input class=\"form-control input-sm\" maxlength=100 name=distrito type=text ng-model=vm.dataInstalacion.puntoEste ng-disabled=\"vm.RucValido==false\"></div></div><div class=row><div class=\"form-group col-md-12\"><label for=distrito>Referencia</label><div class=form-group><input class=\"form-control input-sm\" maxlength=300 name=distrito ng- type=text ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.referencia></div></div></div><h3 class=title-slider-nt style=\"color: gray; font-weight: lighter\">Ficha de Registro de Hidrocarburos:</h3><br><!-- \r\n			<div class=\"row\">\r\n				<div class=\"form-group col-md-2\">\r\n					<strong>\r\n						<p class=\"important-box\">\r\n							Fichas de registro: \r\n						</p>\r\n					</strong>\r\n				</div>\r\n				<div class=\"form-group col-md-10\">\r\n					<table>\r\n						<tr ng-repeat=\"item in vm.lstFichaxInstalacion\">\r\n							<td class=\"text-center\"><a\r\n								download=\"{{item.ruta_ficha_registro}}\"\r\n								href=\"{{vm.urlData}}instalacion/descargar-ficha-registro/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.ficha_registro}}\"\r\n								target=\"_blank\">{{item.ficha_registro}}</a></td>\r\n							<td align=\"center\"><span class=\"glyphicon glyphicon-trash\"\r\n								title=\"Eliminar\"\r\n								ng-click=\"vm.eliminarDocumentoInstalacion($index)\"> </span></td>\r\n						</tr>\r\n					</table>\r\n				</div>\r\n			</div> --><div class=row><div class=\"form-group col-md-3\"><p>Número de registro:</p><input class=\"form-control input-sm\" required maxlength=50 ng-model=vm.dataInstalacion.numeroRegistro type=text></div><div class=\"form-group col-md-3\"><p>Archivo:</p><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivoMedio multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><!-- <div class=\"form-group col-md-1\">\r\n					<button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n						id=\"btnAgregarFicha\"\r\n						ng-disabled=\"vm.dataDocumentoInstalacion.ficha_registro ==\'\' || vm.dataDocumentoInstalacion.ficha_registro==null || vm.listaArchivos.length == 0\"\r\n						ng-click=\"vm.guardarFichaxInstalacion()\">\r\n						Añadir Ficha <i aria-hidden=\"true\" class=\"glyphicon glyphicon-ok\">\r\n						</i>\r\n					</button>\r\n\r\n				</div> --></div><span class=content-box><label class=important-box>(Campos Obligatorios)</label></span></div><br><div class=row ng-show=!vm.isnuevaInstalacion><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Nombre</th><th class=text-center>Sector</th><th class=text-center>Subsector</th><th class=text-center>Competencia</th><th class=text-center>Actividad</th><th class=text-center>Departamento</th><th class=\"text-center td-tabla-01\">Provincia</th><th class=\"text-center td-tabla-01\">Distrito</th><th class=\"text-center td-tabla-01\">Direcci&oacute;n</th><th class=\"text-center td-tabla-01\">Acción</th><th class=\"text-center td-tabla-01\">Sel</th></tr></thead><tbody><tr dir-paginate=\"itemInstalacion in vm.listaSolicitudesInstalacion  | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Sector>{{ itemInstalacion.numeroInstalacion }}</td><td data-label=Sector>{{ itemInstalacion.sectorDescripcion }}</td><td data-label=Subsector>{{ itemInstalacion.subSectorDescripcion }}</td><td data-label=Competencia>{{ itemInstalacion.competenciaDescripcion }}</td><td data-label=Actividad>{{ itemInstalacion.actividadDescripcion }}</td><td data-label=Departamento>{{ itemInstalacion.departamento.descripcionDepartamento }}</td><td data-label=Provincia>{{ itemInstalacion.provincia.descripcion }}</td><td data-label=Distrito>{{ itemInstalacion.distrito.descripcionDistrito }}</td><td data-label=Direcci&oacute;n>{{ itemInstalacion.direccion }}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.nuevaInstalacion(itemInstalacion) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-show=\"itemInstalacion.idInstalacion==0\" ng-click=vm.confirmarEliminacion($index) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td><td class=text-center data-label=Sel><input type=checkbox ng-model=itemInstalacion.flgSeleccionado ng-show=\"itemInstalacion.idInstalacion!=0\"></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><!-- <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n					ng-click=\"vm.nuevaInstalacion()\" type=\"button\"\r\n					ng-show=\"!vm.isnuevaInstalacion\">\r\n					<span class=\"glyphicon glyphicon-ok spac-btn-r\"> </span> Nueva\r\n					instalaci&oacute;n\r\n				</button>\r\n				<button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n					ng-click=\"vm.agregarInstalaciones()\"\r\n					ng-show=\"vm.isnuevaInstalacion\"\r\n					ng-disabled=\"vm.dataInstalacion.numeroRegistro==null || vm.dataInstalacion.numeroRegistro==\'\' || vm.dataInstalacion.numeroInstalacion==null || vm.dataInstalacion.tipoEstablecimiento == 0 || \r\n				vm.dataInstalacion.sector == \'\' || vm.dataInstalacion.subSector == \'\' || vm.dataInstalacion.actividad == \'\' || \r\n				vm.dataInstalacion.departamento.codigoDepartamento == 0 || vm.dataInstalacion.provincia.codigoProvincia == 0 || vm.dataInstalacion.distrito.codigoDistrito == 0 ||\r\n				vm.dataInstalacion.direccion == null || vm.dataInstalacion.direccion == \'\'  || vm.dataInstalacion.puntoNorte == null || vm.dataInstalacion.puntoNorte == \'\' || vm.dataInstalacion.puntoEste == null || vm.dataInstalacion.puntoEste == \'\' || vm.dataInstalacion.idzona == 0\"\r\n					type=\"button\">\r\n					<span class=\"glyphicon glyphicon-ok spac-btn-r\"> </span> {{\r\n					(vm.dataInstalacion.idInstalacion==0)? \'Agregar instalaci&oacute;n\'\r\n					: \'Modificar instalaci&oacute;n\' }}\r\n				</button>\r\n				<button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\"\r\n					ng-click=\"vm.regresar()\" type=\"button\"\r\n					ng-show=\"vm.isnuevaInstalacion\">\r\n					<span class=\"glyphicon glyphicon-remove spac-btn-r\"> </span>\r\n					Regresar\r\n				</button> --><!-- <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\"\r\n					ng-click=\"vm.cancelar()\" type=\"button\">\r\n					<span class=\"glyphicon glyphicon-remove spac-btn-r\"> </span>\r\n					Cancelar\r\n				</button> --></div></div></uib-tab></uib-tabset></span></div><span class=overlay-block ng-if=\"$parent.cargandoInformacion> 0\"><div class=contenedor_load><img alt=\"\" ng-src=assets/images/gif/gears-red.gif><p>Procesando...</p></div></span>");
$templateCache.put("app/modules/supervision/solicitud-administrado/solicitud-administrado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Bandeja de solicitudes</span></h3></div></div><br><div id=BandejaSolicitud ng-show=\"vm.flagActivoBandeja==\'1\'\"><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Sector:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-change=\" vm.listarSubSector()\" ng-model=vm.datafiltroSolicitudes.sector><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSector\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Subsector:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-change=vm.listarActividad() ng-model=vm.datafiltroSolicitudes.subSector><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSubSector\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Actividad:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.datafiltroSolicitudes.actividad><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaActividad\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Estado:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.datafiltroSolicitudes.estado><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaEstadoSolicitud\" ng-value=item.codigoRegistro>{{item.descripcion}}</option><!--\r\n					<option ng-value=\"1\">Pendiente</option>\r\n					<option ng-value=\"2\">Aprobada</option>\r\n					<option ng-value=\"3\">Rechazada</option>\r\n					<option ng-value=\"4\">Solicitud de Cancelaci&oacute;n de Registro</option>\r\n					--></select></div><div class=\"form-group col-md-5\"><label for=tipoPersona>Tipo solicitud:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.datafiltroSolicitudes.tipoSolicitud><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoSolicitud\" ng-value=item.codigoRegistro>{{item.descripcion}}</option><!--\r\n					<option ng-value=\"1\">Solicitud Acceso</option>\r\n					<option ng-value=\"2\">Solicitud de Modificaci&oacute;n de Datos</option>\r\n					<option ng-value=\"3\">Solicitud de Nueva Instalaci&oacute;n</option>\r\n					<option ng-value=\"4\">Solicitud de Cancelaci&oacute;n de Registro</option>\r\n					--></select></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-s btn-pd-5\" ng-click=vm.limpiar() type=button><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnRef_recurso ng-click=vm.listarSolicitudes() type=button uib-tooltip=\"Buscar norma\"><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Tipo Persona</th><th class=text-center>Documento</th><th class=text-center>Razón social / nombre</th><th class=\"text-center td-tabla-01\">Nro. instalaciones</th><th class=\"text-center td-tabla-01\">Tipo de solicitud</th><th class=\"text-center td-tabla-01\">Fecha de registro</th><th class=\"text-center td-tabla-01\">Motivo de acción</th><th class=\"text-center td-tabla-01\">Estado</th></tr></thead><tbody><tr dir-paginate=\"itemSolicitud in vm.listaSolicitudes  | orderBy:\'-idSolicitud\' | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center>{{itemSolicitud.nombreTipoPersona}}</td><td class=text-center>{{itemSolicitud.documento}}</td><td class=text-center>{{itemSolicitud.nombreCompleto}}</td><td class=\"text-center td-tabla-01\">{{itemSolicitud.numeroInstalaciones}}</td><td class=\"text-center td-tabla-01\">{{itemSolicitud.nombreSolicitud}}</td><td class=\"text-center td-tabla-01\">{{itemSolicitud.fechaRegistroSolicitud}}</td><td class=\"text-center td-tabla-01\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.revisarSolicitud(itemSolicitud,\'1\')\" type=button uib-tooltip=\"Ver información\"><span class=icon-agregar></span></button></td><td class=\"text-center td-tabla-01\">{{itemSolicitud.nombreEstado}}</td></tr><!--	<tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n								<td colspan=\"5\">No se encontraron resultados</td>\r\n							</tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><br><!--\r\n		<div class=\"row\">\r\n	        <div class=\"form-group col-lg-12 text-right\">\r\n	            <button type=\"button\" ng-disabled=\"vm.formUsuario.$invalid\" ng-click=\"vm.guardar()\" class=\"btn btn-flat btn-success btn-sm\">\r\n	                <span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar Solicitud\r\n	            </button>\r\n	            <a class=\"btn btn-flat btn-primary btn-sm\" ng-click=\"vm.limpiar()\">\r\n	                <span class=\"glyphicon glyphicon-erase spac-btn-r\"></span> Limpiar\r\n	            </a>\r\n	            <button type=\"button\" ng-click=\"vm.cancelar()\" class=\"btn btn-flat btn-default btn-sm\">\r\n	                <span class=\"glyphicon glyphicon- spac-btn-r\"></span> Cancelar\r\n	            </button>  \r\n	        </div>\r\n  	    </div>\r\n--></div><div class=datoSolicitudAcceso ng-show=\"vm.flagActivoBandeja==\'0\'\"><div class=\"row formDataSolicitudes\"><div class=\"form-group col-md-3 dataSolicitudes\"><strong>Tipo de solicitud</strong></div><div class=\"form-group col-md-9 dataSolicitudes\">{{vm.dataSolicitudes.nombreSolicitud}}</div></div><div class=\"row formDataSolicitudes\"><div class=\"form-group col-md-12 dataSolicitudes\"><b style=font-size:14px>Datos de solicitante</b></div></div><div class=\"row formDataSolicitudes\"><div class=\"form-group col-md-3 dataSolicitudes\"><strong>Tipo de persona</strong></div><div class=\"form-group col-md-3 dataSolicitudes\">{{vm.dataSolicitudes.nombreTipoPersona}}</div><div class=\"form-group col-md-3 dataSolicitudes\"><strong>Documento</strong></div><div class=\"form-group col-md-3 dataSolicitudes\">{{vm.dataSolicitudes.documento}}</div></div><div class=\"row formDataSolicitudes\"><div class=\"form-group col-md-3 dataSolicitudes\"><strong>Nombre / razón social</strong></div><div class=\"form-group col-md-9 dataSolicitudes\">{{vm.dataSolicitudes.nombreCompleto}}</div></div><div class=\"row formDataSolicitudes\"><div class=\"form-group col-md-3 dataSolicitudes\"><strong>Domicilio fiscal:</strong></div><div class=\"form-group col-md-9 dataSolicitudes\">{{vm.dataSolicitudes.direccionFiscalizacion}}</div></div><div class=\"row formDataSolicitudes\" ng-show=\"vm.dataSolicitudes.tipoPersona==2\"><div class=\"form-group col-md-12 dataSolicitudes\"><b style=font-size:14px>Representante legal</b></div></div><div class=\"row formDataSolicitudes\" ng-show=\"vm.dataSolicitudes.tipoPersona==2\"><div class=\"form-group col-md-3 dataSolicitudes\"><strong>Nombre y apellidos:</strong></div><div class=\"form-group col-md-9 dataSolicitudes\">{{vm.dataSolicitudes.nombreResponsable}}</div></div><div class=\"row formDataSolicitudes\"><div class=\"form-group col-md-12 dataSolicitudes\"><b style=font-size:14px>Contactos</b></div></div><div class=\"row formDataSolicitudes\" ng-repeat=\"contacto in vm.listaContactoAdministrado\"><div class=\"form-group col-md-12 dataSolicitudes\"><strong>{{contacto.nombres}} - {{contacto.cargo}} - {{contacto.valor}} - {{contacto.telefono}}</strong></div></div><!--   <div class=\"row formDataSolicitudes\" ng-show=\"vm.dataSolicitudes.nombreSolicitud==\'Solicitud De Cancelacion de Instalacion\'\">\r\n                <div class=\"form-group col-md-3 dataSolicitudes\">\r\n                    <strong>\r\n                        Motivo de cancelación\r\n                    </strong>\r\n                </div>\r\n                <div class=\"form-group col-md-9 dataSolicitudes\">\r\n                    {{vm.listaDetalleSolicitud[0].solicitud.motivoCancelacionInstalacion}}\r\n                </div>\r\n            </div> --><div class=row style=/*overflow:auto;*/ ><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Instalación</th><th class=\"text-center td-tabla-01\">Número registro</th><th class=text-center>Sector</th><th class=text-center>Subsector</th><th class=text-center>Actividad</th><th class=text-center>Departamento</th><th class=\"text-center td-tabla-01\">Provincia</th><th class=\"text-center td-tabla-01\">Distrito</th><th class=\"text-center td-tabla-01\">Dirección</th><th class=\"text-center td-tabla-01\">Documento</th><th class=\"text-center td-tabla-01\">Estado</th><th class=\"text-center td-tabla-01\">Motivo de rechazo</th></tr></thead><tbody><tr dir-paginate=\"itemInstalacion in vm.listaDetalleSolicitud | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td>{{itemInstalacion.instalacion.numeroInstalacion}}</td><td><a download={{itemInstalacion.instalacion.fichaRegistro}} href={{vm.urlData}}solicitud/descargar-ficha-instalacion-solicitud/{{itemInstalacion.instalacion.idInstalacion}}>{{itemInstalacion.instalacion.numeroRegistro}}</a></td><td>{{itemInstalacion.instalacion.sector.descripcion}}</td><td>{{itemInstalacion.instalacion.subSector.descripcion}}</td><td>{{itemInstalacion.instalacion.actividad.descripcion}}</td><td>{{itemInstalacion.instalacion.departamento.descripcionDepartamento}}</td><td>{{itemInstalacion.instalacion.provincia.descripcion}}</td><td>{{itemInstalacion.instalacion.distrito.descripcionDistrito}}</td><td>{{itemInstalacion.instalacion.direccion}}</td><td><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.descargarFicha(); uib-tooltip=\"Ver ficha\"><span class=icon-ficha></span></button></td><td>{{itemInstalacion.estado.descripcion}}</td><td><div style=\"width: 150px\">{{itemInstalacion.instalacion.motivoRechazoInstalacion}}</div><!-- 						        <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR\')\" uib-tooltip=\"Aprobar\" ng-click=\"vm.validarDetalleSolicitudEstado(1,itemInstalacion,2)\" ng-disabled=\"itemInstalacion.estado.codigoRegistro!=1 && itemInstalacion.estado.codigoRegistro!=4\"> --><!-- 	                                <span class=\"glyphicon glyphicon-ok\"></span> --><!-- 	                            </button> --><!-- 								  <button type=\"button\" class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'RECHAZAR\')\" ng-disabled=\"itemInstalacion.estado.codigoRegistro!=1 && itemInstalacion.estado.codigoRegistro!=4\" uib-tooltip=\"Rechazar\" ng-click=\"vm.validarDetalleSolicitudEstado(1,itemInstalacion,3)\"> --><!-- 	                                <span class=\"glyphicon glyphicon-ban-circle\"></span> --><!-- 	                            </button> --></td></tr><!--	<tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n								<td colspan=\"5\">No se encontraron resultados</td>\r\n							</tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.aprobarSolicitudesSelecc() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR SELECCIONADAS\')\" type=button uib-tooltip=\"Aprobar Seleccionadas\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Aprobar seleccionadas</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.aprobarTodasSolicitudes() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'APROBAR TODAS\')\" type=button uib-tooltip=\"Aprobar Todas\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Aprobar todas</button></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() type=button uib-tooltip=Regresar><span class=\"glyphicon glyphicon-arrow-left\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/seguridad/configuraciones/configuracion.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Seguridad</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Seguridad</li><li>Configuraciones</li></ol></span></div></div><div class=row><div class=col-md-5 style=\"text-align: left\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N°</th><th style=\"text-align: center\">Nombre Presentación</th><th style=\"text-align: center\">Frecuencia</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstFechasFrecuencia.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstFechasFrecuencia | itemsPerPage: config.itemsPerPage\" pagination-id=count><td data-label=N° style=\"text-align: center\">{{$index + 1}}</td><td data-label=\"Nombre Presentación\" style=\"text-align: center\">{{item.nombrepresentacion}}</td><td data-label=Frecuencia style=\"text-align: center\">{{item.frecuencia}}</td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.listarfechasfrecuenciaDet(item) type=button uib-tooltip=Ver><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=count></dir-pagination-controls></div></div><div class=col-md-1 style=\"text-align: center\"></div><div class=col-md-6 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N°</th><th style=\"text-align: center\">Periodo</th><th style=\"text-align: center\">Frecuencia</th><th style=\"text-align: center\">Fecha Límite</th></tr></thead><tbody><tr ng-show=\"vm.lstFechasFrecuenciaDet.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstFechasFrecuenciaDet | itemsPerPage: config.itemsPerPage\" pagination-id=count><td data-label=N° style=\"text-align: center\">{{$index + 1}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Frecuencia style=\"text-align: center\">{{item.numerofrecuencia}}</td><td data-label=Frecuencia style=\"text-align: center\">{{item.fechalimite}}</td></tr></tbody></table><dir-pagination-controls pagination-id=count></dir-pagination-controls></div></div></div><br><div class=row><div class=col-md-12><h3 class=title-slider-nt>Configuración de días para el envío de correos de aviso de presentación de obligaciones.</h3></div></div><br><div class=row><div class=\"form-group col-md-2\"><strong><p>Enviar Correo IMA</p></strong><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasIMA1><p>días antes</p><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasIMA2><p>días antes</p></div><div class=\"form-group col-md-2\"><strong><p>Enviar Correo DRS</p></strong><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasDRS1><p>días antes</p><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasDRS2><p>días antes</p></div><div class=\"form-group col-md-2\"><strong><p>Enviar Correo MRS</p></strong><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasMRS1><p>días antes</p><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasMRS2><p>días antes</p></div><div class=\"form-group col-md-2\"><strong><p>Enviar Correo IAA</p></strong><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasIAA1><p>días antes</p><input class=\"form-control input-sm\" type=text ng-model=vm.prmDiasCorreo.diasIAA2><p>días antes</p></div></div><div class=row><div class=\"form-group col-md-6\"><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.guardarDiasPrevioCorreo()><span class=icon-agregar></span>Guardar Configuración</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.enviarCorreoAnticipado()><span class=icon-agregar></span> Enviar Correo Anticipado</button></div></div></div>");
$templateCache.put("app/modules/componente/dialog/componente-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmComponente.codigo == 0 ? \'Nueva\' : \'Editar\' }} Componente:</h4></div></div><div class=modal-body name=componenteDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-6\"><label class=important-box>Descripci&oacuten:</label><div ng-class=\"{\'has-error\':componenteDataDialogForm.descripcion.$invalid && componenteDataDialogForm.descripcion.$touched}\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion maxlength=50 ng-model=vm.prmComponente.descripcion type=text></div></div><div class=\"form-group col-md-4\"><label class=important-box>Estado:</label><div><select ng-model=vm.prmComponente.estado class=\"form-control input-sm\" id=estado name=estado><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div></div></div><br><!-- 	<div class=\"row\">\r\n			<div class=\"form-group col-md-6\">\r\n				<label class=\"\"> Mostrar para: </label>\r\n				<div>\r\n					<input id=\"unidadmayor\" name=\"unidadmayor\"\r\n						ng-model=\"vm.prmComponente.blUnidadMayor\" type=\"checkbox\">Unidades\r\n					Mayores</input> <input id=\"unidadmenor\" name=\"unidadmenor\"\r\n						ng-model=\"vm.prmComponente.blUnidadMenor\" type=\"checkbox\">Unidades\r\n					Menores</input>\r\n				</div>\r\n			</div>\r\n\r\n		</div> --><div class=row><div class=\"form-group col-md-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmComponente.descripcion==\'\' ||vm.prmComponente.descripcion.length==0\" type=button uib-tooltip=\"{{ vm.prmComponente.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmComponente.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-md-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/componente/listado/componente-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de Componentes</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>Componentes</li></ol></span></div></div><div class=row><div ng-show=\"vm.prmComponentePadre.codigo != 0\" class=\"form-group col-md-12\"><strong><p>Componente Padre: {{vm.prmComponentePadre.descripcion}}</p></strong></div></div><div class=row><div ng-show=\"vm.prmComponentePadre.codigo == 0\" class=\"form-group col-md-3\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmComponente.descripcion></div><div ng-show=\"vm.prmComponentePadre.codigo == 0\" class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmComponente.estado class=form-control id=estado name=estado><option value=T>--TODOS--</option><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button ng-show=\"vm.prmComponentePadre.codigo == 0\" uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.regresar() type=button ng-show=\"vm.prmComponentePadre.codigo != 0\" uib-tooltip=Regresar><span class=\"icon-regresar spac-btn-r\"></span> Regresar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Nombre</th><th style=\"text-align: center\">Estado</th><th style=\"text-align: center\">Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstComponentes.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstComponentes | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Nombre style=\"text-align: center\">{{item.descripcion}}</td><td data-label=Estado style=\"text-align: center\"><div ng-show=\"{{item.estado == \'1\'}}\">ACTIVO</div><div ng-show=\"{{item.estado == \'0\'}}\">INACTIVO</div></td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-show=\"{{item.estado == \'1\'}}\" ng-click=vm.listarRegistroHijo(item) type=button><span class=icon-agregar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.cargarParametros(item) type=button uib-tooltip=\"Parametros del Componente\"><span class=\"glyphicon glyphicon-cog\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarInactivacion(item) type=button ng-show=\"{{item.estado == \'1\'}}\" uib-tooltip=Inactivar><span class=\"glyphicon glyphicon-minus-sign\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/seguridad/perfiles/perfil-registro.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Gestión de perfil</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Perfiles</li><li>Gestión</li></ol></span></div></div><div class=row><div class=\"form-group col-md-4\" ng-class=\"{\'has-error\':usuarioRegistroForm.NombrePersona.$invalid && usuarioRegistroForm.NombrePersona.$touched}\"><label class=important-box for=NombrePersona>Código</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=texto-espacio maxlength=100 name=NombrePersona ng-model=vm.dataPerfil.idPerfil required type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-class=\"{\'has-error\':usuarioRegistroForm.ApePaternoPersona.$invalid && usuarioRegistroForm.ApePaternoPersona.$touched}\"><label class=important-box for=ApePaternoPersona>Nombre</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=texto-espacio maxlength=100 name=ApePaternoPersona ng-model=vm.dataPerfil.nombrePerfil placeholder=\"Ingresar nombre perfil\" required type=text></div></div></div><div class=row><div class=\"form-group col-lg-10 text-right\"><!--             <button type=\"botton\" onclick=\"limpiar();\" class=\"btn btnSearch btn-flat btn-default btn-sm\">\r\n	                <span class=\"glyphicon glyphicon-erase space-ico-r\"></span> Limpiar\r\n	            </button> --> <button class=\"btn btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=usuarioRegistroForm.$invalid type=button><span class=\"glyphicon glyphicon-floppy-disk spac-btn-r\"></span> Guardar</button> <button class=\"btn btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() type=button><span class=icon-limpiar></span> Limpiar</button></div></div><div class=row><div class=col-md-10 style=text-align:center><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=text-align:center>Ítem</th><th style=text-align:center>Perfil</th><th aria-hidden=true class=ng-hide ng-show=false style=text-align:center>Tipo perfil</th><th style=text-align:center>Acción</th></tr></thead><tbody><tr class=ng-scope dir-paginate=\"item in vm.listaPerfiles | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=ng-binding data-label=Ítem>{{item.idPerfil}}</td><td class=ng-binding data-label=Perfil>{{item.nombrePerfil}}</td><td aria-hidden=true class=\"ng-binding ng-hide\" data-label=\"Tipo Perfil\" ng-show=false></td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm ng-scope\" ng-click=vm.editarPerfil(item.idPerfil) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm ng-scope\" ng-click=vm.confirmarEliminacion(item.idPerfil) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/seguridad/usuarios-ubigeo/usuario-ubigeo-listado.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Permisos Usuario</span></h3></div></div><br><div class=row><div class=col-md-3><strong>USUARIOS</strong></div><div class=col-md-3><table><tr><td><strong>DEPARTAMENTOS&nbsp;</strong></td></tr></table></div><div class=col-md-3><strong>PROVINCIAS</strong></div><div class=col-md-3><strong>DISTRITOS</strong></div></div><div class=row><div class=col-md-3><table><tr ng-repeat=\"item in vm.listaUsuariosSSO\" ng-class=\"{select: vm.dataUsuarioUbgeo.idUsuario == item.idUsuario, null: vm.dataUsuarioUbgeo.idUsuario != item.idUsuario}\"><td data-label=\"\" style=\"text-align: right\">{{$index + 1}}&nbsp;</td><td data-label=\"\">{{item.nombreUsuario}}&nbsp;</td><td class=text-center><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnVer ng-click=vm.cargarDepartamento(item) type=button uib-tooltip=Ver><span class=\"icon-buscar spac-btn-r\"></span></button></td></tr></table></div><div class=col-md-3><table><tr ng-repeat=\"item in vm.listaDepartamento\" ng-class=\"{select: vm.dataUsuarioUbgeo.ubigeo.substring(0,2) == item.codigoDepartamento, null: vm.dataUsuarioUbgeo.ubigeo != item.codigoDepartamento}\"><td data-label=\"\" style=\"text-align: right\">{{$index + 1}}&nbsp;&nbsp;</td><td data-label=\"\">{{item.descripcionDepartamento}}&nbsp;</td><td class=text-center><input type=checkbox ng-model=item.isSeleccionado ng-change=vm.cargarProvincia(item)></td><td class=text-center><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnVer ng-click=vm.verConfigProvincia(item) type=button uib-tooltip=Ver><span class=\"icon-buscar spac-btn-r\"></span></button></td></tr></table></div><div class=col-md-3><table><tr ng-repeat=\"item in vm.listaProvincia\" ng-class=\"{select: vm.dataUsuarioUbgeo.ubigeo.substring(2,4) == item.codigoProvincia, null: vm.dataUsuarioUbgeo.ubigeo != item.codigoProvincia}\"><td data-label=\"\" style=\"text-align: right\">{{$index + 1}}&nbsp;</td><td data-label=\"\">{{item.descripcion}}&nbsp;&nbsp;</td><td class=text-center><input type=checkbox ng-model=item.isSeleccionado ng-change=vm.cargarDistrito(item)></td><td class=text-center><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnVer ng-click=vm.verConfigDistrito(item) type=button uib-tooltip=Ver><span class=\"icon-buscar spac-btn-r\"></span></button></td></tr></table></div><div class=col-md-3><table><tr ng-repeat=\"item in vm.listaDistrito\" ng-class=\"{select: vm.dataUsuarioUbgeo.ubigeo.substring(4,6) == item.codigoDistrito, null: vm.dataUsuarioUbgeo.ubigeo != item.codigoDistrito}\"><td data-label=\"\" style=\"text-align: right\">{{$index + 1}}&nbsp;</td><td data-label=\"\">{{item.descripcionDistrito}}&nbsp;&nbsp;</td><td class=text-center><input type=checkbox ng-model=item.isSeleccionado ng-change=vm.guardarDistrito(item)></td></tr></table></div></div></span></div>");
$templateCache.put("app/modules/etapa/dialog/etapa-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmEtapa.codetapa == 0 ? \'Nueva\' : \'Editar\' }} Etapa:</h4></div></div><div class=modal-body name=etapaDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-lg-6\"><label class=important-box>Descripci&oacuten:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':etapaDataDialogForm.descripcion.$invalid && etapaDataDialogForm.descripcion.$touched}\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion maxlength=50 ng-model=vm.prmEtapa.descripcion type=text></div></div><div class=\"form-group col-lg-4\"><label class=important-box>Estado:</label><div class=\"input-group col-lg-12\" ng-class=\"{\'has-error\':etapaDataDialogForm.descripcion.$invalid && etapaDataDialogForm.descripcion.$touched}\"><select ng-model=vm.prmEtapa.estado class=\"form-control input-sm\" id=estado name=estado><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div></div></div><br><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmEtapa.descripcion==\'\' ||vm.prmEtapa.descripcion.length==0\" type=button uib-tooltip=\"{{ vm.prmEtapa.codetapa == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmEtapa.codetapa == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/etapa/listado/etapa-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de Etapas</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>Etapas del Proyecto</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmEtapa.descripcion></div><div class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmEtapa.estado class=form-control id=estado name=estado><option value=T>--TODOS--</option><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=10%>N° Item</th><th style=\"text-align: center\" width=50%>Nombre</th><th style=\"text-align: center\" width=20%>Estado</th><th style=\"text-align: center\" width=20%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstEtapas.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstEtapas | itemsPerPage: config.itemsPerPage\" pagination-id=coutetapa><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Nombre style=\"text-align: center\">{{item.descripcion}}</td><td data-label=Estado style=\"text-align: center\"><div ng-show=\"{{item.estado == \'1\'}}\">ACTIVO</div><div ng-show=\"{{item.estado == \'0\'}}\">INACTIVO</div></td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarInactivacion(item) type=button ng-show=\"{{item.estado == \'1\'}}\" uib-tooltip=Inactivar><span class=\"glyphicon glyphicon-minus-sign\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutetapa></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/tipoiga/dialog/tipoiga-data-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.titulo }} Tipo Iga:</h4></div></div><div class=modal-body name=tipoigaDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><label class=important-box>C&oacutedigo:</label><div ng-class=\"{\'has-error\':tipoigaDataDialogForm.codigo.$invalid && tipoigaDataDialogForm.codigo.$touched}\"><input class=\"form-control input-sm\" id=Codigo ng-disabled=\"{{ vm.titulo == \'Editar\'}}\" maxlength=10 required name=codigo ng-model=vm.prmTipoIga.codigo type=text></div></div></div><div class=row><div class=\"form-group col-md-6\"><label class=important-box>Descripci&oacuten:</label><div ng-class=\"{\'has-error\':tipoigaDataDialogForm.descripcion.$invalid && tipoigaDataDialogForm.descripcion.$touched}\"><input class=\"form-control input-sm\" id=Descripcion required name=descripcion maxlength=50 ng-model=vm.prmTipoIga.descripcion type=text></div></div><div class=\"form-group col-md-4\"><label class=important-box>Estado:</label><select ng-model=vm.prmTipoIga.estado class=\"form-control input-sm\" id=estado name=estado><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div></div><br><!-- <div class=\"row\">\r\n			<div class=\"form-group col-md-6\">\r\n				<label class=\"\"> Mostrar para: </label>\r\n				<div>\r\n					<input id=\"unidadmayor\" name=\"unidadmayor\"\r\n						ng-model=\"vm.prmTipoIga.blUnidadMayor\" type=\"checkbox\">Unidades\r\n					Mayores</input> <input id=\"unidadmenor\" name=\"unidadmenor\"\r\n						ng-model=\"vm.prmTipoIga.blUnidadMenor\" type=\"checkbox\">Unidades\r\n					Menores</input>\r\n				</div>\r\n			</div>\r\n\r\n		</div> </br> --><div class=row><div class=\"form-group col-md-10\"><label>Comentarios:</label><div><input class=\"form-control input-sm\" id=Comentario multiple name=comentario maxlength=4000 ng-model=vm.prmTipoIga.comentario type=text></div></div></div><div class=row><div class=\"form-group col-md-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.prmTipoIga.descripcion==\'\' ||vm.prmTipoIga.descripcion.length==0\" type=button uib-tooltip=\"{{ vm.prmTipoIga.codigo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.tituloAccion }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-md-12 text-left\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div></div></span></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/tipoiga/listado/tipoiga-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de Tipo de IGAS</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Maestros</li><li>Tipo de IGA</li></ol></span></div></div><div class=row><div class=\"form-group col-md-3\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmTipoIga.descripcion></div><div class=\"form-group col-md-2\"><label>Estado</label><select ng-model=vm.prmTipoIga.estado class=form-control id=estado name=estado><option value=T>--TODOS--</option><option value=1>ACTIVO</option><option value=0>INACTIVO</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-2\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=10%>N° Item</th><th style=\"text-align: center\" width=50%>Nombre</th><th style=\"text-align: center\" width=20%>Estado</th><th style=\"text-align: center\" width=20%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstTipoIgas.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstTipoIgas | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Nombre style=\"text-align: center\">{{item.descripcion}}</td><td data-label=Estado style=\"text-align: center\"><div ng-show=\"{{item.estado == \'1\'}}\">ACTIVO</div><div ng-show=\"{{item.estado == \'0\'}}\">INACTIVO</div></td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarInactivacion(item) type=button ng-show=\"{{item.estado == \'1\'}}\" uib-tooltip=Inactivar><span class=\"glyphicon glyphicon-minus-sign\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/online/listado-supervicion-online.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Módulo de supervisión online</span></h3></div></div><br><div id=ModuloSupervisionOnline ng-show=\"vm.flagActivoMSO==\'1\'\"><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Sector:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-change=vm.listarSubSector() ng-model=vm.datafiltroAdministrado.instalacion.sector.codigoRegistro><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSector\" ng-value=\"itemCombo.codigoRegistro | number\">{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Subsector:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-change=vm.listarActividad() ng-model=vm.datafiltroAdministrado.instalacion.subSector.codigoRegistro><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSubSector\" ng-value=\"itemCombo.codigoRegistro | number\">{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Actividad:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.datafiltroAdministrado.instalacion.actividad.codigoRegistro><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaActividad\" ng-value=\"itemCombo.codigoRegistro | number\">{{itemCombo.descripcion}}</option></select></div></div><!-- 		<div class=\"row\"> --><!--             	<div class=\"form-group col-md-3\"> --><!-- 				<label for=\"tipoPersona\">Sector:</label> --><!-- 				<select id=\"tipoPersona\" name=\"tipoPersona\" ng-model=\"vm.datafiltroAdministrado.instalacion.sector\" ng-change=\" vm.listarSubSector()\" class=\"form-control input-sm\"> --><!-- 					<option ng-value=\"0\">Seleccione</option> --><!-- 					<option ng-repeat=\"itemCombo in vm.listaSector\"  --><!-- 							ng-value=\"itemCombo.codigoRegistro*1\">{{itemCombo.descripcion}}</option> --><!-- 				</select> --><!-- 			</div> --><!-- 			<div class=\"form-group col-md-3\"> --><!-- 				<label for=\"tipoPersona\">Sub Sector:</label> --><!-- 				<select id=\"tipoPersona\" name=\"tipoPersona\" ng-model=\"vm.datafiltroAdministrado.instalacion.subSector\" ng-change=\"vm.listarActividad()\" class=\"form-control input-sm\"> --><!-- 					<option ng-value=\"0\">Seleccione</option> --><!-- 					<option ng-repeat=\"itemCombo in vm.listaSubSector\"  --><!-- 							ng-value=\"itemCombo.codigoRegistro*1\">{{itemCombo.descripcion}}</option> --><!-- 				</select> --><!-- 			</div> --><!-- 			<div class=\"form-group col-md-3\"> --><!-- 				<label for=\"tipoPersona\">Actividad:</label> --><!-- 				<select id=\"tipoPersona\" name=\"tipoPersona\" ng-model=\"vm.datafiltroAdministrado.instalacion.actividad\" class=\"form-control input-sm\"> --><!-- 					<option ng-value=\"0\">Seleccione</option> --><!-- 					<option ng-repeat=\"itemCombo in vm.listaActividad\"  --><!-- 							ng-value=\"itemCombo.codigoRegistro*1\">{{itemCombo.descripcion}}</option> --><!-- 				</select> --><!-- 			</div> --><!-- 				</div> --><div class=row><div class=\"form-group col-md-3\"><label for=numeroDocumento>Nro. de documento:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero maxlength=11 name=numeroDocumento ng-keyup=\"vm.dataUsuario.nombreUsuario=vm.dataEntidad.ruc\" ng-model=vm.datafiltroAdministrado.documento placeholder=\"Ingrese nro de documento\" requerid=\"\" type=text></div></div><div class=\"form-group col-md-6\"><label for=razonSocial>Razón social:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=100 name=razonSocial ng-model=vm.datafiltroAdministrado.nombreCompleto type=text></div></div></div><div class=row><div class=\"form-group col-md-6\"><label for=razonSocial>Instalación:</label><div class=form-group><input class=\"form-control input-sm\" name=razonSocial ng-model=vm.datafiltroAdministrado.instalacion.numeroInstalacion type=text></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'LIMPIAR\')\" type=button uib-tooltip=\"Limpiar filtros\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" id=btnRef_recurso ng-click=vm.listarAdministrador() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'BUSCAR\')\" type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button><!--  <a class=\"btn btn-flat btn-primary btn-sm\" ng-click=\"vm.irRegistroDenuncia()\" uib-tooltip=\"Nuevo Registro\">\r\n	                <span class=\"glyphicon glyphicon-plus-sign spac-btn-r\"></span> Nuevo\r\n	            </a>--></div></div><div class=row><div class=col-md-12><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered table-striped table-app\" id=listaDenuncias width=100%><thead><tr><th class=text-center>Tipo persona</th><th class=text-center>Documento</th><th class=text-center>Razón social / nombre</th><th class=\"text-center td-tabla-01\">Nro. instalaciones</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody dir-paginate=\"itemAdministrado in vm.listaAdmistradoActivo | itemsPerPage: config.itemsPerPage\" pagination-id=cout><tr><td class=text-center data-label=tipoPersona>{{itemAdministrado.nombreTipoAdministrado}}</td><td class=text-center data-label=Documento>{{itemAdministrado.documento}}</td><td class=text-center data-label=\"Razón social / nombre\">{{itemAdministrado.nombreCompleto}}</td><td class=\"text-center td-tabla-01\" data-label=\"Nro. instalaciones\">{{itemAdministrado.numeroInstalaciones}}</td><td data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=\"itemAdministrado.seleccionado = !itemAdministrado.seleccionado; vm.listarInstalaciones(itemAdministrado,itemAdministrado.seleccionado)\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'VER INSTALACIONES\')\" type=button uib-tooltip=\"Ver Instalaciones\"><span class=icon-nuevo></span></button></td><!--<td class=\"text-center\" width=\"90\">{{itemDenuncia.estado}}</td> --></tr><tr ng-show=itemAdministrado.seleccionado><td colspan=6><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered table-striped table-app\" width=100%><thead><tr><th class=text-center>Instalación</th><th class=text-center>Tipo de establecimiento</th><th class=text-center>Nro. de registro</th><th class=text-center>Información</th><th class=text-center>AutoSupervición</th><th class=text-center>Presentación</th></tr></thead><tbody><tr dir-paginate=\"itemEntidad in itemAdministrado.listaInstalaciones | itemsPerPage: config.itemsPerPage\" pagination-id=cout2><td class=text-center data-label=Instalación>{{itemEntidad.numeroInstalacion}}</td><td class=text-center data-label=\"Tipo de establecimiento\">{{itemEntidad.nombreTipoEstablecimiento}}</td><td class=\"text-center td-tabla-01\" data-label=\"Nro. de registro\"><a download={{itemEntidad.numeroRegistro}} href={{vm.urlData}}instalacion/descargar-ficha-instalacion/{{itemEntidad.idInstalacion}}>{{itemEntidad.numeroRegistro}} </a><!-- 									<a href=\"{{vm.urlData}}solicitud/descargar-ficha-registro/{{itemEntidad.idInstalacion}}\">{{itemEntidad.numeroRegistro}}</a> --></td><td class=\"text-center td-tabla-01\" data-label=Información><button class=\"btn btn-default btn-sm\" ng-click=vm.mostrarInformacionInstalacionDialog(itemEntidad) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'VER DOCUMENTOS\')\" type=button uib-tooltip=\"Ver documentos\"><span class=icon-agregar></span></button></td><td class=\"text-center td-tabla-01\" data-label=Autosupervición><button class=\"btn btn-default btn-sm\" ng-click=vm.verDatosAutoSupervisionOnline(itemEntidad) type=button uib-tooltip=\"Ver ficha de autosupervisión\"><span class=icon-agregar></span></button></td><td class=\"text-center td-tabla-01\" data-label=Presentación><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarVerPresentacion(itemEntidad) type=button uib-tooltip=\"Ver presentación\"><span class=icon-agregar></span></button></td></tr><!--  \r\n	                             <tr ng-show=\"itemDenuncia.lstEntidadDenuncia == null || itemDenuncia.lstEntidadDenuncia.length==0\">\r\n	                              <td colspan=\"6\">No se encontraron resultados</td>\r\n	                             </tr> \r\n	                            --></tbody></table><dir-pagination-controls pagination-id=cout2></dir-pagination-controls></div></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><br><!--  <div class=\"row\">\r\n	        <div class=\"form-group col-lg-12 text-right\">\r\n	            <button type=\"button\" ng-disabled=\"vm.formUsuario.$invalid\" ng-click=\"vm.guardar()\" class=\"btn btn-flat btn-success btn-sm\">\r\n	                <span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar Solicitud\r\n	            </button>\r\n	            <a class=\"btn btn-flat btn-primary btn-sm\" ng-click=\"vm.limpiar()\">\r\n	                <span class=\"glyphicon glyphicon-erase spac-btn-r\"></span> Limpiar\r\n	            </a>\r\n	            <button type=\"button\" ng-click=\"vm.cancelar()\" class=\"btn btn-flat btn-default btn-sm\">\r\n	                <span class=\"glyphicon glyphicon- spac-btn-r\"></span> Cancelar\r\n	            </button>  \r\n	        </div>\r\n  	    </div>--></div><div class=datosDeInstalaciones ng-show=\"vm.flagActivoMSO==\'0\'\"></div></div></span></div>");
$templateCache.put("app/modules/usuario/listado/usuario-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado de usuarios</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Data</li><li>Listado</li></ol></span></div></div><div class=row><div class=\"form-group col-md-6\"><label for=usuario>Usuario</label><div class=form-group><input class=\"form-control input-sm\" id=usuario name=usuario ng-model=vm.prmUsuario.usuario placeholder=\"Filtrar por nombre de usuario\" type=text></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm btn-pd-5\" ng-click=vm.limpiar() type=button><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnRef_recurso ng-click=vm.buscar() type=button><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.nuevo()><span class=\"icon-nuevo spac-btn-r\"></span> Nuevo</a></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cantidadPaginas>Páginas</label><select class=\"form-control input-sm\" id=cantidadPaginas name=cantidadPaginas ng-model=vm.opcionesPaginacion.itemsPorPag><option ng-repeat=\"itemPag in vm.opcionesPaginacion.cantidades\" ng-value=itemPag*1>{{itemPag}}</option></select></div></div><div class=row><div class=col-md-12 style=text-align:right><div class=table-rpv><table cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption>Resultados de búsqueda</caption><thead><tr><th style=text-align:center>Ítem</th><th style=text-align:center>Nombre</th><th style=text-align:center>Usuario</th><th style=text-align:center>Acción</th></tr></thead><tbody><tr dir-paginate=\"itemUsuario in vm.listaUsuario | filter : vm.filtroRapido | itemsPerPage : vm.opcionesPaginacion.itemsPorPag\"><td data-label=Ítem style=text-align:center>{{itemUsuario.idUsuario}}</td><td data-label=Nombre style=text-align:center>{{itemUsuario.nombre}}</td><td data-label=Usuario style=text-align:center>{{itemUsuario.usuario}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.editar(itemUsuario.idUsuario) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(itemUsuario.idUsuario) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table></div></div></div><div class=row><div class=text-center><dir-pagination-controls boundary-links=true></dir-pagination-controls></div></div></span></div>");
$templateCache.put("app/modules/usuario/registro/usuario-registro.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Registro de usuarios</span></h3></div></div><br><fieldset class=\"well unp-fieldset\"><legend class=unp-legend></legend><div class=row><div class=\"form-group col-md-6\"><label class=important-box for=idUsuario>Código de usuario</label><div class=form-group><input class=\"form-control input-sm\" name=idUsuario ng-disabled=true ng-model=vm.dataUsuario.idUsuario placeholder=\"Código generado\" type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-class=\"{\'has-error\':formUsuario.nombreUsuario.$invalid && formUsuario.nombreUsuario.$touched}\"><label class=important-box for=nombreUsuario>Usuario</label><div class=form-group><input autocomplete=off class=\"form-control input-sm\" name=nombreUsuario ng-model=vm.dataUsuario.nombreUsuario placeholder=\"Ingresar usuario\" required type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-class=\"{\'has-error\':formUsuario.clave.$invalid && formUsuario.clave.$touched}\"><label class=important-box for=clave>Clave</label><div class=form-group><input autocomplete=off class=\"form-control input-sm\" name=clave ng-model=vm.dataUsuario.clave placeholder=\"Ingresar clave\" required type=password></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-class=\"{\'has-error\':vm.formUsuario.nombres.$invalid && vm.formUsuario.nombres.$touched}\"><div class=form-group><label class=important-box for=nombres>Nombre</label><input class=\"form-control input-sm\" input-restrict=texto-espacio maxlength=100 name=nombres ng-model=vm.dataUsuario.persona.nombres placeholder=\"Ingrese su nombre\" required type=text></div></div></div></fieldset><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=vm.formUsuario.$invalid type=button><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar()><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar </a><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon- spac-btn-r\"></span> Cancelar</button></div></div></span></div>");
$templateCache.put("app/modules/preguntas/registro/registro-pregunta.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Registro de preguntas</span></h3></div></div><br><uib-tabset active=vm.active><uib-tab heading=\"Datos pregunta\" index=0><br><div class=row><div class=\"form-group col-md-6\"><label class=important-box for=tipoPersona>Tipo de pregunta:</label><select class=\"form-control input-sm\" ng-disabled=\"vm.dataPregunta.idPregunta!=0\" ng-model=vm.dataPregunta.tipoPregunta ng-change=vm.limpiarAlCambiarComboTipoPregunta() ng-options=\"item as item.descripcion for item in vm.listaTipoPregunta track by item.codigoRegistro\"></select></div></div><div class=row><div class=\"form-group col-md-6\"><label class=important-box for=numeroDocumento>Pregunta:</label><div class=form-group><textarea class=\"form-control input-sm\" maxlength=400 name=numeroDocumento ng-model=vm.dataPregunta.descripcion placeholder=\"Ingrese pregunta\" type=text>\r\n                            </textarea></div></div><div class=\"form-group col-md-3\" ng-if=\"vm.dataPregunta.tipoPregunta.codigoRegistro==3 || vm.dataPregunta.tipoPregunta.codigoRegistro==4 || vm.dataPregunta.tipoPregunta.codigoRegistro==6 \"><label for=numeroDocumento>Solicitar archivo:</label><div class=form-group><input ng-false-value=0 ng-model=vm.dataPregunta.flagArchivo ng-true-value=1 type=checkbox></div></div></div><div class=row ng-if=\"vm.dataPregunta.tipoPregunta.codigoRegistro==5\"><div class=\"form-group col-md-3\"><label class=important-box for=numeroDocumento>Números de fila:</label><div class=form-group><input class=\"form-control input-sm\" name=numerosFila ng-disabled=\"vm.dataPregunta.idPregunta!=0\" ng-keyup=vm.opcionesPreguntaTabla() ng-model=vm.dataPregunta.numerosFila input-restrict=numero maxlength=2 placeholder=\"Ingrese numeros de fila\" type=text></div></div><div class=\"form-group col-md-3\"><label class=important-box for=numeroDocumento>Números de columna:</label><div class=form-group><input class=\"form-control input-sm\" name=numerosColumna ng-disabled=\"vm.dataPregunta.idPregunta!=0\" ng-keyup=vm.opcionesPreguntaTabla() ng-model=vm.dataPregunta.numerosColumna input-restrict=numero maxlength=1 placeholder=\"Ingrese numeros de columna\" type=text></div></div></div><div class=row ng-show=\"vm.dataPregunta.tipoPregunta.codigoRegistro==3 || vm.dataPregunta.tipoPregunta.codigoRegistro==4  \"><div class=\"form-group col-md-4\"><label for=razonSocial>Opción:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=100 name=razonSocial ng-model=vm.dataOpcionPregunta.valor type=text></div></div><div class=\"form-group col-md-4\"><label for=razonSocial></label><div class=form-group><a class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.agregarOpcion() ng-disabled=\"vm.dataOpcionPregunta.valor.length<=1\" ng-class=\"vm.dataOpcionPregunta.valor.length<=1 ? \'bloquear\' : \'\'\"><span class=icon-agregar></span> Añadir</a></div></div></div><div class=row ng-show=\"vm.dataPregunta.tipoPregunta.codigoRegistro==6\"><div class=\"form-group col-md-6\"><label for=razonSocial>Valor Correcto:</label><div class=form-group><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Opción</th><th class=text-center>Valor correcto</th></tr></thead><tbody><tr ng-repeat=\"itemOpcionSiNo in vm.dataPregunta.lstOpcionPregunta\"><td class=text-center data-label=Ítem>{{$index+1}}</td><td class=text-center data-label=Opción>{{itemOpcionSiNo.valor}}</td><td class=text-center data-label=\"Valor correcto\"><input checked name=swCorrecto ng-change=vm.reiniciarSelecionarOpcionSeleccion($index) ng-model=itemOpcionSiNo.swCorrecto type=radio value=1></td></tr></tbody></table></div></div></div><div class=row ng-show=\"vm.dataPregunta.tipoPregunta.codigoRegistro==3 || vm.dataPregunta.tipoPregunta.codigoRegistro==4 \"><div class=\"form-group col-md-8\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Opción</th><th class=text-center>Valor correcto</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemOpcion in vm.dataPregunta.lstOpcionPregunta | itemsPerPage: config.itemsPerPage\" pagination-id=coutOpcionPregunta><td class=text-center data-label=Ítem>{{ $index + serialPregunta}}</td><td class=text-center data-label=Opción>{{itemOpcion.valor}}</td><td class=text-center data-label=\"Valor correcto\" ng-if=\"vm.dataPregunta.tipoPregunta.codigoRegistro==3\"><input checked name=swCorrecto ng-change=vm.reiniciarSelecionarOpcionSeleccion(obtenerValorIndex($index,serialPregunta)) ng-model=itemOpcion.swCorrecto type=radio value=1></td><td class=text-center data-label=Acción ng-if=\"vm.dataPregunta.tipoPregunta.codigoRegistro==4\"><input ng-false-value=0 ng-model=itemOpcion.swCorrecto ng-true-value=1 type=checkbox></td><td class=\"text-center td-tabla-01\"><button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarOpcionesPregunta(itemOpcion) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"vm.dataPregunta.lstOpcionPregunta ==null || vm.dataPregunta.lstOpcionPregunta.length==0\"><td colspan=4>No se encontraron resultados.</td></tr></tbody></table><dir-pagination-controls boundary-links=true direction-links=true max-size=8 on-page-change=indexCount(newPageNumber) pagination-id=coutOpcionPregunta></dir-pagination-controls></div></div></div><div class=row ng-show=\"vm.dataPregunta.tipoPregunta.codigoRegistro==5 \"><div class=\"form-group col-md-10\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><tbody><tr ng-repeat=\"itemFila in vm.dataPregunta.lstOpcionPregunta\"><td class=text-center ng-repeat=\"itemColumna in itemFila.lstOpcionPreguntaColumna\"><input class=\"form-control input-sm\" maxlength=50 name=numerosFila ng-if=\"itemColumna.posicionFila==0 || itemColumna.posicionColumna==0\" ng-model=itemColumna.valor placeholder=\"Ingrese Valor\" type=text> <input class=\"form-control input-sm\" disabled maxlength=50 name=numerosFila ng-if=\"itemColumna.posicionFila!=0 && itemColumna.posicionColumna!=0\" ng-model=itemColumna.valor type=text></td></tr></tbody></table></div></div></div><br><div class=row><div id=campoObligatorio class=\"col-lg-4 text-left ng-scope\" ng-if=true><p class=\"font-text text-justify\"><span class=important-box></span> Campo obligatorio.</p></div><div class=\"form-group col-lg-8 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.registrarPregunta() ng-disabled=\"!vm.dataPregunta.descripcion ||vm.dataPregunta.tipoPregunta.codigoRegistro==0\" type=button><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{vm.btnAccion}}</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() ng-if=\"vm.dataPregunta.idPregunta==0\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar </a><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div><!--\r\n				<div class=\"row\" ng-show=\"vm.pregunta.tipoPregunta.codigoRegistro==3 || vm.pregunta.tipoPregunta==4 || vm.pregunta.tipoPregunta==6  \">\r\n		\r\n\r\n					<div class=\"form-group col-md-8\">\r\n							<label for=\"razonSocial\">Descripcion Archivo:</label>\r\n							<div class=\"form-group\">\r\n								<input ng-model=\"vm.dataEntidad.razonSocial\" type=\"text\" class=\"form-control input-sm\" name=\"razonSocial\" >\r\n							</div>\r\n						</div>		\r\n\r\n		\r\n	\r\n			\r\n				</div>\r\n	--><!-- --></uib-tab><uib-tab heading=\"Periodos de la Pregunta\" index=1 ng-if=\"vm.dataPregunta.idPregunta!=0\"><br><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Periodo:</label><select class=\"form-control input-sm\" ng-model=vm.datePeriodoPregunta.periodo ng-options=\"item as item.descripcion for item in vm.listaPeriodoPreguntas track by item.codigoRegistro\"><option ng-value=0>Seleccione</option></select></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.registrarPeriodoPregunta() ng-disabled=\"vm.datePeriodoPregunta.periodo.codigoRegistro==0\" type=button><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar periodo</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiarPeriodo()><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</a></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Periodo</th><th class=text-center>Vigencia</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemPeriodoPregunta in vm.listaDatosPeriodoPregunta | itemsPerPage: config.itemsPerPage\" pagination-id=coutPeriodoPregunta><td class=text-center data-label=Ítem>{{$index+1}}</td><td class=text-center data-label=Periodo>{{itemPeriodoPregunta.periodo.descripcion}}</td><td class=text-center data-label=Vigencia>{{itemPeriodoPregunta.periodo.valorGeneral03}}</td><td class=\"text-center td-tabla-01\" data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmareliminarPeriodoPregunta(itemPeriodoPregunta) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"vm.listaDatosPeriodoPregunta == null || vm.listaDatosPeriodoPregunta.length==0\"><td colspan=4>No se encontraron resultados.</td></tr></tbody></table><dir-pagination-controls pagination-id=coutPeriodoPregunta></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=Sector index=2 ng-if=\"vm.dataPregunta.idPregunta!=0\"><br><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Sector:</label><select class=\"form-control input-sm\" ng-change=\" vm.listarSubSector()\" ng-model=vm.dataPreguntaSector.sector ng-options=\"item as item.descripcion for item in vm.listaSector track by item.codigoRegistro\"><option ng-value=0>Todos</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Subsector:</label><select class=\"form-control input-sm\" ng-change=vm.listarActividad() ng-model=vm.dataPreguntaSector.subSector ng-options=\"item as item.descripcion for item in vm.listaSubSector track by item.codigoRegistro\"><option ng-value=0>Todos</option></select></div><div class=\"form-group col-md-3\"><label for=tipoPersona>Actividad:</label><select class=\"form-control input-sm\" ng-model=vm.dataPreguntaSector.actividad ng-options=\"item as item.descripcion for item in vm.listaActividad track by item.codigoRegistro\"><option ng-value=0>Todos</option></select></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.registrarPreguntaSector() ng-disabled=vm.formUsuario.$invalid type=button><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar sector</button> <a class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.limpiarSector()><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</a></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Sector</th><th class=text-center>Subsector</th><th class=text-center>Actividad</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemPreguntaSector in vm.listaPreguntaSector | itemsPerPage: config.itemsPerPage\" pagination-id=coutPreguntaSector><td class=text-center data-label=Sector>{{itemPreguntaSector.sector.descripcion}}</td><td class=text-center data-label=Subsector>{{itemPreguntaSector.subSector.descripcion}}</td><td class=text-center data-label=Actividad>{{itemPreguntaSector.actividad.descripcion}}</td><td class=\"text-center td-tabla-01\" data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminarPreguntaSector(itemPreguntaSector) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"vm.listaPreguntaSector==null || vm.listaPreguntaSector.length==0\"><td colspan=4>No se encontraron resultados.</td></tr></tbody></table><dir-pagination-controls pagination-id=coutPreguntaSector></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=Norma index=3 ng-if=\"vm.dataPregunta.idPregunta!=0\"><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.mostrarAgregarNormativaDialog() type=button><span class=icon-buscar></span> Buscar norma</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Dispositivo</th><th class=text-center>Artículo</th><th class=text-center>Descripción artículo</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemPreguntaNormativa in vm.listaNormativasPregunta | itemsPerPage: config.itemsPerPage\" pagination-id=coutPreguntaNormativa><td class=text-center data-label=Dispositivo>{{itemPreguntaNormativa.contenidoNorma.dispositivo}}</td><td class=text-center data-label=Artículo>{{itemPreguntaNormativa.contenidoNorma.numeroArticulo}}</td><td class=text-center data-label=\"Descripción Artículo\">{{itemPreguntaNormativa.contenidoNorma.descripcionArticulo}}</td><td class=\"text-center td-tabla-01\" data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminarPreguntaNormativa(itemPreguntaNormativa) type=button uib-tooltip=\"Eliminar Artículo\"><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-if=\"vm.listaNormativasPregunta==null || vm.listaNormativasPregunta.length==0\"><td colspan=4>No se encontraron resultados.</td></tr></tbody></table><dir-pagination-controls pagination-id=coutPreguntaNormativa></dir-pagination-controls></div></div></div></uib-tab></uib-tabset><!--\r\n		<div class=\"row\" ng-show=\"vm.dataPregunta.tipoPregunta.codigoRegistro==3 || vm.dataPregunta.tipoPregunta.codigoRegistro==4  || vm.dataPregunta.tipoPregunta.codigoRegistro==6 \">\r\n			\r\n		\r\n		<div class=\"form-group col-md-4\">\r\n				<label for=\"razonSocial\">Valor Correcto:</label>\r\n				<div class=\"form-group\">\r\n					<input ng-model=\"vm.dataEntidad.razonSocial\" type=\"text\" class=\"form-control input-sm\" name=\"razonSocial\" >\r\n				</div>\r\n			</div>		\r\n\r\n				<div class=\"form-group col-md-4\">\r\n				<label for=\"razonSocial\">Archivo:</label>\r\n				<div class=\"form-group\">\r\n					<input ng-model=\"vm.dataEntidad.razonSocial\" type=\"file\" class=\"form-control input-sm\" name=\"razonSocial\" >\r\n				</div>\r\n			</div>	\r\n		\r\n	\r\n			\r\n		</div>\r\n\r\n--></span></div>");
$templateCache.put("app/modules/supervision/administrado/autosupervision/cuestionario-administrado.html","<div class=modal-header name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>{{vm.dataCuestionarioAutosupervision.nombreCuestionario}}</span></h3></div></div><br><!--        <uib-tabset active=\"active\"> --><!--            <uib-tab index=\"0\" heading=\"Presentacion\"> --><br><uib-accordion close-others=oneAtATime><!--  A  --><div class=panel-default id=instrumentoGestionAmbiental is-open=\"vm.dataValidacion[$index]==1\" ng-if=\"vm.dataValidacion[$index]==1\" ng-repeat=\"itemPregunta in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle | orderBy:itemPregunta.idCuestionarioDetalle\" uib-accordion-group=\"\"><uib-accordion-heading>{{$index+1}} {{itemPregunta.pregunta.descripcion}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': vm.dataValidacion.opcion1==1, \'glyphicon-chevron-right\': vm.dataValidacion.opcion1==0}\"></i></uib-accordion-heading><div class=row ng-if=\"itemPregunta.pregunta.tipoPregunta.codigoRegistro==1\"><div class=\"form-group col-md-8\"><label for=cargo>Respuesta pregunta:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=texto-espacio name=cargo ng-model=itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta maxlength=200 type=text></div></div></div><div class=row ng-if=\"itemPregunta.pregunta.tipoPregunta.codigoRegistro==2\"><div class=\"form-group col-md-8\"><label for=cargo>Respuesta pregunta:</label><div class=form-group><input class=\"form-control input-sm\" input-restrict=numero name=cargo ng-model=itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta maxlength=200 type=text></div></div></div><div id=preguntaSeleccion ng-if=\"itemPregunta.pregunta.tipoPregunta.codigoRegistro==3\"><div class=row><div class=\"form-group col-md-3\"><label for=tipoOpcion>Opción:</label><select class=\"form-control input-sm\" id=tipoOpcion name=tipoOpcion ng-init=\"(itemPregunta.pregunta.lstRespuestaPregunta.length > 0) ? itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta : itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta=0\" ng-model=itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in itemPregunta.pregunta.lstOpcionPregunta\" ng-value=\"itemCombo.idOpcionPregunta*1+\'\'\">{{itemCombo.valor}}</option></select></div></div></div><div id=preguntaSiNo ng-if=\"itemPregunta.pregunta.tipoPregunta.codigoRegistro==6\"><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Opción:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-init=\"itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta=0\" ng-model=itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in itemPregunta.pregunta.lstOpcionPregunta\" ng-value=\"itemCombo.idOpcionPregunta | number\">{{itemCombo.valor}}</option></select></div></div></div><div id=preguntaTabla ng-if=\"itemPregunta.pregunta.tipoPregunta.codigoRegistro==5\"><div class=row><div class=\"form-group col-md-10\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><tbody><tr dir-paginate=\"itemFila in itemPregunta.pregunta.lstOpcionPregunta | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center ng-repeat=\"itemColumna in itemFila.lstOpcionPreguntaColumna\"><input class=\"form-control input-sm\" disabled name=numerosFila ng-if=\"itemColumna.posicionFila==0 || itemColumna.posicionColumna==0\" ng-model=itemColumna.valor placeholder=\"Ingrese valor\" type=text> <input class=\"form-control input-sm\" name=numerosFila ng-if=\"itemColumna.posicionFila!=0 && itemColumna.posicionColumna!=0\" ng-model=itemColumna.valor type=text></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></div><div id=preguntaSeleccion ng-if=\"itemPregunta.pregunta.tipoPregunta.codigoRegistro==4\"><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona>Opción:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-init=\"vm.dataOpcionPreguntaObj.opcionPregunta.idOpcionPregunta=0\" ng-model=vm.dataOpcionPreguntaObj.opcionPregunta.idOpcionPregunta><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in itemPregunta.pregunta.lstOpcionPregunta\" ng-value=itemCombo.idOpcionPregunta*1>{{itemCombo.valor}}</option></select></div><div class=\"form-group col-md-3\"><br><button class=\"btn btn-flat btn-primary btn-sm btn-sm\" ng-click=vm.agregarDatosPreguntaSeleccionMultiple(itemPregunta.pregunta.lstOpcionPregunta,$index) type=button><span class=\"glyphicon glyphicon-plus-sign\"></span> Añadir</button></div></div><div class=row><div class=\"form-group col-md-6\"><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Opción</th><th class=\"text-center td-tabla-01\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemRespuesta in itemPregunta.pregunta.lstRespuestaPregunta | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Ítem>{{$index+1}}</td><td class=text-center data-label=Opción>{{itemRespuesta.opcionPregunta.valor}}</td><td class=\"text-center td-tabla-01\" data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarRespuestaSeleccionMultiple($index,itemPregunta) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></div></div></div><div id=archivo ng-if=\"(itemPregunta.pregunta.tipoPregunta.codigoRegistro==3 || itemPregunta.pregunta.tipoPregunta.codigoRegistro==4 || itemPregunta.pregunta.tipoPregunta.codigoRegistro==6) && itemPregunta.pregunta.flagArchivo==1\"><div class=row><div class=\"form-group col-md-5\"><h4>Subir archivos</h4></div></div><!-- --><div class=row><div class=\"form-group col-md-6\"><label for=idProducto>Descripción del archivo</label><div class=form-group><textarea class=\"form-control input-sm\" maxlength=100 ng-model=vm.dataArchivo.descripcion>\r\n                                </textarea></div></div><div class=\"form-group col-md-3\"><br><div class=form-group><div class=\"form-group col-lg-12 text-left\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.registrarArchivoCuestionarioDetalle(itemPregunta) ng-disabled=!vm.dataArchivo.descripcion uib-tooltip=\"Agregar archivo\"><span class=icon-agregar></span> Agregar archivo</button></div></div></div></div><div class=row><div class=\"form-group col-md-5\"><label class=important-box for=idUsuario>Archivo adjunto (100mb)</label><div class=form-group><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivoPreguntaInstalacion ng-click=vm.validaArchivos($index) type=file><div class=help-block>Archivos permitidos: {{vm.extension}}<br>Tamaño máximo: {{vm.tamanioArchivo}} MB<br></div></div></div></div><div class=row><div class=col-md-12><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered table-striped table-app\" id=listaBandeja width=100%><thead><tr><th class=text-center>Ítem</th><th class=text-center>Descripción archivo</th><th class=text-center>Nombre archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr dir-paginate=\"itemArchivo in vm.listaArchivosRespuesta | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Ítem>{{$index+1}}</td><td data-label=\"Descripción archivo\">{{itemArchivo.descripcion}}</td><td data-label=\"Nombre archivo\">{{itemArchivo.nombreArchivo}}</td><td class=text-center data-label=Acción><a class=\"btn btn-default btn-sm\" download={{itemArchivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{itemArchivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span> </a><!--                                                <a class=\"btn btn-flat btn-primary btn-sm\" href=\"{{itemArchivo.ruta}}\" download=\"{{itemArchivo.nombreArchivo}}\"> --><!--                                                    <span class=\"glyphicon glyphicon-download-alt\"></span>  --><!--                                                </a> --> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminarArchivo(itemArchivo,itemPregunta) ng-if=\"itemBandeja.estadoBandejaDetalle!=10\" type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><tr ng-show=\"vm.listaArchivosRespuesta  == null || vm.listaArchivosRespuesta==0\"><td colspan=6>No se encontraron resultados</td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><!-- --></div><div class=row><div class=\"form-group col-md-12 input-sm\" ng-if=\"itemPregunta.pregunta.lstPreguntaNormativa.length > 0\">Base legal: <span ng-repeat=\"itemNormativa in itemPregunta.pregunta.lstPreguntaNormativa\">Reglamento de la {{itemNormativa.contenidoNorma.dispositivo}}, artículo Nº {{itemNormativa.contenidoNorma.numeroArticulo}} .- {{itemNormativa.contenidoNorma.descripcionArticulo}}</span></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.verCuestionario() ng-disabled=\"(itemPregunta.pregunta.tipoPregunta.codigoRegistro==1 && !itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta) || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==2 && !itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta) ||(itemPregunta.pregunta.tipoPregunta.codigoRegistro==3 && itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta==0) || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==6 && itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta==0) || ( itemPregunta.pregunta.tipoPregunta.codigoRegistro==4 && itemPregunta.pregunta.lstRespuestaPregunta.length==0) \r\n\r\n                                        || ( itemPregunta.pregunta.tipoPregunta.codigoRegistro==5 && vm.validaDatosPreguntaTabla(itemPregunta.pregunta.lstOpcionPregunta)==0) \r\n\r\n                                        || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==3 && vm.listaArchivosRespuesta.length==0 && itemPregunta.pregunta.flagArchivo==1) \r\n                                        || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==4 && vm.listaArchivosRespuesta.length==0 && itemPregunta.pregunta.flagArchivo==1) \r\n                                        || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==6 && vm.listaArchivosRespuesta.length==0 && itemPregunta.pregunta.flagArchivo==1)    \r\n                                        \" ng-show=\"{{$index}}==(vm.dataValidacion.length-1)\" type=button><span class=glyphicon></span> ver cuestionario</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=\"vm.atras($index - 1 );\" ng-show=\"{{$index}}!=0\" type=button><span class=icon-regresar></span> Atras</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=\"vm.siguiente($index + 1 );\" ng-disabled=\"(itemPregunta.pregunta.tipoPregunta.codigoRegistro==1 && !itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta) || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==2 && !itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta) ||(itemPregunta.pregunta.tipoPregunta.codigoRegistro==3 && itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta==0) || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==6 && itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta==0) || ( itemPregunta.pregunta.tipoPregunta.codigoRegistro==4 && itemPregunta.pregunta.lstRespuestaPregunta.length==0) \r\n\r\n                                        || ( itemPregunta.pregunta.tipoPregunta.codigoRegistro==5 && vm.validaDatosPreguntaTabla(itemPregunta.pregunta.lstOpcionPregunta)==0) \r\n\r\n                                        || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==3 && vm.listaArchivosRespuesta.length==0 && itemPregunta.pregunta.flagArchivo==1) \r\n                                        || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==4 && vm.listaArchivosRespuesta.length==0 && itemPregunta.pregunta.flagArchivo==1) \r\n                                        || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==6 && vm.listaArchivosRespuesta.length==0 && itemPregunta.pregunta.flagArchivo==1)    \r\n                                        \" ng-show=\"{{$index}}!=(vm.dataValidacion.length-1);\" type=button>Siguiente <span class=icon-siguiente></span></button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.terminarCuestionario() ng-disabled=\"(itemPregunta.pregunta.tipoPregunta.codigoRegistro==1 && !itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta) || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==2 && !itemPregunta.pregunta.lstRespuestaPregunta[0].descripcionRespuesta) ||(itemPregunta.pregunta.tipoPregunta.codigoRegistro==3 && itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta==0) || (itemPregunta.pregunta.tipoPregunta.codigoRegistro==6 && itemPregunta.pregunta.lstRespuestaPregunta[0].opcionPregunta.idOpcionPregunta==0) || ( itemPregunta.pregunta.tipoPregunta.codigoRegistro==4 && itemPregunta.pregunta.lstRespuestaPregunta.length==0) || ( itemPregunta.pregunta.tipoPregunta.codigoRegistro==5 && vm.validaDatosPreguntaTabla(itemPregunta.pregunta.lstOpcionPregunta)==0) || vm.flagCuestionario==0\" ng-show=\"{{$index}}==(vm.dataValidacion.length-1)\" type=button><span class=glyphicon></span> Terminar</button></div></div></div><!-- Fin A --></uib-accordion><!--            </uib-tab> --><!--     </uib-tabset> --></span></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/administrado/cuestionarios-autosupervision/cuestionarios-instalacion.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>AutoSupervisión</span></h3></div></div><br><!-- 		<uib-tabset active=\"active\"> --><!-- 			<uib-tab index=\"0\" heading=\"Presentacion\"> --><div class=row ng-if=\"vm.flagActivoCuestionario==0\"><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Cuestionario</th><th class=text-center>Fecha registro</th><th class=text-center>Ver información</th><!--<th class=\"text-center td-tabla-01\" >Accion</th>--></tr></thead><tbody><tr dir-paginate=\"item in vm.listaCuestionariosAutoSupervision | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Ítem>{{$index+1}}</td><td class=text-center data-label=Cuestionario>{{item.nombreCuestionario}}</td><td class=text-center data-label=\"Fecha registro\">{{item.fechaRegistro}}</td><td class=\"text-center td-tabla-01\" data-label=\"Ver información\"><button class=\"btn btn-default btn-sm\" ng-click=vm.visualizarPDF(item) type=button uib-tooltip=\"Ver cuestionario\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.irCuestionario(item) type=button uib-tooltip=\"Ver archivos cuestionario\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td><!--\r\n								<td class=\"text-center td-tabla-01\">\r\n												<button type=\"button\" class=\"btn btn-default btn-sm\" uib-tooltip=\"Editar Pregunta\" ng-click=\"vm.irCuestionario(item)\" >\r\n				                                	<span class=\"glyphicon glyphicon-eye-open\"></span>\r\n				                            	</button>\r\n\r\n				                            \r\n\r\n								</td>\r\n--></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><br><div class=row ng-if=\"vm.flagActivoCuestionario==1\"><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><th><center><h4><b>Archivos {{vm.dataCuestionarioAutosupervision.nombreCuestionario}}</b></h4></center></th></thead><tbody dir-paginate=\"itemPregunta in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle | itemsPerPage: config.itemsPerPage\" pagination-id=cout><tr ng-if=\"itemPregunta.pregunta.flagArchivo==1\"><td data-label=Archivos>{{$index+1}}	{{itemPregunta.pregunta.descripcion}} {{itemPregunta.pregunta.tipoPregunta.flagArchivo}}</td></tr><tr ng-if=\"itemPregunta.pregunta.flagArchivo==1\"><td class=text-center><!-- ***************************************************************************************************************** --><div class=row><div class=col-md-12><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered table-striped table-app\" id=listaBandeja width=100%><thead><tr><th class=text-center>Ítem</th><th class=text-center>Descripción archivo</th><th class=text-center>Nombre archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr dir-paginate=\"itemArchivo in itemPregunta.lstArchivo | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Ítem>{{$index+1}}</td><td data-label=\"Descripción Archivo\">{{itemArchivo.descripcion}}</td><td data-label=\"Nombre archivo\">{{itemArchivo.nombreArchivo}}</td><td class=text-center data-label=Acción><a class=\"btn btn-default btn-sm\" download={{itemArchivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{itemArchivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span> </a><!-- 										                <a class=\"btn btn-flat btn-primary btn-sm\" href=\"{{itemArchivo.ruta}}\" download=\"{{itemArchivo.nombreArchivo}}\"> --><!-- 											                <span class=\"glyphicon glyphicon-download-alt\"></span>  --><!-- 											            </a> --></td></tr><tr ng-show=\"itemPregunta.lstArchivo  == null || itemPregunta.lstArchivo.length==0\"><td colspan=6>No se encontraron resultados</td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><!-- ********************************************************* --></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button><!--\r\n                 <button class=\"btn btn-flat btn-default btn-sm\" ng-if=\"vm.flagActivoCuestionario==1\" ng-click=\"vm.cancelar()\" type=\"button\">\r\n                    <span class=\"glyphicon glyphicon-remove spac-btn-r\">\r\n                    </span>\r\n                    Cancelar\r\n                </button>   \r\n                --></div></div><!-- 			</uib-tab> --><!-- 	 </uib-tabset> --></span></div>");
$templateCache.put("app/modules/supervision/administrado/dialog-cancelacion/cancelacion-instalacion-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Cancelación de instalación</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><strong><p>Unidad fiscalizable</p></strong></div><div class=\"form-group col-md-8\"><p>{{ vm.dataInstalacion.numeroInstalacion}}</p></div></div><br><span class=content-box><div class=row><div class=\"form-group col-md-12\"><label>Motivo cancelación:</label></div></div><div class=row><div class=\"form-group col-md-6\"><textarea maxlength=100 class=\"form-control input-sm\" rows=4 ng-model=vm.dataSolicitud.motivoCancelacionInstalacion>\r\n                                </textarea></div><div class=\"input-group col-md-6\"><div class=form-group><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivoCancelacionInstalacion type=file><div class=help-block>Archivos permitidos: {{vm.extension}}<br>Tamaño máximo: {{vm.tamanioArchivo}} MB<br></div><!--  <input class=\"btn btn-flat btn-primary btn-sm\" type=\"file\" file-model=\"vm.fileModelDocumento\" ng-click=\"vm.validaDocumento()\"> --></div></div></div></span><br></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.registrarSolicitudArchivo() type=button><span class=\"fa fa-save spac-btn-r\"></span> Guardar</button> <button class=\"btn btn-primary btn-sm btn-pd-5\" ng-click=closeThisDialog(0)><i aria-hidden=true></i> Cerrar</button></div></div><br></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/administrado/selector/administrado-selector.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector de Administrados</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><label>Razón social</label><input class=form-control type=text ng-model=vm.objAdministrado.entidad.razonSocial></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">RUC</th><th style=\"text-align: center\">Razón Social</th><th style=\"text-align: center\">Seleccione</th></tr></thead><tbody><tr ng-show=\"vm.listaAdministrado.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.listaAdministrado | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=RUC style=\"text-align: center\">{{item.entidad.ruc}}</td><td data-label=\"Razón social\" style=\"text-align: center\">{{item.entidad.razonSocial}}</td><td class=text-center data-label=Acciones><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.cargarSeleccion(item) type=button><span class=icon-check></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/administrado/accion-administrado/accion-administrado-informe.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Instrumentos de Gestión Ambiental</span></h3></div></div><br><div ng-show=\"vm.mostrarPresentacion==false\"><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Unidad Fiscalizable:</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto>Estación de Servicios</label></div></div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Dirección:</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto>Av. La Marina 1225</label></div></div></div><div class=row ng-show=\"vm.mostrarPresentacion==false\"><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Código</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Año</th><th class=text-center>Seleccione</th></tr></thead><tbody><tr pagination-id=cout><td data-label=Item>1</td><td data-label=Código>DIA-0001253</td><td data-label=Resolución>R.D. N° 077-2011-MEM/DGAAE</td><td data-label=\"\">2010</td><td align=center data-label=Acción><input type=checkbox></td></tr><tr pagination-id=cout style=\"background-color: rgb(212, 249, 155)\"><td data-label=Item>1.1</td><td data-label=Código>ITS-0001253</td><td data-label=Resolución>R.D. N° 077-2014-MEM/DGAAE</td><td data-label=\"\">2014</td><td align=center data-label=Acción><input type=checkbox></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=text-right><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.mostrarCampos(2) type=button uib-tooltip=\"Informe de Monitoreo\"><span class=\"glyphicon glyphicon-arrow-right spac-btn-r\">Siguiente</span></button></div></div><uib-accordion close-others=oneAtATime ng-show=\"vm.mostrarPresentacion==true\"><!--  A  --><div class=panel-default id=as is-open=status.open uib-accordion-group=\"\" ng-show=false><uib-accordion-heading>Declaración de la Información a Remitir <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open, \'glyphicon-chevron-right\': !status.open}\"></i></uib-accordion-heading><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true\"><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Datos del IGA</h5></div></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true\"><div class=\"form-group col-md-3\"><label for=cargo>Código:</label><input class=\"form-control input-sm\" ng-disabled=true type=text value=DIA-0001253></div><div class=\"form-group col-md-3\"><label for=cargo>Resolución de Aprobación:</label><input class=\"form-control input-sm\" ng-disabled=true type=text value=\"R.D. NÂ° 077-2011-MEM/DGAAE\"></div><div class=\"form-group col-md-3\"><label for=cargo>Fecha de Aprobación:</label><input class=\"form-control input-sm\" ng-disabled=true value=01/08/2011 type=text></div></div><br><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true && vm.active>0\"><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Datos Seleccionados</h5></div></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true && vm.active>0\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Etapa del Proyecto:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Operación</label></div></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true && vm.active>0\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Componente:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Calidad de Agua</label></div><!-- <div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\" style=\"font-weight: bold;\"> Matriz: </label>\r\n				</div>\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\"> Agua Natural</label>\r\n				</div>\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\" style=\"font-weight: bold;\"> Sub Matriz</label>\r\n				</div>\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\">Agua SubterrÃ¡nea</label>\r\n				</div> --></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true && vm.active>2\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Periodo:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Mensual</label></div></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true && vm.active>3\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Punto:</label></div><div class=\"form-group col-md-2\"><label for=cargo>1</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Zona:</label></div><div class=\"form-group col-md-2\"><label for=cargo>17</label></div></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true && vm.active>3\"><div class=\"form-group col-md-4\"><label for=cargo style=\"font-weight: bold\">Coordenadas UTM (Datum WGS84):</label></div><div class=\"form-group col-md-2\"><label for=cargo>Norte: 8653719</label></div><div class=\"form-group col-md-2\"><label for=cargo>Este: 287128</label></div></div><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true\"><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Datos de la Declaración de la Información a Remitir</h5></div></div><uib-tabset active=vm.active ng-show=\"vm.mostrarProgramaMonitoreo==true\"><uib-tab heading=\"Componentes / Frecuencia\" index=0><div class=row><div class=\"form-group col-md-3\"><br><label for=cargo>Etapa del proyecto:</label><select class=\"form-control input-sm\"><option ng-value=0>Seleccione</option><option>Abandono</option><option>Operación</option><option>Construcción</option></select></div><div class=\"form-group col-md-3\"><br><label for=cargo>Componente Ambiental:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento><option ng-value=0>Seleccione</option><option ng-value=1>Calidad de Agua</option><option ng-value=2>Calidad de Suelo</option><option ng-value=3>Calidad Componente Atmosf&eacute;ricoo</option><option ng-value=4>Biol&oacute;gica</option></select></div><div class=\"form-group col-md-3\"><br><label for=cargo>Frecuencia:</label><select class=\"form-control input-sm\"><option ng-value=0>Seleccione</option><option ng-value=1>Mensual</option><option ng-value=2>Bimestral</option><option ng-value=3>Trimestral</option><option ng-value=4>Semestral</option><option ng-value=5>Anual</option></select></div><div class=row><div class=\"form-group col-lg-12 text-right\"><br><button class=\"btn btn-flat btn-primary btn-sm\" type=button><span class=icon-agregar>Añadir</span></button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Componente</th><th class=text-center>Frecuencia</th><th class=text-center>Acción</th><th class=text-center>Seleccione</th></tr></thead><tbody><tr pagination-id=cout><td data-label=Código>Calidad de Agua</td><td data-label=text-center>Trimestral</td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" type=button uib-tooltip=Eliminar><span class=icon-trash></span></button></td><td align=center data-label=Seleccione><input class=\"cmn-toggle cmn-toggle-round\" type=checkbox></td></tr></tbody></table></div></div></div></div><!-- <div class=\"row\">\r\n				\r\n                <div class=\"form-group col-lg-12 text-right\">\r\n                    <br />\r\n                    <button class=\"btn btn-flat btn-primary btn-sm\"\r\n                        ng-click=\"vm.nuevaEtapa()\" type=\"button\">\r\n                        <span class=\"icon-agregar\"> Agregar Etapa de Proyecto \r\n                    </button>\r\n                </div>\r\n            </div>\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-md-12\">\r\n                    <div class=\"table-rpv\">\r\n                        <table bgcolor=\"#d0c9c9\"\r\n                            class=\"table table-hover table-bordered table-striped table-app tabla-config\">\r\n                            <thead>\r\n                                <tr>\r\n                                   <th class=\"text-center\">Código</th> \r\n                                    <th class=\"text-center\">Nombre</th>\r\n                                    <th class=\"text-center\">Acción</th>\r\n                                    <th class=\"text-center\">Seleccione</th>\r\n                                </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                                <tr pagination-id=\"cout\">\r\n                                   <td data-label=\"Código\">O</td>\r\n                                    <td data-label=\"text-center\">Operación</td>\r\n                                    <td align=\"center\" data-label=\"Acción\"><button\r\n                                            class=\"btn btn-default btn-sm\" type=\"button\"\r\n                                            uib-tooltip=\"Eliminar\">\r\n                                            <span class=\"icon-trash\"> </span>\r\n                                        </button></td>\r\n                                    <td align=\"center\" data-label=\"Seleccione\"><input\r\n                                        class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" /></td>\r\n                                </tr>\r\n                            </tbody>\r\n                        </table>\r\n                    </div>\r\n                </div> \r\n            </div>--></uib-tab><!--   <uib-tab  heading=\"Componentes Ambientales\"\r\n				index=\"1\"> </br>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-lg-12 text-right\">\r\n					<button class=\"btn btn-flat btn-primary btn-sm\"\r\n						ng-click=\"vm.nuevoComponenteAmbiental()\" type=\"button\">\r\n						<span class=\"icon-agregar\"> Agregar Componente Ambiental \r\n					</button>\r\n				</div>\r\n			</div>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-md-12\">\r\n					<div class=\"table-rpv\">\r\n						<table bgcolor=\"#d0c9c9\"\r\n							class=\"table table-hover table-bordered table-striped table-app tabla-config\">\r\n							<thead>\r\n								<tr>\r\n									<th class=\"text-center\">Código</th>\r\n									<th class=\"text-center\">Nombre</th>\r\n									<th class=\"text-center\">Matriz</th>\r\n									<th class=\"text-center\">Sub Matiz</th>\r\n									<th class=\"text-center\">Acción</th>\r\n									<th class=\"text-center\">Seleccione</th>\r\n								</tr>\r\n							</thead>\r\n							<tbody>\r\n								<tr pagination-id=\"cout\">\r\n									<td data-label=\"Código\">CA</td>\r\n									<td data-label=\"text-center\">Calidad de Agua</td>\r\n									<td data-label=\"text-center\">Agua Natural</td>\r\n									<td data-label=\"text-center\">Agua SubterrÃ¡nea</td>\r\n									<td align=\"center\" data-label=\"Acción\"><button\r\n											class=\"btn btn-default btn-sm\" type=\"button\"\r\n											uib-tooltip=\"Eliminar\">\r\n											<span class=\"icon-trash\"> </span>\r\n										</button></td>\r\n									<td align=\"center\" data-label=\"Seleccione\"><input\r\n										class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" /></td>\r\n								</tr>\r\n							</tbody>\r\n						</table>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n			</uib-tab> <uib-tab heading=\"Frecuencia de Presentación\" index=\"2\"> </br>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-lg-3\">\r\n					<label for=\"cargo\"> Periodo </label> <select\r\n						class=\"form-control input-sm\" id=\"tipoDocumento\"\r\n						name=\"tipoDocumento\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-value=\"1\">Mensual</option>\r\n						<option ng-value=\"2\">Bimestral</option>\r\n						<option ng-value=\"3\">Trimestral</option>\r\n						<option ng-value=\"4\">Semestral</option>\r\n						<option ng-value=\"5\">Anual</option>\r\n					</select>\r\n\r\n				</div>\r\n				<div class=\"form-group col-lg-3 text-right\">\r\n\r\n\r\n					<button class=\"btn btn-flat btn-primary btn-sm\" type=\"button\">\r\n						<span class=\"icon-agregar\"> Agregar Frecuencia \r\n					</button>\r\n				</div>\r\n			</div>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-md-12\">\r\n					<div class=\"table-rpv\">\r\n						<table bgcolor=\"#d0c9c9\"\r\n							class=\"table table-hover table-bordered table-striped table-app tabla-config\">\r\n							<thead>\r\n								<tr>\r\n									<th class=\"text-center\">Periodo</th>\r\n									<th class=\"text-center\">Acción</th>\r\n									<th class=\"text-center\">Seleccione</th>\r\n								</tr>\r\n							</thead>\r\n							<tbody>\r\n								<tr pagination-id=\"cout\">\r\n									<td data-label=\"Código\">Mensual</td>\r\n									<td align=\"center\" data-label=\"Acción\"><button\r\n											class=\"btn btn-default btn-sm\" type=\"button\"\r\n											uib-tooltip=\"Eliminar\">\r\n											<span class=\"icon-trash\"> </span>\r\n										</button></td>\r\n									<td align=\"center\" data-label=\"Seleccione\"><input\r\n										class=\"cmn-toggle cmn-toggle-round\" type=\"checkbox\" /></td>\r\n								</tr>\r\n							</tbody>\r\n						</table>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n			</uib-tab> --><uib-tab heading=\"Puntos de Monitoreo / Parámetros\" index=1><br><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.nuevoPuntoMonitoreo() type=button><span class=icon-agregar>Agregar Punto de Monitoreo</span></button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>NÂ°</th><!-- <th class=\"text-center\">Código</th> --><th class=text-center>Zona</th><th class=text-center>Coordenadas UTM (Datum WGS84)</th><th class=text-center>Breve Descripción</th><th class=text-center>Acción</th><th class=text-center>Parámetros</th></tr></thead><tbody><tr pagination-id=cout><td data-label=Código>1</td><!-- <td data-label=\"Código\"></td> --><td data-label=Código>17</td><td data-label=Código>Norte:8653719 - Este: 287128</td><td data-label=Código>A la entrada del grifo</td><td data-label=Acción align=center><button class=\"btn btn-default btn-sm\" type=button uib-tooltip=Eliminar><span class=icon-trash></span></button></td><td data-label=Seleccione align=center><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.nuevoParametroAmbiental() type=button><span class=icon-agregar></span></button></td></tr></tbody></table></div></div></div></uib-tab><!--  <uib-tab heading=\"ParÃ¡metros\" index=\"4\"> </br>\r\n\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-lg-12 text-right\">\r\n\r\n					<button class=\"btn btn-flat btn-primary btn-sm\"\r\n						ng-click=\"vm.nuevoParametroAmbiental()\" type=\"button\">\r\n						<span class=\"icon-agregar\"> Agregar ParÃ¡metro \r\n					</button>\r\n				</div>\r\n			</div>\r\n\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-md-12\">\r\n					<div class=\"table-rpv\">\r\n						<table bgcolor=\"#d0c9c9\"\r\n							class=\"table table-hover table-bordered table-striped table-app tabla-config\">\r\n							<thead>\r\n								<tr>\r\n									<th class=\"text-center\">Código</th>\r\n									<th class=\"text-center\">Nombre</th>\r\n									<th class=\"text-center\">Frecuencia</th>\r\n									<th class=\"text-center\">Unidad</th>\r\n									<th class=\"text-center\">Estandard</th>\r\n									<th class=\"text-center\">Acción</th>\r\n								</tr>\r\n							</thead>\r\n							<tbody>\r\n								<tr>\r\n									<td class=\"text-center\">PAR00001</td>\r\n									<td class=\"text-center\">Fracción de Hidrocarburos</td>\r\n									<td class=\"text-center\">24 horas</td>\r\n									<td class=\"text-center\">mg/Kg</td>\r\n									<td class=\"text-center\">500</td>\r\n									<td align=\"center\"><button class=\"btn btn-default btn-sm\"\r\n											type=\"button\" uib-tooltip=\"Eliminar\">\r\n											<span class=\"icon-trash\"> </span>\r\n										</button></td>\r\n								</tr>\r\n							</tbody>\r\n						</table>\r\n					</div>\r\n				</div>\r\n			</div>\r\n\r\n			</uib-tab> --></uib-tabset><br><div class=row ng-show=\"vm.mostrarProgramaMonitoreo==true\"><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-show=\"vm.active>0\" ng-click=vm.grabarProgramaMonitoreo() type=button><span class=\"fa fa-save\"></span> Finalizar</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-show=\"vm.active<1\" ng-click=vm.siguienteProgramMonitoreoAmbiental(vm.active) type=button><span class=\"glyphicon glyphicon-arrow-right spac-btn-r\"></span> Siguiente</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.atrasProgramMonitoreoAmbiental(vm.active) type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div><!-- Fin A --><!--  b  --><div class=panel-default id=instrumentoGestionAmbiental is-open=true uib-accordion-group=\"\" ng-show=\"vm.mostrarInformeMonitoreo==true\"><uib-accordion-heading>Informe de monitoreo ambiental. <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open1, \'glyphicon-chevron-right\': !status.open1}\"></i></uib-accordion-heading><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true\"><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Datos del IGA</h5></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true\"><div class=\"form-group col-md-3\"><label for=cargo>Código:</label><input class=\"form-control input-sm\" ng-disabled=true type=text value=DIA-0001253></div><div class=\"form-group col-md-3\"><label for=cargo>Resolución de Aprobación:</label><input class=\"form-control input-sm\" ng-disabled=true type=text value=\"R.D. NÂ° 077-2011-MEM/DGAAE\"></div><div class=\"form-group col-md-3\"><label for=cargo>Fecha de Aprobación:</label><input class=\"form-control input-sm\" ng-disabled=true value=01/08/2011 type=text></div></div><br><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true && vm.active2>0\"><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Datos Seleccionados</h5></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true && vm.active2>0\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Etapa del Proyecto:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Operación</label></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true && vm.active2>0\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Componente:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Calidad de Agua</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Matriz:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Agua Natural</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Sub Matriz</label></div><div class=\"form-group col-md-2\"><label for=cargo>Agua SubterrÃ¡nea</label></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true && vm.active2>2\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Periodo:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Mensual</label></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true && vm.active2>3\"><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Punto:</label></div><div class=\"form-group col-md-2\"><label for=cargo>1</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Zona:</label></div><div class=\"form-group col-md-2\"><label for=cargo>17</label></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true && vm.active2>3\"><div class=\"form-group col-md-4\"><label for=cargo style=\"font-weight: bold\">Coordenadas UTM (Datum WGS84):</label></div><div class=\"form-group col-md-2\"><label for=cargo>Norte: 8653719</label></div><div class=\"form-group col-md-2\"><label for=cargo>Este: 287128</label></div></div><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true\"><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Datos del Informe de Monitoreo</h5></div></div><uib-tabset active=vm.active2 ng-show=\"vm.mostrarInformeMonitoreo==true\"><uib-tab heading=Componentes index=0><div class=row><div class=\"form-group col-md-3\"><br><label for=cargo>Etapa del proyecto:</label><select class=\"form-control input-sm\"><option ng-value=0>Seleccione</option><option>Abandono</option><option>Operación</option><option>Construcción</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><br><label for=cargo>Componente Ambiental:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento><option ng-value=0>Seleccione</option><option ng-value=1>Calidad de Agua</option><option ng-value=2>Calidad de Suelo</option><option ng-value=3>Calidad Componente Atmosf&eacute;ricoo</option><option ng-value=4>Biol&oacute;gica</option></select></div><div class=\"form-group col-md-3\"><br><label for=cargo>Matriz</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento><option ng-value=0>Seleccione</option><option ng-value=1>Agua Natural</option><option ng-value=2>Agua Residual</option><option ng-value=3>Agua para Uso y consumo humano</option><option ng-value=4>Agua Salina</option><option ng-value=5>Agua de Proceso</option><option ng-value=6>Sustancia Desconocida</option></select></div><div class=\"form-group col-md-3\"><br><label for=cargo>Sub Matriz</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento><option ng-value=0>Seleccione</option><option ng-value=1>Agua Subterránea</option><option ng-value=2>Agua de Manantial</option><option ng-value=3>Agua Termal</option><option ng-value=4>Agua Superficial</option></select></div></div></uib-tab><!-- 1ro fin --><!-- 2do--><!-- <uib-tab\r\n				heading=\"Componentes Ambientales\" index=\"1\">\r\n\r\n			<div class=\"row\">\r\n				<br>\r\n				<div class=\"form-group col-md-3\">\r\n					<label for=\"cargo\"> Componente </label> <select\r\n						class=\"form-control input-sm\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option>Calidad de Agua</option>\r\n					</select>\r\n				</div>\r\n\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\"> Matriz </label> <select\r\n						class=\"form-control input-sm\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option>Agua Natural</option>\r\n					</select>\r\n				</div>\r\n\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\"> Sub Matriz </label> <select\r\n						class=\"form-control input-sm\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option>Agua subterranea</option>\r\n					</select>\r\n				</div>\r\n\r\n				<div class=\"form-group col-lg-5 text-right\">\r\n					<button class=\"btn btn-flat btn-primary btn-sm\"\r\n						ng-click=\"vm.nuevoComponenteAmbiental()\" type=\"button\">\r\n						<span class=\"icon-agregar\"> </span> Agregar Nuevo Componente\r\n						Ambiental\r\n					</button>\r\n				</div>\r\n			</div>\r\n\r\n\r\n			</uib-tab> 2do fin 3Ro <uib-tab\r\n				heading=\"Frecuencia de presentacion\" index=\"2\">\r\n\r\n			<div class=\"row\">\r\n				<br>\r\n				<div class=\"form-group col-md-4\">\r\n					<label for=\"cargo\"> AÃ±o </label> <select\r\n						class=\"form-control input-sm\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option>2015</option>\r\n						<option>2016</option>\r\n						<option>2017</option>\r\n						<option>2018</option>\r\n					</select>\r\n				</div>\r\n\r\n				<div class=\"form-group col-md-2\">\r\n					<label for=\"cargo\"> Periodo </label> <select\r\n						class=\"form-control input-sm\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option>Bimestral</option>\r\n						<option>Trimestral</option>\r\n						<option>Semestral</option>\r\n						<option>Anual</option>\r\n						<option>Mensual</option>\r\n\r\n\r\n					</select>\r\n				</div>\r\n				<div class=\"form-group col-lg-6 text-right\">\r\n					<button class=\"btn btn-flat btn-primary btn-sm\" type=\"button\">\r\n						<span class=\"icon-agregar\"> </span> Agregar Nuevo Periodo\r\n					</button>\r\n				</div>\r\n\r\n\r\n			</div>\r\n\r\n			</uib-tab> 3ro fin 4to --><uib-tab heading=Resultados index=1><div class=row><br></div><!--\r\n            <div class=\"row\">\r\n\r\n                <br> <span>Filtro de busqueda</span><br>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n                <div class=\"form-group col-md-3\">\r\n                    <label for=\"cargo\"> Parametro </label> <input\r\n                        class=\"form-control input-sm\" ng-model=\"\" type=\"text\" />\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                    <label for=\"cargo\"> Unidad </label> <select\r\n                        class=\"form-control input-sm\">\r\n                        <option ng-value=\"0\">Seleccione</option>\r\n                        <option>ejemplo</option>\r\n\r\n                    </select>\r\n                </div>\r\n\r\n\r\n            </div>\r\n\r\n            --><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.nuevoParametroAmbiental() type=button><span class=icon-agregar></span> Agregar Parametro</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.nuevoPuntoMonitoreo() type=button><span class=icon-agregar></span> Agregar Punto de Monitoreo</button><!-- \r\n                    <button class=\"btn btn-flat btn-primary btn-sm\"\r\n                        ng-click=\"vm.atrasInformMonitoreoAmbiental(0)\" type=\"button\">\r\n                        <span class=\"glyphicon glyphicon-remove spac-btn-r\"> </span>\r\n                        Buscar\r\n                    </button>\r\n                   --></div><div class=row><table border=\"1px solid white\"><!-- Lo cambiaremos por CSS --><tr><th colspan=2 bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">Puntos de muestreo</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">20.6.OLE-CA16-PTC</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">20.6.OLE-CA16-PTC</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">20.6.OLE-CA16-PTC</th><th rowspan=2 bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">ECA</th><th rowspan=2 bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">Código Ensayo</th></tr><tr><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">parametro</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">Unidad</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">S.R.</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">S.R.</th><th bgcolor=#144aa7 style=\"color: #FFFFFF; border-color: white; text-align: center\">S.R.</th></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Fraccion de Hidrocarburo F1 (C5-C10)</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>500</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Fraccion de Hidrocarburo F1 (C10-C28)</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>5000</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Fraccion de Hidrocarburo F1 (C28-C40)</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>6000</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Argenico Total</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>140</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Bario Total</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>2000</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Cadmio Total</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>22</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr><tr><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">Cromo Total</td><td bgcolor=#EEEEEE style=\"border-color: white; text-align: center\">mgKg PS</td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td><input style=\"margin: 5px\" type=text name=matriz></td><td bgcolor=#EEEEEE>1000</td><td bgcolor=#EEEEEE><input type=text style=\"margin: 5px\"></td></tr></table></div></div><!-- hoy --><div class=row><div class=\"form-group col-md-12\"><label style=\"text-decoration: underline; font-weight: bolder\">Documentos Relacionados a los resultados</label></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>NÂ°.</th><th class=text-center>Código</th><th class=text-center>Nombre</th><th class=text-center>Ver Documento</th><th class=text-center>Cargar Documento</th></tr></thead><tbody><tr><td data-label=Item>1</td><td data-label=Código>Ensayo-Lab-000001</td><td data-label=Resolución>Ensayo-calidadAire.pdf</td><td align=center><button class=\"btn btn-default btn-sm\" type=button uib-tooltip=\"Ver Documentos\"><span class=\"fa fa-file\">Ver</span></button></td><td><input type=file></td></tr><tr><td data-label=Item>1</td><td data-label=Código>Ensayo-Lab-000002</td><td data-label=Resolución>Ensayo-calidadAgua.pdf</td><td align=center><button class=\"btn btn-default btn-sm\" type=button uib-tooltip=\"Ver Documentos\"><span class=\"fa fa-file\">Ver</span></button></td><td><input type=file></td></tr><tr><td data-label=Item>1</td><td data-label=Código>Ensayo-Lab-000003</td><td data-label=Resolución>Ensayo-general.pdf</td><td align=center><button class=\"btn btn-default btn-sm\" type=button uib-tooltip=\"Ver Documentos\"><span class=\"fa fa-file\">Ver</span></button></td><td><input type=file></td></tr><tr><td data-label=Item>1</td><td data-label=Código>Ensayo-Lab-000004</td><td data-label=Resolución>Ensayo-calidadAire_Agua_2015.pdf</td><td align=center><button class=\"btn btn-default btn-sm\" type=button uib-tooltip=\"Ver Documentos\"><span class=\"fa fa-file\">Ver</span></button></td><td><input type=file></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></uib-tab><!-- 4to fin --></uib-tabset><div class=row ng-show=\"vm.mostrarInformeMonitoreo==true\"><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-show=\"vm.active2==1\" ng-click=vm.guardarInformeAmbiental() type=button><span class=\"fa fa-save\"></span> Finalizar</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-show=\"vm.active2<1\" ng-click=vm.siguienteInformeAmbiental(vm.active2) type=button><span class=\"glyphicon glyphicon-arrow-right spac-btn-r\"></span> Siguiente</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.atrasInformeAmbiental(vm.active2) type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div><!-- </div>   hoy --><!-- Fin  b  --><!--  C --><div ng-show=false class=panel-default id=instrumentoGestionAmbiental is-open=status.open2 uib-accordion-group=\"\"><uib-accordion-heading>Plan de contingencia <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open2, \'glyphicon-chevron-right\': !status.open2}\"></i></uib-accordion-heading><div class=row><div class=\"form-group col-md-4\"><label for=cargo>AÃ±o:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-change=vm.listarDocumentacion(1) ng-model=vm.prmPlan.anio><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstAnio\" ng-value=itemCombo>{{itemCombo}}</option></select></div><div class=\"form-group col-md-6\" ng-repeat=\"item in vm.lstPlan\" ng-show=\"vm.prmPlan.archivo ==null || vm.prmPlan.idArchivo == 0 || vm.prmPlan.archivo.ruta == null || vm.prmPlan.archivo.ruta == \'\'\"><label for=cargo></label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivoPlan multiple type=file><div class=help-block>Archivos permitidos: {{vm.extension}}<br>TamaÃ±o mÃ¡ximo: {{vm.tamanioArchivo}} MB<br></div></div></div><br><div class=row><div class=\"form-group col-md-12\" ng-show=\"vm.prmPlan.archivo !=null && vm.prmPlan.idArchivo > 0 && vm.prmPlan.archivo.ruta != null && vm.prmPlan.archivo.ruta!= \'\'\"><ul class=list-group><div><li class=list-group-item>{{vm.prmPlan.archivo.nombreArchivo}} - {{vm.prmPlan.strFechaRegistro}} <a class=\"btn btn-default btn-sm\" download={{vm.prmPlan.archivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{vm.prmPlan.archivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span></a></li></div></ul></div></div><div class=row><div class=\"form-group col-md-12\"><label for=representanteLegal>Descripción:</label><div class=form-group><textarea class=\"form-control input-sm\" maxlength=200 ng-model=vm.prmPlan.descripcion>\r\n                                </textarea></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-sm\" ng-disabled=\"vm.prmPlan.descripcion.length==0 || vm.prmPlan.anio==0\" ng-click=vm.guardarPlan(1) type=button><span class=\"fa fa-save spac-btn-r\"></span> Guardar</button></div></div><br></div><!-- Fin C --><!--  D --><div ng-show=false class=panel-default id=instrumentoGestionAmbiental is-open=status.open3 uib-accordion-group=\"\"><uib-accordion-heading>Informe ambiental anual <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open3, \'glyphicon-chevron-right\': !status.open3}\"></i></uib-accordion-heading><div class=row><div class=\"form-group col-md-4\"><label for=cargo>AÃ±o:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-change=vm.listarDocumentacion(2) ng-model=vm.prmInforme.anio><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstAnio\" ng-value=itemCombo>{{itemCombo}}</option></select></div><div class=\"form-group col-md-6\" ng-repeat=\"item in vm.lstInforme\" ng-show=\"vm.prmInforme.archivo ==null || vm.prmInforme.idArchivo == 0 || vm.prmInforme.archivo.ruta == null || vm.prmInforme.archivo.ruta == \'\'\"><label for=cargo></label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumentoInforme id=fileArchivoPlanInforme multiple type=file><div class=help-block>Archivos permitidos: {{vm.extension}}<br>TamaÃ±o mÃ¡ximo: {{vm.tamanioArchivo}} MB<br></div></div></div><br><div class=row><div class=\"form-group col-md-12\" ng-show=\"vm.prmInforme.archivo !=null && vm.prmInforme.idArchivo > 0 && vm.prmInforme.archivo.ruta != null && vm.prmInforme.archivo.ruta!= \'\'\"><ul class=list-group><div><li class=list-group-item>{{vm.prmInforme.archivo.nombreArchivo}} - {{vm.prmInforme.strFechaRegistro}} <a class=\"btn btn-default btn-sm\" download={{vm.prmInforme.archivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{vm.prmInforme.archivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span> </a><!--                                                <span class=\"badge\" ng-click=\"vm.eliminarDocumento(vm.prmInforme,2)\"><span class=\"glyphicon glyphicon-trash\"></span></span> --></li></div></ul></div></div><div class=row><div class=\"form-group col-md-12\"><label for=representanteLegal>Descripción:</label><div class=form-group><textarea class=\"form-control input-sm\" maxlength=200 ng-model=vm.prmInforme.descripcion>\r\n                                </textarea></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-sm\" ng-disabled=\"vm.prmInforme.descripcion.length==0 || vm.prmInforme.anio==0\" ng-click=vm.guardarPlan(2) type=button><span class=\"fa fa-save spac-btn-r\"></span> Guardar</button></div></div><br></div><!-- Fin D --><!--  E --><div class=panel-default id=instrumentoGestionAmbiental is-open=status.open4 uib-accordion-group=\"\" ng-show=false><uib-accordion-heading>Declaración y plan de manejo de residuos <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open4, \'glyphicon-chevron-right\': !status.open4}\"></i></uib-accordion-heading><div class=row><div class=\"form-group col-md-4\"><label for=cargo>AÃ±o:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-change=vm.listarDocumentacion(3) ng-model=vm.prmDeclaracion.anio><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstAnio\" ng-value=itemCombo>{{itemCombo}}</option></select></div><div class=\"form-group col-md-6\" ng-repeat=\"item in vm.lstDeclaracion\" ng-show=\"vm.prmDeclaracion.archivo ==null || vm.prmDeclaracion.idArchivo == 0 || vm.prmDeclaracion.archivo.ruta == null || vm.prmDeclaracion.archivo.ruta == \'\'\"><label for=cargo></label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumentoDeclaracion id=fileArchivoPlanDeclaracion multiple type=file><div class=help-block>Archivos permitidos: {{vm.extension}}<br>TamaÃ±o mÃ¡ximo: {{vm.tamanioArchivo}} MB<br></div></div></div><br><div class=row><div class=\"form-group col-md-12\" ng-show=\"vm.prmDeclaracion.archivo !=null && vm.prmDeclaracion.idArchivo > 0 && vm.prmDeclaracion.archivo.ruta != null && vm.prmDeclaracion.archivo.ruta!= \'\'\"><ul class=list-group><div><li class=list-group-item>{{vm.prmDeclaracion.archivo.nombreArchivo}} - {{vm.prmDeclaracion.strFechaRegistro}} <a class=\"btn btn-default btn-sm\" download={{vm.prmDeclaracion.archivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{vm.prmDeclaracion.archivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span> </a><!--                                                <span class=\"badge\" ng-click=\"vm.eliminarDocumento(vm.prmDeclaracion,3)\"><span class=\"glyphicon glyphicon-trash\"></span></span> --></li></div></ul></div></div><div class=row><div class=\"form-group col-md-12\"><label for=representanteLegal>Descripción:</label><div class=form-group><textarea class=\"form-control input-sm\" maxlength=200 ng-model=vm.prmDeclaracion.descripcion>\r\n                                </textarea></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-sm\" ng-disabled=\"vm.prmDeclaracion.descripcion.length==0 || vm.prmDeclaracion.anio==0\" ng-click=vm.guardarPlan(3) type=button><span class=\"fa fa-save spac-btn-r\"></span> Guardar</button></div></div><br></div><!-- Fin E --><!--  F --><div class=panel-default id=instrumentoGestionAmbiental is-open=status.open5 uib-accordion-group=\"\" ng-show=false><uib-accordion-heading>Manifiestos de manejo de residuos sólidos peligrosos <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open5, \'glyphicon-chevron-right\': !status.open5}\"></i></uib-accordion-heading><div ng-show=vm.mostrarDatos1><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Administrado</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad Fiscalizable:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Estación de Servicio</label></div></div><br><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Residuo</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Código de Manifiesto:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Tipo de Residuo:</label></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-change=vm.listarDocumentacion(4) ng-model=vm.prmManifestacion.anio><option ng-value=0>Seleccione</option><option ng-value=1>Peligroso</option><option ng-value=1>No Peligroso</option></select></div></div><!-- <div class=\"row\">\r\n					 \r\n					<div class=\"form-group col-md-12\">\r\n						<label for=\"cargo\" style=\"font-weight: bold;\">DescripciÃ³n:\r\n						</label>\r\n					</div>\r\n\r\n					<div class=\"form-group col-md-8\">\r\n						<input type=\"text\" multiple=\"multiple\" class=\"form-control\" />\r\n					</div>\r\n\r\n\r\n				</div>--><br><div class=row><div class=col-md-12><span style=\"font-weight: bolder; text-decoration: underline\">Cantidad Generada</span></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N°:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div></div></div><div ng-show=vm.mostrarDatos2><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Residuo</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Código de Manifiesto:</label></div><div class=\"form-group col-md-2\"><label>3620-2016</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Tipo de Residuo:</label></div><div class=\"form-group col-md-2\"><label>Peligroso</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Cantidad:</label></div><div class=\"form-group col-md-2\"><label>12</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad:</label></div><div class=\"form-group col-md-2\"><label>Kg</label></div></div><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Transporte</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">EPS-RS:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° Registro</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><input type=button value=\"Obtener Datos\" for=cargo style=\"font-weight: bold\" class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha de Vencimiento de Registro</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° de Autorización Municipal</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Placa de Vehículo</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos de la Disposición Final</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">EPS-RS</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° de Registro</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha de Vencimiento de Registro</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° de Autorización Municipal</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Tipo de Destino Final</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Cantidad:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div></div><!--\r\n								<div class=\"row\">\r\n					<div class=\"form-group col-md-12\">\r\n						<label for=\"cargo\" style=\"font-weight: bold;\">DescripciÃ³n:\r\n						</label>\r\n					</div>\r\n					<div class=\"form-group col-md-8\">\r\n						<input type=\"text\" class=\"form-control\" multiple=\"multiple\">\r\n					</div>\r\n\r\n				</div>\r\n\r\n				--></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-show=vm.mostrarDatos2 ng-click=vm.guardarManifiestoResiduos() type=button><span class=\"fa fa-save\"></span> Finalizar</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-show=vm.mostrarDatos1 ng-click=vm.siguienteManifiestoResiduos() type=button><span class=\"glyphicon glyphicon-arrow-right spac-btn-r\"></span> Siguiente</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-show=vm.mostrarDatos2 ng-click=vm.atrasManifiestoResiduos() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div><!-- Fin F --></uib-accordion><!--            </uib-tab> --><!--     </uib-tabset> --></span></div>");
$templateCache.put("app/modules/supervision/administrado/accion-administrado/accion-administrado-residuos.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Presentación</span></h3></div></div><br><uib-accordion close-others=oneAtATime><!--  A  --><!-- Fin D --><!--  E --><div class=panel-default id=instrumentoGestionAmbiental is-open=true uib-accordion-group=\"\"><uib-accordion-heading>Manifiestos de manejo de residuos sólidos peligrosos <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open4, \'glyphicon-chevron-right\': !status.open4}\"></i></uib-accordion-heading><div ng-show=vm.mostrarDatos1><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Administrado</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad Fiscalizable:</label></div><div class=\"form-group col-md-2\"><label for=cargo>Estación de Servicio</label></div></div><br><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Residuo</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Código de Manifiesto:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Tipo de Residuo:</label></div><div class=\"form-group col-md-2\"><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-change=vm.listarDocumentacion(4) ng-model=vm.prmManifestacion.anio><option ng-value=0>Seleccione</option><option ng-value=1>Semisólido</option></select></div></div><!-- <div class=\"row\">\r\n					 \r\n					<div class=\"form-group col-md-12\">\r\n						<label for=\"cargo\" style=\"font-weight: bold;\">Descripción:\r\n						</label>\r\n					</div>\r\n\r\n					<div class=\"form-group col-md-8\">\r\n						<input type=\"text\" multiple=\"multiple\" class=\"form-control\" />\r\n					</div>\r\n\r\n\r\n				</div>--><br><div class=row><div class=col-md-12><span style=\"font-weight: bolder; text-decoration: underline\">Cantidad Generada</span></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N°:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div></div></div><div ng-show=vm.mostrarDatos2><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Residuo</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Código de Manifiesto:</label></div><div class=\"form-group col-md-2\"><label>3620-2016</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Tipo de Residuo:</label></div><div class=\"form-group col-md-2\"><label>Semisólido</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Cantidad:</label></div><div class=\"form-group col-md-2\"><label>12</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad:</label></div><div class=\"form-group col-md-2\"><label>Kg</label></div></div><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos del Transporte</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">EPS-RS:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° Registro</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><input type=button value=\"Obtener Datos\" for=cargo style=\"font-weight: bold\" class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha de Vencimiento de Registro</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° de Autorización Municipal</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Placa de Vehículo</label></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=col-md-12><h5 class=\"unp-legend title-slider-nt\" style=\"text-decoration: underline\">Datos de la Disposición Final</h5></div></div><br><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">EPS-RS</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° de Registro</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha de Vencimiento de Registro</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">N° de Autorización Municipal</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Tipo de Destino Final</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Fecha</label></div><div class=\"form-group col-md-2\"><input type=date class=form-control></div></div><div class=row><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Cantidad:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div><div class=\"form-group col-md-2\"><label for=cargo style=\"font-weight: bold\">Unidad:</label></div><div class=\"form-group col-md-2\"><input type=text class=form-control></div></div><!--\r\n								<div class=\"row\">\r\n					<div class=\"form-group col-md-12\">\r\n						<label for=\"cargo\" style=\"font-weight: bold;\">Descripción:\r\n						</label>\r\n					</div>\r\n					<div class=\"form-group col-md-8\">\r\n						<input type=\"text\" class=\"form-control\" multiple=\"multiple\">\r\n					</div>\r\n\r\n				</div>\r\n\r\n				--></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-show=vm.mostrarDatos2 ng-click=vm.guardarManifiestoResiduos() type=button><span class=\"fa fa-save\"></span> Finalizar</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-show=vm.mostrarDatos1 ng-click=vm.siguienteManifiestoResiduos() type=button><span class=\"glyphicon glyphicon-arrow-right spac-btn-r\"></span> Siguiente</button> <button class=\"btn btn-flat btn-primary btn-sm\" ng-show=vm.mostrarDatos2 ng-click=vm.atrasManifiestoResiduos() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div><!-- Fin E --><!--  F --><div class=panel-default id=instrumentoGestionAmbiental is-open=status.open5 uib-accordion-group=\"\" ng-show=false><uib-accordion-heading>b. Declaración y plan de manejo de residuos <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': status.open5, \'glyphicon-chevron-right\': !status.open5}\"></i></uib-accordion-heading><div class=row><div class=\"form-group col-md-3\"><label for=cargo>AÃ±o:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-change=vm.listarDocumentacion(4) ng-model=vm.prmManifestacion.anio><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstAnio\" ng-value=itemCombo>{{itemCombo}}</option></select></div><div class=\"form-group col-md-6\" ng-repeat=\"item in vm.lstManifestacion\" ng-show=\"vm.prmManifestacion.archivo ==null || vm.prmManifestacion.idArchivo == 0 || vm.prmManifestacion.archivo.ruta == null || vm.prmManifestacion.archivo.ruta == \'\'\"><label for=cargo></label><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumentoManifestacion id=fileArchivoPlanManifestacion multiple type=file><div class=help-block>Archivos permitidos: {{vm.extension}}<br>TamaÃ±o mÃ¡ximo: {{vm.tamanioArchivo}} MB<br></div></div></div><br><div class=row><div class=\"form-group col-md-12\" ng-show=\"vm.prmManifestacion.archivo !=null && vm.prmManifestacion.idArchivo > 0 && vm.prmManifestacion.archivo.ruta != null && vm.prmManifestacion.archivo.ruta!= \'\'\"><ul class=list-group><div><li class=list-group-item>{{vm.prmManifestacion.archivo.nombreArchivo}} - {{vm.prmManifestacion.strFechaRegistro}} <a class=\"btn btn-default btn-sm\" download={{vm.prmManifestacion.archivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{vm.prmManifestacion.archivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span></a></li></div></ul></div></div><!--\r\n						<div class=\"row\">\r\n				<div class=\"form-group col-md-12\">\r\n					<label for=\"representanteLegal\"> DescripciÃ³n: </label>\r\n					<div class=\"form-group\">\r\n						<textarea class=\"form-control input-sm\" maxlength=\"200\"\r\n							ng-model=\"vm.prmManifestacion.descripcion\">\r\n                                </textarea>\r\n					</div>\r\n				</div>\r\n			</div>\r\n			--><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-sm\" ng-click=vm.guardarPlan(4) ng-disabled=\"vm.prmManifestacion.mes == 0 || vm.prmManifestacion.mes == null || vm.prmManifestacion.descripcion.length==0 || vm.prmManifestacion.anio==0\" type=button><span class=\"fa fa-save spac-btn-r\"></span> Guardar</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ã�tem</th><th class=text-center>AÃ±o</th><th class=text-center>Mes</th><th class=text-center>DescripciÃ³n</th><th class=text-center>Fecha registro</th><th class=text-center>AcciÃ³n</th></tr></thead><tbody><tr dir-paginate=\"item in vm.listaManifestacion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Ã�tem>{{$index + 1}}</td><td data-label=AÃ±o>{{item.anio}}</td><td data-label=Mes>{{item.nombreMes}}</td><td data-label=DescripciÃ³n>{{item.descripcion}}</td><td data-label=\"Fecha registro\">{{item.strFechaRegistro}}</td><td align=center data-label=Ã�tem><!-- <button class=\"btn btn-default btn-sm\" ng-click=\"vm.eliminarDocumento(item,4)\" type=\"button\" uib-tooltip=\"Eliminar\">\r\n                                                    <span class=\"glyphicon glyphicon-trash\">\r\n                                                    </span>\r\n                                                </button>--> <a class=\"btn btn-default btn-sm\" href={{vm.rutaBase}}archivo/descargar-archivo/{{item.archivo.idArchivo}} download={{item.archivo.nombreArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span></a></td></tr><!--	<tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n												<td colspan=\"5\">No se encontraron resultados</td>\r\n											</tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><br></div></uib-accordion></span><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div>");
$templateCache.put("app/modules/supervision/administrado/accion-administrado/accion-administrado.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Declaración de la Información a Remitir</span></h3></div></div><br><uib-tabset active=vm.active><uib-tab heading=\"Datos de la Unidad Fiscalizable:\" index=0><br><div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">N° de Registro:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.objInstalacion.numeroRegistro}}</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Nombre:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.objInstalacion.numeroInstalacion}}</label></div></div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Departamento:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.objInstalacion.departamento.descripcionDepartamento}}</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Provincia:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.objInstalacion.provincia.descripcion}}</label></div><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Distrito:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.objInstalacion.distrito.descripcionDistrito}}</label></div></div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Dirección:</label></div><div class=\"form-group col-lg-4\"><label>{{ vm.objInstalacion.direccion}}</label></div></div></div></uib-tab><uib-tab heading=\"Datos del IGA\" index=1><br><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Tipo:</label></div><div class=\"form-group col-lg-4\"><label>{{vm.objInstrumentoGestion.auxTipoIgaNombre}}</label></div></div><div class=row><div class=\"form-group col-lg-2\"><label for=tipoContacto style=\"font-weight: bold\">Fecha de Aprobación:</label></div><div class=\"form-group col-lg-2\"><label>{{vm.objInstrumentoGestion.fechaAprobacion}}</label></div></div></uib-tab></uib-tabset><div class=row><div class=col-md-12><h3 class=title-slider-nt>Etapa del proyecto</h3></div></div><br><div class=row><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.cargarDeclaracionComponentes() ng-model=vm.objInstrumentoGestion.declaracionEtapa.idEtapa><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstEtapas\" ng-value=itemCombo.codetapa>{{itemCombo.descripcion}}</option></select></div></div><div class=row ng-show=vm.verComponentes><div class=col-md-12><h3 class=title-slider-nt>Componentes Ambientales</h3></div></div><br><div class=\"form-group col-lg-12 text-right\" ng-show=vm.verComponentes><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.agregarDeclaracionComponentes() type=button><span class=icon-agregar>Agregar Componente</span></button></div><div class=row ng-show=vm.verComponentes><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Componente</th><th style=\"text-align: center\">Frecuencia</th><th style=\"text-align: center\">Acción</th><th style=\"text-align: center\">Puntos Monitoreo</th></tr></thead><tbody><tr ng-show=\"vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length==0\"><td colspan=5 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objDeclaracionComponente.idComponente == item.idComponente, null: vm.objDeclaracionComponente.idComponente != item.idComponente}\" dir-paginate=\"item in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes | itemsPerPage: config.itemsPerPage\" pagination-id=coutComponente><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=Nombre style=\"text-align: center\">{{item.auxComponenteNombre}}</td><td data-label=Frecuencia style=\"text-align: center\"><select ng-model=item.idFrecuencia ng-change=vm.actualizarDeclaracionComponentes(item) class=\"form-control input-sm\"><option ng-value=0>No Presenta</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionComponente(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td><td class=text-center data-label=\"Puntos Monitoreo\"><button class=\"btn btn-default btn-sm\" ng-click=vm.cargarDeclaracionPuntosMonitoreo(item) type=button uib-tooltip=\"Puntos de Monitoreo\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutComponente></dir-pagination-controls></div></div></div><div class=row ng-show=vm.verPuntosMonitoreo><div class=col-md-12><h3 class=title-slider-nt>Puntos de Monitoreo</h3></div></div><br><div class=\"form-group col-lg-12 text-right\" ng-show=vm.verPuntosMonitoreo><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.agregarDeclaracionPuntosMonitoreo() type=button><span class=icon-agregar>Agregar Puntos Monitoreo</span></button></div><div class=row ng-show=vm.verPuntosMonitoreo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N° Item</th><th class=text-center>Zona</th><th class=text-center>Coordenadas UTM (Datum WGS84)</th><th class=text-center>Observación</th><th class=text-center>Acción</th><th class=text-center>Parámetros</th></tr></thead><tbody><tr ng-show=\"vm.lstDeclaracionPunto.length==0\"><td colspan=5 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objDeclaracionPuntoMonitoreo.idPunto == item.idPunto, null: vm.objDeclaracionPuntoMonitoreo.idPunto != item.idPunto}\" dir-paginate=\"item in vm.lstDeclaracionPunto | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Zona style=\"text-align: center\">{{item.idZona}}</td><td data-label=Coordenadas>Norte: {{item.puntoNorte}} - Este: {{item.puntoEste}}</td><td data-label=Observación>{{item.observacion}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarDeclaracionPuntosMonitoreo(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionPunto(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td><td class=text-center data-label=Parámetros><button class=\"btn btn-default btn-sm\" ng-click=vm.cargarDeclaracionParametros(item) type=button uib-tooltip=\"Puntos de Monitoreo\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table></div></div></div><div class=row ng-show=vm.verParametros><div class=col-md-12><h3 class=title-slider-nt>Parámetros</h3></div></div><br><div class=\"form-group col-lg-12 text-right\" ng-show=vm.verParametros><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.agregarDeclaracionParametros() type=button><span class=icon-agregar>Agregar Parámetros</span></button></div><div class=row ng-show=vm.verParametros><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N° Item</th><th class=text-center>Nombre</th><th class=text-center>Periodo</th><th class=text-center>Valor</th><th class=text-center>Unidad Medida</th><th class=text-center>Norma</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstDeclaracionParametro.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstDeclaracionParametro | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Nombre style=\"text-align: center\">{{item.auxParametroNombre}}</td><td data-label=Periodo>{{item.auxPeriodoNombre}}</td><td data-label=Valor>{{item.auxValor}}</td><td data-label=\"Unidad Medida\">{{item.auxUnidadNombre}}</td><td data-label=Norma>{{item.auxNormaNombre}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionParametro(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table></div></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.guardarDeclaracion() type=button><span class=\"fa fa-save\"></span> Finallizar</button> <button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div>");
$templateCache.put("app/modules/supervision/cargainformacion/informe-ensayo/cargainfo-informe-ensayo.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector Informe de Ensayo</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><strong><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarInformeEnsayo() uib-tooltip=\"Agregar Informe de ensayo\"><i aria-hidden=true class=\"glyphicon glyphicon-plus\"></i></button></strong></div></div><div class=row ng-show=vm.mostrarNuevoEnsayo><div class=\"form-group col-md-2\"><p>RUC Laboratorio:</p><input class=\"form-control input-sm\" required maxlength=11 ng-model=vm.objInformeEnsayo.ruc_laboratorio type=text></div><div class=\"form-group col-md-3\"><p>Nombre Laboratorio:</p><input class=\"form-control input-sm\" required maxlength=200 ng-model=vm.objInformeEnsayo.razon_laboratorio type=text></div><div class=\"form-group col-md-2\"><p>Código de Ensayo:</p><input class=\"form-control input-sm\" required maxlength=10 ng-model=vm.objInformeEnsayo.codigo_ensayo type=text></div><div class=\"form-group col-md-3\"><p></p><br><input class=\"form-control input-sm\" file-change=vm.validaDocumentoEnsayo id=fileArchivoEnsayo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }} Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-lg-1\"><p></p><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnAgregarEnsayo ng-disabled=\"vm.objInformeEnsayo.codigo_ensayo==\'\' || vm.objInformeEnsayo.codigo_ensayo==null || vm.objInformeEnsayo.ruc_consultora ==\'\' || vm.objInformeEnsayo.ruc_consultora==null || vm.objInformeEnsayo.razon_consultora ==\'\' || vm.objInformeEnsayo.razon_consultora==null || vm.listaArchivos.length == 0\" ng-click=vm.guardarInformeEnsayo()><i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i> Grabar</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center width=8%>N° Item</th><th class=text-center width=10%>RUC Laboratorio</th><th class=text-center width=30%>Nombre Laboratorio</th><th class=text-center width=10%>Código de Ensayo</th><th class=text-center width=10%>Documento</th><th class=text-center width=10%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstEnsayos.length==0\"><td colspan=5 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstEnsayos | itemsPerPage: config.itemsPerPage\" pagination-id=pgInformeEnsayo><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=\"RUC Laboratorio\">{{item.ruc_laboratorio}}</td><td data-label=\"Nombre Laboratorio\">{{item.razon_laboratorio}}</td><td data-label=\"Código Ensayo\">{{item.codigo_ensayo}}</td><td data-label=Documento><a download={{item.nombreArchivo}} href=\"{{vm.urlData}}informeEnsayo/descargar-ensayo/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.codigo_ensayo.replace(\'/\',\'|\')}}\" target=_blank>{{item.nombreArchivo}}</a></td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarInformeEnsayo($index) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.seleccionarInformeEnsayo(item) type=button uib-tooltip=Seleccionar><span class=\"glyphicon glyphicon-check\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=pgInformeEnsayo></dir-pagination-controls></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/administrado/dialog/componente-ambiental-selector.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector de Componentes Ambientales</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><label>Nombre</label><input class=form-control type=text ng-model=vm.prmComponente.descripcion></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\">N° Item</th><th style=\"text-align: center\">Nombre</th><th style=\"text-align: center\">Seleccione</th></tr></thead><tbody><tr ng-show=\"vm.lstComponentes.length==0\"><td colspan=4 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstComponentes | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=\"N° Item\" style=\"text-align: center\">{{$index + 1}}</td><td data-label=Nombre style=\"text-align: center\">{{item.descripcion}}</td><td class=text-center data-label=Acciones><input type=checkbox ng-model=item.blSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar()><i aria-hidden=true class=\"glyphicon glyphicon-floppy-disk\"></i> Aceptar</button></div></div></span></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/administrado/dialog/declaracion_jurada.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Declaración Jurada</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"col-lg-12 text-right\"><p>Declaración</p></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.guardar()><i aria-hidden=true></i> Aceptar</button></div></div></span></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/administrado/dialog/informacion-instalacion-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Instalación {{ vm.dataInstalacion.numeroInstalacion}}</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-3\"><strong><p>Unidad fiscalizable</p></strong></div><div class=\"form-group col-md-9\"><p>{{ vm.dataInstalacion.numeroInstalacion}}</p></div></div><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Número de registro</p></strong></div><div class=\"form-group col-md-9\"><p>{{ vm.dataInstalacion.numeroRegistro}}</p></div></div><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Sector</p></strong></div><div class=\"form-group col-md-3\"><p>{{ vm.dataInstalacion.sector.descripcion}}</p></div><div class=\"form-group col-md-2\"><strong><p>Subsector</p></strong></div><div class=\"form-group col-md-3\"><p>{{ vm.dataInstalacion.subSector.descripcion}}</p></div></div><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Actividad</p></strong></div><div class=\"form-group col-md-9\"><p>{{ vm.dataInstalacion.actividad.descripcion}}</p></div></div><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong></div><div class=\"form-group col-md-3\"><p>{{ vm.dataInstalacion.departamento.descripcionDepartamento}}</p></div><div class=\"form-group col-md-2\"><strong><p>Provincia</p></strong></div><div class=\"form-group col-md-3\"><p>{{ vm.dataInstalacion.provincia.descripcion}}</p></div></div><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong></div><div class=\"form-group col-md-3\"><p>{{ vm.dataInstalacion.distrito.descripcionDistrito}}</p></div><div class=\"form-group col-md-2\"><strong><p>Dirección</p></strong></div><div class=\"form-group col-md-3\"><p>{{ vm.dataInstalacion.direccion }}</p></div></div><br><div class=row><div class=\"form-group col-md-3\"><strong><p>Ficha</p></strong></div><div class=\"form-group col-md-9\"><p></p><td><i aria-hidden=true class=\"fa fa-file-pdf-o inverse\"></i> <a download={{vm.dataInstalacion.fichaRegistro}} href={{vm.urlData}}instalacion/descargar-ficha-instalacion/{{vm.dataInstalacion.idInstalacion}}>{{vm.dataInstalacion.fichaRegistro}} </a><!-- 						<a href=\"{{ vm.dataInstalacion.rutaFichaRegistro }}\">{{ vm.dataInstalacion.fichaRegistro }}</a></p> --></td><p></p></div></div><div class=row ng-show=\"vm.dataInstalacion.estado == 3\"><div class=\"form-group col-md-4\"><strong><p>Motivo rechazo</p></strong></div><div class=\"form-group col-md-8\"><p>{{ vm.dataInstalacion.motivoRechazoInstalacion }}</p></div></div><br><br><br><br><br><br></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=closeThisDialog(0)><i aria-hidden=true></i> Cerrar</button></div></div><br></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/administrado/dialog/punto-monitoreo-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmParametro.codigo == 0 ? \'Nueva\' : \'Editar\' }} Punto de Monitoreo:</h4></div><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-3\"><strong><p>Zona</p></strong><select class=\"form-control input-sm\" name=tipoPersona ng-model=vm.objDeclaracionPunto.idZona><option ng-value=0>Seleccione</option><option ng-value=17>17</option><option ng-value=18>18</option><option ng-value=19>19</option></select></div></div><br><div class=row><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Coordenadas UTM (Datum WGS84)</h5></div></div><div class=row><div class=\"form-group col-md-6\"><strong><p>Norte</p></strong><p><input class=\"form-control input-sm\" type=text ng-model=vm.objDeclaracionPunto.puntoNorte></p></div></div><div class=row><div class=\"form-group col-md-6\"><strong><p>Este</p></strong><p><input class=\"form-control input-sm\" type=text ng-model=vm.objDeclaracionPunto.puntoEste></p></div></div><div class=row><div class=\"form-group col-md-10\"><strong><p>Observación</p></strong><p><input class=\"form-control input-sm\" type=text ng-model=vm.objDeclaracionPunto.observacion multiple></p></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.guardarDeclaracionPunto()><i aria-hidden=true class=\"fa fa-save\"></i> Aceptar</button></div></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/cargainformacion/administradoInstalacion/cargainfo-administracion-instalacion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Trasnferencia de Unidad Fiscalizable</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><label><p class=important-box>RUC</p></label></div><div class=\"form-group col-md-3\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.dataAdminInstalacion.idInstalacion!=0\" maxlength=11 ng-model=vm.dataAdminInstalacion.ruc type=text></div><div class=\"form-group col-md-5\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false || vm.dataAdminInstalacion.idInstalacion!=0\" ng-model=\"vm.dataAdminInstalacion.razonsocial \" type=text></div><div class=\"input-group col-md-2\"><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-disabled=\"vm.dataAdminInstalacion.ruc.length<11 || vm.dataAdminInstalacion.idInstalacion!=0\" ng-click=vm.validarRuc() type=button><span class=icon-check></span> Validar Ruc</button></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Vigencia desde</p></strong></div><div class=\"form-group col-md-3\"><input class=\"form-control input-sm\" type=date ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataAdminInstalacion.inicioAdministradoBase></div><div class=\"form-group col-md-2\"><strong><p>Vigencia hasta</p></strong></div><div class=\"form-group col-md-3\"><input class=\"form-control input-sm\" type=date ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataAdminInstalacion.finAdministrado></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p>Archivo</p></strong></div><div class=\"form-group col-md-3\" ng-show=\"vm.blCambiarArchivo==true || vm.dataAdminInstalacion.uuid==null || vm.dataAdminInstalacion.uuid==\'\'\"><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-md-3\" ng-show=\"vm.blCambiarArchivo==false && vm.dataAdminInstalacion.uuid!=null && vm.dataAdminInstalacion.uuid != \'\'\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{vm.dataAdminInstalacion.nombrearchivo}} href={{vm.rutaBase}}administradoXinstalaciontemp/descargar-archivo/{{vm.dataAdminInstalacion.ruc}}/{{vm.dataAdminInstalacion.idInstalacion}}/{{vm.dataAdminInstalacion.fechaInicioTexto}}>{{vm.dataAdminInstalacion.nombrearchivo}}</a> <a ng-click=\"vm.blCambiarArchivo=true\">(Cambiar archivo)</a></div><div class=\"form-group col-md-2\"><strong><p>¿Está activo?</p></strong></div><div class=\"form-group col-md-3\"><p><input type=checkbox ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataAdminInstalacion.auxflgaactivo></p></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=\"vm.RucValido==false || vm.dataAdminInstalacion.inicioAdministradoBase == null || (vm.listaArchivos.length==0 && vm.blCambiarArchivo==true)\"><i aria-hidden=true></i> Grabar</button></div></div></span></div><button id=btnRefrescar style=\"display: none\" ng-click=vm.refrescar()></button><script type=text/javascript>$(document)\r\n				.ready(\r\n						function() {\r\n							$(\'button.ngdialog-close\').remove();\r\n							$(\'.ngdialog-content\')\r\n									.append(\r\n											\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n						});</script></div>");
$templateCache.put("app/modules/supervision/cargainformacion/declaracion/cargainfo-accion-administrado.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}\r\n\r\n.selectComponente {\r\n	background-color: #35bfb1 !important;\r\n	color: white !important;\r\n	border: none !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Declaración de la Información a Remitir</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstalacion.numeroInstalacion}}</label><br><label>{{ vm.objInstalacion.direccion}}</label><br>{{vm.objInstalacion.distrito.descripcionDistrito}} - {{vm.objInstalacion.provincia.descripcion}} - {{vm.objInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #35bfb1; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Instrumento de Gestión</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstrumentoGestion.auxTipoIgaNombre}}</label><br><label>{{vm.objInstrumentoGestion.resolucion}}</label><br>{{vm.objInstrumentoGestion.fechaAprobacion}}</div></div><div class=row><div class=col-md-12><h3 class=title-slider-nt>Etapa del proyecto</h3></div></div><br><div class=row><uib-tabset active=vm.activeetapa type=pills><uib-tab ng-click=vm.cambiarEtapa(item) ng-repeat=\"item in vm.lstEtapas\" heading={{item.descripcion}} index=$index><br></uib-tab></uib-tabset></div><div class=row ng-show=vm.verComponentes><div class=col-md-12><h3 class=title-slider-nt>Compromisos Ambientales</h3></div></div><br><div class=row ng-show=vm.verComponentes><div class=col-md-3><div style=\"width: 100%; min-height: 150px; border: solid 2px #35bfb1\"><div ng-click=vm.cargarDeclaracionPuntosMonitoreo(item); ng-class=\"{selectComponente: vm.objDeclaracionComponente.idComponente == item.idComponente, null: vm.objDeclaracionComponente.idComponente != item.idComponente}\" style=\"height: 40px; color: #35bfb1; -webkit-border-radius: 0px 18px 18px 0px; -moz-border-radius: 0px 18px 18px 0px; border-radius: 0px 18px 18px 0px\" ng-repeat=\"item in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes\"><span style=\"height: 40px !important; vertical-align: middle !important; display: table-cell\">&nbsp;&nbsp;{{item.auxComponenteNombre}}</span></div><br></div><br><button class=\"btn btn-flat btn-primary\" style=\"background-color: #35bfb1 !important; border-color: #35bfb1 !important; color: white !important\" ng-click=vm.agregarDeclaracionComponentes() type=button ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO COMPONENTE\')\"><span class=icon-agregar></span> Agregar</button> <button class=\"btn btn-flat btn-primary\" style=\"background-color: #35bfb1 !important; border-color: #35bfb1 !important; color: white !important\" ng-click=vm.confirmarEliminacionComponente(vm.objDeclaracionComponente) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR COMPONENTE\')\" type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span> Eliminar</button></div><div class=col-md-9><div class=row><div class=\"form-group col-lg-2\"><label ng-show=\"vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length > 0 && vm.verFrecuenciaAbandono\">Frecuencia:</label></div><div class=\"form-group col-lg-2\"><select ng-model=vm.objDeclaracionComponente.idFrecuencia ng-disabled=\"!$parent.sisoValidaOperacionesWbUvk(\'EDITAR FRECUENCIA\')\" ng-show=\"vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length > 0 && vm.verFrecuenciaAbandono\" ng-change=vm.actualizarDeclaracionComponentes(vm.objDeclaracionComponente) class=\"form-control input-sm\"><option ng-value=0>NO ESPECIFICA</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-lg-8 text-right\" ng-show=vm.verPuntosMonitoreo><button class=\"btn btn-flat btn-primary\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO PUNTO\')\" style=\"background-color: #144aa7 !important; color: white !important\" ng-click=vm.agregarDeclaracionPuntosMonitoreo() type=button><span class=icon-agregar></span> Agregar Puntos Monitoreo</button></div></div><div class=row ng-show=vm.verPuntosMonitoreo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center width=5% style=\"vertical-align: middle !important\">N°</th><th class=text-center width=6% style=\"vertical-align: middle !important\">C&oacute;digo</th><th class=text-center width=30% style=\"vertical-align: middle !important\">Descripci&oacute;n</th><th class=text-center width=8% style=\"vertical-align: middle !important\">Zona</th><th class=text-center width=10% style=\"vertical-align: middle !important\">Coordenadas UTM<br>(Datum WGS84)</th><th class=text-center width=10% style=\"vertical-align: middle !important\">Acciones</th></tr></thead><tbody><tr ng-show=\"vm.lstDeclaracionPunto.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objDeclaracionPuntoMonitoreo.idPunto == item.idPunto, null: vm.objDeclaracionPuntoMonitoreo.idPunto != item.idPunto}\" dir-paginate=\"item in vm.lstDeclaracionPunto | itemsPerPage: config.itemsPerPage\" pagination-id=coutpuntos><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Código class=text-center>{{item.codigo}}</td><td data-label=Nombre>{{item.observacion}}</td><td data-label=Zona style=\"text-align: center\">{{item.idZona}}</td><td data-label=Coordenadas>NORTE: {{item.puntoNorte}}<br>ESTE: {{item.puntoEste}}</td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarDeclaracionPuntosMonitoreo(item) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR PUNTO\')\" type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR PUNTO\')\" ng-click=vm.confirmarEliminacionPunto(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.cargarDeclaracionParametros(item) type=button uib-tooltip=\"Parámetros de Monitoreo\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutpuntos></dir-pagination-controls></div></div></div></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div>");
$templateCache.put("app/modules/supervision/cargainformacion/declaracion/cargainfo-declaracion-parametro.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Parámetros de {{vm.prmComponente.auxComponenteNombre}} declarados en el instrumento de gestión ambiental</h4></div></div><div class=modal-body name=parametroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=col-md-12><h3 class=title-slider-nt>Filtros de Búsqueda</h3></div></div><br><div class=row><div class=\"form-group col-md-3\"><label>Parámetro</label><input class=form-control type=text ng-model=vm.prmComponenteParametro.auxParametroNombre></div><!-- <div class=\"form-group col-lg-3\">\r\n				<label> Unidad de Medida: </label>\r\n				<div class=\"input-group col-lg-12\">\r\n					<select ng-model=\"vm.prmComponenteParametro.auxCodUnidad\"\r\n						class=\"form-control input-sm\" id=\"unidadmedida\"\r\n						name=\"unidadmedida\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"itemCombo in vm.lstUnidadMedida\"\r\n							ng-value=\"itemCombo.codigoRegistro\">\r\n							{{itemCombo.descripcion}}</option>\r\n					</select>\r\n				</div>\r\n			</div> --><!-- <div class=\"form-group col-md-3\">\r\n				<label> Periodo: </label>\r\n				<div class=\"input-group col-lg-12\"\r\n					ng-class=\"{\'has-error\':parametroDataDialogForm.estado.$invalid && parametroDataDialogForm.estado.$touched}\">\r\n					<select ng-model=\"vm.prmComponenteParametro.auxCodPeriodo\"\r\n						class=\"form-control input-sm\" id=\"periodoeca\" name=\"periodoeca\">\r\n						<option ng-value=\"0\">Seleccione</option>\r\n						<option ng-repeat=\"itemCombo in vm.lstFrecuencia\"\r\n							ng-value=\"itemCombo.idMaestro\">{{itemCombo.descripcion}}</option>\r\n					</select>\r\n				</div>\r\n			</div> --><div class=\"form-group col-md-3\"><label>Norma Legal:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.auxCodNorma class=\"form-control input-sm\" id=normaeca name=normaeca><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstNormaLegal\" ng-value=itemCombo.idNorma>{{itemCombo.numeroNorma}}</option></select></div></div><div class=\"form-group col-lg-2\"><label>Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.matriz class=\"form-control input-sm\" id=matriz ng-change=\"vm.listarSubMatriz(vm.prmComponenteParametro.matriz);vm.prmComponenteParametro.submatriz=0 \" name=matriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"form-group col-lg-2\"><label>Sub Matriz:</label><div class=\"input-group col-lg-12\"><select ng-model=vm.prmComponenteParametro.submatriz class=\"form-control input-sm\" id=submatriz name=submatriz><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in  vm.lstSubMatriz\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div></div><div class=\"col-lg-2 text-right\"><label></label><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><caption style=\"font-weight: bolder\">Maestro de Parámetros</caption><thead><tr><th style=\"text-align: center\" style=\"vertical-align: middle !important\">N°</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Componente</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Parámetro</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Unidad Medida</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Periodo</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Valor</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Norma</th><th style=\"text-align: center\" style=\"vertical-align: middle !important\">Selección</th></tr></thead><tbody><tr ng-show=\"vm.lstParametrosComponente.length==0\"><td colspan=8 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametrosComponente | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=N° style=\"text-align: center\">{{$index + 1}}</td><td data-label=Componente style=\"text-align: center\">{{item.auxComponenteNombre}}</td><td data-label=Nombre style=\"text-align: center\">{{item.auxParametroNombre}}</td><td data-label=\"Unidad Medida\" style=\"text-align: center\">{{item.auxUnidadNombre}}</td><td data-label=Periodo style=\"text-align: center\">{{item.auxPeriodoNombre}}</td><td data-label=Valor style=\"text-align: center\"><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == \'RANGO\'}}\">Rango: {{item.auxValor}} a {{item.auxValor2}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == null || item.auxConcentracionTexto.toUpperCase() == \'\'}}\">{{item.auxValor}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == \'<\'}}\">{{item.auxConcentracionTexto}} {{item.auxValor}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() != \'RANGO\' && item.auxConcentracionTexto.toUpperCase() != \'<\'}}\">{{item.auxConcentracionTexto.toUpperCase()}}</div></td><td data-label=Norma style=\"text-align: center\">{{item.auxNormaNombre}}</td><td class=text-center data-label=Selección><input ng-change=vm.agregarParametro(item); type=checkbox ng-model=item.blSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><caption style=\"font-weight: bolder\">Parámetros seleccionados</caption><thead><tr><th class=text-center>N°</th><th class=text-center>Nombre</th><th class=text-center>Periodo</th><th class=text-center>Valor</th><th class=text-center>Unidad Medida</th><th class=text-center>Norma</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstParametrosComponenteBase.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametrosComponenteBase | itemsPerPage: config.itemsPerPage\" pagination-id=cout2><td data-label=Item style=\"vertical-align: middle !important; text-align: center\">{{item.numeroItem}}</td><td data-label=Nombre style=\"vertical-align: middle !important; text-align: center\">{{item.auxParametroNombre}}</td><td data-label=Periodo class=text-center style=\"vertical-align: middle !important\">{{item.auxPeriodoNombre}}</td><td data-label=Valor class=text-center style=\"vertical-align: middle !important\"><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == \'RANGO\'}}\">Rango: {{item.auxValor}} a {{item.auxValor2}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == null || item.auxConcentracionTexto.toUpperCase() == \'\'}}\">{{item.auxValor}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == \'<\'}}\">{{item.auxConcentracionTexto}} {{item.auxValor}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() != \'RANGO\' && item.auxConcentracionTexto.toUpperCase() != \'<\'}}\">{{item.auxConcentracionTexto.toUpperCase()}}</div></td><td data-label=\"Unidad Medida\" class=text-center style=\"vertical-align: middle !important\">{{item.auxUnidadNombre}}</td><td data-label=Norma class=text-center style=\"vertical-align: middle !important\">{{item.auxNormaNombre}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionParametro(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout2></dir-pagination-controls></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.salir()><i aria-hidden=true></i> Salir</button></div></div></span></div>");
$templateCache.put("app/modules/supervision/cargainformacion/declaracion/cargainfo-punto-monitoreo.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.objDeclaracionPunto.codigo == 0 ? \'Nuevo\' : \'Editar\' }} Punto de Monitoreo:</h4></div><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><strong><p class=important-box>C&oacute;digo</p></strong><p><input class=\"form-control input-sm\" type=text maxlength=20 ng-model=vm.objDeclaracionPunto.codigo></p></div></div><div class=row><div class=\"form-group col-md-10\"><strong><p class=important-box>Descripci&oacute;n</p></strong><p><input class=\"form-control input-sm\" type=text maxlength=4000 ng-model=vm.objDeclaracionPunto.observacion multiple></p></div></div><div class=row><div class=\"form-group col-md-12\"><h5 class=\"unp-legend title-slider-nt\">Coordenadas UTM (Datum WGS84)</h5></div></div><div class=row><div class=\"form-group col-md-3\"><strong><p class=important-box>Zona</p></strong><select class=\"form-control input-sm\" name=tipoPersona ng-model=vm.objDeclaracionPunto.idZona><option ng-value=0>Seleccione</option><option ng-value=17>17</option><option ng-value=18>18</option><option ng-value=19>19</option></select></div></div><div class=row><div class=\"form-group col-md-6\"><strong><p class=important-box>Norte</p></strong><p><input class=\"form-control input-sm\" type=text ng-model=vm.objDeclaracionPunto.puntoNorte maxlength=100></p></div><div class=\"form-group col-md-6\"><input type=checkbox ng-change=vm.mostrarNoEspecificaNorte() ng-model=vm.boolNorte> No Presenta coordenada Norte</div></div><div class=row><div class=\"form-group col-md-6\"><strong><p class=important-box>Este</p></strong><p><input class=\"form-control input-sm\" type=text ng-model=vm.objDeclaracionPunto.puntoEste maxlength=100></p></div><div class=\"form-group col-md-6\"><input type=checkbox ng-change=vm.mostrarNoEspecificaEste() ng-model=vm.boolEste> No Presenta coordenada Este</div></div><label class=important-box>(Campos Obligatorios)</label></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.objDeclaracionPunto.idZona==0 || (vm.objDeclaracionPunto.codigo==null || vm.objDeclaracionPunto.codigo==\'\') || vm.objDeclaracionPunto.observacion==null || vm.objDeclaracionPunto.observacion==\'\' || vm.objDeclaracionPunto.puntoNorte== null || vm.objDeclaracionPunto.puntoNorte==\'\' || vm.objDeclaracionPunto.puntoEste==\'\' || vm.objDeclaracionPunto.puntoEste == null\" ng-click=vm.guardarDeclaracionPunto()><i aria-hidden=true></i> Guardar</button></div></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-instrumento.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Instrumentos de Gestión Ambiental</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°</th><th class=text-center>Instrumento de Gestión</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.idInstrumentoGestion == item.idInstrumentoGestion, null: vm.idInstrumentoGestion != item.idInstrumentoGestion}\" dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Item>{{$index + 1}}</td><td data-label=\"Intrumento de Gestión\">{{item.auxTipoIgaNombre}}</td><td class=text-center data-label=Resolución>{{item.resolucion}}</td><td class=text-center data-label=Fecha>{{item.fechaAprobacion}}</td><td style=\"vertical-align: middle !important\" align=center><table><tr ng-repeat=\"itemdoc in item.lstIntrumentoGestionDoc\"><td class=text-center><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{itemdoc.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{itemdoc.idInstrumentoGestion}}/{{itemdoc.secuencia}}>{{itemdoc.nombreArchivo}}</a></td></tr></table></td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irInformeMonitoreo(item) type=button uib-tooltip=\"Informe de Monitoreo\"><span class=\"glyphicon glyphicon-cog\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo-archivo.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Editar Informe</h4></div><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-4\"><strong>Periodo </strong><input class=\"form-control input-sm\" type=text maxlength=20 ng-model=vm.objInformeMonitoreo.periodo disabled></div><div class=\"form-group col-lg-4\"><strong>Frecuencia</strong><select ng-model=vm.objInformeMonitoreo.frecuencia class=\"form-control input-sm\" disabled><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-lg-2\"><strong>N° Frecuencia</strong><select ng-model=vm.objInformeMonitoreo.numero_frecuencia class=\"form-control input-sm\" disabled><option ng-value=1>1</option><option ng-value=2>2</option><option ng-value=3>3</option><option ng-value=4>4</option><option ng-value=5>5</option><option ng-value=6>6</option><option ng-value=7>7</option><option ng-value=8>8</option><option ng-value=9>9</option><option ng-value=10>10</option><option ng-value=11>11</option><option ng-value=12>12</option></select></div></div><div class=row><div class=\"form-group col-md-12\"><strong>Archivo </strong><a download={{vm.objInformeMonitoreo.nombreArchivo}} href={{vm.urlData}}informeMonitoreo/descargar-informe/{{vm.objInformeMonitoreo.idInformeMonitoreo}}/{{vm.objInformeMonitoreo.idAdministrado}}/{{vm.objInformeMonitoreo.idInstalacion}} target=_blank>{{vm.objInformeMonitoreo.nombreArchivo}}</a></div></div><div class=row><div class=\"form-group col-md-12\"><strong>Cambiar </strong><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div></div><div class=row><div class=\"form-group col-lg-3\"><strong>Fecha Presentación</strong> <input type=date ng-model=vm.objInformeMonitoreo.fechaPresentacion class=\"form-control input-sm\"></div><div class=\"form-group col-lg-9\"><strong>Comentario</strong> <input class=\"form-control input-sm\" maxlength=4000 placeholder=\"Escriba un Comentario del informe de monitoreo\" ng-model=vm.objInformeMonitoreo.comentario type=text></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=false ng-click=vm.actualizarArchivo()><i aria-hidden=true></i> Guardar</button></div></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo-masivo.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Carga masiva del Informe de monitoreo ambiental</h4></div><br><div class=modal-body name=notificacionDialogForm><span class=content-box><div class=row><div class=\"form-group col-md-12\"><strong><p class=important-box>Archivo</p></strong><input class=\"form-control input-sm\" file-change=vm.validaDocumento id=fileArchivoInformeMonitoreo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }} Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() id=btnRegistrarInformeMasivo ng-disabled=true><i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i> Grabar</button></div></div><button id=btnRefrescar ng-click=vm.refrescar style=\"display: none\"></button></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-monitoreo.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Informe de Monitoreo Ambiental</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstalacion.numeroInstalacion}}</label><br><label>{{ vm.objInstalacion.direccion}}</label><br>{{vm.objInstalacion.distrito.descripcionDistrito}} - {{vm.objInstalacion.provincia.descripcion}} - {{vm.objInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #35bfb1; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Instrumento de Gestión</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstrumentoGestion.auxTipoIgaNombre}}</label><br><label>{{vm.objInstrumentoGestion.resolucion}}</label><br>{{vm.objInstrumentoGestion.fechaAprobacion}}</div></div><div class=row><div class=col-md-12><h3 class=title-slider-nt>Etapa del proyecto</h3></div></div><br><div class=row><uib-tabset active=vm.activeetapa type=pills><uib-tab ng-click=vm.cargarDeclaracionComponentes(item) ng-repeat=\"item in vm.lstEtapas\" heading={{item.descripcion}} index=$index><br></uib-tab></uib-tabset></div><div class=row><div class=col-md-12><h3 class=title-slider-nt>Datos del Informe <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.nuevoInformeMonitoreo() uib-tooltip=\"Agregar Informe de monitoreo\"><i aria-hidden=true class=\"glyphicon glyphicon-plus\"></i></button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.obtenerInformeEnsayo() uib-tooltip=\"Ver Informe de ensayo\"><i aria-hidden=true class=\"glyphicon glyphicon-search\"></i> Informe de ensayo</button></h3></div></div><br><div style=\"border-bottom: solid 1px #ddd\" ng-if=\"vm.acciones.nuevoInforme==true\"><div class=row><div class=\"form-group col-md-1\"><strong>Periodo</strong><select class=\"form-control input-sm\" ng-model=vm.objInformeMonitoreo.periodo><option value=\"\">--Seleccione--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-2\"><strong>Frecuencia</strong><select ng-model=vm.objInformeMonitoreo.frecuencia class=\"form-control input-sm\" ng-change=vm.cargarPeriodosHijos(vm.objInformeMonitoreo.frecuencia);><option ng-value=0>--Seleccione--</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><strong><span ng-if=\"vm.objInformeMonitoreo.frecuencia==0\">N° Frecuencia</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==1\">Mes</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==3\">Trimestre</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==4\">Semestre</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==5\">Anual</span></strong><select ng-model=vm.objInformeMonitoreo.numero_frecuencia class=\"form-control input-sm\"><option ng-value=0>--Seleccione--</option><option ng-repeat=\"itemCombo in vm.lstPeriodosHijos\" ng-value=itemCombo.descripcion>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><strong>Fecha Presentación</strong> <input type=date ng-model=vm.objInformeMonitoreo.fechaPresentacion class=\"form-control input-sm\"></div><div class=\"form-group col-md-2\"><strong>Componente</strong><div ng-repeat=\"item in vm.lstComponentesBase\">{{item.auxComponenteNombre}} <input type=checkbox ng-model=item.blSeleccionado ng-change=vm.elejirComponente(item)></div></div><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" file-change=vm.validaDocumentoInformeMonitoreo id=fileArchivoInformeMonitoreo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }} / Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-lg-1\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardarInforme() id=btnRegistrarInforme ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'REGISTRAR IMA\')\" ng-disabled=\"vm.objInformeMonitoreo.periodo==0||vm.objInformeMonitoreo.numero_frecuencia==0|| vm.listaArchivosInformeMonitoreo.length==0\"><i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i> Grabar</button></div></div></div><br><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°</th><th class=text-center>Periodo</th><th class=text-center>Frecuencia</th><th class=text-center>N° Frecuencia</th><th class=text-center>Componentes</th><th class=text-center>Fecha de Presentación</th><!-- <th class=\"text-center\">Comentario</th> --><th class=text-center>Estado</th><th class=text-center>Archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstInformesMonitoreo.length==0\"><td colspan=8 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objInformeSel.idInformeMonitoreo == item.idInformeMonitoreo, null: vm.objInformeSel.idInformeMonitoreo != item.idInformeMonitoreo}\" dir-paginate=\"item in vm.lstInformesMonitoreo | itemsPerPage: config.itemsPerPage\" pagination-id=cout4><td data-label=Item style=\"text-align: center; vertical-align: middle !important\">{{item.numeroItem}}</td><td class=text-center data-label=Periodo style=\"vertical-align: middle !important\">{{item.periodo}}</td><td class=text-center data-label=Frecuencia style=\"vertical-align: middle !important\">{{item.frecuenciaNombre}}</td><td class=text-center data-label=\"N° Frecuencia\" style=\"vertical-align: middle !important\"><div ng-show=\"item.numero_frecuencia == 1\">I</div><div ng-show=\"item.numero_frecuencia == 2\">II</div><div ng-show=\"item.numero_frecuencia == 3\">III</div><div ng-show=\"item.numero_frecuencia == 4\">IV</div><div ng-show=\"item.numero_frecuencia == 5\">V</div><div ng-show=\"item.numero_frecuencia == 6\">VI</div><div ng-show=\"item.numero_frecuencia == 7\">VII</div><div ng-show=\"item.numero_frecuencia == 8\">VIII</div><div ng-show=\"item.numero_frecuencia == 9\">IX</div><div ng-show=\"item.numero_frecuencia == 10\">X</div><div ng-show=\"item.numero_frecuencia == 11\">XI</div><div ng-show=\"item.numero_frecuencia == 12\">XII</div></td><td class=text-center style=\"vertical-align: middle !important\" data-label=Componentes>{{item.auxComponenteNombre}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Fecha de Presentación\">{{item.fechaPresentacionTexto}}</td><!-- <td style=\"vertical-align: middle !important;\"\r\n									class=\"text-center\" data-label=\"Comentario\">{{item.comentario}}</td> --><td style=\"vertical-align: middle !important\" class=text-center data-label=Estado><div ng-show=\"{{item.estado == 1}}\">Abierto</div><div ng-show=\"{{item.estado == 2}}\">Cerrado</div></td><td style=\"vertical-align: middle !important\" class=text-center data-label=Documento><a download={{item.nombreArchivo}} href={{vm.rutaBase}}informeMonitoreo/descargar-informe/{{item.idInformeMonitoreo}}/{{item.idAdministrado}}/{{item.idInstalacion}} target=_blank>{{item.nombreArchivo}}</a></td><td style=\"vertical-align: middle !important\" class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR IMA\')\" ng-click=vm.editarArchivoInforme(item) type=button uib-tooltip=Editar><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR IMA\')\" uib-tooltip=Eliminar ng-click=vm.confirmarEliminacionInforme(item)><i aria-hidden=true class=\"glyphicon glyphicon-trash\"></i></button> <button class=\"btn btn-default btn-sm\" ng-click=\"vm.verComponentes=true;vm.objInformeSel=item;vm.filtrarComponentes(item);\" type=button uib-tooltip=\"Detalle del Informe\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.abrirInformeMonitoreo(item) ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ABRIR IMA\')\" ng-show=\"item.estado==2\" uib-tooltip=\"Abrir Informe\"><i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'CERRAR IMA\')\" uib-tooltip=\"Cerrar Informe\" ng-click=vm.declaracion(item) ng-show=\"item.estado==1\"><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'CERRAR IMA\')\" uib-tooltip=\"Generar plantilla para carga masiva\" ng-click=vm.generarPlantillaMonitoreoMasivo(item) ng-show=\"item.estado==1\"><i aria-hidden=true class=\"glyphicon glyphicon-saved\"></i></button> <a class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'CERRAR IMA\')\" uib-tooltip=\"Descargar plantilla para carga masiva\" ng-show=\"item.estado==1 && (item.uuidplantilla!=null && item.uuidplantilla!=\'\')\" download=PlantillaMonitoreo.xlsx href={{vm.rutaBase}}reporte/descargar-plantilla-monitoreo/{{item.idInformeMonitoreo}} target=_blank><i aria-hidden=true class=\"glyphicon glyphicon-save\"></i> </a><button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'CERRAR IMA\')\" uib-tooltip=\"Cargar plantilla para carga masiva\" ng-click=vm.cargarPlantillaMonitoreoMasivo(item) ng-show=\"item.estado==1 && (item.uuidplantilla!=null && item.uuidplantilla!=\'\')\"><i aria-hidden=true class=\"glyphicon glyphicon-open\"></i></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout4></dir-pagination-controls></div></div></div><div class=row ng-show=vm.verComponentes><div class=col-md-12><h3 class=title-slider-nt>Resultados de Monitoreo</h3></div></div><br><div class=row ng-show=vm.verComponentes><div class=col-md-3><uib-tabset active=vm.active vertical=true type=pills style=\"border: solid 2px #35bfb1\" class=tabComponentes><uib-tab ng-click=vm.cargarDeclaracionPuntosMonitoreo(item); ng-repeat=\"item in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes\" heading={{item.auxComponenteNombre}} index=$index><br></uib-tab></uib-tabset><br></div><div class=col-md-9><div class=\"form-group col-lg-12 text-right\" ng-show=vm.verPuntosMonitoreo><button class=\"btn btn-flat btn-primary\" style=\"background-color: #144aa7 !important; color: white !important\" ng-click=vm.agregarDeclaracionPuntosMonitoreo() type=button><span class=icon-agregar>Agregar Puntos Monitoreo</span></button></div><div class=row ng-show=vm.verPuntosMonitoreo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center width=5% style=\"vertical-align: middle !important\">N°</th><th class=text-center width=8% style=\"vertical-align: middle !important\">C&oacute;digo</th><th class=text-center width=30% style=\"vertical-align: middle !important\">Descripci&oacute;n</th><th class=text-center width=8% style=\"vertical-align: middle !important\">Zona</th><th class=text-center width=10% style=\"vertical-align: middle !important\">Coordenadas UTM<br>(Datum WGS84)</th><th class=text-center width=8% style=\"vertical-align: middle !important\">Origen</th><th class=text-center width=5% style=\"vertical-align: middle !important\">Parámetros</th></tr></thead><tbody><tr ng-show=\"vm.lstDeclaracionPunto.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objDeclaracionPuntoMonitoreo.idPunto == item.idPunto, null: vm.objDeclaracionPuntoMonitoreo.idPunto != item.idPunto}\" dir-paginate=\"item in vm.lstDeclaracionPunto | itemsPerPage: config.itemsPerPage\" pagination-id=coutpuntos><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Código class=text-center>{{item.codigo}}</td><td data-label=Nombre>{{item.observacion}}</td><td data-label=Zona style=\"text-align: center\">{{item.idZona}}</td><td data-label=Coordenadas>NORTE: {{item.puntoNorte}}<br>ESTE: {{item.puntoEste}}</td><td data-label=Origen style=\"text-align: center\"><label ng-show=\"item.origen==\'I\'\">IMA</label><label ng-show=\"item.origen!=\'I\'\">IGA</label></td><td class=text-center data-label=Parámetros><button class=\"btn btn-default btn-sm\" ng-show=\"item.origen==\'I\'\" ng-click=vm.agregarDeclaracionPuntosMonitoreo(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-show=\"item.origen==\'I\'\" ng-click=vm.confirmarEliminacionPunto(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.cargarDeclaracionParametros(item) type=button uib-tooltip=\"Puntos de Monitoreo\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutpuntos></dir-pagination-controls></div></div></div></div></div></span><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div>");
$templateCache.put("app/modules/supervision/cargainformacion/informemonitoreo/cargainfo-informe-parametro.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Informe de Monitoreo - Componente: {{vm.prmComponente.auxComponenteNombre}}</h4></div></div><div class=modal-body name=parametroDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><caption style=\"font-weight: bolder\">Parámetros del Compromiso Ambiental</caption><thead><tr><th class=text-center style=\"vertical-align: middle !important\" width=10px>N°</th><th class=text-center style=\"vertical-align: middle !important\" width=120px>Componente</th><th class=text-center style=\"vertical-align: middle !important\" width=120px>Norma</th><th class=text-center ng-show=\"{{vm.prmComponente.auxComponenteNombre != \'RUIDO\'}}\" style=\"vertical-align: middle !important\" width=200px>Parámetro</th><th class=text-center ng-show=\"{{vm.prmComponente.auxComponenteNombre == \'RUIDO\'}}\" style=\"vertical-align: middle !important\" width=200px>Zonificación</th><th class=text-center style=\"vertical-align: middle !important\" width=100px>Periodo</th><th class=text-center style=\"vertical-align: middle !important\" width=40px>Valor (ECA/LMP)</th><!-- 	<th class=\"text-center\"\r\n									style=\"vertical-align: middle !important;\" width=\"40px\">Valor\r\n									Informe</th> --><th class=text-center style=\"vertical-align: middle !important\" width=40px>Unidad</th><th class=text-center style=\"vertical-align: middle !important\" width=40px>Valor Ensayo</th><th class=text-center ng-show=\"{{vm.prmComponente.auxComponenteNombre != \'RUIDO\'}}\" style=\"vertical-align: middle !important\" width=20px>¿Es no detectable?</th><!-- <th class=\"text-center\"\r\n									style=\"vertical-align: middle !important;\" width=\"70px\">Unidad\r\n									Ensayo</th> --><!-- 	<th class=\"text-center\"\r\n									style=\"vertical-align: middle !important;\" width=\"200px\">Comentario\r\n									Ensayo</th> --><th class=text-center ng-show=\"{{vm.prmComponente.auxComponenteNombre != \'RUIDO\'}}\" style=\"vertical-align: middle !important\" width=80px>Código Ensayo</th><th class=text-center style=\"vertical-align: middle !important\" width=20px>¿Acreditado?</th><th class=text-center style=\"vertical-align: middle !important\" width=7px>Seleccionar solo si ha reportado el parámetro</th><th class=text-center width=7px>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstParametrosComponenteBase.length==0\"><td colspan=16 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstParametrosComponenteBase | itemsPerPage: config.itemsPerPage\" pagination-id=cout2><td data-label=Item style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Componente>{{item.componenteNombre}}</td><td data-label=Norma>{{item.auxNormaNombre}}</td><td data-label=Nombre>{{item.auxParametroNombre}}</td><td data-label=Periodo>{{item.auxPeriodoNombre}}</td><td data-label=Valor class=text-center><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == \'RANGO\'}}\">Rango: {{item.auxValor}} a {{item.auxValor2}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == null || item.auxConcentracionTexto.toUpperCase() == \'\'}}\">{{item.auxValor}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() == \'<\'}}\">{{item.auxConcentracionTexto}} {{item.auxValor}}</div><div ng-show=\"{{item.auxConcentracionTexto.toUpperCase() != \'RANGO\' && item.auxConcentracionTexto.toUpperCase() != \'<\'}}\">{{item.auxConcentracionTexto.toUpperCase()}}</div></td><td data-label=\"Unidad Medida\">{{item.auxUnidadNombre}}</td><td data-label=\"Valor Ensayo\" class=text-center><select ng-model=item.valor_concentracion_ensayo_cod ng-show=\"item.lstConcetracionValores.length>0\" class=\"form-control input-sm\"><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in item.lstConcetracionValores\" ng-value={{itemCombo.codigoRegistro}}>{{itemCombo.descripcion}}</option></select><select ng-model=item.valor_concentracion_ensayo_cod ng-show=\"item.lstConcetracionValores.length==0\" class=\"form-control input-sm\"><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.lstConcetracion\" ng-value={{itemCombo.codigoRegistro}}>{{itemCombo.descripcion}}</option></select><input type=text class=\"text-center form-control input-sm\" ng-show=\"item.lstConcetracionValores.length==0\" ng-model=item.valor_ensayo></td><td class=text-center ng-show=\"{{vm.prmComponente.auxComponenteNombre != \'RUIDO\'}}\" data-label=\"¿No detectable?\"><input type=checkbox ng-model=item.bol_nodetectable></td><td data-label=\"Código Ensayo\" ng-show=\"{{vm.prmComponente.auxComponenteNombre != \'RUIDO\'}}\"><input type=text maxlength=50 ng-model=item.codigo_ensayo style=\"width: 100% !important\"> <button class=\"btn btn-default btn-sm\" ng-show=\"vm.objInformeMonitoreo.estado>=1 && vm.lstParametrosComponenteBase.length>0\" ng-click=vm.obtenerInformeEnsayo(item) type=button uib-tooltip=\"Informe Ensayo\"><span class=\"glyphicon glyphicon-search\"></span></button></td><td data-label=¿Acreditado?><select ng-model=item.flg_acreditado class=\"form-control input-sm\" id=acreditado name=acreditado><option value=0>NO</option><option value=1>SI</option><option value=2>NO PRECISA</option></select></td><td class=text-center width=10px><input type=checkbox ng-model=item.boolInforma></td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-show=\"vm.objInformeMonitoreo.estado==\'1\' && vm.lstParametrosComponenteBase.length>0\" ng-click=vm.confirmarEliminacionResultado(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout2></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.confirmarGuardar() ng-show=\"vm.objInformeMonitoreo.estado==\'1\' && vm.lstParametrosComponenteBase.length>0\"><i aria-hidden=true></i> Guardar</button></div></div></span></div>");
$templateCache.put("app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion-edicion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Unidad Fiscalizable {{ vm.dataInstalacion.numeroInstalacion}}</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>RUC</p></strong></div><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.dataInstalacion.idInstalacion != 0\" maxlength=11 ng-model=vm.dataInstalacion.ruc type=text></div><div class=\"form-group col-md-4\"><input class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.razonsocial type=text></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataInstalacion.idInstalacion == 0\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=\"vm.dataInstalacion.ruc.length<11\" ng-click=vm.validarRuc() type=button><span class=icon-check></span> Validar Ruc</button></div></div><uib-tabset active=vm.active ng-show=\"vm.mostrarNuevo==true\"><uib-tab heading=\"Datos de la Unidad Fiscalizable\" index=0><br><div ng-show=\"vm.mostrarInaps==false\"><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Nombre</p><label>(Raz&oacute;n social - Direcci&oacute;n)</label></strong></div><div class=\"form-group col-md-10\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=400 ng-model=vm.dataInstalacion.numeroInstalacion type=text></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Tipo establecimiento</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoEstablecimiento\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Estado</p></strong></div><div class=\"form-group col-md-3\"><div class=form-group><select ng-model=vm.dataInstalacion.estado ng-disabled=\"vm.RucValido==false\" class=\"form-control input-sm\" id=estado name=estado><option ng-value=1>CON ACTIVIDAD</option><option ng-value=0>SIN ACTIVIDAD</option></select></div></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Sector</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.changeSector() ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.sector><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSector\" ng-value=itemCombo.codigosector>{{itemCombo.sector}}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Subsector</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.changeSubSector() ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.subSector><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSubSector\" ng-value=itemCombo.codigosubsector>{{itemCombo.subsector}}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Competencia</p><span><label>(Para seleccionar más de una opción presione la tecla ctrl)</label></span></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" multiple ng-disabled=\"vm.RucValido==false\" ng-change=vm.changeCompetencia() ng-model=vm.dataInstalacion.competenciaArray><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaCompetencia\" ng-value=itemCombo.codigocompetencia>{{itemCombo.competencia}}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Actividad</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.actividad><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaActividad\" ng-value=itemCombo.codigoactividad>{{itemCombo.actividad}}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Departamento</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-change=\"vm.listarProvincia();vm.dataUbigeo.codigoProvincia = \'\';vm.dataUbigeo.codigoDistrito = \'\';\" ng-model=vm.dataInstalacion.departamento.codigoDepartamento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Provincia</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.listarDistrito() ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataInstalacion.provincia.codigoProvincia><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Distrito</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataInstalacion.distrito.codigoDistrito><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Dirección</p></strong></div><div class=\"form-group col-md-10\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=300 ng-model=vm.dataInstalacion.direccion type=text></div></div><div class=row><div class=\"form-group col-md-12\"><h6>Toda la información de Coordenadas debe estar en datum WGS-84 (UTM)</h6></div></div><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona class=important-box>Zona</label><select ng-disabled=\"vm.RucValido==false\" class=\"form-control input-sm\" id=tipoPersona ng-model=vm.dataInstalacion.idzona><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaZonas\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><label for=departamento class=important-box>Norte (7\'950,000 - 9\'999,900)</label><input class=\"form-control input-sm\" maxlength=10 name=distrito ng-disabled=\"vm.RucValido==false\" type=text onkeypress=\"return checkOnlyDigits(event)\" ng-model=vm.dataInstalacion.puntoNorte></div><div class=\"form-group col-md-3\"><label for=departamento class=important-box>Este (160,000 - 840,000)</label><input class=\"form-control input-sm\" maxlength=10 name=distrito type=text onkeypress=\"return checkOnlyDigits(event)\" ng-model=vm.dataInstalacion.puntoEste ng-disabled=\"vm.RucValido==false\"></div></div><div class=row><div class=\"form-group col-md-12\"><label for=distrito>Referencia</label><div class=form-group><input class=\"form-control input-sm\" maxlength=300 name=distrito ng- type=text ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.referencia></div></div></div><h3 class=title-slider-nt style=\"color: gray; font-weight: lighter\">Fichas de Registro de Hidrocarburos:</h3><br><div class=row><div class=\"form-group col-md-2\"><strong>Fichas de registro: <span title=Agregar class=icon-agregar ng-click=vm.agregarFichaxInstalacion()></span></strong></div><div class=\"form-group col-md-10\"><table><tr ng-repeat=\"item in vm.lstFichaxInstalacion\"><td class=text-center><a download={{item.ruta_ficha_registro}} href={{vm.urlData}}instalacion/descargar-ficha-registro/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.ficha_registro}} target=_blank>{{item.ficha_registro}}</a></td><td align=center><span class=\"glyphicon glyphicon-trash\" title=Eliminar ng-click=vm.eliminarDocumentoInstalacion($index)></span></td></tr></table></div></div><div class=row ng-show=vm.mostrarNuevoFicha><div class=\"form-group col-md-3\"><p>Número de registro:</p><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=50 ng-model=vm.dataDocumentoInstalacion.ficha_registro type=text></div><div class=\"form-group col-md-3\"><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumentoDetalle id=fileArchivoFicha multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-md-1\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnAgregarFicha ng-disabled=\"vm.dataDocumentoInstalacion.ficha_registro ==\'\' || vm.dataDocumentoInstalacion.ficha_registro==null || vm.listaArchivos.length == 0\" ng-click=vm.guardarFichaxInstalacion()>Añadir Ficha <i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i></button></div></div><span class=content-box><label class=important-box>(Campos Obligatorios)</label></span></div></uib-tab><uib-tab heading=\"Datos de Administrados\" index=2><br><div class=row><div class=\"form-group col-md-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-if=vm.blAgregarAdministrado ng-click=vm.agregarAdminxInstalacion() type=button><span class=icon-agregar></span> Transferir</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Ruc</th><th class=text-center>Razón social</th><th class=text-center>Vigente desde</th><th class=text-center>Vigente hasta</th><th class=text-center>¿Activo?</th><th class=text-center>Archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstAdminxInstalcion.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstAdminxInstalcion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Ruc>{{item.ruc}}</td><td data-label=\"Razón social\">{{item.razonsocial}}</td><td align=center data-label=\"Vigencia desde\">{{item.auxInicio}}</td><td align=center data-label=\"Vigencia hasta\">{{item.auxFin}}</td><td align=center data-label=¿Activo?><input type=checkbox ng-model=item.auxflgaactivo disabled></td><td align=center data-label=Archivo><a ng-show=\"item.uuid!=null && item.uuid!=\'\' \" class=\"glyphicon glyphicon-download-alt\" target=_blank download={{item.nombrearchivo}} href={{vm.rutaBase}}administradoXinstalaciontemp/descargar-archivo/{{item.ruc}}/{{item.idInstalacion}}/{{item.fechaInicioTexto}}>{{item.nombrearchivo}}</a></td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-if=vm.blAgregarAdministrado ng-click=vm.agregarAdminxInstalacion(item) type=button uib-tooltip=Editar><span class=\"glyphicon glyphicon-pencil\"></span></button> <button class=\"btn btn-default btn-sm\" ng-if=vm.blAgregarAdministrado ng-click=vm.eliminarAdminxInstlacion($index) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></uib-tab></uib-tabset><div ng-show=\"vm.mostrarInaps==true\"><div class=row><div class=\"form-group col-md-2\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarProvinciaInaps(); vm.filtroInstalacionINAPS.provincia.codigoProvincia = \'\';vm.filtroInstalacionINAPS.distrito.codigoDistrito = \'\'\" ng-model=vm.filtroInstalacionINAPS.departamento.codigoDepartamento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-2\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistritoInaps();vm.filtroInstalacionINAPS.distrito.codigoDistrito = \'\'\" ng-model=vm.filtroInstalacionINAPS.provincia.codigoProvincia><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-model=vm.filtroInstalacionINAPS.distrito.codigoDistrito><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscarInaps ng-click=vm.buscarInaps() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div></div><div class=row><div class=\"form-group col-md-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.seleccionarTodos(); ng-show=\"vm.verSelTodos==true\"><i aria-hidden=true></i> Seleccionar Todos</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.desSeleccionarTodos(); ng-show=\"vm.verSelTodos==false\"><i aria-hidden=true></i> Deseleccionar Todos</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center width=5% rowspan=1>N&#176;</th><th class=text-center width=10% rowspan=1>Nombre</th><th class=text-center width=5% rowspan=1>Dirección</th><th class=text-center width=5% rowspan=1>Distrito</th><th class=text-center width=5% rowspan=1>Provincia</th><th class=text-center width=10% rowspan=1>Departamento</th><th class=text-center width=15% rowspan=1>Sector</th><th class=text-center width=15% rowspan=1>Sub Sector</th><th class=text-center width=15% rowspan=1>Competencia</th><th class=text-center width=15% rowspan=1>Actividad</th><th class=text-center width=15% rowspan=1>Selección</th></tr></thead><tbody><tr ng-show=\"vm.listaUnidadesFiscalizablesExterno.length==0\"><td colspan=10>No se encontraron resultados</td></tr><tr dir-paginate=\"itemInstalacion in vm.listaUnidadesFiscalizablesExterno | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutListadoInstalacionExterno><td class=text-center data-label=N&#176;>{{itemInstalacion.numeroItem}}</td><td class=text-center data-label=Nombre width=5%>{{itemInstalacion.numeroInstalacion}}</td><td class=text-center data-label=Dirección width=5%>{{itemInstalacion.direccion}}</td><td class=text-center data-label=Distrito width=5%>{{itemInstalacion.distrito.descripcionDistrito}}</td><td class=text-center data-label=Provincia width=10%>{{itemInstalacion.provincia.descripcion}}</td><td class=text-center data-label=Departamento width=10%>{{itemInstalacion.departamento.descripcionDepartamento}}</td><td class=text-center data-label=Sector width=15%>{{itemInstalacion.sectorDescripcion}}</td><td class=text-center data-label=\"Sub Sector\" width=15%>{{itemInstalacion.subsectorDescripcion}}</td><td class=text-center data-label=Competencia width=15%>{{itemInstalacion.competenciaDescripcion}}</td><td class=text-center data-label=Actividad width=15%>{{itemInstalacion.actividadDescripcion}}</td><td class=text-center data-label=Acción width=20%><input type=checkbox ng-model=itemInstalacion.flgSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=coutListadoInstalacionExterno></dir-pagination-controls></div></div></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() id=btnGuardarInstalacion ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR UF\') && vm.blGuardar==true\" ng-disabled=\"((vm.RucValido==false || (vm.dataInstalacion.numeroInstalacion==null || vm.dataInstalacion.tipoEstablecimiento == 0 || \r\n				vm.dataInstalacion.sector == \'\' || vm.dataInstalacion.subSector == \'\' || vm.dataInstalacion.actividad == \'\' || \r\n				vm.dataInstalacion.departamento.codigoDepartamento == 0 || vm.dataInstalacion.provincia.codigoProvincia == 0 || vm.dataInstalacion.distrito.codigoDistrito == 0 ||\r\n				(vm.dataInstalacion.direccion == null || vm.dataInstalacion.direccion == \'\' ) || vm.dataInstalacion.puntoNorte == null || vm.dataInstalacion.puntoNorte == \'\' || vm.dataInstalacion.puntoEste == null || vm.dataInstalacion.puntoEste == \'\' || vm.dataInstalacion.idzona == 0)) &&  vm.mostrarInaps==false)\"><i aria-hidden=true class=\"glyphicon glyphicon-floppy-disk\"></i> Guardar</button> <button class=\"btn btn-primary btn-sm\" ng-click=closeThisDialog(0)><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i> Cerrar</button></div></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/cargainformacion/instalacion/cargainfo-instalacion.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Registro de Datos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Registro de Datos</li><li>Unidades Fiscalizables</li></ol></span></div></div><div class=row><div class=\"form-group col-md-2\"><label>RUC</label><input class=\"form-control input-sm\" type=text ng-model=vm.dataListaInstalacion.ruc></div><div class=\"form-group col-md-3\"><label>Administrado</label><input class=\"form-control input-sm\" type=text ng-model=vm.dataListaInstalacion.razonsocial></div><div class=\"form-group col-md-4\"><label>Direcci&oacute;n</label><input class=form-control type=text ng-model=vm.dataListaInstalacion.direccion></div></div><div class=row><div class=\"form-group col-md-3\"><label>Departamento</label><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-change=\"vm.listarProvincia();vm.dataUbigeo.codigoProvincia = \'\';vm.dataUbigeo.codigoDistrito = \'\';\" ng-model=vm.dataListaInstalacion.departamento.codigoDepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><label>Provincia</label><select class=\"form-control input-sm\" ng-change=vm.listarDistrito() ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataListaInstalacion.provincia.codigoProvincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><label>Distrito</label><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataListaInstalacion.distrito.codigoDistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div></div><div class=row><div class=\"form-group col-md-3\"><label>N&deg; Resoluci&oacute;n IGA</label><input class=form-control type=text ng-model=vm.dataListaInstalacion.resolucionIga></div><div class=\"form-group col-md-3\"><label>Tipo IGA</label><select class=\"form-control input-sm\" id=tipoIga name=tipoIga ng-model=vm.dataListaInstalacion.tipoIga><option value=\"\">Todos</option><option ng-repeat=\"itemCombo in vm.lstTipoIgas\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><label>Fecha aprobaci&oacute;n IGA</label><input class=form-control type=date ng-model=vm.dataListaInstalacion.fechaaprobacionIga></div><div class=\"input-group col-md-3\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnBuscar ng-click=vm.buscar() type=button uib-tooltip=Buscar><span class=\"glyphicon glyphicon-search\"></span> Buscar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO UF\')\" ng-click=vm.agregarInstalacion() type=button><span class=\"glyphicon glyphicon-plus\"></span> Agregar</button></div></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>RUC</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Administrado</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Unidad Fiscalizable</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Dirección</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Provincia</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Departamento</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Actividad</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2 width=10%>Acción</th><th style=\"background: #35bfb1\" class=text-center colspan=5>Mis Declaraciones</th></tr><tr><th class=text-center style=\"background: #35bfb1\">IGA</th><th class=text-center>IMA</th><th class=text-center>DMRS</th><th class=text-center>MRP</th><th class=text-center>Otros</th></tr></thead><tbody><tr ng-show=\"vm.listaInstalacionAdm.length==0\"><td colspan=15>No se encontraron resultados</td></tr><tr dir-paginate=\"itemInstalacion in vm.listaInstalacionAdm | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutListadoInstalacionAdm><td style=\"vertical-align: middle !important\" class=text-center data-label=N&#176;>{{itemInstalacion.numeroItem}}</td><td style=\"vertical-align: middle !important\" data-label=RUC>{{itemInstalacion.ruc}}</td><td style=\"vertical-align: middle !important\" data-label=Administrado>{{itemInstalacion.razonsocial}}</td><td style=\"vertical-align: middle !important\" data-label=\"Unidad Fiscalizable\">{{itemInstalacion.numeroInstalacion}}</td><td style=\"vertical-align: middle !important\" data-label=Dirección>{{itemInstalacion.direccion}}</td><td style=\"vertical-align: middle !important\" data-label=Distrito>{{itemInstalacion.distrito.descripcionDistrito}}</td><td style=\"vertical-align: middle !important\" data-label=Provincia>{{itemInstalacion.provincia.descripcion}}</td><td style=\"vertical-align: middle !important\" data-label=Departamento>{{itemInstalacion.departamento.descripcionDepartamento}}</td><td style=\"vertical-align: middle !important\" data-label=Actividad>{{itemInstalacion.actividadDescripcion}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR UF\')\" ng-click=vm.agregarInstalacion(itemInstalacion) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'VER UF\')\" ng-click=vm.agregarInstalacion(itemInstalacion) type=button uib-tooltip=Ver><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR UF\')\" ng-click=vm.confirmarEliminacion(itemInstalacion) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td><td style=\"background: #35bfb1; vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irCompromisos(itemInstalacion) ng-disabled=\"itemInstalacion.estado == 3 || itemInstalacion.estado == 5 \" type=button uib-tooltip=\"Mis Intrumentos de Gestión Ambiental\"><span class=\"glyphicon glyphicon-cog\"></span></button></td><td style=\"vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irInformeMonitoreo(itemInstalacion) ng-disabled=\"itemInstalacion.estado == 3 || itemInstalacion.estado == 5 \" type=button uib-tooltip=\"Mis Informes de Monitoreo Ambiental\"><span class=\"glyphicon glyphicon-list-alt\"></span></button></td><td style=\"vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irDeclaracionResiduos(itemInstalacion) type=button uib-tooltip=\"Mis Declaraciones de Manejo de Residuos Sólidos\"><span class=\"glyphicon glyphicon-cog\"></span></button></td><td style=\"vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irManifiestoResiduos(itemInstalacion) type=button uib-tooltip=\"Mis Manifiestos de Residuos Peligrosos\"><span class=\"glyphicon glyphicon-cog\"></span></button></td><td style=\"vertical-align: middle !important\" class=text-center data-label=\"Presentaciones (Documentos)\"><button class=\"btn btn-default btn-sm\" ng-click=vm.irPresentacion(itemInstalacion) type=button uib-tooltip=Documentos><span class=\"glyphicon glyphicon-cog\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutListadoInstalacionAdm></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/presentacion/dialog/presentacion-lista.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Presentaci&oacute;n de documentos</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N° Item</th><th class=text-center>Periodo</th><th class=text-center>Tipo Presentación</th><th class=text-center>Fecha Presentación</th><th class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">Mes Incidente</th><th class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">&iquest;Hubo incidente?</th><th class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">Fecha/hora incidencia</th><th class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">Lugar incidencia</th><th class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">Descripci&oacute;n incidencia</th><th class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">Observaciones incidencia</th><th class=text-center>Archivo</th></tr></thead><tbody><tr ng-show=\"vm.lstPresentacion.length==0\"><td colspan=12 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstPresentacion | itemsPerPage: config.itemsPerPage\" pagination-id=cout4><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Periodo class=text-center>{{item.periodo}}</td><td data-label=\"Tipo Presentación\" class=text-center>{{item.nombreTipoInforme}}</td><td data-label=\"Fecha Presentación\" class=text-center>{{item.fechapresentaciontexto}}</td><td data-label=\"Mes Incidente\" class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\"><div ng-show=\"item.codigoTipoInforme==7\"><div ng-if=\"item.numero_frecuencia==1\">ENERO</div><div ng-if=\"item.numero_frecuencia==2\">FEBRERO</div><div ng-if=\"item.numero_frecuencia==3\">MARZO</div><div ng-if=\"item.numero_frecuencia==4\">ABRIL</div><div ng-if=\"item.numero_frecuencia==5\">MAYO</div><div ng-if=\"item.numero_frecuencia==6\">JUNIO</div><div ng-if=\"item.numero_frecuencia==7\">JULIO</div><div ng-if=\"item.numero_frecuencia==8\">AGOSTO</div><div ng-if=\"item.numero_frecuencia==9\">SEPTIEMBRE</div><div ng-if=\"item.numero_frecuencia==10\">OCTUBRE</div><div ng-if=\"item.numero_frecuencia==11\">NOVIEMBRE</div><div ng-if=\"item.numero_frecuencia==12\">DICIEMBRE</div></div></td><td data-label=\"&iquest;Hubo incidente?\" class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\"><label ng-show=\"item.tiene_incidente==1\">SI</label><label ng-show=\"item.tiene_incidente==0\">NO</label><label ng-show=\"item.tiene_incidente!=1 && item.tiene_incidente!=0\">NO ESPECIFICA</label></td><td data-label=\"Fecha/hora incidencia\" class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">{{item.fechahora_incidente_texto}}</td><td data-label=\"Lugar incidencia\" class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">{{item.lugar_incidente}}</td><td data-label=\"Descripci&oacute;n incidencia\" ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\" class=text-center>{{item.descripcion_incidente}}</td><td data-label=\"Observaciones incidencia\" class=text-center ng-show=\"vm.prmPresentacion.codigoTipoInforme == 7\">{{item.observaciones_incidente}}</td><td data-label=Documento class=text-center><a download={{item.nombredocumento}} href={{vm.rutaBase}}instalacionPresentacion/descargar-documento/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.codigoTipoInforme}}/{{item.periodo}}/{{item.numero_frecuencia}} target=_blank>{{item.nombredocumento}}</a></td></tr></tbody></table><dir-pagination-controls pagination-id=cout4></dir-pagination-controls></div></div></div><div class=row><div class=col-md-12 ng-show=\"vm.lstPresentacion.length>0\"><div class=form-group><a id=btnExportar ng-show=\"vm.prmPresentacion.codigoTipoInforme==1\" ng-click=\"vm.exportarExcel(\'REP_SUP_DET_PC\')\" uib-tooltip=\"Exportar datos\">Exportar Excel </a><a id=btnExportar ng-show=\"vm.prmPresentacion.codigoTipoInforme==2\" ng-click=\"vm.exportarExcel(\'REP_SUP_DET_IAA\')\" uib-tooltip=\"Exportar datos\">Exportar Excel </a><a id=btnExportar ng-show=\"vm.prmPresentacion.codigoTipoInforme==3\" ng-click=\"vm.exportarExcel(\'REP_SUP_DET_PMR\')\" uib-tooltip=\"Exportar datos\">Exportar Excel </a><a id=btnExportar ng-show=\"vm.prmPresentacion.codigoTipoInforme==7\" ng-click=\"vm.exportarExcel(\'REP_SUP_DET_RI\')\" uib-tooltip=\"Exportar datos\">Exportar Excel</a></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/ima/dialog/informe-monitoreo-lista.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Informes de monitoreo</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Periodo</th><th class=text-center>Frecuencia</th><th class=text-center>N° de frecuencia</th><th class=text-center>Fecha de presentaci&oacute;n</th><th class=text-center>Componentes</th><th class=text-center>Estado</th></tr></thead><tbody><tr ng-show=\"vm.lstInformeMonitoreo.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstInformeMonitoreo | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=N°. style=\"text-align: center; vertical-align: middle !important\">{{item.numeroItem}}</td><td class=text-center data-label=Periodo style=\"vertical-align: middle !important\">{{item.periodo}}</td><td class=text-center data-label=Frecuencia style=\"vertical-align: middle !important\">{{item.frecuenciaNombre}}</td><td class=text-center data-label=\"N° Frecuencia\" style=\"vertical-align: middle !important\"><div ng-show=\"item.numero_frecuencia == 1\">I</div><div ng-show=\"item.numero_frecuencia == 2\">II</div><div ng-show=\"item.numero_frecuencia == 3\">III</div><div ng-show=\"item.numero_frecuencia == 4\">IV</div><div ng-show=\"item.numero_frecuencia == 5\">V</div><div ng-show=\"item.numero_frecuencia == 6\">VI</div><div ng-show=\"item.numero_frecuencia == 7\">VII</div><div ng-show=\"item.numero_frecuencia == 8\">VIII</div><div ng-show=\"item.numero_frecuencia == 9\">IX</div><div ng-show=\"item.numero_frecuencia == 10\">X</div><div ng-show=\"item.numero_frecuencia == 11\">XI</div><div ng-show=\"item.numero_frecuencia == 12\">XII</div></td><td class=text-center style=\"vertical-align: middle !important\" data-label=\"Fecha de Presentación\">{{item.fechaPresentacionTexto}}</td><td class=text-center style=\"vertical-align: middle !important\" data-label=Componentes>{{item.auxComponenteNombre}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=Estado><div ng-show=\"{{item.estado == 1}}\">Abierto</div><div ng-show=\"{{item.estado == 2}}\">Cerrado</div></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=col-md-12 ng-show=\"vm.lstInformeMonitoreo.length>0\"><div class=form-group><a id=btnExportar ng-click=\"vm.exportarExcel(\'REP_SUP_DET_IMA\')\" uib-tooltip=\"Exportar datos\">Exportar Excel</a></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/seguridad/usuarios/cambioclave/cambio-clave.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Cambio de clave usuario</span></h3></div></div><br><fieldset class=\"well unp-fieldset\"><div class=row><div class=\"form-group col-md-4\"><label for=numeroDocumento>Usuario:</label><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-model=vm.usuario.usuario type=text></div></div></div><div class=row><div class=\"form-group col-md-4\"><label for=numeroDocumento>Contraseña:</label><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-model=vm.usuario.clave type=password></div></div></div><div class=row><div class=\"form-group col-md-4\">Confirmación contraseña:</div></div></fieldset></span></div><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-model=vm.usuario.clave type=password></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() type=button uib-tooltip=\"Limpiar Filtros\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=vm.productoForm.$invalid type=button uib-tooltip=\"Cambiar Clave\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Aceptar</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.nuevo() uib-tooltip=\"Nuevo Usuario\"><span class=\"glyphicon glyphicon-plus-sign spac-btn-r\"></span> Cancelar</a></div></div>");
$templateCache.put("app/modules/seguridad/usuarios/listado/usuario-listado.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Listado usuarios</span></h3></div></div><br><fieldset class=\"well unp-fieldset\"><div class=row><div class=\"form-group col-md-3\"><label for=numeroDocumento>Nombre:</label><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-model=vm.dataUsuario.numeroDocumento type=text></div></div><div class=\"form-group col-md-3\"><label for=numeroDocumento>Número documento:</label><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-model=vm.dataUsuario.numeroDocumento type=text></div></div><div class=\"form-group col-md-3\"><label for=numeroDocumento>Perfil:</label><div class=form-group><select class=\"form-control input-sm\" id=singleSelect name=singleSelect ng-model=data.singleSelect><option value=\"\">--Seleccione--</option><option value={{data.option1}}>Administrador</option><option value=option-2>EFA</option><option value=option-2>Sinada</option></select></div></div><div class=\"form-group col-md-3\"><label for=numeroDocumento>Situación:</label><div class=form-group><select class=\"form-control input-sm\" id=singleSelect name=singleSelect ng-model=data.singleSelect><option value=\"\">--Seleccione--</option><option value={{data.option1}}>Activo</option><option value=option-2>Inactivo</option></select></div></div></div><div class=row><div class=\"col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar() type=button uib-tooltip=\"Limpiar Filtros\"><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" id=btnRef_recurso ng-click=vm.buscar() type=button uib-tooltip=\"Buscar Usuario\"><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button> <a class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.nuevo() uib-tooltip=\"Nuevo Usuario\"><span class=\"icon-nuevo spac-btn-r\"></span> Nuevo</a></div></div><div class=row><div class=col-md-12><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered table-striped table-app\" id=listaProductos width=100%><thead><tr><th class=text-center>Código</th><th class=text-center>Nombre</th><th class=text-center>Perfil</th><th class=text-center>Situación</th><th class=text-center width=90>Acción</th></tr></thead><tbody><tr dir-paginate=\"usuario in vm.listaUsuarios | filter : { \'nombre\' : vm.prmProducto.nombre} | itemsPerPage : vm.opcionesPaginacion.itemsPorPag | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Código>{{usuario.idUsuario}}</td><td data-label=Nombre>{{usuario.nombre}}</td><td class=text-center data-label=Perfil>{{usuario.perfil}}</td><td class=text-center data-label=Situación>{{usuario.situacion}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irRegistroUsuario() type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacion(itemProducto) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr><!--	<tr ng-show=\"vm.listaProducto == null || vm.listaProducto.length==0\">\r\n									<td colspan=\"5\">No se encontraron resultados</td>\r\n								</tr>--></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></fieldset></span></div>");
$templateCache.put("app/modules/seguridad/usuarios/registro/usuarios-registro.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Registro</span></h3></div></div><br><fieldset class=\"well unp-fieldset\"><legend class=unp-legend>Registro de usuario</legend><div class=row><div class=\"form-group col-md-6\"><label for=tipoPersona>Tipo de persona:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.dataUsuario.tipoPersona><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaTipoPersona\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div></div><div class=row><div class=\"form-group col-md-6\"><label for=tipoDocumento>Tipo de documento:</label><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-model=vm.tipoDocumento><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaTipoDocumento\" ng-value=itemCombo.codigoRegistro*1>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label class=important-box for=numeroDocumento>Nro de documento:</label><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-model=vm.dataPersona.documento placeholder=\"Ingrese nro de documento\" type=text></div></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label class=important-box for=numeroDocumento>Nro de documento:</label><div class=form-group><input class=\"form-control input-sm\" name=numeroDocumento ng-keyup=\"vm.dataUsuario.nombreUsuario=vm.dataEntidad.ruc\" ng-model=vm.dataEntidad.ruc placeholder=\"Ingrese nro de documento\" type=text></div></div><div class=\"input-group col-md-3\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label></label><div class=form-group><a class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.buscarPersonaXNumeroDocumento()><span class=icon-buscar></span> Buscar</a></div></div><div class=\"input-group col-md-3\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label></label><div class=form-group><a class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.buscarEntidadXNumeroDocumento()><span class=icon-buscar></span> Buscar</a></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=razonSocial>Razón social:</label><div class=form-group><input class=\"form-control input-sm\" name=razonSocial ng-disabled=true ng-model=vm.dataEntidad.razonSocial type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=cargo>Cargo:</label><div class=form-group><input class=\"form-control input-sm\" name=cargo ng-disabled=true ng-model=vm.dataEntidad.cargo type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=representanteLegal>Representante legal:</label><div class=form-group><input class=\"form-control input-sm\" name=representanteLegal ng-disabled=true ng-model=vm.dataEntidad.representanteLegal.idPersona type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=nombres>Nombres:</label><div class=form-group><input class=\"form-control input-sm\" name=nombres ng-disabled=true ng-model=vm.dataPersona.nombres type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=apellidoPaterno>Apellido paterno:</label><div class=form-group><input class=\"form-control input-sm\" name=apellidoPaterno ng-disabled=true ng-model=vm.dataPersona.apellidoPaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=apellidoMaterno>Apellido materno:</label><div class=form-group><input class=\"form-control input-sm\" name=apellidoMaterno ng-disabled=true ng-model=vm.dataPersona.apellidoMaterno type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=departamento>Departamento:</label><div class=form-group><input class=\"form-control input-sm\" name=departamento ng-disabled=true ng-model=vm.dataPersona.departamento type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=provincia>Provincia:</label><div class=form-group><input class=\"form-control input-sm\" name=provincia ng-disabled=true ng-model=vm.dataPersona.provincia type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=distrito>Distrito:</label><div class=form-group><input class=\"form-control input-sm\" name=distrito ng-disabled=true ng-model=vm.dataPersona.distrito type=text></div></div><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==1\"><label for=direccion>Dirección:</label><div class=form-group><input class=\"form-control input-sm\" name=direccion ng-disabled=true ng-model=vm.dataPersona.direccion type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-show=\"vm.dataUsuario.tipoPersona==2\"><label for=domicilio>Domicilio fiscal:</label><div class=form-group><input class=\"form-control input-sm\" name=domicilio ng-disabled=true ng-model=vm.dataEntidad.direccion type=text></div></div></div><div class=row><div class=\"form-group col-md-8\"><label for=telefono>Teléfono:</label><div class=form-group><input class=\"form-control input-sm\" name=telefono ng-disabled=flase ng-model=vm.dataUsuario.telefono placeholder=\"Agregar teléfono\" type=text></div></div></div><div class=row><div class=\"form-group col-md-8\"><label for=correo>Correo:</label><div class=form-group><input class=\"form-control input-sm\" name=correo ng-disabled=false ng-model=vm.dataUsuario.correo placeholder=\"Agregar Correo\" type=text></div></div></div><fieldset class=\"well unp-fieldset\"><legend class=unp-legend>Seguridad</legend><div class=row><div class=\"form-group col-md-6\" ng-class=\"{\'has-error\':usuarioRegistroForm.Usuario.$invalid && usuarioRegistroForm.Usuario.$touched}\"><label class=important-box for=Usuario>Usuario</label><div class=form-group><input class=\"form-control input-sm\" ng-model=vm.dataUsuario.nombreUsuario placeholder=\"Ingresar Usuario\" readonly required type=text></div></div></div><div class=row><div class=\"form-group col-md-6\" ng-class=\"{\'has-error\':usuarioRegistroForm.Clave.$invalid && usuarioRegistroForm.Clave.$touched}\"><label class=important-box for=Clave>Clave</label><div class=form-group><input class=\"form-control input-sm\" maxlength=12 ng-model=vm.dataUsuario.clave placeholder=\"Ingresar Clave\" required type=password></div></div></div><div class=row><div class=\"form-group col-md-6\"><label for=tipoPersona>Perfil:</label><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-model=vm.dataUsuario.perfil.idPerfil><option ng-value=0>Seleccione</option><option ng-repeat=\"itemCombo in vm.listaPerfil\" ng-value=itemCombo.idPerfil*1>{{itemCombo.nombrePerfil}}</option></select></div></div></fieldset></fieldset><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-disabled=vm.formUsuario.$invalid type=button><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Registrar</button> <a class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.limpiar()><span class=\"icon-limpiar spac-btn-r\"></span> Limpiar </a><button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-remove spac-btn-r\"></span> Cancelar</button></div></div></span></div>");
$templateCache.put("app/modules/supervision/online/autosupervision-online/autosupervision-online.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Autosupervisión</span></h3></div></div><br><!-- 		<uib-tabset active=\"active\"> --><!-- 			<uib-tab index=\"0\" heading=\"Presentacion\"> --><div class=row ng-if=\"vm.flagActivoCuestionario==0\"><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Ítem</th><th class=text-center>Cuestionario</th><th class=text-center>Fecha registro</th><th class=text-center>Ver información</th><!--<th class=\"text-center td-tabla-01\" >Accion</th>--></tr></thead><tbody><tr dir-paginate=\"item in vm.listaCuestionariosAutoSupervision | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Ítem>{{$index+1}}</td><td class=text-center data-label=Cuestionario>{{item.nombreCuestionario}}</td><td class=text-center data-label=\"Fecha registro\">{{item.fechaRegistro}}</td><td class=\"text-center td-tabla-01\" data-label=\"Ver información\"><button class=\"btn btn-default btn-sm\" ng-click=vm.visualizarPDF(item) type=button uib-tooltip=\"Ver Cuestionario\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.irCuestionario(item) type=button uib-tooltip=\"Ver archivos cuestionario\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td><!--\r\n													<td class=\"text-center td-tabla-01\">\r\n																	<button type=\"button\" class=\"btn btn-default btn-sm\" uib-tooltip=\"Editar Pregunta\" ng-click=\"vm.irCuestionario(item)\" >\r\n									                                	<span class=\"glyphicon glyphicon-eye-open\"></span>\r\n									                            	</button>\r\n\r\n									                            \r\n\r\n													</td>\r\n--></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><br><div class=row ng-if=\"vm.flagActivoCuestionario==1\"><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><th><center><h4><b>Archivos {{vm.dataCuestionarioAutosupervision.nombreCuestionario}}</b></h4></center></th></thead><tbody dir-paginate=\"itemPregunta in vm.dataCuestionarioAutosupervision.lstCuestionarioDetalle | itemsPerPage: config.itemsPerPage\" pagination-id=cout><tr ng-if=\"itemPregunta.pregunta.flagArchivo==1\"><td data-label=Archivos>{{$index+1}}	{{itemPregunta.pregunta.descripcion}}</td></tr><tr ng-if=\"itemPregunta.pregunta.flagArchivo==1\"><td class=text-center><div class=row><div class=col-md-12><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered table-striped table-app\" id=listaBandeja width=100%><thead><tr><th class=text-center>Ítem</th><th class=text-center>Descripción archivo</th><th class=text-center>Nombre archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr dir-paginate=\"itemArchivo in itemPregunta.lstArchivo | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Ítem>{{$index+1}}</td><td data-label=\"Descripción archivo\">{{itemArchivo.descripcion}}</td><td data-label=\"Nombre archivo\">{{itemArchivo.nombreArchivo}}</td><td class=text-center data-label=Acción><a class=\"btn btn-default btn-sm\" download={{itemArchivo.nombreArchivo}} href={{vm.rutaBase}}archivo/descargar-archivo/{{itemArchivo.idArchivo}} target=_blank type=button uib-tooltip=\"Descargar archivo\"><span class=\"glyphicon glyphicon-save\"></span> </a><!-- 											                <a class=\"btn btn-flat btn-default btn-sm\" href=\"{{itemArchivo.ruta}}\" download=\"{{itemArchivo.nombreArchivo}}\"> --><!-- 												                <span class=\"glyphicon glyphicon-download-alt\"></span>  --><!-- 												            </a> --></td></tr><tr ng-show=\"itemPregunta.lstArchivo  == null || itemPregunta.lstArchivo.length==0\"><td colspan=6>No se encontraron resultados</td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><!-- ********************************************************* --></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left\"></span> Regresar</button></div></div><!-- 			</uib-tab> --><!-- 	 </uib-tabset> --></span></div>");
$templateCache.put("app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-edicion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Instrumento de Gesti&oacute;n Ambiental</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><uib-tabset active=vm.active><uib-tab heading=\"Datos del IGA\" index=0><br><div class=row><div class=\"form-group col-md-5\"><strong><p class=important-box>Instrumentos de Gesti&oacute;n</p></strong><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-model=vm.prmIntrumentoGestion.idTipoInstrumento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.lstTipoIgas\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-3\"><strong><p>&iquest;Modifica otros IGAS?</p></strong><input id=esmodificatorio name=esmodificatorio ng-change=vm.mostrarIGASModificacion() ng-model=vm.prmIntrumentoGestion.blModificaIga type=checkbox></div><div class=\"form-group col-md-3\"><strong><p>&iquest;IGA Vigente?</p></strong><input id=esvigente name=esvigente ng-model=vm.prmIntrumentoGestion.blVigente type=checkbox></div></div><br><div class=row><div class=\"form-group col-md-5\"><strong><p class=important-box>Resoluci&oacute;n de Aprobaci&oacute;n</p></strong><p><input ng-model=vm.prmIntrumentoGestion.resolucion class=\"form-control input-sm\" type=text maxlength=200></p></div><div class=\"form-group col-md-3\" ng-if=vm.blEditar><strong><p>&iquest;Est&aacute; el IGA completo?</p></strong><input id=escompleto name=escompleto ng-model=vm.prmIntrumentoGestion.blCompleto type=checkbox></div><div class=\"form-group col-md-3\" ng-if=vm.blEditar><strong><p>&iquest;Se revis&oacute; el IGA?</p></strong><input id=esrevisado name=esrevisado ng-disabled=!vm.blRevisar ng-model=vm.prmIntrumentoGestion.blRevisado type=checkbox></div></div><br><div class=row><div class=\"form-group col-md-5\"><strong><p class=important-box>Fecha de Aprobaci&oacute;n</p></strong><p><input class=\"form-control input-sm\" type=date ng-model=vm.prmIntrumentoGestion.fecha></p></div></div><div class=row><div class=\"form-group col-md-12\"><strong><p class=important-box>Descripci&oacute;n del instrumento</p></strong><p><input ng-model=vm.prmIntrumentoGestion.descripcion maxlength=2000 class=\"form-control input-sm\" type=text></p></div></div></uib-tab><uib-tab heading=\"IGAS Modificados\" index=1 ng-show=vm.prmIntrumentoGestion.blModificaIga><br><div class=row><div class=\"form-group col-md-12\"><strong><p>Comentario</p></strong><p><input ng-model=vm.prmIntrumentoGestion.observacion class=\"form-control input-sm\" type=text maxlength=4000></p></div></div><div class=row><div class=\"form-group col-md-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.mostrarIGASModificacion() type=button ng-show=vm.prmIntrumentoGestion.blModificaIga><span class=icon-agregar></span> Agregar</button></div></div><div class=row ng-show=vm.prmIntrumentoGestion.blModificaIga><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Tipo</th><th class=text-center>Resoluci&oacute;n de Aprobaci&oacute;n</th><th class=text-center>Fecha de Aprobaci&oacute;n</th><th class=text-center>Documento</th><th class=text-center>Acci&oacute;n</th></tr></thead><tbody><tr ng-show=\"vm.prmIntrumentoGestion.lstIntrumentoGestionMod.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmIntrumentoGestion.lstIntrumentoGestionMod | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resoluci&oacute;n>{{item.resolucion}}</td><td data-label=Fecha>{{item.fechaAprobacion}}</td><td style=\"vertical-align: middle !important\" align=center><table><tr ng-repeat=\"itemdoc in item.lstIntrumentoGestionDoc\"><td class=text-center><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{itemdoc.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{itemdoc.idInstrumentoGestion}}/{{itemdoc.secuencia}}>{{itemdoc.nombreArchivo}}</a></td></tr></table></td><td align=center data-label=Acci&oacute;n><button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarIGAModificado($index) ng-disabled=false type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></uib-tab><uib-tab heading=Archivos index=2><br><div class=row><div class=\"form-group col-md-5\"><strong><p class=important-box>Archivo</p></strong><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivoMedio multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div></div><div class=row><div class=\"form-group col-md-5\"><strong>Seleccionados</strong></div></div><div class=row><div class=\"form-group col-md-10\"><table><tr ng-repeat=\"item in vm.prmIntrumentoGestion.lstIntrumentoGestionDoc\"><td class=text-center><span ng-show=\"item.secuencia == 0 ||\r\n					                   item.archivoNombre == \'\'\">{{item.nombreArchivo}}</span> <a class=\"glyphicon glyphicon-download-alt\" target=_blank ng-show=\"item.secuencia != 0 &&\r\n							                   item.archivoNombre != \'\'\" download={{item.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{item.idInstrumentoGestion}}/{{item.secuencia}}>{{item.nombreArchivo}}</a></td><td align=center><span class=\"glyphicon glyphicon-trash\" ng-click=vm.confirmareliminarDocumentoIga($index) title=Eliminar></span></td></tr></table></div></div></uib-tab></uib-tabset><span class=content-box><label class=important-box>(Campos Obligatorios)</label></span><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() id=btnGuardarIGA ng-disabled=\"vm.prmIntrumentoGestion.idTipoInstrumento == 0 || vm.prmIntrumentoGestion.resolucion== \'\' || vm.prmIntrumentoGestion.resolucion==null ||  vm.prmIntrumentoGestion.fecha == null || \r\n						vm.prmIntrumentoGestion.fecha == \'\' || (vm.listaArchivosIGA.length == 0 && vm.prmIntrumentoGestion.idInstrumentoGestion == 0) || vm.prmIntrumentoGestion.descripcion == \'\' || vm.prmIntrumentoGestion.descripcion == null \"><i aria-hidden=true class=\"glyphicon glyphicon-floppy-disk\"></i> Grabar</button></div></div><button id=btnRefrescar ng-click=vm.refrescar style=\"display: none\"></button></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion-selector.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector Instrumento de Gestión Ambiental</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row ng-show=vm.selIgamultiple><div class=\"form-group col-md-12\"><strong>Activar la casilla en caso no se cuente con el instrumento de gestión ambiental </strong><input ng-change=vm.mostrarComentarioModificacion() ng-model=vm.mostrarComentario type=checkbox></div></div><div class=row ng-show=\"vm.mostrarComentario && vm.selIgamultiple\"><div class=\"form-group col-md-12\"><strong><p>Por favor ingresar una observación para este caso</p></strong><input ng-model=vm.comentarioMod class=\"form-control input-sm\" type=text maxlength=4000 multiple></div></div><div class=row ng-show=!vm.mostrarComentario><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Tipo</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th><th class=text-center>Seleccionar</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución>{{item.resolucion}}</td><td data-label=Fecha>{{item.fechaAprobacion}}</td><!-- <td align=\"center\"><a\r\n										class=\"glyphicon glyphicon-download-alt\" target=\"_blank\"\r\n										download=\"{{item.archivoNombre}}\"\r\n										href=\"{{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{item.idInstrumentoGestion}}\">\r\n											{{item.archivoNombre}}</a></td> --><td style=\"vertical-align: middle !important\" align=center><table><tr ng-repeat=\"itemdoc in item.lstIntrumentoGestionDoc\"><td class=text-center><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{itemdoc.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{itemdoc.idInstrumentoGestion}}/{{itemdoc.secuencia}}>{{itemdoc.nombreArchivo}}</a></td></tr></table></td><td align=center data-label=Acción><input ng-show=vm.selIgamultiple type=checkbox ng-model=item.blSeleccionado> <button class=\"btn btn-default btn-sm\" ng-show=!vm.selIgamultiple ng-click=vm.seleccionar(item) type=button uib-tooltip=Seleccionar><span class=\"glyphicon glyphicon-check\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() ng-show=vm.selIgamultiple ng-disabled=\"vm.lstInstrumentosGestion.length==0 && (vm.comentarioMod == null || vm.comentarioMod ==\'\')\"><i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i> Aceptar</button></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/cargainformacion/instrumento-gestion/cargainfo-instrumento-gestion.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Instrumentos de Gestión Ambiental</span></h3></div></div><br><div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.nuevoIGA() ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO IGA\')\"><span class=\"glyphicon glyphicon-plus\"></span> Nuevo IGA</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°</th><th class=text-center>Instrumento Gesti&oacute;n</th><th class=text-center>Resoluci&oacute;n de Aprobaci&oacute;n</th><th class=text-center>Fecha de Aprobaci&oacute;n</th><th class=text-center>&iquest;Vigente?</th><th class=text-center>&iquest;Completo?</th><th class=text-center>&iquest;Revisado?</th><th class=text-center>Documento</th><th class=text-center>Acci&oacute;n</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.idInstrumentoGestion == item.idInstrumentoGestion, null: vm.idInstrumentoGestion != item.idInstrumentoGestion}\" dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td style=\"vertical-align: middle !important\" class=text-center data-label=Item>{{$index + 1}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=Resoluci&oacute;n>{{item.resolucion}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=Fecha>{{item.fechaAprobacion}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=&iquest;Vigente?><label ng-if=\"item.flgvigente==1\">SI</label></td><td style=\"vertical-align: middle !important\" class=text-center data-label=&iquest;Completo?><label ng-if=\"item.flgcompleto==1\">SI</label></td><td style=\"vertical-align: middle !important\" class=text-center data-label=&iquest;Revisado?><div class=text-center style=\"width: 100%; height: 20px; background-color: yellow\" ng-if=\"item.flgrevisado==1\"><label>SI</label></div><div class=text-center style=\"width: 100%; height: 20px; background-color: red; color: white\" ng-if=\"item.flgrevisado!=1\"><label>NO</label></div></td><td style=\"vertical-align: middle !important\" align=center><table><tr ng-repeat=\"itemdoc in item.lstIntrumentoGestionDoc\"><td class=text-center><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{itemdoc.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{itemdoc.idInstrumentoGestion}}/{{itemdoc.secuencia}}>{{itemdoc.nombreArchivo}}</a></td></tr></table></td><td style=\"vertical-align: middle !important\" align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irDeclaracion(item) type=button uib-tooltip=\"Declaraci&oacute;n de la Informaci&oacute;n\"><span class=\"glyphicon glyphicon-cog\"></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'EDITAR IGA\')\" ng-click=vm.nuevoIGA(item) ng-disabled=false type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'VER IGA\')\" ng-click=vm.nuevoIGA(item) ng-disabled=false type=button uib-tooltip=Ver><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR IGA\')\" ng-click=vm.confirmarEliminacion(item) ng-disabled=false type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'COPIAR IGA\') && item.cantDeclaracion>0\" ng-click=vm.seleccionarcopiarIGA(item) ng-disabled=false type=button uib-tooltip=Copiar><span class=\"glyphicon glyphicon-copy\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/residuo/dialog/residuo-lista.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Declaraci&oacute;n de residuos s&oacute;lidos</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>N°</th><th style=\"text-align: center\" width=10%>Periodo</th><th style=\"text-align: center\" width=10% ng-show=\"vm.prmResiduo.tipo==\'MR\'\">Frecuencia</th><th style=\"text-align: center\" width=10% ng-show=\"vm.prmResiduo.tipo==\'MR\'\">N° Frecuencia</th><th style=\"text-align: center\" width=10%>Fecha Presentación</th><th style=\"text-align: center\" width=10% ng-show=\"vm.prmResiduo.tipo==\'MR\'\">Cantidad (TN)</th><th style=\"text-align: center\" width=10% ng-show=\"vm.prmResiduo.tipo==\'DR\'\">Peligrosos (TN)</th><th style=\"text-align: center\" width=10% ng-show=\"vm.prmResiduo.tipo==\'DR\'\">Otros (TN)</th><th style=\"text-align: center\" width=20%>Documento</th></tr></thead><tbody><tr ng-show=\"vm.lstResiduos.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstResiduos | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduo><td data-label=\"N° Item\" style=\"text-align: center\">{{vm.lstResiduos.indexOf(item) + 1}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Frecuencia style=\"text-align: center\" ng-show=\"vm.prmResiduo.tipo==\'MR\'\">{{item.frecuenciaNombre}}</td><td data-label=\"N° Frecuencia\" style=\"text-align: center\" ng-show=\"vm.prmResiduo.tipo==\'MR\'\"><div ng-show=\"item.numero_frecuencia == 1\">I</div><div ng-show=\"item.numero_frecuencia == 2\">II</div><div ng-show=\"item.numero_frecuencia == 3\">III</div><div ng-show=\"item.numero_frecuencia == 4\">IV</div></td><td data-label=\"Fecha Presentación\" style=\"text-align: center\">{{item.fechapresentaciontexto}}</td><td data-label=\"Peligrosos (TN)\" style=\"text-align: center\" ng-show=\"vm.prmResiduo.tipo==\'DR\'\">{{item.peligrosos}}</td><td data-label=\"Otros (TN)\" style=\"text-align: center\" ng-show=\"vm.prmResiduo.tipo==\'DR\'\">{{item.otros}}</td><td data-label=\"Cantidad (TN)\" style=\"text-align: center\" ng-show=\"vm.prmResiduo.tipo==\'MR\'\">{{item.cantTotal}}</td><td data-label=Documento style=\"text-align: center\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{item.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{item.idresiduo}}>{{item.nombredocumento}}</a></td></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduo></dir-pagination-controls></div></div></div><div class=row><div class=col-md-12 ng-show=\"vm.lstResiduos.length>0\"><div class=form-group><a id=btnExportar ng-show=\"vm.prmResiduo.tipo==\'DR\'\" ng-click=\"vm.exportarExcel(\'REP_SUP_DET_DRS\')\" uib-tooltip=\"Exportar datos\">Exportar Excel </a><a id=btnExportar ng-show=\"vm.prmResiduo.tipo==\'MR\'\" ng-click=\"vm.exportarExcel(\'REP_SUP_DET_MRS\')\" uib-tooltip=\"Exportar datos\">Exportar Excel</a></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/iga/dialog/instrumento-gestion-ambiental.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Instrumento de Gesti&oacute;n Ambiental</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><uib-tabset active=vm.active><uib-tab heading=\"Datos del IGA\" index=0><br><div class=row><div class=\"form-group col-md-5\"><strong><p>Tipo de Instrumentos de Gestión</p></strong><select class=\"form-control input-sm\" id=tipoDocumento name=tipoDocumento ng-model=vm.prmIntrumentoGestion.idTipoInstrumento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.lstTipoIgas\" ng-value=itemCombo.codigo>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-7\"><strong><p>¿Modifica otros IGAS?</p></strong><input id=esmodificatorio name=esmodificatorio ng-change=vm.mostrarIGASModificacion() ng-model=vm.prmIntrumentoGestion.blModificaIga type=checkbox></div></div><br><div class=row><div class=\"form-group col-md-5\"><strong><p>Resoluci&oacute;n de Aprobaci&oacute;n</p></strong><p><input ng-model=vm.prmIntrumentoGestion.resolucion class=\"form-control input-sm\" type=text></p></div></div><br><div class=row><div class=\"form-group col-md-5\"><strong><p>Fecha de Aprobaci&oacute;n</p></strong><p><input class=\"form-control input-sm\" type=date ng-model=vm.prmIntrumentoGestion.fecha></p></div><div class=\"form-group col-md-5\"><strong><p>Archivo</p></strong><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivoMedio multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div><a class=icon-ficha target=_blank ng-show=\"vm.prmIntrumentoGestion.idInstrumentoGestion != 0 &&\r\n					                   vm.prmIntrumentoGestion.archivoNombre != \'\'\" download={{vm.prmIntrumentoGestion.archivoNombre}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{vm.prmIntrumentoGestion.idInstrumentoGestion}}>{{vm.prmIntrumentoGestion.archivoNombre}}</a></div></div><div class=row><div class=\"form-group col-md-12\"><strong><p>Descripción del Instrumento</p></strong><p><input ng-model=vm.prmIntrumentoGestion.descripcion class=\"form-control input-sm\" type=text></p></div></div></uib-tab><uib-tab heading=\"IGAS Modificados\" index=1 ng-show=vm.prmIntrumentoGestion.blModificaIga><br><div class=row><div class=\"form-group col-md-2 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.mostrarIGASModificacion() type=button ng-show=vm.prmIntrumentoGestion.blModificaIga><span class=icon-agregar></span> Agregar</button></div></div><div class=row ng-show=vm.prmIntrumentoGestion.blModificaIga><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Tipo</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.prmIntrumentoGestion.lstIntrumentoGestionMod.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.prmIntrumentoGestion.lstIntrumentoGestionMod | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución>{{item.resolucion}}</td><td data-label=Fecha>{{item.fechaAprobacion}}</td><td align=center><a class=icon-ficha target=_blank download={{item.archivoNombre}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{item.id_InstrumentoGestionMod}}>{{item.archivoNombre}}</a></td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.eliminarIGAModificado($index) ng-disabled=false type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></uib-tab></uib-tabset><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.guardar()><i aria-hidden=true></i> Grabar</button></div></div></span></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/iga/dialog/instrumento-gestion-lista.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Instrumentos de Gestión Ambiental</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Tipo</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=5 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución>{{item.resolucion}}</td><td data-label=Fecha>{{item.fechaAprobacion}}</td><td align=center><a class=icon-ficha target=_blank download={{item.archivoNombre}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{item.idInstrumentoGestion}}>{{item.archivoNombre}}</a></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row><div class=col-md-12 ng-show=\"vm.lstInstrumentosGestion.length>0\"><div class=form-group><a id=btnExportar ng-click=\"vm.exportarExcel(\'REP_SUP_DET_IGA\')\" uib-tooltip=\"Exportar datos\">Exportar Excel</a></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/iga/dialog/instrumento-gestion-selector.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Selector Instrumento de Gestión Ambiental</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-7\"><strong><p>Activar en caso no se cuenta con el instrumento de gestión ambiental</p></strong><input ng-change=vm.mostrarComentarioModificacion() ng-model=vm.mostrarComentario type=checkbox></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Tipo</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th><th class=text-center>Seleccionar</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución>{{item.resolucion}}</td><td data-label=Fecha>{{item.fechaAprobacion}}</td><td align=center><a class=icon-ficha target=_blank download={{item.archivoNombre}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{item.idInstrumentoGestion}}>{{item.archivoNombre}}</a></td><td align=center data-label=Acción><input type=checkbox ng-model=item.blSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row ng-show=\"vm.lstInstrumentosGestion.length>0\"><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.guardar()><i aria-hidden=true></i> Aceptar</button></div></div></div></span></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/preguntas/registro/agregar-normativa/agregar-normativa-dialog.html","<div><div class=modal-header ng-show=\"vm.flagBusquedaContenido==0\"><h4 class=\"modal-title title-msg-conf\">Listados de normativas</h4></div><div class=modal-header ng-show=\"vm.flagBusquedaContenido==1\"><h4 class=\"modal-title title-msg-conf\">Listados de artículos</h4></div><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row ng-show=\"vm.flagBusquedaContenido==0\"><div class=\"form-group col-md-12\"><label>Nombre de normativa</label></div><div class=\"form-group col-md-4\"><label for=numeroDocumento>Dispositivo:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=30 name=numeroDocumento ng-model=vm.dataNormas.nombreTipoDispositivo placeholder=\"Ingrese dispositivo\" type=text></div></div><div class=\"form-group col-md-4\"><label for=numeroDocumento>Nro. Norma:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=11 name=numeroDocumento ng-model=vm.dataNormas.numeroNorma placeholder=\"Ingrese número de norma\" type=text></div></div><div class=\"form-group col-md-4\"><label for=numeroDocumento>Normativa:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=100 name=numeroDocumento ng-model=vm.dataNormas.descripcion placeholder=\"Ingrese normativa\" type=text></div></div><div class=\"form-group col-md-10\"></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.listarNormas() ng-disabled=vm.formUsuario.$invalid type=button><span class=icon-buscar></span> Buscar</button></div></div><div class=row ng-show=\"vm.flagBusquedaContenido==0\"><div class=\"form-group col-md-12\"><div class=table-rpv><table cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th>Dispositivo</th><th>Nro. Norma</th><th>Normativa</th><th>Acción</th></tr></thead><tbody><tr dir-paginate=\"itemNormativa in vm.listaNormativas | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Ítem>{{itemNormativa.nombreTipoDispositivo}}</td><td data-label=Num_Norma>{{itemNormativa.numeroNorma}}</td><td data-label=Normativa>{{itemNormativa.descripcion}}</td><td data-label=Acción><!-- 			                      <button type=\"button\" class=\"btn btn-default btn-sm\" uib-tooltip=\"Agregar Normativa\" ng-model=\"itemEFA.seleccionado\" ng-click=\"vm.registrarNormaCaso(itemNormativa)\" > --><!-- 	                                 <span class=\"glyphicon glyphicon-plus\"></span> --><!-- 	                               	</button> --> <button class=\"btn btn-default btn-sm\" ng-click=vm.buscarContenido(itemNormativa) ng-model=itemEFA.seleccionado type=button uib-tooltip=\"Buscar Contenido\"><span class=icon-buscar></span></button></td></tr><tr ng-show=\"vm.listaNormativas == null || vm.listaNormativas.length==0\"><td colspan=6 style=\"text-align: left\">No hay normativas seleccionadas.</td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div><div class=row ng-show=\"vm.flagBusquedaContenido==1\"><!--		<div >\r\n				<div class=\"form-group col-md-9\">\r\n					<label>Descripci&oacute;n art&iacute;culo</label>\r\n				</div>\r\n\r\n				<div class=\"form-group col-md-8\" >\r\n									<label for=\"numeroDocumento\" class=\"important-box\">Pregunta:</label>\r\n									<div class=\"form-group\">\r\n										<input ng-model=\"vm.prmFiltroContenidoNorma.descripcionArticulo\" type=\"text\"  class=\"form-control input-sm\"  name=\"numeroDocumento\" placeholder=\"Ingrese pregunta\" >\r\n									</div>\r\n				</div>	\r\n\r\n\r\n				\r\n				<div class=\"form-group col-md-3\">\r\n					 <button type=\"button\" ng-disabled=\"vm.formUsuario.$invalid\" ng-click=\"vm.listarContenidoNorma()\" class=\"btn btn-flat btn-primary btn-sm\">\r\n	                	<span class=\"icon-buscar\"></span> Buscar\r\n	            	</button>\r\n				</div>\r\n				\r\n				\r\n			</div>\r\n		--><div class=\"form-group col-md-12\"><label>Nombre de artículo</label></div><div class=\"form-group col-md-4\"><label for=numeroDocumento>Nro. artículo:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=20 name=numeroDocumento ng-model=vm.contenidoNorma.numeroArticulo placeholder=\"Ingrese número de artículo\" type=text></div></div><div class=\"form-group col-md-8\"><label for=numeroDocumento>Descripci&oacute;n artículo:</label><div class=form-group><input class=\"form-control input-sm\" maxlength=200 name=numeroDocumento ng-model=vm.contenidoNorma.descripcionArticulo placeholder=\"Ingrese descripción artículo\" type=text></div></div><div class=\"form-group col-md-10\"></div><div class=\"form-group col-md-2\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.listarContenidoNorma() ng-disabled=vm.formUsuario.$invalid type=button><span class=icon-buscar></span> Buscar</button></div><div class=col-md-12><div class=\"form-group table-responsive\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>Código</th><th class=text-center>Norma</th><th class=\"text-center td-tabla-00\">Nro. artículo</th><th class=\"text-center td-tabla-01\" width=200>Descripci&oacute;n artículo</th><th class=\"text-center td-tabla-02\">Estado</th><th class=\"text-center td-tabla-02\">Acción</th></tr></thead><tbody><tr dir-paginate=\"itemNormaContenido in vm.listaContenidoNorma | itemsPerPage: config.itemsPerPage\" ng-show=\"itemNormaContenido.idContenidoNorma!=vm.contenidoNormaModificar.idContenidoNorma\" pagination-id=cout><td class=text-center data-label=Código>{{itemNormaContenido.idContenidoNorma}}</td><td data-label=Norma>{{itemNormaContenido.numeroNorma}}</td><td class=text-center data-label=\"Nro. artículo\">{{itemNormaContenido.numeroArticulo}}</td><td class=text-center data-label=\"Des. artículo\">{{itemNormaContenido.descripcionArticulo}}</td><td class=text-center data-label=Estado>{{itemNormaContenido.nombreEstado}}</td><td class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.registrarPreguntaNormativa(itemNormaContenido) type=button uib-tooltip=Seleccionar><span class=\"glyphicon glyphicon-ok-circle\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></div><div class=row ng-show=\"vm.flagBusquedaContenido==1\"><div class=\"form-group col-md-3 pull-left\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=\"vm.flagBusquedaContenido=0\" ng-disabled=vm.formUsuario.$invalid type=button><span class=\"glyphicon glyphicon-arrow-left\"></span> Regresar</button></div></div><div class=row ng-show=\"vm.flagBusquedaContenido==0\"><div class=\"form-group col-md-3 pull-left\"><button class=\"btn btn-flat btn-primary btn-sm\" ng-click=vm.cancelar() ng-disabled=vm.formUsuario.$invalid type=button><span class=\"glyphicon glyphicon-remove\"></span> Cancelar</button></div></div></span></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/supervision/online/presentacion/presentacion.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Presentación de Documentos</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div style=\"border-bottom: solid 1px #ddd\"><div class=row ng-show=!vm.verNuevo><div class=\"form-group col-md-2\"><label>Tipo Presentación</label><select class=\"form-control input-sm\" ng-change=\"vm.prmPresentacionFiltro.periodo=0; vm.prmPresentacionFiltro.numero_frecuencia=0\" ng-model=vm.prmPresentacionFiltro.codigoTipoInforme><option ng-value=0>--Todos--</option><option ng-repeat=\"item in vm.lstTipoPresentacion\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><label>Periodo</label><div class=form-group><select class=\"form-control input-sm\" ng-model=vm.prmPresentacionFiltro.periodo ng-init=\"vm.prmPresentacionFiltro.periodo = 0\"><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacionFiltro.codigoTipoInforme==7\"><label class=important-box>Mes</label><select ng-model=vm.prmPresentacionFiltro.numero_frecuencia class=\"form-control input-sm\"><option ng-value=0>--Todos--</option><option ng-value=1>ENERO</option><option ng-value=2>FEBRERO</option><option ng-value=3>MARZO</option><option ng-value=4>ABRIL</option><option ng-value=5>MAYO</option><option ng-value=6>JUNIO</option><option ng-value=7>JULIO</option><option ng-value=8>AGOSTO</option><option ng-value=9>SEPTIEMBRE</option><option ng-value=10>OCTUBRE</option><option ng-value=11>NOVIEMBRE</option><option ng-value=12>DICIEMBRE</option></select></div><div class=\"input-group col-md-4\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnAgregar ng-click=vm.agregarItem() type=button ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'NUEVO OTRO\')\" uib-tooltip=Agregar><span class=\"icon-agregar spac-btn-r\"></span> Agregar</button></div></div></div><div class=row ng-show=vm.verNuevo><div class=\"form-group col-md-1\"><strong class=important-box>Periodo</strong><select class=\"form-control input-sm\" ng-model=vm.prmPresentacion.periodo><option ng-value=0>--Seleccione--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-2\"><strong class=important-box>Tipo Presentación</strong><select class=\"form-control input-sm\" ng-change=vm.validarTipoPresentacion(vm.prmPresentacion.codigoTipoInforme); ng-model=vm.prmPresentacion.codigoTipoInforme><option ng-value=0>--Seleccione--</option><option ng-repeat=\"item in vm.lstTipoPresentacion\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacion.codigoTipoInforme==5\"><label class=important-box>Frecuencia</label><select disabled ng-model=vm.prmPresentacion.frecuencia class=\"form-control input-sm\"><option ng-value=0>--Seleccione--</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><label class=important-box>Fecha Presentación</label><input type=date ng-model=vm.prmPresentacion.fechapresentacion class=\"form-control input-sm\"></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacion.frecuencia==1\"><label class=important-box>Mes</label><select ng-model=vm.prmPresentacion.numero_frecuencia class=\"form-control input-sm\"><option ng-value=0>--Seleccione--</option><option ng-value=1>ENERO</option><option ng-value=2>FEBRERO</option><option ng-value=3>MARZO</option><option ng-value=4>ABRIL</option><option ng-value=5>MAYO</option><option ng-value=6>JUNIO</option><option ng-value=7>JULIO</option><option ng-value=8>AGOSTO</option><option ng-value=9>SEPTIEMBRE</option><option ng-value=10>OCTUBRE</option><option ng-value=11>NOVIEMBRE</option><option ng-value=12>DICIEMBRE</option></select></div><div class=\"form-group col-md-3\"><strong class=important-box>Archivo</strong> <input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"input-group col-md-2\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.guardarPresentacion() id=btnGrabar ng-disabled=\"vm.prmPresentacion.codigoTipoInforme==0||vm.prmPresentacion.periodo==0||vm.prmPresentacion.frecuencia==0||vm.prmPresentacion.numero_frecuencia==0 || vm.listaArchivos.length==0 || vm.prmPresentacion.fechapresentacion == null\"><i aria-hidden=true class=\"glyphicon glyphicon-ok spac-btn-r\"></i></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnCancelar ng-click=\"vm.verNuevo = false\" type=button uib-tooltip=Cancelar><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i></button></div></div></div></div><br><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°</th><th class=text-center>Periodo</th><th class=text-center>Tipo Presentaci&oacute;n</th><th class=text-center>Fecha Presentaci&oacute;n</th><th class=text-center>Mes Incidente</th><th class=text-center>&iquest;Hubo incidente?</th><th class=text-center>Fecha/hora incidencia</th><th class=text-center>Lugar incidencia</th><th class=text-center>Descripci&oacute;n incidencia</th><th class=text-center>Observaciones incidencia</th><th class=text-center>Archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstPresentacion.length==0\"><td colspan=12 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstPresentacion | itemsPerPage: config.itemsPerPage\" pagination-id=cout4><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Periodo class=text-center>{{item.periodo}}</td><td data-label=\"Tipo Presentación\" class=text-center>{{item.nombreTipoInforme}}</td><td data-label=\"Fecha Presentación\" class=text-center>{{item.fechapresentaciontexto}}</td><td data-label=\"Mes Incidente\" class=text-center><div ng-show=\"item.codigoTipoInforme==7\"><div ng-if=\"item.numero_frecuencia==1\">ENERO</div><div ng-if=\"item.numero_frecuencia==2\">FEBRERO</div><div ng-if=\"item.numero_frecuencia==3\">MARZO</div><div ng-if=\"item.numero_frecuencia==4\">ABRIL</div><div ng-if=\"item.numero_frecuencia==5\">MAYO</div><div ng-if=\"item.numero_frecuencia==6\">JUNIO</div><div ng-if=\"item.numero_frecuencia==7\">JULIO</div><div ng-if=\"item.numero_frecuencia==8\">AGOSTO</div><div ng-if=\"item.numero_frecuencia==9\">SEPTIEMBRE</div><div ng-if=\"item.numero_frecuencia==10\">OCTUBRE</div><div ng-if=\"item.numero_frecuencia==11\">NOVIEMBRE</div><div ng-if=\"item.numero_frecuencia==12\">DICIEMBRE</div></div></td><td data-label=\"&iquest;Hubo incidente?\" class=text-center><label ng-show=\"item.tiene_incidente==1\">SI</label><label ng-show=\"item.tiene_incidente==0\">NO</label><label ng-show=\"item.tiene_incidente!=1 && item.tiene_incidente!=0\">NO ESPECIFICA</label></td><td data-label=\"Fecha/hora incidencia\" class=text-center>{{item.fechahora_incidente_texto}}</td><td data-label=\"Lugar incidencia\" class=text-center>{{item.lugar_incidente}}</td><td data-label=\"Descripci&oacute;n incidencia\" class=text-center>{{item.descripcion_incidente}}</td><td data-label=\"Observaciones incidencia\" class=text-center>{{item.observaciones_incidente}}</td><td data-label=Documento class=text-center><a download={{item.nombredocumento}} href={{vm.rutaBase}}instalacionPresentacion/descargar-documento/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.codigoTipoInforme}}/{{item.periodo}}/{{item.numero_frecuencia}} target=_blank>{{item.nombredocumento}}</a></td><td data-label=Acción class=text-center><button class=\"btn btn-default btn-sm\" ng-if=\"$parent.sisoValidaOperacionesWbUvk(\'ELIMINAR OTRO\')\" ng-click=vm.confirmarEliminacion(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout4></dir-pagination-controls></div></div></div></span><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div>");
$templateCache.put("app/modules/supervision/online/presentacion/presentacion_edicion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{ vm.prmPresentacion.idresiduo == 0 ? \'Registro de \' : \'Detalle de \' }} Presentación:</h4></div></div><div class=modal-body name=manifiestoresiduoDataDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><label class=important-box>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmPresentacion.periodo ng-disabled=\"vm.prmPresentacion.idresiduo!=0\"><option ng-value=0>--Todos--</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option></select></div><div class=\"form-group col-md-2\"><label class=important-box>Frecuencia</label><select disabled ng-model=vm.prmPresentacion.frecuencia class=\"form-control input-sm\"><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><label class=important-box>N° Frecuencia</label><select ng-model=vm.prmPresentacion.numero_frecuencia class=\"form-control input-sm\"><option ng-value=1>ENERO</option><option ng-value=2>FEBRERO</option><option ng-value=3>MARZO</option><option ng-value=4>ABRIL</option><option ng-value=5>MAYO</option><option ng-value=6>JUNIO</option><option ng-value=7>JULIO</option><option ng-value=8>AGOSTO</option><option ng-value=9>SEPTIEMBRE</option><option ng-value=10>OCTUBRE</option><option ng-value=11>NOVIEMBRE</option><option ng-value=12>DICIEMBRE</option></select></div><div class=\"form-group col-md-2\"><label class=important-box>Tipo de Presentacion</label><select class=\"form-control input-sm\" ng-model=vm.prmPresentacion.codigoTipoInforme><option ng-repeat=\"item in vm.lstPresentacion\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-lg-3\"><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{vm.prmPresentacion.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{vm.prmPresentacion.idresiduo}}>{{vm.prmPresentacion.nombredocumento}}</a></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() type=button id=btnRegistrarManifiesto ng-show=\"vm.prmPresentacion.idresiduo==0\" ng-disabled=\"vm.prmPresentacion.lstCaracteristicas.length==0 || vm.prmPresentacion.lstTransporte.length==0 || vm.prmPresentacion.lstDisposicion.length==0 || vm.prmPresentacion.periodo==0 || vm.listaArchivos.length == 0\" uib-tooltip=\"{{ vm.prmPresentacion.idresiduo == 0 ? \'Registrar\' : \'Actualizar\' }}\"><span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> {{ vm.prmPresentacion.idresiduo == 0 ? \'Registrar\' : \'Actualizar\' }}</button> <button class=\"btn btn-flat btn-primary btn-sm btn-pd-5\" ng-click=vm.cancelar() type=button uib-tooltip=\"Cancelar registro\"><span class=\"fa fa-arrow-left spac-btn-r\"></span> Cancelar</button></div></div><div class=row><div id=campoObligatorio class=\"col-lg-12 text-left\" ng-if=true><span class=important-box></span> Campo obligatorio.</div></div></span></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/accion-instalacion-edicion.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Unidad Fiscalizable {{ vm.dataInstalacion.numeroInstalacion}}</h4></div><br><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>RUC</p></strong></div><div class=\"form-group col-md-2\"><input class=\"form-control input-sm\" required ng-disabled=true maxlength=11 ng-model=vm.dataInstalacion.ruc type=text></div><div class=\"form-group col-md-4\"><input class=\"form-control input-sm\" ng-disabled=true ng-model=vm.dataInstalacion.razonsocial type=text></div><div class=\"form-group col-md-3\" ng-show=\"vm.dataInstalacion.idInstalacion == 0\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-disabled=true ng-click=vm.validarRuc() type=button><span class=icon-check></span> Validar Ruc</button></div></div><uib-tabset active=vm.active ng-show=\"vm.mostrarNuevo==true\"><uib-tab heading=\"Datos de la Unidad Fiscalizable\" index=0><br><div ng-show=\"vm.mostrarInaps==false\"><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Nombre</p><label>(Raz&oacute;n social - Direcci&oacute;n)</label></strong></div><div class=\"form-group col-md-10\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=400 ng-model=vm.dataInstalacion.numeroInstalacion type=text></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Tipo establecimiento</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" id=tipoPersona name=tipoPersona ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.tipoEstablecimiento><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaTipoEstablecimiento\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Estado</p></strong></div><div class=\"form-group col-md-3\"><div class=form-group><select ng-model=vm.dataInstalacion.estado ng-disabled=\"vm.RucValido==false\" class=\"form-control input-sm\" id=estado name=estado><option ng-value=1>CON ACTIVIDAD</option><option ng-value=0>SIN ACTIVIDAD</option></select></div></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Sector</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.changeSector() ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.sector><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSector\" ng-value=itemCombo.codigosector>{{itemCombo.sector}}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Subsector</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.changeSubSector() ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.subSector><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaSubSector\" ng-value=itemCombo.codigosubsector>{{itemCombo.subsector}}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Competencia</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" multiple ng-disabled=\"vm.RucValido==false\" ng-change=vm.changeCompetencia() ng-model=vm.dataInstalacion.competenciaArray><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaCompetencia\" ng-value=itemCombo.codigocompetencia>{{itemCombo.competencia}}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Actividad</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.actividad><option ng-value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaActividad\" ng-value=itemCombo.codigoactividad>{{itemCombo.actividad}}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Departamento</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-change=\"vm.listarProvincia();vm.dataUbigeo.codigoProvincia = \'\';vm.dataUbigeo.codigoDistrito = \'\';\" ng-model=vm.dataInstalacion.departamento.codigoDepartamento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-2\"><strong><p class=important-box>Provincia</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-change=vm.listarDistrito() ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataInstalacion.provincia.codigoProvincia><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Distrito</p></strong></div><div class=\"form-group col-md-3\"><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataInstalacion.distrito.codigoDistrito><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div></div><div class=row><div class=\"form-group col-md-2\"><strong><p class=important-box>Dirección</p></strong></div><div class=\"form-group col-md-10\"><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=300 ng-model=vm.dataInstalacion.direccion type=text></div></div><div class=row><div class=\"form-group col-md-12\"><h6>Toda la información de Coordenadas debe estar en datum WGS-84 (UTM)</h6></div></div><div class=row><div class=\"form-group col-md-3\"><label for=tipoPersona class=important-box>Zona</label><select ng-disabled=\"vm.RucValido==false\" class=\"form-control input-sm\" id=tipoPersona ng-model=vm.dataInstalacion.idzona><option ng-value=0>Seleccione</option><option ng-repeat=\"item in vm.listaZonas\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><label for=departamento class=important-box>Norte (7\'950,000 - 9\'999,900)</label><input class=\"form-control input-sm\" maxlength=10 name=distrito ng-disabled=\"vm.RucValido==false\" onkeypress=\"return checkOnlyDigits(event)\" type=text ng-model=vm.dataInstalacion.puntoNorte></div><div class=\"form-group col-md-3\"><label for=departamento class=important-box>Este (160,000 - 840,000)</label><input class=\"form-control input-sm\" maxlength=10 name=distrito type=text onkeypress=\"return checkOnlyDigits(event)\" ng-model=vm.dataInstalacion.puntoEste ng-disabled=\"vm.RucValido==false\"></div></div><div class=row><div class=\"form-group col-md-12\"><label for=distrito>Referencia</label><div class=form-group><input class=\"form-control input-sm\" maxlength=300 name=distrito ng- type=text ng-disabled=\"vm.RucValido==false\" ng-model=vm.dataInstalacion.referencia></div></div></div><h3 class=title-slider-nt style=\"color: gray; font-weight: lighter\">Fichas de Registro de Hidrocarburos:</h3><br><div class=row><div class=\"form-group col-md-2\"><strong><p>Fichas de registro: <span title=Agregar class=icon-agregar ng-click=vm.agregarFichaxInstalacion()></span></p></strong></div><div class=\"form-group col-md-10\"><table><tr ng-repeat=\"item in vm.lstFichaxInstalacion\"><td class=text-center><a download={{item.ruta_ficha_registro}} href={{vm.urlData}}instalacion/descargar-ficha-registro/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.ficha_registro}} target=_blank>{{item.ficha_registro}}</a></td><td align=center><span class=\"glyphicon glyphicon-trash\" title=Eliminar ng-click=vm.eliminarDocumentoInstalacion($index)></span></td></tr></table></div></div><div class=row ng-show=vm.mostrarNuevoFicha><div class=\"form-group col-md-3\"><p>Número de registro:</p><input class=\"form-control input-sm\" required ng-disabled=\"vm.RucValido==false\" maxlength=50 ng-model=vm.dataDocumentoInstalacion.ficha_registro type=text></div><div class=\"form-group col-md-3\"><input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumentoDetalle id=fileArchivoFicha multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-md-1\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnAgregarFicha ng-disabled=\"vm.dataDocumentoInstalacion.ficha_registro ==\'\' || vm.dataDocumentoInstalacion.ficha_registro==null || vm.listaArchivos.length == 0\" ng-click=vm.guardarFichaxInstalacion()>Añadir Ficha <i aria-hidden=true class=\"glyphicon glyphicon-ok\"></i></button></div></div><span class=content-box><label class=important-box>(Campos Obligatorios)</label></span></div></uib-tab><uib-tab heading=\"Datos de Administrados\" index=2><br><!-- <div class=\"row\">\r\n\r\n				<div class=\"form-group col-md-12 text-right\">\r\n					<button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n						ng-click=\"vm.agregarAdminxInstalacion()\" type=\"button\">\r\n						<span class=\"icon-agregar\"> </span> Agregar\r\n					</button>\r\n				</div>\r\n			</div> --><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Ruc</th><th class=text-center>Razón social</th><th class=text-center>Vigente desde</th><th class=text-center>Vigente hasta</th><th class=text-center>¿Activo?</th></tr></thead><tbody><tr ng-show=\"vm.lstAdminxInstalcion.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstAdminxInstalcion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td data-label=Item>{{$index + 1}}</td><td data-label=Ruc>{{item.ruc}}</td><td data-label=\"Razón social\">{{item.razonsocial}}</td><td align=center data-label=\"Vigencia desde\">{{item.auxInicio}}</td><td align=center data-label=\"Vigencia hasta\">{{item.auxFin}}</td><td align=center data-label=¿Activo?><input type=checkbox ng-model=item.auxflgaactivo disabled></td><!--<td align=\"center\" data-label=\"Acción\">\r\n										<button class=\"btn btn-default btn-sm\"\r\n											ng-click=\"vm.agregarAdminxInstalacion(item)\" type=\"button\"\r\n											uib-tooltip=\"Editar\">\r\n											<span class=\"glyphicon glyphicon-pencil\"> </span>\r\n										</button>\r\n										<button class=\"btn btn-default btn-sm\"\r\n											ng-click=\"vm.eliminarAdminxInstlacion($index)\" type=\"button\"\r\n											uib-tooltip=\"Eliminar\">\r\n											<span class=\"glyphicon glyphicon-trash\"> </span>\r\n										</button>\r\n									</td>--></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div></div></uib-tab></uib-tabset><div ng-show=\"vm.mostrarInaps==true\"><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarProvinciaInaps(); vm.filtroInstalacionINAPS.provincia.codigoProvincia = \'\';vm.filtroInstalacionINAPS.distrito.codigoDistrito = \'\'\" ng-model=vm.filtroInstalacionINAPS.departamento.codigoDepartamento><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistritoInaps();vm.filtroInstalacionINAPS.distrito.codigoDistrito = \'\'\" ng-model=vm.filtroInstalacionINAPS.provincia.codigoProvincia><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-model=vm.filtroInstalacionINAPS.distrito.codigoDistrito><option value=\"\">Seleccione</option><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscarInaps ng-click=vm.buscarInaps() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div></div><div class=row><div class=\"form-group col-md-12\"><button class=\"btn btn-primary btn-sm\" ng-click=vm.seleccionarTodos(); ng-show=\"vm.verSelTodos==true\"><i aria-hidden=true></i> Seleccionar Todos</button> <button class=\"btn btn-primary btn-sm\" ng-click=vm.desSeleccionarTodos(); ng-show=\"vm.verSelTodos==false\"><i aria-hidden=true></i> Deseleccionar Todos</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center width=5% rowspan=1>N&#176;</th><th class=text-center width=10% rowspan=1>Nombre</th><th class=text-center width=5% rowspan=1>Dirección</th><th class=text-center width=5% rowspan=1>Distrito</th><th class=text-center width=5% rowspan=1>Provincia</th><th class=text-center width=10% rowspan=1>Departamento</th><th class=text-center width=15% rowspan=1>Sector</th><th class=text-center width=15% rowspan=1>Sub Sector</th><th class=text-center width=15% rowspan=1>Competencia</th><th class=text-center width=15% rowspan=1>Actividad</th><th class=text-center width=15% rowspan=1>Selección</th></tr></thead><tbody><tr ng-show=\"vm.listaUnidadesFiscalizablesExterno.length==0\"><td colspan=10>No se encontraron resultados</td></tr><tr dir-paginate=\"itemInstalacion in vm.listaUnidadesFiscalizablesExterno | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutListadoInstalacionExterno><td class=text-center data-label=N&#176;>{{itemInstalacion.numeroItem}}</td><td data-label=Nombre width=5%>{{itemInstalacion.numeroInstalacion}}</td><td data-label=Dirección width=5%>{{itemInstalacion.direccion}}</td><td data-label=Distrito width=5%>{{itemInstalacion.distrito.descripcionDistrito}}</td><td data-label=Provincia width=10%>{{itemInstalacion.provincia.descripcion}}</td><td data-label=Departamento width=10%>{{itemInstalacion.departamento.descripcionDepartamento}}</td><td data-label=Actividad width=15%>{{itemInstalacion.sectorDescripcion}}</td><td data-label=Actividad width=15%>{{itemInstalacion.subsectorDescripcion}}</td><td data-label=Actividad width=15%>{{itemInstalacion.competenciaDescripcion}}</td><td data-label=Actividad width=15%>{{itemInstalacion.actividadDescripcion}}</td><td class=text-center data-label=Acción width=20%><input type=checkbox ng-model=itemInstalacion.flgSeleccionado></td></tr></tbody></table><dir-pagination-controls pagination-id=coutListadoInstalacionExterno></dir-pagination-controls></div></div></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardar() id=btnGuardarInstalacion ng-disabled=\"((vm.RucValido==false || (vm.dataInstalacion.numeroInstalacion==null || vm.dataInstalacion.tipoEstablecimiento == 0 || \r\n				vm.dataInstalacion.sector == \'\' || vm.dataInstalacion.subSector == \'\' || vm.dataInstalacion.actividad == \'\' || \r\n				vm.dataInstalacion.departamento.codigoDepartamento == 0 || vm.dataInstalacion.provincia.codigoProvincia == 0 || vm.dataInstalacion.distrito.codigoDistrito == 0 ||\r\n				(vm.dataInstalacion.direccion == null || vm.dataInstalacion.direccion == \'\' ) || vm.dataInstalacion.puntoNorte == null || vm.dataInstalacion.puntoNorte == \'\' || vm.dataInstalacion.puntoEste == null || vm.dataInstalacion.puntoEste == \'\' || vm.dataInstalacion.idzona == 0)) &&  vm.mostrarInaps==false)\"><i aria-hidden=true class=\"glyphicon glyphicon-floppy-disk\"></i> Guardar</button> <button class=\"btn btn-primary btn-sm\" ng-click=closeThisDialog(0)><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i> Cerrar</button></div></div></div><script type=text/javascript>$(document).ready(\r\n			function() {\r\n				$(\'button.ngdialog-close\').remove();\r\n				$(\'.ngdialog-content\').append(\r\n						\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n			});</script>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/accion-instalacion.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Mi Información</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Mi Información</li><li>Unidades Fiscalizables</li></ol></span></div></div><!-- 	<div class=\"row\">\r\n			<div class=\"form-group col-md-2\">\r\n				<strong>\r\n					<p class=\"\">RUC</p>\r\n				</strong><input class=\"form-control\" type=\"text\"\r\n					ng-model=\"vm.dataListaInstalacion.ruc\" />\r\n			</div>\r\n			<div class=\"form-group col-md-3\">\r\n				<strong>\r\n					<p class=\"\">Administrado</p>\r\n				</strong><input class=\"form-control\" type=\"text\"\r\n					ng-model=\"vm.dataListaInstalacion.razonsocial\" />\r\n			</div>\r\n		</div> --><div class=row><div class=\"form-group col-md-3\"><strong><p>Departamento</p></strong><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-change=\"vm.listarProvincia();vm.dataListaInstalacion.provincia.codigoProvincia = \'\'; vm.dataListaInstalacion.distrito.codigoDistrito = \'\';\" ng-model=vm.dataListaInstalacion.departamento.codigoDepartamento><option ng-repeat=\"itemCombo in vm.listaDepartamento\" ng-value=itemCombo.codigoDepartamento>{{ itemCombo.descripcionDepartamento }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Provincia</p></strong><select class=\"form-control input-sm\" ng-change=\"vm.listarDistrito();vm.dataListaInstalacion.distrito.codigoDistrito=\'\'\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataListaInstalacion.provincia.codigoProvincia><option ng-repeat=\"itemCombo in vm.listaProvincia\" ng-value=itemCombo.codigoProvincia>{{ itemCombo.descripcion }}</option></select></div><div class=\"form-group col-md-3\"><strong><p>Distrito</p></strong><select class=\"form-control input-sm\" ng-disabled=\"vm.RucValido==false\" ng-disabled=\"vm.flagRegistrarPersona ==0\" ng-model=vm.dataListaInstalacion.distrito.codigoDistrito><option ng-repeat=\"itemCombo in vm.listaDistrito\" ng-value=itemCombo.codigoDistrito>{{ itemCombo.descripcionDistrito }}</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.buscar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarInstalacion() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr style=\"margin: 0px; padding: 0px\"><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>N&#176;</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Unidad Fiscalizable</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Dirección</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Distrito</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Provincia</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Departamento</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2>Actividad</th><th class=text-center style=\"vertical-align: middle !important\" rowspan=2 width=10%>Acción</th><th style=\"background: #35bfb1\" class=text-center colspan=5>Mis Declaraciones</th></tr><tr><th class=text-center style=\"background: #35bfb1\">IGA</th><th class=text-center>IMA</th><th class=text-center>DMRS</th><th class=text-center>MRP</th><th class=text-center>Otros</th></tr></thead><tbody><tr ng-show=\"vm.listaInstalacionAdm.length==0\"><td colspan=13>No se encontraron resultados</td></tr><tr dir-paginate=\"itemInstalacion in vm.listaInstalacionAdm | itemsPerPage: config.itemsPerPage track by $index \" pagination-id=coutListadoInstalacionAdm><td class=text-center style=\"vertical-align: middle !important\" data-label=N&#176;>{{itemInstalacion.numeroItem}}</td><td data-label=\"Unidad Fiscalizable\" style=\"vertical-align: middle !important\">{{itemInstalacion.numeroInstalacion}}</td><td data-label=Dirección style=\"vertical-align: middle !important\">{{itemInstalacion.direccion}}</td><td data-label=Distrito style=\"vertical-align: middle !important\">{{itemInstalacion.distrito.descripcionDistrito}}</td><td data-label=Provincia style=\"vertical-align: middle !important\">{{itemInstalacion.provincia.descripcion}}</td><td data-label=Departamento style=\"vertical-align: middle !important\">{{itemInstalacion.departamento.descripcionDepartamento}}</td><td data-label=Actividad style=\"vertical-align: middle !important\">{{itemInstalacion.actividadDescripcion}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarInstalacion(itemInstalacion) type=button uib-tooltip=Editar><span class=icon-editar></span></button><!-- <button class=\"btn btn-default btn-sm\"\r\n										ng-click=\"vm.confirmarEliminacion(itemInstalacion)\"\r\n										type=\"button\" uib-tooltip=\"Eliminar\">\r\n										<span class=\"glyphicon glyphicon-trash\"> </span>\r\n									</button> --></td><td style=\"background: #35bfb1;vertical-align: middle !important\" class=text-center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irCompromisos(itemInstalacion) type=button uib-tooltip=\"Mis Intrumentos de Gestión Ambiental\"><span class=\"glyphicon glyphicon-cog\"></span></button></td><td class=text-center data-label=Acción style=\"vertical-align: middle !important\"><button class=\"btn btn-default btn-sm\" ng-click=vm.irInformeMonitoreo(itemInstalacion) type=button uib-tooltip=\"Mis Informes de Monitoreo Ambiental\"><span class=\"glyphicon glyphicon-list-alt\"></span></button></td><td class=text-center data-label=Acción style=\"vertical-align: middle !important\"><button class=\"btn btn-default btn-sm\" ng-click=vm.irDeclaracionResiduos(itemInstalacion) type=button uib-tooltip=\"Mis Declaraciones de Manejo de Residuos Sólidos\"><span class=\"glyphicon glyphicon-cog\"></span></button></td><td class=text-center data-label=Acción style=\"vertical-align: middle !important\"><button class=\"btn btn-default btn-sm\" ng-click=vm.irManifiestoResiduos(itemInstalacion) type=button uib-tooltip=\"Mis Manifiestos de Residuos Peligrosos\"><span class=\"glyphicon glyphicon-cog\"></span></button></td><td style=\"vertical-align: middle !important\" class=text-center data-label=\"Presentaciones (Documentos)\"><button class=\"btn btn-default btn-sm\" ng-click=vm.irPresentacion(itemInstalacion) type=button uib-tooltip=Documentos><span class=\"glyphicon glyphicon-cog\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutListadoInstalacionAdm></dir-pagination-controls></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-declaracion.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}\r\n\r\n.selectComponente {\r\n	background-color: #35bfb1 !important;\r\n	color: white !important;\r\n	border: none !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Declaración de la Información a Remitir</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstalacion.numeroInstalacion}}</label><br><label>{{ vm.objInstalacion.direccion}}</label><br>{{vm.objInstalacion.distrito.descripcionDistrito}} - {{vm.objInstalacion.provincia.descripcion}} - {{vm.objInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #35bfb1; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Instrumento de Gestión</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstrumentoGestion.auxTipoIgaNombre}}</label><br><label>{{vm.objInstrumentoGestion.resolucion}}</label><br>{{vm.objInstrumentoGestion.fechaAprobacion}}</div></div><div class=row><div class=col-md-12><h3 class=title-slider-nt>Etapa del proyecto</h3></div></div><br><div class=row><uib-tabset active=vm.activeetapa type=pills><uib-tab ng-click=vm.cambiarEtapa(item) ng-repeat=\"item in vm.lstEtapas\" heading={{item.descripcion}} index=$index><br></uib-tab></uib-tabset></div><div class=row ng-show=vm.verComponentes><div class=col-md-12><h3 class=title-slider-nt>Compromisos Ambientales</h3></div></div><br><div class=row ng-show=vm.verComponentes><div class=col-md-3><div style=\"width: 100%; min-height: 150px; border: solid 2px #35bfb1\"><div ng-click=vm.cargarDeclaracionPuntosMonitoreo(item); ng-class=\"{selectComponente: vm.objDeclaracionComponente.idComponente == item.idComponente, null: vm.objDeclaracionComponente.idComponente != item.idComponente}\" style=\"height: 40px; color: #35bfb1; -webkit-border-radius: 0px 18px 18px 0px; -moz-border-radius: 0px 18px 18px 0px; border-radius: 0px 18px 18px 0px\" ng-repeat=\"item in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes\"><span style=\"height: 40px !important; vertical-align: middle !important; display: table-cell\">&nbsp;&nbsp;{{item.auxComponenteNombre}}</span></div><br></div><br><button class=\"btn btn-flat btn-primary\" style=\"background-color: #35bfb1 !important; border-color: #35bfb1 !important; color: white !important\" ng-click=vm.agregarDeclaracionComponentes() type=button><span class=icon-agregar></span> Agregar</button> <button class=\"btn btn-flat btn-primary\" style=\"background-color: #35bfb1 !important; border-color: #35bfb1 !important; color: white !important\" ng-click=vm.confirmarEliminacionComponente(vm.objDeclaracionComponente) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\">Eliminar</span></button></div><div class=col-md-9><div class=row><div class=\"form-group col-lg-2\"><label ng-show=\"vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length>0 && vm.verFrecuenciaAbandono\">Frecuencia:</label></div><div class=\"form-group col-lg-2\"><select ng-model=vm.objDeclaracionComponente.idFrecuencia ng-show=\"vm.objInstrumentoGestion.declaracionEtapa.lstComponentes.length>0 && vm.verFrecuenciaAbandono\" ng-change=vm.actualizarDeclaracionComponentes(vm.objDeclaracionComponente) class=\"form-control input-sm\"><option ng-value=0>NO ESPECIFICA</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-lg-8 text-right\" ng-show=vm.verPuntosMonitoreo><button class=\"btn btn-flat btn-primary\" style=\"background-color: #144aa7 !important; color: white !important\" ng-click=vm.agregarDeclaracionPuntosMonitoreo() type=button><span class=icon-agregar></span> Agregar Puntos Monitoreo</button></div></div><div class=row ng-show=vm.verPuntosMonitoreo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center width=5% style=\"vertical-align: middle !important\">N°</th><th class=text-center width=5% style=\"vertical-align: middle !important\">C&oacute;digo</th><th class=text-center width=30% style=\"vertical-align: middle !important\">Descripci&oacute;n</th><th class=text-center width=8% style=\"vertical-align: middle !important\">Zona</th><th class=text-center width=10% style=\"vertical-align: middle !important\">Coordenadas UTM<br>(Datum WGS84)</th><th class=text-center width=10% style=\"vertical-align: middle !important\">Acciones</th></tr></thead><tbody><tr ng-show=\"vm.lstDeclaracionPunto.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objDeclaracionPuntoMonitoreo.idPunto == item.idPunto, null: vm.objDeclaracionPuntoMonitoreo.idPunto != item.idPunto}\" dir-paginate=\"item in vm.lstDeclaracionPunto | itemsPerPage: config.itemsPerPage\" pagination-id=coutpuntos><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Código class=text-center>{{item.codigo}}</td><td data-label=Nombre>{{item.observacion}}</td><td data-label=Zona style=\"text-align: center\">{{item.idZona}}</td><td data-label=Coordenadas>NORTE: {{item.puntoNorte}}<br>ESTE: {{item.puntoEste}}</td><td class=text-center data-label=Acciones><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarDeclaracionPuntosMonitoreo(item) type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.confirmarEliminacionPunto(item) type=button uib-tooltip=Eliminar><span class=\"glyphicon glyphicon-trash\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.cargarDeclaracionParametros(item) type=button uib-tooltip=\"Parámetros de Monitoreo\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutpuntos></dir-pagination-controls></div></div></div></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-declaracion_anual_residuos.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Residuos Sólidos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Residuos Sólidos</li><li>Declaración de Manejo de Residuos Sólidos No Municipales</li></ol></span></div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-md-2\"><label>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmResiduo.periodo><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>N°</th><th style=\"text-align: center\" width=10%>Periodo</th><th style=\"text-align: center\" width=20%>Documento</th><th style=\"text-align: center\" width=10%>Peligrosos (TN)</th><th style=\"text-align: center\" width=10%>Otros (TN)</th><th style=\"text-align: center\" width=10%>Fecha Presentación</th><th style=\"text-align: center\" width=10%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstResiduos.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstResiduos | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduomain><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Documento style=\"text-align: center\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{item.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{item.idresiduo}}>{{item.nombredocumento}}</a></td><td data-label=\"Peligrosos (TN)\" style=\"text-align: center\">{{item.peligrosos}}</td><td data-label=\"Otros (TN)\" style=\"text-align: center\">{{item.otros}}</td><td data-label=\"Fecha Presentación\" style=\"text-align: center\">{{item.fechapresentaciontexto}}</td><td data-label=Acción style=\"text-align: center\"><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Ver><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduomain></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></span></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-informe-instrumento.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Instrumentos de Gestión Ambiental</span></h3></div></div><br><!-- <h3 class=\"title-slider-nt\" style=\"color: gray; font-weight: lighter;\">Datos\r\n			de la Unidad Fiscalizable:</h3> <br />\r\n\r\n		<div>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-lg-2\">\r\n					<label for=\"tipoContacto\" style=\"font-weight: bold\">Nombre:\r\n					</label>\r\n				</div>\r\n				<div class=\"form-group col-lg-4\">\r\n					<label> {{vm.prmInstalacion.numeroInstalacion}}</label>\r\n				</div>\r\n\r\n			</div>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-lg-2\">\r\n					<label for=\"tipoContacto\" style=\"font-weight: bold\">\r\n						Departamento: </label>\r\n				</div>\r\n				<div class=\"form-group col-lg-2\">\r\n					<label>\r\n						{{vm.prmInstalacion.departamento.descripcionDepartamento}} </label>\r\n				</div>\r\n				<div class=\"form-group col-lg-2\">\r\n					<label for=\"tipoContacto\" style=\"font-weight: bold\">\r\n						Provincia: </label>\r\n				</div>\r\n				<div class=\"form-group col-lg-2\">\r\n					<label> {{vm.prmInstalacion.provincia.descripcion}} </label>\r\n				</div>\r\n				<div class=\"form-group col-lg-2\">\r\n					<label for=\"tipoContacto\" style=\"font-weight: bold\">\r\n						Distrito: </label>\r\n				</div>\r\n				<div class=\"form-group col-lg-2\">\r\n					<label> {{vm.prmInstalacion.distrito.descripcionDistrito}}\r\n					</label>\r\n				</div>\r\n			</div>\r\n			<div class=\"row\">\r\n				<div class=\"form-group col-lg-2\">\r\n					<label for=\"tipoContacto\" style=\"font-weight: bold\">\r\n						Dirección: </label>\r\n				</div>\r\n				<div class=\"form-group col-lg-4\">\r\n					<label> {{ vm.prmInstalacion.direccion}} </label>\r\n				</div>\r\n			</div>\r\n		</div> --><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°.</th><th class=text-center>Instrumento de Gestión</th><th class=text-center>Resolución de Aprobación</th><th class=text-center>Fecha de Aprobación</th><th class=text-center>Documento</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.idInstrumentoGestion == item.idInstrumentoGestion, null: vm.idInstrumentoGestion != item.idInstrumentoGestion}\" dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución class=text-center>{{item.resolucion}}</td><td data-label=Fecha class=text-center>{{item.fechaAprobacion}}</td><td style=\"vertical-align: middle !important\" align=center><table><tr ng-repeat=\"itemdoc in item.lstIntrumentoGestionDoc\"><td class=text-center><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{itemdoc.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{itemdoc.idInstrumentoGestion}}/{{itemdoc.secuencia}}>{{itemdoc.nombreArchivo}}</a></td></tr></table></td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irInformeMonitoreo(item) type=button uib-tooltip=\"Informe de Monitoreo\"><span class=\"glyphicon glyphicon-cog\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-informe-monitoreo.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Informe de Monitoreo Ambiental</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstalacion.numeroInstalacion}}</label><br><label>{{ vm.objInstalacion.direccion}}</label><br>{{vm.objInstalacion.distrito.descripcionDistrito}} - {{vm.objInstalacion.provincia.descripcion}} - {{vm.objInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #35bfb1; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Instrumento de Gesti&oacute;n</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.objInstrumentoGestion.auxTipoIgaNombre}}</label><br><label>{{vm.objInstrumentoGestion.resolucion}}</label><br>{{vm.objInstrumentoGestion.fechaAprobacion}}</div></div><div class=row><div class=col-md-12><h3 class=title-slider-nt>Etapa del proyecto</h3></div></div><br><div class=row><uib-tabset active=vm.activeetapa type=pills><uib-tab ng-click=vm.cargarDeclaracionComponentes(item) ng-repeat=\"item in vm.lstEtapas\" heading={{item.descripcion}} index=$index><br></uib-tab></uib-tabset></div><div class=row><div class=col-md-12><h3 class=title-slider-nt>Datos del Informe <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.nuevoInformeMonitoreo() uib-tooltip=\"Agregar Informe de monitoreo\"><i aria-hidden=true class=\"glyphicon glyphicon-plus\"></i></button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.obtenerInformeEnsayo() uib-tooltip=\"Ver Informe de ensayo\"><i aria-hidden=true class=\"glyphicon glyphicon-search\"></i> Informe de ensayo</button></h3></div></div><br><div style=\"border-bottom: solid 1px #ddd\" ng-if=\"vm.acciones.nuevoInforme==true\"><div class=row><div class=\"form-group col-md-2\"><strong>Periodo</strong><select class=\"form-control input-sm\" ng-model=vm.objInformeMonitoreo.periodo><option value=\"\">--Seleccione--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-2\"><strong>Frecuencia</strong><select ng-model=vm.objInformeMonitoreo.frecuencia class=\"form-control input-sm\" ng-change=vm.cargarPeriodosHijos(vm.objInformeMonitoreo.frecuencia);><option ng-value=0>--Seleccione--</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><strong><span ng-if=\"vm.objInformeMonitoreo.frecuencia==0\">N° Frecuencia</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==1\">Mes</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==3\">Trimestre</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==4\">Semestre</span> <span ng-if=\"vm.objInformeMonitoreo.frecuencia==5\">Anual</span></strong><select ng-model=vm.objInformeMonitoreo.numero_frecuencia class=\"form-control input-sm\"><option ng-value=0>--Seleccione--</option><option ng-repeat=\"itemCombo in vm.lstPeriodosHijos\" ng-value=itemCombo.descripcion>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\"><strong>Componente</strong><div ng-repeat=\"item in vm.lstComponentesBase\">{{item.auxComponenteNombre}} <input type=checkbox ng-model=item.blSeleccionado ng-change=vm.elejirComponente(item)></div></div><div class=\"form-group col-md-3\"><p></p><input class=\"form-control input-sm\" file-change=vm.validaDocumentoInformeMonitoreo id=fileArchivoInformeMonitoreo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }} / Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"form-group col-lg-1\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.guardarInforme() id=btnRegistrarInforme ng-disabled=\"vm.objInformeMonitoreo.periodo==0||vm.objInformeMonitoreo.numero_frecuencia==0|| vm.listaArchivosInformeMonitoreo.length==0\"><i aria-hidden=true></i> Registrar Informe</button></div></div></div><br><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N°</th><th class=text-center>Periodo</th><th class=text-center>Frecuencia</th><th class=text-center>N° Frecuencia</th><th class=text-center>Componentes</th><th class=text-center>Fecha de Presentación</th><!-- <th class=\"text-center\">Comentario</th> --><th class=text-center>Estado</th><th class=text-center>Archivo</th><th class=text-center>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstInformesMonitoreo.length==0\"><td colspan=8 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objInformeSel.idInformeMonitoreo == item.idInformeMonitoreo, null: vm.objInformeSel.idInformeMonitoreo != item.idInformeMonitoreo}\" dir-paginate=\"item in vm.lstInformesMonitoreo | itemsPerPage: config.itemsPerPage\" pagination-id=cout4><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Periodo class=text-center>{{item.periodo}}</td><td data-label=Frecuencia class=text-center>{{item.frecuenciaNombre}}</td><td data-label=\"N° Frecuencia\" class=text-center><div ng-show=\"item.numero_frecuencia == 1\">I</div><div ng-show=\"item.numero_frecuencia == 2\">II</div><div ng-show=\"item.numero_frecuencia == 3\">III</div><div ng-show=\"item.numero_frecuencia == 4\">IV</div><div ng-show=\"item.numero_frecuencia == 5\">V</div><div ng-show=\"item.numero_frecuencia == 6\">VI</div><div ng-show=\"item.numero_frecuencia == 7\">VII</div><div ng-show=\"item.numero_frecuencia == 8\">VIII</div><div ng-show=\"item.numero_frecuencia == 9\">IX</div><div ng-show=\"item.numero_frecuencia == 10\">X</div><div ng-show=\"item.numero_frecuencia == 11\">XI</div><div ng-show=\"item.numero_frecuencia == 12\">XII</div></td><td class=text-center style=\"vertical-align: middle !important\" data-label=Componentes>{{item.auxComponenteNombre}}</td><td data-label=\"Fecha de Presentación\" class=text-center>{{item.fechaPresentacionTexto}}</td><!-- <td data-label=\"Comentario\">{{item.comentario}}</td> --><td data-label=Estado class=text-center><div ng-show=\"{{item.estado == 1}}\">Abierto</div><div ng-show=\"{{item.estado == 2}}\">Cerrado</div></td><td data-label=Documento class=text-center><a download={{item.nombreArchivo}} href={{vm.rutaBase}}informeMonitoreo/descargar-informe/{{item.idInformeMonitoreo}}/{{item.idAdministrado}}/{{item.idInstalacion}} target=_blank>{{item.nombreArchivo}}</a></td><td class=text-center data-label=\"Detalle del Informe\"><button class=\"btn btn-default btn-sm\" ng-click=\"vm.verComponentes=true;vm.objInformeSel=item;vm.filtrarComponentes(item);\" type=button uib-tooltip=\"Resultados del Informe\"><span class=\"glyphicon glyphicon-eye-open\"></span></button> <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" uib-tooltip=\"Cerrar Informe\" ng-click=vm.declaracion(item) ng-show=\"item.estado==1\"><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i></button> <button class=\"btn btn-default btn-sm\" uib-tooltip=\"Generar plantilla para carga masiva\" ng-click=vm.generarPlantillaMonitoreoMasivo(item) ng-show=\"item.estado==1\"><i aria-hidden=true class=\"glyphicon glyphicon-saved\"></i></button> <a class=\"btn btn-default btn-sm\" uib-tooltip=\"Descargar plantilla para carga masiva\" ng-show=\"item.estado==1 && (item.uuidplantilla!=null && item.uuidplantilla!=\'\')\" download=PlantillaMonitoreo.xlsx href={{vm.rutaBase}}reporte/descargar-plantilla-monitoreo/{{item.idInformeMonitoreo}} target=_blank><i aria-hidden=true class=\"glyphicon glyphicon-save\"></i> </a><button class=\"btn btn-default btn-sm\" uib-tooltip=\"Cargar plantilla para carga masiva\" ng-click=vm.cargarPlantillaMonitoreoMasivo(item) ng-show=\"item.estado==1 && (item.uuidplantilla!=null && item.uuidplantilla!=\'\')\"><i aria-hidden=true class=\"glyphicon glyphicon-open\"></i></button></td></tr></tbody></table><dir-pagination-controls pagination-id=cout4></dir-pagination-controls></div></div></div><div class=row ng-show=vm.verComponentes><div class=col-md-12><h3 class=title-slider-nt>Resultados de Monitoreo</h3></div></div><br><div class=row ng-show=vm.verComponentes><div class=col-md-3><uib-tabset active=vm.active vertical=true type=pills style=\"border: solid 2px #35bfb1\" class=tabComponentes><uib-tab ng-click=vm.cargarDeclaracionPuntosMonitoreo(item); ng-repeat=\"item in vm.objInstrumentoGestion.declaracionEtapa.lstComponentes\" heading={{item.auxComponenteNombre}} index=$index><br></uib-tab></uib-tabset><br></div><div class=col-md-9><div class=\"form-group col-lg-12 text-right\" ng-show=vm.verPuntosMonitoreo><button class=\"btn btn-flat btn-primary\" style=\"background-color: #144aa7 !important; color: white !important\" ng-click=vm.agregarDeclaracionPuntosMonitoreo() type=button><span class=icon-agregar>Agregar Puntos Monitoreo</span></button></div><div class=row ng-show=vm.verPuntosMonitoreo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center width=5% style=\"vertical-align: middle !important\">N°</th><th class=text-center width=8% style=\"vertical-align: middle !important\">C&oacute;digo</th><th class=text-center width=30% style=\"vertical-align: middle !important\">Descripci&oacute;n</th><th class=text-center width=8% style=\"vertical-align: middle !important\">Zona</th><th class=text-center width=10% style=\"vertical-align: middle !important\">Coordenadas UTM<br>(Datum WGS84)</th><th class=text-center width=8% style=\"vertical-align: middle !important\">Origen</th><th class=text-center width=5% style=\"vertical-align: middle !important\">Par&aacute;metros</th></tr></thead><tbody><tr ng-show=\"vm.lstDeclaracionPunto.length==0\"><td colspan=7 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.objDeclaracionPuntoMonitoreo.idPunto == item.idPunto, null: vm.objDeclaracionPuntoMonitoreo.idPunto != item.idPunto}\" dir-paginate=\"item in vm.lstDeclaracionPunto | itemsPerPage: config.itemsPerPage\" pagination-id=coutpuntos><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Código class=text-center>{{item.codigo}}</td><td data-label=Nombre>{{item.observacion}}</td><td data-label=Zona style=\"text-align: center\">{{item.idZona}}</td><td data-label=Coordenadas>NORTE: {{item.puntoNorte}}<br>ESTE: {{item.puntoEste}}</td><td data-label=Origen style=\"text-align: center\"><label ng-show=\"item.origen==\'I\'\">IMA</label><label ng-show=\"item.origen!=\'I\'\">IGA</label></td><td class=text-center data-label=Parámetros><button class=\"btn btn-default btn-sm\" ng-click=vm.cargarDeclaracionParametros(item) type=button uib-tooltip=\"Resultados de Párametros\"><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutpuntos></dir-pagination-controls></div></div></div></div></div></span><div class=row><div class=\"form-group col-lg-12 text-right\"><!-- <button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\"\r\n				ng-click=\"vm.abrirInformeMonitoreo()\"\r\n				ng-show=\"vm.objInformeSel.estado==2\">\r\n				<i aria-hidden=\"true\" class=\"\"> </i> Abrir Informe\r\n			</button> --> <button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-instrumento-gestion.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Instrumentos de Gestión Ambiental</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.nuevoIGA()><span class=\"glyphicon glyphicon-plus\"></span> Nuevo IGA</button></div></div><div class=row><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center style=\"vertical-align: middle !important\">N°</th><th class=text-center style=\"vertical-align: middle !important\">Instrumento de Gesti&oacute;n</th><th class=text-center style=\"vertical-align: middle !important\">Resoluci&oacute;n de Aprobaci&oacute;n</th><th class=text-center style=\"vertical-align: middle !important\">Fecha de Aprobaci&oacute;n</th><th class=text-center>&iquest;Vigente?</th><th class=text-center style=\"vertical-align: middle !important\">Documento</th><th class=text-center style=\"vertical-align: middle !important\">Acci&oacute;n</th></tr></thead><tbody><tr ng-show=\"vm.lstInstrumentosGestion.length==0\"><td colspan=6 style=\"text-align: left\">No se encontraron resultados</td></tr><tr ng-class=\"{select: vm.idInstrumentoGestion == item.idInstrumentoGestion, null: vm.idInstrumentoGestion != item.idInstrumentoGestion}\" dir-paginate=\"item in vm.lstInstrumentosGestion | itemsPerPage: config.itemsPerPage\" pagination-id=cout><td class=text-center data-label=Item>{{$index + 1}}</td><td data-label=Tipo>{{item.auxTipoIgaNombre}}</td><td data-label=Resolución class=text-center>{{item.resolucion}}</td><td data-label=Fecha class=text-center>{{item.fechaAprobacion}}</td><td style=\"vertical-align: middle !important\" class=text-center data-label=&iquest;Vigente?><label ng-if=\"item.flgvigente==1\">SI</label></td><td style=\"vertical-align: middle !important\" align=center><table><tr ng-repeat=\"itemdoc in item.lstIntrumentoGestionDoc\"><td class=text-center><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{itemdoc.nombreArchivo}} href={{vm.rutaBase}}instrumentoGestion/descargar-instrumento/{{itemdoc.idInstrumentoGestion}}/{{itemdoc.secuencia}}>{{itemdoc.nombreArchivo}}</a></td></tr></table></td><td align=center data-label=Acción><button class=\"btn btn-default btn-sm\" ng-click=vm.irDeclaracion(item) type=button uib-tooltip=\"Declaración de la Información\"><span class=\"glyphicon glyphicon-cog\"></span></button> <button class=\"btn btn-default btn-sm\" ng-click=vm.nuevoIGA(item) ng-disabled=false type=button uib-tooltip=Editar><span class=icon-editar></span></button> <button class=\"btn btn-default btn-sm\" ng-if=\"item.cantDeclaracion>0\" ng-click=vm.seleccionarcopiarIGA(item) ng-disabled=false type=button uib-tooltip=Copiar><span class=\"glyphicon glyphicon-copy\"></span></button><!-- <button class=\"btn btn-default btn-sm\"\r\n										ng-click=\"vm.confirmarEliminacion(item)\" ng-disabled=\"false\"\r\n										type=\"button\" uib-tooltip=\"Eliminar\">\r\n										<span class=\"glyphicon glyphicon-trash\"> </span>\r\n									</button> --></td></tr></tbody></table><dir-pagination-controls pagination-id=cout></dir-pagination-controls></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div></span></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-manifiesto_residuos.html","<div class=\"col-lg-12 animated bounceInUp sin_padding\"><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Residuos Sólidos</span></h3><span class=nav_bread><ol class=breadcrumb><li class=active>Residuos Sólidos</li><li>Manifiesto de Residuos Peligrosos</li></ol></span></div></div><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div class=row><div class=\"form-group col-md-2\"><label>Periodo</label><select class=\"form-control input-sm\" id=periodo ng-model=vm.prmResiduo.periodo><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button></div></div><div class=\"form-group col-md-1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm btn-pd-5\" ng-click=vm.agregarItem() type=button><span class=icon-agregar></span> Agregar</button></div></div></div><div class=row><div class=col-md-12 style=\"text-align: right\"><div class=table-rpv><table bgcolor=#d0c9c9 cellspacing=0 class=\"table table-hover table-bordered tableSiafx table-app\" width=100%><thead><tr><th style=\"text-align: center\" width=5%>N° Item</th><th style=\"text-align: center\" width=10%>Periodo</th><th style=\"text-align: center\" width=10%>Frecuencia</th><th style=\"text-align: center\" width=10%>N° Frecuencia</th><th style=\"text-align: center\" width=10%>Fecha Presentación</th><th style=\"text-align: center\" width=10%>Cantidad (TN)</th><th style=\"text-align: center\" width=20%>Documento</th><th style=\"text-align: center\" width=10%>Acción</th></tr></thead><tbody><tr ng-show=\"vm.lstResiduos.length==0\"><td colspan=8 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstResiduos | itemsPerPage: config.itemsPerPage\" pagination-id=coutresiduomain><td data-label=\"N° Item\" style=\"text-align: center\">{{item.numeroItem}}</td><td data-label=Periodo style=\"text-align: center\">{{item.periodo}}</td><td data-label=Frecuencia style=\"text-align: center\">{{item.frecuenciaNombre}}</td><td data-label=\"N° Frecuencia\" style=\"text-align: center\"><div ng-show=\"item.numero_frecuencia == 1\">I</div><div ng-show=\"item.numero_frecuencia == 2\">II</div><div ng-show=\"item.numero_frecuencia == 3\">III</div><div ng-show=\"item.numero_frecuencia == 4\">IV</div></td><td data-label=Frecuencia style=\"text-align: center\">{{item.fechapresentaciontexto}}</td><td data-label=\"Cantidad (TN)\" style=\"text-align: center\">{{item.cantTotal}}</td><td data-label=Documento style=\"text-align: center\"><a class=\"glyphicon glyphicon-download-alt\" target=_blank download={{item.nombredocumento}} href={{vm.rutaBase}}residuo/descargar-documento/{{item.idresiduo}}>{{item.nombredocumento}}</a></td><td data-label=Acción style=\"text-align: center\"><button class=\"btn btn-default btn-sm\" ng-click=vm.agregarItem(item) type=button uib-tooltip=Ver><span class=\"glyphicon glyphicon-eye-open\"></span></button></td></tr></tbody></table><dir-pagination-controls pagination-id=coutresiduomain></dir-pagination-controls></div></div></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></span></div>");
$templateCache.put("app/modules/supervision/instalacion/accion-instalacion/instalacion-presentacion.html","<style type=text/css>.select {\r\n	background-color: #CEEFEB !important;\r\n}</style><div class=\"col-lg-12 animated bounceInUp sin_padding\" name=usuarioRegistroForm ng-form=\"\" novalidate><span ng-form=vm.formUsuario><!-- box-bg-lef-15 --><div class=row><div class=col-md-12><h3 class=title-slider-nt><span>Presentación de Documentos</span></h3></div></div><br><div class=row><div class=\"form-group col-lg-2\" style=\"border: solid 1px #144aa7; margin-left: 15px\"><center><label style=\"font-weight: bold; font-size: 15px; color: #111\">Unidad Fiscalizable</label></center></div><div class=\"form-group col-lg-9\"><label style=\"font-weight: bold; font-size: 16px; color: #111\">{{vm.prmInstalacion.numeroInstalacion}}</label><br><label>{{ vm.prmInstalacion.direccion}}</label><br>{{vm.prmInstalacion.distrito.descripcionDistrito}} - {{vm.prmInstalacion.provincia.descripcion}} - {{vm.prmInstalacion.departamento.descripcionDepartamento}}</div></div><div style=\"border-bottom: solid 1px #ddd\"><div class=row ng-show=!vm.verNuevo><div class=\"form-group col-md-2\"><label>Tipo Presentación</label><select class=\"form-control input-sm\" ng-change=\"vm.prmPresentacionFiltro.periodo=0; vm.prmPresentacionFiltro.numero_frecuencia=0\" ng-model=vm.prmPresentacionFiltro.codigoTipoInforme><option ng-value=0>--Todos--</option><option ng-repeat=\"item in vm.lstTipoPresentacion\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\"><strong>Periodo</strong><div class=form-group><select class=\"form-control input-sm\" ng-model=vm.prmPresentacionFiltro.periodo ng-init=\"vm.prmPresentacionFiltro.periodo = 0\"><option ng-value=0>--Todos--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacionFiltro.codigoTipoInforme==7\"><label class=important-box>Mes</label><select ng-model=vm.prmPresentacionFiltro.numero_frecuencia class=\"form-control input-sm\"><option ng-value=0>--Todos--</option><option ng-value=1>ENERO</option><option ng-value=2>FEBRERO</option><option ng-value=3>MARZO</option><option ng-value=4>ABRIL</option><option ng-value=5>MAYO</option><option ng-value=6>JUNIO</option><option ng-value=7>JULIO</option><option ng-value=8>AGOSTO</option><option ng-value=9>SEPTIEMBRE</option><option ng-value=10>OCTUBRE</option><option ng-value=11>NOVIEMBRE</option><option ng-value=12>DICIEMBRE</option></select></div><div class=\"input-group col-md-4\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnBuscar ng-click=vm.listar() type=button uib-tooltip=Buscar><span class=\"icon-buscar spac-btn-r\"></span> Buscar</button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnAgregar ng-click=vm.agregarItem() type=button uib-tooltip=Agregar><span class=\"icon-agregar spac-btn-r\"></span> Agregar</button></div></div></div><div class=row ng-show=vm.verNuevo><div class=col-md-12><h3 class=title-slider-nt>Nuevo</h3></div></div><div class=row ng-show=vm.verNuevo><div class=\"form-group col-md-1\"><strong>Periodo</strong><select class=\"form-control input-sm\" ng-model=vm.prmPresentacion.periodo><option ng-value=0>--Seleccione--</option><option ng-value=2022>2022</option><option ng-value=2021>2021</option><option ng-value=2020>2020</option><option ng-value=2019>2019</option><option ng-value=2018>2018</option><option ng-value=2017>2017</option><option ng-value=2016>2016</option></select></div><div class=\"form-group col-md-2\"><strong>Tipo Presentación</strong><select class=\"form-control input-sm\" ng-change=vm.validarTipoPresentacion(vm.prmPresentacion.codigoTipoInforme); ng-model=vm.prmPresentacion.codigoTipoInforme><option ng-value=0>--Seleccione--</option><option ng-repeat=\"item in vm.lstTipoPresentacion\" ng-value=\"{{ item.codigoRegistro }}\">{{ item.descripcion }}</option></select></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacion.codigoTipoInforme==7\"><label class=important-box>Frecuencia</label><select disabled ng-model=vm.prmPresentacion.frecuencia class=\"form-control input-sm\"><option ng-value=0>--Seleccione--</option><option ng-repeat=\"itemCombo in vm.lstPeriodos\" ng-value=itemCombo.codigoRegistro>{{itemCombo.descripcion}}</option></select></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacion.frecuencia==1\"><label class=important-box>Mes</label><select ng-model=vm.prmPresentacion.numero_frecuencia class=\"form-control input-sm\"><option ng-value=0>--Seleccione--</option><option ng-value=1>ENERO</option><option ng-value=2>FEBRERO</option><option ng-value=3>MARZO</option><option ng-value=4>ABRIL</option><option ng-value=5>MAYO</option><option ng-value=6>JUNIO</option><option ng-value=7>JULIO</option><option ng-value=8>AGOSTO</option><option ng-value=9>SEPTIEMBRE</option><option ng-value=10>OCTUBRE</option><option ng-value=11>NOVIEMBRE</option><option ng-value=12>DICIEMBRE</option></select></div><div class=\"form-group col-md-3\"><strong>Archivo</strong> <input class=\"btn btn-flat btn-primary btn-sm\" file-change=vm.validaDocumento id=fileArchivo multiple type=file><div class=help-block>Archivos permitidos: {{ vm.extension }}<br>Tamaño m&aacute;ximo: {{ vm.tamanioArchivo }} MB</div></div><div class=\"input-group col-md-2\" ng-show=\"vm.prmPresentacion.frecuencia!=1\"><label></label><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.guardarPresentacion() ng-disabled=\"vm.prmPresentacion.codigoTipoInforme==0||vm.prmPresentacion.periodo==0||vm.prmPresentacion.frecuencia==0||vm.prmPresentacion.numero_frecuencia==0 || vm.listaArchivos.length==0\"><i aria-hidden=true class=\"glyphicon glyphicon-ok spac-btn-r\"></i></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnCancelar ng-click=\"vm.verNuevo = false\" type=button uib-tooltip=Cancelar><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i></button></div></div><div class=\"form-group col-md-2\" ng-show=\"vm.prmPresentacion.frecuencia==1\"><label class=important-box>&iquest;Hubo incidente?</label><br><input type=radio value=1 ng-model=vm.prmPresentacion.tiene_incidente>SI <input type=radio value=0 ng-click=\"vm.prmPresentacion.fechahora_incidente=null; vm.prmPresentacion.lugar_incidente=null; vm.prmPresentacion.descripcion_incidente=null; vm.prmPresentacion.observaciones_incidente=null\" ng-model=vm.prmPresentacion.tiene_incidente>NO</div></div><div class=row ng-show=\"vm.verNuevo && vm.prmPresentacion.tiene_incidente==1\"><!-- 	<div class=\"form-group col-md-3\">\r\n					<strong>Archivo</strong> <input\r\n						class=\"btn btn-flat btn-primary btn-sm\"\r\n						file-change=\"vm.validaDocumento\" id=\"fileArchivo\" multiple=\"false\"\r\n						type=\"file\" />\r\n					<div class=\"help-block\">\r\n						Archivos permitidos: {{ vm.extension }} <br /> Tamaño\r\n						m&aacute;ximo: {{ vm.tamanioArchivo }} MB\r\n					</div>\r\n				</div> --><div class=\"form-group col-md-2\"><label class=important-box>Fecha/hora incidencia</label><input type=datetime-local class=\"form-control input-sm\" ng-model=vm.prmPresentacion.fechahora_incidente></div></div><div class=row ng-show=\"vm.verNuevo && vm.prmPresentacion.tiene_incidente==1\"><div class=\"form-group col-md-6\"><label class=important-box>Lugar incidencia</label><input type=text class=\"form-control input-sm\" ng-model=vm.prmPresentacion.lugar_incidente><br></div></div><div class=row ng-show=\"vm.verNuevo && vm.prmPresentacion.tiene_incidente==1\"><div class=\"form-group col-md-6\"><label class=important-box>Descripci&oacute;n incidencia</label><input type=text multiple class=\"form-control input-sm\" ng-model=vm.prmPresentacion.descripcion_incidente><br></div></div><div class=row ng-show=\"vm.verNuevo && vm.prmPresentacion.tiene_incidente==1\"><div class=\"form-group col-md-6\"><label class=important-box>Observaciones incidencia</label><input type=text multiple class=\"form-control input-sm\" ng-model=vm.prmPresentacion.observaciones_incidente><br></div></div><div class=row ng-show=\"vm.verNuevo && vm.prmPresentacion.tiene_incidente!=null\"><div class=\"input-group col-md-2\"><div class=form-group><button class=\"btn btn-flat btn-primary-inv btn-sm\" ng-click=vm.guardarPresentacion() ng-disabled=\"vm.prmPresentacion.codigoTipoInforme==0||vm.prmPresentacion.periodo==0||vm.prmPresentacion.frecuencia==0||vm.prmPresentacion.numero_frecuencia==0 || vm.listaArchivos.length==0 ||\r\n							((vm.prmPresentacion.fechahora_incidente==null || vm.prmPresentacion.fechahora_incidente==\'\' ||\r\n							vm.prmPresentacion.lugar_incidente==null || vm.prmPresentacion.lugar_incidente==\'\' ||\r\n							vm.prmPresentacion.descripcion_incidente==null || vm.prmPresentacion.descripcion_incidente==\'\' ||\r\n							vm.prmPresentacion.observaciones_incidente==null || vm.prmPresentacion.observaciones_incidente==\'\') && vm.prmPresentacion.tiene_incidente==1)\"><i aria-hidden=true class=\"glyphicon glyphicon-ok spac-btn-r\"></i></button> <button class=\"btn btn-flat btn-primary-inv btn-sm\" id=btnCancelar ng-click=\"vm.verNuevo = false\" type=button uib-tooltip=Cancelar><i aria-hidden=true class=\"glyphicon glyphicon-remove\"></i></button></div></div></div></div><br><div class=row ng-show=!vm.verNuevo><div class=\"form-group col-md-12\"><div class=table-rpv><table bgcolor=#d0c9c9 class=\"table table-hover table-bordered table-striped table-app tabla-config\"><thead><tr><th class=text-center>N° Item</th><th class=text-center>Periodo</th><th class=text-center>Tipo Presentación</th><th class=text-center>Fecha Presentación</th><th class=text-center>Mes Incidente</th><th class=text-center>&iquest;Hubo incidente?</th><th class=text-center>Fecha/hora incidencia</th><th class=text-center>Lugar incidencia</th><th class=text-center>Descripci&oacute;n incidencia</th><th class=text-center>Observaciones incidencia</th><th class=text-center>Archivo</th></tr></thead><tbody><tr ng-show=\"vm.lstPresentacion.length==0\"><td colspan=12 style=\"text-align: left\">No se encontraron resultados</td></tr><tr dir-paginate=\"item in vm.lstPresentacion | itemsPerPage: config.itemsPerPage\" pagination-id=cout4><td data-label=Item style=\"text-align: center\">{{$index + 1}}</td><td data-label=Periodo class=text-center>{{item.periodo}}</td><td data-label=\"Tipo Presentación\" class=text-center>{{item.nombreTipoInforme}}</td><td data-label=\"Fecha Presentación\" class=text-center>{{item.fechapresentaciontexto}}</td><td data-label=\"Mes Incidente\" class=text-center><div ng-show=\"item.codigoTipoInforme==7\"><div ng-if=\"item.numero_frecuencia==1\">ENERO</div><div ng-if=\"item.numero_frecuencia==2\">FEBRERO</div><div ng-if=\"item.numero_frecuencia==3\">MARZO</div><div ng-if=\"item.numero_frecuencia==4\">ABRIL</div><div ng-if=\"item.numero_frecuencia==5\">MAYO</div><div ng-if=\"item.numero_frecuencia==6\">JUNIO</div><div ng-if=\"item.numero_frecuencia==7\">JULIO</div><div ng-if=\"item.numero_frecuencia==8\">AGOSTO</div><div ng-if=\"item.numero_frecuencia==9\">SEPTIEMBRE</div><div ng-if=\"item.numero_frecuencia==10\">OCTUBRE</div><div ng-if=\"item.numero_frecuencia==11\">NOVIEMBRE</div><div ng-if=\"item.numero_frecuencia==12\">DICIEMBRE</div></div></td><td data-label=\"&iquest;Hubo incidente?\" class=text-center><label ng-show=\"item.tiene_incidente==1\">SI</label><label ng-show=\"item.tiene_incidente==0\">NO</label><label ng-show=\"item.tiene_incidente!=1 && item.tiene_incidente!=0\">NO ESPECIFICA</label></td><td data-label=\"Fecha/hora incidencia\" class=text-center>{{item.fechahora_incidente_texto}}</td><td data-label=\"Lugar incidencia\" class=text-center>{{item.lugar_incidente}}</td><td data-label=\"Descripci&oacute;n incidencia\" class=text-center>{{item.descripcion_incidente}}</td><td data-label=\"Observaciones incidencia\" class=text-center>{{item.observaciones_incidente}}</td><td data-label=Documento class=text-center><a download={{item.nombredocumento}} href={{vm.rutaBase}}instalacionPresentacion/descargar-documento/{{item.idAdministrado}}/{{item.idInstalacion}}/{{item.codigoTipoInforme}}/{{item.periodo}}/{{item.numero_frecuencia}} target=_blank>{{item.nombredocumento}}</a></td></tr></tbody></table><dir-pagination-controls pagination-id=cout4></dir-pagination-controls></div></div></div><button style=\"display: none\" id=btnCerrar ng-click=vm.refrescar() type=button></button></span><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-flat btn-default btn-sm\" ng-click=vm.cancelar() type=button><span class=\"glyphicon glyphicon-arrow-left spac-btn-r\"></span> Regresar</button></div></div></div>");
$templateCache.put("app/modules/bandeja/solicitudes/dialog/motivo-rechazo/motivo-rechazo-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">Motivo rechazo</h4></div><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><div class=row><div class=\"form-group col-md-9\"><label>Motivo:</label></div><div class=\"form-group col-md-12\"><textarea class=\"form-control input-sm\" maxlength=1000 ng-keyup=\" vm.guardarMotivoRechazo()\" ng-model=vm.dataMotivoRechazo rows=5>\r\n                    </textarea></div></div></span></div><div class=row><div class=\"form-group col-lg-12 text-right\"><button class=\"btn btn-primary-inv btn-sm btn-pd-5\" ng-click=confirm(1) ng-disabled=\"vm.dataMotivoRechazo.length==0\"><i aria-hidden=true class=\"fa fa-check\"></i> Confirmar</button> <button class=\"btn btn-primary btn-sm btn-pd-5\" ng-click=closeThisDialog(0)><i aria-hidden=true class=\"fa fa-ban\"></i> Cancelar</button></div></div></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");
$templateCache.put("app/modules/bandeja/solicitudes/dialog/solicitud-archivo/solicitud-archivo-dialog.html","<div><div class=modal-header><h4 class=\"modal-title title-msg-conf\">{{vm.dataTitulo}}</h4></div><div class=modal-body name=notificacionDialogForm ng-form=\"\"><span class=content-box><fieldset class=\"well unp-fieldset\"><div ng-bind-html=renderHtml(urlPDFFichaDenuncia)></div></fieldset></span></div><!-- 		<div class=\"row\"> --><!-- 	        <div class=\"form-group col-lg-12 text-right\"> --><!-- 	            <button type=\"button\" ng-click=\"vm.cancelar(1)\" class=\"btn btn-flat btn-success btn-sm\"> --><!-- 	                <span class=\"glyphicon glyphicon-ok spac-btn-r\"></span> Cerrar --><!-- 	            </button>  --><!-- 	        </div> --><!--   	    </div> --></div><script type=text/javascript>$( document ).ready(function() {\r\n        $(\'button.ngdialog-close\').remove();\r\n        $(\'.ngdialog-content\').append(\"<a aria-label=\'Dismiss\' class=\'ngdialog-close\'></a>\");\r\n    });</script>");}]);